(function(){
    angular.module('app.controllers',['ngPostMessage']).controller('CashBoxController',
      function($window,$uibModal, $stateParams, $api, dates, $header, $rootScope, $state, $scope, $filter, $sce, $log, $user,
        $translate, Info, Items, Workers, Resources, Customer, Order, CustomerCards,  Transaction, Categories, Retainer){

        $scope.statusShow = ''; 
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var query = window.location.search.substring(1);
        var qs = query ? parse_query_string(query) : {};

        var ctrl = this;
        ctrl.isQuotationEditMode = ($state.current.name == 'app.cashbox.quotation_edit');

        // console.log(Order.data);
        ctrl.hide_prices = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices') ? true : false;

        $scope.datesProvider = dates;
        $scope.isEmv = false;
        ctrl.show_stock = $rootScope.$user.show_stock;
        $scope.channelHash = $rootScope.generateUniqueId();

        $scope.isMobile = (angular.element(document).width() < 769)
        ctrl.categoryFilter = -1;
        ctrl.maxDebt = null;
        ctrl.isCreditTransaction = false;
        ctrl.isQuotationTransaction = false;
        ctrl.isCreditCreditCard = false;
        ctrl.isOrderTransaction = false;
        ctrl.prepaid = false;
        ctrl.isDebtTransaction = false;
        ctrl.searchItem = "";
        ctrl.customerData = null;
        ctrl.employees = [];
        ctrl.resources = Resources && Resources.data ? Resources.data : [];
        ctrl.salesResources = ctrl.resources.filter(function(resource) {
          return resource.sales_active;
        }).map(function(resource) {
          var option = angular.copy(resource);
          option.id = String(option.id);
          return option;
        });
        ctrl.customer_search_name = "";
        ctrl.searchCustomerResult = [];
        ctrl.items = [];
        ctrl.currentModal = null;
        ctrl.dealer_vat = Info ? parseFloat(Info.data.vat) : 0;
        ctrl.businessInfo = Info;
        ctrl.businessHasCardReader = Info.data.card_reader;
        ctrl.msg_channel_inv_link = Info.data.msg_channel_inv_link;
        ctrl.businessHasEnv = Info.data.env; // is the business has env card reader
        ctrl.useCardReader = ctrl.businessHasCardReader == '1' ? true : false;
        ctrl.sendInvoice = true;
        ctrl.useIframe = false;
        ctrl.creditDeal = false;
        ctrl.isEmv = false;
        ctrl.numberOfPaymentsEmv = 1;
        ctrl.cardQty = 1;
        ctrl.cardQtyModel = 1;
        ctrl.cardPrice = 0;
        ctrl.cardPerItemModel = 1;
        ctrl.cardPerItem = 1;
        ctrl.makeCardIndex = 0;
        ctrl.cerdit_company = Info.data.cerdit_company;
        ctrl.checkCustomerCards = false;
        ctrl.z_credit_credit_deal = Info.data.z_credit_credit_deal;
        ctrl.show_discount = 0;
        ctrl.total_discount = '';
        ctrl.continuous_deal = false;
        ctrl.continuous_deal_count = 2;

        ctrl.BanksList = [
            {'bank_number': 'service_1', 'name': 'Bit', img_url: "assets/images/bank_bit_icon.png"},
            {'bank_number': 'service_2', 'name': 'Paybox', img_url: "assets/images/service_paybox_icon.png"},
            {'bank_number': 12, 'name':	'בנק הפועלים'},
            {'bank_number': 10, 'name': 'בנק לאומי'},
            {'bank_number': 11, 'name': 'בנק דיסקונט'},
            {'bank_number': 20, 'name': 'בנק מזרחי טפחות'},
            {'bank_number': 31, 'name': 'הבנק הבינלאומי הראשון'},
            {'bank_number': 14, 'name': 'בנק אוצר החייל'},
            {'bank_number': 17, 'name': 'בנק מרכנתיל דיסקונט'},
            {'bank_number': 9, 'name': 'בנק הדואר'},
            {'bank_number': 13, 'name': 'בנק איגוד'},
            {'bank_number': 46, 'name': 'בנק מסד'},
            {'bank_number': 52, 'name': 'בנק פועלי אגודת ישראל'},
            {'bank_number': 90, 'name': 'בנק דיסקונט למשכנתאות'},
            {'bank_number': 4, 'name': 'בנק יהב לעובדי המדינה'},
            {'bank_number': 26, 'name': 'יובנק בע"מ'},
            {'bank_number': 7, 'name': 'בנק לפיתוח התעשיה'},
            {'bank_number': 8, 'name': 'בנק הספנות לישראל'},
            {'bank_number': 6, 'name': 'בנק אדנים'},
            {'bank_number': 54, 'name': 'בנק ירושלים'},
            {'bank_number': 34, 'name': 'בנק ערבי ישראלי'},
            {'bank_number': 1, 'name': 'בנק יורו טרייד'},
            {'bank_number': 19, 'name': 'בנק החקלאות לישראל'},
            {'bank_number': 200, 'name': 'one zero'},
        ];

        ctrl.form = {
            email: "",
            phone: "",
            name: "",
            customer_occ_name: "",
            customer_occ_phone: "",
            comment: "",
            customer: null,
            quotation: 0,
            retainer_start_date: null,
            retainer_count: '',
            retainer_infinity: false,
            retainer_period: 'monthly',
        };
        ctrl.retainerPeriodOptions = [
          {id: 'monthly', name: $translate.instant('RETAINER_PERIOD_MONTHLY')},
          {id: 'weekly', name: $translate.instant('RETAINER_PERIOD_WEEKLY')}
        ];

        ctrl.occ_customer = false;

        /** Get customers data */
        if(Customer) {
          ctrl.customerData = Customer.data;
        }

        if(Workers) {
          ctrl.employees = Workers.data;
        }

        ctrl.cashboxTotal = 0;
        ctrl.cashboxTotalByItemsCard = 0;
        ctrl.totalPaid = 0;
        ctrl.cashboxLoading = false;
        ctrl.isManuallyEditingTotal = false;
        if(CustomerCards) {
          ctrl.customerCards = CustomerCards.data;
        }

        for(var i in Items.data){
            if(Items.data[i].categories != null && Items.data[i].item_type != 'card') {
                Items.data[i].categories = String(Items.data[i].categories).replace("{", "[").replace("}", "]");
                Items.data[i].categories = JSON.parse(Items.data[i].categories);
            }
        }

        // Fill payment methods
        ctrl.methods = {
            oncredit: {},
            cash: {},
            cheque: {},
            credit_card_external: {},
            bank_transfer: {},
            credit_card: {},
            items_card: {},
            pay_link: {},
            retainer: {},
        };

        ctrl.resetPaymentMethods = function() {
          Object.keys(ctrl.methods).forEach(function(key, i){
              ctrl.methods[key] = {
                  active: false,
                  disabled: false,
                  amount: null,
                  subtotal: null,
                  vat: null,
                  payment_details: {
                    cheque_number: null,
                      cheque_due_date: moment().format('MM/DD/YYYY'),
                      bank_number: null,
                      branch_number: null,
                      bank_account_number: null,
                      credit_card_ext_number: null,
                  }
              }
          });
        };

        $scope.$watch('ctrl.form.quotation', function(newValue, oldValue) {
          if (newValue !== oldValue) {
            ctrl.resetPaymentMethods();
            if (newValue) {
              ctrl.choosePayMethod('cash');
            } else {
              ctrl.attached_digital_form = null;
            }
          }
        });

        ctrl.resetPaymentMethods();
        ctrl.categories = Categories.data.filter(function (el) { return el.active; });
        var activeCategoryIds = ctrl.categories.map(function (cat) { return cat.id; });
        Items.data = Items.data.filter(function (el) {
            if (el.item_type === 'card' || el.inactive) return false;

            if (!el.categories || !el.categories.length || (el.categories.length == 1 && el.categories[0] == 0)) return true;

            for (var j = 0; j < el.categories.length; j++) {
                if (activeCategoryIds.indexOf(el.categories[j]) !== -1) {
                    return true;
                }
            }

            return false;
        });

        ctrl.products = Items.data;
        ctrl.lastMethod = null;
        $scope.method = null;

        ctrl.load_credit_data = function(){
            ctrl.items = Transaction.data.items;
            ctrl.trigger_items_update(false, true);
        };

        ctrl.update_transaction_customer_data = function() {
            if(!ctrl.form.customer) {
              if (!ctrl.occ_customer) {
                ctrl.remove_customer();
              }
            } else {
              ctrl.customer_search_name = ctrl.customerData.firstname;
              ctrl.customer_search_name +=  ctrl.customerData.lastname ? ' ' + ctrl.customerData.lastname : '';
              ctrl.customer_search_name +=  ctrl.customerData.notes ? ' (' + ctrl.customerData.notes + ')' : '';

              ctrl.form.email = ctrl.customerData.email;
              ctrl.form.phone = ctrl.customerData.phone || ctrl.customerData.telephone;
              ctrl.form.name = ctrl.customerData.firstname;
              ctrl.form.name += ctrl.customerData.lastname ? ' ' + ctrl.customerData.lastname : '';
              ctrl.loadCustomersCards(ctrl.form.customer);
            }
        };

        if (qs.customer) {
          $api.customers.single.get({id: qs.customer}, function(response){
            ctrl.form.customer = response.data ? response.data.id : null;
            ctrl.customerData = response.data ? response.data : null;
            if (response.data) {
              ctrl.form.customer_occ_name = "";
              ctrl.form.customer_occ_phone = "";
              ctrl.occ_customer = false;
            }
            ctrl.update_transaction_customer_data();
          });
        }
        if (qs.quotation) {
          ctrl.form.quotation = true;
        }

        /**
         * Clear customers data from form
         */
        ctrl.remove_customer = function() {
            ctrl.form.email = "";
            ctrl.form.phone = "";
            ctrl.form.name = "";
            ctrl.form.customer_occ_name = "";
            ctrl.form.customer_occ_phone = "";
            ctrl.customerData = {};
            ctrl.form.customer = null;
            ctrl.customer_search_name = "";
            ctrl.customerCards = null;
            ctrl.customerCreditCards = null;
            ctrl.removeRetainer();
        }

        ctrl.removeRetainer = function() {
          ctrl.customerCreditCards = null;
          ctrl.methods['retainer'] = {
            active: false,
            disabled: false,
            amount: null,
            subtotal: null,
            vat: null,
          };
        }

        ctrl.buildCourseOptions = function(courses) {
          var options = [];

          angular.forEach(courses, function(course, index) {
            options.push({
              id: String(index),
              name: course
            });
          });

          return options;
        };

        /**
         * Only for mobile view
         */
        ctrl.openSelectCustomer = function() {
            $uibModal.open({
              templateUrl: "app/modules/customers/popup/customers.popup.html",
              controller: "CustomersSelectController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal medium-modal",
              resolve: {
                Customers: function($api) {
                  return $api.resolve("customers@get", {limit: 20});
                }
              }
            }).result.then(function (selected_customer) {
              ctrl.form.customer = selected_customer ? selected_customer.id : null;
              ctrl.customerData = selected_customer ? selected_customer : null;
              if (selected_customer) {
                ctrl.form.customer_occ_name = "";
                ctrl.form.customer_occ_phone = "";
                ctrl.occ_customer = false;
              }
              ctrl.update_transaction_customer_data();
            });
          }

        ctrl.getEffectivePaymentCount = function() {
          if (ctrl.continuous_deal) {
            var c = parseInt(ctrl.continuous_deal_count, 10);
            return isNaN(c) ? 2 : c;
          }
          return ctrl.numberOfPaymentsEmv;
        };

        ctrl.onContinuousDealClick = function($event) {
          $event.preventDefault();
          if (ctrl.continuous_deal) {
            ctrl.continuous_deal = false;
            return;
          }
          ctrl.openContinuousDealModal();
        };

        ctrl.openContinuousDealModal = function() {
          var startCount = ctrl.continuous_deal_count || 2;
          $uibModal.open({
            templateUrl: "app/modules/cashbox/popup/continuous-deal.modal.html",
            scope: $scope,
            windowTopClass: "form-modal small-modal",
            controller: function($scope, $uibModalInstance) {
              $scope.modalCount = startCount;
              $scope.confirm = function() {
                var n = parseInt($scope.modalCount, 10);
                if (isNaN(n) || n < 2 || n > 18) {
                  alert($translate.instant('CONTINUOUS_DEAL_COUNT_INVALID'));
                  return;
                }
                $uibModalInstance.close(n);
              };
              $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
              };
            }
          }).result.then(function(count) {
            ctrl.continuous_deal = true;
            ctrl.continuous_deal_count = count;
          });
        };

        /**
         * Only for mobile view
         */
        ctrl.openSelectItem = function() {
            $uibModal.open({
              templateUrl: "app/modules/settings/items/popup/items.popup.html",
              controller: "ItemsSelectController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal medium-modal select-item-modal",
              resolve: {
                Items: [function () {
                  return ctrl.products;
                }]
              }
            }).result.then(function (selected_item) {
              if(selected_item) {
                ctrl.addItem(selected_item);
              }
            });
        }


        ctrl.openSelectEmployee = function() {
          $uibModal.open({
            templateUrl: "app/modules/workers/popup/workers.popup.html",
            controller: "WorkersSelectController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal select-worker-modal",
            resolve: {
              Workers: [function () {
                return ctrl.employees;
              }]
            }
          }).result.then(function (selected_employee) {
            ctrl.form.employee = selected_employee.id;
          });
      }

        ctrl.showBankList = function() {
            $uibModal.open({
                templateUrl: "app/modules/cashbox/popup/bank.popup.html",
                controller: "BanksSelectController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal medium-modal",
                resolve: {
                    Banks: [function () {
                        return ctrl.BanksList;
                    }]
                }
            }).result.then(function (bank) {
                if(bank) {
                    ctrl.methods[$scope.method].payment_details.bank_number = bank.bank_number;
                    ctrl.methods[$scope.method].payment_details.bank_name = bank.name;
                }
            });
        }

        ctrl.giftCardIndex = 0;
        ctrl.openGiftCardDetails = function(index) {
          ctrl.giftCardIndex = index;

          $uibModal.open({
            templateUrl: "app/modules/settings/gift_cards/popup/details.view.html",
            controller: "GiftCardsDetailsController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal large-modal",
            resolve: {
              Customer: [function () {
                return ctrl.form.customer ? ctrl.customerData : null;
              }],
              Item: [function () {
                return ctrl.items[index];
              }],
              Templates: ['$api', function ($api) {
                return $api.resolve("giftCardTemplate@get");
              }],
              Info: ['$api', function ($api) {
                return $api.resolve("settings.info@get");
              }],
            }
          }).result.then(function (response) {
            if (response) {
              if (ctrl.items[ctrl.giftCardIndex]) {
                ctrl.items[ctrl.giftCardIndex].item_name = ctrl.items[ctrl.giftCardIndex].item_name ? ctrl.items[ctrl.giftCardIndex].item_name : ctrl.items[ctrl.giftCardIndex].name;

                ctrl.items[ctrl.giftCardIndex].isGiftCard = true;
                ctrl.items[ctrl.giftCardIndex].gift_card_template_id = response.template_id;
                ctrl.items[ctrl.giftCardIndex].gifted_to = response.values.receiver;
                ctrl.items[ctrl.giftCardIndex].sender_text = response.values.sender;
                ctrl.items[ctrl.giftCardIndex].service_text = response.values.service;
                ctrl.items[ctrl.giftCardIndex].message_text = response.values.message;
                ctrl.items[ctrl.giftCardIndex].name = response.values.name;
                ctrl.items[ctrl.giftCardIndex].page_bg_color = response.settings.page_bg_color;
                ctrl.items[ctrl.giftCardIndex].card_bg_color = response.settings.card_bg_color;
                ctrl.items[ctrl.giftCardIndex].primary_color = response.settings.primary_color;
                ctrl.items[ctrl.giftCardIndex].text_color = response.settings.text_color;
                ctrl.items[ctrl.giftCardIndex].logo = response.settings.logo;
                ctrl.items[ctrl.giftCardIndex].image = response.settings.image;
                ctrl.items[ctrl.giftCardIndex].receiver = response.settings.receiver;
                ctrl.items[ctrl.giftCardIndex].sender = response.settings.sender;
                ctrl.items[ctrl.giftCardIndex].service = response.settings.service;
                ctrl.items[ctrl.giftCardIndex].value = response.settings.value;
                ctrl.items[ctrl.giftCardIndex].message = response.settings.message;
              }
            }
          });
        }

        ctrl.selectedCards = [];
        ctrl.openGiftCardModal = function() {
          $uibModal.open({
            templateUrl: "app/modules/settings/gift_cards/popup/select.view.html",
            controller: "GiftCardsSelectController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal",
            resolve: {
              GiftCards: ['$api', function ($api) {
                return $api.resolve("giftCard@get");
              }],
              SelectedGiftCards: ['$api', function ($api) {
                return ctrl.selectedCards;
              }],
            }
          }).result.then(function (response) {
            if (response) {
              var seen = {};
              var updatedCards = [];
              for (var i = 0; i < response.length; i++) {
                var card = response[i];
                var number = card.number;
                if (number && !seen[number]) {
                  seen[number] = true;
                  updatedCards.push(card);
                }
              }
              ctrl.selectedCards = updatedCards;

              var responseSet = {};
              for (i = 0; i < ctrl.selectedCards.length; i++) {
                responseSet[ctrl.selectedCards[i].number] = true;
              }

              var keptItems = [];
              for (i = 0; i < ctrl.items.length; i++) {
                var item = ctrl.items[i];
                if (item.item_type != 'gift_card') {
                  keptItems.push(item);
                  continue;
                }

                if (responseSet[item.number]) {
                  keptItems.push(item);
                }
              }
              ctrl.items = keptItems;

              var giftCardSet = {};
              for (i = 0; i < ctrl.items.length; i++) {
                var item = ctrl.items[i];
                if (item.item_type == 'gift_card') {
                  giftCardSet[item.number] = item;
                }
              }

              var totalLeft = ctrl.cashboxTotal;

              for (var i in ctrl.selectedCards) {
                var card = ctrl.selectedCards[i];

                if (giftCardSet[card.number]) {
                  continue;
                }

                var balance = card.balance * 1 <= totalLeft ? card.balance * 1 : totalLeft;
                balance = balance > 0 ? balance : 0;
                totalLeft -= balance;

                var subtotal = (balance * 1 / (100 + ctrl.dealer_vat)) * 100;
                subtotal = (Math.round(subtotal * 100)) / 100;
                var tax = balance * 1 - subtotal;

                ctrl.items.push({
                  item_duration: null,
                  item_id: null,
                  item_type: "gift_card",
                  gift_card_id: card.id,
                  name: card.name,
                  number: card.number,
                  original_price: card.price,
                  balance: card.balance * 1,
                  price: balance * -1,
                  quantity: 1,
                  subtotal: subtotal * -1,
                  tax: tax * -1,
                });

                ctrl.methods['retainer'].disabled = true;
              }

              if (totalLeft <= 0) {
                for(var method in ctrl.methods) {
                  ctrl.methods[method].active = false;
                }
                ctrl.disableRemainingPayMethods();
              }
            }
          });
        }

        /**
         * Search customer
         */
        ctrl.find_customer = function() {
          $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response){
            if (response.str == ctrl.customer_search_name) {
              ctrl.searchCustomerResult = response.data;
            }
          });
        }

        /**
         * Select customer
         *
         * @param index
         * @param $event
         */
        ctrl.chooseCustomer = function(index,$event){
          ctrl.customerData = ctrl.searchCustomerResult[index];
          ctrl.form.customer = ctrl.customerData.id;
          ctrl.form.customer_occ_name = "";
          ctrl.form.customer_occ_phone = "";
          ctrl.occ_customer = false;
          ctrl.form.randomCustomer = 0;
          ctrl.searchCustomerResult = [];
          ctrl.update_transaction_customer_data();

          $event.stopPropagation();
        }

        /**
         * Empty search customer field
         */
        ctrl.cleanCustomerSearch = function() {
          if(ctrl.form.customer == null || typeof ctrl.form.customer === "undefined") {
            ctrl.customer_search_name = '';
          }
        }

        /**
         * Load all customer's cards
         *
         * @param customer_id
         */
        ctrl.loadCustomersCards = function (customer_id) {
          //ctrl.customerCards = $api.resolve("cards.customers@get", {"id": customer_id});
          $api.cards.customers.get({"id": customer_id}, function (response) {
              if (response.status == "success") {
                ctrl.customerCards = response.data;
                ctrl.matchCardsForItems();

                if (ctrl.checkCustomerCards) {
                  for (var i in ctrl.items) {
                    var card = ctrl.getCustomerCardForItem(ctrl.items[i].id); 
                    if (card && !card.expired && card['balance'] && card['balance'] > 0 && !ctrl.items[i].isCard) {
                      ctrl.items[i].card_balance_used = card['balance'] < ctrl.items[i].quantity ? card['balance'] : ctrl.items[i].quantity;
                    }
                  }
                }
                ctrl.checkCustomerCards = false
              }
            }
          );
          $api.customers.credit_cards.get({"id": customer_id}, function (response) {
            if (response.status == "success") {
              ctrl.customerCreditCards = response.data;
              angular.forEach(ctrl.customerCreditCards, function(card) {
                card.id = String(card.id);
              });
            }
          });
        }

        ctrl.giftCardTotal = function() {
          var total = 0;
          ctrl.items.forEach(function(item) {
            if (item.item_type == 'gift_card') {
              total += Math.abs(item.price);
            }
          });
          return total;
        }

        /**
         * Return Card for specific Item if customer has bought it
         *
         * @param item_id
         * @returns {boolean}
         */
        ctrl.getCustomerCardForItem = function (item_id) {
          var itemCard = false;
          if (ctrl.form.customer && angular.isArray(ctrl.customerCards)) {
            ctrl.customerCards.forEach(function (card) {
              if (card.item_id == item_id) {
                itemCard = card;
              }
            })
          }
          return itemCard;
        }

        /**
         * Check if customer has Card for particular Item with positive balance
         *
         * @param item_id
         * @returns {boolean}
         */
        ctrl.hasCustomerCardForItem = function(item_id) {
          var hasCard = false;
          var card = ctrl.getCustomerCardForItem(item_id);
          if(card && card.balance > 0) {
            if (card.expired) {
              hasCard = 'expired';
            } else {
              hasCard = true;
            }
          }
          return hasCard;
        }

        /**
         * Show Card popup
         *
         * @param item
         */
        ctrl.useCardPopup = function (item) {
          var card = ctrl.getCustomerCardForItem(item.id);
          if (card.expired) {
            swal({
              text: $translate.instant('SWAL_CARD_EXPIRED_TEXT'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 3000
            });
            return;
          }

          ctrl.cashboxLoading = true;
          $uibModal.open({
            templateUrl: "app/modules/cashbox/popup/use-card.form.html",
            controller: "CashboxUseCardFormController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal small-modal card-balance-edit-modal",
            resolve: {
              Card: function ($api) {
                $log.log('card.id: ' + card.id);
                return $api.resolve("cards.single@get", {"id": card.id});
              },
              Item: function () {
                return item;
              }
            }
          }).result.then(function (data) {
            if(data) {
              for (var i in ctrl.items) {
                if (ctrl.items[i].id == data.item.id && ctrl.items[i].price == data.item.price && !ctrl.items[i].isCard) {
                  ctrl.items[i].card_balance_used = data.card_balance_used;
                  break;
                }
              }
            }
            ctrl.cashboxLoading = false;
          })
        }


        $scope.$on('$messageIncoming', function (event, data){
            if(data.msg == "Ok"){
                ctrl.creditPaymentId = data.value;
                ctrl.completePayment();
            }
            else if(data.msg == "Error"){
                ctrl.currentModal.close();

                var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                  message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                }

                swal({
                    title: message,
                    text: $translate.instant('SWAL_PELECARD_MESSAGE_TEXT'),
                    type: "warning",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 3000
                });
            }

        });

        ctrl.askedStockReturn = false;
        ctrl.stockReturn = false;
        ctrl.confirmStock = function(){
          swal({
            title: "",
            text: $translate.instant('SWAL_STOCK_RETURN_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            ctrl.stockReturn = !!(result.value);
            ctrl.askedStockReturn = true;
            ctrl.newTransaction();
          });
        }

        ctrl.askedCardRefund = false;
        ctrl.confirmCreditRefund = function(){
          swal({
            title: "",
            text: $translate.instant('SWAL_CREDIT_CARD_REFUND_AMOUNT_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if (result.value) {
              ctrl.askedCardRefund = true;
              ctrl.newTransaction();
            }
          });
        }

        ctrl.askedGiftCardRefund = false;
        ctrl.giftCardRefund = false;
        ctrl.confirmGiftCardRefund = function() {
          swal({
            title: "",
            text: $translate.instant('SWAL_GIFT_CARD_REFUND_AMOUNT_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if (result.value) {
              ctrl.askedGiftCardRefund = true;
              ctrl.giftCardRefund = true;
              ctrl.newTransaction();
            }
          });
        }
        
        ctrl.getCreditTransactionLimit = function() {
          if (!ctrl.isCreditTransaction || !ctrl.isContinuousDealCredit || !Transaction || !Transaction.data) {
            return null;
          }
          var sourceTotal = Math.abs(parseFloat(Transaction.data.total || 0));
          return isNaN(sourceTotal) ? null : sourceTotal;
        };

        ctrl.validateCreditTransactionLimit = function() {
          var creditLimit = ctrl.getCreditTransactionLimit();
          if (creditLimit === null) {
            return true;
          }

          if (Math.abs(ctrl.cashboxTotal) - creditLimit > 0.0001) {
            swal({
              title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
              text: $translate.instant('SWAL_CREDIT_CARD_REFUND_AMOUNT_ERROR_TEXT'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            });
            return false;
          }

          return true;
        };

        ctrl.transactionNeedsAllocation = function() {
          if (!ctrl.businessInfo || !ctrl.businessInfo.data) {
            return false;
          }
          if (ctrl.businessInfo.data.dealer_type != 'licensed') {
            return false;
          }
          if (ctrl.form.quotation || ctrl.isCreditTransaction || ctrl.isDebtTransaction || ctrl.isAllPayedByCard()) {
            return false;
          }
          if (ctrl.continuous_deal) {
            return false;
          }

          var issueAllocation = parseInt(ctrl.businessInfo.data.issue_allocation_number, 10);
          if (issueAllocation === 1) {
            return true;
          }
          if (issueAllocation === 2) {
            var threshold = parseFloat(ctrl.businessInfo.data.allocation_amount_threshold);
            return !isNaN(threshold) && parseFloat(ctrl.cashboxTotal || 0) >= threshold;
          }

          return false;
        };

        ctrl.customerMissingVatForAllocation = function() {
          if (!ctrl.transactionNeedsAllocation()) {
            return false;
          }
          if (!ctrl.customerData || !ctrl.form.customer) {
            return true;
          }
          var customerVat = ctrl.customerData.dealer_id ? String(ctrl.customerData.dealer_id).replace(/\D/g, '') : '';
          return !customerVat || parseInt(customerVat, 10) <= 0;
        };


        ctrl.newTransaction = function(){
          if (!ctrl.validateCreditTransactionLimit()) {
            return;
          }

          if(!ctrl.customerData) {
            ctrl.customerData = {};
          }

          var hasGiftCards = false;
          var hasSaleItem = false;
          var hasGiftCardRefund = false;
          for (var i in ctrl.items) {
            var item = ctrl.items[i];
            if (item.item_type == 'sale') {
              hasSaleItem = true;
            }
            if (item.isGiftCard*1) {
              hasGiftCardRefund = true;
            }

            if (ctrl.items[i].item_type == 'gift_card') {
              hasGiftCards = true;

              if (Math.abs(item.price * 1) > item.balance * 1) {
                swal({
                  title: $translate.instant('SWAL_GIFT_CARD_BALANCE_ERROR_TITLE'),
                  text: $translate.instant('SWAL_GIFT_CARD_BALANCE_ERROR_TEXT', {number: item.number, balance: item.balance, price: Math.abs(item.price)}),
                  type: "error",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                });
                return;
              }
            }
          }

          if (hasGiftCards && ctrl.cashboxTotal < 0) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARD_NEGATIVE_TOTAL_ERROR_TITLE'),
              text: $translate.instant('SWAL_GIFT_CARD_NEGATIVE_TOTAL_ERROR_TEXT'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            });
            return;
          }

          if (typeof ctrl.methods.cheque.payment_details.cheque_due_date == 'object') // Format moment;
            ctrl.methods.cheque.payment_details.cheque_due_date = ctrl.methods.cheque.payment_details.cheque_due_date.format('MM/DD/YYYY');

          if (ctrl.isCreditTransaction && ctrl.methods.credit_card.active && !ctrl.askedCardRefund) {
            ctrl.confirmCreditRefund();
            return;
          }

          if (ctrl.show_stock && ctrl.isCreditTransaction && !ctrl.askedStockReturn && hasSaleItem) {
            ctrl.confirmStock();
            return;
          }

          if (hasGiftCardRefund && ctrl.isCreditTransaction && !ctrl.askedGiftCardRefund) {
            ctrl.confirmGiftCardRefund();
            return;
          }

          ctrl.cashboxLoading = true;
          $api.transactions.save({
            items: ctrl.items,
            methods: ctrl.methods,
            customer: ctrl.form.customer,
            email: ctrl.form.email,
            phone: ctrl.occ_customer ? ctrl.form.customer_occ_phone : ctrl.form.phone,
            customer_name: ctrl.occ_customer ? ctrl.form.customer_occ_name : (ctrl.form.name ? ctrl.form.name : ""),
            isDebtTransaction: ctrl.isDebtTransaction,
            isCreditTransaction: ctrl.isCreditTransaction,
            isQuotationTransaction: ctrl.isQuotationTransaction,
            isCreditCreditCard: ctrl.isCreditCreditCard,
            stockReturn: ctrl.stockReturn,
            giftCardRefund: ctrl.giftCardRefund,
            isOrderTransaction: ctrl.isOrderTransaction,
            isAllPayedByCard: ctrl.isAllPayedByCard(),
            referenceTransaction: (Transaction != null && !ctrl.isQuotationEditMode) ? (Transaction.data.id) : (null),
            id: (ctrl.isQuotationEditMode && Transaction && Transaction.data) ? Transaction.data.id : null,
            updateQuotation: ctrl.isQuotationEditMode ? true : undefined,
            order_id: Order ? (Order.data.id) : null,
            send_documents: ctrl.customerData.send_documents,
            send_type: ctrl.businessInfo.data.msg_channel_inv_link,
            unique_id_for_creditcard: ctrl.creditPaymentId,
            sendInvoice: ctrl.sendInvoice,
            comment: ctrl.form.comment,
            quotation: ctrl.form.quotation,
            creditCardId: ctrl.creditCardId,
            retainer_id: ctrl.form.retainer_id || null,
            retainer_start_date: ctrl.form.retainer_start_date,
            retainer_period: ctrl.form.retainer_period,
            retainer_count: ctrl.form.retainer_count,
            retainer_infinity: ctrl.form.retainer_infinity,
            attached_digital_form_id: (ctrl.form.quotation && ctrl.attached_digital_form && ctrl.attached_digital_form.id) ? ctrl.attached_digital_form.id : null,
            continuous_deal: ctrl.continuous_deal,
            continuous_deal_count: ctrl.continuous_deal ? ctrl.continuous_deal_count : null,
            numberOfPaymentsEmv: ctrl.getEffectivePaymentCount(),
          },
          function(res){
            if ((res.status && res.status == 'error') || (res.data && res.data.status && res.data.status == 'error')) {
              swal({
                title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
                text: res.message ? res.message : (res.data && res.data.message ? res.data.message : $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TEXT')),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              });
              ctrl.cashboxLoading = false;
              return;
            }

            if(res.file_url && ctrl.customerData.send_documents == 4
              || ( ( ctrl.customerData.send_documents == 0 || ctrl.customerData.send_documents == null ) && ctrl.businessInfo.data.msg_channel_inv_link == 4 )
              || (ctrl.businessInfo.data.print_invoices && !ctrl.form.customer)){
              $scope.receipt_url = res.file_url;
              printJS($scope.receipt_url);
            }

            ctrl.items = [];
            ctrl.cashboxTotal = [];
            ctrl.resetPaymentMethods();

            var successTitle = $translate.instant('SWAL_TRANSACTIONS_SAVE_TITLE');
            if (ctrl.form.quotation) {
              successTitle = $translate.instant('SWAL_TRANSACTIONS_QUOTATION_SAVE_TITLE');
            } else if (ctrl.isCreditTransaction) {
              successTitle = $translate.instant('SWAL_TRANSACTIONS_CREDIT_SAVE_TITLE');
            }

            swal({
              title: successTitle,
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 1500
            });
            $user.go_default_screen();
            ctrl.remove_customer();
            ctrl.cashboxLoading = false;
          },
          function (res) {
            swal({
              title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
              text: res.message ? res.message : (res.data && res.data.message ? res.data.message : $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TEXT')),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 3000
            });
            ctrl.cashboxLoading = false;
          });
        };

        ctrl.newTransactionPrepare = function(){
          if (!ctrl.validateCreditTransactionLimit()) {
            return;
          }

          for(var method in ctrl.methods){
            ctrl.recalculatePaymentData(method);
        }
        
          if(!ctrl.customerData) {
            ctrl.customerData = {};
          }

          if (typeof ctrl.methods.cheque.payment_details.cheque_due_date == 'object') // Format moment;
              ctrl.methods.cheque.payment_details.cheque_due_date = ctrl.methods.cheque.payment_details.cheque_due_date.format('MM/DD/YYYY');


          var errorEmv = false; // is ther any errors in script
          /** validate data */
            var payCount = ctrl.getEffectivePaymentCount();
            if(isNaN(payCount)){
              errorEmv = true;
              alert("מספר התשלומים חייב להכיל ערך מספרי");
            } else {
              if (ctrl.continuous_deal) {
                if (parseInt(payCount, 10) < 2 || parseInt(payCount, 10) > 18) {
                  errorEmv = true;
                  alert($translate.instant('CONTINUOUS_DEAL_COUNT_INVALID'));
                }
              } else {
                if (payCount != 1) {
                  if (parseInt(payCount, 10) < 1 || parseInt(payCount, 10) > 18) {
                    errorEmv = true;
                    alert("מספר התשלומים חייב להיות מספר בין 1 ל- 18");
                  }
                }
              }
            }

            if(!errorEmv) {
              
              ctrl.cashboxLoading = true;
              $api.transactions.prepare.save({
                      pay_link: true,
                      items: ctrl.items,
                      methods: ctrl.methods,
                      customer: ctrl.form.customer,
                      email: ctrl.form.email,
                      phone: ctrl.occ_customer ? ctrl.form.customer_occ_phone : ctrl.form.phone,
                      customer_name: ctrl.occ_customer ? ctrl.form.customer_occ_name : (ctrl.form.name ? ctrl.form.name : ""),
                      isDebtTransaction: ctrl.isDebtTransaction,
                      isCreditTransaction: ctrl.isCreditTransaction,
                      isQuotationTransaction: ctrl.isQuotationTransaction,
                      isCreditCreditCard: ctrl.isCreditCreditCard,
                      isOrderTransaction: ctrl.isOrderTransaction,
                      isAllPayedByCard: ctrl.isAllPayedByCard(),
                      referenceTransaction: (Transaction != null && !ctrl.isQuotationEditMode) ? (Transaction.data.id) : (null),
                      id: (ctrl.isQuotationEditMode && Transaction && Transaction.data) ? Transaction.data.id : null,
                      updateQuotation: ctrl.isQuotationEditMode ? true : undefined,
                      order_id: Order ? (Order.data.id) : null,
                      send_documents: ctrl.customerData.send_documents,
                      send_type: ctrl.businessInfo.data.msg_channel_inv_link,
                      unique_id_for_creditcard: ctrl.creditPaymentId,
                      numberOfPaymentsEmv: ctrl.getEffectivePaymentCount(),
                      continuous_deal: ctrl.continuous_deal,
                      continuous_deal_count: ctrl.continuous_deal ? ctrl.continuous_deal_count : null,
                      sendInvoice: ctrl.sendInvoice,
                      comment: ctrl.form.comment,
                      quotation: ctrl.form.quotation,
                      creditCardId: ctrl.creditCardId,
                      retainer_id: ctrl.form.retainer_id || null,
                  },
                  function(res){
                      ctrl.items = [];
                      ctrl.cashboxTotal = [];
                      ctrl.resetPaymentMethods();
                      swal({
                          title: $translate.instant('SWAL_TRANSACTIONS_SAVE_LINK_TITLE'),
                          text: "",
                          type: "success",
                          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                          timer: 1500
                      });
                      $user.go_default_screen();
                      ctrl.remove_customer();
                      ctrl.cashboxLoading = false;
                  },
                  function (res) {
                      swal({
                          title: $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TITLE'),
                          text: res.message ? res.message : (res.data && res.data.message ? res.data.message : $translate.instant('SWAL_TRANSACTIONS_SAVE_ERROR_TEXT')),
                          type: "error",
                          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                          timer: 3000
                      });
                      ctrl.cashboxLoading = false;
                  });
            }
        };

        ctrl.resetPayment = function(){
            ctrl.cashboxLoading = false;
            $scope.method = ctrl.lastMethod = ctrl.firstPayMethod = undefined;
            ctrl.totalPaid = 0;
            for(var method in ctrl.methods){
              ctrl.methods[method].amount = null;
            }
        };

        ctrl.resetZCredit = function(){
          if (Info.data.cerdit_company == "3") {
            $api.transactions.resetzcredit.get()
          }
        }

        ctrl.attach_digital_form = function() {
          $uibModal.open({
            templateUrl: "app/modules/cashbox/modules/digital_forms/digital_forms.view.html",
            controller: "CashboxDigitalFormsController",
            controllerAs: "ctrl",
            scope: $scope,
            mediumModal: true,
            windowTopClass: "form-modal medium-modal laser-file-modal",
            resolve: {
              DigitalForms: ['$api', function($api) {
                // Load all available digital forms (same as in settings & customers)
                return $api.resolve("digital_forms@get").then(function(response) {
                  return response && response.data ? response.data : [];
                });
              }]
            }
          }).result.then(function (response) {
            if (response) {
              ctrl.attached_digital_form = response;
            }
          });
        }

        ctrl.remove_attached_digital_form = function() {
          ctrl.attached_digital_form = null;
        }

          /**
           * Fill all payment details for each payment method
           */
          ctrl.completePayment = function(){
            if($scope.method != null && ctrl.currentModal != null){
                ctrl.currentModal.close();
            }

            var checkedPayMethodsAmount = 0;
            for(var pMethod in ctrl.methods) {
                if (ctrl.methods[pMethod].active) checkedPayMethodsAmount++;
            }

            if (!$scope.method) {
              var isGiftCards = false;
              for (var i in ctrl.items) {
                  if (ctrl.items[i].item_type == 'gift_card') {
                      isGiftCards = true;
                      break;
                  }
              }
              
              var existingMethod = false;
              for(var method in ctrl.methods) {
                if (ctrl.methods[method].active) {
                  existingMethod = true;
                  break;
                }
              }

              if (!existingMethod && isGiftCards && !ctrl.methods.cash.active) {
                ctrl.methods = ctrl.choosePayMethod('cash');
              }
            }

            // Send transaction if all payment details has been already filled
            if($scope.method && $scope.method == ctrl.lastMethod){
                ctrl.newTransaction();
                return;
            }

            if($scope.method == null){
              for(var method in ctrl.methods) {
                  if (ctrl.methods[method].active) {
                      if (!ctrl.firstPayMethod) {
                          ctrl.firstPayMethod = method;
                      }
                      ctrl.lastMethod = method;
                  }
              }
              $scope.method = ctrl.firstPayMethod;

              // Check if only Cash payment method was chosen then do not show additional prompts
              if (ctrl.firstPayMethod == ctrl.lastMethod && (ctrl.firstPayMethod == 'cash' || ctrl.firstPayMethod == 'retainer')) {
                ctrl.methods[ctrl.firstPayMethod].amount = ctrl.cashboxTotal;
                ctrl.recalculatePaymentData(ctrl.firstPayMethod);
                ctrl.newTransaction();
                return;

                // Check if only Items_Card payment method was chosen then do not show additional prompts
              } else if (ctrl.firstPayMethod == ctrl.lastMethod && ctrl.firstPayMethod == 'items_card') {
                ctrl.methods[ctrl.firstPayMethod].amount = ctrl.cashboxTotalByItemsCard;
                ctrl.newTransaction();
                return;
              } else if (ctrl.firstPayMethod == ctrl.lastMethod && ctrl.firstPayMethod == 'pay_link') {
                ctrl.methods[ctrl.firstPayMethod].amount = ctrl.cashboxTotal;
                ctrl.newTransactionPrepare();
                return;
              }


            } else {
                var getNextMethod = false;
                for(var method in ctrl.methods) {
                    if (ctrl.methods[method].active) {
                        if (getNextMethod) {
                            $scope.method = method;
                            break;
                        }
                        if ($scope.method == method) {
                            getNextMethod = true;
                        }
                    }
                }
                if (!$scope.method) {
                    $scope.method = ctrl.firstPayMethod;
                }
            }

            ctrl.totalPaid = 0;
            for(var method in ctrl.methods){
                ctrl.recalculatePaymentData(method);
            }

            if (ctrl.isCreditTransaction && ctrl.methods.credit_card.active) {
              if (ctrl.methods.credit_card.amount > ctrl.isCreditCreditCard.total*1) {
                swal({
                  title: '',
                  text: $translate.instant('SWAL_CREDIT_CARD_REFUND_AMOUNT_ERROR_TEXT'),
                  type: "error",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 3000
                });
                ctrl.resetPayment();
                return;
              }
            }


            var template = "";
            if($scope.method == "credit_card"){
                if (ctrl.isCreditTransaction) {
                  ctrl.newTransaction();
                  return;
                }

                template = "credit.view.html";
                $scope.showContinue = false;

                if (Info.data.cerdit_company == "1") {
                  var tamp = ctrl.useCardReader ? "9" : "6";
                  var customer = ctrl.form.name ? ctrl.form.name : "לקוח לקוח";

                  $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/yaad?credit_suplier=" + Info.data.credit_suplier + "&amount=" + ctrl.methods["credit_card"].amount + "&tmp=" + tamp + "&customer=" + customer + "&b_id=" + Info.data.id);
                } else if (Info.data.cerdit_company == "0") {
                  $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/tranzila?credit_suplier=" + Info.data.credit_suplier + "&amount=" + ctrl.methods["credit_card"].amount);
                } else if (Info.data.cerdit_company == "2") {
                  var cardReader = ctrl.useCardReader ? true : false;
                  $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/pelecard?amount=" + ctrl.methods["credit_card"].amount + "&reader=" + cardReader + "&b_id=" + Info.data.id);
                } else if (Info.data.cerdit_company == "3") {
                  var useIframe = ctrl.useIframe ? true : false;
                  if (useIframe && !ctrl.creditCardId) {
                    ctrl.prepareTransaction(3, true);
                    //$scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/zcredit?amount=" + ctrl.methods["credit_card"].amount + "&b_id=" + Info.data.id + "&iframe=1");
                  } else {
                    if (!ctrl.creditCardId) {
                      var zPayCount = ctrl.getEffectivePaymentCount();
                      if(isNaN(zPayCount)){
                        errorEmv = true;
                        alert("מספר התשלומים חייב להכיל ערך מספרי");
                      }else {
                        if (ctrl.continuous_deal) {
                          if (parseInt(zPayCount, 10) < 2 || parseInt(zPayCount, 10) > 18) {
                            errorEmv = true;
                            alert($translate.instant('CONTINUOUS_DEAL_COUNT_INVALID'));
                          }
                        } else if (zPayCount != 1) {
                          if (parseInt(zPayCount, 10) < 1 || parseInt(zPayCount, 10) > 18) {
                            errorEmv = true;
                            alert("מספר התשלומים חייב להיות מספר בין 1 ל- 18");
                          }
                        }
                      }

                      template = "credit_zcard.view.html";
                    } else {
                      template = "";
                    }

                    ctrl.prepareTransaction(3, false);
                  }
                }
              //}
            }else{
                template = "payment.view.html";
            }

            if (template) {
              ctrl.currentModal = $uibModal.open({
                  templateUrl: "app/modules/cashbox/methods/" + template,
                  scope: $scope,
                  windowTopClass: "form-modal small-modal",
                  keyboard  : false
              });
            }
        };

        ctrl.prepareTransaction = function(company, iframe) {
          iframe = iframe || false;
          ctrl.cashboxLoading = true;
          
          $api.transactions.prepare.save(
            {
              items: ctrl.items,
              methods: ctrl.methods,
              customer: ctrl.form.customer,
              email: ctrl.form.email,
              phone: ctrl.occ_customer ? ctrl.form.customer_occ_phone : ctrl.form.phone,
              customer_name: ctrl.occ_customer ? ctrl.form.customer_occ_name : (ctrl.form.name ? ctrl.form.name : ""),
              isDebtTransaction: ctrl.isDebtTransaction,
              isCreditTransaction: ctrl.isCreditTransaction,
              isQuotationTransaction: ctrl.isQuotationTransaction,
              isCreditCreditCard: ctrl.isCreditCreditCard,
              isOrderTransaction: ctrl.isOrderTransaction,
              isAllPayedByCard: ctrl.isAllPayedByCard(),
              referenceTransaction: (Transaction != null && !ctrl.isQuotationEditMode) ? (Transaction.data.id) : (null),
              id: (ctrl.isQuotationEditMode && Transaction && Transaction.data) ? Transaction.data.id : null,
              updateQuotation: ctrl.isQuotationEditMode ? true : undefined,
              order_id: Order ? (Order.data.id) : null,
              send_documents: ctrl.customerData ? ctrl.customerData.send_documents : false,
              send_type: ctrl.businessInfo.data.msg_channel_inv_link,
              unique_id_for_creditcard: ctrl.creditPaymentId,
              numberOfPaymentsEmv: ctrl.getEffectivePaymentCount(),
              continuous_deal: ctrl.continuous_deal,
              continuous_deal_count: ctrl.continuous_deal ? ctrl.continuous_deal_count : null,
              sendInvoice: ctrl.sendInvoice,
              comment: ctrl.form.comment,
              quotation: ctrl.form.quotation,
              creditCardId: ctrl.creditCardId,
              retainer_id: ctrl.form.retainer_id || null,
            },
            function(res) {
              if (res && res.status && res.status == 'success') {
                if (!company) {
    
                  if(res.wskey == null || !res.wskey){
                    $scope.statusShow = "קרתה תקלה בעת ביצוע העסקה";
                  }
                }
                
                if (company == 3 && res.data && res.data.id_hash) {
                  if (iframe) {
                    ctrl.listenPaymentIframe(res.data.id_hash);
                    $rootScope.listenPaymentIframe(res.data.id_hash);
                    $scope.iframe = $sce.trustAsResourceUrl($api.baseURL + "/zcredit?id_hash="+res.data.id_hash+"&amount=" + ctrl.methods["credit_card"].amount + "&b_id=" + Info.data.id + "&iframe=1&continuous_deal=" + ctrl.continuous_deal + "&continuous_deal_count=" + ctrl.continuous_deal_count);
                  } else {
                    ctrl.listenPaymentIframe(res.data.id_hash);
                    $rootScope.listenPaymentIframe(res.data.id_hash);
                    $api.zcredit.get({"amount": ctrl.methods["credit_card"].amount, "b_id": Info.data.id, "continuous_deal": ctrl.continuous_deal, "continuous_deal_count": ctrl.continuous_deal_count, "npay": ctrl.getEffectivePaymentCount(), "id_hash": res.data.id_hash, "credit_deal": ctrl.creditDeal, "credit_card_id": ctrl.creditCardId}, function(response) {
                      ctrl.currentModal.close();                      
                    }, function(response) {
                      ctrl.currentModal.close();                      
                    });
                  }
                }
              } else {
                ctrl.currentModal.close();
                ctrl.cashboxLoading = false;

                if (!company) {
                  $scope.statusShow = "המסוף לא מגיב";
                }
              }
            }
          );
        }

        ctrl.listenPaymentIframe = function(hash) {
          var channel = (!pusher.channel('business-'+$rootScope.$user['b_id'])) ? pusher.subscribe('business-'+$rootScope.$user['b_id']) : pusher.channel('business-'+$rootScope.$user['b_id']);
          var eventName = 'iframe-result-'+hash;
          var eventHandler = function(response) {
            console.log(eventName, response);
            if (response) {
                if (response.result == 'success') {

                    var res = response.data;
                    if (res.file_url && ctrl.customerData) {
                      if(ctrl.customerData.send_documents == 4
                          || ((ctrl.customerData.send_documents == 0 || ctrl.customerData.send_documents == null) && ctrl.businessInfo.data.msg_channel_inv_link == 4)
                          || (ctrl.businessInfo && ctrl.businessInfo.data && ctrl.businessInfo.data.print_invoices && !ctrl.form.customer)){
                          $scope.receipt_url = res.file_url;
                          printJS($scope.receipt_url);
                      }
                    }
    
                    ctrl.items = [];
                    ctrl.cashboxTotal = [];
                    ctrl.resetPaymentMethods();
                    $user.go_default_screen();
                    ctrl.remove_customer();
                    ctrl.cashboxLoading = false;
    
                } else if (response.result == 'error') {
                    ctrl.currentModal.close();
                    ctrl.cashboxLoading = false;
                }
            }
          };
    
          channel.bind(eventName, eventHandler);

          ctrl.unsubscribePaymentIframe = function() {
            channel.unbind(eventName, eventHandler);
          };
        }

        $scope.$on('$destroy', function() {
          if (ctrl.unsubscribePaymentIframe) {
              ctrl.unsubscribePaymentIframe();
          }
      });
        
        var channel = (!pusher.channel('business-'+$rootScope.$user['b_id'])) ? pusher.subscribe('business-'+$rootScope.$user['b_id']) : pusher.channel('business-'+$rootScope.$user['b_id']);
        channel.bind('zcredit-event', function(response) {
          ctrl.checkZcreditResponse(response);
        });


        /**
        * Fill payment data
        *
        * @param method
        */
        ctrl.recalculatePaymentData = function(method){
          if(method == $scope.method && method == ctrl.lastMethod) {
              var method_amount = ctrl.cashboxTotal - ctrl.totalPaid;
              ctrl.methods[method].amount = method_amount;
          } else {
              ctrl.totalPaid += ctrl.methods[method].amount;
              var method_amount = ctrl.methods[method].amount;
          }
          var subtotal = (method_amount / (100 + ctrl.dealer_vat)) * 100;
          subtotal = (Math.round(subtotal * 100))/100;
          ctrl.methods[method].subtotal = subtotal;
          var tax = method_amount - subtotal;
          ctrl.methods[method].vat =  tax;
        };


        ctrl.filterCategory = function(c_id){
            ctrl.categoryFilter = c_id;

            if(c_id == -1){
                ctrl.products = Items.data;
                return;
            }

            ctrl.searchItem = "";

            ctrl.products = [];
            var list = Items.data;
            for(var i in list)
                if(list[i].categories != null && list[i].categories.indexOf(c_id) != -1){
                    ctrl.products.push(list[i]);
                }
        };

        ctrl.addItem = function(product){
          for(var i in ctrl.items){
              if(ctrl.items[i].id == product.id && ctrl.items[i].price == product.price && !ctrl.items[i].isCard && !ctrl.items[i].card_balance_used){
                  ctrl.items[i].quantity++;
                  return;
              }
          }
          product = JSON.parse(JSON.stringify(product));
          product.quantity = 1;
          product.price = parseFloat(parseFloat(product.price).toFixed(2));

          product.subtotal = (product.price / (100 + ctrl.dealer_vat)) * 100;
          product.subtotal = (Math.round(product.subtotal * 100))/100;
          product.tax = product.price - product.subtotal;
          product.original_price = product.price;

          ctrl.items.push(product);

          if (product.item_type == 'course') {
            $api.courses.cashbox.get({
              id: product.id
            }, function (res) {
              if (res && res.data) {
                product.courses = res.data;
                product.courseOptions = ctrl.buildCourseOptions(res.data);
              }
            });
          }

          if (ctrl.form.quotation) {
            ctrl.resetPaymentMethods();
            ctrl.choosePayMethod('cash');
          }
        };

        ctrl.removeItem = function(index){
          if(!ctrl.isDebtTransaction){
            var item = ctrl.items[index];

            ctrl.items.splice(index, 1);

            if (item && item.item_type == 'gift_card' && item.number) {
              var newSelected = [];
              for (var i = 0; i < ctrl.selectedCards.length; i++) {
                if (ctrl.selectedCards[i].number !== item.number) {
                  newSelected.push(ctrl.selectedCards[i]);
                }
              }
              ctrl.selectedCards = newSelected;
            }

            if (ctrl.selectedCards.length == 0) {
              ctrl.methods['retainer'].disabled = false;
            }
          }
        };

        ctrl.makeCard = function(index) {
          ctrl.cardQty = ctrl.items[index].quantity*1;
          ctrl.cardQtyModel = ctrl.items[index].quantity*1;
          ctrl.cardPerItem = ctrl.items[index].price*1;
          ctrl.cardPerItemModel = ctrl.items[index].price*1;
          ctrl.cardPrice = ctrl.items[index].price*ctrl.cardQty;
          ctrl.expired_at = ctrl.items[index].expired_at;
          ctrl.makeCardIndex = index;

          ctrl.currentModal = $uibModal.open({
              templateUrl: "app/modules/cashbox/methods/card.popup.html",
              scope: $scope,
              windowTopClass: "form-modal small-modal",
              keyboard  : false
          });
        };

        ctrl.makeCardAccept = function() {
            // if (!ctrl.expired_at) {
            //   swal({
            //     text: $translate.instant('SWAL_CARD_EXPIRED_DATE_REQUIRED'),
            //     type: "error",
            //     confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            //     timer: 3000,
            //   });
            //   return
            // }
            
            if (ctrl.items[ctrl.makeCardIndex]) {
              ctrl.items[ctrl.makeCardIndex].isCard = true;
              ctrl.items[ctrl.makeCardIndex].cardQty = ctrl.cardQty*1;
              ctrl.items[ctrl.makeCardIndex].cardPrice = ctrl.cardPrice*1;
              ctrl.items[ctrl.makeCardIndex].price = ctrl.cardPerItem*1;
              ctrl.items[ctrl.makeCardIndex].quantity = ctrl.cardQty*1;
              ctrl.items[ctrl.makeCardIndex].expired_at = ctrl.expired_at;
            }
            ctrl.currentModal.close();
        }

        ctrl.checkAlreadyExistCard = function(index) {
          for (var i in ctrl.items) {
            if (i != index) {
              if (ctrl.items[i].isCard && ctrl.items[index].id == ctrl.items[i].id) {
                return true;
              }
            }
          }
          return false;
        }

        ctrl.roundedPerCardItem = function() {
          return (ctrl.cardQty != 0 && ctrl.cardQty && ctrl.cardPrice) ? (Math.round((ctrl.cardPrice/ctrl.cardQty)*100) / 100) : 0;
        }

        ctrl.changeCardQty = function() {
          if (ctrl.cardQtyModel && ctrl.cardQtyModel > 0) {
            ctrl.cardPrice = Math.round((ctrl.cardPerItem * ctrl.cardQtyModel)*100)/100;
          } else {
            ctrl.cardPrice = ctrl.cardPerItem;
          }
          ctrl.cardQty = ctrl.cardQtyModel;
          //ctrl.cardPerItem = ctrl.roundedPerCardItem();
        }

        ctrl.changeCardPerItem = function() {
          if (ctrl.cardPerItemModel && ctrl.cardPerItemModel > 0) {
            ctrl.cardPrice = Math.round((ctrl.cardPerItemModel * ctrl.cardQty)*100)/100;
          } else {
            ctrl.cardPrice = 0
          }
          ctrl.cardPerItem = ctrl.cardPerItemModel;
        }

        ctrl.changeCardPrice = function() {
          if (ctrl.cardPrice && ctrl.cardPrice > 0) {
            ctrl.cardPerItemModel = ctrl.roundedPerCardItem();
            ctrl.cardPerItem = ctrl.roundedPerCardItem();
          } else {
            ctrl.cardPerItemModel = 0;
            ctrl.cardPerItem = 0;
          }
        }

        ctrl.trigger_items_update = function(newValue, oldValue){
            if(newValue != oldValue && !ctrl.isManuallyEditingTotal){
                ctrl.cashboxTotal = 0;
                ctrl.cashboxTotalByItemsCard = 0;
                
                for (var i in ctrl.items) {
                  if(ctrl.items[i].card_balance_used > ctrl.items[i].quantity) {
                    ctrl.items[i].card_balance_used = ctrl.items[i].quantity;
                  }
                  var amountWithoutCards = ctrl.items[i].card_balance_used && !ctrl.items[i].isCard
                    ? ctrl.items[i].quantity - ctrl.items[i].card_balance_used
                    : ctrl.items[i].quantity;
                  ctrl.cashboxTotal += (ctrl.items[i].price) * amountWithoutCards;
                  ctrl.cashboxTotalByItemsCard += (ctrl.items[i].price) *  (ctrl.items[i].quantity - amountWithoutCards);

                  //console.log(Order.data);
                  //console.log(ctrl.items[i]);
                }

                if (!ctrl.prepaid && ctrl.isCreditTransaction && (Transaction && Transaction.data && Transaction.data.prepaid)) {
                  ctrl.cashboxTotal = Transaction.data.total;
                }

                if(ctrl.isDebtTransaction && ctrl.cashboxTotal > ctrl.maxDebt) {
                    ctrl.items[0].price = ctrl.maxDebt;


                    ctrl.items[0].subtotal = (ctrl.items[0].quantity / (100 + ctrl.dealer_vat)) * 100;
                    ctrl.items[0].subtotal = (Math.round(ctrl.items[0].subtotal * 100))/100;
                    ctrl.items[0].tax = ctrl.items[0].price - ctrl.items[0].subtotal;
                    // ctrl.items[0].tax = (Math.round(ctrl.items[0].tax * 100))/100;

                    swal({
                        title: $translate.instant('SWAL_CASHBOX_UPDATE_TITLE'), 
                        html: $translate.instant('SWAL_CASHBOX_UPDATE_TEXT').replace('[price]', $filter('price')(ctrl.maxDebt)),
                        type: "info",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }
            }
        };

        $scope.$watch("ctrl.items", ctrl.trigger_items_update, true);

        $scope.$watch("ctrl.searchItem", function(newValue, oldValue){
            if(oldValue != newValue){

                ctrl.categoryFilter = -1;

                if(ctrl.searchItem == "") {
                    ctrl.products = Items.data;
                    return;
                }

                ctrl.products = [];
                var list = Items.data;
                for(var i in list){
                    if(list[i].name.toLowerCase().indexOf(ctrl.searchItem.toLowerCase()) != -1){
                        ctrl.products.push(list[i]);
                    }
                }
            }
        });

        var check_oncredit_customer = function(){
            if(ctrl.methods.oncredit.active == true && !ctrl.form.customer){
                swal({
                    title: $translate.instant('SWAL_CHECK_ONCREDIT_TITLE'),
                    text: $translate.instant('SWAL_CHECK_ONCREDIT_TEXT'),
                    type: "info",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                ctrl.methods.oncredit.active = false;
            }
        };

        $scope.$watch("ctrl.form.customer", check_oncredit_customer);
        $scope.$watch("ctrl.methods.oncredit.active", check_oncredit_customer);

        $header.title = "קופה";
        $header.breadcrumbs.push({
            "title": "קופה"
        });

        /**
         * Check if customer payed by his Items Cards for all order
         *
         * @returns {boolean}
         */
        ctrl.isAllPayedByCard = function() {
          var isAllPayedByCard = true;
          if(ctrl.items && ctrl.items.length > 0) {
            ctrl.items.forEach(function (item) {
              if(!item.card_balance_used || item.quantity != item.card_balance_used) {
                isAllPayedByCard = false;
              }
            });
          } else {
            isAllPayedByCard = false;
          }
          ctrl.methods['items_card'].active =  isAllPayedByCard ? true : false;

          return isAllPayedByCard;
        }

        ctrl.isAllPayedByGiftCards = function() {
          var total = 0;

          for (var i = 0; i < ctrl.items.length; i++) {
            var it = ctrl.items[i];
            total += it.price * 1;
          }

          return total == 0;
        }

        ctrl.isAllPayByCreditCard = function() {
          var isAllPayByCreditCard = ctrl.methods['credit_card'].active ? true : false;
          for(var i in ctrl.methods) {
            if(ctrl.methods[i].active && i != 'credit_card') {
              isAllPayByCreditCard = false;
              break;
            }
          }
          return isAllPayByCreditCard;
        }

        ctrl.hasUsedAnyCards = function() {
          if (!ctrl.items || !ctrl.items.length) {
            return false;
          }

          return ctrl.items.some(function(item) {
            return !!(item.card_balance_used && item.card_balance_used * 1 > 0);
          });
        }

        ctrl.hasUsedGiftCards = function() {
          if (!ctrl.items || !ctrl.items.length) {
            return false;
          }

          return ctrl.items.some(function(item) {
            return item.item_type == 'gift_card' && item.price * 1 < 0;
          });
        }


          /**
           * Toggle payment method
           *
           * @param method
           */
          ctrl.choosePayMethod = function(method){
            if(ctrl.items.length > 0 && !ctrl.methods[method].disabled) {
                ctrl.methods[method].active = !ctrl.methods[method].active;
            }

            ctrl.disableRemainingPayMethods();
            return ctrl.methods
        };

          /**
           * Disable other payment methods if 2 of them already was chosen.
           * If less than 2, then enable.
           */
        ctrl.disableRemainingPayMethods = function() {
          ctrl.continuous_deal = false;
          ctrl.continuous_deal_count = 2;
            var checkedPayMethodsAmount = 0;
            for(var pMethod in ctrl.methods) {
                if (ctrl.methods[pMethod].active) checkedPayMethodsAmount++;
            }

            var isDisabled = true;
            if(checkedPayMethodsAmount < 2) {
              isDisabled = false;
            }

            for(pMethod in ctrl.methods) {
                if (!ctrl.methods[pMethod].active) ctrl.methods[pMethod].disabled = isDisabled;
            }

            if (ctrl.methods['credit_card'].active) {
                ctrl.methods['credit_card_external'].disabled = true
                ctrl.methods['pay_link'].disabled = true
                ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['pay_link'].active) {
              ctrl.methods['credit_card_external'].disabled = true
              ctrl.methods['credit_card'].disabled = true
              ctrl.methods['oncredit'].disabled = true
              ctrl.methods['cash'].disabled = true
              ctrl.methods['cheque'].disabled = true
              ctrl.methods['bank_transfer'].disabled = true
              ctrl.methods['items_card'].disabled = true
              ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['credit_card_external'].active) {
                ctrl.methods['credit_card'].disabled = true
                ctrl.methods['pay_link'].disabled = true
                ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['credit_card'].active ||
                ctrl.methods['oncredit'].active ||
                ctrl.methods['cash'].active ||
                ctrl.methods['cheque'].active ||
                ctrl.methods['bank_transfer'].active ||
                ctrl.methods['items_card'].active
              ) {
              ctrl.methods['pay_link'].disabled = true
              ctrl.methods['retainer'].disabled = true
            }

            if (ctrl.methods['retainer'].active) {
              ctrl.methods['credit_card'].disabled = true
              ctrl.methods['pay_link'].disabled = true
              ctrl.methods['oncredit'].disabled = true
              ctrl.methods['cash'].disabled = true
              ctrl.methods['cheque'].disabled = true
              ctrl.methods['bank_transfer'].disabled = true
              ctrl.methods['items_card'].disabled = true
              ctrl.methods['credit_card_external'].disabled = true
            }
        }

        if(Transaction != null){
            ctrl.isCreditTransaction = Transaction.data && Transaction.data.quotation ? false : true;
            ctrl.isQuotationTransaction = Transaction.data && Transaction.data.quotation ? true : false;
            if (ctrl.isQuotationEditMode) {
              ctrl.isCreditTransaction = false;
              ctrl.isQuotationTransaction = true;
              ctrl.form.quotation = true;
            }
            ctrl.load_credit_data();

            if (Transaction.data.customer_data) {
              ctrl.customerData = Transaction.data.customer_data;
              ctrl.customerData.oncredit = parseFloat(ctrl.customerData.oncredit);
              ctrl.form.customer = String(ctrl.customerData.id);
            } else {
              ctrl.form.customer = null;
              if (Transaction.data.customer_name) {
                ctrl.occ_customer = true;
                ctrl.form.customer_occ_name = Transaction.data.customer_name;
                ctrl.form.customer_occ_phone = Transaction.data.customer_phone;
              }
            }

            if (Transaction.data.payments) {
              for (var i in Transaction.data.payments) {
                if (Transaction.data.payments[i].allow_credit && ctrl.cerdit_company == 3) {
                  ctrl.isCreditCreditCard = Transaction.data.payments[i];
                }
              }
            }
            
            if (ctrl.isQuotationEditMode) {
              ctrl.choosePayMethod('cash');
            }

            ctrl.update_transaction_customer_data();
            
            ctrl.isContinuousDealCredit = !!(Transaction.data.continuous_deal_id && Transaction.data.continuous_deal_type == 'parent');

            $header.title += " - זיכוי עסקה";
            $header.breadcrumbs.push({
                "title" : "זיכוי עסקה"
            });
        }

        /**
         * Initiate dept data for closing the dept
         */
        if ($state.current.name == 'app.cashbox.closedebt' && $stateParams.customer) {
          ctrl.isDebtTransaction = true;
          ctrl.form.customer = $stateParams.customer;
          ctrl.customerData = Customer.data;
          ctrl.update_transaction_customer_data();

          ctrl.maxDebt = parseFloat(parseFloat(ctrl.customerData.oncredit).toFixed(2));
          ctrl.items.push({
            quantity: 1,
            price: ctrl.maxDebt,
            name: "יתרת לקוח"
          });
          ctrl.trigger_items_update(true, false);

          $header.title += " - כיסוי יתרה";
          $header.breadcrumbs.push({
            "title": "כיסוי יתרה"
          });
        }


        ctrl.load_order_data = function () {

          ctrl.isOrderTransaction = true;
          ctrl.prepaid = Order.data.prepaid;
      
          if (Order.data.customer) {
              ctrl.form.customer = String(Order.data.customer);
              ctrl.customerData = Order.data.customer_data;
              ctrl.checkCustomerCards = true;
              ctrl.update_transaction_customer_data();
          }
      
          ctrl.form.email = Order.data.email;
          ctrl.form.phone = Order.data.phone;
      
          if (!ctrl.form.customer) {
              ctrl.form.name = Order.data.customer_name;
              ctrl.form.customer_occ_name = Order.data.customer_name;
              ctrl.form.customer_occ_phone = Order.data.customer_phone;
          }
      
          var newItem, duration;
          ctrl.items = [];
          ctrl.bu_type = parseInt(Info.data.type);
      
          if (Array.isArray(Order.data.items)) {
              for (var i = 0; i < Order.data.items.length; i++) {
                  var orderItem = Order.data.items[i];
      
                  if (!orderItem || typeof orderItem !== 'object') {
                      continue;
                  }
      
                  if (orderItem.part) {
                      continue;
                  }
      
                  if (!orderItem.item_data || typeof orderItem.item_data !== 'object') {
                      continue;
                  }
      
                  var increasedPresentItemQuantity = false;
      
                  newItem = angular.copy(orderItem.item_data);
      
                  newItem.quantity = parseFloat(newItem.quantity);
                  if (isNaN(newItem.quantity)) {
                      newItem.quantity = 0;
                  }
      
                  if (newItem.item_type == 'service') {
                      newItem.quantity = 1;
                  }
      
                  newItem.in_order = true;
                  newItem.price = (newItem.price === '' || newItem.price == null)
                      ? 0
                      : parseFloat(parseFloat(newItem.price).toFixed(2));
      
                  if (isNaN(newItem.price)) {
                      newItem.price = 0;
                  }
      
                  newItem.original_price = newItem.price;
      
                  // Merge duplicate with equal prices
                  ctrl.items.forEach(function (item, index) {
                      if (
                          ctrl.items[index] &&
                          ctrl.items[index].id === newItem.id &&
                          ctrl.items[index].price == newItem.price &&
                          ctrl.items[index].resource_id == orderItem.resource_id
                      ) {
                          ctrl.items[index].quantity++;
                          increasedPresentItemQuantity = true;
                      }
                  });
      
                  var subtotal = (newItem.price / (100 + ctrl.dealer_vat)) * 100;
                  subtotal = Math.round(subtotal * 100) / 100;
                  newItem.subtotal = subtotal;
                  newItem.tax = newItem.price - subtotal;
      
                  newItem.resource = orderItem.resource_id != null ? String(orderItem.resource_id) : '';
      
                  if (Array.isArray(ctrl.resources)) {
                      for (var j = 0; j < ctrl.resources.length; j++) {
                          var resource = ctrl.resources[j];
      
                          if (!resource || typeof resource !== 'object') {
                              continue;
                          }
      
                          if (String(resource.id) == newItem.resource) {
                              if (!resource.sales_active) {
                                  newItem.resource = '';
                              }
                              break;
                          }
                      }
                  }
      
                  if (ctrl.bu_type == 2) {
                      newItem.quantityDisabled = true;
                  }
      
                  if (ctrl.bu_type == 2) {
                      var startTime = orderItem.start_time ? moment(orderItem.start_time) : null;
                      var endTime = orderItem.end_time ? moment(orderItem.end_time) : null;
      
                      if (startTime && endTime && startTime.isValid() && endTime.isValid()) {
                          duration = moment.duration(endTime.diff(startTime));
      
                          if (newItem.item_type == 'service') {
                              newItem.quantity = Math.round(duration.asDays());
                          }
                      }
                  }
      
                  if (!increasedPresentItemQuantity) {
                      ctrl.items.push(newItem);
                  }
              }
          }
      
          if (Order.data.prepaid) {
              var prepaidSubtotal = (Order.data.prepaid * 1 / (100 + ctrl.dealer_vat)) * 100;
              prepaidSubtotal = Math.round(prepaidSubtotal * 100) / 100;
              var prepaidTax = Order.data.prepaid * 1 - prepaidSubtotal;
      
              ctrl.items.push({
                  item_duration: null,
                  item_id: null,
                  item_type: "prepaid",
                  name: "מקדמה",
                  original_price: Order.data.prepaid * -1,
                  price: Order.data.prepaid * -1,
                  quantity: 1,
                  subtotal: prepaidSubtotal * -1,
                  tax: prepaidTax * -1,
              });
          }
      
          ctrl.trigger_items_update(false, true);
      
          $header.title += " - סגירת הזמנה";
          $header.breadcrumbs.push({
              "title": "סגירת הזמנה"
          });
        };

        ctrl.load_retainer_data = function() {
          ctrl.form.retainer_id = Retainer.data.id ? String(Retainer.data.id) : null;
          ctrl.creditCardId = Retainer.data.credit_card_id ? String(Retainer.data.credit_card_id) : null;
          ctrl.form.customer = Retainer.data.customer_id || null;
          ctrl.form.retainer_start_date = Retainer.data.retainer_start_date ? moment(Retainer.data.retainer_start_date).toDate() : null;
          ctrl.form.retainer_count = Retainer.data.retainer_count || null;
          ctrl.form.retainer_infinity = Retainer.data.retainer_infinity || false;
          ctrl.form.retainer_period = Retainer.data.retainer_period || 'monthly';
          ctrl.cashboxTotal = Retainer.data.transaction_data.total || 0;
          ctrl.sendInvoice = Retainer.data.transaction_data.sendInvoice ? true : false;

          ctrl.customerData = Retainer.data.transaction_data.customer_data;
          ctrl.update_transaction_customer_data();

          ctrl.items = [];
          for(var i in Retainer.data.transaction_data.items) {
            ctrl.items.push(Retainer.data.transaction_data.items[i]);
          }

          for(var i in Retainer.data.transaction_data.payments) {
            ctrl.methods[i] = Retainer.data.transaction_data.payments[i];
          }

          ctrl.disableRemainingPayMethods();
        }


          /**
           * Makes Payment button disabled
           *
           * @returns {boolean}
           */
        ctrl.isDisabledPaymentBtn = function() {
            return  (ctrl.isDebtTransaction && ctrl.cashboxTotal > ctrl.maxDebt)
                || ctrl.cashboxTotal == 0
                || (ctrl.isCreditTransaction && ctrl.getCreditTransactionLimit() !== null && Math.abs(ctrl.cashboxTotal) - ctrl.getCreditTransactionLimit() > 0.0001)
                || (!ctrl.methods.cash.active && !ctrl.methods.credit_card.active && !ctrl.methods.oncredit.active
                    && !ctrl.methods.cheque.active && !ctrl.methods.credit_card_external.active && !ctrl.methods.pay_link.active && !ctrl.methods.bank_transfer.active && !ctrl.methods.retainer.active)
                || (ctrl.methods.retainer.active && (!ctrl.form.retainer_start_date || !ctrl.creditCardId || !ctrl.form.retainer_period || (!ctrl.form.retainer_count && !ctrl.form.retainer_infinity)))
                || ctrl.customerMissingVatForAllocation()
                || (ctrl.isCardItemPresent() && (!ctrl.customerData || angular.equals(ctrl.customerData, {}))
                || (ctrl.creditDeal && (ctrl.numberOfPaymentsEmv*1 < 3 || ctrl.numberOfPaymentsEmv*1 > 18)));
        }

        /**
        * Check if user going to buy item with type 'card'
        *
        * @returns {boolean}
        */
        ctrl.isCardItemPresent = function () {
          var isCardItemPresent = false;
          ctrl.items.forEach(function (item) {
              if(item.item_type == 'card') {
                  isCardItemPresent = true;
              }
          })

          return isCardItemPresent;
        }

        ctrl.isDisabledPaymentBtn();

          /**
           * Check if payment details is invalid
           * @returns {boolean}
           */
        ctrl.paymentDetailsInvalid = function() {
            if($scope.method == 'cheque' || $scope.method == 'bank_transfer') {
                if(!ctrl.methods[$scope.method].payment_details.bank_number) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Mark Item with card indicator property if customer has appropriate Card
         */
        ctrl.matchCardsForItems = function() {
          for(var i in ctrl.products) {
            if(ctrl.hasCustomerCardForItem(ctrl.products[i].id)) {
              ctrl.products[i].customer_has_card = true;
            } else {
              ctrl.products[i].customer_has_card = false;
            }
          }
        };

        ctrl.paymentDetailsInvalid();



        if(Order){
            ctrl.load_order_data();
        }

        if (Retainer) {
          ctrl.load_retainer_data();
        }

        ctrl.changePercentage = function(index, total) {
          if (!total) {
            ctrl.total_discount = '';
          }

          var originalItem = false;
          for (var i in ctrl.products) {
            if (ctrl.items[index] && ctrl.products[i].id == ctrl.items[index].id) {
              originalItem = ctrl.products[i];
            }
          }

          var original_price = ctrl.items[index].original_price ? ctrl.items[index].original_price : originalItem.price;

          if (ctrl.items[index].discount && ctrl.items[index].discount > 0) {
            ctrl.items[index].price = Math.round((original_price * (1 - ctrl.items[index].discount*1 / 100))*100)/100;
          } else if (ctrl.items[index].original_price) {
            ctrl.items[index].price = original_price;
          }
        };

        ctrl.changePrice = function(index) {
          if ((ctrl.items[index].discount && ctrl.items[index].discount > 0) || ctrl.show_discount) {
            var originalItem = false;
            for (var i in ctrl.products) {
              if (ctrl.items[index] && ctrl.products[i].id == ctrl.items[index].id) {
                originalItem = ctrl.products[i];
              }
            }

            var original_price = ctrl.items[index].original_price ? ctrl.items[index].original_price : originalItem.price;

            var discount = Math.round((1 - ctrl.items[index].price / original_price)*10000)/100;
            if (discount && discount > 0) {
              ctrl.items[index].discount = discount;
            } else {
              ctrl.items[index].discount = '';
            }
          }
        }

        ctrl.changeTotalPercentage = function() {
          ctrl.items.forEach(function (item, index) {
            item.discount = item.card_balance_used ? item.discount : ctrl.total_discount;
            ctrl.changePercentage(index, true);
          });
        }

        ctrl.changeTotalSum = function() {
          if (!ctrl.cashboxTotal) {
            return;
          }

          // Set flag to prevent automatic recalculation while editing
          ctrl.isManuallyEditingTotal = true;

          var originalTotal = 0;
          ctrl.items.forEach(function (item) {
            originalTotal += item.original_price * ((item.quantity || 1) - (item.card_balance_used || 0));
          });

          if (ctrl.cashboxTotal > originalTotal) {
            ctrl.cashboxTotal = originalTotal;
          }

          var totalDiscount = (originalTotal - (ctrl.cashboxTotal || 0)) / originalTotal * 100;
          ctrl.total_discount = !totalDiscount || totalDiscount < 0 ? '' : parseFloat(totalDiscount).toFixed(2)*1;
          ctrl.changeTotalPercentage();
          
          // Reset flag after a short delay to allow normal recalculation later
          setTimeout(function() {
            ctrl.isManuallyEditingTotal = false;
          }, 100);
        }
    });

    angular.module("app.controllers").controller("BanksSelectController", function ($scope, $state, Banks, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;
        ctrl.banks = Banks;
        ctrl.item_name = "";


        /**
         * search item
        */
        $scope.find_item = function(forceEmptySearch) {
            if( ctrl.item_name != "" || forceEmptySearch) {
                var found = [];
                for (var i in Banks) {
                    if (Banks[i].name && Banks[i].name.toLowerCase().indexOf(ctrl.item_name.toLowerCase()) >= 0) {
                        found.push(Banks[i]);
                    }
                }
                ctrl.banks = found;
            } else {
                ctrl.banks = Banks;
            }

            if ($('#res_dt').DataTable()) {
              $('#res_dt').DataTable().clear().draw();
            }
        }

        $scope.find_item(true);



        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('scrollY', '500px')
            .withOption('aaSorting', [])
            .withOption('searching', false)
            .withOption('info', false)
            .withOption('paging', false);

        ctrl.selectBank = function (index) {
            $uibModalInstance.close(ctrl.banks[index]);
        }

    });

    function parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair.shift());
        var value = decodeURIComponent(pair.join("="));
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
          query_string[key] = value;
          // If second entry with this name
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], value];
          query_string[key] = arr;
          // If third or later entry with this name
        } else {
          query_string[key].push(value);
        }
      }
      return query_string;
    }
})();

(function () {

    angular.module('app.controllers')

        .controller('UsersListController', function (Users, $state, $header, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            var ctrl = this;

            /**
             * Assign data to the table
             */
            ctrl.tableData = Users.data;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "משתמשים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.admin"
            });
            $header.breadcrumbs.push({
                "title": "משתמשים"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider);

        });

})();

(function() {

    angular.module("app.controllers").controller("UsersFormController", function($scope, $state, $api, $rootScope, dates, Businesses, User, $uibModal, $translate) {

        if ($rootScope.userRole !== 1){
          $state.go('app.dashboard');
          return;
        }

        var ctrl = this;

        ctrl.form = {};
        ctrl.form.business_ids = [];

        function toIds(arr) {
          if (!arr || !arr.length) return [];
          return arr.map(function(x) {
            var n = (x && (x.id != null ? x.id : x));
            n = parseInt(n, 10);
            return n > 0 ? n : null;
          }).filter(Boolean);
        }

        function parseBusinessIds(val) {
          if (!val) return [];
          if (typeof val === 'string') { try { val = JSON.parse(val); } catch (e) { val = val.split(','); } }
          if (!Array.isArray(val)) return [];
          return val.map(function(i) { var n = parseInt(i, 10); return n > 0 ? n : null; }).filter(Boolean);
        }

        ctrl.user_roles = [
          {title: 'USER_ROLE_MANAGER', key: 0},
          {title: 'USER_ROLE_EMPLOYEE', key: 2},
          {title: 'USER_ROLE_EMPLOYEE_PERMISSION', key: 3},
          {title: 'USER_ROLE_ADMIN', key: 4}
        ];
        ctrl.roleOptions = [];
        ctrl.resources = [];
        

        $scope.formScreen = 0;
        $scope.isMobile = (angular.element(document).width() < 769)

        $scope.isEdit = false;
        if ($rootScope.b_id) {
          $scope.b_id = $rootScope.b_id;
          delete $rootScope.b_id;
        }

        /**
         * Initialize edit data
         */
        if (Businesses) ctrl.businesses = Businesses.data || [];
        else ctrl.businesses = [];

        if (User != null) {
            $scope.isEdit = true;
            ctrl.form = User.data;
            ctrl.form.password = "";
            ctrl.form.b_id = String(User.data.b_id);
            ctrl.form.role = String(User.data.role);
            ctrl.form.resource_id = User.data.resource_id ? String(User.data.resource_id) : "";
            ctrl.form.business_ids = parseBusinessIds(User.data.business_ids);
            if (ctrl.form.role == '4' && !ctrl.form.business_ids.length && ctrl.form.b_id)
                ctrl.form.business_ids = [parseInt(ctrl.form.b_id, 10)].filter(function(n) { return n > 0; });
        } else {
            ctrl.form.b_id = $scope.b_id ? String($scope.b_id) : "";
            ctrl.form.role = '0';
            ctrl.form.business_ids = [parseInt(ctrl.form.b_id, 10)].filter(function(n) { return n > 0; });
        }

        for (var i in ctrl.businesses) {
            if (ctrl.businesses[i].id*1 == ctrl.form.b_id*1)
                ctrl.name_business = ctrl.businesses[i].name;
        }

        ctrl.updateRoleOptions = function() {
            ctrl.roleOptions = ctrl.user_roles.filter(function(role) {
                return !((!ctrl.form.b_id || ctrl.form.b_id == 'undefined') && role.key == 3);
            }).map(function(role) {
                return {
                    id: String(role.key),
                    name: $translate.instant(role.title)
                };
            });
        };

        ctrl.showBusinessList = function() {
            $uibModal.open({
                templateUrl: "app/modules/admin/modules/users/modules/popup/business.popup.html",
                controller: "BusinessSelectController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal medium-modal",
                resolve: {
                    Businesses: [function () {
                        return ctrl.businesses;
                    }]
                }
            }).result.then(function (business) {
                if(business) {
                    ctrl.form.b_id = business.id;
                    ctrl.name_business = business.name;
                    ctrl.updateRoleOptions();
                }
            });
        }



        ctrl.submit = function() {
            var form = ctrl.form, ids = toIds(form.business_ids);
            if (form.role == 4 && !ids.length) {
                swal({ title: $translate.instant('ADMIN_BUSINESS'), text: $translate.instant('SETTINGS_USER_VALID'), type: 'warning', confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON') });
                return;
            }
            var payload = angular.copy(form);
            if (form.role == 4) { payload.b_id = ids[0]; payload.business_ids = ids; }
            else if (!payload.b_id || payload.b_id === 'undefined') payload.b_id = null;

            if (User == null) {
                $api.users.save(payload, function(response){
                    if (response.status === 'success') {
                        swal({ title: $translate.instant('SWAL_ADMIN_USERS_SAVE_TITLE'), type: "success", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'), timer: 2000 });
                        $state.transitionTo("app.admin.users", {}, {reload: true});
                    }
                });
            } else {
                if ($scope.formScreen == 0 && (form.password != "" || form.email != User.data.email)) {
                    $scope.formScreen = 1;
                    return;
                }
                $api.users.single.save({ id: User.data.id }, payload, function(response){
                    if (response.success) {
                        swal({ title: $translate.instant('SWAL_ADMIN_USERS_SAVE_EDIT_TITLE'), text: "", type: "success", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'), timer: 2000 });
                        $scope.formScreen = 0;
                        $state.transitionTo("app.admin.users", {id: User.data.id}, {reload: true});
                    }
                }, function(response) {
                    if (response.data && response.data.message) {
                        swal({ title: response.data.message, type: "error", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'), timer: 2000 });
                    }
                });
            }
        };

        /**
         * Triggers user delete
         */
        ctrl.delete = function () {

            if($scope.formScreen == 0) {
                $scope.formScreen = 2;
                return false;
            }

            $api.users.single.delete({id: User.data.id}, function(response) {
                if(response.success) {
                    swal({
                        title: $translate.instant('SWAL_ADMIN_USERS_DELETE_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.admin.users", {}, {reload: true});
                }
            });
        };

        ctrl.roleChange = function() {
            ctrl.resources = [];
            var f = ctrl.form, ids = toIds(f.business_ids);
            ctrl.updateRoleOptions();
            if (f.role == 4) {
                if (ids.length) f.b_id = ids[0];
                else if (f.b_id) { var b = ctrl.businesses.filter(function(x) { return x.id == f.b_id; })[0]; if (b) f.business_ids = [b.id]; }
            } else f.business_ids = [];
            if (f.role == 3) $api.businesses.resources.get({ id: f.b_id }, function(r) { if (r.success) ctrl.resources = r.resources; });
        };

        ctrl.updateRoleOptions();
        ctrl.roleChange();
    });


    angular.module("app.controllers").controller("BusinessSelectController", function ($scope, $state, Businesses, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        var ctrl = this;
        ctrl.businesses = Businesses;

        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('scrollY', '500px')
            .withOption('aaSorting', [])
            .withOption('searching', true)
            .withOption('info', false)
            .withOption('paging', false);

        ctrl.selectBusiness = function (index) {
            $uibModalInstance.close(ctrl.businesses[index]);
        }

    });

})();

(function () {

  angular.module('app.controllers')
    .controller('TutorialVideosListController', function (TutorialVideos, $state, $header, $scope, $api, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $translate) {

      if ($rootScope.userRole !== 1) {
        $state.go('app.dashboard');
        return;
      }

      var ctrl = this;
      ctrl.tableData = TutorialVideos && TutorialVideos.data ? TutorialVideos.data : [];

      $header.title = 'Tutorial Videos';
      $header.breadcrumbs.push({
        title: 'SETTINGS',
        state: 'app.admin'
      });

      $header.breadcrumbs.push({
        title: 'Tutorial Videos'
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withLanguage(dataTablesHebrewProvider)
        .withOption('columnDefs', [
          { targets: -1, orderable: false }
        ])
        .withOption('order', [[1, 'desc']]);

      ctrl.editItem = function (id) {
        $state.go('app.admin.tutorial-videos.edit', { id: id });
      };

      ctrl.removeItem = function (id) {
        swal({
          title: "",
          text: $translate.instant('TUTORIAL_VIDEOS_DELETE_CONFIRM_TEXT'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            $api.customTutorialVideos.single.delete({ id: id }, function (response) {
              if (response.status === 'success' || response.success) {
                swal({
                  title: $translate.instant('TUTORIAL_VIDEOS_DELETE_SUCCESS'),
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.admin.tutorial-videos", {}, { reload: true });
              }
            });
          }
        });
      };
    });
})();

(function () {

  angular.module('app.controllers')
    .controller('TutorialVideosFormController', function ($scope, $state, $api, $rootScope, TutorialVideo, $http, $timeout, $translate) {

      if ($rootScope.userRole !== 1) {
        $state.go('app.dashboard');
        return;
      }

      var ctrl = this;
      ctrl.isEdit = false;
      ctrl.form = {};
      ctrl.saving = false;
      ctrl.videoFile = null;
      ctrl.thumbnailFile = null;
      ctrl.videoFilename = '';
      ctrl.thumbnailFilename = '';
      ctrl.thumbnailPreview = null;

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      if (TutorialVideo && TutorialVideo.data) {
        ctrl.isEdit = true;
        ctrl.form = angular.copy(TutorialVideo.data);
        ctrl.form.published_date = ctrl.form.published_at ? new Date(ctrl.form.published_at) : new Date();
      } else {
        ctrl.form = {
          title: '',
          published_date: new Date()
        };
      }

      $scope.uploadVideo = function (element) {
        if (element.files && element.files[0]) {
          ctrl.videoFile = element.files[0];
          ctrl.videoFilename = element.files[0].name;
          $scope.$apply();
        }
      };

      $scope.uploadThumbnail = function (element) {
        if (element.files && element.files[0]) {
          ctrl.thumbnailFile = element.files[0];
          ctrl.thumbnailFilename = element.files[0].name;
          var reader = new FileReader();
          reader.onload = function (e) {
            ctrl.thumbnailPreview = e.target.result;
            $scope.$apply();
          };
          reader.readAsDataURL(element.files[0]);
        }
      };

      ctrl.submit = function () {
        if (ctrl.saving) return;
        if (!ctrl.form.title || !ctrl.form.published_date) return;

        if (!ctrl.isEdit && !ctrl.videoFile) {
          swal({
            title: $translate.instant('TUTORIAL_VIDEOS_VIDEO_REQUIRED'),
            type: 'warning',
            timer: 2000
          });
          return;
        }

        ctrl.saving = true;

        var formData = new FormData();
        formData.append('title', ctrl.form.title);
        var d = ctrl.form.published_date;
        var dateStr = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
        formData.append('published_at', dateStr + ' 00:00:00');

        if (ctrl.videoFile) {
          formData.append('video', ctrl.videoFile);
        }
        if (ctrl.thumbnailFile) {
          formData.append('thumbnail', ctrl.thumbnailFile);
        }

        var url = $api.baseURL + '/customtutorialvideos';
        if (ctrl.isEdit) {
          url += '/id/' + ctrl.form.id;
        }

        $http({
          method: 'POST',
          url: url,
          data: formData,
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        }).then(function (response) {
          ctrl.saving = false;
          if (response.data && (response.data.status === 'success' || response.data.success)) {
            swal({
              title: ctrl.isEdit ? $translate.instant('TUTORIAL_VIDEOS_UPDATE_SUCCESS') : $translate.instant('TUTORIAL_VIDEOS_SAVE_SUCCESS'),
              type: 'success',
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo('app.admin.tutorial-videos', {}, { reload: true });
          } else {
            swal({
              title: response.data && response.data.error ? response.data.error : $translate.instant('TUTORIAL_VIDEOS_SAVE_ERROR'),
              type: 'error',
              timer: 3000
            });
          }
        }, function (error) {
          ctrl.saving = false;
          var msg = (error.data && error.data.error) ? error.data.error : $translate.instant('TUTORIAL_VIDEOS_SAVE_ERROR');
          swal({
            title: msg,
            type: 'error',
            timer: 3000
          });
        });
      };
    });
})();

(function () {
    angular.module('app.controllers')
        .controller('LogsListController', function (Logs, $api, $state, $header, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole !== 1) {
                $state.go('app.dashboard');
                return;
            }

            var ctrl = this;
            ctrl.date = moment();
            ctrl.type = "all";

            ctrl.tableData = Logs.data ? Logs.data.logs : [];
            ctrl.displayDate = "";

            ctrl.datePickerPrev = function() {
                ctrl.date = moment(ctrl.date).add(-1, "days");
            };

            ctrl.datePickerNext = function() {
                ctrl.date = moment(ctrl.date).add(1, "days");
            };

            $scope.$watch("ctrl.date", function(newValue, oldValue) {
                if (document.activeElement) {
                    if (!document.querySelector('.inputs-wrapper .date-picker-date-time')) {
                        document.activeElement.blur();
                    }
                }
                ctrl.get_logs();
            });

            ctrl.change_type = function(type) {
                ctrl.type = type;
                ctrl.get_logs();
            };

            ctrl.get_logs = function() {
                ctrl.tableData = [];
                $api.logs.get({
                    date: moment(ctrl.date).format("YYYY-MM-DD"),
                    type: ctrl.type
                }, function(data) {
                    if (data.success) {
                        ctrl.tableData = data.data.logs;
                        if ($('#res_dt').DataTable()) {
                            $('#res_dt').DataTable().clear().draw();
                          }
                    }
                });
            }

            $header.title = "משתמשים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.admin"
            });
            $header.breadcrumbs.push({
                "title": "משתמשים"
            });

            $scope.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip')
                .withLanguage(dataTablesHebrewProvider)
                .withOption('searching', false)
                .withOption('pageLength', 100)
                .withOption('autoWidth', false)
                .withOption('responsive', true)
                .withPaginationType('full_numbers');
        });
})();

(function () {

  angular.module('app.controllers')
    .controller('CustomFieldsListController', function (CustomFields, $state, $header, $scope, $api, $customFields, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $translate) {

      if ($rootScope.userRole !== 1) {
        $state.go('app.dashboard');
        return;
      }

      var ctrl = this;
      ctrl.types = $customFields.getTypes();
      ctrl.tableData = CustomFields.data;

      $header.title = 'Custom fields';
      $header.breadcrumbs.push({
        title: 'הגדרות',
        state: 'app.admin'
      });

      $header.breadcrumbs.push({
        title: 'Custom fields'
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withLanguage(dataTablesHebrewProvider)
        .withOption('columnDefs', [
          { targets: -1, orderable: false }
        ]);

      ctrl.getCurrentName = function (names) {
        var currentLocale = $rootScope.currentLanguage ? $rootScope.currentLanguage : 'en_US';
        var data = JSON.parse(names);

        var result = data[currentLocale];
        if (!data[currentLocale]) {
          var values = Object.keys(data).map(function (key) {
            return data[key];
          });

          for (var i = 0; i < values.length; i++) {
            if (values[i] && values[i].trim()) {
              result = values[i];
              break;
            }
          }
        }
        return result;
      };

      ctrl.getBusinesses = function (businesses) {
        return businesses.map(function (business) {
          return business.name;
        }).join(', ');
      };

      ctrl.getType = function (key) {
        var typeTitle = key;

        for (var i = 0; i < ctrl.types.length; i++) {
          if (ctrl.types[i].key === key) {
            typeTitle = ctrl.types[i].title;
            break;
          }
        }

        return typeTitle;
      };

      ctrl.editItem = function (id) {
        $state.go('app.admin.custom-fields.edit', { id: id });
      };

      ctrl.removeItem = function (id) {
        swal({
          title: "",
          text: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_DELETE_CONFIRM_TEXT'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function(result) {
          if (result.value) {
            $api.customFields.single.delete({ id: id }, function (response) {
              if (response.success) {
                swal({
                  title: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_DELETE_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.admin.custom-fields", {}, { reload: true });
              }
            });
          }
        });
      };
    });
})();

(function () {

  angular.module('app.controllers')
    .controller('CustomFieldsFormController', function ($scope, $state, $api, $rootScope, Businesses, CustomField, $customFields, $uibModal, $timeout, $translate) {

    if ($rootScope.userRole !== 1) {
      $state.go('app.dashboard');
      return;
    }

    $timeout(function() {
      $('.v2').parent().find('.chosen-container').addClass('v2');
    }, 100);

    $scope.isMobile = (angular.element(document).width() < 769)

    var ctrl = this;
    ctrl.availableLocales = $rootScope.availableLocales;
    ctrl.requiredLocales = ['hb_ISR', 'en_US'];

    ctrl.types = $customFields.getTypes();

    ctrl.isEdit = false;
    ctrl.form = {};
    ctrl.selectedBusinesses = [];
    ctrl.selectedBusinessIds = [];

    if (CustomField != null) {
      ctrl.isEdit = true;
      ctrl.form = CustomField.data;
      ctrl.form.name = JSON.parse(ctrl.form.name);
    }

    ctrl.businesses = [];
    if (Businesses) {
      ctrl.businesses = Businesses.data.map(function (business) {
        return {
          id: business.id,
          name: business.name
        };
      });

      if (ctrl.isEdit) {
        for (var i = 0; i < ctrl.form.businesses.length; i++) {
          var selected = ctrl.form.businesses[i];
          var found = null;
      
          for (var j = 0; j < ctrl.businesses.length; j++) {
            if (ctrl.businesses[j].id === selected.id) {
              found = ctrl.businesses[j];
              break;
            }
          }
      
          ctrl.selectedBusinesses.push(found || selected);
        }
        ctrl.selectedBusinessIds = ctrl.selectedBusinesses.map(function (business) {
          return String(business.id);
        });
      }
    }

    ctrl.isLocalRequired = function (locale) {
      return ctrl.requiredLocales.indexOf(locale) !== -1;
    }

    ctrl.showBusinessList = function () {
      $uibModal.open({
        templateUrl: "app/modules/admin/modules/users/modules/popup/business.popup.html",
        controller: "BusinessSelectController",
        controllerAs: "ctrl",
        scope: $scope,
        windowTopClass: "form-modal medium-modal",
        resolve: {
          Businesses: [function () {
            return ctrl.businesses;
          }]
        }
      }).result.then(function (business) {
        if (business) {
          ctrl.form.b_id = business.id;
          ctrl.name_business = business.name;
        }
      });
    }

    
    ctrl.submit = function () {
      if (ctrl.selectedBusinessIds.length == 0) {
        return;
      }

      ctrl.form.businesses = ctrl.selectedBusinessIds.map(function (businessId) {
        return parseInt(businessId, 10);
      });

      if (CustomField == null) {
        $api.customFields.save(ctrl.form, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.admin.custom-fields", {}, { reload: true });
          }
        });
      } else {
        $api.customFields.single.save({
          id: CustomField.data.id
        }, ctrl.form, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_ADMIN_CUSTOM_FIELDS_SAVE_EDIT_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.admin.custom-fields", { id: CustomField.data.id }, { reload: true });
          }
        });
      }
    };
  });


  angular.module("app.controllers").controller("BusinessSelectController", function ($scope, $state, Businesses, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

    var ctrl = this;
    ctrl.businesses = Businesses;

    $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('pageLength', 100)
      .withOption('scrollY', '500px')
      .withOption('aaSorting', [])
      .withOption('searching', true)
      .withOption('info', false)
      .withOption('paging', false);

    ctrl.selectBusiness = function (index) {
      $uibModalInstance.close(ctrl.businesses[index]);
    }

  });

})();

(function() {
    angular.module("app.controllers").controller("AiSupportSingleController", function(
      $scope, $state, $api, Article, Filters, $rootScope, $timeout, $uibModal
    ) {
        if ($rootScope.userRole !== 1) {
          $state.go('app.dashboard');
          return;
        }

        var ctrl = this;
        ctrl.isEdit = !!Article;

        ctrl.categories = (Filters && Filters.data && Filters.data.categories) ? Filters.data.categories.map(function (c) { return { value: c }; }) : [];
        ctrl.allTags = (Filters && Filters.data && Filters.data.tags) ? Filters.data.tags.map(function (t) { return { value: t }; }) : [];

        ctrl.article = normalizeArticle(Article ? Article.data : null);

        ctrl.slugTouched = !!(ctrl.isEdit && ctrl.article && ctrl.article.slug);

        function slugify(str) {
          if (!str) {
            return '';
          }

          return String(str)
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        function normalizeArticle(raw) {
          var article = raw ? angular.copy(raw) : {};

          if (!article.locale) {
            article.locale = 'en_US';
          }

          if (typeof article.business_id === 'undefined') {
            article.business_id = null;
          }

          if (!raw || !raw.id) {
            article.is_active = true;

            if (!article.body) {
              article.body = getDefaultBodyTemplate();
            }
          } else {
            if (typeof article.is_active === 'undefined' || article.is_active === null) {
              article.is_active = true;
            } else {
              article.is_active = !!article.is_active;
            }
          }

          if (article.category) {
            var existingCat = ctrl.categories.find(function(c) { return c.value === article.category; });
            if (!existingCat) {
              existingCat = { value: article.category };
              ctrl.categories.push(existingCat);
            }
            article.categoryObjs = [existingCat];
          } else {
            article.categoryObjs = [];
          }

          var tagsArray = [];
          if (!article.tags) {
            tagsArray = [];
          } else if (angular.isString(article.tags)) {
            try {
              var decoded = JSON.parse(article.tags);
              tagsArray = angular.isArray(decoded) ? decoded : [];
            } catch (e) {
              tagsArray = [];
            }
          } else if (angular.isArray(article.tags)) {
            tagsArray = article.tags;
          } else {
            tagsArray = [];
          }

          article.tagsObjs = tagsArray.map(function(tag) {
            var existingTag = ctrl.allTags.find(function(t) { return t.value === tag; });
            if (!existingTag) {
              existingTag = { value: tag };
              ctrl.allTags.push(existingTag);
            }
            return existingTag;
          });

          article.is_active = !!article.is_active;

          return article;
        };

        ctrl.onTitleChange = function() {
          if (!ctrl.slugTouched) {
            ctrl.article.slug = slugify(ctrl.article.title);
          }
        };

        ctrl.onSlugChange = function() {
          ctrl.slugTouched = true;
          ctrl.article.slug = slugify(ctrl.article.slug);
        };

        ctrl.addCategoryTag = function(newCategoryName) {
          if (!newCategoryName) {
            return null;
          }

          return { value: newCategoryName };
        };

        ctrl.onCategorySelected = function ($item, $model) {
          if (ctrl.article.categoryObjs && ctrl.article.categoryObjs.length > 1) {
            ctrl.article.categoryObjs = [$item];
          }
        };

        ctrl.onCategoryChange = function(model) {
          if (model && model.length > 1) {
            ctrl.article.categoryObjs = [model[model.length - 1]];
          }
        };

        ctrl.addNewTag = function(newTag) {
          if (!newTag) {
            return null;
          }

          var existing = ctrl.allTags.find(function(t) { return t.value === newTag; });
          if (existing) {
            return existing;
          }

          var obj = { value: newTag };
          ctrl.allTags.push(obj);
          return obj;
        };

        ctrl.save = function() {
          var payload = angular.copy(ctrl.article);

          if (angular.isArray(payload.categoryObjs) && payload.categoryObjs.length) {
            payload.category = payload.categoryObjs[0].value;
          } else {
            payload.category = '';
          }

          if (angular.isArray(payload.tagsObjs)) {
            payload.tags = payload.tagsObjs
              .map(function(t) { return t && t.value && String(t.value).trim(); })
              .filter(function(t) { return !!t; });
          } else {
            payload.tags = [];
          }

          payload.is_active = payload.is_active ? true : false;

          payload.locale = 'en_US';
          if (typeof payload.business_id === 'undefined') {
            payload.business_id = null;
          }

          delete payload.categoryObjs;
          delete payload.tagsObjs;

          var request;
          if (ctrl.isEdit) {
            request = $api.support.update.save({ id: payload.id }, payload);
          } else {
            request = $api.support.create.save(payload);
          }

          request.$promise.then(function(response) {
            $state.go('^', {}, { reload: true });
          }, function(err) {
            console.error('Failed to save article', err);
          });
        };

        function getDefaultBodyTemplate() {
          return [
            '## Article title',
            '',
            'Some description',
            '',
            'How to open:',
            '',
            '- Explain the way',
            '- Or go directly to: `<URL>`',
            '',
            '---',
            '',
            '### 1. Part one',
            '',
            'Steps:',
            '',
            '- Step 1',
            '- Step 2',
            '',
            'More description',
            '',
            '---',
            '',
            '### 2. Part two',
            '',
            'Descriotion',
            '',
            '- **Bold text**',
            '  Some description.',
            '',
            '- **Next bold text**',
            '  Some description',
            '',
            '---',
            '',
            '### 3. Part three',
            '',
            'Some description',
            '',
            '- Step 1',
            '  Description',
            '',
            '- Step 2',
            '  Description',
            '',
            '- Step 3',
            '  Description',
          ].join('\n');
        }
    });
})();

(function () {
  angular.module('app.controllers').controller('AiSupportListController', function (
    Filters, $header, $state, $scope, $rootScope, $timeout, $api, DTOptionsBuilder, DTColumnBuilder, $filter, $location, $compile
  ) {
    if ($rootScope.userRole !== 1) {
      $state.go('app.dashboard');
      return;
    }

    $header.title = "AI Support";
    $header.breadcrumbs.push({
        "title" : "AI Support"
    });

    var ctrl = this;

    ctrl.filter = {
      category: '',
      tags: [],
      search: '',
      ids: ''
    };

    var idsFromUrl = $location.search().ids;
    if (idsFromUrl) {
      ctrl.filter.ids = idsFromUrl;
    }

    ctrl.pagination = {
      page: 1,
      perPage: 50,
      total: 0
    };

    ctrl.categories = Filters.data.categories || [];
    ctrl.tags = Filters.data.tags || [];
    ctrl.categoryOptions = [
      {
        id: '',
        name: $filter('translate')('ADMIN_AI_ALL_CATEGORIES')
      }
    ].concat(ctrl.categories.map(function (category) {
      return {
        id: category,
        name: category
      };
    }));

    ctrl.articles = [];
    ctrl.isLoading = false;
    ctrl.error = null;
    ctrl.dtInstance = {};

    var sortMap = {
      0: 'id',
      1: 'title',
      2: 'category',
      3: 'tags',
      4: 'sort_order',
      5: 'is_active',
      6: 'source_file_id',
    };

    ctrl.dtColumns = [
      DTColumnBuilder.newColumn('id')
        .withTitle($filter('translate')('ADMIN_AI_COL_ID'))
        .renderWith(function (data, type, full, meta) {
          return data ? _.escape(data) : '';
        }),

      DTColumnBuilder.newColumn('title')
        .withTitle($filter('translate')('ADMIN_AI_COL_TITLE'))
        .renderWith(function (data, type, full, meta) {
          return '<div style="max-width:500px; white-space:normal;">' + _.escape(data) + '</div>';
        }),

      DTColumnBuilder.newColumn('category')
        .withTitle($filter('translate')('ADMIN_AI_COL_CATEGORY'))
        .renderWith(function (data) {
          return data ? _.escape(data) : '';
        }),

      DTColumnBuilder.newColumn('tags')
        .withTitle($filter('translate')('ADMIN_AI_COL_TAGS'))
        .renderWith(function (data, type, full) {
          if (!data) {
            return '';
          }

          var arr;
          if (angular.isArray(data)) {
            arr = data;
          } else {
            try {
              arr = JSON.parse(data);
            } catch (e) {
              return _.escape(String(data));
            }
          }

          return _.escape(arr.join(', '));
        }),

      DTColumnBuilder.newColumn('sort_order')
        .withTitle($filter('translate')('ADMIN_AI_COL_ORDER'))
        .renderWith(function (data) {
          return data ? _.escape(data) : '';
        }),

      DTColumnBuilder.newColumn('is_active')
        .withTitle($filter('translate')('ADMIN_AI_COL_ACTIVE'))
        .renderWith(function (data) {
          if (data) {
            return '<span class="label label-success">' +
              $filter('translate')('ADMIN_AI_ACTIVE') +
              '</span>';
          }

          return '<span class="label label-default">' +
            $filter('translate')('ADMIN_AI_INACTIVE') +
            '</span>';
        }),

      DTColumnBuilder.newColumn('source_file_id')
        .withTitle($filter('translate')('ADMIN_AI_COL_FILE'))
        .renderWith(function (data, type, full) {
          var name = full.source_file_name || '';
          var url = full.source_file_path || '';
          var safeName = _.escape(name);

          if (!url) {
            return '---';
          }

          var safeUrl = _.escape(url);

          return '' +
            '<a href="' + safeUrl + '" ng-click="$event.stopPropagation()" target="_blank" tooltip2="' + safeName + '" rel="noopener noreferrer" class="btn icon small blue">' +
            '<i class="las la-file-alt"></i>' +
            '</a>';
        }),
    ];

    ctrl.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('paging', true)
      .withOption('ordering', true)
      .withOption('searching', false)
      .withDataProp('data')
      .withOption('pageLength', 50)
      .withOption('order', [[4, 'asc']])
      .withOption('ajax', function (data, callback, settings) {
        ctrl.isLoading = true;
        ctrl.error = null;

        var order = data.order && data.order.length ? data.order[0] : null;
        var sort = 'sort_order';
        var direction = 'asc';

        if (order) {
          if (sortMap.hasOwnProperty(order.column)) {
            sort = sortMap[order.column];
          }
          direction = order.dir || 'asc';
        }

        var idsRaw = ctrl.filter.ids || '';
        var ids = null;

        if (idsRaw && idsRaw.trim() !== '') {
          ids = idsRaw
            .split(',')
            .map(function (v) { return v.trim(); })
            .filter(function (v) { return v && !isNaN(v); });
          if (!ids.length) {
            ids = null;
          }
        }

        var params;

        if (ids && ids.length) {
          params = {
            ids: ids,
            limit: data.length,
            offset: data.start,
            sort: sort,
            direction: direction
          };
        } else {
          params = {
            category: ctrl.filter.category || '',
            tags: ctrl.filter.tags && ctrl.filter.tags.length ? ctrl.filter.tags : null,
            search: ctrl.filter.search || '',
            limit: data.length,
            offset: data.start,
            sort: sort,
            direction: direction
          };
        }

        $api.support.list.save(params, function (response) {
          var res = response.data || response;

          ctrl.articles = res.data || [];
          var total = res.pagination ? (res.pagination.total || 0) : ctrl.articles.length;

          callback({
            draw: data.draw,
            data: ctrl.articles,
            recordsTotal: total,
            recordsFiltered: total
          });

          ctrl.isLoading = false;
        }, function (err) {
          console.error('Failed to load AI articles', err);
          ctrl.error = 'Failed to load AI articles';

          callback({
            draw: data.draw,
            data: [],
            recordsTotal: 0,
            recordsFiltered: 0
          });

          ctrl.isLoading = false;
        });
      })
      .withOption('rowCallback', function (row, data, index) {
        angular.element(row).css('cursor', 'pointer');
        angular.element(row).off('click').on('click', function () {
          $scope.$apply(function () {
            $state.go('app.admin.ai-support.single', { id: data.id });
          });
        });

        $compile(angular.element(row).contents())($scope);
      });

    var searchTimeoutPromise = null;

    function reloadTable() {
      if (!ctrl.dtInstance || !ctrl.dtInstance.reloadData) {
        return;
      }
      ctrl.dtInstance.reloadData(null, true);
    }

    $scope.$watchGroup(['ctrl.filter.category', 'ctrl.filter.tags'], function (newVals, oldVals) {
      if (!oldVals) {
        return;
      }

      if (newVals[0] === oldVals[0] && newVals[1] === oldVals[1]) {
        return;
      }

      reloadTable();
    });

    $scope.$watch('ctrl.filter.search', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      if (searchTimeoutPromise) {
        $timeout.cancel(searchTimeoutPromise);
      }

      searchTimeoutPromise = $timeout(function () {
        reloadTable();
      }, 1000);
    });

    $scope.$watch('ctrl.filter.ids', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      reloadTable();
    });

    $scope.$on('$destroy', function () {
      if (searchTimeoutPromise) {
        $timeout.cancel(searchTimeoutPromise);
      }
    });
  });
})();

(function () {
  angular.module('app.controllers').controller('AiSupportFilesController', function (
    Businesses, $header, $state, $scope, $rootScope, $timeout, $api, DTOptionsBuilder, DTColumnBuilder, $filter, $resource, $compile
  ) {
    if ($rootScope.userRole !== 1) {
      $state.go('app.dashboard');
      return;
    }

    $header.title = "AI Support - Upload Files";
    $header.breadcrumbs.push({
      "title": "AI Support - Upload Files"
    });

    var ctrl = this;

    ctrl.globalBusy = false;
    ctrl.busyFileId = null;
    ctrl.busyAction = null; 

    ctrl.filter = {
      businessId: '',
      search: ''
    };

    ctrl.pagination = {
      page: 1,
      perPage: 50,
      total: 0
    };

    ctrl.businesses = [];
    ctrl.businessOptions = [
      {
        id: '',
        name: $filter('translate')('ADMIN_AI_ALL_BUSINESSES')
      }
    ];

    if (Businesses) {
      ctrl.businesses = Businesses.data.map(function (business) {
        return {
          id: business.id,
          name: business.name,
        };
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      ctrl.businessOptions = ctrl.businessOptions.concat(ctrl.businesses);
    }

    ctrl.files = [];
    ctrl.isLoading = false;
    ctrl.error = null;
    ctrl.dtInstance = {};

    var sortMap = {
      0: 'name',
      1: 'business',
      2: 'status',
      3: 'sections',
      4: 'articles',
      5: 'actions',
    };

    ctrl.dtColumns = [
      DTColumnBuilder.newColumn('name')
        .withTitle($filter('translate')('ADMIN_AI_COL_FILENAME'))
        .renderWith(function (data, type, full, meta) {
          var name = full.original_name || full.name || '';
          var url = full.path || '';
          var safeName = _.escape(name);

          if (!url) {
            return '<div style="max-width:500px; white-space:normal;">' + safeName + '</div>';
          }

          var safeUrl = _.escape(url);

          return '' +
            '<div style="max-width:500px; white-space:normal;">' +
            '<a href="' + safeUrl + '" target="_blank" rel="noopener noreferrer">' +
            safeName +
            '</a>' +
            '</div>';
        }),

      DTColumnBuilder.newColumn('business')
        .withTitle($filter('translate')('ADMIN_AI_COL_BUSINESS'))
        .renderWith(function (data, type, full) {
          var businessName = full.business || full.business_name || '';
          if (!businessName) {
            businessName = $filter('translate')('ADMIN_AI_COL_BUSINESS_GLOBAL');
          }
          return _.escape(businessName);
        }),

      DTColumnBuilder.newColumn('status')
        .withTitle($filter('translate')('ADMIN_AI_COL_STATUS'))
        .renderWith(function (data, type, full) {
          var status = full.status || '';
          return _.escape(status);
        }),

      DTColumnBuilder.newColumn('sections')
        .withTitle($filter('translate')('ADMIN_AI_COL_SECTIONS'))
        .renderWith(function (data, type, full) {
          var count = typeof full.sections_count !== 'undefined' ? full.sections_count : (full.sections ? full.sections.length : 0);
          return count ? _.escape(String(count)) : '0';
        }),


      DTColumnBuilder.newColumn('articles')
        .withTitle($filter('translate')('ADMIN_AI_COL_ARTICLES'))
        .renderWith(function (data, type, full) {
          var count = (typeof full.articles_count !== 'undefined' && full.articles_count !== null)
            ? full.articles_count
            : (Array.isArray(full.articles) ? full.articles.length : 0);

          if (!count) {
            return '0';
          }

          var ids = Array.isArray(full.articles) ? full.articles : [];
          if (!ids.length) {
            return _.escape(String(count));
          }

          var href = '/super/ai-support?ids=' + ids.join(',');
          var safeHref = _.escape(href);

          return '<a href="' + safeHref + '" target="_blank" rel="noopener noreferrer">' +
            _.escape(String(count)) +
            '</a>';
        }),

      DTColumnBuilder.newColumn('actions')
        .withTitle($filter('translate')('ADMIN_AI_COL_ACTIONS'))
        .renderWith(function (data, type, full) {
          var html = [];
          var fileId = full.id;
          var status = full.status || '';

          var sectionsCount = typeof full.sections_count !== 'undefined' ? full.sections_count : (full.sections ? full.sections.length : 0);
          var articlesCount = typeof full.articles_count !== 'undefined' ? full.articles_count : (full.articles ? full.articles.length : 0);

          if (status === 'new') {
            html.push(
              '<button ' +
              'class="btn icon circle small bordered blue" ' +
              'ng-disabled="ctrl.globalBusy" ' +
              'tooltip2="' + $filter('translate')('ADMIN_AI_TOOLTIP_PROCESS_FILE') + '" ' +
              'onclick="event.stopPropagation(); angular.element(this).scope().processFile(' + fileId + ');">' +
              '<i class="las" ' +
              'ng-class="ctrl.globalBusy && ctrl.busyFileId === ' + fileId + ' && ctrl.busyAction === \'process\' ' +
              '? \'la-spinner la-spin\' : \'la-sync\'"></i>' +
              '</button>'
            );
          }

          if (status === 'sections_ready' && sectionsCount > 0 && articlesCount < sectionsCount) {
            html.push(
              '<button ' +
              'class="btn icon circle small bordered blue" style="margin-left: 8px;" ' +
              'ng-disabled="ctrl.globalBusy" ' +
              'tooltip2="' + $filter('translate')('ADMIN_AI_TOOLTIP_GENERATE_ARTICLES') + '" ' +
              'onclick="event.stopPropagation(); angular.element(this).scope().generateArticles(' + fileId + ');">' +
              '<i class="las" ' +
              'ng-class="ctrl.globalBusy && ctrl.busyFileId === ' + fileId + ' && ctrl.busyAction === \'articles\' ' +
              '? \'la-spinner la-spin\' : \'la-file-alt\'"></i>' +
              '</button>'
            );
          }

          html.push(
            '<button ' +
            'class="btn icon circle small bordered red" style="margin-left: 8px;" ' +
            'ng-disabled="ctrl.globalBusy" ' +
            'tooltip2="' + $filter('translate')('ADMIN_AI_TOOLTIP_DELETE_FILE') + '" ' +
            'onclick="event.stopPropagation(); angular.element(this).scope().deleteFile(' + fileId + ', \'' + _.escape(full.original_name || full.name || '') + '\');">' +
            '<i class="las la-trash"></i>' +
            '</button>'
          );

          return html.join(' ');
        }),
    ];

    ctrl.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('paging', true)
      .withOption('ordering', true)
      .withOption('searching', false)
      .withDataProp('data')
      .withOption('pageLength', 50)
      .withOption('ajax', function (data, callback, settings) {
        ctrl.error = null;

        var order = data.order && data.order.length ? data.order[0] : null;
        var sort = 'name';
        var direction = 'asc';

        if (order) {
          if (sortMap.hasOwnProperty(order.column)) {
            sort = sortMap[order.column];
          }
          direction = order.dir || 'asc';
        }

        var params = {
          businessId: ctrl.filter.businessId || '',
          search: ctrl.filter.search || '',
          limit: data.length,
          offset: data.start,
          sort: sort,
          direction: direction
        };

        $api.support.files.save(params, function (response) {
          var res = response.data || response;

          ctrl.files = res.data || [];
          var total = res.pagination ? (res.pagination.total || 0) : ctrl.files.length;

          callback({
            draw: data.draw,
            data: ctrl.files,
            recordsTotal: total,
            recordsFiltered: total
          });
        }, function (err) {
          console.error('Failed to load AI files', err);
          ctrl.error = 'Failed to load AI files';

          callback({
            draw: data.draw,
            data: [],
            recordsTotal: 0,
            recordsFiltered: 0
          });
        });
      })
      .withOption('rowCallback', function (row, data, index) {
        angular.element(row).css('cursor', 'pointer');
        angular.element(row).off('click').on('click', function () {
          $scope.$apply(function () {
            // alert('Test')
          });
        });

        $compile(angular.element(row).contents())($scope);
      });

    var searchTimeoutPromise = null;

    function reloadTable(keepPaging) {
      keepPaging = keepPaging || false;
      if (!ctrl.dtInstance || !ctrl.dtInstance.reloadData) {
        return;
      }
      ctrl.dtInstance.reloadData(null, !keepPaging);
    }

    $scope.$watchGroup(['ctrl.filter.businessId'], function (newVals, oldVals) {
      if (!oldVals) {
        return;
      }

      if (newVals[0] === oldVals[0] && newVals[1] === oldVals[1]) {
        return;
      }

      reloadTable();
    });

    $scope.$watch('ctrl.filter.search', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      if (searchTimeoutPromise) {
        $timeout.cancel(searchTimeoutPromise);
      }

      searchTimeoutPromise = $timeout(function () {
        reloadTable();
      }, 1000);
    });

    $scope.$on('$destroy', function () {
      if (searchTimeoutPromise) {
        $timeout.cancel(searchTimeoutPromise);
      }
    });

    $scope.uploadFile = function (element) {
      var file = element.files && element.files[0];
      if (!file) {
        return;
      }

      var allowedExtensions = ['pdf'];
      var allowedMimeTypes = [
        'application/pdf'
      ];


      var name = file.name || '';
      var ext = name.split('.').pop().toLowerCase();
      var mime = file.type || '';
      var maxSize = 20 * 1024 * 1024;

      if (allowedExtensions.indexOf(ext) === -1 || allowedMimeTypes.indexOf(mime) === -1) {
        swal({
          title: "{{'ADMIN_AI_UPLOAD_FILE_TYPE_NOT_ALLOWED' | translate}}",
          type: "error",
          timer: 3000
        });
        element.value = '';
        return;
      }

      if (!file.size || file.size > maxSize) {
        swal({
          title: "{{'ADMIN_AI_UPLOAD_FILE_SIZE_ERROR' | translate}}",
          type: "error",
          timer: 3000
        });
        element.value = '';
        return;
      }

      ctrl.isLoading = true;
      ctrl.globalBusy = true;
      ctrl.busyFileId = null;
      ctrl.busyAction = 'upload';

      var fdata = new FormData();
      fdata.append('file', file);

      $resource($api.baseURL + '/support/action/upload', {}, {
        postWithFile: {
          method: "POST",
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        }
      }).postWithFile(fdata).$promise.then(function (response) {
        element.value = '';

        if (response) {
          if (response.success) {
            $scope.processFile()
          } else {
            swal({
              title: response.data,
              type: "error",
              timer: 3000
            });

            ctrl.isLoading = false;
            ctrl.globalBusy = false;
            ctrl.busyFileId = null;
            ctrl.busyAction = null;
          }
        }
      }, function (error) {
        element.value = '';
        console.log(error);
        ctrl.isLoading = false;
        ctrl.globalBusy = false;
        ctrl.busyFileId = null;
        ctrl.busyAction = null;

        if (error.data && error.data.data && error.data.data.error) {
          swal({
            title: error.data.data.error,
            type: "error",
            timer: 3000
          });
        }
      });
    };

    $scope.processFile = function (fileId) {
      var params = {};
      if (fileId) {
        params.fileId = fileId;
      }

      ctrl.globalBusy = true;
      ctrl.busyFileId = fileId || null;
      ctrl.busyAction = 'process';

      $api.support.files.process.save(params, function (response) {
        ctrl.isLoading = false;
        ctrl.globalBusy = false;
        ctrl.busyFileId = null;
        ctrl.busyAction = null;
        reloadTable();
      }, function (error) {
        ctrl.isLoading = false;
        ctrl.globalBusy = false;
        ctrl.busyFileId = null;
        ctrl.busyAction = null;
        console.log(error);
      })
    }

    ctrl.isArticlesLoading = false;

    $scope.generateArticles = function (fileId) {
      if (ctrl.isArticlesLoading) {
        return;
      }

      ctrl.isArticlesLoading = true;
      ctrl.globalBusy = true;
      ctrl.busyFileId = fileId;
      ctrl.busyAction = 'articles';

      runGenerateArticlesBatch(fileId);
    };

    $scope.deleteFile = function (fileId, fileName) {
      swal({
        title: $filter('translate')('ADMIN_AI_DELETE_CONFIRM'),
        html: '<b>' + (fileName || '') + '</b><br />' + $filter('translate')('ADMIN_AI_DELETE_CONFIRM_DESCRIPTION'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: "btn-danger",
        confirmButtonText: $filter('translate')('SWAL_CONFIRM_BUTTON'),
        cancelButtonText: $filter('translate')('SWAL_CANCEL_BUTTON'),
        closeOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          $scope.$apply(function () {
            ctrl.deleteFile(fileId);
          });
        }
      });
    };

    ctrl.deleteFile = function (fileId) {
      $api.support.files.remove.save({ fileId: fileId }, function (response) {
        reloadTable();
      }, function (error) {
        console.log(error);
      });
    };

    function runGenerateArticlesBatch(fileId) {
      $api.support.files.articles.save(
        { fileId: fileId },
        function (response) {
          var res = response.data || response || {};
          var processed = res.processed || 0;

          var file = null;
          for (var i = 0; i < ctrl.files.length; i++) {
            if (ctrl.files[i].id === fileId) {
              file = ctrl.files[i];
              break;
            }
          }

          if (file && processed > 0) {
            file.articles_count = (file.articles_count || 0) + processed;
          }

          reloadTable(true);
          if (processed > 0) {
            runGenerateArticlesBatch(fileId);
          } else {
            runGenerateEmbeddings(fileId);
          }
        },
        function (error) {
          console.error('generate_articles error', error);
          ctrl.isArticlesLoading = false;
          ctrl.globalBusy = false;
          ctrl.busyFileId = null;
          ctrl.busyAction = null;
        }
      );
    }

    function runGenerateEmbeddings(fileId) {
      $api.support.files.embeddings.save(
        { fileId: fileId },
        function (response) {
          ctrl.isArticlesLoading = false;
          ctrl.globalBusy = false;
          ctrl.busyFileId = null;
          ctrl.busyAction = null;

          reloadTable(true);
        },
        function (error) {
          console.error('generate_embeddings error', error);
          ctrl.isArticlesLoading = false;
          ctrl.globalBusy = false;
          ctrl.busyFileId = null;
          ctrl.busyAction = null;

          reloadTable(true);
        }
      );
    }
  });
})();

(function () {
  angular.module('app.controllers')
    .controller('AiSessionsListController', function (
      $scope, $state, $api, $header, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider, $compile, $uibModal, $translate
    ) {
      if ($rootScope.userRole !== 1) {
        $state.go('app.dashboard');
        return;
      }

      $header.title = "AI Sessions";
      $header.breadcrumbs.push({
        title: "NAV_AI_SESSIONS"
      });

      var ctrl = this;
      ctrl.search = '';
      ctrl.dtInstance = null;

      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstance = dtInstance;
      };

      ctrl.reload = function () {
        if (ctrl.dtInstance && ctrl.dtInstance.reloadData) {
          ctrl.dtInstance.reloadData(null, true);
          return;
        }
        if ($('#admin_ai_sessions_dt').DataTable() && $('#admin_ai_sessions_dt').DataTable().ajax) {
          $('#admin_ai_sessions_dt').DataTable().ajax.reload();
        }
      };

      ctrl.openHistoryModal = function (row) {
        var sessionId = row && row.session_id ? row.session_id : '';
        if (!sessionId) {
          return;
        }

        $uibModal.open({
          templateUrl: 'app/modules/admin/modules/ai-sessions/modules/ai-sessions-history/ai-sessions-history.view.html',
          controller: 'AiSessionsHistoryController',
          controllerAs: 'ctrl',
          windowTopClass: 'form-modal medium-modal',
          resolve: {
            sessionId: function () {
              return sessionId;
            }
          }
        });
      };

      ctrl.loadSessions = function (data, callback) {
        var orderCol = '';
        var orderDir = '';

        if (data.order.length) {
          var colIndex = data.order[data.order.length - 1].column;
          orderCol = data.columns[colIndex].name;
          orderDir = data.order[data.order.length - 1].dir;
        }

        $api.admin.ai_sessions.list.get({
          limit: data.length,
          offset: data.start,
          order: orderCol,
          order_dir: orderDir,
          search: ctrl.search
        }, function (result) {
          var payload = (result && result.data) ? result.data : {};
          callback({
            recordsTotal: payload.recordsTotal || 0,
            recordsFiltered: payload.recordsFiltered || 0,
            data: payload.data || [],
            draw: data.draw + 1
          });
        }, function () {
          callback({
            recordsTotal: 0,
            recordsFiltered: 0,
            data: [],
            draw: data.draw + 1
          });
        });
      };

      ctrl.rowCallback = function (nRow, aData) {
        $(nRow).unbind('click');
        $(nRow).bind('click', function () {
          $scope.$apply(function () {
            ctrl.openHistoryModal(aData);
          });
        });
        return nRow;
      };

      ctrl.dtColumns = [
        { name: 'session_id', data: 'session_id', title: $translate.instant('ADMIN_AI_SESSIONS_COL_SESSION_ID') },
        { name: 'business_id', data: 'business_id', title: $translate.instant('ADMIN_AI_SESSIONS_COL_BUSINESS_ID') },
        { name: 'business_name', data: 'business_name', title: $translate.instant('ADMIN_AI_SESSIONS_COL_BUSINESS_NAME') },
        { name: 'customer_name', data: 'customer_name', title: $translate.instant('ADMIN_AI_SESSIONS_COL_CUSTOMER_NAME') },
        { name: 'customer_phone', data: 'customer_phone', title: $translate.instant('ADMIN_AI_SESSIONS_COL_CUSTOMER_PHONE') },
        { name: 'start_time', data: 'start_time', title: $translate.instant('ADMIN_AI_SESSIONS_COL_START_TIME') },
        { name: 'end_time', data: 'end_time', title: $translate.instant('ADMIN_AI_SESSIONS_COL_END_TIME') },
        { name: 'total_messages', data: 'total_messages', title: $translate.instant('ADMIN_AI_SESSIONS_COL_TOTAL_MESSAGES') },
        { name: 'initial_intent', data: 'initial_intent', title: $translate.instant('ADMIN_AI_SESSIONS_COL_INITIAL_INTENT') },
        {
          name: 'status',
          data: null,
          title: $translate.instant('AI_AGENT_BOOKING_STATUS'),
          render: function (data) {
            if (!data || !data.status) {
              return '';
            }
            return $translate.instant('AI_BOOKING_SESSION_STATUS_' + String(data.status).toUpperCase());
          }
        },
        { name: 'failure_reason', data: 'failure_reason', title: $translate.instant('ADMIN_AI_SESSIONS_COL_FAILURE_REASON') },
        { name: 'total_cost', data: 'total_cost', title: $translate.instant('ADMIN_AI_SESSIONS_COL_TOTAL_COST') },
        { name: 'prompt_version', data: 'prompt_version', title: $translate.instant('ADMIN_AI_SESSIONS_COL_PROMPT_VERSION') },
        { name: 'total_tokens', data: 'total_tokens', title: $translate.instant('ADMIN_AI_SESSIONS_COL_TOTAL_TOKENS') }
      ];

      $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
        .withLanguage(dataTablesHebrewProvider)
        .withOption('pageLength', 20)
        .withOption('searching', false)
        .withOption('order', [[5, 'desc']])
        .withOption('serverSide', true)
        .withDataProp('data')
        .withOption('ajax', ctrl.loadSessions)
        .withOption('rowCallback', ctrl.rowCallback)
        .withOption('createdRow', function (row) {
          $compile(angular.element(row).contents())($scope);
        });
    });
})();

(function () {
  angular.module('app.controllers')
    .controller('AiSessionsHistoryController', function ($api, sessionId) {
      var ctrl = this;
      ctrl.loading = true;
      ctrl.messages = [];

      $api.admin.ai_sessions.messages.get({ session_id: sessionId }, function (response) {
        ctrl.loading = false;
        if (response && response.success && response.data) {
          ctrl.messages = response.data;
        } else {
          ctrl.messages = [];
        }
      }, function () {
        ctrl.loading = false;
        ctrl.messages = [];
      });
    });
})();

(function() {
    angular.module("app.controllers").controller("AiPromptsSingleController", function(
      $scope, $state, $api, Prompt, $rootScope, $timeout, $uibModal
    ) {
        if ($rootScope.userRole !== 1) {
          $state.go('app.dashboard');
          return;
        }

        var ctrl = this;
        ctrl.prompt = Prompt.data.prompt;
        ctrl.session_dialog = Prompt.data.session_dialog;

        ctrl.copied = {};

        function getJsonRawByType(type) {
          if (!ctrl.prompt) {
            return null;
          }

          if (ctrl.prompt[type]) {
            return ctrl.prompt[type];
          }

          return null;
        }

        function formatJson(raw) {
          if (!raw) {
            return '';
          }

          if (angular.isObject(raw)) {
            return JSON.stringify(raw, null, 2);
          }

          if (angular.isString(raw)) {
            try {
              var parsed = JSON.parse(raw);
              return JSON.stringify(parsed, null, 2);
            } catch (e) {
              return raw;
            }
          }

          return String(raw);
        }

        ctrl.openJsonModal = function (type) {
          var raw = getJsonRawByType(type);
          if (!raw) {
            return;
          }

          var formatted = formatJson(raw);
          var title = type;

          $uibModal.open({
            animation: true,
            windowTopClass: "form-modal",
            template:
              '<div class="modal-form-inner">' +
              '  <div class="modal-head">' +
              '    <h3 class="form-title">{{$ctrl.title}}</h3>' +
              '    <a class="close" ng-click="$ctrl.close()">&times;</a>' +
              '  </div>' +
              '  <div class="modal-body">' +
              '    <div class="panel-body">' +
              '      <pre style="white-space: pre-wrap; word-wrap: break-word;">{{$ctrl.content}}</pre>' +
              '    </div>' +
              '  </div>' +
              '  <div class="modal-footer end">' +
              '    <button type="button" class="btn text primary large" ng-click="$ctrl.close()">' +
              '      {{\'SETTINGS_INFO_CANCEL\' | translate}}' +
              '    </button>' +
              '  </div>' +
              '</div>',
            controllerAs: '$ctrl',
            controller: function ($uibModalInstance, jsonContent, jsonTitle) {
              var $ctrl = this;

              $ctrl.content = jsonContent;
              $ctrl.title = jsonTitle;

              $ctrl.close = function () {
                $uibModalInstance.close();
              };
            },
            resolve: {
              jsonContent: function () {
                return formatted;
              },
              jsonTitle: function () {
                return title;
              }
            }
          }).closed.then(function() {
            cfilter.applyFilter();
          });
        };

        ctrl.copyJson = function (type) {
          var raw = getJsonRawByType(type);
          if (!raw) {
            return;
          }

          var text = formatJson(raw);

          function onSuccessCopy() {
            $scope.$applyAsync(function () {
              ctrl.copied[type] = true;

              $timeout(function() {
                ctrl.copied[type] = false;
              }, 2000);
            });
          }


          if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
              onSuccessCopy();
            }, function () {
              fallbackCopyText(text, onSuccessCopy);
            });
          } else {
            fallbackCopyText(text, onSuccessCopy);
          }
        };

        function fallbackCopyText(text, onSuccess) {
          var textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();

          try {
            if (document.execCommand('copy')) {
              if (onSuccess) {
                onSuccess();
              }
            }
          } catch (e) {
            console.error('Copy failed', e);
          } finally {
            document.body.removeChild(textarea);
          }
        }

        ctrl.kbDocIds = [];
        ctrl.kbArticlesUrl = null;

        function initKbDocs() {
          if (!ctrl.prompt || !ctrl.prompt.kb_doc_ids_json) {
            return;
          }

          var raw = ctrl.prompt.kb_doc_ids_json;
          var ids = [];

          if (angular.isArray(raw)) {
            ids = raw;
          } else if (angular.isString(raw)) {
            try {
              var parsed = JSON.parse(raw);
              if (angular.isArray(parsed)) {
                ids = parsed;
              }
            } catch (e) {
              console.error('Failed to parse kb_doc_ids_json', e);
            }
          }

          ctrl.kbDocIds = ids.filter(function(id) {
            return id !== null && id !== undefined && id !== '';
          });

          if (ctrl.kbDocIds.length) {
            var baseUrl = '/super/ai-support';
            ctrl.kbArticlesUrl = baseUrl + '?ids=' + ctrl.kbDocIds.join(',');
          }
        };

        initKbDocs();

        ctrl.resolve = function() {
          if (!ctrl.prompt.run_id) {
            return;
          }

          $api.prompts.resolve.get({ run_id: ctrl.prompt.run_id }, function(response) {
              if (response.success) {
                var resolvedAt = new Date();
                ctrl.prompt.feedback_resolved_at = resolvedAt;

                $rootScope.$broadcast('aiPromptResolved', {
                  run_id: ctrl.prompt.run_id,
                  feedback_resolved_at: resolvedAt
                });
              }
            },
            function() {
              console.error('Server error');
            }
          );
        };

        ctrl.loadPrompt = function (id) {
          if (!id || id === ctrl.prompt.query_id) {
            return;
          }

          $api.prompts.single.get({ id: id }, function (response) {
              var data = response.data || response;

              ctrl.prompt = data.prompt || data;
              ctrl.session_dialog = data.session_dialog || ctrl.session_dialog;

              initKbDocs();
            },
            function (err) {
              console.error('Failed to load prompt', err);
            }
          );
        };
    });
})();

(function () {
  angular.module('app.controllers').controller('AiPromptsListController', function (
    Businesses, $header, $state, $scope, $rootScope, $timeout, $api, DTOptionsBuilder, $translate
  ) {
    if ($rootScope.userRole !== 1) {
      $state.go('app.dashboard');
      return;
    }

    $header.title = "AI Prompts";
    $header.breadcrumbs.push({
        "title" : "AI Prompts"
    });

    var ctrl = this;

    ctrl.filter = {
      businessId: '',
      rating: false,
      search: ''
    };

    ctrl.ratingOptions = [
      {
        value: 'all',
        label: 'ADMIN_AI_RATING_ALL',
        name: $translate.instant('ADMIN_AI_RATING_ALL')
      },
      {
        value: true,
        label: 'ADMIN_AI_RATING_POSITIVE',
        name: $translate.instant('ADMIN_AI_RATING_POSITIVE')
      },
      {
        value: false,
        label: 'ADMIN_AI_RATING_NEGATIVE',
        name: $translate.instant('ADMIN_AI_RATING_NEGATIVE')
      },
      {
        value: 'unrated',
        label: 'ADMIN_AI_RATING_NOT_MARKED',
        name: $translate.instant('ADMIN_AI_RATING_NOT_MARKED')
      }
    ];

    ctrl.businesses = [];
    ctrl.businessOptions = [
      {
        id: '',
        name: $translate.instant('ADMIN_AI_ALL_BUSINESSES')
      }
    ];

    if (Businesses) {
      ctrl.businesses = Businesses.data.map(function(business) {
        return {
          id: business.id,
          name: business.name,
        };
      }).sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
      ctrl.businessOptions = ctrl.businessOptions.concat(ctrl.businesses);
    }

    ctrl.prompts = [];
    ctrl.isLoading = false;
    ctrl.error = null;

    ctrl.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
      .withOption('paging', true)
      .withOption('ordering', true)
      .withOption('info', true)
      .withOption('responsive', true)
      .withOption('searching', false)
      .withOption('order', [[5, 'desc']]);

    var searchTimeoutPromise = null;

    ctrl.loadPrompts = function () {
      ctrl.isLoading = true;
      ctrl.error = null;

      var params = {
        business_id: ctrl.filter.businessId || null,
        rating: ctrl.filter.rating,
        search: ctrl.filter.search || null
      };

      $api.prompts.list.save(params, function (response) {
          ctrl.prompts = response.data && response.data.data ? response.data.data : (response.data || []);
          ctrl.isLoading = false;
        }, function (err) {
          console.error('Failed to load AI prompts', err);
          ctrl.error = 'Failed to load AI prompts';
          ctrl.isLoading = false;
        });
    };

    $scope.$watchGroup(['ctrl.filter.businessId', 'ctrl.filter.rating'], function (newVals, oldVals) {
      if (!oldVals) {
        return;
      }

      if (newVals[0] === oldVals[0] && newVals[1] === oldVals[1]) {
        return;
      }

      ctrl.loadPrompts();
    });

    $scope.$watch('ctrl.filter.search', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      if (searchTimeoutPromise) {
        $timeout.cancel(searchTimeoutPromise);
      }

      searchTimeoutPromise = $timeout(function () {
        ctrl.loadPrompts();
      }, 1000);
    });

    $scope.$on('$destroy', function () {
      if (searchTimeoutPromise) {
        $timeout.cancel(searchTimeoutPromise);
      }
    });

    $scope.$on('aiPromptResolved', function (event, data) {
      if (!data || !data.run_id) {
        return;
      }

      var resolvedRunId = data.run_id;
      var resolvedAt = data.feedback_resolved_at || new Date();

      ctrl.prompts.forEach(function (prompt) {
        if (prompt.run_id === resolvedRunId) {
          prompt.feedback_resolved_at = resolvedAt;
        }
      });
    });

    ctrl.loadPrompts();
  });
})();

(function () {

    angular.module('app.controllers')

        .controller('SmsLogsController', function (Logs, $state, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.tableData = Logs && Logs.data ? Logs.data : [];

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_SMS_LOGS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]).withOption('columnDefs', [
                { targets: [2, 3], width: 'auto' }
            ]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = Logs && Logs.data ? Logs.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }
        });
})();

(function () {

    angular.module('app.controllers')

        .controller('SecondResourcesSingleController', function (SecondResource, Info, $api, $state, $scope, $header, $filter, $date, $rootScope, dates, $stateParams, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.loading = false;

            ctrl.request = null;

            ctrl.b_settings = Info.data;

            ctrl.resource_view_types = [
              {
                title: 'RESOURCES_SHIFTS_VIEW_BUSINESS',
                value: 1
              },
              {
                title: 'RESOURCES_SHIFTS_VIEW_CUSTOMERS',
                value: 2
              }
            ];
            ctrl.resourceViewOptions = ctrl.resource_view_types.map(function (shiftsView) {
              return {
                value: shiftsView.value,
                name: $translate.instant(shiftsView.title)
              };
            });

            if(typeof $rootScope.capacityType != "undefined") {
              ctrl.resource_view_type = $rootScope.capacityType;
            } else {
              ctrl.resource_view_type = ctrl.resource_view_types[1].value;
            }

            $scope.second_resource = SecondResource.data;
            ctrl.edit_params = {id: $scope.second_resource.id};

            $rootScope.capacityData = SecondResource.data.capacity;

            $scope.datesProvider = dates;

            /**
             * In case capacity ID wasn't found
             */

            if (SecondResource.status == "failed")
                $state.transitionTo("app.settings.resources", {}, { reload: true });

            /**
             * Open capcity form
             */
            ctrl.capacityForm = function(time) {
                $rootScope.capacityID = SecondResource.data.id;
                $rootScope.capacityDate = $filter("date")(time*1000, "yyyy-MM-dd");
                $rootScope.capacityType = ctrl.resource_view_type;
                $state.transitionTo("app.settings.second_resources.capacity", {id: SecondResource.data.id}, { reload: true });
            };

            /**
             * Load data when change is made
             */
            ctrl.loadData = function(date) {

                ctrl.loading = true;

                if(ctrl.request != null)
                    ctrl.request.$cancelRequest();

                ctrl.request = $api.second_resources.capacity.get({
                    "id": SecondResource.data.id,
                    "date": date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    "capacity_type": ctrl.resource_view_type
                }, function(response) {

                    $rootScope.capacityData = response.data;

                    ctrl.loading = false;

                    ctrl.request = null;
                });
            };

            /**
             * Define page date settings
             */

            $scope.$watch("ctrl.capacityDate", function (newValue, oldValue) {
                if (newValue != oldValue) {
                    newValue = new Date(newValue);
                    ctrl.initDisplayDate(newValue);
                }
            });

            ctrl.initDisplayDate = function (date) {

                var
                    Sunday = $date.getSunday(date),
                    Saturyday = $date.getSaturday(date);

                ctrl.displayDate =
                    (Saturyday.getDate() < 10 ? ("0" + Saturyday.getDate()) : (Saturyday.getDate()))
                    + "/" +
                    ((Saturyday.getMonth() + 1) < 10 ? ("0" + (Saturyday.getMonth() + 1)) : ((Saturyday.getMonth() + 1)))
                    + "/" +
                    Saturyday.getFullYear();

                ctrl.displayDate += " - ";

                ctrl.displayDate +=
                    (Sunday.getDate() < 10 ? ("0" + Sunday.getDate()) : (Sunday.getDate()))
                    + "/" +
                    ((Sunday.getMonth() + 1) < 10 ? ("0" + (Sunday.getMonth() + 1)) : ((Sunday.getMonth() + 1)))
                    + "/" +
                    Sunday.getFullYear();

                ctrl.loadData(Sunday);
            };

            ctrl.nextWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() + (3600 * 24 * 7 * 1000));
            };

            ctrl.prevWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() - (3600 * 24 * 7 * 1000));
            };

            ctrl.displayDate = "";

            if(typeof $rootScope.capacityID == typeof undefined || $rootScope.capacityID == null)
                ctrl.initDisplayDate(new Date());
            else {
                $rootScope.wrapperClasses = "wrapper wrapper-content";
                ctrl.initDisplayDate(new Date($rootScope.capacityDate));
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים - <b>" + SecondResource.data.name + "</b>";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            }, {
                "title": "משאבים",
                "state": "app.settings.second_resources"
            }, {
                "title": SecondResource.data.name
            });

            /**
             * Customer delete
             */
            ctrl.delete = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_RESOURCE_DELETE_CONFIRM_TEXT').replace('[name]', SecondResource.data.name),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.second_resources.single.delete({ id: SecondResource.data.id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_RESOURCE_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.settings.second_resources", {}, { reload: true });
                            }
                        });
                });
            };

            //Config for selectize (categories)
            $scope.userConfig = {
              create: true,
              sortField: 'text'
            };

          ctrl.changeShiftsView = function() {
              if(typeof ctrl.capacityDate == typeof undefined)
                ctrl.initDisplayDate(new Date());
              else {
                ctrl.initDisplayDate(new Date(ctrl.capacityDate));
              }
            }
        });

})();

(function () {

    angular.module('app.controllers')

        .controller('SecondResourcesListController', function (SecondResources, $state, $header, $api, Info, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.bu_type = parseInt(Info.data.type);
            ctrl.second_resource = Info.data.second_resource;
            ctrl.second_resource_name = Info.data.second_resource_name;

            /**
             * Changing the state to the single customer state
             * @param {int} customer_id Customer ID
             * @return {void} void
             */
            ctrl.open_resource_card = function(resource_id) {
                if(ctrl.bu_type == 1) {
                    $state.transitionTo("app.settings.second_resources.single", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                } else {
                    $state.transitionTo("app.settings.second_resources.edit", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                }
            };

            /**
             * Assign data to the table
             */
            ctrl.tableData = SecondResources.data;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "משאבים"
            });

            ctrl.search_value = "";
            ctrl.find_table = function() {
                //reset data
                ctrl.tableData = SecondResources.data;
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                            found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }

                var found = [];
            }

            ctrl.drop = function(){
                var order = [];
                for(var i in ctrl.tableData) {
                    order.push(ctrl.tableData[i].id);
                }
                $api.second_resources.save({ordering: order}, function(response){
                    if(response.status === "success"){
                    }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("SecondResourcesFormController", function($scope, $state, $api, dates, SecondResource, DeleteButton, $rootScope, $resource, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            status: 1,
            is_default: "false",
          sales_active: 1,
          hide_online: 0,
        };

        ctrl.DeleteButton = DeleteButton;

        /**
         * Initialize edit data
         */
        if(SecondResource != null) {
          ctrl.form = SecondResource.data;
          ctrl.form.is_default = "" + ctrl.form.is_default;
          ctrl.form.sales_active = (ctrl.form.sales_active) ? 1 : 0;
          ctrl.form.hide_online = ctrl.form.hide_online;
          ctrl.form.worker_avatar = ctrl.form.avatar ? ctrl.form.avatar : 'assets/images/avatar.jpg';
        }



        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(SecondResource == null)
                /**
                 * In case it's a new customer form
                 */
                $api.second_resources.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RESOURCES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.second_resources", {}, {reload: true});
                    }
                });
            else {
                /**
                 * In case it's an edit form
                 */


                if (ctrl.form.open_orders && ctrl.form.open_orders*1 > 0 && !ctrl.form.sales_active) {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_RESOURCES_SAVE_HAVE_ORDERS_TEXT'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        showCancelButton: true,
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    }).then(function(result) {
                        if(result.value) {
                            ctrl.send();
                        }
                    });
                } else {
                    ctrl.send();
                }
            }
        };

        ctrl.send = function() {
            $api.second_resources.single.save({
                id: SecondResource.data.id
            }, ctrl.form, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCES_SAVE_EDIT_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.go("^", {id: SecondResource.data.id}, {reload: true});
                }
            });
        };

        /**
         * Customer delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_RESOURCES_DELETE_CONFIRM_TEXT').replace('[name]', Resource.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: "אישור",
                cancelButtonText: "ביטול",
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.second_resources.single.delete({ id: SecondResource.data.id }, function (response) {
                        if (response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_RESOURCES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.second_resources", {}, { reload: true });
                        }
                    });
            });
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name  == 'worker_avatar' ? 'worker_avatar' : 'logo';
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            fdata.append("worker_id", ctrl.form.id);
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
            }, function(error){
                console.log(error);
            });
        };

    });

})();

(function () {

    angular.module("app.controllers").controller("SecondResourcesCapacityController", function ($scope, $state, $api, dates, $rootScope, CapacityData, $filter, $stateParams, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(CapacityData == null) {
            $state.transitionTo("app.settings.second_resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
            return;
        }

        ctrl.formScreen = 0;

        ctrl.form = {
            start_time: "08:00",
            end_time: "16:00",
            shift2_start_time: "08:00",
            shift2_end_time: "16:00",
            start_date: $rootScope.capacityDate,
            end_date: $rootScope.capacityDate,
            has_end_date: "0"
        };

        ctrl.endDateOptions = [
            {
                id: "0",
                name: $translate.instant("SETTINGS_RES_PERM")
            },
            {
                id: "1",
                name: $translate.instant("SETTINGS_RES_SPEC_DATE")
            }
        ];

        console.log($stateParams.date);

        $scope.datesProvider = dates;

        /**
         * Apply saved data on "ctrl.form" variable
         */
        ctrl.initFormData = function() {

            ctrl.form.start_time = $filter("hourAndMinute")(CapacityData.data.start_time);
            ctrl.form.end_time = $filter("hourAndMinute")(CapacityData.data.end_time);

            if(CapacityData.data.shift2_start_time) {
                ctrl.form.shift2_start_time = $filter("hourAndMinute")(CapacityData.data.shift2_start_time);
                ctrl.form.shift2_end_time = $filter("hourAndMinute")(CapacityData.data.shift2_end_time);
            }

            ctrl.form.end_date = CapacityData.data.end_date ?  CapacityData.data.end_date : ctrl.form.end_date;
            ctrl.form.has_second_shift = CapacityData.data.shift2_start_time ? true : false;
            ctrl.form.has_end_date = CapacityData.data.end_date ? "1" : "0";
        };

        /**
         * Initialize edit data
         */
        if (CapacityData.data != null)
            if (CapacityData.data.start_time != null)
                ctrl.initFormData();

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.submit = function () {
            ctrl.form.has_shifts = true;
            $api.second_resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.second_resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.delete = function () {

            ctrl.initFormData();
            ctrl.form.has_shifts = false;
            $api.second_resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_DELETE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.second_resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('ResourcesSingleController', function (Resource, Info, $api, $state, $scope, $header, $filter, $date, $rootScope, dates, $stateParams, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.loading = false;

            ctrl.request = null;

            ctrl.b_settings = Info.data;

            ctrl.resource_view_types = [
              {
                title: 'RESOURCES_SHIFTS_VIEW_BUSINESS',
                value: 1
              },
              {
                title: 'RESOURCES_SHIFTS_VIEW_CUSTOMERS',
                value: 2
              }
            ];
            ctrl.resourceViewOptions = ctrl.resource_view_types.map(function (shiftsView) {
              return {
                value: shiftsView.value,
                name: $translate.instant(shiftsView.title)
              };
            });

            if(typeof $rootScope.capacityType != "undefined") {
              ctrl.resource_view_type = $rootScope.capacityType;
            } else {
              ctrl.resource_view_type = ctrl.resource_view_types[1].value;
            }

            $scope.resource = Resource.data;
            ctrl.edit_params = {id: $scope.resource.id};

            $rootScope.capacityData = Resource.data.capacity;

            $scope.datesProvider = dates;

            /**
             * In case capacity ID wasn't found
             */

            if (Resource.status == "failed")
                $state.transitionTo("app.settings.resources", {}, { reload: true });

            /**
             * Open capcity form
             */
            ctrl.capacityForm = function(time) {
                $rootScope.capacityID = Resource.data.id;
                $rootScope.capacityDate = $filter("date")(time*1000, "yyyy-MM-dd");
                $rootScope.capacityType = ctrl.resource_view_type;
                $state.transitionTo("app.settings.resources.capacity", {id: Resource.data.id}, { reload: true });
            };

            /**
             * Load data when change is made
             */
            ctrl.loadData = function(date) {

                ctrl.loading = true;

                if(ctrl.request != null)
                    ctrl.request.$cancelRequest();

                ctrl.request = $api.resources.capacity.get({
                    "id": Resource.data.id,
                    "date": date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    "capacity_type": ctrl.resource_view_type
                }, function(response) {

                    $rootScope.capacityData = response.data;

                    ctrl.loading = false;

                    ctrl.request = null;
                });
            };

            /**
             * Define page date settings
             */

            $scope.$watch("ctrl.capacityDate", function (newValue, oldValue) {
                if (newValue != oldValue) {
                    newValue = new Date(newValue);
                    ctrl.initDisplayDate(newValue);
                }
            });

            ctrl.initDisplayDate = function (date) {

                var
                    Sunday = $date.getSunday(date),
                    Saturyday = $date.getSaturday(date);

                ctrl.displayDate =
                    (Saturyday.getDate() < 10 ? ("0" + Saturyday.getDate()) : (Saturyday.getDate()))
                    + "/" +
                    ((Saturyday.getMonth() + 1) < 10 ? ("0" + (Saturyday.getMonth() + 1)) : ((Saturyday.getMonth() + 1)))
                    + "/" +
                    Saturyday.getFullYear();

                ctrl.displayDate += " - ";

                ctrl.displayDate +=
                    (Sunday.getDate() < 10 ? ("0" + Sunday.getDate()) : (Sunday.getDate()))
                    + "/" +
                    ((Sunday.getMonth() + 1) < 10 ? ("0" + (Sunday.getMonth() + 1)) : ((Sunday.getMonth() + 1)))
                    + "/" +
                    Sunday.getFullYear();

                ctrl.loadData(Sunday);
            };

            ctrl.nextWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() + (3600 * 24 * 7 * 1000));
            };

            ctrl.prevWeek = function() {

                if(ctrl.capacityDate == null)
                    ctrl.capacityDate = new Date();
                else
                    ctrl.capacityDate = new Date(ctrl.capacityDate);

                ctrl.capacityDate = new Date(ctrl.capacityDate.getTime() - (3600 * 24 * 7 * 1000));
            };

            ctrl.displayDate = "";

            if(typeof $rootScope.capacityID == typeof undefined || $rootScope.capacityID == null)
                ctrl.initDisplayDate(new Date());
            else {
                $rootScope.wrapperClasses = "wrapper wrapper-content";
                ctrl.initDisplayDate(new Date($rootScope.capacityDate));
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים - <b>" + Resource.data.name + "</b>";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            }, {
                "title": "משאבים",
                "state": "app.settings.resources"
            }, {
                "title": Resource.data.name
            });

            /**
             * Customer delete
             */
            ctrl.delete = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_RESOURCE_DELETE_CONFIRM_TEXT').replace('[name]', Resource.data.name),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.resources.single.delete({ id: Resource.data.id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_RESOURCE_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.settings.resources", {}, { reload: true });
                            }
                        });
                });
            };

            //Config for selectize (categories)
            $scope.userConfig = {
              create: true,
              sortField: 'text'
            };

          ctrl.changeShiftsView = function() {
              if(typeof ctrl.capacityDate == typeof undefined)
                ctrl.initDisplayDate(new Date());
              else {
                ctrl.initDisplayDate(new Date(ctrl.capacityDate));
              }
            }
        });

})();

(function() {

    angular.module("app.controllers").controller("ResourcesPermissionsController", function($scope, $state, $api, Resource, $rootScope, $resource, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        if ($rootScope.userRole != 0 && $rootScope.userRole != 4){
            $state.go('app.dashboard', {}, {reload: true});
            return;
        }

        var ctrl = this;
        
        ctrl.default_permissions = {
            hide_whatsapp_notifications: {enabled: false},
            dashboard: {enabled: true},
            customers: {enabled: true, personal: false, assigned: false},
            leads: {enabled: true, assigned: false},
            calendar: {enabled: true, personal: false},
            cashbox: {enabled: true},
            business_settings: {enabled: true},
            workers: {enabled: true},
            reports: {enabled: true},
            marketing: {enabled: true},
            business_analysis: {enabled: true},
            hide_prices: {enabled: false},
            show_business_helper: {enabled: false},
            customer_summary_details: {
                reg_date: true, inv: true, cons: true, last_12_month: true, ave: true, bal: true
            },
            customer_tabs: {
                history: true, wachat: true, notes: true, medical_notes: true, cards: true, color: true,
                transaction: true, documents: true, forms: true, laser: true, files: true, smses: true, calls: true
            }
        };

        ctrl.summaryDetailKeys = ['reg_date', 'inv', 'cons', 'last_12_month', 'ave', 'bal'];
        ctrl.tabKeys = ['history', 'wachat', 'notes', 'medical_notes', 'cards', 'color', 'transaction', 'documents', 'forms', 'laser', 'files', 'smses', 'calls'];

        ctrl.form = { permissions: angular.copy(ctrl.default_permissions) };


        /**
         * Initialize edit data
         */
        if (Resource != null) {
            ctrl.form.permissions = angular.copy(ctrl.default_permissions);
            var permissions = Resource.data.permissions ? Resource.data.permissions : false;
            if (permissions) {
              for (var i in permissions) {
                if (ctrl.form.permissions[i] && typeof ctrl.form.permissions[i] === 'object' && !Array.isArray(ctrl.form.permissions[i])) {
                    for (var k in ctrl.form.permissions[i]) {
                        if (ctrl.form.permissions[i][k] !== undefined && permissions[i][k] !== undefined) {
                            ctrl.form.permissions[i][k] = Boolean(permissions[i][k]);
                        }
                    }
                }
              }
            }
        }


        ctrl.submit = function() {

            if(Resource != null) {
                $api.resources.permissions.save({
                    id: Resource.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RESOURCES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.go("^", {id: Resource.data.id}, {reload: true});
                    }
                });
            }
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('ResourcesListController', function (Resources, $state, $header, $api, Info, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;
            ctrl.show_inactive = false;

            ctrl.bu_type = parseInt(Info.data.type);

            /**
             * Changing the state to the single customer state
             * @param {int} customer_id Customer ID
             * @return {void} void
             */
            ctrl.open_resource_card = function(resource_id) {
                if(ctrl.bu_type == 1) {
                    $state.transitionTo("app.settings.resources.single", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                } else {
                    $state.transitionTo("app.settings.resources.edit", {
                        "id": resource_id
                    }, {
                        reload: false
                    });
                }
            };

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול משאבים";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "משאבים"
            });

            ctrl.search_value = "";
            ctrl.find_table = function () {
                var search = ctrl.search_value ? ctrl.search_value.toLowerCase() : '';
                var showInactive = ctrl.show_inactive;

                var filteredData = [];
                for (var i = 0; i < Resources.data.length; i++) {
                    var item = Resources.data[i];
                    var isInactive = item.status * 1 === 0 && item.sales_active * 1 === 0;
                    var isActive = item.status * 1 === 1 || item.sales_active * 1 === 1;

                    if ((isInactive && showInactive) || (isActive && !showInactive)) {
                        if (search) {
                            var found = false;
                            for (var key in item) {
                                if (
                                    item.hasOwnProperty(key) &&
                                    item[key] != null &&
                                    item[key].toString().toLowerCase().indexOf(search) !== -1
                                ) {
                                    found = true;
                                    break;
                                }
                            }
                            if (found) {
                                filteredData.push(item);
                            }
                        } else {
                            filteredData.push(item);
                        }
                    }
                }

                ctrl.tableData = filteredData;
            };

            ctrl.drop = function(){
                var order = [];
                for(var i in ctrl.tableData) {
                    order.push(ctrl.tableData[i].id);
                }
                $api.resources.save({ordering: order}, function(response){
                    if(response.status === "success"){
                    }
                });
            };

            ctrl.change_inactive = function () {
                ctrl.find_table();
            }

            ctrl.find_table();
        });
})();

(function() {

    angular.module("app.controllers").controller("ResourcesFormController", function($scope, $state, $api, dates, Resource, DeleteButton, $rootScope, $resource, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            status: 1,
          is_default: "false",
          sales_active: 1,
          hide_online: 0,
        };

        ctrl.DeleteButton = DeleteButton;

        /**
         * Initialize edit data
         */
        if(Resource != null) {
          ctrl.form = Resource.data;
          ctrl.form.is_default = "" + ctrl.form.is_default;
          ctrl.form.sales_active = (ctrl.form.sales_active) ? 1 : 0;
          ctrl.form.hide_online = ctrl.form.hide_online;
          ctrl.form.worker_avatar = ctrl.form.avatar ? ctrl.form.avatar : 'assets/images/avatar.jpg';
        }



        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(Resource == null)
                /**
                 * In case it's a new customer form
                 */
                $api.resources.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RESOURCES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.resources", {}, {reload: true});
                    }
                });
            else {
                /**
                 * In case it's an edit form
                 */

                if (ctrl.form.open_orders && ctrl.form.open_orders*1 > 0 && ctrl.form.status*1 == 0) {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_RESOURCES_SAVE_HAVE_ORDERS_TEXT'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        showCancelButton: true,
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    }).then(function(result) {
                        if(result.value) {
                            ctrl.send();
                        }
                    });
                } else {
                    ctrl.send();
                }
            }
        };

        ctrl.send = function() {
            $api.resources.single.save({
                id: Resource.data.id
            }, ctrl.form, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCES_SAVE_EDIT_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.go("^", {id: Resource.data.id}, {reload: true});
                }
            });
        };


        /**
         * Customer delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_RESOURCES_DELETE_CONFIRM_TEXT').replace('[name]', Resource.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: "אישור",
                cancelButtonText: "ביטול",
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.resources.single.delete({ id: Resource.data.id }, function (response) {
                        if (response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_RESOURCES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.resources", {}, { reload: true });
                        }
                    });
            });
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name  == 'worker_avatar' ? 'worker_avatar' : 'logo';
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            fdata.append("worker_id", ctrl.form.id);
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
            }, function(error){
                console.log(error);
            });
        };

    });

})();

(function () {

    angular.module("app.controllers").controller("ResourcesCapacityController", function ($scope, $state, $api, dates, $rootScope, CapacityData, $filter, $stateParams, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(CapacityData == null) {
            $state.transitionTo("app.settings.resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
            return;
        }

        ctrl.formScreen = 0;

        ctrl.form = {
            start_time: "08:00",
            end_time: "16:00",
            shift2_start_time: "08:00",
            shift2_end_time: "16:00",
            start_date: $rootScope.capacityDate,
            end_date: $rootScope.capacityDate,
            has_end_date: "0"
        };

        ctrl.endDateOptions = [
            {
                id: "0",
                name: $translate.instant("SETTINGS_RES_PERM")
            },
            {
                id: "1",
                name: $translate.instant("SETTINGS_RES_SPEC_DATE")
            }
        ];

        $scope.datesProvider = dates;

        /**
         * Apply saved data on "ctrl.form" variable
         */
        ctrl.initFormData = function() {

            ctrl.form.start_time = $filter("hourAndMinute")(CapacityData.data.start_time);
            ctrl.form.end_time = $filter("hourAndMinute")(CapacityData.data.end_time);

            if(CapacityData.data.shift2_start_time) {
                ctrl.form.shift2_start_time = $filter("hourAndMinute")(CapacityData.data.shift2_start_time);
                ctrl.form.shift2_end_time = $filter("hourAndMinute")(CapacityData.data.shift2_end_time);
            }

            ctrl.form.end_date = CapacityData.data.end_date ?  CapacityData.data.end_date : ctrl.form.end_date;
            ctrl.form.has_second_shift = CapacityData.data.shift2_start_time ? true : false;
            ctrl.form.has_end_date = CapacityData.data.end_date ? "1" : "0";
        };

        /**
         * Initialize edit data
         */
        if (CapacityData.data != null)
            if (CapacityData.data.start_time != null)
                ctrl.initFormData();

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.submit = function () {
            ctrl.form.has_shifts = true;
            $api.resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

        /**
         * Submit the data to the API to save neccessary information
         */
        ctrl.delete = function () {

            ctrl.initFormData();
            ctrl.form.has_shifts = false;
            $api.resources.capacity.single.save({
                "id": $rootScope.capacityID,
                "date": $rootScope.capacityDate,
                "capacity_type": $rootScope.capacityType
            }, ctrl.form, function (response) {
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_RESOURCE_CAPACITY_DELETE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.resources.single", { id: $rootScope.$stateParams.id }, { reload: true });
                }
            });
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('LogsController', function ($scope, $header, $timeout, $api, $log, $compile, DTOptionsBuilder, dataTablesHebrewProvider, $translate, $rootScope, $uibModal, $state, QuotationStatuses) {
            if ($rootScope.userRole == 1) {
                $state.go('app.admin', {}, { reload: true });
                return;
            }

            var ctrl = this;
            ctrl.enabled_retainers = $rootScope.$user.enabled_retainers;
            ctrl.enabled_continuous_deal = $rootScope.$user.continuous_deal;
            ctrl.quotation_statuses = QuotationStatuses && QuotationStatuses.data ? QuotationStatuses.data : [];
            ctrl.hasQuotationStatuses = ctrl.quotation_statuses.length > 0;
            ctrl.paymentTypeOptions = [
                {id: '', name: $translate.instant('FILTER_PAYMENT_TYPE')},
                {id: '1', name: $translate.instant('CALENDAR_CASH_CASH')},
                {id: '2', name: $translate.instant('ADMIN_CREDIT_CARD')},
                {id: '3', name: $translate.instant('CALENDAR_CASH_ON_CREDIT')},
                {id: '4', name: $translate.instant('CALENDAR_CASH_CHEQUE')},
                {id: '5', name: $translate.instant('CALENDAR_CASH_BANK_TRANS')},
                {id: '6', name: $translate.instant('CALENDAR_CASH_CREDIT_CARD_EXT')}
            ];
            ctrl.quotationStatusFilterOptions = [
                {id: '', name: $translate.instant('CUSTOMER_QUOTATION_STATUS')},
                {id: 'null', name: $translate.instant('QUOTATION_STATUS_VALID')}
            ].concat(ctrl.quotation_statuses.map(function (status) {
                return {
                    id: String(status.id),
                    name: status.name
                };
            }));
            ctrl.quotationStatusOptions = [{
                id: '',
                name: $translate.instant('QUOTATION_STATUS_VALID'),
                color: 'rgba(169, 207, 232, 0.5)'
            }].concat(ctrl.quotation_statuses.map(function (status) {
                return {
                    id: String(status.id),
                    name: status.name,
                    color: status.color || 'rgba(169, 207, 232, 0.5)'
                };
            }));
            $scope.transactionQuotationStatuses = {};

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "היסטוריית עסקאות";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_TRANSACTIONS"
            });

            ctrl.open_log_card = function (logData) {
                $state.transitionTo("app.settings.logs.info", {
                    "id": logData.type3_transaction_id || logData.id
                }, {
                    reload: false
                });
            };

            /**
             * Initiate DataTable Options
             */
            ctrl.initDtOptions = function () {
                $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', 20)
                        //.withOption('order', [[1, 'desc']])
                        .withOption('aaSorting', [])
                        .withOption('searching', false)
                        .withOption('ajax', ctrl.loadLogs)
                        .withOption('serverSide', true)
                        .withDataProp('data')
                        .withOption('rowCallback', ctrl.logsRawCallback)
                        .withOption('createdRow', function (row, data, dataIndex) {
                            // Recompiling so we can bind Angular directive to the DT
                            $compile(angular.element(row).contents())($scope);
                        });
            };

            /**
             * Load logs
             *
             * @param data
             * @param callback
             * @param settings
             */
            ctrl.loadLogs = function (data, callback, settings) {
                var orderCol = '';
                var orderDir = '';

                if (data.order.length) {
                    // Use only last order parameters
                    var colIndex = data.order[data.order.length - 1].column
                    orderCol = data.columns[colIndex]['name'];
                    orderDir = data.order[data.order.length - 1].dir;
                }

                if (ctrl.show_continuous_deals) {
                    $api.continuousDeals.futureInvoices.get({}, function(result) {
                        var allDeals = (result && result.data && Array.isArray(result.data)) ? result.data : [];
                        var filteredDeals = allDeals;
                        var searchValue = (ctrl.search_value || '').toLowerCase().trim();

                        if (searchValue) {
                            filteredDeals = allDeals.filter(function(deal) {
                                var customerName = ((deal.customer_name || '') + '').toLowerCase();
                                return customerName.indexOf(searchValue) !== -1;
                            });
                        }

                        if (orderCol) {
                            filteredDeals = filteredDeals.slice().sort(function(a, b) {
                                var av = a[orderCol];
                                var bv = b[orderCol];

                                if (av === undefined || av === null) av = '';
                                if (bv === undefined || bv === null) bv = '';

                                if (typeof av === 'number' && typeof bv === 'number') {
                                    return orderDir === 'desc' ? (bv - av) : (av - bv);
                                }

                                if (!isNaN(parseFloat(av)) && !isNaN(parseFloat(bv))) {
                                    av = parseFloat(av);
                                    bv = parseFloat(bv);
                                    return orderDir === 'desc' ? (bv - av) : (av - bv);
                                }

                                av = (av + '').toLowerCase();
                                bv = (bv + '').toLowerCase();
                                if (av < bv) return orderDir === 'desc' ? 1 : -1;
                                if (av > bv) return orderDir === 'desc' ? -1 : 1;
                                return 0;
                            });
                        }

                        var start = data.start || 0;
                        var length = data.length || filteredDeals.length;
                        var pagedDeals = filteredDeals.slice(start, start + length);

                        callback({
                            recordsTotal: allDeals.length,
                            recordsFiltered: filteredDeals.length,
                            data: pagedDeals,
                            draw: data.draw + 1
                        });
                    }, function() {
                        callback({
                            recordsTotal: 0,
                            recordsFiltered: 0,
                            data: [],
                            draw: data.draw + 1
                        });
                    });
                    return;
                }

                var getMethod = ctrl.show_pending_payments ? $api.transactions.pending : (ctrl.show_retainers ? $api.transactions.retainers : $api.transactions);

                getMethod.get(
                    {
                        limit: data.length,
                        offset: data.start,
                        order: orderCol,
                        order_dir: orderDir,
                        search: ctrl.search_value,
                        filter: ctrl.filter,
                    }
                    , function (result) {
                        if (result && result.data) {
                            $log.log(result);

                            callback({
                                recordsTotal: result.recordsTotal,
                                recordsFiltered: result.recordsFiltered,
                                data: result.data,
                                draw: data.draw + 1
                            });
                        }

                    });
            };


            ctrl.search_value = "";
            ctrl.filter = {
                payment_type: '',
                quotation_status_id: ''
            };
            ctrl.expandedContinuousRows = {};

            ctrl.show_pending_payments = false;
            ctrl.show_retainers = false;
            ctrl.show_continuous_deals = false;

            ctrl.toggle_retainers = function () {
                ctrl.show_retainers = !ctrl.show_retainers;
                ctrl.show_pending_payments = false;
                ctrl.show_continuous_deals = false;

                ctrl.updateColumns();
                ctrl.initDtOptions();
                // if ($('#logs_dt').DataTable() && $('#logs_dt').DataTable().ajax) {
                //     $('#logs_dt').DataTable().ajax.reload();
                // }
            }

            ctrl.toggle_pending_payments = function () {
                ctrl.show_pending_payments = !ctrl.show_pending_payments;
                ctrl.show_retainers = false;
                ctrl.show_continuous_deals = false;

                ctrl.updateColumns();
                ctrl.initDtOptions();
                // if ($('#logs_dt').DataTable() && $('#logs_dt').DataTable().ajax) {
                //     $('#logs_dt').DataTable().ajax.reload();
                // }
            }

            ctrl.toggle_continuous_deals = function () {
                ctrl.show_continuous_deals = !ctrl.show_continuous_deals;
                ctrl.show_pending_payments = false;
                ctrl.show_retainers = false;

                ctrl.updateColumns();
                ctrl.initDtOptions();
            };

            ctrl.filterModal = false;

            ctrl.openFilter = function () {
                if (!ctrl.filterModal) {
                    $timeout(function () {
                        ctrl.filterModal = true;
                        $('#page-wrapper').addClass('with-filter');
                    });
                }
            }

            ctrl.closeFilter = function () {
                if (ctrl.filterModal) {
                    ctrl.filterModal = false;
                    $('#page-wrapper').removeClass('with-filter');
                }
            }

            ctrl.applyFilter = function () {
                ctrl.find_table();
                ctrl.closeFilter();
            }

            ctrl.clearFilter = function (notSubmit) {

                ctrl.filter = {
                    'date_from': null,
                    'date_to': null,
                    'payment_type': '',
                    'quotation_status_id': ''
                };
                if (!notSubmit) {
                    ctrl.find_table();
                }
                ctrl.closeFilter();
            }

            ctrl.clearFilter(true);


            ctrl.find_table = function () {
                if ($('#logs_dt').DataTable() && $('#logs_dt').DataTable().ajax) {
                    $('#logs_dt').DataTable().ajax.reload();
                }
            }

            /**
             * Bind events to a new row
             *
             * @param nRow
             * @param aData
             * @param iDisplayIndex
             * @param iDisplayIndexFull
             * @returns {*}
             */
            ctrl.logsRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                if (ctrl.show_continuous_deals) {
                    $(nRow).off('click', '.continuous-expand-btn');
                    $(nRow).on('click', '.continuous-expand-btn', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        var $clickedBtn = $(this);
                        $scope.$apply(function () {
                            ctrl.toggleContinuousInvoicesRow(aData, nRow, $clickedBtn);
                        });
                    });
                } else if (!ctrl.show_pending_payments && !ctrl.show_retainers) {
                    $(nRow).unbind('click');
                    $(nRow).bind('click', function () {
                        $scope.$apply(function () {
                            ctrl.open_log_card(aData);
                        });
                    });
                }
                
                if (aData.status === 'second_try') {
                    $(nRow).addClass('deleted-row');
                }
                
                return nRow;
            }

            ctrl.toggleContinuousInvoicesRow = function (deal, rowNode, $clickedBtn) {
                var table = $('#logs_dt').DataTable();
                var row = table.row(rowNode);
                var dealId = deal.id;

                if (row.child.isShown()) {
                    row.child.hide();
                    $(rowNode).removeClass('shown');
                    ctrl.expandedContinuousRows[dealId] = false;
                    if ($clickedBtn && $clickedBtn.length) {
                        $clickedBtn.find('i').removeClass('la-angle-up').addClass('la-angle-down');
                    }
                    return;
                }

                row.child(ctrl.getContinuousInvoicesChildHtml(deal)).show();
                $(rowNode).addClass('shown');
                ctrl.expandedContinuousRows[dealId] = true;
                if ($clickedBtn && $clickedBtn.length) {
                    $clickedBtn.find('i').removeClass('la-angle-down').addClass('la-angle-up');
                }
            };

            ctrl.getContinuousInvoicesChildHtml = function (deal) {
                var invoices = Array.isArray(deal.issued_invoices) ? deal.issued_invoices : [];
                if (!invoices.length) {
                    return "<div class='p-16'>" + $translate.instant('NO_RESULTS') + "</div>";
                }

                var html = "<div class='p-16'><table class='table table-striped table-hover'>";
                html += "<thead><tr>";
                html += "<th>" + $translate.instant('SETTINGS_LOG_TR_NUM') + "</th>";
                html += "<th>" + $translate.instant('SETTINGS_LOG_RECEIPT_DESCRIPTION') + "</th>";
                html += "<th>" + $translate.instant('SETTINGS_LOG_DATE') + "</th>";
                html += "<th>" + $translate.instant('SETTINGS_LOG_TIME') + "</th>";
                html += "<th>" + $translate.instant('SETTINGS_LOG_TR_AM') + "</th>";
                html += "<th>" + $translate.instant('SETTINGS_LOG_CUST_NAME') + "</th>";
                html += "</tr></thead><tbody>";

                for (var i = 0; i < invoices.length; i++) {
                    var invoice = invoices[i];
                    var dateValue = invoice.date ? moment(invoice.date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : '';
                    var timeValue = invoice.date ? moment(invoice.date, "YYYY-MM-DD HH:mm:ss").format("HH:mm") : '';
                    var receiptDescription = $translate.instant('SETTINGS_LOG_INV');
                    if (invoice.allocation_refused) {
                        receiptDescription += " (" + $translate.instant('SETTINGS_LOG_TAX_REFUSED_LABEL') + ")";
                    }

                    html += "<tr>";
                    html += "<td>" + (invoice.document_number || '') + "</td>";
                    html += "<td>" + receiptDescription + "</td>";
                    html += "<td>" + dateValue + "</td>";
                    html += "<td>" + timeValue + "</td>";
                    html += "<td><div style='direction:ltr;text-align:right;'>" + invoice.total + "₪</div></td>";
                    html += "<td>" + (invoice.customer_name || '') + "</td>";
                    html += "</tr>";
                }

                html += "</tbody></table></div>";
                return html;
            };

            if (window.innerWidth < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 3;
            }

            ctrl.initDtOptions();

            /**
             * Customer table column definitions
             * @type {*[]}
             */
            ctrl.dtColumns = [];

            var documentNumberColumn = {
                name: 'document_number',
                data: null,
                title: $translate('SETTINGS_LOG_TR_NUM'),
                render: function (data, type, full, meta) {
                    return data.document_number +
                        (data.allocation_refused ? "<div class='prepaid-label tax-refused-label'>" + $translate.instant('SETTINGS_LOG_TAX_REFUSED_LABEL') + "</div>" : "") +
                        (data.quotation ? "<div class='prepaid-label'>" + $translate.instant('SETTINGS_LOG_QUOTATION_LABEL') + "</div>" : "") +
                        (data.prepaid ? "<div class='prepaid-label show-mobile'>" + $translate.instant('SETTINGS_LOG_PREPAID_LABEL') + "</div>" : "") +
                        (data.payment_type == 9 ? "<div class='prepaid-label show-mobile'>" + $translate.instant('SETTINGS_LOG_PAID_LINK_LABEL') + "</div>" : "");
                }
            };

            var documentTypeKeyToTranslationKey = {
                'invoice_receipt': 'SETTINGS_LOG_INV_TAX',
                'invoice': 'SETTINGS_LOG_INV',
                'receipt': 'SETTINGS_LOG_ACC',
                'proforma_invoice': 'SETTINGS_LOG_INV_TR',
                'credit': 'SETTINGS_LOG_INV_CR',
                'cards-document': 'SETTINGS_LOG_CARD_TR',
                'quotation': 'SETTINGS_LOG_QUOTATION'
            };
            var receiptDescriptionColumn = {
                name: 'receipt_description',
                data: null,
                title: $translate('SETTINGS_LOG_RECEIPT_DESCRIPTION'),
                orderable: false,
                render: function (data, type, full, meta) {
                    var translationKey = data.document_type_key && documentTypeKeyToTranslationKey[data.document_type_key];
                    if (!translationKey) return '';
                    var typeLabel = $translate.instant(translationKey);
                    var cancelledSuffix = data.allocation_refused ? " (" + $translate.instant('SETTINGS_LOG_TAX_REFUSED_LABEL') + ")" : "";
                    return "<div>" + typeLabel + cancelledSuffix + "</div>";
                }
            };

            var dateColumn = {
                name: 'date',
                data: null,
                title: $translate('SETTINGS_LOG_DATE'),
                render: function (data, type, full, meta) {
                    return moment(data.date, "YYYY-MM-DD").format("DD/MM/YYYY");
                }
            };

            var timeColumn = {
                name: 'date',
                data: null,
                title: $translate('SETTINGS_LOG_TIME'),
                render: function (data, type, full, meta) {
                    return moment(data.date, "YYYY-MM-DD HH:mm").format("HH:mm");
                }
            };

            var totalColumn = {
                name: 'total',
                data: null,
                title: $translate('SETTINGS_LOG_TR_AM'),
                render: function (data, type, full, meta) {
                    return "<div style='direction: ltr; text-align: right;'>" + data.total + "₪</div>";
                }
            };

            var quotationStatusColumn = {
                name: 'quotation_status',
                data: null,
                title: $translate('CUSTOMER_QUOTATION_STATUS'),
                orderable: false,
                render: function (data, type, full, meta) {
                    $scope.transactionQuotationStatuses[data.id] = data.quotation_status_id ? String(data.quotation_status_id) : '';
                    return data.quotation ? (
                        '<div class="form-group form-list prevent-click">' +
                            '<app-dropdown model="transactionQuotationStatuses[' + data.id + ']" ' +
                                    'options="ctrl.quotationStatusOptions" ' +
                                    'value-prop="id" ' +
                                    'label-prop="name" ' +
                                    'color-prop="color" ' +
                                    'fixed-panel="true" ' +
                                    'on-change="ctrl.updateQuotationStatus(' + data.id + ', model)">' +
                            '</app-dropdown>' +
                        '</div>'
                    ) : '';
                }
            };

            var prepaidColumn = {
                name: 'prepaid',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    return (data.prepaid ? "<div class='prepaid-label hide-mobile'>" + $translate.instant('SETTINGS_LOG_PREPAID_LABEL') + "</div>" : "") +
                        (data.payment_type == 9 ? "<div class='prepaid-label hide-mobile'>" + $translate.instant('SETTINGS_LOG_PAID_LINK_LABEL') + "</div>" : "");
                }
            };

            var pendingColumn = {
                name: 'pending',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    return "<div class='prepaid-label hide-mobile'>" + (data.prepaid ? $translate.instant('SETTINGS_LOG_PREPAID_LABEL') : $translate.instant('SETTINGS_LOG_PENDING_PAYMENT_LABEL')) + "</div>";
                }
            };

            var customerColumn = {
                name: 'customer_name',
                data: 'customer_name',
                title: $translate('SETTINGS_LOG_CUST_NAME')
            };

            var startDateColumn = {
                name: 'retainer_start_date',
                data: 'retainer_start_date',
                title: $translate('SETTINGS_LOG_RETAINER_START_DATE')
            };

            var nextPaymentDateColumn = {
                name: 'next_withdrawal_date',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_NEXT_PAYMENT_DATE'),
                render: function (data, type, full, meta) {
                    return "<div>" + (data.status === 'second_try' || data.status === 'active' ? (data.second_try_withdrawal_date ? data.second_try_withdrawal_date : data.next_withdrawal_date) : '')+ "</div>";
                }
            };

            var chargetPeriodColumn = {
                name: 'retainer_period',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_PERIOD'),
                render: function (data, type, full, meta) {
                    return "<div>" + (data.retainer_period ? $translate.instant('SETTINGS_LOG_RETAINER_PERIOD_' + data.retainer_period.toUpperCase()) : '') + "</div>";
                }
            };

            var chargesCountColumn = {
                name: 'retainer_count',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_COUNT'),
                render: function (data, type, full, meta) {
                    return "<div>" + (data.retainer_infinity ? $translate.instant('SETTINGS_LOG_RETAINER_INFINITY') : data.retainer_count) + "</div>";
                }
            };

            var chargesWasColumn = {
                name: 'charges_was',
                data: 'charges_was',
                title: $translate('SETTINGS_LOG_RETAINER_CHARGES_WAS')
            };

            var paidAmountColumn = {
                name: 'paid_amount',
                data: null,
                render: function (data, type, full, meta) {
                    return "<div>" + data.paid_amount + "₪</div>";
                },
                title: $translate('SETTINGS_LOG_RETAINER_PAID_AMOUNT')
            };

            var chargesLeftColumn = {
                name: 'charges_left',
                data: 'charges_left',
                title: $translate('SETTINGS_LOG_RETAINER_CHARGES_LEFT')
            };

            var continuousCustomerColumn = {
                name: 'customer_name',
                data: 'customer_name',
                title: $translate('SETTINGS_LOG_CUST_NAME')
            };

            var continuousTotalColumn = {
                name: 'total_amount',
                data: null,
                title: $translate('FUTURE_INVOICES_TOTAL'),
                render: function (data) {
                    return "<div>" + data.total_amount + "₪</div>";
                }
            };

            var continuousIssuedColumn = {
                name: 'num_type2_issued',
                data: null,
                title: $translate('FUTURE_INVOICES_ISSUED'),
                render: function (data) {
                    return "<div>" + data.num_type2_issued + " / " + data.number_of_payments + "</div>";
                }
            };

            var continuousLeftPaymentsColumn = {
                name: 'payments_left',
                data: 'payments_left',
                title: $translate('FUTURE_INVOICES_LEFT')
            };

            var continuousAmountLeftColumn = {
                name: 'amount_left',
                data: null,
                title: $translate('FUTURE_INVOICES_AMOUNT_LEFT'),
                render: function (data) {
                    return "<div>" + data.amount_left + "₪</div>";
                }
            };

            var continuousNextPaymentDateColumn = {
                name: 'next_payment_date',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_NEXT_PAYMENT_DATE'),
                render: function (data) {
                    if (!data.next_payment_date) {
                        return "<div>-</div>";
                    }
                    return "<div>" + moment(data.next_payment_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm") + "</div>";
                }
            };

            var continuousStatusColumn = {
                name: 'status',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_STATUS'),
                render: function (data) {
                    if (!data.status) {
                        return "<div>-</div>";
                    }
                    var statusKey = 'CONTINUOUS_DEAL_STAUS_' + String(data.status).toUpperCase();
                    var translated = $translate.instant(statusKey);
                    return "<div>" + (translated === statusKey ? data.status : translated) + "</div>";
                }
            };

            var continuousCreditColumn = {
                name: 'credit_button',
                data: null,
                title: 'Credit',
                orderable: false,
                render: function (data) {
                    if (data.has_credit) {
                        return '';
                    }
                    return '<a class="btn text border-red small" ng-click="ctrl.openContinuousDealCredit(' + data.type3_transaction_id + '); $event.stopPropagation();">Credit</a>';
                }
            };

            var continuousExpandColumn = {
                name: 'expand',
                data: null,
                title: '',
                orderable: false,
                render: function () {
                    return '<a class="btn icon bordered continuous-expand-btn"><i class="las la-angle-down"></i></a>';
                }
            };

            var reatinerStatusColumn = {
                name: 'retainer_status',
                data: null,
                title: $translate('SETTINGS_LOG_RETAINER_STATUS'),
                render: function (data, type, full, meta) {
                    return "<div>" + $translate.instant('SETTINGS_LOG_RETAINER_STATUS_' + data.status.toUpperCase()) + "</div>";
                }
            };

            var buttonsColumn = {
                name: 'buttons',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    var add_details = '';
                    add_details += '<div class="customer-table-icons">';
                    if (data.order_id != null) {
                        add_details += '<a class="btn icon circle small bordered blue" ng-click="ctrl.toEditOrder(\'' + data.order_id + '\');"><i class="las la-eye"></i></a>';
                    }
                    add_details += '<a class="btn icon circle small bordered red" ng-click="ctrl.deleteTransaction(' + data.id + ');"><i class="las la-trash"></i></a>';
                    add_details += '</div>';

                    return add_details;
                }
            };

            var retainerButtonsColumn = {
                name: 'buttons',
                data: null,
                title: '',
                orderable: false,
                render: function (data, type, full, meta) {
                    var add_details = '';
                    add_details += '<div class="customer-table-icons">';
                    add_details += '<a class="btn icon circle small bordered blue" ng-click="ctrl.toEditRetainer(\'' + data.id + '\');"><i class="las la-edit"></i></a>';
                    add_details += '<a class="btn icon circle small bordered red" ng-click="ctrl.deleteRetainer(' + data.id + ');"><i class="las la-trash"></i></a>';
                    add_details += '</div>';

                    return add_details;
                }
            };

            ctrl.updateColumns = function () {
                if (ctrl.show_continuous_deals) {
                    ctrl.dtColumns = [
                        continuousCustomerColumn,
                        continuousTotalColumn,
                        continuousIssuedColumn,
                        continuousLeftPaymentsColumn,
                        continuousAmountLeftColumn,
                        continuousNextPaymentDateColumn,
                        continuousStatusColumn,
                        continuousCreditColumn,
                        continuousExpandColumn
                    ];
                } else if (ctrl.show_pending_payments) {
                    ctrl.dtColumns = [
                        dateColumn,
                        timeColumn,
                        totalColumn,
                        pendingColumn,
                        customerColumn,
                        buttonsColumn
                    ];
                } else if (ctrl.show_retainers) {
                    ctrl.dtColumns = [
                        dateColumn,
                        timeColumn,
                        totalColumn,
                        customerColumn,
                        startDateColumn,
                        nextPaymentDateColumn,
                        chargetPeriodColumn,
                        chargesCountColumn,
                        chargesWasColumn,
                        paidAmountColumn,
                        chargesLeftColumn,
                        reatinerStatusColumn,
                        retainerButtonsColumn
                    ];
                } else {
                    ctrl.dtColumns = [
                        documentNumberColumn,
                        receiptDescriptionColumn,
                        dateColumn,
                        timeColumn,
                        totalColumn,
                        prepaidColumn,
                        customerColumn
                    ];

                    if (ctrl.hasQuotationStatuses) {
                        ctrl.dtColumns.push(quotationStatusColumn);
                    }
                }
            };

            ctrl.updateColumns();

            ctrl.dtInstanceCallback = function (dtInstance) {
                ctrl.dtInstanceLogs = dtInstance;
            };

            ctrl.openContinuousDealCredit = function (dealId) {
                $state.transitionTo("app.cashbox.credit", {transaction: dealId}, {
                    reload: true
                });
            };

            ctrl.toEditOrder = function (order_id) {
                $uibModal.open({
                    templateUrl: "app/modules/calendar/order/order.form.html",
                    controller: "OrderFormController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Items: function($api) {
                            return $api.resolve("items.items_with_duration@get");
                        },
                        Customers: function($api) {
                            return $api.resolve("customers@get");
                        },
                        Resources: function($api) {
                            return $api.resolve("resources@get");
                        },
                        SecondResources: function($api) {
                            return $api.resolve("second_resources@get");
                        },
                        Info: function ($api) {
                            return $api.resolve("settings.info@get");
                        },
                        Clubs: function($api) {
                            return $api.resolve("settings.clubs@get");
                        },
                        Customer: function($api) {
                            return null;
                        },
                        Order: function($api) {
                            return $api.resolve("orders.single@get", {
                                "id": order_id
                            });
                        },
                        Messages:  function($api) {
                            return $api.resolve("settings.messages@get");
                        },
                        CalendarCourse: null,
                        CalendarEvent: null,
                        EventCopy: false,
                        CoursesFields: ['$api', function ($api) {
                            return $api.resolve('coursesFields.lists@get');
                        }],
                    }
                });
            };

            ctrl.deleteTransaction = function (id) {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_WAITING_LIST_DELETE_CONFIRM_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function (result) {
                    if (result.value) {
                        $api.transactions.remove.get({ id: id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });

                                ctrl.dtInstanceLogs.reloadData(null, false);
                            }
                        });
                    }
                });
            };

            ctrl.toEditRetainer = function (id) {
                $state.transitionTo("app.cashbox.retainer", { retainerID: id }, {
                    reload: true
                });
            };

            ctrl.deleteRetainer = function (id) {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_WAITING_LIST_DELETE_CONFIRM_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function (result) {
                    if (result.value) {
                        $api.transactions.remove_retainer.get({ id: id }, function (response) {
                            if (response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });

                                ctrl.dtInstanceLogs.reloadData(null, false);
                            }
                        });
                    }
                });
            };

            ctrl.updateQuotationStatus = function(transactionId, statusId) {
                var statusValue = statusId === '' ? null : statusId;
                $api.transactions.quotation_status.save({id: transactionId}, {quotation_status_id: statusValue}, function(response) {
                    if(response.status == "success") {
                        if (ctrl.dtInstanceLogs && ctrl.dtInstanceLogs.reloadData) {
                            ctrl.dtInstanceLogs.reloadData(null, false);
                        }
                    }
                });
            };

            /**
             * Get quotation status color for background
             */
            ctrl.getQuotationStatusColor = function(statusId) {
                if (!statusId || !ctrl.quotation_statuses) return ctrl.hexToRgbA('#a9cfe8');
                for (var i = 0; i < ctrl.quotation_statuses.length; i++) {
                    if (String(ctrl.quotation_statuses[i].id) === String(statusId)) {
                        return ctrl.hexToRgbA(ctrl.quotation_statuses[i].color || '#a9cfe8');
                    }
                }
                return ctrl.hexToRgbA('#a9cfe8');
            };

            ctrl.hexToRgbA = function(hex){
                var c;
                if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                    c= hex.substring(1).split('');
                    if(c.length== 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
                }
                return 'rgba(169,207,232,0.1)';
            }
        });

})();

(function() {

    angular.module("app.controllers").controller("LogsInfoController", function($scope, Transaction, $rootScope, $state, $api, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.isMobile = (angular.element(document).width() < 769)
        $scope.transaction = Transaction.data;

        ctrl.printInvoice = function(url) {
          printJS(url);
        }

        ctrl.smsInvoice = function(id) {
          $api.transactions.send_sms_invoice.get({id:id},
          function(res){
            swal({
              title: $translate.instant('SWAL_SMS_INVOICE_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 1500
            });
          },
          function (res) {
          });
        }
    });

})();

(function() {

    angular.module("app.controllers").controller("LeadsWhatsappController", function($scope, $state, Statuses, $api, $business, $rootScope, Info, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var tmp_msg_channels = $business.getMsgChannels();
        $scope.msg_channels = [];
        for (var i = 0; i < tmp_msg_channels.length; i++) {
          if (tmp_msg_channels[i].index != 4 && tmp_msg_channels[i].index != 0) {
            $scope.msg_channels.push(tmp_msg_channels[i]);
          }
        }

        var ctrl = this;

        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];
        
        ctrl.form = {
          enabled: Info.data && Info.data.lead_settings && Info.data.lead_settings.whatsapp && Info.data.lead_settings.whatsapp.enabled ? Info.data.lead_settings.whatsapp.enabled : false,
          status: Info.data && Info.data.lead_settings && Info.data.lead_settings.whatsapp && Info.data.lead_settings.whatsapp.status ? Info.data.lead_settings.whatsapp.status :'',
          arrival_source: Info.data && Info.data.lead_settings && Info.data.lead_settings.whatsapp && Info.data.lead_settings.whatsapp.arrival_source ? Info.data.lead_settings.whatsapp.arrival_source :'',
        };


      ctrl.submit = function() {
        if (!Info.data || !Info.data.lead_settings || !Info.data.lead_settings.whatsapp || !Info.data.lead_settings.whatsapp.enabled) {
          ctrl.form.date = moment().format("YYYY-MM-DD HH:mm:ss");
        }
        $api.settings.lead_settings.save({whatsapp: ctrl.form}, function(response){
          if(response.success) {
            swal({
                title: $translate.instant('SETTINGS_LEADS_WHATSAPP_SAVED'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
            });
            $state.transitionTo("app.settings.leads", {}, {reload: true});
          }
        });
      };

      var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}var result=MD5('');console.log(result);var result=MD5('');console.log(result);

      var ID_prefix = MD5(Info.data.id).slice(28,32);
      ctrl.token = ID_prefix + Info.data.id;
    });

})();

(function() {

    angular.module("app.controllers").controller("LeadsWebhookController", function($scope, $state, Statuses, $api, $business, $rootScope, Info, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var tmp_msg_channels = $business.getMsgChannels();
        $scope.msg_channels = [];
        for (var i = 0; i < tmp_msg_channels.length; i++) {
          if (tmp_msg_channels[i].index != 4 && tmp_msg_channels[i].index != 0) {
            $scope.msg_channels.push(tmp_msg_channels[i]);
          }
        }

        var ctrl = this;

        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];

        ctrl.url = 'https://'+window.location.hostname+'/api/leads/action/add';
        
        ctrl.form = {
          status: Info.data && Info.data.lead_settings && Info.data.lead_settings.webhook && Info.data.lead_settings.webhook.status ? Info.data.lead_settings.webhook.status :'',
          arrival_source: Info.data && Info.data.lead_settings && Info.data.lead_settings.webhook && Info.data.lead_settings.webhook.arrival_source ? Info.data.lead_settings.webhook.arrival_source :'',
        };


      ctrl.submit = function() {

        $api.settings.lead_settings.save({webhook: ctrl.form}, function(response){
          if(response.success) {
            swal({
                title: $translate.instant('SETTINGS_LEADS_WEBHOOK_SAVED'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
            });
            $state.transitionTo("app.settings.leads", {}, {reload: true});
          }
        });
      };

      var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}var result=MD5('');console.log(result);var result=MD5('');console.log(result);

      var ID_prefix = MD5(Info.data.id).slice(28,32);
      ctrl.token = ID_prefix + Info.data.id;
    });

})();

(function() {

    angular.module("app.controllers").controller("LeadsStatusesNewController", function($scope, $state, $api, Status, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
            color: '#a9cfe8',
            type: '0',
        };

        ctrl.displayTypeOptions = [
            { id: '0', name: $translate.instant('SETTINGS_LEADS_STATUSES_DISPLAY_IN_CUSTOMERS') },
            { id: '1', name: $translate.instant('SETTINGS_LEADS_STATUSES_DISPLAY_IN_LEADS') }
        ];

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(Status != null) {
            $scope.isEdit = true;
            ctrl.form = Status.data;
            ctrl.form.color = ctrl.form.color ? ctrl.form.color : '#a9cfe8';
            ctrl.form.type = String(ctrl.form.type * 1);
        }

        ctrl.submit = function() {

            if(Status == null)
                $api.statuses.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_STATUSES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.leads.statuses", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.statuses.single.save({
                    id: Status.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_STATUSES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.leads.statuses", {}, {reload: true});
                    }
                });
        };

      
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_STATUSES_DELETE_CONFIRM_TEXT').replace('[name]', Status.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.statuses.single.delete({id: Status.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_STATUSES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.leads.statuses", {}, {reload: true});
                        }
                    });
            });
        };
       
    });

})();

(function () {

    angular.module("app.controllers").controller("LeadsStatusesController", function ($scope, $state, $api, $header, Statuses, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider, $translate) {

        if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, { reload: true });
            return;
        }

        var ctrl = this;

        ctrl.tableData = Statuses && Statuses.data ? Statuses.data.map(function (row) {
            row.type = String(row.type * 1);
            return row;
        }) : [];

        ctrl.displayTypeOptions = [
            { id: '0', name: $translate.instant('SETTINGS_LEADS_STATUSES_DISPLAY_IN_CUSTOMERS') },
            { id: '1', name: $translate.instant('SETTINGS_LEADS_STATUSES_DISPLAY_IN_LEADS') }
        ];

        /**
         * Module header configuration (title and breadcrumbs)
         */
        $header.title = "פריטים";
        $header.breadcrumbs.push({
            "title": "NAV_SETTINGS",
            "state": "app.settings"
        });
        $header.breadcrumbs.push({
            "title": "SETTINGS_LEADS_STATUSES"
        });

        /**
         * Datatable configuration
         */
        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]);

        ctrl.search_value = "";
        ctrl.find_table = function () {
            ctrl.tableData = Statuses && Statuses.data ? Statuses.data : [];
            if (ctrl.search_value) {
                var newData = [];
                for (var i in ctrl.tableData) {
                    var found = false;
                    for (var k in ctrl.tableData[i]) {
                        if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                            found = true;
                        }
                    }

                    if (found) {
                        newData.push(ctrl.tableData[i]);
                    }
                }

                ctrl.tableData = newData;
            }
        };

        ctrl.update = function(item) {
            $api.statuses.single.save({
                id: item.id
            }, item, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_STATUSES_SAVE_EDIT_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }
            });
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('LeadsSettingsController', function ($state, $header, $scope, $api, Info, $business, $translate, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var tmp_msg_channels = $business.getMsgChannels();
            $scope.msg_channels = [];
            for (var i = 0; i < tmp_msg_channels.length; i++) {
            if (tmp_msg_channels[i].index != 4 && tmp_msg_channels[i].index != 0) {
                $scope.msg_channels.push(tmp_msg_channels[i]);
            }
            }

            var ctrl = this;

            var rawNotify = (Info.data && Info.data.lead_settings && Info.data.lead_settings.notify)
                ? Info.data.lead_settings.notify
                : [];
            var notifyIndices = [];
            for (var n = 0; n < rawNotify.length; n++) {
                var entry = rawNotify[n];
                if (entry != null && typeof entry === 'object' && Array.isArray(entry) === false && typeof entry.index !== 'undefined') {
                    notifyIndices.push(entry.index);
                } else {
                    notifyIndices.push(entry);
                }
            }
            ctrl.form = {
                notify: notifyIndices
            };
            ctrl.msgChannelOptions = [];
            for (var j = 0; j < $scope.msg_channels.length; j++) {
                ctrl.msgChannelOptions.push({
                    id: String($scope.msg_channels[j].index),
                    name: $translate.instant($scope.msg_channels[j].name)
                });
            }
            ctrl.form.notify = (ctrl.form.notify || []).map(function (id) {
                return String(id);
            });

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "קטגוריות";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "לידים"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider);

            ctrl.submitSettings = function() {
                $api.settings.lead_settings.save(ctrl.form, function(response){
                    if(response.success) {
                    swal({
                        title: $translate.instant('SETTINGS_LEADS_SAVED'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings.leads", {}, {reload: true});
                    }
                });
            };

        });

})();

(function() {

    angular.module("app.controllers").controller("LeadsFacebookController", function($scope, $window, $state, Statuses, $api, $rootScope, Info, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];
        ctrl.pages = Info.data && Info.data.fb_pages ? Info.data.fb_pages : [];
        
        ctrl.form = {
          status: Info.data && Info.data.lead_settings && Info.data.lead_settings.facebook && Info.data.lead_settings.facebook.status ? Info.data.lead_settings.facebook.status :'',
          arrival_source: Info.data && Info.data.lead_settings && Info.data.lead_settings.facebook && Info.data.lead_settings.facebook.arrival_source ? Info.data.lead_settings.facebook.arrival_source :'',
        };

        ctrl.loginFacebook = function() {
          window.FB.login(function(response){
            if (response.authResponse) {

              window.FB.login(function(response){
                $api.fb_auth.save({authResponse: response}, function (response) {
                  $window.location.reload();
                });
              }, {scope: ['pages_show_list', 'leads_retrieval', 'pages_read_engagement', 'ads_management', 'pages_manage_metadata', 'pages_manage_ads', 'email', 'public_profile']});
              
            }
          }, {scope: ['pages_show_list', 'leads_retrieval', 'pages_read_engagement', 'ads_management', 'pages_manage_metadata', 'pages_manage_ads', 'email', 'public_profile', 'business_management']});
        }


      ctrl.submit = function() {
        $api.settings.lead_settings.save({facebook: ctrl.form}, function(response){
          if(response.success) {
            swal({
                title: $translate.instant('SETTINGS_LEADS_FACEBOOK_SAVED'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
            });
            $state.transitionTo("app.settings.leads", {}, {reload: true});
          }
        });
      };

       
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('ItemsListController', function ($state, $api, $uibModal, $header, $scope, $rootScope, $timeout, $translate, dates, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            function getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            }

            function applyItemsListScroll(clearPending) {
                if (!$rootScope._itemsListScrollPending || $rootScope._itemsListScrollTop == null) {
                    return;
                }

                var scrollTop = $rootScope._itemsListScrollTop;

                $timeout(function () {
                    window.scrollTo(0, scrollTop);
                    if (clearPending) {
                        $timeout(function () {
                            window.scrollTo(0, scrollTop);
                        }, 50);
                        $timeout(function () {
                            window.scrollTo(0, scrollTop);
                        }, 200);
                        $timeout(function () {
                            window.scrollTo(0, scrollTop);
                            $rootScope._itemsListScrollPending = false;
                            $rootScope._itemsListScrollTop = null;
                        }, 500);
                    }
                }, 0);
            }

            function restoreItemsListScrollAfterRender() {
                if ($state.current.name !== 'app.settings.items') {
                    return;
                }

                // After save, the list is reloaded and can force scroll back to top.
                // Re-apply saved position once data/render finishes.
                if ($rootScope._itemsListScrollPending) {
                    applyItemsListScroll(true);
                }
            }

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
                if (fromState && fromState.name === 'app.settings.items' &&
                    toState && (toState.name === 'app.settings.items.edit' || toState.name === 'app.settings.items.new')) {
                    $rootScope._itemsListScrollTop = getScrollTop();
                    $rootScope._itemsListScrollPending = true;
                }
            });

            $scope.$on('$stateChangeSuccess', function (event, toState) {
                if (toState && (toState.name === 'app.settings.items.edit' || toState.name === 'app.settings.items.new')) {
                    applyItemsListScroll(false);
                    return;
                }
                if (toState && toState.name === 'app.settings.items') {
                    applyItemsListScroll(true);
                }
            });

            $scope.$on('$viewContentLoaded', function () {
                if ($rootScope._itemsListScrollPending &&
                    ($state.current.name === 'app.settings.items.edit' || $state.current.name === 'app.settings.items.new')) {
                    applyItemsListScroll(false);
                    return;
                }
                if ($rootScope._itemsListScrollPending && $state.current.name === 'app.settings.items') {
                    applyItemsListScroll(true);
                }
            });

            if ($rootScope._itemsListScrollPending) {
                applyItemsListScroll($state.current.name === 'app.settings.items');
            }

            ctrl.show_inactive = false;
            ctrl.show_stock = $rootScope.$user.show_stock;
            ctrl.stockSkipFields = ctrl.show_stock ? ['stock_action'] : ['stock', 'stock_action'];
            ctrl.loading = true;

            ctrl.fieldSettings = ($rootScope.$user && $rootScope.$user.table_columns && $rootScope.$user.table_columns.items) ? $rootScope.$user.table_columns.items : [];
            var unwatchUser = $scope.$watch(function() {
                return $rootScope.$user;
            }, function(newUser) {
                if (newUser && newUser.table_columns && newUser.table_columns.items) {
                    ctrl.fieldSettings = newUser.table_columns.items;
                    ctrl.rebuildVisibleFields();
                    if (unwatchUser) {
                        unwatchUser();
                    }
                }
            }, true);

            ctrl.onFieldsUpdate = function(fieldsList) {
                ctrl.fieldSettings = fieldsList;
                ctrl.rebuildVisibleFields();
                $api.settings.table_columns.save({section: 'items', columns: fieldsList}, function(response) {
                    if (response.status == 'success') {
                        if (!$rootScope.$user.table_columns) {
                            $rootScope.$user.table_columns = {};
                        }
                        $rootScope.$user.table_columns.items = fieldsList;
                    }
                }, function(response) {
                    console.error('Failed to save table columns', response);
                });
            };

            ctrl.visibleFields = [];

            ctrl.rebuildVisibleFields = function() {
                var result = [];
                var i;
                var field;

                if (ctrl.fieldSettings && ctrl.fieldSettings.length > 0) {
                    for (i = 0; i < ctrl.fieldSettings.length; i++) {
                        field = ctrl.fieldSettings[i];
                        if (!field || !field.display || field.name === 'stock_action') {
                            continue;
                        }
                        if ((field.name === 'stock') && !ctrl.show_stock) {
                            continue;
                        }
                        result.push(field);
                        if (field.name === 'stock' && ctrl.show_stock) {
                            result.push({name: 'stock_action'});
                        }
                    }
                }

                if (result.length === 0) {
                    result = [
                        {name: 'name', translationKey: 'SETTINGS_ITEM'},
                        {name: 'price', translationKey: 'SETTINGS_ITEM_PRICE'},
                        {name: 'categories', translationKey: 'SETTINGS_ITEM_CAT'}
                    ];
                    if (ctrl.show_stock) {
                        result.push({name: 'stock', translationKey: 'SETTINGS_ITEM_STOCK'});
                        result.push({name: 'stock_action'});
                    }
                    result.push({name: 'item_type', translationKey: 'SETTINGS_ITEM_TYPE'});
                }

                ctrl.visibleFields = result;
            };

            ctrl.rebuildVisibleFields();
            ctrl.data = [];
            ctrl.tableData = [];
            ctrl.search_value = "";
            ctrl.categoryFilterOptions = [];

            if (!$rootScope.items_filter) {
                $rootScope.items_filter = {
                    category: [],
                    item_type: [],
                    customer_allowed_booking: ''
                };
            }
            ctrl.digitalFormsMap = {};
            ctrl.durationMap = {};

            angular.forEach((dates && dates.duration) ? dates.duration : [], function(option) {
                if (option && option.duration !== undefined && option.duration !== null) {
                    ctrl.durationMap[String(option.duration)] = option.label;
                }
            });

            ctrl.formatDuration = function(value) {
                if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
                    return $translate.instant('SETTINGS_ITEM_NOT_SET');
                }
                return ctrl.durationMap[String(value)] || String(value);
            };

            ctrl.formatBreak = function(value) {
                if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
                    return $translate.instant('SETTINGS_ITEM_NO_BREAK');
                }
                return ctrl.formatDuration(value);
            };

            ctrl.formatYesNo = function(value) {
                if (value == 1 || value === true) {
                    return $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES');
                }
                return $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO');
            };

            ctrl.formatDigitalForm = function(row) {
                var parts = [];
                var formId = row.digital_form;

                if (!formId || formId == 0 || formId === '0') {
                    parts.push($translate.instant('SETTINGS_ITEM_NOT_SET'));
                } else if (ctrl.digitalFormsMap[String(formId)]) {
                    parts.push(ctrl.digitalFormsMap[String(formId)]);
                } else {
                    parts.push(String(formId));
                }

                if (row.digital_form_hour !== null && row.digital_form_hour !== undefined && row.digital_form_hour !== '') {
                    parts.push($translate.instant('DIGITAL_FORM_SEND_TEXT_2') + ': ' + row.digital_form_hour);
                }

                if (row.digital_form_option) {
                    if (row.digital_form_option === 'order_start') {
                        parts.push($translate.instant('DIGITAL_FORM_SEND_OPTION_1'));
                    } else if (row.digital_form_option === 'order_end') {
                        parts.push($translate.instant('DIGITAL_FORM_SEND_OPTION_2'));
                    } else if (row.digital_form_option === 'invoice') {
                        parts.push($translate.instant('DIGITAL_FORM_SEND_OPTION_3'));
                    } else {
                        parts.push(row.digital_form_option);
                    }
                }

                return parts.join(', ');
            };

            ctrl.formatOnlinePayment = function(row) {
                if (!row.require_online_payment || row.require_online_payment == 0) {
                    return ctrl.formatYesNo(0);
                }

                var parts = [ctrl.formatYesNo(1)];

                if (row.online_payment_type == 1 || row.online_payment_type === '1') {
                    parts.push($translate.instant('ITEM_FULL_ONLINE_PAYMENT'));
                } else if (row.online_payment_type == 2 || row.online_payment_type === '2') {
                    parts.push($translate.instant('ITEM_PREPAID_ONLINE_PAYMENT'));
                    if (row.online_payment_amount !== null && row.online_payment_amount !== undefined && row.online_payment_amount !== '') {
                        parts.push(row.online_payment_amount);
                    }
                }

                return parts.join(', ');
            };

            ctrl.formatText = function(value) {
                if (value === null || value === undefined) {
                    return '';
                }
                return String(value);
            };

            function buildItemRow(source) {
                return {
                    id: source.id,
                    bg_color: source.bg_color,
                    item_image: source.item_image,
                    name: source.name,
                    price: source.price,
                    categories: source.categories,
                    item_type: source.item_type,
                    stock: source.stock,
                    duration: source.duration,
                    customer_allowed_booking: source.customer_allowed_booking,
                    inactive: source.inactive,
                    digital_form: source.digital_form,
                    digital_form_hour: source.digital_form_hour,
                    digital_form_option: source.digital_form_option,
                    name_second: source.name_second,
                    break: source.break,
                    duration_second: source.duration_second,
                    require_online_payment: source.require_online_payment,
                    online_payment_type: source.online_payment_type,
                    online_payment_amount: source.online_payment_amount,
                    description: source.description,
                    general_info: source.general_info,
                    specific_info: source.specific_info,
                    restriction: source.restriction
                };
            }

            function itemMatchesSearch(source, searchValue) {
                if (!searchValue) {
                    return true;
                }

                var search = searchValue.toLowerCase();
                var key;
                var row = buildItemRow(source);

                for (key in source) {
                    if (source[key] != null && String(source[key]).toLowerCase().indexOf(search) > -1) {
                        return true;
                    }
                }

                if (ctrl.formatDigitalForm(row).toLowerCase().indexOf(search) > -1) {
                    return true;
                }

                if (ctrl.formatOnlinePayment(row).toLowerCase().indexOf(search) > -1) {
                    return true;
                }

                if (ctrl.formatDuration(source.duration).toLowerCase().indexOf(search) > -1) {
                    return true;
                }

                if (ctrl.formatBreak(source.break).toLowerCase().indexOf(search) > -1) {
                    return true;
                }

                return false;
            }

            function itemMatchesFilter(source) {
                var filter = $rootScope.items_filter || {};
                var categoryFilter = filter.category;
                var typeFilter = filter.item_type;
                var bookingFilter = filter.customer_allowed_booking;
                var categoryIds = [];
                var types = [];
                var i;
                var itemCategories;
                var hasCategory;
                var bookingVal;
                var itemBooking;

                if (categoryFilter && categoryFilter.length > 0) {
                    for (i = 0; i < categoryFilter.length; i++) {
                        if (categoryFilter[i] && typeof categoryFilter[i] === 'object' && categoryFilter[i].id !== undefined) {
                            categoryIds.push(String(categoryFilter[i].id));
                        } else {
                            categoryIds.push(String(categoryFilter[i]));
                        }
                    }

                    itemCategories = source.categories || [];
                    hasCategory = false;
                    for (i = 0; i < itemCategories.length; i++) {
                        if (categoryIds.indexOf(String(itemCategories[i])) > -1) {
                            hasCategory = true;
                            break;
                        }
                    }
                    if (!hasCategory) {
                        return false;
                    }
                }

                if (typeFilter && typeFilter.length > 0) {
                    types = [];
                    for (i = 0; i < typeFilter.length; i++) {
                        if (typeFilter[i] && typeof typeFilter[i] === 'object' && typeFilter[i].id !== undefined) {
                            types.push(String(typeFilter[i].id));
                        } else {
                            types.push(String(typeFilter[i]));
                        }
                    }
                    if (types.indexOf(String(source.item_type)) === -1) {
                        return false;
                    }
                }

                if (bookingFilter !== null && bookingFilter !== undefined && bookingFilter !== '') {
                    bookingVal = bookingFilter;
                    if (bookingFilter && typeof bookingFilter === 'object' && bookingFilter.id !== undefined) {
                        bookingVal = bookingFilter.id;
                    }
                    itemBooking = (source.customer_allowed_booking == 1 || source.customer_allowed_booking === true) ? '1' : '0';
                    if (String(bookingVal) !== itemBooking) {
                        return false;
                    }
                }

                return true;
            }

            $scope.categories = {};

            function parseItemsCategories(itemsData) {
                for (var i in itemsData) {
                    if (itemsData[i].categories != null) {
                        itemsData[i].categories = String(itemsData[i].categories).replace("{", "[").replace("}", "]");
                        itemsData[i].categories = JSON.parse(itemsData[i].categories);
                    }
                }
            }

            function setCategoriesMap(categoriesData) {
                $scope.categories = {};
                ctrl.categoryFilterOptions = [];
                for (var i in categoriesData) {
                    $scope.categories[categoriesData[i].id] = categoriesData[i];
                    ctrl.categoryFilterOptions.push({
                        id: String(categoriesData[i].id),
                        name: categoriesData[i].name
                    });
                }
            }

            ctrl.onFilterUpdate = function() {
                ctrl.change_inactive();
            };

            ctrl.isSortingDisabled = function() {
                var filter = $rootScope.items_filter || {};

                var hasSearch = ctrl.search_value && String(ctrl.search_value).trim() !== '';
                var hasInactive = ctrl.show_inactive === true;

                var hasCategory = filter.category && filter.category.length > 0;
                var hasItemType = filter.item_type && filter.item_type.length > 0;
                var hasCustomerBooking = filter.customer_allowed_booking !== null &&
                    filter.customer_allowed_booking !== undefined &&
                    filter.customer_allowed_booking !== '';

                // When the list is narrowed (search/filters/inactive toggle),
                // we don't want to persist ordering based on only the visible subset.
                return hasSearch || hasInactive || hasCategory || hasItemType || hasCustomerBooking;
            };

            ctrl.load = function () {
                var itemsDone = false;
                var categoriesDone = false;
                var digitalFormsDone = false;
                var itemsData = null;
                var categoriesData = null;

                ctrl.loading = true;

                function tryFinish() {
                    if (!itemsDone || !categoriesDone || !digitalFormsDone) {
                        return;
                    }

                    try {
                        if (itemsData) {
                            parseItemsCategories(itemsData);
                            ctrl.data = itemsData;
                        } else {
                            ctrl.data = [];
                        }

                        if (categoriesData) {
                            setCategoriesMap(categoriesData);
                        } else {
                            $scope.categories = {};
                        }

                        ctrl.change_inactive();
                    } catch (e) {
                        console.error('Items list load failed', e);
                        ctrl.data = [];
                        ctrl.tableData = [];
                    }

                    ctrl.loading = false;
                    restoreItemsListScrollAfterRender();
                }

                $api.items_list.get(function (response) {
                    itemsData = response && response.data ? response.data : [];
                    itemsDone = true;
                    tryFinish();
                }, function () {
                    itemsData = [];
                    itemsDone = true;
                    tryFinish();
                });

                $api.categories.get(function (response) {
                    categoriesData = response && response.data ? response.data : [];
                    categoriesDone = true;
                    tryFinish();
                }, function () {
                    categoriesData = [];
                    categoriesDone = true;
                    tryFinish();
                });

                $api.digital_forms.get(function (response) {
                    var forms = response && response.data ? response.data : [];
                    var i;

                    ctrl.digitalFormsMap = {};
                    for (i = 0; i < forms.length; i++) {
                        if (forms[i] && forms[i].id) {
                            ctrl.digitalFormsMap[String(forms[i].id)] = forms[i].name;
                        }
                    }
                    digitalFormsDone = true;
                    tryFinish();
                }, function () {
                    ctrl.digitalFormsMap = {};
                    digitalFormsDone = true;
                    tryFinish();
                });
            };

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_ITEMS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'asc']]).withOption('pageLength', 20);

            ctrl.change_inactive = function () {
                ctrl.tableData = [];
                for (var i in ctrl.data) {
                    if (ctrl.data[i].item_type != 'card' && ((ctrl.show_inactive && ctrl.data[i].inactive) || (!ctrl.show_inactive && !ctrl.data[i].inactive))) {
                        if (itemMatchesSearch(ctrl.data[i], ctrl.search_value) && itemMatchesFilter(ctrl.data[i])) {
                            ctrl.tableData.push(buildItemRow(ctrl.data[i]));
                        }
                    }
                }

                if ($('#items_dt').DataTable()) {
                }
            };

            ctrl.find_table = function() {
                ctrl.change_inactive();
            };

            ctrl.stockModal = function (item_id) {
                $uibModal.open({
                    templateUrl: "app/modules/settings/items/stock/items.stock.html",
                    controller: "ItemsStockController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal small-modal",
                    resolve: {
                        Item: function ($api, $stateParams, $rootScope) {
                            $rootScope.$stateParams = $stateParams;
                            return $api.resolve("items.single@get", {"id": item_id});
                        }
                    }
                }).result.then(function (val) {
                    $api.items_list.get(function(response){
                        if (response.data) {
                            parseItemsCategories(response.data);
                            ctrl.data = response.data;
                            ctrl.change_inactive();
                        }
                    });
                });
            };

            ctrl.drop = function(){
                if (ctrl.isSortingDisabled && ctrl.isSortingDisabled()) {
                    return;
                }
                var order = [];
                for(var i in ctrl.tableData) {
                  order.push(ctrl.tableData[i].id);
                }
                $api.items.save({ordering: order}, function(response){
                  if(response.status === "success"){
                  }
                });
            };

            ctrl.download_in_progress = false;
            /**
             * Download items data
             */
            ctrl.downloadItemsData = function () {
                var opts = $rootScope.items_page_data_options || {};

                var colIndex = opts.order;
                var orderDir = opts.order_dir ? opts.order_dir : '';
                var orderCol = '';

                if (colIndex != null && orderDir != '' && ctrl.dtColumns && ctrl.dtColumns[colIndex]) {
                    orderCol = ctrl.dtColumns[colIndex].name;
                }

                var filter = $rootScope.items_filter || {};

                ctrl.download_in_progress = true;
                $api.items.download.download(
                    {order: orderCol, order_dir: orderDir, search: ctrl.search_value, inactive: ctrl.show_inactive * 1, filter: filter}
                    , function success(response) {
                        ctrl.download_in_progress = false;

                        var blob = new Blob([response.data], { type: 'text/csv;charset=UTF-8' });

                        var cd = response.headers('Content-Disposition') ||
                                response.headers('content-disposition') ||
                                '';

                        var match = /filename="?([^"]+)"?/.exec(cd);
                        var filename = match && match[1] ? match[1] : 'items.csv';

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, filename);
                        } else {
                            var link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = filename;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    }, function error(err) {
                        ctrl.download_in_progress = false;
                        console.error('Download failed', err);
                    }
                );
            };

            ctrl.load();
        });
})();

(function() {

    angular.module("app.controllers").controller("ItemsFormController", function($scope, $state, $api, dates, Item, Items, Info, Categories, Resources, DigitalForms, $rootScope, $translate, $resource) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            duration: "",
            bg_color: "#a9cfe8",
            item_type: 'service',
            customer_allowed_booking: 0,
            inactive: 0,
            digital_form_once: 0,
            digital_form_hour: 1,
            require_online_payment: 0,
            online_payment_type: 1,
            online_payment_amount: '',
            digital_form_option: "order_start",
            general_info: '',
            specific_info: '',
            restriction: '',
            minimum_balance: '',
            availability: {}
        };
        ctrl.itemsSelectBoxConfig = {
            create: true,
            sortField: 'text'
        };

        ctrl.business = Info.data;
        
        ctrl.dates = dates;

        ctrl.dfs = DigitalForms.data || [];

        ctrl.resources = Resources.data;
        ctrl.durationOptions = normalizeDurationOptions(ctrl.dates.duration || []);
        ctrl.durationWithEmptyOptions = addEmptyDurationOption(ctrl.durationOptions, 'SETTINGS_ITEM_NOT_SET');
        ctrl.breakOptions = addEmptyDurationOption(ctrl.durationOptions, 'SETTINGS_ITEM_NO_BREAK');
        ctrl.categoryOptions = addEmptyOption(normalizeIdOptions(Categories.data || []), 'SETTINGS_ITEM_CAT_SEL');
        ctrl.customerAllowedBookingOptions = [
            {id: 0, name: $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO')},
            {id: 1, name: $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES')}
        ];
        ctrl.digitalFormOptions = addEmptyOption(normalizeIdOptions(ctrl.dfs), 'DIGITAL_FORM_SEND_DIGITAL_FORM', '0');
        ctrl.digitalFormOptionOptions = [
            {id: 'order_start', name: $translate.instant('DIGITAL_FORM_SEND_OPTION_1')},
            {id: 'order_end', name: $translate.instant('DIGITAL_FORM_SEND_OPTION_2')},
            {id: 'invoice', name: $translate.instant('DIGITAL_FORM_SEND_OPTION_3')}
        ];
        ctrl.serviceItemOptions = [];

        function normalizeIdOptions(options) {
            return (options || []).map(function(option) {
                var normalized = angular.copy(option);
                normalized.id = String(normalized.id);
                return normalized;
            });
        }

        function addEmptyOption(options, placeholderKey, emptyValue) {
            return [{id: emptyValue === undefined ? '' : emptyValue, name: $translate.instant(placeholderKey)}].concat(options || []);
        }

        function normalizeDurationOptions(options) {
            return (options || []).map(function(option) {
                return {
                    id: String(option.duration),
                    name: option.label
                };
            });
        }

        function addEmptyDurationOption(options, placeholderKey) {
            return [{id: '', name: $translate.instant(placeholderKey)}].concat(options || []);
        }

        function prepareServiceItemOptions() {
            ctrl.serviceItemOptions = [];

            angular.forEach(ctrl.items || [], function(item) {
                if (item.item_type == 'service') {
                    ctrl.serviceItemOptions.push({
                        id: String(item.id),
                        name: item.name + ' (' + item.originalPrice + ', ' + item.duration + ')'
                    });
                }
            });
        }

        var dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var weekdays = (typeof moment !== 'undefined' && moment.weekdays) ? moment.weekdays() : null;

        ctrl.availabilityDays = dayKeys.map(function (key, index) {
            var label;
            if (weekdays && weekdays[index]) {
                label = weekdays[index];
            } else if (ctrl.dates && ctrl.dates.daysNames && ctrl.dates.daysNames[index]) {
                label = ctrl.dates.daysNames[index];
            } else {
                label = key.charAt(0).toUpperCase() + key.slice(1);
            }

            return {
                key: key,
                label: label
            };
        });

        function createDefaultAvailability() {
            return {
                enabled: true,
                ranges: [{
                    from: "00:00",
                    to: "00:00"
                }]
            };
        }

        function normalizeAvailability() {
            ctrl.form.availability = ctrl.form.availability || {};
            ctrl.availabilityDays.forEach(function (day) {
                if (!ctrl.form.availability[day.key]) {
                    ctrl.form.availability[day.key] = createDefaultAvailability();
                } else {
                    // Migrate old format to new format
                    if (ctrl.form.availability[day.key].from !== undefined && !ctrl.form.availability[day.key].ranges) {
                        // Old format: {enabled: true, from: "00:00", to: "00:00"}
                        ctrl.form.availability[day.key] = {
                            enabled: !!ctrl.form.availability[day.key].enabled,
                            ranges: [{
                                from: ctrl.form.availability[day.key].from || "00:00",
                                to: ctrl.form.availability[day.key].to || "00:00"
                            }]
                        };
                    } else {
                        // New format or already migrated
                        ctrl.form.availability[day.key].enabled = !!ctrl.form.availability[day.key].enabled;
                        if (!ctrl.form.availability[day.key].ranges || !Array.isArray(ctrl.form.availability[day.key].ranges)) {
                            ctrl.form.availability[day.key].ranges = [{
                                from: "00:00",
                                to: "00:00"
                            }];
                        }
                        // Ensure all ranges have from and to
                        ctrl.form.availability[day.key].ranges = ctrl.form.availability[day.key].ranges.map(function(range) {
                            return {
                                from: range.from || "00:00",
                                to: range.to || "00:00"
                            };
                        });
                    }
                }
            });
        }

        ctrl.addAvailabilityRange = function(dayKey) {
            if (!ctrl.form.availability[dayKey].ranges) {
                ctrl.form.availability[dayKey].ranges = [];
            }
            ctrl.form.availability[dayKey].ranges.push({
                from: "00:00",
                to: "00:00"
            });
        };

        ctrl.removeAvailabilityRange = function(dayKey, index) {
            if (ctrl.form.availability[dayKey].ranges && ctrl.form.availability[dayKey].ranges.length > 1) {
                ctrl.form.availability[dayKey].ranges.splice(index, 1);
            }
        };

        $scope.isEdit = false;
        $scope.itemId = false;

        ctrl.show_stock = $rootScope.$user.show_stock;

        /**
         * Initialize edit data
         */
        if(Item != null) {
            $scope.isEdit = true;

            $scope.itemId = Item.data.id;

            if(Item.data.categories != null) {
                Item.data.categories = String(Item.data.categories).replace("{", "[").replace("}", "]");
                Item.data.categories = JSON.parse(Item.data.categories);
            }

            ctrl.form.name = Item.data.name;
            ctrl.form.name_second = Item.data.name_second ? Item.data.name_second : '';
            ctrl.form.description = Item.data.description ? Item.data.description : '';
            ctrl.form.minimum_balance = Item.data.minimum_balance ? parseInt(Item.data.minimum_balance, 10) : '';
            ctrl.form.general_info = Item.data.general_info ? Item.data.general_info : '';
            ctrl.form.specific_info = Item.data.specific_info ? Item.data.specific_info : '';
            ctrl.form.restriction = Item.data.restriction ? Item.data.restriction : '';
            ctrl.form.item_image = Item.data.item_image ? Item.data.item_image : '';
            ctrl.form.amount = Item.data.amount;
            ctrl.form.price = parseFloat(Item.data.price);
            ctrl.form.categories = Item.data.categories && Item.data.categories[0]?String(Item.data.categories[0]):'';
            ctrl.form.duration = String(Item.data.duration);
            ctrl.form.duration_second = Item.data.duration_second ? String(Item.data.duration_second) : 0;
            ctrl.form.break = Item.data.break ? String(Item.data.break) : 0;
            ctrl.form.item_id = Item.data.item_id;
            ctrl.form.bg_color = String(Item.data.bg_color);
            ctrl.form.item_type = Item.data.item_type;
            ctrl.form.customer_allowed_booking = parseInt(Item.data.customer_allowed_booking);
            ctrl.form.inactive = Item.data.inactive;
            ctrl.form.digital_form_once = Item.data.digital_form_once;
            ctrl.form.require_online_payment = Item.data.require_online_payment;
            ctrl.form.online_payment_type = parseInt(Item.data.online_payment_type);
            ctrl.form.online_payment_amount = parseFloat(Item.data.online_payment_amount);
            ctrl.form.digital_form = Item.data.digital_form ? String(Item.data.digital_form) : '0';
            ctrl.form.digital_form_hour = Item.data.digital_form_hour ? parseFloat(Item.data.digital_form_hour) : 0;
            ctrl.form.digital_form_option = Item.data.digital_form_option ? Item.data.digital_form_option : 'order_start';
            if (Item.data.availability) {
                if (typeof Item.data.availability === 'string') {
                    try {
                        ctrl.form.availability = JSON.parse(Item.data.availability);
                    } catch (error) {
                        ctrl.form.availability = {};
                    }
                } else {
                    ctrl.form.availability = angular.copy(Item.data.availability);
                }
            }

            Item.data.resources = Item.data.resources ? JSON.parse(Item.data.resources) : {};
            Item.data.resources_options = Item.data.resources_options ? JSON.parse(Item.data.resources_options) : {};
            
        }
        
        ctrl.form.resources = {};
        ctrl.form.resources_options = {};
        for (var i in ctrl.resources) {
            ctrl.form.resources[ctrl.resources[i].id] = (Item && Item.data && Item.data.resources && Item.data.resources[ctrl.resources[i].id] === false) ? false : true;
            ctrl.form.resources_options[ctrl.resources[i].id] = (Item && Item.data && Item.data.resources_options && Item.data.resources_options[ctrl.resources[i].id] && (Item.data.resources_options[ctrl.resources[i].id].price || Item.data.resources_options[ctrl.resources[i].id].duration)) ? angular.copy(Item.data.resources_options[ctrl.resources[i].id]) : {duration: '', price: ''};
        }

        normalizeAvailability();

        ctrl.isMobile = (angular.element(document).width() < 769);

        // Get list of existing Items
        Items.$promise.then(function () {
                ctrl.items = Items.data;
                for (var i in ctrl.items) {
                    ctrl.items[i].originalPrice = ctrl.items[i].price;
                    ctrl.items[i].price = parseFloat(parseFloat(ctrl.items[i].price).toFixed(2));
                    ctrl.items[i].quantity = 1;
                }
                prepareServiceItemOptions();
            },
            // Fail to get Items
            function () {
                ctrl.items = [];
                console.error("Get API Items failed");
            });

        $scope.categories = {};

        for(var i in Categories.data){
            $scope.categories[Categories.data[i].id] = Categories.data[i];
        }

        ctrl.submit = function(){
            ctrl.form.categories = [ctrl.form.categories];
            // ctrl.form.bg_color = $scope.colorConfig.selectedColor;
            if(Item == null)
                /**
                 * In case it's a new customer form
                 */
                $api.items.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_ITEMS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.items", {}, {reload: true});
                    } else if (response.status == "exist") {
                        swal({
                            title: $translate.instant('SWAL_ITEMS_SAVE_EXIST_TITLE'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        });
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.items.single.save({
                    id: Item.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_ITEMS_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.items", {id: Item.data.id}, {reload: true});
                    }
                });
        };

        /**
         * Triggers item delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_ITEMS_DELETE_CONFIRM_TEXT').replace('[name]', Item.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.items.single.delete({id: Item.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_ITEMS_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.items", {}, {reload: true});
                        } else if (response.status == "exist") {
                            swal({
                                title: $translate.instant('SWAL_ITEMS_DELETE_EXIST_TITLE'),
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
            });
        };

        // Handler for item selected event for Cards type
        ctrl.itemSelected = function(item_id) {
            //itemSelected(ctrl.form.item_id)
            ctrl.items.forEach(function (item) {
                if(item.id == item_id){
                    if(item.categories != null) {
                        item.categories = String(item.categories)
                            .replace("{", "[")
                            .replace("}", "]");
                        ctrl.form.categories = String(JSON.parse(item.categories));
                    }
                }
            })
        }


        ctrl.cardTypeSelected = function() {
            ctrl.form.categories = "";
        }

        // config for selectize (categories)
        $scope.userConfig = {
            create: true,
            sortField: 'text'
        };

        $scope.colorConfig = {
            customOptions: {
                size: 30,
                roundCorners: true
            },
            customColors: [
                "#a9cfe8",
                "#7bd148",
                "#5484ed",
                "#46d6db",
                "#7ae7bf",
                "#FF7F50",
                "#DDA0DD",
                "#FF6666"
            ],
            selectedColor: ctrl.form.bg_color
        };

        ctrl.openStockLog = function() {
            $scope.$close({item_id: Item.data.id});
            $state.transitionTo('app.settings.items.stock_log', {id: Item.data.id}, { reload: true });
        }

        ctrl.removeImage = function(type) {
            event.preventDefault();
            ctrl.form[type] = '';
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var reader = new FileReader();

            reader.onload = function(e) {
                var image =  document.createElement('img');
                image.src = e.target.result;
                image.onload = function() {
                    var fdata = new FormData();
                    fdata.append("image", element.files[0], new_file_name);
                    fdata.append("type", element.name);
                    
                    console.log(element.files[0]);
                    $resource($api.baseURL + '/Image/upload', {}, {
                        postWithFile: {
                            method: "POST",
                            params: fdata,
                            transformRequest: angular.identity,
                            headers: {'Content-Type': undefined}
                        }
                    }).postWithFile(fdata).$promise.then(function(response){
                        if (response.image) {
                            ctrl.form[element.name] = response.image;
                        }
                    }, function(error){
                        console.log(error);
                    });
                }
            }

            reader.readAsDataURL(element.files[0]);
        };
    });

})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("ManageResourcesController", function($scope, $uibModalInstance, $api, $translate, Account, Resources) {
        
        var ctrl = this;
        
        ctrl.account = Account;
        ctrl.saveLoading = false;
        ctrl.availableResources = Resources && Resources.data ? angular.copy(Resources.data) : [];
        ctrl.availableIncomeResources = Resources && Resources.data ? angular.copy(Resources.data) : [];
        ctrl.selectedResources = [];
        ctrl.selectedIncomeResources = [];
        ctrl.syncType = ctrl.account.sync_type || 'tiffulit_to_google';
        // Initialize resources with current sync status
        ctrl.availableResources.forEach(function(resource) {
            // Check if this resource is currently synced with this account
            resource.selected = ctrl.account.resources && ctrl.account.resources.some(function(accResource) {
                return accResource === resource.id;
            });
        });
        ctrl.availableIncomeResources.forEach(function(resource) {
            resource.selected = ctrl.account.income_resources && ctrl.account.income_resources.some(function(accResource) {
                return accResource === resource.id;
            });
        });
        
        /**
         * Update selected resources
         */
        ctrl.updateSelectedResources = function() {
            ctrl.selectedResources = ctrl.availableResources.filter(function(resource) {
                return resource.selected;
            });
        };

        /**
         * Update selected income resources
         */
        ctrl.updateSelectedIncomeResources = function() {
            ctrl.selectedIncomeResources = ctrl.availableIncomeResources.filter(function(resource) {
                return resource.selected;
            });
        };

        // Update selected resources count
        ctrl.updateSelectedResources();
        ctrl.updateSelectedIncomeResources();
        
        /**
         * Save resources configuration
         */
        ctrl.saveResources = function() {
            ctrl.saveLoading = true;
            
            var resourcesData = {
                resources: ctrl.selectedResources.map(function(resource) {
                    return resource.id;
                }),
                income_resources: ctrl.selectedIncomeResources.map(function(resource) {
                    return resource.id;
                }),
                sync_type: ctrl.syncType
            };
            
            $api.googlecalendar.resources.save({
                id: ctrl.account.id
            }, resourcesData, function(response) {
                ctrl.saveLoading = false;
                
                if (response.success) {
                    swal({
                        title: $translate.instant('RESOURCES_SAVED_SUCCESS'),
                        text: $translate.instant('RESOURCES_SAVED_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    }).then(function() {
                        $uibModalInstance.close(ctrl.account);
                    });
                } else {
                    swal({
                        title: $translate.instant('RESOURCES_SAVE_ERROR'),
                        text: response.message || $translate.instant('RESOURCES_SAVE_ERROR_DESCRIPTION'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }
            }, function(error) {
                ctrl.saveLoading = false;
                console.error('Resources save error:', error);
                
                swal({
                    title: $translate.instant('RESOURCES_SAVE_ERROR'),
                    text: $translate.instant('RESOURCES_SAVE_ERROR_DESCRIPTION'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };


        /**
         * Disconnect account (uses remove_all by default, or equivalent for other sync types)
         */
        ctrl.disconnectAccount = function() {
            swal({
                title: $translate.instant('DISCONNECT_ACCOUNT_CONFIRM_TITLE'),
                text: $translate.instant('DISCONNECT_ACCOUNT_CONFIRM_TEXT').replace('[email]', ctrl.account.email),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('DISCONNECT'),
                cancelButtonText: $translate.instant('CANCEL'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result.value) {
                    var disconnectOption = ctrl.syncType === 'both' ? 'remove_all' :
                        ctrl.syncType === 'google_to_tiffulit' ? 'remove_google_from_tiffulit' :
                        ctrl.syncType === 'tiffulit_to_google' ? 'remove_tiffulit_from_google' : 'keep';
                    ctrl.performDisconnect(disconnectOption);
                }
            });
        };

        ctrl.performDisconnect = function(disconnectOption) {
            var deleteParams = {
                id: ctrl.account.id,
                remove_google_events: 0,
                remove_tiffulit_events: 0
            };

            if (disconnectOption === 'remove_google_from_tiffulit') {
                deleteParams.remove_tiffulit_events = 1;
            }

            if (disconnectOption === 'remove_tiffulit_from_google') {
                deleteParams.remove_google_events = 1;
            }

            if (disconnectOption === 'remove_all') {
                deleteParams.remove_tiffulit_events = 1;
                deleteParams.remove_google_events = 1;
            }
            
            $api.googlecalendar.single.delete(deleteParams, function(response) {
                if (response.success) {
                    swal({
                        title: $translate.instant('SUCCESS'),
                        text: $translate.instant('ACCOUNT_DISCONNECTED'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $uibModalInstance.close(ctrl.account);
                }
            }, function(error) {
                var errorMessage = $translate.instant('ACCOUNT_DISCONNECT_ERROR');
                if (error && error.data && typeof error.data === 'string' && error.data.includes('<div')) {
                    errorMessage = $translate.instant('API_ENDPOINT_NOT_AVAILABLE');
                }

                swal({
                    title: $translate.instant('ERROR'),
                    text: errorMessage,
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };
    });

})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("ConnectAccountController", function($scope, $uibModalInstance, $api, $translate, Resources, GoogleCalendarAccounts, GoogleCalendarService) {
        
        var ctrl = this;
        
        ctrl.authLoading = false;
        ctrl.authSuccess = false;
        ctrl.saveLoading = false;
        ctrl.availableResources = Resources && Resources.data ? angular.copy(Resources.data) : [];
        ctrl.availableIncomeResources = Resources && Resources.data ? angular.copy(Resources.data) : [];
        ctrl.googleCalendarAccounts = GoogleCalendarAccounts && GoogleCalendarAccounts.data ? GoogleCalendarAccounts.data : [];
        ctrl.selectedResources = [];
        ctrl.selectedIncomeResources = [];
        ctrl.googleAccount = null;
        ctrl.syncType = 'tiffulit_to_google';
        
        // Initialize resources with selection state
        ctrl.availableResources.forEach(function(resource) {
            resource.selected = false;
        });
        ctrl.availableIncomeResources.forEach(function(resource) {
            resource.selected = false;
        });
        /**
         * Authenticate with Google
         */
        ctrl.authenticateWithGoogle = function() {
            ctrl.authLoading = true;
            
            // Check if user is already signed in and token is valid
            if (GoogleCalendarService.isSignedIn()) {
                // Try to get user info with existing token
                GoogleCalendarService.checkAndRefreshToken().then(function(tokenResponse) {
                    // If we have a valid token, try to get user info
                    return GoogleCalendarService.getUserInfo();
                }).then(function(userInfo) {
                    ctrl.authLoading = false;
                    ctrl.authSuccess = true;
                    ctrl.googleAccount = {
                        id: userInfo.getId(),
                        email: userInfo.getEmail(),
                        name: userInfo.getName(),
                        picture: userInfo.getImageUrl()
                    };
                    swal({
                        title: $translate.instant('GOOGLE_AUTH_SUCCESS'),
                        text: $translate.instant('GOOGLE_AUTH_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error) {
                    // If existing token fails, proceed with fresh authentication
                    performFreshAuthentication();
                });
            } else {
                // No valid token, proceed with fresh authentication
                performFreshAuthentication();
            }
            
            function performFreshAuthentication() {
                // Initialize and sign in via Google Identity Services
                GoogleCalendarService.initialize().then(function(){
                    return GoogleCalendarService.signIn();
                }).then(function(result){
                    ctrl.authLoading = false;
                    ctrl.authSuccess = true;
                    // Normalize user data for backend save

                    var existingAccount = ctrl.googleCalendarAccounts.find(function(account) {
                        return account.google_account_id === result.user.getId();
                    });

                    if (existingAccount) {
                        ctrl.authSuccess = false;
                        GoogleCalendarService.signOut();
                        swal({
                            title: $translate.instant('GOOGLE_AUTH_ERROR'),
                            text: $translate.instant('GOOGLE_AUTH_ALREADY_CONNECTED'),
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                        });
                        return;
                    }

                    // Get the token response directly from the service
                    var tokenResponse = window.googleTokenResponse;
                    
                    ctrl.googleAccount = {
                        id: result.user.getId(),
                        email: result.user.getEmail(),
                        name: result.user.getName(),
                        picture: result.user.getImageUrl(),
                        access_token: tokenResponse.access_token,
                        refresh_token: tokenResponse.refresh_token,
                        token_expires_at: tokenResponse.expires_in ? new Date(Date.now() + tokenResponse.expires_in * 1000).toISOString() : null,
                    };
                    
                    swal({
                        title: $translate.instant('GOOGLE_AUTH_SUCCESS'),
                        text: $translate.instant('GOOGLE_AUTH_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error){
                    ctrl.authLoading = false;
                    console.error('Google authentication error:', error);
                    var errorText = (typeof error === 'string') ? error : (error && error.message) ? error.message : $translate.instant('GOOGLE_AUTH_ERROR_DESCRIPTION');
                    
                    // Handle specific error types
                    if (errorText && errorText.includes('Token expired')) {
                        errorText = 'Your Google session has expired. Please try again.';
                    } else if (errorText && errorText.includes('popup_closed')) {
                        errorText = 'Sign-in was cancelled. Please try again.';
                    } else if (errorText && errorText.includes('access_denied')) {
                        errorText = 'Access was denied. Please make sure to grant all required permissions.';
                    } else if (errorText && errorText.includes('popup_blocked')) {
                        errorText = 'Popup was blocked by your browser. Please allow popups for this site and try again.';
                    }
                    
                    swal({
                        title: $translate.instant('GOOGLE_AUTH_ERROR'),
                        text: errorText,
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            }
        };
        
        /**
         * Update selected resources
         */
        ctrl.updateSelectedResources = function() {
            ctrl.selectedResources = ctrl.availableResources.filter(function(resource) {
                return resource.selected;
            });
        };

        /**
         * Update selected income resources
         */
        ctrl.updateSelectedIncomeResources = function() {
            ctrl.selectedIncomeResources = ctrl.availableIncomeResources.filter(function(resource) {
                return resource.selected;
            });
        };
        
        /**
         * Save account with selected resources
         */
        ctrl.saveAccount = function() {
            if (((ctrl.syncType === 'tiffulit_to_google' || ctrl.syncType === 'both') && ctrl.selectedResources.length === 0) ||
                ((ctrl.syncType === 'google_to_tiffulit' || ctrl.syncType === 'both') && ctrl.selectedIncomeResources.length === 0)) {
                swal({
                    title: $translate.instant('NO_RESOURCES_SELECTED'),
                    text: $translate.instant('NO_RESOURCES_SELECTED_DESCRIPTION'),
                    type: "warning",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                return;
            }
            
            ctrl.saveLoading = true;
            
            var accountData = {
                google_account_id: ctrl.googleAccount.id,
                email: ctrl.googleAccount.email,
                name: ctrl.googleAccount.name,
                avatar_url: ctrl.googleAccount.picture,
                access_token: ctrl.googleAccount.access_token,
                refresh_token: ctrl.googleAccount.refresh_token,
                token_expires_at: new Date(ctrl.googleAccount.token_expires_at).toISOString(),
                is_active: true,
                sync_type: ctrl.syncType,
                resources: ctrl.selectedResources.map(function(resource) {
                    return resource.id;
                }),
                income_resources: ctrl.selectedIncomeResources.map(function(resource) {
                    return resource.id;
                }),
            };
            
            $api.googlecalendar.save(accountData, function(response) {
                ctrl.saveLoading = false;
                
                if (response.success) {
                    swal({
                        title: $translate.instant('ACCOUNT_SAVED_SUCCESS'),
                        text: $translate.instant('ACCOUNT_SAVED_SUCCESS_DESCRIPTION'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 5000
                    }).then(function() {
                        $uibModalInstance.close(response.account);
                    });
                } else {
                    swal({
                        title: $translate.instant('ACCOUNT_SAVE_ERROR'),
                        text: response.message || $translate.instant('ACCOUNT_SAVE_ERROR_DESCRIPTION'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }
            }, function(error) {
                ctrl.saveLoading = false;
                console.error('Account save error:', error);
                
                swal({
                    title: $translate.instant('ACCOUNT_SAVE_ERROR'),
                    text: $translate.instant('ACCOUNT_SAVE_ERROR_DESCRIPTION'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };
    });

})();

(function () {
  angular.module('app.controllers')
    .controller('GiftCardsTemplatesSettingsController', function ($rootScope, GiftCardsTemplates) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;

      ctrl.templates = [];

      for (var i in GiftCardsTemplates.data) {
        ctrl.templates.push(GiftCardsTemplates.data[i]);
      }
    });
})();

(function () {
  angular.module('app.controllers').controller('GiftCardsTemplateSettingsController', function ($state, $rootScope, $api, $scope, $resource, $translate, GiftCardsTemplate, Info) {
    if ($rootScope.userRole === 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;

    ctrl.settings = {
      name: '',
      page_bg_color: '#EEF3FC',
      card_bg_color: '#ffffff',
      primary_color: '#275A7B',
      text_color: '#1A202C',
      logo: '/assets/images/gift-card-logo.png',
      image: '/assets/images/gift-card-image.png',
      receiver: true,
      sender: true,
      service: true,
      value: true,
      message: true,
    };

    ctrl.isEdit = false;

    if (GiftCardsTemplate != null) {
      ctrl.settings = angular.extend({}, ctrl.settings, GiftCardsTemplate.data);
      ctrl.isEdit = true;
    }

    ctrl.values = {
      number: $translate.instant('DEFAULT_GIFT_CARD_NUMBER'),
      business: $translate.instant('DEFAULT_GIFT_CARD_BUSINESS'),
      address: $translate.instant('DEFAULT_GIFT_CARD_ADDRESS'),
      service: $translate.instant('DEFAULT_GIFT_CARD_SERVICE'),
      receiver: $translate.instant('DEFAULT_GIFT_CARD_RECEIVER'),
      value: $translate.instant('DEFAULT_GIFT_CARD_VALUE'),
      message: $translate.instant('DEFAULT_GIFT_CARD_MESSAGE'),
      sender: $translate.instant('DEFAULT_GIFT_CARD_SENDER'),
    };

    if (Info) {
      ctrl.values.business = Info.data.name || ctrl.values.business;
      ctrl.values.address = Info.data.address || ctrl.values.address;
    }

    ctrl.bumpSettings = function() {
      ctrl.settings = angular.extend({}, ctrl.settings);
    };

    ctrl.resetColors = function() {
      ctrl.settings = {
        page_bg_color: '#EEF3FC',
        card_bg_color: '#ffffff',
        primary_color: '#275A7B',
        text_color: '#1A202C',
        logo: ctrl.settings.logo || '/assets/images/gift-card-logo.png',
        image: ctrl.settings.image || '/assets/images/gift-card-image.png',
        receiver: ctrl.settings.receiver || true,
        sender: ctrl.settings.sender || true,
        service: ctrl.settings.service || true,
        value: ctrl.settings.value || true,
        message: ctrl.settings.message || true,
      };

      ctrl.bumpSettings();
    };

    ctrl.getFilename = function (path) {
      var MAX = 28;

      if (!path || path == '') {
        return $translate.instant('GIFT_CARD_IMAGE_PLACEHOLDER');
      }

      var filename = String(path).split(/[\\/]/).pop();

      if (filename.length <= MAX) {
        return filename;
      }
      
      var dot = filename.lastIndexOf('.');
      var name = (dot > 0) ? filename.slice(0, dot) : filename;
      var ext = (dot > 0) ? filename.slice(dot) : '';

      var endPart = name.slice(-1) + ext;
      var roomForStart = MAX - endPart.length - 3;

      if (roomForStart < 1) {
        return '...' + endPart.slice(-(MAX - 3));
      }

      var startPart = name.slice(0, roomForStart);
      return startPart + '...' + endPart;
    };

    ctrl.removeImage = function (type, $event) {
      if ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }

      ctrl.settings[type] = '';
      ctrl.bumpSettings();
    };

    $scope.uploadImage = function (element) {
      var new_file_name = 'gift_card_' + element.name;
      new_file_name += '_' + Date.now() + '.' + element.files[0].name.split('.').pop();

      var fdata = new FormData();
      fdata.append("image", element.files[0], new_file_name);
      fdata.append("type", element.name);

      $resource($api.baseURL + '/Image/upload', {}, {
        postWithFile: {
          method: "POST",
          params: fdata,
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        }
      }).postWithFile(fdata).$promise.then(function (response) {
        ctrl.settings[element.name] = response.image;
        ctrl.bumpSettings();
      }, function (error) {
        console.log(error);
      });
    };

    ctrl.saveTemplate = function () {
      if (GiftCardsTemplate == null) {
        $api.giftCardTemplate.save(ctrl.settings, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.settings.gift_cards.templates", {}, { reload: true });
          }
        });
      } else {
        $api.giftCardTemplate.single.save({ id: GiftCardsTemplate.data.id }, ctrl.settings, function (response) {
          if (response.success) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_SAVE_EDIT_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
            $state.transitionTo("app.settings.gift_cards.templates", { id: GiftCardsTemplate.data.id }, { reload: true });
          }
        });
      }
    };

    ctrl.delete = function () {
      swal({
        title: "",
        text: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_DELETE_CONFIRM_TEXT'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
        confirmButtonClass: "btn-danger",
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value)
          $api.giftCardTemplate.single.delete({ id: GiftCardsTemplate.data.id }, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_GIFT_CARDS_TEMPLATE_DELETE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.gift_cards.templates", {}, { reload: true });
            }
          });
      });
    };
  });
})();

(function () {
  angular.module('app.controllers').controller('GiftCardsSingleSettingsController', function ($scope, $rootScope, $api, $translate, GiftCard, Info, Transactions, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal) {
    if ($rootScope.userRole === 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;

    ctrl.settings = {};
    ctrl.values = {};
    ctrl.balance = 0;
    ctrl.transactions = angular.copy(Transactions.data || []);
    ctrl.tableData = ctrl.transactions;

    if (GiftCard) {
      ctrl.settings.page_bg_color = GiftCard.data.page_bg_color;
      ctrl.settings.card_bg_color = GiftCard.data.card_bg_color;
      ctrl.settings.primary_color = GiftCard.data.primary_color;
      ctrl.settings.text_color = GiftCard.data.text_color;
      ctrl.settings.logo = GiftCard.data.logo;
      ctrl.settings.image = GiftCard.data.image;
      ctrl.settings.sender = GiftCard.data.sender;
      ctrl.settings.receiver = GiftCard.data.receiver;
      ctrl.settings.value = GiftCard.data.value;
      ctrl.settings.service = GiftCard.data.service;
      ctrl.settings.message = GiftCard.data.message;
      ctrl.settings.name = GiftCard.data.name;

      ctrl.values.number = GiftCard.data.number;
      ctrl.values.sender = GiftCard.data.sender_text;
      ctrl.values.receiver = GiftCard.data.gifted_to;
      ctrl.values.value = GiftCard.data.price;
      ctrl.values.service = GiftCard.data.service_text;
      ctrl.values.message = GiftCard.data.message_text;

      ctrl.balance = GiftCard.data.balance;
    }

    if (Info) {
      var address = [];
      if (Info.data.city) {
        address.push(Info.data.city);
      }
      if (Info.data.address) {
        address.push(Info.data.address);
      }
      if (Info.data.home_number) {
        address.push(Info.data.home_number);
      }
      
      ctrl.values.business = Info.data.name;
      ctrl.values.address = address.join(', ');
    }

    ctrl.changeBalanceModal = function () {
      $uibModal.open({
        templateUrl: "app/modules/settings/gift_cards/popup/balance.view.html",
        controller: "GiftCardsBalanceController",
        controllerAs: "ctrl",
        scope: $scope,
        windowTopClass: "form-modal small-modal",
        resolve: {
          GiftCard: [function () {
            return GiftCard.data;
          }],
        }
      }).result.then(function (response) {
        if (response) {
          var normalizedBalance = parseFloat(String(response.balance).replace(',', '.'));

          if (!isFinite(normalizedBalance)) {
            swal({
              title: $translate.instant('SWAL_GIFT_CARD_BALANCE_ERROR_TITLE'),
              text: $translate.instant('GIFT_CARD_BALANCE'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
            });
            return;
          }

          $api.giftCard.balance.save({ id: response.id }, { balance: normalizedBalance }, function (res) {
            if (res.success) {
              swal({
                title: $translate.instant('SWAL_GIFT_CARDS_BALANCE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });

              ctrl.balance = normalizedBalance;
              ctrl.loadTransactions();
            }
          });
        }
      });
    };

    ctrl.loadTransactions = function () {
      $api.giftCard.transactions.single.get({ id: GiftCard.data.id }, function (res) {
        ctrl.transactions = angular.copy(res.data || []);
        ctrl.tableData = ctrl.transactions;
      });
    };

    /**
     * Datatable configuration
     */
    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('order', [[0, 'asc']])
      .withOption('pageLength', 20);

  });
})();

(function () {
  angular.module('app.controllers').controller('GiftCardsListSettingsController', function ($scope, $rootScope, GiftCards, DTOptionsBuilder, dataTablesHebrewProvider) {
    if ($rootScope.userRole === 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.showUsed = false;

    ctrl.giftCards = angular.copy(GiftCards.data || []);
    ctrl.tableData = [];

    function isUsed(card) {
      return !!(card.used === true || card.used === 1 || card.used === '1' || card.used === 'true');
    }

    ctrl.applyFilters = function () {
      ctrl.tableData = ctrl.giftCards.filter(function (el) {
        return ctrl.showUsed ? isUsed(el) : !isUsed(el);
      });
    };

    ctrl.changeUsed = function () {
      ctrl.applyFilters();
    };

    ctrl.applyFilters();

    /**
     * Datatable configuration
     */
    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('order', [[0, 'asc']])
      .withOption('pageLength', 20);
  });
})();

(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsTemplatesController', function(TemplatesList, $state, $header, $api, $scope, $uibModalInstance, $window, $sce, $translate) {
  
            var ctrl = this;
            ctrl.list = TemplatesList.list;
        
            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.createForm = function(form) {
                form.fields = JSON.parse(form.fields);
                
                $api.digital_forms.save(form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                    }
                });
            }
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsPreviewController', function(DForm, $header, $api, $scope, $uibModalInstance, $window, $sce, $translate) {
  
            var ctrl = this;
            
            $scope.DigitalForm = DForm.data;
            $scope.business = DForm.data.business;
            $scope.DigitalForm.data = DForm.data && DForm.data.data ? JSON.parse(DForm.data.data) : [];
            $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';

            if ($scope.DigitalForm.data) {
                for (var i in $scope.DigitalForm.data) {
                    if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                        $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                    }
                }
            }
            
        
            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            ctrl.back = function() {
                $window.history.back();
            };
           
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsListController', function (DigitalForms, $state, $api, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;
            ctrl.df_templates = [];

            ctrl.refreshList = function() {
                $api.resolve("digital_forms@get").then(function(response) {
                    var data = response.data || [];
                    if (DigitalForms) DigitalForms.data = data;
                    ctrl.tableData = ctrl.search_value ? filterData(data, ctrl.search_value) : data;
                });
            };

            var filterData = function(data, searchVal) {
                if (!searchVal) return data;
                var newData = [];
                for (var i in data) {
                    var found = false;
                    for (var k in data[i]) {
                        if (data[i][k] && data[i][k].toString().toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
                            found = true;
                            break;
                        }
                    }
                    if (found) newData.push(data[i]);
                }
                return newData;
            };

            ctrl.tableData = DigitalForms && DigitalForms.data ? DigitalForms.data : [];

            $scope.$on('digitalForms:updated', function() {
                ctrl.refreshList();
            });

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_DIGITAL_FORMS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('id', [[0, 'desc']]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                var sourceData = DigitalForms && DigitalForms.data ? DigitalForms.data : [];
                ctrl.tableData = ctrl.search_value ? filterData(sourceData, ctrl.search_value) : sourceData;
            }
        });
})();

(function() {

    angular.module("app.controllers").controller("DigitalFormsFormController", function($scope, $state, $api, $resource, dates, DigitalForm, DigitalForms, PhotosStock, isDuplicate, $rootScope, $translate, $timeout, $tiff_page, $minimizableModal) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        
        ctrl.master_business = $rootScope.$user && $rootScope.$user.dealer_name == 'MASTER_BUSINESS' ? true : false;
        ctrl.minimizedStateName = $state.current.name;

        ctrl.form = {
            name: '',
            text_form: false,
            text: '',
            logo: '',
            hide_logo: false,
            locked: false,
            fields: [
                {
                    name: '',
                    type: 'input',//input, textarea, radio, checkbox, select, date, comment, signature, text, business_signature, map
                    items: [],
                    require: false,
                    other: false,
                    other_name: '',
                }
            ],
        };

        ctrl.mapOptions = PhotosStock && PhotosStock.data ? PhotosStock.data : [];
        ctrl.fieldTypeOptions = [
            {
                value: 'input',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_INPUT')
            },
            {
                value: 'textarea',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_TEXTAREA')
            },
            {
                value: 'radio',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_RADIO')
            },
            {
                value: 'checkbox',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_CHECKBOX')
            },
            {
                value: 'select',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_SELECT')
            },
            {
                value: 'date',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_DATE')
            },
            {
                value: 'comment',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_COMMENT')
            },
            {
                value: 'signature',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_SIGNATURE')
            },
            {
                value: 'text',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_TEXT')
            },
            {
                value: 'business_signature',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_BUSINESS_SIGNATURE')
            },
            {
                value: 'map',
                name: $translate.instant('SETTINGS_DIGITAL_FORM_FIELD_TYPE_MAP')
            }
        ];
        
        $scope.isEdit = false;
        $scope.sortableOptions = { handle: '.drag-handle' };

        /**
         * Initialize edit or duplicate data
         */
        if (DigitalForm && DigitalForm._minimizedFormData) {
            $scope.isEdit = DigitalForm._minimizedIsEdit;
            $scope.isDuplicate = DigitalForm._minimizedIsDuplicate;
            ctrl.form = angular.copy(DigitalForm._minimizedFormData);
        } else if (DigitalForms && DigitalForms._minimizedFormData) {
            $scope.isEdit = DigitalForms._minimizedIsEdit;
            $scope.isDuplicate = DigitalForms._minimizedIsDuplicate;
            ctrl.form = angular.copy(DigitalForms._minimizedFormData);
        } else if(DigitalForm != null && DigitalForm.data) {
            $scope.isEdit = !isDuplicate;
            $scope.isDuplicate = isDuplicate;
            ctrl.form.name = isDuplicate ? '' : DigitalForm.data.name;
            ctrl.form.logo = DigitalForm.data.logo;
            ctrl.form.hide_logo = DigitalForm.data.hide_logo;
            ctrl.form.locked = DigitalForm.data.locked;
            ctrl.form.text_form = DigitalForm.data.text_form;
            ctrl.form.text = DigitalForm.data.text;
            ctrl.form.fields = JSON.parse(DigitalForm.data.fields);
        }
        ctrl.isMobile = (angular.element(document).width() < 769);

        ctrl.minimize = function($event) {
            if ($event) {
                $event.stopPropagation();
            }

            if (DigitalForm) {
                DigitalForm._minimizedFormData = angular.copy(ctrl.form);
                DigitalForm._minimizedIsEdit = $scope.isEdit;
                DigitalForm._minimizedIsDuplicate = $scope.isDuplicate;
            } else if (DigitalForms) {
                DigitalForms._minimizedFormData = angular.copy(ctrl.form);
                DigitalForms._minimizedIsEdit = $scope.isEdit;
                DigitalForms._minimizedIsDuplicate = $scope.isDuplicate;
            }

            $minimizableModal.minimize({
                title: ctrl.form && ctrl.form.name ? ctrl.form.name : $translate.instant('SETTINGS_DIGITAL_FORM_NEW'),
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html",
                controller: "DigitalFormsFormController",
                resolve: {
                    DigitalForm: DigitalForm,
                    isDuplicate: isDuplicate,
                    DigitalForms: DigitalForms,
                    PhotosStock: PhotosStock
                }
            }, function(reason) {
                $scope.$dismiss(reason);
            });
        };

        ctrl.restore = function($event) {
            if ($event) {
                $event.stopPropagation();
            }

            $minimizableModal.restore();
        };

        DigitalForms.$promise.then(function () {
                ctrl.digital_forms = DigitalForms.data;
                for (var i in ctrl.digital_forms) {
                }
            },
            function () {
                ctrl.digital_forms = [];
            });

        ctrl.checkRequiredFields = function() {
            var check = true;
            for (var i in ctrl.form.fields) {
                if (ctrl.form.fields[i].require && (ctrl.form.fields[i].type == 'checkbox' || ctrl.form.fields[i].type == 'radio' || ctrl.form.fields[i].type == 'select') && (!ctrl.form.fields[i].items || !ctrl.form.fields[i].items.length)) {
                    check = false;
                    break
                }
            }

            return check;
        }

        ctrl.onChangeType = function(index, type) {
            if (type == 'input' || type == 'textarea' || type == 'date') {
                ctrl.form.fields[index].items = [];
            }
        }

        ctrl.onAddItem = function(index) {
            if (ctrl.form.fields[index]) {
                var value = 0;
                for (var i in ctrl.form.fields[index].items) {
                    if (value <= ctrl.form.fields[index].items[i].value) {
                        value = ctrl.form.fields[index].items[i].value + 1
                    }
                }
                ctrl.form.fields[index].items.push(
                    {
                        value: value,
                        name: '',
                    }
                );
            }
        }

        ctrl.onRemoveItem = function(index, i) {
            if (ctrl.form.fields[index]) {
                ctrl.form.fields[index].items.splice(i, 1);
            }
        }

        ctrl.onAddField = function() {
            ctrl.form.fields.push(
                {
                    name: '',
                    type: 'input',
                    items: [],
                    require: false,
                    other: false,
                    other_name: '',
                }
            )
        }

        ctrl.onRemoveField = function(index) {
            ctrl.form.fields.splice(index, 1);
        }

        ctrl.submit = function(){
            if(DigitalForm == null || isDuplicate)
                /**
                 * In case it's a new customer form
                 */
                $api.digital_forms.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $rootScope.$broadcast('digitalForms:updated');
                        $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                        $scope.$close();
                    } else if (response.status == "exist") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_EXIST_TITLE'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        });
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.digital_forms.single.save({
                    id: DigitalForm.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DD_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $rootScope.$broadcast('digitalForms:updated');
                        $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                        $scope.$close();
                    }
                });
        };

        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_DD_DELETE_CONFIRM_TEXT').replace('[name]', DigitalForm.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.digital_forms.single.delete({id: DigitalForm.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_DD_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $rootScope.$broadcast('digitalForms:updated');
                            $state.transitionTo("app.settings.digital_forms", {}, {reload: true});
                        } else if (response.status == "exist") {
                            swal({
                                title: $translate.instant('SWAL_DD_DELETE_EXIST_TITLE'),
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
            });
        };

        ctrl.removeImage = function(type) {
            event.preventDefault();
            ctrl.form[type] = '';
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var reader = new FileReader();

            reader.onload = function(e) {
                var image =  document.createElement('img');
                image.src = e.target.result;
                image.onload = function() {
                    var fdata = new FormData();
                    fdata.append("image", element.files[0], new_file_name);
                    fdata.append("type", element.name);
                    
                    $resource($api.baseURL + '/Image/upload', {}, {
                        postWithFile: {
                            method: "POST",
                            params: fdata,
                            transformRequest: angular.identity,
                            headers: {'Content-Type': undefined}
                        }
                    }).postWithFile(fdata).$promise.then(function(response){
                        if (response.image) {
                            ctrl.form[element.name] = response.image;
                        }
                    }, function(error){
                        console.log(error);
                    });
                }
            }

            reader.readAsDataURL(element.files[0]);
        };


        ctrl.showImage = function($event, image) {
            $event.stopPropagation();
            $event.preventDefault();
            swal({
                imageUrl: image,
                imageWidth: 800,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: $translate.instant('CALL_CANCEL'),
            })
    
        }

        ctrl.removeImage = function($event, index) {
            $event.stopPropagation();
            $event.preventDefault();
            ctrl.form.fields[index].image = '';
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();
            var index = $(element).data('index');
            console.log(index);

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            $tiff_page.start_loading('save_image');
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form.fields[index].image = response.image;
                $tiff_page.stop_loading('save_image');
            }, function(error){
                $tiff_page.stop_loading('save_image');
                console.log(error);
            });
        };
    });

})();

(function () {
  angular.module("app.controllers")
    .controller("CustomFieldsSingleSettingsController", function ($scope, $state, $header, $customFields, CustomField, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.title = CustomField && CustomField.data && CustomField.data.name ? $customFields.getCurrentName(CustomField.data.name) : '';
      ctrl.tableData = CustomField && CustomField.data && CustomField.data.values ? CustomField.data.values.filter(function(item) { return item.active === true; }) : [];
      ctrl.search_value = '';

      $header.breadcrumbs.push({
        "title": "SETTINGS_CUSTOM_FIELDS"
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withOption('searching', false)
        .withLanguage(dataTablesHebrewProvider)
        .withOption('order', [[0, 'desc']]);

      ctrl.find_table = function () {
        if (!ctrl.originalTableData) {
          ctrl.originalTableData = angular.copy(ctrl.tableData);
        }

        var newData = [];
        var searchValue = ctrl.search_value ? ctrl.search_value.toLowerCase() : '';

        if (!searchValue) {
          ctrl.tableData = angular.copy(ctrl.originalTableData);
          return;
        }

        for (var i = 0; i < ctrl.originalTableData.length; i++) {
          var found = false;
          for (var key in ctrl.originalTableData[i]) {
            if (
              ctrl.originalTableData[i][key] &&
              ctrl.originalTableData[i][key].toString().toLowerCase().indexOf(searchValue) > -1
            ) {
              found = true;
              break;
            }
          }
          
          if (found) {
            newData.push(ctrl.originalTableData[i]);
          }
        }

        ctrl.tableData = newData;
      }
    });
})();

(function () {
  angular.module("app.controllers")
    .controller("CustomFieldsFormSettingsController", function ($stateParams, $state, $api, CustomFieldValue, $rootScope, $translate) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.isEdit = false;
      ctrl.listId = $stateParams.id;

      ctrl.form = {
        value: '',
        position: 0,
        active: true,
      };

      if (CustomFieldValue != null) {
        ctrl.isEdit = true;
        ctrl.form = {
          value: CustomFieldValue.data.value,
          position: CustomFieldValue.data.position,
          active: CustomFieldValue.data.active,
        }
      }

      ctrl.submit = function () {
        if (CustomFieldValue == null) {
          $api.customFields.value.add.save({id: ctrl.listId}, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_SAVE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.custom_fields.single", {id: ctrl.listId}, { reload: true });
            }
          });
        } else {
          $api.customFields.value.update.save({
            id: ctrl.listId,
            vid: CustomFieldValue.data.id
          }, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_UPDATE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.custom_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
            }
          });
        }
      };

      ctrl.delete = function () {
        swal({
          title: "",
          text: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_DELETE_CONFIRM_TEXT').replace('[value]', CustomFieldValue.data.value),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value)
            $api.customFields.value.remove.delete({
              id: ctrl.listId,
              vid: CustomFieldValue.data.id
            }, function (response) {
              if (response.success) {
                swal({
                  title: $translate.instant('SWAL_CUSTOM_FIELDS_VALUE_DELETE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.settings.custom_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
              }
            });
        });
      };
    });
})();

(function () {
  angular.module("app.controllers")
    .controller("CoursesFieldsSingleSettingsController", function ($scope, $state, $header, CoursesField, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.title = CoursesField && CoursesField.data ? CoursesField.data.name : '';
      ctrl.tableData = CoursesField && CoursesField.data && CoursesField.data.values ? CoursesField.data.values : [];
      ctrl.search_value = '';

      $header.breadcrumbs.push({
        "title": "SETTINGS_COURSES_FIELDS"
      });

      $scope.dtOptions = DTOptionsBuilder
        .newOptions()
        .withDOM('Tfgtip')
        .withOption('searching', false)
        .withLanguage(dataTablesHebrewProvider)
        .withOption('order', [[0, 'desc']]);

      ctrl.find_table = function () {
        if (!ctrl.originalTableData) {
          ctrl.originalTableData = angular.copy(ctrl.tableData);
        }

        var newData = [];
        var searchValue = ctrl.search_value ? ctrl.search_value.toLowerCase() : '';

        if (!searchValue) {
          ctrl.tableData = angular.copy(ctrl.originalTableData);
          return;
        }

        for (var i = 0; i < ctrl.originalTableData.length; i++) {
          var found = false;
          for (var key in ctrl.originalTableData[i]) {
            if (
              ctrl.originalTableData[i][key] &&
              ctrl.originalTableData[i][key].toString().toLowerCase().indexOf(searchValue) > -1
            ) {
              found = true;
              break;
            }
          }
          
          if (found) {
            newData.push(ctrl.originalTableData[i]);
          }
        }

        ctrl.tableData = newData;
      }
    });
})();

(function () {
  angular.module("app.controllers")
    .controller("CoursesFieldsFormSettingsController", function ($stateParams, $state, $api, CoursesFieldValue, CoursesField, $rootScope, $translate) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.isEdit = false;
      ctrl.listId = $stateParams.id;
      ctrl.coursesField = CoursesField.data;

      ctrl.form = {
        value: '',
        position: 0,
        cashbox_condition: false,
      };

      if (CoursesFieldValue != null) {
        ctrl.isEdit = true;
        ctrl.form = {
          value: CoursesFieldValue.data.value,
          position: CoursesFieldValue.data.position,
          cashbox_condition: CoursesFieldValue.data.cashbox_condition,
        }
      }

      ctrl.submit = function () {
        if (CoursesFieldValue == null) {
          $api.coursesFields.value.add.save({id: ctrl.listId}, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_COURSES_FIELDS_VALUE_SAVE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.courses_fields.single", {id: ctrl.listId}, { reload: true });
            }
          });
        } else {
          $api.coursesFields.value.update.save({
            id: ctrl.listId,
            vid: CoursesFieldValue.data.id
          }, ctrl.form, function (response) {
            if (response.success) {
              swal({
                title: $translate.instant('SWAL_COURSES_FIELDS_VALUE_UPDATE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.settings.courses_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
            }
          });
        }
      };

      ctrl.delete = function () {
        swal({
          title: "",
          text: $translate.instant('SWAL_COURSES_FIELDS_VALUE_DELETE_CONFIRM_TEXT').replace('[value]', CoursesFieldValue.data.value),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value)
            $api.coursesFields.value.remove.delete({
              id: ctrl.listId,
              vid: CoursesFieldValue.data.id
            }, function (response) {
              if (response.success) {
                swal({
                  title: $translate.instant('SWAL_COURSES_FIELDS_VALUE_DELETE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.settings.courses_fields.single", {id: ctrl.listId, bid: $rootScope.$id}, { reload: true });
              }
            });
        });
      };
    });
})();

(function () {

  angular.module('app.controllers')

    .controller('CategoriesListController', function (Categories, $api, $state, $header, $scope, $translate, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;

      /**
       * Assign data to the table
       */
      ctrl.tableData = Categories.data;

      /**
       * Module header configuration (title and breadcrumbs)
       */
      $header.title = "קטגוריות";
      $header.breadcrumbs.push({
        "title": "הגדרות",
        "state": "app.settings"
      });
      $header.breadcrumbs.push({
        "title": "קטגוריות"
      });

      /**
       * Datatable configuration
       */
      $scope.dtOptions =
        DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider);

      ctrl.search_value = "";
      ctrl.find_table = function() {
        ctrl.tableData = Categories.data;
        if (ctrl.search_value) {
          var newData = [];
          for (var i in ctrl.tableData) {
            var found = false;
            for (var k in ctrl.tableData[i]) {
                if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                found = true;
                }
            }

            if (found) {
                newData.push(ctrl.tableData[i]);
            }
          }

          ctrl.tableData = newData;
        }
      }

      ctrl.drop = function(){
        var order = [];
        for(var i in ctrl.tableData) {
          order.push(ctrl.tableData[i].id);
        }
        $api.categories.save({ordering: order}, function(response){
          if(response.status === "success"){
          }
        });
      };

      ctrl.change_active = function (category) {
        if (!category.active) {
          swal({
              title: $translate.instant('SWAL_ARE_YOU_SURE'),
              text: $translate.instant('NOTIFICATION_CHANGE_CATEGORIES_ACTIVE'),
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              showLoaderOnConfirm: true
          }).then(function(result) {
              if (!result.value) {
                category.active = true;
              }
              ctrl.submit(category);
          });
        } else {
          ctrl.submit(category);
        }
      };

      ctrl.submit = function (category) {
        $api.categories.single.save({
          id: category.id
        }, category, function (response) {
        });
      }

    });
})();

(function() {

    angular.module("app.controllers").controller("CategoriesFormController", function($scope, $state, $api, dates, Category, $rootScope, $translate, $timeout) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
            active: true,
        };

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(Category != null) {
            $scope.isEdit = true;
            ctrl.form = Category.data;
        }

        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(Category == null)
                /**
                 * In case it's a new customer form
                 */
                $api.categories.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_C_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.categories.single.save({
                    id: Category.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {id: Category.data.id}, {reload: true});
                    }
                });
        };

        /**
         * Triggers category delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_CATEGORIES_DELETE_CONFIRM_TEXT').replace('[name]', Category.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.categories.single.delete({id: Category.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_CATEGORIES_C_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.categories", {}, {reload: true});
                        } else if (response.status == "exist") {
                            swal({
                                title: $translate.instant('SWAL_CATEGORIES_DELETE_EXIST_TITLE'),
                                text: "",
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
            });
        };

        ctrl.change_active = function () {
            if (!ctrl.form.active) {
                swal({
                    title: $translate.instant('SWAL_ARE_YOU_SURE'),
                    text: $translate.instant('NOTIFICATION_CHANGE_CATEGORIES_ACTIVE'),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if (!result.value) {
                        $timeout(function() {
                            ctrl.form.active = true;
                        });
                    }
                });
            }
        };
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('CallLogsController', function (CallLogs, $state, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.tableData = CallLogs && CallLogs.data ? CallLogs.data : [];

            // Audio playback functionality
            ctrl.audio = null;
            ctrl.currentAudioRow = null;
            ctrl.audioEndedHandler = null;

            ctrl.getRowId = function(row) {
                // Create a unique identifier for the row
                return row.id || (row.caller + '_' + row.created_at + '_' + (row.duration || '0'));
            };

            ctrl.playRecord = function(row) {
                if (!row.record) {
                    return;
                }

                var rowId = ctrl.getRowId(row);

                // If clicking on the same record that's playing, stop it
                if (ctrl.audio && ctrl.currentAudioRow && ctrl.getRowId(ctrl.currentAudioRow) == rowId) {
                    ctrl.audio.pause();
                    ctrl.audio.removeEventListener('ended', ctrl.audioEndedHandler);
                    ctrl.currentAudioRow = null;
                    ctrl.audio = null;
                    return;
                }

                // Stop current audio if playing
                if (ctrl.audio) {
                    ctrl.audio.pause();
                    ctrl.audio.removeEventListener('ended', ctrl.audioEndedHandler);
                }

                // Play new audio
                ctrl.audio = new Audio(row.record);
                ctrl.audio.play();
                ctrl.currentAudioRow = row;

                ctrl.audioEndedHandler = function() {
                    ctrl.currentAudioRow = null;
                    ctrl.audio = null;
                };
                ctrl.audio.addEventListener('ended', ctrl.audioEndedHandler);
            };

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_CALL_LOGS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip')
                .withOption('searching', false)
                .withLanguage(dataTablesHebrewProvider)
                .withOption('order', [[2, 'desc']])
                .withOption('columnDefs', [
                    { targets: [-1, -2], orderable: false }
                ]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = CallLogs && CallLogs.data ? CallLogs.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }
        });
})();

(function() {

    angular.module("app.controllers").controller("InterestedFormController", function($scope, $state, $api, Interested, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
        };

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */

        if(Interested != null) {
            $scope.isEdit = true;
            ctrl.form = Interested.data;
        }

        ctrl.submit = function() {

            if(Interested == null)
                $api.interested.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_INTERESTED_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.additional_fields.interested", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.interested.single.save({
                    id: Interested.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_INTERESTED_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.additional_fields.interested", {}, {reload: true});
                    }
                });
        };

      
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_INTERESTED_DELETE_CONFIRM_TEXT').replace('[name]', Interested.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.interested.single.delete({id: Interested.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_INTERESTED_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.additional_fields.interested", {}, {reload: true});
                        }
                    });
            });
        };
       
    });

})();

(function() {

    angular.module("app.controllers").controller("InterestedController", function($scope, $state, $api, $header, Interested, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;

      ctrl.tableData = Interested && Interested.data ? Interested.data : [];

      $header.breadcrumbs.push({
          "title": "SETTINGS_INTERESTED"
      });

      /**
       * Datatable configuration
       */
      $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]);

      ctrl.search_value = "";
      ctrl.find_table = function() {
          ctrl.tableData = Interested && Interested.data ? Interested.data : [];
          if (ctrl.search_value) {
              var newData = [];
              for (var i in ctrl.tableData) {
                  var found = false;
                  for (var k in ctrl.tableData[i]) {
                      if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                        found = true;
                      }
                  }

                  if (found) {
                      newData.push(ctrl.tableData[i]);
                  }
              }

              ctrl.tableData = newData;
          }
      }

    });

})();

(function() {

    angular.module("app.controllers").controller("QuotationStatusesNewController", function($scope, $state, $api, QuotationStatus, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            name: '',
            color: '#a9cfe8',
        };

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(QuotationStatus != null) {
            $scope.isEdit = true;
            ctrl.form = QuotationStatus.data;
            ctrl.form.color = ctrl.form.color ? ctrl.form.color : '#a9cfe8';
        }

        ctrl.submit = function() {

            if(QuotationStatus == null)
                $api.quotation_statuses.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_STATUSES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.accounting_settings.quotation_statuses", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.quotation_statuses.single.save({
                    id: QuotationStatus.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_STATUSES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.accounting_settings.quotation_statuses", {}, {reload: true});
                    }
                });
        };

      
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_STATUSES_DELETE_CONFIRM_TEXT').replace('[name]', QuotationStatus.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.quotation_statuses.single.delete({id: QuotationStatus.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_STATUSES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.accounting_settings.quotation_statuses", {}, {reload: true});
                        }
                    });
            });
        };
       
    });

})();

(function () {

    angular.module("app.controllers").controller("QuotationStatusesController", function ($scope, $state, $api, $header, QuotationStatuses, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

        if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, { reload: true });
            return;
        }

        var ctrl = this;

        ctrl.tableData = QuotationStatuses && QuotationStatuses.data ? QuotationStatuses.data : [];

        /**
         * Module header configuration (title and breadcrumbs)
         */
        $header.title = "סטטוסי הצעת מחיר";
        $header.breadcrumbs.push({
            "title": "NAV_SETTINGS",
            "state": "app.settings"
        });
        $header.breadcrumbs.push({
            "title": "ACCOUNTING_SETTINGS",
            "state": "app.settings.accounting_settings"
        });
        $header.breadcrumbs.push({
            "title": "SETTINGS_QUOTATION_STATUSES"
        });

        /**
         * Datatable configuration
         */
        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[0, 'desc']]);

        ctrl.search_value = "";
        ctrl.find_table = function () {
            ctrl.tableData = QuotationStatuses && QuotationStatuses.data ? QuotationStatuses.data : [];
            if (ctrl.search_value) {
                var newData = [];
                for (var i in ctrl.tableData) {
                    var found = false;
                    for (var k in ctrl.tableData[i]) {
                        if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                            found = true;
                        }
                    }

                    if (found) {
                        newData.push(ctrl.tableData[i]);
                    }
                }

                ctrl.tableData = newData;
            }
        };

    });

})();

(function () {

    angular.module('app.controllers')

        .controller('AllocationSettingsController', function ($state, $rootScope, $header, $api, $translate, $location) {

            if ($rootScope.userRole == 1) {
                $state.go('app.admin', {}, { reload: true });
                return;
            }

            var ctrl = this;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = $translate.instant('SETTINGS_ALLOCATION_SETTINGS');
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "ACCOUNTING_SETTINGS",
                "state": "app.settings.accounting_settings"
            });
            $header.breadcrumbs.push({
                "title": "SETTINGS_ALLOCATION_SETTINGS"
            });

            ctrl.loading = true;
            ctrl.issueAllocationNumber = 0;
            ctrl.tokenStatusMessage = '';
            ctrl.tokenStatusIndicator = 'red';
            ctrl.hasToken = false;

            ctrl.issueAllocationOptions = [
                { value: 0, label: 'SETTINGS_ALLOCATION_ISSUE_NUMBER_NEVER' },
                { value: 1, label: 'SETTINGS_ALLOCATION_ISSUE_NUMBER_ALWAYS' },
                { value: 2, label: 'SETTINGS_ALLOCATION_ISSUE_NUMBER_BY_LAW' }
            ];
            ctrl.issueAllocationDropdownOptions = ctrl.issueAllocationOptions.map(function (option) {
                return {
                    value: option.value,
                    name: $translate.instant(option.label)
                };
            });

            /**
             * Check for OAuth callback (code in URL) or redirect result (token_callback param)
             */
            ctrl.handleCallback = function () {
                var params = $location.search();
                console.log('callback params', params);
                var code = params.code;
                var tokenCallback = params.token_callback;
                var tokenMessage = params.token_message;

                if (code) {
                    ctrl.loading = true;
                    $api.settings.allocation_token_callback.get({ code: code }, function () {
                        $location.search({});
                        $state.reload();
                    }, function () {
                        ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_CALLBACK_FAILED');
                        ctrl.tokenStatusIndicator = 'red';
                        ctrl.loading = false;
                        $location.search({});
                    });
                    return true;
                }

                if (tokenCallback === 'success' || tokenCallback === 'error') {
                    $location.search({});
                    ctrl.load();
                    if (tokenCallback === 'error' && tokenMessage) {
                        ctrl.tokenStatusMessage = tokenMessage;
                        ctrl.tokenStatusIndicator = 'red';
                    }
                    return true;
                }

                return false;
            };

            ctrl.load = function () {
                if (ctrl.handleCallback()) {
                    return;
                }

                ctrl.loading = true;

                $api.settings.allocation_settings.get({}, function (response) {
                    ctrl.loading = false;

                    var data = response && response.data ? response.data : response || {};

                    if (typeof data.issue_allocation_number !== 'undefined' && data.issue_allocation_number !== null) {
                        ctrl.issueAllocationNumber = data.issue_allocation_number;
                    } else {
                        ctrl.issueAllocationNumber = 0;
                    }

                    if (data.message_key && data.message_date) {
                        ctrl.tokenStatusMessage = $translate.instant(data.message_key, { date: data.message_date });
                    } else {
                        ctrl.tokenStatusMessage = data.message || '';
                    }
                    ctrl.tokenStatusIndicator = data.indicator || 'red';
                    ctrl.hasToken = !!data.hasToken;

                    if (!ctrl.tokenStatusMessage && !ctrl.hasToken) {
                        ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_STATUS_NO_TOKEN');
                    }
                }, function () {
                    ctrl.loading = false;
                    ctrl.tokenStatusMessage = '';
                    ctrl.tokenStatusIndicator = 'red';
                    ctrl.hasToken = false;
                });
            };

            ctrl.onIssueAllocationNumberChange = function () {
                $api.settings.allocation_settings.save({
                    issue_allocation_number: ctrl.issueAllocationNumber
                }, function () {}, function () {});
            };

            /**
             * Generate token: initiate OAuth flow, get authorization_url, redirect
             */
            ctrl.generate = function () {
                if (ctrl.loadingGenerate) {
                    return;
                }

                ctrl.loadingGenerate = true;

                $api.settings.allocation_token_initiate.get({}, function (response) {
                    ctrl.loadingGenerate = false;

                    var data = response && response.data ? response.data : response || {};
                    console.log(data);
                    if (data.authorization_url) {
                        window.location.href = data.authorization_url;
                        return;
                    }

                    ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_GENERATE_FAILED');
                    ctrl.tokenStatusIndicator = 'red';
                }, function () {
                    ctrl.loadingGenerate = false;
                    ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_GENERATE_FAILED');
                    ctrl.tokenStatusIndicator = 'red';
                });
            };

            /**
             * Refresh token: call backend, if authorization_url returned then redirect, else reload status
             */
            ctrl.refresh = function () {
                if (ctrl.loadingRefresh) {
                    return;
                }

                ctrl.loadingRefresh = true;

                $api.settings.allocation_token_refresh.save({ force: 1 }, function (response) {
                    ctrl.loadingRefresh = false;

                    var data = response && response.data ? response.data : response || {};

                    if (data.authorization_url) {
                        window.location.href = data.authorization_url;
                        return;
                    }

                    if (data.refreshed && data.message_key && data.message_date) {
                        ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_REFRESHED') + ' ' +
                            $translate.instant(data.message_key, { date: data.message_date });
                    } else if (data.refreshed) {
                        ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_REFRESHED');
                    } else if (data.message_key && data.message_date) {
                        ctrl.tokenStatusMessage = $translate.instant(data.message_key, { date: data.message_date });
                    } else if (data.message !== undefined) {
                        ctrl.tokenStatusMessage = data.message;
                    }
                    if (data.indicator !== undefined) {
                        ctrl.tokenStatusIndicator = data.indicator;
                    }
                    if (data.hasToken !== undefined) {
                        ctrl.hasToken = data.hasToken;
                    }
                }, function () {
                    ctrl.loadingRefresh = false;
                    ctrl.tokenStatusMessage = $translate.instant('SETTINGS_ALLOCATION_TOKEN_REFRESH_FAILED');
                    ctrl.tokenStatusIndicator = 'red';
                });
            };

            ctrl.load();
        });

})();

(function () {
    angular.module('app.controllers').controller('CustomersCardTransactionsController',
        function (Customer, Card, CardsTransactions, $state, $header, $scope, $api, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {
            var ctrl = this;

            ctrl.transactions = CardsTransactions.data;
            ctrl.card = Card.data;
            ctrl.customer = Customer.data;

            $header.breadcrumbs.push({
                    "title": "לקוחות",
                    "state": "app.customers"
                }, {
                    "title": Customer.data.firstname + " " + Customer.data.lastname,
                    "state": "app.customers.single({id:" + Customer.data.id + "})"
                },
                {
                    "title": "CUSTOMERS_CARDS_INFO_TAB"
                });
            $header.title = "CUSTOMERS_CARDS_TRANSACTIONS_LABEL" + '. ' + ctrl.card.name;

            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', 20)
                        .withOption('aaSorting', [])
                        .withOption('searching', false);

            if (window.innerWidth < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 3;
            }

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.transactions = CardsTransactions.data;
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.transactions) {
                        var found = false;
                        for (var k in ctrl.transactions[i]) {
                            if (ctrl.transactions[i][k] && ctrl.transactions[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.transactions[i]);
                        }
                    }

                    ctrl.transactions = newData;
                }
            }

        });
})();

(function() {

    angular.module("app.controllers").controller("ColoringFormController", function($scope, $state, $tiff_page, $api, Color, Customer, $rootScope, $uibModalInstance, $translate) {
      
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      $scope.isMobile = (angular.element(document).width() < 769);
      ctrl.form = {
        customer_id: Customer.data.id,
        business_id: Customer.data.b_id
      };

      ctrl.color_inputs = {2:false, 3:false, 4:false};
      /**
       * Initialize edit data
       */
      if (Color != null) {
        ctrl.form = Color.data;
        ctrl.color_inputs[2] = ctrl.form.color_number_2 || ctrl.form.color_dosage_2;
        ctrl.color_inputs[3] = ctrl.form.color_number_3 || ctrl.form.color_dosage_3;
        ctrl.color_inputs[4] = ctrl.form.color_number_4 || ctrl.form.color_dosage_4;
      }

      ctrl.add_color = function () {
        for (var i in ctrl.color_inputs) {
          if (!ctrl.color_inputs[i]) {
            ctrl.color_inputs[i] = true;
            break;
          }
        }
      }

      ctrl.submit = function () {

        $tiff_page.start_loading('save_coloring');
        if (Color == null) {
          var form = ctrl.form;
          form.date = moment(ctrl.form.date).format("YYYY-MM-DD");
          $api.coloring.save(form, function (response) {
            $tiff_page.stop_loading('save_coloring');
            if (response.status == "success") {
              $uibModalInstance.close(response.data);
              if (response.status == "success") {
                swal({
                  title: $translate.instant('SWAL_COLORING_SAVE_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
              }
            }
          }, function (response) {
            $tiff_page.stop_loading('save_coloring');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_COLORING_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
        } else {
          $api.coloring.single.save({
            id: Color.data.id
          }, ctrl.form, function (response) {
            $tiff_page.stop_loading('save_coloring');
            $uibModalInstance.close(response.data);
            if (response.status == "success") {
              swal({
                title: $translate.instant('SWAL_COLORING_SAVE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
            }
          }, function (response) {
            $tiff_page.stop_loading('save_coloring');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_COLORING_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
         }
      };

      ctrl.remove = function () {
        if (Color) {
          swal({
              title: "",
              text: $translate.instant('SWAL_COLORING_REMOVE_CONFIRMATION_TEXT'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              closeOnConfirm: false,
              showLoaderOnConfirm: true
          }).then(function(result) {
              if(result.value)
                  $api.coloring.single.delete({id: Color.data.id}, function(response) {
                      if(response.status == "success") {
                          swal({
                              title: $translate.instant('SWAL_COLORING_REMOVE_TITLE'),
                              text: "",
                              type: "success",
                              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                              timer: 2000
                          });
                          $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                      }
                  });
          });
        }
      };
    });

})();

(function () {
  angular.module("app.controllers").controller("CardBalanceFormController",
    function (Card, $api, $scope, $state, $rootScope, $uibModalInstance, $translate) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }
      var ctrl = this;
      ctrl.card = Card.data;

      // Form data
      ctrl.form = {
        amount_changed: 0,
        expired_at: ctrl.card.expired_at ? moment(ctrl.card.expired_at).toDate() : null,
        comment: ''
      };

      /**
       * Change customer card balance
       */
      ctrl.saveForm = function () {
        $api.cards.single.save({id: ctrl.card.id, data: ctrl.form}, function (response) {
          if (response.status == "success") {
            swal({
              title: $translate.instant('CARD_CHANGED_BALANCE_MSG'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            }).then(function () {
              $state.transitionTo("app.customers.single", {
                "id": $scope.customer.id
              }, {
                reload: true
              });
              $uibModalInstance.close();
            });
          }
        });
      }

    });
})();

(function() {

    angular.module("app.controllers").controller("CustomersSMSController", function($scope, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {};

        /**
         * Triggers when SMS form is submited
         */
        ctrl.submit = function() {

            $api.sms.save({
                message: ctrl.form.message,
                phone: Customer.data.telephone
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_SMS_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

    });

})();

(function () {

  angular.module('app.controllers')

      .controller('WorkersSingleController', function (Worker, $api, $state, $scope, $header, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal, $rootScope,$stateParams, $translate) {

          if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
          }

          // b_type=2 -> motel
          // b_type=1 -> store
          //$scope.b_type = $rootScope.$user.b_type;

          var ctrl = this;

          $scope.isMobile = (angular.element(document).width() < 769);

          
          

          $scope.selectizeConfig = {
              create: true,
              sortField: 'text'
          };


          if (Worker.status == "failed")
              $state.transitionTo("app.workers", {}, { reload: true });

          if (Worker.data.lastname == null)
              Worker.data.lastname = "";

          $scope.worker = Worker.data;
          $scope.businessId = $stateParams.id;

          
          

          /**
           * Module header configuration (title and breadcrumbs)
           */
          $header.title = "ניהול עובדים - <b>" + Worker.data.emp_firstname + " " + Worker.data.emp_lastname + "</b>";
          $header.breadcrumbs.push({
              "title": "עובדים",
              "state": "app.workers"
          }, {
                  "title": Worker.data.emp_firstname + " " + Worker.data.emp_lastname
              });
              /*
              $scope.deletetime = function(id){
                swal.fire({
                  title: 'הכנס סיסמת מנהל',
                  input: 'password',
                  inputAttributes: {
                    autocapitalize: 'off',
                    name: "password",
                    autocomplete: 'new-password'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'אישור',
                  cancelButtonText: 'ביטול',
                  showLoaderOnConfirm: true,
                  preConfirm: function(password){
                    
                    return $api.workers.employee_transactions.single.delete({password:password,id:id}, function(response){ 
                      console.log(response)
                          if(response.status == "success") {
                            $state.transitionTo("app.workers.single", {id: Worker.data.id}, {reload: true});
                          }
                          else{
                            swal.fire({
                              title: "הססמא לא נכונה נא לנסות שנית",
                              confirmButtonText: 'אישור',
                            })
                          }
                        })
                    }
                  })
                    
                      
              }
              */
              
              $scope.turntoinput = function(id,start,end){
                Swal.fire({
                  title: 'הכנס סיסמת מנהל',
                  input: 'password',
                  inputAttributes: {
                    autocapitalize: 'off',
                    name: "password",
                    autocomplete: 'new-password'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'אישור',
                  cancelButtonText: 'ביטול',
                  preConfirm: function(password){
                    return $api.workers.employee_transactions.save({password:password,update: true}, function(response){ 
                      if (response.status == "success") {
                        start_time = moment(start).format('YYYY-MM-DDThh:mm')
                        end_time = moment(end).format('YYYY-MM-DDThh:mm')
  
                        Swal.close()	
                        Swal.fire({
                          title: 'שינוי רשומה',
                          type: 'info',
                          html:
                          '<form class="update_hours"><input type="hidden" name="id" value="'+id+'"><h3>כניסה</h3><input type="datetime-local" class="swal2-input" name="start" value="'+start_time+'"><h3>יציאה</h3><input type="datetime-local" class="swal2-input" name="end" class="" value="'+end_time+'"><br><button type="submit" class="btn blue-btn">עדכן רשומה</button>&nbsp;<button type="button" class="btn btn-danger delete-time">מחק רשומה</button></form>',
                          showCloseButton: true,
                          showCancelButton: true,
                          showConfirmButton: false,
                          focusConfirm: false,
                          cancelButtonText:
                            'ביטול',
                        })
                        
                        $(document).find(".delete-time").bind('click', function(e) {
                          $api.workers.employee_transactions.single.delete({password:password,id:id}, function(response){
                            if(response.status == "success") {
                              swal.close()
                              $state.transitionTo("app.workers.single", {id: Worker.data.id}, {reload: true});
                            }
                            else{
                              swal.fire({
                                title: "הססמא לא נכונה נא לנסות שנית",
                                confirmButtonText: 'אישור',
                              })
                            }
                          });
                        });
                        $(document).find(".update_hours").bind('submit', function(e) {
                          e.preventDefault()
                          var fields = {};
                          $(this).find(":input").each(function() {
                              fields[this.name] = $(this).val();
                          });
                          fields["update"] = true;
                          $api.workers.employee_transactions.save(fields, function(response){ 
                            swal.close()
                            if (response.status == "success") {
                              $state.transitionTo("app.workers.single", {id: Worker.data.id}, {reload: true});
                            }
                            else{
                              swal.fire({
                                title: "ארעה שגיאה אנא נסה שנית",
                                confirmButtonText: 'אישור',
                              })
                            }
                          })
                        })
                      }
                      else{
                        swal.fire({
                          title: "הססמא לא נכונה נא לנסות שנית",
                          confirmButtonText: 'אישור',
                        })
                      }
                    })
                    }
                
                })
              }

              ctrl.showHideSearch = function () {
                  $scope.showHideSearchInput = !$scope.showHideSearchInput;
                ctrl.setDataTableOptions($scope.showHideSearchInput);
              }
              ctrl.setDataTableOptions = function (showSearch) {
                if (window.innerWidth < 768) {
                  if(typeof showSearch === "undefined") {
                    $scope.showHideSearchInput = false;
                  }
                  $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('order', [[0, 'desc']])
                      .withOption('aaSorting', [])
                      .withOption('searching', $scope.showHideSearchInput);
                } else {
                  if(typeof showSearch === "undefined") {
                    $scope.showHideSearchInput = false;
                  }
                  $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('order', [[0, 'desc']])
                      .withOption('aaSorting', [])
                      .withOption('searching', $scope.showHideSearchInput);
                }
              }
  
              ctrl.setDataTableOptions();

              ctrl.getData = function(){
                  $api.workers.employee_transactions.get({id: Worker.data.id}, function(response) {
                      if (response.status == 'success') { 
                        ctrl.tableData = response.data;
                      }
                  });
              }
              ctrl.getData();
          /**
           * Worker delete
           */
          ctrl.delete = function () {
              swal({
                  title: "",
                  text: $translate.instant('SWAL_WORKERS_DELETE_CONFIRM_TEXT').replace('[name]', Worker.data.emp_firstname),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                  confirmButtonClass: "btn-danger",
                  closeOnConfirm: false,
                  showLoaderOnConfirm: true
              }).then(function(result) {
                  if(result.value)
                      $api.workers.single.delete({id: Worker.data.id}, function(response) {
                          if(response.status == "success") {
                              swal({
                                  title: $translate.instant('SWAL_WORKERS_DELETE_TITLE'),
                                  text: "",
                                  type: "success",
                                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                  timer: 2000
                              });
                              $state.transitionTo("app.workers", {}, {reload: true});
                          }
                      });
              });
          };

          ctrl.recover = function () {
              
            $api.workers.recover.get({id: Worker.data.id}, function(response) {
              if(response.status == "success") {
                $state.transitionTo("app.workers", {}, {reload: true});
              }
            });
          };


          

          
      });

})();

(function(){
  angular.module('app.controllers').controller('WorkersListController',
    function ($state, $header, $scope, $api, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log) {
      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      ctrl.worker_name = "";
      ctrl.show_deleted = false;

      $header.title = "NAV_WORKERS";
      $header.breadcrumbs.push({
        "title": "NAV_WORKERS"
      });

      /**
         * search customer
         */
      $scope.find_worker = function() {
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      /**
       * Open customer data
       *
       * @param customerData
       */
      ctrl.open_customer_card = function (customerData) {
        $state.transitionTo("app.customers.single", {
          "id": customerData.id
        }, {
          reload: false
        });
      };

      ctrl.change_deleted = function () {
        ctrl.initDtOptions();
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      /**
       * Initiate DataTable Options
       */
      ctrl.initDtOptions = function(){
        $scope.dtOptions =
          DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            //.withOption('order', [[1, 'desc']])
            .withOption('aaSorting', [])
            .withOption('searching', ctrl.showHideSearchInput)
            .withOption('ajax', ctrl.loadWorkers)
            .withOption('serverSide', true)
            .withDataProp('data')
            .withOption('rowCallback', ctrl.WorkerRawCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });
      };

      ctrl.showHideSearchInput = false;
      ctrl.showHideSearch = function () {
        ctrl.showHideSearchInput = !ctrl.showHideSearchInput;
        ctrl.initDtOptions();
      };

      /**
       * Load customers
       *
       * @param data
       * @param callback
       * @param settings
       */
      ctrl.loadWorkers = function (data, callback, settings) {
        var orderCol = '';
        var orderDir = '';
        var searchStr = '';

        if(data.order.length) {
          // Use only last order parameters
          var colIndex = data.order[data.order.length - 1].column
          var orderCol = data.columns[colIndex]['name'];
          var orderDir = data.order[data.order.length - 1].dir;
        }

        $api.workers.list.get(
          {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.worker_name, deleted: ctrl.show_deleted}
          , function (result) {
          if (result && result.data) {
            $log.log(result);

            callback({
              recordsTotal: result.recordsTotal,
              recordsFiltered: result.recordsFiltered,
              data: result.data,
              draw: data.draw + 1
            });
          }

        });
      };

      /**
       * Bind events to a new row
       *
       * @param nRow
       * @param aData
       * @param iDisplayIndex
       * @param iDisplayIndexFull
       * @returns {*}
       */
      ctrl.WorkerRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        //console.log(aData)
        $(nRow).unbind('click');
        $(nRow).bind('click', function() {
          $scope.$apply(function() {
            ctrl.open_worker_card(aData);
          });
        });
        $(nRow).find(".start-job").unbind('click');
        $(nRow).find(".start-job").bind('click', function(e) {
          e.stopPropagation()

          swal.fire({
            title: 'הכנס סיסמת עובד',
            input: 'password',
            inputAttributes: {
              autocapitalize: 'off',
              name: "password",
              autocomplete: 'new-password'
            },
            showCancelButton: true,
            confirmButtonText: 'אישור',
            cancelButtonText: 'ביטול',
            showLoaderOnConfirm: true,
            preConfirm: function(password){
              return $api.workers.save({password:password,user_id: aData.id}, function(response){
                if (response.status == "success") {
                  $(".start-job,.end-job").attr("disabled", true);
                  $api.employeeTransactions.save({employee_id:aData.id}, function(response){
                    if(response.status == "success") {
                      $state.transitionTo("app.workers", {}, {reload: true});
                    }
                    else{
                      swal.fire({
                        title: "ארעה שגיעה",
                        confirmButtonText: 'אישור',
                      })
                      $(".end-job,.start-job").attr("disabled", false);
                    }
                  });

                }
                else{
                  swal.fire({
                    title: "הססמא לא נכונה נא לנסות שנית",
                    confirmButtonText: 'אישור',
                  })
                  $(".end-job,.start-job").attr("disabled", false);
                }
              })
            },
            allowOutsideClick: function(){!swal.isLoading()}
          })
        });

        $(nRow).find(".end-job").unbind('click');
        $(nRow).find(".end-job").bind('click', function(e) {
          e.stopPropagation()


          swal.fire({
            title: 'הכנס סיסמת עובד',
            input: 'password',
            inputAttributes: {
              autocapitalize: 'off',
              name: "password",
              autocomplete: 'new-password'
            },
            showCancelButton: true,
            confirmButtonText: 'אישור',
            cancelButtonText: 'ביטול',
            showLoaderOnConfirm: true,
            preConfirm: function(password){
              return $api.workers.save({password:password,user_id: aData.id}, function(response){
                if (response.status == "success") {
                  $(".end-job,.start-job").attr("disabled", true);
                  $api.employeeTransactions.save({id:aData.tran_id}, function(response){
                    if(response.status == "success") {
                      $state.transitionTo("app.workers", {}, {reload: true});
                    }
                    else{
                      swal.fire({
                        title: "ארעה שגיאה",
                        confirmButtonText: 'אישור',
                      })
                      $(".end-job,.start-job").attr("disabled", false);
                    }
                  });

                }
                else{
                  swal.fire({
                    title: "הססמא לא נכונה נא לנסות שנית",
                    confirmButtonText: 'אישור',
                  })
                  $(".end-job,.start-job").attr("disabled", false);
                }
              })
            },
            allowOutsideClick: function(){!swal.isLoading()}
          })
          /*
          $scope.$apply(function() {
              $api.employeeTransactions.save({id:aData.tran_id}, function(response){
                if(response.status == "success") {
                  $state.transitionTo("app.workers", {}, {reload: true});
                }
           });
          });*/
        });

        return nRow;
      }

      ctrl.open_worker_card = function (workerData) {

        $state.transitionTo("app.workers.single", {
          "id": workerData.id
        }, {
          reload: false
        });
      };


      if (window.innerWidth < 768) {
        ctrl.showHideSearchInput = false;
        $.fn.DataTable.ext.pager.numbers_length = 3;
      }

      ctrl.initDtOptions();

      /**
       * Customer table column definitions
       * @type {*[]}
       */
      ctrl.dtColumns = [
        { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'customer-name full',
          render: function(data, type, full, meta) {
            var html = '<div class="customer-pic-wrapper"><img src="assets/images/avatar.jpg" alt="User Profile" class="customer-pic"></div> ';
            html+= data.emp_firstname ? ' ' + data.emp_firstname : '';
            html+= data.emp_lastname ? ' ' + data.emp_lastname : '';
            return html;
          }
        },

       {data: null, title: '', orderable: false,
          render: function(data, type, full, meta) {
            //console.log(data.trn_status)
            if(data.trn_status === null || data.trn_status === 1){
              return '<button class="btn text primary start-job">כניסה</button>';
            }
            else{
              return '<button class="btn text error end-job">יציאה</button>';
            }
          }
        },
      ];
      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstanceCustomers = dtInstance;
      }

    });
})();

(function () {
   angular.module("app.controllers")
      .controller("WorkersFormController", function ($scope, $state, $api, dates, Worker, isModal, Info, $rootScope, $uibModalInstance, $translate) {
         if ($rootScope.userRole == 1) {
            $state.go('app.admin', {}, { reload: true });
            return;
         }

         var ctrl = this;
         // ctrl.isModal;
         ctrl.worker_country = {
            "code": "IL",
            "name": "Israel"
         };

         $scope.isModal = isModal;
         ctrl.form = {
            gender: "-1",
            send_notifications: "0",
            self_order: "0",
            group_notifications: "0"
         };

         ctrl.bu_type = parseInt(Info.data.type);

         /**
          * Initialize edit data
          */
         if (Worker != null) {
            ctrl.form = Worker.data;

            if (ctrl.form.emp_birthdate != null) {
               ctrl.form.emp_birthdate = String(ctrl.form.emp_birthdate).split("-");
               ctrl.form.birthdate_year = String(Number(ctrl.form.emp_birthdate[0]));
               ctrl.form.birthdate_month = String(Number(ctrl.form.emp_birthdate[1]));
               ctrl.form.birthdate_day = String(Number(ctrl.form.emp_birthdate[2]));
            }

            if (ctrl.form.emp_jobstartdate != null) {
               ctrl.form.emp_jobstartdate = String(ctrl.form.emp_jobstartdate).split("-");
               ctrl.form.startjob_year = String(Number(ctrl.form.emp_jobstartdate[0]));
               ctrl.form.startjob_month = String(Number(ctrl.form.emp_jobstartdate[1]));
               ctrl.form.startjob_day = String(Number(ctrl.form.emp_jobstartdate[2]));
            }

            if (ctrl.form.emp_jobenddate != null) {
               ctrl.form.emp_jobenddate = String(ctrl.form.emp_jobenddate).split("-");
               ctrl.form.endjob_year = String(Number(ctrl.form.emp_jobenddate[0]));
               ctrl.form.endjob_month = String(Number(ctrl.form.emp_jobenddate[1]));
               ctrl.form.endjob_day = String(Number(ctrl.form.emp_jobenddate[2]));
            }
            ctrl.form.emp_password = ""
         }

         /**
          * Give access from the scope to the datesProvider
          */
         $scope.datesProvider = dates;
         ctrl.yearOptions = buildSimpleDateOptions(dates.years, 'WORKERS_YEAR');
         ctrl.dayOptions = buildSimpleDateOptions(dates.days, 'WORKERS_DAY');
         ctrl.monthOptions = buildMonthOptions(dates.months);

         function buildSimpleDateOptions(values, placeholderKey) {
            var options = [
               { id: '', name: $translate.instant(placeholderKey) }
            ];

            angular.forEach(values, function (value) {
               options.push({
                  id: String(value),
                  name: String(value)
               });
            });

            return options;
         }

         function buildMonthOptions(months) {
            var options = [
               { id: '', name: $translate.instant('WORKERS_MONTH') }
            ];

            angular.forEach(months, function (monthName, month) {
               options.push({
                  id: String(Number(month) + 1),
                  name: monthName
               });
            });

            return options;
         }

         /**
          * Triggers when customers form is submited
          * Preparing the API call for creating or editing the current customer
          */
         ctrl.submit = function () {

            if (ctrl.form.gender == null)
               ctrl.form.gender = -1;

            if (Worker == null)
               /**
                * In case it's a new customer form
                */
               $api.workers.save(ctrl.form, function (response) {
                  if (response.status == "success") {

                     if ($scope.isModal) {
                        console.log("Worker was saved");
                        // if form is calles from order
                        // return new customer object
                        var promise = $api.resolve("workers.single@get", { "id": response.id });
                        promise.then(function (response) {
                           $uibModalInstance.close(response.data);
                        });
                     } else {
                        $state.transitionTo("app.workers", {}, { reload: true });
                     }
                  }
               });
            else
               /**
                * In case it's an edit form
                */
               $api.workers.single.save({
                  id: Worker.data.id
               }, ctrl.form, function (response) {
                  if (response.status == "success") {
                     swal({
                        title: $translate.instant('SWAL_WORKERS_SAVE_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                     });
                     $state.transitionTo("app.workers.single", { id: Worker.data.id }, { reload: true });
                  }
               });
         };

         ctrl.onCountryChange = function () {
            ctrl.form.country = ctrl.customer_country.code;
            //console.log(ctrl.form.country);
         }

         $scope.countries = [
            {
               "code": "AF",
               "name": "Afghanistan"
            },
            {
               "code": "AX",
               "name": "\u00c5land Islands"
            },
            {
               "code": "AL",
               "name": "Albania"
            },
            {
               "code": "DZ",
               "name": "Algeria"
            },
            {
               "code": "AS",
               "name": "American Samoa"
            },
            {
               "code": "AD",
               "name": "Andorra"
            },
            {
               "code": "AO",
               "name": "Angola"
            },
            {
               "code": "AI",
               "name": "Anguilla"
            },
            {
               "code": "AQ",
               "name": "Antarctica"
            },
            {
               "code": "AG",
               "name": "Antigua and Barbuda"
            },
            {
               "code": "AR",
               "name": "Argentina"
            },
            {
               "code": "AM",
               "name": "Armenia"
            },
            {
               "code": "AW",
               "name": "Aruba"
            },
            {
               "code": "AU",
               "name": "Australia"
            },
            {
               "code": "AT",
               "name": "Austria"
            },
            {
               "code": "AZ",
               "name": "Azerbaijan"
            },
            {
               "code": "BS",
               "name": "Bahamas"
            },
            {
               "code": "BH",
               "name": "Bahrain"
            },
            {
               "code": "BD",
               "name": "Bangladesh"
            },
            {
               "code": "BB",
               "name": "Barbados"
            },
            {
               "code": "BY",
               "name": "Belarus"
            },
            {
               "code": "BE",
               "name": "Belgium"
            },
            {
               "code": "BZ",
               "name": "Belize"
            },
            {
               "code": "BJ",
               "name": "Benin"
            },
            {
               "code": "BM",
               "name": "Bermuda"
            },
            {
               "code": "BT",
               "name": "Bhutan"
            },
            {
               "code": "BO",
               "name": "Bolivia, Plurinational State of"
            },
            {
               "code": "BQ",
               "name": "Bonaire, Sint Eustatius and Saba"
            },
            {
               "code": "BA",
               "name": "Bosnia and Herzegovina"
            },
            {
               "code": "BW",
               "name": "Botswana"
            },
            {
               "code": "BV",
               "name": "Bouvet Island"
            },
            {
               "code": "BR",
               "name": "Brazil"
            },
            {
               "code": "IO",
               "name": "British Indian Ocean Territory"
            },
            {
               "code": "BN",
               "name": "Brunei Darussalam"
            },
            {
               "code": "BG",
               "name": "Bulgaria"
            },
            {
               "code": "BF",
               "name": "Burkina Faso"
            },
            {
               "code": "BI",
               "name": "Burundi"
            },
            {
               "code": "KH",
               "name": "Cambodia"
            },
            {
               "code": "CM",
               "name": "Cameroon"
            },
            {
               "code": "CA",
               "name": "Canada"
            },
            {
               "code": "CV",
               "name": "Cape Verde"
            },
            {
               "code": "KY",
               "name": "Cayman Islands"
            },
            {
               "code": "CF",
               "name": "Central African Republic"
            },
            {
               "code": "TD",
               "name": "Chad"
            },
            {
               "code": "CL",
               "name": "Chile"
            },
            {
               "code": "CN",
               "name": "China"
            },
            {
               "code": "CX",
               "name": "Christmas Island"
            },
            {
               "code": "CC",
               "name": "Cocos (Keeling) Islands"
            },
            {
               "code": "CO",
               "name": "Colombia"
            },
            {
               "code": "KM",
               "name": "Comoros"
            },
            {
               "code": "CG",
               "name": "Congo"
            },
            {
               "code": "CD",
               "name": "Congo, the Democratic Republic of the"
            },
            {
               "code": "CK",
               "name": "Cook Islands"
            },
            {
               "code": "CR",
               "name": "Costa Rica"
            },
            {
               "code": "CI",
               "name": "C\u00f4te d'Ivoire"
            },
            {
               "code": "HR",
               "name": "Croatia"
            },
            {
               "code": "CU",
               "name": "Cuba"
            },
            {
               "code": "CW",
               "name": "Cura\u00e7ao"
            },
            {
               "code": "CY",
               "name": "Cyprus"
            },
            {
               "code": "CZ",
               "name": "Czech Republic"
            },
            {
               "code": "DK",
               "name": "Denmark"
            },
            {
               "code": "DJ",
               "name": "Djibouti"
            },
            {
               "code": "DM",
               "name": "Dominica"
            },
            {
               "code": "DO",
               "name": "Dominican Republic"
            },
            {
               "code": "EC",
               "name": "Ecuador"
            },
            {
               "code": "EG",
               "name": "Egypt"
            },
            {
               "code": "SV",
               "name": "El Salvador"
            },
            {
               "code": "GQ",
               "name": "Equatorial Guinea"
            },
            {
               "code": "ER",
               "name": "Eritrea"
            },
            {
               "code": "EE",
               "name": "Estonia"
            },
            {
               "code": "ET",
               "name": "Ethiopia"
            },
            {
               "code": "FK",
               "name": "Falkland Islands (Malvinas)"
            },
            {
               "code": "FO",
               "name": "Faroe Islands"
            },
            {
               "code": "FJ",
               "name": "Fiji"
            },
            {
               "code": "FI",
               "name": "Finland"
            },
            {
               "code": "FR",
               "name": "France"
            },
            {
               "code": "GF",
               "name": "French Guiana"
            },
            {
               "code": "PF",
               "name": "French Polynesia"
            },
            {
               "code": "TF",
               "name": "French Southern Territories"
            },
            {
               "code": "GA",
               "name": "Gabon"
            },
            {
               "code": "GM",
               "name": "Gambia"
            },
            {
               "code": "GE",
               "name": "Georgia"
            },
            {
               "code": "DE",
               "name": "Germany"
            },
            {
               "code": "GH",
               "name": "Ghana"
            },
            {
               "code": "GI",
               "name": "Gibraltar"
            },
            {
               "code": "GR",
               "name": "Greece"
            },
            {
               "code": "GL",
               "name": "Greenland"
            },
            {
               "code": "GD",
               "name": "Grenada"
            },
            {
               "code": "GP",
               "name": "Guadeloupe"
            },
            {
               "code": "GU",
               "name": "Guam"
            },
            {
               "code": "GT",
               "name": "Guatemala"
            },
            {
               "code": "GG",
               "name": "Guernsey"
            },
            {
               "code": "GN",
               "name": "Guinea"
            },
            {
               "code": "GW",
               "name": "Guinea-Bissau"
            },
            {
               "code": "GY",
               "name": "Guyana"
            },
            {
               "code": "HT",
               "name": "Haiti"
            },
            {
               "code": "HM",
               "name": "Heard Island and McDonald Islands"
            },
            {
               "code": "VA",
               "name": "Holy See (Vatican City State)"
            },
            {
               "code": "HN",
               "name": "Honduras"
            },
            {
               "code": "HK",
               "name": "Hong Kong"
            },
            {
               "code": "HU",
               "name": "Hungary"
            },
            {
               "code": "IS",
               "name": "Iceland"
            },
            {
               "code": "IN",
               "name": "India"
            },
            {
               "code": "ID",
               "name": "Indonesia"
            },
            {
               "code": "IR",
               "name": "Iran, Islamic Republic of"
            },
            {
               "code": "IQ",
               "name": "Iraq"
            },
            {
               "code": "IE",
               "name": "Ireland"
            },
            {
               "code": "IM",
               "name": "Isle of Man"
            },
            {
               "code": "IL",
               "name": "Israel"
            },
            {
               "code": "IT",
               "name": "Italy"
            },
            {
               "code": "JM",
               "name": "Jamaica"
            },
            {
               "code": "JP",
               "name": "Japan"
            },
            {
               "code": "JE",
               "name": "Jersey"
            },
            {
               "code": "JO",
               "name": "Jordan"
            },
            {
               "code": "KZ",
               "name": "Kazakhstan"
            },
            {
               "code": "KE",
               "name": "Kenya"
            },
            {
               "code": "KI",
               "name": "Kiribati"
            },
            {
               "code": "KP",
               "name": "Korea, Democratic People's Republic of"
            },
            {
               "code": "KR",
               "name": "Korea, Republic of"
            },
            {
               "code": "KW",
               "name": "Kuwait"
            },
            {
               "code": "KG",
               "name": "Kyrgyzstan"
            },
            {
               "code": "LA",
               "name": "Lao People's Democratic Republic"
            },
            {
               "code": "LV",
               "name": "Latvia"
            },
            {
               "code": "LB",
               "name": "Lebanon"
            },
            {
               "code": "LS",
               "name": "Lesotho"
            },
            {
               "code": "LR",
               "name": "Liberia"
            },
            {
               "code": "LY",
               "name": "Libya"
            },
            {
               "code": "LI",
               "name": "Liechtenstein"
            },
            {
               "code": "LT",
               "name": "Lithuania"
            },
            {
               "code": "LU",
               "name": "Luxembourg"
            },
            {
               "code": "MO",
               "name": "Macao"
            },
            {
               "code": "MK",
               "name": "Macedonia, the Former Yugoslav Republic of"
            },
            {
               "code": "MG",
               "name": "Madagascar"
            },
            {
               "code": "MW",
               "name": "Malawi"
            },
            {
               "code": "MY",
               "name": "Malaysia"
            },
            {
               "code": "MV",
               "name": "Maldives"
            },
            {
               "code": "ML",
               "name": "Mali"
            },
            {
               "code": "MT",
               "name": "Malta"
            },
            {
               "code": "MH",
               "name": "Marshall Islands"
            },
            {
               "code": "MQ",
               "name": "Martinique"
            },
            {
               "code": "MR",
               "name": "Mauritania"
            },
            {
               "code": "MU",
               "name": "Mauritius"
            },
            {
               "code": "YT",
               "name": "Mayotte"
            },
            {
               "code": "MX",
               "name": "Mexico"
            },
            {
               "code": "FM",
               "name": "Micronesia, Federated States of"
            },
            {
               "code": "MD",
               "name": "Moldova, Republic of"
            },
            {
               "code": "MC",
               "name": "Monaco"
            },
            {
               "code": "MN",
               "name": "Mongolia"
            },
            {
               "code": "ME",
               "name": "Montenegro"
            },
            {
               "code": "MS",
               "name": "Montserrat"
            },
            {
               "code": "MA",
               "name": "Morocco"
            },
            {
               "code": "MZ",
               "name": "Mozambique"
            },
            {
               "code": "MM",
               "name": "Myanmar"
            },
            {
               "code": "NA",
               "name": "Namibia"
            },
            {
               "code": "NR",
               "name": "Nauru"
            },
            {
               "code": "NP",
               "name": "Nepal"
            },
            {
               "code": "NL",
               "name": "Netherlands"
            },
            {
               "code": "NC",
               "name": "New Caledonia"
            },
            {
               "code": "NZ",
               "name": "New Zealand"
            },
            {
               "code": "NI",
               "name": "Nicaragua"
            },
            {
               "code": "NE",
               "name": "Niger"
            },
            {
               "code": "NG",
               "name": "Nigeria"
            },
            {
               "code": "NU",
               "name": "Niue"
            },
            {
               "code": "NF",
               "name": "Norfolk Island"
            },
            {
               "code": "MP",
               "name": "Northern Mariana Islands"
            },
            {
               "code": "NO",
               "name": "Norway"
            },
            {
               "code": "OM",
               "name": "Oman"
            },
            {
               "code": "PK",
               "name": "Pakistan"
            },
            {
               "code": "PW",
               "name": "Palau"
            },
            {
               "code": "PS",
               "name": "Palestine, State of"
            },
            {
               "code": "PA",
               "name": "Panama"
            },
            {
               "code": "PG",
               "name": "Papua New Guinea"
            },
            {
               "code": "PY",
               "name": "Paraguay"
            },
            {
               "code": "PE",
               "name": "Peru"
            },
            {
               "code": "PH",
               "name": "Philippines"
            },
            {
               "code": "PN",
               "name": "Pitcairn"
            },
            {
               "code": "PL",
               "name": "Poland"
            },
            {
               "code": "PT",
               "name": "Portugal"
            },
            {
               "code": "PR",
               "name": "Puerto Rico"
            },
            {
               "code": "QA",
               "name": "Qatar"
            },
            {
               "code": "RE",
               "name": "R\u00e9union"
            },
            {
               "code": "RO",
               "name": "Romania"
            },
            {
               "code": "RU",
               "name": "Russian Federation"
            },
            {
               "code": "RW",
               "name": "Rwanda"
            },
            {
               "code": "BL",
               "name": "Saint Barth\u00e9lemy"
            },
            {
               "code": "SH",
               "name": "Saint Helena, Ascension and Tristan da Cunha"
            },
            {
               "code": "KN",
               "name": "Saint Kitts and Nevis"
            },
            {
               "code": "LC",
               "name": "Saint Lucia"
            },
            {
               "code": "MF",
               "name": "Saint Martin (French part)"
            },
            {
               "code": "PM",
               "name": "Saint Pierre and Miquelon"
            },
            {
               "code": "VC",
               "name": "Saint Vincent and the Grenadines"
            },
            {
               "code": "WS",
               "name": "Samoa"
            },
            {
               "code": "SM",
               "name": "San Marino"
            },
            {
               "code": "ST",
               "name": "Sao Tome and Principe"
            },
            {
               "code": "SA",
               "name": "Saudi Arabia"
            },
            {
               "code": "SN",
               "name": "Senegal"
            },
            {
               "code": "RS",
               "name": "Serbia"
            },
            {
               "code": "SC",
               "name": "Seychelles"
            },
            {
               "code": "SL",
               "name": "Sierra Leone"
            },
            {
               "code": "SG",
               "name": "Singapore"
            },
            {
               "code": "SX",
               "name": "Sint Maarten (Dutch part)"
            },
            {
               "code": "SK",
               "name": "Slovakia"
            },
            {
               "code": "SI",
               "name": "Slovenia"
            },
            {
               "code": "SB",
               "name": "Solomon Islands"
            },
            {
               "code": "SO",
               "name": "Somalia"
            },
            {
               "code": "ZA",
               "name": "South Africa"
            },
            {
               "code": "GS",
               "name": "South Georgia and the South Sandwich Islands"
            },
            {
               "code": "SS",
               "name": "South Sudan"
            },
            {
               "code": "ES",
               "name": "Spain"
            },
            {
               "code": "LK",
               "name": "Sri Lanka"
            },
            {
               "code": "SD",
               "name": "Sudan"
            },
            {
               "code": "SR",
               "name": "Suriname"
            },
            {
               "code": "SJ",
               "name": "Svalbard and Jan Mayen"
            },
            {
               "code": "SZ",
               "name": "Swaziland"
            },
            {
               "code": "SE",
               "name": "Sweden"
            },
            {
               "code": "CH",
               "name": "Switzerland"
            },
            {
               "code": "SY",
               "name": "Syrian Arab Republic"
            },
            {
               "code": "TW",
               "name": "Taiwan, Province of China"
            },
            {
               "code": "TJ",
               "name": "Tajikistan"
            },
            {
               "code": "TZ",
               "name": "Tanzania, United Republic of"
            },
            {
               "code": "TH",
               "name": "Thailand"
            },
            {
               "code": "TL",
               "name": "Timor-Leste"
            },
            {
               "code": "TG",
               "name": "Togo"
            },
            {
               "code": "TK",
               "name": "Tokelau"
            },
            {
               "code": "TO",
               "name": "Tonga"
            },
            {
               "code": "TT",
               "name": "Trinidad and Tobago"
            },
            {
               "code": "TN",
               "name": "Tunisia"
            },
            {
               "code": "TR",
               "name": "Turkey"
            },
            {
               "code": "TM",
               "name": "Turkmenistan"
            },
            {
               "code": "TC",
               "name": "Turks and Caicos Islands"
            },
            {
               "code": "TV",
               "name": "Tuvalu"
            },
            {
               "code": "UG",
               "name": "Uganda"
            },
            {
               "code": "UA",
               "name": "Ukraine"
            },
            {
               "code": "AE",
               "name": "United Arab Emirates"
            },
            {
               "code": "GB",
               "name": "United Kingdom"
            },
            {
               "code": "US",
               "name": "United States"
            },
            {
               "code": "UM",
               "name": "United States Minor Outlying Islands"
            },
            {
               "code": "UY",
               "name": "Uruguay"
            },
            {
               "code": "UZ",
               "name": "Uzbekistan"
            },
            {
               "code": "VU",
               "name": "Vanuatu"
            },
            {
               "code": "VE",
               "name": "Venezuela, Bolivarian Republic of"
            },
            {
               "code": "VN",
               "name": "Viet Nam"
            },
            {
               "code": "VG",
               "name": "Virgin Islands, British"
            },
            {
               "code": "VI",
               "name": "Virgin Islands, U.S."
            },
            {
               "code": "WF",
               "name": "Wallis and Futuna"
            },
            {
               "code": "EH",
               "name": "Western Sahara"
            },
            {
               "code": "YE",
               "name": "Yemen"
            },
            {
               "code": "ZM",
               "name": "Zambia"
            },
            {
               "code": "ZW",
               "name": "Zimbabwe"
            }
         ];
   });
})();

(function() {

    angular.module("app.controllers").controller("LaserFilePopupFieldController", function($scope, $api, $resource, $state, $tiff_page, $uibModalStack, DTOptionsBuilder, dataTablesHebrewProvider, Field, Category_id, $rootScope, $uibModalInstance, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = Field ? Field : {};
        ctrl.form.category_id = Category_id ? Category_id : 1;
        ctrl.fieldTypeOptions = [
            {value: 'text', name: $translate.instant('SETTINGS_LASER_FIELD_TYPE_TEXT')},
            {value: 'list', name: $translate.instant('SETTINGS_LASER_FIELD_TYPE_LIST')},
            {value: 'date', name: $translate.instant('SETTINGS_LASER_FIELD_TYPE_DATE')},
            {value: 'datetime', name: $translate.instant('SETTINGS_LASER_FIELD_TYPE_DATETIME')},
            {value: 'textarea', name: $translate.instant('SETTINGS_LASER_FIELD_TYPE_TEXTAREA')},
            {value: 'map', name: $translate.instant('SETTINGS_LASER_FIELD_TYPE_MAP')}
        ];

        $scope.isEdit = Field ? true : false;
       
        ctrl.submit = function(){
            if(!ctrl.form.id)
                $api.settings.laser_file_field.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_LF_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        //$state.transitionTo("app.settings.laser_file", {}, {reload: true});
                        $uibModalInstance.close();
                    }
                });
            else
                $api.settings.laser_file_field.single.save({
                    id: ctrl.form.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_LF_SAVE_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        
                        $uibModalInstance.close();
                    }
                });
        };

        ctrl.delete = function(){
            swal({
                title: "",
                text: $translate.instant('SWAL_LF_FIELD_DELETE_CONFIRM_TEXT').replace('[name]', ctrl.form.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.settings.laser_file_field.single.delete({id: ctrl.form.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_LF_FIELD_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $uibModalInstance.close();
                        }
                    });
            });
        };

        ctrl.showImage = function($event, image) {
            $event.stopPropagation();
            $event.preventDefault();
            swal({
                imageUrl: image,
                imageWidth: 800,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: $translate.instant('CALL_CANCEL'),
            })
    
        }

        ctrl.removeImage = function($event, key) {
            $event.stopPropagation();
            $event.preventDefault();
            ctrl.form.image = '';
        };

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();
    
            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            $tiff_page.start_loading('save_image');
            
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
                $tiff_page.stop_loading('save_image');
            }, function(error){
                $tiff_page.stop_loading('save_image');
                console.log(error);
            });
        };
    });

})();

(function() {

    angular.module("app.controllers").controller("LaserFileController", function($scope, $api, $business, $state, $translate, $uibModal, $uibModalStack, Info, Data, Customer, Order, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.laser_categories = $business.laser_categories;
        ctrl.laser_category = 1;

        ctrl.form = [];
        ctrl.customer_id = Customer ? Customer.id : false;
        ctrl.order_id = Order ? Order.id : null;
        ctrl.fields = [];
        ctrl.blank = {};
        ctrl.orders = {};
        ctrl.orders_count = {};

        if (Info.data) {
            for (var i in Info.data) {
                if (Info.data[i].active) {
                    ctrl.fields.push(Info.data[i]);
                    ctrl.blank[Info.data[i].id] = '';
                }
            }
        }

        ctrl.init_list = function(data){
            ctrl.form = [];
            ctrl.orders = {};
            ctrl.orders_count = {};
            for (var i in data) {
                var d = JSON.parse(data[i].data);
                d.id = data[i].id
                d.show = false
                d.category_id = data[i].category_id;
                for (var j in ctrl.fields) {
                    //old code compatibility
                    if (d[ctrl.fields[j].code]) {
                        d[ctrl.fields[j].id] = d[ctrl.fields[j].code];
                    }
                    //old list code compatibility
                    if (ctrl.fields[j].list) {
                        for (var k in ctrl.fields[j].list) {
                            if (ctrl.fields[j].list[k].code && ctrl.fields[j].list[k].code == d[ctrl.fields[j].id]) {
                                d[ctrl.fields[j].id] = String(ctrl.fields[j].list[k].id);
                            }
                        }
                    }


                    if ((ctrl.fields[j].type == 'date' || ctrl.fields[j].type == 'datetime') && d[ctrl.fields[j].id]) {
                        d[ctrl.fields[j].id] = new Date(d[ctrl.fields[j].id]);
                    }
                }

                if (!ctrl.orders[data[i].order_id]) {
                    d.first = true;
                } else {
                    d.first = false;
                }

                if (data[i].order_id) {
                  ctrl.orders[data[i].order_id] = 'closed';
                  ctrl.orders_count[data[i].order_id] = ctrl.orders_count[data[i].order_id] ? ctrl.orders_count[data[i].order_id] + 1 : 1;
                  d.order_id = data[i].order_id;
                }

                ctrl.form.push(d);
            }
        }

        if (Data.data) {
            ctrl.init_list(Data.data);
        }

        ctrl.display_laser_orders = function(data, hide) {
          ctrl.orders[data.order_id] = hide ? 'closed' : 'opened';
          for (var i in ctrl.form) {
            if (ctrl.form[i].order_id == data.order_id) {
              ctrl.form[i].show = hide ? false : true;
            }
          }
        }

        ctrl.submit = function(easy){
            $api.laser_file.save({form: ctrl.form, customer_id: ctrl.customer_id, order_id: ctrl.order_id}, function(response){
                if (response.status === "success") {
                    ctrl.init_list(response.data);
                }
                if(response.status === "success" && !easy){
                    swal({
                        title: $translate.instant('SWAL_LF_P_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $uibModalStack.dismiss($uibModalStack.getTop().key);
                }
            });
        };

        ctrl.add_line = function(){
            //var copy = JSON.parse(JSON.stringify(ctrl.blank));
            var copy = {};
            copy.show = true;
            copy.category_id = ctrl.laser_category;
            
            if (Info.data) {
              for (var i in Info.data) {
                  if (Info.data[i].active && Info.data[i].category_id == ctrl.laser_category) {
                    if (Info.data[i].type == 'date' || Info.data[i].type == 'datetime') {
                      copy[Info.data[i].id] = new Date(new Date().setSeconds(0, 0));
                    } else {
                      copy[Info.data[i].id] = '';
                    }
                  }
              }
            }

            ctrl.form.push(copy);
        };

        ctrl.remove_line = function(index){
            swal({
                title: "",
                text: $translate.instant('LASER_FILE_REMOVE_LINE_CONFIRM'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value) {
                    ctrl.form[index].remove = true;
                    ctrl.submit(true);
                }
            });
        };

        ctrl.laser_map = function(index, field){
            $('body').addClass('fixed-body');

            $uibModal.open({
                templateUrl: "app/modules/settings/laser_file/map/laser_file.map.html",
                controller: "LaserFileMapController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Data: ctrl.form[index],
                  Field: field
                }
              }).result.then(function (val) {
                $('body').removeClass('fixed-body');
                  if (val) {
                      ctrl.form[index].menmap = val.men;
                      ctrl.form[index][field.id] = val.existed;
                      ctrl.submit(true);
                  }
              });
        };


    });

})();

(function() {

    angular.module("app.controllers").controller("LaserFileMapController", function($scope, $api, $state, Data, Field, $uibModalStack, $translate, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.men = Data.menmap ? true : false;
        ctrl.field = Field;
        ctrl.existed = Data && Data[ctrl.field.id] ? Data[ctrl.field.id] : false;

        var canvas, ctx;
        var pos = { x: 0, y: 0 };
        
        ctrl.init = function() {
          setTimeout( function() {
            canvas = document.getElementById('can');

            ctx = canvas.getContext('2d');
            ctrl.resize();

            document.addEventListener('mousemove', ctrl.draw);
            document.addEventListener('mousedown', ctrl.setPosition);
            document.addEventListener('mouseenter', ctrl.setPosition);

            document.addEventListener('touchmove', ctrl.draw);
            document.addEventListener('touchstart', ctrl.setPosition);

            ctrl.print();
          }, 500);
        }

        // new position from mouse event
        ctrl.setPosition = function (e) {
          pos.x = e.touches && e.touches["0"] ? e.touches["0"].clientX : e.clientX;
          pos.y = e.touches && e.touches["0"] ? e.touches["0"].clientY : e.clientY;
        }

        // resize canvas
        ctrl.resize = function() {
          var rect = ctx.canvas.parentElement.getBoundingClientRect()
          ctx.canvas.width = rect.width;
          ctx.canvas.height = ctx.canvas.width * 1.059;

          ctrl.change_image();
        }

        ctrl.draw = function(e) {
          if (e.buttons !== 1 && !e.touches) return;
          
          ctx.beginPath(); // begin

          ctx.lineWidth = 4;
          ctx.lineCap = 'round';
          ctx.strokeStyle = 'rgba(255, 0, 0, 0.5)';

          ctx.moveTo(pos.x-ctx.canvas.getBoundingClientRect().left, pos.y-ctx.canvas.getBoundingClientRect().top); // from
          ctrl.setPosition(e);
          ctx.lineTo(pos.x-ctx.canvas.getBoundingClientRect().left, pos.y-ctx.canvas.getBoundingClientRect().top); // to

          ctrl.generateSprayPoints(pos) // new

          //ctx.stroke(); // draw it!
        }

        ctrl.getRandomOffset = function(radius) {
          var randomAngle = Math.random() * (2 * Math.PI);
          var randomRadius = Math.random() * radius;
        
          return {
            x: Math.cos(randomAngle) * randomRadius,
            y: Math.sin(randomRadius) * randomAngle
          }
        }

        ctrl.generateSprayPoints = function(pos) {
          var amountOfPoints = 20
        
          for (var i = 0; i < amountOfPoints; i++) {
            var offset = ctrl.getRandomOffset(ctx.lineWidth * 2);
            var x = pos.x + offset.x - ctx.canvas.getBoundingClientRect().left
            var y = pos.y + offset.y - ctx.canvas.getBoundingClientRect().top
        
            ctx.fillStyle = ctx.strokeStyle
            ctx.fillRect(x, y, 1, 1)
          }
        }

        ctrl.erase = function() {
          swal({
              title: "",
              text: $translate.instant('LASER_FILE_MAP_CLEAR_CONFIRM'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              closeOnConfirm: false,
              showLoaderOnConfirm: true
          }).then(function(result) {
              if(result.value)
                ctrl.existed = [];
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctrl.resize();
          });
        }

        ctrl.change_image = function () {
          var background = new Image();
          background.src = ctrl.field.image ? ctrl.field.image : (ctrl.men ? "assets/images/menmap.jpg" : "assets/images/womenmap.jpg");

          background.onload = function(){
            ctx.canvas.parentElement.style.background = 'url('+background.src+') center no-repeat';
            ctx.canvas.parentElement.style.backgroundSize = 'contain';
          }
        }

        ctrl.print = function() {
          if (ctrl.existed) {
            var img = new Image;
            img.onload = function(){
              ctx.drawImage(img,0,0, ctx.canvas.width, ctx.canvas.height);
            };
            img.src = ctrl.existed;
          }
        }

        ctrl.save = function() {
          ctrl.existed = canvas.toDataURL();
        }

        ctrl.init();

    });

})();

(function() {

    angular.module("app.controllers").controller("LaserFileListController", function($scope, $api, $state, $uibModalStack, DTOptionsBuilder, dataTablesHebrewProvider, Field, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.list = Field.list ? Field.list : [];
       

        ctrl.submit = function(){
            $uibModalStack.dismiss($uibModalStack.getTop().key);
            return;
            $api.settings.laser_file.save({laser_file: ctrl.form}, function(response){
                if(response.status === "success"){
                    swal({
                        title: "פרטי העסק נשמרו",
                        type: "success",
                        confirmButtonText: "אישור",
                        timer: 2000
                    });

                    
                }
            });
        };

        ctrl.add_value = function(){
          var id = 1;
          for (var i in ctrl.list) {
            if (id <= ctrl.list[i].id) {
                id = ctrl.list[i].id;
            }
          }
          ctrl.list.push({id: id+1, name: ''});
        };

        ctrl.remove_value = function(index){
            ctrl.list = ctrl.list.slice(0, index).concat(ctrl.list.slice(index + 1, ctrl.list.length))
        };

    });

})();

(function () {
    angular.module('app.controllers').controller('ItemsStockLogController',
        function (Item, StockTransactions, $state, $header, $scope, $api, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal) {
            var ctrl = this;

            ctrl.transactions = StockTransactions.data;
            ctrl.item = Item.data;

            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', 20)
                        .withOption('aaSorting', [])
                        .withOption('searching', false);

            if (window.innerWidth < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 3;
            }

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.transactions = StockTransactions.data;
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.transactions) {
                        var found = false;
                        for (var k in ctrl.transactions[i]) {
                            if (ctrl.transactions[i][k] && ctrl.transactions[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.transactions[i]);
                        }
                    }

                    ctrl.transactions = newData;
                }
            }

            ctrl.open_log_card = function (id) {

                $uibModal.open({
                    templateUrl: "app/modules/settings/logs/modules/logs-info/logs.info.html",
                    controller: "LogsInfoController",
                    controllerAs: "ctrl",
                    windowTopClass: "form-modal small-modal",
                    scope: $scope,
                    resolve: {
                    Transaction: function ($api) {
                        return $api.resolve("transactions.single@get", {"id": id});
                        }
                    }
                }).closed.then(function() {

                });
            };

        });
})();

(function () {
    angular.module("app.controllers").controller("ItemsStockController",
      function (Item, $api, $scope, $state, $rootScope, $uibModalInstance, $translate) {
  
        if ($rootScope.userRole == 1) {
          $state.go('app.admin', {}, {reload: true});
          return;
        }
        var ctrl = this;
        ctrl.item = Item.data;
  
        // Form data
        ctrl.form = {
          amount_changed: 0,
          cost: 0,
          comment: ''
        };
  
        /**
         * Change item stock
         */
        ctrl.saveForm = function () {
          $api.items.single.save({id: ctrl.item.id, action: 'change_stock', data: ctrl.form}, function (response) {
            if (response.status == "success") {
              swal({
                title: $translate.instant('ITEM_CHANGED_STOCK_MSG'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              }).then(function () {
                $uibModalInstance.close();
              });
            }
          });
        }
  
      });
  })();
  
(function() {

    angular.module("app.controllers").controller("ItemsSelectController", function($scope, $state, Items, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope, $uibModalInstance) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.items = Items;
        ctrl.item_name = "";


        /**
         * search item
        */
        $scope.find_item = function() {
            var found = [];
            
            for (var i in Items) {
                if (ctrl.item_name == "" || (Items[i].name && Items[i].name.toLowerCase().indexOf(ctrl.item_name.toLowerCase().trim()) >= 0)) {
                    found.push(Items[i]);
                }
            }
            if (ctrl.items.length != found.length) {
                ctrl.items = found;
                if ($('#items_dt').DataTable()) {
                    $('#items_dt').DataTable().clear().draw();
                }
            }
        }

        $scope.find_item();


        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('scrollY', '500px')
            .withOption('order', [[2, 'asc']])
            .withOption('searching', false);

        ctrl.selectCustomer = function(index) {
            $uibModalInstance.close(ctrl.items[index]);
        }

    });

})();

(function () {
  angular.module("app.controllers").controller("GiftCardsSelectController", function ($scope, $state, GiftCards, SelectedGiftCards, $rootScope, $uibModalInstance, DTOptionsBuilder, dataTablesHebrewProvider, $timeout) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.search = '';
    ctrl.giftCards = angular.copy(GiftCards.data || []);
    ctrl.tableData = [];

    ctrl.selectedCards = SelectedGiftCards || [];
    ctrl.giftCardToggle = function (row) {
      var i, idx = -1;
      for (i = 0; i < ctrl.selectedCards.length; i++) {
        if (ctrl.selectedCards[i].id === row.id) {
          idx = i;
          break;
        }
      }

      if (idx > -1) {
        ctrl.selectedCards.splice(idx, 1);
      } else {
        ctrl.selectedCards.push(row);
      }
    };

    ctrl.isSelected = function (row) {
      for (var i = 0; i < ctrl.selectedCards.length; i++) {
        if (ctrl.selectedCards[i].id === row.id) {
          return true;
        }
      }
      return false;
    };

    function isUsed(card) {
      return !!(card.used === true || card.used === 1 || card.used === '1' || card.used === 'true');
    }

    function toStr(v) {
      return (v == null ? '' : (v + '')).toLowerCase();
    }

    function matchesSearch(card) {
      var q = toStr(ctrl.search).trim();
      if (!q) {
        return true;
      }

      var tokens = q.split(/\s+/);
      var hay = [
        toStr(card.number),
        toStr(card.name),
        toStr(card.service_text),
        toStr(card.sender_text),
        toStr(card.gifted_to)
      ].join(' ');

      for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] && hay.indexOf(tokens[i]) === -1) {
          return false;
        }
      }
      return true;
    }

    ctrl.applyFilters = function () {
      ctrl.tableData = ctrl.giftCards.filter(function (el) {
        return !isUsed(el) && matchesSearch(el);
      });
    };

    ctrl.applyFilters();

    var searchDebounce;
    $scope.$watch(function () { return ctrl.search; }, function () {
      if (searchDebounce) {
        $timeout.cancel(searchDebounce);
      }

      searchDebounce = $timeout(function () {
        ctrl.applyFilters();
      }, 150);
    });

    /**
     * Datatable configuration
     */
    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDOM('Tfgtip')
      .withLanguage(dataTablesHebrewProvider)
      .withOption('order', [[0, 'asc']])
      .withOption('pageLength', 20);

    ctrl.confirm = function () {
      $uibModalInstance.close(ctrl.selectedCards);
    };
  });
})();
(function () {
  angular.module("app.controllers").controller("GiftCardsDetailsController", function ($scope, $state, Customer, Item, Templates, Info, $rootScope, $uibModalInstance) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.item = Item.isGiftCard ? angular.copy(Item) : null;

    ctrl.values = {
      receiver: ctrl.item ? ctrl.item.gifted_to : '',
      message: ctrl.item ? ctrl.item.message_text : '',
    };

    if (Info) {
      var address = [];
      if (Info.data.city) {
        address.push(Info.data.city);
      }
      if (Info.data.address) {
        address.push(Info.data.address);
      }
      if (Info.data.home_number) {
        address.push(Info.data.home_number);
      }
      
      ctrl.values.business = Info.data.name;
      ctrl.values.address = address.join(', ');
    }

    if (Item) {
      ctrl.values.value = Item.price * Item.quantity;
      ctrl.values.service = ctrl.item ? ctrl.item.service_text : Item.name;
    }

    if (Customer) {
      ctrl.values.sender = ctrl.item ? ctrl.item.sender_text : [Customer.firstname, Customer.lastname].join(' ');
    }

    ctrl.templates = [];
    if (Templates) {
      ctrl.templates = Templates.data;
    }

    ctrl.localSettings = {};
    ctrl.selectedTemplate = 0;
    if (ctrl.item && ctrl.item.gift_card_template_id) {
      var foundIndex = -1;
      for (var i = 0; i < ctrl.templates.length; i++) {
        if (ctrl.templates[i].id == ctrl.item.gift_card_template_id) {
          foundIndex = i;
          break;
        }
      }

      ctrl.selectedTemplate = foundIndex > -1 ? foundIndex : 0;
    }

    ctrl.bumpSettings = function() {
      ctrl.localSettings = angular.extend({}, ctrl.localSettings);
    };

    ctrl.bumpValues = function() {
      ctrl.values = angular.extend({}, ctrl.values);
    };

    ctrl.selectTemplate = function(index) {
      ctrl.selectedTemplate = index;

      var template = ctrl.templates[index];
      if (template) {
        ctrl.localSettings.page_bg_color = ctrl.item ? ctrl.item.page_bg_color : template.page_bg_color;
        ctrl.localSettings.card_bg_color = ctrl.item ? ctrl.item.card_bg_color : template.card_bg_color;
        ctrl.localSettings.primary_color = ctrl.item ? ctrl.item.primary_color : template.primary_color;
        ctrl.localSettings.text_color = ctrl.item ? ctrl.item.text_color : template.text_color;
        ctrl.localSettings.logo = ctrl.item ? ctrl.item.logo : template.logo;
        ctrl.localSettings.image = ctrl.item ? ctrl.item.image : template.image;
        ctrl.localSettings.receiver = ctrl.item ? ctrl.item.receiver : template.receiver;
        ctrl.localSettings.sender = ctrl.item ? ctrl.item.sender : template.sender;
        ctrl.localSettings.service = ctrl.item ? ctrl.item.service : template.service;
        ctrl.localSettings.value = ctrl.item ? ctrl.item.value : template.value;
        ctrl.localSettings.message = ctrl.item ? ctrl.item.message : template.message;

        ctrl.values.name = ctrl.item ? ctrl.item.name : template.name;
      }

      ctrl.bumpSettings()
    };
    
    ctrl.$onInit = function () {
      if (ctrl.templates.length) {
        ctrl.selectTemplate(ctrl.selectedTemplate);
      }
    };

    $scope.$watch(
      function () {
        return ctrl.selectedTemplate;
      },

      function (idx, prev) {
        if (idx !== prev && idx != null && ctrl.templates[idx]) {
          ctrl.selectTemplate(idx);
        }
      }
    );

    ctrl.save = function () {
      $uibModalInstance.close({
        template_id: ctrl.templates[ctrl.selectedTemplate] ? ctrl.templates[ctrl.selectedTemplate].id : null,
        settings: ctrl.localSettings,
        values: ctrl.values,
      });
    };
  });
})();

(function () {
  angular.module("app.controllers").controller("GiftCardsBalanceController", function ($state, GiftCard, $rootScope, $uibModalInstance) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.giftCard = GiftCard ? angular.copy(GiftCard) : null;

    ctrl.save = function () {
      $uibModalInstance.close(ctrl.giftCard);
    };
  });
})();

(function () {
  angular.module('app.controllers')
    .controller('AgentBookingHistoryController', function ($api, sessionId) {
      var ctrl = this;
      ctrl.loading = true;
      ctrl.messages = [];

      $api.ai_booking_agent.history_messages.get({ session_id: sessionId }, function (response) {
        ctrl.loading = false;
        if (response && response.success && response.data) {
          ctrl.messages = response.data;
        } else {
          ctrl.messages = [];
        }
      }, function () {
        ctrl.loading = false;
        ctrl.messages = [];
      });
    });
})();

(function () {
  var SETTINGS_CONFIG = [
    {
      key: 'agent_name',
      labelKey: 'AI_AGENT_AB_AGENT_NAME',
      hintKey: 'AI_AGENT_AB_AGENT_NAME_HINT',
      type: 'text',
      maxLength: 60,
      defaultValue: ''
    },
    {
      key: 'agent_trigger',
      labelKey: 'AI_AGENT_AB_TRIGGER',
      hintKey: 'AI_AGENT_AB_TRIGGER_HINT',
      options: [
        { value: 'online_booking', labelKey: 'AI_AGENT_AB_TRIGGER_ONLINE_BOOKING', descKey: 'AI_AGENT_AB_TRIGGER_ONLINE_BOOKING_DESC', isDefault: true },
        { value: 'whatsapp', labelKey: 'AI_AGENT_AB_TRIGGER_WHATSAPP', descKey: 'AI_AGENT_AB_TRIGGER_WHATSAPP_DESC' },
        { value: 'both', labelKey: 'AI_AGENT_AB_TRIGGER_BOTH', descKey: 'AI_AGENT_AB_TRIGGER_BOTH_DESC' },
      ],
      defaultValue: 'online_booking'
    },
    {
      key: 'tone_of_voice',
      labelKey: 'AI_AGENT_AB_TONE_OF_VOICE',
      hintKey: 'AI_AGENT_AB_TONE_OF_VOICE_HINT',
      options: [
        { value: 'friendly', labelKey: 'AI_AGENT_AB_TONE_FRIENDLY', descKey: 'AI_AGENT_AB_TONE_FRIENDLY_DESC', isDefault: true },
        { value: 'professional', labelKey: 'AI_AGENT_AB_TONE_PROFESSIONAL', descKey: 'AI_AGENT_AB_TONE_PROFESSIONAL_DESC' },
        { value: 'elegant', labelKey: 'AI_AGENT_AB_TONE_ELEGANT', descKey: 'AI_AGENT_AB_TONE_ELEGANT_DESC' },
        { value: 'clinical', labelKey: 'AI_AGENT_AB_TONE_CLINICAL', descKey: 'AI_AGENT_AB_TONE_CLINICAL_DESC' }
      ],
      defaultValue: 'friendly'
    },
    {
      key: 'response_length',
      labelKey: 'AI_AGENT_AB_RESPONSE_LENGTH',
      hintKey: 'AI_AGENT_AB_RESPONSE_LENGTH_HINT',
      options: [
        { value: 'short', labelKey: 'AI_AGENT_AB_RESPONSE_SHORT', descKey: 'AI_AGENT_AB_RESPONSE_SHORT_DESC', isDefault: true },
        { value: 'balanced', labelKey: 'AI_AGENT_AB_RESPONSE_BALANCED', descKey: 'AI_AGENT_AB_RESPONSE_BALANCED_DESC' },
        { value: 'detailed', labelKey: 'AI_AGENT_AB_RESPONSE_DETAILED', descKey: 'AI_AGENT_AB_RESPONSE_DETAILED_DESC' }
      ],
      defaultValue: 'short'
    },
    {
      key: 'update_cancel_not_allowed_behavior',
      labelKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED',
      hintKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_HINT',
      options: [
        { value: 'business_policy', labelKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_POLICY', descKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_POLICY_DESC', isDefault: true },
        { value: 'display_business_policy', labelKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_DISPLAY_POLICY', descKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_DISPLAY_POLICY_DESC' },
        { value: 'contact_business', labelKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_CONTACT_BUSINESS', descKey: 'AI_AGENT_AB_UPDATE_CANCEL_NOT_ALLOWED_CONTACT_BUSINESS_DESC' }
      ],
      defaultValue: 'business_policy'
    },
    {
      key: 'allow_edit_cancel_non_online_services',
      labelKey: 'AI_AGENT_AB_ALLOW_EDIT_CANCEL_NON_ONLINE_SERVICES',
      hintKey: 'AI_AGENT_AB_ALLOW_EDIT_CANCEL_NON_ONLINE_SERVICES_HINT',
      valueType: 'boolean',
      options: [
        { value: true, labelKey: 'AI_AGENT_AB_ALLOW_EDIT_CANCEL_NON_ONLINE_YES', descKey: 'AI_AGENT_AB_ALLOW_EDIT_CANCEL_NON_ONLINE_YES_DESC', isDefault: true },
        { value: false, labelKey: 'AI_AGENT_AB_ALLOW_EDIT_CANCEL_NON_ONLINE_NO', descKey: 'AI_AGENT_AB_ALLOW_EDIT_CANCEL_NON_ONLINE_NO_DESC' }
      ],
      defaultValue: true
    },
    {
      key: 'initiative_level',
      labelKey: 'AI_AGENT_AB_INITIATIVE_LEVEL',
      hintKey: 'AI_AGENT_AB_INITIATIVE_LEVEL_HINT',
      options: [
        { value: 'guided', labelKey: 'AI_AGENT_AB_INITIATIVE_GUIDED', descKey: 'AI_AGENT_AB_INITIATIVE_GUIDED_DESC' },
        { value: 'proactive', labelKey: 'AI_AGENT_AB_INITIATIVE_PROACTIVE', descKey: 'AI_AGENT_AB_INITIATIVE_PROACTIVE_DESC', isDefault: true },
        { value: 'assertive', labelKey: 'AI_AGENT_AB_INITIATIVE_ASSERTIVE', descKey: 'AI_AGENT_AB_INITIATIVE_ASSERTIVE_DESC' }
      ],
      defaultValue: 'proactive'
    },
    {
      key: 'emoji_usage',
      labelKey: 'AI_AGENT_AB_EMOJI_USAGE',
      hintKey: 'AI_AGENT_AB_EMOJI_USAGE_HINT',
      options: [
        { value: 'none', labelKey: 'AI_AGENT_AB_EMOJI_NONE', descKey: 'AI_AGENT_AB_EMOJI_NONE_DESC' },
        { value: 'balanced', labelKey: 'AI_AGENT_AB_EMOJI_BALANCED', descKey: 'AI_AGENT_AB_EMOJI_BALANCED_DESC', isDefault: true },
        { value: 'expressive', labelKey: 'AI_AGENT_AB_EMOJI_EXPRESSIVE', descKey: 'AI_AGENT_AB_EMOJI_EXPRESSIVE_DESC' }
      ],
      defaultValue: 'balanced'
    },
    {
      key: 'staff_presentation',
      labelKey: 'AI_AGENT_AB_STAFF_PRESENTATION',
      hintKey: 'AI_AGENT_AB_STAFF_PRESENTATION_HINT',
      options: [
        { value: 'staff_visible', labelKey: 'AI_AGENT_AB_STAFF_VISIBLE', descKey: 'AI_AGENT_AB_STAFF_VISIBLE_DESC' },
        { value: 'optimized_assignment', labelKey: 'AI_AGENT_AB_STAFF_OPTIMIZED', descKey: 'AI_AGENT_AB_STAFF_OPTIMIZED_DESC', isDefault: true }
      ],
      defaultValue: 'optimized_assignment'
    },
    {
      key: 'slot_choice_preset',
      labelKey: 'AI_AGENT_AB_SLOT_CHOICE',
      hintKey: 'AI_AGENT_AB_SLOT_CHOICE_HINT',
      options: [
        { value: 'focused_3', labelKey: 'AI_AGENT_AB_SLOT_FOCUSED', descKey: 'AI_AGENT_AB_SLOT_FOCUSED_DESC', isDefault: true },
        { value: 'balanced_5', labelKey: 'AI_AGENT_AB_SLOT_BALANCED', descKey: 'AI_AGENT_AB_SLOT_BALANCED_DESC' },
        { value: 'wide_7', labelKey: 'AI_AGENT_AB_SLOT_WIDE', descKey: 'AI_AGENT_AB_SLOT_WIDE_DESC' }
      ],
      defaultValue: 'focused_3'
    },
    {
      key: 'alternative_suggestion_style',
      labelKey: 'AI_AGENT_AB_ALT_SUGGESTION',
      hintKey: 'AI_AGENT_AB_ALT_SUGGESTION_HINT',
      options: [
        { value: 'minimal', labelKey: 'AI_AGENT_AB_ALT_MINIMAL', descKey: 'AI_AGENT_AB_ALT_MINIMAL_DESC' },
        { value: 'standard', labelKey: 'AI_AGENT_AB_ALT_STANDARD', descKey: 'AI_AGENT_AB_ALT_STANDARD_DESC', isDefault: true },
        { value: 'proactive', labelKey: 'AI_AGENT_AB_ALT_PROACTIVE', descKey: 'AI_AGENT_AB_ALT_PROACTIVE_DESC' }
      ],
      defaultValue: 'standard'
    },
    {
      key: 'returning_client_suggestions',
      labelKey: 'AI_AGENT_AB_RETURNING_CLIENT',
      hintKey: 'AI_AGENT_AB_RETURNING_CLIENT_HINT',
      options: [
        { value: 'disabled', labelKey: 'AI_AGENT_AB_RETURNING_DISABLED', descKey: 'AI_AGENT_AB_RETURNING_DISABLED_DESC' },
        { value: 'suggest_recent', labelKey: 'AI_AGENT_AB_RETURNING_SUGGEST', descKey: 'AI_AGENT_AB_RETURNING_SUGGEST_DESC', isDefault: true }
      ],
      defaultValue: 'suggest_recent'
    },
    {
      key: 'customer_restrictions_block',
      labelKey: 'AI_AGENT_AB_CUSTOMER_RESTRICTIONS_SECTION',
      hintKey: 'AI_AGENT_AB_CUSTOMER_RESTRICTIONS_SECTION_HINT',
      type: 'customer_restrictions_block',
      skipPersist: true,
      defaultValue: null
    },
    {
      key: 'service_info_timing',
      labelKey: 'AI_AGENT_AB_SERVICE_INFO_TIMING',
      hintKey: 'AI_AGENT_AB_SERVICE_INFO_TIMING_HINT',
      options: [
        { value: 'on_request', labelKey: 'AI_AGENT_AB_SERVICE_ON_REQUEST', descKey: 'AI_AGENT_AB_SERVICE_ON_REQUEST_DESC', isDefault: true },
        { value: 'proactive', labelKey: 'AI_AGENT_AB_SERVICE_PROACTIVE', descKey: 'AI_AGENT_AB_SERVICE_PROACTIVE_DESC' }
      ],
      defaultValue: 'on_request'
    },
    {
      key: 'knowledge_info',
      labelKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_INFO',
      hintKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_INFO_HINT',
      type: 'checkboxes',
      options: [
        { value: 'general', labelKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_GENERAL', descKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_GENERAL_DESC' },
        { value: 'specific', labelKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_SPECIFIC', descKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_SPECIFIC_DESC' },
        { value: 'knowledge_file', labelKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_FILE', descKey: 'AI_AGENT_AB_SERVICE_KNOWLEDGE_FILE_DESC' }
      ],
      defaultValue: { general: true, specific: true, knowledge_file: false }
    },
    {
      key: 'general_info',
      labelKey: 'AI_AGENT_AB_SERVICE_GENERAL_INFO',
      hintKey: 'AI_AGENT_AB_SERVICE_GENERAL_INFO_HINT',
      type: 'textarea',
      maxLength: 3000,
      defaultValue: ''
    },
    {
      key: 'non_booking_message_handling',
      labelKey: 'AI_AGENT_AB_NON_BOOKING_MESSAGE',
      hintKey: 'AI_AGENT_AB_NON_BOOKING_MESSAGE_HINT',
      options: [
        { value: 'ignore_and_continue', labelKey: 'AI_AGENT_AB_NON_BOOKING_IGNORE', descKey: 'AI_AGENT_AB_NON_BOOKING_IGNORE_DESC' },
        { value: 'reply_and_continue', labelKey: 'AI_AGENT_AB_NON_BOOKING_REPLY', descKey: 'AI_AGENT_AB_NON_BOOKING_REPLY_DESC', isDefault: true },
        { value: 'stop_and_notify_business', labelKey: 'AI_AGENT_AB_NON_BOOKING_STOP', descKey: 'AI_AGENT_AB_NON_BOOKING_STOP_DESC' }
      ],
      defaultValue: 'reply_and_continue'
    },
    {
      key: 'customer_followup_trigger_delay',
      labelKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_TRIGGER_DELAY',
      hintKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_TRIGGER_DELAY_HINT',
      options: [
        { value: 'none', labelKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_NONE', descKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_NONE_DESC', isDefault: true },
        { value: '10m', labelKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_10M', descKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_10M_DESC' },
        { value: '15m', labelKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_15M', descKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_15M_DESC' },
        { value: '20m', labelKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_20M', descKey: 'AI_AGENT_AB_CUSTOMER_FOLLOWUP_DELAY_20M_DESC' }
      ],
      defaultValue: 'none'
    },
    {
      key: 'availability',
      labelKey: 'AI_AGENT_AB_AVAILABILITY',
      hintKey: 'AI_AGENT_AB_AVAILABILITY_HINT',
      hasSchedule: true,
      weekdays: [
        { key: 'sun', labelKey: 'AI_AGENT_AB_DAY_SUN' },
        { key: 'mon', labelKey: 'AI_AGENT_AB_DAY_MON' },
        { key: 'tue', labelKey: 'AI_AGENT_AB_DAY_TUE' },
        { key: 'wed', labelKey: 'AI_AGENT_AB_DAY_WED' },
        { key: 'thu', labelKey: 'AI_AGENT_AB_DAY_THU' },
        { key: 'fri', labelKey: 'AI_AGENT_AB_DAY_FRI' },
        { key: 'sat', labelKey: 'AI_AGENT_AB_DAY_SAT' }
      ],
      options: [
        { value: 'always', labelKey: 'AI_AGENT_AB_AVAILABILITY_ALWAYS', descKey: 'AI_AGENT_AB_AVAILABILITY_ALWAYS_DESC', isDefault: true },
        { value: 'custom', labelKey: 'AI_AGENT_AB_AVAILABILITY_CUSTOM', descKey: 'AI_AGENT_AB_AVAILABILITY_CUSTOM_DESC' }
      ],
      defaultValue: 'always'
    },
    {
      key: 'availability_turns_before_assistance',
      labelKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_BEFORE_ASSISTANCE',
      hintKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_BEFORE_ASSISTANCE_HINT',
      options: [
        { value: 0, labelKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_0', descKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_0_DESC', isDefault: true },
        { value: 2, labelKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_2', descKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_2_DESC' },
        { value: 3, labelKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_3', descKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_3_DESC' },
        { value: 4, labelKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_4', descKey: 'AI_AGENT_AB_AVAILABILITY_TURNS_4_DESC' }
      ],
      defaultValue: 2
    },
    {
      key: 'non_online_service_request_behavior',
      labelKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_BEHAVIOR',
      hintKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_BEHAVIOR_HINT',
      options: [
        { value: 'offer_handoff', labelKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_HANDOFF', descKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_HANDOFF_DESC', isDefault: true },
        { value: 'offer_allowed_services_dropdown', labelKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_ALLOWED_DROPDOWN', descKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_ALLOWED_DROPDOWN_DESC' },
        { value: 'display_all_allowed_services', labelKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_DISPLAY_ALL', descKey: 'AI_AGENT_AB_NON_ONLINE_SERVICE_REQUEST_DISPLAY_ALL_DESC' }
      ],
      defaultValue: 'offer_handoff'
    }
  ];

  angular.module('app.controllers')
    .controller('AgentBookingController', function ($scope, $state, $stateParams, $api, $translate, $rootScope, $header, $timeout, Info, Statuses, DTOptionsBuilder, dataTablesHebrewProvider, $compile, $uibModal) {
      if ($rootScope.userRole === 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({ title: 'AI_AGENT_ONLINE_BOOKING' });

      var ctrl = this;
      ctrl.isActivating = false;
      ctrl.isDeactivating = false;
      ctrl.animationPhase = 'idle';
      ctrl.settingsConfig = SETTINGS_CONFIG;
      ctrl.settingsConfigByKey = {};
      SETTINGS_CONFIG.forEach(function (cfg) {
        ctrl.settingsConfigByKey[cfg.key] = cfg;
      });
      ctrl.visibleSettingsConfig = SETTINGS_CONFIG.filter(function (cfg) {
        return cfg.key !== 'agent_name';
      });
      ctrl.settings = {};
      ctrl.isSavingSettings = false;
      ctrl.hasUnsavedChanges = false;
      ctrl._dirtyWhileSaving = false;
      ctrl.activeTab = 'settings';
      ctrl.isTestingEnabled = false;
      ctrl.historySearch = '';
      ctrl.historyDtInstance = null;
      ctrl.testingPhone = '';
      ctrl.testingMessage = '';
      ctrl.testingMessages = [];
      ctrl.testingLoading = 0;
      ctrl.testingSessionId = '';
      ctrl.testingSessionPhone = '';
      ctrl.allowedOnlineServiceOptions = [];

      function parseAiAgentsOptions(data) {
        if (!data || !data.ai_agents_options) return {};
        try {
          return typeof data.ai_agents_options === 'string'
            ? JSON.parse(data.ai_agents_options) : data.ai_agents_options;
        } catch (e) {
          return {};
        }
      }

      function getAgentBookingEnabled(opts) {
        return opts && opts.agent_booking && (opts.agent_booking.enabled === true || opts.agent_booking.enabled === 1);
      }

      function getSettingValue(config, ab) {
        var v = ab && ab[config.key];
        if (v !== undefined && v !== null) {
          if (config.valueType === 'boolean') {
            return !!(v === true || v === 1 || v === '1' || v === 'true');
          }
          return v;
        }
        return config.defaultValue;
      }

      // AngularJS input[type="time"] requires a Date object in the model
      function timeStringToDate(str) {
        var parts = (str || '09:00').split(':');
        return new Date(1970, 0, 1, parseInt(parts[0], 10) || 9, parseInt(parts[1], 10) || 0);
      }

      function dateToTimeString(d) {
        if (!d || !(d instanceof Date) || isNaN(d.getTime())) return '09:00';
        var h = d.getHours(), m = d.getMinutes();
        return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
      }

      var SCHEDULE_DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var SCHEDULE_DEFAULTS = {
        sun: { enabled: false }, mon: { enabled: true },
        tue: { enabled: true },  wed: { enabled: true },
        thu: { enabled: true },  fri: { enabled: true },
        sat: { enabled: false }
      };

      function scheduleFromStorage(stored) {
        var result = {};
        SCHEDULE_DAYS.forEach(function (day) {
          var s = stored && stored[day];
          result[day] = {
            enabled: s ? !!s.enabled : SCHEDULE_DEFAULTS[day].enabled,
            from: timeStringToDate(s ? s.from : '09:00'),
            to:   timeStringToDate(s ? s.to   : '18:00')
          };
        });
        return result;
      }

      function scheduleToStorage(schedule) {
        var result = {};
        SCHEDULE_DAYS.forEach(function (day) {
          var d = schedule[day];
          result[day] = {
            enabled: !!d.enabled,
            from: dateToTimeString(d.from),
            to:   dateToTimeString(d.to)
          };
        });
        return result;
      }

      var opts = parseAiAgentsOptions(Info && Info.data ? Info.data : {});
      ctrl.isEnabled = getAgentBookingEnabled(opts);
      ctrl.isTestingEnabled = !!(Info && Info.data && (
        Info.data.ai_agent_testing === 1 ||
        Info.data.ai_agent_testing === '1' ||
        Info.data.ai_agent_testing === true
      ));

      SETTINGS_CONFIG.forEach(function (cfg) {
        if (cfg.skipPersist) return;
        ctrl.settings[cfg.key] = getSettingValue(cfg, opts.agent_booking);
      });

      // Guard against old/invalid stored values for checkbox groups.
      SETTINGS_CONFIG.forEach(function (cfg) {
        if (cfg.type !== 'checkboxes') return;

        var def = cfg.defaultValue;
        var current = ctrl.settings[cfg.key];

        if (!def || typeof def !== 'object' || Array.isArray(def)) return;

        if (!current || typeof current !== 'object' || Array.isArray(current)) {
          ctrl.settings[cfg.key] = angular.copy(def);
          return;
        }

        Object.keys(def).forEach(function (k) {
          if (current[k] === undefined) current[k] = def[k];
        });
      });

      ctrl.settings.availability_schedule = scheduleFromStorage(
        opts.agent_booking && opts.agent_booking.availability_schedule
      );

      applyAllSettingMaxLengths();

      ctrl.customerStatusOptions = (Statuses && Statuses.data ? Statuses.data : []).map(function (row) {
        var copy = angular.copy(row);
        copy.id = String(copy.id);
        return copy;
      });

      function normalizeIdArray(value) {
        if (!value || !Array.isArray(value)) {
          return [];
        }
        return value.map(function (id) {
          return String(id);
        });
      }

      function normalizeServiceId(value) {
        if (value === undefined || value === null || value === '') {
          return '';
        }
        if (Array.isArray(value) && value.length) {
          return String(value[0]);
        }
        return String(value);
      }

      var abBooking = opts.agent_booking || {};
      var statusIdsRaw = abBooking.dont_allow_status_ids;
      if (!statusIdsRaw || !Array.isArray(statusIdsRaw)) {
        ctrl.settings.dont_allow_status_ids = [];
      } else {
        ctrl.settings.dont_allow_status_ids = statusIdsRaw.map(function (id) {
          return String(id);
        });
      }
      var disallowNewRaw = abBooking.dont_allow_new_customers;
      ctrl.settings.dont_allow_new_customers = !!(
        disallowNewRaw === true ||
        disallowNewRaw === 1 ||
        disallowNewRaw === '1'
      );
      ctrl.settings.non_online_service_offer_service_id = normalizeServiceId(
        abBooking.non_online_service_offer_service_id != null
          ? abBooking.non_online_service_offer_service_id
          : abBooking.non_online_service_offer_service_ids
      );

      function loadAllowedOnlineServiceOptions() {
        $api.items_list.get(function (response) {
          var items = response && response.data ? response.data : [];
          ctrl.allowedOnlineServiceOptions = [
            {
              id: '',
              name: 'AI_AGENT_AB_NON_ONLINE_SERVICE_ALLOWED_DROPDOWN_LABEL'
            }
          ];

          items.forEach(function (item) {
            var isOnlineAllowed = item && (
              item.customer_allowed_booking === 1 ||
              item.customer_allowed_booking === '1' ||
              item.customer_allowed_booking === true
            );
            var isActive = !(item && (
              item.inactive === 1 ||
              item.inactive === '1' ||
              item.inactive === true
            ));
            if (!item || item.item_type !== 'service' || !isOnlineAllowed || !isActive) {
              return;
            }

            ctrl.allowedOnlineServiceOptions.push({
              id: String(item.id),
              name: item.name || ('#' + String(item.id))
            });
          });
        }, function () {
          ctrl.allowedOnlineServiceOptions = [];
        });
      }

      loadAllowedOnlineServiceOptions();

      ctrl.enableAgent = function () {
        if (ctrl.isActivating || ctrl.isEnabled) return;
        ctrl.isActivating = true;
        ctrl.hasUnsavedChanges = false;
        ctrl._dirtyWhileSaving = false;
        ctrl.animationPhase = 'activating';

        applyAllSettingMaxLengths();

        var newOpts = angular.copy(opts);
        newOpts.agent_booking = newOpts.agent_booking || {};
        newOpts.agent_booking.enabled = true;
        // Save all booking settings (defaults or current UI values) at enable time.
        SETTINGS_CONFIG.forEach(function (cfg) {
          if (cfg.skipPersist) return;
          newOpts.agent_booking[cfg.key] = angular.copy(ctrl.settings[cfg.key]);
        });
        newOpts.agent_booking.dont_allow_new_customers = angular.copy(ctrl.settings.dont_allow_new_customers);
        newOpts.agent_booking.dont_allow_status_ids = angular.copy(ctrl.settings.dont_allow_status_ids);
        newOpts.agent_booking.non_online_service_offer_service_id = angular.copy(ctrl.settings.non_online_service_offer_service_id);
        newOpts.agent_booking.availability_schedule = scheduleToStorage(ctrl.settings.availability_schedule);

        setTimeout(function () {
          $api.settings.ai_agents_options.save(
            { ai_agents_options: JSON.stringify(newOpts) },
            function (response) {
              ctrl.isActivating = false;
              if (response && response.success) {
                opts = newOpts;
                ctrl.animationPhase = 'complete';
                ctrl.isEnabled = true;
                ctrl.hasUnsavedChanges = false;
                $timeout(function () {
                  ctrl.animationPhase = 'idle';
                }, 2500);
              } else {
                ctrl.animationPhase = 'idle';
                swal({
                  title: $translate.instant('AI_AGENT_ENABLE_ERROR'),
                  text: (response && response.message) || '',
                  type: 'error',
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
              }
            },
            function () {
              ctrl.isActivating = false;
              ctrl.animationPhase = 'idle';
              swal({
                title: $translate.instant('AI_AGENT_ENABLE_ERROR'),
                text: '',
                type: 'error',
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
              });
            }
          );
        }, 2500);
      };

      ctrl.disableAgent = function () {
        if (ctrl.isDeactivating || !ctrl.isEnabled) return;
        ctrl.isDeactivating = true;
        ctrl.hasUnsavedChanges = false;

        var newOpts = angular.copy(opts);
        newOpts.agent_booking = newOpts.agent_booking || {};
        newOpts.agent_booking.enabled = false;

        $api.settings.ai_agents_options.save(
          { ai_agents_options: JSON.stringify(newOpts) },
          function (response) {
            ctrl.isDeactivating = false;
            if (response && response.success) {
              opts = newOpts;
              ctrl.isEnabled = false;
              ctrl.hasUnsavedChanges = false;
            } else {
              swal({
                title: $translate.instant('AI_AGENT_DISABLE_ERROR'),
                text: (response && response.message) || '',
                type: 'error',
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
              });
            }
          },
          function () {
            ctrl.isDeactivating = false;
            swal({
              title: $translate.instant('AI_AGENT_DISABLE_ERROR'),
              text: '',
              type: 'error',
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
            });
          }
        );
      };

      function applySettingMaxLength(settingKey) {
        var cfg;
        var currentValue;
        var maxLength;

        if (!settingKey) return;
        cfg = ctrl.settingsConfigByKey[settingKey];
        if (!cfg || !cfg.maxLength) return;

        maxLength = parseInt(cfg.maxLength, 10);
        if (!maxLength || maxLength < 1) return;

        currentValue = ctrl.settings[settingKey];
        if (typeof currentValue !== 'string') return;
        if (currentValue.length <= maxLength) return;

        ctrl.settings[settingKey] = currentValue.substring(0, maxLength);
      }

      function applyAllSettingMaxLengths() {
        SETTINGS_CONFIG.forEach(function (cfg) {
          if (cfg.maxLength) {
            applySettingMaxLength(cfg.key);
          }
        });
      }

      ctrl.onSettingChange = function (settingKey) {
        applySettingMaxLength(settingKey);

        // Persist only when the user clicks "Save".
        if (ctrl.isSavingSettings) ctrl._dirtyWhileSaving = true;
        ctrl.hasUnsavedChanges = true;
      };

      ctrl.onScheduleChange = function () {
        // Persist only when the user clicks "Save".
        if (ctrl.isSavingSettings) ctrl._dirtyWhileSaving = true;
        ctrl.hasUnsavedChanges = true;
      };

      ctrl.saveSettings = function () {
        if (ctrl.isSavingSettings || !ctrl.hasUnsavedChanges) return;

        applyAllSettingMaxLengths();

        var newOpts = angular.copy(opts);
        newOpts.agent_booking = newOpts.agent_booking || {};

        SETTINGS_CONFIG.forEach(function (cfg) {
          if (cfg.skipPersist) return;
          newOpts.agent_booking[cfg.key] = angular.copy(ctrl.settings[cfg.key]);
        });
        newOpts.agent_booking.dont_allow_new_customers = angular.copy(ctrl.settings.dont_allow_new_customers);
        newOpts.agent_booking.dont_allow_status_ids = angular.copy(ctrl.settings.dont_allow_status_ids);
        newOpts.agent_booking.non_online_service_offer_service_id = angular.copy(ctrl.settings.non_online_service_offer_service_id);
        newOpts.agent_booking.availability_schedule = scheduleToStorage(ctrl.settings.availability_schedule);

        ctrl._dirtyWhileSaving = false;
        ctrl.isSavingSettings = true;
        $api.settings.ai_agents_options.save(
          { ai_agents_options: JSON.stringify(newOpts) },
          function (response) {
            ctrl.isSavingSettings = false;
            if (response && response.success) {
              opts = newOpts;
              ctrl.hasUnsavedChanges = !!ctrl._dirtyWhileSaving;
            } else {
              ctrl.hasUnsavedChanges = true;
              swal({
                title: $translate.instant('AI_AGENT_SETTINGS_SAVE_ERROR_TITLE'),
                text: (response && response.message) || $translate.instant('AI_AGENT_SETTINGS_SAVE_ERROR_TEXT'),
                type: 'error',
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
              });
            }
          },
          function () {
            ctrl.isSavingSettings = false;
            ctrl.hasUnsavedChanges = true;
          }
        );
      };

      ctrl.setTab = function (tab) {
        if (tab === 'history') {
          ctrl.activeTab = 'history';
        } else if (tab === 'testing' && ctrl.isTestingEnabled) {
          ctrl.activeTab = 'testing';
        } else {
          ctrl.activeTab = 'settings';
        }
        if (ctrl.activeTab === 'history') {
          $timeout(function () {
            ctrl.reloadHistory();
          }, 0);
        }
      };

      ctrl.sendTestingMessage = function () {
        if (!ctrl.testingPhone || !ctrl.testingMessage) return;

        if (ctrl.testingSessionPhone && ctrl.testingSessionPhone !== ctrl.testingPhone) {
          ctrl.testingSessionId = '';
          ctrl.testingSessionPhone = '';
        }

        var outgoingMessage = String(ctrl.testingMessage);
        ctrl.testingMessage = '';
        ctrl.testingMessages.push({
          role: 'user',
          content: outgoingMessage
        });
        ctrl.testingLoading += 1;

        $api.settings.ai_agent_test_message.save({
          number: ctrl.testingPhone,
          message: outgoingMessage,
          session_id: ctrl.testingSessionId || null
        }, function (response) {
          ctrl.testingLoading -= 1;
          if (response && response.success && response.data && response.data.session_id) {
            ctrl.testingSessionId = response.data.session_id;
            ctrl.testingSessionPhone = ctrl.testingPhone;
          }
          if (response && response.success && response.data && response.data.response) {
            ctrl.testingMessages.push({
              role: 'assistant',
              content: response.data.response
            });
          }
        }, function () {
          ctrl.testingLoading -= 1;
          ctrl.testingMessages.push({
            role: 'assistant',
            content: 'Failed to send testing message'
          });
        });
      };

      ctrl.handleTestingKeyDown = function ($event) {
        if (!$event) return;
        if ($event.keyCode === 13 && !$event.shiftKey) {
          $event.preventDefault();
          ctrl.sendTestingMessage();
        }
      };

      ctrl.startNewTestingSession = function () {
        if (ctrl.testingLoading > 0) return;
        ctrl.testingMessages = [];
        ctrl.testingMessage = '';
        ctrl.testingSessionId = '';
        ctrl.testingSessionPhone = '';
        ctrl.testingLoading = 0;
      };

      ctrl.startNewTestingSession();

      ctrl.reloadHistory = function () {
        if (ctrl.historyDtInstance && ctrl.historyDtInstance.reloadData) {
          ctrl.historyDtInstance.reloadData(null, true);
          return;
        }
        if ($('#ab_history_dt').DataTable() && $('#ab_history_dt').DataTable().ajax) {
          $('#ab_history_dt').DataTable().ajax.reload();
        }
      };

      ctrl.historyDtInstanceCallback = function (dtInstance) {
        ctrl.historyDtInstance = dtInstance;
      };

      ctrl.openHistoryModal = function (row) {
        var sessionId = row && row.session_id ? row.session_id : '';
        if (!sessionId) {
          return;
        }

        $uibModal.open({
          templateUrl: 'app/modules/settings/ai_agents/agent_booking/agent_booking_history.view.html',
          controller: 'AgentBookingHistoryController',
          controllerAs: 'ctrl',
          windowTopClass: 'form-modal medium-modal',
          resolve: {
            sessionId: function () {
              return sessionId;
            }
          }
        });
      };

      ctrl.initHistoryDtOptions = function () {
        $scope.historyDtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
          .withLanguage(dataTablesHebrewProvider)
          .withOption('pageLength', 20)
          .withOption('aaSorting', [[0, 'desc']])
          .withOption('searching', false)
          .withOption('ajax', ctrl.loadHistoryList)
          .withOption('serverSide', true)
          .withDataProp('data')
          .withOption('rowCallback', ctrl.historyRowCallback)
          .withOption('createdRow', function (row) {
            $compile(angular.element(row).contents())($scope);
          });
      };

      ctrl.loadHistoryList = function (data, callback) {
        var orderCol = '';
        var orderDir = '';

        if (data.order.length) {
          var colIndex = data.order[data.order.length - 1].column;
          orderCol = data.columns[colIndex].name;
          orderDir = data.order[data.order.length - 1].dir;
        }

        $api.ai_booking_agent.history_list.get({
          limit: data.length,
          offset: data.start,
          order: orderCol,
          order_dir: orderDir,
          search: ctrl.historySearch
        }, function (result) {
          var payload = (result && result.data) ? result.data : {};
          callback({
            recordsTotal: payload && payload.recordsTotal ? payload.recordsTotal : 0,
            recordsFiltered: payload && payload.recordsFiltered ? payload.recordsFiltered : 0,
            data: payload && payload.data ? payload.data : [],
            draw: data.draw + 1
          });
        }, function () {
          callback({
            recordsTotal: 0,
            recordsFiltered: 0,
            data: [],
            draw: data.draw + 1
          });
        });
      };

      ctrl.historyRowCallback = function (nRow, aData) {
        $(nRow).unbind('click');
        $(nRow).bind('click', function () {
          $scope.$apply(function () {
            ctrl.openHistoryModal(aData);
          });
        });
        return nRow;
      };

      ctrl.historyDtColumns = [
        {
          name: 'created_at',
          data: null,
          title: $translate.instant('AI_AGENT_BOOKING_DATE'),
          render: function (data) {
            return (data && data.created_at ? data.created_at : '') + ' ' + (data && data.wa_instance ? '' : '(' + $translate.instant('AI_AGENT_BOOKING_WA_TESTING') + ')');
          }
        },
        {
          name: 'number',
          data: null,
          title: $translate.instant('AI_AGENT_BOOKING_NUMBER'),
          render: function (data) {
            var number = (data && data.number ? String(data.number) : '');
            if (number.indexOf('972') === 0) {
              return '0' + number.substring(3);
            }
            return number;
          }
        },
        {
          name: 'customer_name',
          data: null,
          title: $translate.instant('AI_AGENT_BOOKING_CUSTOMER'),
          render: function (data) {
            var html = '';
            var customerName = data.customer_name || data.session_customer_name;
            var customerAvatar = data.customer_avatar || data.session_avatar;
            if (customerName || customerAvatar) {
              html += '<div class="flex nowrap gap-8">'
                + '<div class="customer-pic-wrapper no-margin"><img src="' + (customerAvatar ? customerAvatar : 'assets/images/avatar.jpg') + '" alt="User Profile" class="customer-pic"></div>'
                + (customerName || '');

                if (data.customer_id) {
                  html += '<a class="btn icon green" ui-sref="app.customers.single({id: ' + data.customer_id + '})" ng-click="$event.stopPropagation()"><i class="las la-user"></i></a>';
                }

                html += '</div>';
            }
            return html;
          }
        },
        {
          name: 'status',
          data: null,
          title: $translate.instant('AI_AGENT_BOOKING_STATUS'),
          render: function (data) {
            if (!data || !data.status) {
              return '';
            }
            return $translate.instant('AI_BOOKING_SESSION_STATUS_' + String(data.status).toUpperCase());
          }
        }
      ];

      ctrl.initHistoryDtOptions();

      if ($stateParams.tab === 'history') {
        ctrl.setTab('history');
      }
    });
})();

(function () {

    angular.module('app.controllers')

        .controller('NotificationsListController', function (Notifications, $state, $user, $api, $header, $scope, $rootScope, DTOptionsBuilder, dataTablesHebrewProvider) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.tableData = Notifications && Notifications.data ? Notifications.data : [];

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "פריטים";
            $header.breadcrumbs.push({
                "title": "NOTIFICATIONS_LIST"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider).withOption('order', [[2, 'desc']]);

            ctrl.search_value = "";
            ctrl.find_table = function() {
                ctrl.tableData = Notifications && Notifications.data ? Notifications.data : [];
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                        var found = false;
                        for (var k in ctrl.tableData[i]) {
                            if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                                found = true;
                            }
                        }

                        if (found) {
                            newData.push(ctrl.tableData[i]);
                        }
                    }

                    ctrl.tableData = newData;
                }
            }

            ctrl.delete = function(id) {
                $api.notifications.remove.get({id: id}, function (response) {
                    if (response.status == "success") {
                        $state.go($state.current, {}, {reload: true});
                        $user.getNotifications();
                    }
                });
            }
        });
})();

(function(){
  angular.module('app.controllers').controller('NotesListController',
    function ($state, $header, $scope, $api, DTOptionsBuilder, $tiff_page, $uibModal, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log, $stateParams, $utils) {
      if ($rootScope.userRole == 1){
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      ctrl.search = "";
      ctrl.type = "notes";
      if ($stateParams.type) {
        ctrl.type = $stateParams.type;
      }

      $header.title = "NAV_NOTES";
      $header.breadcrumbs.push({
        "title": "NAV_NOTES"
      });

      ctrl.change_type = function(type) {
        ctrl.type = type;
        $scope.find_items();
      }

   
      $scope.find_items = function() {
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      ctrl.filter = {};
      ctrl.medical_filter = {};
      ctrl.onFilterUpdate = function(list) {
        ctrl.filter = list;
        $scope.find_items();
      }
      ctrl.onFilterMedicalUpdate = function(list) {
        ctrl.medical_filter = list;
        $scope.find_items();
      }

      ctrl.add_note = function(note) {
        $uibModal.open({
          templateUrl: "app/modules/notes/modules/notes-form/notes.form.html",
          controller: "NotesFormController",
          controllerAs: "ctrl",
          scope: $scope,
          smallModal: true,
          windowTopClass: "form-modal small-modal",
          resolve: {
            Customer: function($api) {
              return {data: note ? {id: note.customer_id, name: note.customer_name} : null};
            },
            Resources: function($api) {
              return $api.resolve("resources@get");
            },
            Note: note ? note : null,
          }
        }).result.then(function (val) {
          $('#cust_dt').DataTable().ajax.reload();
        });
      };

      ctrl.add_medical_note = function(medical_note) {
        $uibModal.open({
          templateUrl: "app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html",
          controller: "MedicalNotesFormController",
          controllerAs: "ctrl",
          scope: $scope,
          smallModal: true,
          windowTopClass: "form-modal small-modal",
          resolve: {
            Customer: function($api) {
              return {data: medical_note ? {id: medical_note.customer_id, name: medical_note.customer_name} : null};
            },
            Resources: function($api) {
              return $api.resolve("resources@get");
            },
            MedicalNote: medical_note ? medical_note : null,
            OrderLink: function() {
              return null;
            },
          }
        }).result.then(function (val) {
          $('#cust_dt').DataTable().ajax.reload();
        });
      };

      /**
       * Initiate DataTable Options
       */
      ctrl.initDtOptions = function(){
        $scope.dtOptions =
          DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            //.withOption('order', [[1, 'desc']])
            .withOption('aaSorting', [])
            .withOption('searching', false)
            .withOption('ajax', ctrl.loadList)
            .withOption('serverSide', true)
            .withDataProp('data')
            .withOption('rowCallback', ctrl.ListRawCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });
      };

      /**
       * Load customers
       *
       * @param data
       * @param callback
       * @param settings
       */
      ctrl.loadList = function (data, callback, settings) {
        var orderCol = '';
        var orderDir = '';

        if(data.order.length) {
          // Use only last order parameters
          var colIndex = data.order[data.order.length - 1].column
          var orderCol = data.columns[colIndex]['name'];
          var orderDir = data.order[data.order.length - 1].dir;
        }

        $tiff_page.start_loading('list');
        var point = ctrl.type == "notes" ? $api.notes : $api.medical_notes;
        var filter = ctrl.type == "notes" ? ctrl.filter : ctrl.medical_filter;

        point.get(
          {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.search, filter: filter},
            function (result) {
              if (result && result.data) {

                $tiff_page.stop_loading('list');

                callback({
                  recordsTotal: result.recordsTotal,
                  recordsFiltered: result.recordsFiltered,
                  data: result.data,
                  draw: data.draw + 1
                });
              }

        });
      };

      /**
       * Bind events to a new row
       *
       * @param nRow
       * @param aData
       * @param iDisplayIndex
       * @param iDisplayIndexFull
       * @returns {*}
       */
      ctrl.ListRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        if (aData.removed_at) {
          $(nRow).addClass('deleted-row');
        } else {
          $(nRow).removeClass('deleted-row');
        }

        $(nRow).unbind('click');
        $(nRow).bind('click', function() {
          $scope.$apply(function() {
            if (ctrl.type == "notes") {
              ctrl.add_note(aData);
            } else if (ctrl.type == "medical_notes") {
              ctrl.add_medical_note(aData);
            }
          });
        });
        
        return nRow;
      }

      ctrl.renderNoteText = function(text) {
        if (!text) {
          return '';
        }

        var value = String(text);
        var urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
        var html = '';
        var lastIndex = 0;
        var match;

        while ((match = urlRegex.exec(value)) !== null) {
          var url = match[0];
          var cleanUrl = url;
          var trailing = '';

          while (cleanUrl && /[.,!?;:)]$/.test(cleanUrl)) {
            trailing = cleanUrl.charAt(cleanUrl.length - 1) + trailing;
            cleanUrl = cleanUrl.substring(0, cleanUrl.length - 1);
          }

          html += $utils.escapeHtml(value.substring(lastIndex, match.index));

          if (cleanUrl) {
            var href = /^https?:\/\//i.test(cleanUrl) ? cleanUrl : 'https://' + cleanUrl;
            html += '<a href="' + $utils.escapeHtml(href) + '" ng-click="$event.stopPropagation()" target="_blank" rel="noopener noreferrer">' + $utils.escapeHtml(cleanUrl) + '</a>';
          }

          html += $utils.escapeHtml(trailing);
          lastIndex = match.index + url.length;
        }

        html += $utils.escapeHtml(value.substring(lastIndex));

        return html;
      }

      ctrl.initDtOptions();

      /**
       * Customer table column definitions
       * @type {*[]}
       */
      ctrl.dtColumns = [
        { name: 'customer_name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'customer-name',
          render: function(data, type, full, meta) {
            var html = "";
            if (data.customer_name || data.customer_avatar) {
              html += (data.customer_id ? '<a ui-sref="app.customers.single({id: ' + data.customer_id + '})" ng-click="$event.stopPropagation()">' : '') + '<div class="customer-pic-wrapper"><img src="'+(data.customer_avatar ? data.customer_avatar : 'assets/images/avatar.jpg')+'" alt="User Profile" class="customer-pic"></div>' + (data.customer_id ? '</a>' : '') + ' ';
              html += data.customer_name;
            }
            return html;
          }
        },
        { name: 'created_at', data: 'created_at_display', title: $translate('NOTES_CREATED_AT') },
        { name: 'resource_name', data: 'resource_name', title: $translate('NOTES_RESOURCE') },
        { name: 'text', data: 'text', title: $translate('NOTES_TEXT'),
          render: function(data, type, full, meta) {
            return ctrl.renderNoteText(data);
          }
        },
        { name: 'remind_at', data: 'remind_at_display', title: $translate('NOTES_REMIND_AT') },
      ];
      
      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstanceCustomers = dtInstance;
      }

    });
})();

(function() {

    angular.module("app.controllers").controller("NotesFormController", function($scope, $state, $timeout, $translate, $rootScope, Note, Resources, Customer, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.date = new Date();
        ctrl.customer_modal = Customer && Customer.data ? true : false;
        ctrl.customer_search_name = Customer && Customer.data ? Customer.data.name : "";
        ctrl.customer_selected_name = "";
        ctrl.searchCustomerResult = [];
    
        ctrl.form = {
          customer_id: Customer && Customer.data ? Customer.data.id : false,
          resource_id: "",
          text: "",
          remind_at: "",
          remind_at_date: ctrl.date,
          remind_at_time: "",
        };

        $scope.isEdit = false;

        $scope.resources = Resources.data;
        ctrl.resourceOptions = [
            {
                id: "",
                name: $translate.instant("NOTES_RESOURCE_EMPTY")
            }
        ].concat(Resources.data.map(function(resource) {
            return {
                id: String(resource.id),
                name: resource.name
            };
        }));

        ctrl.padTimeValue = function(value) {
            return value < 10 ? "0" + value : String(value);
        };

        ctrl.formatTimeValue = function(dateValue) {
            if (!dateValue) return "";
            return ctrl.padTimeValue(dateValue.getHours()) + ":" + ctrl.padTimeValue(dateValue.getMinutes());
        };

        /**
         * Initialize edit data
         */
        if(Note != null) {
            $scope.isEdit = true;
            
            ctrl.form.customer_id = Note.customer_id;
            ctrl.form.resource_id = String(Note.resource_id || '');
            ctrl.form.text = Note.text;
            ctrl.form.remind_at_date = Note.remind_at ? new Date(Note.remind_at) : ctrl.date;
            ctrl.form.remind_at_time = Note.remind_at ? ctrl.formatTimeValue(new Date(Note.remind_at)) : "";
        }

        ctrl.find_customer = function() {
            $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response){
                if (response.str == ctrl.customer_search_name) {
                    ctrl.searchCustomerResult = response.data;
                }
            });
        }

        ctrl.chooseCustomer = function(index,$event){
            ctrl.customerData = ctrl.searchCustomerResult[index];
            ctrl.form.customer_id = ctrl.customerData.id;
            ctrl.customer_selected_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.customer_search_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.searchCustomerResult = [];
            $event.stopPropagation();
        }

        ctrl.cleanCustomerSearch = function() {
            ctrl.customer_search_name = ctrl.customer_selected_name;
            $timeout(function(){
                ctrl.searchCustomerResult = [];
                }, 200);
        }

        ctrl.submit = function(){
            ctrl.form.remind_at = ctrl.combineDateTime(ctrl.form.remind_at_time, ctrl.form.remind_at_date);

            if(Note == null)
                $api.notes.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
            else
                $api.notes.single.save({
                    id: Note.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
        };

        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_NOTES_DELETE_CONFIRM_TEXT'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.notes.single.delete({id: Note.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_NOTES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $scope.$close();
                        }
                    });
            });
        };

        ctrl.combineDateTime = function(timeValue, dateTime2) {
            if (!timeValue || !dateTime2) return null;

            var timeParts = timeValue.split(':');
            var hours = parseInt(timeParts[0], 10);
            var minutes = parseInt(timeParts[1], 10);

            if (isNaN(hours) || isNaN(minutes)) return null;

            // Get day, month, and year from dateTime2 in local timezone
            dateTime2 = new Date(typeof dateTime2 === 'string' ? dateTime2.split('/').reverse().join('-') : dateTime2);
            var day = dateTime2.getDate();
            var month = dateTime2.getMonth();
            var year = dateTime2.getFullYear();

            // Create a new Date object using the local timezone
            var combinedDateTime = new Date(year, month, day, hours, minutes);

            // Adjust the combinedDateTime by the local timezone offset
            var timezoneOffset = combinedDateTime.getTimezoneOffset();
            combinedDateTime.setMinutes(combinedDateTime.getMinutes() - timezoneOffset);

            return combinedDateTime;
        };

        ctrl.buildTimeOptions = function() {
            var options = [];
            for (var hour = 0; hour < 24; hour++) {
                for (var minute = 0; minute < 60; minute += 5) {
                    var hourString = ctrl.padTimeValue(hour);
                    var minuteString = ctrl.padTimeValue(minute);
                    options.push({
                        value: hourString + ":" + minuteString,
                        label: hourString + ":" + minuteString
                    });
                }
            }
            return options;
        };

        ctrl.timeOptions = ctrl.buildTimeOptions();

    });

})();

(function() {

    angular.module("app.controllers").controller("MedicalNotesLogController", function($scope, $state, $translate, $rootScope, Log, DTOptionsBuilder, dataTablesHebrewProvider, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
    
        ctrl.list = Log.data ? Log.data : [];

        $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 100)
            .withOption('aaSorting', [])
            .withOption('searching', false);
    });

})();

(function() {

    angular.module("app.controllers").controller("MedicalNotesFormController", function($scope, $state, $timeout, $translate, $rootScope, MedicalNote, Resources, Customer, OrderLink, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.date = new Date();
        ctrl.customer_modal = Customer && Customer.data ? true : false;
        ctrl.customer_search_name = Customer && Customer.data ? Customer.data.name : "";
        ctrl.customer_selected_name = "";
        ctrl.searchCustomerResult = [];
    
        ctrl.form = {
          customer_id: Customer && Customer.data ? Customer.data.id : false,
          resource_id: "",
          text: "",
          remind_at: "",
          remind_at_date: ctrl.date,
          remind_at_time: "",
        };
        
        $scope.isEdit = false;

        $scope.resources = Resources.data;
        ctrl.resourceOptions = [
            {
                id: "",
                name: $translate.instant("NOTES_RESOURCE_EMPTY")
            }
        ].concat(Resources.data.map(function(resource) {
            return {
                id: String(resource.id),
                name: resource.name
            };
        }));

        ctrl.padTimeValue = function(value) {
            return value < 10 ? "0" + value : String(value);
        };

        ctrl.formatTimeValue = function(dateValue) {
            if (!dateValue) return "";
            return ctrl.padTimeValue(dateValue.getHours()) + ":" + ctrl.padTimeValue(dateValue.getMinutes());
        };


        /**
         * Initialize edit data
         */
        MedicalNote = MedicalNote && MedicalNote.data && MedicalNote.data.id ? MedicalNote.data : MedicalNote;
        if(MedicalNote != null) {
            $scope.isEdit = true;
            
            ctrl.form.customer_id = MedicalNote.customer_id;
            ctrl.form.resource_id = String(MedicalNote.resource_id || '');
            ctrl.form.text = MedicalNote.text;
            ctrl.form.remind_at_date = MedicalNote.remind_at ? new Date(MedicalNote.remind_at) : ctrl.date;
            ctrl.form.remind_at_time = MedicalNote.remind_at ? ctrl.formatTimeValue(new Date(MedicalNote.remind_at)) : "";
        }

        ctrl.find_customer = function() {
            $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response){
                if (response.str == ctrl.customer_search_name) {
                    ctrl.searchCustomerResult = response.data;
                }
            });
        }

        ctrl.chooseCustomer = function(index,$event){
            ctrl.customerData = ctrl.searchCustomerResult[index];
            ctrl.form.customer_id = ctrl.customerData.id;
            ctrl.customer_selected_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.customer_search_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
            ctrl.searchCustomerResult = [];
            $event.stopPropagation();
        }

        ctrl.cleanCustomerSearch = function() {
            ctrl.customer_search_name = ctrl.customer_selected_name;
            $timeout(function(){
                ctrl.searchCustomerResult = [];
                }, 200);
        }

        ctrl.submit = function(){
            ctrl.form.remind_at = ctrl.combineDateTime(ctrl.form.remind_at_time, ctrl.form.remind_at_date);

            if(MedicalNote == null)
                $api.medical_notes.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        var noteId = response.id;
                        var closeModal = function() {
                            swal({
                                title: $translate.instant('SWAL_NOTES_SAVE_TITLE'),
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $scope.$close();
                        };
                        if (OrderLink && OrderLink.order_id && noteId) {
                            $api.orders.link_medical_note.save({ id: OrderLink.order_id }, { medical_note_id: noteId }, function () {
                                closeModal();
                            }, function () {
                                closeModal();
                            });
                        } else if (OrderLink && typeof OrderLink.onMedicalNoteCreated === 'function' && noteId) {
                            OrderLink.onMedicalNoteCreated(noteId);
                            closeModal();
                        } else {
                            closeModal();
                        }
                    }
                });
            else
                $api.medical_notes.single.save({
                    id: MedicalNote.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_NOTES_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $scope.$close();
                    }
                });
        };

        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_NOTES_DELETE_CONFIRM_TEXT'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.medical_notes.single.delete({id: MedicalNote.id}, function(response) {
                        if(response.status == "success") {
                            var done = function() {
                                swal({
                                    title: $translate.instant('SWAL_NOTES_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $scope.$close();
                            };
                            if (OrderLink && OrderLink.order_id) {
                                $api.orders.link_medical_note.save({ id: OrderLink.order_id }, { medical_note_id: null }, function () {
                                    done();
                                }, function () {
                                    done();
                                });
                            } else if (OrderLink && typeof OrderLink.onMedicalNoteUnlinked === 'function') {
                                OrderLink.onMedicalNoteUnlinked();
                                done();
                            } else {
                                done();
                            }
                        }
                    });
            });
        };

        ctrl.combineDateTime = function(timeValue, dateTime2) {
            if (!timeValue || !dateTime2) return null;

            var timeParts = timeValue.split(':');
            var hours = parseInt(timeParts[0], 10);
            var minutes = parseInt(timeParts[1], 10);

            if (isNaN(hours) || isNaN(minutes)) return null;

            // Get day, month, and year from dateTime2 in local timezone
            dateTime2 = new Date(typeof dateTime2 === 'string' ? dateTime2.split('/').reverse().join('-') : dateTime2);
            var day = dateTime2.getDate();
            var month = dateTime2.getMonth();
            var year = dateTime2.getFullYear();

            // Create a new Date object using the local timezone
            var combinedDateTime = new Date(year, month, day, hours, minutes);

            // Adjust the combinedDateTime by the local timezone offset
            var timezoneOffset = combinedDateTime.getTimezoneOffset();
            combinedDateTime.setMinutes(combinedDateTime.getMinutes() - timezoneOffset);

            return combinedDateTime;
        };

        ctrl.buildTimeOptions = function() {
            var options = [];
            for (var hour = 0; hour < 24; hour++) {
                for (var minute = 0; minute < 60; minute += 5) {
                    var hourString = ctrl.padTimeValue(hour);
                    var minuteString = ctrl.padTimeValue(minute);
                    options.push({
                        value: hourString + ":" + minuteString,
                        label: hourString + ":" + minuteString
                    });
                }
            }
            return options;
        };

        ctrl.timeOptions = ctrl.buildTimeOptions();

    });

})();

(function() {

    angular.module("app.controllers").controller("AutomationsFormController", function($scope, $cfilter, $resource, $cookies, $state, dates, $api, $timeout, Automation, DigitalForms, CustomerStatuses, $rootScope, $translate, $user) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {
            "name": "",
            "trigger": "",
            "order_status": "",
            "birthday_time": null,
            "send_message": true,
            "active": true,
            "recommendation": false,
            "digital_form_id": '',
            "notify_type": "email",
            "notify_text": "",
            "remind_type": "",
            "remind_time": "",
            "timetype": "minutes",
            "filter": {},
            "files": [],
            "once": false,
            "last": false,
            "change_customer_status": false,
            "status_id": 0,
        };

        $scope.datesProvider = dates;

        var fileElement = null;

        $scope.isEdit = false;
        $scope.automationId = false;
        ctrl.triggers = [
            { id:'cashbox_sell', name: $translate.instant('AUTOMATION_TRIGGER_CASHBOX_SELL'), after: true, before: false, now: false },
            { id:'order_date', name: $translate.instant('AUTOMATION_TRIGGER_ORDER_DATE'), after: true, before: true, now: true },
            { id:'status', name: $translate.instant('AUTOMATION_TRIGGER_STATUS'), after: true, before: false, now: false },
            { id:'order_status', name: $translate.instant('AUTOMATION_TRIGGER_ORDER_STATUS'), after: true, before: false, now: false },
            { id:'birthday', name: $translate.instant('AUTOMATION_TRIGGER_BIRTHDAY'), after: true, before: true, now: false },
        ];

        ctrl.orderStatuses = [
            { name: $translate.instant('ORDER_STATUS_OPEN'), value: '0,2' },
            { name: $translate.instant('ORDER_STATUS_CANCELLED'), value: '1' },
            { name: $translate.instant('ORDER_STATUS_PAID'), value: '3' },
            { name: $translate.instant('ORDER_STATUS_CUSTOMER_BOOKED'), value: '4' },
        ];
        ctrl.notifyTypeOptions = [
            {id: 'email', name: $translate.instant('AUTOMATION_CUSTOMER_NOTIFY_TYPE_EMAIL')},
            {id: 'sms', name: $translate.instant('AUTOMATION_CUSTOMER_NOTIFY_TYPE_SMS')}
        ];
        ctrl.timeTypeOptions = [
            {id: 'minutes', name: $translate.instant('AUTOMATION_CUSTOMER_TIMETYPE_MINUTES')},
            {id: 'hours', name: $translate.instant('AUTOMATION_CUSTOMER_TIMETYPE_HOURS')},
            {id: 'days', name: $translate.instant('AUTOMATION_CUSTOMER_TIMETYPE_DAYS')}
        ];

        ctrl.wa_status = $cookies.get("wa_status");
        if (ctrl.wa_status == 'authorized') {
            ctrl.notifyTypeOptions.push({id: 'wa', name: $translate.instant('AUTOMATION_CUSTOMER_NOTIFY_TYPE_WA')});
        }

        $scope.uploadFile = function(element){
            ctrl.form.files = element.files;
            fileElement = element;
            $scope.$apply();
        };

        ctrl.digitalForms = DigitalForms ? DigitalForms.data : [];
        ctrl.customerStatuses = CustomerStatuses ? CustomerStatuses.data : [];
        ctrl.remindTypeOptions = [];
        ctrl.updateRemindTypeOptions = function () {
            var opts = [];
            if (ctrl.checkRemindType('before')) {
                opts.push({id: 'before', name: $translate.instant('AUTOMATION_CUSTOMER_REMIND_TYPE_BEFORE')});
            }
            if (ctrl.checkRemindType('after')) {
                opts.push({id: 'after', name: $translate.instant('AUTOMATION_CUSTOMER_REMIND_TYPE_AFTER')});
            }
            if (ctrl.checkRemindType('now')) {
                opts.push({id: 'now', name: $translate.instant('AUTOMATION_CUSTOMER_REMIND_TYPE_NOW')});
            }
            ctrl.remindTypeOptions = opts;
        };

        /**
         * Filter
        */
        $rootScope.automations_filter = {};

        /**
         * Initialize edit data
         */
        if(Automation != null) {
            $scope.isEdit = true;

            $scope.automationId = Automation.data.id;

            ctrl.form.name = Automation.data.name;
            ctrl.form.trigger = Automation.data.trigger;
            ctrl.form.order_status = Automation.data.order_status;
            if (Automation.data.birthday_time) {
                var parts = Automation.data.birthday_time.split(':'); // ['05', '04']
                var date = new Date();
                date.setHours(parseInt(parts[0], 10));
                date.setMinutes(parseInt(parts[1], 10));
                date.setSeconds(0);
                date.setMilliseconds(0);
                ctrl.form.birthday_time = date;
            } else {
                ctrl.form.birthday_time = null;
            }

            ctrl.form.send_message = Automation.data.send_message;
            ctrl.form.active = Automation.data.active;
            ctrl.form.recommendation = Automation.data.recommendation;
            ctrl.form.once = Automation.data.once;
            ctrl.form.last = Automation.data.last;
            ctrl.form.notify_type = Automation.data.notify_type;
            ctrl.form.notify_text = Automation.data.notify_text;
            ctrl.form.remind_type = Automation.data.remind_type;
            ctrl.form.remind_time = Automation.data.remind_time;
            ctrl.form.timetype = Automation.data.timetype;
            ctrl.form.digital_form_id = Automation.data.digital_form_id ? Automation.data.digital_form_id : '';
            ctrl.form.filter = Automation.data.filter ? JSON.parse(Automation.data.filter) : {};
            ctrl.form.files = Automation.data.files ? JSON.parse(Automation.data.files) : {};

            ctrl.form.change_customer_status = Automation.data.change_customer_status;
            ctrl.form.status_id = Automation.data.status_id;

            $rootScope.automations_filter = ctrl.form.filter;
        }

        ctrl.isMobile = (angular.element(document).width() < 769);

        ctrl.checkRemindType = function(type) {
            for (var i in ctrl.triggers) {
                if (ctrl.triggers[i].id == ctrl.form.trigger) {
                    if (ctrl.form.remind_type == type && !ctrl.triggers[i][type]) {
                        ctrl.form.remind_type = "";
                    }
                    return ctrl.triggers[i][type];
                }
            }
            return false;
        }

        ctrl.displayRemindType = true;
        
        $scope.$watch('ctrl.form.trigger', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                ctrl.displayRemindType = false;
                $timeout(function() {
                    ctrl.displayRemindType = true;
                });
            }
            ctrl.updateRemindTypeOptions();
        });
        ctrl.updateRemindTypeOptions();

        ctrl.variables = {
            'customer_name' : "[the customer's name]",
            "customer_name|he" : "[שם הלקוח]",
            'businesses_name' : "[name of the business]",
            "businesses_name|he" : "[שם בית העסק]",
        };

        ctrl.insertVariable = function(code) {
            code = $user.currentLanguage == 'hb_ISR' ? code+'|he' : code;
            var variable = ctrl.variables[code] ? ctrl.variables[code] : '['+code+']';

            var textarea = document.querySelector('#categories-form textarea[name="notify_text"]');
            if (textarea) {
                var start = textarea.selectionStart || 0;
                var end = textarea.selectionEnd || 0;
                var text = (textarea.value !== undefined && textarea.value !== null) ? textarea.value : (ctrl.form.notify_text || '');
                var newText = text.substring(0, start) + variable + text.substring(end);
                ctrl.form.notify_text = newText;
                $timeout(function() {
                    textarea.focus();
                    var newPos = start + variable.length;
                    textarea.setSelectionRange(newPos, newPos);
                }, 10);
            } else {
                ctrl.form.notify_text = (ctrl.form.notify_text || '') + variable;
            }
        }

        ctrl.submit = function(){
            ctrl.form.filter = $rootScope.automations_filter || {};

            if (ctrl.form.name == '' || ctrl.form.trigger == '' || (ctrl.form.change_customer_status && ctrl.form.status_id == 0)) {
                return;
            }

            var fdata = new FormData();
            if (fileElement && fileElement.files && fileElement.files.length > 0) {
                fdata.append("file", fileElement.files[0]);
            } else if (ctrl.form.files && ctrl.form.files.length > 0) {
                fdata.append("uploaded_file", JSON.stringify(ctrl.form.files));
            } else {
                fdata.append("uploaded_file", '');
            }
            
            fdata.append("name", ctrl.form.name);
            fdata.append("trigger", ctrl.form.trigger);
            fdata.append("order_status", ctrl.form.order_status);
            if (ctrl.form.birthday_time instanceof Date) {
                var hours = ctrl.form.birthday_time.getHours();
                var minutes = ctrl.form.birthday_time.getMinutes();
                if (hours < 10) hours = '0' + hours;
                if (minutes < 10) minutes = '0' + minutes;

                fdata.append("birthday_time", hours + ':' + minutes);
            } else {
                fdata.append("birthday_time", '');
            }
            fdata.append("send_message", ctrl.form.send_message);
            fdata.append("active", ctrl.form.active);
            fdata.append("recommendation", ctrl.form.recommendation);
            fdata.append("once", ctrl.form.once);
            fdata.append("last", ctrl.form.last);
            fdata.append("notify_type", ctrl.form.notify_type);
            fdata.append("notify_text", ctrl.form.notify_text);
            fdata.append("remind_type", ctrl.form.remind_type);
            fdata.append("remind_time", ctrl.form.remind_time == null ? '' : ctrl.form.remind_time);
            fdata.append("digital_form_id", ctrl.form.digital_form_id ? ctrl.form.digital_form_id : '');
            fdata.append("timetype", ctrl.form.timetype);
            fdata.append("change_customer_status", ctrl.form.change_customer_status);
            fdata.append("status_id", ctrl.form.status_id);
            fdata.append("filter", JSON.stringify(ctrl.form.filter));

            $resource($api.baseURL + '/automations'+((Automation == null) ? '' : '/id/:id'), ((Automation == null) ? {} : {id: Automation.data.id}), {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                if(response.status == "success") {
                    if(Automation == null) {
                        swal({
                            title: $translate.instant('SWAL_AUTOMATIONS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.marketing.automations", {}, {reload: true});
                    } else {
                        swal({
                            title: $translate.instant('SWAL_AUTOMATIONS_SAVE_EDIT_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.marketing.automations", {id: Automation.data.id}, {reload: true});
                    }
                }
            }, function(error){
                console.log(error);
            });
        };

        
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_AUTOMATIONS_DELETE_CONFIRM_TEXT').replace('[name]', Automation.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.automations.single.delete({id: Automation.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_AUTOMATIONS_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.marketing.automations", {}, {reload: true});
                        }
                    });
            });
        };


        $cfilter.apply('automations');
    });

})();

(function () {
  angular.module('app.controllers').controller('DigitalFormsAllListController',
    function ($state, $header, $scope, $api, DTOptionsBuilder, $tiff_page, $uibModal, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      var ctrl = this;
      ctrl.search = "";

      $header.title = "NAV_DIGITAL_FORMS";
      $header.breadcrumbs.push({
        "title": "NAV_DIGITAL_FORMS"
      });

      /**
         * search customer
         */
      $scope.find_items = function () {
        if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
          $('#cust_dt').DataTable().ajax.reload();
        }
      }

      ctrl.newForm = function () {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
          controller: "CustomersDigitalFormsAddController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal laser-file-modal",
          resolve: {
            DigitalForms: ['$api', function ($api) {
              return $api.resolve("digital_forms@get");
            }],
            Customer: null,
            DigitalForm: null,
            Order: null,
            OrderForm: false
          }
        }).result.then(function (result) {
          if (result) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        });
      }

      ctrl.add_digital_form = function (digital_form) {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
          controller: "CustomersDigitalFormsController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal laser-file-modal",
          resolve: {
            Customer: digital_form && digital_form.customer_id ? ['$api', function ($api) {
                return $api.resolve('customers.single@get', { id: digital_form.customer_id });
              }
            ] : null,
            DigitalForm: digital_form ? ['$api', function ($api) {
                return $api.resolve('customer_forms@get', { id: digital_form.id });
              }
            ] : null,
            DigitalForms: null,
            Business: [ '$api', function ($api) {
                return $api.resolve('settings.info@get');
              }
            ],
            Order: null
          }
        }).result.then(function (val) {
          $('#cust_dt').DataTable().ajax.reload();
        });
      };

      /**
       * Initiate DataTable Options
       */
      ctrl.initDtOptions = function () {
        $scope.dtOptions =
          DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            //.withOption('order', [[1, 'desc']])
            .withOption('aaSorting', [])
            .withOption('searching', false)
            .withOption('ajax', ctrl.loadList)
            .withOption('serverSide', true)
            .withDataProp('data')
            .withOption('rowCallback', ctrl.ListRawCallback)
            .withOption('createdRow', function (row, data, dataIndex) {
              // Recompiling so we can bind Angular directive to the DT
              $compile(angular.element(row).contents())($scope);
            });
      };

      /**
       * Load Digital Forms
       *
       * @param data
       * @param callback
       * @param settings
       */
      ctrl.loadList = function (data, callback, settings) {
        var orderCol = '';
        var orderDir = '';

        if (data.order.length) {
          // Use only last order parameters
          var colIndex = data.order[data.order.length - 1].column
          var orderCol = data.columns[colIndex]['name'];
          var orderDir = data.order[data.order.length - 1].dir;
        }

        $tiff_page.start_loading('list');

        $api.digital_forms.all.save({
          limit: data.length,
          offset: data.start,
          order: orderCol,
          order_dir: orderDir,
          search: ctrl.search
        }, function (result) {
          if (result && result.data) {
            $tiff_page.stop_loading('list');

            callback({
              recordsTotal: result.recordsTotal,
              recordsFiltered: result.recordsFiltered,
              data: result.data,
              draw: data.draw + 1
            });
          }
        });
      };

      /**
       * Bind events to a new row
       *
       * @param nRow
       * @param aData
       * @param iDisplayIndex
       * @param iDisplayIndexFull
       * @returns {*}
       */
      ctrl.ListRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        //console.log(aData)
        $(nRow).unbind('click');
        $(nRow).bind('click', function () {
          $scope.$apply(function () {
            ctrl.add_digital_form(aData);
          });
        });

        return nRow;
      }

      ctrl.initDtOptions();

      /**
       * Customer table column definitions
       * @type {*[]}
       */
      ctrl.dtColumns = [
        {
          name: 'customer_name', data: null, title: $translate('CUSTOMER_FORMS_CUSTOMER_NAME'), class: 'customer-name',
          render: function (data, type, full, meta) {
            var html = "";
            if (data.customer_name || data.customer_avatar) {
              html += '<div class="customer-pic-wrapper"><img src="' + (data.customer_avatar ? data.customer_avatar : 'assets/images/avatar.jpg') + '" alt="User Profile" class="customer-pic"></div> ';
              html += data.customer_name;
            }
            return html;
          }
        },
        { name: 'name', data: 'name', title: $translate('CUSTOMER_FORMS_NAME') },
        { name: 'date', data: 'date_display', title: $translate('CUSTOMER_FORMS_DATE') },
        { name: 'fill_date', data: 'fill_date_display', title: $translate('CUSTOMER_FORMS_FILL_DATE') },
        { name: 'icons', orderable: false,
          render: function (data, type, full, meta) {
            var html = '<div class="buttons-box">';
            html += '<button tooltip="' + $translate.instant('CUSTOMERS_DF_PDF_TOOLTIP') + '" class="have-tooltip green btn icon circle large single-model-message" ng-click="$event.stopPropagation(); ctrl.send_form(' + full.id + ')">';
            html += '<i class="las la-file-pdf"></i>';
            html += '</button>';
            html += '<button tooltip="' + $translate.instant('CUSTOMERS_DF_PRINT_TOOLTIP') + '" class="have-tooltip blue btn icon circle large single-model-message" ng-click="$event.stopPropagation(); ctrl.print_form(' + full.id + ')">';
            html += '<i class="las la-print"></i>';
            html += '</button>';
            html += '</div>';
            return html;
          }
        },
        { name: 'remove', orderable: false,
          render: function (data, type, full, meta) {
            var html = '<div class="buttons-box">';
            html += '<button class="btn text border-red" ng-click="ctrl.removeForm(' + full.id + '); $event.stopPropagation()">' + $translate.instant('SETTINGS_INFO_REMOVE') + '</button>';
            html += '</div>';
            return html;
          }
        },
      ];

      ctrl.dtInstanceCallback = function (dtInstance) {
        ctrl.dtInstanceCustomers = dtInstance;
      }

      ctrl.removeForm = function (form_id) {
        swal({
          title: "",
          text: $translate.instant('SWAL_CUSTOMER_DELETE_CONFIRM_TEXT'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          confirmButtonClass: "btn-danger",
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            $api.customer_forms.delete({ id: form_id }, function (response) {
              if (response.status == "success") {
                ctrl.dtInstanceCustomers.reloadData(null, false)
              }
            });
          }
        });
      }

      ctrl.print_form = function (form_id) {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html",
          controller: "CustomersDigitalFormsPrintController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal laser-file-modal",
          resolve: {
            DigitalForm: function ($api, $stateParams, $rootScope) {
              $rootScope.$stateParams = $stateParams;
              return $api.resolve("customer_forms@get", { "id": form_id });
            }
          }
        });
      };

      ctrl.send_form = function (form_id) {
        $api.customer_forms.pdf.save({ id: form_id }, function (response) {
          if (response.status == "success") {
            swal({
              title: $translate.instant('SWAL_CUSTOMER_FORM_SEND_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      };
    });
})();

(function(){
    angular.module('app.controllers').controller('LeadsListController',
      function ($state, $header, $scope, $api, $user, $cfilter, Statuses, Resources, dates, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $rootScope, $translate, $compile, $timeout, $utils) {
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        
        ctrl.dtInstance = {};
        ctrl.statuses = Statuses.data;
        ctrl.resources = Resources.data;
        ctrl.resourceLeadOptions = [{
          id: '',
          name: $translate.instant('CUSTOMERS_RESOURSE')
        }].concat((ctrl.resources || []).filter(function (resource) {
          return resource && resource.sales_active;
        }).map(function (resource) {
          return {
            id: String(resource.id),
            name: resource.name
          };
        }));
        ctrl.statusOptions = [{
          id: '',
          name: $translate.instant('CUSTOMERS_STATUS'),
          color: ''
        }].concat((ctrl.statuses || []).map(function (status) {
          return {
            id: String(status.id),
            name: status.name,
            color: status.color || ''
          };
        }));

        ctrl.customer_name = $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.search : "";
        ctrl.show_deleted = $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.deleted : false;
        ctrl.entriesPerPage = $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.limit : "20";

        ctrl.fieldSettings = ($rootScope.$user && $rootScope.$user.table_columns && $rootScope.$user.table_columns.leads) ? $rootScope.$user.table_columns.leads : [];
        var unwatchUser = $scope.$watch(function() {
          return $rootScope.$user;
        }, function(newUser) {
          if (newUser && newUser.table_columns && newUser.table_columns.leads) {
            ctrl.fieldSettings = newUser.table_columns.leads;
            ctrl.updateDtColumns();
            if (unwatchUser) {
              unwatchUser();
            }
          }
        }, true);

        $scope.datesProvider = dates;

        $header.title = "NAV_LEADS";
        $header.breadcrumbs.push({
          "title": "NAV_LEADS"
        });

        ctrl.onFieldsUpdate = function(fieldsList) {
          ctrl.fieldSettings = fieldsList;
          $api.settings.table_columns.save({section: 'leads', columns: fieldsList}, function(response) {
            if (response.status == 'success') {
              $rootScope.$user.table_columns.leads = fieldsList;
              ctrl.updateDtColumns();
            }
          }, function(response) {
            console.error('Failed to save table columns', response);
          });
        };

        /**
         * Open customer data
         *
         * @param customerData
         */
        ctrl.open_customer_card = function (customerData) {
          $state.transitionTo("app.leads.single", {
            "id": customerData.id
          }, {
            reload: false
          });
        };

        ctrl.download_in_progress = false;
        /**
         * Download customer data
         *
         */
        ctrl.downloadCustomerData = function () {
          var opts = $rootScope.lead_page_data_options || {};

          var colIndex = opts.order;
          var orderDir = opts.order_dir ? opts.order_dir : '';
          var orderCol = '';

          if (colIndex != null && orderDir != '' && ctrl.dtColumns[colIndex]) {
            orderCol = ctrl.dtColumns[colIndex].name;
          }

          var filter = $rootScope.leads_filter || {};

          ctrl.download_in_progress = true;
          $api.customers.download.download(
            {order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted * 1, leads: true, filter: filter}
            , function success(response) {
              ctrl.download_in_progress = false;

              var blob = new Blob([response.data], { type: 'text/csv;charset=UTF-8' });

              var cd = response.headers('Content-Disposition') ||
                       response.headers('content-disposition') ||
                       '';

              var match = /filename="?([^"]+)"?/.exec(cd);
              var filename = match && match[1] ? match[1] : 'leads.csv';

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }, function error(err) {
              ctrl.download_in_progress = false;
              console.error('Download failed', err);
            }
          );
        };

        /**
         * search customer
         */
        $scope.find_customer = function() {
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Initiate DataTable Options
         */
        ctrl.initDtOptions = function(){
          var initialOrder = [];
          if ($rootScope.lead_page_data_options && $rootScope.lead_page_data_options.order_dir) {
            var columnIndex = $rootScope.lead_page_data_options.order; 
            var orderDirection = $rootScope.lead_page_data_options.order_dir;
            initialOrder = [[columnIndex, orderDirection]];
          }
          
          $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', ctrl.entriesPerPage)
              .withOption('order', initialOrder)
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('displayStart', $rootScope.lead_page_data_options ? $rootScope.lead_page_data_options.offset : 0)
              .withOption('ajax', ctrl.loadCustomers)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('rowCallback', ctrl.customerRawCallback)
              .withOption('initComplete', function() {
                $("#custom-pagination-container").find("#cust_dt_info").remove();
                $("#custom-pagination-container").find("#cust_dt_paginate").remove();
                $("#cust_dt_info").prependTo("#custom-pagination-container");
                $("#cust_dt_paginate").prependTo("#custom-pagination-container");
              })
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.change_deleted = function () {
          ctrl.initDtOptions();
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Load customers
         *
         * @param data
         * @param callback
         * @param settings
         */
        ctrl.loadCustomers = function (data, callback, settings) {
          var orderCol = '';
          var orderDir = '';
          var colIndex = 0;

          if(data.order.length) {
            // Use only last order parameters
            colIndex = data.order[data.order.length - 1].column
            orderCol = data.columns[colIndex]['name'];
            orderDir = data.order[data.order.length - 1].dir;
          }

          //remember current position
          $rootScope.lead_page_data_options = {
            limit: data.length,
            offset: data.start,
            order: colIndex,
            order_dir: orderDir,
            search: ctrl.customer_name,
            deleted: ctrl.show_deleted*1
          };
          var filter = $rootScope.leads_filter || {};

          callback({recordsTotal:0, recordsFiltered: 0, data: [], draw: data.draw+1});
          $scope.module_is_loading = true;
          $api.customers.list.get(
            {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted*1, leads: true, filter: filter}
            , function (result) {
              $scope.module_is_loading = false;
            if (result && result.data) {

              callback({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: result.data,
                draw: data.draw + 1
              });
            }

          });
        };

        ctrl.moveToCustomers = function(id) {
          $api.customers.movelead.get({id: id}, function(response) {
            if(response.status == "success") {
              $state.transitionTo("app.leads", {}, {reload: true});
            }
          });
        };

        /**
         * Bind events to a new row
         *
         * @param nRow
         * @param aData
         * @param iDisplayIndex
         * @param iDisplayIndexFull
         * @returns {*}
         */
        ctrl.customerRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $(nRow).unbind('click').bind('click', function (event) {
            // Prevent click event from firing when clicking on select dropdown
            if ($(event.target).closest('select, .prevent-click').length) {
                event.stopPropagation(); // Stop the event from bubbling up to the row click handler
            } else {
                $scope.$apply(function() {
                    ctrl.open_customer_card(aData);
                });
            }
          });
          return nRow;
        }

        if (window.innerWidth < 768) {
          $.fn.DataTable.ext.pager.numbers_length = 3;
        }

        ctrl.initDtOptions();
        $scope.customerStatuses = {};
        $scope.customerResources = {};

        /**
         * Customer table column definitions
         * @type {*[]}
         */
        var originalColumnDefinitions = {
          'name': {
            name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125 w-100',
            render: function(data, type, full, meta) {
              var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
              var repeat = data.repeat_at ? '<span class="repeat-at"><i class="las la-sync"></i></span>' : '';
              var html = '<div class="customer-pic-outer"><div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>'+repeat+'</div>';
              html+= '<b>';
              html+= data.firstname ? ' ' + data.firstname : '';
              html+= data.lastname ? ' ' + data.lastname : '';
              html+= '</b>';
              return '<div class="flex nowrap">'+html+'</div>';
            }
          },
          'phone': {
            name: 'phone', data: null, title: $translate('CUSTOMERS_PHONE'), class: 'customer-phone',
            render: function(data, type, full, meta) {
              return "<span class='nowrap'>"+(data.phone ? data.phone : '')+"</span>";
            }
          },
          'date': {
            name: 'date', data: null, title: $translate('CUSTOMERS_DATE'), class: 'customer-date',
            render: function(data, type, full, meta) {
              return "<span class='nowrap'>"+data.date+"</span>";
            }
          },
          'resource_lead_name': {
            name: 'resource_lead_name', data: null, title: $translate('CUSTOMERS_RESOURSE'), class: 'customer-resources',
            render: function(data, type, full, meta) {
              //return data.resource_lead_name ? data.resource_lead_name : '';
              $scope.customerResources[data.id] = String(data.resource_id || '');
              return '<div class="form-group prevent-click">'
                +'<app-dropdown model="customerResources[' + data.id + ']"'
                  +' options="ctrl.resourceLeadOptions"'
                  +' value-prop="id"'
                  +' label-prop="name"'
                  +' fixed-panel="true"'
                  +' placeholder="{{\'CUSTOMERS_RESOURSE\' | translate}}"'
                  +' on-change="ctrl.updateData(' + data.id + ', {resource_lead: model})">'
                +'</app-dropdown></div>';
            }
          },
          'statuses_name': {
            name: 'statuses_name', data: null, title: $translate('CUSTOMERS_STATUS'), class: 'customer-status',
            render: function(data, type, full, meta) {
              //return data.statuses_name ? '<span class="btn btn-primary btn-xs category-item" style="background-color: '+ctrl.hexToRgbA(data.statuses_color ? data.statuses_color : '#a9cfe8')+'">'+data.statuses_name+'</span>' : '';
              $scope.customerStatuses[data.id] = String(data.status_id || '');
              return '<div class="form-group form-list prevent-click">'
                +'<app-dropdown model="customerStatuses[' + data.id + ']"'
                  +' options="ctrl.statusOptions"'
                  +' value-prop="id"'
                  +' label-prop="name"'
                  +' color-prop="color"'
                  +' fixed-panel="true"'
                  +' placeholder="{{\'CUSTOMERS_STATUS\' | translate}}"'
                  +' on-change="ctrl.updateData(' + data.id + ', {status_id: model})">'
                +'</app-dropdown></div>';
            }
          },
          'arrival_source': {
            name: 'arrival_source', data: null, title: $translate('CUSTOMER_ARRIVAL_SOURCE'), class: 'customer-arrivalsource hidden-xs',
            render: function(data, type, full, meta) {
              return data.arrival_source;
            }
          },
          'desktop_icons': {
            name: 'desktop_icons', data: null, title: '', orderable: false, class: 'desktop-icons-column',
            render: function (data, type, full, meta) {
              var add_details = '<div class="customers_add_details icons desktop">';

              if (data.oncredit > 0) {
                add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
              }
              if (data.has_cards) {
                add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
              }
              if ((data.has_color)) {
                add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
          'icons': {
            name: 'icons',
            sortable: false,
            data: null,
            title: '',
            class: 'customer-icons',
            render: function (data, type, full, meta) {
              var add_details = '';
              add_details += '<div class="customers_call_details icons" style="'+(((data.oncredit > 0 || data.has_cards || data.has_color) && window.innerWidth < 768) ? 'margin-top: 22px;' : '')+'">';

              if (data.phone) {
                var phone = data.phone;
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                phone = '+972'+phone;

                add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
              }

              if ($rootScope.lead_appearence === 0) {
                add_details += window.innerWidth < 768 ? '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation(); ctrl.moveToCustomers('+data.id+')" ><i class="las la-users"></i></a>' : '';
                add_details += window.innerWidth >= 768 ? '<button class="btn text primary" ng-click="d(); $event.stopPropagation(); ctrl.moveToCustomers('+data.id+')">'+$translate.instant('CUSTOMERS_MAKE_CUSTOMER')+'</button>' : '';
              }

              add_details += '</div>';

              return add_details;
            }
          },
          'gender': {
            name: 'gender', data: null, title: $translate('CUSTOMERS_GENDER'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.gender) {
                case 0:
                  return $translate.instant('CUSTOMERS_GENDER_MALE');
                case 1:
                  return $translate.instant('CUSTOMERS_GENDER_FEMALE');
                default:
                  return $translate.instant('CUSTOMERS_GENDER_NOT_SET');
              }
            }
          },
          'send_notifications': {
            name: 'send_notifications', data: null, title: $translate('SETTINGS_USER_SEND_MESSAGES'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.send_notifications) {
                case 0:
                  return $translate.instant('SETTINGS_USER_REMINDER_NO');
                case 1:
                  return $translate.instant('CUSTOMER_SETTING_EMAIL');
                case 2:
                  return $translate.instant('CUSTOMERS_SMS');
                case 3:
                  return $translate.instant('CUSTOMERS_WHATSAPP');
                default:
                  return '';
              }
            }
          },
          'send_reminder': {
            name: 'send_reminder', data: null, title: $translate('SETTINGS_USER_SEND_REMINDER'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.send_reminder) {
                case 0:
                  return $translate.instant('SETTINGS_USER_REMINDER_NO');
                case 2:
                  return $translate.instant('SETTINGS_USER_REMINDER_2_HOURS');
                case 4:
                  return $translate.instant('SETTINGS_USER_REMINDER_4_HOURS');
                case 24:
                  return $translate.instant('SETTINGS_USER_REMINDER_24_HOURS');
                case 48:
                  return $translate.instant('SETTINGS_USER_REMINDER_48_HOURS');
                case 72:
                  return $translate.instant('SETTINGS_USER_REMINDER_72_HOURS');
                case 168:
                  return $translate.instant('SETTINGS_USER_REMINDER_168_HOURS');
                default:
                  return '';
              }
            }
          },
          'reminder_send_type': {
            name: 'reminder_send_type', data: null, title: $translate('CUSTOMERS_SEND_REMINDER'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.reminder_send_type) {
                case 1:
                  return $translate.instant('SETTINGS_USER_MAIL');
                case 2:
                  return $translate.instant('CUSTOMERS_SMS');
                case 3:
                  return $translate.instant('CUSTOMERS_WHATSAPP');
                default:
                  return '';
              }
            }
          },
          'request_order_confirmation': {
            name: 'request_order_confirmation', data: null, title: $translate('SETTINGS_USER_SEND_ORDER_CONFIRMATION'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              return data.request_order_confirmation == 0 ? $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO') : $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES');
            }
          },
          'send_documents': {
            name: 'send_documents', data: null, title: $translate('CUSTOMERS_SEND_DOCUMENTS'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.send_documents) {
                case 0:
                  return $translate.instant('SETTINGS_USER_REMINDER_NO');
                case 1:
                  return $translate.instant('CUSTOMER_SETTING_EMAIL');
                case 2:
                  return $translate.instant('CUSTOMERS_SMS');
                case 3:
                  return $translate.instant('CUSTOMERS_WHATSAPP');
                case 4:
                  return $translate.instant('CUSTOMERS_PRINT');
                default:
                  return '';
              }
            }
          },
          'self_order': {
            name: 'self_order', data: null, title: $translate('CUSTOMERS_IND_ORD'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              return data.self_order == 0 ? $translate.instant('CUSTOMERS_UNAUTHORIZED') : $translate.instant('CUSTOMERS_ALLOWED');
            }
          },
          'group_notifications': {
            name: 'group_notifications', data: null, title: $translate('CUSTOMERS_GROUP_MESS'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              return data.group_notifications == 0 ? $translate.instant('CUSTOMERS_OFF') : $translate.instant('CUSTOMERS_ACTIVE');
            }
          },
          'last_note': {
            name: 'last_note', data: null, title: $translate('CUSTOMERS_LAST_NOTE'), hide: true, sortable: false, class: 'last-note-column',
            render: function(data, type, full, meta) {
              return data.last_note ? data.last_note : '';
            }
          },
          'last_note_remind_at': {
            name: 'last_note_remind_at', data: null, title: $translate('CUSTOMERS_LAST_NOTE_REMIND_AT'), hide: true, sortable: false, class: 'last-note-remind-at-column',
            render: function(data, type, full, meta) {
              if (!data.last_note_remind_at) {
                return '';
              }
              try {
                var remindDate = moment(data.last_note_remind_at);
                if (remindDate.isValid()) {
                  return remindDate.format('DD/MM/YYYY HH:mm');
                }
              } catch (e) {
                // Fall through to default handling
              }
              return data.last_note_remind_at;
            }
          },
        };



        function createSimpleColumn(name, translationKey, fieldType, customFieldId) {
          // For custom fields, translationKey is the actual field name, not a translation key
          // For regular fields, translationKey is a translation key that needs to be translated
          var isCustomField = name && name.indexOf('custom_field_') === 0;
          var title = isCustomField ? translationKey : $translate(translationKey);
          
          return {
            name: name,
            data: null,
            title: title,
            sortable: false,
            class: 'default-custom-column',
            render: function(data, type, full, meta) {
              if (!data || !data[name]) {
                return '';
              }
              
              var value = data[name];
              
              // Handle custom field types
              if (fieldType === 'date' && value) {
                try {
                  // Handle ISO date strings or timestamps
                  var dateValue = moment(value);
                  if (dateValue.isValid()) {
                    return dateValue.format('DD/MM/YYYY');
                  }
                } catch (e) {
                  // Fall through to default handling
                }
              } else if (fieldType === 'datetime' && value) {
                try {
                  var dateTimeValue = moment(value);
                  if (dateTimeValue.isValid()) {
                    return dateTimeValue.format('DD/MM/YYYY HH:mm');
                  }
                } catch (e) {
                  // Fall through to default handling
                }
              }
              
              // For text and list types, or if date formatting failed, return escaped string
              return $utils.escapeHtml(String(value));
            }
          };
        }

        
        ctrl.updateDtColumns = function() {
          var newColumns = [];
          for (var i = 0; i < ctrl.fieldSettings.length; i++) {
            var field = ctrl.fieldSettings[i];
            
            if (field.display) {
              if (originalColumnDefinitions[field.name] || field.name === 'buttons') {
                if (field.name === 'buttons') {
                  newColumns.push(originalColumnDefinitions['desktop_icons']);
                  newColumns.push(originalColumnDefinitions['icons']);
                } else {
                  newColumns.push(originalColumnDefinitions[field.name]);
                }
              } else {
                // Pass field type and custom_field_id for custom fields
                var fieldType = field.type || null;
                var customFieldId = field.custom_field_id || null;
                newColumns.push(createSimpleColumn(field.name, field.translationKey || field.name, fieldType, customFieldId));
              }
            }
          }

          if (newColumns.length === 0) {
            for (var key in originalColumnDefinitions) {
              if (originalColumnDefinitions[key].hide) continue;
              newColumns.push(originalColumnDefinitions[key]);
            }
          }
          
          ctrl.dtColumns = newColumns;
        };

        ctrl.dtColumns = [];
        ctrl.updateDtColumns();



        $scope.$watch(function() {
            return $rootScope.lead_appearence;
        }, function(newValue, oldValue) {
            if (newValue !== oldValue && (newValue === 0 || newValue === 1)) {
              $scope.find_customer();
            }
        });

        ctrl.updateData = function(customerId, newValue) {
          newValue.id = customerId;
          $api.customers.update.save(newValue, function(response) {
            if(response.status == "success") {
              if ($rootScope.lead_appearence === 1) {
                $state.transitionTo("app.leads", {}, {reload: true});
                $user.getLeadsCount();
              }
            }
          });
        }

        /**
         * Get status color for background
         */
        ctrl.getStatusColor = function(statusId) {
          if (!statusId || !ctrl.statuses) return '';
          for (var i = 0; i < ctrl.statuses.length; i++) {
            if (String(ctrl.statuses[i].id) === String(statusId)) {
              return ctrl.hexToRgbA(ctrl.statuses[i].color || '#a9cfe8');
            }
          }
          return '';
        }

        ctrl.hexToRgbA = function(hex){
          var c;
          if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
              c= hex.substring(1).split('');
              if(c.length== 3){
                  c= [c[0], c[0], c[1], c[1], c[2], c[2]];
              }
              c= '0x'+c.join('');
              return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
          }
          return 'rgba(169,207,232,0.1)';
        }


        /**
         * Filter
        */
        $cfilter.apply('leads', true);
        $scope.submit_filter = function() {
          $scope.find_customer();
        }

      });
})();

(function () {

    angular.module('app.controllers').controller('CustomersDigitalFormsPrintController',
        function(DigitalForm, $scope, $state, $rootScope, $timeout, $uibModal, $tiff_page) {
  
            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            var ctrl = this;

            ctrl.business_logo = $rootScope.$user ? $rootScope.$user.logo : null;
            ctrl.business_name = $rootScope.$user ? $rootScope.$user.dealer_name : null;
            $scope.business = DigitalForm.data.business;

            ctrl.init_signatures = function() {
                $timeout( function() {
                    if ($scope.DigitalForm.data) {
                        for (var i in $scope.DigitalForm.data) {
                            if ($scope.DigitalForm.data[i].type == 'signature') {
                                var el = document.getElementById('can'+i);
                                if (el) {
                                    canvas[i] = new PortrayCanvas(el, {
                                        lineWidth: 2,
                                        period: 5,
                                        //disabled: !!$scope.DigitalForm.fill_date,
                                        lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                                    });

                                    //put canvas like image
                                    var img = document.createElement('img');
                                    img.src = canvas[i].canvas.toDataURL();
                                    img.width = el.width;
                                    img.height = el.height;
                                    el.parentNode.replaceChild(img, el);


                                }
                            }
                        }
                    }
                }, 500);
            }

            ctrl.openForm = function(form){
                $scope.DigitalForm = form;
                $scope.DigitalForm.data = form.data ? (typeof form.data === 'string' ? JSON.parse(form.data) : form.data) : [];
                $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';
    
                if ($scope.DigitalForm.data) {
                    for (var i in $scope.DigitalForm.data) {
                        if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                            $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                        }
                    }
                }

                ctrl.init_signatures();
            }

            $scope.DigitalForm = {};
            if (DigitalForm.data && DigitalForm.data.id) {
                
                $tiff_page.start_loading('printing');
                ctrl.openForm(DigitalForm.data);


                $timeout(function() {
                    if (!$scope.printTriggered) {
                        $scope.printTriggered = true;
                        window.print();
                        $scope.$close();
                        $tiff_page.stop_loading('printing');
                    }
                }, 500);
                
            }

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            var canvas = {};
        });
})();
(function () {
  angular.module('app.controllers').controller('CustomersDigitalFormsAddController', function ($scope, $state, $api, Customer, DigitalForms, DigitalForm, Order, OrderForm, $rootScope, $translate, $timeout, $minimizableModal) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;

    ctrl.form = {
      customer_id: '',
      form_id: '',
      order_id: null,
    };

    if (Customer && Customer.data) {
      ctrl.customer_page = true;
      ctrl.form.customer_id = Customer.data.id;
    }

    if (Order && Order.id) {
      ctrl.form.order_id = Order.id;
    }

    $scope.forms = DigitalForms.data;
    $scope.DigitalForm = DigitalForm ? DigitalForm : null;

    if (DigitalForm && DigitalForm._minimizedCtrlForm) {
      ctrl.form = angular.copy(DigitalForm._minimizedCtrlForm);
    } else if (DigitalForms && DigitalForms._minimizedCtrlForm) {
      ctrl.form = angular.copy(DigitalForms._minimizedCtrlForm);
    }

    ctrl.customer_modal = false;
    ctrl.customer_search_name = "";
    ctrl.customer_selected_name = "";
    ctrl.searchCustomerResult = [];
    ctrl.orderForm = OrderForm;
    ctrl.minimizedStateName = $state.current.name;

    if (DigitalForm && DigitalForm._minimizedCustomerSearchName) {
      ctrl.customer_search_name = DigitalForm._minimizedCustomerSearchName;
      ctrl.customer_selected_name = DigitalForm._minimizedCustomerSelectedName;
    } else if (DigitalForms && DigitalForms._minimizedCustomerSearchName) {
      ctrl.customer_search_name = DigitalForms._minimizedCustomerSearchName;
      ctrl.customer_selected_name = DigitalForms._minimizedCustomerSelectedName;
    }

    $scope.isMobile = (angular.element(document).width() < 769);

    function captureDrawings() {
      if (!$scope.DigitalForm || !$scope.DigitalForm.data) {
        return;
      }

      $scope.DigitalForm.data.forEach(function (f, i) {
        if (f.type === 'signature' && canvas[i]) {
          f.value = canvas[i].getLines();
        }

        if (f.type === 'map' && f._canvas && f._drawTexts) {
          f._drawTexts();
          f.value = f._canvas.toDataURL();
        }
      });
    }

    ctrl.minimize = function ($event) {
      if ($event) {
        $event.stopPropagation();
      }

      captureDrawings();

      if ($scope.DigitalForm) {
        $scope.DigitalForm._minimizedCtrlForm = angular.copy(ctrl.form);
        $scope.DigitalForm._minimizedCustomerSearchName = ctrl.customer_search_name;
        $scope.DigitalForm._minimizedCustomerSelectedName = ctrl.customer_selected_name;
      } else if (DigitalForms) {
        DigitalForms._minimizedCtrlForm = angular.copy(ctrl.form);
        DigitalForms._minimizedCustomerSearchName = ctrl.customer_search_name;
        DigitalForms._minimizedCustomerSelectedName = ctrl.customer_selected_name;
      }

      $minimizableModal.minimize({
        title: ($scope.DigitalForm && $scope.DigitalForm.name) ? $scope.DigitalForm.name : $translate.instant('CUSTOMERS_DIGITAL_FORM'),
        templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
        controller: "CustomersDigitalFormsAddController",
        resolve: {
          Customer: Customer,
          DigitalForms: DigitalForms,
          DigitalForm: $scope.DigitalForm,
          Order: Order,
          OrderForm: OrderForm
        }
      }, function(reason) {
        $scope.$dismiss(reason);
      });
    };

    ctrl.find_customer = function () {
      $api.customers.find.get({ str: ctrl.customer_search_name, limit: 20 }, function (response) {
        if (response.str == ctrl.customer_search_name) {
          ctrl.searchCustomerResult = response.data;
        }
      });
    }

    ctrl.chooseCustomer = function (index, $event) {
      ctrl.customerData = ctrl.searchCustomerResult[index];
      ctrl.form.customer_id = ctrl.customerData.id;
      ctrl.customer_selected_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
      ctrl.customer_search_name = (ctrl.customerData.firstname || '') + " " + (ctrl.customerData.lastname || '');
      ctrl.searchCustomerResult = [];
      $event.stopPropagation();
    }

    ctrl.cleanCustomerSearch = function () {
      ctrl.customer_search_name = ctrl.customer_selected_name;
      $timeout(function () {
        ctrl.searchCustomerResult = [];
      }, 200);
    }

    ctrl.backForm = function () {
      ctrl.form['form_id'] = null;
      $scope.DigitalForm = null;
    };

    ctrl.chooseForm = function () {
      $api.digital_forms.preview.get({ id: ctrl.form.form_id }, function (response) {
        if (response.status === "success") {
          $scope.DigitalForm = response.data;
          $scope.DigitalForm.data = response.data && response.data.data ? JSON.parse(response.data.data) : [];
          $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';

          if ($scope.DigitalForm.data) {
            for (var i in $scope.DigitalForm.data) {
              if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
              }
            }
          }

          ctrl.init_signatures();
          $scope.initMapCanvases();
        }
      });
    };

    ctrl.textValueWithBR = function (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    };

    var canvas = {};
    ctrl.init_signatures = function () {
      setTimeout(function () {
        if ($scope.DigitalForm && $scope.DigitalForm.data) {
          for (var i in $scope.DigitalForm.data) {
            if ($scope.DigitalForm.data[i].type == 'signature') {
              var el = document.getElementById('can' + i);
              if (el) {
                canvas[i] = new PortrayCanvas(el, {
                  lineWidth: 2,
                  period: 5,
                  disabled: $scope.DigitalForm.cf_locked,
                  lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                });
              }
            }
          }
        }
      }, 500);
    };

    ctrl.save = function () {
      if ($scope.DigitalForm && $scope.DigitalForm.id) {
        $scope.DigitalForm.data.forEach(function (f, i) {
          if (f.type === 'signature' && canvas[i]) {
            f.value = canvas[i].getLines();
          }

          if (f.type === 'map' && f._canvas && f._drawTexts) {
            f._drawTexts();
            f.value = f._canvas.toDataURL();
          }
        });

        if ((OrderForm && ctrl.form.order_id) || !OrderForm) {
          if ($scope.DigitalForm.locked) {
            swal({
              title: $translate.instant('DIGITAL_FORM_LOCKED'),
              text: $translate.instant('DIGITAL_FORM_LOCKED_TEXT'),
              type: "warning",
              showCancelButton: true,
              confirmButtonText: $translate.instant('OPTION_YES'),
              cancelButtonText: $translate.instant('OPTION_NO'),
            }).then(function (res) {
              if (res.value) {
                ctrl.send_form();
              }
            });
          } else {
            ctrl.send_form();
          }
        } else {
          $scope.$close({id: $scope.DigitalForm.id, data: $scope.DigitalForm.data, order_id: ctrl.form.order_id, customer_id: ctrl.form.customer_id, b_id: $rootScope.$user.b_id});
        }
      }
    };

    ctrl.close = function() {
      if ((OrderForm && ctrl.form.order_id) || !OrderForm) {
        $scope.$close();
      } else {
        $scope.$close({id: $scope.DigitalForm.id, data: $scope.DigitalForm.data, order_id: ctrl.form.order_id, customer_id: ctrl.form.customer_id, b_id: $rootScope.$user.b_id});
      }
    }

    ctrl.send_to_customer = function() {
      $api.digital_forms.send.save({
          id: ctrl.form.form_id*1,
          customer_id: ctrl.form.customer_id*1,
          order_id: ctrl.form.order_id*1
      }, function(response){
          if(response.status == "success") {
              swal({
                  title: $translate.instant('SWAL_DF_TITLE'),
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
              });

              $scope.$close();
          }
      });
    };

    ctrl.send_form = function () {
      var cleanedData = [];

      for (var i = 0; i < $scope.DigitalForm.data.length; i++) {
        var f = $scope.DigitalForm.data[i];

        // Create a shallow clone
        var clean = {};
        for (var key in f) {
          if (
            key !== '_canvas' &&
            key !== '_ctx' &&
            key !== '_drawTexts' &&
            key !== '_activeText' &&
            key !== 'tool' &&
            key !== 'color' &&
            key !== 'size' &&
            key !== 'textInput'
          ) {
            clean[key] = f[key];
          }
        }

        cleanedData.push(clean);
      }

      $api.customer_forms.new.save({
        id: $scope.DigitalForm.id,
        data: {
          data: cleanedData,
          customer_id: ctrl.form.customer_id,
          order_id: ctrl.form.order_id,
          b_id: $rootScope.$user.b_id,
        },
      }, function (response) {
        if (response.status === "success") {
          swal({
            title: $translate.instant('DIGITAL_FORM_FILLED'),
            text: "",
            type: "success",
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            timer: 2000,
          });

          $scope.$close(response);
        }
      });
    };


    $scope.initMapCanvases = function () {
      // init defaults
      if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

      $scope.DigitalForm.data.forEach(function (field) {
        if (field.type === 'map') {
          field.tool = 'pen';
          field.color = '#000000';
          field.size = 5;
          field.textInput = '';
          field.texts = [];
          field._activeText = null;
        }
      });

      setTimeout(function () {
        if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

        $scope.DigitalForm.data.forEach(function (field, index) {
          if (field.type !== 'map' || !field.map) return;

          var canvasEl = document.getElementById('mapCanvas' + index);
          if (!canvasEl) return;

          var ctx = canvasEl.getContext('2d');
          var rect = canvasEl.getBoundingClientRect();
          canvasEl.width = rect.width;
          canvasEl.height = rect.width * 0.7;

          var img = new Image();
          img.src = field.map;
          img.onload = function () {
            // Set canvas width based on container
            var parentWidth = canvasEl.parentElement.offsetWidth;
            var aspectRatio = img.height / img.width;

            canvasEl.width = parentWidth;
            canvasEl.height = parentWidth * aspectRatio;
            canvasEl.parentNode.style.height = (parentWidth * aspectRatio) + 'px';
          };

          if (field.value) {
            var img = new Image();
            img.src = field.value;
            img.onload = function () {
                ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);
            };
          }

          field._ctx = ctx;
          field._canvas = canvasEl;

          var inputDiv = document.createElement('div');
          inputDiv.contentEditable = true;
          inputDiv.className = 'canvas-text-input';
          inputDiv.style.position = 'absolute';
          inputDiv.style.display = 'none';
          inputDiv.style.outline = 'none';
          inputDiv.style.zIndex = 1000;
          inputDiv.style.whiteSpace = 'nowrap';
          canvasEl.parentElement.appendChild(inputDiv);

          var pos = { x: 0, y: 0 };
          var drawing = false;

          function setPosition(e) {
            var bounds = canvasEl.getBoundingClientRect();
            pos.x = (e.clientX || e.touches[0].clientX) - bounds.left;
            pos.y = (e.clientY || e.touches[0].clientY) - bounds.top;
          }

          function draw(e) {
            if (!drawing) return;

            ctx.lineWidth = field.size;
            ctx.strokeStyle = field.color;
            ctx.fillStyle = field.color;
            ctx.lineCap = 'round';

            if (field.tool === 'pen') {
              ctx.beginPath();
              ctx.moveTo(pos.x, pos.y);
              setPosition(e);
              ctx.lineTo(pos.x, pos.y);
              ctx.stroke();
            } else if (field.tool === 'spray') {
              setPosition(e);
              for (var i = 0; i < 20; i++) {
                var angle = Math.random() * 2 * Math.PI;
                var radius = Math.random() * field.size * 2;
                var x = pos.x + Math.cos(angle) * radius;
                var y = pos.y + Math.sin(angle) * radius;
                ctx.fillRect(x, y, 1, 1);
              }
            }
          }

          canvasEl.addEventListener('mousedown', function (e) {
            if (field.tool === 'pen' || field.tool === 'spray') {
              drawing = true;
              setPosition(e);
              draw(e);
            }
          });

          canvasEl.addEventListener('mouseup', function () {
            drawing = false;
          });

          canvasEl.addEventListener('mousemove', draw);

          canvasEl.addEventListener('click', function (e) {
            var bounds = canvasEl.getBoundingClientRect();
            var x = e.clientX - bounds.left;
            var y = e.clientY - bounds.top;

            if (field.tool === 'text') {
              // First: save current input if visible and has content
              if (inputDiv.style.display === 'block' && inputDiv.innerText.trim()) {
                var val = inputDiv.innerText.trim();
                var canvasX = parseFloat(inputDiv.style.left);
                var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                if (field._activeText) {
                  field._activeText.value = val;
                  field._activeText.x = canvasX;
                  field._activeText.y = canvasY;
                } else {
                  field.texts.push({
                    value: val,
                    x: canvasX,
                    y: canvasY,
                    color: field.color,
                    size: field.size
                  });
                }

                inputDiv.style.display = 'none';
                inputDiv.innerText = '';
                field._activeText = null;
                drawTexts();
              }

              // Then: check if user clicked on existing text
              var clicked = false;
              field.texts.forEach(function (t) {
                var w = ctx.measureText(t.value).width;
                var h = t.size * 3;
                if (x >= t.x && x <= t.x + w && y >= t.y - h && y <= t.y) {
                  inputDiv.innerText = t.value;
                  inputDiv.style.left = t.x + 'px';
                  inputDiv.style.top = (t.y - h) + 'px';
                  inputDiv.style.display = 'block';
                  inputDiv.style.color = t.color;
                  inputDiv.style.font = "500 " + (t.size * 3) + "px Arial";
                  inputDiv.focus();
                  field._activeText = t;
                  clicked = true;
                }
              });

              if (!clicked) {
                inputDiv.innerText = '';
                inputDiv.style.left = x + 'px';
                inputDiv.style.top = y + 'px';
                inputDiv.style.color = field.color;
                inputDiv.style.font = "500 " + (field.size * 3) + "px Arial";
                inputDiv.dataset.x = x;
                inputDiv.dataset.y = y;
                inputDiv.style.display = 'block';
                field._activeText = null;
                inputDiv.focus();
              }
            } else {
              inputDiv.style.display = 'none';
              field._activeText = null;
            }
          });

          document.addEventListener('click', function (e) {
            if (!inputDiv.contains(e.target) && e.target !== canvasEl) {
              if (inputDiv.style.display === 'block') {
                var val = inputDiv.innerText.trim();
                if (val) {
                    var canvasX = parseFloat(inputDiv.style.left);
                    var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                    if (field._activeText) {
                        field._activeText.value = val;
                        field._activeText.x = canvasX;
                        field._activeText.y = canvasY;
                    } else {
                        field.texts.push({
                        value: val,
                        x: canvasX,
                        y: canvasY,
                        color: field.color,
                        size: field.size
                        });
                    }

                    drawTexts();
                }
                inputDiv.style.display = 'none';
                inputDiv.innerText = '';
              }
            }
          });

          function drawTexts() {
            field.texts.forEach(function (t) {
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = t.color;
              ctx.font = "300 " + (t.size * 3) + "px Arial";

              var lines = t.value.split('\n');
              var lineHeight = t.size * 3 * 1.2;

              for (var i = 0; i < lines.length; i++) {
                ctx.fillText(lines[i], t.x, t.y + i * lineHeight);
              }
            });
          }

          field._drawTexts = drawTexts;
        });
      }, 500);
    };

    $scope.clearCanvas = function(field) {
      if (!field._ctx || !field._canvas) return;

      // Clear canvas
      field._ctx.clearRect(0, 0, field._canvas.width, field._canvas.height);

      // Clear stored texts
      field.texts = [];

      // Hide any visible text editor
      var inputDivs = field._canvas.parentElement.querySelectorAll('.canvas-text-input');
      angular.forEach(inputDivs, function(div) {
        div.style.display = 'none';
      });
    };

    // Color click logic for UI
    $scope.openColorPicker = function ($event, field) {
      var input = $event.currentTarget.nextElementSibling;
      if (input && input.type === 'color') input.click();
    };

    if (DigitalForm) {
      ctrl.init_signatures();
      $scope.initMapCanvases();
    }

    
  });
})();
(function () {

    angular.module('app.controllers').controller('CustomersDigitalFormsController',
        function(Customer, DigitalForm, DigitalForms, Order, Business, $scope, $state, $api, $rootScope, $translate, $uibModal, $minimizableModal) {
  
            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            var ctrl = this;

            ctrl.business_logo = $rootScope.$user ? $rootScope.$user.logo : null;
            ctrl.business_name = $rootScope.$user ? $rootScope.$user.dealer_name : null;
            ctrl.minimizedStateName = $state.current.name;
            $scope.business = Business.data;
            $scope.business.online_booking_data = $scope.business.online_booking_data ? (typeof $scope.business.online_booking_data === 'string' ? JSON.parse($scope.business.online_booking_data) : $scope.business.online_booking_data) : {};
            $scope.DigitalFormList = DigitalForms ? DigitalForms : [];

            function captureDrawings() {
                if (!$scope.DigitalForm || !$scope.DigitalForm.data) {
                    return;
                }

                $scope.DigitalForm.data.forEach(function (f, i) {
                    if (f.type === 'signature' && canvas[i]) {
                        f.value = canvas[i].getLines();
                    }

                    if (f.type === 'map' && f._canvas && f._drawTexts) {
                        f._drawTexts();
                        f.value = f._canvas.toDataURL();
                    }
                });
            }

            ctrl.minimize = function ($event) {
                if ($event) {
                    $event.stopPropagation();
                }

                captureDrawings();

                $minimizableModal.minimize({
                    title: $scope.DigitalForm && $scope.DigitalForm.name ? $scope.DigitalForm.name : $translate.instant('CUSTOMERS_DIGITAL_FORM'),
                    templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
                    controller: "CustomersDigitalFormsController",
                    resolve: {
                        Customer: Customer,
                        DigitalForm: {
                            data: $scope.DigitalForm
                        },
                        DigitalForms: $scope.DigitalFormList,
                        Order: Order,
                        Business: {
                            data: $scope.business
                        }
                    }
                }, function(reason) {
                    $scope.$dismiss(reason);
                });
            };

            ctrl.init_signatures = function() {
                setTimeout( function() {
                    if ($scope.DigitalForm.data) {
                        for (var i in $scope.DigitalForm.data) {
                            if ($scope.DigitalForm.data[i].type == 'signature') {
                                var el = document.getElementById('can'+i);
                                if (el) {
                                    canvas[i] = new PortrayCanvas(el, {
                                        lineWidth: 2,
                                        period: 5,
                                        //disabled: !!$scope.DigitalForm.fill_date,
                                        disabled: $scope.DigitalForm.cf_locked,
                                        lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                                    });
                                }
                            }
                        }
                    }
                }, 500);
            }


            $scope.initMapCanvases = function () {
                // init defaults
                if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

                $scope.DigitalForm.data.forEach(function (field) {
                    if (field.type === 'map') {
                    field.tool = 'pen';
                    field.color = '#000000';
                    field.size = 5;
                    field.textInput = '';
                    field.texts = [];
                    field._activeText = null;
                    }
                });
                
                setTimeout(function () {
                    if (!$scope.DigitalForm || !$scope.DigitalForm.data) return;

                    $scope.DigitalForm.data.forEach(function (field, index) {
                    if (field.type !== 'map' || !field.map) return;

                    var canvasEl = document.getElementById('mapCanvas' + index);
                    if (!canvasEl) return;

                    var ctx = canvasEl.getContext('2d');
                    var rect = canvasEl.getBoundingClientRect();
                    canvasEl.width = rect.width;
                    canvasEl.height = rect.width * 0.7;

                    var img = new Image();
                    img.src = field.map;
                    img.onload = function () {
                        // Set canvas width based on container
                        var parentWidth = canvasEl.parentElement.offsetWidth;
                        var aspectRatio = img.height / img.width;

                        canvasEl.width = parentWidth;
                        canvasEl.height = parentWidth * aspectRatio;
                        canvasEl.parentNode.style.height = (parentWidth * aspectRatio) + 'px';
                    };

                    if (field.value) {
                        var img = new Image();
                        img.src = field.value;
                        img.onload = function () {
                            ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);
                        };
                    }

                    field._ctx = ctx;
                    field._canvas = canvasEl;

                    var inputDiv = document.createElement('div');
                    inputDiv.contentEditable = true;
                    inputDiv.className = 'canvas-text-input';
                    inputDiv.style.position = 'absolute';
                    inputDiv.style.display = 'none';
                    inputDiv.style.outline = 'none';
                    inputDiv.style.zIndex = 1000;
                    inputDiv.style.whiteSpace = 'nowrap';
                    canvasEl.parentElement.appendChild(inputDiv);

                    var pos = { x: 0, y: 0 };
                    var drawing = false;

                    function setPosition(e) {
                        var bounds = canvasEl.getBoundingClientRect();
                        pos.x = (e.clientX || e.touches[0].clientX) - bounds.left;
                        pos.y = (e.clientY || e.touches[0].clientY) - bounds.top;
                    }

                    function draw(e) {
                        if (!drawing) return;

                        ctx.lineWidth = field.size;
                        ctx.strokeStyle = field.color;
                        ctx.fillStyle = field.color;
                        ctx.lineCap = 'round';

                        if (field.tool === 'pen') {
                        ctx.beginPath();
                        ctx.moveTo(pos.x, pos.y);
                        setPosition(e);
                        ctx.lineTo(pos.x, pos.y);
                        ctx.stroke();
                        } else if (field.tool === 'spray') {
                        setPosition(e);
                        for (var i = 0; i < 20; i++) {
                            var angle = Math.random() * 2 * Math.PI;
                            var radius = Math.random() * field.size * 2;
                            var x = pos.x + Math.cos(angle) * radius;
                            var y = pos.y + Math.sin(angle) * radius;
                            ctx.fillRect(x, y, 1, 1);
                        }
                        }
                    }

                    canvasEl.addEventListener('mousedown', function (e) {
                        if (field.tool === 'pen' || field.tool === 'spray') {
                        drawing = true;
                        setPosition(e);
                        draw(e);
                        }
                    });

                    canvasEl.addEventListener('mouseup', function () {
                        drawing = false;
                    });

                    canvasEl.addEventListener('mousemove', draw);

                    canvasEl.addEventListener('click', function (e) {
                        var bounds = canvasEl.getBoundingClientRect();
                        var x = e.clientX - bounds.left;
                        var y = e.clientY - bounds.top;

                        if (field.tool === 'text') {
                        // First: save current input if visible and has content
                        if (inputDiv.style.display === 'block' && inputDiv.innerText.trim()) {
                            var val = inputDiv.innerText.trim();
                            var canvasX = parseFloat(inputDiv.style.left);
                            var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                            if (field._activeText) {
                            field._activeText.value = val;
                            field._activeText.x = canvasX;
                            field._activeText.y = canvasY;
                            } else {
                            field.texts.push({
                                value: val,
                                x: canvasX,
                                y: canvasY,
                                color: field.color,
                                size: field.size
                            });
                            }

                            inputDiv.style.display = 'none';
                            inputDiv.innerText = '';
                            field._activeText = null;
                            drawTexts();
                        }

                        // Then: check if user clicked on existing text
                        var clicked = false;
                        field.texts.forEach(function (t) {
                            var w = ctx.measureText(t.value).width;
                            var h = t.size * 3;
                            if (x >= t.x && x <= t.x + w && y >= t.y - h && y <= t.y) {
                            inputDiv.innerText = t.value;
                            inputDiv.style.left = t.x + 'px';
                            inputDiv.style.top = (t.y - h) + 'px';
                            inputDiv.style.display = 'block';
                            inputDiv.style.color = t.color;
                            inputDiv.style.font = "500 " + (t.size * 3) + "px Arial";
                            inputDiv.focus();
                            field._activeText = t;
                            clicked = true;
                            }
                        });

                        if (!clicked) {
                            inputDiv.innerText = '';
                            inputDiv.style.left = x + 'px';
                            inputDiv.style.top = y + 'px';
                            inputDiv.style.color = field.color;
                            inputDiv.style.font = "500 " + (field.size * 3) + "px Arial";
                            inputDiv.dataset.x = x;
                            inputDiv.dataset.y = y;
                            inputDiv.style.display = 'block';
                            field._activeText = null;
                            inputDiv.focus();
                        }
                        } else {
                        inputDiv.style.display = 'none';
                        field._activeText = null;
                        }
                    });

                    document.addEventListener('click', function (e) {
                        if (!inputDiv.contains(e.target) && e.target !== canvasEl) {
                        if (inputDiv.style.display === 'block') {
                            var val = inputDiv.innerText.trim();
                            if (val) {
                                var canvasX = parseFloat(inputDiv.style.left);
                                var canvasY = parseFloat(inputDiv.style.top) + parseFloat(field.size * 3); // baseline

                                if (field._activeText) {
                                    field._activeText.value = val;
                                    field._activeText.x = canvasX;
                                    field._activeText.y = canvasY;
                                } else {
                                    field.texts.push({
                                    value: val,
                                    x: canvasX,
                                    y: canvasY,
                                    color: field.color,
                                    size: field.size
                                    });
                                }

                                drawTexts();
                            }
                            inputDiv.style.display = 'none';
                            inputDiv.innerText = '';
                        }
                        }
                    });

                    function drawTexts() {
                        field.texts.forEach(function (t) {
                        ctx.textBaseline = 'bottom';
                        ctx.fillStyle = t.color;
                        ctx.font = "300 " + (t.size * 3) + "px Arial";

                        var lines = t.value.split('\n');
                        var lineHeight = t.size * 3 * 1.2;

                        for (var i = 0; i < lines.length; i++) {
                            ctx.fillText(lines[i], t.x, t.y + i * lineHeight);
                        }
                        });
                    }

                    field._drawTexts = drawTexts;
                    });
                }, 500);
            };

            $scope.clearCanvas = function(field) {
            if (!field._ctx || !field._canvas) return;

            // Clear canvas
            field._ctx.clearRect(0, 0, field._canvas.width, field._canvas.height);

            // Clear stored texts
            field.texts = [];

            // Hide any visible text editor
            var inputDivs = field._canvas.parentElement.querySelectorAll('.canvas-text-input');
            angular.forEach(inputDivs, function(div) {
                div.style.display = 'none';
            });
            };

            // Color click logic for UI
            $scope.openColorPicker = function ($event, field) {
            var input = $event.currentTarget.nextElementSibling;
            if (input && input.type === 'color') input.click();
            };
            

            ctrl.openForm = function(form){
                $scope.DigitalForm = form;
                $scope.DigitalForm.data = form.data ? (typeof form.data === 'string' ? JSON.parse(form.data) : form.data) : [];
                $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';
    
                if ($scope.DigitalForm.data) {
                    for (var i in $scope.DigitalForm.data) {
                        if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                            $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                        }
                    }
                }

                ctrl.init_signatures();
                $scope.initMapCanvases();
            }

            $scope.DigitalForm = {};
            if (DigitalForm && DigitalForm.data && DigitalForm.data.id) {
                ctrl.openForm(DigitalForm.data);
            }
        
            $scope.isMobile = (angular.element(document).width() < 769);

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            var canvas = {};

            ctrl.init_signatures();
            $scope.initMapCanvases();

            ctrl.save = function(){
                if ($scope.DigitalForm.id) {
                    var cleanedData = [];

                    for (var i = 0; i < $scope.DigitalForm.data.length; i++) {
                        var f = $scope.DigitalForm.data[i];

                        if ((f.type == 'signature') && canvas[i]) {
                            f.value = canvas[i].getLines();
                        }

                        if (f.type === 'map' && f._canvas && f._drawTexts) {
                            f._drawTexts();
                            f.value = f._canvas.toDataURL();
                        }

                        // Create a shallow clone
                        var clean = {};
                        for (var key in f) {
                            if (
                                key !== '_canvas' &&
                                key !== '_ctx' &&
                                key !== '_drawTexts' &&
                                key !== '_activeText' &&
                                key !== 'tool' &&
                                key !== 'color' &&
                                key !== 'size' &&
                                key !== 'textInput'
                            ) {
                                clean[key] = f[key];
                            }
                        }

                        cleanedData.push(clean);
                    }
                    
                    $api.customer_forms.save({
                        id: $scope.DigitalForm.id,
                        data: cleanedData,
                    }, function (response) {
                        if (response.status === "success") {
    
                            swal({
                                title: $translate.instant('DIGITAL_FORM_FILLED'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });

                            $scope.$close($scope.DigitalFormList);
                        }
                    });
                }
            };

            ctrl.newForm = function() {
                $uibModal.open({
                    templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                    controller: "CustomersDigitalFormsAddController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal laser-file-modal",
                    resolve: {
                      Customer: Customer,
                      Order: Order,
                      OrderForm: false,
                      DigitalForm: null,
                      DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                      }]
                    }
                  }).result.then(function (result) {
                    
                    if (result && result.form_data) {
                        $scope.DigitalFormList = result.form_data;
                    }
                });
            }



            
        });
})();
(function() {
    
    angular.module("app.components").factory("$wachat", function($rootScope){
        
        var $wachat = this;
        $wachat.customer = false;
        
        $wachat.apply = function(customer) {
            $wachat.customer = customer;
        };

        return $wachat;
    });
})();
(function() {
  angular.module("app.controllers").controller("CustomersWaChatController", function($rootScope, $wachat, $cookies, $scope, $api, $resource, $translate) {
    $scope.wa_history = false;
    $scope.files = false;
    $scope.wa_message = '';
    $scope.chat_id = false;
    var fileElement = null;
    var wa_status = $cookies.get("wa_status");

    $scope.getHistory = function() {
      if (wa_status != 'authorized') {
        $scope.wa_history = {invokeStatus: { descr: $translate.instant('WA_CHAT_NOT_AUTHORIZED') }};
        return;
      }
      $api.whatsapp.wachat.get({ chat_id: $scope.chat_id, customer_id: $wachat.customer.id }, function(response) {
        if (response && response.data) {
          $scope.wa_history = response.data;
          $scope.scrollWaToBottom();
        }
      });
    };

    if ($wachat.customer && $wachat.customer.id) {
      var phone = $wachat.customer.phone;
      if (phone[0] === '0') {
        phone = '972' + phone.substr(1);
      }

      $scope.chat_id = phone + "@c.us";

      $scope.getHistory();

      if ($wachat.customer.avatar) {
        $scope.wa_avatar = $wachat.customer.avatar;
      }

      $api.whatsapp.avatar.get({}, function(response) {
        if (response && response.data && response.data.urlAvatar) {
          $scope.wa_avatar_my = response.data.urlAvatar;
        }
      });

      $api.whatsapp.avatar.get({ chat_id: $scope.chat_id }, function(response) {
        if (response && response.data && response.data.urlAvatar) {
          $scope.wa_avatar = response.data.urlAvatar;
        }
      });
    }

    $scope.subscribeToWaChat = function() {
      if (wa_status != 'authorized') {
        $scope.wa_history = {invokeStatus: { descr: $translate.instant('WA_CHAT_NOT_AUTHORIZED') }};
        return;
      }
      
      if (!pusher.channel('wa-' + $scope.chat_id)) {
        // If not subscribed, subscribe to the channel
        var channel = pusher.subscribe('wa-' + $scope.chat_id);

        channel.bind('message', function(data) {
          $scope.getHistory();
        });
      }
    };

    $scope.subscribeToWaChat();

    $scope.$on('$destroy', function() {
      // Unsubscribe from the channel when the controller is destroyed
      pusher.unsubscribe('wa-' + $scope.chat_id);
    });

    $scope.sendWaMessage = function() {
      if ($scope.wa_message || ($scope.files && $scope.files.length)) {
        var fdata = new FormData();
        if (fileElement) {
          for (var i = 0; i < fileElement.files.length; i++) {
            fdata.append("files", fileElement.files[i]);
          }
        }
        fdata.append("message", $scope.wa_message);
        fdata.append("chat_id", $scope.chat_id);

        $resource($api.baseURL + '/whatsapp/action/message', {}, {
          postWithFile: {
            method: "POST",
            params: fdata,
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
          }
        }).postWithFile(fdata).$promise.then(function(response) {
          $scope.wa_message = '';
          $scope.files = false;
        }, function(error) {
          console.log(error);
        });
      }
    };

    $scope.scrollWaToBottom = function() {
      $scope.$applyAsync(function() {
        var container = document.getElementById('wa-chat-container');
        if (container) {
          container.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });

          var page_wrap = document.getElementById('wrapper');
          if (page_wrap) {
            page_wrap.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
          }
        }
      });
    };

    $scope.formattedText = function(text) {
      if (!text) {
        return '';
      }
      // Replace "\n" with "<br>" for line breaks
      return text.replace(/\n/g, '<br />');
    };

    $scope.checkForUrl = function(text) {
      if (!text) {
        return '';
      }
      var urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
      var escaped = text.replace(/\n/g, '<br />');
      return escaped.replace(urlRegex, function(url) {
        var href = url.indexOf('http') === 0 ? url : ('https://' + url);
        return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
      });
    };

    $scope.extractDomain = function(text) {
      if (!text) {
        return '';
      }
      var urlRegex = /((https?:\/\/|www\.)[^\s<]+)/i;
      var match = text.match(urlRegex);
      if (!match) {
        return '';
      }
      try {
        var rawUrl = match[0];
        var withScheme = rawUrl.indexOf('http') === 0 ? rawUrl : ('http://' + rawUrl);
        var parsedUrl = new URL(withScheme);
        return parsedUrl.hostname;
      } catch (e) {
        return '';
      }
    };

    $scope.getReadableTime = function(timestamp) {
      var now = moment();
      var momentTimestamp = moment.unix(timestamp);

      var formattedTime;

      if (now.isSame(momentTimestamp, 'day')) {
        // If the timestamp is today, display in 'HH:mm' format
        formattedTime = momentTimestamp.format('HH:mm');
      } else {
        // If the timestamp is not today, display in 'DD-MM-YYYY HH:mm' format
        formattedTime = momentTimestamp.format('DD-MM-YYYY HH:mm');
      }
      return formattedTime;
    };

    $scope.audio = false;
    $scope.audioEndedHandler = null;
    $scope.currentAudioId = null;

    $scope.playWaRecord = function(item) {
      if ($scope.audio) {
        $scope.audio.pause();
        $scope.audio.removeEventListener('ended', $scope.audioEndedHandler);
      }

      if (item.downloadUrl && $scope.currentAudioId != item.idMessage) {
        $scope.audio = new Audio(item.downloadUrl);
        $scope.audio.play();
        $scope.currentAudioId = item.idMessage;

        $scope.audioEndedHandler = function() {
          $scope.currentAudioId = null;
        };
        $scope.audio.addEventListener('ended', $scope.audioEndedHandler);

      } else {
        $scope.currentAudioId = null;
      }
    };

    $scope.uploadFile = function(element) {
      $scope.files = element.files;
      fileElement = element;
      $scope.$apply();
    };

    $scope.clearFiles = function() {
      $scope.files = false;
      fileElement.value = '';
    };

  });
})();
(function() {

    angular.module("app.controllers").controller("CustomersSMSController", function($scope, $resource, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {
            message: "",
            files: []
        };

        var fileElement = null

        /**
         * Triggers when SMS form is submited
         */
        ctrl.submit = function() {

            var fdata = new FormData();
            if (fileElement) {
                fdata.append("file", fileElement.files[0]);
            }
            fdata.append("message", ctrl.form.message);
            fdata.append("phone", Customer.data.phone);
            fdata.append("customer_id", Customer.data.id);

            $resource($api.baseURL + '/sms', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_CUSTOMER_SMS_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            }, function(error){
                console.log(error);
            });

            return;
            $api.sms.save({
                message: ctrl.form.message,
                files: ctrl.form.files,
                phone: Customer.data.phone,
                customer_id: Customer.data.id
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_CUSTOMER_SMS_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

        $scope.uploadFile = function(element){
            ctrl.form.files = element.files;
            fileElement = element;
            $scope.$apply();
        };

    });

})();

(function () {
    angular.module('app.controllers')

        .controller('CustomersSingleController', function (Customer, Info, LaserInfo, CustomFields, QuotationStatuses, $api, $state, $location, $scope, $translate, $wachat, $tiff_page, $customFields, $header, DTOptionsBuilder, dataTablesHebrewProvider, $uibModal, $rootScope, $window, $resource, $business, $webview, $utils, $sce) {

            function formatTexterContact(phone, country) {
                var raw = String(phone || '').trim();
                var digits = raw.replace(/\D/g, '');
                var countryDialCodes = {
                    'IL': '972',
                    'UA': '380',
                    'US': '1',
                    'GB': '44',
                    'RU': '7',
                    'FR': '33',
                    'DE': '49',
                    'IT': '39',
                    'ES': '34',
                    'PL': '48',
                    'RO': '40',
                    'MD': '373',
                    'BY': '375'
                };
                var knownDialCodes = ['972', '380', '375', '373', '371', '370', '359', '358', '357', '356', '355', '354', '353', '352', '351', '49', '48', '47', '46', '45', '44', '43', '41', '40', '39', '36', '34', '33', '32', '31', '30', '27', '20', '7', '1'];
                var dialCodes = knownDialCodes.slice().sort(function(a, b) {
                    return b.length - a.length;
                });
                var i;
                var dialCode;
                var parts;
                var countryPart;
                var numberPart;

                if (!digits) {
                    return '';
                }

                if (raw.indexOf('-') > 0) {
                    parts = raw.split('-');
                    countryPart = parts[0].replace(/\D/g, '');
                    numberPart = parts.slice(1).join('').replace(/\D/g, '');
                    if (countryPart && numberPart) {
                        return countryPart + '-' + numberPart;
                    }
                }

                if (digits.charAt(0) === '0') {
                    return '972-' + digits.substr(1);
                }

                for (i = 0; i < dialCodes.length; i++) {
                    dialCode = dialCodes[i];
                    if (digits.indexOf(dialCode) === 0 && digits.length > dialCode.length) {
                        return dialCode + '-' + digits.substr(dialCode.length);
                    }
                }

                if (country && countryDialCodes[country]) {
                    return countryDialCodes[country] + '-' + digits;
                }

                return digits;
            }

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            // b_type=2 -> motel
            // b_type=1 -> store
            $scope.b_type = $rootScope.$user.b_type;
            $scope.documents = $rootScope.$user.documents;
            $scope.forms = $rootScope.$user.forms;

            var ctrl = this;

            ctrl.isTexterWa = !!($rootScope.$user && $rootScope.$user.wa_api == 'texter');
            ctrl.texterIframeUrl = null;

            ctrl.updateTexterIframeUrl = function() {
                ctrl.texterIframeUrl = null;

                if (!ctrl.isTexterWa || !$rootScope.$user || !$rootScope.$user.wa_instance || !$scope.customer || !$scope.customer.phone) {
                    return;
                }

                var contact = formatTexterContact($scope.customer.phone, $scope.customer.country);
                if (!contact) {
                    return;
                }

                ctrl.texterIframeUrl = $sce.trustAsResourceUrl('https://' + $rootScope.$user.wa_instance + '.texterchat.com/?contact=' + encodeURIComponent(contact));
            };

            ctrl.renderNoteText = function(text) {
                if (!text) {
                    return '';
                }

                var value = String(text);
                var urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
                var html = '';
                var lastIndex = 0;
                var match;

                while ((match = urlRegex.exec(value)) !== null) {
                    var url = match[0];
                    var cleanUrl = url;
                    var trailing = '';

                    while (cleanUrl && /[.,!?;:)]$/.test(cleanUrl)) {
                        trailing = cleanUrl.charAt(cleanUrl.length - 1) + trailing;
                        cleanUrl = cleanUrl.substring(0, cleanUrl.length - 1);
                    }

                    html += $utils.escapeHtml(value.substring(lastIndex, match.index));

                    if (cleanUrl) {
                        var href = /^https?:\/\//i.test(cleanUrl) ? cleanUrl : 'https://' + cleanUrl;
                        html += '<a href="' + $utils.escapeHtml(href) + '" onclick="event.stopPropagation()" target="_blank" rel="noopener noreferrer">' + $utils.escapeHtml(cleanUrl) + '</a>';
                    }

                    html += $utils.escapeHtml(trailing);
                    lastIndex = match.index + url.length;
                }

                html += $utils.escapeHtml(value.substring(lastIndex));

                return $sce.trustAsHtml(html);
            };

            ctrl.isWebView = $webview.isWebView
            ctrl.isPdfUrl = $webview.isPdfUrl
            ctrl.isImageUrl = $webview.isImageUrl;
            ctrl.laser_categories = $business.laser_categories;
            ctrl.laser_category = 1;
            ctrl.tabLoading = false;

            // Audio playback functionality for call logs
            ctrl.audio = null;
            ctrl.currentAudioRow = null;
            ctrl.audioEndedHandler = null;

            ctrl.getRowId = function(row) {
                // Create a unique identifier for the row
                return row.id || (row.caller + '_' + row.created_at + '_' + (row.duration || '0'));
            };

            ctrl.playRecord = function(row) {
                if (!row.record) {
                    return;
                }

                var rowId = ctrl.getRowId(row);

                // If clicking on the same record that's playing, stop it
                if (ctrl.audio && ctrl.currentAudioRow && ctrl.getRowId(ctrl.currentAudioRow) == rowId) {
                    ctrl.audio.pause();
                    ctrl.audio.removeEventListener('ended', ctrl.audioEndedHandler);
                    ctrl.currentAudioRow = null;
                    ctrl.audio = null;
                    return;
                }

                // Stop current audio if playing
                if (ctrl.audio) {
                    ctrl.audio.pause();
                    ctrl.audio.removeEventListener('ended', ctrl.audioEndedHandler);
                }

                // Play new audio
                ctrl.audio = new Audio(row.record);
                ctrl.audio.play();
                ctrl.currentAudioRow = row;

                ctrl.audioEndedHandler = function() {
                    ctrl.currentAudioRow = null;
                    ctrl.audio = null;
                };
                ctrl.audio.addEventListener('ended', ctrl.audioEndedHandler);
            };
            ctrl.hide_prices = ($rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices'));
            ctrl.personal_only = ($rootScope.userRole == 3 && $rootScope.employee_permissions && $rootScope.employee_permissions.customers && $rootScope.employee_permissions.customers.personal);

            ctrl.isSummaryDetailEnabled = function(key) {
                if ($rootScope.userRole != 3) return true;
                var p = $rootScope.employee_permissions && $rootScope.employee_permissions.customer_summary_details;
                if (!p || p[key] === undefined) return true;
                return p[key] !== false;
            };
            ctrl.isTabEnabled = function(name) {
                if ($rootScope.userRole != 3) return true;
                var p = $rootScope.employee_permissions && $rootScope.employee_permissions.customer_tabs;
                if (!p || p[name] === undefined) return true;
                return p[name] !== false;
            };
            if (ctrl.personal_only) {
              if (Customer.data && (Customer.data.resource_lead == $rootScope.$user.resource_id || Customer.data.resource == $rootScope.$user.resource_id || (Customer.data.worked_resources && Customer.data.worked_resources.indexOf($rootScope.$user.resource_id) > -1))) {
                ctrl.personal_only = false;
              }
            }

            $scope.isMobile = (angular.element(document).width() < 769);

            ctrl.orderStatus = [
                {title: 'CUSTOMERS_ORDERS_FILTER_ALL', value: 'all'},
                {title: 'CUSTOMERS_ORDERS_FILTER_OPENED', value: 'opened'},
                {title: 'CUSTOMERS_ORDERS_FILTER_PAID', value: 'paid'},
                {title: 'CUSTOMERS_ORDERS_FILTER_DECLINED', value: 'declined'},
                {title: 'CUSTOMERS_ORDERS_FILTER_CANCELED', value: 'canceled'},
            ];
            ctrl.orderStatusOptions = ctrl.orderStatus.map(function (statusItem) {
              return {
                value: statusItem.value,
                name: $translate.instant(statusItem.title)
              };
            });

            $scope.selectizeConfig = {
                create: true,
                sortField: 'text'
            };

            ctrl.business = Info.data;
            ctrl.quotation_statuses = QuotationStatuses && QuotationStatuses.data ? QuotationStatuses.data : [];
            ctrl.quotation_statuses_options = [{
              id: '',
              name: $translate.instant('QUOTATION_STATUS_VALID'),
              color: 'rgba(169, 207, 232, 0.5)'
            }].concat(ctrl.quotation_statuses.map(function (status) {
              return {
                id: String(status.id),
                name: status.name,
                color: status.color || 'rgba(169, 207, 232, 0.5)'
              };
            }));
            ctrl.hasQuotationStatuses = ctrl.quotation_statuses.length > 0;
            $scope.transactionQuotationStatuses = {};

            ctrl.menuOrderedList = [
              {name: 'history', display: true, translationKey: "CUSTOMERS_ORDER_HIST"},
              {name: 'wachat', display: true, translationKey: "CUSTOMERS_WA_CHAT"},
              {name: 'notes', display: true, translationKey: "CUSTOMERS_NOTE"},
              {name: 'medical_notes', display: true, translationKey: "CUSTOMERS_MEDICAL_NOTE"},
              {name: 'cards', display: true, translationKey: "CUSTOMERS_CARDS_INFO_TAB"},
              {name: 'color', display: true, translationKey: "CUSTOMERS_COLOR"},
              {name: 'transaction', display: true, translationKey: "CUSTOMERS_TRANSACTIONS"},
              {name: 'documents', display: true, translationKey: "CUSTOMERS_DOCUMENTS"},
              {name: 'forms', display: true, translationKey: "CUSTOMERS_FORMS"},
              {name: 'laser', display: true, translationKey: "CALENDAR_ORDER_LASER_FILE"},
              {name: 'files', display: true, translationKey: "CUSTOMERS_FILES"},
              {name: 'smses', display: true, translationKey: "CUSTOMERS_SMSES"},
              {name: 'calls', display: true, translationKey: "CUSTOMERS_CALLS"},
            ];

            ctrl.menuDefaultsByName = {};
            for (var menuIndex = 0; menuIndex < ctrl.menuOrderedList.length; menuIndex++) {
              ctrl.menuDefaultsByName[ctrl.menuOrderedList[menuIndex].name] = ctrl.menuOrderedList[menuIndex];
            }

            ctrl.normalizeMenuItem = function(item) {
              if (!item || !item.name) {
                return null;
              }

              var defaultItem = ctrl.menuDefaultsByName[item.name] || {};
              return {
                name: item.name,
                display: item.display !== false,
                translationKey: item.translationKey || defaultItem.translationKey || ''
              };
            };

            ctrl.normalizeMenuOrder = function(menuList) {
              var normalizedList = [];
              if (!menuList || !menuList.length) {
                return normalizedList;
              }

              for (var idx = 0; idx < menuList.length; idx++) {
                var normalizedItem = ctrl.normalizeMenuItem(menuList[idx]);
                if (normalizedItem) {
                  normalizedList.push(normalizedItem);
                }
              }

              return normalizedList;
            };

            ctrl.menuTitles = ctrl.menuOrderedList.reduce(function (acc, item) {
              acc[item.name] = $translate.instant(item.translationKey);
              return acc;
            }, {});

            ctrl.getDefaultActiveTab = function(menuList) {
              if (!menuList || !menuList.length) {
                return null;
              }

              var firstDisplayedMenu = menuList.find(function(item) {
                return item && item.display !== false && item.name;
              });

              if (firstDisplayedMenu) {
                return firstDisplayedMenu.name;
              }

              return menuList[0] && menuList[0].name ? menuList[0].name : null;
            };

            if ($rootScope.$user.customer_menu_order) {
              var default_order = ctrl.menuOrderedList;
              ctrl.menuOrderedList = ctrl.normalizeMenuOrder($rootScope.$user.customer_menu_order);

              for (var j in default_order) {
                var found = false;
                for (var i in ctrl.menuOrderedList) {
                  if (ctrl.menuOrderedList[i].name == default_order[j].name) {
                    found = true;
                  }
                }

                if (!found) {
                  ctrl.menuOrderedList.push(ctrl.normalizeMenuItem(default_order[j]));
                }
              }

              ctrl.active_tab = ctrl.getDefaultActiveTab(ctrl.menuOrderedList);
            }

            ctrl.menuOrderedList = ctrl.menuOrderedList.filter(function(row) {
                return ctrl.isTabEnabled(row.name);
            });

            ctrl.goBackOrNavigate = function(hasLead, $event) {
              $event && $event.preventDefault();

              var raw = null, target = null;
              try {
                raw = sessionStorage.getItem('backTarget');
                target = raw ? JSON.parse(raw) : null;
              } catch (e) {
                target = null;
              }

              if (target && target.name) {
                $state.go(target.name, target.params || {}, { location: 'replace' });
                return;
              }

              if (hasLead) {
                $state.go('app.leads');
              } else {
                $state.go('app.customers');
              }
            };

            ctrl.openPdf = function(url) {
              $uibModal.open({
                templateUrl: "app/modules/pdf-preview/pdf-preview.view.html",
                controller: "PdfPreviewController",
                controllerAs: "ctrl",
                windowTopClass: "form-modal large-modal",
                scope: $scope,
                resolve: {
                  pdfUrl: function () {
                    return ctrl.isPdfUrl(url) ? url : '';
                  },
                  imageUrl: function () {
                    return ctrl.isImageUrl(url) ? url : '';
                  }
                },
              });
            };

            ctrl.menuListByPermission = function() {
              var menuOrderedList = [];
              if (ctrl.personal_only) {
                ctrl.menuOrderedList = menuOrderedList;
                return;
              }

              for (var i in ctrl.menuOrderedList) {
                var item = ctrl.menuOrderedList[i];

                switch (item.name) {
                  case 'history':
                    if (!$rootScope.isUserAllowedAccess('calendar')) {
                      continue;
                    }
                    break;
                  case 'transaction':
                    if (!$rootScope.isUserAllowedAccess('cashbox') || ctrl.hide_prices) {
                      continue;
                    }
                    break;
                  default:
                    break;
                }

                menuOrderedList.push(item);
              }

              ctrl.menuOrderedList = menuOrderedList;
              ctrl.active_tab = ctrl.getDefaultActiveTab(ctrl.menuOrderedList);
            }

            ctrl.menuListByPermission();


            ctrl.active_item_type = '';

            if (Customer.status == "failed")
                $state.transitionTo("app.customers", {}, { reload: true });

            if (Customer.data.lastname == null)
                Customer.data.lastname = "";

            $scope.customer = Customer.data;
            $scope.customer.custom_fields = $scope.customer.custom_fields ? JSON.parse($scope.customer.custom_fields) : false;
            ctrl.updateTexterIframeUrl();

            $scope.customer.custom_values_list = [];
            ctrl.customFields = CustomFields.data ? CustomFields.data : [];
            ctrl.customFields.forEach(function (field) {
              field.name = $customFields.getCurrentName(field.name);
              if ($scope.customer.custom_values && $scope.customer.custom_values[field.id]) {
                var value = $scope.customer.custom_values[field.id];
                if (value) {
                  if (field.type == 'date') {
                    value = moment(value).format('DD/MM/YYYY')
                  }

                  if (field.type == 'datetime') {
                    value = moment(value).format('DD/MM/YYYY HH:mm')
                  }

                  if (field.type == 'list') {
                    var filteredValues = field.values.filter(function (item) {
                      return item.id == value;
                    });
                    value = filteredValues.length > 0 ? filteredValues[0].value : '---';
                  }
                } else {
                  value = '---';
                }

                $scope.customer.custom_values_list.push({
                  name: field.name,
                  value: value,
                });
              }
            });

            //ctrl.tableData = $scope.customer.history;

            ctrl.initedDrag = false;
        ctrl.initDrag = function () {
          // ************************ Drag and drop ***************** //
          var dropArea = document.getElementById("drop-area");

          if (!dropArea || ctrl.initedDrag) return;

          ctrl.initedDrag = true;

          dropArea.addEventListener('dragenter', highlight, false)
          dropArea.addEventListener('dragover', highlight, false)

          dropArea.addEventListener('dragleave', unhighlight, false)
          dropArea.addEventListener('drop', unhighlight, false)
          
          dropArea.addEventListener('drop', handleDrop, false);

          function preventDefaults (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          function highlight(e) {
            preventDefaults(e);
            dropArea.classList.add('highlight');
          }

          function unhighlight(e) {
            preventDefaults(e);
            dropArea.classList.remove('highlight');
          }

          function handleDrop(e) {
            var dt = e.dataTransfer;
            $scope.uploadFile(dt);
          }

        };
            
            ctrl.dtInstance = null;

            ctrl.dtIntanceCallback = function (instance) {
                ctrl.dtInstance = instance;
            }

            if($scope.customer.resource  != null) {
              $api.resources.single.get({
                id: $scope.customer.resource
              }, function(response) {
                $scope.customer.resource_name = response.data.name;
              });
            }

            if($scope.customer.resource_lead  != null) {
              $api.resources.single.get({
                id: $scope.customer.resource_lead
              }, function(response) {
                $scope.customer.resource_lead_name = response.data.name;
              });
            }


            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "ניהול לקוחות - <b>" + Customer.data.firstname + " " + Customer.data.lastname + "</b>";
            $header.breadcrumbs.push({
                "title": "לקוחות",
                "state": "app.customers"
            }, {
                    "title": Customer.data.firstname + " " + Customer.data.lastname
                });

            ctrl.showHideSearch = function () {
                $scope.showHideSearchInput = !$scope.showHideSearchInput;
              ctrl.setDataTableOptions($scope.showHideSearchInput);
            }
            ctrl.setDataTableOptions = function (showSearch) {
              if (window.innerWidth < 768) {
                if(typeof showSearch === "undefined") {
                  $scope.showHideSearchInput = false;
                }
                $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    //.withOption('scrollY', '500px')
                    //.withOption('order', [[1, 'desc']])
                    .withOption('aaSorting', [])
                    .withOption('searching', $scope.showHideSearchInput);
              } else {
                if(typeof showSearch === "undefined") {
                  $scope.showHideSearchInput = false;
                }
                $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    //.withOption('scrollY', '500px')
                    //.withOption('order', [[1, 'desc']])
                    .withOption('aaSorting', [])
                    .withOption('searching', $scope.showHideSearchInput);
              }
            }

            ctrl.setDataTableOptions();

            ctrl.go_quotation = function () {
              $location.url('/cashbox?customer=' + $scope.customer.id + '&quotation=true');
            }

            /**
             * Customer delete
             */
            ctrl.delete = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_CUSTOMER_DELETE_CONFIRM_TEXT').replace('[name]', Customer.data.firstname),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.customers.single.delete({id: Customer.data.id}, function(response) {
                            if(response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                ctrl.goBackOrNavigate(Customer.data.lead);
                            } else if (response.status == "exist") {
                              swal({
                                  title: $translate.instant('SWAL_CUSTOMER_DELETE_EXIST_TITLE'),
                                  type: "warning",
                                  confirmButtonText: $translate.instant('CUSTOMER_CONFIRM_REMOVE'),
                                  showCancelButton: true,
                                  cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                                  confirmButtonClass: "btn-danger",
                                  cancelButtonClass: "btn btn-danger",
                                  closeOnConfirm: false,
                                  showLoaderOnConfirm: true
                              }).then(function(result) {
                                if(result.value)
                                  $api.customers.remove.delete({id: Customer.data.id, confirm: 1}, function(response) {
                                    if(response.status == "success") {
                                      swal({
                                        title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                                        text: "",
                                        type: "success",
                                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                        timer: 2000
                                      });
                                      ctrl.goBackOrNavigate(Customer.data.lead);
                                    }
                                  });
                              });
                            }
                        });
                });
            };

            /**
             * Customer recover
             */
             ctrl.recover = function () {
              
              $api.customers.recover.get({id: Customer.data.id}, function(response) {
                if(response.status == "success") {
                  ctrl.goBackOrNavigate(Customer.data.lead);
                }
              });
          };

          ctrl.open_log_card = function (logData) {

            $uibModal.open({
              templateUrl: "app/modules/settings/logs/modules/logs-info/logs.info.html",
              controller: "LogsInfoController",
              controllerAs: "ctrl",
              windowTopClass: "form-modal small-modal",
              scope: $scope,
              resolve: {
                Transaction: function ($api) {
                  return $api.resolve("transactions.single@get", {"id": logData.id});
                  }
              }
            }).closed.then(function() {

            });
          };

          ctrl.edit_customer = function() {
            $uibModal.open({
              templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
              controller: "CustomersFormController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal medium-modal side-modal",
              resolve: {
                Customer: ['$api', function ($api) {
                  return $api.resolve("customers.single@get", {"id": $scope.customer.id});
                }],
                isModal: false,
                Lead: false,
                Info: ['$api', function ($api) {
                  return $api.resolve("settings.info@get");
                }],
                Resources: ['$api', function ($api) {
                  return $api.resolve("resources@get");
                }],
                Statuses: ['$api', function ($api) {
                  return $api.resolve("statuses@get");
                }],
                Interested: ['$api', function ($api) {
                  return $api.resolve("interested@get");
                }],
                CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                  return $api.resolve("customFields.all@get");
                }],
                Phone: null,
              }
            });
          }


            /**
             * Opens "Edit Order" form
             */
            ctrl.edit_order_form = function(order) {

                $uibModal.open({
                    templateUrl: "app/modules/calendar/order/order.form.html",
                    controller: "OrderFormController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Items: function($api) {
                            return $api.resolve("items.items_with_duration@get");
                        },
                        Customers: function($api) {
                            return $api.resolve("customers@get");
                        },
                        Resources: function($api) {
                            return $api.resolve("resources@get");
                        },
                        SecondResources: function($api) {
                          return $api.resolve("second_resources@get");
                        },
                        Info: function ($api) {
                            return $api.resolve("settings.info@get");
                        },
                        Clubs: function($api) {
                            return $api.resolve("settings.clubs@get");
                        },
                        Customer: function($api) {
                          return null;
                        },
                        Order: function($api) {
                            return $api.resolve("orders.single@get", {
                                "id": order.order_id
                            });
                        },
                        CalendarEvent: null,
                        CalendarCourse: null,
                        Messages:  function($api) {
                            return $api.resolve("settings.messages@get");
                        },
                        EventCopy: false,
                        CoursesFields: ['$api', function ($api) {
                          return $api.resolve('coursesFields.lists@get');
                        }],
                    }
                }).closed.then(function() {

                });
            };

            ctrl.request_review = function (customer_id, type) {
              swal({
                  title: '',
                  text: $translate.instant('CONFIRM_REVIEW_REQUEST'),
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('OPTION_YES'),
                  cancelButtonText: $translate.instant('OPTION_NO'),
              }).then(function (res) {
                  if (res.value) {
                      ctrl.sendReviewRequest(customer_id, type);
                  }
              });
            };

             /**
             *
             * @param type Social network type
             */
          ctrl.sendReviewRequest = function (customer_id, type) {
            $tiff_page.start_loading('request_review');
            $api.customers.request_review.get({
                    id: customer_id,
                    type: type,
                },
                function (response) {
                    $scope.customer[type+'_review_request'] = true;
                    $tiff_page.stop_loading('request_review');
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('REVIEW_REQUEST_SUCCESS_SENT'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        }).then(function(){

                        });
                    }
                });
          }

          ctrl.social_link = function (customer_id) {
            $tiff_page.start_loading('social_link');
            $api.customers.social_link.get({
                  id: customer_id,
                },
                function (response) {
                    $tiff_page.stop_loading('social_link');
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('SOCIAL_LINK_SUCCESS_SENT'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        }).then(function(){

                    });
                }
              });
          }

          ctrl.send_online_booking_link = function () {
            $tiff_page.start_loading('send_online_booking_link');
            $api.customers.send_online_booking_link.get({
              id: $scope.customer.id,
            }, function(response) {
              $tiff_page.stop_loading('send_online_booking_link');
              if(response.status == "success") {
                swal({
                  title: $translate.instant('SWAL_CUSTOMER_SEND_ONLINE_BOOKING_LINK_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
              }
            });
          };

            /**
             * Load customer's orders history
             */
            ctrl.loadOrderHistory = function() {
                // Check filters
                var filter = null;
                if(ctrl.historyOrdersStatusFilter) {
                    filter = ctrl.historyOrdersStatusFilter;
                }
                $scope.customer.history = null;
                ctrl.tableData = null;

              $api.orders.customer_history.get({id: Customer.data.id, filter_status: filter}, function(response) {
                if (response.status == 'success') {
                  ctrl.tableData = response.data;
                  $scope.customer.history = response.data;
                }
                });


            }

            /**
             * Show transactions with Card
             * @param customer_id
             */
            ctrl.open_customer_card_transactions = function(card_id) {
                $state.transitionTo("app.customers.card_transactions", {
                    "card_id": card_id,
                    "id": $scope.customer.id
                }, {
                    reload: false
                });
            };

            /**
             * Set active tab and re-render DataTable
             * @param index
             */
            ctrl.initedTableData = [];
            ctrl.futureInvoices = [];
            ctrl.loadFutureInvoices = function() {
              if (!$scope.customer || !$scope.customer.id) return;
              $api.continuousDeals.futureInvoices.get({customer_id: $scope.customer.id}, function(res) {
                ctrl.futureInvoices = (res.data && Array.isArray(res.data)) ? res.data : [];
              }, function() {
                ctrl.futureInvoices = [];
              });
            };
            ctrl.setActiveTab = function (index) {
              ctrl.active_tab = index;
              ctrl.initedTableData = [];
              ctrl.tableData = [];
              if (index == 'wachat') {
                if (ctrl.isTexterWa) {
                  ctrl.updateTexterIframeUrl();
                } else {
                  $wachat.apply($scope.customer);
                }
                return;
              }
              ctrl.tabLoading = true;

              $api.customers.tab_info.get({id: $scope.customer.id, tab: index}, function(response) {
                ctrl.tabLoading = false;
                if (response.success && response.tab == ctrl.active_tab) {
                  ctrl.tableData = response.data;
                  ctrl.initedTableData = response.data;
                if (index == 'transaction') {
                  $scope.transactionQuotationStatuses = {};
                  for (var t = 0; t < response.data.length; t++) {
                    var rowItem = response.data[t];
                    $scope.transactionQuotationStatuses[rowItem.id] = rowItem.quotation_status_id ? String(rowItem.quotation_status_id) : '';
                  }
                  ctrl.loadFutureInvoices();
                }
                  if (index == 'history') {
                    var historyData = []
                    for (var i in response.data) {
                      var row = response.data[i];

                      row.images_before = [];
                      row.images_after = [];

                      for (j = 1; j <= 5; j++) {
                        if (row['order_image_before' + j] != null) {
                          row.images_before.push(row['order_image_before' + j]);
                        }
                      }

                      for (j = 1; j <= 5; j++) {
                        if (row['order_image_after' + j] != null) {
                          row.images_after.push(row['order_image_after' + j]);
                        }
                      }
                      historyData.push(row);
                    }

                    ctrl.tableData = historyData;
                    ctrl.initedTableData = historyData;
                  }
                  if (index == 'files') {
                    ctrl.initDrag();
                  }
                  if (index == 'laser') {
                    ctrl.init_laser_list(response.data);
                  }
                }
              });
            }

            if (ctrl.active_tab) {
              ctrl.setActiveTab(ctrl.active_tab);
            }

            ctrl.showImage = function($event, images) {
              $event.stopPropagation();
              $event.preventDefault();

              var current = 0;

              Swal.fire({
                html:
                  '<div style="position: relative; display: flex; justify-content: center; align-items: center; width: 100%; height: 400px;">' +
                    '<img id="swal-image" src="' + images[0] + '" style="max-width:100%; max-height: 100%; display: block;" />' +
                    '<button id="prev-btn" class="btn icon default"' +
                            'style="opacity: 0.8; position: absolute; top: 50%; inset-inline-start: 0; transform: translateY(-50%); ' +
                                  'cursor: pointer; display: none;">' +
                      '<i class="las la-angle-right rotatable"></i>' +
                    '</button>' +
                    '<button id="next-btn" class="btn icon default" ' +
                            'style="opacity: 0.8; position: absolute; top: 50%; inset-inline-end: 0; transform: translateY(-50%); ' +
                                  'cursor: pointer;">' +
                      '<i class="las la-angle-left rotatable"></i>' +
                    '</button>' +
                  '</div>',
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: $translate.instant('CALL_CANCEL'),
                allowOutsideClick: false,
                allowEscapeKey: false,
                onOpen: function(popup) {
                  // popup is the modal DOM element
                  var img     = popup.querySelector('#swal-image');
                  var prevBtn = popup.querySelector('#prev-btn');
                  var nextBtn = popup.querySelector('#next-btn');

                  var updateArrows = function() {
                    prevBtn.style.display = (current > 0) ? 'block' : 'none';
                    nextBtn.style.display = (current < images.length - 1) ? 'block' : 'none';
                    img.src = images[current];
                  };

                  prevBtn.addEventListener('click', function() {
                    if (current > 0) {
                      current--;
                      updateArrows();
                    }
                  });
                  nextBtn.addEventListener('click', function() {
                    if (current < images.length - 1) {
                      current++;
                      updateArrows();
                    }
                  });

                  // initialize
                  updateArrows();
                }
              });
            };
            
            ctrl.searchTableData = function(key) {

              if (ctrl[key]) {
                var newData = [];
                for (var i in ctrl.initedTableData) {
                  var found = false;
                  for (var k in ctrl.initedTableData[i]) {
                    if (k == "item_data" && ctrl.initedTableData[i][k].name && ctrl.initedTableData[i][k].name.toString().toLowerCase().indexOf(ctrl[key].toLowerCase()) > -1) {
                      found = true;
                    } else if (ctrl.initedTableData[i][k] && ctrl.initedTableData[i][k].toString().toLowerCase().indexOf(ctrl[key].toLowerCase()) > -1) {
                      found = true;
                    }
                  }

                  if (found) {
                    newData.push(ctrl.initedTableData[i]);
                  }
                }

                ctrl.tableData = newData;
              }
              
              if ($('#res_dt-'+key).DataTable()) {
                //$('#res_dt-'+key).DataTable().clear().draw();
              }
            }

            /**
             * Show change Card balance popup
             */
            ctrl.showChangeCard = function(card_id) {
              $uibModal.open({
                templateUrl: "app/modules/customers/modules/customers-single/cards/change-balance.form.html",
                controller: "CardBalanceFormController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal small-modal card-balance-edit-modal",
                resolve: {
                  Card: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("cards.single@get", {"id": card_id});
                  }
                }
              })
            }

            ctrl.removeDocument = function(id) {
              swal({
                title: '',
                text: $translate.instant('CONFIRM_DELETE_DD'),
                type: "warning",
                showCancelButton: true,
                confirmButtonText: $translate.instant('OPTION_YES'),
                cancelButtonText: $translate.instant('OPTION_NO'),
              }).then(function (res) {
                  if (res.value) {
                    $api.customer_documents.delete({id: id}, function(response) {
                      if(response.status == "success") {
                        $state.transitionTo("app.customers.single", { "id": $scope.customer.id }, { reload: true });
                      }
                    });
                  }
              });
            }

            ctrl.documentName = function(document) {
              if (document && document.url) {
                var splited = document.url.split($scope.customer.id + "-");
                return splited[1] ? splited[1] : splited[0];
              }

              return '';
            }

            $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromParams) {
              $rootScope.previousState = fromState;
              $rootScope.previousStateParams = fromParams;
            });

            /**
             * Load previous location
             */
            ctrl.go_back = function () {
                if ($rootScope.previousState) {
                  $state.go($rootScope.previousState, $rootScope.previousStateParams);
                } else {
                  $window.history.back();
                }
              }

            ctrl.print_coloring = function (row, $event) {
              if ($event) {
                $event.stopPropagation();
                $event.preventDefault();
              }

              if (!row || !row.id) return;

              $api.coloring.pdf.get({id: row.id}, function (response) {
                if (response && response.status == "success" && response.path) {
                  try {
                    printJS(response.path);
                  } catch (e) {
                    window.open(response.path, '_blank');
                  }
                } else {
                  swal({
                    title: $translate.instant('SWAL_ERROR_DEFAULT_TITLE'),
                    text: "",
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2500
                  });
                }
              }, function () {
                swal({
                  title: $translate.instant('SWAL_ERROR_DEFAULT_TITLE'),
                  text: "",
                  type: "error",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2500
                });
              });
            };
          
            ctrl.edit_color_form = function(coloring_id) {

              $uibModal.open({
                  templateUrl: "app/modules/customers/modules/customers-single/cards/coloring.form.html",
                  controller: "ColoringFormController",
                  controllerAs: "ctrl",
                  scope: $scope,
                  windowTopClass: "form-modal small-modal",
                  resolve: {
                    Color: function ($api, $stateParams, $rootScope) {
                      $rootScope.$stateParams = $stateParams;
                      return (coloring_id) ? $api.resolve("coloring.single@get", {"id": coloring_id}) : null;
                    },
                    Customer: Customer
                  }
              }).closed.then(function() {
                
              });
            }

            ctrl.add_form = function() {
              $uibModal.open({
                  templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                  controller: "CustomersDigitalFormsAddController",
                  controllerAs: "ctrl",
                  scope: $scope,
                  windowTopClass: "form-modal medium-modal laser-file-modal",
                  resolve: {
                    Customer: Customer,
                    DigitalForms: ['$api', function($api) {
                      return $api.resolve("digital_forms@get");
                    }],
                    DigitalForm: null,
                    Order: null,
                    OrderForm: false,
                  }
              }).closed.then(function() {
                $state.transitionTo("app.customers.single", { "id": $scope.customer.id }, { reload: true });
              });
            }

            ctrl.change_item_type = function(type) {
              if (ctrl.active_item_type == type) {
                ctrl.active_item_type = '';
              } else {
                ctrl.active_item_type = type;
              }
              var new_data = [];
              for ( var k in $scope.customer.transactions_items ) {
                if ($scope.customer.transactions_items[k]['type'] == ctrl.active_item_type || ctrl.active_item_type == '') {
                  new_data.push($scope.customer.transactions_items[k]);
                }
              }
              
              ctrl.tableData = new_data;
            }



            //Laser file
            ctrl.laser_form = [];
            ctrl.laser_fields = [];
            ctrl.laser_blank = {};
            ctrl.laser_orders = {};
            ctrl.laser_orders_count = {};
    
            if (LaserInfo.data) {
              for (var i in LaserInfo.data) {
                if (LaserInfo.data[i].active) {
                  ctrl.laser_fields.push(LaserInfo.data[i]);
                  ctrl.laser_blank[LaserInfo.data[i].id] = '';
                }
              }
            }

            ctrl.init_laser_list = function(data){
              ctrl.laser_form = [];
              ctrl.laser_orders = {};
              ctrl.laser_orders_count = {};
              for (var i in data) {
                var d = JSON.parse(data[i].data);
                d.id = data[i].id
                d.show = false
                d.category_id = data[i].category_id;
                for (var j in ctrl.laser_fields) {
                    //old code compatibility
                    if (d[ctrl.laser_fields[j].code]) {
                      d[ctrl.laser_fields[j].id] = d[ctrl.laser_fields[j].code];
                    }
                    //old list code compatibility
                    if (ctrl.laser_fields[j].list) {
                      for (var k in ctrl.laser_fields[j].list) {
                        if (ctrl.laser_fields[j].list[k].code && ctrl.laser_fields[j].list[k].code == d[ctrl.laser_fields[j].id]) {
                          d[ctrl.laser_fields[j].id] = String(ctrl.laser_fields[j].list[k].id);
                        }
                      }
                    }


                    if ((ctrl.laser_fields[j].type == 'date' || ctrl.laser_fields[j].type == 'datetime') && d[ctrl.laser_fields[j].id]) {
                      d[ctrl.laser_fields[j].id] = new Date(d[ctrl.laser_fields[j].id]);
                    }
                }

                if (!ctrl.laser_orders[data[i].order_id]) {
                  d.first = true;
                } else {
                  d.first = false;
                }

                if (data[i].order_id) {
                  ctrl.laser_orders[data[i].order_id] = 'closed';
                  ctrl.laser_orders_count[data[i].order_id] = ctrl.laser_orders_count[data[i].order_id] ? ctrl.laser_orders_count[data[i].order_id] + 1 : 1;
                  d.order_id = data[i].order_id;
                }

                ctrl.laser_form.push(d);
              }
            }

            ctrl.display_laser_orders = function(data, hide) {
              ctrl.laser_orders[data.order_id] = hide ? 'closed' : 'opened';
              for (var i in ctrl.laser_form) {
                if (ctrl.laser_form[i].order_id == data.order_id) {
                  ctrl.laser_form[i].show = hide ? false : true;
                }
              }
            }
    
            ctrl.submit_fields = function(easy){
                $api.laser_file.save({form: ctrl.laser_form, customer_id: Customer.data.id}, function(response){
                    if (response.status === "success"){
                      ctrl.init_laser_list(response.data);
                    }
                    if(response.status === "success" && !easy){
                        swal({
                            title: $translate.instant('SWAL_CUSTOMER_LASER_FILE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    }
                });
            };

            ctrl.updateQuotationStatus = function(transactionId, statusId) {
              var statusValue = statusId === '' ? null : statusId;
              $api.transactions.quotation_status.save({id: transactionId}, {quotation_status_id: statusValue}, function(response) {
                if(response.status == "success") {
                  for (var i = 0; i < ctrl.tableData.length; i++) {
                    if (ctrl.tableData[i].id == transactionId) {
                      ctrl.tableData[i].quotation_status_id = statusValue;
                      break;
                    }
                  }
                }
              });
            };

            /**
             * Get quotation status color for background
             */
            ctrl.getQuotationStatusColor = function(statusId) {
              if (!statusId || !ctrl.quotation_statuses) return ctrl.hexToRgbA('#a9cfe8');
              for (var i = 0; i < ctrl.quotation_statuses.length; i++) {
                if (String(ctrl.quotation_statuses[i].id) === String(statusId)) {
                  return ctrl.hexToRgbA(ctrl.quotation_statuses[i].color || '#a9cfe8');
                }
              }
              return ctrl.hexToRgbA('#a9cfe8');
            };
    
            ctrl.add_line = function(){
              //var copy = JSON.parse(JSON.stringify(ctrl.laser_blank));
              var copy = {};
              copy.show = true;
              copy.category_id = ctrl.laser_category;
              
              if (LaserInfo.data) {
                for (var i in LaserInfo.data) {
                    if (LaserInfo.data[i].active && LaserInfo.data[i].category_id == ctrl.laser_category) {
                      if (LaserInfo.data[i].type == 'date' || LaserInfo.data[i].type == 'datetime') {
                        copy[LaserInfo.data[i].id] = new Date(new Date().setSeconds(0, 0));
                      } else {
                        copy[LaserInfo.data[i].id] = '';
                      }
                    }
                }
              }

              ctrl.laser_form.push(copy);
            };
    
            ctrl.remove_line = function(index){
              swal({
                  title: "",
                  text: $translate.instant('LASER_FILE_REMOVE_LINE_CONFIRM'),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                  confirmButtonClass: "btn-danger",
                  closeOnConfirm: false,
                  showLoaderOnConfirm: true
              }).then(function(result) {
                  if(result.value) {
                    ctrl.laser_form[index].remove = true;
                    ctrl.submit_fields(true);
                  }
              });
            };

            ctrl.laser_map = function(index, field){
              $('body').addClass('fixed-body');
              $uibModal.open({
                templateUrl: "app/modules/settings/laser_file/map/laser_file.map.html",
                controller: "LaserFileMapController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Data: ctrl.laser_form[index],
                  Field: field
                }
              }).result.then(function (val) {
                $('body').removeClass('fixed-body');
                if (val) {
                  ctrl.laser_form[index].menmap = val.men;
                  ctrl.laser_form[index][field.id] = val.existed;
                  ctrl.submit_fields(true);
                }
              });
            };

            ctrl.add_note = function(note) {
              $uibModal.open({
                templateUrl: "app/modules/notes/modules/notes-form/notes.form.html",
                controller: "NotesFormController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Customer: function($api) {
                    return {data: Customer && Customer.data ? {id: Customer.data.id, name: (Customer.data.firstname || '') + " " + (Customer.data.lastname || '')} : null};
                  },
                  Resources: function($api) {
                    return $api.resolve("resources@get");
                  },
                  Note: note ? note : null,
                }
              }).result.then(function (val) {
                ctrl.setActiveTab('notes');
              });
            };

            ctrl.add_medical_note = function(medical_note) {
              $uibModal.open({
                templateUrl: "app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html",
                controller: "MedicalNotesFormController",
                controllerAs: "ctrl",
                scope: $scope,
                smallModal: true,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Customer: function($api) {
                    return {data: Customer && Customer.data ? {id: Customer.data.id, name: (Customer.data.firstname || '') + " " + (Customer.data.lastname || '')} : null};
                  },
                  Resources: function($api) {
                    return $api.resolve("resources@get");
                  },
                  MedicalNote: medical_note ? medical_note : null,
                  OrderLink: function() {
                    return null;
                  },
                }
              }).result.then(function (val) {
                ctrl.setActiveTab('medical_notes');
              });
            };

            ctrl.open_medical_note_log = function (event, medical_note) {
              event.stopPropagation();
              $uibModal.open({
                templateUrl: "app/modules/medical_notes/modules/medical_notes-log/medical_notes.log.html",
                controller: "MedicalNotesLogController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal large-modal",
                resolve: {
                  Log: function($api) {
                    return $api.resolve("medical_notes.log@get", {"id": medical_note.id});
                  }
                }
              });
            };

            $scope.uploadFile = function(element){
              if (element.files && element.files.length > 0) {
                for (var i = 0; i < element.files.length; i++) {
                  $scope.postFile(element.files[i]);
                }
              }
            };


            $scope.postFile = function(file){
              var fdata = new FormData();
              fdata.append("file", file);
              fdata.append("customer_id", Customer.data.id);
  
              $resource($api.baseURL + '/Files/upload', {}, {
                  postWithFile: {
                      method: "POST",
                      params: fdata,
                      transformRequest: angular.identity,
                      headers: {'Content-Type': undefined}
                  }
              }).postWithFile(fdata).$promise.then(function(response){
                  if (response) {
                      if(response.status == "success"){
                        ctrl.setActiveTab('files');
                      } else if (response.status == "failed"){
                        swal({
                            title: response.message,
                            type: "error",
                            timer: 3000
                        });
                      }
                  }
              }, function(error){
                  console.log(error);
              });
            };

          ctrl.deleteFile = function (id) {
            swal({
              title: "",
              text: $translate.instant('SWAL_FILES_DELETE_CONFIRM_TEXT'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
              confirmButtonClass: "btn-danger",
              closeOnConfirm: false,
              showLoaderOnConfirm: true
            }).then(function(result) {
              if(result.value)
                $api.files.single.delete({id: id}, function(response) {
                  if(response.status == "success") {
                    ctrl.setActiveTab('files');

                    swal({
                        title: $translate.instant('SWAL_FILES_DELETE_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $scope.$close();
                  }
                });
            });
        };

        ctrl.removeForm = function(id) {
          swal({
            title: "",
            text: $translate.instant('SWAL_CUSTOMER_DELETE_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
              if(result.value)
                  $api.customer_forms.delete({id: id}, function(response) {
                      if(response.status == "success") {
                        $state.transitionTo("app.customers.single", { "id": $scope.customer.id }, { reload: true });
                      }
                  });
          });
        };

        ctrl.print_form = function(form_id) {
          $uibModal.open({
            templateUrl: "app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html",
            controller: "CustomersDigitalFormsPrintController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal laser-file-modal",
            resolve: {
              DigitalForm: function ($api, $stateParams, $rootScope) {
                $rootScope.$stateParams = $stateParams;
                return $api.resolve("customer_forms@get", {"id": form_id});
              }
            }
          });
        };

        ctrl.send_form = function(form_id) {
          $api.customer_forms.pdf.save({id: form_id}, function(response) {
            if (response.status == "success") {
              swal({
                title: $translate.instant('SWAL_CUSTOMER_FORM_SEND_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
            }
          });
        };

        ctrl.request_card = function() {
          //ask swal
          swal({
            title: $translate.instant('SWAL_CUSTOMER_CARD_REQUEST_TITLE'),
            text: "",
            type: "question",
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-primary",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if(result.value) {
              $api.customers.request_card.get({
                id: Customer.data.id
              }, function(response) {
                if(response.status == "success") {
                  swal({
                    title: $translate.instant('SWAL_CUSTOMER_CARD_REQUEST_SUCCESS_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                } else {
                  swal({
                    title: $translate.instant('SWAL_CUSTOMER_CARD_REQUEST_ERROR_TITLE'),
                    text: $translate.instant(response.data.message),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 3000
                  });
                }
              });
            }
          });
        };

        ctrl.goToOrder = function(event, order) {
          event.preventDefault();
          event.stopPropagation();
          $state.go('app.calendar.date', {date: moment(order.order_date, 'HH:mm DD/MM/YYYY').format('YYYY-MM-DD HH:mm')});
        };

        ctrl.dropMenu = function(){
          ctrl.menuOrderedList = ctrl.normalizeMenuOrder(ctrl.menuOrderedList);

          var activeMenu = ctrl.menuOrderedList.find(function(item) {
            return item.name == ctrl.active_tab;
          });

          if (activeMenu && !activeMenu.display) {
            var firstDisplayedMenu = ctrl.menuOrderedList.find(function(item) {
              return item.display;
            });

            if (firstDisplayedMenu) {
              ctrl.setActiveTab(firstDisplayedMenu.name);
            } else if (ctrl.menuOrderedList.length) {
              ctrl.setActiveTab(ctrl.menuOrderedList[0].name);
            }
          }

          var order = [];
          for (var i in ctrl.menuOrderedList) {
            var orderItem = ctrl.normalizeMenuItem(ctrl.menuOrderedList[i]);
            if (orderItem) {
              order.push(orderItem);
            }
          }

          $api.settings.menuorder.save({order: order}, function(response) {
            
          });
        };

        ctrl.calculateAge = function (birthdate) {
          if (!birthdate) return '';
          var birthDate = new Date(birthdate);
          var today = new Date();
          var age = today.getFullYear() - birthDate.getFullYear();
          var monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }
          return age;
        };

        ctrl.hexToRgbA = function(hex){
          var c;
          if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
              c= hex.substring(1).split('');
              if(c.length== 3){
                  c= [c[0], c[0], c[1], c[1], c[2], c[2]];
              }
              c= '0x'+c.join('');
              return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
          }
          return 'rgba(169,207,232,0.1)';
        }


        });
})();

(function() {

    angular.module("app.controllers").controller("CustomersPublicFormController", function($scope, $state, $api, dates,
     Customer, $rootScope, $tiff_page, $resource, $translate) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      $scope.isMobile = (angular.element(document).width() < 769);

      ctrl.form = {
         firstname: '',
         lastname: '',
         email: '',
         phone: '',
         birthdate: '',
         gender: '',
         telephone: '',
         address: '',
         city: '',
         zipcode: '',
         home_number: '',
         dealer_id: '',
         avatar: '',
      };

      $scope.business = Customer.business ? Customer.business : null;
   

      /**
       * Initialize edit data
       */
      if (Customer != null && Customer.data) {
        ctrl.form = Customer.data;
        ctrl.form.gender = String(ctrl.form.gender);
        
        if (ctrl.form.birthdate != null) {
          ctrl.form.birthdate = String(ctrl.form.birthdate).split("-");
          ctrl.form.birthdate_year = String(Number(ctrl.form.birthdate[0]));
          ctrl.form.birthdate_month = String(Number(ctrl.form.birthdate[1]));
          ctrl.form.birthdate_day = String(Number(ctrl.form.birthdate[2]));
        }
      }
      /**
       * Give access from the scope to the datesProvider
       */
      $scope.datesProvider = dates;
      ctrl.birthdateYearOptions = dates.years.map(function(year) {
        return {
          value: String(year),
          label: String(year)
        };
      });
      ctrl.birthdateMonthOptions = dates.months.map(function(monthName, monthIndex) {
        return {
          value: String(monthIndex + 1),
          label: monthName
        };
      });
      ctrl.birthdateDayOptions = dates.days.map(function(day) {
        return {
          value: String(day),
          label: String(day)
        };
      });

      /**
       * Triggers when customers form is submited
       * Preparing the API call for creating or editing the current customer
       */
      ctrl.submit = function () {

        if (ctrl.form.gender == null)
          ctrl.form.gender = -1;

        if (Customer !== null) {
         $tiff_page.start_loading('save_customer');
         $api.social.customer_post.save({
            id: $rootScope.$stateParams.id
          }, ctrl.form, function (response) {
            $scope.business = false;
            $tiff_page.stop_loading('save_customer');
            swal({
              title: $translate.instant('CUSTOMER_PUBLIC_SAVED'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            }).then(function(){
            });

          }, function (response) {
            $tiff_page.stop_loading('save_customer');
            var error = '';
            if (response.data.errors) {
              for (var key in response.data.errors) {
                error += response.data.errors[key] + '<br>';
              }
            }

            swal({
              title: $translate.instant('CUSTOMER_PUBLIC_ERROR'),
              html: error,
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            }).then(function(){
            });
          });
         }
      };

      /**
       * Upload new avatar
       *
       * @param element
       */
      $scope.uploadImage = function (element) {
        var file = element.files[0];
        var obj = new FormData();
        var new_file_name = 'customer_avatar' + '_' + Date.now() + '.' + element.files[0].name.split('.').pop();
        obj.append('image', file, new_file_name);
        obj.append("type", element.name);
        obj.append("customer_id", $rootScope.$stateParams.id);
        var reader = new FileReader();
        reader.onload = function (data) {
          ctrl.sendImage(obj);
        };
        reader.readAsDataURL(file);
      };

      /**
       * Sending file
       *
       * @param fdata
       */
      ctrl.sendImage = function (fdata) {
        $resource($api.baseURL + '/social/action/customer_avatar_upload', {}, {
          postWithFile: {
            method: "POST",
            params: fdata,
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          }
        }).postWithFile(fdata).$promise.then(function (response) {
          ctrl.form.avatar = response.image;
        }, function (error) {
        });
      }

    });

})();

(function(){
    angular.module('app.controllers').controller('CustomersListController',
      function ($state, $header, $scope, $api, $cfilter, Statuses, dates, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log, $timeout, $utils) {
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.statuses = Statuses.data;
        ctrl.statusOptions = [{
          id: '',
          name: $translate.instant('CUSTOMERS_STATUS'),
          color: ''
        }].concat((ctrl.statuses || []).map(function (status) {
          return {
            id: String(status.id),
            name: status.name,
            color: status.color || ''
          };
        }));
        ctrl.dtInstance = {};
        ctrl.customer_name = $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.search : "";
        ctrl.show_deleted = $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.deleted : false;
        ctrl.entriesPerPage = $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.limit : "20";
        
        ctrl.fieldSettings = ($rootScope.$user && $rootScope.$user.table_columns && $rootScope.$user.table_columns.customers) ? $rootScope.$user.table_columns.customers : [];
        var unwatchUser = $scope.$watch(function() {
          return $rootScope.$user;
        }, function(newUser) {
          if (newUser && newUser.table_columns && newUser.table_columns.customers) {
            ctrl.fieldSettings = newUser.table_columns.customers;
            ctrl.updateDtColumns();
            if (unwatchUser) {
              unwatchUser();
            }
          }
        }, true);

        $scope.datesProvider = dates;
        $scope.customerStatuses = {};

        $header.title = "NAV_CUSTOMERS";
        $header.breadcrumbs.push({
          "title": "NAV_CUSTOMERS"
        });

        ctrl.onFieldsUpdate = function(fieldsList) {
          ctrl.fieldSettings = fieldsList;
          $api.settings.table_columns.save({section: 'customers', columns: fieldsList}, function(response) {
            if (response.status == 'success') {
              $rootScope.$user.table_columns.customers = fieldsList;
              ctrl.updateDtColumns();
            }
          }, function(response) {
            console.error('Failed to save table columns', response);
          });
        };


        /**
         * Open customer data
         *
         * @param customerData
         */
        ctrl.open_customer_card = function (customerData) {
          $state.transitionTo("app.customers.single", {
            "id": customerData.id
          }, {
            reload: false
          });
        };

        ctrl.click2Call = function (customerNumber) {
          var user = $rootScope.$user;
          if (!user || !user.telephony_agent_id || !user.telephony_token || !customerNumber) return;
          var url = 'https://login.webpbx.co.il/click2call.php?customer_number=' + encodeURIComponent(customerNumber) + '&agent=' + encodeURIComponent(user.telephony_agent_id) + '&callfirst=0&callerid=00000&clicktocall_token=' + encodeURIComponent(user.telephony_token);
          var img = new Image();
          img.src = url;
        };

        ctrl.download_in_progress = false;
        /**
         * Download customer data
         *
         */
        ctrl.downloadCustomerData = function () {
          var opts = $rootScope.customer_page_data_options || {};

          var colIndex = opts.order;
          var orderDir = opts.order_dir ? opts.order_dir : '';
          var orderCol = '';

          if (colIndex != null && orderDir != '' && ctrl.dtColumns[colIndex]) {
            orderCol = ctrl.dtColumns[colIndex].name;
          }

          var filter = $rootScope.customers_filter || {};

          ctrl.download_in_progress = true;
          $api.customers.download.download(
            {order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted * 1, filter: filter}
            , function success(response) {
              ctrl.download_in_progress = false;

              var blob = new Blob([response.data], { type: 'text/csv;charset=UTF-8' });

              var cd = response.headers('Content-Disposition') ||
                       response.headers('content-disposition') ||
                       '';

              var match = /filename="?([^"]+)"?/.exec(cd);
              var filename = match && match[1] ? match[1] : 'customers.csv';

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }, function error(err) {
              ctrl.download_in_progress = false;
              console.error('Download failed', err);
            }
          );
        };

        /**
         * Initiate DataTable Options
         */
        ctrl.initDtOptions = function(){
          var initialOrder = [];
          if ($rootScope.customer_page_data_options && $rootScope.customer_page_data_options.order_dir) {
            var columnIndex = $rootScope.customer_page_data_options.order; 
            var orderDirection = $rootScope.customer_page_data_options.order_dir;
            initialOrder = [[columnIndex, orderDirection]];
          }

          $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', ctrl.entriesPerPage)
              .withOption('order', initialOrder)
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('displayStart', $rootScope.customer_page_data_options ? $rootScope.customer_page_data_options.offset : 0)
              .withOption('ajax', ctrl.loadCustomers)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('rowCallback', ctrl.customerRawCallback)
              .withOption('initComplete', function() {
                $("#custom-pagination-container").find("#cust_dt_info").remove();
                $("#custom-pagination-container").find("#cust_dt_paginate").remove();
                $("#cust_dt_info").prependTo("#custom-pagination-container");
                $("#cust_dt_paginate").prependTo("#custom-pagination-container");
              })
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.change_deleted = function () {
          ctrl.initDtOptions();
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Load customers
         *
         * @param data
         * @param callback
         * @param settings
         */
        ctrl.loadCustomers = function (data, callback, settings) {
          var orderCol = '';
          var orderDir = '';
          var colIndex = 0;

          if(data.order.length) {
            // Use only last order parameters
            colIndex = data.order[data.order.length - 1].column
            orderCol = data.columns[colIndex]['name'];
            orderDir = data.order[data.order.length - 1].dir;
          }

          $rootScope.customer_page_data_options = {
            limit: data.length,
            offset: data.start,
            order: colIndex,
            order_dir: orderDir,
            search: ctrl.customer_name,
            deleted: ctrl.show_deleted*1
          };

          var filter = $rootScope.customers_filter || {};

          callback({recordsTotal:0, recordsFiltered: 0, data: [], draw: data.draw+1});
          $scope.module_is_loading = true;
          $api.customers.list.get(
            {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.customer_name, deleted: ctrl.show_deleted*1, filter: filter}
            , function (result) {
              $scope.module_is_loading = false;
            if (result && result.data) {
              callback({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: result.data,
                draw: data.draw + 1
              });
            }

          });
        };

        ctrl.customer_name = "";

        /**
         * search customer
         */
        $scope.find_customer = function() {
          if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
            $('#cust_dt').DataTable().ajax.reload();
          }
        }

        /**
         * Bind events to a new row
         *
         * @param nRow
         * @param aData
         * @param iDisplayIndex
         * @param iDisplayIndexFull
         * @returns {*}
         */
        ctrl.customerRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $(nRow).unbind('click').bind('click', function (event) {
            // Prevent click event from firing when clicking on select dropdown
            if ($(event.target).closest('select, .prevent-click').length) {
                event.stopPropagation(); // Stop the event from bubbling up to the row click handler
            } else {
                $scope.$apply(function() {
                    ctrl.open_customer_card(aData);
                });
            }
          });
          return nRow;
        }


        if (window.innerWidth < 768) {
          $.fn.DataTable.ext.pager.numbers_length = 3;
        }

        ctrl.initDtOptions();

        /**
         * Filter
        */
        $cfilter.apply('customers', true);
        $scope.submit_filter = function() {
          $scope.find_customer();
        }

        /**
         * Customer table column definitions
         * @type {*[]}
         */

        ctrl.renderNoteText = function(text) {
          if (!text) {
            return '';
          }

          var value = String(text);
          var urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
          var html = '';
          var lastIndex = 0;
          var match;

          while ((match = urlRegex.exec(value)) !== null) {
            var url = match[0];
            var cleanUrl = url;
            var trailing = '';

            while (cleanUrl && /[.,!?;:)]$/.test(cleanUrl)) {
              trailing = cleanUrl.charAt(cleanUrl.length - 1) + trailing;
              cleanUrl = cleanUrl.substring(0, cleanUrl.length - 1);
            }

            html += $utils.escapeHtml(value.substring(lastIndex, match.index));

            if (cleanUrl) {
              var href = /^https?:\/\//i.test(cleanUrl) ? cleanUrl : 'https://' + cleanUrl;
              html += '<a href="' + $utils.escapeHtml(href) + '" ng-click="$event.stopPropagation()" target="_blank" rel="noopener noreferrer">' + $utils.escapeHtml(cleanUrl) + '</a>';
            }

            html += $utils.escapeHtml(trailing);
            lastIndex = match.index + url.length;
          }

          html += $utils.escapeHtml(value.substring(lastIndex));

          return html;
        }

        // Store original column definitions for lookup
        var originalColumnDefinitions = {
          'name': {
            name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125 w-100',
            render: function(data, type, full, meta) {
              var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
              var html = '<div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>';
              html+= '<b>';
              html+= data.firstname ? ' ' + $utils.escapeHtml(data.firstname) : '';
              html+= data.lastname ? ' ' + $utils.escapeHtml(data.lastname) : '';
              html+= '</b>';
              html+= data.wa_stop ? ' <span class="have-tooltip" tooltip="'+$translate.instant('CUSTOMERS_STOP_WA')+'"><i class="las la-hand-paper color-red"></i></span>' : '';
              return '<div class="flex nowrap">'+html+'</div>';
            }
          },
          'last_visit': {
            name: 'last_visit', data: null, title: $translate('CUSTOMERS_LAST_VISIT'), class: 'customer-name',
            render: function (data, type, full, meta) {
              var add_details = '<span ng-hide="\''+ data['last_visit'] +'\' ==\'01/01/1970\'">'+ (data['last_visit'] ? data['last_visit'] : '') +'</span>'
              
              add_details += '<div class="customers_add_details icons mobile">';

              if (data.oncredit > 0) {
                add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
              }
              if (data.has_cards) {
                add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
              }
              if ((data.has_color)) {
                add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
              }
              
              add_details += '</div>';

              return add_details;
            }
          },
          'desktop_icons': {
            name: 'desktop_icons', data: null, title: '', orderable: false, class: 'desktop-icons-column',
            render: function (data, type, full, meta) {
              var add_details = '<div class="customers_add_details icons desktop">';

              if (data.oncredit > 0) {
                add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
              }
              if (data.has_cards) {
                add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
              }
              if ((data.has_color)) {
                add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
          'icons': {
            name: 'icons', sortable: false, data: null, title: '', class: 'customer-icons',
            render: function (data, type, full, meta) {
              var add_details = '';
              add_details += '<div class="customers_call_details icons" style="'+(((data.oncredit > 0 || data.has_cards || data.has_color) && window.innerWidth < 768) ? 'margin-top: 22px;' : '')+'">';

              if (data.phone) {
                var phone = data.phone;
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                phone = '+972'+phone;

                add_details += window.innerWidth >= 768 ? '<a class="btn icon circle small bordered green" href="/cashbox?customer='+data.id+'"><i class="las la-hand-holding-usd"></i></a>' : '';
                add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                var user = $rootScope.$user;
                var hasClick2Call = user && user.telephony_agent_id && user.telephony_token;
                if (hasClick2Call && data.phone) {
                  var customerNumber = (data.phone || '').replace(/\D/g, '');
                  if (customerNumber) {
                    var safeNum = customerNumber.replace(/'/g, "\\'");
                    add_details += '<a class="btn icon circle small bordered blue" href="javascript:void(0)" ng-click="d(); $event.stopPropagation(); $event.preventDefault(); ctrl.click2Call(\'' + safeNum + '\')" title="'+$translate.instant('TELEPHONY_CLICK_TO_CALL')+'"><i class="las la-phone-volume"></i></a>';
                  }
                }
                add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
          'gender': {
            name: 'gender', data: null, title: $translate('CUSTOMERS_GENDER'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.gender) {
                case 0:
                  return $translate.instant('CUSTOMERS_GENDER_MALE');
                case 1:
                  return $translate.instant('CUSTOMERS_GENDER_FEMALE');
                default:
                  return $translate.instant('CUSTOMERS_GENDER_NOT_SET');
              }
            }
          },
          'send_notifications': {
            name: 'send_notifications', data: null, title: $translate('SETTINGS_USER_SEND_MESSAGES'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.send_notifications) {
                case 0:
                  return $translate.instant('SETTINGS_USER_REMINDER_NO');
                case 1:
                  return $translate.instant('CUSTOMER_SETTING_EMAIL');
                case 2:
                  return $translate.instant('CUSTOMERS_SMS');
                case 3:
                  return $translate.instant('CUSTOMERS_WHATSAPP');
                default:
                  return '';
              }
            }
          },
          'send_reminder': {
            name: 'send_reminder', data: null, title: $translate('SETTINGS_USER_SEND_REMINDER'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.send_reminder) {
                case 0:
                  return $translate.instant('SETTINGS_USER_REMINDER_NO');
                case 2:
                  return $translate.instant('SETTINGS_USER_REMINDER_2_HOURS');
                case 4:
                  return $translate.instant('SETTINGS_USER_REMINDER_4_HOURS');
                case 24:
                  return $translate.instant('SETTINGS_USER_REMINDER_24_HOURS');
                case 48:
                  return $translate.instant('SETTINGS_USER_REMINDER_48_HOURS');
                case 72:
                  return $translate.instant('SETTINGS_USER_REMINDER_72_HOURS');
                case 168:
                  return $translate.instant('SETTINGS_USER_REMINDER_168_HOURS');
                default:
                  return '';
              }
            }
          },
          'reminder_send_type': {
            name: 'reminder_send_type', data: null, title: $translate('CUSTOMERS_SEND_REMINDER'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.reminder_send_type) {
                case 1:
                  return $translate.instant('SETTINGS_USER_MAIL');
                case 2:
                  return $translate.instant('CUSTOMERS_SMS');
                case 3:
                  return $translate.instant('CUSTOMERS_WHATSAPP');
                default:
                  return '';
              }
            }
          },
          'request_order_confirmation': {
            name: 'request_order_confirmation', data: null, title: $translate('SETTINGS_USER_SEND_ORDER_CONFIRMATION'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              return data.request_order_confirmation == 0 ? $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO') : $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES');
            }
          },
          'send_documents': {
            name: 'send_documents', data: null, title: $translate('CUSTOMERS_SEND_DOCUMENTS'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              switch (data.send_documents) {
                case 0:
                  return $translate.instant('SETTINGS_USER_REMINDER_NO');
                case 1:
                  return $translate.instant('CUSTOMER_SETTING_EMAIL');
                case 2:
                  return $translate.instant('CUSTOMERS_SMS');
                case 3:
                  return $translate.instant('CUSTOMERS_WHATSAPP');
                case 4:
                  return $translate.instant('CUSTOMERS_PRINT');
                default:
                  return '';
              }
            }
          },
          'self_order': {
            name: 'self_order', data: null, title: $translate('CUSTOMERS_IND_ORD'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              return data.self_order == 0 ? $translate.instant('CUSTOMERS_UNAUTHORIZED') : $translate.instant('CUSTOMERS_ALLOWED');
            }
          },
          'group_notifications': {
            name: 'group_notifications', data: null, title: $translate('CUSTOMERS_GROUP_MESS'), hide: true, sortable: false,
            render: function(data, type, full, meta) {
              return data.group_notifications == 0 ? $translate.instant('CUSTOMERS_OFF') : $translate.instant('CUSTOMERS_ACTIVE');
            }
          },
          'last_note': {
            name: 'last_note', data: null, title: $translate('CUSTOMERS_LAST_NOTE'), hide: true, sortable: false, class: 'last-note-column',
            render: function(data, type, full, meta) {
              return ctrl.renderNoteText(data.last_note);
            }
          },
          'last_note_remind_at': {
            name: 'last_note_remind_at', data: null, title: $translate('CUSTOMERS_LAST_NOTE_REMIND_AT'), hide: true, sortable: false, class: 'last-note-remind-at-column',
            render: function(data, type, full, meta) {
              if (!data.last_note_remind_at) {
                return '';
              }
              try {
                var remindDate = moment(data.last_note_remind_at);
                if (remindDate.isValid()) {
                  return remindDate.format('DD/MM/YYYY HH:mm');
                }
              } catch (e) {
                // Fall through to default handling
              }
              return data.last_note_remind_at;
            }
          },
          'statuses_name': {
            name: 'statuses_name', data: null, title: $translate('CUSTOMERS_STATUS'), class: 'customer-status',
            render: function(data, type, full, meta) {
              //return data.statuses_name ? '<span class="btn btn-primary btn-xs category-item" style="background-color: '+ctrl.hexToRgbA(data.statuses_color ? data.statuses_color : '#a9cfe8')+'">'+data.statuses_name+'</span>' : '';
              $scope.customerStatuses[data.id] = String(data.status_id || '');
              return '<div class="form-group form-list prevent-click">'
                +'<app-dropdown model="customerStatuses[' + data.id + ']"'
                  +' options="ctrl.statusOptions"'
                  +' value-prop="id"'
                  +' label-prop="name"'
                  +' color-prop="color"'
                  +' fixed-panel="true"'
                  +' placeholder="{{\'CUSTOMERS_STATUS\' | translate}}"'
                  +' on-change="ctrl.updateData(' + data.id + ', {status_id: model})">'
                +'</app-dropdown></div>';
            }
          },
        };

        function createSimpleColumn(name, translationKey, fieldType, customFieldId) {
          // For custom fields, translationKey is the actual field name, not a translation key
          // For regular fields, translationKey is a translation key that needs to be translated
          var isCustomField = name && name.indexOf('custom_field_') === 0;
          var title = isCustomField ? translationKey : $translate(translationKey);
          
          return {
            name: name,
            data: null,
            title: title,
            sortable: false,
            class: 'default-custom-column',
            render: function(data, type, full, meta) {
              if (!data || !data[name]) {
                return '';
              }
              
              var value = data[name];
              
              // Handle custom field types
              if (fieldType === 'date' && value) {
                try {
                  // Handle ISO date strings or timestamps
                  var dateValue = moment(value);
                  if (dateValue.isValid()) {
                    return dateValue.format('DD/MM/YYYY');
                  }
                } catch (e) {
                  // Fall through to default handling
                }
              } else if (fieldType === 'datetime' && value) {
                try {
                  var dateTimeValue = moment(value);
                  if (dateTimeValue.isValid()) {
                    return dateTimeValue.format('DD/MM/YYYY HH:mm');
                  }
                } catch (e) {
                  // Fall through to default handling
                }
              }
              
              // For text and list types, or if date formatting failed, return escaped string
              return $utils.escapeHtml(String(value));
            }
          };
        }
        
        ctrl.updateDtColumns = function() {
          var newColumns = [];
          for (var i = 0; i < ctrl.fieldSettings.length; i++) {
            var field = ctrl.fieldSettings[i];
            
            if (field.display) {
              if (originalColumnDefinitions[field.name] || field.name === 'buttons') {
                if (field.name === 'buttons') {
                  newColumns.push(originalColumnDefinitions['desktop_icons']);
                  newColumns.push(originalColumnDefinitions['icons']);
                } else {
                  newColumns.push(originalColumnDefinitions[field.name]);
                }
              } else {
                // Pass field type and custom_field_id for custom fields
                var fieldType = field.type || null;
                var customFieldId = field.custom_field_id || null;
                newColumns.push(createSimpleColumn(field.name, field.translationKey || field.name, fieldType, customFieldId));
              }
            }
          }

          if (newColumns.length === 0) {
            for (var key in originalColumnDefinitions) {
              if (originalColumnDefinitions[key].hide) continue;
              newColumns.push(originalColumnDefinitions[key]);
            }
          }
          
          ctrl.dtColumns = newColumns;
        };

        ctrl.dtColumns = [];
        ctrl.updateDtColumns();

        ctrl.updateData = function(customerId, newValue) {
          newValue.id = customerId;
          $api.customers.update.save(newValue, function(response) {
            if(response.status == "success") {
              $state.transitionTo("app.customers", {}, {reload: true});
            }
          });
        }

        /**
         * Get status color for background
         */
        ctrl.getStatusColor = function(statusId) {
          if (!statusId || !ctrl.statuses) return '';
          for (var i = 0; i < ctrl.statuses.length; i++) {
            if (String(ctrl.statuses[i].id) === String(statusId)) {
              return ctrl.hexToRgbA(ctrl.statuses[i].color || '#a9cfe8');
            }
          }
          return '';
        }

        /**
         * Convert hex color to rgba with opacity
         */
        ctrl.hexToRgbA = function(hex){
          if (!hex) return '';
          var c;
          if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
              c= hex.substring(1).split('');
              if(c.length== 3){
                  c= [c[0], c[0], c[1], c[1], c[2], c[2]];
              }
              c= '0x'+c.join('');
              return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
          }
          return 'rgba(169,207,232,0.2)';
        }
      });
})();

(function() {

    angular.module("app.controllers").controller("CustomersFormController", function($scope, $state, $api, $customFields, dates,
     Customer, isModal, Lead, Info, Resources, Statuses, Interested, CustomFields, Phone, $rootScope, $uibModalInstance, $tiff_page, $translate, $resource) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }

      var ctrl = this;
      $scope.isMobile = (angular.element(document).width() < 769);
      ctrl.customer_country = {
        "code": "IL",
        "name": "Israel"
      };
      $scope.isModal = isModal;
      ctrl.resources = Resources.data;
      ctrl.statuses = Statuses.data;
      ctrl.interesteds = Interested.data;
      ctrl.resourceOptions = normalizeIdOptions(ctrl.resources);
      ctrl.salesResourceOptions = ctrl.resourceOptions.filter(function(resource) {
        return resource.sales_active;
      });
      ctrl.statusOptions = addEmptyOption(normalizeIdOptions(ctrl.statuses), 'CUSTOMERS_STATUS');
      ctrl.interestedOptions = addEmptyOption(normalizeIdOptions(ctrl.interesteds), 'CUSTOMERS_INTERESTED');
      ctrl.resourceLeadOptions = addEmptyOption(ctrl.salesResourceOptions, 'CUSTOMERS_RESOURSE');

      ctrl.form = {
        gender: "-1",
        send_notifications: "0",
        self_order: Info.data.allow_online_booking*1 > 0 ? "1" : "0",
        group_notifications: "1",
        lead: Lead ? true : false,
        lead_platform: Lead ? 'manual' : null,
        custom_values: {},
      };

      ctrl.customFields = CustomFields.data ? CustomFields.data : [];
      ctrl.customFields.forEach(function (field) {
         field.name = $customFields.getCurrentName(field.name);
         if (field.type === 'list' && field.values) {
            field.values = addEmptyValueOption(field.values.filter(function(value) {
               return value.active === true;
            }).map(function(value) {
               var option = angular.copy(value);
               option.id = String(option.id);
               return option;
            }));
         }
         ctrl.form.custom_values[field.id] = (field.type === 'date' || field.type === 'datetime') ? (new Date()) : '';
      });

      ctrl.bu_type = parseInt(Info.data.type);

      /**
       * Initialize edit data
       */
      if (Customer != null) {
        ctrl.form = Customer.data;
        ctrl.form.gender = String(ctrl.form.gender);
        ctrl.form.status_id = ctrl.form.status_id ? String(ctrl.form.status_id) : '';
        ctrl.form.interested_id = ctrl.form.interested_id ? String(ctrl.form.interested_id) : '';
        ctrl.form.send_notifications = String(Number(ctrl.form.send_notifications));
        ctrl.form.self_order = String(Number(ctrl.form.self_order));
        ctrl.form.group_notifications = String(Number(ctrl.form.group_notifications));
        ctrl.form.resource = String(ctrl.form.resource);
        ctrl.form.resource_lead = String(ctrl.form.resource_lead);
        if (ctrl.form.country == null) {
          ctrl.form.country = "IL";
        }

        if (ctrl.form.birthdate != null) {
          ctrl.form.birthdate = String(ctrl.form.birthdate).split("-");
          ctrl.form.birthdate_year = String(Number(ctrl.form.birthdate[0]));
          ctrl.form.birthdate_month = String(Number(ctrl.form.birthdate[1]));
          ctrl.form.birthdate_day = String(Number(ctrl.form.birthdate[2]));
        }

        if (ctrl.customFields.length > 0) {
         var custom_values = {}
         ctrl.customFields.forEach(function (field) {
            var value = ctrl.form.custom_values[field.id];
            if (field.type === 'date' || field.type === 'datetime') {
               if (value) {
                  custom_values[field.id] = new Date(value);
               } else {
                  custom_values[field.id] = new Date();
               }
            } else {
               custom_values[field.id] = value || '';
            }
         });

         ctrl.form.custom_values = custom_values;
        }
      } else {
        ctrl.form.send_notifications = Info.data.msg_channel_scheduling;
        ctrl.form.send_documents = Info.data.msg_channel_inv_link;
        ctrl.form.send_reminder = Info.data.send_reminder;
        ctrl.form.reminder_send_type = Info.data.reminder_send_type;
        ctrl.form.request_order_confirmation = Info.data.request_order_confirmation;
        if(ctrl.resources && ctrl.resources.length > 0) {
          for(var i in ctrl.resources) {
            if(ctrl.resources[i]['is_default'] == true) {
              ctrl.form.resource = String(ctrl.resources[i]['id']);
            }
          }
        }

        if (Phone != null) {
            //check if it's number then phone alse name
            if (Phone.match(/^\d+$/)) {
               ctrl.form.phone = Phone;
            } else {
               ctrl.form.firstname = Phone;
            }
         }
      }

      ctrl.form.avatar = ctrl.form.avatar ? ctrl.form.avatar : 'assets/images/avatar.jpg';

      /**
       * Give access from the scope to the datesProvider
       */
      $scope.datesProvider = dates;
      ctrl.yearOptions = buildSimpleDateOptions(dates.years, 'CUSTOMERS_YEAR');
      ctrl.dayOptions = buildSimpleDateOptions(dates.days, 'CUSTOMERS_DAY');
      ctrl.monthOptions = buildMonthOptions(dates.months);

      function normalizeIdOptions(options) {
        return (options || []).map(function(option) {
          var normalized = angular.copy(option);
          normalized.id = String(normalized.id);
          return normalized;
        });
      }

      function addEmptyOption(options, placeholderKey) {
        return [{id: '', name: $translate.instant(placeholderKey)}].concat(options || []);
      }

      function addEmptyValueOption(options) {
        return [{id: '', value: $translate.instant('CUSTOMERS_CUSTOM_FIELDS_LIST_PLACEHOLDER')}].concat(options || []);
      }

      function buildSimpleDateOptions(values, placeholderKey) {
        var options = [
          { id: '', name: $translate.instant(placeholderKey) }
        ];

        angular.forEach(values, function(value) {
          options.push({
            id: String(value),
            name: String(value)
          });
        });

        return options;
      }

      function buildMonthOptions(months) {
        var options = [
          { id: '', name: $translate.instant('CUSTOMERS_MONTH') }
        ];

        angular.forEach(months, function(monthName, month) {
          options.push({
            id: String(Number(month) + 1),
            name: monthName
          });
        });

        return options;
      }

      /**
       * Triggers when customers form is submited
       * Preparing the API call for creating or editing the current customer
       */
      ctrl.submit = function () {

        if (ctrl.form.gender == null)
          ctrl.form.gender = -1;

        $tiff_page.start_loading('save_customer');
        if (Customer == null) {
          $api.customers.save(ctrl.form, function (response) {
            $tiff_page.stop_loading('save_customer');
            if (response.status == "success") {

              if ($scope.isModal) {
                var promise = $api.resolve("customers.single@get", {"id": response.id});
                promise.then(function (response) {
                  $uibModalInstance.close(response.data);
                });
              } else {
                  $state.transitionTo((ctrl.form.lead) ? "app.leads" : "app.customers", {}, {reload: true});
              }
            }
          }, function (response) {
            $tiff_page.stop_loading('save_customer');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_CUSTOMER_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
        } else {
          $api.customers.single.save({
            id: Customer.data.id
          }, ctrl.form, function (response) {
            $tiff_page.stop_loading('save_customer');
            $uibModalInstance.close(response.data);
            if (response.status == "success") {
              swal({
                title: $translate.instant('SWAL_CUSTOMER_SAVE_TITLE'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              $state.transitionTo((ctrl.form.lead) ? "app.leads.single" : "app.customers.single", {id: Customer.data.id}, {reload: true});
            }
          }, function (response) {
            $tiff_page.stop_loading('save_customer');
            if(response && response.data.message)
              swal({
                title: $translate.instant('SWAL_CUSTOMER_SAVE_ERROR_TITLE'),
                text: $translate.instant(response.data.message),
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 3000
              });
          });
         }
      };

      ctrl.moveToLeads = function () {
         ctrl.form.lead = true;
         $tiff_page.stop_loading('save_customer');
         $api.customers.single.save({
            id: Customer.data.id
          }, ctrl.form, function (response) {
            $tiff_page.stop_loading('save_customer');
         });
      };

      ctrl.onCountryChange = function () {
        ctrl.form.country = ctrl.customer_country.code;
      }

      /**
       * Initialize phone_exists flag
       */
      ctrl.phone_exists = false;

      /**
       * Check if phone number already exists
       */
      ctrl.checkPhoneExists = function () {
         var phone = !ctrl.form.phone || ctrl.form.phone.trim() === '' ? '' : ctrl.form.phone.replace(/[^\d]/g, '');
         console.log(phone);
        if (phone.length === 0) {
          ctrl.phone_exists = false;
          return;
        }
        
        var exclude_id = Customer && Customer.data ? Customer.data.id : null;
        var params = { phone: phone };
        if (exclude_id) {
          params.exclude_id = exclude_id;
        }

        $api.customers.check_phone.get(params, function (response) {
          if (response.status === "success") {
            ctrl.phone_exists = response.exists;
          } else {
            ctrl.phone_exists = false;
          }
        }, function (error) {
          ctrl.phone_exists = false;
        });
      }

      /**
       * Upload new avatar
       *
       * @param element
       */
      $scope.uploadImage = function (element) {
        var file = element.files[0];
        var obj = new FormData();
        var new_file_name = 'customer_avatar' + '_' + Date.now() + '.' + element.files[0].name.split('.').pop();
        obj.append('image', file, new_file_name);
        obj.append("type", element.name);
        obj.append("customer_id", ctrl.form.id);
        var reader = new FileReader();
        reader.onload = function (data) {
          ctrl.sendImage(obj);
        };
        reader.readAsDataURL(file);
      };

      /**
       * Sending file
       *
       * @param fdata
       */
      ctrl.sendImage = function (fdata) {
        $resource($api.baseURL + '/Image/upload', {}, {
          postWithFile: {
            method: "POST",
            params: fdata,
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          }
        }).postWithFile(fdata).$promise.then(function (response) {
          ctrl.form.avatar = response.image;
        }, function (error) {
        });
      }

        $scope.countries = [
            {
               "code":"AF",
               "name":"Afghanistan"
            },
            {
               "code":"AX",
               "name":"\u00c5land Islands"
            },
            {
               "code":"AL",
               "name":"Albania"
            },
            {
               "code":"DZ",
               "name":"Algeria"
            },
            {
               "code":"AS",
               "name":"American Samoa"
            },
            {
               "code":"AD",
               "name":"Andorra"
            },
            {
               "code":"AO",
               "name":"Angola"
            },
            {
               "code":"AI",
               "name":"Anguilla"
            },
            {
               "code":"AQ",
               "name":"Antarctica"
            },
            {
               "code":"AG",
               "name":"Antigua and Barbuda"
            },
            {
               "code":"AR",
               "name":"Argentina"
            },
            {
               "code":"AM",
               "name":"Armenia"
            },
            {
               "code":"AW",
               "name":"Aruba"
            },
            {
               "code":"AU",
               "name":"Australia"
            },
            {
               "code":"AT",
               "name":"Austria"
            },
            {
               "code":"AZ",
               "name":"Azerbaijan"
            },
            {
               "code":"BS",
               "name":"Bahamas"
            },
            {
               "code":"BH",
               "name":"Bahrain"
            },
            {
               "code":"BD",
               "name":"Bangladesh"
            },
            {
               "code":"BB",
               "name":"Barbados"
            },
            {
               "code":"BY",
               "name":"Belarus"
            },
            {
               "code":"BE",
               "name":"Belgium"
            },
            {
               "code":"BZ",
               "name":"Belize"
            },
            {
               "code":"BJ",
               "name":"Benin"
            },
            {
               "code":"BM",
               "name":"Bermuda"
            },
            {
               "code":"BT",
               "name":"Bhutan"
            },
            {
               "code":"BO",
               "name":"Bolivia, Plurinational State of"
            },
            {
               "code":"BQ",
               "name":"Bonaire, Sint Eustatius and Saba"
            },
            {
               "code":"BA",
               "name":"Bosnia and Herzegovina"
            },
            {
               "code":"BW",
               "name":"Botswana"
            },
            {
               "code":"BV",
               "name":"Bouvet Island"
            },
            {
               "code":"BR",
               "name":"Brazil"
            },
            {
               "code":"IO",
               "name":"British Indian Ocean Territory"
            },
            {
               "code":"BN",
               "name":"Brunei Darussalam"
            },
            {
               "code":"BG",
               "name":"Bulgaria"
            },
            {
               "code":"BF",
               "name":"Burkina Faso"
            },
            {
               "code":"BI",
               "name":"Burundi"
            },
            {
               "code":"KH",
               "name":"Cambodia"
            },
            {
               "code":"CM",
               "name":"Cameroon"
            },
            {
               "code":"CA",
               "name":"Canada"
            },
            {
               "code":"CV",
               "name":"Cape Verde"
            },
            {
               "code":"KY",
               "name":"Cayman Islands"
            },
            {
               "code":"CF",
               "name":"Central African Republic"
            },
            {
               "code":"TD",
               "name":"Chad"
            },
            {
               "code":"CL",
               "name":"Chile"
            },
            {
               "code":"CN",
               "name":"China"
            },
            {
               "code":"CX",
               "name":"Christmas Island"
            },
            {
               "code":"CC",
               "name":"Cocos (Keeling) Islands"
            },
            {
               "code":"CO",
               "name":"Colombia"
            },
            {
               "code":"KM",
               "name":"Comoros"
            },
            {
               "code":"CG",
               "name":"Congo"
            },
            {
               "code":"CD",
               "name":"Congo, the Democratic Republic of the"
            },
            {
               "code":"CK",
               "name":"Cook Islands"
            },
            {
               "code":"CR",
               "name":"Costa Rica"
            },
            {
               "code":"CI",
               "name":"C\u00f4te d'Ivoire"
            },
            {
               "code":"HR",
               "name":"Croatia"
            },
            {
               "code":"CU",
               "name":"Cuba"
            },
            {
               "code":"CW",
               "name":"Cura\u00e7ao"
            },
            {
               "code":"CY",
               "name":"Cyprus"
            },
            {
               "code":"CZ",
               "name":"Czech Republic"
            },
            {
               "code":"DK",
               "name":"Denmark"
            },
            {
               "code":"DJ",
               "name":"Djibouti"
            },
            {
               "code":"DM",
               "name":"Dominica"
            },
            {
               "code":"DO",
               "name":"Dominican Republic"
            },
            {
               "code":"EC",
               "name":"Ecuador"
            },
            {
               "code":"EG",
               "name":"Egypt"
            },
            {
               "code":"SV",
               "name":"El Salvador"
            },
            {
               "code":"GQ",
               "name":"Equatorial Guinea"
            },
            {
               "code":"ER",
               "name":"Eritrea"
            },
            {
               "code":"EE",
               "name":"Estonia"
            },
            {
               "code":"ET",
               "name":"Ethiopia"
            },
            {
               "code":"FK",
               "name":"Falkland Islands (Malvinas)"
            },
            {
               "code":"FO",
               "name":"Faroe Islands"
            },
            {
               "code":"FJ",
               "name":"Fiji"
            },
            {
               "code":"FI",
               "name":"Finland"
            },
            {
               "code":"FR",
               "name":"France"
            },
            {
               "code":"GF",
               "name":"French Guiana"
            },
            {
               "code":"PF",
               "name":"French Polynesia"
            },
            {
               "code":"TF",
               "name":"French Southern Territories"
            },
            {
               "code":"GA",
               "name":"Gabon"
            },
            {
               "code":"GM",
               "name":"Gambia"
            },
            {
               "code":"GE",
               "name":"Georgia"
            },
            {
               "code":"DE",
               "name":"Germany"
            },
            {
               "code":"GH",
               "name":"Ghana"
            },
            {
               "code":"GI",
               "name":"Gibraltar"
            },
            {
               "code":"GR",
               "name":"Greece"
            },
            {
               "code":"GL",
               "name":"Greenland"
            },
            {
               "code":"GD",
               "name":"Grenada"
            },
            {
               "code":"GP",
               "name":"Guadeloupe"
            },
            {
               "code":"GU",
               "name":"Guam"
            },
            {
               "code":"GT",
               "name":"Guatemala"
            },
            {
               "code":"GG",
               "name":"Guernsey"
            },
            {
               "code":"GN",
               "name":"Guinea"
            },
            {
               "code":"GW",
               "name":"Guinea-Bissau"
            },
            {
               "code":"GY",
               "name":"Guyana"
            },
            {
               "code":"HT",
               "name":"Haiti"
            },
            {
               "code":"HM",
               "name":"Heard Island and McDonald Islands"
            },
            {
               "code":"VA",
               "name":"Holy See (Vatican City State)"
            },
            {
               "code":"HN",
               "name":"Honduras"
            },
            {
               "code":"HK",
               "name":"Hong Kong"
            },
            {
               "code":"HU",
               "name":"Hungary"
            },
            {
               "code":"IS",
               "name":"Iceland"
            },
            {
               "code":"IN",
               "name":"India"
            },
            {
               "code":"ID",
               "name":"Indonesia"
            },
            {
               "code":"IR",
               "name":"Iran, Islamic Republic of"
            },
            {
               "code":"IQ",
               "name":"Iraq"
            },
            {
               "code":"IE",
               "name":"Ireland"
            },
            {
               "code":"IM",
               "name":"Isle of Man"
            },
            {
               "code":"IL",
               "name":"Israel"
            },
            {
               "code":"IT",
               "name":"Italy"
            },
            {
               "code":"JM",
               "name":"Jamaica"
            },
            {
               "code":"JP",
               "name":"Japan"
            },
            {
               "code":"JE",
               "name":"Jersey"
            },
            {
               "code":"JO",
               "name":"Jordan"
            },
            {
               "code":"KZ",
               "name":"Kazakhstan"
            },
            {
               "code":"KE",
               "name":"Kenya"
            },
            {
               "code":"KI",
               "name":"Kiribati"
            },
            {
               "code":"KP",
               "name":"Korea, Democratic People's Republic of"
            },
            {
               "code":"KR",
               "name":"Korea, Republic of"
            },
            {
               "code":"KW",
               "name":"Kuwait"
            },
            {
               "code":"KG",
               "name":"Kyrgyzstan"
            },
            {
               "code":"LA",
               "name":"Lao People's Democratic Republic"
            },
            {
               "code":"LV",
               "name":"Latvia"
            },
            {
               "code":"LB",
               "name":"Lebanon"
            },
            {
               "code":"LS",
               "name":"Lesotho"
            },
            {
               "code":"LR",
               "name":"Liberia"
            },
            {
               "code":"LY",
               "name":"Libya"
            },
            {
               "code":"LI",
               "name":"Liechtenstein"
            },
            {
               "code":"LT",
               "name":"Lithuania"
            },
            {
               "code":"LU",
               "name":"Luxembourg"
            },
            {
               "code":"MO",
               "name":"Macao"
            },
            {
               "code":"MK",
               "name":"Macedonia, the Former Yugoslav Republic of"
            },
            {
               "code":"MG",
               "name":"Madagascar"
            },
            {
               "code":"MW",
               "name":"Malawi"
            },
            {
               "code":"MY",
               "name":"Malaysia"
            },
            {
               "code":"MV",
               "name":"Maldives"
            },
            {
               "code":"ML",
               "name":"Mali"
            },
            {
               "code":"MT",
               "name":"Malta"
            },
            {
               "code":"MH",
               "name":"Marshall Islands"
            },
            {
               "code":"MQ",
               "name":"Martinique"
            },
            {
               "code":"MR",
               "name":"Mauritania"
            },
            {
               "code":"MU",
               "name":"Mauritius"
            },
            {
               "code":"YT",
               "name":"Mayotte"
            },
            {
               "code":"MX",
               "name":"Mexico"
            },
            {
               "code":"FM",
               "name":"Micronesia, Federated States of"
            },
            {
               "code":"MD",
               "name":"Moldova, Republic of"
            },
            {
               "code":"MC",
               "name":"Monaco"
            },
            {
               "code":"MN",
               "name":"Mongolia"
            },
            {
               "code":"ME",
               "name":"Montenegro"
            },
            {
               "code":"MS",
               "name":"Montserrat"
            },
            {
               "code":"MA",
               "name":"Morocco"
            },
            {
               "code":"MZ",
               "name":"Mozambique"
            },
            {
               "code":"MM",
               "name":"Myanmar"
            },
            {
               "code":"NA",
               "name":"Namibia"
            },
            {
               "code":"NR",
               "name":"Nauru"
            },
            {
               "code":"NP",
               "name":"Nepal"
            },
            {
               "code":"NL",
               "name":"Netherlands"
            },
            {
               "code":"NC",
               "name":"New Caledonia"
            },
            {
               "code":"NZ",
               "name":"New Zealand"
            },
            {
               "code":"NI",
               "name":"Nicaragua"
            },
            {
               "code":"NE",
               "name":"Niger"
            },
            {
               "code":"NG",
               "name":"Nigeria"
            },
            {
               "code":"NU",
               "name":"Niue"
            },
            {
               "code":"NF",
               "name":"Norfolk Island"
            },
            {
               "code":"MP",
               "name":"Northern Mariana Islands"
            },
            {
               "code":"NO",
               "name":"Norway"
            },
            {
               "code":"OM",
               "name":"Oman"
            },
            {
               "code":"PK",
               "name":"Pakistan"
            },
            {
               "code":"PW",
               "name":"Palau"
            },
            {
               "code":"PS",
               "name":"Palestine, State of"
            },
            {
               "code":"PA",
               "name":"Panama"
            },
            {
               "code":"PG",
               "name":"Papua New Guinea"
            },
            {
               "code":"PY",
               "name":"Paraguay"
            },
            {
               "code":"PE",
               "name":"Peru"
            },
            {
               "code":"PH",
               "name":"Philippines"
            },
            {
               "code":"PN",
               "name":"Pitcairn"
            },
            {
               "code":"PL",
               "name":"Poland"
            },
            {
               "code":"PT",
               "name":"Portugal"
            },
            {
               "code":"PR",
               "name":"Puerto Rico"
            },
            {
               "code":"QA",
               "name":"Qatar"
            },
            {
               "code":"RE",
               "name":"R\u00e9union"
            },
            {
               "code":"RO",
               "name":"Romania"
            },
            {
               "code":"RU",
               "name":"Russian Federation"
            },
            {
               "code":"RW",
               "name":"Rwanda"
            },
            {
               "code":"BL",
               "name":"Saint Barth\u00e9lemy"
            },
            {
               "code":"SH",
               "name":"Saint Helena, Ascension and Tristan da Cunha"
            },
            {
               "code":"KN",
               "name":"Saint Kitts and Nevis"
            },
            {
               "code":"LC",
               "name":"Saint Lucia"
            },
            {
               "code":"MF",
               "name":"Saint Martin (French part)"
            },
            {
               "code":"PM",
               "name":"Saint Pierre and Miquelon"
            },
            {
               "code":"VC",
               "name":"Saint Vincent and the Grenadines"
            },
            {
               "code":"WS",
               "name":"Samoa"
            },
            {
               "code":"SM",
               "name":"San Marino"
            },
            {
               "code":"ST",
               "name":"Sao Tome and Principe"
            },
            {
               "code":"SA",
               "name":"Saudi Arabia"
            },
            {
               "code":"SN",
               "name":"Senegal"
            },
            {
               "code":"RS",
               "name":"Serbia"
            },
            {
               "code":"SC",
               "name":"Seychelles"
            },
            {
               "code":"SL",
               "name":"Sierra Leone"
            },
            {
               "code":"SG",
               "name":"Singapore"
            },
            {
               "code":"SX",
               "name":"Sint Maarten (Dutch part)"
            },
            {
               "code":"SK",
               "name":"Slovakia"
            },
            {
               "code":"SI",
               "name":"Slovenia"
            },
            {
               "code":"SB",
               "name":"Solomon Islands"
            },
            {
               "code":"SO",
               "name":"Somalia"
            },
            {
               "code":"ZA",
               "name":"South Africa"
            },
            {
               "code":"GS",
               "name":"South Georgia and the South Sandwich Islands"
            },
            {
               "code":"SS",
               "name":"South Sudan"
            },
            {
               "code":"ES",
               "name":"Spain"
            },
            {
               "code":"LK",
               "name":"Sri Lanka"
            },
            {
               "code":"SD",
               "name":"Sudan"
            },
            {
               "code":"SR",
               "name":"Suriname"
            },
            {
               "code":"SJ",
               "name":"Svalbard and Jan Mayen"
            },
            {
               "code":"SZ",
               "name":"Swaziland"
            },
            {
               "code":"SE",
               "name":"Sweden"
            },
            {
               "code":"CH",
               "name":"Switzerland"
            },
            {
               "code":"SY",
               "name":"Syrian Arab Republic"
            },
            {
               "code":"TW",
               "name":"Taiwan, Province of China"
            },
            {
               "code":"TJ",
               "name":"Tajikistan"
            },
            {
               "code":"TZ",
               "name":"Tanzania, United Republic of"
            },
            {
               "code":"TH",
               "name":"Thailand"
            },
            {
               "code":"TL",
               "name":"Timor-Leste"
            },
            {
               "code":"TG",
               "name":"Togo"
            },
            {
               "code":"TK",
               "name":"Tokelau"
            },
            {
               "code":"TO",
               "name":"Tonga"
            },
            {
               "code":"TT",
               "name":"Trinidad and Tobago"
            },
            {
               "code":"TN",
               "name":"Tunisia"
            },
            {
               "code":"TR",
               "name":"Turkey"
            },
            {
               "code":"TM",
               "name":"Turkmenistan"
            },
            {
               "code":"TC",
               "name":"Turks and Caicos Islands"
            },
            {
               "code":"TV",
               "name":"Tuvalu"
            },
            {
               "code":"UG",
               "name":"Uganda"
            },
            {
               "code":"UA",
               "name":"Ukraine"
            },
            {
               "code":"AE",
               "name":"United Arab Emirates"
            },
            {
               "code":"GB",
               "name":"United Kingdom"
            },
            {
               "code":"US",
               "name":"United States"
            },
            {
               "code":"UM",
               "name":"United States Minor Outlying Islands"
            },
            {
               "code":"UY",
               "name":"Uruguay"
            },
            {
               "code":"UZ",
               "name":"Uzbekistan"
            },
            {
               "code":"VU",
               "name":"Vanuatu"
            },
            {
               "code":"VE",
               "name":"Venezuela, Bolivarian Republic of"
            },
            {
               "code":"VN",
               "name":"Viet Nam"
            },
            {
               "code":"VG",
               "name":"Virgin Islands, British"
            },
            {
               "code":"VI",
               "name":"Virgin Islands, U.S."
            },
            {
               "code":"WF",
               "name":"Wallis and Futuna"
            },
            {
               "code":"EH",
               "name":"Western Sahara"
            },
            {
               "code":"YE",
               "name":"Yemen"
            },
            {
               "code":"ZM",
               "name":"Zambia"
            },
            {
               "code":"ZW",
               "name":"Zimbabwe"
            }
         ];
         ctrl.countryOptions = [{code: '', name: $translate.instant('CUSTOMERS_COUNTRY')}].concat($scope.countries);

    });

})();

(function() {

    angular.module("app.controllers").controller("CustomersDFController", function($scope, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.forms = $rootScope.$user.forms;

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {};

        ctrl.submit = function() {
            
            $api.digital_forms.send.save({
                id: ctrl.form.form,
                customer_id: Customer.data.id,
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_DF_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

    });

})();

(function() {

    angular.module("app.controllers").controller("CustomersDDController", function($scope, $state, $api, Customer, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        if(Customer == null) {
            $state.transitionTo("app.customers", {}, {reload: true});
            return false;
        }

        $scope.documents = $rootScope.$user.documents;

        $scope.Customer = Customer.data;
        // console.log(Customer.data);

        ctrl.form = {};

        ctrl.submit = function() {
            
            $api.settings.digital_documents.save({
                id: ctrl.form.document,
                customer_id: Customer.data.id,
            }, function(response){
                if(response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_DD_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.customers.single", {id: Customer.data.id}, {reload: true});
                }
            });
        };

    });

})();

(function () {
    angular.module('app.controllers')
      .controller('PublicCardRequestController', function (Info, $sce, $scope, $translate) {
        var ctrl = this;

        $scope.business = Info.data ? Info.data.business : null;
        ctrl.iframe = Info.data && Info.data.iframe ? $sce.trustAsResourceUrl(Info.data.iframe) : null;
        $scope.channelHash = Info.data ? Info.data.id : null;


        var channel = (!pusher.channel('business-'+$scope.business.id)) ? pusher.subscribe('business-'+$scope.business.id) : pusher.channel('business-'+$scope.business.id);
        channel.bind('iframe-result-'+$scope.channelHash, function(response) {
            if (response) {
                if (response.result == 'success') {
                    swal({
                        title: $translate.instant('SWAL_IFRAME_REQUEST_CARD_SUCCESS_TITLE'),
                        text: "",
                        type: "success",
                    });
                } else if (response.result == 'error') {
                    var message = '';
                    swal({
                        title: response.message ? response.message : message,
                        text: $translate.instant('SWAL_IFRAME_REQUEST_CARD_ERROR_TEXT'),
                        type: "warning",
                    });
                }
            }
        });
        
    });
})();
(function () {

    angular.module('app.controllers').controller('CashboxDigitalFormsController',
        function ($scope, $uibModalInstance, DigitalForms) {

            var ctrl = this;

            // DigitalForms is expected to be an array; support both plain array and {data: []}
            $scope.DigitalFormList = (DigitalForms && DigitalForms.data)
                ? DigitalForms.data
                : (angular.isArray(DigitalForms) ? DigitalForms : (DigitalForms || []));

            ctrl.selectedForm = null;

            ctrl.isSelected = function (form) {
                return !!(ctrl.selectedForm && form && ctrl.selectedForm.id === form.id);
            };

            ctrl.select = function (form) {
                if (!form) {
                    return;
                }
                ctrl.selectedForm = form;
            };

            ctrl.attach = function () {
                if (ctrl.selectedForm) {
                    $scope.$close(ctrl.selectedForm);
                } else {
                    $scope.$close(null);
                }
            };

            ctrl.cancel = function () {
                $scope.$dismiss('cancel');
            };

        });

})();


(function () {

    angular.module('app.controllers')

        .controller('BusinessesListController', function (Categories, $state, $header, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $rootScope) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            /**
             * Assign data to the table
             */
            ctrl.tableData = Categories.data;

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "קטגוריות";
            $header.breadcrumbs.push({
                "title": "הגדרות",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "קטגוריות"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip').withLanguage(dataTablesHebrewProvider);

        });

})();

(function() {

    angular.module("app.controllers").controller("BusinessesFormController", function($scope, $state, $api, dates, Category, $rootScope, $translate) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        ctrl.form = {};

        $scope.isEdit = false;

        /**
         * Initialize edit data
         */
        if(Category != null) {
            $scope.isEdit = true;
            ctrl.form = Category.data;
        }

        /**
         * Triggers when customers form is submited
         * Preparing the API call for creating or editing the current customer
         */
        ctrl.submit = function() {

            if(Category == null)
                /**
                 * In case it's a new customer form
                 */
                $api.categories.save(ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_ADD_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {}, {reload: true});
                    }
                });
            else
                /**
                 * In case it's an edit form
                 */
                $api.categories.single.save({
                    id: Category.data.id
                }, ctrl.form, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_CATEGORIES_SAVE_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings.categories", {id: Category.data.id}, {reload: true});
                    }
                });
        };

        /**
         * Triggers category delete
         */
        ctrl.delete = function () {
            swal({
                title: "",
                text: $translate.instant('SWAL_CATEGORIES_DELETE_CONFIRM_TITLE').replace('[name]', Category.data.name),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value)
                    $api.categories.single.delete({id: Category.data.id}, function(response) {
                        if(response.status == "success") {
                            swal({
                                title: $translate.instant('SWAL_CATEGORIES_DELETE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.settings.categories", {}, {reload: true});
                        }
                    });
            });
        };
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('BusinessSingleController', function (Business, Variants, $api, $state, $scope, $rootScope, $header, $stateParams, $translate) {

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }
            var ctrl = this;
            ctrl.businessId = $stateParams.id;
            ctrl.business = Business.data;
            ctrl.business.language = "SETTINGS_INFO_" + ctrl.business.language_code.toUpperCase() + "_LANG";

            ctrl.variants = [];

            if (Variants){
                ctrl.variants = Variants.data;
            }



            //Module header configuration (title and breadcrumbs)
            $header.title = "Business - <b>" + Business.data.name + "</b>";
            $header.breadcrumbs.push({
                "title": "Businesses",
                "state": "app.admin"
            }, {
                    "title": Business.data.name
                });

            ctrl.createNewUser = function () {
              $rootScope.b_id = ctrl.businessId;
              $state.go('app.admin.users.new')
            }

            /**
             * Business delete
             */
            ctrl.removeBusiness = function () {
                swal({
                    title: "",
                    text: $translate.instant('SWAL_ADMIN_BUSINESS_DELELE_CONFIRM_TEXT').replace('[name]', Business.data.name),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value)
                        $api.businesses.single.delete({id: Business.data.id}, function(response) {
                            if(response.success) {
                                swal({
                                    title: $translate.instant('SWAL_ADMIN_BUSINESS_DELELE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                $state.transitionTo("app.admin", {}, {reload: true});
                            }
                        });
                });
            };
        });

})();

(function() {

    angular.module("app.controllers").controller("BusinessMessageController",
        function($scope, $state, $api, Types, Business, Resources, $business, $rootScope, dates, $translate) {

            var ctrl = this;

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            ctrl.form = {
                type: "info",
                text: "",
            };
            ctrl.messageTypeOptions = [
                {id: 'info', name: $translate.instant('ADMIN_BUSINESS_MESSAGE_TYPE_INFO')},
                {id: 'error', name: $translate.instant('ADMIN_BUSINESS_MESSAGE_TYPE_ERROR')},
                {id: 'success', name: $translate.instant('ADMIN_BUSINESS_MESSAGE_TYPE_SUCCESS')}
            ];

            ctrl.submit = function() {

                $api.businesses.message.save(ctrl.form, function(response){
                    if(response.success) {
                        swal({
                            title: $translate.instant('SWAL_BUSINESS_MESSAGE_SENT_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.admin", {}, {reload: true});
                    }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("BusinessFormController",
        function($scope, $state, $api, $tiff_page, Types, Variants, Business, Resources, $business, $rootScope, dates, $translate) {

            var ctrl = this;

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            ctrl.types = [];
            ctrl.variants = [];
            ctrl.resources = [];

            if (Types){
                ctrl.types = Types.data;
            }

            if (Variants){
                ctrl.variants = Variants.data;
            }

            if (Resources){
                ctrl.resources = Resources.data;
            }

            $scope.datesProvider = dates;

            ctrl.form = {
                //vat: 17,
                type: "1",
                credit_card: "1",
                paid_link: "0",
                courses: "0",
                second_resource: "0",
                cashbox: "1",
                zero_vat: "0",
                ai_assistant: "0",
                ai_booking_agent: "0",
                ai_agent_booking: "0",
                ai_agent_testing: "0",
                online_payments: "0",
                card_reader: "0",
                sms_own_sign: "0",
                enabled_retainers: "0",
                continuous_deal: "0",
                business_helper: "0",
                create_resources_services: "0",
                offline_presence: "0",
                wa_api: "green",
                customers_settings: {
                  send_notifications: {update_all: 0, value: null},
                  self_order: {update_all: 0, value: null},
                  resource: {update_all: 0, value: null},
                  send_reminder: {update_all: 0, value: null},
                  reminder_send_type: {update_all: 0, value: null},
                  send_documents: {update_all: 0, value: null},
                  request_order_confirmation: {update_all: 0, value: null}
                }
            };

            //Initialize edit data
            if(Business != null) {
                //ctrl.form.vat = Number(Business.data.vat);
                ctrl.form.address = String(Business.data.address);
                ctrl.form.home_number = String(Business.data.home_number);
                ctrl.form.zip = String(Business.data.zip);
                ctrl.form.agent = String(Business.data.agent);
                ctrl.form.cashbox = String(Number(Business.data.cashbox));
                ctrl.form.ai_assistant = String(Number(Business.data.ai_assistant));
                ctrl.form.ai_booking_agent = String(Number(Business.data.ai_booking_agent));
                ctrl.form.ai_agent_booking = Business.data.ai_agent_booking !== undefined
                    ? (Number(Business.data.ai_agent_booking))
                    : ctrl.form.ai_booking_agent;
                ctrl.form.ai_agent_testing = Business.data.ai_agent_testing !== undefined
                    ? (Number(Business.data.ai_agent_testing))
                    : "0";
                ctrl.form.online_payments = String(Number(Business.data.online_payments));
                ctrl.form.card_reader = String(Number(Business.data.card_reader));
                ctrl.form.sms_own_sign = String(Number(Business.data.sms_own_sign));
                ctrl.form.city = String(Business.data.city);
                ctrl.form.credit_card = String(Number(Business.data.credit_card));
                ctrl.form.paid_link = String(Number(Business.data.paid_link));
                ctrl.form.courses = String(Number(Business.data.courses));
                ctrl.form.second_resource = String(Number(Business.data.second_resource));
                ctrl.form.second_resource_name = Business.data.second_resource_name ? String(Business.data.second_resource_name) : '';
                ctrl.form.email = String(Business.data.email);
                ctrl.form.language = "SETTINGS_INFO_" + Business.data.language_code.toUpperCase() + "_LANG";
                ctrl.form.language_code = String(Business.data.language_code);
                ctrl.form.emv_terminal_id = String(Business.data.emv_terminal_id);
                ctrl.form.zcredit_key = String(Business.data.zcredit_key);
                ctrl.form.z_credit_credit_deal = String(Number(Business.data.z_credit_credit_deal));
                ctrl.form.call_token = String(Business.data.call_token);
                ctrl.form.name = String(Business.data.name);
                ctrl.form.phone = String(Business.data.phone);
                ctrl.form.type = String(Business.data.type);
                ctrl.form.variant = String(Business.data.variant);
                ctrl.form.dealer_type = String(Business.data.dealer_type);
                ctrl.form.zero_vat = String(Number(Business.data.zero_vat));
                ctrl.form.company_id = String(Business.data.company_id);
                ctrl.form.status = String(Business.data.status);
                ctrl.form.deductions_file = String(Business.data.deductions_file);
                ctrl.form.wa_instance = Business.data.wa_instance ? String(Business.data.wa_instance) : '';
                ctrl.form.wa_token = Business.data.wa_token ? String(Business.data.wa_token) : '';
                ctrl.form.wa_account_id = Business.data.wa_account_id ? String(Business.data.wa_account_id) : '';
                ctrl.form.wa_api = Business.data.wa_api ? String(Business.data.wa_api) : 'green';
                ctrl.form.credit_suplier = String(Business.data.credit_suplier);
                ctrl.form.cerdit_company = String(Business.data.cerdit_company);
                ctrl.form.credit_yaad_key = String(Business.data.credit_yaad_key);
                ctrl.form.enabled_retainers = String(Number(Business.data.enabled_retainers));
                ctrl.form.continuous_deal = String(Number(Business.data.continuous_deal));
                ctrl.form.business_helper = String(Number(Business.data.business_helper));
                ctrl.form.offline_presence = Boolean(Business.data.offline_presence);
                ctrl.hideUser = true;
            }else{
                ctrl.hideUser = false;
            }

            $scope.bis_statuses = $business.getAllStatuses();
            $scope.credit_comp = $business.getAllCreditComp();
            ctrl.businessControls = $business;

            ctrl.variantOptions = [];
            for (var variantId in ctrl.variants) {
                if (ctrl.variants.hasOwnProperty(variantId)) {
                    ctrl.variantOptions.push({
                        id: String(variantId),
                        name: $translate.instant(ctrl.variants[variantId])
                    });
                }
            }

            ctrl.dealerTypeOptions = [
                {id: "licensed", name: $translate.instant("BUSINESS_TYPE_LICENSED")},
                {id: "exempt", name: $translate.instant("BUSINESS_TYPE_EXTEMPT")}
            ];

            ctrl.waApiOptions = [
                {id: "green", name: $translate.instant("ADMIN_WA_API_GREEN")},
                {id: "whapi", name: $translate.instant("ADMIN_WA_API_WHAPI")},
                {id: "official", name: $translate.instant("ADMIN_WA_API_OFFICIAL")},
                {id: "texter", name: $translate.instant("ADMIN_WA_API_TEXTER")}
            ];

            ctrl.creditCompanyOptions = $scope.credit_comp.map(function(comp, index) {
                return {
                    id: String(index),
                    name: $translate.instant(comp)
                };
            });

            ctrl.statusOptions = $scope.bis_statuses.map(function(status, index) {
                return {
                    id: String(index),
                    name: $translate.instant(status)
                };
            });

            ctrl.languageOptions = [
                {id: "hb_ISR", name: $translate.instant("SETTINGS_INFO_HB_ISR_LANG")},
                {id: "en_US", name: $translate.instant("SETTINGS_INFO_EN_US_LANG")},
                {id: "ru_RU", name: $translate.instant("SETTINGS_INFO_RU_RU_LANG")},
                {id: "ar_AR", name: $translate.instant("SETTINGS_INFO_AR_AR_LANG")}
            ];

            ctrl.selfOrderOptions = [
                {id: "true", name: $translate.instant("SETTINGS_USER_SELF_ORDER_YES")},
                {id: "false", name: $translate.instant("SETTINGS_USER_SELF_ORDER_NO")}
            ];

            ctrl.resourceOptions = ctrl.resources.map(function(resource) {
                return {
                    id: String(resource.id),
                    name: resource.name
                };
            });

            ctrl.customerNotificationOptions = ctrl.businessControls.customers_notifications_channels.map(function(channel) {
                return {
                    id: String(channel.value),
                    name: $translate.instant(channel.name)
                };
            });

            ctrl.reminderSendOptions = ctrl.businessControls.reminder_send_times.map(function(reminder) {
                return {
                    id: String(reminder.value),
                    name: $translate.instant(reminder.name)
                };
            });

            ctrl.documentMessageChannelOptions = ctrl.businessControls.businesses_msg_channels.map(function(channel) {
                return {
                    id: String(channel.index),
                    name: $translate.instant(channel.name)
                };
            });

            $scope.sanitizeString = function(str) {
                if (typeof str === 'string') {
                    // Allow printable ASCII, Hebrew, Arabic, and space
                    return str.replace(/[^\x20-\x7E\u0590-\u05FF\u0600-\u06FF]/g, ''); 
                }
                return str;
            };

            $scope.excelDateFormats = [
                'DD/MM/YYYY HH:mm:ss',
                'DD/MM/YYYY HH:mm',
                'DD/MM/YYYY',
                'D/M/YYYY HH:mm',
                'D/M/YYYY',
                'DD-MM-YYYY HH:mm:ss',
                'DD-MM-YYYY HH:mm',
                'DD-MM-YYYY',
                'DD-MM-YY HH:mm:ss',
                'DD-MM-YY HH:mm',
                'DD-MM-YY',
                'DD/MM/YY HH:mm:ss',
                'DD/MM/YY HH:mm',
                'DD/MM/YY',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DD HH:mm',
                'YYYY-MM-DD',
                'HH:mm DD/MM/YYYY',
                'HH:mm DD/MM/YY',
                'HH:mm:ss DD/MM/YYYY',
                'MM/DD/YYYY HH:mm',
                'MM/DD/YYYY'
            ];

            $scope.padExcelDatePart = function(value) {
                return value < 10 ? '0' + value : String(value);
            };

            $scope.formatExcelDateParts = function(y, m, d, H, M, S) {
                H = H || 0;
                M = M || 0;
                S = Math.round(S || 0);

                var day = $scope.padExcelDatePart(d);
                var month = $scope.padExcelDatePart(m);
                var year = String(y);

                if (H === 0 && M === 0 && S === 0) {
                    return day + '/' + month + '/' + year;
                }

                return day + '/' + month + '/' + year + ' ' + $scope.padExcelDatePart(H) + ':' + $scope.padExcelDatePart(M);
            };

            $scope.normalizeExcelSerial = function(serial) {
                if (typeof serial !== 'number' || !isFinite(serial)) {
                    return serial;
                }

                var fraction = serial - Math.floor(serial);
                var epsilon = 0.00001;

                // Excel float noise around midnight should stay at 00:00, not 23:59.
                if (fraction < epsilon) {
                    return Math.floor(serial);
                }

                if (fraction > 1 - epsilon) {
                    return Math.ceil(serial);
                }

                return Math.round(serial * 86400000) / 86400000;
            };

            $scope.parseExcelSerial = function(serial) {
                serial = $scope.normalizeExcelSerial(serial);

                if (typeof XLSX !== 'undefined' && XLSX.SSF && XLSX.SSF.parse_date_code) {
                    var dateCode = XLSX.SSF.parse_date_code(serial);
                    if (dateCode) {
                        return dateCode;
                    }
                }

                return null;
            };

            $scope.formatExcelSerial = function(serial) {
                var dateCode = $scope.parseExcelSerial(serial);

                if (!dateCode) {
                    return serial;
                }

                return $scope.formatExcelDateParts(dateCode.y, dateCode.m, dateCode.d, dateCode.H, dateCode.M, dateCode.S);
            };

            $scope.formatExcelDateObject = function(date) {
                if (!(date instanceof Date) || isNaN(date.getTime())) {
                    return date;
                }

                // SheetJS stores Excel wall-clock values in UTC date fields.
                return $scope.formatExcelDateParts(
                    date.getUTCFullYear(),
                    date.getUTCMonth() + 1,
                    date.getUTCDate(),
                    date.getUTCHours(),
                    date.getUTCMinutes(),
                    date.getUTCSeconds()
                );
            };

            $scope.formatExcelDate = function(date) {
                if (date instanceof Date) {
                    return $scope.formatExcelDateObject(date);
                }

                if (typeof date === 'number') {
                    return $scope.formatExcelSerial(date);
                }

                var formatted = moment(date);
                if (!formatted.isValid()) {
                    return date;
                }

                return $scope.formatExcelDateParts(
                    formatted.year(),
                    formatted.month() + 1,
                    formatted.date(),
                    formatted.hour(),
                    formatted.minute(),
                    formatted.second()
                );
            };

            $scope.isExcelDateCell = function(cell) {
                if (!cell) {
                    return false;
                }

                if (cell.t === 'd') {
                    return true;
                }

                if (cell.t === 'n' && cell.z && typeof XLSX !== 'undefined' && XLSX.SSF && XLSX.SSF.is_date) {
                    return XLSX.SSF.is_date(cell.z);
                }

                return false;
            };

            $scope.getExcelCellValue = function(cell) {
                if (!cell || cell.v === undefined || cell.v === null) {
                    return '';
                }

                if ($scope.isExcelDateCell(cell)) {
                    if (cell.t === 'd') {
                        return $scope.formatExcelDateObject(cell.v);
                    }

                    return $scope.formatExcelSerial(cell.v);
                }

                if (typeof cell.v === 'string') {
                    return $scope.normalizeExcelDateString(cell.v);
                }

                return cell.v;
            };

            $scope.normalizeExcelDateString = function(value) {
                var sanitized = $scope.sanitizeString(value);

                if (typeof sanitized !== 'string' || !sanitized) {
                    return sanitized;
                }

                var parsed = moment(sanitized, $scope.excelDateFormats, true);
                if (parsed.isValid()) {
                    return $scope.formatExcelDateParts(
                        parsed.year(),
                        parsed.month() + 1,
                        parsed.date(),
                        parsed.hour(),
                        parsed.minute(),
                        parsed.second()
                    );
                }

                return sanitized;
            };

            $scope.sheetToRowObjects = function(sheet) {
                if (!sheet || !sheet['!ref']) {
                    return [];
                }

                var range = XLSX.utils.decode_range(sheet['!ref']);
                var headers = [];
                var rows = [];
                var row, header, cell, R, C;

                for (C = range.s.c; C <= range.e.c; C++) {
                    cell = sheet[XLSX.utils.encode_cell({r: range.s.r, c: C})];
                    header = cell && cell.v !== undefined && cell.v !== null ? String(cell.v).trim() : '';
                    headers[C] = header;
                }

                for (R = range.s.r + 1; R <= range.e.r; R++) {
                    row = {};
                    for (C = range.s.c; C <= range.e.c; C++) {
                        header = headers[C];
                        if (!header) {
                            continue;
                        }

                        cell = sheet[XLSX.utils.encode_cell({r: R, c: C})];
                        row[header] = $scope.getExcelCellValue(cell);
                    }
                    rows.push(row);
                }

                return rows;
            };

            $scope.sanitizeData = function(excelRows) {
                return excelRows.map(function(row) {
                    var sanitizedRow = {};
                    for (var key in row) {
                        if (row.hasOwnProperty(key)) {
                            var value = row[key];

                            if (value instanceof Date) {
                                sanitizedRow[key] = $scope.formatExcelDate(value);
                            } else if (typeof value === 'string') {
                                sanitizedRow[key] = $scope.normalizeExcelDateString(value);
                            } else {
                                sanitizedRow[key] = value;
                            }
                        }
                    }
                    return sanitizedRow;
                });
            };


            // /**
            //  * Triggers when customers form is submited
            //  * Preparing the API call for creating or editing the current customer
            //  */
            $scope.uploadExcel = function(event, type) {
                type = type || 'customers';
                SelectedFile = event.target.files[0];

                var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
                if (typeof (FileReader) != "undefined") {
                    var reader = new FileReader();

                    $tiff_page.start_loading('load_excel');

                    //For Browsers other than IE.
                    if (reader.readAsBinaryString) {
                        reader.onload = function (e) {
                            $scope.ProcessExcel(e.target.result, type);
                        };
                        reader.readAsBinaryString(SelectedFile);
                    } else {
                        //For IE Browser.
                        reader.onload = function (e) {
                            var data = "";
                            var bytes = new Uint8Array(e.target.result);
                            for (var i = 0; i < bytes.byteLength; i++) {
                                data += String.fromCharCode(bytes[i]);
                            }
                            $scope.ProcessExcel(data, type);
                        };
                        reader.readAsArrayBuffer(SelectedFile);
                    }
                } else {
                    alert("This browser does not support HTML5.");
                }
            };
            $scope.ProcessExcel = function (data, type) {
                //Read the Excel File data.
                var workbook = XLSX.read(data, {
                    type: 'binary',
                    cellNF: true
                });

                if (type == 'crm') {
                    //Fetch all sheets from the workbook
                    var sanitizedData = {};
                    for (var y in workbook.SheetNames) {
                        var excelRows = $scope.sheetToRowObjects(workbook.Sheets[workbook.SheetNames[y]]);

                        // Sanitize the data to remove strange symbols
                        sanitizedData[workbook.SheetNames[y]] = $scope.sanitizeData(excelRows);
                    }
                } else {
                    //Fetch the name of First Sheet.
                    var firstSheet = workbook.SheetNames[0];
                    var excelRows = $scope.sheetToRowObjects(workbook.Sheets[firstSheet]);

                    // Sanitize the data to remove strange symbols
                    var sanitizedData = $scope.sanitizeData(excelRows);
                }
                
                $tiff_page.stop_loading('load_excel');
                // Assign the sanitized data to the form
                ctrl.form[type] = sanitizedData;
            };
           
            ctrl.submit = function() {
                $tiff_page.start_loading('load_submit');
                if(Business == null){
                    $api.businesses.save(ctrl.form, function(response){
                        if(response.success) {
                            swal({
                                title: $translate.instant('SWAL_BUSINESS_ADD_TITLE'),
                                text: $translate.instant('SWAL_BUSINESS_ADD_TEXT'),
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.admin", {}, {reload: true});
                        } else if (response.message) {
                            swal({
                                title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                                text: response.message,
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            });
                        }
                    });
                    $tiff_page.stop_loading('load_submit');
                }
                else
                    /**
                     * In case it's an edit form
                     */
                    $api.businesses.single.save({
                        id: Business.data.id
                    }, ctrl.form, function(response){
                        if(response.success) {
                            if (response.waiting) {
                                ctrl.checkImportStatus();
                                return;
                            }

                            $tiff_page.stop_loading('load_submit');
                            swal({
                                title: $translate.instant('SWAL_BUSINESS_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            $state.transitionTo("app.admin.single-business", {id: Business.data.id}, {reload: true});
                        }
                    }, function () {
                        $tiff_page.stop_loading('load_submit');
                        swal({
                            title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                            text: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TEXT'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });

                    });
            };

            ctrl.checkImportStatus = function() {
                $api.businesses.check_import.get({id: Business.data.id}, function(response) {
                    if (response.success) {
                        if (response.waiting) {
                            angular.element(document.querySelector( '#loading_count' )).addClass('active');
                            angular.element(document.querySelector( '#l_imported' )).html("<b>"+((response.imported_records) ? response.imported_records : 0)+"</b>");
                            angular.element(document.querySelector( '#l_total' )).html("<b>"+((response.total) ? response.total : 0)+"</b>");

                            setTimeout(ctrl.checkImportStatus, 500);
                            return;
                        } else {
                            angular.element(document.querySelector( '#loading_count' )).removeClass('active');
                            $tiff_page.stop_loading('load_submit');
                            if (response.imported) {
                                swal({
                                    title: "Data was imported successfully",
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 20000
                                });
                            } else {
                                swal({
                                    title: $translate.instant('SWAL_BUSINESS_SAVE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 20000
                                });
                            }
                            $state.transitionTo("app.admin.single-business", {id: Business.data.id}, {reload: true});
                        }
                    } else {
                        angular.element(document.querySelector( '#loading_count' )).removeClass('active');
                        $tiff_page.stop_loading('load_submit');
                        swal({
                            title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                            text: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TEXT'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 30000
                        });
                    }
                }, function () {
                    angular.element(document.querySelector( '#loading_count' )).removeClass('active');
                    $tiff_page.stop_loading('load_submit');
                    swal({
                        title: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TITLE'),
                        text: $translate.instant('SWAL_BUSINESS_SAVE_ERROR_TEXT'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 30000
                    }); 
                });
            }

            ctrl.createTexterWebhook = function() {
                if (!ctrl.form.wa_instance || !ctrl.form.wa_token) {
                    swal({
                        title: "",
                        text: $translate.instant('ADMIN_WA_INSTANCE') + ' / ' + $translate.instant('ADMIN_WA_TOKEN') + ' ' + $translate.instant('LOGIN_FIELD_VALID'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 3000
                    });
                    return;
                }

                $tiff_page.start_loading('create_texter_webhook');
                swal({
                    title: "",
                    text: $translate.instant('ADMIN_CREATE_TEXTER_WEBHOOK') + '...',
                    type: "info",
                    timer: 3000,
                    showConfirmButton: false
                });

                $api.businesses.create_texter_webhook.save({
                    wa_instance: ctrl.form.wa_instance,
                    wa_token: ctrl.form.wa_token,
                    wa_account_id: ctrl.form.wa_account_id
                }, function(response) {
                    $tiff_page.stop_loading('create_texter_webhook');

                    if (response.success) {
                        var successText = (response.data && response.data.already_exists)
                            ? $translate.instant('ADMIN_TEXTER_WEBHOOK_EXISTS')
                            : $translate.instant('ADMIN_TEXTER_WEBHOOK_CREATED');

                        swal({
                            title: "",
                            text: response.message || successText,
                            type: "success",
                            timer: 3000
                        });
                    } else {
                        swal({
                            title: "",
                            text: (response.data && response.data.message) || response.message || $translate.instant('ADMIN_TEXTER_WEBHOOK_FAILED'),
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 30000
                        });
                    }
                }, function(errorResponse) {
                    $tiff_page.stop_loading('create_texter_webhook');
                    swal({
                        title: "",
                        text: (errorResponse.data && errorResponse.data.message) || errorResponse.message || $translate.instant('ADMIN_TEXTER_WEBHOOK_FAILED'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 30000
                    });
                });
            };

            ctrl.createWhapiInstance = function() {
                // Validate name field
                if (!ctrl.form.name) {
                    swal({
                        title: "",
                        text: $translate.instant('ADMIN_BUSINESS_NAME') + ' ' + $translate.instant('LOGIN_FIELD_VALID'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 3000
                    });
                    return;
                }

                // Show loading and info message
                $tiff_page.start_loading('create_whapi_instance');
                swal({
                    title: "",
                    text: "Creating Whapi instance, please wait...",
                    type: "info",
                    timer: 3000,
                    showConfirmButton: false
                });

                // Call backend to create Whapi instance
                $api.businesses.create_whapi_instance.save({name: ctrl.form.name}, function(response) {
                    if(response.success && response.data && response.data.wa_instance && response.data.wa_token) {
                        // Update form fields with the response
                        ctrl.form.wa_instance = response.data.wa_instance;
                        ctrl.form.wa_token = response.data.wa_token;

                        // Save business if it's edit mode
                        if (Business && Business.data && Business.data.id) {
                            $api.businesses.single.save({
                                id: Business.data.id
                            }, ctrl.form, function(updateResponse) {
                                // Continue with settings even if update fails
                            });
                        }

                        // Build webhook URL - backend will add the token
                        var webhookUrl = window.location.origin + '/api/smsApi/waresult/token/';
                        
                        // Set settings with webhook URL (with retry logic)
                        ctrl.setWhapiSettingsWithRetry({
                            wa_token: response.data.wa_token,
                            wa_instance: response.data.wa_instance,
                            webhook_url: webhookUrl
                        }, 20, 10000);
                    } else {
                        swal({
                            title: "",
                            text: (response.data && response.data.error) || response.message || "Create Whapi Instance failed",
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 30000
                        });
                        $tiff_page.stop_loading('create_whapi_instance');
                    }
                }, function(errorResponse) {
                    swal({
                        title: "",
                        text: (errorResponse.data && errorResponse.data.message) || errorResponse.message || "Create Whapi Instance failed",
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 30000
                    });
                    $tiff_page.stop_loading('create_whapi_instance');
                });
            }

            ctrl.setWhapiSettingsWithRetry = function(payload, maxRetries, delay) {
                maxRetries = maxRetries || 20;
                delay = delay || 10000;
                var attempt = 0;

                var trySetSettings = function() {
                    attempt++;
                    $api.businesses.set_whapi_settings.save(payload, function(settingsResponse) {
                        if(settingsResponse && settingsResponse.success) {
                            swal({
                                title: "",
                                text: "Whapi instance created and configured successfully",
                                type: "success",
                                timer: 3000
                            });
                            $tiff_page.stop_loading('create_whapi_instance');
                        } else if(settingsResponse && settingsResponse.data && settingsResponse.data.error && attempt < maxRetries) {
                            // Channel might not be ready yet, retry after delay
                            setTimeout(function() {
                                trySetSettings();
                            }, delay);
                        } else {
                            // Max retries reached or other error
                            swal({
                                title: "",
                                text: (settingsResponse && settingsResponse.data && settingsResponse.data.error) || 
                                      (settingsResponse && settingsResponse.message) || 
                                      "Failed to set Whapi settings",
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 30000
                            });
                            $tiff_page.stop_loading('create_whapi_instance');
                        }
                    }, function(errorResponse) {
                        if(attempt < maxRetries) {
                            // Retry on network errors too
                            setTimeout(function() {
                                trySetSettings();
                            }, delay);
                        } else {
                            swal({
                                title: "",
                                text: (errorResponse.data && errorResponse.data.message) || 
                                      errorResponse.message || 
                                      "Failed to set Whapi settings",
                                type: "warning",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 30000
                            });
                            $tiff_page.stop_loading('create_whapi_instance');
                        }
                    });
                };
                
                trySetSettings();
            }
        });
})();
(function() {

    angular.module("app.controllers").controller("BusinessCopyController",
        function($scope, $state, $api, Variants, $rootScope, $uibModal, $translate) {

            var ctrl = this;

            if ($rootScope.userRole !== 1){
              $state.go('app.dashboard');
              return;
            }

            ctrl.variants = [];
            
            if (Variants){
                ctrl.variants = Variants.data;
            }

            ctrl.variantOptions = [];
            for (var variantId in ctrl.variants) {
                if (ctrl.variants.hasOwnProperty(variantId)) {
                    ctrl.variantOptions.push({
                        id: String(variantId),
                        name: $translate.instant(ctrl.variants[variantId])
                    });
                }
            }

            ctrl.form = {
                variant: "",
                name: "",
                email: "",
				password: "",
				name: "",
                copy: true
            };

            
            ctrl.submit = function() {

                $api.businesses.save(ctrl.form, function(response){
                    if(response.success && response.data && response.data.b_id) {
                        $uibModal.open({
                            templateUrl: "app/modules/admin/modules/business-form/business.form.html",
                            controller: "BusinessFormController",
                            controllerAs: "ctrl",
                            windowTopClass: "form-modal",
                            resolve: {
                                Business: ['$api', '$rootScope', function ($api, $rootScope) {
                                    return $api.resolve("businesses.single@get", {"id": response.data.b_id});
                                }],
                                Types: ['$api', function ($api) {
                                    return $api.resolve("businesses.types@get");
                                }],
                                Variants: ['$api', function ($api) {
                                    return $api.resolve("businesses.variants@get");
                                }],
                                Resources: ['$api', '$rootScope', function ($api, $rootScope) {
                                    return $api.resolve("resources@get", {"b_id": response.data.b_id});
                                }]
                            }
                          }).result.then(function (val) {
                            $scope.$close();
                        });
                    }
                });
            };
        });
})();

(function() {

    angular.module("app.controllers").controller("WorkersSelectController", function($scope, $state, DTOptionsBuilder, Workers, dataTablesHebrewProvider, $rootScope, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.workers = Workers;


        ctrl.selectCustomer = function(index) {
            $uibModalInstance.close(ctrl.workers[index]);
        }

        $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip')
            .withLanguage(dataTablesHebrewProvider)
            .withOption('pageLength', 20)
            .withOption('scrollY', '500px')
            .withOption('order', [[1, 'desc']])
            .withOption('searching', false);


    });

})();

(function () {
    angular.module('app.controllers')
        .controller('WhatsappTemplatesSettingsController', function ($api, $state, $rootScope, $header, $translate, $scope, $uibModal) {

            if ($rootScope.userRole == 1) {
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            $header.breadcrumbs.push({
                "title": "SETTINGS_WHATSAPP_TEMPLATES"
            });

            var ctrl = this;
            ctrl.loading = false;
            ctrl.actionLoading = false;
            ctrl.syncAllRunning = false;
            ctrl.templates = [];
            ctrl.marketingForm = {message: ''};
            ctrl.marketingModal = null;

            var customerNameMask = $rootScope.currentLanguage == 'hb_ISR' ? '[שם הלקוח]' : "[the customer's name]";
            ctrl.marketingMasks = [
                {key: 'customer_name', value: customerNameMask, label: customerNameMask}
            ];

            ctrl.statusLabels = {
                not_created: 'WA_TEMPLATE_STATUS_NOT_CREATED',
                draft: 'WA_TEMPLATE_STATUS_DRAFT',
                localization_ready: 'WA_TEMPLATE_STATUS_LOCALIZATION_READY',
                pending_approval: 'WA_TEMPLATE_STATUS_PENDING_APPROVAL',
                approved: 'WA_TEMPLATE_STATUS_APPROVED',
                rejected: 'WA_TEMPLATE_STATUS_REJECTED',
                error: 'WA_TEMPLATE_STATUS_ERROR'
            };

            ctrl.getStatusLabel = function (item) {
                var key = ctrl.statusLabels[item.status] || item.status;
                return $translate.instant(key);
            };

            ctrl.canSync = function (item) {
                return !item || item.status === 'not_created' || item.status === 'error' || item.status === 'draft';
            };

            ctrl.canSubmit = function (item) {
                return item && (item.status === 'localization_ready' || item.status === 'rejected' || item.message_outdated);
            };

            ctrl.canResubmit = function (item) {
                return item && item.status && item.status !== 'not_created' && item.status !== 'approved' && item.status !== 'draft' && item.status !== 'pending_approval';
            };

            ctrl.canUpdateLocalization = function (item) {
                return item && item.status !== 'not_created' && item.message_outdated;
            };

            ctrl.hasNotCreated = function () {
                if (!ctrl.templates || !ctrl.templates.length) {
                    return false;
                }
                for (var i = 0; i < ctrl.templates.length; i++) {
                    if (ctrl.templates[i].status === 'not_created') {
                        return true;
                    }
                }
                return false;
            };

            ctrl.load = function (refreshStatuses) {
                ctrl.loading = true;
                var params = {};
                if (refreshStatuses === false) {
                    params.refresh_statuses = '0';
                }
                $api.whatsapptemplates.get(params, function (response) {
                    ctrl.loading = false;
                    ctrl.templates = response && response.data ? response.data : [];
                    ctrl.sortTemplates();
                }, function () {
                    ctrl.loading = false;
                    ctrl.templates = [];
                });
            };

            ctrl.runAction = function (resource, payload, onSuccess) {
                if (ctrl.actionLoading) {
                    return;
                }
                ctrl.actionLoading = true;
                resource.save(payload || {}, function (response) {
                    ctrl.actionLoading = false;
                    if (response && response.data && response.data.list) {
                        ctrl.templates = response.data.list;
                        ctrl.sortTemplates();
                    } else {
                        ctrl.load(true);
                    }
                    if (onSuccess) {
                        onSuccess(response);
                    }
                }, function (err) {
                    ctrl.actionLoading = false;
                    var message = (err.data && err.data.error) ? err.data.error : $translate.instant('WA_TEMPLATE_ACTION_FAILED');
                    swal({
                        title: '',
                        text: message,
                        type: 'warning',
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                    if (err.data && err.data.data && err.data.data.list) {
                        ctrl.templates = err.data.data.list;
                        ctrl.sortTemplates();
                    }
                });
            };

            ctrl.sortTemplates = function () {
                if (!ctrl.templates || !ctrl.templates.length) {
                    return;
                }

                var isCustomTemplate = function (item) {
                    return item && item.template_key
                        && (item.template_key.indexOf('automation_') === 0 || item.template_key.indexOf('marketing_message_') === 0);
                };

                ctrl.templates.sort(function (a, b) {
                    var aAutomation = isCustomTemplate(a);
                    var bAutomation = isCustomTemplate(b);

                    if (aAutomation && !bAutomation) {
                        return 1;
                    }
                    if (!aAutomation && bAutomation) {
                        return -1;
                    }
                    return 0;
                });
            };

            ctrl.syncAll = function () {
                if (ctrl.actionLoading) {
                    return;
                }

                var queue = [];
                if (ctrl.templates && ctrl.templates.length) {
                    for (var i = 0; i < ctrl.templates.length; i++) {
                        if (ctrl.templates[i].status === 'not_created') {
                            queue.push(ctrl.templates[i]);
                        }
                    }
                }

                if (!queue.length) {
                    return;
                }

                ctrl.syncAllRunning = true;
                var index = 0;

                var syncNext = function () {
                    if (index >= queue.length) {
                        ctrl.actionLoading = false;
                        ctrl.syncAllRunning = false;
                        ctrl.load(true);
                        return;
                    }

                    var item = queue[index];
                    index++;
                    ctrl.actionLoading = true;

                    $api.whatsapptemplates.sync_one.save({template_key: item.template_key}, function (response) {
                        if (response && response.data && response.data.list) {
                            ctrl.templates = response.data.list;
                            ctrl.sortTemplates();
                        }
                        syncNext();
                    }, function (err) {
                        ctrl.actionLoading = false;
                        ctrl.syncAllRunning = false;
                        var message = (err.data && err.data.error) ? err.data.error : $translate.instant('WA_TEMPLATE_ACTION_FAILED');
                        swal({
                            title: '',
                            text: message,
                            type: 'warning',
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                        });
                        if (err.data && err.data.data && err.data.data.list) {
                            ctrl.templates = err.data.data.list;
                            ctrl.sortTemplates();
                        }
                    });
                };

                syncNext();
            };

            ctrl.syncOne = function (item) {
                ctrl.runAction($api.whatsapptemplates.sync_one, {template_key: item.template_key});
            };

            ctrl.submitOne = function (item) {
                ctrl.runAction($api.whatsapptemplates.submit_one, {template_key: item.template_key});
            };

            ctrl.resubmitOne = function (item) {
                if (ctrl.actionLoading) {
                    return;
                }

                swal({
                    title: '',
                    text: $translate.instant('WA_TEMPLATE_RESUBMIT_CONFIRM'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: 'btn-danger'
                }).then(function (result) {
                    if (result.value) {
                        ctrl.runAction($api.whatsapptemplates.resubmit_one, {template_key: item.template_key});
                    }
                });
            };

            ctrl.updateLocalization = function (item) {
                ctrl.runAction($api.whatsapptemplates.update_localization, {template_key: item.template_key});
            };

            ctrl.openMarketingModal = function () {
                ctrl.marketingForm = {message: ''};
                ctrl.marketingModal = $uibModal.open({
                    templateUrl: 'app/modules/settings/whatsapp_templates/marketing_template.modal.html',
                    scope: $scope,
                    windowTopClass: 'form-modal small-modal'
                });
            };

            ctrl.saveMarketingTemplate = function () {
                if (ctrl.actionLoading || !ctrl.marketingForm.message) {
                    return;
                }
                ctrl.runAction($api.whatsapptemplates.create_marketing, {message: ctrl.marketingForm.message}, function () {
                    ctrl.marketingForm = {message: ''};
                    if (ctrl.marketingModal) {
                        ctrl.marketingModal.close();
                        ctrl.marketingModal = null;
                    }
                });
            };

            ctrl.deleteMarketing = function (item) {
                if (ctrl.actionLoading) {
                    return;
                }

                swal({
                    title: '',
                    text: $translate.instant('WA_TEMPLATE_DELETE_CONFIRM'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: 'btn-danger'
                }).then(function (result) {
                    if (result.value) {
                        ctrl.runAction($api.whatsapptemplates.delete_marketing, {template_key: item.template_key});
                    }
                });
            };

            ctrl.refreshStatuses = function () {
                ctrl.runAction($api.whatsapptemplates.sync_statuses);
            };

            ctrl.load(true);
        });
})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("TelephonySettingsController", function($scope, $state, $api, $translate, $rootScope, $header, Info, Resources, Statuses, TelephonyUsers) {
        
        if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $header.breadcrumbs.push({
            "title": "TELEPHONY_SETTINGS"
        });

        var ctrl = this;
        
        ctrl.loading = false;
        ctrl.saveLoading = false;
        
        // Set static API link
        ctrl.callsApiLink = window.location.origin + '/api/calls';
        
        // Get token from Info settings
        ctrl.callsApiToken = '';
        if (Info && Info.data && Info.data.telephony_token) {
            ctrl.callsApiToken = Info.data.telephony_token;
        }
        
        // Get available statuses for lead creation
        ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];
        
        // Initialize form with caller popup users and lead settings
        ctrl.form = {
            caller_popup_users: {},
            create_lead_on_call: false,
            lead_status: '',
            lead_arrival_source: ''
        };
        
        // Load existing telephony settings from lead_settings
        if (Info && Info.data && Info.data.lead_settings && Info.data.lead_settings.telephony) {
            var telephonySettings = Info.data.lead_settings.telephony;
            var savedCallerPopupUsers = telephonySettings.caller_popup_users;
            
            // Convert old array format to new object format for backward compatibility
            if (Array.isArray(savedCallerPopupUsers)) {
                // Old format: array of IDs - convert to object where all IDs are true
                ctrl.form.caller_popup_users = {};
                savedCallerPopupUsers.forEach(function(id) {
                    ctrl.form.caller_popup_users[id] = true;
                });
            } else if (savedCallerPopupUsers && typeof savedCallerPopupUsers === 'object') {
                // New format: object with id => true|false
                ctrl.form.caller_popup_users = savedCallerPopupUsers;
            } else {
                ctrl.form.caller_popup_users = {};
            }
            
            ctrl.form.create_lead_on_call = telephonySettings.create_lead_on_call || false;
            ctrl.form.lead_status = telephonySettings.status || '';
            ctrl.form.lead_arrival_source = telephonySettings.arrival_source || '';
        }
        
        // Get available resources (users)
        ctrl.resources = Resources && Resources.data ? Resources.data : [];

        // Telephony Agent/Token per business user
        ctrl.telephonyUsers = TelephonyUsers && TelephonyUsers.data ? TelephonyUsers.data : [];
        
        // Initialize selected users as ID list - default all selected (true if not in mapping)
        ctrl.selectedUsers = [];
        ctrl.resources.forEach(function(resource) {
            // If resource ID exists in mapping, use its value; otherwise default to true (new resource)
            var isSelected = false;
            if (ctrl.form.caller_popup_users.hasOwnProperty(resource.id)) {
                isSelected = ctrl.form.caller_popup_users[resource.id] === true;
            } else {
                // New resource not in mapping - default to true
                isSelected = true;
                ctrl.form.caller_popup_users[resource.id] = true;
            }
            
            if (isSelected) {
                ctrl.selectedUsers.push(String(resource.id));
            }
        });
        
        /**
         * Update selected users object (id => true|false) based on ui-select model
         */
        ctrl.updateSelectedUsers = function() {
            // Reset all resources to false
            ctrl.resources.forEach(function(resource) {
                ctrl.form.caller_popup_users[resource.id] = false;
            });
            
            // Set selected resources to true
            if (ctrl.selectedUsers && Array.isArray(ctrl.selectedUsers)) {
                ctrl.selectedUsers.forEach(function(resourceId) {
                    ctrl.form.caller_popup_users[resourceId] = true;
                });
            }
        };
        
        /**
         * Copy API link to clipboard
         */
        ctrl.copyApiLink = function() {
            var input = document.createElement('input');
            input.value = ctrl.callsApiLink;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        };
        
        /**
         * Copy API token to clipboard
         */
        ctrl.copyApiToken = function() {
            var input = document.createElement('input');
            input.value = ctrl.callsApiToken;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        };
        
        /**
         * Save telephony settings using lead_settings endpoint
         */
        ctrl.save = function() {
            if (ctrl.saveLoading) {
                return;
            }
            
            ctrl.saveLoading = true;
            
            // Prepare telephony settings object with all fields including caller_popup_users
            var telephonySettings = {
                create_lead_on_call: ctrl.form.create_lead_on_call,
                status: ctrl.form.lead_status,
                arrival_source: ctrl.form.lead_arrival_source,
                caller_popup_users: ctrl.form.caller_popup_users
            };
            
            // Save lead settings and telephony users
            $api.settings.lead_settings.save({telephony: telephonySettings}, function(leadResponse) {
                if (!leadResponse.success) {
                    ctrl.saveLoading = false;
                    swal({ title: $translate.instant('TELEPHONY_SETTINGS_SAVE_ERROR'), type: "error", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON') });
                    return;
                }
                $api.settings.telephony_users.save({users: ctrl.telephonyUsers}, function(usersResponse) {
                    ctrl.saveLoading = false;
                    swal({
                        title: $translate.instant('TELEPHONY_SETTINGS_SAVED'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }, function() {
                    ctrl.saveLoading = false;
                    swal({ title: $translate.instant('TELEPHONY_SETTINGS_SAVE_ERROR'), type: "error", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON') });
                });
            }, function() {
                ctrl.saveLoading = false;
                swal({ title: $translate.instant('TELEPHONY_SETTINGS_SAVE_ERROR'), type: "error", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON') });
            });
        };
        
    });

})();

(function () {
  'use strict';

  angular.module('app.controllers').controller('AppDropdownController', [
    '$document', '$element', '$scope', '$timeout', '$filter',
    function ($document, $element, $scope, $timeout, $filter) {
      var ctrl = this;
      var outsideClickHandler = null;
      var positionUpdateHandler = null;
      var fixedPanelEl = null;
      var fixedPanelParent = null;
      var fixedPanelNextSibling = null;
      var parentFormCtrl = null;
      var typeaheadKeyHandler = null;
      var typeaheadBuffer = '';
      var typeaheadResetTimeout = null;
      /** Raw `searchable` binding from parent; undefined/null ⇒ derive from option count. */
      var searchableBindingRaw = undefined;

      // ─── lifecycle ────────────────────────────────────────────────────────────

      ctrl.$onInit = function () {
        ctrl.isOpen      = false;
        ctrl.dropup      = false;
        ctrl.searchQuery = '';
        ctrl._labelProp  = ctrl.labelProp  || 'name';
        ctrl._valueProp  = ctrl.valueProp  || null;
        ctrl._colorProp  = ctrl.colorProp  || null;
        ctrl._imageProp  = ctrl.imageProp  || null;
        ctrl._options    = ctrl.options    || [];

        // behaviour flags / defaults (searchable resolved in _syncEffectiveSearchable)
        _syncEffectiveSearchable();
        ctrl.showClear               = ctrl.showClear === true;
        ctrl.withTooltip             = ctrl.withTooltip === true;
        ctrl.allowCreate             = ctrl.allowCreate === true;
        ctrl.fixedPanel              = ctrl.fixedPanel === true;
        ctrl.expandTriggerForAllTags = ctrl.expandTriggerForAllTags === true;
        ctrl.visibleTagsCount        = _normalizeVisibleTagsCount(ctrl.visibleTagsCount);
        ctrl.panelStyle              = null;
        parentFormCtrl               = $element.controller('form') || null;

        $scope.$watch(function () {
          if (!ctrl.searchable || !ctrl.isOpen) return null;
          return ctrl.searchQuery;
        }, function (newVal, oldVal) {
          if (!ctrl.searchable || !ctrl.isOpen) return;
          if (newVal === oldVal) return;
          $timeout(function () {
            if (!ctrl.isOpen) return;
            if (!ctrl.searchQuery) {
              _scrollToSelected();
            } else {
              _scrollToFirstMatchForQuery(ctrl.searchQuery);
            }
          }, 0);
        });

        // Parent may pass options via a getter; keep panel list in sync while open.
        $scope.$watch(function () {
          return ctrl.options;
        }, function (newOpts) {
          _applyOptionsFromBinding(newOpts);
        });
      };

      ctrl.$onChanges = function (changes) {
        if (changes.options) {
          _applyOptionsFromBinding(changes.options.currentValue);
        }
        if (changes.labelProp && changes.labelProp.currentValue) {
          ctrl._labelProp = changes.labelProp.currentValue;
        }
        if (changes.valueProp) {
          ctrl._valueProp = changes.valueProp.currentValue || null;
        }
        if (changes.colorProp) {
          ctrl._colorProp = changes.colorProp.currentValue || null;
        }
        if (changes.imageProp) {
          ctrl._imageProp = changes.imageProp.currentValue || null;
        }
        if (changes.searchable) {
          searchableBindingRaw = changes.searchable.currentValue;
        }
        if (changes.options || changes.searchable) {
          _syncEffectiveSearchable();
        }
        if (changes.showClear) {
          ctrl.showClear = changes.showClear.currentValue === true;
        }
        if (changes.withTooltip) {
          ctrl.withTooltip = changes.withTooltip.currentValue === true;
        }
        if (changes.allowCreate) {
          ctrl.allowCreate = changes.allowCreate.currentValue === true;
        }
        if (changes.fixedPanel) {
          ctrl.fixedPanel = changes.fixedPanel.currentValue === true;
        }
        if (changes.expandTriggerForAllTags) {
          ctrl.expandTriggerForAllTags = changes.expandTriggerForAllTags.currentValue === true;
        }
        if (changes.visibleTagsCount) {
          ctrl.visibleTagsCount = _normalizeVisibleTagsCount(changes.visibleTagsCount.currentValue);
        }
      };

      ctrl.$onDestroy = function () {
        _restoreFixedPanel();
        ctrl.isOpen = false;
        ctrl.panelStyle = null;
        _unbindOutsideClick();
        _unbindPositionUpdate();
        _unbindTypeaheadKeys();
      };

      /**
       * Sets ctrl.searchable: explicit true/false from binding wins; otherwise
       * searchable when there are more than 10 options.
       */
      function _syncEffectiveSearchable() {
        if (searchableBindingRaw === true) {
          ctrl.searchable = true;
          return;
        }
        if (searchableBindingRaw === false) {
          ctrl.searchable = false;
          return;
        }
        var opts = ctrl._options || [];
        var n = Array.isArray(opts) ? opts.length : 0;
        ctrl.searchable = n > 10;
      }

      // ─── helpers ──────────────────────────────────────────────────────────────

      ctrl.getLabel = function (opt) {
        if (opt === null || opt === undefined) return '';
        if (typeof opt === 'object') return opt[ctrl._labelProp] || '';
        return String(opt);
      };

      ctrl.getValue = function (opt) {
        if (opt === null || opt === undefined) return opt;
        if (ctrl._valueProp && typeof opt === 'object') return opt[ctrl._valueProp];
        return opt;
      };

      /** Returns the label to display in the closed trigger for single-select. */
      ctrl.getDisplayLabel = function () {
        if (ctrl.multiple) return null;
        if (ctrl._valueProp) {
          if (ctrl.model === null || ctrl.model === undefined) return null;
          var found = _findByValue(ctrl.model);
          if (found) return ctrl.getLabel(found);
          if (ctrl.model === '') return null;
          return String(ctrl.model);
        }
        if (ctrl.model === null || ctrl.model === undefined || ctrl.model === '') return null;
        return ctrl.getLabel(ctrl.model);
      };

      ctrl.getSelectedOption = function () {
        if (ctrl.multiple) return null;
        if (ctrl._valueProp) {
          if (ctrl.model === null || ctrl.model === undefined) return null;
          return _findByValue(ctrl.model);
        }
        if (ctrl.model === null || ctrl.model === undefined || ctrl.model === '') return null;
        return typeof ctrl.model === 'object' ? ctrl.model : null;
      };

      ctrl.getCardBadgeState = function (opt) {
        if (!opt || typeof opt !== 'object') return null;
        if (opt.customer_has_card === true) return 'active';
        if (opt.customer_has_card === 'expired') return 'expired';
        return null;
      };

      ctrl.getOptionBackground = function (opt) {
        if (!ctrl._colorProp || !opt || typeof opt !== 'object') return null;
        return _normalizeBackgroundColor(opt[ctrl._colorProp]);
      };

      ctrl.getTriggerBackground = function () {
        if (!ctrl._colorProp || ctrl.multiple) return null;
        var selectedOption = ctrl.getSelectedOption();
        if (!selectedOption || typeof selectedOption !== 'object') return null;
        return _normalizeBackgroundColor(selectedOption[ctrl._colorProp]);
      };

      ctrl.getOptionImage = function (opt) {
        if (!ctrl._imageProp || !opt || typeof opt !== 'object') return null;
        return opt[ctrl._imageProp] || null;
      };

      /** Returns array of selected option objects (for chip rendering in multi-select). */
      ctrl.getSelectedItems = function () {
        if (!ctrl.multiple || !ctrl.model || !Array.isArray(ctrl.model) || !ctrl.model.length) {
          return [];
        }
        if (ctrl._valueProp) {
          return ctrl.model.map(function (val) {
            return _findByValue(val) || _syntheticOpt(val);
          });
        }
        return ctrl.model;
      };

      ctrl.getVisibleChipsLimit = function () {
        if (!ctrl.multiple) return 0;
        var items = ctrl.getSelectedItems();
        if (!items.length) return 0;
        var limit = ctrl.visibleTagsCount;
        if (!limit) return items.length;
        return Math.min(limit, items.length);
      };

      ctrl.getHiddenChipsCount = function () {
        if (!ctrl.multiple) return 0;
        var items = ctrl.getSelectedItems();
        var limit = ctrl.getVisibleChipsLimit();
        if (!items.length || !limit || items.length <= limit) return 0;
        return items.length - limit;
      };

      ctrl.getMoreLabel = function () {
        var hiddenCount = ctrl.getHiddenChipsCount();
        if (!hiddenCount) return '';

        var key = ctrl.moreLabelKey || 'DROPDOWN_AND_MORE';
        var translateFilter = null;
        try {
          translateFilter = $filter && $filter('translate');
        } catch (e) {
          translateFilter = null;
        }

        if (typeof translateFilter === 'function') {
          return translateFilter(key, { count: hiddenCount });
        }

        return 'and ' + hiddenCount + ' more';
      };

      ctrl.isSelected = function (opt) {
        var val = ctrl.getValue(opt);
        if (ctrl.multiple) {
          if (!ctrl.model || !Array.isArray(ctrl.model)) return false;
          return ctrl.model.some(function (item) {
            return ctrl._valueProp ? _isSameValue(item, val) : _isSameValue(ctrl.getValue(item), val);
          });
        } else {
          if (ctrl.model === null || ctrl.model === undefined) return false;
          return _isSameValue(ctrl.getValue(ctrl.model), val);
        }
      };

      /** Filter function used with ng-repeat's built-in filter. */
      ctrl.searchFilter = function (opt) {
        if (!ctrl.searchQuery) return true;
        var label = ctrl.getLabel(opt) || '';
        return label.toLowerCase().indexOf(ctrl.searchQuery.toLowerCase()) >= 0;
      };

      ctrl.isRequired = function () {
        return ctrl.require === true || ctrl.required === true;
      };

      ctrl.isRequiredInvalid = function () {
        return ctrl.isRequired() && _isEmptyModel();
      };

      ctrl.canCreateOption = function () {
        var label = _getCreateLabel();
        if (!ctrl.allowCreate || !ctrl.searchable || !label) return false;

        return !(ctrl._options || []).some(function (opt) {
          return ctrl.getLabel(opt).toLowerCase() === label.toLowerCase();
        });
      };

      // ─── actions ──────────────────────────────────────────────────────────────

      ctrl.toggle = function ($event) {
        $event.stopPropagation();
        if (ctrl.disabled) return;
        ctrl.isOpen ? ctrl.close() : ctrl.open();
      };

      ctrl.open = function () {
        ctrl.isOpen      = true;
        ctrl.searchQuery = '';
        _checkPosition();
        _bindOutsideClick();
        _bindPositionUpdate();
        _bindTypeaheadKeys();
        $timeout(function () {
          _syncFixedPanel();
          _checkPosition();
          _scrollToSelected();
          _focusSearch();
        }, 0);
      };

      ctrl.close = function () {
        _restoreFixedPanel();
        ctrl.isOpen = false;
        ctrl.panelStyle = null;
        _unbindOutsideClick();
        _unbindPositionUpdate();
        _unbindTypeaheadKeys();
      };

      ctrl.select = function (opt) {
        if (ctrl.multiple) {
          if (!Array.isArray(ctrl.model)) ctrl.model = [];
          var val     = ctrl.getValue(opt);
          var storeVal = ctrl._valueProp ? val : opt;
          var idx = ctrl.model.findIndex(function (item) {
            return ctrl._valueProp ? _isSameValue(item, val) : _isSameValue(ctrl.getValue(item), val);
          });
          if (idx >= 0) {
            ctrl.model.splice(idx, 1);
          } else {
            ctrl.model.push(storeVal);
          }
        } else {
          ctrl.model = ctrl._valueProp ? ctrl.getValue(opt) : opt;
          ctrl.close();
        }
        _emitChange();

        if (ctrl.multiple && ctrl.expandTriggerForAllTags) {
          $timeout(_checkPosition, 0);
        }
      };

      ctrl.createOption = function ($event) {
        if ($event) {
          $event.stopPropagation();
        }
        if (!ctrl.canCreateOption()) return;

        var label = _getCreateLabel();
        var opt = _createOption(label);
        if (!Array.isArray(ctrl._options)) ctrl._options = [];
        ctrl._options.push(opt);

        ctrl.select(opt);
        ctrl.searchQuery = '';
      };

      ctrl.removeChip = function ($event, item) {
        $event.stopPropagation();
        if (!Array.isArray(ctrl.model)) return;
        var val = ctrl.getValue(item);
        ctrl.model = ctrl.model.filter(function (m) {
          return ctrl._valueProp ? !_isSameValue(m, val) : !_isSameValue(ctrl.getValue(m), val);
        });
        _emitChange();

        if (ctrl.multiple && ctrl.expandTriggerForAllTags) {
          $timeout(_checkPosition, 0);
        }
      };

      ctrl.clearAll = function ($event) {
        $event.stopPropagation();
        ctrl.model = ctrl.multiple ? [] : null;
        _emitChange();
      };

      // ─── private ──────────────────────────────────────────────────────────────

      function _applyOptionsFromBinding(nextOpts) {
        var opts = nextOpts || [];
        if (opts === ctrl._options) {
          return;
        }
        ctrl._options = opts;
        _syncEffectiveSearchable();
        if (ctrl.isOpen) {
          $timeout(function () {
            if (!ctrl.isOpen) return;
            _syncFixedPanel();
            _checkPosition();
            if (!ctrl.searchQuery) {
              _scrollToSelected();
            }
          }, 0);
        }
      }

      function _emitChange() {
        var model = ctrl.model;
        _markParentFormDirty();
        if (!ctrl.onChange) return;
        $timeout(function () {
          ctrl.onChange({ model: model });
        }, 0);
      }

      function _markParentFormDirty() {
        if (parentFormCtrl && parentFormCtrl.$setDirty) {
          parentFormCtrl.$setDirty();
        }
      }

      function _findByValue(val) {
        return (ctrl._options || []).find(function (opt) {
          return opt && _isSameValue(opt[ctrl._valueProp], val);
        }) || null;
      }

      function _isSameValue(a, b) {
        if (a === b) return true;
        if (a === null || a === undefined || b === null || b === undefined) return false;
        if (typeof a === 'object' || typeof b === 'object') return false;
        return String(a) === String(b);
      }

      function _isEmptyModel() {
        return ctrl.model === null ||
          ctrl.model === undefined ||
          ctrl.model === '' ||
          (Array.isArray(ctrl.model) && !ctrl.model.length);
      }

      function _getCreateLabel() {
        return ctrl.searchQuery ? String(ctrl.searchQuery).trim() : '';
      }

      function _createOption(label) {
        var opt = {};
        opt[ctrl._labelProp] = label;
        if (ctrl._valueProp) opt[ctrl._valueProp] = label;
        return opt;
      }

      function _syntheticOpt(val) {
        var o = {};
        o[ctrl._labelProp] = String(val);
        if (ctrl._valueProp) o[ctrl._valueProp] = val;
        return o;
      }

      function _normalizeBackgroundColor(color) {
        if (!color) return null;
        var value = String(color).trim();
        var hexMatch = /^#([A-Fa-f0-9]{3}){1,2}$/.test(value);
        if (!hexMatch) return value;

        var chars = value.substring(1).split('');
        if (chars.length === 3) {
          chars = [chars[0], chars[0], chars[1], chars[1], chars[2], chars[2]];
        }
        var parsed = '0x' + chars.join('');
        return 'rgba(' + [(parsed >> 16) & 255, (parsed >> 8) & 255, parsed & 255].join(',') + ',0.2)';
      }

      function _normalizeVisibleTagsCount(raw) {
        if (raw === undefined || raw === null || raw === '') return null;
        var n = typeof raw === 'number' ? raw : parseInt(raw, 10);
        if (!n || n < 1 || isNaN(n)) return null;
        return n;
      }

      /**
       * Measures space below the trigger and switches to "dropup" mode when
       * there isn't enough room for the panel below the viewport fold.
       */
      function _checkPosition() {
        var triggerEl = $element[0].querySelector('.app-dropdown__trigger');
        if (!triggerEl) return;
        var rect       = triggerEl.getBoundingClientRect();
        var spaceBelow = window.innerHeight - rect.bottom;
        var spaceAbove = rect.top;
        ctrl.dropup    = spaceBelow < 280 && spaceAbove > spaceBelow;

        if (ctrl.fixedPanel) {
          var availableSpace = ctrl.dropup ? spaceAbove : spaceBelow;
          ctrl.panelStyle = {
            left: rect.left + 'px',
            right: 'auto',
            width: rect.width + 'px',
            top: ctrl.dropup ? 'auto' : rect.bottom + 'px',
            bottom: ctrl.dropup ? (window.innerHeight - rect.top) + 'px' : 'auto',
            maxHeight: Math.max(120, availableSpace - 8) + 'px'
          };
        } else {
          ctrl.panelStyle = null;
        }
      }

      function _scrollOptionRowIntoView(optionRowEl) {
        if (!optionRowEl) return;
        var container = optionRowEl.parentNode;
        if (!container || !container.classList || !container.classList.contains('app-dropdown__options')) {
          return;
        }

        var sRect = optionRowEl.getBoundingClientRect();
        var cRect = container.getBoundingClientRect();
        var delta = sRect.top - cRect.top - (container.clientHeight / 2) + (sRect.height / 2);
        var newScrollTop = container.scrollTop + delta;
        var maxScroll = Math.max(0, container.scrollHeight - container.clientHeight);

        if (newScrollTop < 0) {
          newScrollTop = 0;
        } else if (newScrollTop > maxScroll) {
          newScrollTop = maxScroll;
        }

        container.scrollTop = newScrollTop;
      }

      function _scrollToSelected() {
        if (!ctrl.isOpen) return;

        var panelEl = fixedPanelEl || $element[0].querySelector('.app-dropdown__panel');
        if (!panelEl) return;

        var optionsEl = panelEl.querySelector('.app-dropdown__options');
        if (!optionsEl) return;

        var selectedEl = optionsEl.querySelector('.app-dropdown__option.is-selected');
        if (!selectedEl) return;

        _scrollOptionRowIntoView(selectedEl);
      }

      /**
       * Scrolls the options list to the first visible row whose label contains `query`
       * (case-insensitive). Used for searchable filter + native-style typeahead.
       */
      function _scrollToFirstMatchForQuery(query) {
        if (!ctrl.isOpen) return;

        var q = query ? String(query).trim().toLowerCase() : '';
        if (!q) {
          _scrollToSelected();
          return;
        }

        var panelEl = fixedPanelEl || $element[0].querySelector('.app-dropdown__panel');
        if (!panelEl) return;

        var optionsEl = panelEl.querySelector('.app-dropdown__options');
        if (!optionsEl) return;

        var rows = optionsEl.querySelectorAll('.app-dropdown__option:not(.app-dropdown__option--create)');
        var i;
        var row;
        var labelEl;
        var text;

        for (i = 0; i < rows.length; i++) {
          row = rows[i];
          labelEl = row.querySelector('.app-dropdown__option-label');
          text = labelEl ? (labelEl.textContent || '') : '';
          if (text.toLowerCase().indexOf(q) >= 0) {
            _scrollOptionRowIntoView(row);
            return;
          }
        }
      }

      function _resetTypeaheadIdleTimer() {
        if (typeaheadResetTimeout) {
          $timeout.cancel(typeaheadResetTimeout);
          typeaheadResetTimeout = null;
        }
        typeaheadResetTimeout = $timeout(function () {
          typeaheadBuffer = '';
          typeaheadResetTimeout = null;
        }, 800);
      }

      function _bindTypeaheadKeys() {
        _unbindTypeaheadKeys();
        if (ctrl.searchable) return;

        typeaheadKeyHandler = function (ev) {
          if (!ctrl.isOpen || ctrl.disabled || ctrl.searchable) return;

          var target = ev.target;
          if (target) {
            var tag = target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
          }

          if (ev.ctrlKey || ev.metaKey || ev.altKey) return;

          var code = ev.which || ev.keyCode;

          if (code === 8) {
            if (!typeaheadBuffer.length) return;
            ev.preventDefault();
            typeaheadBuffer = typeaheadBuffer.slice(0, -1);
            _resetTypeaheadIdleTimer();
            $timeout(function () {
              if (!ctrl.isOpen) return;
              if (typeaheadBuffer) {
                _scrollToFirstMatchForQuery(typeaheadBuffer);
              } else {
                _scrollToSelected();
              }
            }, 0);
            return;
          }

          var ch = null;
          if (typeof ev.key === 'string' && ev.key.length === 1) {
            ch = ev.key;
          } else if (code >= 32 && code <= 126) {
            ch = String.fromCharCode(code);
          }

          if (!ch) return;

          ev.preventDefault();
          typeaheadBuffer += ch;
          _resetTypeaheadIdleTimer();
          $timeout(function () {
            if (!ctrl.isOpen) return;
            _scrollToFirstMatchForQuery(typeaheadBuffer);
          }, 0);
        };

        $document[0].addEventListener('keydown', typeaheadKeyHandler, true);
      }

      function _unbindTypeaheadKeys() {
        if (typeaheadKeyHandler) {
          $document[0].removeEventListener('keydown', typeaheadKeyHandler, true);
          typeaheadKeyHandler = null;
        }
        typeaheadBuffer = '';
        if (typeaheadResetTimeout) {
          $timeout.cancel(typeaheadResetTimeout);
          typeaheadResetTimeout = null;
        }
      }

      function _focusSearch() {
        if (ctrl.searchable === false) return;
        $timeout(function () {
          var panelEl = fixedPanelEl || $element[0].querySelector('.app-dropdown__panel');
          var input = panelEl ? panelEl.querySelector('.app-dropdown__search-input') : null;
          if (input) input.focus();
        }, 30);
      }

      function _bindOutsideClick() {
        _unbindOutsideClick();
        outsideClickHandler = function (event) {
          if ($element[0].contains(event.target)) return;
          if (fixedPanelEl && fixedPanelEl.contains(event.target)) return;

          $scope.$evalAsync(function () {
            ctrl.close();
          });
        };
        $document[0].addEventListener('click', outsideClickHandler, true);
      }

      function _bindPositionUpdate() {
        if (!ctrl.fixedPanel) return;
        _unbindPositionUpdate();
        positionUpdateHandler = function () {
          $scope.$evalAsync(function () {
            if (ctrl.isOpen) {
              _checkPosition();
            }
          });
        };
        window.addEventListener('resize', positionUpdateHandler, true);
        window.addEventListener('scroll', positionUpdateHandler, true);
      }

      function _syncFixedPanel() {
        if (!ctrl.fixedPanel || !ctrl.isOpen) return;

        fixedPanelEl = fixedPanelEl || $element[0].querySelector('.app-dropdown__panel');
        if (fixedPanelEl && fixedPanelEl.parentNode !== $document[0].body) {
          fixedPanelParent = fixedPanelEl.parentNode;
          fixedPanelNextSibling = fixedPanelEl.nextSibling;
          $document[0].body.appendChild(fixedPanelEl);
        }
      }

      function _restoreFixedPanel() {
        if (fixedPanelEl && fixedPanelEl.parentNode === $document[0].body) {
          if (fixedPanelParent) {
            fixedPanelParent.insertBefore(fixedPanelEl, fixedPanelNextSibling);
          } else {
            $element[0].appendChild(fixedPanelEl);
          }
        }
        fixedPanelEl = null;
        fixedPanelParent = null;
        fixedPanelNextSibling = null;
      }

      function _unbindOutsideClick() {
        if (outsideClickHandler) {
          $document[0].removeEventListener('click', outsideClickHandler, true);
          outsideClickHandler = null;
        }
      }

      function _unbindPositionUpdate() {
        if (positionUpdateHandler) {
          window.removeEventListener('resize', positionUpdateHandler, true);
          window.removeEventListener('scroll', positionUpdateHandler, true);
          positionUpdateHandler = null;
        }
      }
    }
  ]);
})();

(function () {
  'use strict';

  angular.module('app.components').component('appDropdown', {
    bindings: {
      /**
       * model: two-way binding — the selected value.
       *   single mode  → any value or object
       *   multiple mode → array of values or objects
       */
      model: '=',

      /**
       * options: one-way — array of items to display.
       * Each item can be a plain value (string/number) or an object.
       * When objects are used, `labelProp` and `valueProp` control
       * which properties are used for display and storage.
       */
      options: '<',

      /**
       * multiple: boolean — enable multi-select with checkboxes.
       */
      multiple: '<?',

      /**
       * searchable: boolean — show the search input inside the panel.
       * Omit to auto-enable search when there are more than 10 options,
       * otherwise off (10 or fewer). Explicit true/false always wins.
       */
      searchable: '<?',

      /**
       * showClear: boolean — show the clear (reset) icon in the trigger.
       * Defaults to false.
       */
      showClear: '<?',

      /**
       * withTooltip: boolean — enables tooltip directive for selected label.
       * Defaults to false.
       */
      withTooltip: '<?',

      /**
       * allowCreate: boolean — allow creating an option from the search value.
       * Defaults to false.
       */
      allowCreate: '<?',

      /**
       * placeholder: string — shown when nothing is selected.
       */
      placeholder: '@?',

      /**
       * label: string — field label shown above the dropdown.
       */
      label: '@?',

      /**
       * searchPlaceholder: string — placeholder for the search input.
       */
      searchPlaceholder: '@?',

      /**
       * labelProp: string — object property to display as the option label.
       * Defaults to 'name'.
       */
      labelProp: '@?',

      /**
       * valueProp: string — object property to store as the model value.
       * When omitted the whole option object is stored.
       */
      valueProp: '@?',
      /**
       * colorProp: string — object property used as background color
       * for selected value and options.
       */
      colorProp: '@?',
      /**
       * imageProp: string — object property with image URL
       * shown in selected value and options.
       */
      imageProp: '@?',

      /**
       * disabled: boolean — disables the dropdown.
       */
      disabled: '<?',

      /**
       * require/required: boolean — marks the dropdown value as required.
       * Used by the component to style invalid state and by the internal
       * validator input to keep the parent Angular form invalid.
       */
      require: '<?',
      required: '<?',

      /**
       * fixedPanel: boolean — render the panel with fixed viewport positioning.
       * Useful inside modal containers that clip absolute children with overflow.
       * Defaults to false.
       */
      fixedPanel: '<?',

      /**
       * expandTriggerForAllTags: boolean — in multi-select mode expand the
       * trigger height so that all selected tags are visible. When false
       * the trigger keeps a single-row layout.
       * Defaults to false.
       */
      expandTriggerForAllTags: '<?',

      /**
       * visibleTagsCount: number — in multi-select mode controls how many
       * tags are visible in the trigger before collapsing into "and N more".
       * Used only when expandTriggerForAllTags is false. Defaults to 3.
       */
      visibleTagsCount: '<?',

      /**
       * moreLabelKey: string — optional translation key for the
       * "and N more" label in multi-select mode.
       */
      moreLabelKey: '@?',

      /**
       * onChange: expression — fired after selection changes.
       * Receives { model } in the expression context.
       */
      onChange: '&?',
    },
    controllerAs: '$ctrl',
    templateUrl: 'app/components/app/app-dropdown/app-dropdown.view.html',
    controller: 'AppDropdownController',
  });
})();

(function () {
  angular.module('app.controllers')
    .controller('PhotosStockSettingsController', function ($state, $scope, $header, $api, $rootScope, PhotosStock, DTOptionsBuilder, dataTablesHebrewProvider, $translate) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }
      
      $header.breadcrumbs.push({
        title: 'SETTINGS_PHOTOS_STOCK'
      });

      var ctrl = this;
      ctrl.tableData = PhotosStock ? PhotosStock.data : [];

      $scope.dtOptions = DTOptionsBuilder.newOptions().withDOM('Tfgtip').withOption('searching', false).withLanguage(dataTablesHebrewProvider)
        .withOption('order', [[2, 'desc']])
        .withOption('columnDefs', [
          { targets: [0], width: '40px', orderable: false },
          { targets: [1, 2], width: 'auto' },
          { targets: [3], width: '40px', orderable: false }
        ]);


      ctrl.uploadProgress = 0;
      $scope.uploadFile = function(element){
        if (ctrl.uploadProgress > 1) return;
        if (element.files && element.files.length > 0) {
          ctrl.uploadProgress = element.files.length;
          for (var i = 0; i < element.files.length; i++) {
            $scope.postFile(element.files[i]);
          }
        }
      };


      $scope.postFile = function(file) {
          var fdata = new FormData();
          fdata.append("file", file);

          $api.photosStock.upload(fdata).$promise.then(function(response) {
            ctrl.uploadProgress--;
            if (response) {
              if (response.success && ctrl.uploadProgress < 1) {
                ctrl.getPhotos();
              } else {
                swal({
                  title: response.message,
                  type: "error",
                  timer: 3000
                });
              }
            }
          }).catch(function(error) {
              console.log(error);
          });
      };

      ctrl.deletePhoto = function(photoId) {
          swal({
              title: "",
              text: $translate.instant('SWAL_PHOTOS_STOCK_DELETE_CONFIRM_TEXT'),
              type: "warning",
              showCancelButton: true,
              confirmButtonClass: "btn-danger",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          }).then(function(result) {
            if(result.value) {
              $api.photosStock.delete.delete({ id: photoId }).$promise.then(function(response) {
                if (response && response.success) {
                  ctrl.tableData = ctrl.tableData.filter(function(item) {
                      return item.id !== photoId;
                  });
                  swal('', $translate.instant('SWAL_PHOTOS_STOCK_DELETE_SUCCESS_TEXT'), "success");
                } else {
                  swal('', $translate.instant('SWAL_PHOTOS_STOCK_DELETE_ERROR_TEXT'), "error");
                }
              });
            }
          });
      };

      ctrl.getPhotos = function() {
        $api.photosStock.get().$promise.then(function(response) {
          if (response && response.success) {
            ctrl.tableData = response.data;
          }
        });
      };

    });
})();

(function (){

    angular.module('app.controllers').controller('OnlineSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, FillableFields, $rootScope, $resource, $translate, $uibModal){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        ctrl.fillable_fields = FillableFields.data || [];

        Info.data.online_booking_data = Info.data && Info.data.online_booking_data ? JSON.parse(Info.data.online_booking_data) : {};
        
        ctrl.form = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.name ? Info.data.online_booking_data : {};
        ctrl.form.background_picture = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background_picture && Info.data.online_booking_data.background_picture != "" ? Info.data.online_booking_data.background_picture : 'women';
        ctrl.form.icon = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.icon && Info.data.online_booking_data.icon != "" ? Info.data.online_booking_data.icon : location.protocol + "//" + location.host+'/assets/images/pwa-icon.png';
        ctrl.form.background = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background && Info.data.online_booking_data.background != "" ? Info.data.online_booking_data.background : (Info.data.online_booking_data.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
        ctrl.form.background1 = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background1 ? Info.data.online_booking_data.background1 : '';
        ctrl.form.background2 = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background2 ? Info.data.online_booking_data.background2 : '';
        ctrl.form.background3 = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.background3 ? Info.data.online_booking_data.background3 : '';
        ctrl.form.online_logo = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.online_logo && Info.data.online_booking_data.online_logo != "" ? (Info.data.online_booking_data.online_logo == "removed" ? "" : Info.data.online_booking_data.online_logo) : location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
        ctrl.form.online_color = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.online_color && Info.data.online_booking_data.online_color != "" ? Info.data.online_booking_data.online_color : 'purple';
        ctrl.form.online_text_color = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.online_text_color && Info.data.online_booking_data.online_text_color != "" ? Info.data.online_booking_data.online_text_color : '#ffffff';
        ctrl.form.available_hours = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.available_hours && Info.data.online_booking_data.available_hours != "" ? Info.data.online_booking_data.available_hours : 'calendar';

        if (ctrl.form.online_color == 'purple') {
            ctrl.form.online_color = '#8C60AE';
        }
        if (ctrl.form.online_color == 'turquoise') {
            ctrl.form.online_color = '#61B9A0';
        }

        ctrl.form.name = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.name ? String(Info.data.online_booking_data.name) : '';
        ctrl.form.address = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.address ? String(Info.data.online_booking_data.address) : '';
        ctrl.form.phone = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.phone ? String(Info.data.online_booking_data.phone) : '';
        ctrl.form.facebook = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.facebook ? String(Info.data.online_booking_data.facebook) : '';
        ctrl.form.instagram = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.instagram ? String(Info.data.online_booking_data.instagram) : '';
        ctrl.form.linkedin = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.linkedin ? String(Info.data.online_booking_data.linkedin) : '';
        ctrl.form.twitter = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.twitter ? String(Info.data.online_booking_data.twitter) : '';
        ctrl.form.facebook_pixel = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.facebook_pixel ? String(Info.data.online_booking_data.facebook_pixel) : '';

        ctrl.form.allow_update = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_update ? String(Info.data.online_booking_data.allow_update) : '0';
        ctrl.form.allow_cancel = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_cancel ? String(Info.data.online_booking_data.allow_cancel) : '0';
        ctrl.form.update_hours = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.update_hours ? String(Info.data.online_booking_data.update_hours) : '4h';
        ctrl.form.cancel_hours = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.cancel_hours ? String(Info.data.online_booking_data.cancel_hours) : '4h';
        ctrl.form.closest_time = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.closest_time ? String(Info.data.online_booking_data.closest_time) : '0';
        ctrl.form.latest_time = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.latest_time ? Info.data.online_booking_data.latest_time*1 : 365;

        ctrl.form.instagram = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.instagram ? String(Info.data.online_booking_data.instagram) : '';
        ctrl.form.status = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.status ? String(Info.data.online_booking_data.status) : 'pending';
        ctrl.form.resource = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.resource ? String(Info.data.online_booking_data.resource) : '0';
        ctrl.form.display_category = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_category ? String(Info.data.online_booking_data.display_category) : '0';
        ctrl.form.display_earliest = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_earliest ? String(Info.data.online_booking_data.display_earliest) : '0';
        ctrl.form.allow_multi = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_multi ? String(Info.data.online_booking_data.allow_multi) : '0';
        ctrl.form.allow_first_available = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_first_available ? String(Info.data.online_booking_data.allow_first_available) : '0';
        ctrl.form.about = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.about ? String(Info.data.online_booking_data.about) : '';
        ctrl.form.popup_text = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.popup_text ? String(Info.data.online_booking_data.popup_text) : '';
        ctrl.form.display_price = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_price ? String(Info.data.online_booking_data.display_price) : '0';
        ctrl.form.display_duration = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.display_duration ? String(Info.data.online_booking_data.display_duration) : '1';
        ctrl.form.allow_number_of_payment = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_number_of_payment ? String(Info.data.online_booking_data.allow_number_of_payment) : '0';

        ctrl.form.disable_confirmation_code = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.disable_confirmation_code ? String(Info.data.online_booking_data.disable_confirmation_code) : '0';
        ctrl.form.confirmation_code = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.confirmation_code ? String(Info.data.online_booking_data.confirmation_code) : '0';
        ctrl.form.send_code_by = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.send_code_by ? String(Info.data.online_booking_data.send_code_by) : 'wa';
        ctrl.form.allow_new = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.allow_new ? String(Info.data.online_booking_data.allow_new) : '1';
        ctrl.form.waiting_list = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.waiting_list ? String(Info.data.online_booking_data.waiting_list) : '0';
        ctrl.form.interval = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.interval ? String(Info.data.online_booking_data.interval) : '';
        ctrl.form.ai_agent_popup = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.ai_agent_popup ? String(Info.data.online_booking_data.ai_agent_popup) : '0';
        ctrl.form.ai_button_text = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.ai_button_text ? String(Info.data.online_booking_data.ai_button_text) : 'לחץ כאן-תן למזכירה לתאם לך תור 🙋‍♀️';

        ctrl.form.alias = Info.data && Info.data.alias ? Info.data.alias : '';
        ctrl.form.allow_online_booking = String(parseInt(Info.data.allow_online_booking));

        ctrl.form.booking_fields = Info.data && Info.data.online_booking_data && Info.data.online_booking_data.booking_fields ? Info.data.online_booking_data.booking_fields : [];

        ctrl.aliasStatus = 'pending';
        ctrl.aliasTimer = null;
        ctrl.copied = false;

        $scope.msg_channels = $business.getMsgChannels();
        $scope.getMsgChannelByIndex = $business.getMsgChannelByIndex;
        ctrl.yesNoOptions = [
            {id: '0', name: $translate.instant('OPTION_NO')},
            {id: '1', name: $translate.instant('OPTION_YES')}
        ];
        ctrl.statusOptions = [
            {id: 'pending', name: $translate.instant('SETTINGS_ONLINE_STATUS_PENDING')},
            {id: 'open', name: $translate.instant('SETTINGS_ONLINE_STATUS_OPEN')}
        ];
        ctrl.allowOnlineBookingOptions = [
            {id: '0', name: $translate.instant('SETTINGS_ALLOW_ONLINE_BOOKING_NO')},
            {id: '1', name: $translate.instant('SETTINGS_ALLOW_ONLINE_BOOKING_FOR_EXISTING_CUST')},
            {id: '2', name: $translate.instant('SETTINGS_ALLOW_ONLINE_BOOKING_FOR_ALL_CUST')}
        ];
        ctrl.availableHoursOptions = [
            {id: 'calendar', name: $translate.instant('SETTINGS_ONLINE_CALENDAR_INTERVAL')},
            {id: 'item', name: $translate.instant('SETTINGS_ONLINE_ITEM_DURATION')},
            {id: 'calendar_order', name: $translate.instant('SETTINGS_ONLINE_CALENDAR_ORDER_INTERVAL')},
            {id: 'item_order', name: $translate.instant('SETTINGS_ONLINE_ITEM_ORDER_DURATION')}
        ];
        ctrl.intervalOptions = [
            {id: '5', name: $translate.instant('SETTINGS_INFO_MIN5')},
            {id: '10', name: $translate.instant('SETTINGS_INFO_MIN10')},
            {id: '15', name: $translate.instant('SETTINGS_INFO_MIN15')},
            {id: '20', name: $translate.instant('SETTINGS_INFO_MIN20')},
            {id: '30', name: $translate.instant('SETTINGS_INFO_MIN30')},
            {id: '45', name: $translate.instant('SETTINGS_INFO_MIN45')},
            {id: '60', name: $translate.instant('SETTINGS_INFO_MIN60')},
            {id: '75', name: $translate.instant('SETTINGS_INFO_MIN75')},
            {id: '90', name: $translate.instant('SETTINGS_INFO_MIN90')},
            {id: '105', name: $translate.instant('SETTINGS_INFO_MIN105')},
            {id: '120', name: $translate.instant('SETTINGS_INFO_MIN120')},
            {id: '135', name: $translate.instant('SETTINGS_INFO_MIN135')},
            {id: '150', name: $translate.instant('SETTINGS_INFO_MIN150')},
            {id: '165', name: $translate.instant('SETTINGS_INFO_MIN165')},
            {id: '180', name: $translate.instant('SETTINGS_INFO_MIN180')}
        ];
        ctrl.backgroundPictureOptions = [
            {id: 'men', name: $translate.instant('SETTINGS_BACKGROUND_MEN')},
            {id: 'women', name: $translate.instant('SETTINGS_BACKGROUND_WOMEN')}
        ];
        ctrl.hoursOptions = [
            {id: '0', name: $translate.instant('SETTINGS_ONLINE_0_HOURS')},
            {id: '1h', name: $translate.instant('SETTINGS_ONLINE_1_HOURS')},
            {id: '2h', name: $translate.instant('SETTINGS_ONLINE_2_HOURS')},
            {id: '4h', name: $translate.instant('SETTINGS_ONLINE_4_HOURS')},
            {id: '8h', name: $translate.instant('SETTINGS_ONLINE_8_HOURS')},
            {id: '1d', name: $translate.instant('SETTINGS_ONLINE_1_DAYS')},
            {id: '2d', name: $translate.instant('SETTINGS_ONLINE_2_DAYS')},
            {id: '3d', name: $translate.instant('SETTINGS_ONLINE_3_DAYS')},
            {id: '7d', name: $translate.instant('SETTINGS_ONLINE_7_DAYS')}
        ];
        ctrl.closestTimeOptions = [
            {id: '0', name: $translate.instant('SETTINGS_ONLINE_0_CLOSEST_TIME')},
            {id: '1', name: $translate.instant('SETTINGS_ONLINE_1_CLOSEST_TIME')},
            {id: '2', name: $translate.instant('SETTINGS_ONLINE_2_CLOSEST_TIME')},
            {id: '4', name: $translate.instant('SETTINGS_ONLINE_4_CLOSEST_TIME')},
            {id: '8', name: $translate.instant('SETTINGS_ONLINE_8_CLOSEST_TIME')},
            {id: '12', name: $translate.instant('SETTINGS_ONLINE_12_CLOSEST_TIME')},
            {id: '24', name: $translate.instant('SETTINGS_ONLINE_24_CLOSEST_TIME')},
            {id: 'DAY', name: $translate.instant('SETTINGS_ONLINE_DAY_CLOSEST_TIME')}
        ];
        ctrl.sendCodeByOptions = [
            {id: 'wa', name: $translate.instant('CUSTOMERS_WHATSAPP')},
            {id: 'sms', name: $translate.instant('CUSTOMERS_SMS')}
        ];

        ctrl.syncBookingFields = function() {
            var syncedFields = [];
            var existingFieldMap = {};

            if (ctrl.form.booking_fields && ctrl.form.booking_fields.length > 0) {
                ctrl.form.booking_fields.forEach(function(field) {
                    existingFieldMap[field.name] = field;
                });
            }

            if (ctrl.form.booking_fields && ctrl.form.booking_fields.length > 0) {
                ctrl.form.booking_fields.forEach(function(field) {
                    var exists = ctrl.fillable_fields.some(function(f) {
                        return f.name === field.name;
                    });
                    
                    if (exists) {
                        syncedFields.push(field);
                    }
                });
            }

            ctrl.fillable_fields.forEach(function(fillableField) {
                var found = syncedFields.some(function(f) {
                    return f.name === fillableField.name;
                });

                if (!found) {
                    syncedFields.push({
                        name: fillableField.name,
                        type: fillableField.type,
                        translationKey: fillableField.translationKey,
                        display: false,
                        required: false,
                        custom_field_id: fillableField.custom_field_id || null
                    });
                }
            });

            return syncedFields;
        };

        if (!ctrl.form.booking_fields || ctrl.form.booking_fields.length === 0) {
            ctrl.form.booking_fields = ctrl.fillable_fields.map(function(field) {
                return {
                    name: field.name,
                    type: field.type,
                    translationKey: field.translationKey,
                    display: false,
                    required: false,
                    custom_field_id: field.custom_field_id || null
                };
            });
        } else {
            ctrl.form.booking_fields = ctrl.syncBookingFields();
        }

        ctrl.getFieldDisplayName = function(field) {
            if (!field) {
                return '';
            }
            
            if (field.translationKey) {
                return $translate.instant(field.translationKey);
            }
            
            return field.name;
        };

        ctrl.getVisibleFieldsDisplay = function() {
            if (!ctrl.form.booking_fields || ctrl.form.booking_fields.length === 0) {
                return null;
            }

            var visibleFields = ctrl.form.booking_fields.filter(function(field) {
                return field.display === true;
            });

            if (visibleFields.length === 0) {
                return null;
            }

            return visibleFields.map(function(field) {
                var fieldName = ctrl.getFieldDisplayName(field);
                return field.required ? fieldName + '*' : fieldName;
            }).join(', ');
        };

        ctrl.hasVisibleFields = function() {
            return ctrl.getVisibleFieldsDisplay() !== null;
        };

        ctrl.openBookingFieldsModal = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/modules/settings/online/booking-fields-modal.html',
                controller: 'BookingFieldsModalController',
                controllerAs: 'ctrl',
                windowTopClass: "form-modal medium-modal",
                scope: $scope,
                resolve: {
                    fields: function() {
                        return angular.copy(ctrl.form.booking_fields);
                    },
                    fillableFields: function() {
                        return ctrl.fillable_fields;
                    }
                }
            });

            modalInstance.result.then(function(updatedFields) {
                ctrl.form.booking_fields = updatedFields;
                ctrl.saveBookingFields();
            });
        };

        ctrl.saveBookingFields = function() {
            $api.settings.online.save(ctrl.form, function(response){
                // silent save for booking fields (no redirect or alert)
            });
        };

        ctrl.submit = function(){
            if (ctrl.aliasStatus == 'symbols' || ctrl.aliasStatus == 'taken' || ctrl.aliasStatus == 'length') {
                return;
            }

            $api.settings.online.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_ONLINE_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                }
            });
        };

        ctrl.removeImage = function(type) {
            event.preventDefault();
            if (type == "background") {
                ctrl.form[type] = (ctrl.form.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
            } else if (type == "icon") {
                ctrl.form[type] = location.protocol + "//" + location.host+'/assets/images/pwa-icon.png';
            } else if (type == "online_logo") {
                ctrl.form[type] = 'removed';// location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
            } else {
                ctrl.form[type] = '';
            }
        }

        ctrl.checkDefaultBack = function(e) {
            if (ctrl.form.background.indexOf("pwa-default-") > 0) {
                ctrl.form.background = (ctrl.form.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
            }
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name;
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var reader = new FileReader();

            reader.onload = function(e) {
                var image =  document.createElement('img');
                image.src = e.target.result;
                image.onload = function() {
                    var fdata = new FormData();
                    fdata.append("image", element.files[0], new_file_name);
                    fdata.append("type", element.name);

                    if (element.name == "icon" && (element.files[0].type != 'image/png' || image.width != 512 || image.height != 512)) {
                        alert('Image must be 512x512 .png');
                        return;
                    }
                    console.log(element.files[0]);
                    $resource($api.baseURL + '/Image/upload', {}, {
                        postWithFile: {
                            method: "POST",
                            params: fdata,
                            transformRequest: angular.identity,
                            headers: {'Content-Type': undefined}
                        }
                    }).postWithFile(fdata).$promise.then(function(response){
                        ctrl.form[element.name] = response.image;
                    }, function(error){
                        console.log(error);
                    });
                }
            }

            reader.readAsDataURL(element.files[0]);
        };

        var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_};

        ctrl.uniqueBusinessBookingURL = function () {
            var alias = ctrl.form.alias;
            if (alias == '') {
                var ID_prefix = MD5(Info.data.id).slice(28,32);
                alias = ID_prefix + Info.data.id;
            }
            return 'https://' + (window.location.hostname == 'app.tiffulit.co.il' ? '' : 'stage') + 'booking.tiffulit.co.il/' + alias;
        };

        ctrl.validateAlias = function() {
            var alias = ctrl.form.alias;
            var aliasPattern = /^[a-zA-Z0-9-_]{5,25}$/;
            
            clearTimeout(ctrl.aliasTimer);
            if (alias.length >= 5 && alias.length <= 25) {
                if (aliasPattern.test(alias)) {
                    ctrl.aliasStatus = 'pending';
                    ctrl.aliasTimer = setTimeout(function() {
                        ctrl.aliasStatus = 'loading';
                        $api.settings.online.isAliasTaken.save({alias: alias}, function(response) {
                            if (response.status === "success") {
                                ctrl.aliasStatus = 'success';
                            } else {
                                ctrl.aliasStatus = 'taken';
                            }
                        });
                    }, 1000);
                } else {
                    ctrl.aliasStatus = 'symbols';
                }
            } else {
                if (alias.length > 0) {
                    ctrl.aliasStatus = 'length';
                } else {
                    ctrl.aliasStatus = 'pending';
                }
            }
        };

        ctrl.onAliasChange = function() {
            ctrl.validateAlias();
        };

        ctrl.getAliasError = function() {
            if (ctrl.aliasStatus == 'symbols') {
                return $translate.instant('SETTINGS_ONLINE_ALIAS_SYMBOLS');
            }

            if (ctrl.aliasStatus == 'taken') {
                return $translate.instant('SETTINGS_ONLINE_ALIAS_TAKEN');
            }

            if (ctrl.aliasStatus == 'length') {
                return $translate.instant('SETTINGS_ONLINE_ALIAS_LENGTH');
            }

            return '';
        };

        ctrl.copyLink = function() {
            var url = ctrl.uniqueBusinessBookingURL();
            navigator.clipboard.writeText(url).then(function() {
                ctrl.copied = true;
                setTimeout(function() {
                    ctrl.copied = false;
                }, 3000);
            }).catch(function(error) {
                console.error('Failed to copy URL: ', error);
            });
        };

        ctrl.handleDisableCode = function() {
            if (ctrl.form.disable_confirmation_code == '1') {
                swal({
                    title: "",
                    html: $translate.instant('SWAL_SETTINGS_ONLINE_DISABLE_CODE_TEXT') + "<br />" + $translate.instant('SWAL_SETTINGS_ONLINE_DISABLE_CODE_QUESTION'),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                }).then(function(result) {
                    if (!result.value) {
                        ctrl.form.disable_confirmation_code = '0';
                    }
                });
            }
        };
    });
})();

(function() {
    'use strict';

    angular.module('app.controllers').controller('BookingFieldsModalController', 
      function($scope, $translate, $timeout, $window, $uibModalInstance, fields, fillableFields) {
          
        var ctrl = this;

        ctrl.fields = angular.copy(fields);
        ctrl.fillableFields = fillableFields;

        ctrl.getFieldDisplayName = function(field) {
          if (!field) {
            return '';
          }
          
          if (field.translationKey) {
            return $translate.instant(field.translationKey);
          }
          
          return field.name;
        };

        ctrl.toggleFieldDisplay = function(field) {
          if (!field.display) {
            field.required = false;
          }
        };

        ctrl.toggleFieldRequired = function(field) {
          if (!field.display) {
            field.required = false;
            return;
          }
        };

        ctrl.canRequire = function(field) {
          return field.display;
        };

        ctrl.onSortStop = function() {
          // Fields array is automatically updated by ui-sortable via ng-model
          // Nothing else needed
        };

        ctrl.save = function() {
          $uibModalInstance.close(ctrl.fields);
        };

        ctrl.cancel = function() {
          $uibModalInstance.dismiss('cancel');
        };
      }
    );
})();

(function () {

    angular.module('app.controllers')

        .controller('MessagesSettingsController', function ($api, $state, Messages, DigitalSecretary, NotificationsMessages, $rootScope, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            // Initialize main tab index
            ctrl.mainTabIndex = 0;
            ctrl.digitalSecretaryActiveTabIndex = 0;
            ctrl.digitalSecretaryActiveTab = 'order_approval';

            // Initialize form data
            var messagesData = Messages.data || {};
            
            // Separate regular messages from other data
            ctrl.form = {
                id: messagesData.id,
                b_id: messagesData.b_id
            };
            
            // Initialize regular messages structure
            ctrl.form.regular = {
                order_created: messagesData.order_created || '',
                order_updated: messagesData.order_updated || '',
                order_cancelled: messagesData.order_cancelled || '',
                customer_debt: messagesData.customer_debt || '',
                debt_reminder: messagesData.debt_reminder || '',
                invoice: messagesData.invoice || '',
                reminder: messagesData.reminder || '',
                order_approval: messagesData.order_approval || '',
                birthday: messagesData.birthday || '',
                online_approval: messagesData.online_approval || '',
                online_decline: messagesData.online_decline || '',
                customer_update_online: messagesData.customer_update_online || '',
                customer_online_canceled: messagesData.customer_online_canceled || '',
                digital_form: messagesData.digital_form || '',
                digital_documents: messagesData.digital_documents || '',
                pay_by_link: messagesData.pay_by_link || '',
                prepaid: messagesData.prepaid || '',
                public_link: messagesData.public_link || '',
                waiting_sms: messagesData.waiting_sms || '',
                gift_card_sms: messagesData.gift_card_sms || '',
                request_card: messagesData.request_card || '',
                link_online: messagesData.link_online || ''
            };
            
            // Initialize notifications structure
            // Handle migration: if NotificationsMessages doesn't exist or has no data, initialize with empty values
            var notificationsData = NotificationsMessages && NotificationsMessages.data ? NotificationsMessages.data : {};
            ctrl.form.notifications = {
                tasks: notificationsData.tasks || '',
                digital_forms: notificationsData.digital_forms || '',
                new_leads: notificationsData.new_leads || '',
                birthdays: notificationsData.birthdays || '',
                upcoming_queue: notificationsData.upcoming_queue || '',
                cancellations: notificationsData.cancellations || '',
                queue_awaiting_approval: notificationsData.queue_awaiting_approval || ''
            };

            // Initialize digital secretary structure (default message comes from backend on GET)
            if (!ctrl.form.digital_secretary) {
                try {
                    ctrl.form.digital_secretary = DigitalSecretary && DigitalSecretary.data ? JSON.parse(JSON.stringify(DigitalSecretary.data)) : {};
                } catch (e) {
                    ctrl.form.digital_secretary = {};
                }
            }
            var speechKeys = ['speech_1','speech_2','speech_3','speech_4','speech_5','speech_6','speech_7','speech_8','speech_9','speech_0'];
            // Same structure for all tabs: active, message, speech_1..speech_0. How many speech inputs to show per tab.
            ctrl.digitalSecretarySpeechCount = { order_approval: 2 };
            ctrl.digitalSecretarySpeechPlaceholders = {
                order_approval: {
                    1: 'SETTINGS_DIGITAL_SECRETARY_SPEECH_AFTER_APPROVAL_PLACEHOLDER',
                    2: 'SETTINGS_DIGITAL_SECRETARY_SPEECH_AFTER_DISCARD_PLACEHOLDER'
                }
            };
            ctrl.getDigitalSecretarySpeechPlaceholder = function(n, tabKey) {
                tabKey = tabKey || ctrl.digitalSecretaryActiveTab;
                var key = (ctrl.digitalSecretarySpeechPlaceholders[tabKey] && ctrl.digitalSecretarySpeechPlaceholders[tabKey][n])
                    ? ctrl.digitalSecretarySpeechPlaceholders[tabKey][n]
                    : 'SETTINGS_DIGITAL_SECRETARY_SPEECH_LABEL';
                return $translate.instant(key);
            };
            angular.forEach(ctrl.form.digital_secretary, function(block, tabKey) {
                if (block && typeof block === 'object') {
                    speechKeys.forEach(function(k) { if (typeof block[k] === 'undefined') block[k] = ''; });
                    var count = ctrl.digitalSecretarySpeechCount[tabKey];
                    var tabPlaceholders = ctrl.digitalSecretarySpeechPlaceholders[tabKey];
                    if (count && tabPlaceholders) {
                        for (var i = 1; i <= Math.min(count, 9); i++) {
                            if (!block['speech_' + i] || String(block['speech_' + i]).trim() === '') {
                                block['speech_' + i] = ctrl.getDigitalSecretarySpeechPlaceholder(i, tabKey);
                            }
                        }
                        if (count >= 10 && (!block['speech_0'] || String(block['speech_0']).trim() === '')) {
                            block['speech_0'] = ctrl.getDigitalSecretarySpeechPlaceholder('0', tabKey);
                        }
                    }
                }
            });
            ctrl.getDigitalSecretarySpeechRange = function() {
                var tab = ctrl.digitalSecretaryActiveTab;
                var count = (tab && ctrl.digitalSecretarySpeechCount[tab]) ? ctrl.digitalSecretarySpeechCount[tab] : 0;
                var out = [];
                for (var i = 1; i <= Math.min(count, 9); i++) out.push(i);
                if (count >= 10) out.push('0');
                return out;
            };
            if (!ctrl.form.digital_secretary.order_approval) {
                ctrl.form.digital_secretary.order_approval = {
                    active: false,
                    message: '',
                    speech_1: ctrl.getDigitalSecretarySpeechPlaceholder(1, 'order_approval'),
                    speech_2: ctrl.getDigitalSecretarySpeechPlaceholder(2, 'order_approval'),
                    speech_3: '', speech_4: '', speech_5: '',
                    speech_6: '', speech_7: '', speech_8: '', speech_9: '', speech_0: ''
                };
            }

            ctrl.msg_placeholders = {
                'customer_name' : "[the customer's name]",
                'item_name' : "[Item description]",
                'start_date' : "[date]",
                'start_time' : "[time]",
                'datetime' : "[datetime]",
                'businesses_name' : "[name of the business]",
                'order_id' : "[order ID]",
                'link' : "[link]",
                'week_day' : "[week day]",
                'resource' : "[resource]",
                "customer_name|he" : "[שם הלקוח]",
                "item_name|he" : "[שם המוצר]",
                "item_name|he2" : "[שם הטיפול]",
                "start_date|he" : "[תאריך]",
                "start_time|he" : "[שעה]",
                "businesses_name|he" : "[שם בית העסק]",
                "order_id|he" : "[סכום יתרה]",
                'link|he' : "[קישור]",
                'datetime|he' : "[תאריך ושעת השירות]",
                'week_day|he' : "[יום בשבוע]",
                'resource|he' : "[שם העובד]",
                'digital_form_name': "[digital form name]",
                'digital_form_name|he': "[שם טופס דיגיטאלי]",
                'phone': "[phone]",
                'arrival_source': "[arrival source]",
                'age': "[age]",
                'sum': "[sum]",
                'phone|he': "[טלפון]",
                'arrival_source|he': "[מקור הגעה]",
                'age|he': "[גיל]",
                "phone|he2": "[נייד]",
                'sum|he': "[סכום]",
                'sum|he2': "[סְכוּם]"
            };

            /**
             * Get placeholder for digital secretary based on current language
             * @param {string} key - The key of the placeholder
             * @return {string}
             */
            ctrl.getDigitalSecretaryPlaceholder = function(key) {
                var lang = $rootScope.currentLanguage || 'en_US';
                var langSuffix = lang === 'hb_ISR' ? '|he' : '';
                var placeholderKey = key + langSuffix;
                
                // For item_name in Hebrew, try both variants
                if (lang === 'hb_ISR' && key === 'item_name') {
                    return ctrl.msg_placeholders['item_name|he2'] || ctrl.msg_placeholders['item_name|he'] || ctrl.msg_placeholders[key];
                }
                
                return ctrl.msg_placeholders[placeholderKey] || ctrl.msg_placeholders[key] || '[' + key + ']';
            };

            ctrl.digitalSecretaryMasks = [
                { key: 'customer_name', value: ctrl.getDigitalSecretaryPlaceholder('customer_name'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_CUSTOMER_NAME', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_CUSTOMER_NAME' },
                { key: 'item_name', value: ctrl.getDigitalSecretaryPlaceholder('item_name'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_ITEM_NAME', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_ITEM_NAME' },
                { key: 'datetime', value: ctrl.getDigitalSecretaryPlaceholder('datetime'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_DATETIME', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_DATETIME' },
                { key: 'start_date', value: ctrl.getDigitalSecretaryPlaceholder('start_date'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_DATE', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_DATE' },
                { key: 'start_time', value: ctrl.getDigitalSecretaryPlaceholder('start_time'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_TIME', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_TIME' },
                { key: 'businesses_name', value: ctrl.getDigitalSecretaryPlaceholder('businesses_name'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_BUSINESS_NAME', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_BUSINESS_NAME' },
                { key: 'week_day', value: ctrl.getDigitalSecretaryPlaceholder('week_day'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_WEEK_DAY', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_WEEK_DAY' },
                { key: 'resource', value: ctrl.getDigitalSecretaryPlaceholder('resource'), labelKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_RESOURCE', titleKey: 'SETTINGS_DIGITAL_SECRETARY_MASK_RESOURCE' }
            ];

            function buildRegularMasks(keys) {
                return keys.map(function(key) {
                    var value = ctrl.getDigitalSecretaryPlaceholder(key);
                    return { key: key, value: value, label: value };
                });
            }

            ctrl.regularMessageMasks = {
                order_created: buildRegularMasks(['customer_name', 'item_name', 'datetime', 'start_date', 'start_time', 'week_day', 'businesses_name', 'resource']),
                order_updated: buildRegularMasks(['customer_name', 'item_name', 'datetime', 'start_date', 'start_time', 'week_day', 'businesses_name', 'resource']),
                order_cancelled: buildRegularMasks(['customer_name', 'item_name', 'businesses_name']),
                customer_debt: buildRegularMasks(['customer_name', 'businesses_name', 'order_id']),
                debt_reminder: buildRegularMasks(['sum', 'businesses_name']),
                invoice: buildRegularMasks(['customer_name', 'businesses_name']),
                reminder: buildRegularMasks(['customer_name', 'item_name', 'businesses_name', 'week_day', 'datetime', 'start_date', 'start_time']),
                order_approval: buildRegularMasks(['customer_name', 'item_name', 'businesses_name', 'datetime', 'start_date', 'start_time', 'week_day', 'resource']),
                birthday: buildRegularMasks(['customer_name']),
                online_approval: buildRegularMasks(['customer_name', 'datetime', 'start_date', 'start_time', 'week_day', 'businesses_name', 'resource']),
                online_decline: buildRegularMasks(['customer_name', 'datetime', 'start_date', 'start_time', 'week_day', 'businesses_name', 'resource']),
                customer_update_online: buildRegularMasks(['customer_name', 'datetime', 'start_date', 'start_time', 'week_day', 'businesses_name', 'resource']),
                customer_online_canceled: buildRegularMasks(['customer_name', 'datetime', 'start_date', 'start_time', 'week_day', 'businesses_name', 'resource']),
                digital_form: buildRegularMasks(['customer_name', 'businesses_name', 'digital_form_name']),
                digital_documents: buildRegularMasks(['customer_name', 'businesses_name']),
                pay_by_link: buildRegularMasks(['customer_name', 'businesses_name']),
                prepaid: buildRegularMasks(['customer_name', 'businesses_name']),
                public_link: buildRegularMasks(['customer_name', 'businesses_name']),
                waiting_sms: buildRegularMasks(['customer_name', 'businesses_name', 'link']),
                gift_card_sms: buildRegularMasks(['customer_name', 'businesses_name', 'link']),
                request_card: buildRegularMasks(['customer_name', 'businesses_name']),
                link_online: buildRegularMasks(['customer_name', 'businesses_name'])
            };

            /**
             * Track digital secretary tab selection
             * @param {string} tabName - The name of the tab
             */
            ctrl.onDigitalSecretaryTabSelect = function(tabName) {
                ctrl.digitalSecretaryActiveTab = tabName;
            };

            /**
             * Validate form before submission
             * @return {boolean}
             */
            ctrl.validate = function() {
                // Validate regular messages
                if (ctrl.form.regular) {
                    for (var key in ctrl.form.regular) {
                        if (typeof ctrl.form.regular[key] === 'string' && ctrl.form.regular[key]) {
                            var matches = ctrl.form.regular[key].match(/\[(.*?)\]/g);
                            if (matches) {
                                for (var i in matches) {
                                    var check = false;
                                    for (var j in ctrl.msg_placeholders) {
                                        if (matches[i] == ctrl.msg_placeholders[j]) {
                                            check = true;
                                            break;
                                        }
                                    }
                                    if (!check) {
                                        swal({
                                            title: "",
                                            text: $translate.instant("SETTINGS_MESS_VALIDATE"),
                                            type: "warning",
                                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                            timer: 3000
                                        });
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }

                // Validate notifications
                if (ctrl.form.notifications) {
                    for (var notifKey in ctrl.form.notifications) {
                        if (typeof ctrl.form.notifications[notifKey] === 'string' && ctrl.form.notifications[notifKey]) {
                            var matches = ctrl.form.notifications[notifKey].match(/\[(.*?)\]/g);
                            if (matches) {
                                for (var i in matches) {
                                    var check = false;
                                    for (var j in ctrl.msg_placeholders) {
                                        if (matches[i] == ctrl.msg_placeholders[j]) {
                                            check = true;
                                            break;
                                        }
                                    }
                                    if (!check) {
                                        swal({
                                            title: "",
                                            text: $translate.instant("SETTINGS_MESS_VALIDATE"),
                                            type: "warning",
                                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                            timer: 3000
                                        });
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }

                // Validate digital secretary (empty message allowed; backend returns default on GET)
                if (ctrl.form.digital_secretary) {
                    for (var dsKey in ctrl.form.digital_secretary) {
                        var dsData = ctrl.form.digital_secretary[dsKey];
                        if (dsData && typeof dsData === 'object' && dsData.active && dsData.message && dsData.message.trim() !== '') {
                            var messageToValidate = dsData.message;

                            // Validate masks in message
                            var matches = messageToValidate.match(/\[(.*?)\]/g);
                            if (matches) {
                                for (var i in matches) {
                                    var check = false;
                                    for (var j in ctrl.msg_placeholders) {
                                        if (matches[i] == ctrl.msg_placeholders[j]) {
                                            check = true;
                                            break;
                                        }
                                    }
                                    if (!check) {
                                        swal({
                                            title: "",
                                            text: $translate.instant("SETTINGS_MESS_VALIDATE"),
                                            type: "warning",
                                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                            timer: 3000
                                        });
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }

                return true;
            };

            /**
             * Submit the data to the API and save necessary information
             * @return {void}
             */
            ctrl.submit = function () {
                if (!ctrl.validate()) {
                    return;
                }

                var totalCalls = 0;
                var completedCalls = 0;
                var hasError = false;

                // Helper function to check if all calls are done
                var checkAllDone = function() {
                    completedCalls++;
                    if (completedCalls >= totalCalls) {
                        // All saves completed
                        swal({
                            title: $translate.instant('SWAL_SETTINGS_MESSAGES_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings", {}, { reload: true });
                    }
                };

                // Save messages settings - merge regular messages with id and b_id
                var messagesData = JSON.parse(JSON.stringify(ctrl.form.regular));
                if (ctrl.form.id) messagesData.id = ctrl.form.id;
                if (ctrl.form.b_id) messagesData.b_id = ctrl.form.b_id;
                totalCalls++;
                $api.settings.messages.save(messagesData, function (response) {
                    if (response && response.status == "success") {
                        checkAllDone();
                    } else {
                        checkAllDone();
                    }
                });

                // Save notifications messages if they exist
                if (ctrl.form.notifications && Object.keys(ctrl.form.notifications).length > 0) {
                    if ($api.settings.notifications_messages && $api.settings.notifications_messages.save) {
                        totalCalls++;
                        $api.settings.notifications_messages.save(ctrl.form.notifications, function (response) {
                            if (response && response.status == "success") {
                                checkAllDone();
                            } else {
                                checkAllDone();
                            }
                        });
                    }
                }

                // Save digital secretary settings if they exist (message default comes from backend on GET)
                if (ctrl.form.digital_secretary && Object.keys(ctrl.form.digital_secretary).length > 0) {
                    if ($api.settings.digital_secretary && $api.settings.digital_secretary.save) {
                        totalCalls++;
                        var toSave = JSON.parse(JSON.stringify(ctrl.form.digital_secretary));
                        angular.forEach(toSave, function(block, tabKey) {
                            if (block && typeof block === 'object' && ctrl.digitalSecretarySpeechCount[tabKey] && ctrl.digitalSecretarySpeechPlaceholders[tabKey]) {
                                var range = ctrl.digitalSecretarySpeechCount[tabKey];
                                for (var i = 1; i <= Math.min(range, 9); i++) {
                                    if (!block['speech_' + i] || String(block['speech_' + i]).trim() === '') {
                                        block['speech_' + i] = ctrl.getDigitalSecretarySpeechPlaceholder(i, tabKey);
                                    }
                                }
                                if (range >= 10 && (!block['speech_0'] || String(block['speech_0']).trim() === '')) {
                                    block['speech_0'] = ctrl.getDigitalSecretarySpeechPlaceholder('0', tabKey);
                                }
                            }
                        });
                        $api.settings.digital_secretary.save(toSave, function (response) {
                            if (response && response.status == "success") {
                                checkAllDone();
                            } else {
                                checkAllDone();
                            }
                        });
                    }
                }
            }
        });
})();

(function (){
    angular.module('app.controllers').controller('LaserFileSettingsController', function ($header, $business, $uibModal, $uibModalStack, $api, $state, $filter, dates, $scope, $business, Info, $translate, $rootScope, $resource){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;
        ctrl.laser_categories = $business.laser_categories;
        ctrl.category_edit = {};
        ctrl.category_edit_values = {};
        ctrl.custom_category_names = {};

        ctrl.category = 1;

        ctrl.form = Info.data;
        $scope.sortableOptions = { handle: '.drag-handle' };

        $scope.msg_channels = $business.getMsgChannels();
        $scope.getMsgChannelByIndex = $business.getMsgChannelByIndex;

        ctrl.submit = function(preventClose){
            $api.settings.laser_file.save({laser_file: ctrl.form}, function(response){
                if(response.status === "success"){
                    if (!preventClose) {
                        swal({
                            title: $translate.instant('SWAL_LF_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    
                        $state.transitionTo("app.settings", {}, {reload: true});
                    }

                    if (response.data) {
                        ctrl.form = response.data;
                    }
                }
            });
        };

        ctrl.setup_list = function (field) {
            $uibModal.open({
              templateUrl: "app/modules/settings/laser_file/list/laser_file.list.html",
              controller: "LaserFileListController",
              controllerAs: "ctrl",
              scope: $scope,
              windowTopClass: "form-modal small-modal",
              resolve: {
                Field: field,
              }
            }).result.then(function (val) {

                if (val) {
                    field.list = val;
                    ctrl.submit(true);
                }
              
            });
        }

        ctrl.new_field = function(field) {
            $uibModal.open({
                templateUrl: "app/modules/settings/laser_file/popup_field/laser_file.popup_field.html",
                controller: "LaserFilePopupFieldController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal small-modal",
                resolve: {
                  Field: field ? angular.copy(field) : null,
                  Category_id: ctrl.category
                }
            }).result.then(function (val) {
                ctrl.refresh_list();
            });
        }

        ctrl.change_category = function(id) {
            ctrl.category = id;
        }

        ctrl.start_edit_category = function($event, category) {
            if ($event) {
                $event.stopPropagation();
            }

            ctrl.category_edit[category.id] = true;
            ctrl.category_edit_values[category.id] = category.name;
        };

        ctrl.save_category_name = function($event, category) {
            var value;

            if ($event) {
                $event.stopPropagation();
            }

            value = ctrl.category_edit_values[category.id];
            value = value ? value.trim() : '';

            if (!category.default_name) {
                category.default_name = category.name;
            }

            if (!value || value === category.default_name) {
                delete ctrl.custom_category_names[category.id];
            } else {
                ctrl.custom_category_names[category.id] = value;
            }

            $api.settings.laser_file_categories.save({ names: ctrl.custom_category_names }, function(response) {
                if (response && response.status === "success") {
                    ctrl.custom_category_names = response.data || {};
                    ctrl.apply_category_names();
                    ctrl.category_edit[category.id] = false;
                }
            });
        };

        ctrl.apply_category_names = function() {
            angular.forEach(ctrl.laser_categories, function(category) {
                var category_id;
                var custom_name;

                if (!category.default_name) {
                    category.default_name = category.name;
                }

                category_id = String(category.id);
                custom_name = ctrl.custom_category_names[category_id];

                category.name = custom_name ? custom_name : category.default_name;
            });
        };

        ctrl.load_category_names = function() {
            $api.settings.laser_file_categories.get(function(response) {
                if (response && response.status === "success") {
                    ctrl.custom_category_names = response.data || {};
                    ctrl.apply_category_names();
                }
            });
        };

        ctrl.refresh_list = function() {
            $api.settings.laser_file.get(function(response){
                if (response.data) {
                    ctrl.form = response.data;
                }
            });
        };

        ctrl.load_category_names();
    });
})();

(function (){

    angular.module('app.controllers').controller('LandingSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        Info.data.landing_data = Info.data && Info.data.landing_data ? JSON.parse(Info.data.landing_data) : {};
        ctrl.form = Info.data.landing_data;
        ctrl.form.template = Info.data && Info.data.landing_data && Info.data.landing_data.template ? Info.data.landing_data.template : 1;
      
        ctrl.form.landing_alias = Info.data && Info.data.landing_alias ? Info.data.landing_alias : '';

        ctrl.aliasStatus = 'pending';
        ctrl.aliasTimer = null;
        ctrl.copied = false;

        ctrl.submit = function(publish){
            publish = publish || false;
            if (ctrl.aliasStatus == 'symbols' || ctrl.aliasStatus == 'taken' || ctrl.aliasStatus == 'length') {
                return;
            }

            var post_data = ctrl.form;
            post_data.publish = publish;
            $api.settings.landing.save(post_data, function(response){
                if(response.status === "success" && publish){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_LANDING_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                }
            });
        };
       
        var MD5=function(d){d=unescape(encodeURIComponent(d));result=M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_};

        ctrl.uniqueBusinessBookingURL = function () {
            var alias = ctrl.form.landing_alias;
            if (alias == '') {
                var ID_prefix = MD5(Info.data.id).slice(28,32);
                alias = ID_prefix + Info.data.id;
            }
            return 'https://' + (window.location.hostname == 'app.tiffulit.co.il' ? '' : 'stage') + 'landing.tiffulit.co.il/' + alias;
        };

        ctrl.editPage = function(){
            $api.settings.landing.edit_page.get(function(response) {
                if (response.status === "success") {
                    window.open(ctrl.uniqueBusinessBookingURL() + "/" + response.data, '_blank');
                }
            });
        };

        ctrl.validateAlias = function() {
            var alias = ctrl.form.landing_alias;
            var aliasPattern = /^[a-zA-Z0-9-_]{5,25}$/;
            
            clearTimeout(ctrl.aliasTimer);
            if (alias.length >= 5 && alias.length <= 25) {
                if (aliasPattern.test(alias)) {
                    ctrl.aliasStatus = 'pending';
                    ctrl.aliasTimer = setTimeout(function() {
                        ctrl.aliasStatus = 'loading';
                        $api.settings.landing.isAliasTaken.save({landing_alias: alias}, function(response) {
                            if (response.status === "success") {
                                ctrl.aliasStatus = 'success';
                            } else {
                                ctrl.aliasStatus = 'taken';
                            }
                        });
                    }, 1000);
                } else {
                    ctrl.aliasStatus = 'symbols';
                }
            } else {
                if (alias.length > 0) {
                    ctrl.aliasStatus = 'length';
                } else {
                    ctrl.aliasStatus = 'pending';
                }
            }
        };

        ctrl.onAliasChange = function() {
            ctrl.validateAlias();
        };

        ctrl.copyLink = function() {
            var url = ctrl.uniqueBusinessBookingURL();
            navigator.clipboard.writeText(url).then(function() {
                ctrl.copied = true;
                setTimeout(function() {
                    ctrl.copied = false;
                }, 3000);
            }).catch(function(error) {
                console.error('Failed to copy URL: ', error);
            });
        };

        ctrl.resetColors = function(){
            ctrl.form.bg2 = '#EEF3FC';
            ctrl.form.bg1 = '#F0F9FF';
            ctrl.form.text = '#2A313C';
            ctrl.form.sub = '#FCA8CF';
            ctrl.form.button = '#275A7B';
            ctrl.form.graph = '#FBE4EF';
        };
    });
})();

(function (){
    angular.module('app.controllers').controller('InfoSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        ctrl.form = JSON.parse(JSON.stringify(Info.data));
        ctrl.form.msg_channel_scheduling = String(ctrl.form.msg_channel_scheduling);
        ctrl.form.msg_channel_inv_link = String(ctrl.form.msg_channel_inv_link);
        ctrl.form.print_invoices = ctrl.form.print_invoices;
        ctrl.form.show_stock = ctrl.form.show_stock;
        ctrl.form.stop_saturday_messages = ctrl.form.stop_saturday_messages;
        ctrl.form.stop_saturday_messages_condition = ctrl.form.stop_saturday_messages_condition;
        ctrl.form.manage_employee = ctrl.form.manage_employee;
        ctrl.form.send_reminder = String(ctrl.form.send_reminder);
        ctrl.form.reminder_send_type = String(ctrl.form.reminder_send_type);
        ctrl.form.avatar = ctrl.form.image ? ctrl.form.image : 'assets/images/avatar.jpg';
        ctrl.form.logo = ctrl.form.logo ? ctrl.form.logo : 'assets/images/logo/business_logo_placeholder.png';
        ctrl.form.language_code = Info.data.language_code;
        ctrl.form.type = String(Info.data.type);
        ctrl.form.prepaid = Info.data.prepaid ? Info.data.prepaid*1 : '';
        ctrl.form.ave_calculation = Info.data.ave_calculation ? Info.data.ave_calculation+'' : '0';
        ctrl.form.stop_messages = ctrl.form.stop_messages;
        ctrl.form.show_notes = ctrl.form.show_notes;
        ctrl.form.show_notes_page = ctrl.form.show_notes_page;
        ctrl.form.show_digital_forms_page = ctrl.form.show_digital_forms_page;
        ctrl.form.manage_leads = ctrl.form.manage_leads;
        ctrl.form.default_screen = Info.data.default_screen;
        ctrl.form.credit_suplier = String(Info.data.credit_suplier);
        ctrl.form.request_order_confirmation = String(parseInt(Info.data.request_order_confirmation));
        ctrl.form.dd_df_channel = String(ctrl.form.dd_df_channel);
        ctrl.form.online_channel = String(ctrl.form.online_channel);
        ctrl.form.not_arrive_option = String(Info.data.not_arrive_option*1);
        ctrl.form.update_order_notification = String(Info.data.update_order_notification*1);
        ctrl.form.lead_appearence = String(Info.data.lead_appearence * 1);
        ctrl.form.display_wa_messages = Info.data.display_wa_messages;
        ctrl.form.display_order_user = Info.data.display_order_user;
        ctrl.form.display_one_block_services = Info.data.display_one_block_services;
        ctrl.form.display_hebrew_dates = Info.data.display_hebrew_dates;
        ctrl.form.self_queue_notification = String(Info.data.self_queue_notification || null);
        ctrl.form.sent_accountant_report = Info.data.sent_accountant_report || false;
        ctrl.form.accountant_report_day = String(Info.data.accountant_report_day || 1);
        ctrl.form.accountant_report_time = Info.data.accountant_report_time || '09:00';

        if(Info.data.processing_time != null){
            ctrl.form.processing_time = $filter("hourAndMinute")(Info.data.processing_time);
        }else{
            ctrl.form.processing_time = "00:00";
        }

        // Initialize accountant report day options (1-28)
        ctrl.accountantReportDays = [];
        ctrl.accountantReportDayOptions = [];
        for (var i = 1; i <= 28; i++) {
            ctrl.accountantReportDays.push(i);
            ctrl.accountantReportDayOptions.push({id: String(i), name: String(i)});
        }

        // Initialize accountant report time options (30-minute intervals)
        ctrl.accountantReportTimes = [];
        ctrl.accountantReportTimeOptions = [];
        for (var hour = 0; hour < 24; hour++) {
            for (var minute = 0; minute < 60; minute += 30) {
                var timeStr = (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
                ctrl.accountantReportTimes.push(timeStr);
                ctrl.accountantReportTimeOptions.push({id: timeStr, name: timeStr});
            }
        }

        var bu_type = parseInt(Info.data.type);
        if(bu_type == 1) {
            $scope.default_screens = ["Dashboard", "Calendar-Daily", "Calendar-Weekly"];
        } else if(bu_type == 2) {
            $scope.default_screens = ["Dashboard", "Calendar-Orders", "Calendar-Occupation"];
        }
        ctrl.defaultScreenOptions = ($scope.default_screens || []).map(function (screen) {
            return {id: screen, name: $translate.instant(screen)};
        });
        $scope.BU_Types = BU_Types.data;
        $scope.datesProvider = dates;
        $scope.msg_channels = $business.getMsgChannels();
        $scope.getMsgChannelByIndex = $business.getMsgChannelByIndex;
        ctrl.msgChannelOptions = buildMsgChannelOptions($scope.msg_channels);
        ctrl.msgChannelOptionsNoFour = buildMsgChannelOptions($scope.msg_channels, function (channel) {
            return channel.index != 4;
        });
        ctrl.msgChannelOptionsNoFourNoOne = buildMsgChannelOptions($scope.msg_channels, function (channel) {
            return channel.index != 4 && channel.index != 1;
        });

        ctrl.dealerTypeOptions = [
            {id: 'licensed', name: 'Licensed'},
            {id: 'exempt', name: 'Exempt'}
        ];
        ctrl.languageOptions = [
            {id: 'hb_ISR', name: $translate.instant('SETTINGS_INFO_HB_ISR_LANG')},
            {id: 'en_US', name: $translate.instant('SETTINGS_INFO_EN_US_LANG')},
            {id: 'ru_RU', name: $translate.instant('SETTINGS_INFO_RU_RU_LANG')},
            {id: 'ja_JP', name: $translate.instant('SETTINGS_INFO_JA_JP_LANG')},
            {id: 'ar_AR', name: $translate.instant('SETTINGS_INFO_AR_AR_LANG')}
        ];
        ctrl.aveCalculationOptions = [
            {id: '1', name: $translate.instant('SETTINGS_INFO_AVE_CALCULATION_INVOICE')},
            {id: '0', name: $translate.instant('SETTINGS_INFO_AVE_CALCULATION_SHOWS')}
        ];
        ctrl.orderUpdateNotificationOptions = [
            {id: '0', name: $translate.instant('SETTINGS_ORDER_UPDATE_NOTIFICATION_0')},
            {id: '1', name: $translate.instant('SETTINGS_ORDER_UPDATE_NOTIFICATION_1')},
            {id: '2', name: $translate.instant('SETTINGS_ORDER_UPDATE_NOTIFICATION_2')}
        ];
        ctrl.sendReminderOptions = [
            {id: '0', name: $translate.instant('SETTINGS_USER_REMINDER_NO')},
            {id: '2', name: $translate.instant('SETTINGS_USER_REMINDER_2_HOURS')},
            {id: '4', name: $translate.instant('SETTINGS_USER_REMINDER_4_HOURS')},
            {id: '24', name: $translate.instant('SETTINGS_USER_REMINDER_24_HOURS')},
            {id: '48', name: $translate.instant('SETTINGS_USER_REMINDER_48_HOURS')},
            {id: '72', name: $translate.instant('SETTINGS_USER_REMINDER_72_HOURS')},
            {id: '168', name: $translate.instant('SETTINGS_USER_REMINDER_168_HOURS')}
        ];
        ctrl.yesNoOptions = [
            {id: '0', name: $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO')},
            {id: '1', name: $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES')}
        ];
        ctrl.leadAppearanceOptions = [
            {id: '0', name: $translate.instant('SETTINGS_LEAD_APPEARENCE_DEFAULT')},
            {id: '1', name: $translate.instant('SETTINGS_LEAD_APPEARENCE_STATUSES')}
        ];
        ctrl.stopSaturdayConditionOptions = [
            {id: 'before', name: $translate.instant('SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION_BEFORE')},
            {id: 'after', name: $translate.instant('SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION_AFTER')}
        ];

        ctrl.user_device_notifications_options = [
            {
                id: 'tasks',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_TASKS')
            },
            {
                id: 'digital_forms',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_DIGITAL_FORMS')
            },
            {
                id: 'new_leads',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_NEW_LEADS')
            },
            {
                id: 'birthdays',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_BIRTHDAYS')
            },
            {
                id: 'upcoming_queue',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_UPCOMING_QUEUE')
            },
            {
                id: 'cancellations',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_CANCELLATIONS')
            },
            {
                id: 'queue_awaiting_approval',
                name: $translate.instant('SETTINGS_MOBILE_NOTIFICATION_QUEUE_APPROVAL')
            },
        ];

        // Map saved ids from backend to option objects for ui-select
        var savedNotificationIds = Array.isArray(Info.data.user_device_notifications) ? Info.data.user_device_notifications : [];
        ctrl.selectedNotifications = ctrl.user_device_notifications_options.filter(function(option) {
            return savedNotificationIds.indexOf(option.id) !== -1;
        });

        // Generate time interval options (5 to 120 minutes in 5-minute intervals)
        ctrl.queueNotificationIntervals = [{value: null, label: $translate.instant('SETTINGS_SELECT_INTERVAL')}];
        for (var i = 5; i <= 120; i += 5) {
            ctrl.queueNotificationIntervals.push({
                value: i,
                label: i + ' ' + $translate.instant('SETTINGS_MINUTES')
            });
        }
        ctrl.queueNotificationIntervalOptions = ctrl.queueNotificationIntervals.map(function (interval) {
            return {id: String(interval.value), name: interval.label};
        });

        // Check if upcoming_queue is selected
        ctrl.isUpcomingQueueSelected = function() {
            return ctrl.selectedNotifications.some(function(notification) {
                return notification.id === 'upcoming_queue';
            });
        };

        ctrl.submit = function(){
            // Before submit, map selected option objects back to ids for backend
            ctrl.form.user_device_notifications = Array.isArray(ctrl.selectedNotifications)
                ? ctrl.selectedNotifications.map(function(option){ return option.id; })
                : [];

            // Only send self_queue_notification if upcoming_queue is selected
            if (!ctrl.isUpcomingQueueSelected()) {
                ctrl.form.self_queue_notification = null;
            }

            var accountantEmail = (ctrl.form.accountant_email || '').trim();
            if (ctrl.form.sent_accountant_report && !accountantEmail) {
                swal({
                    title: "",
                    text: $translate.instant('SETTINGS_INFO_ACCOUNTANT_EMAIL_EMPTY'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                return;
            }

            $api.settings.info.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_INFO_SAVE_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                    $rootScope.changeLanguage(ctrl.form.language_code);
                    $rootScope.show_notes_page = ctrl.form.show_notes_page;
                    $rootScope.customer_wa_chat = ctrl.form.customer_wa_chat;
                    $rootScope.cashbox_discount = ctrl.form.cashbox_discount;
                    $rootScope.lead_appearence = ctrl.form.lead_appearence * 1;
                    $rootScope.display_order_user = ctrl.form.display_order_user;
                    $rootScope.display_one_block_services = ctrl.form.display_one_block_services;
                    $rootScope.display_hebrew_dates = ctrl.form.display_hebrew_dates;
                }
            });
        };

        ctrl.checkCustomerDefault = function(option) {
            swal({
                title: "",
                text: $translate.instant('NOTIFICATION_MOVE_TO_CUSTOMER_CONFIRM'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result.value) {
                    ctrl.form['move_'+option] = result.value;
                    $api.settings.mass_customers.save(ctrl.form, function(response){
                        if(response.status === "success"){
                            swal({
                                title: $translate.instant('SWAL_SETTINGS_INFO_SAVE_TITLE'),
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    });
                }
            });
        }

        ctrl.changeCustomerWaChat = function() {
            ctrl.form.customer_wa_chat = !ctrl.form.customer_wa_chat;
            swal({
                title: $translate.instant('NOTIFICATION_CHANGE_CUSTOMER_WA_CHAT'),
                input: 'password',
                inputPlaceholder: $translate.instant('SWAL_PASSWORD_PLACEHOLDER'),
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result.value) {
                    $api.auth.check_password.save({password: result.value}, function(response){
                        if (response && response.check) {
                            ctrl.form.customer_wa_chat = !ctrl.form.customer_wa_chat;
                        }
                    });
                }
            });
        }

        $scope.uploadImage = function(element){
            var new_file_name = element.name  == 'avatar' ? 'avatar' : 'logo';
            new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

            var fdata = new FormData();
            fdata.append("image", element.files[0], new_file_name);
            fdata.append("type", element.name);
            $resource($api.baseURL + '/Image/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                ctrl.form[element.name] = response.image;
            }, function(error){
                console.log(error);
            });
        };

        ctrl.telephonyLink = window.location.origin+'/api/telephony';

        function buildMsgChannelOptions(channels, predicate) {
            var list = [];
            for (var i = 0; i < channels.length; i++) {
                if (!predicate || predicate(channels[i])) {
                    list.push({
                        id: String(channels[i].index),
                        name: $translate.instant(channels[i].name)
                    });
                }
            }
            return list;
        }
    });
})();

(function() {
    'use strict';

    angular.module("app.controllers").controller("GoogleCalendarController", function($scope, $state, $api, $translate, $uibModal, $rootScope, GoogleCalendarAccounts, $header) {
        
        if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $header.breadcrumbs.push({
            "title": "GOOGLE_CALENDAR_SETTINGS"
        });

        var ctrl = this;
        
        ctrl.loading = false;
        ctrl.accounts = GoogleCalendarAccounts && GoogleCalendarAccounts.data ? GoogleCalendarAccounts.data : [];
        ctrl.apiError = false;
        
        /**
         * Connect new Google account
         */
        ctrl.connectNewAccount = function() {
            $uibModal.open({
                templateUrl: 'app/modules/settings/google_calendar/modules/connect-account/connect-account.modal.html',
                controller: 'ConnectAccountController as ctrl',
                windowClass: 'form-modal small-modal',
                resolve: {
                    Resources: function ($api) {
                        return $api.resolve("resources@get");
                    },
                    GoogleCalendarAccounts: function () {
                        return $api.resolve("googlecalendar@get");
                    }
                }
            }).result.then(function(account) {
                $api.googlecalendar.get(function(response) {
                    if (response.success) {
                        ctrl.accounts = response.data;
                    }
                });
            });
        };
        
        /**
         * Toggle account active status
         */
        ctrl.toggleAccountStatus = function(account) {
            ctrl.loading = true;
            
            $api.googlecalendar.active.save({
                id: account.id
            }, {
                is_active: account.is_active
            }, function(response) {
                ctrl.loading = false;
                if (response.status === 'success') {
                    swal({
                        title: $translate.instant('SUCCESS'),
                        text: $translate.instant('ACCOUNT_STATUS_UPDATED'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }
            }, function(error) {
                ctrl.loading = false;
                account.is_active = !account.is_active; // Revert the change
                
                // Handle JSON parsing errors (HTML responses)
                var errorMessage = $translate.instant('ACCOUNT_STATUS_UPDATE_ERROR');
                if (error && error.data && typeof error.data === 'string' && error.data.includes('<div')) {
                    errorMessage = $translate.instant('API_ENDPOINT_NOT_AVAILABLE');
                    ctrl.apiError = true;
                }
                
                swal({
                    title: $translate.instant('ERROR'),
                    text: errorMessage,
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
            });
        };
        
        /**
         * Edit account resources
         */
        ctrl.editAccountResources = function(account) {
            $uibModal.open({
                templateUrl: 'app/modules/settings/google_calendar/modules/manage-resources/manage-resources.modal.html',
                controller: 'ManageResourcesController as ctrl',
                windowClass: 'form-modal small-modal',
                resolve: {
                    Account: function() {
                        return account;
                    },
                    Resources: function($api) {
                        return $api.resolve("resources@get");
                    },
                }
            }).result.then(function(updatedAccount) {
                $api.googlecalendar.get(function(response) {
                    if (response.success) {
                        ctrl.accounts = response.data;
                    }
                });
            });

        };
        
        
    });

})();

(function () {

    angular.module('app.controllers')

        .controller('DocumentSettingsController', function ($api, $state, $scope, Settings, Language, $rootScope, $translate) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;
            ctrl.form = Settings.data;
            $scope.lang = Language;

            /**
             * Submit the data to the API and save neccessary information
             * @return {void}
             */
            ctrl.submit = function () {

                $api.settings.documents.save({
                    lang: Language
                }, ctrl.form, function (response) {
                    if (response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_DOCUMENTS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        $state.transitionTo("app.settings", {}, { reload: true });
                    }
                });
            }
        });
})();

(function (){

    angular.module('app.controllers').controller('DigitalDocumentsSettingsController', function ($api, $state, DigitalDocuments, $scope, $rootScope, $resource, $translate) {

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;
        ctrl.form = {};

        ctrl.list = [];

        if (DigitalDocuments && DigitalDocuments.list) {
            for (var i in DigitalDocuments.list) {
                ctrl.list.push({id: DigitalDocuments.list[i].id, name: DigitalDocuments.list[i].name});
            }
        }
        
        ctrl.submit = function(){
            $api.settings.online.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_DD_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                }
            });
        };

        ctrl.removeFile = function(id) {
            event.preventDefault();
            $api.settings.digital_documents.single.delete({id: id}, function(response){
                if(response.status == "success"){
                    ctrl.list = ctrl.list.filter(function( obj ) {
                        return obj.id !== id;
                    });
                } else if (response.status == "failed"){
                    swal({
                        title: response.message,
                        type: "error",
                        timer: 3000
                    });
                }
            });
        }

        $scope.uploadFile = function(element){
            var fdata = new FormData();
            fdata.append("file", element.files[0]);

            $resource($api.baseURL + '/DigitalDocuments/upload', {}, {
                postWithFile: {
                    method: "POST",
                    params: fdata,
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            }).postWithFile(fdata).$promise.then(function(response){
                if (response) {
                    if(response.status == "success"){
                        ctrl.list.push({id: response.id, name: response.fileName});
                    } else if (response.status == "failed"){
                        swal({
                            title: response.message,
                            type: "error",
                            timer: 3000
                        });
                    }
                }
            }, function(error){
                console.log(error);
            });
        };

    });
})();

(function () {
  angular.module('app.controllers')
    .controller('CustomFieldsSettingsController', function ($state, $header, $rootScope, $customFields, CustomFields) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({
        title: 'SETTINGS_CUSTOM_FIELDS'
      });

      var ctrl = this;
      ctrl.customFields = CustomFields ? CustomFields.data : [];
      for (var i = 0; i < ctrl.customFields.length; i++) {
        ctrl.customFields[i].name = $customFields.getCurrentName(ctrl.customFields[i].name);
      }
    });
})();

(function () {
  angular.module('app.controllers')
    .controller('CoursesFieldsSettingsController', function ($state, $header, $rootScope, CoursesFields) {
      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({
        title: 'SETTINGS_COURSES_FIELDS'
      });

      var ctrl = this;
      ctrl.coursesFields = CoursesFields ? CoursesFields.data : [];
    });
})();

(function (){

    angular.module('app.controllers').controller('ColorSettingsController', function ($header, $api, $state, $filter, dates, $scope, $business, Info, BU_Types, $rootScope, $resource, $translate){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        ctrl.form = Info.data;
        ctrl.form.interval = String(Info.data.interval);
        ctrl.form.holiday_color = ctrl.form.holiday_color ? ctrl.form.holiday_color : '#E77471';
        ctrl.form.back_color = ctrl.form.back_color ? ctrl.form.back_color : '#F2F6FF';
        ctrl.form.menu_color = ctrl.form.menu_color ? ctrl.form.menu_color : '#216089';
        ctrl.form.calendar_color = ctrl.form.calendar_color ? ctrl.form.calendar_color : '#f2f2f2';
        ctrl.form.switch_colors = ctrl.form.switch_colors ? ctrl.form.switch_colors : false;
        ctrl.form.calendar_stripe_color = ctrl.form.calendar_stripe_color ? ctrl.form.calendar_stripe_color : '#f7fafc';
        ctrl.form.calendar_event_color = ctrl.form.calendar_event_color ? ctrl.form.calendar_event_color : '#778899';
        ctrl.form.calendar_default = ctrl.form.calendar_default;

        $scope.datesProvider = dates;
        ctrl.intervalOptions = [
            {id: '5', name: $translate.instant('SETTINGS_INFO_MIN5')},
            {id: '10', name: $translate.instant('SETTINGS_INFO_MIN10')},
            {id: '15', name: $translate.instant('SETTINGS_INFO_MIN15')},
            {id: '20', name: $translate.instant('SETTINGS_INFO_MIN20')},
            {id: '30', name: $translate.instant('SETTINGS_INFO_MIN30')},
            {id: '60', name: $translate.instant('SETTINGS_INFO_MIN60')},
            {id: '90', name: $translate.instant('SETTINGS_INFO_MIN90')}
        ];
        ctrl.calendarDefaultOptions = [
            {id: '0', name: $translate.instant('SETTINGS_CALENDAR_DEFAULT_DAILY')},
            {id: '1', name: $translate.instant('SETTINGS_CALENDAR_DEFAULT_WEEKLY')},
            {id: '2', name: $translate.instant('SETTINGS_CALENDAR_DEFAULT_MONTHLY')}
        ];

        ctrl.submit = function(){
            $api.settings.info.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_SETTINGS_COLOR_TITLE'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("app.settings", {}, {reload: true});
                    $rootScope.changeLanguage(ctrl.form.language_code);
                    
                    $rootScope.color_form = ctrl.form;
                    $rootScope.submitColors();
                }
            });
        };

        ctrl.resetColors = function(){
            ctrl.form.back_color = '#F2F6FF';
            ctrl.form.menu_color = '#216089';
            ctrl.resetColorsCalendar();
        };

        ctrl.resetColorsCalendar = function(){
            ctrl.form.calendar_color = '#f2f2f2';
            ctrl.form.holiday_color = '#E77471';
        };
    });
})();

(function () {
    angular.module('app.controllers')
        .controller('BusinessWhatsappSettingsController', function ($api, $state, $rootScope, $header, $translate) {

            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            $header.breadcrumbs.push({
                "title": "SETTINGS_BUSINESS_WHATSAPP"
            });

            var ctrl = this;
            ctrl.loading = false;
            ctrl.saving = false;
            ctrl.channel = null;
            ctrl.pin = '';
            ctrl.showRegisterForm = false;
            ctrl.registerError = null;
            ctrl.retryCreditSaving = false;
            ctrl.retryCreditError = null;
            ctrl.statusLabels = {
                pending: $translate.instant('BUSINESS_WHATSAPP_STATUS_PENDING'),
                active: $translate.instant('BUSINESS_WHATSAPP_STATUS_ACTIVE'),
                error: $translate.instant('BUSINESS_WHATSAPP_STATUS_ERROR'),
                disabled: $translate.instant('BUSINESS_WHATSAPP_STATUS_DISABLED')
            };
            ctrl.poller = null;

            ctrl.needsRegistration = function () {
                if (!ctrl.channel || !ctrl.channel.phone_number_id) return false;
                return ctrl.channel.status === 'pending' || ctrl.channel.status === 'error';
            };

            ctrl.canShowRegisterOption = function () {
                if (!ctrl.channel || !ctrl.channel.phone_number_id) return false;
                return !ctrl.channel.registration_completed_at;
            };

            ctrl.isFullyConnected = function () {
                return ctrl.channel && ctrl.channel.status === 'active' && ctrl.channel.registration_completed_at && !ctrl.channel.last_error;
            };

            ctrl.load = function () {
                ctrl.loading = true;
                $api.whatsappagent.get({}, function (response) {
                    ctrl.loading = false;
                    ctrl.channel = response && response.data ? response.data : null;
                }, function () {
                    ctrl.loading = false;
                    ctrl.channel = null;
                });
            };

            ctrl.init = function () {
                if (ctrl.saving) {
                    return;
                }
                ctrl.saving = true;
                $api.whatsappagent.init.save({}, function (response) {
                    ctrl.saving = false;
                    var data = response && response.data ? response.data : {};
                    ctrl.channel = data.channel ? data.channel : (data || null);
                    if (data.signup_url) {
                        ctrl.openEmbeddedSignup(data.signup_url);
                    }
                }, function () {
                    ctrl.saving = false;
                });
            };

            ctrl.disconnect = function () {
                if (ctrl.saving) {
                    return;
                }
                ctrl.saving = true;
                $api.whatsappagent.disconnect.save({}, function (response) {
                    ctrl.saving = false;
                    ctrl.channel = response && response.data ? response.data : null;
                }, function () {
                    ctrl.saving = false;
                });
            };

            ctrl.toggleRegisterForm = function () {
                ctrl.showRegisterForm = !ctrl.showRegisterForm;
                ctrl.pin = '';
                ctrl.registerError = null;
            };

            ctrl.retryCreditAttach = function () {
                if (ctrl.retryCreditSaving || !ctrl.channel) return;
                ctrl.retryCreditSaving = true;
                ctrl.retryCreditError = null;
                $api.whatsappagent.retry_credit_attach.save({}, function (response) {
                    ctrl.retryCreditSaving = false;
                    ctrl.retryCreditError = null;
                    ctrl.channel = response && response.data ? response.data : ctrl.channel;
                }, function (err) {
                    ctrl.retryCreditSaving = false;
                    ctrl.retryCreditError = (err.data && err.data.error) || $translate.instant('BUSINESS_WHATSAPP_RETRY_CREDIT_FAILED');
                    ctrl.channel = err.data && err.data.data ? err.data.data : ctrl.channel;
                });
            };

            ctrl.registerWa = function () {
                var pin = (ctrl.pin || '').replace(/\D/g, '');
                if (pin.length !== 6) {
                    ctrl.registerError = $translate.instant('BUSINESS_WHATSAPP_PIN_INVALID');
                    return;
                }
                if (ctrl.saving) return;
                ctrl.saving = true;
                ctrl.registerError = null;
                $api.whatsappagent.register_wa.save({}, {pin: pin}, function (response) {
                    ctrl.saving = false;
                    ctrl.showRegisterForm = false;
                    ctrl.pin = '';
                    ctrl.load();
                }, function (err) {
                    ctrl.saving = false;
                    ctrl.registerError = (err.data && err.data.error) || $translate.instant('BUSINESS_WHATSAPP_REGISTER_FAILED');
                });
            };

            ctrl.openEmbeddedSignup = function (url) {
                var popup = window.open(url, "whatsapp_signup", "width=720,height=800,scrollbars=yes");
                if (!popup) {
                    return;
                }

                var onComplete = function () {
                    if (ctrl.poller) {
                        clearInterval(ctrl.poller);
                        ctrl.poller = null;
                    }
                    ctrl.load();
                };

                window.addEventListener('message', function handler(e) {
                    if (e.data && e.data.type === 'whatsapp_signup_complete') {
                        window.removeEventListener('message', handler);
                        onComplete();
                    }
                });

                ctrl.poller = setInterval(function () {
                    if (popup.closed) {
                        onComplete();
                        return;
                    }

                    ctrl.load();
                    if (ctrl.channel && ctrl.channel.status == 'active') {
                        onComplete();
                    }
                }, 3000);
            };

            ctrl.load();
        });
})();

(function () {
  'use strict';

  angular
    .module("app.controllers")
    .controller("AiBookingAgentController", function ($scope, $state, $api, $resource, $translate, $rootScope, $header, Info, Agent) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({ title: "AI_BOOKING_AGENT_SETTINGS" });

      var ctrl = this;

      ctrl.safeParseJson = function (raw) {
        if (!raw) {
          return null;
        }

        if (typeof raw === 'object') {
          return raw;
        }

        try {
          return JSON.parse(raw);
        } catch (e) {
          return null;
        }
      };

      ctrl.data = Agent.data || {};
      ctrl.agent = ctrl.data.agent || {};
      ctrl.agent.status = ctrl.data.agent.status === 1 ? '1' : '0';
      ctrl.settingsRow = ctrl.data.settings || null;
      ctrl.kbFiles = (ctrl.data.kb && ctrl.data.kb.files) ? ctrl.data.kb.files : [];
      ctrl.faqItems = (ctrl.data.kb && ctrl.data.kb.faq) ? ctrl.data.kb.faq : [];

      ctrl.onlineBookingRaw = (Info && Info.data && Info.data.online_booking_data) || {};
      ctrl.onlineBooking = ctrl.safeParseJson(ctrl.onlineBookingRaw) || {};

      ctrl.bookingUi = {};
      ctrl.businessBookingUi = {};
      ctrl.overridesUi = {};

      ctrl.saving = false;
      ctrl.form = null;

      ctrl.activationKeywordsText = '';
      ctrl.bookingTriggerKeywordsText = '';
      ctrl.handoffKeywordsText = '';

      ctrl.inheritOnlineBooking = true;

      ctrl.activeTab = 'general';

      ctrl.agentStatusOptions = [
        { value: '1', name: $translate.instant('ACTIVE') },
        { value: '0', name: $translate.instant('INACTIVE') }
      ];

      ctrl.languageOptions = [
        { value: 'en_US', name: 'English' },
        { value: 'hb_ISR', name: 'Hebrew' },
        { value: 'ar_AR', name: 'Arabic' },
        { value: 'ja_JP', name: 'Japanese' }
      ];

      ctrl.currencyOptions = [
        { value: 'ILS', name: 'ILS' },
        { value: 'USD', name: 'USD' },
        { value: 'EUR', name: 'EUR' }
      ];

      ctrl.pricePrecisionOptions = [
        { value: '0', name: '0' },
        { value: '2', name: '2' }
      ];

      ctrl.weekStartOptions = [
        { value: 'monday', name: $translate.instant('MONDAY') },
        { value: 'sunday', name: $translate.instant('SUNDAY') }
      ];

      ctrl.activationModeOptions = [
        { value: 'immediate', name: $translate.instant('AI_AGENT_ACTIVATION_MODE_IMMEDIATE') },
        { value: 'keywords_only', name: $translate.instant('AI_AGENT_ACTIVATION_MODE_KEYWORDS_ONLY') },
        { value: 'after_admin_silence', name: $translate.instant('AI_AGENT_ACTIVATION_MODE_AFTER_ADMIN_SILENCE') }
      ];

      ctrl.bookingTriggerModeOptions = [
        { value: 'always_on', name: $translate.instant('AI_AGENT_BOOKING_TRIGGER_MODE_ALWAYS_ON') },
        { value: 'hybrid', name: $translate.instant('AI_AGENT_BOOKING_TRIGGER_MODE_HYBRID') },
        { value: 'keywords_only', name: $translate.instant('AI_AGENT_BOOKING_TRIGGER_MODE_KEYWORDS_ONLY') }
      ];

      ctrl.fallbackModeOptions = [
        { value: 'ask_clarifying_question', name: $translate.instant('AI_AGENT_FALLBACK_MODE_ASK_CLARIFYING_QUESTION') }
      ];

      ctrl.fallbackThenOptions = [
        { value: 'handoff', name: $translate.instant('AI_AGENT_FALLBACK_MODE_HANDOFF_IMMEDIATELY') }
      ];

      ctrl.employeeAutoPickStrategyOptions = [
        { value: 'ask_user', name: $translate.instant('AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY_ASK_USER') },
        { value: 'earliest_available', name: $translate.instant('AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY_EARLIEST_AVAILABLE') },
        { value: 'least_loaded', name: $translate.instant('AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY_LEAST_LOADED') },
        { value: 'preferred_if_known', name: $translate.instant('AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY_PREFERRED_IF_KNOWN') }
      ];

      ctrl.kbStrictModeOptions = [
        { value: 'kb_only_strict', name: $translate.instant('AI_AGENT_KB_STRICT_KB_ONLY') }
      ];

      ctrl.tabs = [
        {id: 'general', label: 'AI_AGENT_GENERAL_TITLE'},
        {id: 'routing', label: 'AI_AGENT_ROUTING_TITLE'},
        {id: 'booking', label: 'AI_AGENT_BOOKING_TITLE'},
        {id: 'time', label: 'AI_AGENT_TIME_DATE_TITLE'},
        {id: 'kb', label: 'AI_AGENT_KB_TITLE'},
        {id: 'customer_info', label: 'AI_AGENT_CUSTOMER_INFO_TITLE'},
        {id: 'messages', label: 'AI_AGENT_MESSAGES_TITLE'}
      ];

      ctrl.setTab = function(tabKey) {
        ctrl.activeTab = tabKey;
        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
          window.scrollTo(0, 0);
        }
      };

      ctrl.allowOnlineBookingOptions = [
        { value: 1, label: 'AI_AGENT_BOOKING_ACCESS_ONLY_REGISTERED', name: $translate.instant('AI_AGENT_BOOKING_ACCESS_ONLY_REGISTERED') },
        { value: 2, label: 'AI_AGENT_BOOKING_ACCESS_ALL_USERS', name: $translate.instant('AI_AGENT_BOOKING_ACCESS_ALL_USERS') }
      ];

      ctrl.closestTimeOptions = [
        { value: 0, label: 'AI_AGENT_CLOSEST_TIME_ANY', name: $translate.instant('AI_AGENT_CLOSEST_TIME_ANY') },
        { value: 1, label: 'AI_AGENT_CLOSEST_TIME_1H', name: $translate.instant('AI_AGENT_CLOSEST_TIME_1H') },
        { value: 2, label: 'AI_AGENT_CLOSEST_TIME_2H', name: $translate.instant('AI_AGENT_CLOSEST_TIME_2H') },
        { value: 4, label: 'AI_AGENT_CLOSEST_TIME_4H', name: $translate.instant('AI_AGENT_CLOSEST_TIME_4H') },
        { value: 8, label: 'AI_AGENT_CLOSEST_TIME_8H', name: $translate.instant('AI_AGENT_CLOSEST_TIME_8H') },
        { value: 12, label: 'AI_AGENT_CLOSEST_TIME_12H', name: $translate.instant('AI_AGENT_CLOSEST_TIME_12H') },
        { value: 24, label: 'AI_AGENT_CLOSEST_TIME_24H', name: $translate.instant('AI_AGENT_CLOSEST_TIME_24H') },
        { value: 'DAY', label: 'AI_AGENT_CLOSEST_TIME_1D', name: $translate.instant('AI_AGENT_CLOSEST_TIME_1D') }
      ];

      ctrl.deadlineOptions = [
        { value: 0, label: 'AI_AGENT_DEADLINE_ANY', name: $translate.instant('AI_AGENT_DEADLINE_ANY') },
        { value: '1h', label: 'AI_AGENT_DEADLINE_1H', name: $translate.instant('AI_AGENT_DEADLINE_1H') },
        { value: '2h', label: 'AI_AGENT_DEADLINE_2H', name: $translate.instant('AI_AGENT_DEADLINE_2H') },
        { value: '4h', label: 'AI_AGENT_DEADLINE_4H', name: $translate.instant('AI_AGENT_DEADLINE_4H') },
        { value: '8h', label: 'AI_AGENT_DEADLINE_8H', name: $translate.instant('AI_AGENT_DEADLINE_8H') },
        { value: '1d', label: 'AI_AGENT_DEADLINE_1D', name: $translate.instant('AI_AGENT_DEADLINE_1D') },
        { value: '2d', label: 'AI_AGENT_DEADLINE_2D', name: $translate.instant('AI_AGENT_DEADLINE_2D') },
        { value: '7d', label: 'AI_AGENT_DEADLINE_7D', name: $translate.instant('AI_AGENT_DEADLINE_7D') }
      ];

      ctrl.coerceInt = function (v, def) {
        var n = parseInt(v, 10);
        return isNaN(n) ? def : n;
      };

      ctrl.pick = function (obj, key, def) {
        return (obj && obj[key] !== undefined && obj[key] !== null) ? obj[key] : def;
      };

      ctrl.isPlainObject = function (v) {
        return v && typeof v === 'object' && !Array.isArray(v);
      };

      ctrl.pruneBySchema = function (obj, schema) {
        if (!schema) {
          return undefined;
        }

        if (schema === true) {
          return obj;
        }

        if (schema === 'string') {
          return (obj === undefined || obj === null) ? undefined : String(obj);
        }

        if (schema === 'number') {
          if (obj === undefined || obj === null || obj === '') {
            return undefined;
          }

          var n = parseInt(obj, 10);
          return isNaN(n) ? undefined : n;
        }

        if (schema === 'boolean') {
          return (obj === true || obj === 1 || obj === '1');
        }

        if (Array.isArray(schema)) {
          var itemSchema = schema[0] || true;
          if (!Array.isArray(obj)) {
            return [];
          }

          return obj
            .map(function (it) { return ctrl.pruneBySchema(it, itemSchema); })
            .filter(function (it) { return it !== undefined && it !== null; });
        }

        if (ctrl.isPlainObject(schema)) {
          if (!ctrl.isPlainObject(obj)) {
            obj = {};
          }

          var out = {};
          Object.keys(schema).forEach(function (k) {
            var v = ctrl.pruneBySchema(obj[k], schema[k]);
            if (v !== undefined) out[k] = v;
          });
          return out;
        }

        return undefined;
      };

      ctrl.getBookingDefaults = function () {
        return {
          allow_online_booking: 2,
          closest_time: 0,
          latest_time: 30,
          allow_update: 1,
          update_hours: 0,
          allow_cancel: 1,
          cancel_hours: 0,
          display_price: 1,
          display_duration: 1
        };
      };

      ctrl.sanitizeBookingOverrides = function (src, def) {
        def = def || ctrl.getBookingDefaults();
        src = src || {};

        var pickFirst = function () {
          for (var i = 0; i < arguments.length; i++) {
            var v = arguments[i];
            if (v !== undefined && v !== null && v !== '') {
              return v;
            }
          }
          return undefined;
        };

        var out = {
          allow_online_booking: pickFirst(src.allow_online_booking, src.allow_new_users_to_book),
          closest_time: pickFirst(src.closest_time, src.minimum_time_before_booking_hours),
          latest_time: pickFirst(src.latest_time, src.maximum_days_for_booking),
          allow_update: pickFirst(src.allow_update, src.allow_booking_updates),
          update_hours: pickFirst(src.update_hours, src.update_deadline_hours),
          allow_cancel: pickFirst(src.allow_cancel, src.allow_booking_cancellation),
          cancel_hours: pickFirst(src.cancel_hours, src.cancel_deadline_hours, src.cancellation_deadline_hours),
          display_price: pickFirst(src.display_price, src.show_service_price),
          display_duration: pickFirst(src.display_duration, src.show_service_duration)
        };

        out = ctrl.normalizeBooking(out, def);

        if (out.closest_time === undefined || out.closest_time === null) {
          out.closest_time = def.closest_time;
        }

        return out;
      };

      ctrl.normalizeBooking = function (model, def) {
        def = def || ctrl.getBookingDefaults();

        model.allow_online_booking = ctrl.coerceInt(model.allow_online_booking, def.allow_online_booking);
        model.latest_time = ctrl.coerceInt(model.latest_time, def.latest_time);

        model.allow_update = ctrl.coerceInt(model.allow_update, def.allow_update);
        model.allow_cancel = ctrl.coerceInt(model.allow_cancel, def.allow_cancel);
        model.display_price = ctrl.coerceInt(model.display_price, def.display_price);
        model.display_duration = ctrl.coerceInt(model.display_duration, def.display_duration);

        if (model.allow_update !== 1) {
          model.update_hours = 0;
        }

        if (model.allow_cancel !== 1) {
          model.cancel_hours = 0;
        }

        return model;
      };

      ctrl.buildBusinessBookingUi = function () {
        var def = ctrl.getBookingDefaults();
        var src = ctrl.onlineBooking || {};
        ctrl.businessBookingUi = ctrl.sanitizeBookingOverrides(src, def);
      };

      ctrl.buildOverridesUi = function () {
        var def = ctrl.getBookingDefaults();
        var src = (ctrl.form && ctrl.form.booking && ctrl.form.booking.overrides) || {};
        ctrl.overridesUi = ctrl.sanitizeBookingOverrides(src, def);
      };

      ctrl.syncDisplayedBookingUi = function () {
        ctrl.bookingUi = ctrl.inheritOnlineBooking ? ctrl.businessBookingUi : ctrl.overridesUi;
      };

      ctrl.kbLoading = false;
      ctrl.kbUploading = false;

      ctrl.faqDraft = { id: null, question: '', answer: '' };
      ctrl.faqEditing = false;
      ctrl.faqTmpIdSeq = 1;

      ctrl.resetFaqDraft = function () {
        ctrl.faqDraft = { id: null, question: '', answer: '' };
        ctrl.faqEditing = false;
      };

      ctrl.ensureFaqArray = function () {
        if (!ctrl.form) {
          return;
        }
        ctrl.form.kb = ctrl.form.kb || {};
        ctrl.form.kb.faq = Array.isArray(ctrl.form.kb.faq) ? ctrl.form.kb.faq : [];
        ctrl.faqItems = ctrl.form.kb.faq;
      };

      ctrl.makeTmpFaqId = function () {
        ctrl.faqTmpIdSeq = (ctrl.faqTmpIdSeq || 1) + 1;
        return -1 * ctrl.faqTmpIdSeq;
      };

      ctrl.findFaqIndexById = function (id) {
        var arr = ctrl.faqItems || [];
        for (var i = 0; i < arr.length; i++) {
          if (String(arr[i].id) === String(id)) {
            return i;
          }
        }
        return -1;
      };

      ctrl.normalizeFaqDraft = function () {
        var q = (ctrl.faqDraft.question || '').trim();
        var a = (ctrl.faqDraft.answer || '').trim();
        return { question: q, answer: a };
      };

      ctrl.editFaq = function (q) {
        if (!q) {
          return;
        }

        ctrl.faqEditing = true;
        ctrl.faqDraft = {
          id: q.id,
          question: q.question || '',
          answer: q.answer || ''
        };

        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {}
      };

      ctrl.cancelFaqEdit = function () {
        ctrl.resetFaqDraft();
      };

      ctrl.saveFaq = function () {
        ctrl.ensureFaqArray();

        var norm = ctrl.normalizeFaqDraft();
        if (!norm.question || !norm.answer) {
          return;
        }

        var arr = ctrl.faqItems;

        if (ctrl.faqEditing && ctrl.faqDraft.id !== null && ctrl.faqDraft.id !== undefined) {
          var idx = ctrl.findFaqIndexById(ctrl.faqDraft.id);
          if (idx >= 0) {
            arr[idx].question = norm.question;
            arr[idx].answer = norm.answer;
          }
          ctrl.resetFaqDraft();
          return;
        }

        arr.unshift({
          id: ctrl.makeTmpFaqId(),
          question: norm.question,
          answer: norm.answer
        });

        ctrl.resetFaqDraft();
      };

      ctrl.deleteFaq = function (q) {
        if (!q) {
          return;
        }

        ctrl.ensureFaqArray();

        var idx = ctrl.findFaqIndexById(q.id);
        if (idx >= 0) {
          ctrl.faqItems.splice(idx, 1);
        }

        if (ctrl.faqEditing && String(ctrl.faqDraft.id) === String(q.id)) {
          ctrl.resetFaqDraft();
        }
      };

      ctrl.customerInfoQueries = [
        { key: 'last_visit_date', titleKey: 'AI_AGENT_CI_Q_LAST_VISIT_DATE', hintKey: 'AI_AGENT_CI_Q_LAST_VISIT_DATE_HINT' },
        { key: 'last_visit_employee', titleKey: 'AI_AGENT_CI_Q_LAST_VISIT_EMPLOYEE', hintKey: 'AI_AGENT_CI_Q_LAST_VISIT_EMPLOYEE_HINT' },
        { key: 'last_visit_service', titleKey: 'AI_AGENT_CI_Q_LAST_VISIT_SERVICE', hintKey: 'AI_AGENT_CI_Q_LAST_VISIT_SERVICE_HINT' },
        { key: 'last_visit_price', titleKey: 'AI_AGENT_CI_Q_LAST_VISIT_PRICE', hintKey: 'AI_AGENT_CI_Q_LAST_VISIT_PRICE_HINT' },
        { key: 'last_visit_duration', titleKey: 'AI_AGENT_CI_Q_LAST_VISIT_DURATION', hintKey: 'AI_AGENT_CI_Q_LAST_VISIT_DURATION_HINT' },
        { key: 'visits_count_this_year', titleKey: 'AI_AGENT_CI_Q_VISITS_COUNT_THIS_YEAR', hintKey: 'AI_AGENT_CI_Q_VISITS_COUNT_THIS_YEAR_HINT' },
        { key: 'visits_count_range', titleKey: 'AI_AGENT_CI_Q_VISITS_COUNT_RANGE', hintKey: 'AI_AGENT_CI_Q_VISITS_COUNT_RANGE_HINT' },
        { key: 'total_spend_this_year', titleKey: 'AI_AGENT_CI_Q_TOTAL_SPEND_THIS_YEAR', hintKey: 'AI_AGENT_CI_Q_TOTAL_SPEND_THIS_YEAR_HINT' },
        { key: 'total_spend_range', titleKey: 'AI_AGENT_CI_Q_TOTAL_SPEND_RANGE', hintKey: 'AI_AGENT_CI_Q_TOTAL_SPEND_RANGE_HINT' },
        { key: 'next_appointment', titleKey: 'AI_AGENT_CI_Q_NEXT_APPOINTMENT',  hintKey: 'AI_AGENT_CI_Q_NEXT_APPOINTMENT_HINT' },
        { key: 'last_cancelled', titleKey: 'AI_AGENT_CI_Q_LAST_CANCELLED', hintKey: 'AI_AGENT_CI_Q_LAST_CANCELLED_HINT' },
        { key: 'favourite_employee', titleKey: 'AI_AGENT_CI_Q_FAV_EMPLOYEE', hintKey: 'AI_AGENT_CI_Q_FAV_EMPLOYEE_HINT' },
        { key: 'favourite_service', titleKey: 'AI_AGENT_CI_Q_FAV_SERVICE', hintKey: 'AI_AGENT_CI_Q_FAV_SERVICE_HINT' },
        { key: 'last_visit_notes', titleKey: 'AI_AGENT_CI_Q_LAST_NOTES', hintKey: 'AI_AGENT_CI_Q_LAST_NOTES_HINT' }
      ];

      ctrl.customerInfoAllowAll = function () {
        if (!ctrl.form || !ctrl.form.customer_info || ctrl.form.customer_info.enabled !== true) {
          return;
        }

        ctrl.form.customer_info.allowed = ctrl.form.customer_info.allowed || {};
        Object.keys(ctrl.customerInfoQueryOptionsMap()).forEach(function (k) {
          ctrl.form.customer_info.allowed[k] = true;
        });
      };

      ctrl.customerInfoDenyAll = function () {
        if (!ctrl.form || !ctrl.form.customer_info || ctrl.form.customer_info.enabled !== true) {
          return;
        }

        ctrl.form.customer_info.allowed = ctrl.form.customer_info.allowed || {};
        Object.keys(ctrl.customerInfoQueryOptionsMap()).forEach(function (k) {
          ctrl.form.customer_info.allowed[k] = false;
        });
      };

      ctrl.customerInfoQueryOptionsMap = function () {
        var out = {};
        (ctrl.customerInfoQueries || []).forEach(function (q) { out[q.key] = true; });
        return out;
      };

      ctrl.isCustomerInfoAllowed = function (key) {
        if (!ctrl.form || !ctrl.form.customer_info) {
          return false;
        }

        var allowed = ctrl.form.customer_info.allowed || {};
        return allowed[key] === true;
      };

      ctrl.setCustomerInfoAllowed = function (key, value) {
        if (!ctrl.form) {
          return;
        }

        ctrl.form.customer_info = ctrl.form.customer_info || {};
        ctrl.form.customer_info.allowed = ctrl.form.customer_info.allowed || {};
        ctrl.form.customer_info.allowed[key] = !!value;
      };

      ctrl.timezoneOptions = [
        { value: 'Asia/Jerusalem', label: 'Asia/Jerusalem (Israel)', name: 'Asia/Jerusalem (Israel)' },
        { value: 'Europe/London', label: 'Europe/London', name: 'Europe/London' },
        { value: 'America/New_York', label: 'America/New_York', name: 'America/New_York' }
      ];

      ctrl.dateFormatOptions = [
        { value: 'DD.MM.YYYY', label: 'DD.MM.YYYY (31.12.2026)', name: 'DD.MM.YYYY (31.12.2026)' },
        { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (2026-12-31)', name: 'YYYY-MM-DD (2026-12-31)' },
        { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY (12/31/2026)', name: 'MM/DD/YYYY (12/31/2026)' },
        { value: 'D MMM YYYY', label: 'D MMM YYYY (31 Dec 2026)', name: 'D MMM YYYY (31 Dec 2026)' }
      ];

      ctrl.timeFormatOptions = [
        { value: 'HH:mm', label: '24h (18:30)', name: '24h (18:30)' },
        { value: 'hh:mm A', label: '12h (6:30 PM)', name: '12h (6:30 PM)' }
      ];

      ctrl.outsideWorkingHoursOptions = [
        { value: 'allow', label: 'AI_AGENT_OUTSIDE_WORKING_HOURS_ALLOW', name: $translate.instant('AI_AGENT_OUTSIDE_WORKING_HOURS_ALLOW') },
        { value: 'suggest_next_time', label: 'AI_AGENT_OUTSIDE_WORKING_HOURS_NEXT', name: $translate.instant('AI_AGENT_OUTSIDE_WORKING_HOURS_NEXT') },
        { value: 'handoff', label: 'AI_AGENT_OUTSIDE_WORKING_HOURS_HANDOFF', name: $translate.instant('AI_AGENT_OUTSIDE_WORKING_HOURS_HANDOFF') }
      ];

      ctrl.weekDays = [
        { key: 'mon', label: 'MONDAY' },
        { key: 'tue', label: 'TUESDAY' },
        { key: 'wed', label: 'WEDNESDAY' },
        { key: 'thu', label: 'THURSDAY' },
        { key: 'fri', label: 'FRIDAY' },
        { key: 'sat', label: 'SATURDAY' },
        { key: 'sun', label: 'SUNDAY' }
      ];

      ctrl.timeStepMinutes = 15;
      ctrl.timeOptions = [];

      ctrl.pad2 = function(n) {
        return (n < 10 ? '0' : '') + n;
      };

      ctrl.timeToMinutes = function (t) {
        if (!t || typeof t !== 'string') {
          return null;
        }

        var m = t.match(/^(\d{1,2}):(\d{2})$/);
        if (!m) {
          return null;
        }

        var hh = parseInt(m[1], 10);
        var mm = parseInt(m[2], 10);
        if (isNaN(hh) || isNaN(mm) || hh < 0 || hh > 23 || mm < 0 || mm > 59) {
          return null;
        }

        return hh * 60 + mm;
      };

      ctrl.minutesToTime = function (mins) {
        mins = Math.max(0, Math.min(23 * 60 + 59, mins));
        var hh = Math.floor(mins / 60);
        var mm = mins % 60;
        return ctrl.pad2(hh) + ':' + ctrl.pad2(mm);
      };

      ctrl.buildTimeOptions = function () {
        var step = ctrl.timeStepMinutes || 15;
        var arr = [];
        for (var m = 0; m < 24 * 60; m += step) {
          arr.push(ctrl.minutesToTime(m));
        }
        ctrl.timeOptions = arr;
      };

      ctrl.getTimeOptionsMin = function (minTime, plusMinutes) {
        var base = ctrl.timeToMinutes(minTime);
        if (base === null) {
          base = 0;
        }
        base += (plusMinutes || 0);

        return (ctrl.timeOptions || []).filter(function (t) {
          var mm = ctrl.timeToMinutes(t);
          return mm !== null && mm >= base;
        });
      };

      ctrl.clampToOptions = function (value, options, fallback) {
        if (options && options.indexOf(value) !== -1) {
          return value;
        }

        return fallback || (options && options[0]) || value;
      };

      ctrl.ensureIntervalValid = function (obj, fromKey, toKey, minFrom, minTo) {
        if (!obj) {
          return;
        }

        var fromOpts = ctrl.getTimeOptionsMin(minFrom, 0);
        obj[fromKey] = ctrl.clampToOptions(obj[fromKey], fromOpts, fromOpts[0]);

        var toOpts = ctrl.getTimeOptionsMin(obj[fromKey], ctrl.timeStepMinutes);
        obj[toKey] = ctrl.clampToOptions(obj[toKey], toOpts, toOpts[0]);

        if (minTo) {
          var minToM = ctrl.timeToMinutes(minTo);
          var curToM = ctrl.timeToMinutes(obj[toKey]);
          if (minToM !== null && curToM !== null && curToM < minToM) {
            var forced = ctrl.getTimeOptionsMin(minTo, 0);
            obj[toKey] = ctrl.clampToOptions(obj[toKey], forced, forced[0]);
          }
        }
      };

      ctrl.normalizeDayParts = function () {
        if (!ctrl.form || !ctrl.form.time || !ctrl.form.time.day_parts) {
          return;
        }

        var dp = ctrl.form.time.day_parts;
        dp.morning = dp.morning || {};
        dp.day = dp.day || {};
        dp.evening = dp.evening || {};

        ctrl.ensureIntervalValid(dp.morning, 'from', 'to', '00:00');

        dp.day.from = dp.day.from || dp.morning.to;
        dp.day.from = ctrl.clampToOptions(dp.day.from, ctrl.getTimeOptionsMin(dp.morning.to, 0), dp.morning.to);
        ctrl.ensureIntervalValid(dp.day, 'from', 'to', dp.morning.to);

        dp.evening.from = dp.evening.from || dp.day.to;
        dp.evening.from = ctrl.clampToOptions(dp.evening.from, ctrl.getTimeOptionsMin(dp.day.to, 0), dp.day.to);
        ctrl.ensureIntervalValid(dp.evening, 'from', 'to', dp.day.to);
      };

      ctrl.normalizeWorkingHoursDay = function (dayKey) {
        if (!ctrl.form || !ctrl.form.time || !ctrl.form.time.working_hours) {
          return;
        }

        var wh = ctrl.form.time.working_hours;
        if (!wh.days) {
          return;
        }

        if (!Array.isArray(wh.days[dayKey]) || wh.days[dayKey].length === 0) {
          return;
        }

        wh.days[dayKey][0] = wh.days[dayKey][0] || {};
        var it = wh.days[dayKey][0];

        ctrl.ensureIntervalValid(it, 'from', 'to', '00:00');
      };

      ctrl.onDayPartsChange = function () {
        ctrl.normalizeDayParts();
      };

      ctrl.onWorkingHoursChange = function (dayKey) {
        ctrl.normalizeWorkingHoursDay(dayKey);
      };

      ctrl.workingDaysEnabled = { mon: true, tue: true, wed: true, thu: true, fri: true, sat: false, sun: false };
      ctrl.exceptionDate = undefined;

      ctrl.toneOptions = [
        { value: 'professional', label: 'AI_AGENT_TONE_PROFESSIONAL', name: $translate.instant('AI_AGENT_TONE_PROFESSIONAL') },
        { value: 'friendly', label: 'AI_AGENT_TONE_FRIENDLY', name: $translate.instant('AI_AGENT_TONE_FRIENDLY') },
        { value: 'warm', label: 'AI_AGENT_TONE_WARM', name: $translate.instant('AI_AGENT_TONE_WARM') },
        { value: 'concise', label: 'AI_AGENT_TONE_CONCISE', name: $translate.instant('AI_AGENT_TONE_CONCISE') },
        { value: 'formal', label: 'AI_AGENT_TONE_FORMAL', name: $translate.instant('AI_AGENT_TONE_FORMAL') }
      ];

      ctrl.sessionPolicyOptions = [
        { value: 'soft_reset', label: 'AI_AGENT_SESSION_POLICY_SOFT_RESET', name: $translate.instant('AI_AGENT_SESSION_POLICY_SOFT_RESET') },
        { value: 'hard_reset', label: 'AI_AGENT_SESSION_POLICY_HARD_RESET', name: $translate.instant('AI_AGENT_SESSION_POLICY_HARD_RESET') },
        { value: 'never_reset', label: 'AI_AGENT_SESSION_POLICY_NEVER_RESET', name: $translate.instant('AI_AGENT_SESSION_POLICY_NEVER_RESET') }
      ];

      ctrl.priceDisplayOptions = [
        { value: 'auto_by_locale', label: 'AI_AGENT_PRICE_DISPLAY_AUTO_BY_LOCALE', name: $translate.instant('AI_AGENT_PRICE_DISPLAY_AUTO_BY_LOCALE') },
        { value: 'symbol_before', label: 'AI_AGENT_PRICE_DISPLAY_SYMBOL_BEFORE', name: $translate.instant('AI_AGENT_PRICE_DISPLAY_SYMBOL_BEFORE') },
        { value: 'symbol_before_space', label: 'AI_AGENT_PRICE_DISPLAY_SYMBOL_BEFORE_SPACE', name: $translate.instant('AI_AGENT_PRICE_DISPLAY_SYMBOL_BEFORE_SPACE') },
        { value: 'code_after_space', label: 'AI_AGENT_PRICE_DISPLAY_CODE_AFTER_SPACE', name: $translate.instant('AI_AGENT_PRICE_DISPLAY_CODE_AFTER_SPACE') }
      ];

      ctrl.needsActivationKeywords = function () {
        var m = ctrl.form && ctrl.form.routing && ctrl.form.routing.activation ? ctrl.form.routing.activation.mode : 'immediate';
        return (m === 'keywords_only');
      };

      ctrl.needsBookingTriggerKeywords = function () {
        var m = ctrl.form && ctrl.form.booking && ctrl.form.booking.trigger ? ctrl.form.booking.trigger.mode : 'hybrid';
        return (m === 'keywords_only' || m === 'hybrid');
      };

      ctrl.splitCsv = function (text) {
        if (!text) {
          return [];
        }

        return text.split(',').map(function (s) {
          return (s || '').trim();
        }).filter(Boolean);
      };

      ctrl.normalizeModalities = function () {
        var g = ctrl.form && ctrl.form.general ? ctrl.form.general : null;
        if (!g) {
          return;
        }

        if (!Array.isArray(g.supported_modalities)) {
          g.supported_modalities = ['text'];
        }

        var map = {};
        g.supported_modalities = g.supported_modalities
          .map(function (m) {
            return (m || '').toLowerCase().trim();
          })
          .filter(function (m) {
            if (!m) {
              return false;
            }

            if (map[m]) {
              return false;
            }

            map[m] = true;
            return true;
          });

        if (g.supported_modalities.length === 0) {
          g.supported_modalities = ['text'];
        }

        g.default_modality = g.default_modality || g.supported_modalities[0];
        if (g.supported_modalities.indexOf(g.default_modality) === -1) {
          g.default_modality = g.supported_modalities[0];
        }
      };

      ctrl.hasModality = function (m) {
        var g = ctrl.form && ctrl.form.general ? ctrl.form.general : null;
        if (!g) {
          return false;
        }

        return (g.supported_modalities || []).indexOf(m) !== -1;
      };

      ctrl.toggleModality = function (m) {
        var g = ctrl.form && ctrl.form.general ? ctrl.form.general : null;
        if (!g) {
          return;
        }

        g.supported_modalities = g.supported_modalities || ['text'];
        var idx = g.supported_modalities.indexOf(m);

        if (idx === -1) {
          g.supported_modalities.push(m);
        } else {
          if (g.supported_modalities.length === 1) {
            return;
          }

          g.supported_modalities.splice(idx, 1);
        }

        ctrl.normalizeModalities();
      };

      ctrl.ensureDayInterval = function (obj, dayKey, fromDef, toDef) {
        if (!obj[dayKey] || !Array.isArray(obj[dayKey]) || obj[dayKey].length === 0) {
          obj[dayKey] = [{ from: fromDef, to: toDef }];
          return;
        }
        obj[dayKey][0] = obj[dayKey][0] || {};
        obj[dayKey][0].from = obj[dayKey][0].from || fromDef;
        obj[dayKey][0].to = obj[dayKey][0].to || toDef;
      };

      ctrl.syncWorkingDaysEnabledFromModel = function () {
        var wh = ctrl.form && ctrl.form.time && ctrl.form.time.working_hours ? ctrl.form.time.working_hours : null;
        if (!wh || wh.enabled === false) {
          return;
        }

        if (!wh.days) {
          return;
        }

        ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].forEach(function (d) {
          ctrl.workingDaysEnabled[d] = Array.isArray(wh.days[d]) && wh.days[d].length > 0;
        });
      };

      ctrl.applyWorkingDaysEnabledToModel = function () {
        var wh = ctrl.form.time.working_hours;
        wh.days = wh.days || {};

        var defFrom = '09:00';
        var defTo = '18:00';

        ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].forEach(function (d) {
          if (ctrl.workingDaysEnabled[d]) {
            ctrl.ensureDayInterval(wh.days, d, defFrom, defTo);
          } else {
            wh.days[d] = [];
          }
        });
      };

      ctrl.toIsoDate = function (v) {
        if (!v) {
          return null;
        }

        if (v && typeof v === 'object' && v._isAMomentObject && typeof v.format === 'function') {
          return v.format('YYYY-MM-DD');
        }

        if (v && typeof v === 'object' && typeof v.getFullYear === 'function') {
          var y = v.getFullYear();
          var m = String(v.getMonth() + 1).padStart(2, '0');
          var d = String(v.getDate()).padStart(2, '0');
          return y + '-' + m + '-' + d;
        }

        if (typeof v === 'string') {
          var s = v.trim();
          if (!s) {
            return null;
          }

          var m1 = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
          if (m1) {
            return s;
          }

          var m2 = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
          if (m2) {
            return m2[3] + '-' + m2[2] + '-' + m2[1];
          }

          var dt = new Date(s);
          if (!isNaN(dt.getTime())) {
            var yy = dt.getFullYear();
            var mm = String(dt.getMonth() + 1).padStart(2, '0');
            var dd = String(dt.getDate()).padStart(2, '0');
            return yy + '-' + mm + '-' + dd;
          }
        }

        return null;
      };

      ctrl.addExceptionDate = function () {
        if (!ctrl.form || !ctrl.form.time || !ctrl.form.time.working_hours) {
          return;
        }

        var wh = ctrl.form.time.working_hours;
        wh.exceptions = Array.isArray(wh.exceptions) ? wh.exceptions : [];

        var iso = ctrl.toIsoDate(ctrl.exceptionDate);
        if (!iso) {
          return;
        }

        if (wh.exceptions.indexOf(iso) === -1) {
          wh.exceptions.push(iso);

          wh.exceptions.sort(function (a, b) {
            return String(a).localeCompare(String(b));
          });
        }

        ctrl.exceptionDate = undefined;
      };

      ctrl.formatIsoToUiDate = function (iso) {
        if (!iso) {
          return '';
        }

        var m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!m) {
          return iso;
        }

        return m[3] + '-' + m[2] + '-' + m[1];
      };

      ctrl.removeExceptionDate = function (idx) {
        var wh = ctrl.form && ctrl.form.time && ctrl.form.time.working_hours ? ctrl.form.time.working_hours : null;
        if (!wh || !Array.isArray(wh.exceptions)) {
          return;
        }
        wh.exceptions.splice(idx, 1);
      };

      ctrl.ensureDefaults = function (f) {
        // GENERAL
        f.general = f.general || {};
        f.general.default_language = f.general.default_language || 'hb_ISR';
        f.general.tone = f.general.tone || 'friendly';
        f.general.currency = f.general.currency || 'ILS';
        f.general.price_display = f.general.price_display || 'auto_by_locale';

        if (f.general.price_precision === undefined || f.general.price_precision === null) {
          f.general.price_precision = '0';
        }

        f.general.default_channel = f.general.default_channel || 'whatsapp';
        f.general.supported_modalities = f.general.supported_modalities || ['text'];
        ctrl.normalizeModalities();

        if (f.general.session_idle_minutes === undefined || f.general.session_idle_minutes === null) {
          f.general.session_idle_minutes = 60;
        }

        f.general.session_policy = f.general.session_policy || 'soft_reset';

        // ROUTING
        f.routing = f.routing || {};
        f.routing.handoff_keywords = Array.isArray(f.routing.handoff_keywords) ? f.routing.handoff_keywords : [];

        f.routing.activation = f.routing.activation || {};
        if (!f.routing.activation.mode) {
          if (f.routing.activation_policy && f.routing.activation_policy.mode) {
            f.routing.activation.mode = f.routing.activation_policy.mode;
          } else {
            f.routing.activation.mode = 'immediate';
          }
        }

        if (!Array.isArray(f.routing.activation.keywords)) {
          f.routing.activation.keywords = [];
        }

        if (f.routing.activation.admin_silence_seconds === undefined || f.routing.activation.admin_silence_seconds === null) {
          if (f.routing.activation_policy && f.routing.activation_policy.admin_silence_seconds !== undefined && f.routing.activation_policy.admin_silence_seconds !== null) {
            f.routing.activation.admin_silence_seconds = f.routing.activation_policy.admin_silence_seconds;
          } else {
            f.routing.activation.admin_silence_seconds = 120;
          }
        }

        if (f.routing.activation.only_if_last_message_from_customer === undefined) {
          if (f.routing.activation_policy && f.routing.activation_policy.only_if_last_message_from_customer !== undefined) {
            f.routing.activation.only_if_last_message_from_customer = !!f.routing.activation_policy.only_if_last_message_from_customer;
          } else {
            f.routing.activation.only_if_last_message_from_customer = true;
          }
        }

        f.routing.handoff_policy = f.routing.handoff_policy || {};
        f.routing.handoff_policy.on_customer_request = ctrl.coerceBool(f.routing.handoff_policy.on_customer_request, true);
        f.routing.handoff_policy.on_low_confidence = ctrl.coerceBool(f.routing.handoff_policy.on_low_confidence, true);
        f.routing.handoff_policy.on_repeated_no_progress = ctrl.coerceBool(f.routing.handoff_policy.on_repeated_no_progress, true);

        // BOOKING trigger (NEW, but with backward compat from routing.trigger_mode/trigger_keywords)
        f.booking = f.booking || {};
        f.booking.trigger = f.booking.trigger || {};

        if (!f.booking.trigger.mode) {
          if (f.routing && f.routing.trigger_mode) {
            f.booking.trigger.mode = f.routing.trigger_mode;
          } else {
            f.booking.trigger.mode = 'hybrid';
          }
        }

        if (!Array.isArray(f.booking.trigger.keywords)) {
          if (f.routing && Array.isArray(f.routing.trigger_keywords)) {
            f.booking.trigger.keywords = f.routing.trigger_keywords;
          } else {
            f.booking.trigger.keywords = [];
          }
        }

        // BOOKING
        f.booking = f.booking || {};
        if (f.booking.suggested_slots_count === undefined || f.booking.suggested_slots_count === null) {
          f.booking.suggested_slots_count = 3;
        }

        if (f.booking.slot_search_window_hours === undefined || f.booking.slot_search_window_hours === null) {
          f.booking.slot_search_window_hours = 72;
        }

        f.booking.employee_auto_pick_strategy = f.booking.employee_auto_pick_strategy || 'ask_user';

        f.booking.overrides = f.booking.overrides || {};
        if (f.booking.overrides.allow_online_booking === undefined || f.booking.overrides.allow_online_booking === null) {
          f.booking.overrides.allow_online_booking = 2;
        }

        if (f.booking.overrides.closest_time === undefined || f.booking.overrides.closest_time === null) {
          f.booking.overrides.closest_time = 0;
        }

        if (f.booking.overrides.latest_time === undefined || f.booking.overrides.latest_time === null) {
          f.booking.overrides.latest_time = 30;
        }

        if (f.booking.overrides.allow_update === undefined || f.booking.overrides.allow_update === null) {
          f.booking.overrides.allow_update = 1;
        }

        if (f.booking.overrides.update_hours === undefined || f.booking.overrides.update_hours === null) {
          f.booking.overrides.update_hours = 0;
        }

        if (f.booking.overrides.allow_cancel === undefined || f.booking.overrides.allow_cancel === null) {
          f.booking.overrides.allow_cancel = 1;
        }

        if (f.booking.overrides.cancel_hours === undefined || f.booking.overrides.cancel_hours === null) {
          f.booking.overrides.cancel_hours = 0;
        }

        if (f.booking.overrides.display_price === undefined || f.booking.overrides.display_price === null) {
          f.booking.overrides.display_price = 1;
        }

        if (f.booking.overrides.display_duration === undefined || f.booking.overrides.display_duration === null) {
          f.booking.overrides.display_duration = 1;
        }

        // TIME
        f.time = f.time || {};
        f.time.timezone = f.time.timezone || 'Asia/Jerusalem';
        f.time.date_format = f.time.date_format || 'DD.MM.YYYY';
        f.time.time_format = f.time.time_format || 'HH:mm';
        f.time.week_start = f.time.week_start || 'sunday';

        f.time.outside_working_hours = f.time.outside_working_hours || {};
        f.time.outside_working_hours.mode = f.time.outside_working_hours.mode || 'suggest_next_time';

        f.time.day_parts = f.time.day_parts || {};
        f.time.day_parts.morning = f.time.day_parts.morning || { from: '09:00', to: '12:00' };
        f.time.day_parts.day = f.time.day_parts.day || { from: '12:00', to: '17:00' };
        f.time.day_parts.evening = f.time.day_parts.evening || { from: '17:00', to: '21:00' };

        f.time.working_hours = f.time.working_hours || {};
        if (f.time.working_hours.enabled === undefined) {
          f.time.working_hours.enabled = true;
        }

        f.time.working_hours.days = f.time.working_hours.days || {};
        f.time.working_hours.exceptions = Array.isArray(f.time.working_hours.exceptions) ? f.time.working_hours.exceptions : [];

        ctrl.ensureDayInterval(f.time.working_hours.days, 'mon', '09:00', '18:00');
        ctrl.ensureDayInterval(f.time.working_hours.days, 'tue', '09:00', '18:00');
        ctrl.ensureDayInterval(f.time.working_hours.days, 'wed', '09:00', '18:00');
        ctrl.ensureDayInterval(f.time.working_hours.days, 'thu', '09:00', '18:00');
        ctrl.ensureDayInterval(f.time.working_hours.days, 'fri', '09:00', '18:00');
        if (!Array.isArray(f.time.working_hours.days.sat)) {
          f.time.working_hours.days.sat = [];
        }

        if (!Array.isArray(f.time.working_hours.days.sun)) {
          f.time.working_hours.days.sun = [];
        }

        if (!ctrl.timeOptions || ctrl.timeOptions.length === 0) {
          ctrl.buildTimeOptions();
        }
        ctrl.normalizeDayParts();

        // KB
        f.kb = f.kb || {};
        if (f.kb.enabled === undefined) {
          f.kb.enabled = true;
        }
        f.kb.strict_mode = f.kb.strict_mode || 'kb_only_strict';
        f.kb.faq = Array.isArray(f.kb.faq) ? f.kb.faq : [];

        // CUSTOMER INFO
        f.customer_info = f.customer_info || {};
        if (f.customer_info.enabled === undefined) {
          f.customer_info.enabled = false;
        }

        f.customer_info.allowed = f.customer_info.allowed || {};
        var allowed = {};
        var known = ctrl.customerInfoQueryOptionsMap();

        var hasAny = false;
        Object.keys(f.customer_info.allowed).forEach(function (k) {
          f.customer_info.allowed[k] = ctrl.coerceBool(f.customer_info.allowed[k], null);
          if (f.customer_info.allowed[k] === true || f.customer_info.allowed[k] === false) {
            hasAny = true;
          }
        });

        Object.keys(known).forEach(function (k) {
          f.customer_info.allowed[k] = ctrl.coerceBool(f.customer_info.allowed[k], null);
          if (f.customer_info.allowed[k] === true || f.customer_info.allowed[k] === false) {
            allowed[k] = !!f.customer_info.allowed[k];
          } else {
            allowed[k] = (f.customer_info.enabled === true && hasAny === false) ? true : false;
          }
        });
        f.customer_info.allowed = allowed;

        // MESSAGES
        if (f.messages === undefined || f.messages === null) {
          f.messages = {};
        }

        var msgKeys = [
          'out_of_scope',
          'kb_no_answer',
          'kb_handoff_offer',
          'welcome',
          'need_more_info',
          'ask_service',
          'ask_date_time',
          'ask_employee',
          'confirm_booking',
          'booking_created',
          'booking_updated',
          'booking_cancelled',
          'booking_action_failed',
          'no_slots_found',
          'outside_working_hours',
          'handoff'
        ];

        msgKeys.forEach(function (k) {
          if (f.messages[k] === undefined || f.messages[k] === null) {
            f.messages[k] = '';
          }
        });
      };

      ctrl.onKbPdfSelected = function () {};
      ctrl.deleteKbFile = function () {};
      
      ctrl.coerceBool = function (v, def) {
        if (v === true || v === 1 || v === '1') {
          return true;
        }

        if (v === false || v === 0 || v === '0') {
          return false;
        }

        return !!def;
      };

      // =========================
      // Init
      // =========================
      ctrl.init = function () {
        var raw = null;

        if (ctrl.settingsRow && ctrl.settingsRow.settings_json !== undefined) {
          raw = ctrl.settingsRow.settings_json;
          ctrl.inheritOnlineBooking = (ctrl.settingsRow.inherit_online_booking === true || ctrl.settingsRow.inherit_online_booking === 1 || ctrl.settingsRow.inherit_online_booking === '1');
        }

        ctrl.form = ctrl.safeParseJson(raw) || {};
        if (ctrl.form && ctrl.form.kb) {
          ctrl.form.kb.enabled = (ctrl.form.kb.enabled === true || ctrl.form.kb.enabled === 1 || ctrl.form.kb.enabled === '1');
        }
        ctrl.ensureDefaults(ctrl.form);

        if (ctrl.form && ctrl.form.routing && ctrl.form.routing.activation) {
          var activation = ctrl.form.routing.activation;
          activation.only_if_last_message_from_customer = (activation.only_if_last_message_from_customer === true || activation.only_if_last_message_from_customer === 1 || activation.only_if_last_message_from_customer === '1');
        }

        if (ctrl.form && ctrl.form.routing && ctrl.form.routing.handoff_policy) {
          var hp = ctrl.form.routing.handoff_policy;
          hp.on_customer_request = (hp.on_customer_request === true || hp.on_customer_request === 1 || hp.on_customer_request === '1');
          hp.on_low_confidence = (hp.on_low_confidence === true || hp.on_low_confidence === 1 || hp.on_low_confidence === '1');
          hp.on_repeated_no_progress = (hp.on_repeated_no_progress === true || hp.on_repeated_no_progress === 1 || hp.on_repeated_no_progress === '1');
        }

        if (ctrl.form && ctrl.form.time && ctrl.form.time.working_hours) {
          ctrl.form.time.working_hours.enabled = (ctrl.form.time.working_hours.enabled === true || ctrl.form.time.working_hours.enabled === 1 || ctrl.form.time.working_hours.enabled === '1');
        }

        if (ctrl.form && ctrl.form.customer_info && ctrl.form.customer_info.enabled) {
          ctrl.form.customer_info.enabled = (ctrl.form.customer_info.enabled === true || ctrl.form.customer_info.enabled === 1 || ctrl.form.customer_info.enabled === '1');
        }

        ctrl.faqItems = ctrl.form.kb.faq;

        ctrl.buildBusinessBookingUi();
        ctrl.buildOverridesUi();
        ctrl.syncDisplayedBookingUi();

        ctrl.buildTimeOptions();
        ctrl.normalizeDayParts();

        ctrl.activationKeywordsText = ((ctrl.form.routing.activation && ctrl.form.routing.activation.keywords) || []).join(', ');
        ctrl.bookingTriggerKeywordsText = ((ctrl.form.booking.trigger && ctrl.form.booking.trigger.keywords) || []).join(', ');
        ctrl.handoffKeywordsText = (ctrl.form.routing.handoff_keywords || []).join(', ');

        ctrl.syncWorkingDaysEnabledFromModel();
      };

      $scope.$watch(function () { return ctrl.inheritOnlineBooking; }, function (v, prev) {
        if (v === prev) {
          return;
        }

        ctrl.buildBusinessBookingUi();
        ctrl.syncDisplayedBookingUi();
      });

      $scope.$watch(function () {
        return ctrl.form && ctrl.form.customer_info ? ctrl.form.customer_info.enabled : false;
      }, function (enabled, prev) {
        if (!ctrl.form) {
          return;
        }

        if (enabled === prev) {
          return;
        }

        ctrl.form.customer_info = ctrl.form.customer_info || {};
        ctrl.form.customer_info.allowed = ctrl.form.customer_info.allowed || {};

        if (enabled === true) {
          var any = false;
          Object.keys(ctrl.form.customer_info.allowed).forEach(function (k) {
            if (ctrl.form.customer_info.allowed[k] === true || ctrl.form.customer_info.allowed[k] === false) {
              any = true;
            }
          });
          if (!any) {
            ctrl.customerInfoAllowAll();
          }
        }
      });

      ctrl.getSettingsSchemaV1 = function () {
        return {
          general: {
            default_language: 'string',
            tone: 'string',
            currency: 'string',
            price_display: 'string',
            price_precision: 'string',
            default_channel: 'string',
            supported_modalities: ['string'],
            default_modality: 'string',
            session_idle_minutes: 'number',
            session_policy: 'string'
          },

          routing: {
            activation: {
              mode: 'string',
              keywords: ['string'],
              admin_silence_seconds: 'number',
              only_if_last_message_from_customer: 'boolean'
            },
            handoff_keywords: ['string'],
            handoff_policy: {
              on_customer_request: 'boolean',
              on_low_confidence: 'boolean',
              on_repeated_no_progress: 'boolean',
              max_no_progress_turns: 'number'
            },
            fallback_behavior: {
              mode: 'string',
              max_clarify_turns: 'number',
              then: 'string'
            }
          },

          booking: {
            trigger: {
              mode: 'string',
              keywords: ['string']
            },
            suggested_slots_count: 'number',
            slot_search_window_hours: 'number',
            employee_auto_pick_strategy: 'string',
            overrides: {
              allow_online_booking: 'number',
              closest_time: true,
              latest_time: 'number',
              allow_update: 'number',
              update_hours: true,
              allow_cancel: 'number',
              cancel_hours: true,
              display_price: 'number',
              display_duration: 'number'
            }
          },

          time: {
            timezone: 'string',
            date_format: 'string',
            time_format: 'string',
            week_start: 'string',
            outside_working_hours: {
              mode: 'string'
            },
            day_parts: {
              morning: { from: 'string', to: 'string' },
              day: { from: 'string', to: 'string' },
              evening: { from: 'string', to: 'string' }
            },
            working_hours: {
              enabled: 'boolean',
              days: true,
              exceptions: ['string']
            }
          },

          kb: {
            enabled: 'boolean',
            strict_mode: 'string',
            faq: [{
              id: true,
              question: 'string',
              answer: 'string'
            }]
          },

          customer_info: {
            enabled: 'boolean',
            allowed: true
          },

          messages: {
            out_of_scope: 'string',
            kb_no_answer: 'string',
            kb_handoff_offer: 'string',
            welcome: 'string',
            need_more_info: 'string',
            ask_service: 'string',
            ask_date_time: 'string',
            ask_employee: 'string',
            confirm_booking: 'string',
            booking_created: 'string',
            booking_updated: 'string',
            booking_cancelled: 'string',
            booking_action_failed: 'string',
            no_slots_found: 'string',
            outside_working_hours: 'string',
            handoff: 'string'
          }
        };
      };

      ctrl.submit = function () {
        ctrl.saving = true;

        // activation keywords
        ctrl.form.routing.activation = ctrl.form.routing.activation || {};
        ctrl.form.routing.activation.keywords = ctrl.splitCsv(ctrl.activationKeywordsText);

        // booking trigger keywords
        ctrl.form.booking = ctrl.form.booking || {};
        ctrl.form.booking.trigger = ctrl.form.booking.trigger || {};
        ctrl.form.booking.trigger.keywords = ctrl.splitCsv(ctrl.bookingTriggerKeywordsText);

        // handoff keywords
        ctrl.form.routing.handoff_keywords = ctrl.splitCsv(ctrl.handoffKeywordsText);

        // cleanup by modes
        if (!ctrl.needsActivationKeywords()) {
          ctrl.form.routing.activation.keywords = [];
        }

        if (!ctrl.needsBookingTriggerKeywords()) {
          ctrl.form.booking.trigger.keywords = [];
        }

        if (ctrl.form.time && ctrl.form.time.working_hours && ctrl.form.time.working_hours.enabled) {
          ctrl.applyWorkingDaysEnabledToModel();
        }

        if (ctrl.form.booking) {
          ctrl.form.booking.suggested_slots_count = parseInt(ctrl.form.booking.suggested_slots_count, 10);
          if (isNaN(ctrl.form.booking.suggested_slots_count) || ctrl.form.booking.suggested_slots_count < 1) {
            ctrl.form.booking.suggested_slots_count = 3;
          }

          ctrl.form.booking.slot_search_window_hours = parseInt(ctrl.form.booking.slot_search_window_hours, 10);
          if (isNaN(ctrl.form.booking.slot_search_window_hours) || ctrl.form.booking.slot_search_window_hours < 1) {
            ctrl.form.booking.slot_search_window_hours = 72;
          }

          ctrl.form.booking.employee_auto_pick_strategy = ctrl.form.booking.employee_auto_pick_strategy || 'ask_user';
        }

        ctrl.form.booking = ctrl.form.booking || {};
        
        var def = ctrl.getBookingDefaults();
        ctrl.form.booking.overrides = ctrl.sanitizeBookingOverrides(ctrl.overridesUi || {}, def);

        ['mon','tue','wed','thu','fri','sat','sun'].forEach(function(d){
          ctrl.normalizeWorkingHoursDay(d);
        });

        if (ctrl.form && ctrl.form.kb) {
          ctrl.form.kb.faq = (ctrl.form.kb.faq || [])
            .map(function (it) {
              return {
                id: it.id,
                question: (it.question || '').trim(),
                answer: (it.answer || '').trim()
              };
            })
            .filter(function (it) {
              return it.question && it.answer;
            });
        }

        // legacy cleanup (optional)
        if (ctrl.form.routing) {
          ctrl.form.routing.trigger_mode = undefined;
          ctrl.form.routing.trigger_keywords = undefined;
          ctrl.form.routing.activation_policy = undefined;
        }

        var cleanSettings = ctrl.pruneBySchema(ctrl.form, ctrl.getSettingsSchemaV1());

        cleanSettings.booking = cleanSettings.booking || {};
        cleanSettings.booking.overrides = angular.copy(ctrl.overridesUi || {});

        cleanSettings.routing = cleanSettings.routing || {};
        cleanSettings.routing.activation = cleanSettings.routing.activation || {};
        cleanSettings.routing.activation.keywords = ctrl.splitCsv(ctrl.activationKeywordsText);

        cleanSettings.booking = cleanSettings.booking || {};
        cleanSettings.booking.trigger = cleanSettings.booking.trigger || {};
        cleanSettings.booking.trigger.keywords = ctrl.splitCsv(ctrl.bookingTriggerKeywordsText);

        cleanSettings.routing.handoff_keywords = ctrl.splitCsv(ctrl.handoffKeywordsText);

        if (!ctrl.needsActivationKeywords()) {
          cleanSettings.routing.activation.keywords = [];
        }
        if (!ctrl.needsBookingTriggerKeywords()) {
          cleanSettings.booking.trigger.keywords = [];
        }

        ctrl.form = cleanSettings;

        var payload = {
          agent_id: ctrl.agent.id,
          agent: {
            name: ctrl.agent.name,
            status: parseInt(ctrl.agent.status, 10)
          },
          inherit_online_booking: !!ctrl.inheritOnlineBooking,
          settings_json: ctrl.form
        };

        $api.ai_booking_agent.agent.save(payload, function (response) {
          if (response.success) {
            if (response.data.error) {
              swal({
                title: response.error,
                text: "",
                type: "error",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
            } else {
              swal({
                title: $translate.instant('AI_AGENT_SETTINGS_SAVED_SUCCESS'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });

              if (response.kb && Array.isArray(response.kb.faq)) {
                ctrl.form = ctrl.form || {};
                ctrl.form.kb = ctrl.form.kb || {};

                ctrl.form.kb.faq = response.kb.faq;
                ctrl.faqItems = ctrl.form.kb.faq;

                if (typeof ctrl.resetFaqDraft === 'function') {
                  ctrl.resetFaqDraft();
                } else {
                  ctrl.faqDraft = { id: null, question: '', answer: '' };
                  ctrl.faqEditing = false;
                }
              }
            }
          }

          ctrl.saving = false;
        }, function() {
          ctrl.saving = false;
        });
      };

      ctrl.init();

      $scope.uploadFile = function (element) {
        var file = element.files && element.files[0];
        if (!file) {
          return;
        }

        var allowedExtensions = ['pdf'];
        var allowedMimeTypes = [
          'application/pdf'
        ];

        var name = file.name || '';
        var ext = name.split('.').pop().toLowerCase();
        var mime = file.type || '';
        var maxSize = 20 * 1024 * 1024;

        if (allowedExtensions.indexOf(ext) === -1 || allowedMimeTypes.indexOf(mime) === -1) {
          swal({
            title: "{{'ADMIN_AI_UPLOAD_FILE_TYPE_NOT_ALLOWED' | translate}}",
            type: "error",
            timer: 3000
          });
          element.value = '';
          return;
        }

        if (!file.size || file.size > maxSize) {
          swal({
            title: "{{'ADMIN_AI_UPLOAD_FILE_SIZE_ERROR' | translate}}",
            type: "error",
            timer: 3000
          });
          element.value = '';
          return;
        }

        ctrl.kbLoading = true;
        ctrl.kbUploading = true;

        var fdata = new FormData();
        fdata.append('file', file);

        $resource($api.baseURL + '/bookingagent/action/upload', {}, {
          postWithFile: {
            method: "POST",
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
          }
        }).postWithFile(fdata).$promise.then(function (response) {
          element.value = '';

          if (response) {
            if (response.success) {
              if (response.data && response.data.kb && response.data.kb.files) {
                ctrl.kbFiles = response.data.kb.files;
              }
            } else {
              swal({
                title: response.data,
                type: "error",
                timer: 3000
              });
            }

            ctrl.kbLoading = false;
            ctrl.kbUploading = false;
          }
        }, function (error) {
          element.value = '';
          console.log(error);
          ctrl.kbLoading = false;
          ctrl.kbUploading = false;

          if (error.data && error.data.data && error.data.data.error) {
            swal({
              title: error.data.data.error,
              type: "error",
              timer: 3000
            });
          }
        });
      };

      ctrl.confirmDeleteFile = function (file) {
        if (!file || !file.id) {
          return;
        }

        swal({
          title: $translate.instant('ADMIN_AI_DELETE_CONFIRM'),
          html: '<b>' + (file.original_name || '') + '</b><br />' + $translate.instant('ADMIN_AI_DELETE_CONFIRM_DESCRIPTION'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
          closeOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            ctrl.deleteFile(file.id);
          }
        });
      };

      ctrl.deleteFile = function (fileId) {
        $api.ai_booking_agent.remove.save({ fileId: fileId }, function (response) {
          if (response.success) {
            if (response.data && response.data.kb && response.data.kb.files) {
              ctrl.kbFiles = response.data.kb.files;
            }
          }
        }, function (error) {
          console.log(error);
        });
      };

      ctrl.getTooltip = function (file) {
        switch (file.pipeline_status) {
          case 'new':
            return $translate.instant('ADMIN_AI_KB_FILE_TOOLTIP_NEW');
          case 'error':
            return $translate.instant('ADMIN_AI_KB_FILE_TOOLTIP_ERROR');
          case 'done':
            return $translate.instant('ADMIN_AI_KB_FILE_TOOLTIP_DONE');
          default:
            return $translate.instant('ADMIN_AI_KB_FILE_TOOLTIP_PENDING');
        }
      };
    });

})();
(function () {
  angular.module('app.controllers')
    .controller('AiAgentsListController', function ($state, $header, $rootScope, Info) {
      if ($rootScope.userRole === 1) {
        $state.go('app.admin', {}, { reload: true });
        return;
      }

      $header.breadcrumbs.push({
        title: 'SETTINGS_AI_AGENTS'
      });

      var ctrl = this;
      ctrl.enabledAgents = [];

      var settings = Info && Info.data ? Info.data : {};
      var aiAgentBooking = settings.ai_agent_booking === 1 ||
        settings.ai_agent_booking === '1' ||
        settings.ai_agent_booking === true;

      if (aiAgentBooking) {
        ctrl.enabledAgents.push({
          id: 'agent_booking',
          name: 'AI_AGENT_ONLINE_BOOKING',
          description: 'AI_AGENT_ONLINE_BOOKING_DESCRIPTION',
          state: 'app.settings.ai_agents.agent_booking',
          icon: 'las la-calendar'
        });
      }

      if (ctrl.enabledAgents.length === 0) {
        $state.go('app.settings');
      }
    });
})();

(function () {

    angular.module('app.controllers')

        .controller('AdditionalFieldsSettingsController', function ($state, $header, $rootScope, $customFields, CustomFields) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.breadcrumbs.push({
                "title": 'SETTINGS_ADDITIONAL_FIELDS'
            });
            
            var ctrl = this;
            ctrl.customFields = CustomFields ? CustomFields.data : [];
            for (var i = 0; i < ctrl.customFields.length; i++) {
                ctrl.customFields[i].name = $customFields.getCurrentName(ctrl.customFields[i].name);
            }
        });

})();

(function () {

    angular.module('app.controllers')

        .controller('AccountingSettingsController', function ($state, $header, $rootScope) {

            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "הגדרות חשבונאות";
            $header.breadcrumbs.push({
                "title": "NAV_SETTINGS",
                "state": "app.settings"
            });
            $header.breadcrumbs.push({
                "title": "ACCOUNTING_SETTINGS"
            });
        });

})();

(function () {

    angular.module('app.controllers')

        .controller('TaxFilesReportsController', function ($state, $header, $scope, $api, $rootScope, $window) {

            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            var ctrl = this;

            ctrl.form = {
                from: '',
                to: '',
            }

            ctrl.submit = function () {
                $api.settings.tax_files.save(ctrl.form, function (response) {
                    ctrl.check();
                });
            }

            ctrl.check = function () {
                $api.settings.tax_files_check.save(ctrl.form, function (response) {

                    if (response.data && response.data.status && response.data.status == 2) {
                        if (response.data.zip_link) {
                            $scope.downloadFile(response.data.zip_link);
                        }
                    } else {
                        setTimeout(function() { ctrl.check(); }, 1000);
                    }
                });
            }

            $scope.downloadFile = function(link) {
                $window.open('/back-end/'+link, '_blank');
            };

        });
})();

(function () {
    angular.module('app.controllers')
        .controller('DebtRemindController', function ($window, $header, $api, $scope, $state, $rootScope, $uibModalInstance, $uibModal, $translate, customerData, Messages) {

            var ctrl = this;

            ctrl.customer = customerData;
            var debtSum = ctrl.customer.oncredit || 0;
            var businessName = ctrl.customer.businesses_name || '';
            var debtReminderTemplate = Messages && Messages.data && Messages.data.debt_reminder
                ? Messages.data.debt_reminder
                : '';

            var replaceTemplateVars = function (template) {
                if (!template) {
                    return '';
                }

                var normalizedSum = String(debtSum);
                return String(template)
                    .replace(/\[sum\]/g, normalizedSum)
                    .replace(/\[סְכוּם\]/g, normalizedSum)
                    .replace(/\[סכום\]/g, normalizedSum)
                    .replace(/\[name of the business\]/g, businessName)
                    .replace(/\[שם בית העסק\]/g, businessName);
            };

            ctrl.form = {
                send_method: 1,
                message: replaceTemplateVars(debtReminderTemplate) || ($translate.instant('REMIND_DEBT_MSG') + ' ' + debtSum + '₪. ' + businessName),
            };

            if (customerData.send_notifications && customerData.send_notifications != 0) {
                ctrl.form.send_method = customerData.send_notifications;
            }

            /**
             * Send message to API
             */
            ctrl.sendReminder = function() {
                switch (parseInt(ctrl.form.send_method)) {
                    case 1:
                        ctrl._sendEmail();
                        break;
                    case 2:
                        ctrl._sendSMS();
                        break;
                    case 3:
                        ctrl._sendWhatsApp();
                        break;
                }
            }

            /**
             * Send SMS
             * @private
             */
            ctrl._sendSMS = function() {
                $api.sms.save({
                    message: ctrl.form.message,
                    phone: ctrl.customer.phone
                }, function(response){
                    ctrl._showSendingResult(response);
                });
            }

            /**
             * Send message through WhatsApp
             * @private
             */
            ctrl._sendWhatsApp = function() {
                $api.whatsapp.save({
                    message: ctrl.form.message,
                    phone: ctrl.customer.phone
                }, function(response){
                    ctrl._showSendingResult(response);
                });
            }

            /**
             * Send message through Email
             * @private
             */
            ctrl._sendEmail = function() {
                $api.mails.save({
                    subject: $translate.instant('REMIND_DEBT_EMAIL_SUBJ'),
                    message: ctrl.form.message,
                    email_address: ctrl.customer.email
                }, function(response){
                    ctrl._showSendingResult(response);
                });
            }

            /**
             * Notify user if message was sent successfully
             * @param response
             * @private
             */
            ctrl._showSendingResult = function(response) {
                if(response.status == "success" && !response.error) {
                    swal({
                        title: $translate.instant('REMIND_DEBT_MSG_SUCCESS'),
                        type: "success",
                        confirmButtonText: $translate.instant('SETTINGS_INFO_SEND'),
                        timer: 2000
                    }).then(function () {
                        $uibModalInstance.close();
                    });
                } else {
                    swal({
                        title: $translate.instant('REMIND_DEBT_MSG_ERROR'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SETTINGS_INFO_SEND'),
                        timer: 2000
                    }).then(function () {
                        $uibModalInstance.close();
                    });
                }
            }
        });
})();

(function () {
    angular.module('app.controllers')
        .controller('RecommendationsController', function ($header, Recommendations, $api, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $state, $rootScope, $translate, $timeout, $cookies) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.title = "MARKETING_RECOMMENDATIONS";
            $header.breadcrumbs.push({
                "title": "MARKETING_RECOMMENDATIONS"
            });

            var ctrl = this;

            ctrl.tableData = Recommendations.data;

            ctrl.send = function(id){
                $api.automations.recommendations.send.get({id: id}, function(response){
                    if(response.status == "success") {
                        swal({
                            title: $translate.instant('SWAL_RECOMMENDATIONS_SEND_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                        });

                        $state.go($state.current, {}, {reload: true});
                    }
                });
            }

            ctrl.delete = function(id){
                swal({
                    title: "",
                    text: $translate.instant('SWAL_RECOMMENDATION_DELETE_CONFIRM_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value) {
                        $api.automations.recommendations.single.delete({id: id}, function(response){
                            if(response.status == "success") {
                                swal({
                                    title: $translate.instant('SWAL_RECOMMENDATION_DELETE_TITLE'),
                                    text: "",
                                    type: "success",
                                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                    timer: 2000
                                });
                                
                                $state.go($state.current, {}, {reload: true});
                            }
                        });
                    }
                });
            }



            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    .withOption('aaSorting', [])
                    .withOption('columnDefs', [
                        { targets: [-1, -2], orderable: false } // Disabling sorting for the last two columns
                    ])
                    .withOption('searching', false);

        });
})();

(function () {
    angular.module('app.controllers')
        .controller('AutomationsController', function ($header, Automations, $api, $scope, DTOptionsBuilder, dataTablesHebrewProvider, $state, $rootScope, $translate, $timeout, $cookies) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.title = "MARKETING_AUTOMATIONS";
            $header.breadcrumbs.push({
                "title": "MARKETING_AUTOMATIONS"
            });

            var ctrl = this;

            ctrl.tableData = Automations.data;

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                .withLanguage(dataTablesHebrewProvider)
                .withOption('pageLength', 100)
                .withOption('aaSorting', [])
                .withOption('searching', false);

            ctrl.updateActive = function(row){
                $api.automations.activations.save({id: row.id}, {active: row.active}, function(response){
                    if(response.status != "success") {
                        row.active = !row.active;
                    }
                });
                
            }

        });
})();

(function() {
  angular.module("app.controllers").controller("CustomersBookingsWaitingListAddController", function($scope, $timeout, $translate, $api, dates, Items, Resources, WaitingList) {
    var ctrl = this;
    ctrl.searchCustomerResult = [];
    ctrl.customer_search_name = "";
    ctrl.customer_selected_name = "";
    ctrl.isChoosingCustomer = false;
    ctrl.resources = Resources && Resources.data ? Resources.data.filter(function(resource) {
      return resource.status != 0;
    }) : [];
    ctrl.items = Items && Items.data ? Items.data : [];
    ctrl.serviceItems = ctrl.items.filter(function(item) {
      return item.item_type == 'service';
    }).map(function(item) {
      return {
        id: String(item.id),
        name: item.name + ' (' + formatDuration(item.duration) + ')'
      };
    });
    ctrl.isLoading = false;
    ctrl.today = new Date();
    ctrl.dates = dates;
    ctrl.userConfig = {
      maxItems: 1,
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      create: false
    };

    function formatDuration(duration) {
      for (var i in dates.duration) {
        if (dates.duration[i].duration == duration) {
          return dates.duration[i].label;
        }
      }

      return duration;
    }

    ctrl.form = {
      customer_id: null,
      customer: null,
      item_id: null,
      resource_id: "",
      date: ctrl.today,
      start_time: null,
      end_time: null
    };

    for (var i in ctrl.items) {
      ctrl.items[i].originalPrice = ctrl.items[i].price;
      ctrl.items[i].price = parseFloat(parseFloat(ctrl.items[i].price).toFixed(2));
      ctrl.items[i].quantity = 1;
    }
    if (WaitingList && WaitingList.data) {
      var waitingData = WaitingList.data;
      var fromMoment = waitingData.from ? moment(waitingData.from) : null;
      var toMoment = waitingData.to ? moment(waitingData.to) : null;

      ctrl.form.customer_id = String(waitingData.customer_id || null);
      ctrl.form.item_id = String(waitingData.item_id || null);
      ctrl.form.resource_id = waitingData.resource_id ? waitingData.resource_id.toString() : "";
      ctrl.form.date = fromMoment && fromMoment.isValid() ? fromMoment.toDate() : ctrl.today;
      ctrl.form.start_time = fromMoment && fromMoment.isValid() ? fromMoment.format('HH:mm') : null;
      ctrl.form.end_time = toMoment && toMoment.isValid() ? toMoment.format('HH:mm') : null;
      
      
      ctrl.form.customer_id = waitingData.customer_id || null;
      ctrl.form.customer = { id: waitingData.customer_id || null };
      ctrl.customer_selected_name = waitingData.name || '';
      ctrl.customer_search_name = ctrl.customer_selected_name;
    }

    ctrl.find_customer = function() {
      if (!ctrl.customer_search_name) {
        ctrl.form.customer_id = null;
        ctrl.form.customer = null;
        ctrl.searchCustomerResult = [];
        return;
      }
      if (ctrl.customer_search_name !== ctrl.customer_selected_name) {
        ctrl.form.customer_id = null;
        ctrl.form.customer = null;
      }

      $api.customers.find.get({str: ctrl.customer_search_name, limit: 20}, function(response) {
        if (response.str == ctrl.customer_search_name) {
          ctrl.searchCustomerResult = response.data || [];
        }
      });
    };

    ctrl.chooseCustomer = function(index, $event) {
      var customer = ctrl.searchCustomerResult[index];
      ctrl.form.customer_id = customer.id;
      ctrl.form.customer = customer;
      ctrl.customer_selected_name = ((customer.firstname || '') + ' ' + (customer.lastname || '')).trim();
      ctrl.customer_search_name = ctrl.customer_selected_name;
      ctrl.searchCustomerResult = [];
      ctrl.isChoosingCustomer = false;
      if ($event) {
        $event.stopPropagation();
      }
    };

    ctrl.startChooseCustomer = function() {
      ctrl.isChoosingCustomer = true;
    };

    ctrl.cleanCustomerSearch = function() {
      if (ctrl.isChoosingCustomer) {
        $timeout(function() {
          ctrl.isChoosingCustomer = false;
        }, 0);
        return;
      }
      ctrl.customer_search_name = ctrl.customer_selected_name;
      $timeout(function() {
        ctrl.searchCustomerResult = [];
      }, 200);
    };

    ctrl.combineDateTime = function(timeStr, dateObj) {
      if (!timeStr || !dateObj) return null;
      return moment(dateObj).format('YYYY-MM-DD') + ' ' + timeStr + ':00';
    };

    ctrl.submit = function() {
      if (!ctrl.form.customer_id || !ctrl.form.item_id) {
        swal({
          text: $translate.instant('ERROR'),
          type: "error",
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
        });
        return;
      }

      var from = ctrl.combineDateTime(ctrl.form.start_time, ctrl.form.date);
      var to = ctrl.combineDateTime(ctrl.form.end_time, ctrl.form.date);

      if (!from || !to) {
        swal({
          text: $translate.instant('ERROR'),
          type: "error",
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
        });
        return;
      }
      if (moment(to).isSameOrBefore(moment(from))) {
        swal({
          text: $translate.instant('ERROR'),
          type: "error",
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
        });
        return;
      }

      ctrl.isLoading = true;
      $api.orders.add_waiting_list.save({
        id: WaitingList && WaitingList.data ? WaitingList.data.id : null,
        action: 'add_waiting_list',
        customer_id: ctrl.form.customer_id,
        item_id: ctrl.form.item_id,
        resource_id: ctrl.form.resource_id || null,
        from: from,
        to: to
      }, function(response) {
        ctrl.isLoading = false;
        if (response && response.status === "success") {
          swal({
            title: $translate.instant('SWAL_ORDER_ADD_WAITING_LIST_TITLE'),
            type: "success",
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            timer: 2000
          });
          $scope.$close(true);
        }
      }, function() {
        ctrl.isLoading = false;
      });
    };
  });
})();

(function(){
    angular.module('app.controllers').controller('CustomersBookingsController',
      function ($state, $header, $scope, $api, DTOptionsBuilder, $tiff_page, dataTablesHebrewProvider, $rootScope, $translate, $compile, $log, $uibModal) {
        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;

        $header.title = "NAV_CUSTOMERS_BOOKINGS";
        $header.breadcrumbs.push({
          "title": "NAV_CUSTOMERS_BOOKINGS"
        });

        $scope.activeTab = 'pending';

        ctrl.changeTab = function(tab) {
          $scope.activeTab = tab;
        };

        ctrl.openAddWaitingListModal = function () {
          $uibModal.open({
            animation: true,
            templateUrl: 'app/modules/customers_bookings/list/waiting-list-add.modal.html',
            controller: 'CustomersBookingsWaitingListAddController',
            controllerAs: 'ctrl',
            windowTopClass: "form-modal medium-modal",
            scope: $scope,
            resolve: {
              Items: function ($api) {
                return $api.resolve("items.items_with_duration@get");
              },
              Resources: function ($api) {
                return $api.resolve("resources@get");
              },
              WaitingList: function ($api) {
                return null;
              }
            }
          }).result.then(function () {
            $scope.activeTab = 'waiting';
            if ($('#cust_dt_waitings').DataTable() && $('#cust_dt_waitings').DataTable().ajax) {
              $('#cust_dt_waitings').DataTable().ajax.reload();
            }
          });
        };


        /**
         * Initiate DataTable Options
         */
        ctrl.initDtOptions = function(){
          $scope.dtOptions =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', 20)
              //.withOption('order', [[1, 'desc']])
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('ajax', ctrl.loadCustomersBookings)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('rowCallback', ctrl.bookingRawCallback)
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.initDtOptionsWaitings = function(){
          $scope.dtOptionsWaitings =
            DTOptionsBuilder.newOptions().withDOM('Tfgtip')
              .withLanguage(dataTablesHebrewProvider)
              .withOption('pageLength', 20)
              //.withOption('order', [[1, 'desc']])
              .withOption('aaSorting', [])
              .withOption('searching', false)
              .withOption('ajax', ctrl.loadCustomersBookings)
              .withOption('serverSide', true)
              .withDataProp('data')
              .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
              });
        };

        ctrl.search_value = "";
        ctrl.find_table = function() {
          if ($scope.activeTab == 'pending') {
            if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
              $('#cust_dt').DataTable().ajax.reload();
            }
          } else {
            if ($('#cust_dt_waitings').DataTable() && $('#cust_dt_waitings').DataTable().ajax) {
              $('#cust_dt_waitings').DataTable().ajax.reload();
            }
          }
        }

        ctrl.delete = function (wlistId) {
          swal({
            title: "",
            text: $translate.instant('SWAL_WAITING_LIST_DELETE_CONFIRM_TEXT'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
            confirmButtonClass: "btn-danger",
            closeOnConfirm: false,
            showLoaderOnConfirm: true
          }).then(function(result) {
            if (result.value) {
              $api.customers_bookings.remove_waiting_list.get({list_id: wlistId}, function (response) {
                if (response.status == "success") {
                  swal({
                    title: $translate.instant('SWAL_CUSTOMER_DELETE_TITLE'),
                    text: "",
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });

                  ctrl.dtInstanceCustomers.reloadData(null, false);
                }
              });
            }
          });
        };

        /**
         * Load customers bookings
         *
         * @param data
         * @param callback
         * @param settings
         */
        ctrl.loadCustomersBookings = function (data, callback, settings) {
          var orderCol = '';
          var orderDir = '';

          if(data.order.length) {
            // Use only last order parameters
            var colIndex = data.order[data.order.length - 1].column
            var orderCol = data.columns[colIndex]['name'];
            var orderDir = data.order[data.order.length - 1].dir;
          }
          $tiff_page.start_loading('list');
          $api.customers_bookings[(($scope.activeTab == 'pending') ? 'list' : 'waiting_list')].get(
            {limit: data.length, offset: data.start, order: orderCol, order_dir: orderDir, search: ctrl.search_value}
            , function (result) {
              $tiff_page.stop_loading('list');
            if (result && result.data) {

              callback({
                recordsTotal: result.recordsTotal ? result.recordsTotal : 0,
                recordsFiltered: result.recordsFiltered ? result.recordsFiltered : 0,
                data: result.data,
                draw: data.draw + 1
              });
            }

          });
            
        };

        /**
         * Bind events to a new row
         *
         * @param nRow
         * @param aData
         * @param iDisplayIndex
         * @param iDisplayIndexFull
         * @returns {*}
         */
        ctrl.bookingRawCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $(nRow).find('td').not(".calendar-col").unbind('click');
          $(nRow).find('td').not(".calendar-col").bind('click', function() {
            $scope.$apply(function() {
              $state.go('app.calendar.order-edit', {id: aData.id});
            });
          });

          $(nRow).find('td.calendar-col').unbind('click');
          $(nRow).find('td.calendar-col').bind('click', function() {
            $scope.$apply(function() {
              $state.go('app.calendar.date', {date: moment(aData.order_date).format('YYYY-MM-DD HH:mm')});
            });
          });
          
          return nRow;
        }

        if (window.innerWidth < 768) {
          $.fn.DataTable.ext.pager.numbers_length = 3;
        }

        ctrl.initDtOptions();
        ctrl.initDtOptionsWaitings();

        /**
         * Bookings table column definitions
         * @type {*[]}
         */
        ctrl.dtColumns = [
          { name: 'name', data: 'customer_name', title: $translate('CUSTOMERS_NAME'), class: 'customer-name'},
          { name: 'order_date', data: null, title: $translate('BOOKING_DATE_TIME_TTL'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['order_date']).format('HH:mm DD/MM/YYYY');
            }
          },
          { name: 'name', data: 'customer_phone', title: $translate('CUSTOMERS_PHONE'), class: ''},
          { data: null, title: '', orderable: false, class: 'calendar-col',
            render: function(data, type, full, meta) {
              return '<i class="las la-eye"></i>';
            }
          },
        ];

        ctrl.dtColumnsWaitingList = [
          { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'customer-name',
            render: function (data, type, full, meta) {
              return data['name'] ? data['name'] : data['customer_name'];
            }
          },
          { name: 'phone', data: null, title: $translate('CUSTOMERS_PHONE'), class: '',
            render: function (data, type, full, meta) {
              return data['phone'] ? data['phone'] : data['customer_phone'];
            }
          },
          { name: 'item_name', data: 'item_name', title: $translate('BOOKING_ITEM'), class: ''},
          { name: 'resource_name', data: null, title: $translate('BOOKING_RESOURCE'), class: '',
            render: function (data, type, full, meta) {
              return data['resource_name'] ? data['resource_name'] : $translate.instant('BOOKING_RESOURCE_ANY');
            }
          },
          { name: 'from', data: null, title: $translate('BOOKING_WAITING_DATE'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['from']).format('DD/MM/YYYY');
            }
          },
          { name: 'from', data: null, title: $translate('BOOKING_DATE_TIME_FROM'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['from']).format('HH:mm');
            }
          },
          { name: 'to', data: null, title: $translate('BOOKING_DATE_TIME_TO'), class: '',
            render: function (data, type, full, meta) {
              return moment(data['to']).format('HH:mm');
            }
          },
          {name: 'icons', sortable: false, data: null, title: '', class: 'customer-icons',
            render: function (data, type, full, meta) {
              var add_details = '';
              add_details += '<div class="customer-table-icons">';

              add_details += '<a class="btn icon circle small bordered blue" ng-click="ctrl.edit(' + data.id + ');"><i class="las la-edit"></i></a>';

              if (data.phone) {
                var phone = data.phone;
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                phone = '+972'+phone;

                add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
                add_details += '<a class="btn icon circle small bordered red" ng-click="ctrl.delete(' + data.id + ');"><i class="las la-trash"></i></a>';
              }

              add_details += '</div>';

              return add_details;
            }
          },
        ];

        ctrl.dtInstanceCallback = function (dtInstance) {
          ctrl.dtInstanceCustomers = dtInstance;
        }

        ctrl.edit = function (id) {
          $uibModal.open({
            animation: true,
            templateUrl: 'app/modules/customers_bookings/list/waiting-list-add.modal.html',
            controller: 'CustomersBookingsWaitingListAddController',
            controllerAs: 'ctrl',
            windowTopClass: "form-modal medium-modal",
            scope: $scope,
            resolve: {
              Items: function ($api) {
                return $api.resolve("items.items_with_duration@get");
              },
              Resources: function ($api) {
                return $api.resolve("resources@get");
              },
              WaitingList: function ($api) {
                return $api.resolve("customers_bookings.waiting_list.single@get", {id: id});
              }
            }
          }).result.then(function () {
            $scope.activeTab = 'waiting';
            if ($('#cust_dt_waitings').DataTable() && $('#cust_dt_waitings').DataTable().ajax) {
              $('#cust_dt_waitings').DataTable().ajax.reload();
            }
          });
        }

      });
})();

(function() {

    angular.module("app.controllers").controller("CustomersSelectController", function($scope, $state, $timeout, DTOptionsBuilder,
          dataTablesHebrewProvider, $rootScope, $uibModalInstance, $api) {

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }

        var ctrl = this;
        ctrl.customers = [];
        ctrl.customer_name = "";

        var debounceTimeout = null;
        var currentRequest = null;

        $scope.find_customer = function() {
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }

            debounceTimeout = setTimeout(function() {
                if (currentRequest && currentRequest.abort) {
                    currentRequest.abort();
                }

                currentRequest = $api.customers.find.get(
                    { str: ctrl.customer_name },
                    function(response) {
                        if (response.str == ctrl.customer_name) {
                            ctrl.customers = response.data;
                        }
                    },
                    function(error) {
                    }
                );
            }, 100);
        };

        ctrl.selectCustomer = function(customer) {
            $uibModalInstance.close(customer);
        }

        $scope.find_customer();
    });

})();

(function () {
  angular.module("app.controllers").controller("CashboxUseCardFormController",
    function (Card, Item, $api, $scope, $state, $rootScope, $uibModalInstance, $translate, $log) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {reload: true});
        return;
      }
      var ctrl = this;
      ctrl.card = Card.data;
      ctrl.item = Item;

      ctrl.form = {
        card_balance_used: 0,
        item: ctrl.item,
        card: ctrl.card
      };

      if (ctrl.item.card_balance_used) {
        ctrl.form.card_balance_used = ctrl.item.card_balance_used;
      }

      /**
       * Use card
       */
      ctrl.saveForm = function () {
        $uibModalInstance.close(ctrl.form);
      }

      ctrl.close = function () {
        $uibModalInstance.close();
      }

    });
})();

(function () {

  angular.module('app.controllers')

    .controller('OrderFormController', ['Clubs', 'Info', 'Items', 'Resources', 'SecondResources', 'Customer', 'Order', 'CalendarEvent', 'EventCopy', 'CalendarCourse', 'CoursesFields', 'Messages',
        'dates', '$api', '$scope', '$state', '$rootScope', '$uibModal', '$uibModalStack', '$filter', '$translate', '$timeout' , '$log', '$tiff_page', '$window', '$resource', '$sce',
        function (Clubs, Info, Items, Resources, SecondResources, Customer, Order, CalendarEvent, EventCopy, CalendarCourse, CoursesFields, Messages, dates, $api, $scope, $state, $rootScope,
                  $uibModal, $uibModalStack, $filter, $translate, $timeout, $log, $tiff_page, $window, $resource, $sce) {

      if ($rootScope.userRole == 1) {
        $state.go('app.admin', {}, {
          reload: true
        });
        return;
      }

      $scope.getTrustedHtml = function(item, badge, onTop) {
        var html = "<span tooltip='" + item + "' class='have-tooltip " + (onTop ? 'tooltip-top' : '') + " tooltip-wrap'>" + badge + item + "</span>";
        return $sce.trustAsHtml(html);
      };

      $scope.filterItems = function(orderItem) {
        return function(item) {
          return (
            orderItem.item_type === item.item_type && (!item.inactive || item.id === orderItem.item_id)
          );
        };
      };

      $scope.getItemPriority = function (item) {
        var status = ctrl.hasCustomerCardForItem(item.id); 
        if (status === true) return 0;
        if (status === 'expired') return 1;
        return 2;
      };
      
      var ctrl = this;

      ctrl.hide_prices = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices') ? true : false;
      ctrl.searchResult = [];

      ctrl.isMobile = (angular.element(document).width() < 769);
      ctrl.start_time = "00:00";

      ctrl.date = moment();

      ctrl.business = Info.data;

      ctrl.prepared_form = false;

      ctrl.is_prepaid = ctrl.business.prepaid && ctrl.business.prepaid*1 > 0;

      ctrl.bu_type = parseInt(Info.data.type);

      ctrl.dealer_type = Info.data.dealer_type;

      ctrl.courses_fields = CoursesFields && CoursesFields.data ? CoursesFields.data : [];

      ctrl.customer = null;
      ctrl.customer_search_name = "";
      ctrl.formItemsChangedNotSaved = false;
      ctrl.courseItems = [];
      ctrl.cancelReasonOptions = [
        {id: 'לקוח ביטל', name: $translate.instant('CALENDAR_ORDER_CANCEL_REASON_1')},
        {id: 'אי הופעת לקוח', name: $translate.instant('CALENDAR_ORDER_CANCEL_REASON_2')},
        {id: 'ביטול ע"י העסק', name: $translate.instant('CALENDAR_ORDER_CANCEL_REASON_3')}
      ];

      ctrl.allow_sending = false;

      ctrl.notifications_type = 0;

      ctrl.dealer_vat = parseFloat(Info.data.vat);

      ctrl.is_edit = false;

      ctrl.order = null;

      ctrl.pending_medical_note_id = null;

      ctrl.clubs = Clubs.data;
      ctrl.orderRepeatPeriodOptions = [
        {id: '7', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_7')},
        {id: '14', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_14')},
        {id: '21', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_21')},
        {id: '28', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_28')},
        {id: '35', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_35')},
        {id: '42', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_42')},
        {id: '49', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_49')},
        {id: '56', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_56')},
        {id: '63', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_63')},
        {id: '70', name: $translate.instant('CALENDAR_ORDER_REPEAT_PERIOD_70')}
      ];
      ctrl.eventRepeatPeriodOptions = [
        {id: '1', name: $translate.instant('CALENDAR_ORDER_REPEAT_DAILY')},
        {id: '2', name: $translate.instant('CALENDAR_ORDER_REPEAT_WEEKLY')},
        {id: '4', name: $translate.instant('CALENDAR_ORDER_REPEAT_2WEEKS')},
        {id: '3', name: $translate.instant('CALENDAR_ORDER_REPEAT_MONTHLY')}
      ];

      ctrl.message_template = Messages.data;
      ctrl.holidays = {};
      ctrl.holidayName = "";

      ctrl.images_count = [1,2,3,4,5];

      ctrl.is_full_prepaid = false;

      // need for correct rendering list after adding new customer
      ctrl.showCustomerSelect = true;

      ctrl.allow_edit = false;

      ctrl.showMultiServiceDropdown = false;
      ctrl.multiServiceFilterText = '';
      ctrl.multiServiceSelectedItems = [];

      $scope.$watch("ctrl.form.date", function(newValue, oldValue, event) {
        ctrl.detectHolidays();

        if (document.activeElement) {
          //document.activeElement.blur();
        }
      });

      ctrl.detectHolidays = function() {
        
        var year = ctrl.form.date ? ctrl.form.date.format("YYYY") : ctrl.date.format("YYYY");

        if(!ctrl.holidays[year]) {
            $api.holidays.get({
                year: year
            }, function(response) {

                if(response.status == "success") {

                    ctrl.holidays[year] = response.data.holidays;

                    ctrl.setDetectedHoliday(ctrl.form.date);
                }
            });
        } else {
          ctrl.setDetectedHoliday(ctrl.form.date);
        }
      };

      ctrl.setDetectedHoliday = function(date) {
        ctrl.holidayName = ctrl.getHolidayName(date);
      };

      ctrl.getHolidayName = function(date) {
        if (!date || !date.format) {
          return "";
        }
        var
            fullDate = date.format("YYYY-MM-DD"),
            year = date.format("YYYY");

        if(ctrl.holidays[year]) {
            if(ctrl.holidays[year][fullDate]) {
                if (ctrl.holidays[year][fullDate][0] && ctrl.holidays[year][fullDate][0].name) {
                    return $filter('hebrewHolidayName')(ctrl.holidays[year][fullDate][0].name);
                }
            }
            else {
                for(var i in ctrl.holidays[year]) {
                  if(ctrl.holidays[year][i][0] != undefined) {
                    var startDate = moment(ctrl.holidays[year][i][0].date),
                      endDate = moment(ctrl.holidays[year][i][0].observed);

                    if (startDate.unix() <= date.unix() && date.unix() <= endDate.unix()) {
                      return $filter('hebrewHolidayName')(ctrl.holidays[year][i][0].name);
                    }
                  }
                }
            }
        }

        return "";
      };

      if (!Order) {
        if ($scope.new_order_date && typeof $scope.new_order_date.format === "function") {
          if (ctrl.bu_type == 1) {
            ctrl.start_time = $scope.new_order_date.format("HH:mm");
          } else {
            ctrl.start_time = $scope.new_order_date;
          }
          ctrl.date = $scope.new_order_date;
        }
        ctrl.approved_date = null;
      } else if (!EventCopy) {
        ctrl.is_edit = true;
        ctrl.order = Order.data;
        if ($scope.new_order_date && typeof $scope.new_order_date.format === "function") {
          ctrl.date = $scope.new_order_date;
        }
        ctrl.approved_date = ctrl.order && ctrl.order.approved_date != null ?
          moment(ctrl.order.approved_date).format("DD/MM/YYYY HH:mm"): null;
      }

      ctrl.form = {
        date: ctrl.date,
        randomCustomer: false,
        eventDescription: '',
        event_resource_ids: [],
        typeOfOrder: 0,
        item_id: '',
        courses_fields: {},
        items:
          [{
            start_time: ctrl.start_time,
            item_type: 'service'
          }],
        meetings: [
          {
            date: ctrl.date,
            start_time: ctrl.start_time,
          }
        ],
        customers_list: [],
        not_send_message: false,
      };
      ctrl.event_group_key = null;
      ctrl.linked_event_rows = [];

      ctrl.normalizeResourceIds = function(resourceIds) {
        var normalized = [];
        if (!Array.isArray(resourceIds)) {
          return normalized;
        }
        for (var i = 0; i < resourceIds.length; i++) {
          if (resourceIds[i] === null || resourceIds[i] === undefined || resourceIds[i] === '') {
            continue;
          }
          normalized.push(String(resourceIds[i]));
        }
        return normalized.filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
      };

      ctrl.setEventResourceIds = function(resourceIds) {
        ctrl.form.event_resource_ids = ctrl.normalizeResourceIds(resourceIds);
        ctrl.syncEventPrimaryResource();
      };

      ctrl.syncEventPrimaryResource = function() {
        if (!Array.isArray(ctrl.form.event_resource_ids) || !ctrl.form.event_resource_ids.length) {
          ctrl.form.items[0].resource = '';
          return;
        }
        ctrl.form.items[0].resource = String(ctrl.form.event_resource_ids[0]);
      };

      ctrl.ensureEventGroupKey = function() {
        if (ctrl.event_group_key) {
          return ctrl.event_group_key;
        }
        ctrl.event_group_key = 'grp_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
        return ctrl.event_group_key;
      };

      ctrl.applyLinkedEvents = function(events, groupKey) {
        if (!Array.isArray(events) || !events.length) {
          ctrl.linked_event_rows = [ctrl.event];
          ctrl.setEventResourceIds([ctrl.event.resource_id]);
          return;
        }

        ctrl.linked_event_rows = events;
        ctrl.event_group_key = groupKey || ctrl.event_group_key;
        ctrl.setEventResourceIds(events.map(function(eventRow) {
          return String(eventRow.resource_id);
        }));
      };

      ctrl.loadLinkedEventsFallback = function() {
        if (!ctrl.event || !ctrl.event.start_date_time) {
          ctrl.applyLinkedEvents([ctrl.event], null);
          return;
        }

        var eventDate = moment(ctrl.event.start_date_time).format('YYYY-M-D');
        $api.events.calendar.get({
          date: eventDate,
          range: 'daily'
        }, function(response) {
          var rows = (response && Array.isArray(response.data)) ? response.data : [];
          var linked = rows.filter(function(row) {
            if (!row) {
              return false;
            }

            if (ctrl.event.repeat_id && row.repeat_id && String(ctrl.event.repeat_id) === String(row.repeat_id)) {
              return true;
            }

            var sameStart = String(row.start_date_time || '') === String(ctrl.event.start_date_time || '');
            var sameEnd = String(row.end_date_time || '') === String(ctrl.event.end_date_time || '');
            var sameDescription = String(row.description || '') === String(ctrl.event.description || '');
            return sameStart && sameEnd && sameDescription;
          });

          if (!linked.length) {
            linked = [ctrl.event];
          }
          ctrl.applyLinkedEvents(linked, null);
        }, function() {
          ctrl.applyLinkedEvents([ctrl.event], null);
        });
      };

      if(CalendarEvent) {
        CalendarEvent.$promise.then(function (response) {
          ctrl.is_edit = true;
          ctrl.event = CalendarEvent.data[0];
          
          ctrl.form.repeat = ctrl.event.repeat;
          ctrl.form.period = ctrl.event.period;
          ctrl.form.endDate = moment(ctrl.event.repeat_end_date).format("YYYY-MM-DD");
          ctrl.date = moment(ctrl.event.start_date_time).format("DD/MM/YYYY HH:mm");
          ctrl.form.date = moment(ctrl.event.start_date_time);
          ctrl.form.event_description = ctrl.event.description;
          ctrl.form.items[0].start_time = moment(ctrl.event.start_date_time).format("HH:mm");
          ctrl.form.items[0].duration = String(moment.duration(moment(ctrl.event.end_date_time).diff(moment(ctrl.event.start_date_time))).asMinutes());
          ctrl.form.items[0].resource = String(ctrl.event.resource_id);
          ctrl.setEventResourceIds([ctrl.event.resource_id]);
          ctrl.event_group_key = ctrl.event.event_group_key || null;
          ctrl.form.isEvent = true;
          ctrl.form.typeOfOrder = 1;
          $scope.selected_resource = String(ctrl.event.resource_id);
          $api.events.group.get({
            id: ctrl.event.id
          }, function(groupResponse) {
            if (groupResponse && groupResponse.status === 'success' && Array.isArray(groupResponse.data) && groupResponse.data.length) {
              if (groupResponse.data.length > 1) {
                ctrl.applyLinkedEvents(groupResponse.data, groupResponse.group_key);
              } else {
                ctrl.loadLinkedEventsFallback();
              }
            } else {
              ctrl.loadLinkedEventsFallback();
            }
          }, function() {
            ctrl.loadLinkedEventsFallback();
          });
          if (ctrl.form.items[0].start_time == "00:00") {
            ctrl.form.all_day = true;  
          }
        });
      }

      if(CalendarCourse) {
        CalendarCourse.$promise.then(function (response) {

          ctrl.is_edit = true;
          ctrl.course = CalendarCourse.data;
          ctrl.date = moment(ctrl.course.start_date);
          ctrl.form.date = moment(ctrl.course.start_date);
          ctrl.form.item_id = String(ctrl.course.item_id);
          ctrl.form.item_data = ctrl.course.item_data;
          ctrl.form.meetings = [];
          ctrl.form.customers_list = [];

          if (ctrl.course.meetings) {
            for (var i in ctrl.course.meetings) {
              ctrl.form.meetings.push({
                name: ctrl.course.meetings[i].name,
                date: moment(ctrl.course.meetings[i].start_time).format("YYYY-MM-DD"),
                start_time: moment(ctrl.course.meetings[i].start_time).format("HH:mm"),
                resource: String(ctrl.course.meetings[i].resource_id),
                second_resource: String(ctrl.course.meetings[i].second_resource_id || ''),
                duration: String(moment.duration(moment(ctrl.course.meetings[i].end_time).diff(moment(ctrl.course.meetings[i].start_time))).asMinutes())
              });
            }
          }

          if (ctrl.course.customers) {
            for (var i in ctrl.course.customers) {
              ctrl.form.customers_list.push({
                id: ctrl.course.customers[i].customer_id,
                firstname: ctrl.course.customers[i].firstname,
                lastname: ctrl.course.customers[i].lastname,
                avatar: ctrl.course.customers[i].avatar
              });
            }
          }

          if (ctrl.course.courses_fields) {
            for (var i in ctrl.course.courses_fields) {
              ctrl.form.courses_fields[i] = String(ctrl.course.courses_fields[i]);
            }
          }

          ctrl.form.typeOfOrder = 2;
          ctrl.form.isCourse = true;
          ctrl.prepareCourseItems();
        });
      }
      

      $scope.showCancelBtn = ctrl.is_edit && ctrl.order && (([1, 3, 4, 7].indexOf(ctrl.order.status) === -1) || (ctrl.order.status == 3 && !ctrl.business.cashbox));
      ctrl.isOrderTransaction = true;


      if (ctrl.bu_type == 2) {
          ctrl.form.items[0].end_time = ctrl.start_time;
      }

      if ($scope.selected_resource) {
          ctrl.form.items[0].resource = String($scope.selected_resource);
          ctrl.form.meetings[0].resource = String($scope.selected_resource);
          ctrl.setEventResourceIds([String($scope.selected_resource)]);
      }
      //Auto select resource if only one is available
      else if (Resources.data.length == 1) {
          ctrl.form.items[0].resource = Resources.data[0].id;
          ctrl.form.meetings[0].resource = Resources.data[0].id;
          ctrl.setEventResourceIds([String(Resources.data[0].id)]);
      } else {
        //Auto select resource if only one active is available
        var active = false
        var count_active = 0;
        for (var i in Resources.data) {
          
          if (Resources.data[i].status == 1) {
            count_active++;
            if (active === false && count_active == 1) {
              active = Resources.data[i].id;
            } else if (count_active > 1) {
              active = false;
            }
          }
        }
        
        if (active) {
          ctrl.form.items[0].resource = active;
          ctrl.form.meetings[0].resource = active;
          ctrl.setEventResourceIds([String(active)]);
        }
      }

      ctrl.buildOrderItemDropdownLabel = function(item) {
        var itemPrice = !ctrl.hide_prices ? ($filter('price')(item.originalPrice) + ', ') : '';
        return item.name + ' (' + itemPrice + ($filter('duration')(item.duration)) + ')';
      };

      ctrl.items = Items.data;
      ctrl.itemsDropdownVersion = 0;
      for (var i in ctrl.items) {
          ctrl.items[i].originalPrice = ctrl.items[i].price;
          ctrl.items[i].price = parseFloat(parseFloat(ctrl.items[i].price).toFixed(2));
          ctrl.items[i].quantity = 1;
          ctrl.items[i].course_dropdown_label = ctrl.items[i].name + (!ctrl.hide_prices ? ' (' + $filter('price')(ctrl.items[i].originalPrice) + ')' : '');
          ctrl.items[i].order_dropdown_label = ctrl.buildOrderItemDropdownLabel(ctrl.items[i]);
      }
      ctrl.itemsDropdownVersion++;

      ctrl.getOrderItemOptions = function(orderItem) {
        if (!orderItem) {
          return [];
        }

        var shouldRebuild = !orderItem._dropdownOptionsCache ||
          orderItem._dropdownOptionsVersion !== ctrl.itemsDropdownVersion ||
          orderItem._dropdownOptionsType !== orderItem.item_type ||
          String(orderItem._dropdownOptionsItemId || '') !== String(orderItem.item_id || '');

        if (shouldRebuild) {
          orderItem._dropdownOptionsCache = ctrl.items
            .filter(function(item) {
              return orderItem.item_type === item.item_type && (!item.inactive || item.id === orderItem.item_id);
            })
            .sort(function(a, b) {
              var pa = $scope.getItemPriority(a);
              var pb = $scope.getItemPriority(b);
              if (pa === pb) {
                return 0;
              }
              return pa < pb ? -1 : 1;
            });

          orderItem._dropdownOptionsVersion = ctrl.itemsDropdownVersion;
          orderItem._dropdownOptionsType = orderItem.item_type;
          orderItem._dropdownOptionsItemId = orderItem.item_id;
        }

        return orderItem._dropdownOptionsCache;
      };
      ctrl.prepareCourseItems = function () {
        ctrl.courseItems = ctrl.items.filter(function (item) {
          return item.item_type == 'course' && (!item.inactive || item.id == ctrl.form.item_id);
        });
      };
      ctrl.prepareCourseItems();
      ctrl.byType = 0;
      ctrl.setNightsType = function (type) {
          ctrl.byType = type;
      }
      $scope.userConfig = {
          create: true,
          //sortField: 'text'
      };

      ctrl.resources = Resources.data;
      ctrl.second_resources = SecondResources.data;
      ctrl.activeResources = ctrl.resources.filter(function (resource) {
        return resource.status != 0;
      });
      ctrl.activeSecondResources = ctrl.second_resources.filter(function (resource) {
        return resource.status != 0;
      });
      ctrl.syncEventPrimaryResource();

      var format = 'hh:mm:ss';
      var new_dates = [];

      for (var hour in dates.hours) {
        var time = moment(dates.hours[hour],format);          
        
        if (time.isBetween(moment(ctrl.business.min_time, format), moment(ctrl.business.max_time, format)) || 
            time.isSame(moment(ctrl.business.min_time, format)) ||
            time.isSame(moment(ctrl.business.max_time, format))) {
          new_dates.push(dates.hours[hour]);
        }
      }
      if (new_dates.length > 0) {
        dates.hours = new_dates;
      }
      ctrl.dates = dates;
      

      ctrl.random_customer_changed = function () {
        if (ctrl.form.randomCustomer) {
          ctrl.form.customer = {};
          ctrl.form.phone = "";
          ctrl.form.email = "";
          ctrl.form.customer_name = "";
          ctrl.customer_search_name = "";
          ctrl.allow_sending = true;
          ctrl.notifications_type = 2;
          ctrl.customerCards = null;
        }
      };

      ctrl.changeOrderType = function () {
        switch (ctrl.form.typeOfOrder) {
          case '0':
            ctrl.form.isEvent = false;
            ctrl.form.isCourse = false;
            break;
          case '1':
            ctrl.form.isEvent = true;
            ctrl.form.isCourse = false;
            break;
          case '2':
            ctrl.form.isEvent = false;
            ctrl.form.isCourse = true;
            break;
        }
      }

      /**
       * When selecting customer from list,
       * fill email and phone
       */

      ctrl.customer_selected = function () {
        ctrl.customer_search_name = '';
        if (ctrl.form.customer) {
          ctrl.customer_search_name += ctrl.form.customer.firstname;
          ctrl.customer_search_name +=  ctrl.form.customer.lastname ? ' ' + ctrl.form.customer.lastname : '';
          ctrl.customer_search_name +=  ctrl.form.customer.notes ? ' (' + ctrl.form.customer.notes + ')' : '';
        }

        var selected_customer = ctrl.form.customer;
        ctrl.customer = selected_customer;

        ctrl.allow_sending = ctrl.customer && ctrl.customer.send_notifications > 0;
        if (selected_customer) {
          ctrl.form.phone = selected_customer.phone || selected_customer.telephone; // mobile
          ctrl.form.email = selected_customer.email;
          ctrl.notifications_type = selected_customer.send_notifications;
          ctrl.loadCustomersCards(selected_customer.id);
        }

        if (ctrl.form.isCourse) {
          ctrl.add_customer_item();
        }
      }

      /**
       * search customer
       */
      $scope.find_customer = function() {
        ctrl.customer = null;
        ctrl.form.customer = null;

        $api.customers.find.get({str: ctrl.customer_search_name}, function(response){
          if (response.str == ctrl.customer_search_name) {
            ctrl.searchResult = response.data;
          }
        });
      }


      // Set value to search box
      $scope.chooseCustomer = function(index,$event){
        ctrl.form.customer = ctrl.searchResult[index];
        ctrl.customer_selected();
        ctrl.form.randomCustomer = 0;
        ctrl.searchResult = [];
        $event.stopPropagation();
      }

      $scope.searchboxClicked = function($event){
        $event.stopPropagation();
      }

      $scope.containerClicked = function(){
        ctrl.searchResult = [];
      }

      ctrl.cleanCustomerSearch = function() {
        if(angular.equals(ctrl.form.customer, {}) || typeof ctrl.form.customer === "undefined") {
          ctrl.customer_search_name = '';
        }
      }

      ctrl.get_customer_by_id = function (id) {
        var promise = $api.resolve("customers.single@get", {"id": id});
        promise.then(function(response){
          ctrl.form.customer = response.data;
          if(ctrl.form.customer) {
            ctrl.form.randomCustomer = false;
            ctrl.customer_selected();
          } else {
            ctrl.form.randomCustomer = true;
            ctrl.customer = null;
            ctrl.allow_sending = true;
            ctrl.notifications_type = 2;
          }
        });
      }

      if (Customer) {
        ctrl.get_customer_by_id(Customer.id);
      }

      ctrl.cancel_order = function (type) {
        $tiff_page.start_loading('cancel_order');
        var data = {
          id: ctrl.order.id,
          reason: ctrl.form.cancelReason,
          discardSms: ctrl.form.discardSms,
          all_repeatable: ctrl.form.all_repeatable ? ctrl.form.repeat_id : 0,
        }
        if(type == 'decline_booking') {
          data.type = 'decline_booking';
        }
        $api.orders.single.delete(data, function (response) {
          $tiff_page.stop_loading('cancel_order');
          $uibModalStack.dismissAll();
          if (response.status === "success") {
            swal({
              title: $translate.instant('SWAL_ORDERS_DELETE_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      };

      ctrl.decline_order = function() {
        ctrl.form.cancelReason = 'ביטול ע"י העסק';
        ctrl.cancel_order('decline_booking');
      }

      ctrl.deleteCourse = function() {
        swal({
          title: $translate.instant('SWAL_COURSE_DELETE_TITLE'),
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
        }).then(function(result) {
          if (result && result.value) {
            $api.courses.single.delete({
              id: ctrl.course.id
            }, function (response) {
              if (response.status === "success") {
                swal({
                  title: $translate.instant('SWAL_COURSE_DELETE_SUCCESS_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $uibModalStack.dismissAll();
              }
            });
          }
        });
      }

      ctrl.calculate_totals = function () {
        ctrl.form.total = 0;
        for (var i in ctrl.form.items) {
          if (ctrl.bu_type == 1 && ctrl.form.items[i].item && ctrl.form.items[i].item.price) {
            if(ctrl.form.items[i].item.item_type == 'service')
              ctrl.form.total += ctrl.form.items[i].item.price;
            else if(ctrl.form.items[i].item.item_type == 'sale')
              ctrl.form.total += ctrl.form.items[i].item.price * ctrl.form.items[i].item.quantity;
          } else if (ctrl.bu_type == 2 && ctrl.form.items[i].item ) {
            if(ctrl.form.items[i].item.item_type == 'service' && ctrl.form.items[i].nights > 0 )
              ctrl.form.total += ctrl.form.items[i].item.price * ctrl.form.items[i].nights;
            else if (ctrl.form.items[i].item.item_type == 'sale')
              ctrl.form.total += ctrl.form.items[i].item.price * ctrl.form.items[i].item.quantity;
          }
        }
        if (ctrl.dealer_type === "licensed") {
          ctrl.form.subtotal = (ctrl.form.total / (100 + ctrl.dealer_vat)) * 100;
          ctrl.form.subtotal = (Math.round(ctrl.form.subtotal * 100))/100;
          ctrl.form.tax = ctrl.form.total - ctrl.form.subtotal;
        }

        ctrl.is_full_prepaid = ctrl.order && ctrl.form && (ctrl.form.total == ctrl.order.prepaid);
      };
      ctrl.calculate_totals();

      ctrl.motels_update_item_nights = function (itemIndex) {
        var item = ctrl.form.items[itemIndex];
        if (ctrl.byType === 1) {
          if(item.item_type == 'service') {
            item.end_time = moment(item.start_time).add(item.nights, 'days');
          }
        } else {
          if(item.item_type == 'service') {
            if (item.start_time && item.end_time) {
              var duration;
              item.start_time = moment(item.start_time);
              item.end_time = moment(item.end_time);
              duration = moment.duration(item.end_time.diff(item.start_time));
              item.nights = Math.round(duration.asDays());
            } else {
              item.nights = null;
            }
            ctrl.calculate_totals();
          }
        }
      }

      ctrl.removeImage = function($event, key) {
        $event.stopPropagation();
        $event.preventDefault();
        ctrl.form[key] = '';
      }

      ctrl.showImage = function($event, image) {
        $event.stopPropagation();
        $event.preventDefault();
        swal({
            imageUrl: image,
            imageWidth: 800,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: $translate.instant('CALL_CANCEL'),
        })
      }

      ctrl.checkFirstWImage = function(key, k) {
        var w_image = false;
        for (var i in ctrl.images_count) {
          if ((!ctrl.form[key+ctrl.images_count[i]] || ctrl.form[key+ctrl.images_count[i]] == '') && !w_image) {  
            w_image = ctrl.images_count[i];
          }

          if (w_image == k) {
            return true;
          }
        }

        return false;
      }

      ctrl.changeStartTime = function($orderItemIndex) {
        if ($orderItemIndex == 0 && ctrl.form.items.length > 1) {
          for (var i = $orderItemIndex + 1; i < ctrl.form.items.length; i++) {
            ctrl.form.items[i].start_time = moment(ctrl.form.items[i-1].start_time, 'HH:mm').add(ctrl.form.items[i-1].duration, 'minutes').format('HH:mm');
          }
        }
      }

      ctrl.load_order_data = function () {
        var start_date, start_hour, start_minute, duration;
        var item = false;
        var joinedItems = [];
        if (Order.data) {
          for (var i in Order.data.items) {
            if (Order.data.items[i]['item_data'] && Order.data.items[i]['item_data']['item_type'] != 'sale' && !item) {
              item = Order.data.items[i];
            }

            if (!Order.data.items[i].part) {
              joinedItems.push(Order.data.items[i]);
              if (Order.data.items[i].item_id !== null && Order.data.items[i].item_id !== undefined) {
                ctrl.multiServiceSelectedItems.push(Order.data.items[i].item_id.toString());
              }
            }
          }
        }

        ctrl.form = {
          customer: null,
          notes: Order.data.notes,
          phone: Order.data.phone,
          email: Order.data.email,
          image_before1: Order.data.image_before1,
          image_before2: Order.data.image_before2,
          image_before3: Order.data.image_before3,
          image_before4: Order.data.image_before4,
          image_before5: Order.data.image_before5,
          image_after1: Order.data.image_after1,
          image_after2: Order.data.image_after2,
          image_after3: Order.data.image_after3,
          image_after4: Order.data.image_after4,
          image_after5: Order.data.image_after5,
          approval_sent: Order.data.approval_sent,
          request_feedback: Order.data.request_feedback,
          date: moment(item.start_time),
          items: joinedItems,//Order.data.items
          not_send_message: Order.data.not_send_message || false,
        };
        if(Order.data.id && Order.data.customer) {
          if (Order.data.customer_data && Order.data.customer_data.id == Order.data.customer) {
            ctrl.form.customer = Order.data.customer_data;
            if(ctrl.form.customer) {
              ctrl.form.randomCustomer = false;
              ctrl.customer_selected();
            } else {
              ctrl.form.randomCustomer = true;
              ctrl.customer = null;
              ctrl.allow_sending = true;
              ctrl.notifications_type = 2;
            }
          } else {
            ctrl.get_customer_by_id(Order.data.customer);
          }
        } else {
          ctrl.form.randomCustomer = true;
          ctrl.customer = null;
          ctrl.customer_search_name = "";
          ctrl.allow_sending = true;
          ctrl.notifications_type = 2;
          if(Order.data.customer_name && Order.data.customer_name !="") {
            ctrl.form.customer_name = ctrl.customer_search_name = Order.data.customer_name;
          }
        }


        // if (!ctrl.form.customer) {
        //   ctrl.form.randomCustomer = true;
        //   ctrl.customer = null;
        //   ctrl.allow_sending = true;
        //   ctrl.notifications_type = 2;
        // } else {
        //   ctrl.customer_selected();
        // }

        for (var i = 0; i < ctrl.form.items.length; i++) {
          var formItem = ctrl.form.items[i];
          if (!formItem) continue;
      
          formItem.item_id = formItem.item_id != null ? String(formItem.item_id) : '';
          formItem.resource = formItem.resource_id != null ? String(formItem.resource_id) : '';
      
          for (var j = 0; j < Order.data.items.length; j++) {
              var orderItem = Order.data.items[j];
              if (!orderItem) continue;
      
              if (formItem.id == orderItem.part) {
                  formItem.enabled_second = true;
                  formItem.resource_second = orderItem.resource_id;
                  formItem.duration_second = orderItem.duration;
                  formItem.start_time_second = orderItem.start_time;
                  formItem.end_time_second = orderItem.end_time;
              }
          }
      
          var itemData = formItem.item_data || null;
          var itemType = itemData ? itemData.item_type : null;
      
          if (ctrl.bu_type == 1 && itemType == 'service') {
              var start_date_time = moment(formItem.start_time);
              var end_date_time = moment(formItem.end_time);
              formItem.start_time = moment(start_date_time).format('HH:mm');
              formItem.duration = String(moment.duration(end_date_time.diff(start_date_time)).asMinutes());
      
              if (formItem.enabled_second) {
                  var start_date_time_second = moment(formItem.start_time_second);
                  var end_date_time_second = moment(formItem.end_time_second);
                  formItem.start_time_second = moment(start_date_time_second).format('HH:mm');
                  formItem.duration_second = String(moment.duration(end_date_time_second.diff(start_date_time_second)).asMinutes());
              }
          } else if (ctrl.bu_type == 2 && itemType == 'service') {
              if (!formItem.adults) formItem.adults = 0;
              if (!formItem.kids) formItem.kids = 0;
              if (!formItem.babies) formItem.babies = 0;
      
              ctrl.motels_update_item_nights(i);
          }
      
          ctrl.saveOriginalItemsData(i);
          ctrl.calculate_totals();
      
          if (itemData) {
              if (!formItem.item) {
                  formItem.item = {};
              }
      
              formItem.item.price = (itemData.price || 0) * 1;
              formItem.item_type = itemType;
      
              if (itemType != 'service') {
                  formItem.item.quantity = itemData.quantity != null ? itemData.quantity : 0;
              }
          }
        }
        if(Order.data.id) {
          ctrl.originalFormItemsData = angular.copy(ctrl.form.items);
        }
        
        ctrl.form.repeat_id = (Order.data.repeat_id ? Order.data.repeat_id : null);
      };

      ctrl.approveArrival = function() {
        if (!Order.data || !Order.data.id) return;

        $api.orders.approval.save({
            id: Order.data.id
        }, {}, function (response) {
            ctrl.form.approval_sent = 2;
        });
      };


      $scope.uploadImage = function(element){
        var new_file_name = element.name;
        new_file_name += '_' + Date.now() +  '.' + element.files[0].name.split('.').pop();

        var fdata = new FormData();
        fdata.append("image", element.files[0], new_file_name);
        fdata.append("type", element.name);
        $tiff_page.start_loading('save_image');
        
        $resource($api.baseURL + '/Image/upload', {}, {
            postWithFile: {
                method: "POST",
                params: fdata,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            }
        }).postWithFile(fdata).$promise.then(function(response){
            ctrl.form[element.name] = response.image;
            $tiff_page.stop_loading('save_image');
        }, function(error){
            $tiff_page.stop_loading('save_image');
            console.log(error);
        });
      };

      /**
       * Save order to API
       *
       * @param callBack
       */
      ctrl.send_order_form = function (callBack) {

        if(ctrl.form.isEvent) {
            ctrl.save_event();
            return;
        }

        if(ctrl.form.isCourse) {
          ctrl.save_course();
          return;
        }

        if (ctrl.bu_type == 2) {
          for (var i in ctrl.form.items) {
            if(ctrl.form.items[i].item_type == 'service'){
              ctrl.form.items[i].start_time = ctrl.form.items[i].start_time.year() + "-" + (ctrl.form.items[i].start_time.month() + 1) + "-" + ctrl.form.items[i].start_time.date();
              ctrl.form.items[i].end_time = ctrl.form.items[i].end_time.year() + "-" + (ctrl.form.items[i].end_time.month() + 1) + "-" + ctrl.form.items[i].end_time.date();
            }
          }
        }

        var original_start = false;
        var modified_start = false;
        var original_date = ctrl.order ? moment(ctrl.order.date) : false;
        var modified_date = ctrl.form.date;

        for (var j in ctrl.originalFormItemsData) {
          if (ctrl.originalFormItemsData[j].start_time) {
            var start_moment = moment(ctrl.originalFormItemsData[j].start_time, 'HH:mm');
            if (!original_start || start_moment.isBefore(original_start)) {
              original_start = start_moment;
            }
          }
        }


        if (Array.isArray(ctrl.form.items)) {
          for (var i = 0; i < ctrl.form.items.length; i++) {
              var row = ctrl.form.items[i];
      
              if (!row || typeof row !== 'object') {
                  continue;
              }
      
              if (row.start_time) {
                  var start_moment = moment(row.start_time, 'HH:mm');
                  if (!modified_start || start_moment.isBefore(modified_start)) {
                      modified_start = start_moment;
                  }
              }
      
              if (!row.item || typeof row.item !== 'object') {
                  continue;
              }
      
              if (row.item.price == null || row.item.price === '') {
                  row.item.price = 0;
              }
          }
        }

        var changed_items_time = (!original_start || !modified_start || (original_start && modified_start && original_start.format('HH:mm') != modified_start.format('HH:mm')) || (original_date && modified_date && !original_date.isSame(modified_date, 'day')));

        var order_data = JSON.parse(JSON.stringify(ctrl.form));
        
        order_data.date = moment(ctrl.form.date).format("YYYY-MM-DD HH:mm");
        if (ctrl.is_edit && ctrl.order && Object.prototype.hasOwnProperty.call(ctrl.order, 'medical_note_id')) {
          order_data.medical_note_id = ctrl.order.medical_note_id;
        } else if (!ctrl.is_edit && ctrl.pending_medical_note_id) {
          order_data.medical_note_id = ctrl.pending_medical_note_id;
        }
        if( typeof(order_data.customer) == "object" && order_data.customer !== null) {
          order_data.customer = order_data.customer.id;
          order_data.allow_sending = ctrl.allow_sending;
          order_data.not_send_message = ctrl.form.not_send_message;
        }
        if(ctrl.order && ctrl.order.status == 4) {
          order_data.status = 0;
          order_data.booking_approved = true;
        }

        $tiff_page.start_loading('save_order');
        if (ctrl.is_edit) {
          if (Info.data.update_order_notification == 2 && changed_items_time) {
            swal({
                text: $translate.instant('CALENDAR_UPDATE_ORDER_NOTIFICATION'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: $translate.instant('OPTION_YES'),
                cancelButtonText: $translate.instant('OPTION_NO')
            }).then(function(result) {
              order_data.send_notification = result.value ? 1 : 0;
              $api.orders.single.save({
                "id": ctrl.order.id
              }, order_data, function (response) {
                $tiff_page.stop_loading('save_order');
                if (response.status === "success") {
                  if(angular.isUndefined(callBack)) {
                    $uibModalStack.dismissAll();
                  }
                  if(!ctrl.formItemsChangedNotSaved) {
                    swal({
                      title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                      type: "success",
                      confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                      timer: 2000
                    });
                  } else {
                    ctrl.formItemsChangedNotSaved = false;
                    if (callBack) {
                      callBack(function () {
                        $uibModalStack.dismissAll();
                      });
                    }
                  }
                }
              });
            });
          } else {
            $api.orders.single.save({
              "id": ctrl.order.id
            }, order_data, function (response) {
              $tiff_page.stop_loading('save_order');
              if (response.status === "success") {
                if(angular.isUndefined(callBack)) {
                  $uibModalStack.dismissAll();
                }
                if(!ctrl.formItemsChangedNotSaved) {
                  swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                } else {
                  ctrl.formItemsChangedNotSaved = false;
                  if (callBack) {
                    callBack(function () {
                      $uibModalStack.dismissAll();
                    });
                  }
                }
              }
            });
          }
          
        } else {
          $api.orders.save(order_data, function (response) {
            $tiff_page.stop_loading('save_order');
            if (response.status === "success") {
              ctrl.savePreparedDF(response.id);
              ctrl.pending_medical_note_id = null;
              $uibModalStack.dismissAll();
              swal({
                title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 2000
              });
              if(callBack){
                callBack();
              }
            } else {
              if (response.overlap) {
                swal({
                    title: "",
                    text: $translate.instant('CALENDAR_ORDER_REPEAT_OVERLAP'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('CALENDAR_ORDER_REPEAT_OVERLAP_YES'),
                    cancelButtonText: $translate.instant('CALENDAR_ORDER_REPEAT_OVERLAP_NO'),
                    confirmButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true
                }).then(function(result) {
                    if(result.value) {
                      $tiff_page.start_loading('save_order');
                      order_data['confirm_repeat'] = true;
                      $api.orders.save(order_data, function (response) {
                        $tiff_page.stop_loading('save_order');
                        if (response.status === "success") {
                          ctrl.savePreparedDF(response.id);
                          ctrl.pending_medical_note_id = null;
                          $uibModalStack.dismissAll();
                          swal({
                            title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                          });
                          if(callBack){
                            callBack();
                          }
                        }
                      });
                    }
                });
              } else if (response.overlap == 0) {
                $tiff_page.start_loading('save_order');
                order_data['confirm_repeat'] = true;
                $api.orders.save(order_data, function (response) {
                  $tiff_page.stop_loading('save_order');
                  if (response.status === "success") {
                    ctrl.pending_medical_note_id = null;
                    $uibModalStack.dismissAll();
                    swal({
                      title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                      type: "success",
                      confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                      timer: 2000
                    });
                    if(callBack){
                      callBack();
                    }
                  }
                });
              }
            }
          });
        }
      };

      ctrl.buildEventPayload = function(resourceId) {
        var event_data = JSON.parse(JSON.stringify(ctrl.form));
        var start_time = (ctrl.form.all_day ? "00:00" : ctrl.form.items[0].start_time).split(':');
        var start_date_time = moment(ctrl.form.date).hours(start_time[0]).minutes(start_time[1]);
        event_data.end_date = moment(ctrl.form.endDate).format("YYYY-MM-DD HH:mm");
        event_data.start_date_time = start_date_time.format("YYYY-MM-DD HH:mm");
        event_data.end_date_time = start_date_time
          .clone()
          .add((ctrl.form.all_day ? 60 * 24 : ctrl.form.items[0].duration), 'minutes')
          .format("YYYY-MM-DD HH:mm");
        event_data.resource_id = String(resourceId);
        event_data.description = ctrl.form.event_description;
        event_data.event_group_key = ctrl.event_group_key;
        return event_data;
      };

      ctrl.runSequential = function(tasks, done) {
        var index = 0;
        var failures = [];
        var results = [];
        var next = function() {
          if (index >= tasks.length) {
            done(failures, results);
            return;
          }
          tasks[index](function(success, response) {
            if (success) {
              results.push(response);
            } else {
              failures.push(response || {});
            }
            index++;
            next();
          });
        };
        next();
      };

      ctrl.handleEventSaveResult = function(failures) {
        $tiff_page.stop_loading('save_event');
        if (!failures.length) {
          $uibModalStack.dismissAll();
          swal({
            title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
            type: "success",
            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
            timer: 2000
          });
          return;
        }

        swal({
          title: $translate.instant('SWAL_ORDERS_ERROR_TITLE'),
          type: "error",
          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
          timer: 2000
        });
      };

      ctrl.createEventsForResources = function(resourceIds, allEvents) {
        ctrl.ensureEventGroupKey();
        var tasks = [];
        for (var i = 0; i < resourceIds.length; i++) {
          (function(resourceId) {
            tasks.push(function(next) {
              var payload = ctrl.buildEventPayload(resourceId);
              if (allEvents) {
                payload.all_events = true;
              }
              $api.events.save(payload, function(response) {
                next(response && response.status === "success", response);
              }, function(response) {
                next(false, response);
              });
            });
          })(resourceIds[i]);
        }

        $tiff_page.start_loading('save_event');
        ctrl.runSequential(tasks, function(failures, results) {
          if (!ctrl.event_group_key && results.length && results[0].event_group_key) {
            ctrl.event_group_key = results[0].event_group_key;
          }
          ctrl.handleEventSaveResult(failures);
        });
      };

      ctrl.edit_event = function(resourceIds, eventData) {
        var desiredByResource = {};
        for (var i = 0; i < resourceIds.length; i++) {
          desiredByResource[String(resourceIds[i])] = true;
        }

        var linkedRows = Array.isArray(ctrl.linked_event_rows) && ctrl.linked_event_rows.length ? ctrl.linked_event_rows : [ctrl.event];
        var currentByResource = {};
        for (var j = 0; j < linkedRows.length; j++) {
          currentByResource[String(linkedRows[j].resource_id)] = linkedRows[j];
        }

        var toCreate = [];
        var toUpdate = [];
        var toDelete = [];
        var key;

        for (key in desiredByResource) {
          if (currentByResource[key]) {
            toUpdate.push(currentByResource[key]);
          } else {
            toCreate.push(key);
          }
        }

        for (key in currentByResource) {
          if (!desiredByResource[key]) {
            toDelete.push(currentByResource[key]);
          }
        }

        var tasks = [];

        for (var u = 0; u < toUpdate.length; u++) {
          (function(eventRow) {
            tasks.push(function(next) {
              var payload = ctrl.buildEventPayload(eventRow.resource_id);
              if (eventData && eventData.all_events) {
                payload.all_events = true;
              }
              $api.events.single.save({
                id: eventRow.id
              }, payload, function(response) {
                next(response && response.status === "success", response);
              }, function(response) {
                next(false, response);
              });
            });
          })(toUpdate[u]);
        }

        for (var c = 0; c < toCreate.length; c++) {
          (function(resourceId) {
            tasks.push(function(next) {
              var payload = ctrl.buildEventPayload(resourceId);
              if (eventData && eventData.all_events) {
                payload.all_events = true;
              }
              $api.events.save(payload, function(response) {
                next(response && response.status === "success", response);
              }, function(response) {
                next(false, response);
              });
            });
          })(toCreate[c]);
        }

        for (var d = 0; d < toDelete.length; d++) {
          (function(eventRow) {
            tasks.push(function(next) {
              $api.events.single.delete({
                id: eventRow.id,
                all: 0
              }, function(response) {
                next(response && response.status === "success", response);
              }, function(response) {
                next(false, response);
              });
            });
          })(toDelete[d]);
        }

        $tiff_page.start_loading('save_event');
        ctrl.runSequential(tasks, function(failures) {
          ctrl.handleEventSaveResult(failures);
        });
      }

      ctrl.save_event = function() {
          var selectedResources = ctrl.normalizeResourceIds(ctrl.form.event_resource_ids);
          if (!selectedResources.length && ctrl.form.items[0].resource) {
            selectedResources = [String(ctrl.form.items[0].resource)];
          }

          if (!selectedResources.length) {
            swal({
              title: $translate.instant('SWAL_ORDERS_ERROR_TITLE'),
              text: $translate.instant('CALENDAR_ORDER_MULTI_RESOURCE_REQUIRED'),
              type: "error",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
            });
            return;
          }

          if (ctrl.is_edit) {
            var event_data = ctrl.buildEventPayload(selectedResources[0]);
            if (event_data.repeat) {
              swal({
                  title: "",
                  text: $translate.instant('ORDER_EVENT_EDIT_CONFIRMATION'),
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonText: $translate.instant('ORDER_EVENT_EDIT_CONFIRMATION_ALL'),
                  cancelButtonText: $translate.instant('ORDER_EVENT_EDIT_CONFIRMATION_CURRENT'),
                  confirmButtonClass: "btn-primary",
                  cancelButtonClass: "btn-primary",
                  closeOnConfirm: false,
                  showLoaderOnConfirm: false
              }).then(function(result) {
                if (result.dismiss && result.dismiss == "overlay") {
                  return;
                }
                event_data.all_events = result.value ? true : false;
                ctrl.edit_event(selectedResources, event_data);
              });
            } else {
              ctrl.edit_event(selectedResources, event_data);
            }
          } else {
            ctrl.createEventsForResources(selectedResources);
          }
      }

      ctrl.save_course = function() {
        var data = JSON.parse(JSON.stringify(ctrl.form));
        if (ctrl.is_edit) {
          ctrl.edit_course(data);
        } else {
            $tiff_page.start_loading('save_course');
            $api.courses.save(data, function (response) {
                $tiff_page.stop_loading('save_course');
                $uibModalStack.dismissAll();
                if (response.status === "success") {
                  swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                } else {
                  swal({
                    title: $translate.instant('SWAL_ORDERS_ERROR_TITLE'),
                    type: "error",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                  });
                }
            });
        }
    }

      ctrl.edit_course = function(data) {
        $tiff_page.start_loading('save_course');
        $api.courses.single.save({
            "id": ctrl.course.id
        }, data, function (response) {
            $tiff_page.stop_loading('save_course');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.remove_item_from_order = function ($orderItemIndex) {
        ctrl.form.items.splice($orderItemIndex, 1);
        ctrl.multiServiceSelectedItems.splice($orderItemIndex, 1);
        ctrl.calculate_totals();
      };

      ctrl.completeOrder = function (orderId, directly) {
          if (!directly) {
            if (ctrl.business.cashbox) {
                swal({
                    title: '',
                    text: $translate.instant('ORDER_CLOSE__WITHOUT_PAYMENT_ALERT_TTL'),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: $translate.instant('OPTION_YES'),
                    cancelButtonText: $translate.instant('OPTION_NO'),
                }).then(function (res) {
                    if (res.value) {
                        ctrl._postCompletedOrder(orderId, true);
                    }
                });
            } else {
                ctrl._postCompletedOrder(orderId);
            }
          } else {
            ctrl._postPaidOrder(orderId);
          }
      };

      ctrl.request_review = function (customer_id, type) {
        swal({
            title: '',
            text: $translate.instant('CONFIRM_REVIEW_REQUEST'),
            type: "warning",
            showCancelButton: true,
            confirmButtonText: $translate.instant('OPTION_YES'),
            cancelButtonText: $translate.instant('OPTION_NO'),
        }).then(function (res) {
            if (res.value) {
                ctrl.sendReviewRequest(customer_id, type);
            }
        });
      };
      
      /**
       *
       * @param orderId
       * @param completeWithoutPayment Parameter define whether order could be completed without payment even though business has cashbox
       * @private
       */
      ctrl._postCompletedOrder = function (orderId, completeWithoutPayment) {
          $tiff_page.start_loading('complete_order');
          $api.transactions.save({
                  items: ctrl.form.items,
                  customer: ctrl.form.customer,
                  email: ctrl.form.email,
                  phone: ctrl.form.phone,
                  request_feedback: ctrl.form.request_feedback,
                  isOrderTransaction: ctrl.isOrderTransaction,
                  order_id: orderId,
                  completeWithoutPayment: completeWithoutPayment ? true : undefined,
              },
              function (response) {
                  $tiff_page.stop_loading('complete_order');
                  if (response.status == "success") {
                      swal({
                          title: $translate.instant('SWAL_ORDERS_TRANSACTION_SAVE_SUCCESS_TITLE'),
                          text: "",
                          type: "success",
                          confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                          timer: 2000
                      }).then(function(){
                          $uibModalStack.dismissAll();
                      });
                  }
              });
      }

      ctrl._postPaidOrder = function (orderId) {
        $tiff_page.start_loading('complete_order');
        $api.transactions.save({
                mark_paid: true,
                order_id: orderId,
            },
            function (response) {
                $tiff_page.stop_loading('complete_order');
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('SWAL_ORDERS_TRANSACTION_SAVE_SUCCESS_TITLE'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    }).then(function(){
                        $uibModalStack.dismissAll();
                    });
                }
            });
    }

       /**
       *
       * @param type Social network type
       */
      ctrl.sendReviewRequest = function (customer_id, type) {
        $tiff_page.start_loading('request_review');
        $api.customers.request_review.get({
                id: customer_id,
                type: type,
            },
            function (response) {
                $tiff_page.stop_loading('request_review');
                if (response.status == "success") {
                    swal({
                        title: $translate.instant('REVIEW_REQUEST_SUCCESS_SENT'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    }).then(function(){
                      $uibModalStack.dismissAll();
                    });
                }
            });
      }

      ctrl.add_service_item = function () {
        var duration_splitted_to_fives, start_time_hour_index = null,
          next_item_start_time = null;

        if (ctrl.form.items[ctrl.form.items.length - 1].item && ctrl.form.items[ctrl.form.items.length - 1].duration) {

          duration_splitted_to_fives = ctrl.form.items[ctrl.form.items.length - 1].enabled_second ? parseInt(ctrl.form.items[ctrl.form.items.length - 1].duration_second / 5) : parseInt(ctrl.form.items[ctrl.form.items.length - 1].duration / 5);

          for (var i in dates.hours) {
            if (ctrl.form.items[ctrl.form.items.length - 1].enabled_second) {
              if (dates.hours[i] == ctrl.form.items[ctrl.form.items.length - 1].start_time_second) {
                start_time_hour_index = parseInt(i);
              }
            } else if (dates.hours[i] == ctrl.form.items[ctrl.form.items.length - 1].start_time) {
              start_time_hour_index = parseInt(i);
            }
          }

          next_item_start_time = start_time_hour_index + duration_splitted_to_fives;
          if (next_item_start_time >= dates.hours.length) {
            next_item_start_time = next_item_start_time - dates.hours.length;
          }

          var start_time = dates.hours[next_item_start_time];
          if (ctrl.bu_type == 2) {
            start_time = ctrl.form.items[0].start_time;
          }
        } else {
          start_time = ctrl.form.items[0].start_time;
        }

        //Auto select resource if only one is available
        if(ctrl.resources.length == 1) {
            $scope.selected_resource = ctrl.resources[0].id;
        }

        ctrl.form.items.push({
          item_type: 'service',
          start_time: start_time,
          resource: $scope.selected_resource ? String($scope.selected_resource) : ("")
        });

        if (ctrl.bu_type == 2) {
          ctrl.form.items[ctrl.form.items.length - 1].end_time = ctrl.form.items[0].end_time;
        }
      };

      ctrl.add_sales_item = function () {
        ctrl.form.items.push({
          item_type: 'sale',
          quantity: 1
        });
      };

      ctrl.add_meeting_item = function () {
        if(ctrl.resources.length == 1) {
          $scope.selected_resource = ctrl.resources[0].id;
        }

        ctrl.form.meetings.push({
          date: ctrl.date,
          start_time: ctrl.form.meetings[0] ? ctrl.form.meetings[0].start_time : ctrl.start_time,
          resource: $scope.selected_resource ? String($scope.selected_resource) : (""),
          second_resource: "",
        });
      }

      ctrl.remove_meeting_item = function (index) {
        ctrl.form.meetings.splice(index, 1);
      }

      ctrl.add_customer_item = function () {
        if (ctrl.form.customer) {
          ctrl.form.customers_list.push(angular.copy(ctrl.form.customer));
          delete ctrl.form.customer
          delete ctrl.customer
          ctrl.customer_search_name = ""
        }
      }

      ctrl.remove_customer_item = function (index) {
        ctrl.form.customers_list.splice(index, 1);
      }

      ctrl.check_existed_customer = function (id) {
        for (var i in ctrl.form.customers_list) {
          if (ctrl.form.customers_list[i].id == id) {
            return true;
          }
        }

        return false;
      }

      ctrl.show_laser_file = function () {
        if (ctrl.form.customer) {
          $uibModal.open({
            templateUrl: "app/modules/settings/laser_file/popup/laser_file.popup.html",
            controller: "LaserFileController",
            controllerAs: "ctrl",
            scope: $scope,
            windowTopClass: "form-modal medium-modal laser-file-modal",
            resolve: {
              Info: ['$api', function ($api) {
                return $api.resolve("settings.laser_file@get");
              }],
              Data: ['$api', function ($api) {
                return $api.resolve("laser_file@get", {"customer_id": ctrl.form.customer.id});
              }],
              Customer: ctrl.form.customer,
              Order: ctrl.order,
            }
          }).result.then(function () {
            
          });
        }
      }
      
      ctrl.open_medical_note = function () {
        if (!ctrl.form.customer) {
          return;
        }
        $uibModal.open({
          templateUrl: "app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html",
          controller: "MedicalNotesFormController",
          controllerAs: "ctrl",
          scope: $scope,
          smallModal: true,
          windowTopClass: "form-modal small-modal",
          resolve: {
            Customer: function () {
              return { data: { id: ctrl.form.customer.id, name: (ctrl.form.customer.firstname || '') + ' ' + (ctrl.form.customer.lastname || '') } };
            },
            Resources: function ($api) {
              return $api.resolve("resources@get");
            },
            MedicalNote: ['$api', function ($api) {
              var noteId = null;
              if (ctrl.order && ctrl.order.medical_note_id) {
                noteId = ctrl.order.medical_note_id;
              } else if (ctrl.pending_medical_note_id) {
                noteId = ctrl.pending_medical_note_id;
              }
              if (!noteId) {
                return null;
              }
              return $api.resolve("medical_notes.single@get", { id: noteId }).then(function (res) {
                return res && res.data ? res.data : res;
              });
            }],
            OrderLink: function () {
              return {
                order_id: ctrl.order && ctrl.order.id ? ctrl.order.id : null,
                onMedicalNoteCreated: function (noteId) {
                  ctrl.pending_medical_note_id = noteId;
                },
                onMedicalNoteUnlinked: function () {
                  ctrl.pending_medical_note_id = null;
                }
              };
            }
          }
        }).result.then(function () {
          if (ctrl.order && ctrl.order.id) {
            $api.orders.single.get({ id: ctrl.order.id }, function (response) {
              if (response.status === 'success' && response.data && response.data.medical_note_id !== undefined) {
                ctrl.order.medical_note_id = response.data.medical_note_id;
              }
            });
          }
        });
      };

      ctrl.add_form = function() {
        if (ctrl.form.customer) {
          if (ctrl.order && ctrl.order.digital_form && ctrl.order.digital_form.length) {
            $uibModal.open({
              templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
              controller: "CustomersDigitalFormsController",
              controllerAs: "ctrl",
              scope: $scope,
              mediumModal: true,
              windowTopClass: "form-modal medium-modal laser-file-modal",
              resolve: {
                Customer: ['$api', function ($api) {
                    return $api.resolve('customers.single@get', { id: ctrl.form.customer.id });
                  }
                ],
                DigitalForm: null,
                DigitalForms: ['$api', function($api) {
                    return ctrl.order.digital_form;
                  }
                ],
                Business: [ '$api', function ($api) {
                    return $api.resolve('settings.info@get');
                  }
                ],
                Order: ctrl.order
              }
            }).result.then(function (response) {
              if (response) {
                ctrl.order.digital_form = response;
              }
            });
          } else {
            $uibModal.open({
                templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                controller: "CustomersDigitalFormsAddController",
                controllerAs: "ctrl",
                scope: $scope,
                mediumModal: true,
                windowTopClass: "form-modal medium-modal laser-file-modal",
                resolve: {
                  Customer: {data: ctrl.form.customer},
                  Order: ctrl.order,
                  OrderForm: true,
                  DigitalForm: ctrl.prepared_form ? ctrl.prepared_form : null,
                  DigitalForms: ['$api', function($api) {
                    return $api.resolve("digital_forms@get");
                  }]
                }
              }).result.then(function (result) {
                if (result && result.form_data) {
                  ctrl.order.digital_form = result.form_data;
                } else if (result) {
                  ctrl.prepared_form = result;
                }
              });
          }
        }
      }

      ctrl.savePreparedDF = function (order_id) {
        if (ctrl.prepared_form) {
          ctrl.prepared_form.order_id = order_id;
          ctrl.prepared_form.customer_id = ctrl.form.customer && ctrl.form.customer.id ? ctrl.form.customer.id : null;
          $api.customer_forms.new.save({
              id: ctrl.prepared_form.id,
              data: ctrl.prepared_form,
          }, function (response) {
              if (response.status === "success") {
              }
          });
        }

        ctrl.prepared_form = false;
      }

      ctrl.enable_second_change = function ($orderItemIndex) {
        if (ctrl.form.items[$orderItemIndex].enabled_second) {
          
          if (ctrl.form.items[$orderItemIndex].item.break) {
            ctrl.form.items[$orderItemIndex].resource_second = ctrl.form.items[$orderItemIndex].resource;
            if(ctrl.form.items[$orderItemIndex].item.duration_second && ctrl.form.items[$orderItemIndex].item.duration_second != '-1') {
              ctrl.form.items[$orderItemIndex].duration_second = String(ctrl.form.items[$orderItemIndex].item.duration_second);
            } else {
              ctrl.form.items[$orderItemIndex].duration_second = undefined;
            }
            
            var newDateObj = new Date('01/01/2023 '+ctrl.form.items[$orderItemIndex].start_time);
            var date = new Date(newDateObj.getTime() + (ctrl.form.items[$orderItemIndex].item.break+(ctrl.form.items[$orderItemIndex].duration*1))*60000);
            ctrl.form.items[$orderItemIndex].start_time_second = date.getHours() + ':' + date.getMinutes();
          }
        }
      };

      ctrl.order_item_resource_change = function ($orderItemIndex) {
        var orderItem = ctrl.form.items[$orderItemIndex];
        if (!orderItem) {
          return;
        }

        ctrl.saveOriginalItemsData($orderItemIndex);
        ctrl.multiServiceSelectedItems[$orderItemIndex] = orderItem.item_id;
        orderItem.enabled_second = false;

        if (!orderItem.item) {
          return;
        }

        if(orderItem.item.duration && orderItem.item.duration != '-1') {
          orderItem.duration = String(orderItem.item.duration);
        } else {
          orderItem.duration = undefined;
        }

        if (orderItem.item.break) {
          orderItem.enabled_second = true;
          orderItem.resource_second = orderItem.resource;
          if(orderItem.item.duration_second && orderItem.item.duration_second != '-1') {
            orderItem.duration_second = String(orderItem.item.duration_second);
          } else {
            orderItem.duration_second = undefined;
          }
          

          var newDateObj = new Date('01/01/2023 '+orderItem.start_time);
          var date = new Date(newDateObj.getTime() + (orderItem.item.break+(orderItem.duration*1))*60000);
          orderItem.start_time_second = date.getHours() + ':' + date.getMinutes();
        }

        ctrl.calculate_totals();
      };

      ctrl.saveOriginalItemsData = function($orderItemIndex) {
        if (!ctrl.items || !ctrl.items.length || !ctrl.form.items[$orderItemIndex]) {
          return;
        }

        for (var i in ctrl.items) {
          if (ctrl.items[i].id == ctrl.form.items[$orderItemIndex].item_id) {
            ctrl.form.items[$orderItemIndex].item = angular.copy(ctrl.items[i]);
          }
        }
      }

      ctrl.addNewCustomer = function () {
        $uibModal.open({
          templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
          controller: "CustomersFormController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal side-modal",
          resolve: {
            Customer: null,
            isModal: true,
            Lead: false,
            Info: ['$api', function ($api) {
              return $api.resolve("settings.info@get");
            }],
            Resources: ['$api', function ($api) {
              return $api.resolve("resources@get");
            }],
            Statuses: ['$api', function ($api) {
              return $api.resolve("statuses@get");
            }],
            Interested: ['$api', function ($api) {
              return $api.resolve("interested@get");
            }],
            Phone: function () {
              return ctrl.searchResult.length ? null : ctrl.customer_search_name;
            },
            CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
              return $api.resolve("customFields.all@get");
            }],
          }
        }).result.then(function (new_customer) {
          // after creating new customer, update form data
          // ctrl.customers.push(new_customer);
          ctrl.customer = new_customer;
          ctrl.form.customer = new_customer;
          // hide list
          ctrl.showCustomerSelect = false;
          setTimeout(function(){
            ctrl.customer_selected();
            // show list
            ctrl.showCustomerSelect = true;
          //     // rerender customer select
          //     angular.element("#customers_select").val(new_customer.id).trigger('chosen:updated');
          },100);
        });
      }

      ctrl.form_validate = function() {
        //console.log($scope.orderForm.$error.required);
      }

      ctrl.openSelectCustomer = function() {
        $uibModal.open({
          templateUrl: "app/modules/customers/popup/customers.popup.html",
          controller: "CustomersSelectController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal"
        }).result.then(function (selected_customer) {
          ctrl.customer = selected_customer;
          ctrl.form.customer = selected_customer;
          ctrl.customer_selected();
        });
      }

      ctrl.openSelectItem = function($orderItemIndex, orderItem, course) {
        course = course || false;
        temp = [];
        for( var i in ctrl.items) {
          if(!course && ctrl.items[i].item_type == orderItem.item_type && (!ctrl.items[i].inactive || ctrl.items[i].id == orderItem.item_id))
            temp.push(ctrl.items[i]);

          if(course && orderItem.item_type == 'course' && (!ctrl.items[i].inactive || ctrl.items[i].id == ctrl.form.item_id))
            temp.push(ctrl.items[i]);
        }
        $uibModal.open({
          templateUrl: "app/modules/settings/items/popup/items.popup.html",
          controller: "ItemsSelectController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal medium-modal select-item-modal",
          resolve: {
            Items: [function () {
              return temp;
            }]
          }
        }).result.then(function (selected_item) {
            if (selected_item) {
              if (course)  {
                ctrl.form.item_id = ("" + selected_item.id);
              } else {
                ctrl.form.items[$orderItemIndex].item_id = ("" + selected_item.id);
                for (var i in ctrl.items) {
                  if (ctrl.items[i].id == ctrl.form.items[$orderItemIndex].item_id) {
                    ctrl.form.items[$orderItemIndex].item = ctrl.items[i];
                  }
                }
                ctrl.order_item_resource_change($orderItemIndex);
              }
            }
        });
    }

      ctrl.customers_select_onclick = function() {
        if (ctrl.isMobile) {
          ctrl.openSelectCustomer();
          return false;
        } else {
          return true;
        }
      }

      ctrl.send_order_prepaid = function () {
        var order_data = {};
        order_data.id = ctrl.order.id;
        order_data.type = "send_prepaid";
        if( typeof(ctrl.form.customer) == "object" && ctrl.form.customer !== null) {
          order_data.customer = ctrl.form.customer.id;
        }

        $api.orders.save(order_data, function (response) {
          $tiff_page.stop_loading('save_order');
          if (response.status === "success") {
            $uibModalStack.dismissAll();
            swal({
              title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      }

      ctrl.send_order_sms = function () {
        swal({
            title: '',
            text: $translate.instant('CONFIRM_SEND_SMS'),
            type: "warning",
            showCancelButton: true,
            confirmButtonText: $translate.instant('OPTION_YES'),
            cancelButtonText: $translate.instant('OPTION_NO'),
        }).then(function (res) {
            if (res.value) {
                ctrl.send_order_sms_approved();
            }
        });
      }

      ctrl.send_order_sms_approved = function () {
        var order_data = JSON.parse(JSON.stringify(ctrl.form));
        order_data.date = moment(ctrl.form.date).format("YYYY-MM-DD HH:mm");
        if( typeof(order_data.customer) == "object" && order_data.customer !== null) {
          order_data.customer = order_data.customer.id;
          order_data.allow_sending = ctrl.allow_sending;
          order_data.not_send_message = ctrl.form.not_send_message;
        }
        if(ctrl.order && ctrl.order.status == 4) {
          order_data.status = 0;
          order_data.booking_approved = true;
        }

        order_data.type = "send_sms";
        order_data.id = ctrl.order.id;

        $api.orders.save(order_data, function (response) {
          $tiff_page.stop_loading('save_order');
          if (response.status === "success") {
            $uibModalStack.dismissAll();
            swal({
              title: $translate.instant('SWAL_ORDERS_SAVE_TITLE'),
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      }

      ctrl.send_approval_request = function () {
        $uibModal.open({
          templateUrl: "app/modules/approvalrequest/approvalrequest.view.html",
          controller: "ApprovalRequestController",
          controllerAs: "ctrl",
          scope: $scope,
          windowTopClass: "form-modal small-modal",
          resolve: {
            OrderId: ctrl.order.id
          }
        }).result.then(function (send_method) {
          if(typeof(send_method) != 'undefined'){
            ctrl.request_approval(send_method);
            $uibModalStack.dismissAll();
          }
        });
      }

      // Send request approval from customer
      ctrl.request_approval = function (send_method) {
        var send_method_name = "";
        // console.log("send_method", send_method);
        if (!send_method || send_method === null) return;
        switch (send_method) {
          case 1:
            send_method_name = "email";
            break;
          case 2:
            send_method_name = "sms";
            break;
          // case 3:
          //   send_method_name = "whatsapp";
          //   break;
        }
        $tiff_page.start_loading('request_approval');
        $api.orders.request_approval.get({
          order_id: ctrl.order.id,
          send_method: send_method,
          method_name: send_method_name,
          email: ctrl.form.email,
          phone: ctrl.form.phone,
          request_feedback: ctrl.form.request_feedback,
          hostname: window.location.hostname,
          customer_first_name: ctrl.form.customer ? ctrl.form.customer.firstname : ctrl.form.customer_name
        }, function (response) {
          $tiff_page.stop_loading('request_approval');
          if (response.status === "success") {
            swal({
              title: $translate.instant('SWAL_ORDERS_REQUEST_APPROVAL_TITLE'),
              text: "",
              type: "success",
              confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
              timer: 2000
            });
          }
        });
      }

        ctrl.delete_event = function () {
          if (ctrl.form.repeat) {
            swal({
              title: "",
              text: $translate.instant('ORDER_EVENT_DELETE_CONFIRMATION'),
              type: 'info',
              showCancelButton: true,
              confirmButtonText: $translate.instant('ORDER_EVENT_DELETE_CONFIRMATION_ALL'),
              cancelButtonText: $translate.instant('ORDER_EVENT_DELETE_CONFIRMATION_CURRENT'),
              confirmButtonClass: "btn-primary",
              cancelButtonClass: "btn-primary",
              closeOnConfirm: false,
              showLoaderOnConfirm: false
            }).then(function(result) {
              if (result.dismiss && result.dismiss == "overlay") {
                return;
              }
              ctrl.confirm_delete_event(result.value ? true : false);
            });
          } else {
            ctrl.confirm_delete_event(false);
          }

        };
      ctrl.confirm_delete_event = function (all) {
        $tiff_page.start_loading('delete_event');
        $api.events.single.delete({
            id: ctrl.event.id,
            all: all*1
        }, function (response) {
            $tiff_page.stop_loading('delete_event');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_DELETE_EVENT_TITLE'),
                    text: "",
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.confirm_delete_course = function () {
        $tiff_page.start_loading('delete_course');
        $api.courses.single.delete({
            id: ctrl.course.id
        }, function (response) {
            $tiff_page.stop_loading('delete_course');
            $uibModalStack.dismissAll();
            if (response.status === "success") {
                swal({
                    title: $translate.instant('SWAL_ORDERS_DELETE_COURSE_TITLE'),
                    text: "",
                    type: "success",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            }
        });
      }

      ctrl.reminderText = function() {
        var text = '';
        var order_data = JSON.parse(JSON.stringify(ctrl.form));
        if (order_data.items) {
          order_data.date = moment(ctrl.form.date).format("DD-MM-YYYY");
          
          order_data.items.sort(compareTimes);
          var first_item = order_data.items[0];

          for (var i in order_data.items) {
            var $item = order_data.items[i];
            var type_current = $item.item_data && $item.item_data.item_type ? $item.item_data.item_type : $item.item_type;
            var type_first = first_item.item_data && first_item.item_data.item_type ? first_item.item_data.item_type : first_item.item_type;
            if (!first_item || type_first !== 'service' || 
              (type_current === 'service' && $item['start_time'] && 
              new Date($item['start_time']).getTime() < new Date(first_item['start_time']).getTime())) {
              first_item = $item;
            }
          }

          var resource = ctrl.resources.find(function(resource) {
            return resource.id == first_item.resource;
          });

          var m_data = {
            'start_date': order_data.date,
            'start_time': first_item.start_time,
            'datetime': order_data.date + " " + first_item.start_time,
            'customer_name': order_data.customer ? order_data.customer.firstname + (order_data.customer.lastname ? " " + order_data.customer.lastname : "") : order_data.customer_name,
            'item_name': first_item.item_data.name,
            'businesses_name': ctrl.business.name,
            'week_day': moment(order_data.date).format('dddd'),
            'resource': resource ? resource.name : '',
          };

          text = ctrl.replaceMessageText(ctrl.order.reminder_text, m_data);
        }
        return encodeURIComponent(text);
      }

      function compareTimes(a, b) {
        var timeA = a.start_time;
        var timeB = b.start_time;
        
        if (timeA < timeB) {
          return -1;
        }
        if (timeA > timeB) {
          return 1;
        }
        return 0;
      }

      ctrl.msg_placeholders = {
        'customer_name': "[the customer's name]",
        'item_name': "[Item description]",
        'start_date': "[date]",
        'start_time': "[time]",
        'datetime': "[datetime]",
        'businesses_name': "[name of the business]",
        'order_id': "[order ID]",
        'link': "[link]",
        'week_day': "[week day]",
        'resource': "[resource]",
        "customer_name|he": "[שם הלקוח]",
        "item_name|he": "[שם המוצר]",
        "item_name|he2": "[שם הטיפול]",
        "start_date|he": "[תאריך]",
        "start_time|he": "[שעה]",
        "businesses_name|he": "[שם בית העסק]",
        "order_id|he": "[סכום יתרה]",
        'link|he': "[קישור]",
        'datetime|he': "[תאריך ושעת השירות]",
        'week_day|he': "[יום בשבוע]",
        'resource|he': "[שם העובד]",
      };

      ctrl.replaceMessageText = function(message, data) {
        if (typeof data.start_date !== 'undefined' && typeof data.start_time !== 'undefined') {
          data.datetime = data.start_date + ' ' + data.start_time;
        }

        var text = '';
        text = message;

        for (var key in ctrl.msg_placeholders) {
            if (ctrl.msg_placeholders.hasOwnProperty(key)) {
                var placeholder = ctrl.msg_placeholders[key];
                var replacedKey = key.replace('|he2', '').replace('|he', '');
        
                if (typeof data[replacedKey] !== 'undefined' && data[replacedKey] !== null) {
                  text = text.replace(placeholder, data[replacedKey]);
                }
            }
        }
      
        return text;
      }

      ctrl.waPhone = function() {
        var phone = ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone;
        var symbols = [' ', '-', '_', '(', ')', '+972', '+'];
        for (var s in symbols) {
          phone = phone.replace(symbols[s], '')
        }
        return '+972'+phone
      },

      $scope.$watch("ctrl.form.items", function () {
        if (ctrl.bu_type == 2) {
          for (var i in ctrl.form.items) {
            ctrl.motels_update_item_nights(i);
          }
        }
        ctrl.calculate_totals();
        ctrl.formItemsChangedNotSaved = angular.equals(ctrl.form.items, ctrl.originalFormItemsData) ? false : true;
      }, true);

      $scope.$watch("ctrl.form.request_feedback", function () {
        ctrl.formItemsChangedNotSaved = true;
      });

        /**
         * Load all customer's cards
         *
         * @param customer_id
         */
        ctrl.loadCustomersCards = function (customer_id) {
          ctrl.customerCards = $api.resolve("cards.customers@get", {"id": customer_id});
          $api.cards.customers.get({"id": customer_id}, function (response) {
              if (response.status == "success") {
                ctrl.customerCards = response.data;
                ctrl.matchCardsForItems();
              }
            }
          );
        }

        /**
         * Return Card for specific Item if customer has bought it
         *
         * @param item_id
         * @returns {boolean}
         */
        ctrl.getCustomerCardForItem = function (item_id) {
          var itemCard = false;
          if (ctrl.form.customer && angular.isArray(ctrl.customerCards)) {
            ctrl.customerCards.forEach(function (card) {
              if (card.item_id == item_id) {
                itemCard = card;
              }
            })
          }
          return itemCard;
        }

          /**
           * Check if customer has Card for particular Item with positive balance
           *
           * @param item_id
           * @returns {boolean}
           */
          ctrl.hasCustomerCardForItem = function(item_id) {
            var hasCard = false;
            var card = ctrl.getCustomerCardForItem(item_id);
            if(card && card.balance > 0) {
              if (card.expired) {
                hasCard = 'expired';
              } else {
                hasCard = true;
              }
            }
            return hasCard;
          }

          /**
           * Mark Item with card indicator property if customer has appropriate Card
           */
          ctrl.matchCardsForItems = function() {
            ctrl.items.forEach(function (item) {
              var card = ctrl.getCustomerCardForItem(item.id);
              if(card && card.balance > 0) {
                item.customer_has_card = true;
              } else {
                item.customer_has_card = false;
              }
              item.order_dropdown_label = ctrl.buildOrderItemDropdownLabel(item);
            });
            ctrl.itemsDropdownVersion++;
            if (ctrl.form && ctrl.form.items && ctrl.form.items.length) {
              for (var i = 0; i < ctrl.form.items.length; i++) {
                ctrl.form.items[i]._dropdownOptionsVersion = null;
              }
            }
          };

          /**
           * Add Card flag for Items that match Customer's Cards list
           *
           * @param item
           * @returns {string}
           */
          ctrl.addCardBadge = function(item) {
            var badge = ctrl.hasCustomerCardForItem(item.id);
            if(badge === true) {
              return  "<i class='las la-ticket-alt'></i> ";
            }
            if(badge === 'expired') {
              return  "<i class='las la-ticket-alt expired'></i> ";
            }

            return "";
          }

          ctrl.goToCashbox = function() {
            if(ctrl.formItemsChangedNotSaved) {
              ctrl.send_order_form(function (callBackFromCallback) {
                $state.go('app.cashbox.order', {orderID: ctrl.order.id}, {
                  reload: true
                });
                if(angular.isUndefined(callBackFromCallback)) {
                  callBackFromCallback();
                }
              });
            } else {
              $state.go('app.cashbox.order', {orderID: ctrl.order.id}, {
                reload: true
              });
            }
          }

          /**
           * Go to the previous location
            */
          ctrl.goBack = function() {
            if(ctrl.order && ctrl.is_edit && ctrl.order.status == 4) {
              $window.history.back();
            }
          }

      if (ctrl.is_edit || EventCopy) {
        ctrl.load_order_data();
      }


    // multiservice

    ctrl.toggleDropdown = function ($event) {
      $event.stopPropagation();
      ctrl.showMultiServiceDropdown = !ctrl.showMultiServiceDropdown;
    };

    ctrl.closeDropdown = function () {
      if (ctrl.showMultiServiceDropdown) {
        ctrl.multiServiceFilterText = '';
        ctrl.syncSelectedItems();
      }
      ctrl.showMultiServiceDropdown = false;
    };

    ctrl.toggleItem = function (item_id) {
      var index = ctrl.multiServiceSelectedItems.indexOf(item_id.toString());
      if (index === -1) {
        ctrl.multiServiceSelectedItems.push(item_id.toString());
      } else {
        ctrl.multiServiceSelectedItems.splice(index, 1);
      }
    };

    ctrl.isSelected = function (item_id) {
      return ctrl.multiServiceSelectedItems.indexOf(item_id.toString()) !== -1;
    };

    ctrl.syncSelectedItems = function () {
      var existed;

      // Add new items
      for (var i = 0; i < ctrl.multiServiceSelectedItems.length; i++) {
        existed = false;
        for (var j = 0; j < ctrl.form.items.length; j++) {
          var formItem = ctrl.form.items[j];

          if (!formItem.item_id) {
            ctrl.form.items[ctrl.form.items.length - 1].item_id = ctrl.multiServiceSelectedItems[i].toString();
            ctrl.order_item_resource_change(j);
            existed = true;
            break;
          } else if (formItem.item_id.toString() === ctrl.multiServiceSelectedItems[i].toString()) {
            existed = true;
            break;
          }
        }

        if (!existed) {
          ctrl.add_service_item();
          ctrl.form.items[ctrl.form.items.length - 1].item_id = ctrl.multiServiceSelectedItems[i].toString();
          ctrl.order_item_resource_change(ctrl.form.items.length - 1);
        }
      }

      // Remove items no longer selected
      for (var i = 0; i < ctrl.form.items.length; i++) {
        existed = false;
        for (var j = 0; j < ctrl.multiServiceSelectedItems.length; j++) {
          if (ctrl.form.items[i].item_id.toString() === ctrl.multiServiceSelectedItems[j].toString()) {
            existed = true;
            break;
          }
        }

        if (!existed) {
          if (ctrl.form.items.length > 1) {
            ctrl.remove_item_from_order(i);
            i--; // adjust index due to item removal
          } else {
            ctrl.form.items[i].item_id = null;
            ctrl.form.items[i].item = null;
            ctrl.form.items[i].duration = null;
            
          }
        }
      }
    };

    ctrl.isNoCustomerSelected = function() {
      return !((ctrl.form.customer && ctrl.form.customer.id) || ctrl.form.randomCustomer);
    }

    ctrl.copyId = function(id) {
      navigator.clipboard.writeText(id).then(function() {
          ctrl.copied = true;
          setTimeout(function() {
              ctrl.copied = false;
          }, 3000);
      }).catch(function(error) {
          console.error('Failed to copy URL: ', error);
      });
    };

    ctrl.openAiSession = function() {
      var sessionId = ctrl.order && ctrl.order.session_id_book ? ctrl.order.session_id_book : '';
        if (!sessionId) {
          return;
        }

        $uibModal.open({
          templateUrl: 'app/modules/settings/ai_agents/agent_booking/agent_booking_history.view.html',
          controller: 'AgentBookingHistoryController',
          controllerAs: 'ctrl',
          windowTopClass: 'form-modal medium-modal',
          resolve: {
            sessionId: function () {
              return sessionId;
            }
          }
        });
    }
  }]);
})();

(function() {

    angular.module("app.controllers").controller("StoreFilterController", function($scope, Data, $rootScope, $user, $api, $translate) {

        var ctrl = this;
        ctrl.form = {
          name: '',
          default: '',
          module: Data.module,
          data: Data.filter,
        };

        ctrl.submit = function() {

          $api.filters.save(ctrl.form,
            function(res){
              swal({
                title: $translate.instant('STORE_FILTER_STORED'),
                text: "",
                type: "success",
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                timer: 1500
              });
              $user.getFilters();
              $scope.$close();
            },
          function (res) {            
          });
        }
    });

})();

(function () {
  'use strict';

  angular.module('app.controllers').controller('AppTextareaMaskController', [
    '$document', '$element', '$scope', '$timeout',
    function ($document, $element, $scope, $timeout) {
      var ctrl = this;
      var outsideClickHandler = null;

      ctrl.$onInit = function () {
        ctrl.rows = ctrl.rows || 5;
        ctrl.trim = ctrl.trim === true;
        ctrl.isOpen = false;
      };

      ctrl.$onChanges = function (changes) {
        if (changes.rows && changes.rows.currentValue) {
          ctrl.rows = changes.rows.currentValue;
        }
        if (changes.trim) {
          ctrl.trim = changes.trim.currentValue === true;
        }
      };

      ctrl.$onDestroy = function () {
        _unbindOutsideClick();
      };

      ctrl.handleChange = function () {
        if (ctrl.onChange) {
          ctrl.onChange({ model: ctrl.model });
        }
      };

      ctrl.toggleMasks = function ($event) {
        if ($event) $event.stopPropagation();
        if (ctrl.disabled || ctrl.readonly) return;
        ctrl.isOpen ? ctrl.closeMasks() : ctrl.openMasks();
      };

      ctrl.openMasks = function () {
        if (!ctrl.masks || !ctrl.masks.length) return;
        ctrl.isOpen = true;
        _bindOutsideClick();
      };

      ctrl.closeMasks = function () {
        ctrl.isOpen = false;
        _unbindOutsideClick();
      };

      ctrl.insertMask = function ($event, mask) {
        if ($event) $event.stopPropagation();
        if (!mask || ctrl.disabled || ctrl.readonly) return;

        var textarea = _getTextarea();
        if (!textarea) return;

        var insertValue = _resolveMaskValue(mask);
        if (!insertValue) return;

        var start = textarea.selectionStart || 0;
        var end = textarea.selectionEnd || 0;
        var text = (ctrl.model !== undefined && ctrl.model !== null) ? String(ctrl.model) : '';

        ctrl.model = text.substring(0, start) + insertValue + text.substring(end);
        ctrl.handleChange();

        $timeout(function () {
          var nextPos = start + insertValue.length;
          textarea.focus();
          textarea.setSelectionRange(nextPos, nextPos);
        }, 0);

        ctrl.closeMasks();
      };

      ctrl.hasMasks = function () {
        return Array.isArray(ctrl.masks) && ctrl.masks.length > 0;
      };

      ctrl.getMaskLabel = function (mask) {
        if (!mask) return '';
        return mask.label || mask.labelKey || mask.key || '';
      };

      ctrl.getMaskTitle = function (mask) {
        if (!mask) return '';
        return mask.title || mask.titleKey || ctrl.getMaskLabel(mask);
      };

      function _resolveMaskValue(mask) {
        if (ctrl.maskResolver) {
          var resolved = ctrl.maskResolver({ mask: mask });
          if (resolved !== undefined && resolved !== null && resolved !== '') {
            return String(resolved);
          }
        }

        if (mask.value !== undefined && mask.value !== null && mask.value !== '') {
          return String(mask.value);
        }

        if (mask.key) {
          return '[' + mask.key + ']';
        }

        return '';
      }

      function _getTextarea() {
        return $element[0].querySelector('.app-textarea-mask__field');
      }

      function _bindOutsideClick() {
        _unbindOutsideClick();
        outsideClickHandler = function (evt) {
          if ($element[0].contains(evt.target)) return;
          $scope.$applyAsync(function () {
            ctrl.closeMasks();
          });
        };
        $document.on('click', outsideClickHandler);
      }

      function _unbindOutsideClick() {
        if (outsideClickHandler) {
          $document.off('click', outsideClickHandler);
          outsideClickHandler = null;
        }
      }
    }
  ]);
})();

(function () {
  'use strict';

  angular.module('app.components').component('appTextareaMask', {
    bindings: {
      /**
       * model: two-way binding — textarea value.
       */
      model: '=',

      /**
       * masks: one-way array of available masks.
       * Supports objects like:
       * { key, value, label, labelKey, title, titleKey }
       */
      masks: '<',

      /**
       * label: optional field label shown above the textarea.
       */
      label: '@?',

      /**
       * placeholder: native textarea placeholder.
       */
      placeholder: '@?',

      /**
       * rows: textarea rows. Defaults to 5.
       */
      rows: '<?',

      /**
       * disabled / readonly: native textarea states.
       */
      disabled: '<?',
      readonly: '<?',

      /**
       * trim: controls ng-trim. Defaults to false.
       */
      trim: '<?',

      /**
       * onChange: expression callback with { model }.
       */
      onChange: '&?',

      /**
       * maskResolver: expression callback with { mask } that returns
       * final placeholder text to insert into textarea.
       */
      maskResolver: '&?',
    },
    controllerAs: '$ctrl',
    templateUrl: 'app/components/app/app-textarea-mask/app-textarea-mask.view.html',
    controller: 'AppTextareaMaskController',
  });
})();

(function () {
  'use strict';

  angular.module('app.controllers').controller('AppInputController', [
    function () {
      var ctrl = this;

      ctrl.$onInit = function () {
        ctrl.type = ctrl.type || 'text';
        ctrl.rows = ctrl.rows || 3;
        ctrl.clearable = ctrl.clearable === true;
      };

      ctrl.handleChange = function () {
        if (ctrl.onChange) {
          ctrl.onChange({ model: ctrl.model });
        }
      };

      ctrl.handleBlur = function ($event) {
        if (ctrl.onBlur) {
          ctrl.onBlur({ $event: $event, model: ctrl.model });
        }
      };

      ctrl.handleFocus = function ($event) {
        if (ctrl.onFocus) {
          ctrl.onFocus({ $event: $event, model: ctrl.model });
        }
      };

      ctrl.clear = function () {
        if (ctrl.disabled || ctrl.readonly) return;
        ctrl.model = ctrl.multiline ? '' : '';
        ctrl.handleChange();
      };

      ctrl.hasValue = function () {
        return ctrl.model !== null && ctrl.model !== undefined && ctrl.model !== '';
      };
    }
  ]);
})();


(function () {
  'use strict';

  angular.module('app.components').component('appInput', {
    bindings: {
      /**
       * model: two-way binding — the input value.
       */
      model: '=?',

      /**
       * value: string — read-only display value for computed fields.
       */
      value: '@?',

      /**
       * type: string — input type (text, email, number, password, etc.).
       * Defaults to 'text'.
       */
      type: '@?',

      /**
       * name: string — native input name.
       */
      name: '@?',

      /**
       * label: string — field label shown above the input.
       */
      label: '@?',

      /**
       * placeholder: string — native placeholder.
       */
      placeholder: '@?',

      /**
       * maxlength: number — maximum input length.
       */
      maxlength: '<?',

      /**
       * disabled: boolean — disables the input.
       */
      disabled: '<?',

      /**
       * readonly: boolean — read-only state.
       */
      readonly: '<?',

      /**
       * required: boolean — marks the native control as required.
       */
      required: '<?',

      /**
       * multiline: boolean — when true, renders a textarea instead of input.
       */
      multiline: '<?',

      /**
       * rows: number — textarea rows when multiline is true.
       */
      rows: '<?',

      /**
       * error: string — validation error text (red).
       */
      error: '@?',

      /**
       * hint: string — additional helper text below the input.
       */
      hint: '@?',

      /**
       * loading: boolean — shows a small loader icon inside the field.
       */
      loading: '<?',

      /**
       * clearable: boolean — shows clear (reset) icon when there is a value.
       * Defaults to false.
       */
      clearable: '<?',

      /**
       * simple: boolean — compact, borderless input style.
       */
      simple: '<?',

      /**
       * onChange: expression — fired after the value changes.
       * Receives { model } in the expression context.
       */
      onChange: '&?',

      /**
       * onBlur / onFocus: expressions — native focus/blur events.
       */
      onBlur: '&?',
      onFocus: '&?',
    },
    controllerAs: '$ctrl',
    templateUrl: 'app/components/app/app-input/app-input.view.html',
    controller: 'AppInputController',
  });
})();


(function () {
  'use strict';

  angular.module('app.controllers').controller('AppButtonController', function () {
    var ctrl = this;

    function buildClasses() {
      var variant = ctrl.variant || 'text';
      var classes = ['btn', variant];

      if (ctrl.color) {
        if (ctrl.outlined) {
          if (variant === 'icon') {
            // icon variant: .bordered + .<color>
            classes.push('bordered');
            classes.push(ctrl.color);
          } else {
            // text variant: .border-<color>
            classes.push('border-' + ctrl.color);
          }
        } else {
          classes.push(ctrl.color);
        }
      }

      if (ctrl.size) {
        classes.push(ctrl.size);
      }
      if (ctrl.circle) {
        classes.push('circle');
      }
      if (ctrl.simple && variant === 'icon') {
        classes.push('simple');
      }
      if (ctrl.loading) {
        classes.push('loading');
      }

      ctrl.classes = classes.join(' ');
    }

    ctrl.$onChanges = function () {
      buildClasses();
    };

    ctrl.handleClick = function ($event) {
      if (ctrl.disabled || ctrl.loading) {
        return;
      }
      if (ctrl.onClick) {
        ctrl.onClick({ $event: $event });
      }
    };
  });
})();

(function () {
  'use strict';

  angular.module('app.components').component('appButton', {
    bindings: {
      /**
       * variant: 'text' (default) | 'icon'
       *   'text'  → .btn.text  — standard labeled button
       *   'icon'  → .btn.icon  — square/circle icon-only button
       */
      variant: '@?',

      /**
       * color: base color name.
       *
       * For variant='text':
       *   'primary'     → filled with brand color, white text
       *   'simple'      → transparent background, brand-color border
       *   'transparent' → no background, brand color text
       *   'success'     → green tint
       *   'warning'     → yellow tint
       *   'error'       → red tint
       *   'purple'      → purple tint
       *   'blue'        → blue tint
       *   'orange'      → orange tint
       *
       * For variant='icon':
       *   'default' → standard icon button (white bg)
       *   'primary' → brand color
       *   'red'     → red color
       *   'green'   → green color
       *   'blue'    → blue color
       *
       * When `outlined=true` the color is rendered as .border-{color}.
       */
      color: '@?',

      /**
       * outlined: boolean
       * When true, renders the button as an outlined (border) style.
       * Combines with `color` to produce .border-{color}, e.g.:
       *   color="primary" outlined  → .btn.text.border-primary
       *   color="red"     outlined  → .btn.text.border-red
       * For icon buttons adds .bordered instead, with the color class alongside.
       */
      outlined: '<?',

      /**
       * size: 'small' | 'large'
       * Omit for the default (36px) size.
       */
      size: '@?',

      /**
       * type: 'button' (default) | 'submit'
       */
      type: '@?',

      /**
       * icon: icon class string, e.g. 'las la-plus'
       * Rendered as <i class="..."> inside the button.
       */
      icon: '@?',

      /**
       * circle: boolean — adds .circle to icon buttons for a round shape.
       */
      circle: '<?',

      /**
       * simple: boolean
       *   icon variant → transparent background / no background
       */
      simple: '<?',

      /**
       * disabled: boolean — disables the button.
       */
      disabled: '<?',

      /**
       * loading: boolean — shows loading spinner overlay and disables the button.
       */
      loading: '<?',

      /**
       * onClick: expression — called on click with { $event }.
       * Not called when disabled or loading.
       */
      onClick: '&?',
    },
    transclude: true,
    controllerAs: '$ctrl',
    templateUrl: 'app/components/app/app-button/app-button.view.html',
    controller: 'AppButtonController',
  });
})();

(function () {
    angular.module("app.controllers").controller("TutorialsCenterController", function ($scope, $header, $state, $api, $rootScope, $http, $translate, $timeout, $uibModal, $sce) {
        if ($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $header.title = "NAV_TUTORIALS";
        $header.breadcrumbs.push({
            "title": "NAV_TUTORIALS"
        });

        var ctrl = this;
        
        ctrl.playlistId = 'PLCp_SGV306bi-J7b9ABOhXNr4Nd3bjxma';
        
        ctrl.loading = false;
        ctrl.error = null;
        ctrl.videos = [];
        
        ctrl.init = function() {
            ctrl.loadVideos();
        };
        
        ctrl.loadVideos = function() {
            ctrl.loading = true;
            ctrl.error = null;
            ctrl.fetchAllVideos();
        };
        
        ctrl.fetchAllVideos = function() {
            var youtubeDone = false;
            var customDone = false;
            var youtubeVideos = [];
            var customVideos = [];
            
            function tryFinish() {
                if (!youtubeDone || !customDone) return;
                var merged = youtubeVideos.concat(customVideos);
                merged.sort(function(a, b) {
                    var dateA = new Date(a.publishedAt || 0).getTime();
                    var dateB = new Date(b.publishedAt || 0).getTime();
                    return dateB - dateA;
                });
                ctrl.videos = merged;
                ctrl.loading = false;
            }
            
            $api.tutorials.playlist.get({playlist_id: ctrl.playlistId}, function(response) {
                youtubeDone = true;
                if (response.status === 'success' && response.data) {
                    youtubeVideos = response.data;
                }
                tryFinish();
            }, function() {
                youtubeDone = true;
                tryFinish();
            });
            
            $api.tutorials.custom.get({}, function(response) {
                customDone = true;
                if (response.status === 'success' && response.data) {
                    customVideos = (response.data || []).map(function(v) {
                        return {
                            id: v.id,
                            title: v.title,
                            videoId: v.videoId,
                            thumbnail: v.thumbnail || '',
                            publishedAt: v.publishedAt,
                            video_url: v.video_url,
                            isCustom: true
                        };
                    });
                }
                tryFinish();
            }, function() {
                customDone = true;
                tryFinish();
            });
        };
        
        ctrl.openVideo = function(video) {
            $uibModal.open({
                templateUrl: 'app/modules/tutorials_center/video.modal.html',
                controller: function($scope, $uibModalInstance, Video, $sce, $translate) {
                    var vm = this;
                    vm.video = Video;
                    vm.isCustom = Video.isCustom || false;
                    vm.getEmbedUrl = function() {
                        if (vm.isCustom && vm.video.video_url) {
                            return $sce.trustAsResourceUrl(vm.video.video_url);
                        }
                        return $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + vm.video.videoId + '?autoplay=1&rel=0');
                    };
                    vm.stopVideo = function() {
                        $uibModalInstance.close();
                    };
                    vm.close = function() { $uibModalInstance.close(); };
                },
                controllerAs: 'vm',
                windowTopClass: 'form-modal medium-modal video-modal',
                backdrop: 'static',
                keyboard: true,
                scope: $scope,
                resolve: {
                    Video: function() { return video; }
                }
            });
        };
        
        ctrl.init();
    });
})();
(function(){
    angular.module('app.controllers').controller('TermsOfUseController', function($api, $state, $location){

        var ctrl = this;
        console.log(ctrl);
    });
})();
(function(){
    angular.module('app.controllers').controller('SettingsController', function($header, $state, $window, $rootScope, Info){

        if($rootScope.userRole === 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        $rootScope.bu_type = parseInt(Info.data.type);
        $header.title = "NAV_SETTINGS";

        $rootScope.second_resource = Info.data.second_resource;
        $rootScope.second_resource_name = Info.data.second_resource_name;

        $header.breadcrumbs.push({
            "title": "NAV_SETTINGS"
        });

        var ctrl = this;
        ctrl.settings = Info.data;
        
    });
})();
(function () {

    angular.module('app.controllers')

        .controller('ReviewController', function(Order, IsPreview, $header, $api, $scope, $uibModalInstance, $window, $translate) {
  
            var ctrl = this;
            ctrl.stars = 0;
            ctrl.service = 0;
            ctrl.level_service = 0;
            ctrl.level_cleanliness = 0;
            ctrl.feedback = '';
            ctrl.is_review = false;
            $scope.isMobile = (angular.element(document).width() < 769);
            $scope.orderItem = Order.data;
            $scope.isPreview = IsPreview ? true: false;        

            ctrl.mainTitle = "Main Title";

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "NAV_REVIEW";
            $header.breadcrumbs.push({
                "title": "NAV_REVIEW"
            });

            ctrl.submit = function(){
                if (ctrl.stars > 0) {
                    $api.review.save({
                        id: $scope.orderItem.id,
                        stars: ctrl.stars,
                        service: ctrl.service,
                        level_service: ctrl.level_service,
                        level_cleanliness: ctrl.level_cleanliness,
                        text: ctrl.feedback
                    }, function (response) {
                        ctrl.is_review = true;
                        if (response.status === "success") {
                            swal({
                                title: $translate.instant('SWAL_REVIEW_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    });
                }
            }
        });
})();
(function () {
    angular.module('app.controllers')
        .controller('ReportsController', function ($header, $api, $scope, $cfilter, dates, DTOptionsBuilder, Info, dataTablesHebrewProvider, $state, $stateParams, $rootScope, $uibModal, Resources, $translate, $timeout) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }
            $scope.showDownloadBtn = false;

            var ctrl = this;
            ctrl.customers = [];
            ctrl.start_date = moment().startOf('month');
            ctrl.end_date = moment();
            ctrl.mainMobile = true;
            ctrl.mobileDropdown = false;
            ctrl.tab = parseInt($stateParams.tab, 10) || 4;
            ctrl.mainTitle = "Reports";
            ctrl.smsMaxLength = 800;
            ctrl.sendMessage = false;

            $scope.datesProvider = dates;

            ctrl.dealer_type = Info.data ? Info.data.dealer_type : '';

            if(Resources && angular.isDefined(Resources.data)) {
              ctrl.resources = Resources.data;
            }

            $scope.$watch("ctrl.tab", function(newValue, oldValue) {
                window.scrollTo( 0, 0 );
            });

            ctrl.tabList = {
                ALL: 4,
                DEBTORS: 7,
                MESSAGE: 6
                // ... TODO: should be filled with other tabs
            };

            if (ctrl.tab == 9) {
                $cfilter.apply('reports', true);
            } else if (ctrl.tab == 12) {
                $cfilter.apply('sales', true);
            }

            ctrl.ordersReportDefaultFieldSettings = [
                { name: 'resource_name', translationKey: 'REPORT_ORDERS_RES_COL', display: true },
                { name: 'customer_name', translationKey: 'SALES_REPORT_FIELD_CUSTOMER', display: true },
                { name: 'customer_phone', translationKey: 'CUSTOMERS_PHONE', display: true },
                { name: 'dealer_id', translationKey: 'DEALER_ID', display: true },
                { name: 'order_status', translationKey: 'REPORT_ORDERS_ORDER_STATUS_COL', display: true },
                { name: 'item_name', translationKey: 'REPORT_ORDERS_ITEM_COL', display: true },
                { name: 'order_date', translationKey: 'REPORT_ORDERS_DATE_COL', display: true },
                { name: 'item_start_time', translationKey: 'REPORT_ORDERS_START_COL', display: true },
                { name: 'item_end_time', translationKey: 'REPORT_ORDERS_END_COL', display: true },
                { name: 'item_duration', translationKey: 'REPORT_ORDERS_HOURS_COL', display: true },
                { name: 'item_price', translationKey: 'REPORT_ORDERS_PRICE_COL', display: true },
                { name: 'notes', translationKey: 'CUSTOMER_ORDER_HISTORY_NOTES', display: true }
            ];

            ctrl.resetOrdersReportFieldSettings = function() {
                var settings = [];
                var i;
                var field;

                for (i = 0; i < ctrl.ordersReportDefaultFieldSettings.length; i++) {
                    field = ctrl.ordersReportDefaultFieldSettings[i];
                    settings.push({
                        name: field.name,
                        translationKey: field.translationKey,
                        display: true
                    });
                }

                ctrl.ordersReportFieldSettings = settings;
                ctrl.rebuildOrdersReportVisibleFields();
            };

            ctrl.ordersReportVisibleFields = [];

            ctrl.rebuildOrdersReportVisibleFields = function() {
                var result = [];
                var i;
                var field;

                if (ctrl.ordersReportFieldSettings && ctrl.ordersReportFieldSettings.length > 0) {
                    for (i = 0; i < ctrl.ordersReportFieldSettings.length; i++) {
                        field = ctrl.ordersReportFieldSettings[i];
                        if (!field || !field.display) {
                            continue;
                        }
                        result.push(field);
                    }
                }

                if (result.length === 0) {
                    result = ctrl.ordersReportDefaultFieldSettings.slice();
                }

                ctrl.ordersReportVisibleFields = result;
            };

            ctrl.onOrdersReportFieldsUpdate = function(fieldsList) {
                ctrl.ordersReportFieldSettings = fieldsList;
                ctrl.rebuildOrdersReportVisibleFields();

                if ($scope.showTable && ctrl.form.order_type === 'items' && ctrl.form.report_type === 'detailed') {
                    $scope.showTable = false;
                    $timeout(function() {
                        $scope.showTable = true;
                    }, 0);
                }
            };

            ctrl.resetOrdersReportFieldSettings();

            ctrl.statusList = [
                { name: 'STATUS_OPEN', value: '0,2' },
                { name: 'STATUS_CANCELLED', value: 1 },
                // { name: 'STATUS_CLOSED', value: 2 },
                { name: 'STATUS_PAID', value: 3 },
                { name: 'STATUS_CUSTOMER_BOOKED', value: 4 },
                // { name: 'STATUS_BOOKING_DECLINED', value: 5 },
                // { name: 'STATUS_CANCELED_ONLINE', value: 6 },
                // { name: 'STATUS_PAID_LINK', value: 7 },
                // { name: 'STATUS_WAITING_ONLINE_PAYMENT', value: 8 },
            ];

            ctrl.genderOptions = [
                { id: '', name: $translate.instant('REPORT_OPTION_ALL') },
                { id: '0', name: $translate.instant('CUSTOMERS_GENDER_MALE') },
                { id: '1', name: $translate.instant('CUSTOMERS_GENDER_FEMALE') }
            ];

            ctrl.yesNoAllOptions = [
                { id: '', name: $translate.instant('REPORT_OPTION_ALL') },
                { id: '1', name: $translate.instant('OPTION_YES') },
                { id: '0', name: $translate.instant('OPTION_NO') }
            ];

            ctrl.reportTypeOptions = [
                { id: '', name: $translate.instant('REPORT_TYPE') },
                { id: 'detailed', name: $translate.instant('REPORT_TYPE_DETAIL') },
                { id: 'summary', name: $translate.instant('REPORT_TYPE_SUMMERY') }
            ];

            ctrl.statusFilterOptions = ctrl.statusList.map(function (status) {
                return {
                    name: status.name,
                    value: status.value,
                    label: $translate.instant('ORDER_' + status.name)
                };
            });

            ctrl.selectedStatuses = ctrl.statusFilterOptions.filter(function() {
                return true;
            });

            if(window.innerWidth < 768){
                ctrl.mainMobile = false;
                ctrl.mobileDropdown = true;
            }


            $scope.userConfig = {
                create: true
              };
            $scope.userConfig1 = {
                create: true,
                searchField: false,
                openOnFocus: false,
                hideSelected: true,
                onDropdownOpen: function(dropdown) {
                  dropdown.remove();
                }
              };
            ctrl.months = [];
            for( var i = 1 ;i < 25 ; i++) {
                month = {
                    'value': i,
                    'name': i+' months'
                };
                ctrl.months.push(month);
            }
            ctrl.tableData = [];

            ctrl.filter_table = function() {
                
                ctrl.tableData = [];
                ctrl.allTableData = [];

                if (ctrl.customers.length > 0) {
                    ctrl.fill_table_data();
                    return;
                }

                $api.customers.get(
                    {filter: ctrl.filter}
                    , function (result) {
                    if (result && result.data) {
                        ctrl.customers = result.data;
                        ctrl.fill_table_data();
                    }
                });

                
                // $.fn.DataTable.render;
            }

            ctrl.fill_table_data = function() {
                for(i in ctrl.customers) {
                    if((ctrl.tab != ctrl.tabList.DEBTORS) ||
                        (ctrl.tab == ctrl.tabList.DEBTORS && ctrl.customers[i].oncredit > 0)) {
                            ctrl.tableData.push(ctrl.customers[i]);
                    }
                }

                ctrl.allTableData = ctrl.tableData;
            }

            $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('searching', false)
                      .withOption('order', [[1, 'desc']]);
            $scope.dtOptions.searching = false;

            $scope.dtOptionsFeedback =
                DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('pageLength', 100)
                    .withOption('scrollY', '500px')
                    .withOption('searching', false)
                    .withOption('order', [[6, 'desc']]);
            $scope.dtOptionsFeedback.searching = false;

            //ctrl.filter_table();

            ctrl.setTitle = function (newTab) {
                switch (newTab) {
                    case 4:
                        $api.test(false);
                        ctrl.mainTitle = "Reports";
                        break;
                    case 7:
                        ctrl.mainTitle = "CUSTOMERS_DEBTS_REPORT_TITLE";
                        break;
                    default:
                        $api.test(true);
                        ctrl.mainTitle = "Revenue";
                        break;
                }
            }

            ctrl.orderType = function(order){
                if(order === "income"){
                    $api.test(false);
                    ctrl.setTab(3);
                } else if(typeof order === 'undefined'){
                    ctrl.setTab(1);
                } else if(order === "everything"){
                    ctrl.setTab(4);
                } else if(order === "cancelled"){
                    ctrl.setTab(2);
                } else if(order === "financial"){
                    ctrl.setTab(5);
                } else if(order === "customers"){
                    ctrl.setTab(10);
                }

            };

            ctrl.goToTransactions = function() {
                $state.go('app.settings.logs');
            }

            ctrl.openOrderModal = function(id) {
                $state.go('app.calendar.order-edit', {id: id});
            }  

            ctrl.setTab = function(newTab){
                if (newTab == 9) {
                    $cfilter.apply('reports', true);
                } else if (newTab == 12) {
                    $cfilter.apply('sales', true);
                }

                ctrl.setTitle(newTab);
                switch (newTab) {
                    case 4: {
                        $scope.showBack = false;
                        $scope.$emit('someEvent', "test");
                        break;
                    }
                    case 5:
                        break;

                    case 7:
                        ctrl.tab = newTab;
                        ctrl.filter_table();
                        return;

                    default: {
                        $scope.showBack = true;
                        $scope.$emit('click', "test");
                    }
                }
                
                $scope.showTable = false;
                return ctrl.tab = newTab;
            };

            ctrl.isSet = function(tabNum){
                if(tabNum === 4) {
                    $scope.showBack = false;
                }else {
                    $scope.showBack = true;
                }
                return ctrl.tab === tabNum;
            };

            $scope.showTable = false;

            ctrl.form = {
                start: moment(ctrl.start_date).format("YYYY-MM-DD"),
                end: moment(ctrl.end_date).format("YYYY-MM-DD"),
                statuses: [],
            };

            ctrl.request_in_progress = false;
            ctrl.preview_in_progress = false;
            ctrl.download_in_progress = false;
            ctrl.send_in_progress = false;
            ctrl.report_is_finished = false;

            /**
             * Triggers when hiting one of the buttons on "Create New Report" form
             * @return void
             */
            ctrl.create_new_report = function(export_type) {
                //console.log(ctrl.form.order_type);
                $scope.showTable = false;

                if(export_type == "preview"){
                    ctrl.preview_in_progress = true;
                    ctrl.request_in_progress = true;
                    ctrl.report_is_finished = true;
                }
                // else if(export_type == "download")
                //     ctrl.download_in_progress = true;
                else if(export_type == "sendbymail") {
                    ctrl.send_in_progress = true;
                }

                ctrl.form.action = export_type;
                ctrl.form.start = moment(ctrl.start_date).format("YYYY-MM-DD");
                ctrl.form.end = moment(ctrl.end_date).format("YYYY-MM-DD");

                if( ctrl.form.order_type == "financial") {
                    var $request = {
                        start: ctrl.form.start,
                        end: ctrl.form.end,
                        step: "start"
                    };
                    $api.financial.get($request, function(response) {
                        setTimeout( function() {
                            ctrl.check_financial_report_status();
                        }, 300);
                    });
                }
                else if( ctrl.form.order_type == "workers_time" ){
                    $api.workers.employee_transactions.get(ctrl.form, function(response) {
                        //console.log(response)
                            swal({
                                title: $translate.instant('SWAL_WORKER_TRANSACTION_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });

                        ctrl.request_in_progress = false;
                        ctrl.preview_in_progress = false;
                        ctrl.download_in_progress = false;
                        ctrl.send_in_progress = false;

                        // ctrl.report_is_finished = false;
                    });
                }
                else {
                    var statusCodes = [];
                    for (var key in ctrl.selectedStatuses) {
                        statusCodes.push(ctrl.selectedStatuses[key].value);
                    }

                    if (statusCodes.length !== 0) {
                        ctrl.form.statuses = statusCodes.join(',');
                    }

                    if (ctrl.tab == 9) {
                        ctrl.form.filter = $rootScope.reports_filter;
                        if (ctrl.form.report_type === 'detailed') {
                            ctrl.form.column_settings = JSON.stringify(ctrl.ordersReportFieldSettings);
                        } else {
                            ctrl.form.column_settings = null;
                        }
                    } else if (ctrl.tab == 12) {
                        ctrl.form.filter = $rootScope.sales_filter
                    }

                    $api.reports.get(ctrl.form, function(response) {
                        if(export_type == "sendbymail") {
                            swal({
                                title: $translate.instant('SWAL_REPORTS_GET_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        } else {
                            response.data.forEach(function(item){
                                item = ctrl.calculate_vat(item);
                                // Keep backend document_type_id if present; else use document_type or invoice_type (income report)
                                if (item['document_type_id'] == null) {
                                    item['document_type_id'] = item['document_type'] != null ? item['document_type'] : item['invoice_type'];
                                }
                                if (item['document_type'] != null) {
                                    item['document_type'] = "DOCUMENT_" + item['document_type'];
                                }
                            });
                            ctrl.tableData = response.data;
                            ctrl.allTableData = ctrl.tableData;
                            $scope.showTable = true;
                        }

                        ctrl.request_in_progress = false;
                        ctrl.preview_in_progress = false;
                        ctrl.download_in_progress = false;
                        ctrl.send_in_progress = false;

                        // ctrl.report_is_finished = false;
                    });
                }


            };

            ctrl.check_financial_report_status = function() {
                var $request = {
                    start: ctrl.form.start,
                    end: ctrl.form.end,
                    step: "status"
                };
                $api.financial.get($request, function(response) {
                    if(response.data.code == 2) {
                        ctrl.request_in_progress = false;
                        ctrl.preview_in_progress = false;
                        ctrl.download_in_progress = false;
                        ctrl.send_in_progress = false;
                        location.href = "http://dev.enm.co.il/tifulit/" + response.data.zip_link;
                        // window.open("http://dev.enm.co.il/tifulit/" + response.data.zip_link, "");
                    } else {
                        setTimeout( function() {
                            ctrl.check_financial_report_status();
                        }, 100);
                    }
                });
            }

            ctrl.calculate_vat = function(item) {
                var total = item.total_paid?item.total_paid:item.total;
                item.subtotal = parseFloat(total - item.vat).toFixed(2);
                item.vat = parseFloat(item.vat).toFixed(2);
                return item;
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "NAV_REPORTS";
            $header.breadcrumbs.push({
                "title": "NAV_REPORTS"
            });

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[1, 'desc']]);

            $scope.dtOptionsFeedback =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[3, 'desc']]);
            
            $scope.dtOptionsSales =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[0, 'desc']]);

            $scope.dtOptionsCards =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                    .withLanguage(dataTablesHebrewProvider)
                    .withOption('searching', false)
                    .withOption('order', [[0, 'asc']]);
            /**
             * Show popup for sending reminder about debt
             * @param customerData
             */
            ctrl.remind_customer_debt = function (customerData) {
                $uibModal.open({
                    templateUrl: "app/modules/reports/popups/debt-remind.view.html",
                    controller: "DebtRemindController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal small-modal",
                    resolve: {
                        customerData: customerData,
                        Messages: function () {
                            return $api.resolve("settings.messages@get");
                        }
                    }
                });
            }

            ctrl.allTableData = [];
            ctrl.searchTableData = function() {
                //reset data
                ctrl.tableData = ctrl.allTableData;
                
                if (ctrl.search_value) {
                    var newData = [];
                    for (var i in ctrl.tableData) {
                    var found = false;
                    for (var k in ctrl.tableData[i]) {
                        if (ctrl.tableData[i][k] && ctrl.tableData[i][k].toString().toLowerCase().indexOf(ctrl.search_value.toLowerCase()) > -1) {
                        found = true;
                        }
                    }

                    if (found) {
                        newData.push(ctrl.tableData[i]);
                    }
                    }

                    ctrl.tableData = newData;
                }
            }

            ctrl.calculateTotals = function() {
                var t = { qty: 0, total: 0 };
                for (var i = 0; i < ctrl.tableData.length; i++) {
                  var row = ctrl.tableData[i];
                  var qty = row.qty || 0;
                  var total = row.total || 0;
                  if (row.document_type_id == 5) {
                    t.qty   -= qty;
                  } else {
                    t.qty   += qty;
                  }

                  t.total += total;
                }
                return t;
              };

            /**
             * Show customers details
             * @param customer_id
             */
            ctrl.showCustomersDetails = function(customer_id) {
                $state.transitionTo("app.customers.single", {
                    "id": customer_id
                });
            }

        });
})();

(function(){
    angular.module('app.controllers').controller('PrepaidController', function (Order, $header, $rootScope, $api, $scope, $uibModalInstance, $window, $sce, $translate){

        var ctrl = this;

        ctrl.form = {};
        
        $scope.orderItem = Order ? Order.data : false;
        $scope.channelHash = $rootScope.generateUniqueId();

        if ($scope.orderItem && $scope.orderItem.business && $scope.orderItem.business['favicon_path']) {
            $('#favicon').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon.ico');
            $('#favicon-16').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon-16.png');
            $('#favicon-32').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon-32.png');
            $('#favicon-64').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon-64.png');
        }

        $scope.iframe = function(){
            if ($scope.orderItem) {
                var cardReader = false;
                var tamp = cardReader ? "9" : "6";
                var customer = $scope.orderItem.customer_name ? $scope.orderItem.customer_name : "לקוח לקוח";

                if ($scope.orderItem.business.cerdit_company == "1") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/yaad?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.business.prepaid + "&tmp=" + tamp + "&customer=" + customer + "&b_id=" + $scope.orderItem.business.id);
                } else if ($scope.orderItem.business.cerdit_company == "0") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/tranzila?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.business.prepaid);
                } else if ($scope.orderItem.business.cerdit_company == "2") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/pelecard?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&amount=" + $scope.orderItem.business.prepaid + "&reader=" + cardReader + "&b_id=" + $scope.orderItem.business.id);
                } else if ($scope.orderItem.business.cerdit_company == "3") {
                    return $sce.trustAsResourceUrl($api.baseURL + "/zcredit?id_hash="+$scope.channelHash+"&prepaid="+$scope.orderItem.id+"&amount=" + $scope.orderItem.business.prepaid + "&b_id=" + $scope.orderItem.business.id + "&iframe=1");
                }
            }

            return "";
        };

        var channel = (!pusher.channel('business-'+$scope.orderItem.business.id)) ? pusher.subscribe('business-'+$scope.orderItem.business.id) : pusher.channel('business-'+$scope.orderItem.business.id);
        channel.bind('iframe-result-'+$scope.channelHash, function(response) {
            if (response) {
                if (response.result == 'success') {
                    swal({
                        title: $translate.instant('SWAL_PEL_PAY_TITLE'),
                        text: "",
                        type: "success",
                    });
                } else if (response.result == 'error') {
                    var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                    if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                        message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                    }

                    swal({
                        title: response.message ? response.message : message,
                        text: $translate.instant('SWAL_PEL_PAY_ERROR_TEXT'),
                        type: "warning",
                    });
                }
            }
        });

        $scope.$on('$messageIncoming', function (event, data){
            if(data.msg == "Ok"){
                swal({
                    title: $translate.instant('SWAL_PEL_PREPAID_TITLE'),
                    text: "",
                    type: "success",
                    //confirmButtonText: "אישור",
                });
            }
            else if(data.msg == "Error"){

                var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                }

                
                swal({
                    title: message,
                    text: $translate.instant('SWAL_PEL_PREPAID_ERROR_TEXT'),
                    type: "warning",
                    //confirmButtonText: "אישור",
                    //timer: 3000
                });
            }

        });

    });
})();

(function () {
  angular.module("app.controllers").controller("PdfPreviewController", function ($scope, pdfUrl, imageUrl, $rootScope, $state, $sce) {
    if ($rootScope.userRole == 1) {
      $state.go('app.admin', {}, { reload: true });
      return;
    }

    var ctrl = this;
    ctrl.pdfUrl = pdfUrl ? $sce.trustAsResourceUrl('https://docs.google.com/gview?embedded=true&chrome=true&url=' + pdfUrl) : '';
    ctrl.imageUrl = imageUrl ? $sce.trustAsResourceUrl(imageUrl) : '';
  });
})();

(function(){
    angular.module('app.controllers').controller('PayController', function (Order, $rootScope, $header, $api, $scope, $window, $sce, $translate){

            var ctrl = this;

            ctrl.form = {};

            $scope.orderItem = Order ? Order.data : false;
            $scope.channelHash = $rootScope.generateUniqueId();
            $scope.items = [];

            if ($scope.orderItem && $scope.orderItem.business && $scope.orderItem.business['favicon_path']) {
                $('#favicon').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon.ico');
                $('#favicon-16').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon-16.png');
                $('#favicon-32').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon-32.png');
                $('#favicon-64').attr('href', $scope.orderItem.business['favicon_path'] + 'favicon-64.png');
            }

            if ($scope.orderItem && $scope.orderItem.data && $scope.orderItem.data.items) {
                for (var i in $scope.orderItem.data.items) {
                    $scope.items.push($scope.orderItem.data.items[i]);
                }
            }

            $scope.iframe = function(){
                if ($scope.orderItem) {
                    var cardReader = false;
                    var tamp = cardReader ? "9" : "6";
                    var customer = $scope.orderItem.customer_name ? $scope.orderItem.customer_name : "לקוח לקוח";
                    var npay = $scope.orderItem.data.numberOfPaymentsEmv && $scope.orderItem.data.numberOfPaymentsEmv*1 > 1 ? $scope.orderItem.data.numberOfPaymentsEmv : false;

                    if ($scope.orderItem.business.cerdit_company == "1") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/yaad?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&tmp=" + tamp + "&customer=" + customer + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay);
                    } else if ($scope.orderItem.business.cerdit_company == "0") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/tranzila?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&credit_suplier=" + $scope.orderItem.business.credit_suplier + "&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay);
                    } else if ($scope.orderItem.business.cerdit_company == "2") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/pelecard?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&reader=" + cardReader + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay);
                    } else if ($scope.orderItem.business.cerdit_company == "3") {
                        return $sce.trustAsResourceUrl($api.baseURL + "/zcredit?id_hash="+$scope.channelHash+"&pay="+$scope.orderItem.id+"&amount=" + $scope.orderItem.data.payments.pay_link.amount + "&b_id=" + $scope.orderItem.business.id + "&npay=" + npay + "&iframe=1");
                    }
                }

                return "";
            };

            if ($scope.orderItem) {
                var channel = (!pusher.channel('business-'+$scope.orderItem.business.id)) ? pusher.subscribe('business-'+$scope.orderItem.business.id) : pusher.channel('business-'+$scope.orderItem.business.id);
                channel.bind('iframe-result-'+$scope.channelHash, function(response) {
                    if (response) {
                        if (response.result == 'success') {
                            swal({
                                title: $translate.instant('SWAL_PEL_PAY_TITLE'),
                                text: "",
                                type: "success",
                            });
                        } else if (response.result == 'error') {
                            var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                            if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                                message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                            }

                            swal({
                                title: response.message ? response.message : message,
                                text: $translate.instant('SWAL_PEL_PAY_ERROR_TEXT'),
                                type: "warning",
                            });
                        }
                    }
                });
            }

            $scope.$on('$messageIncoming', function (event, data){
                if(data.msg == "Ok"){
                    swal({
                        title: $translate.instant('SWAL_PEL_PAY_TITLE'),
                        text: "",
                        type: "success",
                    });
                }
                else if(data.msg == "Error"){

                    var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');

                    if (data.code && (data.code == "010" || data.code == "550" || data.code == "500" || data.code == "004" || data.code == "006")) {
                        message = $translate.instant('PELACARD_MESSAGE_'+data.code);
                    }


                    swal({
                        title: message,
                        text: $translate.instant('SWAL_PEL_PAY_ERROR_TEXT'),
                        type: "warning",
                    });
                }

            });

        });
})();
(function () {
    angular.module('app.controllers')
        .controller('MarketingController', function ($header, $cfilter, $resource, $api, $scope, $tiff_page, dates, DTOptionsBuilder, dataTablesHebrewProvider, $state, $rootScope, $translate, $timeout, $cookies, $user) {


            if ($rootScope.userRole == 1){
              $state.go('app.admin', {}, {reload: true});
              return;
            }

            $header.title = "NAV_MARKETING";
            $header.breadcrumbs.push({
                "title": "NAV_MARKETING"
            });

            var ctrl = this;
            ctrl.customers = [];
            ctrl.tab = '';
            ctrl.smsMaxLength = 800;
            ctrl.sendMessage = false;
            ctrl.message = '';
            ctrl.files = [];
            var fileElement = null;

            ctrl.wa_status = $cookies.get("wa_status");

            // Texter WA cannot send free text in bulk — only approved marketing templates.
            ctrl.isTexterWa = false;
            ctrl.marketingTemplates = [];
            ctrl.selectedTemplateKey = null;
            ctrl.marketingTemplatesLoading = false;
            var marketingTemplatesLoaded = false;

            function syncTexterWa() {
                ctrl.isTexterWa = !!($rootScope.$user && $rootScope.$user.wa_api == 'texter');
                if (ctrl.isTexterWa && ctrl.tab == 'wa') {
                    ctrl.loadMarketingTemplates();
                }
            }

            syncTexterWa();
            $scope.$watch(function () {
                return $rootScope.$user && $rootScope.$user.wa_api;
            }, function () {
                syncTexterWa();
            });

            ctrl.loadMarketingTemplates = function() {
                if (!ctrl.isTexterWa || ctrl.marketingTemplatesLoading || marketingTemplatesLoaded) {
                    return;
                }
                ctrl.marketingTemplatesLoading = true;
                $api.whatsapptemplates.marketing.get({}, function (response) {
                    ctrl.marketingTemplatesLoading = false;
                    marketingTemplatesLoaded = true;
                    ctrl.marketingTemplates = response && response.data ? response.data : [];
                }, function () {
                    ctrl.marketingTemplatesLoading = false;
                    ctrl.marketingTemplates = [];
                });
            };

            $scope.datesProvider = dates;

            $scope.$watch("ctrl.tab", function(newValue, oldValue) {
                window.scrollTo( 0, 0 );
            });

            ctrl.tableData = [];

            $scope.uploadFile = function(element){
                ctrl.files = element.files;
                fileElement = element;
                $scope.$apply();
            };

            ctrl.initDtOptions = function(){
            $scope.dtOptions =
                DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                .withLanguage(dataTablesHebrewProvider)
                .withOption('pageLength', 20)
                .withOption('order', false)
                .withOption('aaSorting', [])
                .withOption('searching', false)
                .withOption('ajax', ctrl.filter_table)
                .withOption('serverSide', true)
                .withDataProp('data');
            };

            ctrl.initDtOptions();

            ctrl.filter_table = function (data, callback) {
                callback({recordsTotal:0, recordsFiltered: 0, data: [], draw: data.draw+1});
                
                ctrl.tableData = [];
                ctrl.allTableData = [];
                var filter = $rootScope.marketing_filter || {};

                $api.customers.marketing.get(
                    {filter: filter, limit: data.length, offset: data.start}
                    , function (result) {
                        if (result && result.data) {

                        callback({
                            recordsTotal: result.recordsTotal,
                            recordsFiltered: result.recordsFiltered,
                            data: result.data,
                            draw: data.draw + 1
                        });
                    }
                });
            }
            
            ctrl.variables = {
                'customer_name' : "[the customer's name]",
                "customer_name|he" : "[שם הלקוח]",
            };
    
            ctrl.putVariable = function(code) {
                code = code || 'customer_name';
                code = $user.currentLanguage == 'hb_ISR' ? code+'|he' : code;
                var variable = ctrl.variables[code] ? ctrl.variables[code] : '['+code+']';
                ctrl.message += " "+variable; 
            };


            ctrl.send_message = function() {
                if (ctrl.sendMessage) {
                    return;
                }

                if (ctrl.tab == 'wa' && ctrl.isTexterWa) {
                    if (!ctrl.selectedTemplateKey) {
                        return;
                    }
                } else if (!ctrl.message && !(fileElement && fileElement.files[0])) {
                    return;
                }
                
                if (ctrl.tab == 'wa' || ctrl.tab == 'sms') {
                    swal({
                        title: '',
                        text: $translate.instant('CONFIRM_MARKETING_SEND'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('OPTION_YES'),
                        cancelButtonText: $translate.instant('OPTION_NO'),
                    }).then(function (res) {
                        if (res.value) {
                            ctrl.send_message_request();
                        }
                    });
                } else {
                    ctrl.send_message_request();
                }
            }
            
            ctrl.send_message_request = function() {
                $tiff_page.start_loading('marketing');
                var data = {};
                data = angular.copy(ctrl, data);
                ctrl.sendMessage = true;

                var message_type = 2;
                var stop_text = "";
                switch (ctrl.tab) {
                    case 'sms': 
                        message_type = 2;
                        break;
                    case 'wa':
                        message_type = 3;
                        stop_text = $translate.instant('WA_STOP_TEXT');
                        break;
                    case 'email':
                        message_type = 1;
                        break;
                }

                var filter = $rootScope.marketing_filter || {};
                var texterWaSend = ctrl.tab == 'wa' && ctrl.isTexterWa;

                var send_data = {'filter_options': {
                                    'send_type': message_type,
                                    'filter': filter,
                                },
                                'message': texterWaSend ? '' : data.message,
                                'stop_text': texterWaSend ? '' : stop_text};

                var fdata = new FormData();
                if (fileElement && !texterWaSend) {
                    fdata.append("file", fileElement.files[0]);
                }
                fdata.append("filter_options", JSON.stringify(send_data.filter_options));
                fdata.append("message", send_data.message);
                fdata.append("stop_text", send_data.stop_text);
                if (texterWaSend) {
                    fdata.append("template_key", ctrl.selectedTemplateKey);
                }

                $resource($api.baseURL + '/reports', {}, {
                    postWithFile: {
                        method: "POST",
                        params: fdata,
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined}
                    }
                }).postWithFile(fdata).$promise.then(function(response){
                    ctrl.sendMessage = false;
                    $tiff_page.stop_loading('marketing');
                    swal({
                            title: $translate.instant('SWAL_REPORT_SAVE_TITLE'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    ctrl.setTab('');
                    ctrl.message = '';
                    ctrl.selectedTemplateKey = null;
                }, function(error){
                    $tiff_page.stop_loading('marketing');
                    ctrl.sendMessage = false;
                    if (error.data && error.data.message) {
                        swal({
                            title: '',
                            text: error.data.message,
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });
                    } else {
                        swal({
                            title: '',
                            text: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });
                    }
                });

                return;
            }

            ctrl.setTab = function(newTab){
                syncTexterWa();

                if (newTab == 'wa' && ctrl.wa_status != 'authorized') {
                    swal({
                        title: $translate.instant('SWAL_PLEASE_CONNECT_WA'),
                        text: "",
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 3000
                    });
                    
                    return;
                }
                
                if (newTab == 'wa' && ctrl.isTexterWa) {
                    ctrl.loadMarketingTemplates();
                }

                if (newTab == 'wa' && $rootScope.$user.wa_block*1 >= 10) {
                    swal({
                        title: "",
                        text: $translate.instant('SWAL_WA_BLOCK_WARNING'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    }).then(function(result) {
                        if (result.value) {
                            ctrl.initDtOptions();
                            if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                                $('#cust_dt').DataTable().ajax.reload();
                            }
                            ctrl.tab = newTab;
                            $scope.$apply();
                            return;
                        }
                    });
                    
                    return;
                }
                

                if (newTab == 'wa') {
                    swal({
                        title: "",
                        html: $translate.instant('SWAL_WA_WARNING'),
                        type: "warning",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                        showCancelButton: true,
                    }).then(function(result) {
                        if (result.value) {
                            ctrl.initDtOptions();
                            if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                                $('#cust_dt').DataTable().ajax.reload();
                            }
                            ctrl.tab = newTab;
                            $scope.$apply();
                            return;
                        }
                    });
                    
                    return;
                }

                ctrl.initDtOptions();
                if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                    $('#cust_dt').DataTable().ajax.reload();
                }
                return ctrl.tab = newTab;
            };

            /**
             * Datatable configuration
             */
            $scope.dtOptions =
                  DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                      .withLanguage(dataTablesHebrewProvider)
                      .withOption('pageLength', 100)
                      .withOption('scrollY', '500px')
                      .withOption('searching', false)
                      .withOption('order', [[1, 'desc']]);
            $scope.dtOptions.searching = false;

            /**
             * Filter
            */
            $cfilter.apply('marketing');
            $scope.submit_filter = function() {
                $scope.find_customer();
            }

            $scope.find_customer = function() {
                ctrl.customers = [];
                ctrl.initDtOptions();
                if ($('#cust_dt').DataTable() && $('#cust_dt').DataTable().ajax) {
                    $('#cust_dt').DataTable().ajax.reload();
                }
            }


            ctrl.dtColumns = [
                { name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125 w-100',
                  render: function(data, type, full, meta) {
                    var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
                    var html = '<div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>';
                    html+= '<b>';
                    html+= data.firstname ? ' ' + data.firstname : '';
                    html+= data.lastname ? ' ' + data.lastname : '';
                    html+= '</b>';
                    return '<div class="flex nowrap">'+html+'</div>';
                  }
                },
                {name: 'last_visit', data: null, title: $translate('CUSTOMERS_LAST_VISIT'), class: 'customer-name',
                    render: function (data, type, full, meta) {
                        return data['last_visit'] != '01/01/1970' ? '<span>'+ (data['last_visit'] ? data['last_visit'] : '') +'</span>' : '';
                    }
                },
                { name: 'gender', data: null, title: $translate('CUSTOMERS_GENDER'), class: 'customer-gender',
                  render: function(data, type, full, meta) {
                    return data.gender == 0?$translate.instant("CUSTOMERS_GENDER_MALE"):data.gender==1?$translate.instant("CUSTOMERS_GENDER_FEMALE"):$translate.instant("CUSTOMERS_GENDER_NOT_SET");
                  }
                },
                { name: 'age', data: null, title: $translate('CUSTOMERS_AGE'), class: 'customer-age',
                  render: function(data, type, full, meta) {
                    return data.age;
                  }
                },
              ];

        });
})();

(function(){
    angular.module('app.controllers').controller('LoginController', function ($user, $scope, $state, $notify, $rootScope, $timeout){

            var ctrl = this;

            ctrl.form = {};
            ctrl.showPassword = false;
            ctrl.mfaRequired = false;
            ctrl.mfaSetup = false;
            ctrl.mfaSecret = null;
            ctrl.mfaOtpauthUrl = null;
            ctrl.mfaQrAvailable = false;

            ctrl.togglePasswordVisibility = function(){
                ctrl.showPassword = !ctrl.showPassword;
            };

            ctrl.login = function(){
                $rootScope.page_is_loading = true;
                ctrl.form.mfa_device_id = getMfaDeviceId();

                $user.login(ctrl.form, function(success, response){

                    if(success){
                      $user.go_default_screen();
                    }
                    else if(response && response.mfa_required){
                        $rootScope.page_is_loading = false;
                        ctrl.mfaRequired = true;
                        ctrl.mfaSetup = response.mfa_setup;
                        ctrl.mfaSecret = response.mfa_secret;
                        ctrl.mfaOtpauthUrl = response.mfa_otpauth_url;
                        renderMfaQrCode();

                        if ($scope.loginForm.mfa_code) {
                            $scope.loginForm.mfa_code.$setValidity('mfa', response.status != 'failed');
                        }
                    }
                    else {
                        $rootScope.page_is_loading = false;
                        $scope.loginForm.email.$setValidity('creds', false);
                        $scope.loginForm.password.$setValidity('creds', false);
                        $scope.loginForm.$setSubmitted();
                    }
                });
            };

            var getMfaDeviceId = function(){
                var storageKey = 'tiffulit-mfa-device-id';
                var deviceId = null;

                try {
                    deviceId = localStorage.getItem(storageKey);
                    if(!deviceId){
                        deviceId = new Date().getTime() + '-' + Math.random().toString(36).substr(2, 12);
                        localStorage.setItem(storageKey, deviceId);
                    }
                } catch(e) {
                    deviceId = navigator.userAgent;
                }

                return deviceId;
            };

            var clearMfaQrCode = function(){
                ctrl.mfaQrAvailable = false;
                var qrHolder = document.getElementById('mfa-qrcode');
                if(qrHolder){
                    qrHolder.innerHTML = '';
                }
            };

            var renderMfaQrCode = function(){
                clearMfaQrCode();
                if(!ctrl.mfaSetup || !ctrl.mfaOtpauthUrl || !window.QRCode){
                    return;
                }

                $timeout(function(){
                    var qrHolder = document.getElementById('mfa-qrcode');
                    if(!qrHolder){
                        return;
                    }

                    qrHolder.innerHTML = '';
                    new window.QRCode(qrHolder, {
                        text: ctrl.mfaOtpauthUrl,
                        width: 160,
                        height: 160
                    });
                    ctrl.mfaQrAvailable = true;
                });
            };

            var resetCreds = function(newValue, oldValue){
                if(newValue != oldValue){
                    $scope.loginForm.email.$setValidity('creds', true);
                    $scope.loginForm.password.$setValidity('creds', true);
                    if ($scope.loginForm.mfa_code) {
                        $scope.loginForm.mfa_code.$setValidity('mfa', true);
                    }
                    $scope.loginForm.$setSubmitted();
                }
            };

            var resetLogin = function(newValue, oldValue){
                resetCreds(newValue, oldValue);
                if(newValue != oldValue){
                    ctrl.mfaRequired = false;
                    ctrl.mfaSetup = false;
                    ctrl.mfaSecret = null;
                    ctrl.mfaOtpauthUrl = null;
                    clearMfaQrCode();
                    ctrl.form.mfa_code = null;
                }
            };
            $scope.$watch("ctrl.form.email", resetLogin);
            $scope.$watch("ctrl.form.password", resetLogin);
            $scope.$watch("ctrl.form.mfa_code", resetCreds);
        });
})();

(function () {
  angular.module('app.controllers')
    .controller('PublicGiftCardController', function (GiftCard) {
      var ctrl = this;

      ctrl.settings = {};
      ctrl.values = {};
      ctrl.used = false

      if (GiftCard && GiftCard.data) {
        ctrl.used = GiftCard.data.used || false;
        
        ctrl.settings.page_bg_color = GiftCard.data.page_bg_color || '#EEF3FC';
        ctrl.settings.card_bg_color = GiftCard.data.card_bg_color || '#ffffff';
        ctrl.settings.primary_color = GiftCard.data.primary_color || '#275A7B';
        ctrl.settings.text_color = GiftCard.data.text_color || '#1A202C';
        ctrl.settings.logo = GiftCard.data.logo || '/assets/images/gift-card-logo.png';
        ctrl.settings.image = GiftCard.data.image || '/assets/images/gift-card-image.png';
        ctrl.settings.receiver = GiftCard.data.receiver;
        ctrl.settings.sender = GiftCard.data.sender;
        ctrl.settings.service = GiftCard.data.service;
        ctrl.settings.value = GiftCard.data.value;
        ctrl.settings.message = GiftCard.data.message;

        ctrl.values.number = GiftCard.data.number || '';
        ctrl.values.sender = GiftCard.data.sender_text || '';
        ctrl.values.receiver = GiftCard.data.gifted_to || '';
        ctrl.values.value = GiftCard.data.price || 0;
        ctrl.values.balance = GiftCard.data.balance || 0;
        ctrl.values.service = GiftCard.data.service_text || '';
        ctrl.values.message = GiftCard.data.message_text || '';
        ctrl.values.business = GiftCard.data.name || '';

        var address = [];
        if (GiftCard.data.city) {
          address.push(GiftCard.data.city);
        }
        if (GiftCard.data.address) {
          address.push(GiftCard.data.address);
        }
        if (GiftCard.data.home_number) {
          address.push(GiftCard.data.home_number);
        }
        ctrl.values.address = address.join(', ');
      }

      ctrl.getPhoneLink = function (phone) {
        if (!phone || phone == '') {
          return null;
        }

        return 'tel:' + phone;
      };

      ctrl.getFacebookLink = function (link) {
        if (!link || link == '') {
          return null;
        }

        return link;
      };

      ctrl.getWhatsAppLink = function (phone) {
        if (!phone || phone == '') {
          return null;
        }

        var raw = String(phone).trim();
        if (raw.charAt(0) === '+') {
          raw = raw.slice(1);
        }

        var digits = raw.replace(/\D+/g, '');
        if (digits.charAt(0) === '0' && digits.indexOf('972') !== 0) {
          digits = '972' + digits.slice(1);
        }

        return 'https://wa.me/' + digits;
      };

      ctrl.getWazeLink = function (address) {
        if (!address || address == '') {
          return null;
        }

        return 'https://waze.com/ul?q=' + encodeURIComponent(address);
      };

      ctrl.getInstagramLink = function (link) {
        if (!link || link == '') {
          return null;
        }

        return link;
      };

      ctrl.socials = {
        phone: (GiftCard && GiftCard.data) ? ctrl.getPhoneLink(GiftCard.data.phone) : null,
        facebook: (GiftCard && GiftCard.data) ? ctrl.getFacebookLink(GiftCard.data.facebook_review) : null,
        wa: (GiftCard && GiftCard.data) ? ctrl.getWhatsAppLink(GiftCard.data.phone) : null,
        waze: (GiftCard && GiftCard.data) ? ctrl.getWazeLink(ctrl.values.address) : null,
        instagram: (GiftCard && GiftCard.data) ? ctrl.getInstagramLink(GiftCard.data.instagram) : null
      };
    });
})();
(function(){
    angular.module('app.controllers').controller('ForgotPasswordConfirmController', function($api, $state, $location, $translate){

        var ctrl = this;

        ctrl.form = {};

        ctrl.form.token = $location.search().token ? $location.search().token : '';

        ctrl.submit = function(){
            delete ctrl.form.newPassword;
            $api.passwordconfirm.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: $translate.instant('SWAL_PASS_CONFIRM_TITLE'),
                        text: $translate.instant('SWAL_PASS_CONFIRM_TEXT'),
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                    $state.transitionTo("login", {}, {reload: true});
                }else{
                    $state.transitionTo("login", {}, {reload: true});
                }
            });
        }
    });
})();
(function(){
    angular.module('app.controllers').controller('ForgotPasswordController', function($api, $state){

        var ctrl = this;

        ctrl.form = {};

        ctrl.submit = function(){
            $api.forgot_password.save(ctrl.form, function(response){
                if(response.status === "success"){
                    swal({
                        title: "Thank you!",
                        text: "We will send you message on your email",
                        type: "success",
                        confirmButtonText: "OK",
                        timer: 2000
                    });
                    $state.transitionTo("login", {}, {reload: true});
                }
            });
        }
    });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalFormsController', function(DigitalForm, $header, $api, $scope, $uibModalInstance, $window, $sce, $color, $translate) {
  
            var ctrl = this;
            
            $scope.DigitalForm = DigitalForm.data;
            $scope.business = DigitalForm.data.business;
            $scope.DigitalForm.data = DigitalForm.data && DigitalForm.data.data ? JSON.parse(DigitalForm.data.data) : [];
            $scope.DigitalForm.text = $scope.DigitalForm.text ? $scope.DigitalForm.text.replace(/\n/g, '<br />') : '';

            if ($scope.DigitalForm.data) {
                for (var i in $scope.DigitalForm.data) {
                    if ($scope.DigitalForm.data[i].type == 'date' && $scope.DigitalForm.data[i].value) {
                        $scope.DigitalForm.data[i].value = new Date($scope.DigitalForm.data[i].value);
                    }
                }
            }

            // if ($scope.business['favicon_path']) {
            //     $('#favicon').attr('href', $scope.business['favicon_path']+'favicon.ico');
            //     $('#favicon-16').attr('href', $scope.business['favicon_path']+'favicon-16.png');
            //     $('#favicon-32').attr('href', $scope.business['favicon_path']+'favicon-32.png');
            //     $('#favicon-64').attr('href', $scope.business['favicon_path']+'favicon-64.png');
            // }

            ctrl.setBusinessSettings = function() {
                $scope.business.online_booking_data.online_color = $scope.business.online_booking_data.online_color ? $scope.business.online_booking_data.online_color : '#61B9A0';
                if ($scope.business.online_booking_data.online_color == 'purple') {
                    $scope.business.online_booking_data.online_color = '#8C60AE';
                }
                if ($scope.business.online_booking_data.online_color == 'turquoise') {
                    $scope.business.online_booking_data.online_color = '#61B9A0';
                }

                $scope.business.online_booking_data.background = $scope.business.online_booking_data && $scope.business.online_booking_data.background && $scope.business.online_booking_data.background != "" ? $scope.business.online_booking_data.background : ($scope.business.online_booking_data.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
                $scope.business.online_booking_data.online_logo = $scope.business.online_booking_data && $scope.business.online_booking_data.online_logo && $scope.business.online_booking_data.online_logo != "" ? ($scope.business.online_booking_data.online_logo == "removed" ? "" : $scope.business.online_booking_data.online_logo) : location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
                
                
                document.documentElement.style.setProperty('--menu-color', $scope.business.menu_color ? $scope.business.menu_color : '#216089');
                document.documentElement.style.setProperty('--online-color', $scope.business.online_booking_data.online_color);
                document.documentElement.style.setProperty('--online-text-color', $scope.business.online_booking_data.online_text_color);
                document.documentElement.style.setProperty('--back-color', $scope.business.back_color ? $scope.business.back_color : '#F2F6FF');
                document.documentElement.style.setProperty('--calendar-color', $scope.business.calendar_color != '#f2f2f2' ? $scope.business.calendar_color : '#fff');
                document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--calendar-stripe-color', $scope.business.calendar_stripe_color ? $scope.business.calendar_stripe_color : '#f7fafc');
                
            }

            ctrl.setBusinessSettings();
            
        
            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.textValueWithBR = function(str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            ctrl.submit = function(){
                
                var required = false;
                for (var i in $scope.DigitalForm.data) {
                    if ($scope.DigitalForm.data[i].type == 'comment' || $scope.DigitalForm.data[i].type == 'map' || $scope.DigitalForm.data[i].type == 'business_signature') {
                        continue;
                    }

                    if (($scope.DigitalForm.data[i].type == 'signature')) {
                        $scope.DigitalForm.data[i].value = canvas[i].getLines();
                    }

                    if ($scope.DigitalForm.data[i].require || $scope.DigitalForm.data[i].required) {
                        if (($scope.DigitalForm.data[i].type != 'checkbox' && !$scope.DigitalForm.data[i].value)) {
                            required = true;
                            console.log('required', $scope.DigitalForm.data[i].name);
                        }

                        if (($scope.DigitalForm.data[i].type == 'checkbox' && $scope.DigitalForm.data[i].items && $scope.DigitalForm.data[i].items.length)) {
                            var check_for_checked = false;
                            for (var j in $scope.DigitalForm.data[i].items) {
                                if ($scope.DigitalForm.data[i].items[j].checked) {
                                    check_for_checked = true;
                                }
                            }

                            if (!check_for_checked) {
                                required = true;
                                console.log('required', $scope.DigitalForm.data[i].name);
                            }
                        }

                        if (($scope.DigitalForm.data[i].type == 'signature' && (!$scope.DigitalForm.data[i].value || !$scope.DigitalForm.data[i].value.length))) {
                            required = true;
                            console.log('required', $scope.DigitalForm.data[i].name);
                        }
                    }
                }

                if (required) {
                    swal({
                        title: $translate.instant('DIGITAL_FORM_REQUIRED'),
                        text: "",
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        //timer: 2000
                    });

                    return;
                }

                $api.customer_forms.save({
                    id: $scope.DigitalForm.id,
                    data: $scope.DigitalForm.data,
                    public: 1,
                }, function (response) {
                    if (response.status === "success") {
                        $scope.DigitalForm.fill_date = true;

                        swal({
                            title: $translate.instant('DIGITAL_FORM_FILLED'),
                            text: "",
                            type: "success",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 3000
                        });

                        ctrl.finished = true;
                    }
                });
            }

            var canvas = {};
            
            ctrl.init_signatures = function() {
                setTimeout( function() {
                    if ($scope.DigitalForm.data) {
                        for (var i in $scope.DigitalForm.data) {
                            if ($scope.DigitalForm.data[i].type == 'signature') {
                                var el = document.getElementById('can'+i);
                                if (el) {
                                    canvas[i] = new PortrayCanvas(el, {
                                        lineWidth: 2,
                                        period: 5,
                                        disabled: !!$scope.DigitalForm.fill_date,
                                        lines: ($scope.DigitalForm.data[i].value && $scope.DigitalForm.data[i].value.length) ? $scope.DigitalForm.data[i].value : [],
                                    });

                                    canvas[i].canvas.addEventListener("touchstart",  function(event) {event.preventDefault()})
                                    canvas[i].canvas.addEventListener("touchmove",   function(event) {event.preventDefault()})
                                    canvas[i].canvas.addEventListener("touchend",    function(event) {event.preventDefault()})
                                    canvas[i].canvas.addEventListener("touchcancel", function(event) {event.preventDefault()})
                                }
                            }
                        }
                    }
                }, 500);
            }

            ctrl.clearSign = function(index) {
                canvas[i].clear();
            }

            ctrl.init_signatures();
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('DigitalDocumentsController', function(DigitalDocument, $header, $api, $scope, $uibModalInstance, $window, $sce, $translate) {
  
            var ctrl = this;
            ctrl.sign = false;
            
            $scope.DigitalDocument = DigitalDocument.data;
            
            $scope.iframe = function(){
                return $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+$scope.DigitalDocument.url+'&embedded=true');
            };

            $scope.isMobile = (angular.element(document).width() < 769);

            $header.title = "NAV_DOCUMENT";
            $header.breadcrumbs.push({
                "title": "NAV_DOCUMENT"
            });

            ctrl.submit = function(){
                if (ctrl.sign) {
                    $api.customer_documents.save({
                        id: $scope.DigitalDocument.id,
                    }, function (response) {
                        if (response.status === "success") {
                            $scope.DigitalDocument.sign = true;

                            swal({
                                title: $translate.instant('DIGITAL_DOCUMENT_SIGNED'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    });
                }
            }
        });
})();
(function(){
    angular.module('app.controllers').controller('DashboardController', function (Info, $api, $header, dataTablesHebrewProvider, DTOptionsBuilder, DTColumnDefBuilder, $scope, $rootScope, $translate, $state, $uibModal, uiCalendarConfig, $payment, $timeout){
        $header.title = "ראשי";

        if ($rootScope.userRole == 1){
          $state.go('app.admin', {}, {reload: true});
          return;
        }
        var ctrl = this;
        $scope.isMobile = (angular.element(document).width() < 769);
        $scope.b_type = $rootScope.$user && $rootScope.$user ? $rootScope.$user.b_type : 1;
        $scope.showCalendar = $scope.b_type === 2;
        $scope.showIncomeByItem = $scope.b_type === 1;
        ctrl.tableOrdersData = null;
        $scope.currentDateTime = Date.now();
        var isRTL = langKey === 'hb_ISR' || langKey === 'ar_AR';
        ctrl.hide_prices = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_prices') ? true : false;

        ctrl.tableCustomersData = null;
        ctrl.customersLoading = true;
        ctrl.incomeLoading = true;
        ctrl.statsPieLoading = true;
        ctrl.statsBarLoading = true;
        ctrl.paymentLoading = true;
        ctrl.incomeByItemLoading = true;
        ctrl.campaignBarLoading = true;
        ctrl.capacityData = null;
        ctrl.apiRequest = null;

        ctrl.bar_start_date = moment().subtract(1, 'years')
        ctrl.bar_end_date = moment();
        ctrl.bar_filter = 'monthly';
        ctrl.bar_type = 'leads';

        ctrl.pie_start_date = moment().subtract(1, 'months');
        ctrl.pie_end_date = moment();
        ctrl.pie_type = 'leads';
        ctrl.payment_start_date = moment().startOf('month');
        ctrl.payment_end_date = moment();

        // Campaign bar variables
        ctrl.campaign_bar_type = 'campaigns';
        ctrl.campaign_bar_metric = 'leads';
        ctrl.campaign_bar_filter = 'this_month';
        ctrl.campaignBarMetricOptions = [
            {id: 'leads', name: $translate.instant('CAMPAIGN_BAR_METRIC_LEADS')},
            {id: 'income', name: $translate.instant('CAMPAIGN_BAR_METRIC_INCOME')}
        ];
        ctrl.campaignBarFilterOptions = [
            {id: 'this_month', name: $translate.instant('CAMPAIGN_BAR_THIS_MONTH')},
            {id: 'last_month', name: $translate.instant('CAMPAIGN_BAR_LAST_MONTH')},
            {id: 'this_year', name: $translate.instant('CAMPAIGN_BAR_THIS_YEAR')},
            {id: 'last_year', name: $translate.instant('CAMPAIGN_BAR_LAST_YEAR')},
            {id: 'custom', name: $translate.instant('CAMPAIGN_BAR_CUSTOM')}
        ];
        ctrl.paymentFilterOptions = [
            {id: 'today', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_1')},
            {id: 'yesterday', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_6')},
            {id: 'week', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_5')},
            {id: 'month', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_2')},
            {id: 'year', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_3')},
            {id: 'lastyear', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_4')},
            {id: 'daterange', name: $translate.instant('ANALYTIC_PAYMENT_SELECT_7')}
        ];
        function buildCategoryOptions(categories) {
            var options = [{
                id: '',
                name: $translate.instant('ANALYTICS_ALL_CATEGORIES')
            }];
            for (var i = 0; i < (categories || []).length; i++) {
                options.push(categories[i]);
            }
            options.push({
                id: 0,
                name: $translate.instant('ANALYTICS_NO_CATEGORY')
            });
            return options;
        }
        function buildResourceOptions(resources) {
            var options = [{
                id: '',
                name: $translate.instant('CALENDAR_RESOURCES')
            }];
            for (var i = 0; i < (resources || []).length; i++) {
                options.push(resources[i]);
            }
            return options;
        }
        var now = moment();
        ctrl.campaign_bar_start_date = now.clone().startOf('month');
        ctrl.campaign_bar_end_date = now.clone().endOf('month');

        $scope.$watch('ctrl.bar_start_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsBar();
            }
        });

        $scope.$watch('ctrl.bar_end_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsBar();
            }
        });

        $scope.$watch('ctrl.pie_start_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsPie();
            }
        });

        $scope.$watch('ctrl.pie_end_date', function(newValue, oldValue) {
            if(newValue != oldValue) {
                ctrl.loadStatsPie();
            }
        });

        $scope.$watch('ctrl.payment_start_date', function(newValue, oldValue) {
            if (newValue != oldValue && ctrl.paymentGraph && ctrl.paymentGraph.filter == 'daterange') {
                ctrl.loadAnalyticsPaymentType();
            }
        });

        $scope.$watch('ctrl.payment_end_date', function(newValue, oldValue) {
            if (newValue != oldValue && ctrl.paymentGraph && ctrl.paymentGraph.filter == 'daterange') {
                ctrl.loadAnalyticsPaymentType();
            }
        });

        $scope.$watch('ctrl.campaign_bar_start_date', function(newValue, oldValue) {
            if(newValue != oldValue && ctrl.campaign_bar_filter == 'custom') {
                ctrl.loadCampaignBar();
            }
        });

        $scope.$watch('ctrl.campaign_bar_end_date', function(newValue, oldValue) {
            if(newValue != oldValue && ctrl.campaign_bar_filter == 'custom') {
                ctrl.loadCampaignBar();
            }
        });
        


        $scope.dtOptions =
                DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip') //.withDOM('Tgtip')
                .withOption('searching', false)
                .withLanguage(dataTablesHebrewProvider)
                //.withOption('order', [[1, 'asc']]);
                .withOption('columnDefs', [
                    { "orderable": false, "targets": 6 } 
                  ])
                .withOption('aaSorting', [])
        $scope.dtOptions.searching = false;

        $scope.dtOptionsBirth =
                DTOptionsBuilder.newOptions()
                .withDOM('Tfgtip') //.withDOM('Tgtip')
                .withOption('searching', false)
                .withLanguage(dataTablesHebrewProvider)
                //.withOption('order', [[1, 'asc']]);
                .withOption('columnDefs', [
                    { "orderable": false, "targets": 4 } 
                  ])
                  .withOption("fnDrawCallback", function(oSettings){
                    if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                        $(oSettings.nTableWrapper).find('.dataTables_paginate, .dataTables_info').hide();
                    } else {
                         $(oSettings.nTableWrapper).find('.dataTables_paginate, .dataTables_info').show();
                    }
                })
                .withOption('aaSorting', [])
        $scope.dtOptionsBirth.searching = false;


        $scope.dtToddtOptionsyColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable()
        ];

        moment.locale("he");

        ctrl.settings = {
            resource: null,
            time: "daily",
            type: "orders",
            interval: Info ? Info.data.interval ? '00:' + String(Info.data.interval) + ':00' : '00:10:00' : '',
            date: moment(),
            datePickerView: "date",
            loading: false,
            loadingHolidays: false,
            bu_type: parseInt($rootScope.$user.b_type)
        };

        ctrl.yesterday = function() {
            return moment().subtract(1, 'days').format('DD.MM.YYYY')
        }

        ctrl.today = function() {
            return moment().format('DD.MM.YYYY')
        }

        ctrl.checkPercent = function(num1, num2) {
            if (num1 == num2)
                return 0;

            if (num2 == 0) 
                return 0;

            if (num1 == 0) {
                return 100;
            }

            var val = ((num2 - num1) / num1) * 100;

            return val ? Math.round(val) : 0;
        }

        $scope.getOptions = function(){
            return ctrl.defaults.options
        }
        $scope.getPaymentOptions = function(){
            return ctrl.paymentDefaults.options
        }

        ctrl.send_birthday_message = function(id) {
            today_birthday = {'id': id};
            btn = '.btn-birthday-' + id;
            $(btn).addClass('sending');
            $api.dashboard.get(today_birthday, function(response) {
                swal({
                  title: $translate.instant('SWAL_BIRTHDAY_MESSAGE_TITLE'),
                  text: "",
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 2000
                });
                $(btn).removeClass('sending');
                $(btn).remove();
            });
        };

        ctrl.extractLabels = function(labels) {
            for (var k in labels) {
                var text = labels[k];

                switch (labels[k]) {
                    case 1:
                        text = $translate.instant('CALENDAR_CASH_CASH');
                        break;
                    case 2:
                        text = $translate.instant('CALENDAR_CASH_CREDIT');
                        break;
                    case 3:
                        text = $translate.instant('CALENDAR_CASH_ON_CREDIT');
                        break;
                    case 4:
                        text = $translate.instant('CALENDAR_CASH_CHEQUE');
                        break;
                    case 5:
                        text = $translate.instant('CALENDAR_CASH_BANK_TRANS');
                        break;
                    case 6:
                        text = $translate.instant('CALENDAR_CASH_CREDIT_CARD_EXT');
                        break;
                    case 7:
                        text = $translate.instant('CALENDAR_CASH_PAY_CREDIT');
                        break;
                    case 8:
                        text = $translate.instant('CALENDAR_CASH_CREDIT');
                        break;
                    default:
                        text = k;
                }

                labels[k] = text;
            }

            return labels;
        };

        ctrl.translateChartLabels = function(labels) {
            var labelMap = {
                'NEW_LEADS': 'ANALYTIC_LABEL_NEW_LEADS',
                'FIRST_ORDERS': 'ANALYTIC_LABEL_FIRST_ORDERS',
                // 'FIRST_PAID': 'ANALYTIC_LABEL_FIRST_PAID',
                'REST_ORDERS': 'ANALYTIC_LABEL_REST_ORDERS',
                'CANCELED_ORDERS': 'ANALYTIC_LABEL_CANCELED_ORDERS'
            };

            var translateLabel = function(label) {
                var translationKey = labelMap[label];
                if (translationKey) {
                    return $translate.instant(translationKey);
                }
                return label;
            };

            // Handle array (pie chart) or single string (bar chart)
            if (Array.isArray(labels)) {
                return labels.map(translateLabel);
            }
            return translateLabel(labels);
        };

        /**
         * Calendar Configuration
         */
        // $scope.calendarConfig = null;

        // if($scope.b_type == 2) {
        //     ctrl.prepare_motels_configuration();
        //     $scope.calendarConfig.nowIndicator = false;
        // }

        // charts

        ctrl.graphHeight = $scope.isMobile ? 200 : 160;
        ctrl.defaults = {
            options: {
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        stacked: true,
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        display: false
                    }
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.x) {
                        var barWidth = chart.scales.x.width / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                }
            },
        };

        ctrl.paymentDefaults = {
            options: {
                indexAxis: 'y',
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false
                        },
                    },
                    y: {
                        stacked: true,
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem) {
                                var index = tooltipItem.dataIndex;
                                var percentage = ctrl.paymentGraph.percentages[index] 
                                    ? ctrl.paymentGraph.percentages[index] 
                                    : null;
        
                                var label = tooltipItem.label || '';
                                var value = tooltipItem.raw;
        
                                return label + ': ' + value + ' (' + (percentage !== null ? percentage + '%' : '') + ')';
                            }
                        }
                    }
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.x) {
                        var barWidth = chart.scales.y.height / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                },
            },
        };


        ctrl.statsPie = {
            options: {
                responsive: true,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem) {
                                var dataset = tooltipItem.dataset;
                                var currentValue = dataset.data[tooltipItem.dataIndex];
                                var total = dataset.data.reduce(function(acc, val) {
                                    return acc + val;
                                }, 0);
                                var percentage = ((currentValue / total) * 100).toFixed();
                                return tooltipItem.label + ": " + currentValue + " (" + percentage + "%)";
                            }
                        }
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            generateLabels: function(chart) {
                                var data = chart.data;
                                return data.labels.map(function(label, index) {
                                    var value = data.datasets[0].data[index];
                                    var total = data.datasets[0].data.reduce(function(acc, val) {
                                        return acc + val;
                                    }, 0);
                                    var percentage = ((value / total) * 100).toFixed();
                                    return {
                                        text: label + " (" + percentage + "%)",
                                        fillStyle: data.datasets[0].backgroundColor[index],
                                        hidden: false,
                                        index: index,
                                    };
                                });
                            },
                            usePointStyle: true,
                        },
                        rtl: isRTL,
                    },
                },
                scales: {}
            },
        };


        ctrl.statsBar = {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        grid: {
                            display: false
                        }
                    },
                    y: {
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            generateLabels: function(chart) {
                                var data = chart.data;
                                return data.datasets.map(function(dataset, index) {
                                    return {
                                        text: dataset.label,
                                        fillStyle: dataset.backgroundColor,
                                        hidden: false,
                                        index: index,
                                    };
                                });
                            },
                            usePointStyle: true,
                        },
                        rtl: isRTL, 
                    },
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.x) {
                        var barWidth = chart.scales.x.width / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                },
            },
        };


        var menu_color = $rootScope.color_form && $rootScope.color_form.menu_color ? $rootScope.color_form.menu_color : '#006495';

        ctrl.paymentGraph = {
            type: "bar",
            title: "",
            category: "",
            payment_methods: $payment.methods,
            payment_method: '',
            data: {
                labels: [],
                datasets: [{
                    label: '',
                    data: [],
                    backgroundColor: menu_color,
                    maxBarThickness: 60,
                }],
            },
            percentages: [],
            filter: "today",
            options: ctrl.paymentDefaults.options,
        };

        ctrl.incomeGraph = {
            type: "bar",
            title: "ניתוח הכנסות",
            category: "",
            resource: "",
            categories: [],
            categoryOptions: buildCategoryOptions([]),
            resources: [],
            resourceOptions: buildResourceOptions([]),
            payment_methods: $payment.methods,
            payment_method: '',
            data: {
                labels: [],
                datasets: [{
                    label: 'הכנסות',
                    data: [],
                    backgroundColor: menu_color,
                }, {
                    label: $translate.instant("ANALYTIC_FORECAST"),
                    data: [],
                    backgroundColor: $rootScope.createDiagonalPattern(menu_color)
                }],
            },
            filter: "monthly",
            options: ctrl.defaults.options,
        };

        angular.extend(ctrl.statsPie, {
            type: "doughnut",
            data: {
                labels: [],
                originalLabels: [],
                datasets: [{
                    label: '',
                    data: [],
                    backgroundColor: [],
                }],
            }
        });

        angular.extend(ctrl.statsBar, {
            type: "bar",
            data: {
                labels: [],
                datasets: [],
            }
        });

        // Campaign bar chart configuration (horizontal bars)
        ctrl.campaignBar = {
            type: "bar",
            data: {
                labels: [],
                datasets: [{
                    label: '',
                    data: [],
                    backgroundColor: menu_color,
                    maxBarThickness: 60,
                }],
            },
            options: {
                indexAxis: 'y', // Horizontal bars
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        grid: {
                            display: false
                        }
                    }
                },
                borderRadius: 6,
                plugins: {
                    legend: {
                        display: false
                    }
                },
                onResize: function(chart) {
                    if (chart && chart.scales && chart.scales.y) {
                        var barWidth = chart.scales.y.height / chart.data.labels.length;
                        chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                        chart.update();
                    }
                },
            },
        };

        ctrl.dailyIncomeByItemGraph = {
            type: "bar",
            data: {
                labels: [],
                datasets: [{
                    label: 'הכנסות',
                    data: [],
                    backgroundColor: menu_color,
                    maxBarThickness: 60,
                }],
            },
            options: ctrl.defaults.options,
        };
        ctrl.dailyIncome = 0;
        ctrl.dailyOrders = 0;
        ctrl.yesterdayIncome = 0;
        ctrl.yesterdayOrders = 0;

        function setDashboardChartsLoading(loading) {
            ctrl.incomeLoading = loading;
            ctrl.statsPieLoading = loading;
            ctrl.statsBarLoading = loading;
            ctrl.paymentLoading = loading;
            ctrl.incomeByItemLoading = loading;
        }

        function refreshDashboardChartOptions() {
            ctrl.incomeGraph.options = angular.copy(ctrl.incomeGraph.options);
            ctrl.statsPie.options = angular.copy(ctrl.statsPie.options);
            ctrl.statsBar.options = angular.copy(ctrl.statsBar.options);
            ctrl.paymentGraph.options = angular.copy(ctrl.paymentGraph.options);
            ctrl.dailyIncomeByItemGraph.options = angular.copy(ctrl.dailyIncomeByItemGraph.options);
        }

        function applyAnalyticsData(response) {
            var analyticsData = response && response.data ? response.data : null;
            var paymentType = analyticsData && analyticsData.paymentType ? analyticsData.paymentType : null;
            var income = analyticsData && analyticsData.income ? analyticsData.income : null;
            var orders = analyticsData && analyticsData.orders ? analyticsData.orders : null;
            var statsPieData = analyticsData && analyticsData.statsPie ? analyticsData.statsPie : null;
            var statsBarData = analyticsData && analyticsData.statsBar ? analyticsData.statsBar : null;
            var dailyIncomeByItems = analyticsData && analyticsData.daily_income_by_items ? analyticsData.daily_income_by_items : null;
            var incomeWidget = income && income.widget ? income.widget : null;
            var ordersWidget = orders && orders.widget ? orders.widget : null;

            ctrl.paymentGraph.data.labels = ctrl.extractLabels(paymentType && paymentType.labels ? paymentType.labels : []);
            ctrl.paymentGraph.data.datasets[0].data = paymentType && paymentType.values ? paymentType.values : [];
            ctrl.paymentGraph.percentages = paymentType && paymentType.percentages ? paymentType.percentages : [];

            ctrl.incomeGraph.categories = analyticsData && analyticsData.categories ? analyticsData.categories : [];
            ctrl.incomeGraph.categoryOptions = buildCategoryOptions(ctrl.incomeGraph.categories);
            ctrl.incomeGraph.resources = analyticsData && analyticsData.resources ? analyticsData.resources : [];
            ctrl.incomeGraph.resourceOptions = buildResourceOptions(ctrl.incomeGraph.resources);
            ctrl.incomeGraph.data.labels = income && income.labels ? income.labels : [];
            ctrl.incomeGraph.data.datasets[0].data = income && income.values ? income.values : [];
            ctrl.incomeGraph.data.datasets[1].data = income && income.forecast ? income.forecast : [];

            ctrl.statsPie.data.labels = statsPieData && statsPieData.labels ? ctrl.translateChartLabels(statsPieData.labels) : [];
            ctrl.statsPie.data.originalLabels = statsPieData && statsPieData.labels ? statsPieData.labels : [];
            ctrl.statsPie.data.datasets[0].data = statsPieData && statsPieData.values ? statsPieData.values : [];
            ctrl.statsPie.data.datasets[0].backgroundColor = statsPieData && statsPieData.colors ? statsPieData.colors : [];

            var datasetsBar = [];
            if (statsBarData && statsBarData.values) {
                for (var key in statsBarData.values) {
                    datasetsBar.push({
                        label: ctrl.translateChartLabels(statsBarData.values[key].name),
                        data: statsBarData.values[key].values,
                        backgroundColor: statsBarData.values[key].color || menu_color,
                        maxBarThickness: 60,
                    });
                }
            }
            ctrl.statsBar.data.labels = statsBarData && statsBarData.periods ? statsBarData.periods : [];
            ctrl.statsBar.data.datasets = datasetsBar;

            var items_values = dailyIncomeByItems && dailyIncomeByItems.values ? dailyIncomeByItems.values.slice() : [];
            var items_labels = dailyIncomeByItems && dailyIncomeByItems.labels ? dailyIncomeByItems.labels.slice() : [];

            if (items_values.length > 0) {
                for (var i = 0; i < items_values.length - 1; i++) {
                    for (var j = i + 1; j < items_values.length; j++) {
                        if (items_values[i] < items_values[j]) {
                            var temp_label = items_labels[i];
                            items_labels[i] = items_labels[j];
                            items_labels[j] = temp_label;
                            var temp_value = items_values[i];
                            items_values[i] = items_values[j];
                            items_values[j] = temp_value;
                        }
                    }
                }
            }
            ctrl.dailyIncomeByItemGraph.data.labels = items_labels;
            ctrl.dailyIncomeByItemGraph.data.datasets[0].data = items_values;

            ctrl.dailyIncome = incomeWidget && incomeWidget.daily != null ? incomeWidget.daily : 0;
            ctrl.dailyOrders = ordersWidget && ordersWidget.daily != null ? ordersWidget.daily : 0;
            ctrl.yesterdayIncome = incomeWidget && incomeWidget.yesterday != null ? incomeWidget.yesterday : 0;
            ctrl.yesterdayOrders = ordersWidget && ordersWidget.yesterday != null ? ordersWidget.yesterday : 0;

            refreshDashboardChartOptions();
        }

        function setCustomersData(customersResponse) {
            var rows = customersResponse && customersResponse.data ? customersResponse.data : [];
            ctrl.tableCustomersData = rows.map(function(row) {
                var age = row.age.match(/([0-9]*)/);
                if (age.length > 1) {
                    row.age = age[1];
                }
                return row;
            });
        }

        ctrl.loadDashboardAnalytics = function() {
            setDashboardChartsLoading(true);
            $api.analytics.get({
                type: "income",
                filter: "monthly",
                getAll: true
            }, function(response) {
                applyAnalyticsData(response);
                setDashboardChartsLoading(false);
            }, function() {
                setDashboardChartsLoading(false);
            });
        };

        ctrl.loadDashboardCustomers = function() {
            ctrl.customersLoading = true;
            $api.resolve('customers.today_birthday@get').then(function(Customers) {
                setCustomersData(Customers);
                ctrl.customersLoading = false;
            }, function() {
                ctrl.tableCustomersData = [];
                ctrl.customersLoading = false;
            });
        };

        ctrl.loadAnalytics = function(dataType, filter) {
            if(filter) {
                ctrl.incomeGraph.filter = filter;
            }
            var request = {
                filter: ctrl.incomeGraph.filter,
                type: dataType
            };
            if(ctrl.incomeGraph.category && ctrl.incomeGraph.category != '') {
                request.category = ctrl.incomeGraph.category;
            }
            if(ctrl.incomeGraph.resource && ctrl.incomeGraph.resource != '') {
                request.resource = ctrl.incomeGraph.resource;
            }
            if(ctrl.incomeGraph.resource_treated && ctrl.incomeGraph.resource_treated != '') {
                request.resource_treated = ctrl.incomeGraph.resource_treated;
            }
            if(ctrl.incomeGraph.resource_booked && ctrl.incomeGraph.resource_booked != '') {
                request.resource_booked = ctrl.incomeGraph.resource_booked;
            }
            if(ctrl.incomeGraph.resource_responsible && ctrl.incomeGraph.resource_responsible != '') {
                request.resource_responsible = ctrl.incomeGraph.resource_responsible;
            }
            if(ctrl.incomeGraph.payment_method && ctrl.incomeGraph.payment_method != '') {
                request.payment_method = ctrl.incomeGraph.payment_method;
            }
            ctrl.incomeLoading = true;
            $api.analytics.get(request,
                function(response) {
                    if (response.data[dataType]) {
                        ctrl.incomeGraph.data.labels = response.data[dataType].labels;
                        ctrl.incomeGraph.data.datasets[0].data = response.data[dataType].values;

                        if (response.data[dataType].forecast) {
                            ctrl.incomeGraph.data.datasets[1].data = response.data[dataType].forecast;
                        }

                        ctrl.incomeGraph.options = angular.copy(ctrl.incomeGraph.options);
                    } else {
                        ctrl.incomeGraph.data.labels = [];
                        ctrl.incomeGraph.data.datasets[0].data = [];
                        ctrl.incomeGraph.data.datasets[1].data = [];
                        ctrl.incomeGraph.options = angular.copy(ctrl.incomeGraph.options);
                    }
                    ctrl.incomeLoading = false;
                }, function() {
                    ctrl.incomeLoading = false;
                });
        };

        ctrl.loadStatsBar = function() {
            var request = {
                type: 'statsBar',
                start: ctrl.bar_start_date.format('YYYY-MM-DD'),
                end: ctrl.bar_end_date.format('YYYY-MM-DD'),
                period: ctrl.bar_filter,
                stats_type: ctrl.bar_type,
            };
            ctrl.statsBarLoading = true;
            $api.analytics.get(request,
                function(response) {
                    var datasetsBar = [];
                    if (response.data.statsBar && response.data.statsBar.values) {
                        for (var key in response.data.statsBar.values) {
                            datasetsBar.push({
                                label: ctrl.translateChartLabels(response.data.statsBar.values[key].name),
                                data: response.data.statsBar.values[key].values,
                                backgroundColor: response.data.statsBar.values[key].color || menu_color,
                                maxBarThickness: 60,
                            });
                        }
                    }

                    ctrl.statsBar.data.labels = response.data.statsBar && response.data.statsBar.periods ? response.data.statsBar.periods : [];
                    ctrl.statsBar.data.datasets = datasetsBar;

                    var periodsCount = response.data.statsBar && response.data.statsBar.periods ? response.data.statsBar.periods.length : 0;
                    var isMobile = $scope.isMobile;

                    ctrl.statsBar.options = angular.copy(ctrl.statsBar.options);

                    if (isMobile && periodsCount > 6) {
                        ctrl.statsBar.options.maintainAspectRatio = false;
                    }
                    ctrl.statsBarLoading = false;
                }, function() {
                    ctrl.statsBarLoading = false;
                });
        };

        ctrl.loadStatsPie = function() {
            var request = {
                type: 'statsPie',
                start: ctrl.pie_start_date.format('YYYY-MM-DD'),
                end: ctrl.pie_end_date.format('YYYY-MM-DD'),
                stats_type: ctrl.pie_type,
            };
            ctrl.statsPieLoading = true;
            $api.analytics.get(request,
                function(response) {
                    var statsPieData = response.data && response.data.statsPie ? response.data.statsPie : null;
                    ctrl.statsPie.data.originalLabels = statsPieData && statsPieData.labels ? statsPieData.labels : [];
                    ctrl.statsPie.data.labels = statsPieData && statsPieData.labels ? ctrl.translateChartLabels(statsPieData.labels) : [];
                    ctrl.statsPie.data.datasets[0].data = statsPieData && statsPieData.values ? statsPieData.values : [];
                    ctrl.statsPie.data.datasets[0].backgroundColor = statsPieData && statsPieData.colors ? statsPieData.colors : [];

                    ctrl.statsPie.options = angular.copy(ctrl.statsPie.options);
                    ctrl.statsPieLoading = false;
                }, function() {
                    ctrl.statsPieLoading = false;
                });
        };

        ctrl.onCampaignBarFilterChange = function() {
            var now = moment();
            switch(ctrl.campaign_bar_filter) {
                case 'this_month':
                    ctrl.campaign_bar_start_date = now.clone().startOf('month');
                    ctrl.campaign_bar_end_date = now.clone().endOf('month');
                    break;
                case 'last_month':
                    ctrl.campaign_bar_start_date = now.clone().subtract(1, 'month').startOf('month');
                    ctrl.campaign_bar_end_date = now.clone().subtract(1, 'month').endOf('month');
                    break;
                case 'this_year':
                    ctrl.campaign_bar_start_date = now.clone().startOf('year');
                    ctrl.campaign_bar_end_date = now.clone().endOf('year');
                    break;
                case 'last_year':
                    ctrl.campaign_bar_start_date = now.clone().subtract(1, 'year').startOf('year');
                    ctrl.campaign_bar_end_date = now.clone().subtract(1, 'year').endOf('year');
                    break;
                case 'custom':
                    // Keep current dates, user will set them manually
                    break;
            }
            if (ctrl.campaign_bar_filter != 'custom') {
                ctrl.loadCampaignBar();
            }
        };

        ctrl.loadCampaignBar = function() {
            var request = {
                type: 'campaignBar',
                start: ctrl.campaign_bar_start_date.format('YYYY-MM-DD'),
                end: ctrl.campaign_bar_end_date.format('YYYY-MM-DD'),
                campaign_type: ctrl.campaign_bar_type,
                campaign_metric: ctrl.campaign_bar_metric,
            };
            ctrl.campaignBarLoading = true;
            $api.analytics.get(request,
                function(response) {
                    if (response.data.campaignBar && response.data.campaignBar.labels && response.data.campaignBar.values) {
                        ctrl.campaignBar.data.labels = response.data.campaignBar.labels;
                        ctrl.campaignBar.data.datasets[0].data = response.data.campaignBar.values;
                        if (Array.isArray(response.data.campaignBar.colors)) {
                            ctrl.campaignBar.data.datasets[0].backgroundColor = response.data.campaignBar.colors;
                        } else {
                            ctrl.campaignBar.data.datasets[0].backgroundColor = response.data.campaignBar.colors || menu_color;
                        }
                    } else {
                        ctrl.campaignBar.data.labels = [];
                        ctrl.campaignBar.data.datasets[0].data = [];
                        ctrl.campaignBar.data.datasets[0].backgroundColor = menu_color;
                    }

                    ctrl.campaignBar.options = angular.copy(ctrl.campaignBar.options);
                    ctrl.campaignBarLoading = false;
                }, function() {
                    ctrl.campaignBarLoading = false;
                });
        };

        ctrl.loadAnalyticsPaymentType = function() {
            var dataType = 'paymentType';
            var request = {
                filter: ctrl.paymentGraph.filter,
                type: dataType
            };

            if (ctrl.paymentGraph.filter == 'daterange') {
                request.start = ctrl.payment_start_date ? ctrl.payment_start_date.format('YYYY-MM-DD') : null;
                request.end = ctrl.payment_end_date ? ctrl.payment_end_date.format('YYYY-MM-DD') : null;
            }
            ctrl.paymentLoading = true;
            $api.analytics.get(request,
                function(response) {
                    var paymentType = response.data && response.data[dataType] ? response.data[dataType] : null;
                    ctrl.paymentGraph.data.labels = ctrl.extractLabels(paymentType && paymentType.labels ? paymentType.labels : []);
                    ctrl.paymentGraph.data.datasets[0].data = paymentType && paymentType.values ? paymentType.values : [];
                    ctrl.paymentGraph.percentages = paymentType && paymentType.percentages ? paymentType.percentages : [];

                    ctrl.paymentGraph.options = angular.copy(ctrl.paymentGraph.options);
                    ctrl.paymentLoading = false;
                }, function() {
                    ctrl.paymentLoading = false;
                });
        };

        ctrl.filterModal = {};
        ctrl.openFilter = function(graphID) {
            if (!ctrl.filterModal[graphID]) {
                $timeout(function() {
                ctrl.filterModal[graphID] = true;
                });
            }
        }

        ctrl.closeFilter = function(graphID) {
            if (ctrl.filterModal[graphID]) {
                ctrl.filterModal[graphID] = false;
            }
        }

        $rootScope.$on('change-language', function(event, langKey){
            $scope.langKey = langKey
            if (uiCalendarConfig && uiCalendarConfig.calendars && uiCalendarConfig.calendars.mainCalendar) {
                uiCalendarConfig.calendars.mainCalendar.fullCalendar("option", "isRTL", langKey === 'hb_ISR' || langKey === 'ar_AR');
            }
        });

        $scope.$on('chart-create', function (event, chart) {
            chart.chart.height = 500;
            // console.log(chart.chart)
        });

        /**
         * Opens "Edit Order" form
         */
        ctrl.edit_order_form = function(order_id) {

            $uibModal.open({
                templateUrl: "app/modules/calendar/order/order.form.html",
                controller: "OrderFormController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                resolve: {
                    Items: function($api) {
                        return $api.resolve("items.items_with_duration@get");
                    },
                    Customers: function($api) {
                        return $api.resolve("customers@get");
                    },
                    Resources: function($api) {
                        return $api.resolve("resources@get");
                    },
                    SecondResources: function($api) {
                        return $api.resolve("second_resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Clubs: function($api) {
                        return $api.resolve("settings.clubs@get");
                    },
                    Customer: function($api) {
                        return null;
                    },
                    Order: function($api) {
                        return $api.resolve("orders.single@get", {
                            "id": order_id
                        });
                    },
                    Messages:  function($api) {
                        return $api.resolve("settings.messages@get");
                    },
                    CalendarCourse: null,
                    CalendarEvent: null,
                    EventCopy: false,
                    CoursesFields: ['$api', function ($api) {
                        return $api.resolve('coursesFields.lists@get');
                    }],
                }
            }).closed.then(function() {
                ctrl.tableOrdersData = null;
                ctrl.load_next_orders();
                ctrl.get_orders_capacity();
            });
        };

        /**
         * Loading next orders data
         */
        ctrl.load_next_orders = function() {
            return $api.orders.today_orders.get({},
                function(response) {
                    // duration = moment.duration(ctrl.form.items[itemIndex].end_time.diff(ctrl.form.items[itemIndex].start_time));
                    for (var i=0; i<response.data.length; i++) {
                        if($scope.b_type == 2) {
                            var start_time = moment(response.data[i].start_time);
                            var end_time = moment(response.data[i].end_time);
                            var duration = moment.duration(end_time.diff(start_time));
                            response.data[i].nights = Math.round(duration.asDays());
                            response.data[i].date = response.data[i].start_time;
                            response.data[i].start_time = moment(response.data[i].start_time).format('DD/MM/YYYY');
                        } else {
                            //response.data[i].start_time = moment(response.data[i].start_time).format('HH:mm');
                        }
                    }
                    ctrl.tableOrdersData = response.data;
                });
        }

        /**
         * Triggers when event is rendered on the calendar
         * @param {Object} event Event object
         * @param {jQuery} element  jQuery element
         * @return {void}
         */
        ctrl.event_render = function(event, element){
            if(event.order_status == 2){
                element.append('<i class="fa fa-clock-o"></i>');
            }else if(event.order_status == 3){
                element.append('<i class="fa fa-money"></i>');
                element.css('background-color', '#e4e4e4');
                element.addClass('calendar-order-completed');
            }
        };


        /**
         * Preparing neccesary configuration for the motels calendar UI
         * @return object
         */
        ctrl.prepare_motels_configuration = function(isRTL) {

            return {
                // resourceAreaWidth: 230,
                editable: true,
                aspectRatio: 1.5,
                scrollTime: '00:00',
                firstDay: 0,
                locale: 'he',
                defaultView: 'customWeek',
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                views: {
                    customWeek: {
                        type: 'timeline',
                        duration: { weeks: 1 },
                        slotDuration: { days: 1 }
                    }
                },
                height: 200,
                dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                dayNamesShort: ["'א", "'ב", "'ג", "'ד", "'ה", "'ו", "'ש"],
                isRTL: isRTL,
                events: [],
                axisFormat: 'HH:mm',
                resources: ctrl.uiResources,
                resourceLabelText: 'משאבים',
                eventResize: ctrl.handle_item_drag_resize,
                eventDrop: ctrl.handle_item_drag_resize,
                header: {
                    left: '',
                    center: '',
                    right: ''
                },
                dayRender: ctrl.day_render,
                eventRender: ctrl.event_render,
                // viewRender: function() {
                //     setTimeout(ctrl.timeline_view_hover, 200);
                // },
                // eventClick: function(event) {
                //     ctrl.edit_order_form(event.orderId);
                // },
                // dayClick: function(date, jsEvent, view, resourceObj) {
                //     if(ctrl.settings.time == "monthly") {
                //         ctrl.change_calendar_type("orders");
                //         ctrl.change_calendar_time("weekly");
                //         ctrl.settings.date = new Date(date.format());
                //         uiCalendarConfig.calendars.mainCalendar.fullCalendar("gotoDate", date);
                //     } else {
                //         if(resourceObj) {
                //             ctrl.open_order_form(date, resourceObj.id);
                //         } else {
                //             ctrl.open_order_form(date);
                //         }
                //     }
                // }
            };
        };


        /**
         * Triggers the API call to retreive capacity information
         * @return {void}
         */
        ctrl.get_orders_capacity = function() {
            //stop orders capacity
            return;
            
            var date = new Date(ctrl.settings.date);

            ctrl.settings.loading = true;

            if(ctrl.apiRequest != null)
                ctrl.apiRequest.$cancelRequest();

            ctrl.apiRequest = $api.orders.capcaity.get({
                date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
            }, function(response) {
                ctrl.settings.loading = false;
                ctrl.capacityData = response.data;
                ctrl.set_capacity_colors();
                ctrl.apiRequest = null;
            });
        };

        /**
         * Sets the color for each day according to its capacity
         */
        ctrl.set_capacity_colors = function() {
            var
                color,
                capacity_to_check,
                slots_string;

            for(var i in ctrl.capacityData) {

                if(ctrl.settings.resource)
                    capacity_to_check = ctrl.capacityData[i][parseInt(ctrl.settings.resource)];
                else
                    capacity_to_check = ctrl.capacityData[i]["global"];

                if(capacity_to_check.percentage < 75)
                    color = "green";
                else if(capacity_to_check.percentage < 90)
                    color = "orange";
                else
                    color = "red";

                slots_string = (capacity_to_check.total_slots - capacity_to_check.taken_slots) + "/" + (capacity_to_check.total_slots) + " (" + capacity_to_check.percentage + "% תפוסה)";

                $(".day-" + i).addClass("day-capacity-" + color).attr("data-slots", slots_string);
            }
        };

        ctrl.load_next_orders();
        ctrl.get_orders_capacity();

        // Load campaign bar on initialization
        ctrl.loadCampaignBar();

        $timeout(function() {
            ctrl.loadDashboardAnalytics();
            ctrl.loadDashboardCustomers();
        }, 0);

        ctrl.hexToRgbA = function(hex){
            var c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c= hex.substring(1).split('');
                if(c.length== 3){
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
            }
            return 'rgba(169,207,232,0.1)';
        }
    });


})();

(function () {

    angular.module('app.controllers')

        .controller('CalendarEventController', function(Order, $timeout, $header, $api, $scope, $window, $translate) {
  
            var ctrl = this;

            function compareTimes(a, b) {
                if (a.start_time < b.start_time) return -1;
                if (a.start_time > b.start_time) return 1;
                return 0;
            }

            ctrl.order = Order && Order.data ? Order.data : false
            ctrl.first_item = {};
            ctrl.start = '';
            ctrl.end = '';
            ctrl.tz = '';
            ctrl.utcOffset = '';

            if (ctrl.order && ctrl.order.items) {
                ctrl.order.items.sort(compareTimes);
                ctrl.first_item = ctrl.order.items[0];
                for (var i in ctrl.order.items) {
                    var $item = ctrl.order.items[i];
                    var type_current = $item.item_data && $item.item_data.item_type ? $item.item_data.item_type : $item.item_type;
                    var type_first = ctrl.first_item.item_data && ctrl.first_item.item_data.item_type ? ctrl.first_item.item_data.item_type : ctrl.first_item.item_type;
                    if (!ctrl.first_item || type_first !== 'service' || 
                        (type_current === 'service' && $item['start_time'] && 
                        new Date($item['start_time']).getTime() < new Date(ctrl.first_item['start_time']).getTime())) {
                        ctrl.first_item = $item;
                    }
                }
                ctrl.date = moment(ctrl.first_item.start_time).format('YYYY-MM-DD');
                ctrl.start = moment(ctrl.first_item.start_time).format('HH:mm');
                ctrl.end = moment(ctrl.first_item.end_time).format('HH:mm');
                ctrl.tz = moment(ctrl.first_item.start_time).tz();
                ctrl.utcOffset = moment(ctrl.first_item.start_time).format('Z');

                $timeout(function() { atcb_init(); }, 100);
            }
        });
        
})();
(function () {
    angular.module('app.controllers')

        .controller('CalendarController', function ($header, $interval, $scope, $rootScope, Info, Lflag, $date, $filter,
            Holidays, dates, Resources, Customer, $translate, uiCalendarConfig, $uibModal, $api, $color, $state, $stateParams, $timeout, $compile, HebrewDate, $window) {
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            // It's Ugly, no need it for now
            // var tooltip = $('<div/>').qtip({
            //     id: 'fullcalendar',
            //     prerender: true,
            //     content: {
            //         text: ' ',
            //         title: ' '
            //     },
            //     position: {
            //         my: 'bottom center',
            //         at: 'top center',
            //         target: 'mouse',
            //         viewport: $('#fullcalendar'),
            //         adjust: {
            //             mouse: false,
            //             scroll: false
            //         }
            //     },
            //     show: false,
            //     hide: false,
            //     style: 'qtip-light'
            // }).qtip('api');
            if ($rootScope.userRole == 1) {
                $state.go('app.admin', {}, { reload: true });
                return;
            }

            $scope.clientEvents = []; // all Events
            $scope.isMobile = (angular.element(document).width() < 769);

            var ctrl = this;
            ctrl.showCapacityButton = true;
            ctrl.moved_order = false;
            ctrl.copied_order = false;
            ctrl.isSearching = false;
            ctrl.isExpanded = false;
            ctrl.order_form_modal_opened = false;

            ctrl.activateSearch = function () {
                $timeout(function () {
                    ctrl.isSearching = true;

                    $timeout(function () {
                        var input = document.querySelector('.find-event-input');
                        if (input) {
                            input.focus();
                        }
                    });
                });
            };

            ctrl.canPrintCalendar = function () {
                return !$scope.isMobile
                    && ctrl.settings
                    && ctrl.settings.bu_type == 1
                    && ctrl.settings.type == "orders"
                    && (ctrl.settings.time == "daily" || ctrl.settings.time == "weekly");
            };

            // Calendar print geometry: must stay in sync with @page calendar_print in calendar.less (A4 landscape, 8mm margins).
            var CALENDAR_PRINT_PAGE_HEIGHT_MM = 210;
            var CALENDAR_PRINT_PAGE_MARGIN_MM = 8;
            var CALENDAR_PRINT_ROWS_PER_PAGE = 20;
            var CALENDAR_PRINT_INNER_HEIGHT_SAFETY_PX = 2;

            function calendarPrintMmToPx(mm) {
                return (mm * 96) / 25.4;
            }

            function calendarPrintPageInnerHeightPx() {
                return calendarPrintMmToPx(
                    CALENDAR_PRINT_PAGE_HEIGHT_MM - 2 * CALENDAR_PRINT_PAGE_MARGIN_MM
                );
            }

            function calendarPrintSlotMinutesFromSettings(settings) {
                if (!settings) {
                    return 10;
                }
                var interval = settings.interval || "00:10:00";
                var parts = String(interval).split(":");
                var h = parseInt(parts[0], 10) || 0;
                var m = parseInt(parts[1], 10) || 0;
                var sec = parseInt(parts[2], 10) || 0;
                var slotMinutes = h * 60 + m + sec / 60;
                if (!slotMinutes || slotMinutes <= 0) {
                    slotMinutes = 10;
                }
                return slotMinutes;
            }

            function calendarPrintGridSpanMinutes(settings) {
                if (!settings) {
                    return 0;
                }
                var min = settings.minTime || "07:00:00";
                var max = settings.maxTime || "21:00:00";
                var day = "2000-01-01";
                var t0 = moment(day + " " + min, "YYYY-MM-DD HH:mm:ss");
                var t1 = moment(day + " " + max, "YYYY-MM-DD HH:mm:ss");
                if (!t1.isAfter(t0)) {
                    t1.add(1, "day");
                }
                return Math.max(0, t1.diff(t0, "minutes"));
            }

            function calendarPrintCountSlotsFromSettings(settings) {
                var span = calendarPrintGridSpanMinutes(settings);
                var slotMinutes = calendarPrintSlotMinutesFromSettings(settings);
                return Math.max(0, Math.round(span / slotMinutes));
            }

            function calendarPrintGridStartMomentForEventDay(settings, startMoment) {
                if (!startMoment || !moment.isMoment(startMoment) || !startMoment.isValid()) {
                    return null;
                }
                var d = startMoment.format("YYYY-MM-DD");
                var minT = (settings && settings.minTime) ? settings.minTime : "07:00:00";
                return moment(d + " " + minT, "YYYY-MM-DD HH:mm:ss");
            }

            function calendarPrintEventSlotRowRange(settings, startM, endM, domSlatRowCount) {
                if (!settings || !startM || !endM || !moment.isMoment(startM) || !moment.isMoment(endM)) {
                    return null;
                }
                if (!startM.isValid() || !endM.isValid()) {
                    return null;
                }
                var slotMinutes = calendarPrintSlotMinutesFromSettings(settings);
                if (slotMinutes <= 0) {
                    return null;
                }
                var spanMinutes = calendarPrintGridSpanMinutes(settings);
                if (spanMinutes <= 0) {
                    return null;
                }
                var gridStart = calendarPrintGridStartMomentForEventDay(settings, startM);
                if (!gridStart || !gridStart.isValid()) {
                    return null;
                }
                var startOff = startM.diff(gridStart, "minutes");
                var endOff = endM.diff(gridStart, "minutes");
                startOff = Math.max(0, Math.min(startOff, spanMinutes));
                endOff = Math.max(0, Math.min(endOff, spanMinutes));
                var rowStart = Math.floor(startOff / slotMinutes);
                var rowEndInclusive;
                if (endOff <= startOff) {
                    rowEndInclusive = rowStart;
                } else {
                    var rowEndExclusive = Math.ceil(endOff / slotMinutes);
                    rowEndInclusive = rowEndExclusive - 1;
                }
                rowEndInclusive = Math.max(rowEndInclusive, rowStart);
                var nRowsSettings = calendarPrintCountSlotsFromSettings(settings);
                var nRows = nRowsSettings;
                if (domSlatRowCount && domSlatRowCount > nRows) {
                    nRows = domSlatRowCount;
                }
                if (nRows > 0) {
                    rowStart = Math.min(rowStart, nRows - 1);
                    rowEndInclusive = Math.min(rowEndInclusive, nRows - 1);
                }
                return { rowStart: rowStart, rowEndInclusive: rowEndInclusive };
            }

            function calendarPrintPageRangeForRows(rowStart, rowEndInclusive, rowsPerPageOverride) {
                var rowsPerPage = rowsPerPageOverride && rowsPerPageOverride > 0 ? Math.floor(rowsPerPageOverride) : CALENDAR_PRINT_ROWS_PER_PAGE;
                if (rowsPerPage < 1) {
                    rowsPerPage = 1;
                }
                var rs = rowStart < 0 ? 0 : rowStart;
                var re = rowEndInclusive < rs ? rs : rowEndInclusive;
                var pageStart = Math.floor(rs / rowsPerPage);
                var pageEnd = Math.floor(re / rowsPerPage);
                return { pageStart: pageStart, pageEnd: pageEnd };
            }

            /** Row indices from absolute layout vs first slat row top (weekly). Logs showed tbody/parent top is ~1 rowPx above slot 0 vs event tops (gStart = rowTime - 1). */
            function calendarPrintWeeklyGeomRowsFromRects(printWrapper, eventEl, rowPx, capIdx) {
                if (!printWrapper || !printWrapper.length || !eventEl || !eventEl.getBoundingClientRect || rowPx < 1 || capIdx < 0) {
                    return null;
                }
                var slatsTable = printWrapper.find(".fc-slats table").first();
                if (!slatsTable.length) {
                    return null;
                }
                var firstDataTr = slatsTable[0].querySelector("tbody tr") || slatsTable[0].querySelector("tr");
                if (!firstDataTr || !firstDataTr.getBoundingClientRect) {
                    return null;
                }
                var slot0Top = firstDataTr.getBoundingClientRect().top;
                var eRect = eventEl.getBoundingClientRect();
                var relTop = eRect.top - slot0Top;
                var relBottom = eRect.bottom - slot0Top;
                if (!isFinite(relTop) || !isFinite(relBottom)) {
                    return null;
                }
                var gStart = Math.min(Math.max(0, Math.floor(relTop / rowPx + 1e-9)), capIdx);
                var gEnd = Math.min(capIdx, Math.max(gStart, Math.ceil(relBottom / rowPx - 1e-9) - 1));
                return { gStart: gStart, gEnd: gEnd, relTop: relTop, relBottom: relBottom };
            }

            function calendarPrintProbeHeadHeightPx(rootJQ) {
                if (!rootJQ || !rootJQ.length) {
                    return 0;
                }
                function nodeOuterPx(node) {
                    if (!node || node.nodeType !== 1) {
                        return 0;
                    }
                    var h = node.offsetHeight || 0;
                    if (h <= 0 && node.getBoundingClientRect) {
                        h = node.getBoundingClientRect().height || 0;
                    }
                    return Math.round(h * 1000) / 1000;
                }
                // Do not take max across all thead/head nodes: .fc-view-container can contain several
                // header bands (e.g. week row + time-grid header); max was ~one slot row too tall vs what repeats per printed page.
                var timeGrid = rootJQ.find(".fc-time-grid").first();
                if (timeGrid.length) {
                    var headInGrid = timeGrid.find(".fc-head-container").first();
                    if (headInGrid.length) {
                        var hx = nodeOuterPx(headInGrid[0]);
                        if (hx > 0) {
                            return hx;
                        }
                    }
                    var theadInGrid = timeGrid.find("thead").first();
                    if (theadInGrid.length) {
                        var ty = nodeOuterPx(theadInGrid[0]);
                        if (ty > 0) {
                            return ty;
                        }
                    }
                }
                var headFallback = rootJQ.find(".fc-head-container").first();
                if (headFallback.length) {
                    var hz = nodeOuterPx(headFallback[0]);
                    if (hz > 0) {
                        return hz;
                    }
                }
                return 0;
            }

            function calendarPrintMeasureHeadHeightPx(printWrapper) {
                return calendarPrintProbeHeadHeightPx(printWrapper);
            }

            /**
             * Weekly print: effective height (px) of the band that repeats above the time grid on each printed page.
             * Logs showed fallback headerPx+gap gave 79+8=87 → ~8px/page drift down with holidays; compact 58+8=66 still ~8px/page up → need +2×gap for short heads.
             * Tall heads (holiday row): use head box only — margin is already in fc-head-container height; do not add headerBodyGapPx again.
             */
            function calendarPrintMeasureWeeklyHeadToSlatsBandPx(printWrapper, headerBodyGapPx) {
                if (!printWrapper || !printWrapper.length) {
                    return null;
                }
                var headEl = printWrapper.find(".fc-time-grid .fc-head-container").first();
                if (!headEl.length || !headEl[0]) {
                    return null;
                }
                var headNode = headEl[0];
                var headRect = headNode.getBoundingClientRect ? headNode.getBoundingClientRect() : null;
                var headH = headRect && isFinite(headRect.bottom - headRect.top) ? headRect.bottom - headRect.top : 0;
                if (headH < 1) {
                    headH = headNode.offsetHeight || 0;
                }
                if (!isFinite(headH) || headH <= 0) {
                    return null;
                }
                var gapPx = typeof headerBodyGapPx === "number" && headerBodyGapPx >= 0 ? headerBodyGapPx : 0;
                var tallWeeklyHeadPx = 70;
                if (headH >= tallWeeklyHeadPx) {
                    return Math.round(headH * 1000) / 1000;
                }
                var slatTr = printWrapper.find(".fc-time-grid .fc-slats tbody tr").first();
                if (!slatTr.length) {
                    slatTr = printWrapper.find(".fc-time-grid .fc-slats tr").first();
                }
                if (!slatTr.length) {
                    slatTr = printWrapper.find(".fc-slats tbody tr").first();
                }
                if (!slatTr.length) {
                    slatTr = printWrapper.find(".fc-slats tr").first();
                }
                if (!slatTr.length || !slatTr[0] || !slatTr[0].getBoundingClientRect || !headRect) {
                    return Math.round((headH + (gapPx > 0 ? 2 * gapPx : 0)) * 1000) / 1000;
                }
                var slatRect = slatTr[0].getBoundingClientRect();
                var gapAfterHead = slatRect.top - headRect.bottom;
                if (!isFinite(gapAfterHead)) {
                    return Math.round((headH + (gapPx > 0 ? 2 * gapPx : 0)) * 1000) / 1000;
                }
                var band = headH + Math.max(0, gapAfterHead);
                if (gapAfterHead < 1 && gapPx > 0) {
                    band += 2 * gapPx;
                }
                if (gapPx > 0) {
                    band = Math.max(band, headH + 2 * gapPx);
                }
                if (!isFinite(band) || band <= 0) {
                    return null;
                }
                return Math.round(band * 1000) / 1000;
            }

            /** margin-bottom under .fc-row.fc-widget-header (see calendar.less); not included in fc-head-container offsetHeight, repeats with printed header bands. */
            function calendarPrintHeaderBodyGapPx(sourceCalendarWrapper) {
                var row = sourceCalendarWrapper.find(".fc-time-grid .fc-row.fc-widget-header").first();
                if (!row.length) {
                    row = sourceCalendarWrapper.find(".fc-row.fc-widget-header").first();
                }
                if (!row.length || !row[0]) {
                    return 8;
                }
                var mb = $window.getComputedStyle(row[0]).marginBottom || "";
                var n = parseFloat(mb);
                return isFinite(n) && n >= 0 ? n : 8;
            }

            function calendarPrintParseLengthPx(val) {
                if (val == null || val === "" || val === "auto") {
                    return null;
                }
                var s = String(val).trim();
                var m = /^(-?[0-9]*\.?[0-9]+)px$/i.exec(s);
                if (m) {
                    var n = parseFloat(m[1]);
                    return isFinite(n) ? n : null;
                }
                return null;
            }

            function calendarPrintReadPxProp(node, propName) {
                var inlinePx = calendarPrintParseLengthPx(node.style.getPropertyValue(propName));
                if (inlinePx != null) {
                    return inlinePx;
                }
                var cs = $window.getComputedStyle(node);
                return calendarPrintParseLengthPx(cs.getPropertyValue(propName));
            }

            function calendarPrintGetFcSegFromElement(sourceNode) {
                if (!sourceNode) {
                    return null;
                }
                var jq = typeof jQuery !== "undefined" ? jQuery : (typeof $ !== "undefined" ? $ : null);
                if (jq) {
                    var segJq = jq(sourceNode).data("fcSeg");
                    if (segJq) {
                        return segJq;
                    }
                }
                var segNg = angular.element(sourceNode).data("fcSeg");
                return segNg || null;
            }

            function calendarPrintGetEventTimesFromSourceNode(sourceNode, clientEvents) {
                if (!sourceNode) {
                    return null;
                }
                var seg = calendarPrintGetFcSegFromElement(sourceNode);
                if (seg && seg.start) {
                    var s = seg.start;
                    var e = seg.end || seg.start;
                    var startM = moment.isMoment(s) ? s.clone() : moment(s);
                    var endM = moment.isMoment(e) ? e.clone() : moment(e);
                    if (startM.isValid() && endM.isValid()) {
                        return { start: startM, end: endM };
                    }
                }
                if (clientEvents && clientEvents.length) {
                    var dataItem = sourceNode.getAttribute("data-item");
                    if (dataItem) {
                        var dash = dataItem.indexOf("-");
                        if (dash > 0) {
                            var type = dataItem.substring(0, dash);
                            var idStr = dataItem.substring(dash + 1);
                            for (var i = 0; i < clientEvents.length; i++) {
                                var ev = clientEvents[i];
                                if (type === "order" && ev.orderId != null && String(ev.orderId) === idStr && ev.start && ev.end) {
                                    return { start: moment(ev.start), end: moment(ev.end) };
                                }
                                if (type === "event" && ev.eventId != null && String(ev.eventId) === idStr && ev.start && ev.end) {
                                    return { start: moment(ev.start), end: moment(ev.end) };
                                }
                                if (type === "course" && ev.courseId != null && String(ev.courseId) === idStr && ev.start && ev.end) {
                                    return { start: moment(ev.start), end: moment(ev.end) };
                                }
                            }
                        }
                    }
                }
                return null;
            }

            function calendarPrintApplyEventHeaderOffsets(printWrapper, sourceCalendarWrapper, settings, clientEvents, headerPxCache, domSlatRowCount) {
                // Prefer on-screen calendar head height: the print clone lives in a different width (off-screen modal)
                // and weekly headers can reflow (taller .fc-head-container) → inflated pageBreakShift and wrong page-2+ placement.
                var measuredPrint = calendarPrintMeasureHeadHeightPx(printWrapper);
                var measuredSource = calendarPrintProbeHeadHeightPx(sourceCalendarWrapper);
                var headerPx = measuredSource > 0 ? measuredSource : measuredPrint;
                if (headerPx <= 0 && headerPxCache && headerPxCache.value > 0) {
                    headerPx = headerPxCache.value;
                }
                if (headerPx <= 0) {
                    return;
                }
                if (headerPx > 0 && headerPxCache) {
                    headerPxCache.value = headerPx;
                }
                // fc-head-container height includes the time-axis corner row (~one slot tall) that sits beside the grid,
                // not the band that repeats at each printed page. Subtract one print slot row (same model as applyPrintGridFromPageModel).
                // Weekly agenda: printed thead repeats differently than daily; subtracting the same corner row makes
                // pageBreakShiftPx short by ~one print row per continuation page (events drift up on page 2, 3, …).
                var printInnerPx = Math.max(0, calendarPrintPageInnerHeightPx() - CALENDAR_PRINT_INNER_HEIGHT_SAFETY_PX);
                var printSlotRowPx = printInnerPx / CALENDAR_PRINT_ROWS_PER_PAGE;
                if (printSlotRowPx < 1) {
                    printSlotRowPx = 1;
                }
                var headerBodyGapPx = headerPxCache && typeof headerPxCache.bodyGapPx === "number" ? headerPxCache.bodyGapPx : calendarPrintHeaderBodyGapPx(sourceCalendarWrapper);
                var isWeeklyPrint = settings && settings.time === "weekly";
                var weeklyBandPx = isWeeklyPrint ? calendarPrintMeasureWeeklyHeadToSlatsBandPx(printWrapper, headerBodyGapPx) : null;
                var weeklyHeaderBudgetPx = isWeeklyPrint
                    ? (weeklyBandPx != null
                        ? weeklyBandPx
                        : Math.max(0, headerPx < 70 ? headerPx + 2 * headerBodyGapPx : headerPx))
                    : null;
                var headerPxForPageBreak = isWeeklyPrint
                    ? Math.max(0, weeklyHeaderBudgetPx)
                    : Math.max(0, headerPx - printSlotRowPx);
                // Half of margin-bottom under the header row (daily). Weekly: band measurement already includes thead→slats gap.
                var pageBreakShiftPx = headerPxForPageBreak + (isWeeklyPrint ? 0 : headerBodyGapPx / 2);
                // Rows that fit below the **repeating** print header. For daily, headerPxForPageBreak already subtracts the
                // non-repeating time-axis corner row; rowsPerPrintedPage must use the same budget — using full headerPx here
                // removed one content row per sheet vs reality → pageStart one too high for the first slot after each break
                // (~one printSlotRowPx extra deltaTop, looked like a single 15m row shift). Weekly: same budget as pageBreakShift.
                var headerPxForRowsPerPage = isWeeklyPrint
                    ? Math.max(0, weeklyHeaderBudgetPx || headerPx)
                    : Math.max(0, headerPx - printSlotRowPx);
                var rowsPerPrintedPage = Math.max(1, Math.floor((printInnerPx - headerPxForRowsPerPage) / printSlotRowPx));

                var sourceTimedEvents = sourceCalendarWrapper.find(".fc-time-grid-event, .fc-bgevent");
                var printTimedEvents = printWrapper.find(".fc-time-grid-event, .fc-bgevent");
                printTimedEvents.each(function (index, targetNode) {
                    var sourceNode = sourceTimedEvents[index];
                    if (!sourceNode) {
                        return;
                    }
                    var times = calendarPrintGetEventTimesFromSourceNode(sourceNode, clientEvents);
                    if (!times) {
                        return;
                    }
                    var rowRange = calendarPrintEventSlotRowRange(settings, times.start, times.end, domSlatRowCount);
                    if (!rowRange) {
                        return;
                    }
                    var topPx = calendarPrintReadPxProp(targetNode, "top");
                    var hPx = calendarPrintReadPxProp(targetNode, "height");
                    // Weekly: use max(time-based, geometry-based) page index so we never under-shift continuation pages
                    // (too little deltaTop → event sits above the slats). Geometry uses scaled top/rowPx; time uses slot math
                    // with clamp expanded by domSlatRowCount when DOM has more rows than settings-derived count.
                    var pagesTime = calendarPrintPageRangeForRows(rowRange.rowStart, rowRange.rowEndInclusive, rowsPerPrintedPage);
                    var pages = pagesTime;
                    var gStart;
                    var gEnd;
                    var pagesGeom = null;
                    var rectGeom = null;
                    if (isWeeklyPrint && domSlatRowCount && domSlatRowCount > 0 && printSlotRowPx >= 1) {
                        var capIdx = domSlatRowCount - 1;
                        if (capIdx >= 0) {
                            rectGeom = calendarPrintWeeklyGeomRowsFromRects(printWrapper, targetNode, printSlotRowPx, capIdx);
                            if (rectGeom) {
                                gStart = rectGeom.gStart;
                                gEnd = rectGeom.gEnd;
                            } else if (topPx != null) {
                                gStart = Math.min(Math.max(0, Math.floor(topPx / printSlotRowPx + 1e-9)), capIdx);
                                gEnd = gStart;
                                if (hPx != null && hPx > 0) {
                                    gEnd = Math.min(capIdx, Math.max(gStart, Math.ceil((topPx + hPx) / printSlotRowPx - 1e-9) - 1));
                                }
                            }
                            if (gStart != null) {
                                pagesGeom = calendarPrintPageRangeForRows(gStart, gEnd, rowsPerPrintedPage);
                                pages = {
                                    pageStart: Math.max(pagesTime.pageStart, pagesGeom.pageStart),
                                    pageEnd: Math.max(pagesTime.pageEnd, pagesGeom.pageEnd)
                                };
                            }
                        }
                    }
                    // pageStart: which printed page the event start row falls on (row 0..ROWS-1 => 0; >= ROWS => 1+).
                    var deltaTop = pages.pageStart * pageBreakShiftPx;
                    var deltaHeight = (pages.pageEnd - pages.pageStart) * pageBreakShiftPx;

                    if (topPx != null) {
                        targetNode.style.setProperty("top", (topPx + deltaTop) + "px", "important");
                    }
                    if (hPx != null) {
                        targetNode.style.setProperty("height", (hPx + deltaHeight) + "px", "important");
                    }
                    var minHPx = calendarPrintReadPxProp(targetNode, "min-height");
                    if (minHPx != null) {
                        targetNode.style.setProperty("min-height", (minHPx + deltaHeight) + "px", "important");
                    }
                    var maxHPx = calendarPrintReadPxProp(targetNode, "max-height");
                    if (maxHPx != null) {
                        targetNode.style.setProperty("max-height", (maxHPx + deltaHeight) + "px", "important");
                    }
                    var bottomPx = calendarPrintReadPxProp(targetNode, "bottom");
                    if (bottomPx != null) {
                        targetNode.style.setProperty("bottom", (bottomPx - deltaHeight) + "px", "important");
                    }
                });
            }

            ctrl.printCalendar = function () {
                if (!ctrl.canPrintCalendar()) {
                    return;
                }
                var bodyElement = angular.element(document.body);
                var sourceCalendarWrapper = angular.element('#calendar .calendar-wrapper').first();
                if (!sourceCalendarWrapper.length) {
                    return;
                }

                var prePrintSourceHeadPx = calendarPrintProbeHeadHeightPx(sourceCalendarWrapper);
                var prePrintHeaderBodyGapPx = calendarPrintHeaderBodyGapPx(sourceCalendarWrapper);

                var printModal = $uibModal.open({
                    templateUrl: "app/modules/calendar/calendar.print-modal.html",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal calendar-print-modal",
                    backdrop: 'static',
                    keyboard: false
                });

                printModal.rendered.then(function () {
                    $timeout(function () {
                        var targetContainer = angular.element('.calendar-print-modal .calendar-print-modal-body').last();
                        if (!targetContainer.length) {
                            printModal.dismiss('error');
                            return;
                        }

                        var printWrapper = angular.element('<div id="calendar" class="calendar-print-route"></div>');
                        var clonedWrapper = sourceCalendarWrapper.clone();
                        clonedWrapper.removeClass('height-100');
                        clonedWrapper.find('.height-100').removeClass('height-100');
                        clonedWrapper.find('.calendar-non-capacity, .calendar-capacity').removeClass('calendar-non-capacity calendar-capacity');

                        clonedWrapper.find('#mainCalendar').attr('id', 'mainCalendarPrint');
                        clonedWrapper.find('.calendar-expand-button').remove();
                        clonedWrapper.find('.cursor-circle').remove();
                        clonedWrapper.find('.fc-helper, .fc-highlight, .fc-popover, .ui-resizable-handle, .temp-cells, .temp-cell').remove();
                        clonedWrapper.find('.fc-scroller, .fc-time-grid-container, .fc-view-container, .fc-view').css({
                            overflow: 'visible',
                            height: 'auto',
                            maxHeight: 'none'
                        });
                        clonedWrapper.find('.fc-scroller').scrollTop(0);

                        printWrapper.append(clonedWrapper);

                        // Print modal is off-screen on screen (see calendar.less) but keeps real geometry; cache still
                        // covers edge cases where probe runs before layout settles.
                        var printHeadHeightPxCache = { value: prePrintSourceHeadPx, bodyGapPx: prePrintHeaderBodyGapPx };

                        // Print: vertical column dividers — override screen `border-collapse: separate` on
                        // `.fc-slats > table` (calendar.less) by setting collapse + fixed layout on slats/skeleton/bg
                        // tables in the clone. Row height is derived from the printable page (see CALENDAR_PRINT_*)
                        // so slats, skeleton, and fc-bg table share one vertical module (no drift on page 3+).
                        // `.fc-time-grid > .fc-bg`: wrapper sizing for print is CSS inset stretch (see calendar.less), not inline px.
                        var applyPrintGridFromPageModel = function () {
                            var pageInnerPx = calendarPrintPageInnerHeightPx();
                            var inner = Math.max(0, pageInnerPx - CALENDAR_PRINT_INNER_HEIGHT_SAFETY_PX);
                            var rowPx = inner / CALENDAR_PRINT_ROWS_PER_PAGE;
                            if (rowPx < 1) {
                                rowPx = 1;
                            }

                            var slatsTable = printWrapper.find(".fc-slats table").first();
                            var nRows = slatsTable.length ? slatsTable.find("tbody tr").length : 0;
                            if (!nRows) {
                                nRows = printWrapper.find(".fc-slats tbody tr").length;
                            }
                            if (!nRows) {
                                nRows = printWrapper.find(".fc-slats tr").length;
                            }
                            if (!nRows) {
                                nRows = calendarPrintCountSlotsFromSettings(ctrl.settings);
                            }
                            if (!nRows) {
                                return;
                            }

                            var tableTotalPx = nRows * rowPx;

                            // Extra .fc-bg height for print: each continuation sheet repeats the header band (same model as event pageBreakShiftPx).
                            var printInnerForPages = Math.max(0, calendarPrintPageInnerHeightPx() - CALENDAR_PRINT_INNER_HEIGHT_SAFETY_PX);
                            var slotPxForPages = printInnerForPages / CALENDAR_PRINT_ROWS_PER_PAGE;
                            if (slotPxForPages < 1) {
                                slotPxForPages = 1;
                            }
                            var gapForPages = typeof printHeadHeightPxCache.bodyGapPx === "number"
                                ? printHeadHeightPxCache.bodyGapPx
                                : calendarPrintHeaderBodyGapPx(sourceCalendarWrapper);
                            var headPrint = calendarPrintMeasureHeadHeightPx(printWrapper);
                            var headSource = calendarPrintProbeHeadHeightPx(sourceCalendarWrapper);
                            var headPxForPages = headSource > 0 ? headSource : headPrint;
                            if (headPxForPages <= 0 && printHeadHeightPxCache.value > 0) {
                                headPxForPages = printHeadHeightPxCache.value;
                            }
                            var weeklyP = ctrl.settings && ctrl.settings.time === "weekly";
                            var weeklyBandP = weeklyP ? calendarPrintMeasureWeeklyHeadToSlatsBandPx(printWrapper, gapForPages) : null;
                            var weeklyBudgetP = weeklyP
                                ? (weeklyBandP != null
                                    ? weeklyBandP
                                    : Math.max(0, headPxForPages < 70 ? headPxForPages + 2 * gapForPages : headPxForPages))
                                : null;
                            var headerForBreakP = weeklyP
                                ? Math.max(0, weeklyBudgetP)
                                : Math.max(0, headPxForPages - slotPxForPages);
                            var pageBreakShiftForBg = headerForBreakP + (weeklyP ? 0 : gapForPages / 2);
                            var headerForRowsP = weeklyP
                                ? Math.max(0, weeklyBudgetP || headPxForPages)
                                : Math.max(0, headPxForPages - slotPxForPages);
                            var rowsPerSheet = Math.max(1, Math.floor((printInnerForPages - headerForRowsP) / slotPxForPages));
                            var printedPages = Math.max(1, Math.ceil(nRows / rowsPerSheet));
                            var bgContinuationExtraPx = printedPages > 1 ? pageBreakShiftForBg * (printedPages - 1) : 0;
                            var bgTableTotalPx = tableTotalPx + bgContinuationExtraPx;

                            printWrapper.find(".fc-slats table, .fc-content-skeleton table").each(function () {
                                this.style.setProperty("height", tableTotalPx + "px", "important");
                                this.style.setProperty("min-height", tableTotalPx + "px", "important");
                                this.style.setProperty("table-layout", "fixed", "important");
                                this.style.setProperty("border-collapse", "collapse", "important");
                            });
                            printWrapper.find(".fc-bg table").each(function () {
                                this.style.setProperty("height", bgTableTotalPx + "px", "important");
                                this.style.setProperty("min-height", bgTableTotalPx + "px", "important");
                                this.style.setProperty("table-layout", "fixed", "important");
                                this.style.setProperty("border-collapse", "collapse", "important");
                            });

                            // Do not size .fc-bg rows with rowPx: FullCalendar uses one tbody row for day columns;
                            // capping that tr to rowPx collapses vertical borders while slats use one tr per slot.
                            var slotRows = printWrapper.find(".fc-slats tbody tr, .fc-content-skeleton tbody tr");
                            if (!slotRows.length) {
                                slotRows = printWrapper.find(".fc-slats tr, .fc-content-skeleton tr");
                            }
                            slotRows.each(function () {
                                this.style.setProperty("height", rowPx + "px", "important");
                                this.style.setProperty("min-height", rowPx + "px", "important");
                                this.style.setProperty("max-height", rowPx + "px", "important");
                            });
                            printWrapper.find(".fc-time-grid > .fc-bg tr").each(function () {
                                this.style.setProperty("height", "100%", "important");
                                this.style.setProperty("min-height", bgTableTotalPx + "px", "important");
                                this.style.setProperty("max-height", "none", "important");
                            });

                            if (bgContinuationExtraPx > 0) {
                                printWrapper.find(".fc-time-grid > .fc-bg").each(function () {
                                    this.style.setProperty("top", "0", "important");
                                    this.style.setProperty("left", "0", "important");
                                    this.style.setProperty("right", "0", "important");
                                    this.style.setProperty("bottom", "auto", "important");
                                    this.style.setProperty("height", bgTableTotalPx + "px", "important");
                                    this.style.setProperty("min-height", bgTableTotalPx + "px", "important");
                                });
                            }

                            var sourceSlatsTable = sourceCalendarWrapper.find("#mainCalendar .fc-slats table").first();
                            if (!sourceSlatsTable.length) {
                                sourceSlatsTable = sourceCalendarWrapper.find(".fc-slats table").first();
                            }
                            var sourceTotalPx = 0;
                            if (sourceSlatsTable.length && sourceSlatsTable[0].getBoundingClientRect) {
                                sourceTotalPx = sourceSlatsTable[0].getBoundingClientRect().height || 0;
                            }
                            if (sourceTotalPx > 0) {
                                var ratio = tableTotalPx / sourceTotalPx;
                                var sourceTimedEvents = sourceCalendarWrapper.find(".fc-time-grid-event, .fc-bgevent");
                                var printTimedEvents = printWrapper.find(".fc-time-grid-event, .fc-bgevent");
                                var scaleEventLength = function (sourceNode, targetNode, cssProp, cssSetProp) {
                                    var sourceVal = $window.getComputedStyle(sourceNode)[cssProp];
                                    if (!sourceVal || sourceVal === "auto" || sourceVal.indexOf("px") === -1) {
                                        return;
                                    }
                                    var num = parseFloat(sourceVal);
                                    if (!isFinite(num)) {
                                        return;
                                    }
                                    targetNode.style.setProperty(cssSetProp, (num * ratio) + "px", "important");
                                };
                                printTimedEvents.each(function (index, targetNode) {
                                    var sourceNode = sourceTimedEvents[index];
                                    if (!sourceNode) {
                                        return;
                                    }
                                    scaleEventLength(sourceNode, targetNode, "top", "top");
                                    scaleEventLength(sourceNode, targetNode, "bottom", "bottom");
                                    scaleEventLength(sourceNode, targetNode, "height", "height");
                                    scaleEventLength(sourceNode, targetNode, "minHeight", "min-height");
                                    scaleEventLength(sourceNode, targetNode, "maxHeight", "max-height");
                                });
                            }
                            calendarPrintApplyEventHeaderOffsets(printWrapper, sourceCalendarWrapper, ctrl.settings, $scope.clientEvents, printHeadHeightPxCache, nRows);
                        };
                        var sourceEvents = sourceCalendarWrapper.find('.fc-event');
                        var clonedEvents = printWrapper.find('.fc-event');

                        // Preserve rendered event colors/styles exactly as on screen.
                        clonedEvents.each(function (index, eventNode) {
                            var sourceNode = sourceEvents[index];
                            if (sourceNode) {
                                var computed = $window.getComputedStyle(sourceNode);
                                if (computed.backgroundColor && computed.backgroundColor !== 'rgba(0, 0, 0, 0)') {
                                    eventNode.style.setProperty('background-color', computed.backgroundColor, 'important');
                                }
                                if (computed.backgroundImage && computed.backgroundImage !== 'none') {
                                    eventNode.style.setProperty('background-image', computed.backgroundImage, 'important');
                                }
                                if (computed.background && computed.background !== 'none') {
                                    eventNode.style.setProperty('background', computed.background, 'important');
                                }
                                if (computed.borderColor) {
                                    eventNode.style.setProperty('border-color', computed.borderColor, 'important');
                                }
                                if (computed.color) {
                                    eventNode.style.setProperty('color', computed.color, 'important');
                                }
                                eventNode.style.setProperty('-webkit-print-color-adjust', 'exact', 'important');
                                eventNode.style.setProperty('print-color-adjust', 'exact', 'important');

                                var copyPrintDecorStyles = function (sel) {
                                    var srcEl = sourceNode.querySelector(sel);
                                    var dstEl = eventNode.querySelector(sel);
                                    if (!srcEl || !dstEl) {
                                        return;
                                    }
                                    var dec = $window.getComputedStyle(srcEl);
                                    if (dec.backgroundImage && dec.backgroundImage !== 'none') {
                                        dstEl.style.setProperty('background-image', dec.backgroundImage, 'important');
                                    }
                                    if (dec.backgroundSize) {
                                        dstEl.style.setProperty('background-size', dec.backgroundSize, 'important');
                                    }
                                    if (dec.backgroundPosition) {
                                        dstEl.style.setProperty('background-position', dec.backgroundPosition, 'important');
                                    }
                                    if (dec.backgroundRepeat) {
                                        dstEl.style.setProperty('background-repeat', dec.backgroundRepeat, 'important');
                                    }
                                    dstEl.style.setProperty('-webkit-print-color-adjust', 'exact', 'important');
                                    dstEl.style.setProperty('print-color-adjust', 'exact', 'important');
                                };
                                copyPrintDecorStyles('.order-avatar');
                                copyPrintDecorStyles('.ai-icon');
                            }

                            if (!eventNode.querySelector('.c-event-time')) {
                                var period = eventNode.getAttribute('tooltip');
                                if (period) {
                                    angular.element(eventNode).append('<p class="c-event-time">' + period + '</p>');
                                }
                            }
                        });

                        targetContainer.empty();
                        targetContainer.append(printWrapper);

                        applyPrintGridFromPageModel();

                        // Re-apply after the clone is in the modal DOM (layout can differ from detached clone).
                        $timeout(function () {
                            applyPrintGridFromPageModel();
                        }, 0);

                        bodyElement.addClass('calendar-printing');

                        var isPrintCleaned = false;
                        var afterPrintHandler = null;
                        var cleanupPrintState = function () {
                            if (isPrintCleaned) {
                                return;
                            }
                            isPrintCleaned = true;
                            bodyElement.removeClass('calendar-printing');
                            if (afterPrintHandler) {
                                angular.element($window).off('afterprint', afterPrintHandler);
                            }
                            printModal.close();
                        };

                        $timeout(function () {
                            applyPrintGridFromPageModel();
                            afterPrintHandler = function () {
                                $timeout(function () {
                                    cleanupPrintState();
                                }, 0);
                            };
                            angular.element($window).on('afterprint', afterPrintHandler);
                            $window.print();
                            // Fallback for browsers that do not reliably fire afterprint.
                            $timeout(function () {
                                cleanupPrintState();
                            }, 1200);
                        }, 300);
                    }, 0);
                });
            };

            moment.locale("he");
            ctrl.settings = {
                resource: null,
                time: "daily",
                type: "orders",
                interval: Info.data.interval ? '00:' + String(Info.data.interval) + ':00' : '00:10:00',
                date: ($stateParams.date) ? moment($stateParams.date) : moment(),
                scrollTime: (($stateParams.date) ? moment($stateParams.date) : moment()).subtract(60, 'minutes').format("HH") + ":00:00",
                datePickerView: "date",
                view: ($stateParams.view && $stateParams.view == 'view'),
                loading: false,
                loadingHolidays: false,
                bu_type: parseInt(Info.data.type),
                allow_online_booking: parseInt(Info.data.allow_online_booking),
                minTime: Info.data.min_time ? Info.data.min_time : "07:00:00",
                maxTime: Info.data.max_time ? Info.data.max_time : "21:00:00",
                exist_bookings: Info.data.exist_bookings,
                holiday_color: Info.data.holiday_color,
                resource: [],
            };

            ctrl.apiRequest = null;

            if (parseInt(Info.data.interval) == 60) {
                ctrl.settings.interval = "01:00:00";
            }
            if (parseInt(Info.data.interval) == 90) {
                ctrl.settings.interval = "01:30:00";
            }
            if (ctrl.settings.bu_type == 1) {
                ctrl.showCapacityButton = false;
            }
            if (ctrl.settings.bu_type == 2) {
                ctrl.settings.interval = "24:00:00";
                // ctrl.settings.time = "monthly";
                ctrl.settings.time = "weekly";
            }

            if ($stateParams.date) {
                //ctrl.settings.date = moment($stateParams.date);

            }

            $scope.events = [];
            $scope.resources = (Array.isArray(Resources.data) ? Resources.data : []).filter(function (item) {
                return item && typeof item === 'object' && item.id != null && item.name != null;
            });
            
            $scope.todayCapacity = {};
            
            ctrl.uiResources = [];
            ctrl.capacityData = null;
            
            var orderById = true;
            
            $scope.resources.forEach(function (resource) {
                ctrl.uiResources.push({
                    id: resource.id,
                    title: resource.name,
                    avatar: resource.avatar
                });
            
                if (resource.order * 1) {
                    orderById = false;
                }
            });
            
            if (orderById) {
                ctrl.uiResources.sort(function (a, b) {
                    return a.id - b.id;
                });
            }

            $scope.$watch("ctrl.settings.date", function (newValue, oldValue) {
                if (document.activeElement) {
                    if (!document.querySelector('.inputs-wrapper .date-picker-date-time')) {
                        //document.activeElement.blur();
                    }

                    if (!$('.date-picker-date-time').size()) {
                        document.activeElement.blur();
                    }
                }
            });

            ctrl.holidays = {};
            var current_year = new Date().getFullYear();
            if (Holidays.data) {
                ctrl.holidays[current_year] = Holidays.data.holidays;
            } else {
                ctrl.holidays[current_year] = [];
            }
            for (var i in ctrl.holidays[current_year]) {
                if (ctrl.holidays[current_year][i].length == 0)
                    delete ctrl.holidays[current_year][i];
            }
            /**
             * Loading holidays dates and names for the current year to the "ctrl.holidays" object
             * @return {void}
             */

            ctrl.load_holidays = function () {

                var year = ctrl.settings.date.format("YYYY");

                if (!ctrl.holidays[year]) {

                    ctrl.settings.loadingHolidays = true;

                    $api.holidays.get({
                        year: year
                    }, function (response) {

                        ctrl.settings.loadingHolidays = false;

                        if (response.status == "success") {

                            ctrl.holidays[year] = response.data.holidays;
                            //$("#mainCalendar").fullCalendar("prev");
                            //$("#mainCalendar").fullCalendar("next");

                            ctrl.initDisplayDate(ctrl.settings.date);
                        }
                    });
                }
            };


            $('#header-wrapper').toggleClass('hide-header', ctrl.isExpanded);
            $('#wrapper').toggleClass('calendar-expanded', ctrl.isExpanded);
            ctrl.expandCalendar = function() {
                ctrl.isExpanded = !ctrl.isExpanded;
                $('#header-wrapper').toggleClass('hide-header', ctrl.isExpanded);
                $('#wrapper').toggleClass('calendar-expanded', ctrl.isExpanded);
            };


            //call modal

            if ($state.current.name == 'app.calendar.call') {

            }


            /**
             * Return holiday information of given date
             * @param {Moment} date Moment.js date
             */
            ctrl.get_date_holiday = function (date) {

                var
                    fullDate = date.format("YYYY-MM-DD"),
                    year = date.format("YYYY"),
                    isHoliday = false,
                    holidayName = null;

                if (ctrl.holidays[year]) {
                    if (ctrl.holidays[year][fullDate]) {
                        if (ctrl.holidays[year][fullDate][0] && ctrl.holidays[year][fullDate][0].name) {
                            isHoliday = true;
                            holidayName = $filter('hebrewHolidayName')(ctrl.holidays[year][fullDate][0].name);
                        }
                    }
                    else {
                        for (var i in ctrl.holidays[year]) {
                            if (ctrl.holidays[year][i][0] != undefined) {
                                var startDate = moment(ctrl.holidays[year][i][0].date),
                                    endDate = moment(ctrl.holidays[year][i][0].observed);

                                if (startDate.unix() <= date.unix() && date.unix() <= endDate.unix()) {
                                    isHoliday = true;
                                    holidayName = $filter('hebrewHolidayName')(ctrl.holidays[year][i][0].name);
                                }
                            }
                        }
                    }
                }

                if (isHoliday) {
                    var days = document.getElementsByClassName("fc-widget-content");
                    if (days) {
                        for (var i = 0; i < days.length; i++) {
                            if (days[i].dataset.date == fullDate) {
                                days[i].className += ' fc-holiday';
                                if (ctrl.settings.holiday_color) {
                                    days[i].style.background = ctrl.settings.holiday_color;
                                }
                            }
                        }
                    }
                }

                return {
                    isHoliday: isHoliday,
                    holidayName: holidayName
                };
            }

            /**
             * Triggers when event is been dragged across the calendar
             * @param {Object} event New event object
             * @param {Object} delta Previous event object
             * @param {Function} revertFunc Callback to abort dragging or resize
             */
            ctrl.handle_item_drag_resize = function (event, delta, revertFunc) {
                var originalEvent;
                for (var i = 0; i < $scope.clientEvents.length; i++) {
                    if ($scope.clientEvents[i].id == event.id) {
                        originalEvent = $scope.clientEvents[i];
                        break;
                    }
                }

                if (Info.data.update_order_notification == 2 && event.type != 'event' && event.type != 'course' && originalEvent.start && moment(event.start).format("YYYY-MM-DD HH:mm") != moment(originalEvent.start).format("YYYY-MM-DD HH:mm")) {
                    swal({
                        text: $translate.instant('CALENDAR_UPDATE_ORDER_NOTIFICATION'),
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('OPTION_YES'),
                        cancelButtonText: $translate.instant('OPTION_NO')
                    }).then(function (result) {
                        ctrl.submit_update_order(event, delta, revertFunc, result.value);
                    });
                } else {
                    ctrl.submit_update_order(event, delta, revertFunc);
                }
            };

            ctrl.submit_update_order = function (event, delta, revertFunc, send_notification) {
                var start = moment(event.start);
                var end = moment(event.end);
                
                if (event.type == 'event') {
                    var event_data = {};
                    event_data.start_date_time = start.format("YYYY-MM-DD HH:mm");
                    event_data.end_date_time = end.format("YYYY-MM-DD HH:mm");
                    event_data.resource_id = event.resourceId;

                    $api.events.single.save({
                        "id": event.eventId
                    }, event_data, function (response) {
                        if (response.status !== "success") {
                            revertFunc();
                        }
                    });
                } else if (event.type == 'course') {
                    var data = {};
                    data.start_date_time = start.format("YYYY-MM-DD HH:mm");
                    data.end_date_time = end.format("YYYY-MM-DD HH:mm");
                    data.resource_id = event.resourceId;
                    data.id = event.id;
                    data.type = "meeting";

                    $api.courses.single.save({
                        "id": event.courseId,
                    }, data, function (response) {
                        if (response.status !== "success") {
                            revertFunc();
                        }
                    });
                } else {
                    var difference = false;
                    if (event.merged) {
                        difference = moment(event.original_start_time).diff(start, 'minutes')*-1;
                        end = start.clone().add(event.duration, 'minutes');
                    }

                    $api.orders.single.save({
                        "id": event.orderId
                    }, {
                        "type": "item",
                        "start": start.format("YYYY-MM-DD HH:mm"),
                        "end": end.format("YYYY-MM-DD HH:mm"),
                        "item": event.id,
                        "resource": event.resourceId,
                        "send_notification": send_notification ? 1 : 0
                    }, function (response) {
                        if (response.status !== "success") {
                            revertFunc();
                        } else {
                            if (event.merged && difference) {
                                for (var i in event.merged) {
                                    var merged_event = event.merged[i];
                                    start = moment(merged_event.start_time).add(difference, 'minutes');
                                    end = moment(merged_event.end_time).add(difference, 'minutes');
            
                                    $api.orders.single.save({
                                        "id": event.orderId
                                    }, {
                                        "type": "item",
                                        "start": start.format("YYYY-MM-DD HH:mm"),
                                        "end": end.format("YYYY-MM-DD HH:mm"),
                                        "item": merged_event.id,
                                        "resource": event.resourceId,
                                        "send_notification": 0
                                    }, function (response) {
                                        if (response.status !== "success") {
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            };

            /**
             * Handles FullCalendar dayRender event
             * @param {Moment} date
             * @param {jQuery} cell
             * @return {void}
             */
            ctrl.day_render = function (date, cell) {

                if (cell) {
                    cell.addClass("day-" + date.date());
                }

                var fullDate = date.format("YYYY-MM-DD"), dateHoliday = ctrl.get_date_holiday(moment(date));

                if (dateHoliday.isHoliday) {

                    if (cell) {
                        if (ctrl.settings.time == "monthly") {
                            cell.addClass("is-holiday");
                        }
                    }
                    else {
                        // $('.fc-bg .fc-day[data-date="' + fullDate + '"]').addClass("is-holiday");
                    }

                    $('.fc-widget-header[data-date="' + fullDate + '"]').addClass("is-holiday");
                    $('.fc-day-top[data-date="' + fullDate + '"]').addClass("is-holiday-number");
                }

                if (ctrl.settings.time == "weekly") {

                    var dateText = date.format("<b>dd DD</b>");

                    if ($rootScope.display_hebrew_dates) {
                        var hDate = HebrewDate.getHebrewFormatDateName(date.toDate());
                        if (hDate && hDate != 'undefined' && hDate != '' && hDate != null && hDate != undefined && hDate != 'null') {
                            dateText += "<small>"+hDate+"</small>";
                        }
                    } else {
                        dateText += "<br />";
                    }
                    
                    if (dateHoliday.isHoliday && dateHoliday.holidayName && dateHoliday.holidayName != 'undefined' && dateHoliday.holidayName != '' && dateHoliday.holidayName != null && dateHoliday.holidayName != undefined && dateHoliday.holidayName != 'null')
                        dateText += "<small class='holiday-name'>" + dateHoliday.holidayName + "</small>";

                    // Motels
                    $('th.fc-widget-header[data-date="' + fullDate + '"] .fc-cell-content').html(dateText);

                    // Stores
                    $('th.fc-day-header[data-date="' + fullDate + '"] > span').html(dateText).addClass('flex-column');

                    return dateText;
                } else if (ctrl.settings.time == "monthly") {
                    $('.fc-day-top[data-date="' + fullDate + '"]').append($("<span/>").addClass("holiday-name").text(dateHoliday.holidayName));
                    $('span.fc-day-number').css('float', 'left');
                    $('span.holiday-name').css('float', 'right');
                } else {
                    $(".fc-resource-cell").each(function () {
                        if ($(this).data('resource-id')) {
                            var resourceId = $(this).data('resource-id');
                            for (var i in ctrl.uiResources) {
                                if (ctrl.uiResources[i].id == resourceId) {
                                    $(this).prepend('<div class="customer-pic-wrapper calendar"><img src="' + (ctrl.uiResources[i].avatar ? ctrl.uiResources[i].avatar : "assets/images/avatar.jpg") + '" class="customer-pic"></div>');
                                    $(this).html('<div class="calendar-resourse">' + $(this).html() + '</div>');
                                    $(this).find('.calendar-resourse').off('click').on('click', function () {
                                        $state.go('app.settings.resources.single', { id: resourceId });
                                    });
                                    break;
                                }
                            }
                        }
                    });
                }

                if (cell) {
                    cell.mouseover(function (event) {
                        date = new Date(date);
                        $api.orders.calendar.get({
                            date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                            range: "weekly"
                        }, function (response) {
                            if (response.data.length > 0) {
                                var temp = '<p style="float:left;"><div style="width:8px;background-color:#2D9EE6;height:8px;float:left;border-radius:4px;margin-top:5px;"></div><h3 style="float:left;margin:0;font-size:14px;color:#14384F;">';
                                var content = '';
                                for (var i in response.data) {
                                    var eventName = '';
                                    if (response.data[i].order_customer) {
                                        eventName = response.data[i].order_customer_firstname;
                                        eventName += response.data[i].order_customer_lastname ? " " + response.data[i].order_customer_lastname : '';
                                    } else {
                                        // TODO: use translation
                                        eventName = "לקוח מזדמן";
                                    }
                                    content += temp + eventName + ', ' + (response.data[i].part ? response.data[i].item_data.name_second : response.data[i].item_data.name) + '</h3></p>';
                                }
                                // tooltip.set({
                                //     'content.text': content,
                                //     'content.title': monthNames[date.getMonth()]
                                // }).reposition(event).show(event);
                            }
                        });
                    });
                    cell.mouseleave(function () {
                        //tooltip.hide();
                    });
                }
            };

            ctrl.afterAllRender = function () {
                setTimeout(function () {
                    date = new Date();
                    $('.fc-customWeek-view table tbody  .fc-time-area').find('[data-resource-id]').each(function () {
                        $(this).find('div[class=temp-cells] div').eq(date.getDay()).addClass('today-color');
                    });

                }, 4000);
            };

            /**
             * Triggers when event is rendered on the calendar
             * @param {Object} event Event object
             * @param {jQuery} element  jQuery element
             * @return {void}
             */

            ctrl.event_render = function (event, element) {
                ctrl.scrollToTime();

                // Handle HTML in event title
                if (event.title && event.title.includes('<i class="las la-ticket-alt')) {
                    element.find('.fc-title').html('<span>'+event.title+'</span>');
                }

                var dataItem = ''
                if (event.type == 'event') {
                    dataItem = 'event-' + event.eventId;
                } else if (event.type == 'course') {
                    dataItem = 'course-' + event.courseId;
                } else {
                    dataItem = 'order-' + event.orderId;
                }

                if (dataItem != '') {
                    element.attr('data-item', dataItem);
                }

                var found_c = false;
                if (ctrl.settings.time === 'monthly') {
                    if (event.type = 'event') {
                        // For not an orders - Events
                        element.append('<i class="calendar-status-1"></i>');
                        element.css('background-color', '#f2f6ff');
                        element.addClass('calendar-order-completed');
                        found_c = true;
                    }
                } else {
                    if (event.type == 'event') {
                        // For not an orders - Events
                        //$(element).addClass('status-simple');
                        $(element).css('background-color', $rootScope.color_form.calendar_event_color);
                        $(element).css('border-color', $color.pSBC(-0.4, $rootScope.color_form.calendar_event_color));
                        found_c = true;
                    }
                }

                var top_icons = $('<div class="event-top-icons"></div>');
                var bottom_icons = $('<div class="event-bottom-icons"></div>');

                if (event.approved == 1) {
                    bottom_icons.append('<i class="las la-thumbs-up" style="color: red;"></i>');
                } else if (event.approved == 2) {
                    bottom_icons.append('<i class="las la-thumbs-up" style="color: green;"></i>');
                }
                if (event.order_status == 2) {
                    // element.append('<i class="fa fa-clock-o"></i>');
                } else if (event.order_status == 3) {
                    found_c = true;
                    if (!(event.pay_link && event.pay_link == 2)) {
                        top_icons.append('<i class="las la-money-bill"></i>');
                    }
                    element.css('background-color', '#e4e4e4');
                    element.addClass('calendar-order-completed');
                } else if (event.order_status == 4) {
                    found_c = true;
                    top_icons.append('<i class="fa fa-question-circle-o"></i>');
                    element.css('background-color', '#fff!important');
                    element.addClass('calendar-customer-booking');
                }

                if ((event.pay_link && (event.pay_link == 1 || event.pay_link == 2)) || (event.prepaid && event.order_price == event.prepaid)) {
                    var pay_link_color = 'red';
                    pay_link_color = event.pay_link == 2 || (event.prepaid && event.order_price == event.prepaid) ? 'green' : pay_link_color;
                    top_icons.append('<i class="las la-hand-holding-usd ' + (pay_link_color) + '"></i>');
                }

                if (event.feedback_id) {
                    top_icons.append('<i class="las la-star"><span>' + event.feedback_stars + '</span></i>');
                }

                if (event.order_notes && event.order_notes != '') {
                    bottom_icons.append('<span tooltip2-size="large" tooltip2="'+event.order_notes.replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/"/g, "&quot;")
                        .replace(/'/g, "&#39;")
                        .replace(/\n/g, "<br>")+'"><i class="las la-comment"></i></span>');
                }

                if (event.prepaid && event.prepaid * 1 > 0 && !(event.order_price == event.prepaid)) {
                    bottom_icons.append('<i class="las la-credit-card green"></i>');
                } else if (event.request_prepaid) {
                    bottom_icons.append('<i class="las la-credit-card red"></i>');
                }

                if (event.online && event.order_status != 4) {
                    top_icons.append('<i class="las la-mobile"><span></span></i>');
                }
                if (event.ai && event.order_status != 4) {
                    top_icons.append('<span class="ai-icon"><span></span></span>');
                }

                var time_card = '';

                if (event.card_balance && !event.merged) {
                    bottom_icons.append('<i class="las la-ticket-alt customers-has-chards' + (event.expired ? ' expired' : '') + '"><span></span></i>');
                }

                if ($rootScope.display_order_user && event.created_at && event.user_name) {
                    bottom_icons.append('<span tooltip2="'+event.user_name+' - '+event.created_at+'"><i class="las la-eye"></i></span>');
                }

                if (event.start && event.end) {
                    time_card += moment(event.start).format('H:mm') + ' - ' + moment(event.end).format('H:mm');
                }

                var duration = moment(event.end, "YYYY-MM-DD HH:mm:ss").diff(moment(event.start, "YYYY-MM-DD HH:mm:ss"), 'minutes');

                if (duration > Info.data.interval) {
                    element.append('<p class="c-event-time">' + time_card + '</p>');
                } else {
                    element.attr('tooltip', time_card);
                    element.addClass('have-tooltip');
                }

                if (!found_c) {
                    element.css("border-color", event.backgroundColor);
                    element.css("background", 'transparent linear-gradient(180deg, ' + pSBC(0.1, event.backgroundColor) + ' 0%, ' + pSBC(0.25, event.backgroundColor) + ' 100%) 0% 0% no-repeat padding-box').css("opacity", 1);
                }

                if (event.avatar) {
                    element.find('.fc-title').prepend('<div class="order-avatar" style="background-image: url(' + event.avatar + '); background-size: cover; background-repeat: no-repeat; background-position: center;"></div>');
                }

                if (event.type == 'course' && event.secondResourceTitle && event.secondResourceId) {
                    element.find('.fc-title').after('<div class="fc-second-resource">' + event.secondResourceTitle + ': ' + event.secondResourceName + '</div>');
                }

                if (event.approval_sent == 3) {
                    element.addClass("not-arrived");
                }

                //for make tooltip workable
                $compile(bottom_icons.contents())($scope);

                element.append(top_icons);
                element.append(bottom_icons);

                if (!event.part && !event.imported && event.type != 'course') {
                    var options = $('<div class="event-options"></div>');
                    options.append('<label for="itm-' + (event.id ? event.id : event.eventId) + '" class="event-options-dots"><i></i><i></i><i></i></label><input type="checkbox" id="itm-' + (event.id ? event.id : event.eventId) + '">');
                    var options_menu = $('<div class="event-options-menu"></div>');

                    options_menu.append('<span class="move-event"><i class="las la-arrows-alt"></i>' + $translate.instant('CALENDAR_EVENT_MOVE') + '</span>');
                    options_menu.append('<span class="copy-event"><i class="las la-copy"></i>' + $translate.instant('CALENDAR_EVENT_COPY') + '</span>');
                    if ($rootScope.cashbox_available && [3, 4].indexOf(event.status) === -1) {
                        options_menu.append('<span class="checkout-event"><i class="las la-hand-holding-usd"></i>' + $translate.instant('CALENDAR_EVENT_CHECKOUT') + '</span>');
                    }
                    options.append(options_menu);

                    element.append(options);
                }

                element.append('<span data-item="' + (event.id ? event.id : event.eventId) + '" class="fororder-' + event.orderId + '" class="hidden"></span>');
            };

            var pSBC = function (p, c0, c1, l) {
                var r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
                if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
                if (!this.pSBCr) this.pSBCr = function (d) {
                    var n = d.length, x = {};
                    if (n > 9) {
                        d = d.split(","), n = d.length;
                        r = d[0] ? d[0] : '';
                        g = d[1] ? d[1] : '';
                        b = d[2] ? d[2] : '';
                        a = d[3] ? d[3] : '';
                        if (n < 3 || n > 4) return null;
                        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
                    } else {
                        if (n == 8 || n == 6 || n < 4) return null;
                        if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
                        d = i(d.slice(1), 16);
                        if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
                        else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
                    } return x
                };
                h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
                if (!f || !t) return null;
                if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
                else r = m(Math.pow((P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2)), 0.5)), g = m(Math.pow((P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2)), 0.5)), b = m(Math.pow((P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2)), 0.5));
                a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
                if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
                else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
            };

            /**
             * Preparing neccesary configuration for the motels calendar UI
             * @return object Rooms
             */


            ctrl.prepare_motels_configuration = function (isRTL) {

                return {
                    // resourceAreaWidth: 230,
                    eventLimit: true,
                    editable: true,
                    aspectRatio: 1.5,
                    scrollTime: '00:00',
                    firstDay: 0,
                    locale: 'he',
                    defaultView: 'customWeek',
                    schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                    views: {
                        customWeek: {
                            type: 'timeline',
                            duration: { weeks: 1 },
                            slotDuration: { days: 1 }
                        },
                        month: {
                            eventLimit: 3,
                        }


                    },
                    height: $(window).height() - 100,
                    dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                    dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                    isRTL: isRTL,
                    events: [],
                    minTime: ctrl.settings.minTime,
                    maxTime: ctrl.settings.maxTime,
                    axisFormat: 'HH:mm',
                    resources: ctrl.uiResources,
                    resourceLabelText: 'משאבים',
                    eventResize: ctrl.handle_item_drag_resize,
                    eventDrop: ctrl.handle_item_drag_resize,
                    header: {
                        left: '',
                        center: '',
                        right: ''
                    },
                    dayRender: ctrl.day_render,
                    eventRender: ctrl.event_render,
                    viewRender: function () {
                        setTimeout(ctrl.timeline_view_hover, 200);
                    },
                    eventClick: function (event, e) {
                        if (e && e.target && ($(e.target).hasClass('event-options') || $(e.target).closest('.event-options').length)) {
                            if ($(e.target).hasClass('checkout-event') || $(e.target).closest('checkout-event').length) {
                                $state.go('app.cashbox.order', { orderID: event.orderId }, {
                                    reload: true
                                });
                            }
                            if ($(e.target).hasClass('copy-event') || $(e.target).closest('copy-event').length) {
                                ctrl.copy_order_form(event);
                            }
                            if ($(e.target).hasClass('move-event') || $(e.target).closest('move-event').length) {
                                ctrl.move_order(event);
                            }
                            return;
                        }

                        ctrl.edit_order_form(event);
                        //tooltip.hide();
                    },
                    dayClick: function (date, jsEvent, view, resourceObj) {
                        //tooltip.hide();

                        // Prevent dayClick when pinching
                        if (ctrl.pinchZoom && ctrl.pinchZoom.preventDayClick) {
                            return;
                        }

                        if (ctrl.moved_order) {
                            ctrl.move_confirm(date, resourceObj ? resourceObj.id : false);
                            return;
                        }
                        if (ctrl.copied_order) {
                            ctrl.copy_confirm(date, resourceObj ? resourceObj.id : false);
                            return;
                        }
                        if (ctrl.settings.time == "monthly") {
                            ctrl.change_calendar_type("orders");
                            ctrl.change_calendar_time("weekly");
                            ctrl.settings.date = new Date(date.format());
                            $("#mainCalendar").fullCalendar("gotoDate", date);
                        } else {
                            if (resourceObj) {
                                ctrl.open_order_form(date, resourceObj.id);
                            } else {
                                ctrl.open_order_form(date);
                            }
                        }
                    },
                };
            };

            if (window.innerWidth > 768) {
                ctrl.prepare_stores_configuration = function (isRTL) {
                    return {
                        eventLimit: true,
                        views: {
                            customWeek: {
                                type: 'timeline',
                                duration: { weeks: 1 },
                                slotDuration: { days: 1 }
                            },
                            month: {
                                eventLimit: 4,
                            }
                        },
                        defaultDate: ctrl.settings.date,
                        height: "auto",//200,//$(window).height() - 210,
                        editable: true,
                        defaultView: "agendaDay",
                        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                        allDaySlot: false,
                        slotDuration: ctrl.settings.interval,
                        slotLabelInterval: ctrl.settings.interval,
                        //groupByDateAndResource: false,
                        dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        isRTL: isRTL,
                        events: [],
                        minTime: ctrl.settings.minTime,
                        maxTime: ctrl.settings.maxTime,
                        axisFormat: 'HH:mm',
                        timeFormat: 'HH:mm',
                        slotLabelFormat: 'HH:mm',
                        resources: ctrl.uiResources,
                        columnHeaderHtml: function (mom) {
                            if (ctrl.settings.time == "monthly" || ctrl.settings.time == "daily") {
                                return mom.format('dddd');
                                return mom.format("dddd, DD/MM");
                            } else {
                                return mom.format('DD, dddd');
                                return mom.format("dddd, DD/MM");
                            }
                        },
                        header: {
                            left: '',
                            center: '',
                            right: ''
                        },
                        eventResize: ctrl.handle_item_drag_resize,
                        eventDrop: ctrl.handle_item_drag_resize,
                        dayRender: ctrl.day_render,
                        eventRender: function (event, element, view) {
                            ctrl.event_render(event, element);
                        },
                        viewRender: function () {
                            setTimeout(ctrl.agenda_view_hover, 800);

                            if (ctrl.settings.time == "daily") {
                                ctrl.day_render(moment(ctrl.settings.date), null);
                            } else if (ctrl.settings.time == "weekly") {
                                var day = moment($date.getSunday(new Date(ctrl.settings.date)));
                                for (var i = 0; i < 7; i++) {
                                    ctrl.day_render(moment(day), null);
                                    day = day.add(1, 'days');
                                }
                            }
                        },
                        eventClick: function (event, e) {
                            //tooltip.hide();

                            if (e && e.target && ($(e.target).hasClass('event-options') || $(e.target).closest('.event-options').length)) {
                                if ($(e.target).hasClass('checkout-event') || $(e.target).closest('checkout-event').length) {
                                    $state.go('app.cashbox.order', { orderID: event.orderId }, {
                                        reload: true
                                    });
                                }
                                if ($(e.target).hasClass('copy-event') || $(e.target).closest('copy-event').length) {
                                    ctrl.copy_order_form(event);
                                }
                                if ($(e.target).hasClass('move-event') || $(e.target).closest('move-event').length) {
                                    ctrl.move_order(event);
                                }
                                return;
                            }
                            $scope.new_order_date = event.start;
                            ctrl.edit_order_form(event);
                        },
                        dayClick: function (date, jsEvent, view, resourceObj) {
                            //tooltip.hide();

                            // Prevent dayClick when pinching
                            if (ctrl.pinchZoom && ctrl.pinchZoom.preventDayClick) {
                                return;
                            }
                            
                            if (ctrl.moved_order) {
                                ctrl.move_confirm(date, resourceObj ? resourceObj.id : false);
                                return;
                            }
                            if (ctrl.copied_order) {
                                ctrl.copy_confirm(date, resourceObj ? resourceObj.id : false);
                                return;
                            }
                            if (ctrl.settings.time == "monthly") {
                                ctrl.change_calendar_type("orders");
                                ctrl.change_calendar_time("daily");
                                ctrl.settings.date = new Date(date.format());
                                $("#mainCalendar").fullCalendar("gotoDate", date);
                            }
                            else {
                                if (!resourceObj && ctrl.settings.resource.length == 1) {
                                    resourceObj = {
                                        id: parseInt(ctrl.settings.resource[0].id)
                                    }
                                }
                                if (resourceObj)
                                    ctrl.open_order_form(date, resourceObj.id);
                                else
                                    ctrl.open_order_form(date);
                            }
                        }
                    };
                };
            } else {
                ctrl.prepare_stores_configuration = function (isRTL) {
                    return {
                        eventLimit: true,
                        views: {
                            customWeek: {
                                type: 'timeline',
                                duration: { weeks: 1 },
                                slotDuration: { days: 1 }
                            },
                            month: {
                                eventLimit: 4
                            }
                        },
                        height: 'auto',
                        editable: true,
                        defaultDate: ctrl.settings.date,
                        defaultView: "agendaDay",
                        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                        allDaySlot: false,
                        slotDuration: ctrl.settings.interval,
                        slotLabelInterval: ctrl.settings.interval,
                        //groupByDateAndResource: false,
                        dayNames: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                        isRTL: isRTL,
                        events: [],
                        minTime: ctrl.settings.minTime,
                        maxTime: ctrl.settings.maxTime,
                        axisFormat: 'HH:mm',
                        timeFormat: 'HH:mm',
                        slotLabelFormat: 'HH:mm',
                        resources: ctrl.uiResources,
                        columnHeaderHtml: function (mom) {
                            if (ctrl.settings.time == "monthly" || ctrl.settings.time == "daily") {
                                return mom.format('dddd');
                                return mom.format("dddd, DD/MM");
                            } else {
                                return mom.format('DD, dddd');
                                return mom.format("dddd, DD/MM");
                            }

                        },
                        header: {
                            left: '',
                            center: '',
                            right: ''
                        },
                        eventResize: ctrl.handle_item_drag_resize,
                        eventDrop: ctrl.handle_item_drag_resize,
                        dayRender: ctrl.day_render,
                        eventRender: function (event, element, view) {
                            ctrl.event_render(event, element);
                        },
                        eventClick: function (event, e) {
                            //tooltip.hide();
                            if (e && e.target && ($(e.target).hasClass('event-options') || $(e.target).closest('.event-options').length)) {
                                if ($(e.target).hasClass('checkout-event') || $(e.target).closest('checkout-event').length) {
                                    $state.go('app.cashbox.order', { orderID: event.orderId }, {
                                        reload: true
                                    });
                                }
                                if ($(e.target).hasClass('copy-event') || $(e.target).closest('copy-event').length) {
                                    ctrl.copy_order_form(event);
                                }
                                if ($(e.target).hasClass('move-event') || $(e.target).closest('move-event').length) {
                                    ctrl.move_order(event);
                                }
                                return;
                            }
                            $scope.new_order_date = event.start;
                            ctrl.edit_order_form(event);
                        },
                        viewRender: function () {
                            setTimeout(ctrl.agenda_view_hover, 800);

                            if (ctrl.settings.time == "daily")
                                ctrl.day_render(moment(ctrl.settings.date), null);
                            else if (ctrl.settings.time == "weekly") {

                                var day = moment($date.getSunday(new Date(ctrl.settings.date)));

                                for (var i = 0; i < 7; i++) {
                                    ctrl.day_render(moment(day), null);
                                    day = day.add(1, 'days');
                                }
                            }
                        },
                        dayClick: function (date, jsEvent, view, resourceObj) {
                            //tooltip.hide();
                            
                            // Prevent dayClick when pinching
                            if (ctrl.pinchZoom && ctrl.pinchZoom.preventDayClick) {
                                return;
                            }
                            
                            var allDate = $scope.clientEvents;
                            var currentDate = moment(date).format("YYYY-MM-DD");
                            var selectedDate = [];

                            for (var i = 0; i < allDate.length; i++) {
                                if (moment(allDate[i].start).format("YYYY-MM-DD") == currentDate) {
                                    var datesArray = JSON.parse(JSON.stringify(allDate[i]));
                                    datesArray.start = moment(datesArray.start).format("YYYY-MM-DD");
                                    selectedDate.push(datesArray)
                                }
                            }

                            ctrl.selectedDate = selectedDate;

                            if (ctrl.settings.time == "monthly") {
                                ctrl.change_calendar_type("orders");
                                ctrl.change_calendar_time("daily");
                                ctrl.settings.date = new Date(date.format());
                                $("#mainCalendar").fullCalendar("gotoDate", date);
                            }
                            else {
                                if (ctrl.moved_order) {
                                    ctrl.move_confirm(date, resourceObj ? resourceObj.id : false);
                                    return;
                                }
                                if (ctrl.copied_order) {
                                    ctrl.copy_confirm(date, resourceObj ? resourceObj.id : false);
                                    return;
                                }

                                if (!resourceObj && ctrl.settings.resource.length == 1) {
                                    resourceObj = {
                                        id: parseInt(ctrl.settings.resource[0].id)
                                    }
                                }
                                if (resourceObj)
                                    ctrl.open_order_form(date, resourceObj.id);
                                else
                                    ctrl.open_order_form(date);
                            }
                        }
                    };
                };
            }
            /**
             * Calendar Configuration
             */
            $scope.calendarConfig = null;

            $rootScope.$on('change-language', function (event, langKey) {
                $("#mainCalendar").fullCalendar("option", "isRTL", langKey === 'hb_ISR' || langKey === 'ar_AR');
            });

            if (ctrl.settings.bu_type == 1) {
                default_screen = $scope.default_screen ? $scope.default_screen : '';

                if (default_screen == "Calendar-Weekly" && (Lflag == 1 || ctrl.settings.view)) {
                    ctrl.settings.time = "weekly";
                    $scope.calendarConfig = ctrl.prepare_stores_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = true;
                    $scope.calendarConfig.defaultView = "agendaWeek";
                } else if (default_screen == "Calendar-Monthly" && (Lflag == 1 || ctrl.settings.view)) {
                    ctrl.settings.time = "monthly";
                    $scope.calendarConfig = ctrl.prepare_stores_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = true;
                    $scope.calendarConfig.defaultView = "month";
                } else {
                    $scope.calendarConfig = ctrl.prepare_stores_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = true;
                    if ($rootScope.$user.calendar_default * 1 == 1) {
                        ctrl.settings.time = "weekly";
                        $scope.calendarConfig.defaultView = "agendaWeek";
                    }
                    if ($rootScope.$user.calendar_default * 1 == 2) {
                        ctrl.settings.time = "monthly";
                        $scope.calendarConfig.defaultView = "month";
                    }
                }

                if ($stateParams.date && ctrl.settings.scrollTime) {
                    $scope.calendarConfig.scrollTime = ctrl.settings.scrollTime;
                } else {
                    $scope.calendarConfig.scrollTime = moment().subtract(60, 'minutes').format("HH") + ":00:00";
                }

            } else if (ctrl.settings.bu_type == 2) {
                default_screen = $scope.default_screen ? $scope.default_screen : '';
                if (default_screen == "Calendar-Occupation" && (Lflag == 1 || ctrl.settings.view)) {
                    ctrl.settings.type = "capacity";
                    ctrl.settings.time = "monthly";
                    ctrl.settings.datePickerView = "month";
                    $scope.calendarConfig = ctrl.prepare_motels_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = false;
                    // ctrl.get_orders_capacity();
                    // ctrl.initDisplayDate(ctrl.settings.date);
                    setTimeout(function () {
                        ctrl.change_calendar_type('capacity');
                    }, 100);
                } else {
                    $scope.calendarConfig = ctrl.prepare_motels_configuration(langKey === 'hb_ISR' || langKey === 'ar_AR');
                    $scope.calendarConfig.nowIndicator = false;
                }
            }

            ctrl.userChangedDate = false;
            ctrl.datePickerClicked = function() {
                ctrl.userChangedDate = true;  
            };

            /**
             * Responsible for changes on the datepicker input
             */
            $scope.$watch("ctrl.settings.date", function (newValue, oldValue) {
                if (newValue != oldValue) {
                    newValue = new Date(newValue);
                    ctrl.initDisplayDate(newValue);
                    //ctrl.get_resources_capacity();

                    if (ctrl.settings.type == "orders") {
                        if (ctrl.userChangedDate) {
                            ctrl.resetFindSettings();
                        }

                        ctrl.refresh_calendar();
                    } else {
                        ctrl.get_orders_capacity();
                    }

                    ctrl.load_holidays();
                    ctrl.userChangedDate = false;
                }
            });

            ctrl.initDisplayDate = function (date) {
                var date = new Date(date);

                if (ctrl.settings.time == "weekly") {

                    var
                        Sunday = $date.getSunday(date),
                        Saturyday = $date.getSaturday(date);

                    ctrl.displayDate =
                        (Saturyday.getDate() < 10 ? ("0" + Saturyday.getDate()) : (Saturyday.getDate()))
                        + "/" +
                        ((Saturyday.getMonth() + 1) < 10 ? ("0" + (Saturyday.getMonth() + 1)) : ((Saturyday.getMonth() + 1)))
                        + "/" +
                        Saturyday.getFullYear();

                    ctrl.displayDate += " - ";

                    ctrl.displayDate +=
                        (Sunday.getDate() < 10 ? ("0" + Sunday.getDate()) : (Sunday.getDate()))
                        + "/" +
                        ((Sunday.getMonth() + 1) < 10 ? ("0" + (Sunday.getMonth() + 1)) : ((Sunday.getMonth() + 1)))
                        + "/" +
                        Sunday.getFullYear();
                }
                else if (ctrl.settings.time == "daily") {
                    var holidayData = ctrl.get_date_holiday(moment(date));

                    // Check if Hebrew dates should be displayed
                    if ($rootScope.display_hebrew_dates) {
                        ctrl.displayDate = HebrewDate.getHebrewFormatDateString(date);
                    } else {
                        ctrl.displayDate = "יום " + dates.daysNames[date.getDay()] + ", ";

                        ctrl.displayDate +=
                            (date.getDate() < 10 ? ("0" + date.getDate()) : (date.getDate()))
                            + "/" +
                            ((date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : ((date.getMonth() + 1)))
                            + "/" +
                            date.getFullYear();
                    }

                    if (holidayData.isHoliday && holidayData.holidayName)
                        ctrl.displayDate += ", " + holidayData.holidayName;
                }
                else if (ctrl.settings.time == "monthly")
                    ctrl.displayDate = dates.months[date.getMonth()] + " " + date.getFullYear();
                if (typeof uiCalendarConfig.calendars.mainCalendar !== typeof undefined) {
                    //uiCalendarConfig.calendars.mainCalendar.fullCalendar("gotoDate", date);
                    $("#mainCalendar").fullCalendar("gotoDate", date);
                }

                if (ctrl.settings.holiday_color) {
                    $('.is-holiday').css('background-color', ctrl.settings.holiday_color);
                    //load hook
                    setTimeout(function () {
                        $('.is-holiday').css('background-color', ctrl.settings.holiday_color);
                    }, 100);
                }
            };

            ctrl.displayDate = "";
            ctrl.initDisplayDate(ctrl.settings.date);

            /**
             * Triggers when clicked on next button in the datepicker
             */
            ctrl.datePickerPrev = function () {
                ctrl.resetFindSettings();

                if (ctrl.settings.time == "daily")
                    ctrl.settings.date = moment(ctrl.settings.date).add(-1, "days");
                else if (ctrl.settings.time == "weekly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(-7, "days");
                else if (ctrl.settings.time == "monthly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(-1, "month");
            };

            /**
             * Goto to today
             */
            ctrl.gotoToday = function () {
                ctrl.settings.date = moment();

                ctrl.resetFindSettings();
            }
            /**
             * Triggers when clicked on next button in the datepicker
             * @return {void}
             */
            ctrl.datePickerNext = function () {
                ctrl.resetFindSettings();

                if (ctrl.settings.time == "daily")
                    ctrl.settings.date = moment(ctrl.settings.date).add(1, "days");
                else if (ctrl.settings.time == "weekly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(7, "days");
                else if (ctrl.settings.time == "monthly")
                    ctrl.settings.date = moment(ctrl.settings.date).add(1, "month");
            };

            /**
             * Triggers when resource checkbox is changed
             * @return {void}
             */
            ctrl.change_resource = function () {
                ctrl.resetFindSettings();

                if (!ctrl.settings.resource.length) {
                    $scope.calendarConfig.resources = ctrl.uiResources;
                }
                else {
                    $scope.calendarConfig.resources = [];
                    for (var i in ctrl.uiResources) {
                        for (var j in ctrl.settings.resource) {
                            if (ctrl.uiResources[i].id == ctrl.settings.resource[j].id) {
                                $scope.calendarConfig.resources.push(ctrl.uiResources[i]);
                            }
                        }
                    }
                }
                $("#mainCalendar").fullCalendar("option", "resources", $scope.calendarConfig.resources);
                $("#mainCalendar").fullCalendar("refetchResources", $scope.calendarConfig.resources);
                ctrl.set_working_hours();

                ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                if (ctrl.settings.type == "capacity")
                    ctrl.set_capacity_colors();
            };

            $scope.$watch(
                function () { return ctrl.settings.resource; },
                function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        ctrl.change_resource();
                    }
                },
                true // Set deep watch to detect changes in array elements
            );

            ctrl.getDefaultFindSettings = function () {
                return {
                    search: '',
                    noCustomers: true,
                    orderIds: [],
                    eventIds: [],
                    courseIds: [],
                    lastDate: null,
                    direction: null,
                    resourceIds: [],
                    currentId: null,
                    currentType: null,
                    isEnd: true,
                    loading: false
                };
            };

            ctrl.findSettings = ctrl.getDefaultFindSettings();

            ctrl.resetFindSettings = function(keepSearch) {
                var search = ctrl.findSettings.search;
                ctrl.findSettings = ctrl.getDefaultFindSettings();
                if (keepSearch) {
                    ctrl.findSettings.search = search;
                }
            };

            ctrl.isButtonDisabled = function (direction) {
                if (ctrl.findSettings.search == '' || ctrl.findSettings.noCustomers) {
                    return true;
                }

                if (direction === ctrl.findSettings.direction && ctrl.findSettings.isEnd) {
                    return true;
                }

                var idsCount = ctrl.findSettings.orderIds.length + ctrl.findSettings.eventIds.length + ctrl.findSettings.courseIds.length;
                if (direction === 'prev') {
                    if (ctrl.findSettings.direction == 'prev' && idsCount == 0) {
                        return true;
                    }

                    if (ctrl.findSettings.direction == 'next' && idsCount <= 1) {
                        return true;
                    }
                }

                return false;
            };

            var searchTimeout;
            $scope.$watch(function () {
                return ctrl.findSettings.search;
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    ctrl.resetFindSettings(true);
                    ctrl.clearHighlight();
                    
                    if (searchTimeout) {
                        $timeout.cancel(searchTimeout);
                    }

                    if (newVal && newVal.length >= 3) {
                        searchTimeout = $timeout(function () {
                            ctrl.findEvent('next');
                        }, 1000);
                    }
                }
            });

            ctrl.pad = function (num, size) {
                var s = num + '';
                while (s.length < size) s = '0' + s;
                return s;
            };

            ctrl.findEvent = function (direction) {
                ctrl.findSettings.loading = true;

                if (ctrl.findSettings.lastDate === null) {
                    ctrl.findSettings.lastDate = moment().format('YYYY-MM-DD HH:mm:ss');
                }

                ctrl.findSettings.direction = direction;
                ctrl.findSettings.resourceIds = ctrl.settings.resource.map(function (r) { return r.id });

                if (direction === 'prev' && ctrl.findSettings.currentId) {
                    if (ctrl.findSettings.currentType === 'order') {
                        var idxOrder = ctrl.findSettings.orderIds.indexOf(ctrl.findSettings.currentId);
                        if (idxOrder >= 0) {
                            ctrl.findSettings.orderIds.splice(idxOrder, 1);
                        }
                    } else if (ctrl.findSettings.currentType === 'event') {
                        var idxEvent = ctrl.findSettings.eventIds.indexOf(ctrl.findSettings.currentId);
                        if (idxEvent >= 0) {
                            ctrl.findSettings.eventIds.splice(idxEvent, 1);
                        }
                    } else if (ctrl.findSettings.currentType === 'course') {
                        var idxCourse = ctrl.findSettings.courseIds.indexOf(ctrl.findSettings.currentId);
                        if (idxCourse >= 0) {
                            ctrl.findSettings.courseIds.splice(idxCourse, 1);
                        }
                    }
                }

                $api.findEvents.save(ctrl.findSettings, function (response) {
                    ctrl.findSettings.loading = false;

                    if (response.data) {
                        ctrl.findSettings.isEnd = false;
                        ctrl.findSettings.noCustomers = false;
                        if (response.data.order) {
                            var orderId = response.data.order.id;
                            var idxOrder = ctrl.findSettings.orderIds.indexOf(orderId);
                            if (idxOrder >= 0) {
                                ctrl.findSettings.orderIds.splice(idxOrder, 1);
                            } else {
                                ctrl.findSettings.orderIds.push(orderId);
                            }

                            ctrl.findSettings.lastDate = response.data.order.start_time;
                            ctrl.findSettings.currentId = orderId;
                            ctrl.findSettings.currentType = 'order';
                        } else if (response.data.event) {
                            var eventId = response.data.event.id;
                            var idxEvent = ctrl.findSettings.eventIds.indexOf(eventId);
                            if (idxEvent >= 0) {
                                ctrl.findSettings.eventIds.splice(idxEvent, 1);
                            } else {
                                ctrl.findSettings.eventIds.push(eventId);
                            }

                            ctrl.findSettings.lastDate = response.data.event.start_time;
                            ctrl.findSettings.currentId = eventId;
                            ctrl.findSettings.currentType = 'event';
                        } else if (response.data.course) {
                            var courseId = response.data.course.id;
                            var idxCourse = ctrl.findSettings.courseIds.indexOf(courseId);
                            if (idxCourse >= 0) {
                                ctrl.findSettings.courseIds.splice(idxCourse, 1);
                            } else {
                                ctrl.findSettings.courseIds.push(courseId);
                            }

                            ctrl.findSettings.lastDate = response.data.course.start_time;
                            ctrl.findSettings.currentId = courseId;
                            ctrl.findSettings.currentType = 'course';
                        }

                        if (moment(ctrl.settings.date).isSame(moment(ctrl.findSettings.lastDate), 'day')) {
                            ctrl.scrollToEvent(ctrl.findSettings.currentId, ctrl.findSettings.currentType);
                        } else {
                            ctrl.settings.date = moment(ctrl.findSettings.lastDate);
                        }
                    } else {
                        ctrl.findSettings.isEnd = true;

                        var title = $translate.instant(ctrl.findSettings.direction == 'prev' ? 'SWAL_FIND_EVENTS_PREV_TITLE' : 'SWAL_FIND_EVENTS_NEXT_TITLE', { search: ctrl.findSettings.search });
                        if (response.code && response.code == 'no_customers') {
                            ctrl.findSettings.noCustomers = true;
                            title = $translate.instant('SWAL_FIND_EVENTS_NO_CUSTOMERS_TITLE', { search: ctrl.findSettings.search });
                        }

                        swal({
                            title: title,
                            text: "",
                            type: "warning",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        });
                    }
                });
            };

            ctrl.scrollToEvent = function (eventId, eventType) {
                $timeout(function () {
                    ctrl.clearHighlight();

                    var eventElements = document.querySelectorAll(".fc-event[data-item='" + eventType + "-" + eventId + "']");
                    if (eventElements && eventElements.length > 0) {
                        for (var i = 0; i < eventElements.length; i++) {
                            eventElements[i].classList.add('fc-glowing');
                            if (i == 0) {
                                eventElements[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }
                    }
                }, 0);
            };

            ctrl.clearHighlight = function () {
                var previousGlows = document.querySelectorAll('.fc-glowing');
                if (previousGlows && previousGlows.length > 0) {
                    for (var i = 0; i < previousGlows.length; i++) {
                        previousGlows[i].classList.remove('fc-glowing');
                    }
                }
            };

            ctrl.refresh_calendar = function () {
                ctrl.get_orders_data().$promise.then(function () {
                    ctrl.get_events_data().$promise.then(function () {
                        ctrl.get_courses_data().$promise.then(function () {
                            if (ctrl.findSettings.currentId != null && ctrl.findSettings.currentType != null) {
                                ctrl.scrollToEvent(ctrl.findSettings.currentId, ctrl.findSettings.currentType);
                            }
                        });
                    });
                });
            }

            /**
             * Trigger the API call to retrieve relevent orders from the server
             */
            ctrl.get_orders_data = function () {
                $scope.clientEvents = [];
                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }

                ctrl.apiRequest = $api.orders.calendar.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    range: ctrl.settings.time
                }, function (response) {
                    response.data = response.data.sort(function (a, b) { return a.resource_id > b.resource_id ? 1 : -1 })
                    $scope.todayCapacity = response.capacity;

                    if (ctrl.settings.bu_type == 2) {
                        var top = $(".fc-scroller-canvas .fc-rows").offset().top;
                        $(".calendar-wrapper").css('height', top).css('overflow', 'hidden');
                    } else {
                        setTimeout(function () { $(".fc-scroller").css('height', 'auto') }, 200);
                    }
                    if (response.data == null) {

                        $scope.clientEvents = [];

                    }

                    var mergedEvents = response.data;
                    if ($rootScope.display_one_block_services) {
                        mergedEvents = ctrl.mergeEvents(mergedEvents);
                    }

                    for (var i in mergedEvents) {
                        var eventName = "";
                        var event = mergedEvents[i];
                        if (event.order_customer) {
                            eventName = event.order_customer_firstname;

                            if (event.order_customer_lastname) {
                                if (!$scope.isMobile
                                    || ($scope.isMobile && ctrl.settings.time == 'daily')) {
                                    eventName += " " + event.order_customer_lastname;
                                }
                            }
                        } else {
                            //eventName = "לקוח מזדמן";
                            eventName = event.customer_name ? event.customer_name : '';
                        }

                        eventName += ", " + (event.item_data ? (event.part ? event.item_data.name_second : event.item_data.name) : '');
                        
                        // Add ticket icon after first name if merged and has card_balance
                        if (event.merged && event.card_balance) {
                            eventName += ' <i class="las la-ticket-alt customers-has-chards' + (event.expired ? ' expired' : '') + '"><span></span></i>';
                        }
                        
                        var endTime = event.end_time;

                        if (event.merged) {
                            for (var j in event.merged) {
                                eventName += ", " + (event.merged[j].item_data ? (event.merged[j].part ? event.merged[j].item_data.name_second : event.merged[j].item_data.name) : '');
                                
                                // Add ticket icon after each merged name if has card_balance
                                if (event.merged[j].card_balance) {
                                    eventName += ' <i class="las la-ticket-alt customers-has-chards' + (event.merged[j].expired ? ' expired' : '') + '"><span></span></i>';
                                }
                                
                                endTime = event.merged[j].end_time;
                            }
                        }

                        var event = {
                            id: event.id,
                            title: eventName,
                            start: moment(event.start_time).format(),
                            end: endTime,
                            order_status: event.order_status,
                            feedback_id: event.feedback_id,
                            order_notes: event.order_notes,
                            prepaid: event.prepaid,
                            request_prepaid: event.request_prepaid,
                            card_balance: event.card_balance,
                            expired: event.expired,
                            feedback_stars: event.feedback_stars,
                            approved: 0,
                            online: event.online,
                            ai: event.ai,
                            resourceId: event.resource_id,
                            orderId: event.order_id,
                            backgroundColor: (event.item_data && event.item_data.bg_color) || '#a9cfe8',
                            pay_link: event.pay_link,
                            avatar: event.avatar,
                            approval_sent: event.approval_sent,
                            part: event.part,
                            imported: event.imported,
                            order_price: event.order_price,
                            user_name: event.user_name,
                            created_at: event.created_at,
                            merged: event.merged || false,
                            duration: moment(event.end_time).diff(moment(event.start_time), 'minutes'),
                            original_start_time: moment(event.start_time).valueOf(),
                            durationEditable: event.merged ? false : true,
                        }

                        if (event.order_status !== 3) {
                            event.approved = event.approval_sent;
                        }

                        if (ctrl.moved_order && ctrl.moved_order.id == event.id) continue;

                        $scope.clientEvents.push(event);
                    }

                    var seen = {};
                    //You can filter based on Id or Name based on the requirement
                    var uniqueStudents = $scope.clientEvents.filter(function (item) {
                        if (seen.hasOwnProperty(item.id)) {
                            return false;
                        } else {
                            seen[item.id] = true;
                            return true;
                        }
                    })

                    $scope.clientEvents = uniqueStudents;

                    ctrl.set_working_hours();
                    // Render events by resource id

                    ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));

                    ctrl.settings.loading = false;
                    ctrl.apiRequest = null;
                });
                return ctrl.apiRequest;
            };

            /**
             * Merge events that have same customer same resource and goes by each other
             */
            ctrl.mergeEvents = function (events) {
                var mergedEvents = [];
                events = events.sort(function (a, b) { return a.start_time > b.start_time ? 1 : -1 })
                events = events.sort(function (a, b) { return a.order_customer > b.order_customer ? 1 : -1 })
                events = events.sort(function (a, b) { return a.resource_id > b.resource_id ? 1 : -1 })
                
                for (var i = 0; i < events.length; i++) {
                    var currentEvent = events[i];
                    var endTime = currentEvent.end_time;
                    var j = i + 1;
                    
                    // Look for consecutive events that can be merged
                    while (j < events.length && 
                           moment(endTime).isSame(moment(events[j].start_time), 'minute') &&
                           currentEvent.order_customer == events[j].order_customer && 
                           currentEvent.resource_id == events[j].resource_id) {
                        // Merge the next event into the current one
                        endTime = events[j].end_time;
                        if (!currentEvent.merged) {
                            currentEvent.merged = [];
                        }
                        currentEvent.merged.push(events[j]);
                        j++;
                    }
                    
                    mergedEvents.push(currentEvent);
                    i = j - 1; // Skip the events that were merged
                }
                return mergedEvents;
            }


            /**
             * Trigger the API call to retrieve relevent orders from the server
             */
            ctrl.get_events_data = function () {

                $scope.clientEvents = $scope.clientEvents || [];
                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }

                ctrl.apiRequest = $api.events.calendar.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    range: ctrl.settings.time
                }, function (response) {
                    response.data = response.data.sort(function (a, b) {
                        return a.resource_id > b.resource_id ? 1 : -1
                    })

                    if (response.data == null) {
                        $scope.clientEvents = [];
                    }

                    var issetIds = [];
                    for (var i in $scope.clientEvents) {
                        issetIds.push($scope.clientEvents[i].eventId);
                    }

                    for (var i in response.data) {
                        var eventName = "";
                        if ($scope.isMobile && ctrl.settings.time == "weekly") {
                            //eventName = " ";
                            eventName = response.data[i].description;
                        } else {
                            eventName = response.data[i].description;
                        }

                        if (response.data[i].start_date_time != response.data[i].end_date_time) {
                            var event = {
                                eventId: response.data[i].id,
                                title: eventName,
                                type: 'event',
                                start: moment(response.data[i].start_date_time).format(),
                                end: moment(response.data[i].end_date_time).format(),
                                resourceId: response.data[i].resource_id,
                                backgroundColor: '#77889'
                            }
                            if (issetIds.indexOf(event.eventId) < 0) {
                                $scope.clientEvents.push(event);
                            }
                        }
                    }

                    ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                    ctrl.settings.loading = false;
                    ctrl.apiRequest = null;
                });

                return ctrl.apiRequest;
            };

            ctrl.get_courses_data = function () {

                $scope.clientEvents = $scope.clientEvents || [];
                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }

                ctrl.apiRequest = $api.courses.calendar.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
                    range: ctrl.settings.time
                }, function (response) {
                    if (!response || !response.data || !Array.isArray(response.data)) {
                        $scope.clientEvents = [];
                        ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                        ctrl.settings.loading = false;
                        ctrl.apiRequest = null;
                        return;
                    }
                    response.data = response.data.sort(function (a, b) {
                        return a.resource_id > b.resource_id ? 1 : -1
                    })

                    var issetIds = [];
                    for (var i in $scope.clientEvents) {
                        issetIds.push($scope.clientEvents[i].courseId);
                    }

                    for (var i in response.data) {
                        var item = response.data[i];
                        if (!item || !item.item_data) continue;
                        var course = {
                            id: item.id,
                            courseId: item.courseId,
                            title: (item.item_data.name || '') + " - " + (item.name || ''),
                            type: 'course',
                            start: moment(item.start_time).format(),
                            end: moment(item.end_time).format(),
                            resourceId: item.resource_id,
                            secondResourceId: item.second_resource_id,
                            secondResourceEnabled: item.second_resource_enabled,
                            secondResourceTitle: item.second_resource_title,
                            secondResourceName: item.second_resource_name,
                            backgroundColor: item.item_data.bg_color || '#a9cfe8'
                        }
                        if (issetIds.indexOf(course.courseId) < 0) {
                            $scope.clientEvents.push(course);
                        }
                    }

                    ctrl.render_client_events(ctrl.filter_client_events(ctrl.settings.resource));
                    ctrl.settings.loading = false;
                    ctrl.apiRequest = null;
                });

                return ctrl.apiRequest;
            };

            ctrl.refresh_calendar();


            /**
             * Triggers the API call to retreive capacity information
             * @return {void}
             */
            ctrl.get_orders_capacity = function () {
                //stop orders capacity
                return;

                $(".calendar-wrapper").css('height', 'auto')

                var date = new Date(ctrl.settings.date);

                ctrl.settings.loading = true;

                if (ctrl.apiRequest && typeof ctrl.apiRequest.$cancelRequest == "function") {
                    ctrl.apiRequest.$cancelRequest();
                }


                ctrl.apiRequest = $api.orders.capcaity.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                }, function (response) {
                    ctrl.settings.loading = false;
                    ctrl.capacityData = response.data;
                    ctrl.set_capacity_colors();
                    ctrl.apiRequest = null;
                });
            };

            ctrl.get_resources_capacity = function () {
                var date = new Date(ctrl.settings.date.startOf('week'));

                $api.resources.capacity.all.get({
                    date: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                }, function (response) {
                    $scope.resources = response.data;
                    ctrl.set_working_hours();
                });
            };

            /**
             * Sets the color for each day according to its capacity
             */
            ctrl.set_capacity_colors = function () {

                var
                    color,
                    capacity_to_check,
                    slots_string;

                for (var i in ctrl.capacityData) {

                    if (ctrl.settings.resource.length) {
                        //capacity_to_check = ctrl.capacityData[i][parseInt(ctrl.settings.resource)];
                    } else {
                        capacity_to_check = ctrl.capacityData[i]["global"];
                    }

                    slots_string = (capacity_to_check.total_slots - capacity_to_check.taken_slots);
                    if (capacity_to_check.taken_slots == 0)
                        color = "green";
                    else if (capacity_to_check.taken_slots == capacity_to_check.total_slots)
                        color = "red";
                    else
                        color = "orange";

                    //slots_string = (capacity_to_check.total_slots - capacity_to_check.taken_slots) + "/" + (capacity_to_check.total_slots) + " (" + capacity_to_check.percentage + "% תפוסה)";
                    $(".day-" + i).addClass("day-capacity-" + color).attr("data-slots", slots_string);
                    // if( capacity_to_check.taken_slots > 0 ) {
                    //     $(".day-" + i).find('.hoverEffect').remove();
                    //     $(".day-" + i).append("<span class='hoverEffect' style='display: none;'>This is hover"+capacity_to_check.taken_slots+"</span>");
                    // }
                }
            };

            /**
             * Sets two shifts of working hours by adding events to background on non-working hours
             */
            ctrl.set_working_hours = function () {
                // Only for stores business
                if (ctrl.settings.bu_type == 1) {
                    for (var i in $scope.resources) {
                        if (ctrl.settings.time == "daily") {
                            if ($scope.todayCapacity && $scope.todayCapacity[$scope.resources[i].id]) {
                                var shift = $scope.todayCapacity[$scope.resources[i].id];
                                var event = {
                                    resourceId: $scope.resources[i].id,
                                    id: $scope.resources[i].id, // empty 'id' should be here to fix overlapping work shifts
                                    rendering: 'inverse-background',
                                    className: 'fc-nonbusiness',
                                };


                                // First shift
                                if (shift.start_time !== undefined && shift.this_date !== undefined) {
                                    var first_shift_event = angular.copy(event);
                                    //var start_time = moment(shift.date).add(shift.start_time.split(':')[0], 'h')
                                    //    .add(shift.start_time.split(':')[1], 'm');
                                    //var end_time = moment.unix(shift.date).add(shift.end_time.split(':')[0], 'h')
                                    //    .add(shift.end_time.split(':')[1], 'm');
                                    var start_time = moment(shift.this_date + ' ' + shift.start_time, 'YYYY-MM-DD HH:mm:ss');
                                    var end_time = moment(shift.this_date + ' ' + shift.end_time, 'YYYY-MM-DD HH:mm:ss');

                                    // Check if shift starts and ends on the same day.
                                    if (moment(shift.end_time, "HH:mm:ss").isAfter(shift.start_time, "HH:mm:ss")) {
                                        end_time.add(1, 'd');
                                    }

                                    first_shift_event.start = start_time;
                                    first_shift_event.end = end_time;
                                    $scope.clientEvents.push(first_shift_event);

                                    // Second shift
                                    if (shift.shift2_end_time && shift.shift2_start_time) {

                                        var second_shift_event = angular.copy(event);
                                        // var shift2_start_time = moment.unix(shift.date).add(shift.shift2_start_time.split(":")[0], "h")
                                        //     .add(shift.shift2_start_time.split(":")[1], "m");
                                        // var shift2_end_time = moment.unix(shift.date).add(shift.shift2_end_time.split(":")[0], "h")
                                        //     .add(shift.shift2_end_time.split(":")[1], "m");

                                        var shift2_start_time = moment(shift.this_date + ' ' + shift.shift2_start_time, 'YYYY-MM-DD HH:mm:ss');
                                        var shift2_end_time = moment(shift.this_date + ' ' + shift.shift2_end_time, 'YYYY-MM-DD HH:mm:ss');

                                        if (moment(shift.shift2_end_time, "HH:mm:ss").isAfter(shift.shift2_start_time, "HH:mm:ss")) {
                                            shift2_end_time.add(1, 'd');
                                        }
                                        second_shift_event.start = shift2_start_time;
                                        second_shift_event.end = shift2_end_time;
                                        $scope.clientEvents.push(second_shift_event);
                                    }
                                }
                            }
                        } else {
                            //for (var s in $scope.resources[i].capacity) {
                            var capacity = $scope.resources[i].capacity;
                            if ($scope.todayCapacity && $scope.todayCapacity[$scope.resources[i].id] && Array.isArray($scope.todayCapacity[$scope.resources[i].id])) {
                                capacity = $scope.todayCapacity[$scope.resources[i].id];
                            }

                            for (var s in capacity) {
                                var shift = capacity[s];

                                var event = {
                                    resourceId: $scope.resources[i].id,
                                    id: '', // empty 'id' should be here to fix overlapping work shifts
                                    rendering: 'inverse-background',
                                    className: 'fc-nonbusiness',
                                };

                                // First shift
                                if (shift.start_time !== undefined && shift.this_date !== undefined) {

                                    var first_shift_event = angular.copy(event);
                                    // var start_time = moment.unix(shift.date).add(shift.start_time.split(':')[0], 'h')
                                    //     .add(shift.start_time.split(':')[1], 'm');
                                    // var end_time = moment.unix(shift.date).add(shift.end_time.split(':')[0], 'h')
                                    //     .add(shift.end_time.split(':')[1], 'm');
                                    var start_time = moment(shift.this_date + ' ' + shift.start_time, 'YYYY-MM-DD HH:mm:ss');
                                    var end_time = moment(shift.this_date + ' ' + shift.end_time, 'YYYY-MM-DD HH:mm:ss');
                                    // Check if shift starts and ends on the same day.
                                    if (moment(shift.end_time, "HH:mm:ss").isAfter(shift.start_time, "HH:mm:ss")) {
                                        end_time.add(1, 'd');
                                    }

                                    first_shift_event.start = start_time;
                                    first_shift_event.end = end_time;
                                    $scope.clientEvents.push(first_shift_event);

                                    // Second shift
                                    if (shift.shift2_end_time && shift.shift2_start_time) {

                                        var second_shift_event = angular.copy(event);
                                        // var shift2_start_time = moment.unix(shift.date).add(shift.shift2_start_time.split(":")[0], "h")
                                        //     .add(shift.shift2_start_time.split(":")[1], "m");
                                        // var shift2_end_time = moment.unix(shift.date).add(shift.shift2_end_time.split(":")[0], "h")
                                        //     .add(shift.shift2_end_time.split(":")[1], "m");
                                        var shift2_start_time = moment(shift.this_date + ' ' + shift.shift2_start_time, 'YYYY-MM-DD HH:mm:ss');
                                        var shift2_end_time = moment(shift.this_date + ' ' + shift.shift2_end_time, 'YYYY-MM-DD HH:mm:ss');
                                        if (moment(shift.shift2_end_time, "HH:mm:ss").isAfter(shift.shift2_start_time, "HH:mm:ss")) {
                                            shift2_end_time.add(1, 'd');
                                        }
                                        second_shift_event.start = shift2_start_time;
                                        second_shift_event.end = shift2_end_time;
                                        $scope.clientEvents.push(second_shift_event);
                                    }
                                }
                            }
                        }
                    }
                }
            };

            /**
             * Opens "New Order" form
             */
            ctrl.open_order_form = function (date, resourceID) {
                if (ctrl.order_form_modal_opened) {
                    return;
                }

                ctrl.order_form_modal_opened = true;
                $scope.new_order_date = date;

                $scope.selected_resource = resourceID;

                var orderModal = $uibModal.open({
                    templateUrl: "app/modules/calendar/order/order.form.html",
                    controller: "OrderFormController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Items: function ($api) {
                            return $api.resolve("items.items_with_duration@get");
                        },
                        // Customers: function($api) {
                        //     return $api.resolve("customers@get");
                        // },
                        Resources: function ($api) {
                            return $api.resolve("resources@get");
                        },
                        SecondResources: function ($api) {
                            return $api.resolve("second_resources@get");
                        },
                        Info: function ($api) {
                            return $api.resolve("settings.info@get");
                        },
                        Clubs: function ($api) {
                            return $api.resolve("settings.clubs@get");
                        },
                        Customer: function ($api) {
                            if (Customer && Customer.data && Customer.data[0]) {
                                return Customer.data[0];
                            }
                            if (Customer && Customer.data && Customer.data.id) {
                                return Customer.data;
                            }
                            return null;
                        },
                        Order: null,
                        CalendarEvent: null,
                        CalendarCourse: null,
                        Messages: function ($api) {
                            return $api.resolve("settings.messages@get");
                        },
                        EventCopy: false,
                        CoursesFields: ['$api', function ($api) {
                            return $api.resolve('coursesFields.lists@get');
                        }],
                    }
                });

                orderModal.closed.then(function () {
                    ctrl.order_form_modal_opened = false;
                    if (ctrl.settings.type == "orders") {
                        ctrl.refresh_calendar();
                    }
                    else { ctrl.get_orders_capacity() };
                }, function () {
                    ctrl.order_form_modal_opened = false;
                });
            };

            /**
             * Opens "Edit Order" form
             */
            ctrl.edit_order_form = function (event) {
                if (event.type == 'event') {
                    $state.go('app.calendar.event-edit', { id: event.eventId });
                } else if (event.type == 'course') {
                    $state.go('app.calendar.course-edit', { id: event.courseId });
                } else {
                    $state.go('app.calendar.order-edit', { id: event.orderId });
                }
            };

            ctrl.copy_order_form = function (event) {
                ctrl.copied_order = event;
                var event_object = $("#itm-" + event.id).closest('.fc-event');
                if (event_object.length) {
                    var clone = event_object.clone();
                    clone.css('height', event_object.height() + 8);
                    clone.addClass('copied-order');
                    $("#mainCalendar").addClass('coping-enabled').append(clone);
                    $('#itm-' + event.id).prop('checked', false);

                    var second_clone = {};
                    var second_diff = {};

                    $(".fororder-" + event.orderId).each(function () {
                        var itmId = $(this).data('item');
                        if (itmId == event.id) return;

                        second_event_object = $(this).closest('.fc-event');

                        if (second_event_object.length) {
                            var rect1 = event_object.get(0).getBoundingClientRect();
                            var rect2 = second_event_object.get(0).getBoundingClientRect();

                            second_diff[itmId] = rect2.top - rect1.top;

                            second_clone[itmId] = second_event_object.clone();
                            second_clone[itmId].css('height', second_event_object.height() + 8);
                            second_clone[itmId].addClass('copied-order');
                            $("#mainCalendar").addClass('moving-enabled').append(second_clone[itmId]);

                            second_clone[itmId].css('inset', "-100% 0 0 0");
                        }
                    });

                    clone.css('inset', "-100% 0 0 0");

                    $(document).off("click mousemove", "#mainCalendar");
                    $(document).on("click mousemove", "#mainCalendar", function (e) {
                        if (e.target && ($(e.target).hasClass('temp-cell') || $(e.target).hasClass('fc-day'))) {
                            var current_offset = $(e.target).offset();
                            var main_offset = $("#mainCalendar").offset();
                            $('.cursor-circle').css('left', (e.clientX - 15 - (langKey === 'hb_ISR' || langKey === 'ar_AR' ? 0 : 250)) + 'px')
                            $('.cursor-circle').css('top', (e.clientY - 15 - 70 + document.documentElement.scrollTop) + 'px');

                            if (current_offset && main_offset) {
                                var newposX = current_offset.left - main_offset.left + (langKey === 'hb_ISR' || langKey === 'ar_AR' ? 49 : 41);
                                var newposY = current_offset.top - main_offset.top;
                                var newposR = $(window).width() - current_offset.left - $(e.target).outerWidth() - (langKey === 'hb_ISR' || langKey === 'ar_AR' ? 273 : 18);

                                clone.css('inset', newposY + "px " + newposR + "px 0 " + newposX + "px");
                                if (second_clone) {
                                    for (var itmId in second_clone) {
                                        second_clone[itmId].css('inset', (newposY + second_diff[itmId]) + "px " + newposR + "px 0 " + newposX + "px");
                                    }
                                }
                            }
                        }
                    });

                    $(document).off("keydown");
                    $(document).on("keydown", function (event) {
                        if (event.key === "Escape" || event.keyCode === 27) {
                            ctrl.copy_cancel();
                        }
                    });
                }
            }

            ctrl.copy_confirm = function (date, resourceId) {

                if (ctrl.settings.datePickerView == "month") {
                    var hours = moment(ctrl.copied_order.start).hours();
                    var minutes = moment(ctrl.copied_order.start).minutes();

                    date.hours(hours).minutes(minutes);
                }

                var duration = ctrl.copied_order.duration;
                var end = date.clone().add(duration, 'minutes').format("YYYY-MM-DD HH:mm");
                var start = date.format("YYYY-MM-DD HH:mm");

                if (ctrl.copied_order.type == 'event') {
                    var event_data = {};
                    event_data.start_date_time = start;
                    event_data.end_date_time = end;
                    event_data.resource_id = resourceId;

                    $api.events.copy.save({
                        "id": ctrl.copied_order.eventId,
                        "action": "copy",
                        "resource": resourceId ? resourceId : ctrl.copied_order.resourceId
                    }, event_data, function (response) {
                        ctrl.copy_cancel();

                    });
                } else {
                    $api.orders.copy.save({
                        "id": ctrl.copied_order.orderId
                    }, {
                        "type": "item",
                        "action": "copy",
                        "start": start,
                        "end": end,
                        "item": ctrl.copied_order.id,
                        "resource": resourceId ? resourceId : ctrl.copied_order.resourceId
                    }, function (response) {
                        ctrl.copy_cancel();
                    });
                }
            }

            ctrl.copy_cancel = function () {
                ctrl.copied_order = false;
                $(".copied-order").remove();
                $("#mainCalendar").removeClass('coping-enabled');
                $('.cursor-circle').css('left', '-200%').css('top', '-200%');
                $(document).off("click mousemove", "#mainCalendar");
                ctrl.refresh_calendar();
            }

            ctrl.move_order = function (event) {
                ctrl.moved_order = event;
                var event_object = $("#itm-" + event.id).closest('.fc-event');
                if (event_object.length) {
                    var clone = event_object.clone();
                    clone.css('height', event_object.height() + 8);
                    clone.addClass('moved-order');
                    $("#mainCalendar").addClass('moving-enabled').append(clone);
                    $('#itm-' + event.id).prop('checked', false);

                    var second_clone = {};
                    var second_diff = {};

                    $(".fororder-" + event.orderId).each(function () {
                        var itmId = $(this).data('item');
                        if (itmId == event.id) return;
                        second_event_object = $(this).closest('.fc-event');

                        if (second_event_object.length) {
                            var rect1 = event_object.get(0).getBoundingClientRect();
                            var rect2 = second_event_object.get(0).getBoundingClientRect();

                            second_diff[itmId] = rect2.top - rect1.top;

                            second_clone[itmId] = second_event_object.clone();
                            second_clone[itmId].css('height', second_event_object.height() + 8);
                            second_clone[itmId].addClass('moved-order');
                            $("#mainCalendar").addClass('moving-enabled').append(second_clone[itmId]);
                            second_event_object.hide();

                            second_clone[itmId].css('inset', "-100% 0 0 0");
                        }
                    });

                    event_object.hide();

                    clone.css('inset', "-100% 0 0 0");

                    $(document).off("click mousemove", "#mainCalendar");
                    $(document).on("click mousemove", "#mainCalendar", function (e) {
                        if (e.target && ($(e.target).hasClass('temp-cell') || $(e.target).hasClass('fc-day'))) {
                            var current_offset = $(e.target).offset();
                            var main_offset = $("#mainCalendar").offset();
                            $('.cursor-circle').css('left', (e.clientX - 15 - (langKey === 'hb_ISR' ? 0 : 250)) + 'px')
                            $('.cursor-circle').css('top', (e.clientY - 15 - 70 + document.documentElement.scrollTop) + 'px');

                            if (current_offset && main_offset) {
                                var newposX = current_offset.left - main_offset.left + (langKey === 'hb_ISR' ? 49 : 41);
                                var newposY = current_offset.top - main_offset.top;
                                var newposR = $(window).width() - current_offset.left - $(e.target).outerWidth() - (langKey === 'hb_ISR' ? 273 : 18);

                                clone.css('inset', newposY + "px " + newposR + "px 0 " + newposX + "px");
                                if (second_clone) {
                                    for (var itmId in second_clone) {
                                        second_clone[itmId].css('inset', (newposY + second_diff[itmId]) + "px " + newposR + "px 0 " + newposX + "px");
                                    }
                                }
                            }
                        }
                    });

                    $(document).off("keydown");
                    $(document).on("keydown", function (event) {
                        if (event.key === "Escape" || event.keyCode === 27) {
                            ctrl.move_cancel();
                        }
                    });
                }
            }

            ctrl.move_confirm = function (date, resourceId) {

                if (ctrl.settings.datePickerView == "month") {
                    var hours = moment(ctrl.moved_order.start).hours();
                    var minutes = moment(ctrl.moved_order.start).minutes();

                    date.hours(hours).minutes(minutes);
                }
                var duration = ctrl.moved_order.duration;
                var end = date.clone().add(duration, 'minutes').format("YYYY-MM-DD HH:mm");
                var start = date.format("YYYY-MM-DD HH:mm");

                if (ctrl.moved_order.type == 'event') {
                    var event_data = {};
                    event_data.start_date_time = start;
                    event_data.end_date_time = end;
                    event_data.resource_id = resourceId;

                    $api.events.single.save({
                        "id": ctrl.moved_order.eventId
                    }, event_data, function (response) {
                        ctrl.move_cancel();

                    });
                } else {
                    if (Info.data.update_order_notification == 2 && moment(start).format("YYYY-MM-DD HH:mm") != moment(ctrl.moved_order.start).format("YYYY-MM-DD HH:mm")) {
                        swal({
                            text: $translate.instant('CALENDAR_UPDATE_ORDER_NOTIFICATION'),
                            type: 'question',
                            showCancelButton: true,
                            confirmButtonText: $translate.instant('OPTION_YES'),
                            cancelButtonText: $translate.instant('OPTION_NO')
                        }).then(function (result) {
                            $api.orders.single.save({
                                "id": ctrl.moved_order.orderId
                            }, {
                                "type": "item",
                                "action": "move",
                                "start": start,
                                "end": end,
                                "item": ctrl.moved_order.id,
                                "resource": resourceId ? resourceId : ctrl.moved_order.resourceId,
                                "send_notification": result.value ? 1 : 0
                            }, function (response) {
                                ctrl.move_cancel();
                            });
                        });
                    } else {
                        $api.orders.single.save({
                            "id": ctrl.moved_order.orderId
                        }, {
                            "type": "item",
                            "action": "move",
                            "start": start,
                            "end": end,
                            "item": ctrl.moved_order.id,
                            "resource": resourceId ? resourceId : ctrl.moved_order.resourceId
                        }, function (response) {
                            ctrl.move_cancel();
                        });
                    }
                }
            }

            ctrl.move_cancel = function () {
                ctrl.moved_order = false;
                $(".moved-order").remove();
                $("#mainCalendar").removeClass('moving-enabled');
                $('.cursor-circle').css('left', '-200%').css('top', '-200%');
                $(document).off("click mousemove", "#mainCalendar");
                ctrl.refresh_calendar();
            }



            $scope.$on('$stateChangeSuccess',
                function (event, toState, toParams, fromState, fromParams) {
                    if ((fromState.name == 'app.calendar.order-copy'
                        || fromState.name == 'app.calendar.order-edit'
                        || fromState.name == 'app.calendar.event-edit'
                        || fromState.name == 'app.calendar.course-edit')
                        && toState.name == 'app.calendar') {
                        ctrl.refresh_calendar();
                    } else {
                        ctrl.get_orders_capacity();
                    }
                })

            /**
             * Change the time range (which is basicly FullCalendar view types)
             */
            ctrl.change_calendar_time = function (time) {
                ctrl.scrolled = false;
                ctrl.resetFindSettings();

                $('.moved-order').css('inset', "-100% 0 0 0");

                ctrl.settings.time = time;
                if (time == "daily") {
                    ctrl.settings.datePickerView = "date";
                    $scope.calendarConfig.defaultView = "agendaDay";
                }
                else if (time == "weekly") {
                    ctrl.settings.datePickerView = "date";

                    if (ctrl.settings.bu_type == 1) {
                        $scope.calendarConfig.defaultView = "agendaWeek";
                    }
                    else if (ctrl.settings.bu_type == 2) {
                        ctrl.settings.type = "orders";
                        // $scope.calendarConfig.defaultView = "agendaWeek";
                        $scope.calendarConfig.defaultView = "customWeek";
                    }
                }
                else {
                    ctrl.settings.datePickerView = "month";
                    $scope.calendarConfig.defaultView = "month";

                    if (ctrl.settings.bu_type == 2)
                        ctrl.settings.type = "capacity";
                }

                ctrl.change_resource();
                ctrl.initDisplayDate(ctrl.settings.date);

                if (ctrl.settings.type == "orders") {
                    ctrl.refresh_calendar();
                }
                else
                    ctrl.get_orders_capacity();

            };

            /**
             * Change calendar view type (Capacity/Orders)
             */
            ctrl.change_calendar_type = function (type) {

                ctrl.settings.type = type;
                if (ctrl.settings.bu_type == 2) {

                    if (type == "orders") {
                        ctrl.change_calendar_time("weekly");
                    }
                    else {
                        ctrl.change_calendar_time("monthly");
                    }
                }
                else if (ctrl.settings.time != "monthly") {
                    ctrl.change_calendar_time("monthly");
                }

                if (ctrl.settings.type == "orders") {
                    ctrl.refresh_calendar();
                }
                else
                    ctrl.get_orders_capacity();
            };

            /**
             * Maniplute FullCalendar DOM so we can hover over time slots on agendaView
             */
            ctrl.agenda_view_hover = function () {

                if (ctrl.settings.time == "monthly" || $scope.isMobile)
                    return;

                $('.fc-widget-content').hover(function () {

                    if (!$(this).html()) {

                        var
                            parent = $(this).parent(),
                            time = parent.data("time");

                        timeParts = String(time).split(":");
                        time = timeParts[0] + ":" + timeParts[1];

                        var limit = (ctrl.settings.time == "daily") ? 1 : 7;

                        if (ctrl.settings.time == "daily" && !ctrl.settings.resource.length)
                            limit = ctrl.uiResources.length;

                        for (var i = 0; i < limit; i++)
                            $(this).append('<div class="temp-cell" style="border: 0px; width:' + (Number($('.fc-day').width()) + 2) + 'px">' + time + '</div>');
                    }
                });
            };

            /**
             * Maniplute FullCalendar DOM so we can hover over time slots on timelineView
             */
            ctrl.timeline_view_hover = function () {

                if (ctrl.settings.time == "monthly")
                    return;

                $('.fc-time-area .fc-rows .fc-widget-content > div').hover(function () {
                    if (!$(this).find(".temp-cells").length) {
                        $(this).append('<div class="temp-cells"></div>');
                        for (var i = 1; i <= 7; i++) {
                            var
                                headerWidth = $(".fc-time-area.fc-widget-header table th:nth-child(" + i + ") .fc-cell-content").width() + 9,
                                tempCell = $("<div/>").addClass("temp-cell").width(headerWidth);
                            $(this).find(".temp-cells").append(tempCell);
                        }
                    }
                });
            };

            /**
             * Render All events
             */
            ctrl.render_client_events = function (events) {

                $("#mainCalendar").fullCalendar('removeEvents');
                $("#mainCalendar").fullCalendar('renderEvents', events);
                //uiCalendarConfig.calendars.mainCalendar.fullCalendar('removeEvents');
                //uiCalendarConfig.calendars.mainCalendar.fullCalendar('renderEvents', events);
            };

            /**
             * Filter events by Resource id
             */
            ctrl.filter_client_events = function (resource_id) {
                // If no selected resource return all events
                if (!resource_id.length) {
                    return $scope.clientEvents;
                }
                var events = [];

                $scope.clientEvents.forEach(function (event) {
                    for (var i in resource_id) {
                        if (event.resourceId == resource_id[i].id) {
                            events.push(event);
                        }
                    }
                });

                return events;
            }

            ctrl.goToCustomersBookings = function () {
                $state.go('app.admin', {}, { reload: true });
            }

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "יומן";
            $header.breadcrumbs.push({
                "title": "NAV_DAY"
            });

            ctrl.scrolled = false;
            ctrl.scrollToTime = function () {
                //no need with current styles
                //return;
                if (ctrl.scrolled) return;

                var el = document.querySelector('.fc-now-indicator.fc-now-indicator-line');

                if (el) {
                    ctrl.scrolled = true;
                    var scrollPosition = el.offsetTop - ($('#mainCalendar').height()/2) + 100;
                    $('.fc-view-container').animate({
                        scrollTop: scrollPosition
                    }, 200, 'swing');
                }
            }

            /**
             * Pinch-to-zoom functionality for changing slot duration
             */
            ctrl.pinchZoom = {
                initialDistance: 0,
                initialInterval: null,
                isPinching: false,
                minInterval: '00:05:00', // 5 minutes minimum
                maxInterval: '04:00:00',  // 4 hours maximum
                preventDayClick: false, // Flag to prevent dayClick during pinch
                pinchAccumulator: 0, // Track accumulated pinch distance
                lastZoomTime: 0, // Prevent too frequent zoom updates
                zoomThreshold: 0.08 // Minimum accumulated change to trigger zoom
            };

            // Available interval options for zoom
            ctrl.intervalOptions = [];
            for (var i = 5; i <= 240; i+=5) {
                ctrl.intervalOptions.push('00:' + i + ':00');
            }

            /**
             * Calculate distance between two touch points
             */
            ctrl.getTouchDistance = function(touch1, touch2) {
                var dx = touch1.clientX - touch2.clientX;
                var dy = touch1.clientY - touch2.clientY;
                return Math.sqrt(dx * dx + dy * dy);
            };

            /**
             * Get the closest interval option based on scale
             */
            ctrl.getClosestInterval = function(scale) {
                var currentIndex = ctrl.intervalOptions.indexOf(ctrl.settings.interval);
                if (currentIndex === -1) currentIndex = 2; // Default to 1 hour if not found
                
                var newIndex = Math.round(currentIndex + (scale - 1) * 3);
                newIndex = Math.max(0, Math.min(ctrl.intervalOptions.length - 1, newIndex));
                
                return ctrl.intervalOptions[newIndex];
            };

            /**
             * Update calendar slot duration
             */
            ctrl.updateSlotDuration = function(newInterval) {
                if (newInterval !== ctrl.settings.interval) {
                    // Calculate the current time being viewed based on scroll position
                    var currentScrollTop = $(".fc-view-container").scrollTop();
                    var currentSlotHeight = $(".fc-slats tr").first().height();
                    var currentSlotCount = currentScrollTop / currentSlotHeight; // Use exact division, not floor
                    var currentSlotDuration = moment.duration(ctrl.settings.interval).asMinutes();
                    var currentTime = moment().startOf('day').add(currentSlotCount * currentSlotDuration, 'minutes');
                    
                    ctrl.settings.interval = newInterval;
                    
                    // Update calendar configuration
                    $("#mainCalendar").fullCalendar('option', 'slotDuration', newInterval);
                    $("#mainCalendar").fullCalendar('option', 'slotLabelInterval', newInterval);

                    // Calculate new scroll position to maintain the same time in view
                    var newSlotDuration = moment.duration(newInterval).asMinutes();
                    var newSlotHeight = $(".fc-slats tr").first().height();
                    var newSlotCount = (currentTime.diff(moment().startOf('day'), 'minutes')) / newSlotDuration;
                    var newScrollTop = newSlotCount * newSlotHeight;
                    
                    $(".fc-view-container").scrollTop(newScrollTop);
                    
                    // Add visual feedback
                    ctrl.showZoomFeedback(newInterval);
                }
            };

            /**
             * Show visual feedback for zoom changes
             */
            ctrl.showZoomFeedback = function(interval) {
                var feedback = $('<div class="zoom-feedback">');
                var zoomPercentage = Math.round((moment.duration(interval).asMinutes() / Info.data.interval) * 100);
                feedback.text('Zoom: ' + zoomPercentage + '%');
                
                $('body').append(feedback);
                
                setTimeout(function() {
                    feedback.fadeOut(300, function() {
                        feedback.remove();
                    });
                }, 500);
            };

            /**
             * Touch event handlers for pinch gestures
             */
            ctrl.initPinchZoom = function() {
                var calendarElement = document.getElementById('mainCalendar');
                if (!calendarElement) return;

                calendarElement.addEventListener('touchstart', function(e) {
                    if (e.touches.length === 2) {
                        ctrl.pinchZoom.isPinching = true;
                        ctrl.pinchZoom.preventDayClick = true;
                        ctrl.pinchZoom.initialDistance = ctrl.getTouchDistance(e.touches[0], e.touches[1]);
                        ctrl.pinchZoom.initialInterval = ctrl.settings.interval;
                        ctrl.pinchZoom.pinchAccumulator = 0; // Reset accumulator
                        ctrl.pinchZoom.lastZoomTime = 0; // Reset zoom timer
                        
                        // Add visual feedback
                        $(calendarElement).addClass('pinching');
                        
                        e.preventDefault();
                    }
                }, { passive: false });

                calendarElement.addEventListener('touchmove', function(e) {
                    if (ctrl.pinchZoom.isPinching && e.touches.length === 2) {
                        var currentDistance = ctrl.getTouchDistance(e.touches[0], e.touches[1]);
                        var scale = currentDistance / ctrl.pinchZoom.initialDistance;
                        
                        // Accumulate the pinch change
                        ctrl.pinchZoom.pinchAccumulator += (scale - 1);
                        
                        var currentTime = Date.now();
                        var zoomDelay = 30; // Minimum time between zoom updates (ms)
                        
                        // Check if we should zoom based on accumulated distance and timing
                        if (Math.abs(ctrl.pinchZoom.pinchAccumulator) >= ctrl.pinchZoom.zoomThreshold && 
                            (currentTime - ctrl.pinchZoom.lastZoomTime) >= zoomDelay) {
                            
                            var currentIndex = ctrl.intervalOptions.indexOf(ctrl.settings.interval);
                            if (currentIndex === -1) currentIndex = 2; // Default to 1 hour if not found
                            
                            // Calculate how many steps to move based on accumulated pinch
                            // Invert the direction: pinch out (positive) should zoom in (decrease index)
                            var stepsToMove = Math.round(ctrl.pinchZoom.pinchAccumulator / ctrl.pinchZoom.zoomThreshold);
                            var newIndex = currentIndex - stepsToMove;
                            newIndex = Math.max(0, Math.min(ctrl.intervalOptions.length - 1, newIndex));
                            
                            if (newIndex !== currentIndex) {
                                var newInterval = ctrl.intervalOptions[newIndex];
                                ctrl.updateSlotDuration(newInterval);
                                
                                // Reset accumulator and update time
                                ctrl.pinchZoom.pinchAccumulator = 0;
                                ctrl.pinchZoom.lastZoomTime = currentTime;
                            }
                        }
                        
                        e.preventDefault();
                    }
                }, { passive: false });

                calendarElement.addEventListener('touchend', function(e) {
                    if (ctrl.pinchZoom.isPinching) {
                        ctrl.pinchZoom.isPinching = false;
                        ctrl.pinchZoom.initialDistance = 0;
                        ctrl.pinchZoom.initialInterval = null;
                        ctrl.pinchZoom.pinchAccumulator = 0; // Reset accumulator
                        ctrl.pinchZoom.lastZoomTime = 0; // Reset zoom timer
                        
                        // Remove visual feedback
                        $(calendarElement).removeClass('pinching');
                        
                        // Reset preventDayClick flag after a short delay
                        setTimeout(function() {
                            ctrl.pinchZoom.preventDayClick = false;
                        }, 100);
                    }
                });
            };

            /**
             * Mouse wheel zoom for desktop users
             */
            ctrl.initMouseWheelZoom = function() {
                var calendarElement = document.getElementById('mainCalendar');
                if (!calendarElement) return;

                var wheelAccumulator = 0;
                var wheelThreshold = 30; // Require more wheel movement
                var lastWheelTime = 0;
                var wheelDelay = 100; // Minimum time between zoom changes (ms)

                calendarElement.addEventListener('wheel', function(e) {
                    if (e.ctrlKey || e.metaKey) { // Ctrl/Cmd + wheel
                        e.preventDefault();
                        
                        var currentTime = Date.now();
                        if (currentTime - lastWheelTime < wheelDelay) {
                            return; // Too soon, ignore this wheel event
                        }
                        
                        wheelAccumulator += e.deltaY;
                        
                        // Only change if accumulated enough movement
                        if (Math.abs(wheelAccumulator) >= wheelThreshold) {
                            var delta = wheelAccumulator > 0 ? 1 : -1;
                            var currentIndex = ctrl.intervalOptions.indexOf(ctrl.settings.interval);
                            if (currentIndex === -1) currentIndex = 2;
                            
                            var newIndex = currentIndex + delta;
                            newIndex = Math.max(0, Math.min(ctrl.intervalOptions.length - 1, newIndex));
                            
                            var newInterval = ctrl.intervalOptions[newIndex];
                            ctrl.updateSlotDuration(newInterval);
                            
                            // Reset accumulator and update time
                            wheelAccumulator = 0;
                            lastWheelTime = currentTime;
                        }
                    }
                }, { passive: false });
            };

            // Initialize pinch zoom when calendar is ready
            $timeout(function() {
                ctrl.initPinchZoom();
                ctrl.initMouseWheelZoom();
            }, 1000);
        });


})();

(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('CalendarSyncController', function ($scope, $uibModalInstance, $api, GoogleCalendarService, CalendarSyncService, Resources, $translate, moment, $q) {
            
            var ctrl = this;
            
            ctrl.resources = Resources.data || [];
            ctrl.syncResources = ctrl.resources.filter(function(resource) {
                return resource.google_calendar_sync == 1 && resource.google_calendar_email;
            }).map(function(resource) {
                return angular.extend({}, resource, {
                    sync_label: resource.name + ' (' + resource.google_calendar_email + ')'
                });
            });
            ctrl.selectedResource = null;
            ctrl.selectedDate = moment().format('YYYY-MM-DD');
            ctrl.syncLoading = false;
            ctrl.syncResults = [];

            /**
             * Initialize Google Calendar integration
             */
            ctrl.initGoogleCalendar = function() {
                ctrl.syncLoading = true;
                
                GoogleCalendarService.initialize().then(function() {
                    if (!GoogleCalendarService.isSignedIn()) {
                        return GoogleCalendarService.signIn();
                    }
                    return $q.resolve();
                }).then(function() {
                    ctrl.syncLoading = false;
                    ctrl.googleInitialized = true;
                }).catch(function(error) {
                    ctrl.syncLoading = false;
                    console.error('Google Calendar initialization error:', error);
                    
                    var errorMessage = $translate.instant('GOOGLE_CALENDAR_INIT_ERROR');
                    
                    // Provide specific error messages for common OAuth issues
                    if (error && error.includes('verification')) {
                        errorMessage = 'Google Calendar access is currently restricted. The app needs to complete Google verification. Please contact your administrator or try again later.';
                    } else if (error && error.includes('popup')) {
                        errorMessage = 'Please allow popups for this site and try again.';
                    } else if (error && error.includes('cancelled')) {
                        errorMessage = 'Google Calendar sign-in was cancelled. Please try again.';
                    }
                    
                    swal({
                        title: $translate.instant('ERROR'),
                        text: errorMessage,
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            };

            /**
             * Sync calendar for selected resource and date
             */
            ctrl.syncCalendar = function() {
                if (!ctrl.selectedResource || !ctrl.selectedResource.google_calendar_email) {
                    swal({
                        title: $translate.instant('ERROR'),
                        text: $translate.instant('GOOGLE_CALENDAR_EMAIL_REQUIRED'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                    return;
                }

                ctrl.syncLoading = true;
                ctrl.syncResults = [];

                CalendarSyncService.syncResourceCalendar(
                    ctrl.selectedResource.id,
                    ctrl.selectedResource.google_calendar_email,
                    ctrl.selectedDate
                ).then(function(result) {
                    ctrl.syncLoading = false;
                    ctrl.syncResults.push({
                        resource: ctrl.selectedResource.name,
                        date: ctrl.selectedDate,
                        result: result,
                        timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
                    });

                    var message = $translate.instant('GOOGLE_CALENDAR_SYNC_SUCCESS') + '\n';
                    message += $translate.instant('CREATED') + ': ' + result.created + '\n';
                    message += $translate.instant('UPDATED') + ': ' + result.updated + '\n';
                    message += $translate.instant('DELETED') + ': ' + result.deleted;
                    
                    if (result.errors && result.errors.length > 0) {
                        message += '\n' + $translate.instant('ERRORS') + ': ' + result.errors.length;
                    }

                    swal({
                        title: $translate.instant('GOOGLE_CALENDAR_SYNC_COMPLETE'),
                        text: message,
                        type: result.errors && result.errors.length > 0 ? "warning" : "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error) {
                    ctrl.syncLoading = false;
                    console.error('Calendar sync error:', error);
                    
                    swal({
                        title: $translate.instant('ERROR'),
                        text: $translate.instant('GOOGLE_CALENDAR_SYNC_ERROR'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            };

            /**
             * Sync calendar for all resources with Google Calendar enabled
             */
            ctrl.syncAllCalendars = function() {
                var resourcesWithGoogleSync = ctrl.resources.filter(function(resource) {
                    return resource.google_calendar_sync == 1 && resource.google_calendar_email;
                });

                if (resourcesWithGoogleSync.length === 0) {
                    swal({
                        title: $translate.instant('NO_GOOGLE_SYNC_RESOURCES'),
                        text: $translate.instant('NO_GOOGLE_SYNC_RESOURCES_MESSAGE'),
                        type: "info",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                    return;
                }

                ctrl.syncLoading = true;
                ctrl.syncResults = [];

                var syncPromises = resourcesWithGoogleSync.map(function(resource) {
                    return CalendarSyncService.syncResourceCalendar(
                        resource.id,
                        resource.google_calendar_email,
                        ctrl.selectedDate
                    ).then(function(result) {
                        ctrl.syncResults.push({
                            resource: resource.name,
                            date: ctrl.selectedDate,
                            result: result,
                            timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
                        });
                        return result;
                    });
                });

                $q.all(syncPromises).then(function(results) {
                    ctrl.syncLoading = false;
                    
                    var totalCreated = 0;
                    var totalUpdated = 0;
                    var totalDeleted = 0;
                    var totalErrors = 0;

                    results.forEach(function(result) {
                        totalCreated += result.created;
                        totalUpdated += result.updated;
                        totalDeleted += result.deleted;
                        totalErrors += result.errors ? result.errors.length : 0;
                    });

                    var message = $translate.instant('BULK_SYNC_COMPLETE') + '\n';
                    message += $translate.instant('RESOURCES_SYNCED') + ': ' + resourcesWithGoogleSync.length + '\n';
                    message += $translate.instant('CREATED') + ': ' + totalCreated + '\n';
                    message += $translate.instant('UPDATED') + ': ' + totalUpdated + '\n';
                    message += $translate.instant('DELETED') + ': ' + totalDeleted;
                    
                    if (totalErrors > 0) {
                        message += '\n' + $translate.instant('ERRORS') + ': ' + totalErrors;
                    }

                    swal({
                        title: $translate.instant('BULK_SYNC_COMPLETE'),
                        text: message,
                        type: totalErrors > 0 ? "warning" : "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                }).catch(function(error) {
                    ctrl.syncLoading = false;
                    console.error('Bulk sync error:', error);
                    
                    swal({
                        title: $translate.instant('ERROR'),
                        text: $translate.instant('BULK_SYNC_ERROR'),
                        type: "error",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                    });
                });
            };

            /**
             * Close modal
             */
            ctrl.close = function() {
                $uibModalInstance.close();
            };

            /**
             * Cancel modal
             */
            ctrl.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };

            // Initialize Google Calendar on modal open
            ctrl.initGoogleCalendar();
        });
})();

(function () {

    angular.module('app.controllers')

        .controller('ApprovalRequestController', function($window, $header, $api, $scope, $state, $rootScope, $uibModalInstance, $uibModal, OrderId) {
  
            var ctrl = this;

            ctrl.form = {
                send_method: 1
            };

            ctrl.send = function() {
                $uibModalInstance.close(ctrl.form.send_method);
            }

            ctrl.viewRequest = function() {
                
                $uibModal.open({
                    templateUrl: "app/modules/approval/approval.view.html",
                    controller: "ApprovalController",
                    controllerAs: "ctrl",
                    scope: $scope,
                    windowTopClass: "form-modal medium-modal order-edit-modal side-modal",
                    resolve: {
                        Order: ['$api', '$rootScope', function ($api) {
                            return $api.resolve("approval@get", {"id": OrderId});
                        }],
                        IsPreview: ['$rootScope', function () {
                            return 1;
                        }]
                    }
                }).closed.then(function() {
                    
                });
                // var url = $api.baseURL.replace("/api/index.php/api", "/#/approval/" );
                // // var url = "http://localhost:3000/#/approval/"
                // url += OrderId;
                // url += "/1";
                // var winRef = $window.open(encodeURI(url), "_blank");
                // winRef.addEventListener('loadstop', function(event) {
                //     console.log('loadstop');     
                //     if (event.url.match("/#/approval/"+OrderId+"2")) {
                //         winRef.close();
                //     }
                // });
            }
            
        });
})();

(function () {

    angular.module('app.controllers')

        .controller('ApprovalController', function(Order, IsPreview, $header, $api, $scope, $color, $timeout, $uibModalInstance, $window, $translate) {
  
            var ctrl = this;
            ctrl.date = moment().format("DD/MM/YYYY");
            $scope.isMobile = (angular.element(document).width() < 769);
            $scope.orderItem = Order.data;
            $scope.business = Order.data ? Order.data.business_data : {};
            $scope.business.approval_text = $scope.business.approval_text ? $scope.business.approval_text.replace(/\n/g, '<br/>') : '';
            $scope.total = 0;
            $scope.tax = 0;
            $scope.subtotal = 0;
            $scope.isApproved = false;
            $scope.isPreview = IsPreview ? true: false;        
            $scope.isApproved = $scope.orderItem.approval_sent == 2;

            if($scope.orderItem.customer_data !== null) {
                $scope.orderItem.name = $scope.orderItem.customer_data.firstname + 
                    " " + $scope.orderItem.customer_data.lastname;
            }

            if($scope.orderItem.approved_date !== null){
                $scope.orderItem.approved_date = moment($scope.orderItem.approved_date).format("DD/MM/YYYY");
            }

            function compareTimes(a, b) {
                if (a.start_time < b.start_time) return -1;
                if (a.start_time > b.start_time) return 1;
                return 0;
            }
            
            ctrl.first_item = {};
            ctrl.start = '';
            ctrl.end = '';
            ctrl.tz = '';
            ctrl.utcOffset = '';

            if ($scope.orderItem && $scope.orderItem.items) {
                $scope.orderItem.items.sort(compareTimes);
                ctrl.first_item = $scope.orderItem.items[0];

                for (var i in $scope.orderItem.items) {
                    var $item = $scope.orderItem.items[i];
                    var type_current = $item.item_data && $item.item_data.item_type ? $item.item_data.item_type : $item.item_type;
                    var type_first = ctrl.first_item.item_data && ctrl.first_item.item_data.item_type ? ctrl.first_item.item_data.item_type : ctrl.first_item.item_type;
                    if (!ctrl.first_item || type_first !== 'service' || 
                        (type_current === 'service' && $item['start_time'] && 
                        new Date($item['start_time']).getTime() < new Date(ctrl.first_item['start_time']).getTime())) {
                        ctrl.first_item = $item;
                    }
                }

                
                ctrl.date = moment(ctrl.first_item.start_time).format('YYYY-MM-DD');
                ctrl.start = moment(ctrl.first_item.start_time).format('HH:mm');
                ctrl.end = moment(ctrl.first_item.end_time).format('HH:mm');
                ctrl.tz = moment(ctrl.first_item.start_time).tz();
                ctrl.utcOffset = moment(ctrl.first_item.start_time).format('Z');
                $scope.orderItem.order_date = moment(ctrl.first_item.start_time).format("HH:mm DD/MM/YYYY");

                $timeout(function() { atcb_init(); }, 100);
            }


            if ($scope.business['favicon_path']) {
                $('#favicon').attr('href', $scope.business['favicon_path']+'favicon.ico');
                $('#favicon-16').attr('href', $scope.business['favicon_path']+'favicon-16.png');
                $('#favicon-32').attr('href', $scope.business['favicon_path']+'favicon-32.png');
                $('#favicon-64').attr('href', $scope.business['favicon_path']+'favicon-64.png');
            }
            
            ctrl.update_item_nights = function (itemIndex) {
                if ($scope.orderItem.items[itemIndex].start_time && $scope.orderItem.items[itemIndex].end_time) {
                  var duration;
                  var start_time = moment($scope.orderItem.items[itemIndex].start_time);
                  $scope.orderItem.items[itemIndex].start_time = moment(start_time).format("DD/MM/YYYY");
                  var end_time = moment($scope.orderItem.items[itemIndex].end_time);
                  $scope.orderItem.items[itemIndex].end_time = moment(end_time).format("DD/MM/YYYY");
                  duration = moment.duration(end_time.diff(start_time));
                  $scope.orderItem.items[itemIndex].nights = Math.round(duration.asDays());
                } else {
                  $scope.orderItem.items[itemIndex].nights = null;
                }
            };

            ctrl.calculate_totals = function () {
                $scope.total = 0;
                $scope.tax = 0;
                $scope.subtotal = 0;
                for (var i in $scope.orderItem.items) {
                    if ($scope.orderItem.business_data.type == 1 && $scope.orderItem.items[i].price) {
                    $scope.total += $scope.orderItem.items[i].price;
                    } else if ($scope.orderItem.business_data.type == 2 && $scope.orderItem.items[i].nights > 0) {
                    $scope.total += $scope.orderItem.items[i].item_data.price * $scope.orderItem.items[i].nights;
                    }
                }
                if ($scope.orderItem.business_data.dealer_type === "licensed") {
                    $scope.subtotal = ($scope.total / (100 + parseFloat($scope.orderItem.business_data.vat))) * 100;
                    $scope.tax = $scope.total - $scope.subtotal;
                }
            };

            for (var i in $scope.orderItem.items) {
                ctrl.update_item_nights(i);
            }

            ctrl.mainTitle = "Main Title";

            ctrl.calculate_totals();

            /**
             * Module header configuration (title and breadcrumbs)
             */
            $header.title = "NAV_APPROVAL";
            $header.breadcrumbs.push({
                "title": "NAV_APPROVAL"
            });

            ctrl.submit = function(not_arrive){
                not_arrive = not_arrive ? 1 : 0;
                $api.approval.save({
                    id: $scope.orderItem.id,
                    not_arrive: not_arrive
                }, function (response) {
                    if (response.status === "success") {
                        if (not_arrive) {
                            $scope.isApproved = false;
                            $scope.orderItem.approval_sent = 3;
                            swal({
                                title: $translate.instant('SWAL_NOT_APPROVAL_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                            
                        } else {
                            $scope.isApproved = true;
                            $scope.orderItem.approval_sent = 2;
                            swal({
                                title: $translate.instant('SWAL_APPROVAL_SAVE_TITLE'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    }
                });
            }

            ctrl.close = function() {
                $uibModalInstance.close();
            }

            ctrl.setBusinessSettings = function() {
                $scope.business.online_booking_data.online_color = $scope.business.online_booking_data.online_color ? $scope.business.online_booking_data.online_color : '#61B9A0';
                if ($scope.business.online_booking_data.online_color == 'purple') {
                    $scope.business.online_booking_data.online_color = '#8C60AE';
                }
                if ($scope.business.online_booking_data.online_color == 'turquoise') {
                    $scope.business.online_booking_data.online_color = '#61B9A0';
                }

                $scope.business.online_booking_data.background = $scope.business.online_booking_data && $scope.business.online_booking_data.background && $scope.business.online_booking_data.background != "" ? $scope.business.online_booking_data.background : ($scope.business.online_booking_data.background_picture == "men" ? location.protocol + "//" + location.host+'/assets/images/pwa-default-men-back.png' : location.protocol + "//" + location.host+'/assets/images/pwa-default-women-back.png');
                $scope.business.online_booking_data.online_logo = $scope.business.online_booking_data && $scope.business.online_booking_data.online_logo && $scope.business.online_booking_data.online_logo != "" ? ($scope.business.online_booking_data.online_logo == "removed" ? "" : $scope.business.online_booking_data.online_logo) : location.protocol + "//" + location.host+'/assets/images/logo-icon@2x.png';
                
                // less.modifyVars({
                //     '@menu-color': $scope.business.menu_color ? $scope.business.menu_color : '#216089',
                //     '@online-color': $scope.business.online_booking_data.online_color,
                //     '@online-text-color':  $scope.business.online_booking_data.online_text_color,
                //     '@back-color': $scope.business.back_color ? $scope.business.back_color : '#F2F6FF',
                //     '@calendar-color': $scope.business.calendar_color != '#f2f2f2' ? $scope.business.calendar_color : '#fff',
                // });

                document.documentElement.style.setProperty('--menu-color', $scope.business.menu_color ? $scope.business.menu_color : '#216089');
                document.documentElement.style.setProperty('--online-color', $scope.business.online_booking_data.online_color);
                document.documentElement.style.setProperty('--online-text-color', $scope.business.online_booking_data.online_text_color);
                document.documentElement.style.setProperty('--back-color', $scope.business.back_color ? $scope.business.back_color : '#F2F6FF');
                document.documentElement.style.setProperty('--calendar-color', $scope.business.calendar_color != '#f2f2f2' ? $scope.business.calendar_color : '#fff');
                document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $scope.business.menu_color ? $scope.business.menu_color : '#216089'));
                document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $scope.business.back_color ? $scope.business.back_color : '#F2F6FF'));
                document.documentElement.style.setProperty('--calendar-stripe-color', $scope.business.calendar_stripe_color ? $scope.business.calendar_stripe_color : '#f7fafc');
            }

            ctrl.setBusinessSettings();

            ctrl.waPhone = function(phone) {
                var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                for (var s in mas) {
                  phone = phone.replace(mas[s], '')
                }
                return '+972'+phone;
            }
        });
})();
(function () {

    angular.module('app.controllers')

        .controller('AnalyticsController', function ($header, $timeout, $translate, $scope, dates, $api, $rootScope, $user, $state, $payment, AnalyticsStorage, DTOptionsBuilder, DTColumnDefBuilder, dataTablesHebrewProvider, $compile, $utils, Statuses) {

            var showCapacityGraph = $rootScope.$user && $rootScope.$user.b_type == 2;
            
            if ($rootScope.userRole == 1){
                $state.go('app.admin', {}, {reload: true});
                return;
            }

            var ctrl = this;

            ctrl.graphLoading = {};
            
            ctrl.isMobile = (angular.element(document).width() < 769)
            ctrl.graphHeight = ctrl.isMobile ? 200 : 420;
            $scope.datesProvider = dates;

            ctrl.selectedPoint = {};
            ctrl.chartInstances = {};

            ctrl.statuses = Statuses && Statuses.data ? Statuses.data : [];
            ctrl.statusOptions = [{
                id: '',
                name: $translate.instant('CUSTOMERS_STATUS'),
                color: ''
            }].concat((ctrl.statuses || []).map(function (status) {
                return {
                    id: String(status.id),
                    name: status.name,
                    color: status.color || ''
                };
            }));
            ctrl.birthdayOptions = buildMonthOptions(dates.months);
            ctrl.campaignMetricOptions = [
                {id: 'leads', name: $translate.instant('CAMPAIGN_BAR_METRIC_LEADS')},
                {id: 'income', name: $translate.instant('CAMPAIGN_BAR_METRIC_INCOME')}
            ];
            ctrl.campaignFilterOptions = [
                {id: 'this_month', name: $translate.instant('CAMPAIGN_BAR_THIS_MONTH')},
                {id: 'last_month', name: $translate.instant('CAMPAIGN_BAR_LAST_MONTH')},
                {id: 'this_year', name: $translate.instant('CAMPAIGN_BAR_THIS_YEAR')},
                {id: 'last_year', name: $translate.instant('CAMPAIGN_BAR_LAST_YEAR')},
                {id: 'custom', name: $translate.instant('CAMPAIGN_BAR_CUSTOM')}
            ];
            ctrl.genderOptions = [
                {id: '0', name: $translate.instant('CUSTOMERS_GENDER_MALE')},
                {id: '1', name: $translate.instant('CUSTOMERS_GENDER_FEMALE')}
            ];
            function buildCategoryOptions(categories) {
                var options = [{
                    id: '',
                    name: $translate.instant('ANALYTICS_ALL_CATEGORIES')
                }];
                for (var i = 0; i < (categories || []).length; i++) {
                    options.push(categories[i]);
                }
                options.push({
                    id: 0,
                    name: $translate.instant('ANALYTICS_NO_CATEGORY')
                });
                return options;
            }
            $scope.customerStatuses = {};
            ctrl.fieldSettings = ($rootScope.$user && $rootScope.$user.table_columns && $rootScope.$user.table_columns.customers) ? $rootScope.$user.table_columns.customers : [];

            ctrl.onFieldsUpdate = function(fieldsList) {
                ctrl.fieldSettings = fieldsList;
                $api.settings.table_columns.save({section: 'customers', columns: fieldsList}, function(response) {
                    if (response.status == 'success') {
                        $rootScope.$user.table_columns.customers = fieldsList;
                        
                        Object.keys(ctrl.customersDt || {}).forEach(function(graphID) {
                            if (ctrl.customersDt[graphID]) {
                                ctrl.customersDt[graphID].refreshing = true;
                                
                                ctrl.customersDt[graphID].columns = updateDtColumns(graphID);
                                
                                $timeout(function() {
                                    ctrl.customersDt[graphID].refreshing = false;
                                }, 100);
                            }
                        });
                    }
                }, function(response) {
                    console.error('Failed to save table columns', response);
                });
            };

            ctrl.applyChartSelectionStyle = function(graphID) {
                var graph = ctrl.graphs && ctrl.graphs[graphID];
                if (!graph || !graph.data || !graph.data.datasets) {
                    return;
                }

                var sel = ctrl.selectedPoint[graphID];
                var hasSel = sel && sel.index != null;

                var GREY = '#e5e7eb';

                graph.data.datasets.forEach(function(ds, dsIndex) {
                    if (ds && ds.statKey === 'forecast') {
                        return;
                    }

                    var len = (ds && ds.data) ? ds.data.length : 0;
                    if (!len) {
                        return;
                    }

                    if (ds._baseBackgroundColor == null) {
                        ds._baseBackgroundColor = ds.backgroundColor;
                    }
                    var baseBg = ds._baseBackgroundColor;
                    if (!hasSel) {
                        ds.backgroundColor = baseBg;
                        return;
                    }

                    function getBaseColorAt(i) {
                        if (Array.isArray(baseBg)) {
                            return baseBg[i] || baseBg[0];
                        }

                        return baseBg;
                    }

                    var bgArr = new Array(len);

                    for (var i = 0; i < len; i++) {
                        var isSelected = hasSel && sel.index === i && (sel.datasetIndex == null || sel.datasetIndex === dsIndex);

                        bgArr[i] = (!hasSel || isSelected) ? getBaseColorAt(i) : GREY;
                    }

                    ds.backgroundColor = bgArr;
                });

                var ch = ctrl.chartInstances && ctrl.chartInstances[graphID];
                if (ch) {
                    ch.update('none');
                }
            };

            ctrl.persistSelectedPoint = function(graphID) {
                try {
                    var saved = AnalyticsStorage.getCustomersState(graphID) || {};
                    saved.selectedPoint = ctrl.selectedPoint[graphID] || null;
                    saved.ts = Date.now();
                    AnalyticsStorage.setCustomersState(graphID, saved);
                } catch (e) {}
            };

            ctrl.translateChartLabels = function(labels) {
                var labelMap = {
                    'NEW_LEADS': 'ANALYTIC_LABEL_NEW_LEADS',
                    'FIRST_ORDERS': 'ANALYTIC_LABEL_FIRST_ORDERS',
                    'FIRST_PAID': 'ANALYTIC_LABEL_FIRST_PAID',
                    'REST_ORDERS': 'ANALYTIC_LABEL_REST_ORDERS',
                    'CANCELED_ORDERS': 'ANALYTIC_LABEL_CANCELED_ORDERS'
                };

                var translateLabel = function(label) {
                    var translationKey = labelMap[label];
                    if (translationKey) {
                        return $translate.instant(translationKey);
                    }
                    return label;
                };

                // Handle array (pie chart) or single string (bar chart)
                if (Array.isArray(labels)) {
                    return labels.map(translateLabel);
                }
                return translateLabel(labels);
            };

            $scope.$watch('ctrl.graphs.statsBar.start', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsBar');
                }
            });
    
            $scope.$watch('ctrl.graphs.statsBar.end', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsBar');
                }
            });
    
            $scope.$watch('ctrl.graphs.statsPie.start', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsPie');
                }
            });
    
            $scope.$watch('ctrl.graphs.statsPie.end', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ctrl.loadAnalytics('statsPie');
                }
            });

            $scope.$watch('ctrl.graphs.campaignBar.start', function(newValue, oldValue) {
                if(newValue != oldValue && ctrl.graphs.campaignBar && ctrl.graphs.campaignBar.campaign_filter == 'custom') {
                    ctrl.loadAnalytics('campaignBar');
                }
            });
    
            $scope.$watch('ctrl.graphs.campaignBar.end', function(newValue, oldValue) {
                if(newValue != oldValue && ctrl.graphs.campaignBar && ctrl.graphs.campaignBar.campaign_filter == 'custom') {
                    ctrl.loadAnalytics('campaignBar');
                }
            });

            // Watch for campaign_filter changes
            $scope.$watch('ctrl.graphs.campaignBar.campaign_filter', function(newValue, oldValue) {
                if(newValue != oldValue && ctrl.graphs.campaignBar) {
                    ctrl.onCampaignBarFilterChange();
                }
            });

            function formatDateToYMD(date) {
                if (!date) return null;
                var d = new Date(date);
                var year = d.getFullYear();
                var month = ('0' + (d.getMonth() + 1)).slice(-2);
                var day = ('0' + d.getDate()).slice(-2);
                return year + '-' + month + '-' + day;
            }

            function periodFromLabel(label, filter) {
                if (!label) {
                    return { start: null, end: null };
                }

                var raw = String(label).trim();

                var rangeParts = raw.split(/\s*[-–—]\s*/);
                if (rangeParts.length === 2) {
                    var a = rangeParts[0].trim();
                    var b = rangeParts[1].trim();

                    var ma = moment(a, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'DD.MM.YYYY', 'DD/MM'], true);
                    var mb = moment(b, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'DD.MM.YYYY', 'DD/MM'], true);

                    if (ma.isValid() && mb.isValid()) {
                        return { start: ma.clone().startOf('day'), end: mb.clone().endOf('day') };
                    }
                }

                function parseDay(s) {
                    return moment(s, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'DD.MM.YYYY'], true);
                }

                function parseMonth(s) {
                    return moment(s, ['YYYY/MM', 'MM/YYYY', 'YYYY-MM'], true);
                }

                function parseDayNoYear(s) {
                    var m = moment(s, ['DD/MM', 'DD.MM'], true);
                    return m;
                }

                function inferWeeklySundayYear(dayMonthMoment) {
                    if (!dayMonthMoment || !dayMonthMoment.isValid()) {
                        return null;
                    }

                    var now = moment();
                    var day = dayMonthMoment.date();
                    var monthIdx = dayMonthMoment.month();

                    var minDate = now.clone().subtract(370, 'days').startOf('day');
                    var maxDate = now.clone().endOf('day');

                    var candidates = [];
                    var thisYear = now.year();

                    [thisYear, thisYear - 1].forEach(function (y) {
                        var d = moment({ year: y, month: monthIdx, day: day });

                        if (!d.isValid()) {
                            return;
                        }

                        if (d.isAfter(maxDate)) {
                            return;
                        }

                        var isSunday = (d.day && d.day() === 0);
                        var inRange = d.isSameOrAfter(minDate) && d.isSameOrBefore(maxDate);

                        if (isSunday && inRange) {
                            candidates.push(d);
                        }
                    });

                    if (candidates.length === 1) {
                        return candidates[0];
                    }

                    if (candidates.length > 1) {
                        candidates.sort(function (a, b) {
                            return Math.abs(a.diff(now, 'seconds')) - Math.abs(b.diff(now, 'seconds'));
                        });
                        return candidates[0];
                    }

                    var fallback = [];
                    [thisYear, thisYear - 1].forEach(function (y) {
                        var d = moment({ year: y, month: monthIdx, day: day });
                        if (!d.isValid()) {
                            return;
                        }

                        if (d.isAfter(maxDate)) {
                            return;
                        }

                        fallback.push(d);
                    });

                    if (!fallback.length) {
                        return null;
                    }

                    fallback.sort(function (a, b) {
                        return Math.abs(a.diff(now, 'seconds')) - Math.abs(b.diff(now, 'seconds'));
                    });

                    return fallback[0];
                }

                if (filter === 'daily') {
                    var md = parseDay(raw);
                    if (!md.isValid()) {
                        return { start: null, end: null };
                    }
                    return { start: md.clone().startOf('day'), end: md.clone().endOf('day') };
                }

                if (filter === 'monthly') {
                    var mm = parseMonth(raw);
                    if (!mm.isValid()) {
                        return { start: null, end: null };
                    }
                    return {
                        start: mm.clone().startOf('month').startOf('day'),
                        end: mm.clone().endOf('month').endOf('day')
                    };
                }

                if (filter === 'weekly') {
                    var iso = raw.match(/^(\d{4})\s*\/\s*(\d{1,2})$/);
                    if (iso) {
                        var year = parseInt(iso[1], 10);
                        var week = parseInt(iso[2], 10);

                        var mw = moment().isoWeekYear(year).isoWeek(week).startOf('isoWeek');
                        if (!mw.isValid()) {
                            return { start: null, end: null };
                        }
                        return {
                            start: mw.clone().startOf('isoWeek').startOf('day'),
                            end: mw.clone().endOf('isoWeek').endOf('day')
                        };
                    }

                    var mdw = moment(raw, ['DD/MM/YYYY', 'DD.MM.YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'], true);
                    if (mdw.isValid()) {
                    return {
                            start: mdw.clone().startOf('day'),
                            end: mdw.clone().add(6, 'days').endOf('day')
                        };
                    }

                    var mny = parseDayNoYear(raw);
                    if (mny.isValid()) {
                        var inferred = inferWeeklySundayYear(mny);
                        if (!inferred) {
                            return { start: null, end: null };
                        }

                        return {
                            start: inferred.clone().startOf('day'),
                            end: inferred.clone().add(6, 'days').endOf('day')
                        };
                    }

                    return { start: null, end: null };
                }

                return { start: null, end: null };
            }

            function formatDateTimeForApi(v, edge) {
                if (!v) {
                    return null;
                }

                var m = moment.isMoment(v) ? v.clone() : moment(v);

                if (!m.isValid()) {
                    return null;
                }

                if (edge === 'start') {
                    m.startOf('day');
                }

                if (edge === 'end') {
                    m.endOf('day');
                }

                return m.format('YYYY-MM-DD HH:mm:ss');
            }

            ctrl.restoreCustomersAll = function() {
                var graphIds = AnalyticsStorage.listCustomersGraphIds ? AnalyticsStorage.listCustomersGraphIds() : Object.keys(ctrl.graphs || {});

                graphIds.forEach(function(graphID) {
                    var saved = AnalyticsStorage.getCustomersState(graphID);
                    if (!saved || !saved.request) {
                        return;
                    }

                    if (saved.selectedPoint) {
                        ctrl.selectedPoint[graphID] = saved.selectedPoint;
                    }

                    if (!ctrl.customersByGraph[graphID]) {
                        ctrl.customersByGraph[graphID] = {
                            request: saved.request,
                            customer_ids: Array.isArray(saved.customer_ids) ? saved.customer_ids : [],
                            pagination: saved.pagination || null,
                            loading: false,
                            error: null,
                        };
                    } else {
                        ctrl.customersByGraph[graphID].request = saved.request;
                        ctrl.customersByGraph[graphID].customer_ids = Array.isArray(saved.customer_ids) ? saved.customer_ids : [];
                        ctrl.customersByGraph[graphID].pagination = saved.pagination || null;
                    }

                    var tableSel = '#analytics_cust_dt_' + graphID;
                    var alreadyInited = $.fn.DataTable && $.fn.DataTable.isDataTable(tableSel);

                    if (ctrl.customersByGraph[graphID] && ctrl.customersByGraph[graphID].request) {
                        ensureCustomersDt(graphID);
                    }

                    if (alreadyInited) {
                        $timeout(function() {
                            try {
                                $(tableSel).DataTable().ajax.reload();
                            } catch (e) {}
                        }, 0);
                    }

                    $timeout(function() {
                        ctrl.applyChartSelectionStyle(graphID);
                    }, 0);
                });
            };

            ctrl.handleChartClick = function (graphID, meta) {
                var graph = ctrl.graphs[graphID];
                if (!graph) {
                    return;
                }

                var start = null;
                var end = null;
                var extra = {};

                if (meta.periodLabel && graph.filter) {
                    var p = periodFromLabel(meta.periodLabel, graph.filter);
                    if (p.start) {
                        start = formatDateTimeForApi(p.start, 'start');
                    }

                    if (p.end) {
                        end = formatDateTimeForApi(p.end, 'end');
                    }
                }

                switch (graphID) {
                    case 'statsBar':
                        extra.stat_key = meta.statKey;
                        extra.stats_type = graph.stats_type || 'leads';
                        break;

                    case 'statsPie':
                        extra.stat_key = meta.statKey;
                        extra.stats_type = graph.stats_type || 'leads';
                        start = graph.start ? formatDateTimeForApi(graph.start, 'start') : null;
                        end = graph.end ? formatDateTimeForApi(graph.end, 'end') : null;
                        break;

                    case 'campaignBar':
                        extra.campaign_type = graph.campaign_type || 'campaigns';
                        extra.campaign_metric = graph.campaign_metric || 'leads';
                        extra.campaign_value = meta.label;
                        start = graph.start ? formatDateTimeForApi(graph.start, 'start') : null;
                        end = graph.end ? formatDateTimeForApi(graph.end, 'end') : null;
                        break;

                    case 'income':
                        extra.metric = 'income';
                        extra.stat_key = meta.statKey || 'income';
                        break;

                    case 'orders':
                        extra.metric = 'orders';
                        extra.stat_key = meta.statKey || 'orders';
                        break;
                }

                var graph = ctrl.graphs[graphID];

                var request = angular.extend({
                    type: 'chartCustomers',
                    graph: graphID,
                    start: start,
                    end: end,
                    page: 1,
                    per_page: 20,
                    filter_values: AnalyticsStorage.normalizeFilter(ctrl.filter[graphID] || {}),
                }, extra);

                if (request.filter_values) {
                    request.filter_values.created_from = formatDateToYMD(request.filter_values.created_from);
                    request.filter_values.created_to = formatDateToYMD(request.filter_values.created_to);
                    request.filter_values.lastvisit_from = formatDateToYMD(request.filter_values.lastvisit_from);
                    request.filter_values.lastvisit_to = formatDateToYMD(request.filter_values.lastvisit_to);
                    request.filter_values.visited_from = formatDateToYMD(request.filter_values.visited_from);
                    request.filter_values.visited_to = formatDateToYMD(request.filter_values.visited_to);
                }

                if (graph.category && graph.category !== '') {
                    request.category = graph.category;
                }

                if (graph.resource && graph.resource !== '') {
                    request.resource = graph.resource;
                }

                if (graph.resource_booked && graph.resource_booked !== '') {
                    request.resource_booked = graph.resource_booked;
                }

                if (graph.resource_responsible && graph.resource_responsible !== '') {
                    request.resource_responsible = graph.resource_responsible;
                }

                if (graph.resource_treated && graph.resource_treated !== '') {
                    request.resource_treated = graph.resource_treated;
                }

                if (graph.payment_method && graph.payment_method !== '') {
                    request.payment_method = graph.payment_method;
                }

                var tableSel = '#analytics_cust_dt_' + graphID;
                var alreadyInited = $.fn.DataTable && $.fn.DataTable.isDataTable(tableSel);

                ctrl.setCustomersRequest(graphID, request);
                ensureCustomersDt(graphID);

                if (alreadyInited) {
                    $timeout(function() {
                        try {
                            var dt = $(tableSel).DataTable();
                            if (dt && dt.ajax) dt.ajax.reload();
                        } catch (e) {}
                    }, 0);
                }
            };

            ctrl.setCustomersRequest = function(graphID, request) {
                if (!ctrl.customersByGraph[graphID]) {
                    ctrl.customersByGraph[graphID] = {
                        request: null,
                        customer_ids: [],
                        pagination: null,
                        loading: false,
                        error: null,
                        items: [],
                    };
                }

                ctrl.customersByGraph[graphID].request = angular.copy(request);
                ctrl.customersByGraph[graphID].error = null;

                ensureCustomersDt(graphID);

                var saved = AnalyticsStorage.getCustomersState(graphID) || {};
                saved.ts = Date.now();
                saved.request = ctrl.customersByGraph[graphID].request;
                saved.selectedPoint = ctrl.selectedPoint[graphID] || saved.selectedPoint || null;

                AnalyticsStorage.setCustomersState(graphID, saved);
            };

            ctrl.defaults = {
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            stacked: true,
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            display: false
                        },
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.x) {
                            var barWidth = chart.scales.x.width / chart.data.labels.length;
                            chart.options.borderRadius = barWidth / 5;
                            chart.update();
                        }
                    },
                    onClick: function(evt, activeEls, chart) {
                        if (!activeEls || !activeEls.length) {
                            return;
                        }

                        var el = activeEls[0];
                        var datasetIndex = el.datasetIndex;
                        var index = el.index;

                        var periodLabel = chart.data.labels[index];
                        var dataset = chart.data.datasets[datasetIndex];

                        if (dataset.statKey === 'forecast') {
                            return;
                        }

                        $scope.$applyAsync(function() {
                            var ok = ctrl.toggleChartSelection('income', datasetIndex, index);
                            if (!ok) {
                                return;
                            }

                            ctrl.handleChartClick('income', {
                                statKey: dataset.statKey,
                                periodLabel: periodLabel
                            });
                        });
                    }
                },
                opacity_graph_options:{
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            stacked: true,
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.x) {
                            var barWidth = chart.scales.x.width / chart.data.labels.length;
                            chart.options.borderRadius = barWidth / 5;
                            chart.update();
                        }
                    },
                    onClick: function(evt, activeEls, chart) {
                        if (!activeEls || !activeEls.length) {
                            return;
                        }

                        var el = activeEls[0];
                        var datasetIndex = el.datasetIndex != null ? el.datasetIndex : 0;
                        var index = el.index;

                        var periodLabel = chart.data.labels[index];

                        $scope.$applyAsync(function() {
                            var ok = ctrl.toggleChartSelection('orders', datasetIndex, index);
                            if (!ok) {
                                return;
                            }

                            ctrl.handleChartClick('orders', {
                                statKey: chart.data.datasets[0].statKey,
                                periodLabel: periodLabel
                            });
                        });
                    }
                },
                stats_pie_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(tooltipItem) {
                                    var dataset = tooltipItem.dataset;
                                    var currentValue = dataset.data[tooltipItem.dataIndex];
                                    var total = dataset.data.reduce(function(acc, val) {
                                        return acc + val;
                                    }, 0);
                                    var percentage = ((currentValue / total) * 100).toFixed();
                                    return tooltipItem.label + ": " + currentValue + " (" + percentage + "%)";
                                }
                            }
                        },
                        legend: {
                            labels: {
                                generateLabels: function(chart) {
                                    var data = chart.data;
                                    return data.labels.map(function(label, index) {
                                        var value = data.datasets[0].data[index];
                                        var total = data.datasets[0].data.reduce(function(acc, val) {
                                            return acc + val;
                                        }, 0);
                                        var percentage = ((value / total) * 100).toFixed();
                                        return {
                                            text: label + ": " + value + " (" + percentage + "%)",
                                            fillStyle: data.datasets[0].backgroundColor[index],
                                            hidden: false,
                                            index: index
                                        };
                                    });
                                }
                            }
                        }
                    },
                    scales: {},
                    onClick: function(evt, activeEls, chart) {
                        if (!activeEls || !activeEls.length) {
                            return;
                        }

                        var el = activeEls[0];
                        var datasetIndex = el.datasetIndex != null ? el.datasetIndex : 0;
                        var index = el.index;

                        var graph = ctrl.graphs.statsPie;
                        var statKey = (graph && graph.rawLabels && graph.rawLabels[index]) ? graph.rawLabels[index] : null;

                        if (!statKey) {
                            return;
                        }

                        $scope.$applyAsync(function() {
                            var ok = ctrl.toggleChartSelection('statsPie', datasetIndex, index);
                            if (!ok) {
                                return;
                            }

                            ctrl.handleChartClick('statsPie', {
                                statKey: statKey
                            });
                        });
                    }
                },
                stats_bar_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            grid: {
                                display: false
                            }
                        },
                        y: {
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            labels: {
                                generateLabels: function(chart) {
                                    var datasets = chart.data.datasets;
                                    return datasets.map(function(dataset, datasetIndex) {
                                        return {
                                            text: dataset.label || 'Dataset ' + datasetIndex,
                                            fillStyle: (function(){
                                                var c = (dataset && dataset._baseBackgroundColor != null) ? dataset._baseBackgroundColor : dataset.backgroundColor;
                                                if (Array.isArray(c)) return c[0] || dataset.borderColor || '#000000';
                                                return c || dataset.borderColor || '#000000';
                                            })(),
                                            hidden: dataset.hidden || false,
                                            index: datasetIndex,
                                            datasetIndex: datasetIndex
                                        };
                                    });
                                },
                            }
                        }
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.x) {
                            var barWidth = chart.scales.x.width / chart.data.labels.length;
                            chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                            chart.update();
                        }
                    },
                    onClick: function(evt, activeEls, chart) {
                        if (!activeEls || !activeEls.length) {
                            return;
                        }

                        var el = activeEls[0];
                        var datasetIndex = el.datasetIndex != null ? el.datasetIndex : 0;
                        var index = el.index;

                        var periodLabel = chart.data.labels[index];

                        var ds = chart.data.datasets[datasetIndex];
                        var statKey = ds.statKey;

                        $scope.$applyAsync(function() {
                            var ok = ctrl.toggleChartSelection('statsBar', datasetIndex, index);
                            if (!ok) {
                                return;
                            }

                            ctrl.handleChartClick('statsBar', {
                                statKey: statKey,
                                periodLabel: periodLabel
                            });
                        });
                    }
                },
                campaign_bar_options: {
                    indexAxis: 'y',
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            grid: {
                                display: false
                            }
                        }
                    },
                    borderRadius: 6,
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    onResize: function(chart) {
                        if (chart && chart.scales && chart.scales.y) {
                            var barWidth = chart.scales.y.height / chart.data.labels.length;
                            chart.options.borderRadius = Math.min(barWidth, 60) / 5;
                            chart.update();
                        }
                    },
                    onClick: function(evt, activeEls, chart) {
                        if (!activeEls || !activeEls.length) {
                            return;
                        }

                        var el = activeEls[0];
                        var datasetIndex = el.datasetIndex != null ? el.datasetIndex : 0;
                        var index = el.index;

                        var label = chart.data.labels[index];

                        $scope.$applyAsync(function() {
                            var ok = ctrl.toggleChartSelection('campaignBar', datasetIndex, index);
                            if (!ok) {
                                return;
                            }

                            ctrl.handleChartClick('campaignBar', {
                                label: label
                            });
                        });
                    }
                },
            };

            function getMenuColor() {
                if ($rootScope.$user && $rootScope.$user.menu_color) {
                    return $rootScope.$user.menu_color;
                }
                if ($rootScope.color_form && $rootScope.color_form.menu_color) {
                    return $rootScope.color_form.menu_color;
                }
                return '#216089';
            }

            function applyBusinessChartColors() {
                var color = getMenuColor();

                if (ctrl.graphs.income && ctrl.graphs.income.data && ctrl.graphs.income.data.datasets) {
                    if (ctrl.graphs.income.data.datasets[0]) {
                        ctrl.graphs.income.data.datasets[0].backgroundColor = color;
                    }
                    if (ctrl.graphs.income.data.datasets[1] && ctrl.graphs.income.data.datasets[1].statKey === 'forecast') {
                        ctrl.graphs.income.data.datasets[1].backgroundColor = $rootScope.createDiagonalPattern(color);
                    }
                }

                if (ctrl.graphs.campaignBar && ctrl.graphs.campaignBar.data && ctrl.graphs.campaignBar.data.datasets && ctrl.graphs.campaignBar.data.datasets[0]) {
                    var campaignBg = ctrl.graphs.campaignBar.data.datasets[0].backgroundColor;
                    if (!Array.isArray(campaignBg)) {
                        ctrl.graphs.campaignBar.data.datasets[0].backgroundColor = color;
                    }
                }

                if (ctrl.graphs.statsBar && ctrl.graphs.statsBar.data && ctrl.graphs.statsBar.data.datasets) {
                    for (var i = 0; i < ctrl.graphs.statsBar.data.datasets.length; i++) {
                        var ds = ctrl.graphs.statsBar.data.datasets[i];
                        if (ds && !ds._apiColor) {
                            ds.backgroundColor = color;
                        }
                    }
                }
            }

            function refreshGraphOptions() {
                Object.keys(ctrl.graphs || {}).forEach(function(graphID) {
                    if (ctrl.graphs[graphID] && ctrl.graphs[graphID].options) {
                        ctrl.graphs[graphID].options = angular.copy(ctrl.graphs[graphID].options);
                    }
                });
            }

            function normalizeGraphDropdownFields(graph) {
                if (!graph) {
                    return;
                }
                if (graph.category == null) {
                    graph.category = '';
                }
                if (graph.resource == null) {
                    graph.resource = '';
                }
                if (graph.resource_treated == null) {
                    graph.resource_treated = '';
                }
                if (graph.resource_booked == null) {
                    graph.resource_booked = '';
                }
                if (graph.resource_responsible == null) {
                    graph.resource_responsible = '';
                }
                if (graph.payment_method == null) {
                    graph.payment_method = '';
                }
            }

            function setGraphLoading(graphID, loading) {
                if (graphID) {
                    ctrl.graphLoading[graphID] = loading;
                    return;
                }
                Object.keys(ctrl.graphs || {}).forEach(function(id) {
                    ctrl.graphLoading[id] = loading;
                });
            }

            function buildAnalyticsState() {
                var graphIds = ['income', 'orders', 'statsPie', 'statsBar', 'campaignBar'];
                if (showCapacityGraph) {
                    graphIds.push('capacity');
                }
                var state = {};
                graphIds.forEach(function(id) {
                    state[id] = AnalyticsStorage.get(id) || null;
                });
                return state;
            }

            function buildStatsBarDatasets(statsBarData) {
                var datasetsBar = [];
                var color = getMenuColor();
                if (statsBarData && statsBarData.values) {
                    for (var key in statsBarData.values) {
                        var barColor = statsBarData.values[key].color || color;
                        datasetsBar.push({
                            label: ctrl.translateChartLabels(statsBarData.values[key].name),
                            statKey: key,
                            data: statsBarData.values[key].values,
                            backgroundColor: barColor,
                            _apiColor: !!statsBarData.values[key].color,
                            maxBarThickness: 60,
                        });
                    }
                }
                return datasetsBar;
            }

            function buildEmptyGraphs() {
                var color = getMenuColor();
                var graphs = {
                    income: {
                        category: "",
                        categories: [],
                        categoryOptions: buildCategoryOptions([]),
                        resources: [],
                        payment_methods: $payment.methods,
                        payment_method: '',
                        filter: "monthly",
                        type: 'bar',
                        options: ctrl.defaults.options,
                        title: "ניתוח הכנסות",
                        customer_filter: true,
                        widgets: [
                            {
                                icon: "fa fa-ils",
                                title: "ANALYTIC_MONTHLY_TRANSACTIONS_TOTAL",
                                data: 0,
                                bgcolor: '006495'
                            },
                            {
                                icon: "fa fa-ils",
                                title: "ANALYTIC_YEARLY_TRANSACTIONS_TOTAL",
                                data: 0,
                                bgcolor: '006495'
                            }
                        ],
                        data: {
                            labels: [],
                            datasets: [{
                                label: 'הכנסות',
                                statKey: 'income',
                                data: [],
                                backgroundColor: color,
                            }, {
                                label: $translate.instant("ANALYTIC_FORECAST"),
                                statKey: 'forecast',
                                data: [],
                                backgroundColor: $rootScope.createDiagonalPattern(color),
                            }],
                        },
                    },
                    orders: {
                        type: 'bar',
                        title: "ניתוח הזמנות",
                        category: "",
                        categories: [],
                        categoryOptions: buildCategoryOptions([]),
                        resources: [],
                        filter: "monthly",
                        options: ctrl.defaults.opacity_graph_options,
                        customer_filter: true,
                        widgets: [
                            {
                                icon: "fa fa-user",
                                title: "ANALYTIC_MONTHLY_ORDERS_TOTAL",
                                data: 0,
                                bgcolor: '3c9933'
                            },
                            {
                                icon: "fa fa-user",
                                title: "ANALYTIC_YEARLY_ORDERS_TOTAL",
                                data: 0,
                                bgcolor: '3c9933'
                            }
                        ],
                        data: {
                            labels: [],
                            datasets: [{
                                label: 'הכנסות',
                                statKey: 'orders',
                                data: [],
                                backgroundColor: "#3c9933",
                            }],
                        },
                    },
                    statsPie: {
                        title: $translate.instant("CUSTOMERS_STATSPIE"),
                        type: "doughnut",
                        height: ctrl.isMobile ? 200 : 500,
                        start: moment().subtract(1, 'months'),
                        end: moment(),
                        rawLabels: [],
                        data: {
                            labels: [],
                            datasets: [{
                                label: '',
                                data: [],
                                backgroundColor: [],
                            }],
                        },
                        options: ctrl.defaults.stats_pie_options,
                        stats_type: 'leads',
                    },
                    statsBar: {
                        title: $translate.instant("CUSTOMERS_STATSBAR"),
                        type: "bar",
                        filter: "monthly",
                        start: moment().subtract(1, 'years'),
                        end: moment(),
                        data: {
                            labels: [],
                            datasets: [],
                        },
                        options: ctrl.defaults.stats_bar_options,
                        stats_type: 'leads',
                    },
                    campaignBar: {
                        title: $translate.instant("CAMPAIGN_BAR"),
                        type: "bar",
                        customer_filter: false,
                        start: moment().startOf('month'),
                        end: moment().endOf('month'),
                        campaign_type: 'campaigns',
                        campaign_metric: 'leads',
                        campaign_filter: 'this_month',
                        height: ctrl.isMobile ? 300 : 400,
                        data: {
                            labels: [],
                            datasets: [{
                                label: '',
                                data: [],
                                backgroundColor: color,
                                maxBarThickness: 60,
                            }],
                        },
                        options: ctrl.defaults.campaign_bar_options,
                    },
                };

                if (showCapacityGraph) {
                    graphs.capacity = {
                        title: "ניתוח תפוסה",
                        widgets: [
                            {
                                icon: "fa fa-bed",
                                title: "ANALYTIC_MONTHLY_OCCUPANCY_TOTAL",
                                data: "0%",
                                bgcolor: '663399'
                            },
                            {
                                icon: "fa fa-bed",
                                title: "ANALYTIC_YEARLY_OCCUPANCY_TOTAL",
                                data: "0%",
                                bgcolor: '663399'
                            }
                        ],
                        data: [[]],
                        labels: [],
                        filter: "monthly",
                        options: ctrl.defaults.opacity_graph_options,
                        hover: ctrl.defaults.hover,
                        colors: ['#663399'],
                        series: ["תפוסה"]
                    };
                }

                return graphs;
            }

            function applyAllAnalyticsData(response) {
                var data = response && response.data ? response.data : null;
                if (!data) {
                    return;
                }

                var categories = data.categories || [];
                var resources = data.resources || [];
                var income = data.income || {};
                var incomeWidget = income.widget || {};
                var orders = data.orders || {};
                var ordersWidget = orders.widget || {};
                var statsPieData = data.statsPie || null;
                var statsBarData = data.statsBar || null;
                var campaignBarData = data.campaignBar || null;
                var capacity = data.capacity || null;
                var capacityWidget = capacity && capacity.widget ? capacity.widget : null;

                if (ctrl.graphs.income) {
                    ctrl.graphs.income.categories = categories;
                    ctrl.graphs.income.categoryOptions = buildCategoryOptions(categories);
                    ctrl.graphs.income.resources = resources;
                    ctrl.graphs.income.widgets[0].data = incomeWidget.monthly != null ? incomeWidget.monthly : 0;
                    ctrl.graphs.income.widgets[1].data = incomeWidget.yearly != null ? incomeWidget.yearly : 0;
                    ctrl.graphs.income.data.labels = income.labels || [];
                    ctrl.graphs.income.data.datasets[0].data = income.values || [];
                    ctrl.graphs.income.data.datasets[1].data = income.forecast || [];
                }

                if (ctrl.graphs.orders) {
                    ctrl.graphs.orders.categories = categories;
                    ctrl.graphs.orders.categoryOptions = buildCategoryOptions(categories);
                    ctrl.graphs.orders.resources = resources;
                    ctrl.graphs.orders.widgets[0].data = ordersWidget.monthly != null ? ordersWidget.monthly : 0;
                    ctrl.graphs.orders.widgets[1].data = ordersWidget.yearly != null ? ordersWidget.yearly : 0;
                    ctrl.graphs.orders.data.labels = orders.labels || [];
                    ctrl.graphs.orders.data.datasets[0].data = orders.values || [];
                }

                if (ctrl.graphs.statsPie) {
                    ctrl.graphs.statsPie.rawLabels = statsPieData && statsPieData.ids
                        ? statsPieData.ids
                        : (statsPieData && statsPieData.labels ? statsPieData.labels : []);
                    ctrl.graphs.statsPie.data.labels = statsPieData && statsPieData.labels
                        ? ctrl.translateChartLabels(statsPieData.labels)
                        : [];
                    ctrl.graphs.statsPie.data.datasets[0].data = statsPieData && statsPieData.values ? statsPieData.values : [];
                    ctrl.graphs.statsPie.data.datasets[0].backgroundColor = statsPieData && statsPieData.colors ? statsPieData.colors : [];
                }

                if (ctrl.graphs.statsBar) {
                    ctrl.graphs.statsBar.data.labels = statsBarData && statsBarData.periods ? statsBarData.periods : [];
                    ctrl.graphs.statsBar.data.datasets = buildStatsBarDatasets(statsBarData);
                }

                if (ctrl.graphs.campaignBar) {
                    ctrl.graphs.campaignBar.data.labels = campaignBarData && campaignBarData.labels ? campaignBarData.labels : [];
                    ctrl.graphs.campaignBar.data.datasets[0].data = campaignBarData && campaignBarData.values ? campaignBarData.values : [];
                    if (campaignBarData && campaignBarData.colors) {
                        ctrl.graphs.campaignBar.data.datasets[0].backgroundColor = Array.isArray(campaignBarData.colors)
                            ? campaignBarData.colors
                            : (campaignBarData.colors || getMenuColor());
                    } else {
                        ctrl.graphs.campaignBar.data.datasets[0].backgroundColor = getMenuColor();
                    }
                }

                applyBusinessChartColors();

                if (ctrl.graphs.capacity && capacity) {
                    ctrl.graphs.capacity.widgets[0].data = capacityWidget && capacityWidget.monthly != null
                        ? capacityWidget.monthly + "%"
                        : "0%";
                    ctrl.graphs.capacity.widgets[1].data = capacityWidget && capacityWidget.yearly != null
                        ? capacityWidget.yearly + "%"
                        : "0%";
                    ctrl.graphs.capacity.data = [capacity.values || []];
                    ctrl.graphs.capacity.labels = capacity.labels || [];
                }

                refreshGraphOptions();
            }

            ctrl.graphs = buildEmptyGraphs();
            setGraphLoading(null, true);

            ctrl.filter = {};
            Object.keys(ctrl.graphs).forEach(function (graphID) {
                ctrl.filter[graphID] = AnalyticsStorage.defaultFilter();
            });

            AnalyticsStorage.registerDefaults(ctrl.graphs, ctrl.filter, Object.keys(ctrl.graphs));

            Object.keys(ctrl.graphs).forEach(function (graphID) {
                AnalyticsStorage.applyStoredOrDefault(graphID, ctrl.graphs, ctrl.filter);
                normalizeGraphDropdownFields(ctrl.graphs[graphID]);
            });

            AnalyticsStorage.watch($scope, ctrl.graphs, ctrl.filter, Object.keys(ctrl.graphs));

            var pageAnalyticsLoaded = false;

            ctrl.loadPageAnalytics = function() {
                applyBusinessChartColors();
                setGraphLoading(null, true);
                $api.analytics.get({
                    type: 'all',
                    state: buildAnalyticsState()
                }, function(response) {
                    applyAllAnalyticsData(response);
                    setGraphLoading(null, false);
                }, function() {
                    setGraphLoading(null, false);
                });
            };

            function startPageAnalyticsOnce() {
                if (pageAnalyticsLoaded) {
                    applyBusinessChartColors();
                    refreshGraphOptions();
                    return;
                }
                pageAnalyticsLoaded = true;
                ctrl.loadPageAnalytics();
            }

            if ($rootScope.$user) {
                $timeout(startPageAnalyticsOnce, 0);
            } else {
                var unwatchUser = $scope.$watch(function() {
                    return $rootScope.$user;
                }, function(user) {
                    if (user) {
                        unwatchUser();
                        startPageAnalyticsOnce();
                    }
                });
            }

            $scope.$watch(function() {
                return ($rootScope.$user && $rootScope.$user.menu_color) ||
                    ($rootScope.color_form && $rootScope.color_form.menu_color);
            }, function(newColor, oldColor) {
                if (!newColor || newColor === oldColor) {
                    return;
                }
                applyBusinessChartColors();
                refreshGraphOptions();
            });

            ctrl.prepare_graph_labels = function(graph) {

                ctrl.graphs[graph].labels = [];

                switch(ctrl.graphs[graph].filter) {

                    case "monthly":

                        var
                            date = new Date(),
                            month = date.getMonth() + 1,
                            monthString = month;

                        if(month < 10)
                            monthString = "0" + month;

                        for(var i = 1; i <= date.getDate(); i++) {

                            var dayString = i;

                            if(i < 10)
                                dayString = "0" + i;

                            ctrl.graphs[graph].labels.push(dayString + "/" + monthString);
                            ctrl.graphs[graph].data[0].push(Math.floor((Math.random() * 1000000) + 1));
                        }

                        break;
                    case "daily":
                        break;
                    case "year":
                        break;
                }
            };

            ctrl.customersByGraph = {};

            ctrl.customersDt = {};

            // Customer table column definitions - store original column definitions for lookup
            var originalColumnDefinitions = {
                'name': {
                    name: 'name', data: null, title: $translate('CUSTOMERS_NAME'), class: 'size-125',
                    render: function(data, type, full, meta) {
                        var avatarURL = data.avatar ? data.avatar : 'assets/images/avatar.jpg';
                        var html = '<div class="customer-pic-wrapper"><img src="' + avatarURL + '" alt="User Profile" class="customer-pic"></div>';
                        html += '<b>';
                        html += data.firstname ? ' ' + $utils.escapeHtml(data.firstname) : '';
                        html += data.lastname ? ' ' + $utils.escapeHtml(data.lastname) : '';
                        html += '</b>';
                        html += data.wa_stop ? ' <span class="have-tooltip" tooltip="'+$translate.instant('CUSTOMERS_STOP_WA')+'"><i class="las la-hand-paper color-red"></i></span>' : '';
                        return '<div class="flex nowrap">'+html+'</div>';
                    }
                },
                'last_visit': {
                    name: 'last_visit', data: null, title: $translate('CUSTOMERS_LAST_VISIT'), class: 'customer-name',
                    render: function (data, type, full, meta) {
                        var add_details = '<span ng-hide="\''+ data['last_visit'] +'\' ==\'01/01/1970\'">'+ (data['last_visit'] ? data['last_visit'] : '') +'</span>';
                        
                        add_details += '<div class="customers_add_details icons mobile">';

                        if (data.oncredit > 0) {
                            add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
                        }
                        if (data.has_cards) {
                            add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
                        }
                        if ((data.has_color)) {
                            add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
                        }
                        
                        add_details += '</div>';

                        return add_details;
                    }
                },
                'desktop_icons': {
                    name: 'desktop_icons', data: null, title: '', orderable: false, class: 'desktop-icons-column',
                    render: function (data, type, full, meta) {
                        var add_details = '<div class="customers_add_details icons desktop">';

                        if (data.oncredit > 0) {
                            add_details += '<i class="las la-dollar-sign customers-debt-icon" aria-hidden="true"></i>';
                        }
                        if (data.has_cards) {
                            add_details += '<i class="las la-ticket-alt customers-has-chards" aria-hidden="true"></i>';
                        }
                        if ((data.has_color)) {
                            add_details += '<i class="las la-tint customers-has-coloring" aria-hidden="true"></i>';
                        }

                        add_details += '</div>';

                        return add_details;
                    }
                },
                'icons': {
                    name: 'icons', sortable: false, data: null, title: '', class: 'customer-icons',
                    render: function (data, type, full, meta) {
                        var add_details = '';
                        add_details += '<div class="customers_call_details icons" style="'+(((data.oncredit > 0 || data.has_cards || data.has_color) && window.innerWidth < 768) ? 'margin-top: 22px;' : '')+'">';

                        if (data.phone) {
                            var phone = data.phone;
                            var mas = [' ', '-', '_', '(', ')', '+972', '+'];
                            for (var s in mas) {
                                phone = phone.replace(mas[s], '');
                            }
                            phone = '+972'+phone;

                            add_details += window.innerWidth >= 768 ? '<a class="btn icon circle small bordered green" href="/cashbox?customer='+data.id+'"><i class="las la-hand-holding-usd"></i></a>' : '';
                            add_details += '<a class="btn icon circle small bordered blue" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'tel:'+data.phone : 'javascript:;')+'" ><i class="las la-phone"></i></a>';
                            var user = $rootScope.$user;
                            var hasClick2Call = user && user.telephony_agent_id && user.telephony_token;
                            if (hasClick2Call && data.phone) {
                                var customerNumber = (data.phone || '').replace(/\D/g, '');
                                if (customerNumber) {
                                    var safeNum = customerNumber.replace(/'/g, "\\'");
                                    add_details += '<a class="btn icon circle small bordered blue" href="javascript:void(0)" ng-click="d(); $event.stopPropagation(); $event.preventDefault(); ctrl.click2Call(\'' + safeNum + '\')" title="'+$translate.instant('TELEPHONY_CLICK_TO_CALL')+'"><i class="las la-phone-volume"></i></a>';
                                }
                            }
                            add_details += '<a class="btn icon circle small bordered green" ng-click="d(); $event.stopPropagation();" target="_blank" href="'+(data.phone != '' ? 'https://wa.me/'+phone : 'javascript:;')+'"><i class="lab la-whatsapp"></i></a>';
                        }

                        add_details += '</div>';

                        return add_details;
                    }
                },
                'gender': {
                    name: 'gender', data: null, title: $translate('CUSTOMERS_GENDER'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        switch (data.gender) {
                            case 0:
                                return $translate.instant('CUSTOMERS_GENDER_MALE');
                            case 1:
                                return $translate.instant('CUSTOMERS_GENDER_FEMALE');
                            default:
                                return $translate.instant('CUSTOMERS_GENDER_NOT_SET');
                        }
                    }
                },
                'send_notifications': {
                    name: 'send_notifications', data: null, title: $translate('SETTINGS_USER_SEND_MESSAGES'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        switch (data.send_notifications) {
                            case 0:
                                return $translate.instant('SETTINGS_USER_REMINDER_NO');
                            case 1:
                                return $translate.instant('CUSTOMER_SETTING_EMAIL');
                            case 2:
                                return $translate.instant('CUSTOMERS_SMS');
                            case 3:
                                return $translate.instant('CUSTOMERS_WHATSAPP');
                            default:
                                return '';
                        }
                    }
                },
                'send_reminder': {
                    name: 'send_reminder', data: null, title: $translate('SETTINGS_USER_SEND_REMINDER'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        switch (data.send_reminder) {
                            case 0:
                                return $translate.instant('SETTINGS_USER_REMINDER_NO');
                            case 2:
                                return $translate.instant('SETTINGS_USER_REMINDER_2_HOURS');
                            case 4:
                                return $translate.instant('SETTINGS_USER_REMINDER_4_HOURS');
                            case 24:
                                return $translate.instant('SETTINGS_USER_REMINDER_24_HOURS');
                            case 48:
                                return $translate.instant('SETTINGS_USER_REMINDER_48_HOURS');
                            case 72:
                                return $translate.instant('SETTINGS_USER_REMINDER_72_HOURS');
                            case 168:
                                return $translate.instant('SETTINGS_USER_REMINDER_168_HOURS');
                            default:
                                return '';
                        }
                    }
                },
                'reminder_send_type': {
                    name: 'reminder_send_type', data: null, title: $translate('CUSTOMERS_SEND_REMINDER'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        switch (data.reminder_send_type) {
                            case 1:
                                return $translate.instant('SETTINGS_USER_MAIL');
                            case 2:
                                return $translate.instant('CUSTOMERS_SMS');
                            case 3:
                                return $translate.instant('CUSTOMERS_WHATSAPP');
                            default:
                                return '';
                        }
                    }
                },
                'request_order_confirmation': {
                    name: 'request_order_confirmation', data: null, title: $translate('SETTINGS_USER_SEND_ORDER_CONFIRMATION'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        return data.request_order_confirmation == 0 ? $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO') : $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES');
                    }
                },
                'send_documents': {
                    name: 'send_documents', data: null, title: $translate('CUSTOMERS_SEND_DOCUMENTS'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        switch (data.send_documents) {
                            case 0:
                                return $translate.instant('SETTINGS_USER_REMINDER_NO');
                            case 1:
                                return $translate.instant('CUSTOMER_SETTING_EMAIL');
                            case 2:
                                return $translate.instant('CUSTOMERS_SMS');
                            case 3:
                                return $translate.instant('CUSTOMERS_WHATSAPP');
                            case 4:
                                return $translate.instant('CUSTOMERS_PRINT');
                            default:
                                return '';
                        }
                    }
                },
                'self_order': {
                    name: 'self_order', data: null, title: $translate('CUSTOMERS_IND_ORD'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        return data.self_order == 0 ? $translate.instant('CUSTOMERS_UNAUTHORIZED') : $translate.instant('CUSTOMERS_ALLOWED');
                    }
                },
                'group_notifications': {
                    name: 'group_notifications', data: null, title: $translate('CUSTOMERS_GROUP_MESS'), hide: true, sortable: false,
                    render: function(data, type, full, meta) {
                        return data.group_notifications == 0 ? $translate.instant('CUSTOMERS_OFF') : $translate.instant('CUSTOMERS_ACTIVE');
                    }
                },
                'last_note': {
                    name: 'last_note', data: null, title: $translate('CUSTOMERS_LAST_NOTE'), hide: true, sortable: false, class: 'last-note-column',
                    render: function(data, type, full, meta) {
                        return data.last_note ? data.last_note : '';
                    }
                },
                'last_note_remind_at': {
                    name: 'last_note_remind_at', data: null, title: $translate('CUSTOMERS_LAST_NOTE_REMIND_AT'), hide: true, sortable: false, class: 'last-note-remind-at-column',
                    render: function(data, type, full, meta) {
                        if (!data.last_note_remind_at) {
                            return '';
                        }
                        try {
                            var remindDate = moment(data.last_note_remind_at);
                            if (remindDate.isValid()) {
                                return remindDate.format('DD/MM/YYYY HH:mm');
                            }
                        } catch (e) {
                            // Fall through to default handling
                        }
                        return data.last_note_remind_at;
                    }
                },
                'statuses_name': {
                    name: 'statuses_name', data: null, title: $translate('CUSTOMERS_STATUS'), class: 'customer-status',
                    render: function(data, type, full, meta) {
                        $scope.customerStatuses[data.id] = String(data.status_id || '');
                        return '<div class="form-group form-list prevent-click">'
                            +'<app-dropdown model="customerStatuses[' + data.id + ']"'
                              +' options="ctrl.statusOptions"'
                              +' value-prop="id"'
                              +' label-prop="name"'
                              +' color-prop="color"'
                              +' fixed-panel="true"'
                              +' placeholder="{{\'CUSTOMERS_STATUS\' | translate}}"'
                              +' on-change="ctrl.updateData(' + data.id + ', {status_id: model})">'
                            +'</app-dropdown></div>';
                    }
                }
            };

            function createSimpleColumn(name, translationKey, fieldType, customFieldId) {
                // For custom fields, translationKey is the actual field name, not a translation key
                // For regular fields, translationKey is a translation key that needs to be translated
                var isCustomField = name && name.indexOf('custom_field_') === 0;
                var title = isCustomField ? translationKey : $translate(translationKey);
                
                return {
                    name: name,
                    data: null,
                    title: title,
                    sortable: false,
                    class: 'default-custom-column',
                    render: function(data, type, full, meta) {
                        if (!data || !data[name]) {
                            return '';
                        }
                        
                        var value = data[name];
                        
                        // Handle custom field types
                        if (fieldType === 'date' && value) {
                            try {
                                // Handle ISO date strings or timestamps
                                var dateValue = moment(value);
                                if (dateValue.isValid()) {
                                    return dateValue.format('DD/MM/YYYY');
                                }
                            } catch (e) {
                                // Fall through to default handling
                            }
                        } else if (fieldType === 'datetime' && value) {
                            try {
                                var dateTimeValue = moment(value);
                                if (dateTimeValue.isValid()) {
                                    return dateTimeValue.format('DD/MM/YYYY HH:mm');
                                }
                            } catch (e) {
                                // Fall through to default handling
                            }
                        }
                        
                        // For text and list types, or if date formatting failed, return escaped string
                        return $utils.escapeHtml(String(value));
                    }
                };
            }

            function updateDtColumns(graphID) {
                var newColumns = [];
                
                if (ctrl.fieldSettings && ctrl.fieldSettings.length > 0) {
                    for (var i = 0; i < ctrl.fieldSettings.length; i++) {
                        var field = ctrl.fieldSettings[i];
                        
                        if (field.display) {
                            if (originalColumnDefinitions[field.name] || field.name === 'buttons') {
                                if (field.name === 'buttons') {
                                    newColumns.push(originalColumnDefinitions['desktop_icons']);
                                    newColumns.push(originalColumnDefinitions['icons']);
                                } else {
                                    newColumns.push(originalColumnDefinitions[field.name]);
                                }
                            } else {
                                // Pass field type and custom_field_id for custom fields
                                var fieldType = field.type || null;
                                var customFieldId = field.custom_field_id || null;
                                newColumns.push(createSimpleColumn(field.name, field.translationKey || field.name, fieldType, customFieldId));
                            }
                        }
                    }
                } else {
                    // Default columns when no field settings
                    for (var key in originalColumnDefinitions) {
                        if (originalColumnDefinitions[key].hide) continue;
                        newColumns.push(originalColumnDefinitions[key]);
                    }
                }

                return newColumns;
            }

            function ensureCustomersDt(graphID) {
                if (ctrl.customersDt[graphID]) {
                    return ctrl.customersDt[graphID];
                }

                ctrl.customersDt[graphID] = {
                    instance: {},
                    entriesPerPage: "20",
                    options: null,
                    columns: null,
                    refreshing: false
                };

                // Build columns based on field settings
                ctrl.customersDt[graphID].columns = updateDtColumns(graphID);

                ctrl.customersDt[graphID].options =
                    DTOptionsBuilder.newOptions().withDOM('Tfgtip')
                        .withLanguage(dataTablesHebrewProvider)
                        .withOption('pageLength', parseInt(ctrl.customersDt[graphID].entriesPerPage, 10) || 20)
                        .withOption('aaSorting', [])
                        .withOption('searching', false)
                        .withOption('serverSide', true)
                        .withOption('processing', false)
                        .withDataProp('data')
                        .withOption('ajax', function (dtData, callback) {
                            ctrl.loadAnalyticsCustomersForDt(graphID, dtData, callback);
                        })
                        .withOption('rowCallback', function (nRow, aData) {
                            $(nRow).unbind('click').bind('click', function (event) {
                                if ($(event.target).closest('select, .prevent-click, a, button').length) {
                                    event.stopPropagation();
                                } else {
                                    $scope.$apply(function () {
                                        if (aData && aData.id) {
                                            try {
                                                sessionStorage.setItem('backTarget', JSON.stringify({
                                                    name: 'app.analytics',
                                                    params: {}
                                                }));
                                            } catch (e) {}
                                            $state.transitionTo("app.customers.single", { id: aData.id }, { reload: false });
                                        }
                                    });
                                }
                            });
                            return nRow;
                        })
                        .withOption('initComplete', function () {
                            var tableId = 'analytics_cust_dt_' + graphID;
                            var containerId = 'analytics-custom-pagination-container-' + graphID;

                            $('#' + containerId).find('#' + tableId + '_info').remove();
                            $('#' + containerId).find('#' + tableId + '_paginate').remove();

                            $('#' + tableId + '_info').prependTo('#' + containerId);
                            $('#' + tableId + '_paginate').prependTo('#' + containerId);
                        })
                        .withOption('createdRow', function (row) {
                            $compile(angular.element(row).contents())($scope);
                        });

                return ctrl.customersDt[graphID];
            }

            ctrl.isSameSelection = function(graphID, datasetIndex, index) {
                var sel = ctrl.selectedPoint && ctrl.selectedPoint[graphID];
                if (!sel) {
                    return false;
                }

                return (sel.index === index) && (sel.datasetIndex === datasetIndex || sel.datasetIndex == null);
            };

            ctrl.toggleChartSelection = function(graphID, datasetIndex, index) {
                if (ctrl.isSameSelection(graphID, datasetIndex, index)) {
                    ctrl.clearChartSelection(graphID);
                    return false;
                }

                ctrl.selectedPoint[graphID] = { datasetIndex: datasetIndex, index: index };
                ctrl.persistSelectedPoint(graphID);
                ctrl.applyChartSelectionStyle(graphID);
                return true; // means: selection set
            };

            ctrl.clearChartSelection = function(graphID, opts) {
                opts = opts || {};

                delete ctrl.selectedPoint[graphID];
                ctrl.persistSelectedPoint(graphID);
                ctrl.applyChartSelectionStyle(graphID);

                try {
                    AnalyticsStorage.clearCustomersState(graphID);
                } catch (e) {}

                if (ctrl.customersByGraph && ctrl.customersByGraph[graphID]) {
                    ctrl.customersByGraph[graphID].request = null;
                    ctrl.customersByGraph[graphID].customer_ids = [];
                    ctrl.customersByGraph[graphID].pagination = null;
                    ctrl.customersByGraph[graphID].items = [];
                    ctrl.customersByGraph[graphID].loading = false;
                    ctrl.customersByGraph[graphID].error = null;
                }

                $timeout(function() {
                    var tableSel = '#analytics_cust_dt_' + graphID;

                    try {
                        if ($.fn.DataTable && $.fn.DataTable.isDataTable(tableSel)) {
                            var dt = $(tableSel).DataTable();
                            dt.destroy(true);
                        }
                    } catch (e) {}

                    try {
                        var tableId = 'analytics_cust_dt_' + graphID;
                        var containerId = '#analytics-custom-pagination-container-' + graphID;

                        $(containerId).find('#' + tableId + '_info').remove();
                        $(containerId).find('#' + tableId + '_paginate').remove();
                    } catch (e) {}
                }, 0);

                if (opts.resetPerPage && ctrl.customersDt && ctrl.customersDt[graphID]) {
                    ctrl.customersDt[graphID].entriesPerPage = "20";
                }
            };

            ctrl.loadAnalyticsCustomersForDt = function(graphID, dtData, callback) {
                if (!ctrl.customersByGraph[graphID] || !ctrl.customersByGraph[graphID].request) {
                    callback({ recordsTotal: 0, recordsFiltered: 0, data: [], draw: dtData.draw });
                    return;
                }

                var perPage = dtData.length || 20;
                var start = dtData.start || 0;
                var page = Math.floor(start / perPage) + 1;

                var req = angular.copy(ctrl.customersByGraph[graphID].request);
                req.page = page;
                req.per_page = perPage;

                callback({ recordsTotal: 0, recordsFiltered: 0, data: [], draw: dtData.draw });

                ctrl.customersByGraph[graphID].loading = true;

                $api.analytics.customers.get(req, function(res) {
                    $timeout(function() {
                        ctrl.customersByGraph[graphID].loading = false;
                    }, 500);

                    var items = [];
                    var total = 0;

                    if (res && res.data && Array.isArray(res.data.items)) {
                        items = res.data.items.filter(function(x){
                            return x && x.id != null;
                        });
                    }

                    if (res && res.data && res.data.total != null) {
                        total = parseInt(res.data.total, 10) || 0;
                    } else {
                        total = items.length;
                    }

                    callback({
                        recordsTotal: total,
                        recordsFiltered: total,
                        data: items,
                        draw: dtData.draw
                    });
                }, function() {
                    ctrl.customersByGraph[graphID].loading = false;
                    callback({ recordsTotal: 0, recordsFiltered: 0, data: [], draw: dtData.draw });
                });
            };

            ctrl.reinitCustomersDt = function(graphID) {
                ensureCustomersDt(graphID);

                ctrl.customersDt[graphID].options = ctrl.customersDt[graphID].options
                    .withOption('pageLength', parseInt(ctrl.customersDt[graphID].entriesPerPage, 10) || 20);

                $timeout(function() {
                    var tableSel = '#analytics_cust_dt_' + graphID;
                    if ($.fn.DataTable && $.fn.DataTable.isDataTable(tableSel)) {
                        $(tableSel).DataTable().page.len(parseInt(ctrl.customersDt[graphID].entriesPerPage, 10) || 20);
                        $(tableSel).DataTable().ajax.reload();
                    }
                }, 0);
            };

            ctrl.loadAnalytics = function(dataType, filter) {
                if (!ctrl.graphs[dataType]) {
                    return;
                }

                ctrl.clearChartSelection(dataType);
                setGraphLoading(dataType, true);

                if(filter) {
                    ctrl.graphs[dataType].filter = filter;
                }
                // build request body
                var request = {
                    filter: ctrl.graphs[dataType].filter,
                    type: dataType,
                    filter_values: AnalyticsStorage.normalizeFilter(ctrl.filter[dataType] || {}),
                    period: ctrl.graphs[dataType].filter,
                    start: ctrl.graphs[dataType].start ? formatDateTimeForApi(ctrl.graphs[dataType].start, 'start') : null,
                    end: ctrl.graphs[dataType].end ? formatDateTimeForApi(ctrl.graphs[dataType].end, 'end') : null,
                    stats_type: ctrl.graphs[dataType].stats_type || 'leads',
                    campaign_type: ctrl.graphs[dataType].campaign_type || 'campaigns',
                    campaign_metric: ctrl.graphs[dataType].campaign_metric || 'leads',
                }

                request.filter_values.created_from = formatDateToYMD(request.filter_values.created_from);
                request.filter_values.created_to = formatDateToYMD(request.filter_values.created_to);
                request.filter_values.lastvisit_from = formatDateToYMD(request.filter_values.lastvisit_from);
                request.filter_values.lastvisit_to = formatDateToYMD(request.filter_values.lastvisit_to);
                request.filter_values.visited_from = formatDateToYMD(request.filter_values.visited_from);
                request.filter_values.visited_to = formatDateToYMD(request.filter_values.visited_to);


                if(ctrl.graphs[dataType].category && ctrl.graphs[dataType].category != '') {
                    request.category = ctrl.graphs[dataType].category;
                }
                if(ctrl.graphs[dataType].resource && ctrl.graphs[dataType].resource != '') {
                    request.resource = ctrl.graphs[dataType].resource;
                }
                if(ctrl.graphs[dataType].resource_booked && ctrl.graphs[dataType].resource_booked != '') {
                    request.resource_booked = ctrl.graphs[dataType].resource_booked;
                }
                if(ctrl.graphs[dataType].resource_responsible && ctrl.graphs[dataType].resource_responsible != '') {
                    request.resource_responsible = ctrl.graphs[dataType].resource_responsible;
                }
                if(ctrl.graphs[dataType].resource_treated && ctrl.graphs[dataType].resource_treated != '') {
                    request.resource_treated = ctrl.graphs[dataType].resource_treated;
                }
                if(ctrl.graphs[dataType].payment_method && ctrl.graphs[dataType].payment_method != '') {
                    request.payment_method = ctrl.graphs[dataType].payment_method;
                }
                
                $api.analytics.get(request,
                    function(response) {
                        if (dataType == 'statsPie') {
                            ctrl.graphs[dataType].rawLabels = (response.data.statsPie && response.data.statsPie.ids)
                                ? response.data.statsPie.ids
                                : (response.data.statsPie ? response.data.statsPie.labels : []);
                            ctrl.graphs[dataType].data.labels = ctrl.translateChartLabels(response.data.statsPie.labels);
                            ctrl.graphs[dataType].data.datasets[0].data = response.data.statsPie.values;
                            ctrl.graphs[dataType].data.datasets[0].backgroundColor = response.data.statsPie.colors;
                        } else if (dataType == 'statsBar') {
                            ctrl.graphs[dataType].data.labels = response.data.statsBar.periods;
                            ctrl.graphs[dataType].data.datasets = buildStatsBarDatasets(response.data.statsBar);

                        } else if (dataType == 'campaignBar') {
                            var chartColor = getMenuColor();
                            if (response.data.campaignBar && response.data.campaignBar.labels && response.data.campaignBar.values) {
                                ctrl.graphs[dataType].data.labels = response.data.campaignBar.labels;
                                ctrl.graphs[dataType].data.datasets[0].data = response.data.campaignBar.values;
                                if (Array.isArray(response.data.campaignBar.colors)) {
                                    ctrl.graphs[dataType].data.datasets[0].backgroundColor = response.data.campaignBar.colors;
                                } else {
                                    ctrl.graphs[dataType].data.datasets[0].backgroundColor = response.data.campaignBar.colors || chartColor;
                                }
                            } else {
                                ctrl.graphs[dataType].data.labels = [];
                                ctrl.graphs[dataType].data.datasets[0].data = [];
                                ctrl.graphs[dataType].data.datasets[0].backgroundColor = chartColor;
                            }

                        } else {
                            ctrl.graphs[dataType].data.labels = response.data[dataType].labels;
                            ctrl.graphs[dataType].data.datasets[0].data = response.data[dataType].values;

                            if (response.data[dataType].forecast) {   
                                ctrl.graphs[dataType].data.datasets[1].data = response.data[dataType].forecast;
                            }
                        }

                        applyBusinessChartColors();
                        ctrl.graphs[dataType].options = angular.copy(ctrl.graphs[dataType].options);

                        $timeout(function() {
                            ctrl.applyChartSelectionStyle(dataType);
                        }, 0);
                        setGraphLoading(dataType, false);
                    }, function() {
                        setGraphLoading(dataType, false);
                    });
            };

            $header.title = "ניתוחים עסקיים";
            $header.breadcrumbs.push({
                "title": "NAV_ANALYTIC"
            });



            function ensureArray(v) {
                return Array.isArray(v) ? v : (v ? [v] : []);
            }

            function pickByIds(list, ids) {
                list = ensureArray(list);
                ids = ensureArray(ids);

                if (!ids.length || !list.length) {
                    return [];
                }

                if (typeof ids[0] === 'object') {
                    return ids;
                }

                return list.filter(function (x) {
                    return ids.some(function (id) {
                        return x && x.id != null && x.id == id;
                    });
                });
            }

            function buildMonthOptions(months) {
                var options = [];
                months = ensureArray(months);

                for (var i = 0; i < months.length; i++) {
                    options.push({
                        month: String(i),
                        value: months[i]
                    });
                }

                return options;
            }

            function pickMonthsByValues(monthsMap, values) {
                values = ensureArray(values);
                if (!values.length) {
                    return [];
                }

                if (typeof values[0] === 'object') {
                    return values;
                }

                var months = [];
                if (Array.isArray(monthsMap)) {
                    months = monthsMap;
                } else if (monthsMap && typeof monthsMap === 'object') {
                    Object.keys(monthsMap).forEach(function (k) {
                        months.push(monthsMap[k]);
                    });
                }

                return months.filter(function (m) {
                    return values.some(function (v) {
                        return m && m.value != null && m.value == v;
                    });
                });
            }

            ctrl.rehydrateFilters = function () {
                if (!ctrl.filter_values) {
                    return;
                }

                Object.keys(ctrl.graphs || {}).forEach(function (graphID) {
                    var f = ctrl.filter[graphID];
                    if (!f) {
                        return;
                    }

                    f.item = pickByIds(ctrl.filter_values.items, f.item);
                    f.category = pickByIds(ctrl.filter_values.categories, f.category);
                    f.resource = pickByIds(ctrl.filter_values.resources, f.resource);
                    f.arrival_source = pickByIds(ctrl.filter_values.arrival_sources, f.arrival_source);
                    f.status = pickByIds(ctrl.filter_values.statuses, f.status);

                    f.birthday = pickMonthsByValues(ctrl.birthdayOptions, f.birthday);

                    ctrl.filter[graphID] = f;
                });
            };

            ctrl.getFilterValues = function () {
                $api.customers.filter.get({}, function (result) {
                    if (result && result.data) {
                        ctrl.filter_values = result.data;
                        ctrl.rehydrateFilters();
                    }

                    ctrl.restoreCustomersAll();
                });
            }
    
            ctrl.getFilterValues();

            ctrl.filterModal = {};

            ctrl.openFilter = function(graphID) {
                if (!ctrl.filterModal[graphID]) {
                    $timeout(function() {
                    ctrl.filterModal[graphID] = true;
                    $('#page-wrapper').addClass('with-filter');
                    });
                }
            }

            ctrl.closeFilter = function(graphID) {
                if (ctrl.filterModal[graphID]) {
                    ctrl.filterModal[graphID] = false;
                    $('#page-wrapper').removeClass('with-filter');
                }
            }

            ctrl.applyFilter = function(graphID) {
                ctrl.clearChartSelection(graphID);

                ctrl.loadAnalytics(graphID);
                ctrl.closeFilter(graphID);
            }

            ctrl.isFilterDirty = function(graphID) {
                return AnalyticsStorage.isDirty(graphID, ctrl.graphs, ctrl.filter);
            };

            ctrl.clearFilter = function(graphID) {
                AnalyticsStorage.reset(graphID, ctrl.graphs, ctrl.filter);

                ctrl.clearChartSelection(graphID);

                ctrl.loadAnalytics(graphID);
                ctrl.closeFilter(graphID);

                if (ctrl.resourceFilterModal && ctrl.resourceFilterModal[graphID]) {
                    ctrl.resourceFilterModal[graphID] = false;
                }
            };

            ctrl.resourceFilterModal = {};

            ctrl.openResourceFilter = function(graphID) {
                if (!ctrl.resourceFilterModal[graphID]) {
                    $timeout(function() {
                        ctrl.resourceFilterModal[graphID] = true;
                    });
                }
            }

            ctrl.closeResourceFilter = function(graphID) {
                if (ctrl.resourceFilterModal[graphID]) {
                    ctrl.resourceFilterModal[graphID] = false;
                }
            }

            // Campaign bar filter change handler
            ctrl.onCampaignBarFilterChange = function() {
                var now = moment();
                var graph = ctrl.graphs.campaignBar;
                switch(graph.campaign_filter) {
                    case 'this_month':
                        graph.start = now.clone().startOf('month');
                        graph.end = now.clone().endOf('month');
                        break;
                    case 'last_month':
                        graph.start = now.clone().subtract(1, 'month').startOf('month');
                        graph.end = now.clone().subtract(1, 'month').endOf('month');
                        break;
                    case 'this_year':
                        graph.start = now.clone().startOf('year');
                        graph.end = now.clone().endOf('year');
                        break;
                    case 'last_year':
                        graph.start = now.clone().subtract(1, 'year').startOf('year');
                        graph.end = now.clone().subtract(1, 'year').endOf('year');
                        break;
                    case 'custom':
                        // Keep current dates, user will set them manually
                        break;
                }
                if (graph.campaign_filter != 'custom') {
                    ctrl.loadAnalytics('campaignBar');
                }
            };

            // Customer table helper functions
            ctrl.click2Call = function (customerNumber) {
                var user = $rootScope.$user;
                if (!user || !user.telephony_agent_id || !user.telephony_token || !customerNumber) return;
                var url = 'https://login.webpbx.co.il/click2call.php?customer_number=' + encodeURIComponent(customerNumber) + '&agent=' + encodeURIComponent(user.telephony_agent_id) + '&callfirst=0&callerid=00000&clicktocall_token=' + encodeURIComponent(user.telephony_token);
                var img = new Image();
                img.src = url;
            };

            ctrl.updateData = function(customerId, newValue) {
                newValue.id = customerId;
                $api.customers.update.save(newValue, function(response) {
                    if(response.status == "success") {
                        // Refresh the table
                        Object.keys(ctrl.customersDt || {}).forEach(function(graphID) {
                            var tableSel = '#analytics_cust_dt_' + graphID;
                            if ($.fn.DataTable && $.fn.DataTable.isDataTable(tableSel)) {
                                $(tableSel).DataTable().ajax.reload(null, false);
                            }
                        });
                    }
                });
            };

            ctrl.getStatusColor = function(statusId) {
                if (!statusId || !ctrl.statuses) return '';
                for (var i = 0; i < ctrl.statuses.length; i++) {
                    if (String(ctrl.statuses[i].id) === String(statusId)) {
                        return ctrl.hexToRgbA(ctrl.statuses[i].color || '#a9cfe8');
                    }
                }
                return '';
            };

            ctrl.hexToRgbA = function(hex){
                if (!hex) return '';
                var c;
                if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                    c= hex.substring(1).split('');
                    if(c.length== 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
                }
                return 'rgba(169,207,232,0.2)';
            };

        });
})();

(function(){
    angular.module('app.controllers').controller('AdminController', function (
        Businesses, Variants, Settings, $business, $header, $api, $state, $translate, $rootScope, $scope, DTOptionsBuilder, dataTablesHebrewProvider
    ){

        if ($rootScope.userRole !== 1){
          $state.go('app.dashboard');
          return;
        }
        var ctrl = this;
        ctrl.search = "";

        $scope.getStatusByIndex = $business.getStatusByIndex;

        $header.title = "Businesses";
        $header.breadcrumbs.push({
            "title" : "Businesses"
        });

        if(Businesses){
            ctrl.businesses = Businesses.data;
        }else{
            ctrl.businesses = [];
        }

        ctrl.variants = [];

        if (Variants){
            ctrl.variants = Variants.data;
        }

        ctrl.filtered_businessess = function() {
            if (ctrl.search) {
                var res = ctrl.businesses.filter(function (o) { return ((o.address && o.address.indexOf(ctrl.search) >= 0) ||
                                                                (o.name && o.name.indexOf(ctrl.search) >= 0) ||
                                                                (o.agent && o.agent.indexOf(ctrl.search) >= 0) ||
                                                                (o.business_type_word && o.business_type_word.indexOf(ctrl.search) >= 0) ||
                                                                (o.city && o.city.indexOf(ctrl.search) >= 0) ||
                                                                (o.company_id && o.company_id.indexOf(ctrl.search) >= 0) ||
                                                                (o.email && o.email.indexOf(ctrl.search) >= 0) ||
                                                                (o.id == ctrl.search) ||
                                                                (o.wa_instance && o.wa_instance.indexOf(ctrl.search) >= 0) ||
                                                                (o.phone && o.phone.indexOf(ctrl.search) >= 0) ||
                                                                (o.credit_suplier && o.credit_suplier.indexOf(ctrl.search) >= 0) ||
                                                                (o.credit_yaad_key && o.credit_yaad_key.indexOf(ctrl.search) >= 0) ||
                                                                (o.emv_terminal_id && o.emv_terminal_id.indexOf(ctrl.search) >= 0) ||
                                                                (o.fax && o.fax.indexOf(ctrl.search) >= 0) ||
                                                                (o.home_number && o.home_number.indexOf(ctrl.search) >= 0) ||
                                                                (o.zip && o.zip.indexOf(ctrl.search) >= 0)); });
                return res;
            } else {
                return ctrl.businesses;
            }
        }

        ctrl.enabled_cron = Settings.data ? Settings.data.enabled_cron : false;

        ctrl.change_cron = function() {
            ctrl.enabled_cron = !ctrl.enabled_cron;
            swal({
                title: "Are you sure?",
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result && result.value) {
                    ctrl.enabled_cron = !ctrl.enabled_cron;
                    $api.admin.settings.save({enabled_cron: ctrl.enabled_cron}, function(response){

                    });
                }

                
            });
        }

        ctrl.changeAllVat = function() {
            swal({
                title: "Change VAT for all licenced businesses",
                input: 'number',
                inputPlaceholder: "Enter new VAT",
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if (result && result.value) {
                    if (result.value < 0 || result.value > 100) {
                        swal({
                            title: "VAT must be between 0 and 100",
                            type: "error",
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                        return;
                    }

                    var vat = result.value
                    swal({
                        title: "Are you sure?",
                        text: "Are you sure you want to change VAT for all licenced businesses to "+result.value+"?",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                        confirmButtonClass: "btn-danger",
                        showLoaderOnConfirm: true
                    }).then(function(result) {
                        if (result.value) {
                            $api.businesses.change_all_vat.get({vat: vat}, function(response){
                                if (response && response.success) {
                                    $api.businesses.get(function(response){
                                        if (response && response.success) {
                                            ctrl.businesses = response.data;
                                            swal({
                                                title: "VAT changed successfully",
                                                type: "success",
                                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                                timer: 2000
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });


                }
            });

        }
    });
})();

(function() {
    'use strict';

    angular.module('app.components').controller('TableColumnSettingsController', 
        function($scope, $translate, $timeout, $window, $element) {
            var ctrl = this;

            ctrl.showDropdown = false;
            ctrl.dropdownStyle = null;
            ctrl.skipFields = ctrl.skipFields || [];

            ctrl.isMobile = document.documentElement.clientWidth <= 768;
            
            // Check if field should be shown (not in skipFields)
            ctrl.shouldShowField = function(field) {
                if (!field) return false;
                if (!ctrl.skipFields || ctrl.skipFields.length === 0) return true;
                var fieldName = typeof field === 'string' ? field : field.name;
                return ctrl.skipFields.indexOf(fieldName) === -1;
            };

            // Sortable options
            ctrl.sortableOptions = {
                handle: '.drag-handle',
                stop: function(e, ui) {
                    // When drag ends, notify parent
                    $timeout(function() {
                        ctrl.notifyUpdate();
                    }, 0);
                }
            };

            // Toggle dropdown
            ctrl.toggleDropdown = function(event) {
                if (event) {
                    event.stopPropagation();
                }
                ctrl.showDropdown = !ctrl.showDropdown;

                if (ctrl.showDropdown) {
                    $timeout(function() {
                        ctrl.adjustDropdownIntoViewport();
                    }, 0);
                } else {
                    ctrl.dropdownStyle = null;
                }
            };

            // Close dropdown
            ctrl.closeDropdown = function() {
                ctrl.showDropdown = false;
                ctrl.dropdownStyle = null;
            };

            ctrl.adjustDropdownIntoViewport = function() {
                var dropdownEl = $element[0].querySelector('.dropdown');
                if (!dropdownEl) {
                    return;
                }

                ctrl.dropdownStyle = {'top': null, visibility: 'hidden'};
                $timeout(function() {
                    var rect = dropdownEl.getBoundingClientRect();
                    var vh = $window.innerHeight || document.documentElement.clientHeight;

                    var padding = 8;
                    var bottomMenuHeight = ctrl.isMobile ? 66 : 0;
                    var overflowBottom = rect.bottom - (vh - padding - bottomMenuHeight);

                    if (overflowBottom > 0) {
                        ctrl.dropdownStyle = {
                            top: (-overflowBottom) + 'px',
                            visibility: 'visible'
                        };
                        $scope.$applyAsync();
                    } else {
                        ctrl.dropdownStyle = {top: 0, visibility: 'visible'};
                    }
                }, 200);
            };

            var onResize = function() {
                if (!ctrl.showDropdown) {
                    return;
                }

                $timeout(ctrl.adjustDropdownIntoViewport, 0);
            };
            angular.element($window).on('resize', onResize);

            $scope.$on('$destroy', function() {
                angular.element($window).off('resize', onResize);
            });

            // Toggle field display
            ctrl.toggleFieldDisplay = function(field) {
                field.display = !field.display;
                ctrl.notifyUpdate();
            };

            // Get field display name
            ctrl.getFieldDisplayName = function(field) {
                if (!field) return '';
                
                if (field.translationKey) {
                    return $translate.instant(field.translationKey);
                }
                
                return typeof field === 'string' ? field : field.name;
            };

            // Notify parent of updates
            ctrl.notifyUpdate = function() {
                if (ctrl.onUpdate) {
                    ctrl.onUpdate({fieldsList: ctrl.fieldsList});
                }
            };
        }
    );
})();


(function() {
    'use strict';

    angular.module('app.components').component('tableColumnSettings', {
        templateUrl: 'app/components/table-column-settings/table-column-settings.html',
        controller: 'TableColumnSettingsController',
        controllerAs: 'ctrl',
        bindings: {
            fieldsList: '=',           // Two-way binding for the fields list array
            onUpdate: '&',             // Callback function when fields are updated (called with {fieldsList: array})
            title: '@?',                // Optional title for the button tooltip
            headerTitle: '@?',          // Optional header title for the dropdown
            headerColor: '@?',          // Optional header color for the dropdown
            skipFields: '<?',           // Optional array of field names to skip
            iconClass: '@?',            // Optional icon class for the trigger button
            inline: '<?'               // Optional inline layout (no absolute positioning)
        }
    });
})();


(function() {
    'use strict';

    angular.module('app.components').controller('ListFilterStoreController', function($scope, Data, $rootScope, $user, $api, $translate) {

        var ctrl = this;
        ctrl.form = {
            name: '',
            default: '',
            module: Data.module,
            data: Data.filter,
        };

        ctrl.submit = function() {
            $api.filters.save(ctrl.form,
                function(res){
                    swal({
                        title: $translate.instant('STORE_FILTER_STORED'),
                        text: "",
                        type: "success",
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 1500
                    });
                    $user.getFilters();
                    $scope.$close();
                },
                function (res) {            
                });
        }
    });

})();


(function() {
    'use strict';

    angular.module('app.components').controller('ListFilterController', 
        function($scope, $translate, $timeout, $api, $user, $uibModal, $rootScope) {
            var ctrl = this;

            ctrl.showDropdown = false;
            ctrl.list = {};
            ctrl.filter_values = {};
            ctrl.list.period = null;
            ctrl.suppressPeriodReset = false;

            $scope.$watch('ctrl.list.reminder_from', function(newVal, oldVal) {
                if (oldVal === newVal || ctrl.suppressPeriodReset) {
                    return;
                }

                ctrl.list.period = null;
            });

            $scope.$watch('ctrl.list.reminder_to', function(newVal, oldVal) {
                if (oldVal === newVal || ctrl.suppressPeriodReset) {
                    return;
                }

                ctrl.list.period = null;
            });

            ctrl.toggleDropdown = function() {
                ctrl.showDropdown = !ctrl.showDropdown;
            };
            
            ctrl.clearFilter = function() {
                ctrl.list = {};
                ctrl.toggleDropdown();
                $rootScope[ctrl.module + '_filter'] = ctrl.list;
                ctrl.onUpdate({list: ctrl.list});
            };

            ctrl.applyFilter = function() {
                ctrl.toggleDropdown();
                $rootScope[ctrl.module + '_filter'] = ctrl.list;
                ctrl.onUpdate({list: ctrl.list});
            };

            ctrl.getFilterValues = function() {
                $api.filters.filter_values.get({'module': ctrl.module}, function(result) {
                    if (result.success && result.data) {
                        ctrl.filter_values = result.data;
                    }
                });
            };

            ctrl.changePeriod = function(period) {
                ctrl.suppressPeriodReset = true;

                switch (period) {
                    case 'today':
                        if (ctrl.module == 'notes' || ctrl.module == 'medical_notes') {
                            ctrl.list.reminder_from = moment().startOf('day').toDate();
                            ctrl.list.reminder_to = moment().startOf('day').add(1, 'day').toDate();
                        }
                        break;
                    case 'tomorrow':
                        if (ctrl.module == 'notes' || ctrl.module == 'medical_notes') {
                            ctrl.list.reminder_from = moment().startOf('day').add(1, 'day').toDate();
                            ctrl.list.reminder_to = moment().startOf('day').add(2, 'day').toDate();
                        }
                        break;
                    case 'this_week':
                        if (ctrl.module == 'notes' || ctrl.module == 'medical_notes') {
                            ctrl.list.reminder_from = moment().startOf('day').startOf('week').toDate();
                            ctrl.list.reminder_to = moment().startOf('day').endOf('week').toDate();
                        }
                        break;
                    case 'next_7_days':
                        if (ctrl.module == 'notes' || ctrl.module == 'medical_notes') {
                            ctrl.list.reminder_from = moment().startOf('day').toDate();
                            ctrl.list.reminder_to = moment().startOf('day').add(7, 'day').toDate();
                        }
                        break;
                }

                ctrl.list.period = period;
                $timeout(function() {
                    ctrl.suppressPeriodReset = false;
                }, 0);
            };

            ctrl.storeFilter = function() {
                $uibModal.open({
                    templateUrl: "app/components/list-filter/store-filter.html",
                    controller: "ListFilterStoreController",
                    controllerAs: "ctrl",
                    windowTopClass: "form-modal small-modal",
                    scope: $scope,
                    resolve: {
                        Data: function() {
                            return {
                                module: ctrl.module,
                                filter: ctrl.list
                            };
                        }
                    }
                }).closed.then(function() {
                    ctrl.applyFilter();
                });
            };

            ctrl.getFilterValues();

            if ($rootScope[ctrl.module + '_filter']) {
                ctrl.list = angular.copy($rootScope[ctrl.module + '_filter']);
                if (ctrl.list.period) {
                    ctrl.changePeriod(ctrl.list.period);
                }
                ctrl.onUpdate({list: ctrl.list});
            }
        }
    );
})();


(function() {
    'use strict';

    angular.module('app.components').component('listFilter', {
        templateUrl: 'app/components/list-filter/list-filter.html',
        controller: 'ListFilterController',
        controllerAs: 'ctrl',
        bindings: {
            module: '@',
            onUpdate: '&',
            store: '@'
        }
    });
})();


(function() {
    'use strict';

    angular.module('app.components').controller('ItemsFilterController',
        function($rootScope, $translate) {
            var ctrl = this;

            ctrl.showDropdown = false;

            ctrl.itemTypeOptions = [
                {id: 'service', name: $translate.instant('SERVICE')},
                {id: 'sale', name: $translate.instant('SALE')},
                {id: 'course', name: $translate.instant('COURSE')},
                {id: 'card', name: $translate.instant('CARD_ITEM_TYPE')}
            ];

            ctrl.customerBookingOptions = [
                {id: '', name: $translate.instant('CUSTOMERS_ORDERS_FILTER_ALL')},
                {id: '1', name: $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES')},
                {id: '0', name: $translate.instant('SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO')}
            ];

            function getDefaultFilter() {
                return {
                    category: [],
                    item_type: [],
                    customer_allowed_booking: ''
                };
            }

            ctrl.filter = getDefaultFilter();

            ctrl.toggleDropdown = function() {
                ctrl.showDropdown = !ctrl.showDropdown;
            };

            ctrl.clearFilter = function() {
                ctrl.filter = getDefaultFilter();
                ctrl.applyFilter();
            };

            ctrl.applyFilter = function() {
                $rootScope.items_filter = angular.copy(ctrl.filter);
                ctrl.showDropdown = false;
                ctrl.onUpdate({filter: ctrl.filter});
            };

            if ($rootScope.items_filter) {
                ctrl.filter = angular.copy($rootScope.items_filter);
            } else {
                $rootScope.items_filter = getDefaultFilter();
            }
        }
    );
})();

(function() {
    'use strict';

    angular.module('app.components').component('itemsFilter', {
        templateUrl: 'app/components/items-filter/items-filter.html',
        controller: 'ItemsFilterController',
        controllerAs: 'ctrl',
        bindings: {
            categoryOptions: '<',
            onUpdate: '&'
        }
    });
})();

(function() {
    
    angular.module("app.components").factory("$header", function(){
        
        var $header = this;
        
        /**
         * Holds the title of the current module
         * @type string
         */
        $header.title = null;
        
        /**
         * Holds the path to the current module
         * @type object[]
         */
        $header.breadcrumbs = null;
    
        /**
         * Reset the header variables to their defaults
         * @returns void
         */
        $header.reset = function() {
            
            $header.title = null;
            
            $header.breadcrumbs = [{
                "title": "DASHBOARD",
                "state": "app.dashboard"
            }];
        };
        
        $header.reset();
        
        return $header;
    });
})();
(function(){
    angular.module("app.controllers").controller("HeaderController", function($header, $user, $state, $scope, $cookies, $api, $business, $uibModal, $rootScope, $translate, $filter, $window, AnalyticsStorage){
        var header = this;
        header.show_history_link = $state.current.name === 'app.cashbox' || $state.current.name === 'app.cashbox.order';
        header.title = $header.title;
        header.breadcrumbs = $header.breadcrumbs;

        header.dealer_name = $rootScope.$user && $rootScope.$user.dealer_name ? $rootScope.$user.dealer_name : '';
        header.wa_status = $rootScope.wa_status || $cookies.get("wa_status");
        header.waQrCode = $rootScope.wa_qr_code || false;
        header.wa_instance = $rootScope.$user && $rootScope.$user.wa_instance ? $rootScope.$user.wa_instance : false;
        header.wa_api = $rootScope.$user && $rootScope.$user.wa_api ? $rootScope.$user.wa_api : false;
        $scope.$watch(function() { return $rootScope.wa_status; }, function(next) {
            if (next) { header.wa_status = next; }
        });

        header.activeMessageModal = false;
        header.messages = $rootScope.b_messages;
        header.activeFilterModal = false;
        header.filters = $rootScope.filters;
        header.openedWaNotifications = false;
        header.hide_wa_notifications = $rootScope.userRole == 3 && $rootScope.isUserAllowedAccess('hide_whatsapp_notifications') ? true : false;
        header.notifications = {
            wa_list: [],
            wa_unread: 0,
        };
        header.businesses = $rootScope.header_businesses || [];
        header.allowedBusinessIds = [];
        header.currentBusinessId = $rootScope.$user ? $rootScope.$user.b_id : null;
        header.businessSwitcherOpen = false;
        header.businessesLoaded = !!$rootScope.header_businesses_loaded;

        header.is_ai_enabled = $business.ai.enabled;
        $scope.$watch(function(){ return $business.ai.enabled; }, function(next){
            header.is_ai_enabled = next;
        });

        header.stop_messages = $rootScope.$user && $rootScope.$user.stop_messages;
        var linkifyFilter = $filter('linkify');

        function parseIds(val) {
            if (!val) return [];
            if (typeof val === 'string') { try { val = JSON.parse(val); } catch (e) { val = val.split(','); } }
            if (!Array.isArray(val)) return [];
            return val.map(function(i) { var n = parseInt(i, 10); return n > 0 ? n : null; }).filter(Boolean);
        }

        function updateBusinessContext() {
            var u = $rootScope.$user;
            header.allowedBusinessIds = parseIds(u && u.business_ids);
            header.currentBusinessId = u ? u.b_id : null;
            if (header.allowedBusinessIds.length > 1 && !$rootScope.header_businesses_loaded) header.loadBusinesses();
        }

        header.loadBusinesses = function() {
            if ($rootScope.header_businesses_loaded) {
                header.businesses = $rootScope.header_businesses || [];
                header.businessesLoaded = true;
                return;
            }
            if ($rootScope.header_businesses_loading) return;
            $rootScope.header_businesses_loading = true;
            $api.auth.my_businesses.get({}, function(res) {
                $rootScope.header_businesses_loading = false;
                if (res.success && res.data) {
                    $rootScope.header_businesses = res.data;
                    $rootScope.header_businesses_loaded = true;
                    header.businesses = res.data;
                    header.businessesLoaded = true;
                }
            });
        };

        header.switchBusiness = function(business) {
            if (!business || header.currentBusinessId == business.id) { header.businessSwitcherOpen = false; return; }
            $api.auth.switch_business.save({ b_id: business.id }, function(res) {
                if (res.success) {
                    if (AnalyticsStorage && typeof AnalyticsStorage.clearAll === 'function') {
                        AnalyticsStorage.clearAll();
                    }
                    header.businessSwitcherOpen = false;
                    $window.location.href = $state.href('app.dashboard');
                }
                else swal({ title: "", text: res.data || '', type: "error", confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON') });
            });
        };

        header.checkUnread = function () {
            if (!header.messages || !Array.isArray(header.messages) || header.activeMessageModal) return;

            for (var i = 0; i < header.messages.length; i++) {
                var msg = header.messages[i];
                if (!msg || msg.read_at) continue;
                if (!msg.id) continue; // Skip malformed messages without id (would cause API call without id)

                header.activeMessageModal = true;

                var $image = "";
                switch (msg.type) {
                    case 'info':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjU2IDU2QzE0NS43MiA1NiA1NiAxNDUuNzIgNTYgMjU2czg5LjcyIDIwMCAyMDAgMjAwIDIwMC04OS43MiAyMDAtMjAwUzM2Ni4yOCA1NiAyNTYgNTZabTAgODJhMjYgMjYgMCAxIDEtMjYgMjYgMjYgMjYgMCAwIDEgMjYtMjZabTQ4IDIyNmgtODhhMTYgMTYgMCAwIDEgMC0zMmgyOHYtODhoLTE2YTE2IDE2IDAgMCAxIDAtMzJoMzJhMTYgMTYgMCAwIDEgMTYgMTZ2MTA0aDI4YTE2IDE2IDAgMCAxIDAgMzJaIiBmaWxsPSIjZjBhZDRlIiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48L3N2Zz4=";
                        break;
                    case 'error':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjU2IDQ4QzE0MS4zMSA0OCA0OCAxNDEuMzEgNDggMjU2czkzLjMxIDIwOCAyMDggMjA4IDIwOC05My4zMSAyMDgtMjA4UzM3MC42OSA0OCAyNTYgNDhabTc1LjMxIDI2MC42OWExNiAxNiAwIDEgMS0yMi42MiAyMi42MkwyNTYgMjc4LjYzbC01Mi42OSA1Mi42OGExNiAxNiAwIDAgMS0yMi42Mi0yMi42MkwyMzMuMzcgMjU2bC01Mi42OC01Mi42OWExNiAxNiAwIDAgMSAyMi42Mi0yMi42MkwyNTYgMjMzLjM3bDUyLjY5LTUyLjY4YTE2IDE2IDAgMCAxIDIyLjYyIDIyLjYyTDI3OC42MyAyNTZaIiBmaWxsPSIjZDk1MzRmIiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48L3N2Zz4=";
                        break;
                    case 'success':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjU2IDQ4QzE0MS4zMSA0OCA0OCAxNDEuMzEgNDggMjU2czkzLjMxIDIwOCAyMDggMjA4IDIwOC05My4zMSAyMDgtMjA4UzM3MC42OSA0OCAyNTYgNDhabTEwOC4yNSAxMzguMjktMTM0LjQgMTYwYTE2IDE2IDAgMCAxLTEyIDUuNzFoLS4yN2ExNiAxNiAwIDAgMS0xMS44OS01LjNsLTU3LjYtNjRhMTYgMTYgMCAxIDEgMjMuNzgtMjEuNGw0NS4yOSA1MC4zMiAxMjIuNTktMTQ1LjkxYTE2IDE2IDAgMCAxIDI0LjUgMjAuNThaIiBmaWxsPSIjM2NhYjM1IiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48L3N2Zz4=";
                        break;
                    case 'warning':
                        $image = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNDQ5LjA3IDM5OS4wOCAyNzguNjQgODIuNThjLTEyLjA4LTIyLjQ0LTQ0LjI2LTIyLjQ0LTU2LjM1IDBMNTEuODcgMzk5LjA4QTMyIDMyIDAgMCAwIDgwIDQ0Ni4yNWgzNDAuODlhMzIgMzIgMCAwIDAgMjguMTgtNDcuMTdabS0xOTguNi0xLjgzYTIwIDIwIDAgMSAxIDIwLTIwIDIwIDIwIDAgMCAxLTIwIDIwWm0yMS43Mi0yMDEuMTUtNS43NCAxMjJhMTYgMTYgMCAwIDEtMzIgMGwtNS43NC0xMjEuOTVhMjEuNzMgMjEuNzMgMCAwIDEgMjEuNS0yMi42OWguMjFhMjEuNzQgMjEuNzQgMCAwIDEgMjEuNzMgMjIuN1oiIGZpbGw9IiNmOGJiODYiIGNsYXNzPSJmaWxsLTAwMDAwMCI+PC9wYXRoPjwvc3ZnPg==";
                        break;
                }
                var html = "";
                var title = "";
                if (msg.title) {
                    html += "<p style='text-align: start; font-size: 125%;'><b>"+msg.title+"</b></p>";
                    title = $translate.instant('NOTIFICATION_TITLE');
                }
                html += "<p style='text-align: start;'>"+linkifyFilter(msg.message || '')+"</p>";

                var messageId = msg.id;
                var customerId = msg.customer_id;

                swal({
                    title: title,
                    html: html,
                    imageUrl: $image,
                    imageWidth: 100,
                    imageHeight: 100,
                    confirmButtonText: customerId ? $translate.instant('CUSTOMERS_VIEW') : $translate.instant('SETTINGS_OK'),
                    cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                    showCancelButton: !!customerId,
                }).then(function(result) {
                    header.activeMessageModal = false;

                    $api.b_messages.read.get({id: messageId}, function (response) {
                        if (response.status == "success") {
                            $rootScope.b_messages = response.data;
                            header.messages = $rootScope.b_messages;
                            header.checkUnread();
                        }
                    });

                    if (result.value && customerId) {
                        $state.go('app.customers.single', {id: customerId});
                    }
                });

                break;
            }
        }

        header.removeMessage = function (id) {
            $api.b_messages.remove.get({id: id}, function (response) {
                if (response.status == "success") {
                    $rootScope.b_messages = response.data;
                    header.messages = $rootScope.b_messages;
                    header.checkUnread();
                }
            });
        }

        header.removeFilter = function (id) {
            swal({
                title: $translate.instant('STORE_FILTER_DELETE_CONFIRM'),
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                cancelButtonText: $translate.instant('SWAL_CANCEL_BUTTON'),
                confirmButtonClass: "btn-danger",
                showLoaderOnConfirm: true
            }).then(function(result) {
                if(result.value) {
                    $api.filters.single.remove({id: id}, function (response) {
                        if (response.status == "success") {
                            swal({
                                title: $translate.instant('STORE_FILTER_DELETED'),
                                text: "",
                                type: "success",
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 1500
                            });

                            $user.getFilters();
                        }
                    });
                }
            }); 
        }

        header.goFilter = function (filter) {
            switch (filter.module) {
                case 'customers':
                    $rootScope.customers_filter = filter.data;
                    $state.go('app.customers', {}, {reload: true});
                    break;
                case 'leads':
                    $rootScope.leads_filter = filter.data;
                    $state.go('app.leads', {}, {reload: true});
                    break;
                case 'reports':
                    $rootScope.reports_filter = filter.data;
                    $state.go('app.reports', {tab: 9}, {reload: true});
                    break;
                case 'sales':
                    $rootScope.sales_filter = filter.data;
                    $state.go('app.reports', {tab: 12}, {reload: true});
                    break;
                case 'notes':
                    $rootScope.notes_filter = filter.data;
                    $state.go('app.notes', {}, {reload: true});
                    break;
                case 'medical_notes':
                    $rootScope.medical_notes_filter = filter.data;
                    $state.go('app.notes', {type: 'medical_notes'}, {reload: true});
                    break;
            }
        }

        header.openFeedbackModal = function () {
            $uibModal.open({
                templateUrl: "app/components/feedback/feedback.form.html",
                controller: "FeedbackController",
                controllerAs: "ctrl",
                scope: $scope,
                windowTopClass: "tif-modal form-modal medium-modal"
            })
        }

        header.menuToggle = function () {
            angular.element('body').toggleClass('mini-navbar');
            if (!angular.element('.menuBackDrop').length) {
                angular.element('body').append("<div class='menuBackDrop' onclick='menuBackDropMinimaze()'></div>");
            }
        }

        function onBMessagesUpdated() {
            header.messages = $rootScope.b_messages;
            header.checkUnread();
        }

        function onFiltersUpdated() {
            header.filters = $rootScope.filters;
        }

        function onNotificationsUpdated() {
            header.notifications.wa_list = $rootScope.notification_list && $rootScope.notification_list.wa_list ? $rootScope.notification_list.wa_list : [];
            header.notifications.wa_unread = $rootScope.notification_list && $rootScope.notification_list.wa_unread ? $rootScope.notification_list.wa_unread : 0;
        }

        function applyWaStatus(status) {
            $rootScope.wa_status = status;
            header.wa_status = status;
            $cookies.put("wa_status", status);
        }

        function clearWaQrCode() {
            $rootScope.wa_qr_code = false;
            header.waQrCode = false;
        }

        function clearWaStatusPolling() {
            if ($rootScope.wa_status_interval) {
                clearInterval($rootScope.wa_status_interval);
                $rootScope.wa_status_interval = null;
            }
        }

        function checkWaStatusPolling() {
            if (!$rootScope.wa_qr_code) {
                clearWaStatusPolling();
                return;
            }
            $api.wa.status.get({}, function (response) {
                if (response.status == "success" && response.response == "authorized") {
                    clearWaStatusPolling();
                    clearWaQrCode();
                    applyWaStatus("authorized");
                }
            });
        }

        function startWaStatusPolling() {
            if ($rootScope.wa_status_interval) return;
            $rootScope.wa_status_interval = setInterval(checkWaStatusPolling, 3000);
        }

        function loadWaStatusOnce() {
            if (!header.wa_instance) return;
            if ($rootScope.wa_status_loaded || $rootScope.wa_status_loading) return;
            $rootScope.wa_status_loading = true;
            $api.wa.status.get({}, function (response) {
                $rootScope.wa_status_loading = false;
                $rootScope.wa_status_loaded = true;
                if (response.status == "success" && response.response == "authorized") {
                    clearWaQrCode();
                    applyWaStatus("authorized");
                } else {
                    applyWaStatus("notAuthorized");
                }
            });
        }

        header.getQrCode = function() {
            if (header.wa_api == "official") {
                $state.go("app.settings.business_whatsapp");
                return;
            }
            if (header.wa_instance) {
                if (header.wa_status != "authorized") {
                    $api.wa.qr_code.get({}, function (response) {
                        if (response.status == "success" && response.response && response.response.message) {
                            $rootScope.wa_qr_code = response.response.message;
                            header.waQrCode = response.response.message;

                            swal({
                                imageUrl: "data:image/png;base64," + header.waQrCode,
                                imageWidth: 300,
                                imageHeight: 300,
                                confirmButtonText: $translate.instant("SETTINGS_OK"),
                            });

                            startWaStatusPolling();
                        }
                    });
                } else {
                    swal({
                        title: "",
                        text: $translate.instant("SWAL_WA_LOGOUT"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("SWAL_CONFIRM_BUTTON"),
                        cancelButtonText: $translate.instant("SWAL_CANCEL_BUTTON"),
                        confirmButtonClass: "btn-danger",
                        showLoaderOnConfirm: true
                    }).then(function(result) {
                        if (result.value) {
                            $api.wa.logout.get({}, function (response) {
                                if (response.status == "success") {
                                    clearWaQrCode();
                                    clearWaStatusPolling();
                                    applyWaStatus("notAuthorized");
                                    $rootScope.wa_status_loaded = true;
                                }
                            });
                        }
                    });
                }
            } else {
                swal({
                    title: "",
                    text: $translate.instant("WA_MESSAGE"),
                    type: "info",
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("WA_CONTACT"),
                    cancelButtonText: $translate.instant("WA_CLOSE"),
                    confirmButtonClass: "btn-wa",
                    cancelButtonClass: "btn-danger",
                    closeOnConfirm: false,
                    showLoaderOnConfirm: false
                }).then(function(result) {
                    if (result.value) {
                        window.open("https://wa.me/+972506177762", "_blank");
                    }
                });
            }
        }

        header.checkWaStatus = checkWaStatusPolling;

        header.clickNotification = function (notification) {
            header.removeNotification(notification);
            if (notification.customer_id) {
                $state.go('app.customers.single', {id: notification.customer_id});
            }
        }

        header.removeNotification = function (notification) {
            $api.notifications.remove.get({id: notification.id}, function (response) {
                if (response.status == "success") {
                    $user.getNotifications();
                }
            });
        }

        header.goAllNotifications = function (wa) {
            $state.go('app.notifications');
        }

        header.removeAllNotifications = function (type) {
            $api.notifications.removeAll.delete({type: type}, function (response) {
                if (response.status == "success") {
                    $user.getNotifications();
                }
            });
        }

        if ($rootScope.wa_qr_code && !$rootScope.wa_status_interval) {
            startWaStatusPolling();
        }
        loadWaStatusOnce();
    
        // Listen for the event when $rootScope.b_messages is updated
        $scope.$on('b_messages_updated', onBMessagesUpdated);
        $scope.$on('filters_updated', onFiltersUpdated);
        $scope.$on('notifications_updated', onNotificationsUpdated);
    
        // Initial call to checkUnread
        onBMessagesUpdated();
        onFiltersUpdated();
        onNotificationsUpdated();
        updateBusinessContext();
    });
})();
(function () {
  'use strict';

  angular.module('app.controllers').controller('GiftCardController', function ($translate, $color) {
    var ctrl = this;

    var DEFAULT_SETTINGS = {
      page_bg_color: '#EEF3FC',
      card_bg_color: '#ffffff',
      primary_color: '#275A7B',
      text_color: '#1A202C',
      logo: '/assets/images/gift-card-logo.png',
      image: '/assets/images/gift-card-image.png',
      receiver: true,
      sender: true,
      service: true,
      value: true,
      message: true,
    };

    var DEFAULT_VALUES = {
      number: $translate.instant('DEFAULT_GIFT_CARD_NUMBER'),
      business: $translate.instant('DEFAULT_GIFT_CARD_BUSINESS'),
      address: $translate.instant('DEFAULT_GIFT_CARD_ADDRESS'),
      service: $translate.instant('DEFAULT_GIFT_CARD_SERVICE'),
      receiver: $translate.instant('DEFAULT_GIFT_CARD_RECEIVER'),
      value: $translate.instant('DEFAULT_GIFT_CARD_VALUE'),
      message: $translate.instant('DEFAULT_GIFT_CARD_MESSAGE'),
      sender: $translate.instant('DEFAULT_GIFT_CARD_SENDER'),
    };

    function computeGradient(base) {
      if ($color.gradientLR) {
        return $color.gradientLR(base, 0.50, -0.20);
      }

      var from = $color.pSBC(0.50, base, null, true);
      var to = $color.pSBC(-0.20, base, null, true);
      return 'linear-gradient(90deg,' + from + ' 0%,' + to + ' 100%)';
    }

    ctrl.$onInit = function () {
      ctrl.size = (ctrl.size || 'normal').toLowerCase();
      ctrl.view = (ctrl.view || 'desktop').toLowerCase();
      ctrl.settings = angular.merge({}, DEFAULT_SETTINGS, ctrl.settings || {});
      ctrl.values = angular.merge({}, DEFAULT_VALUES, ctrl.values || {});
      ctrl.card_bg_gradient = computeGradient(ctrl.settings.card_bg_color);
    };

    ctrl.$onChanges = function (changes) {
      if (changes.settings && !changes.settings.isFirstChange()) {
        ctrl.settings = angular.merge({}, DEFAULT_SETTINGS, changes.settings.currentValue || {});
        ctrl.card_bg_gradient = computeGradient(ctrl.settings.card_bg_color);
      }
      if (changes.values && !changes.values.isFirstChange()) {
        ctrl.values = angular.merge({}, DEFAULT_VALUES, changes.values.currentValue || {});
      }

      if (changes.size && changes.size.currentValue) {
        ctrl.size = String(changes.size.currentValue).toLowerCase();
      }

      if (changes.view && changes.view.currentValue) {
        ctrl.view = String(changes.view.currentValue).toLowerCase();
      }
    };

    ctrl.classes = function () {
      return {
        'gift-card--mobile': ctrl.view === 'mobile',
        'gift-card--zoom-on-hover': ctrl.zoomOnHover,
        'gift-card--sm': ctrl.size === 'small',
        'gift-card--lg': ctrl.size === 'large',
        'gift-card--md': ctrl.size === 'normal' || !ctrl.size,
      };
    };
  });
})();

(function () {
  'use strict';

  angular.module('app.components').component('giftCard', {
      bindings: {
        settings: '<',
        values: '<',
        size: '@?', // size: "small" | "normal" | "large"
        view: '@?', // view: "desktop" | "mobile"
        zoomOnHover: '<?' // boolean (optional, one-way binding)
      },
      controllerAs: 'ctrl',
      templateUrl: 'app/components/gift_card/gift_card.view.html',
      controller: 'GiftCardController',
    });
})();
(function(){
    angular.module('app.controllers').controller('FeedbackController', function ($header, $rootScope, $state, $scope, $api, $uibModalStack, $filter){
        if ($rootScope.userRole == 1){
            $state.go('app.admin', {}, {reload: true});
            return;
        }

        var ctrl = this;

        $scope.isModal = true;

        this.submit = function() {
            /**
             * Send feedback to backend to be sent to admin
             */
            $api.feedback.save(ctrl.feedback, function(response){
                if(response.status == "success") {
                    $uibModalStack.dismissAll();
                    var title = $filter('translate')('FEEDBACK_REQUEST_SUCCESS');
                    var type = 'success';
                } else {
                    var title = $filter('translate')('FEEDBACK_REQUEST_ERROR');
                    var type = 'warning';
                }
                swal({
                    title: title,
                    type: type,
                    confirmButtonText: "OK",
                    timer: 3000
                });

            });
        }

    });
})();

(function() {
    
    angular.module("app.components").factory("$cfilter", function($rootScope){
        
        var $cfilter = this;
        $cfilter.values = {};
        $cfilter.module = null;
        $cfilter.store = false;
        
        $cfilter.apply = function(module, store) {
            $cfilter.values = $rootScope[module+'_filter'] || {};
            $cfilter.module = module;
            $cfilter.store = store || false;
        };

        return $cfilter;
    });
})();

(function(){
    angular.module("app.controllers").controller("CfilterController", function($rootScope, $cfilter, $customFields, $scope, $api, $timeout, $uibModal, $translate, dates){
        var cfilter = this;
        cfilter.filter_values = {};
        cfilter.module = $cfilter.module;
        cfilter.store = $cfilter.store;
        cfilter.birthdayOptions = buildMonthOptions(dates.months);
        cfilter.genderOptions = [
          {id: '0', name: $translate.instant('CUSTOMERS_GENDER_MALE')},
          {id: '1', name: $translate.instant('CUSTOMERS_GENDER_FEMALE')}
        ];

        cfilter.openFilter = function() {
            if (!cfilter.filterModal) {
              $timeout(function() {
                cfilter.filterModal = true;
                $('#page-wrapper').addClass('with-filter');
                angular.element('body').addClass('filter-open');
              });
            }
        }

        cfilter.closeFilter = function() {
          if (cfilter.filterModal) {
            cfilter.filterModal = false;
            $('#page-wrapper').removeClass('with-filter');
            angular.element('body').removeClass('filter-open');
          }
        }

        cfilter.storeFilter = function() {
          $uibModal.open({
            templateUrl: "app/components/cfilter/store-filter/store-filter.html",
            controller: "StoreFilterController",
            controllerAs: "ctrl",
            windowTopClass: "form-modal small-modal",
            scope: $scope,
            resolve: {
              Data: cfilter
            }
          }).closed.then(function() {
            cfilter.applyFilter();
          });
        }

        cfilter.applyFilter = function() {
          var filter = cfilter.filter;

          function formatDateToYMD(date) {
            if (!date) return null;
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + d.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
          }

          function formatDateToYMDHM(date) {
            if (!date) return null;
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + d.getDate()).slice(-2);
            var hours = ('0' + d.getHours()).slice(-2);
            var minutes = ('0' + d.getMinutes()).slice(-2);
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
          }

          // convert only specific fields to "YYYY-MM-DD"
          filter.created_from = formatDateToYMD(filter.created_from);
          filter.created_to = formatDateToYMD(filter.created_to);
          filter.opened_orders_from = formatDateToYMD(filter.opened_orders_from);
          filter.opened_orders_to = formatDateToYMD(filter.opened_orders_to);
          filter.lastvisit_from = formatDateToYMD(filter.lastvisit_from);
          filter.lastvisit_to = formatDateToYMD(filter.lastvisit_to);
          filter.visited_from = formatDateToYMD(filter.visited_from);
          filter.visited_to = formatDateToYMD(filter.visited_to);
          filter.birthday = syncBirthdayWithSource(filter.birthday);

          if (filter.custom_fields && cfilter.filter_values.custom_fields) {
            angular.forEach(filter.custom_fields, function(value, fieldId) {
              var def = cfilter.filter_values.custom_fields.find(function(f) {
                return f.id == fieldId;
              });

              if (!def) return;

              if (def.type === 'date') {
                // for a plain date → YYYY-MM-DD
                filter.custom_fields[fieldId] = formatDateToYMD(value);
              }
              // else if (def.type === 'datetime') {
              //   // for date+time → YYYY-MM-DD HH:mm
              //   filter.custom_fields[fieldId] = formatDateToYMDHM(value);
              // }
            });
          }

          $rootScope[cfilter.module + '_filter'] = filter;

          if ($scope.submit_filter) {
            $scope.submit_filter();
          }

          cfilter.closeFilter();
        };

        cfilter.clearFilter = function() {

          cfilter.filter = {
            'item': [],
            'not_use_item': [],
            'category': [],
            'resource': [],
            'arrival_source': [],
            'opened_orders_from': null,
            'opened_orders_to': null,
            'lastvisit_from': null,
            'lastvisit_to': null,
            'created_from': null,
            'created_to': null,
            'birthday': [],
            'status': [],
            'visited_from': null,
            'visited_to': null,
            'have_card': false,
            'gender': ''
          };
          
          $rootScope[cfilter.module+'_filter'] = cfilter.filter;

          if ($scope.submit_filter) {
            $scope.submit_filter();
          }
          cfilter.closeFilter();
        }

        if ($cfilter.values) {
          cfilter.filter = $cfilter.values;
        }

        cfilter.getFilterValues = function () {
          $api.customers.filter.get({}, function (result) {
            if (result && result.data) {
              cfilter.filter_values = result.data;
              cfilter.filter_values.campaigns = normalizeIdOptions(cfilter.filter_values.campaigns);
              cfilter.filter_values.ads = normalizeIdOptions(cfilter.filter_values.ads);
              cfilter.filter_values.adsets = normalizeIdOptions(cfilter.filter_values.adsets);
              cfilter.filter_values.statuses.unshift({id: '', name: $translate.instant('FILTER_STATUS_EMPTY')});

              cfilter.filter_values.types = [
                {id: 'customer', name: $translate.instant('FILTER_TYPE_CUSTOMER')},
                {id: 'lead', name: $translate.instant('FILTER_TYPE_LEAD')}
              ];

              if (cfilter.filter_values.custom_fields) {
                cfilter.filter_values.custom_fields.filter(function(field) {
                  field.name = $customFields.getCurrentName(field.name);

                  if (field.type === 'list') {
                    if (!Array.isArray(field.values)) {
                      return false;
                    }

                    field.values = field.values.filter(function(v) {
                      return v.active === true;
                    });

                    return field.values.length > 0;
                  }

                  return true;
                });
              }

              function syncSelectedWithSource(selectedArray, sourceArray) {
                if (!angular.isArray(selectedArray) || !angular.isArray(sourceArray)) return [];
                var synced = [];
                for (var i = 0; i < selectedArray.length; i++) {
                  var sel = selectedArray[i];
                  var found = null;
                  for (var j = 0; j < sourceArray.length; j++) {
                    if (sourceArray[j].id === sel.id) {
                      found = sourceArray[j];
                      break;
                    }
                  }
                  synced.push(found || sel);
                }
                return synced;
              }

              if (cfilter.filter) {
                normalizeStringFilterValue('campaign');
                normalizeStringFilterValue('ad');
                normalizeStringFilterValue('adset');
                cfilter.filter.item = syncSelectedWithSource(cfilter.filter.item, cfilter.filter_values.items);
                cfilter.filter.not_use_item = syncSelectedWithSource(cfilter.filter.not_use_item, cfilter.filter_values.items);
                cfilter.filter.category = syncSelectedWithSource(cfilter.filter.category, cfilter.filter_values.categories);
                cfilter.filter.resource = syncSelectedWithSource(cfilter.filter.resource, cfilter.filter_values.resources);
                cfilter.filter.arrival_source = syncSelectedWithSource(cfilter.filter.arrival_source, cfilter.filter_values.arrival_sources);
                cfilter.filter.status = syncSelectedWithSource(cfilter.filter.status, cfilter.filter_values.statuses);
                cfilter.filter.interested = syncSelectedWithSource(cfilter.filter.interested, cfilter.filter_values.interested);
                cfilter.filter.birthday = syncBirthdayWithSource(cfilter.filter.birthday);

                if (cfilter.filter.custom_fields && cfilter.filter_values.custom_fields) {
                  angular.forEach(cfilter.filter.custom_fields, function(val, key) {
                    var field = null;
                    for (var i = 0; i < cfilter.filter_values.custom_fields.length; i++) {
                      var f = cfilter.filter_values.custom_fields[i];
                      if (f.id == key && f.type === 'list') {
                        field = f;
                        break;
                      }
                    }
                    if (field) {
                      cfilter.filter.custom_fields[key] = syncSelectedWithSource(val, field.values);
                    }
                  });
                }
              }
            }
          });
        }

        function normalizeIdOptions(options) {
          if (!angular.isArray(options)) return options;

          var normalized = [];
          for (var i = 0; i < options.length; i++) {
            var option = angular.extend({}, options[i]);
            if (option.id !== null && option.id !== undefined) {
              option.id = String(option.id);
            }
            normalized.push(option);
          }

          return normalized;
        }

        function buildMonthOptions(months) {
          var options = [];
          if (!angular.isArray(months)) return options;

          for (var i = 0; i < months.length; i++) {
            options.push({
              month: String(i),
              value: months[i]
            });
          }

          return options;
        }

        function syncBirthdayWithSource(selectedArray) {
          if (!angular.isArray(selectedArray)) return [];

          var synced = [];
          for (var i = 0; i < selectedArray.length; i++) {
            var sel = selectedArray[i];
            var selectedMonth = null;
            var selectedValue = null;

            if (sel && typeof sel === 'object') {
              selectedMonth = sel.month;
              selectedValue = sel.value;
            } else {
              selectedValue = sel;
            }

            for (var j = 0; j < cfilter.birthdayOptions.length; j++) {
              var option = cfilter.birthdayOptions[j];
              if ((selectedMonth !== null && selectedMonth !== undefined && option.month == selectedMonth) || option.value == selectedValue) {
                synced.push(option);
                break;
              }
            }
          }

          return synced;
        }

        function normalizeStringFilterValue(key) {
          if (!cfilter.filter || cfilter.filter[key] === null || cfilter.filter[key] === undefined || cfilter.filter[key] === '') return;
          cfilter.filter[key] = String(cfilter.filter[key]);
        }

        cfilter.getFilterValues();
      
    });
})();
(function () {

    angular.module("app", [

        "app.providers",

        "app.services",

        "app.components",

        "app.filters",

        "app.controllers",

        "app.modules",

        'pusher-angular',

        "pascalprecht.translate",

        "selectize",

        "ngjsColorPicker",

        "socialLogin",

        "ngSanitize"

    ]).config(function ($stateProvider, $urlRouterProvider, chosenProvider, $translateProvider, socialProvider){
        var time = new Date().getTime();
        //socialProvider.setFbKey({appId: "882336122999637", apiVersion: "v17.0"});


        var d = document, fbJs, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
        fbJs = d.createElement('script'); 
        fbJs.id = id; 
        fbJs.async = true;
        fbJs.src = "//connect.facebook.net/en_US/sdk.js";

        fbJs.onload = function() {
            FB.init({ 
                appId: "334220589223415",
                status: false, 
                cookie: true, 
                xfbml: true,
                version: "v18.0"
            });
        };

        ref.parentNode.insertBefore(fbJs, ref);


        $translateProvider.useStaticFilesLoader({
            prefix: '/app/translations/lang_',
            suffix: '.json?'+time
        });
        $translateProvider.preferredLanguage(localStorage.getItem('language') ? localStorage.getItem('language') : 'hb_ISR');
        $stateProvider.state('app', {
            abstract: true,
            url: "",
            templateUrl: "app/components/common/content.html"
        });
        $urlRouterProvider.otherwise('/');
        chosenProvider.setOption({
            rtl: true
        });
    }).run(function ($rootScope, $state, $user, $header, $webview, $minimizableModal) {
        $webview.handshake()

        if ($webview.isWebView && $webview.isWebView()) {
            document.documentElement.classList.add('is-webview');
        }

        $rootScope.$state = $state;

        $rootScope.restoreMinimizedModal = $minimizableModal.restore;

        $rootScope.availableLocales = ['hb_ISR', 'en_US', 'ar_AR', 'ja_JP', 'ru_RU'];

        $rootScope.page_is_loading = true;

        $rootScope.langKey = localStorage.getItem('language') ? localStorage.getItem('language') : 'hb_ISR';

        window.langKey = $rootScope.langKey;

        $rootScope.$on('change-language', function(event, langKey){
            window.langKey = langKey;

            if((window.langKey === 'hb_ISR' || window.langKey === 'ar_AR') && !document.getElementById('bootstrap-rtl-id')){
                var link = document.createElement('link');
                link.id = 'bootstrap-rtl-id';
                link.rel = 'stylesheet';
                link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css';
                document.head.appendChild(link);
            }else{
                if(window.langKey !== 'hb_ISR' && document.getElementById('bootstrap-rtl-id')){
                    document.getElementById("bootstrap-rtl-id").remove();
                }
            }
        });

        function isCustomerSingle(name) {
            return !!name && name.indexOf('app.customers.single') === 0;
        }

        $rootScope.$on('$stateChangeSuccess', function(evt, to, toP, from, fromParams) {
            if (!from || !from.name) return;

            if (from.name === 'app.calendar.order-edit' && isCustomerSingle(to && to.name)) {
                var payload = {
                    name: from.name,
                    params: fromParams || {}
                };

                try {
                    sessionStorage.setItem('backTarget', JSON.stringify(payload));
                } catch (e) {
                    // ignore storage errors
                }
            }

            var fromIsSingle = isCustomerSingle(from && from.name);
            var toIsSingle   = isCustomerSingle(to && to.name);
            if (fromIsSingle && !toIsSingle) {
                try {
                    sessionStorage.removeItem('backTarget');
                } catch (e) {
                    // ignore storage errors
                }
            }
        });

        $rootScope.logout = $user.logout;

        $rootScope.changeLanguage = $user.changeLanguage;

        $rootScope.currentLanguage = $user.currentLanguage;


        if((window.langKey === 'hb_ISR' || window.langKey === 'ar_AR') && !document.getElementById('bootstrap-rtl-id')){
            var link = document.createElement('link');
            link.id = 'bootstrap-rtl-id';
            link.rel = 'stylesheet';
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css';
            document.head.appendChild(link);
        }else{
            if(window.langKey !== 'hb_ISR' && window.langKey !== 'ar_AR' && document.getElementById('bootstrap-rtl-id')){
                document.getElementById("bootstrap-rtl-id").remove();
            }
        }

        $rootScope.$on("$stateChangeStart", function (event, toState) {
            if($rootScope.userRole == 1) {
              if (toState.name === 'app.dashboard' || toState.name === 'login') {
                  $state.go("app.admin");
                  event.preventDefault();
                  return;
              }
            }

            $rootScope.wrapperClasses = "wrapper wrapper-content animated fadeInLeft";

            $header.reset();

            //Check on server if user still active
            $user.isAuth(function (isAuth) {
                $rootScope.isAuth = isAuth;

                if(!isAuth && toState.name !== "login" && toState.name !== "approval" && toState.name !== "order" && toState.name !== "review" && toState.name !== "document" && toState.name !== "form" && toState.name !== "prepaid" && toState.name !== "login.forgot_password" && toState.name !== "forgotpassword" && toState.name !== "login.termsofuse" && toState.name !== "e" && toState.name !== "pay" && toState.name !== "customers_public_form" && toState.name !== "gift_card" && toState.name !== "cardrequest"){
                    $state.go("login");
                }
                else if (isAuth && toState.name === "login"){
                  $user.go_default_screen();
                }
            });
        });

        $rootScope.$on('$stateChangeSuccess', function() {
            $rootScope.page_is_loading = false;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            window.scrollTo(0, 0);
        });

        $rootScope.$on('$viewContentLoaded', function(){
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            window.scrollTo(0, 0);
        });

        $rootScope.getInitials = function(name) {
            // Logic to extract initials from the user name
            var initials = name.match(/\b\w/g) || [];
            return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        };

        $rootScope.lightenColor = function(color, percent) {
            var num = parseInt(color.replace('#', ''), 16),
                amt = Math.round(2.55 * percent),
                R = (num >> 16) + amt,
                G = (num >> 8 & 0x00FF) + amt,
                B = (num & 0x0000FF) + amt;
            return '#' + (
                0x1000000 + 
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + 
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + 
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            ).toString(16).slice(1).toUpperCase();
        };

        $rootScope.createDiagonalPattern = function(color) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
        
            var size = 8;
            var stroke = 3;
            var strokeOffset = stroke / 2;
            canvas.width = size;
            canvas.height = size;
        
            context.strokeStyle = color; // 'rgba(0, 0, 0, 1)';
            context.lineWidth = stroke;
        
            // The offset is needed because of antialiasing. We always want to draw outside the edge
            context.moveTo(size / 2 - strokeOffset, -strokeOffset);
            context.lineTo(size + strokeOffset, size / 2 + strokeOffset);
            context.moveTo(-strokeOffset, size / 2 - strokeOffset);
            context.lineTo(size / 2 + strokeOffset, size + strokeOffset);
            context.stroke();
        
            return context.createPattern(canvas, 'repeat');
        }

    });


})();

(function () {
  'use strict';

  angular.module('app').controller('BusinessHelperController', BusinessHelperController);

  BusinessHelperController.$inject = ['$document', '$api', '$timeout', '$rootScope', '$translate'];

  function BusinessHelperController($document, $api, $timeout, $rootScope, $translate) {
    var $ctrl = this;

    var TAB_INSIGHTS = 'insights';
    var TAB_NEWS = 'news';
    var TAB_SUPPORT = 'support';
    var NEWS_PAGE_LIMIT = 20;
    var NEWS_PUSH_EVENT = 'business-helper-news-event';

    $ctrl.isOpen = false;
    $ctrl.activeTab = TAB_INSIGHTS;
    $ctrl.tabs = [
      { key: TAB_INSIGHTS, label: 'Insights' },
      { key: TAB_NEWS, label: 'News' },
      { key: TAB_SUPPORT, label: 'Support' }
    ];
    $ctrl.insightsPeriods = [];
    $ctrl.selectedInsightsPeriod = 'last_week';
    $ctrl.insightsLoading = false;

    $ctrl.insights = [];
    $ctrl.news = [];
    $ctrl.notificationCount = 0;
    $ctrl.badgeAnimate = false;
    $ctrl.newsHasMore = false;
    $ctrl.newsLoading = false;

    $ctrl.$onInit = function () {
      updateInsightsPeriodLabels();
      bindEscKey();
      bindTranslationEvents();
      bindBusinessNewsEvents();
      loadNews(true);
      //loadInsights();
    };

    $ctrl.$onDestroy = function () {
      if ($ctrl._onKeydown) {
        $document.off('keydown', $ctrl._onKeydown);
      }
      unbindTranslationEvents();
      detachNewsScrollListener();
      unbindBusinessNewsEvents();
    };

    $ctrl.open = function () {
      if ($ctrl.notificationCount > 0) {
        $ctrl.activeTab = TAB_NEWS;
      }
      $ctrl.isOpen = true;
      loadInsights();
      attachNewsScrollListener();
      if ($ctrl.isActiveTab(TAB_NEWS)) {
        markAllLoadedNewsAsRead();
      }
    };

    $ctrl.close = function () {
      $ctrl.isOpen = false;
      detachNewsScrollListener();
    };

    $ctrl.toggle = function () {
      $ctrl.isOpen ? $ctrl.close() : $ctrl.open();
    };

    $ctrl.setTab = function (tabKey) {
      $ctrl.activeTab = tabKey;
      if (tabKey === TAB_NEWS && $ctrl.isOpen) {
        attachNewsScrollListener();
        markAllLoadedNewsAsRead();
      } else {
        detachNewsScrollListener();
      }
    };

    $ctrl.isActiveTab = function (tabKey) {
      return $ctrl.activeTab === tabKey;
    };

    $ctrl.onInsightsPeriodChange = function () {
      loadInsights();
    };

    $ctrl.onNewsScroll = function (element) {
      if (!element || !$ctrl.isActiveTab(TAB_NEWS) || !$ctrl.newsHasMore || $ctrl.newsLoading) {
        return;
      }

      if ((element.scrollTop + element.clientHeight) >= (element.scrollHeight - 24)) {
        loadOlderNews(element);
      }
    };

    $ctrl.getCustomerName = function (customer) {
      if (!customer) {
        return $translate.instant('BUSINESS_HELPER_UNKNOWN_CUSTOMER');
      }

      return [customer.firstname || '', customer.lastname || ''].join(' ').trim() || $translate.instant('BUSINESS_HELPER_UNKNOWN_CUSTOMER');
    };

    $ctrl.getNewsText = function (item) {
      var customerName = $ctrl.getCustomerName(item && item.customer);
      var date = item && item.date ? item.date : '';
      var source = getSourceLabel(item && item.info && item.info.source ? item.info.source : 'online');
      var dfName = item && item.info && item.info.digital_form && item.info.digital_form.name ? item.info.digital_form.name : $translate.instant('BUSINESS_HELPER_DIGITAL_FORM_DEFAULT');

      switch (item && item.type) {
        case 'order_booked':
          return $translate.instant('BUSINESS_HELPER_NEWS_ORDER_BOOKED', { customer: customerName, date: date, source: source });
        case 'order_updated':
          return $translate.instant('BUSINESS_HELPER_NEWS_ORDER_UPDATED', { customer: customerName, date: date, source: source });
        case 'order_copied':
          return $translate.instant('BUSINESS_HELPER_NEWS_ORDER_COPIED', { customer: customerName, date: date, source: source });
        case 'order_pending':
          return $translate.instant('BUSINESS_HELPER_NEWS_ORDER_PENDING', { customer: customerName, date: date, source: source });
        case 'arrival_approved':
          return $translate.instant('BUSINESS_HELPER_NEWS_ARRIVAL_APPROVED', { customer: customerName });
        case 'order_canceled':
          return $translate.instant('BUSINESS_HELPER_NEWS_ORDER_CANCELED', { customer: customerName, date: date });
        case 'df_filled':
          return $translate.instant('BUSINESS_HELPER_NEWS_DF_FILLED', { customer: customerName, dfName: dfName });
        default:
          return $translate.instant('BUSINESS_HELPER_NEWS_ACTIVITY_DEFAULT', { customer: customerName });
      }
    };

    function getSourceLabel(source) {
      switch (source) {
        case 'business':
          return $translate.instant('BUSINESS_HELPER_SOURCE_BUSINESS');
        case 'ai_agent':
          return $translate.instant('BUSINESS_HELPER_SOURCE_AI_AGENT');
        case 'online':
        default:
          return $translate.instant('BUSINESS_HELPER_SOURCE_ONLINE');
      }
    }

    function bindEscKey() {
      $ctrl._onKeydown = function (event) {
        if ((event.key === 'Escape' || event.keyCode === 27) && $ctrl.isOpen) {
          $ctrl.close();
        }
      };

      $document.on('keydown', $ctrl._onKeydown);
    }

    function bindTranslationEvents() {
      $ctrl._onTranslateChange = $rootScope.$on('$translateChangeSuccess', function () {
        updateInsightsPeriodLabels();
      });
    }

    function unbindTranslationEvents() {
      if (typeof $ctrl._onTranslateChange === 'function') {
        $ctrl._onTranslateChange();
      }
      $ctrl._onTranslateChange = null;
    }

    function updateInsightsPeriodLabels() {
      $ctrl.insightsPeriods = [
        { key: 'last_week', label: $translate.instant('BUSINESS_HELPER_PERIOD_LAST_WEEK') },
        { key: 'this_week', label: $translate.instant('BUSINESS_HELPER_PERIOD_THIS_WEEK') },
        { key: 'last_month', label: $translate.instant('BUSINESS_HELPER_PERIOD_LAST_MONTH') },
        { key: 'this_month', label: $translate.instant('BUSINESS_HELPER_PERIOD_THIS_MONTH') },
        { key: 'last_year', label: $translate.instant('BUSINESS_HELPER_PERIOD_LAST_YEAR') },
        { key: 'this_year', label: $translate.instant('BUSINESS_HELPER_PERIOD_THIS_YEAR') }
      ];
    }

    function loadNews(reset, beforeId) {
      if ($ctrl.newsLoading) {
        return;
      }

      $ctrl.newsLoading = true;

      $api.business_helper.dashboard.get(
        {
          limit: NEWS_PAGE_LIMIT,
          before_id: beforeId || null
        },
        function (response) {
          var data = response && response.data ? response.data : {};
          var newsPayload = data && Array.isArray(data.news) ? data.news : null;
          var normalizedNews = normalizeNews(newsPayload || []);

          if (reset) {
            $ctrl.news = normalizedNews;
          } else {
            $ctrl.news = ($ctrl.news || []).concat(normalizedNews);
          }

          $ctrl.newsHasMore = !!(data && data.has_more);
          setNotificationCount(data && data.unread_count !== undefined
            ? (parseInt(data.unread_count, 10) || 0)
            : countUnreadNews($ctrl.news), false);
          $ctrl.newsLoading = false;

          if ($ctrl.isOpen && $ctrl.isActiveTab(TAB_NEWS)) {
            markAllLoadedNewsAsRead();
          }
        },
        function () {
          if (reset) {
            $ctrl.news = [];
            setNotificationCount(0, false);
            $ctrl.newsHasMore = false;
          }
          $ctrl.newsLoading = false;
        }
      );
    }

    function loadInsights() {
      $ctrl.insightsLoading = true;
      $api.business_helper.insights.get(
        {
          period: $ctrl.selectedInsightsPeriod || 'last_week'
        },
        function (response) {
          var data = response && response.data ? response.data : {};
          var insightsPayload = data && data.insights ? data.insights : null;
          if (insightsPayload) {
            $ctrl.insights = mapInsights(insightsPayload);
          } else {
            $ctrl.insights = [];
          }
          $ctrl.insightsLoading = false;
        },
        function () {
          $ctrl.insights = [];
          $ctrl.insightsLoading = false;
        }
      );
    }

    function loadOlderNews(scrollElement) {
      var oldestNewsId = getOldestNewsId();
      if (!oldestNewsId) {
        $ctrl.newsHasMore = false;
        return;
      }

      loadNews(false, oldestNewsId);
    }

    function normalizeNews(newsList) {
      return (newsList || [])
        .map(function (item) {
          item = item || {};
          item.is_read = !!item.is_read;
          return item;
        });
    }

    function getOldestNewsId() {
      if (!$ctrl.news || !$ctrl.news.length) {
        return null;
      }

      var oldest = $ctrl.news[$ctrl.news.length - 1];
      return oldest && oldest.id ? oldest.id : null;
    }

    function countUnreadNews(newsList) {
      return (newsList || []).reduce(function (total, item) {
        return total + (item && !item.is_read ? 1 : 0);
      }, 0);
    }

    function markAllLoadedNewsAsRead() {
      var unreadIds = ($ctrl.news || [])
        .filter(function (item) {
          return item && item.id && !item.is_read;
        })
        .map(function (item) {
          return item.id;
        });

      if (!unreadIds.length) {
        return;
      }

      $api.business_helper.mark_read.save(
        {
          news_ids: unreadIds
        },
        function (response) {
          ($ctrl.news || []).forEach(function (item) {
            if (item && unreadIds.indexOf(item.id) !== -1) {
              item.is_read = true;
            }
          });

          var unreadCount = response
            && response.data
            && response.data.unread_count !== undefined
            ? parseInt(response.data.unread_count, 10)
            : countUnreadNews($ctrl.news);
          setNotificationCount(isNaN(unreadCount) ? 0 : unreadCount, false);
        }
      );
    }

    function bindBusinessNewsEvents() {
      var businessId = $rootScope && $rootScope.$user ? parseInt($rootScope.$user.b_id, 10) : 0;
      if (!businessId || typeof pusher === 'undefined') {
        return;
      }

      var channelName = 'business-' + businessId;
      $ctrl._businessNewsChannel = pusher.channel(channelName) || pusher.subscribe(channelName);
      $ctrl._businessNewsHandler = function (data) {
        if (!data || parseInt(data.b_id, 10) !== businessId) {
          return;
        }

        $rootScope.$evalAsync(function () {
          applyIncomingNews(data);
        });
      };

      $ctrl._businessNewsChannel.bind(NEWS_PUSH_EVENT, $ctrl._businessNewsHandler);
    }

    function unbindBusinessNewsEvents() {
      if ($ctrl._businessNewsChannel && $ctrl._businessNewsHandler) {
        $ctrl._businessNewsChannel.unbind(NEWS_PUSH_EVENT, $ctrl._businessNewsHandler);
      }
      $ctrl._businessNewsChannel = null;
      $ctrl._businessNewsHandler = null;
    }

    function applyIncomingNews(data) {
      var incoming = data && data.news ? normalizeIncomingNewsItem(data.news) : null;
      if (!incoming || !incoming.id) {
        return;
      }

      var existingIndex = -1;
      ($ctrl.news || []).some(function (item, index) {
        if (item && item.id === incoming.id) {
          existingIndex = index;
          return true;
        }
        return false;
      });

      if (existingIndex >= 0) {
        $ctrl.news[existingIndex] = incoming;
      } else {
        incoming._animateIn = true;
        $ctrl.news.unshift(incoming);
        clearIncomingAnimation(incoming);
      }

      if (data && data.unread_count !== undefined) {
        setNotificationCount(parseInt(data.unread_count, 10) || 0, true);
      } else {
        setNotificationCount(countUnreadNews($ctrl.news), true);
      }

      if ($ctrl.isOpen && $ctrl.isActiveTab(TAB_NEWS)) {
        markAllLoadedNewsAsRead();
      }
    }

    function normalizeIncomingNewsItem(item) {
      item = item || {};
      item.is_read = !!item.is_read;
      item._animateIn = false;
      return item;
    }

    function setNotificationCount(value, shouldAnimate) {
      var normalizedValue = parseInt(value, 10);
      if (isNaN(normalizedValue) || normalizedValue < 0) {
        normalizedValue = 0;
      }

      var hasChanged = normalizedValue !== $ctrl.notificationCount;
      $ctrl.notificationCount = normalizedValue;

      if (shouldAnimate && hasChanged && normalizedValue > 0) {
        triggerBadgeAnimation();
      }
    }

    function triggerBadgeAnimation() {
      $ctrl.badgeAnimate = false;
      $timeout(function () {
        $ctrl.badgeAnimate = true;
        $timeout(function () {
          $ctrl.badgeAnimate = false;
        }, 520);
      }, 0);
    }

    function clearIncomingAnimation(item) {
      $timeout(function () {
        if (item) {
          item._animateIn = false;
        }
      }, 560);
    }

    function attachNewsScrollListener() {
      $timeout(function () {
        var newsContainer = getNewsContainer();
        if (!newsContainer) {
          return;
        }

        if ($ctrl._newsScrollElement === newsContainer) {
          return;
        }

        detachNewsScrollListener();
        $ctrl._newsScrollHandler = function () {
          $ctrl.onNewsScroll(newsContainer);
        };
        newsContainer.addEventListener('scroll', $ctrl._newsScrollHandler, { passive: true });
        $ctrl._newsScrollElement = newsContainer;
      }, 0);
    }

    function detachNewsScrollListener() {
      if ($ctrl._newsScrollElement && $ctrl._newsScrollHandler) {
        $ctrl._newsScrollElement.removeEventListener('scroll', $ctrl._newsScrollHandler);
      }
      $ctrl._newsScrollElement = null;
      $ctrl._newsScrollHandler = null;
    }

    function getNewsContainer() {
      return $document[0].querySelector('.business-helper__news');
    }

    function mapInsights(payload) {
      var totalBookedOrders = parseInt(payload.last_week_booked_orders, 10) || 0;

      return [
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_INCOME'), value: formatCurrency(payload.last_week_income), icon: 'la-coins' },
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_BOOKED_ORDERS'), value: String(payload.last_week_booked_orders || 0), icon: 'la-calendar-check' },
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_NEW_CUSTOMER_ORDERS'), value: formatCountWithRatio(payload.new_customer_orders, totalBookedOrders), icon: 'la-user-plus' },
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_BOOKED_BY_BUSINESS'), value: formatCountWithRatio(payload.booked_by_business, totalBookedOrders), icon: 'la-briefcase' },
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_BOOKED_BY_ONLINE'), value: formatCountWithRatio(payload.booked_by_online, totalBookedOrders), icon: 'la-globe' },
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_BOOKED_BY_AI_AGENT'), value: formatCountWithRatio(payload.booked_by_ai_agent, totalBookedOrders), icon: 'ai-icon' },
        { label: $translate.instant('BUSINESS_HELPER_INSIGHT_CANCELED_ORDERS'), value: formatCountWithRatio(payload.canceled_orders, totalBookedOrders), icon: 'la-calendar-times' }
      ];
    }

    function formatCountWithRatio(value, total) {
      var count = parseInt(value, 10) || 0;
      var percentage = total > 0 ? Math.round((count / total) * 100) : 0;

      return String(count) + ' (' + percentage + '%)';
    }

    function formatCurrency(value) {
      var amount = parseFloat(value || 0);
      if (isNaN(amount)) {
        amount = 0;
      }
      return amount.toLocaleString('en-US') + '₪';
    }
  }
})();

(function () {
  'use strict';

  angular.module('app').component('businessHelper', {
    templateUrl: 'app/components/business-helper/business-helper.view.html',
    controller: 'BusinessHelperController'
  });
})();

(function () {
  'use strict';

  angular.module('app').controller('AiRenderController', AiRenderController);

  AiRenderController.$inject = ['$state', '$location', '$window', '$api', '$sce'];
  function AiRenderController($state, $location, $window, $api, $sce) {
    var vm = this;

    vm.hasChart = function () { return !!$window.Chart; };

    /* ==================== TABLE HELPERS ==================== */

    vm.TABLE_LIMIT = 20;

    vm.cell = function (rowArray, colIndex) {
      return (Array.isArray(rowArray) ? rowArray[colIndex] : null);
    };

    vm.normalizeRows = function (block) {
      var cols = block.columns || [];
      var colKeys = cols.map(function (c) {
        return c.key;
      });

      var rows = block.rows || [];
      if (!Array.isArray(rows)) {
        return [];
      }

      return rows.map(function (r) {
        if (Array.isArray(r)) {
          if (r.length < cols.length) {
            return r.concat(Array(cols.length - r.length).fill(null));
          }

          if (r.length > cols.length) {
            return r.slice(0, cols.length);
          }

          return r;
        } else if (r && typeof r === 'object') {
          return colKeys.map(function (k) {
            return Object.prototype.hasOwnProperty.call(r, k) ? r[k] : null;
          });
        }

        return Array(cols.length).fill(null);
      });
    };

    vm.visibleRows = function (block) {
      var norm = vm.normalizeRows(block);
      return norm.slice(0, vm.TABLE_LIMIT);
    };

    vm.isCustomersTable = function (block) {
      return !!(
        block &&
        block.type === 'table' &&
        block.row_link &&
        block.row_link.type === 'navigate' &&
        block.row_link.target === 'customer_detail' &&
        block.row_link.param_map &&
        typeof block.row_link.param_map.id === 'string'
      );
    };

    vm.formatCell = function (val, col) {
      var fmt = (col && col.format) || 'text';
      if (val == null) return '';
      switch (fmt) {
        case 'number':
          return formatNumber(val);
        case 'percent':
          return formatPercent(val);
        case 'currency':
          return formatCurrency(val, (col && col.currency) || null);
        case 'date':
          return formatDate(val);
        case 'datetime':
          return formatDateTime(val);
        default:
          return String(val);
      }
    };

    function formatNumber(x) {
      var n = Number(x);
      if (!isFinite(n)) {
        return String(x);
      }

      return n.toLocaleString();
    }

    function formatPercent(x) {
      var n = Number(x);
      if (!isFinite(n)) {
        return String(x);
      }

      return n.toLocaleString(undefined, { maximumFractionDigits: 2 }) + '%';
    }
    
    function formatCurrency(x, ccy) {
      var n = Number(x);
      if (!isFinite(n)) {
        return String(x);
      }

      try {
        return n.toLocaleString(undefined, { style: 'currency', currency: ccy || 'USD' });
      } catch (_) {
        return n.toLocaleString() + (ccy ? (' ' + ccy) : '');
      }
    }

    function formatDate(iso) {
      try {
        return new Date(iso).toLocaleDateString();
      } catch (_) {
        return String(iso);
      }
    }
    
    function formatDateTime(iso) {
      try {
        return new Date(iso).toLocaleString();
      } catch (_) {
        return String(iso);
      }
    }

    vm.onRowClick = function (block, rowArr) {
      if (!block || !block.row_link || block.row_link.type !== 'navigate') {
        return;
      }

      var cols = block.columns || [];
      var colIndexByKey = {};
      cols.forEach(function (c, i) {
        colIndexByKey[c.key] = i;
      });

      var params = {};
      var map = block.row_link.param_map || {};
      Object.keys(map).forEach(function (appParam) {
        var colKey = map[appParam];
        var idx = colIndexByKey[colKey];
        if (idx != null) {
          params[appParam] = rowArr[idx];
        }
      });

      navigate(block.row_link.target, params);
    };

    vm.extractAllIds = function (block) {
      try {
        var cols = block.columns || [];
        var idKey = (block.row_link && block.row_link.param_map && block.row_link.param_map.id) || 'id';
        var idIndex = cols.findIndex(function (c) { return c.key === idKey; });
        if (idIndex < 0) {
          return [];
        }

        var normAll = vm.normalizeRows(block);
        return normAll
          .map(function (row) { return row[idIndex]; })
          .filter(function (v) { return v != null && v !== ''; });
      } catch (e) {
        return [];
      }
    };

    vm.openCustomersList = function (block) {
      var ids = vm.extractAllIds(block);
      if (!ids.length) {
        navigate('customers', {});
        return;
      }

      navigate('customers', { ids: ids.join(',') });
    };

    /* ==================== ACTIONS ==================== */

    vm.onAction = function (a) {
      if (!a || a.type !== 'navigate') {
        return;
      }

      navigate(a.target, a.params || {});
    };

    var TARGET_TO_STATE = {
      customer_detail: { state: 'app.customers.single', params: ['id'] },
      customers: { state: 'app.customers', params: [] }
    };

    function navigate(target, params) {
      if (!target) {
        return;
      }

      var route = TARGET_TO_STATE[target];

      if (route && route.state) {
        var picked = {};
        (route.params || []).forEach(function (k) {
          if (params && params[k] != null) {
            picked[k] = params[k];
          }
        });

        $state.transitionTo(route.state, Object.keys(picked).length ? picked : params || {}, {
          reload: false
        });
        return;
      }

      if ($state && typeof $state.go === 'function') {
        $state.go(target, params || {});
        return;
      }

      var path = '/' + encodeURIComponent(target);
      $location.path(path).search(params || {});
    }

    /* ==================== LIST HELPERS ==================== */

    vm.safeHref = function (href) {
      if (typeof href !== 'string') {
        return null;
      }

      var ok = /^(https?:\/\/|mailto:|tel:|\/)/i.test(href);
      return ok ? href : null;
    };

    /* ==================== OTHER HELPERS ==================== */

    vm.onRate = function (value) {
      vm.meta.rating = value;
      $api.ai.feedback.save({ run_id: vm.meta.run_id, rating: value });
    };

    function normalizeText(s) {
      if (typeof s !== 'string') {
        return '';
      }

      return s.replace(/\s+/g, ' ').trim().toLowerCase();
    }

    vm.isDuplicateSummaryNote = function (block) {
      if (!block || block.type !== 'note') {
        return false;
      }

      var sum = (vm.data && vm.data.summary) ? normalizeText(vm.data.summary) : '';
      if (!sum) {
        return false;
      }

      var noteText = normalizeText(block.text);
      if (!noteText) {
        return false;
      }

      return sum === noteText;
    };

    vm.richText = function (s) {
      if (typeof s !== 'string' || !s) {
        return '';
      }

      var escaped = s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      escaped = escaped.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');

      escaped = escaped.replace(/\*(.+?)\*/g, '<i>$1</i>');

      escaped = escaped.replace(/`(.+?)`/g, '<code>$1</code>');

      escaped = escaped.replace(/->/g, '&rarr;');

      return $sce.trustAsHtml(escaped);
    };

      vm.stepText = function (step) {
        if (!step) {
          return '';
        }

        if (typeof step === 'string') {
          return step;
        }

        if (typeof step === 'object') {
          return step.text || step.label || '';
        }

        return String(step);
      };

      vm.stepHref = function (step) {
        if (!step || typeof step !== 'object') {
          return null;
        }

        if (step.href && vm.safeHref(step.href)) {
          return vm.safeHref(step.href);
        }

        return null;
      };
  }
})();

(function () {
  'use strict';

  angular.module('app').service('AiDialog', AiDialog);

  AiDialog.$inject = ['$rootScope', '$window', '$injector'];

  function AiDialog($rootScope, $window, $injector) {
    var $business = $injector.get('$business');

    var STORAGE_KEY = 'ai_dialog_state_v1';
    var MIN_POS = { insetInlineEnd: 24, bottom: 24 };

    var defaults = {
      visible: false,
      minimized: false,
      position: { insetInlineEnd: 24, bottom: 24 },
      size: { width: 480, height: 520 },
      bookingMode: false,
      bookingCustomerId: null,
      bookingAgentEnabled: false,
      _restore: null
    };

    function load() {
      try {
        var raw = $window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }

    function save() {
      if (!aiEnabled) {
        return;
      }

      try {
        $window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (e) {}
    }

    function clearSaved() {
      try {
        $window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }

    function normalizeState(s) {
      s = s || {};
      var out = angular.copy(defaults);
      Object.keys(s).forEach(function (k) {
        out[k] = s[k];
      });

      if (!out.position) {
        out.position = angular.copy(defaults.position);
      }

      if (!out.size) {
        out.size = angular.copy(defaults.size);
      }

      return out;
    }

    function enforceBookingAgentPolicy() {
      state.bookingAgentEnabled = bookingAgentEnabled;

      if (!bookingAgentEnabled) {
        state.bookingMode = false;
        state.bookingCustomerId = null;
      }
    }

    var state = normalizeState(load());

    var aiEnabled = ($business.ai && $business.ai.enabled === true);
    var bookingAgentEnabled = ($business.ai && $business.ai.booking_agent === true);

    enforceBookingAgentPolicy();

    if ($business.ai && $business.ai.enabled === false) {
      state = angular.copy(defaults);
      clearSaved();
    }

    enforceBookingAgentPolicy();

    var unwatch = $rootScope.$watch(function () { return $business.ai; }, function (ai) {
      if (!ai) {
        return;
      }

      if (ai.enabled === null) {
        return;
      }

      aiEnabled = (ai.enabled === true);
      bookingAgentEnabled = (ai.booking_agent === true);

      if (!aiEnabled) {
        state = angular.copy(defaults);
        clearSaved();
      } else {
        var persisted = load();
        if (persisted) {
          state = normalizeState(persisted);
        }
      }

      enforceBookingAgentPolicy();

      notify(true);
    }, true);
    
    function notify(skipSave) {
      $rootScope.$broadcast('AiDialog:change', angular.copy(state));

      if (!skipSave) {
        save();
      }
    }

    return {
      getState: function () {
        return angular.copy(state);
      },

      open: function () {
        state.visible = true;
        state.minimized = false;
        notify();
      },

      close: function () {
        state.visible = false;
        notify();
      },

      toggleMinimize: function () {
        if (!state.visible) {
          return;
        }

        if (!state.minimized) {
          state._restore = { position: angular.copy(state.position) };
          state.minimized = true;
          state.position = angular.copy(MIN_POS);
        } else {
          state.minimized = false;
          if (state._restore && state._restore.position) {
            state.position = state._restore.position;
          }
          state._restore = null;
        }
        notify();
      },

      setSize: function (w, h) {
        state.size = { width: w, height: h };
        notify();
      },

      setPosition: function (pos) {
        state.position = pos;
        notify();
      },

      toggleBookingMode: function () {
        if (!state.bookingAgentEnabled) {
          return;
        }

        state.bookingMode = !state.bookingMode;
        notify();
      },

      setBookingMode: function (val) {
        if (!state.bookingAgentEnabled) {
          state.bookingMode = false;
          state.bookingCustomerId = null;
          notify();
          return;
        }

        state.bookingMode = !!val;
        notify();
      },

      getBookingCustomerId: function () {
        return state.bookingCustomerId || null;
      },

      setBookingCustomerId: function (val) {
        var next = val ? parseInt(val, 10) : null;
        var prev = state.bookingCustomerId ? parseInt(state.bookingCustomerId, 10) : null;

        if (prev === next) {
          return;
        }

        state.bookingCustomerId = next;
        notify();
      },
    };
  }
})();

(function () {
  'use strict';

  angular.module('app')
    .directive('aiDialogOpen', aiDialogOpen)
    .directive('aiDialogToggleMin', aiDialogToggleMin)
    .directive('scrollBottom', scrollBottom)
    .directive('aiDialogDragResize', aiDialogDragResize)
    .directive('aiRender', aiRender)
    .directive('aiChart', aiChart);

  aiDialogOpen.$inject = ['AiDialog'];
  function aiDialogOpen(AiDialog) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        el.on('click', function () {
          scope.$applyAsync(function () { AiDialog.open(); });
        });
      }
    };
  }

  aiDialogToggleMin.$inject = ['AiDialog'];
  function aiDialogToggleMin(AiDialog) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        el.on('click', function () {
          scope.$applyAsync(function () { AiDialog.toggleMinimize(); });
        });
      }
    };
  }

  scrollBottom.$inject = ['$timeout'];
  function scrollBottom($timeout) {
    return {
      restrict: 'A',
      scope: {
        scrollBottom: '=',
        scrollBottomTrigger: '=?'
      },
      link: function (scope, el) {
        function doScroll() {
          $timeout(function () {
            var node = el[0];
            node.scrollTop = node.scrollHeight;

            $timeout(function () {
              node.scrollTop = node.scrollHeight;
            }, 50, false);
          }, 0, false);
        }

        scope.$watchCollection('scrollBottom', function () {
          doScroll();
        });

        scope.$watch('scrollBottomTrigger', function () {
          doScroll();
        });

        doScroll();
      }
    };
  }

  aiDialogDragResize.$inject = ['$window', '$document', 'AiDialog'];
  function aiDialogDragResize($window, $document, AiDialog) {
    return {
      restrict: 'A',
      link: function (scope, el) {
        var node = el[0];
        var header = node.querySelector('.ai-dialog__header');
        var resizer = node.querySelector('.ai-dialog__resize');

        function getDir() {
          var doc = $document[0];
          var body = doc && doc.body;
          if (body) {
            if (body.classList.contains('rtls')) {
              return 'rtl';
            }

            if (body.classList.contains('ltrs')) {
              return 'ltr';
            }
          }

          var htmlDir = (doc && doc.documentElement && doc.documentElement.getAttribute('dir')) || '';
          htmlDir = htmlDir.toLowerCase();
          if (htmlDir === 'rtl' || htmlDir === 'ltr') {
            return htmlDir;
          }

          return 'rtl';

        }

        function getState() {
          return AiDialog.getState();
        }

        function clamp(v, min, max) {
          return Math.max(min, Math.min(max, v));
        }

        var dragging = false, startX = 0, startY = 0, startInset = 0, startBottom = 0;

        function onDragStart(e) {
          var s = getState();
          if (!s.visible || s.minimized) {
            return;
          }
          dragging = true;

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          startX = evt.clientX;
          startY = evt.clientY;
          startInset = +s.position.insetInlineEnd || 0;
          startBottom = +s.position.bottom || 0;

          $document.on('mousemove', onDragMove);
          $document.on('mouseup', onDragEnd);
          $document.on('touchmove', onDragMove, { passive: false });
          $document.on('touchend', onDragEnd);
          node.classList.add('ai-dialog--dragging');
          e.preventDefault();
        }

        function onDragMove(e) {
          if (!dragging) {
            return;
          }

          var s = getState();
          var size = s.minimized ? { width: 56, height: 56 } : s.size;

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          var dx = evt.clientX - startX;
          var dy = evt.clientY - startY;

          var vw = $window.innerWidth;
          var vh = $window.innerHeight;

          var dir = getDir();
          var inset = (dir === 'ltr') ? (startInset - dx) : (startInset + dx);
          var bottom = startBottom - dy;

          var minInset = 8;
          var minBottom = 8;
          var maxInset = Math.max(minInset, vw - size.width - 8);
          var maxBottom = Math.max(minBottom, vh - size.height - 8);

          inset = Math.max(minInset, Math.min(maxInset, inset));
          bottom = Math.max(minBottom, Math.min(maxBottom, bottom));

          AiDialog.setPosition({ insetInlineEnd: Math.round(inset), bottom: Math.round(bottom) });
          e.preventDefault();
        }

        function onDragEnd() {
          if (!dragging) {
            return;
          }
          dragging = false;
          $document.off('mousemove', onDragMove);
          $document.off('mouseup', onDragEnd);
          $document.off('touchmove', onDragMove);
          $document.off('touchend', onDragEnd);
          node.classList.remove('ai-dialog--dragging');
        }

        if (header) {
          header.addEventListener('mousedown', onDragStart);
          header.addEventListener('touchstart', onDragStart, { passive: false });
        }

        var resizing = false, rStartX = 0, rStartY = 0, rStartW = 0, rStartH = 0, rStartInset = 0, rStartBottom = 0;

        function onResizeStart(e) {
          var s = getState();
          if (!s.visible || s.minimized) {
            return;
          }

          resizing = true;

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          rStartX = evt.clientX;
          rStartY = evt.clientY;

          rStartW = +s.size.width || 380;
          rStartH = +s.size.height || 520;
          rStartInset = +s.position.insetInlineEnd || 24;
          rStartBottom = +s.position.bottom || 24;

          $document.on('mousemove', onResizeMove);
          $document.on('mouseup', onResizeEnd);
          $document.on('touchmove', onResizeMove, { passive: false });
          $document.on('touchend', onResizeEnd);
          node.classList.add('ai-dialog--resizing');
          e.preventDefault();
        }

        function onResizeMove(e) {
          if (!resizing) {
            return;
          }

          var evt = e.type.startsWith('touch') ? e.touches[0] : e;
          var dx = evt.clientX - rStartX;
          var dy = evt.clientY - rStartY;

          var dir = getDir();

          var deltaInlineStart = (dir === 'ltr') ? -dx : dx;
          var deltaBlockStart = -dy;

          var newW = rStartW + deltaInlineStart;
          var newH = rStartH + deltaBlockStart;

          var vw = $window.innerWidth, vh = $window.innerHeight;

          var gapInlineStart = 8;
          var gapBlockStart = 8;
          var maxW = vw - rStartInset  - gapInlineStart;
          var maxH = vh - rStartBottom - gapBlockStart;

          var minW = 280, minH = 280;

          newW = Math.max(minW, Math.min(maxW, newW));
          newH = Math.max(minH, Math.min(maxH, newH));

          AiDialog.setSize(Math.round(newW), Math.round(newH));

          e.preventDefault();
        }

        function onResizeEnd() {
          if (!resizing) {
            return;
          }
          resizing = false;
          $document.off('mousemove', onResizeMove);
          $document.off('mouseup', onResizeEnd);
          $document.off('touchmove', onResizeMove);
          $document.off('touchend', onResizeEnd);
          node.classList.remove('ai-dialog--resizing');
        }

        if (resizer) {
          resizer.addEventListener('mousedown', onResizeStart);
          resizer.addEventListener('touchstart', onResizeStart, { passive: false });
        }

        scope.$on('$destroy', function () {
          if (header) {
            header.removeEventListener('mousedown', onDragStart);
            header.removeEventListener('touchstart', onDragStart);
          }

          if (resizer) {
            resizer.removeEventListener('mousedown', onResizeStart);
            resizer.removeEventListener('touchstart', onResizeStart);
          }

          onDragEnd();
          onResizeEnd();
        });
      }
    };
  }

  aiRender.$inject = [];
  function aiRender() {
    return {
      restrict: 'E',
      scope: { data: '=', meta: '=', bookingMode: '=?' },
      templateUrl: 'app/components/ai-dialog/ai-render.view.html',
      controller: 'AiRenderController',
      controllerAs: 'vm',
      bindToController: true
    };
  }

  aiChart.$inject = ['$window', '$timeout'];
  function aiChart($window, $timeout) {
    return {
      restrict: 'A',
      scope: { block: '=' },
      link: function (scope, element) {
        var canvas = element[0];
        var buildTimer = null;

        function getExistingChart() {
          if ($window.Chart && typeof $window.Chart.getChart === 'function') {
            return $window.Chart.getChart(canvas) || canvas.__chartInstance || null;
          }
          return canvas.__chartInstance || null;
        }

        function safeDestroy() {
          try {
            var existing = getExistingChart();
            if (existing && typeof existing.destroy === 'function') {
              existing.destroy();
            }
          } catch (e) { /* noop */ }
          canvas.__chartInstance = null;
        }

        function makePalette(n, base) {
          if (!n || n <= 0) {
            return [];
          }

          if (n === 1) {
            return [base || '#006495'];
          }

          var arr = [base || '#006495'];
          for (var i = 1; i < n; i++) {
            var hue = Math.floor((360 / n) * i);
            arr.push('hsl(' + hue + ' 60% 50%)');
          }
          return arr;
        }

        function blockToConfig(block) {
          var menu_color = ($window.appMenuColor || '#006495');
          var isRTL = ($window.langKey === 'hb_ISR' || $window.langKey === 'ar_AR');

          var kind = (block.kind || 'bar').toLowerCase();
          var xKey = block.xKey || null;
          var yKeys = Array.isArray(block.yKeys) && block.yKeys.length ? block.yKeys : null;
          var rows = Array.isArray(block.data) ? block.data : [];

          // ===== PIE / DOUGHNUT =====
          if (kind === 'pie') {
            var labels = [];
            var values = [];
            rows.forEach(function (r) {
              labels.push(String(xKey ? r[xKey] : r.label || ''));
              var val = 0;
              if (yKeys && yKeys.length) {
                val = Number(r[yKeys[0]] || 0);
              } else {
                Object.keys(r || {}).some(function (k) {
                  if (k === xKey) {
                    return false;
                  }
                  var n = Number(r[k]);
                  if (!isNaN(n)) {
                    val = n;
                    return true;
                  }
                  return false;
                });
              }
              values.push(val);
            });

            var colors = makePalette(values.length, menu_color);
            return {
              type: 'doughnut',
              data: {
                labels: labels,
                datasets: [{ label: '', data: values, backgroundColor: colors }]
              },
              options: {
                responsive: true,
                plugins: {
                  legend: {
                    position: 'bottom',
                    labels: { usePointStyle: true },
                    rtl: isRTL
                  },
                  tooltip: {
                    callbacks: {
                      label: function (ctx) {
                        var dataset = ctx.dataset;
                        var val = dataset.data[ctx.dataIndex];
                        var total = dataset.data.reduce(function (a, v) { return a + v; }, 0);
                        var pct = total ? ((val / total) * 100).toFixed() : 0;
                        return (ctx.label || '') + ': ' + val + ' (' + pct + '%)';
                      }
                    }
                  }
                }
              }
            };
          }

          // ===== BAR / LINE =====
          var labelsBL = [];
          if (xKey) {
            labelsBL = rows.map(function (r) { return String(r[xKey]); });
          } else {
            labelsBL = rows.map(function (_, i) { return String(i + 1); });
          }

          if (!yKeys) {
            var numericKeys = {};
            rows.forEach(function (r) {
              Object.keys(r || {}).forEach(function (k) {
                if (k === xKey) {
                  return;
                }
                var n = Number(r[k]);
                if (!isNaN(n)) {
                  numericKeys[k] = true;
                }
              });
            });
            yKeys = Object.keys(numericKeys);
            if (!yKeys.length) {
              yKeys = ['value'];
            }
          }

          var palette = makePalette(yKeys.length, menu_color);
          var isLine = (kind === 'line');
          var datasets = yKeys.map(function (yk, i) {
            return {
              label: yk,
              data: rows.map(function (r) { return Number(r[yk] || 0); }),
              backgroundColor: isLine ? 'transparent' : palette[i],
              borderColor: palette[i],
              maxBarThickness: isLine ? undefined : 60,
              type: isLine ? 'line' : 'bar',
              tension: isLine ? 0.3 : 0
            };
          });

          var baseOptions = {
            responsive: true,
            scales: {
              x: { grid: { display: false } },
              y: {}
            },
            borderRadius: isLine ? 0 : 6,
            plugins: {
              legend: {
                position: 'bottom',
                labels: { usePointStyle: true },
                rtl: isRTL
              },
              tooltip: {}
            }
          };

          return {
            type: isLine ? 'line' : 'bar',
            data: { labels: labelsBL, datasets: datasets },
            options: baseOptions
          };
        }

        function buildChart() {
          if (buildTimer) {
            $timeout.cancel(buildTimer);
          }

          buildTimer = $timeout(function () {
            if (!$window.Chart || !scope.block || !Array.isArray(scope.block.data)) {
              safeDestroy();
              return;
            }

            safeDestroy();

            var cfg = blockToConfig(scope.block);
            var ctx = canvas.getContext('2d');
            var chart = new $window.Chart(ctx, cfg);
            canvas.__chartInstance = chart;
          }, 0);
        }

        scope.$watch('block', buildChart, true);

        scope.$on('$destroy', function () {
          if (buildTimer) {
            $timeout.cancel(buildTimer);
          }
          safeDestroy();
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').controller('AiDialogController', AiDialogController);

  AiDialogController.$inject = ['$scope', '$rootScope', '$api', '$window', 'AiDialog'];

  function AiDialogController($scope, $rootScope, $api, $window, AiDialog) {
    var $ctrl = this;

    $ctrl.mounted = false;

    $ctrl.state = AiDialog.getState();
    $ctrl.customerId = ($ctrl.state && $ctrl.state.bookingCustomerId) ? parseInt($ctrl.state.bookingCustomerId, 10) : null;
    $ctrl.toggleMinimize = AiDialog.toggleMinimize;

    var unbind = $scope.$on('AiDialog:change', function (e, next) {
      var prevBooking = !!($ctrl.state && $ctrl.state.bookingMode);
      var nextBooking = !!(next && next.bookingMode);

      $ctrl.state = next;

      if (next && next.bookingCustomerId !== undefined && next.bookingCustomerId !== null) {
        $ctrl.customerId = parseInt(next.bookingCustomerId, 10) || $ctrl.customerId;
      }

      if (!prevBooking && nextBooking) {
        $ctrl.loadCustomers();
      }

      if (prevBooking !== nextBooking) {
        $ctrl.messages = [];
        $ctrl.loading = false;
        $ctrl.loadHistory();
      }

      $scope.$evalAsync();
    });
    $ctrl.$onDestroy = function () { unbind && unbind(); };

    $ctrl.messages = [];
    $ctrl.input = '';
    $ctrl.customers = [];
    $ctrl.customerOptions = [];

    function getSessionStorageKey() {
      return 'aiChatSessionId';
    }

    function getBookingSessionId() {
      var businessId = $rootScope.$id;
      var customerId = $ctrl.customerId || 0;

      var channel = 'chat_emulator';
      var channelChatId = 'customer:' + customerId;

      return 'b:' + businessId + '|ch:' + channel + '|chat:' + channelChatId;
    }

    function hasCustomer(id) {
      id = parseInt(id || 0, 10);
      if (!id) {
        return false;
      }

      return ($ctrl.customers || []).some(function (c) { return parseInt(c.id, 10) === id; });
    }

    function pickFirstCustomerId() {
      var first = ($ctrl.customers && $ctrl.customers.length) ? $ctrl.customers[0] : null;
      return first ? parseInt(first.id, 10) : null;
    }

    $ctrl.loadCustomers = function () {
      $api.customers.list.get(function (result) {
        var list = (result && Array.isArray(result.data)) ? result.data : [];
        $ctrl.customers = list;
        $ctrl.customerOptions = list.map(function (customer) {
          return {
            id: customer.id,
            name: $ctrl.customerLabel(customer)
          };
        });

        var nextId = $ctrl.customerId;

        if (!hasCustomer(nextId)) {
          nextId = pickFirstCustomerId();
        }

        var changed = parseInt($ctrl.customerId || 0, 10) !== parseInt(nextId || 0, 10);
        $ctrl.customerId = nextId;

        if (changed) {
          AiDialog.setBookingCustomerId(nextId);
        }

        if ($ctrl.state && $ctrl.state.bookingMode && changed) {
          $ctrl.messages = [];
          $ctrl.loading = false;
          $ctrl.loadHistory();
        }

        $scope.$applyAsync();
      });
    };

    $ctrl.ensureSessionId = function (isBooking) {
      if (isBooking) {
        return getBookingSessionId();
      }

      var LS_KEY = getSessionStorageKey();
      var id = $window.localStorage.getItem(LS_KEY);
      if (!id) {
        id = ($window.crypto && $window.crypto.randomUUID) ? $window.crypto.randomUUID() : (Date.now() + '-' + Math.random());
        $window.localStorage.setItem(LS_KEY, id);
      }
      return id;
    };

    var SESSION_ID = $ctrl.ensureSessionId(!!$ctrl.state.bookingMode);

    $ctrl.loadHistory = function () {
      var isBooking = !!$ctrl.state.bookingMode;
      SESSION_ID = $ctrl.ensureSessionId(isBooking);

      var okCallback = function (res) {
        if (res && res.success && res.data && Array.isArray(res.data.messages)) {
          $ctrl.messages = res.data.messages.map(function (m) {
            return m;
          });

          if ($ctrl.messages.length === 0) {
            $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
          }
        } else {
          if (!$ctrl.messages.length) {
            $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
          }
        }

        $scope.$applyAsync();
      };

      var failCallback = function(){
        if (!$ctrl.messages.length) {
          $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];
        }
      };

      if (!isBooking) {
        $api.ai.history.get({ session_id: SESSION_ID }, okCallback, failCallback);
        return;
      }

      $api.ai_booking_agent.history.get({ session_id: SESSION_ID }, okCallback, failCallback);
    }
    $ctrl.loadHistory();

    if ($ctrl.state && $ctrl.state.bookingMode) {
      $ctrl.loadCustomers();
    }

    $scope.$evalAsync(function () {
      $ctrl.mounted = true;
    });

    $ctrl.loading = false;

    $ctrl.send = function () {
      if ($ctrl.loading) {
        return;
      }

      if (!$ctrl.input.trim()) {
        return;
      }

      $ctrl.loading = true;
      $ctrl.messages.push({ role: 'user', text: $ctrl.input });

      var userText = $ctrl.input;
      $ctrl.input = '';

      var isBooking = !!$ctrl.state.bookingMode;
      SESSION_ID = $ctrl.ensureSessionId(isBooking);

      var callOk = function (res) {
        if (res && res.success) {
          $ctrl.messages.push({ role: 'assistant', render: res.data.render, meta: res.data.meta });
          $scope.$applyAsync();
        }
        $ctrl.loading = false;
      };

      var callFail = function () {
        $ctrl.loading = false;
      };

      if (!isBooking) {
        $api.ai.agent.save({ prompt: userText, session_id: SESSION_ID }, callOk, callFail);
        return;
      }

      if (!$ctrl.customerId) {
        $ctrl.loading = false;
        $ctrl.messages.push({ role: 'assistant', text: 'Please select a customer first.' });
        $scope.$applyAsync();
        return;
      }

      $api.ai_booking_agent.prompt.save({ prompt: userText, session_id: SESSION_ID, customer_id: $ctrl.customerId }, callOk, callFail);
    };

    $ctrl.toggleBookingMode = function () {
      AiDialog.toggleBookingMode();
      $ctrl.state = AiDialog.getState();

      if ($ctrl.state.bookingMode) {
        $ctrl.loadCustomers();
      }

      $ctrl.messages = [];
      $ctrl.loading = false;
      $ctrl.loadHistory();
    };

    $ctrl.customerLabel = function (c) {
      if (!c) {
        return '';
      }

      var name = (c.firstname || '') + (c.lastname ? (' ' + c.lastname) : '');
      name = (name || '').trim();
      return name;
    };

    $ctrl.onCustomerChange = function () {
      if (!$ctrl.state || !$ctrl.state.bookingMode) {
        return;
      }

      if (!$ctrl.customerId) {
        return;
      }

      AiDialog.setBookingCustomerId($ctrl.customerId);

      $ctrl.messages = [];
      $ctrl.loading = false;
      $ctrl.loadHistory();
    };

    $ctrl.onTextareaKeydown = function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        if (!e.shiftKey) {
          e.preventDefault();

          if ($ctrl.loading) {
            return;
          }

          if (($ctrl.input || '').trim()) {
            $ctrl.send();
          }
        }
      }
    };

    $ctrl.resetSession = function () {
      var isBooking = !!$ctrl.state.bookingMode;

      $ctrl.messages = [{ role: 'assistant', text: 'Hi! Iʼm ready to help 👋' }];

      if (!isBooking) {
        var key = getSessionStorageKey();
        $window.localStorage.removeItem(key);
        SESSION_ID = $ctrl.ensureSessionId(false);
        return;
      }

      if (!$ctrl.customerId) {
        return;
      }

      $ctrl.loading = true;

      SESSION_ID = $ctrl.ensureSessionId(true);

      $ctrl.messages.push({ role: 'user', text: '__RESET__' });

      $api.ai_booking_agent.prompt.save(
        { prompt: '__RESET__', session_id: SESSION_ID, customer_id: $ctrl.customerId },
        function (res) {
          if (res && res.success) {
            $ctrl.messages.push({ role: 'assistant', render: res.data.render, meta: res.data.meta });
            $scope.$applyAsync();
          }
          $ctrl.loading = false;
        },
        function () { $ctrl.loading = false; $scope.$applyAsync(); }
      );
    };

    function normalizeTextFromMessage(m) {
      if (!m) {
        return '';
      }

      if (m.text) {
        return String(m.text);
      }

      if (m.render) {
        if (Array.isArray(m.render.blocks)) {
          var bodies = [];

          m.render.blocks.forEach(function (b) {
            if (!b) {
              return;
            }

            if (typeof b.body === 'string' && b.body.trim()) {
              bodies.push(b.body.trim());
              return;
            }

            if (typeof b.text === 'string' && b.text.trim()) {
              bodies.push(b.text.trim());
            }
          });

          if (bodies.length) {
            return bodies.join('\n');
          }
        }

        if (typeof m.render.summary === 'string' && m.render.summary.trim()) {
          return m.render.summary.trim();
        }
      }

      return '';
    }

    function buildTranscriptFromPairs(messages, pairsLimit) {
      pairsLimit = parseInt(pairsLimit || 10, 10);

      var list = (messages || []).filter(function (m) {
        return m && (m.role === 'user' || m.role === 'assistant');
      });

      var pairsAll = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].role !== 'user') {
          continue;
        }

        var userMsg = list[i];
        var assistantMsg = null;

        for (var j = i + 1; j < list.length; j++) {
          if (list[j].role === 'assistant') {
            assistantMsg = list[j];
            break;
          }

          if (list[j].role === 'user') {
            break;
          }
        }

        pairsAll.push({ user: userMsg, assistant: assistantMsg });
      }

      var pairs = pairsAll.slice(Math.max(0, pairsAll.length - pairsLimit));

      var out = [];
      out.push('[Booking chat excerpt]');
      out.push('session_id=' + String(SESSION_ID || ''));
      out.push('customer_id=' + String($ctrl.customerId || ''));
      out.push('pairs=' + String(pairs.length));
      out.push('---');

      pairs.forEach(function (p) {
        var u = normalizeTextFromMessage(p.user).trim();
        var a = p.assistant ? normalizeTextFromMessage(p.assistant).trim() : '';

        out.push('User: ' + (u || '[empty]'));
        out.push('Assistant: ' + (a || '[empty]'));
      });

      return out.join('\n');
    }

    function copyToClipboard(text) {
      if ($window.navigator && $window.navigator.clipboard && $window.navigator.clipboard.writeText) {
        return $window.navigator.clipboard.writeText(text);
      }

      return new Promise(function (resolve, reject) {
        try {
          var ta = $window.document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.top = '-1000px';
          ta.style.left = '-1000px';
          $window.document.body.appendChild(ta);
          ta.select();
          var ok = $window.document.execCommand('copy');
          $window.document.body.removeChild(ta);
          ok ? resolve() : reject(new Error('copy failed'));
        } catch (e) {
          reject(e);
        }
      });
    }

    $ctrl.copyLastPairs = function () {
      if (!$ctrl.state || !$ctrl.state.bookingMode) {
        return;
      }

      var pairsLimit = 20;

      var text = buildTranscriptFromPairs($ctrl.messages, pairsLimit);

      copyToClipboard(text).then(function () {
        $ctrl.messages.push({ role: 'assistant', text: '✅ Copied last 20 pairs to clipboard.' });
        $scope.$applyAsync();
      }).catch(function () {
        $ctrl.messages.push({ role: 'assistant', text: '❌ Failed to copy. Please try another browser.' });
        $scope.$applyAsync();
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').component('aiDialog', {
    templateUrl: 'app/components/ai-dialog/ai-dialog.view.html',
    controller: 'AiDialogController'
  });
})();

angular.module("app.services").factory('$webview', ['$window', '$log', '$q', '$timeout', function($window, $log, $q, $timeout) {
  var pending = {};
  var listeners = {};
  var idCounter = 1;
  var DEFAULT_TIMEOUT = 15000;

  function post(msg) {
    var s = JSON.stringify(msg);
    if ($window.ReactNativeWebView && $window.ReactNativeWebView.postMessage) {
      try {
        $window.ReactNativeWebView.postMessage(s);
      } catch(e) {
        $log.warn('postMessage failed', e);
      }
    } else {
      if ($window._handleNativeMessage) {
        $log.warn('No ReactNativeWebView.postMessage available');
      }
    }
  }

  $window._handleNativeMessage = function(raw) {
    try {
      var msg = (typeof raw === 'string') ? JSON.parse(raw) : raw;
    } catch(e) {
      $log.warn('Invalid native message', raw);
      return;
    }

    if (msg.type === 'response') {
      var p = pending[msg.id];
      if (p) {
        $timeout.cancel(p.timer);
        if (msg.ok) {
          p.deferred.resolve(msg.data);
        } else {
          p.deferred.reject(msg.error || 'error');
        }
        delete pending[msg.id];
      }
      return;
    }

    if (msg.type === 'event' || msg.type === 'command') {
      var arr = listeners[msg.action] || [];
      arr.forEach(function(cb) {
        try {
          cb(msg.data);
        } catch(e) {
          $log.warn(e)
        }
      });
      return;
    }

    if (msg.type === 'request') {
      var handlerArr = listeners['__request__' + msg.action] || [];
      if (handlerArr.length) {
        try {
          var res = handlerArr[0](msg.data);
          $q.when(res).then(function(result) {
            post({ type:'response', action: msg.action, id: msg.id, ok: true, data: result });
          }, function(err){
            post({ type:'response', action: msg.action, id: msg.id, ok: false, error: (err && err.message)?err.message:String(err) });
          });
        } catch(err) {
          post({ type:'response', action: msg.action, id: msg.id, ok: false, error: (err && err.message)?err.message:String(err) });
        }
      } else {
        post({ type:'response', action: msg.action, id: msg.id, ok: false, error: 'no_handler' });
      }
      return;
    }
  };

  function request(action, data, timeout) {
    if (!detect()) {
      return $q.reject('not_webview');
    }
    var id = String(Date.now()) + '_' + (idCounter++);
    var deferred = $q.defer();
    var timer = $timeout(function() {
      delete pending[id];
      deferred.reject('timeout');
    }, timeout || DEFAULT_TIMEOUT);

    pending[id] = { deferred: deferred, timer: timer };
    post({ type: 'request', action: action, id: id, data: data });
    return deferred.promise;
  }

  function emit(action, data) {
    if (!detect()) {
      return;
    }

    post({ type: 'event', action: action, data: data });
  }

  function command(action, data) {
    if (!detect()) {
      return;
    }

    post({ type: 'command', action: action, data: data });
  }

  function onEvent(action, cb) {
    if (!listeners[action]) {
      listeners[action] = [];
    }

    listeners[action].push(cb);
    return function off() {
      listeners[action] = listeners[action].filter(function(x) {
        return x !== cb
      });
    }
  }

  function onRequest(action, cb) {
    var key = '__request__' + action;
    if (!listeners[key]) listeners[key] = [];
    listeners[key].push(cb);
    return function off() {
      listeners[key] = listeners[key].filter(function(x){ return x !== cb });
    }
  }

  function handshake() {
    if (detect()) {
      request('app:handshake').then(function(res) {
        console.log('Handshake response:', res);
      }).catch(function(e){ console.warn('No native app', e) });
    }
  }

  function localPush(title, body, data) {
    request('app:showLocalPush', {
      title: title,
      body: body,
      data: data
    }).then(function(res){
      console.log('[WEB] push shown:', res);
    }).catch(function(err){
      console.warn('[WEB] push failed:', err);
    });
  }

  function detect() {
    var ua = $window.navigator.userAgent || '';

    // RN WebView JS bridge
    if ($window.ReactNativeWebView) {
      return true;
    }

    // Android WebView has “; wv)” in its UA
    var isAndroidWV = /Android/.test(ua) && /; wv\)/.test(ua);

    // iOS WebView has AppleWebKit but NO Safari token
    var isIosWV =
      (/iPhone|iPad|iPod/.test(ua)) &&
      (/AppleWebKit/.test(ua)) &&
      !(/Safari/.test(ua));

    return isAndroidWV || isIosWV;
  }

  function isPdfUrl(url) {
    if (typeof url !== 'string') return false;

    var path = url.split(/[?#]/)[0].toLowerCase();
    return path.substr(path.length - 4) === '.pdf';
  }

  function isImageUrl(url) {
    if (typeof url !== 'string') return false;

    var path = url.split(/[?#]/)[0].toLowerCase();
    return /\.(png|jpg|jpeg|gif|webp|ico|avif|heic|heif|jfif|jxl|apng)$/.test(path);
  }

  return {
    isWebView: function() {
      return detect();
    },

    isPdfUrl: function (url) {
      return isPdfUrl(url);
    },

    isImageUrl: function (url) {
      return isImageUrl(url);
    },

    handshake: handshake,
    localPush: localPush,
    request: request,
    emit: emit,
    command: command,
    onEvent: onEvent,
    onRequest: onRequest
  };
}]);

(function() {
    
    angular.module("app.services").factory("$utils", function() {
            
        var $utils = this;

        /**
         * Escape HTML special characters to prevent XSS attacks
         * @param {string} str - The string to escape
         * @returns {string} - The escaped string
         */
        $utils.escapeHtml = function(str) {
            if (!str) return '';
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        return $utils;
    });
    
})();


(function(){
  
    angular.module("app.services").factory("$user", function ($rootScope, $api, $color, $cookies, $timeout, $state, $translate, $business, $webview, AnalyticsStorage){
      
        var $user = this;
        $rootScope.userRole = $cookies.get("role_id");
        $rootScope.version = null;
        $rootScope.isSidebarCollapsed = $cookies.get("isSidebarCollapsed") === "true" || false;
        window.isSidebarCollapsed = $rootScope.isSidebarCollapsed;

        // choosing Interface language
        // TODO: change to English for worldwide use
        $user.currentLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : 'hb_ISR';

        $rootScope.toggleSidebar = function() {
          $rootScope.isSidebarCollapsed = !$rootScope.isSidebarCollapsed;
          $cookies.put("isSidebarCollapsed", $rootScope.isSidebarCollapsed);
          window.isSidebarCollapsed = $rootScope.isSidebarCollapsed;
        };

        $user.getMessages = function() {
          $api.b_messages.get(function (response) {
              if (response.status == "success") {
                $rootScope.b_messages = response.data;
                $rootScope.$broadcast('b_messages_updated');

                if (response.version) {
                  if (!$rootScope.version) {
                    $rootScope.version = response.version;
                  } else if ($rootScope.version != response.version) {
                    location.reload(true);
                  }
                }
              }
            });
        }

        $user.getNotifications = function() {
          $api.notifications.dashboard.get(function (response) {
              if (response.status == "success") {
                $rootScope.notification_list = response.data;
                $rootScope.$broadcast('notifications_updated');
              }
            });
        }

        $user.getFilters = function() {
          $api.filters.get({}, function (response) {
              if (response.status == "success") {
                $rootScope.filters = response.data;
                for (var i in $rootScope.filters) {
                  if ($rootScope.filters[i].def) {
                    $rootScope[$rootScope.filters[i].module+'_filter'] = $rootScope.filters[i].data;
                  }
                }
                $rootScope.$broadcast('filters_updated');
              }
          });
        }

        $user.getLeadsCount = function() {
          $api.customers.leads_count.get({}, function (response) {
              if (response.status == "success") {

                if ($rootScope.leads_count != response.data) {
                  $rootScope.isBouncingLead = true;
                  $rootScope.leads_count = response.data;
                  $timeout(function() {
                    $rootScope.isBouncingLead = false;
                  }, 500);
                }
              }
          });
        }

        $user.updateDfAlertLastTime = function() {
          $api.digital_forms.update_last_time.save({ id: $rootScope.$user['b_id'] });
        }

        $user.getUncheckedFilledDfs = function() {
          $api.digital_forms.unchecked.save({ id: $rootScope.$user['b_id'] }, function (response) {
              if (response.status == "success" && response.data.length) {
                var html = '';
                for (key in response.data) {
                  var item = response.data[key];
                  html += '<div style="text-align: left;">' + $translate.instant('FORM_SHORT_FILLED_MESSAGE').replace(':name', item.name).replace(':customer_name', item.customer_name) + '</div>';
                }

                swal({
                  title: $translate.instant('FORM_FILLED_TITLE'),
                  html: html,
                  type: "success",
                });
              }
          });
        }

        $rootScope.generateUniqueId = function() {
            var randomPart = Math.random().toString(36).substr(2, 5);
            var timestampPart = new Date().getTime().toString(36);
            return randomPart + timestampPart;
        };

        $rootScope.listenPaymentIframe = function(hash) {
          var channel = (!pusher.channel('business-'+$rootScope.$user['b_id'])) ? pusher.subscribe('business-'+$rootScope.$user['b_id']) : pusher.channel('business-'+$rootScope.$user['b_id']);
          channel.bind('iframe-result-'+hash, function(response) {
            if (response) {
              if (response.result == 'success') {
                swal({
                  title: $translate.instant('SWAL_TRANSACTIONS_SAVE_TITLE'),
                  html: response.message ? response.message : '',
                  type: "success",
                  confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                  timer: 1500
                });
  
              } else if (response.result == 'error') {
                var message = $translate.instant('PELACARD_MESSAGE_DEFAULT');
  
                if (response.code && (response.code == "010" || response.code == "550" || response.code == "500" || response.code == "004" || response.code == "006")) {
                  message = $translate.instant('PELACARD_MESSAGE_'+response.code);
                }
  
                swal({
                    title: response.message ? response.message : message,
                    text: $translate.instant('SWAL_PELECARD_MESSAGE_TEXT'),
                    type: "warning",
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 3000
                });
              }
            }
  
          });
        }

        $rootScope.menuHide = function () {
          if (angular.element(document).width() < 769) {
            angular.element('body').addClass('mini-navbar');
          }
        }

        $rootScope.submitColors = function() {
          if ($rootScope.colorTimeout) {
            clearTimeout($rootScope.colorTimeout);
          }

          if ($rootScope.blockedColors) return;
        
          $rootScope.colorTimeout = setTimeout(function() {
            $rootScope.blockedColors = true;

            $api.settings.colors.save($rootScope.color_form, function(response){
              if(response.status === "success"){
                // less.modifyVars({
                //   '@menu-color': $rootScope.color_form.menu_color,
                //   '@online-color': $rootScope.color_form.online_color,
                //   '@online-text-color': $rootScope.color_form.online_text_color,
                //   '@back-color': $rootScope.color_form.back_color,
                //   //'@font-style': $user.currentLanguage != 'hb_ISR' ? "Manrope" : "Assistant",
                // });
                $rootScope.blockedColors = false;

                document.documentElement.style.setProperty('--menu-color', $rootScope.color_form.menu_color);
                document.documentElement.style.setProperty('--online-color', $rootScope.color_form.online_color);
                document.documentElement.style.setProperty('--online-text-color', $rootScope.color_form.online_text_color);
                document.documentElement.style.setProperty('--back-color', $rootScope.color_form.back_color);
                document.documentElement.style.setProperty('--calendar-color', $rootScope.color_form.calendar_color || '#fff');
                document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $rootScope.color_form.menu_color));
                document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $rootScope.color_form.back_color));
                document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.back_color));
                document.documentElement.style.setProperty('--calendar-stripe-color', $rootScope.color_form.calendar_stripe_color ? $rootScope.color_form.calendar_stripe_color : '#f7fafc');
              }
            });
          }, 50);
        }

        $rootScope.color_form = {
          back_color: '#F2F6FF',
          menu_color: '#216089',
          online_color: '#61B9A0',
          online_text_color: '#FFFFFF',
          switch_colors: false
        };

        function finalCallback(cb, result, response) {
          if (result) {
            $business.ai_fetch();
            $webview.request('app:getPushToken').then(function(response) {
              if (response && response.fcm_token) {
                $api.userDevices.save(response, function(res) {
                  console.log(res)
                }, function(res) {
                  console.log(res)
                });
              }
            });
          }
          cb(result, response);
        }

        function clearAnalyticsStorageState() {
          if (AnalyticsStorage && typeof AnalyticsStorage.clearAll === 'function') {
            AnalyticsStorage.clearAll();
          }
        }

        $user.isAuth = function (callback) {
          //need to check this new condition, because every time check isAuth not nice solution
          if ($rootScope.isAuth) {
            return finalCallback(callback, true);
          }

          $api.auth.get({}, function (response) {
            if (response.user) {
              $rootScope.$user = response.user;
              $rootScope.$user.user_acl = response.user_acl;
              $rootScope.default_screen = response.user.default_screen;

              $rootScope.color_form.back_color = response.user.back_color && response.user.back_color != '#D5DEFE' ? response.user.back_color : $rootScope.color_form.back_color;
              $rootScope.color_form.menu_color = response.user.menu_color ? response.user.menu_color : $rootScope.color_form.menu_color;
              $rootScope.color_form.online_color = response.user.online_color ? response.user.online_color : $rootScope.color_form.online_color;
              $rootScope.color_form.online_text_color = response.user.online_text_color ? response.user.online_text_color : $rootScope.color_form.online_text_color;
              $rootScope.color_form.switch_colors = response.user.switch_colors ? response.user.switch_colors : $rootScope.color_form.switch_colors;
              $rootScope.color_form.calendar_color = response.user.calendar_color && response.user.calendar_color != '#f2f2f2' ? response.user.calendar_color : '#fff';
              $rootScope.color_form.calendar_stripe_color = response.user.calendar_stripe_color ? response.user.calendar_stripe_color : '#f7fafc';
              $rootScope.color_form.calendar_event_color = response.user.calendar_event_color ? response.user.calendar_event_color : '#778899';


              document.documentElement.style.setProperty('--menu-color', $rootScope.color_form.menu_color);
              document.documentElement.style.setProperty('--online-color', $rootScope.color_form.online_color);
              document.documentElement.style.setProperty('--online-text-color', $rootScope.color_form.online_text_color);
              document.documentElement.style.setProperty('--back-color', $rootScope.color_form.back_color);
              document.documentElement.style.setProperty('--calendar-color', $rootScope.color_form.calendar_color || '#fff');
              document.documentElement.style.setProperty('--menu-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--menu-color-lighten-15', $color.pSBC(0.15, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--menu-color-lighten-10', $color.pSBC(0.1, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--menu-color-lighten-5', $color.pSBC(0.05, $rootScope.color_form.menu_color));
              document.documentElement.style.setProperty('--back-color-darken-1', $color.pSBC(-0.1, $rootScope.color_form.back_color));
              document.documentElement.style.setProperty('--back-color-darken-2', $color.pSBC(-0.2, $rootScope.color_form.back_color));
              document.documentElement.style.setProperty('--calendar-stripe-color', $rootScope.color_form.calendar_stripe_color);

              //temporary place for subscribe
              if (!pusher.channel('business-' + $rootScope.$user['b_id'])) {
                // If not subscribed, subscribe to the channel
                channel = pusher.subscribe('business-' + $rootScope.$user['b_id']);

                var isWebView = $webview.isWebView();

                if (!isWebView && $rootScope.$user['call_event_popup']) {
                  channel.bind('call-event', function(data) {
                    if (data.customer) {
                      swal({
                          title: "<b style='font-size: 20px'>"+$translate.instant('CALL_INCOMING')+"</b><br/>",
                          html: "<b style='font-size: 1.875em;'>"+data.customer.name+"</b><br />"+data.customer.phone,
                          imageUrl: '/assets/images/phone.png',
                          imageWidth: 100,
                          imageHeight: 100,
                          confirmButtonText: $translate.instant('CALL_ORDER'),
                          cancelButtonText: $translate.instant('CALL_CANCEL'),
                          showCancelButton: true,
                      }).then(function(result) {
                          if (result.value) {
                            $state.transitionTo("app.dashboard.load", {}, {reload: false})
                              .then(function() {
                                $state.transitionTo("app.calendar.call", {phone: data.customer.phone}, {reload: true});
                              });
                          } else {
                            
                          }
                      });
                    }
                  });
                }

                
                channel.bind('message-event', function(data) {
                  //double check
                  if (data && data.b_id == $rootScope.$user['b_id']) {
                    $user.getMessages();
                  }
                });

                channel.bind('notifications-event', function(data) {
                  //double check
                  if (data && data.b_id == $rootScope.$user['b_id']) {
                    $user.getNotifications();
                  }
                });

                channel.bind('leads-count-event', function(data) {
                  if (data && data.b_id == $rootScope.$user['b_id']) {
                    $user.getLeadsCount();
                  }
                });

                
                channel.bind('form-filled-v2', function(response) {
                    console.log('form-filled-v2', response);
                    if (response) {
                      if (response.result == 'success') {
                        if (!isWebView) {
                          swal({
                              title: response.customer_name,
                              text: $translate.instant(response.type.toUpperCase() + '_FILLED_MESSAGE').replace(':name', response.name),
                              type: "success",
                              timer: 5000,
                          });
                        }

                        $user.updateDfAlertLastTime();
                      }
                    }
                });
              }

              if ($rootScope.$user['favicon_path']) {
                $('#favicon').attr('href', $rootScope.$user['favicon_path']+'favicon.ico');
                $('#favicon-16').attr('href', $rootScope.$user['favicon_path']+'favicon-16.png');
                $('#favicon-32').attr('href', $rootScope.$user['favicon_path']+'favicon-32.png');
                $('#favicon-64').attr('href', $rootScope.$user['favicon_path']+'favicon-64.png');
              }

              //bug
              if ($rootScope.$user) {
                $rootScope.userRole = response.user.role;
                if(angular.isDefined(response.user.cashbox_available)) {
                  $rootScope.cashbox_available = response.user.cashbox_available;
                }
                if(angular.isDefined(response.user.permissions)) {
                  $rootScope.employee_permissions = response.user.permissions;
                }
                if(angular.isDefined(response.user.manage_leads)) {
                  $rootScope.manage_leads = response.user.manage_leads;
                }
                if(angular.isDefined(response.user.show_notes_page)) {
                  $rootScope.show_notes_page = response.user.show_notes_page;
                }
                if(angular.isDefined(response.user.show_digital_forms_page)) {
                  $rootScope.show_digital_forms_page = response.user.show_digital_forms_page;
                }
                if(angular.isDefined(response.user.customer_wa_chat)) {
                  $rootScope.customer_wa_chat = response.user.customer_wa_chat;
                }
                if(angular.isDefined(response.user.cashbox_discount)) {
                  $rootScope.cashbox_discount = response.user.cashbox_discount;
                }
                if(angular.isDefined(response.user.lead_appearence)) {
                  $rootScope.lead_appearence = response.user.lead_appearence;
                }
                if(angular.isDefined(response.user.display_order_user)) {
                  $rootScope.display_order_user = response.user.display_order_user;
                }
                if(angular.isDefined(response.user.display_one_block_services)) {
                  $rootScope.display_one_block_services = response.user.display_one_block_services;
                }

                if(angular.isDefined(response.user.display_hebrew_dates)) {
                  $rootScope.display_hebrew_dates = response.user.display_hebrew_dates;
                }
                if(angular.isDefined(response.user.ai_agent_booking)) {
                  $rootScope.ai_agent_booking = response.user.ai_agent_booking;
                }
              }
              //end-bug
            } else {
              $cookies.remove("email");
              $cookies.remove("pass");
              $cookies.remove("hash");
              $cookies.remove("role_id");
              $cookies.remove("token");
              localStorage.removeItem('tiffulit-user-role');
              clearAnalyticsStorageState();
              $rootScope.$user = undefined;
              $rootScope.userRole = undefined;
              $rootScope.ai_agent_booking = false;
            }
            $rootScope.isAuth = response.is_auth;

            if (response.status == "success" && response.is_auth) {
              return $user.getAllACLs(function () {
                $user.getUncheckedFilledDfs();
                finalCallback(callback, true);
              });
            }

            return finalCallback(callback, false);
          });
        };

        $user.login = function (creds, callback) {
            $api.auth.save(creds, function (response) {
                if(response.mfa_required){
                  return finalCallback(callback, false, response);
                }
                if(response.status == "success"){
                  if (response.is_auth) {
                    var options = {};
                    options.expires = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
                    //$cookies.put("email", response.email, options);
                    //$cookies.put("pass", response.pass, options);
                    //$cookies.put("hash", response.hash, options);
                    $cookies.put("token", response.token, options);
                    $cookies.put("role_id", response.role_id, options);
                    $rootScope.userRole = response.role_id;
                    $rootScope.employee_permissions = response.permissions ? response.permissions : false
                    $rootScope.cashbox_available = response.cashbox_available;
                    $rootScope.manage_leads = response.manage_leads;
                    $rootScope.ai_agent_booking = response.ai_agent_booking;
                    $rootScope.show_notes_page = response.show_notes_page;
                    $rootScope.show_digital_forms_page = response.show_digital_forms_page;
                    $rootScope.default_screen = response.default_screen;
                    $rootScope.display_order_user = response.display_order_user;
                    $rootScope.display_one_block_services = response.display_one_block_services;
                    $rootScope.display_hebrew_dates = response.display_hebrew_dates;
                    if(response.language_code) {
                        $rootScope.changeLanguage(response.language_code);
                    }
                    //$user.getMessages();
                    //$user.getFilters();
                  } else {
                    $cookies.remove("email");
                    $cookies.remove("pass");
                    $cookies.remove("hash");
                    $cookies.remove("role_id");
                    $cookies.remove("token");
                    localStorage.removeItem('tiffulit-user-role');
                    clearAnalyticsStorageState();
                    $rootScope.isAuth = false;
                    $rootScope.$user = undefined;
                    $rootScope.userRole = undefined;
                    $rootScope.ai_agent_booking = false;
                  }
                    
                  return $user.getAllACLs(function () { finalCallback(callback, response.is_auth) });
                }
                return finalCallback(callback, false, response);
            });
        };

        $user.logout = function(){
          $webview.request('app:revokePushToken').then(function(res){
            if (res && res.fcm_token) {
              $api.userDevices.revoke.save({ fcm_token: res.fcm_token }, function(){}, function(){});
            }
          }).catch(function(){ }).finally(function(){
              if ($rootScope && $rootScope.$user && $rootScope.$user['b_id']) {
                if (pusher.channel('business-'+$rootScope.$user['b_id'])) {
                  pusher.unsubscribe('business-'+$rootScope.$user['b_id']);
                }
              }
              $api.auth.logout.save({}, function (response) {
                $cookies.remove("email");
                $cookies.remove("pass");
                $cookies.remove("hash");
                $cookies.remove("role_id");
                $cookies.remove("token");
                localStorage.removeItem('tiffulit-user-role');
                clearAnalyticsStorageState();
                
                $rootScope.isAuth = false;
                $rootScope.$user = undefined;
                $rootScope.userRole = undefined;
                $rootScope.ai_agent_booking = false;
                $rootScope.header_businesses = undefined;
                $rootScope.header_businesses_loaded = false;
                $rootScope.header_businesses_loading = false;
                if ($rootScope.wa_status_interval) {
                    clearInterval($rootScope.wa_status_interval);
                    $rootScope.wa_status_interval = null;
                }
                $rootScope.wa_status = undefined;
                $rootScope.wa_status_loaded = false;
                $rootScope.wa_status_loading = false;
                $rootScope.wa_qr_code = false;
                $state.go("login");
              });

              $business.ai_reset();
            });
        };

        $user.changeLanguage = function(langKey){
            $translate.use(langKey);
            $rootScope.currentLanguage = langKey;
            $rootScope.langKey = langKey;
            window.langKey = langKey;
            $rootScope.$emit('change-language', langKey);
            localStorage.setItem('language', langKey);
        };

      /**
       * Get all Access Control List for users
       *
       * @param callback
       */
        $user.getAllACLs = function (callback) {
          $api.all_acls.get(function (response) {
            if (response.status == "success") {
              $rootScope.users_acl = response.roles_acls;
              callback();
            }
          });

          if ($rootScope.$user && $rootScope.$user['b_id']) {
            $user.getMessages();
            $user.getFilters();
            $user.getLeadsCount();
            $user.getNotifications();
            $business.loadLaserCategories();
          }
        }

      /**
       * Redirects User to appropriate login screen
       */
      $user.go_default_screen = function () {
          if($rootScope.default_screen == "Dashboard")
            $timeout(function() { $state.go("app.dashboard"); });
          else if($rootScope.default_screen == "Calendar")
            $timeout(function() { $state.go("app.calendar"); });
          else if($rootScope.default_screen == "Calendar-Daily")
            $timeout(function() { $state.go("app.calendar.login", {view: 'view'}); });
          else if($rootScope.default_screen == "Calendar-Weekly")
            $timeout(function() { $state.go("app.calendar.login", {view: 'view'}); });
          else if($rootScope.default_screen == "Calendar-Monthly")
            $timeout(function() { $state.go("app.calendar.login"); });
          else if($rootScope.default_screen == "Calendar-Orders")
            $timeout(function() { $state.go("app.calendar.login"); });
          else if($rootScope.default_screen == "Calendar-Occupation")
            $timeout(function() { $state.go("app.calendar.login"); });
          else if($rootScope.default_screen == "Businesses")
            $timeout(function() { $state.go("app.admin"); });
          else if($rootScope.default_screen == "Cashbox")
            $timeout(function() { $state.go("app.cashbox"); });
          else if($rootScope.default_screen == "Customers")
            $timeout(function() { $state.go("app.customers"); });
          else if($rootScope.default_screen == "Leads")
            $timeout(function() { $state.go("app.leads"); });
          else if($rootScope.default_screen == "Marketing")
            $timeout(function() { $state.go("app.marketing"); });
          else if($rootScope.default_screen == "Business Analysis")
            $timeout(function() { $state.go("app.analytics"); });
          else if($rootScope.default_screen == "Reports")
            $timeout(function() { $state.go("app.reports"); });
          else if($rootScope.default_screen == "Workers")
            $timeout(function() { $state.go("app.workers"); });
          else if($rootScope.default_screen == "Business Settings")
            $timeout(function() { $state.go("app.settings"); });
        }

      /**
       * Verifies if user has permission to view the section
       *
       * @param section
       * @returns {boolean}
       */
        $rootScope.isUserAllowedAccess = function (section) {
          var is_allowed = false;
          if($rootScope && $rootScope !== undefined && $rootScope.users_acl !== undefined && $rootScope.users_acl[section] !== undefined) {
            var section_key = $rootScope.users_acl[section].key;
            var permissions = $rootScope.$user ? $rootScope.$user.user_acl : {};
            if (angular.isDefined(permissions.allowed)) {
              permissions.allowed.forEach(function (permission) {
                if (permission['key'] === section_key) {
                  is_allowed = true;
                }
              });
            } else if (angular.isDefined(permissions.forbidden)) {
              is_allowed = true;
              permissions.forbidden.forEach(function (permission) {
                if (permission['key'] === section_key) {
                  is_allowed = false;
                }
              });
            }
          } else {
            is_allowed = true;
          }


          // when allowed check also employee permissions
          if (is_allowed) {
            if ($rootScope.userRole == 3) {
              if ($rootScope.employee_permissions && $rootScope.employee_permissions[section]) {
                is_allowed = $rootScope.employee_permissions[section].enabled;
              } else {
                is_allowed = false;
              }
            }
          }

          return is_allowed;
        }


        return $user;
    });
})();

(function() {

  angular.module("app.services").factory("$tiff_page", function() {
    var srv = this;

    srv.loading_stack = [];

    /**
     * Start loading with special key
     * @param loading_name
     */
    srv.start_loading = function (loading_name) {
      if(srv.loading_stack.length == 0) {
        angular.element(document.querySelector( 'body' )).addClass('loading_foreground');
      }
      srv.loading_stack.push(loading_name);
    }

    /**
     * Stop showing loading foreground if all loading stack is empty.
     * Or just remove one of key from loading stack
     * @param loading_name
     */
    srv.stop_loading = function (loading_name) {
      var index = srv.loading_stack.indexOf(loading_name);
      if(index !== -1) {
        srv.loading_stack.splice(index, 1);
      }
      if(srv.loading_stack.length == 0) {
        angular.element(document.querySelector( 'body' )).removeClass('loading_foreground');
      }
    }

    return srv;
  });

})();

(function() {

    angular.module("app.services").factory("$payment", function() {

        /**
         * Return all payment method that can be use in cashbox.
         *
         * @type {{credit_card: {code: number, label: string}, bank_transfer: {code: number, label: string}, cheque: {code: number, label: string}, credit_card_external: {code: number, label: string}, oncredit: {code: number, label: string}, cash: {code: number, label: string}}}
         */
        this.methods = {
            oncredit: {label: 'CALENDAR_CASH_ON_CREDIT', code: 3},
            cash: {label: 'CALENDAR_CASH_CASH', code: 1},
            cheque: {label: 'CALENDAR_CASH_CHEQUE', code: 4},
            credit_card_external: {label: 'CALENDAR_CASH_CREDIT_CARD_EXT', code: 6},
            bank_transfer: {label: 'CALENDAR_CASH_BANK_TRANS', code: 5},
            credit_card: {label: 'ADMIN_CREDIT_CARD', code: 2},
            credit_card_env: {label: 'CREDIT_CARD_ENV', code: 7},
            pay_link: {label: 'CALENDAR_PAY_LINK', code: 9},
        };

        return this;
    });

})();

(function() {
    
    angular.module("app.services").factory("$notify", function(notify) {
        
        return function(message, type) {
            
            return notify({ 
                message: message, 
                classes: 'alert-' + type, 
                templateUrl: "app/components/common/notify.html"
            });
        };
    });
    
})();
(function() {

  angular.module("app.services").factory("$minimizableModal", function($rootScope, $uibModal) {
    var srv = this;

    function resolveValue(value) {
      return function() {
        return value;
      };
    }

    function buildResolve(resolveData) {
      var resolve = {};

      for (var key in resolveData) {
        if (resolveData.hasOwnProperty(key)) {
          resolve[key] = resolveValue(resolveData[key]);
        }
      }

      return resolve;
    }

    srv.minimize = function(config, dismiss) {
      $rootScope.minimizedModal = config;

      if (dismiss) {
        dismiss('minimized');
      }
    };

    srv.restore = function() {
      var modal = $rootScope.minimizedModal;

      if (!modal) {
        return;
      }

      $rootScope.minimizedModal = null;

      $uibModal.open({
        templateUrl: modal.templateUrl,
        controller: modal.controller,
        controllerAs: modal.controllerAs || "ctrl",
        windowTopClass: modal.windowTopClass || "form-modal medium-modal laser-file-modal minimizable-modal",
        backdrop: modal.backdrop || "static",
        keyboard: modal.keyboard === true,
        resolve: buildResolve(modal.resolve || {})
      });
    };

    return srv;
  });

})();

(function() {
    'use strict';

    angular.module('app.services')
        .service('HebrewDate', function() {
            
            // Hebrew month names
            var hebrewMonths = [
                'תשרי', 'חשון', 'כסלו', 'טבת', 'שבט', 'אדר',
                'ניסן', 'אייר', 'סיון', 'תמוז', 'אב', 'אלול'
            ];

            // English transliterations of Hebrew month names
            var englishHebrewMonths = [
                'Tishri', 'Cheshvan', 'Kislev', 'Tevet', 'Shevat', 'Adar',
                'Nisan', 'Iyar', 'Sivan', 'Tammuz', 'Av', 'Elul'
            ];

            // Hebrew day names
            var hebrewDays = [
                'ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'
            ];

            // Hebrew numerals for days
            var hebrewNumerals = [
                '', 'א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ז׳', 'ח׳', 'ט׳', 'י׳',
                'י״א', 'י״ב', 'י״ג', 'י״ד', 'ט״ו', 'ט״ז', 'י״ז', 'י״ח', 'י״ט', 'כ׳',
                'כ״א', 'כ״ב', 'כ״ג', 'כ״ד', 'כ״ה', 'כ״ו', 'כ״ז', 'כ״ח', 'כ״ט', 'ל׳'
            ];

            // jewish-date-browser.js monthName values -> Hebrew display (incl. leap Adar)
            var jewishLibMonthToHebrew = {
                Tishri: 'תשרי',
                Cheshvan: 'חשון',
                Kislev: 'כסלו',
                Tevet: 'טבת',
                Shevat: 'שבט',
                Adar: 'אדר',
                AdarI: 'אדר א׳',
                AdarII: 'אדר ב׳',
                Nisan: 'ניסן',
                Iyyar: 'אייר',
                Sivan: 'סיון',
                Tammuz: 'תמוז',
                Av: 'אב',
                Elul: 'אלול'
            };

            // Same -> English transliteration (matches existing englishHebrewMonths style + leap months)
            var jewishLibMonthToEnglish = {
                Tishri: 'Tishri',
                Cheshvan: 'Cheshvan',
                Kislev: 'Kislev',
                Tevet: 'Tevet',
                Shevat: 'Shevat',
                Adar: 'Adar',
                AdarI: 'Adar I',
                AdarII: 'Adar II',
                Nisan: 'Nisan',
                Iyyar: 'Iyar',
                Sivan: 'Sivan',
                Tammuz: 'Tammuz',
                Av: 'Av',
                Elul: 'Elul'
            };

            // Check if jewish-date library is available
            var jewishDateLib = null;
            
            // Try to access the library from different possible locations
            if (typeof window !== 'undefined') {
                if (window.jewishDate) {
                    jewishDateLib = window.jewishDate;
                } else if (window.jewishDateLib) {
                    jewishDateLib = window.jewishDateLib;
                }
            }

            // Accurate Hebrew date conversion using the jewish-date library
            function accurateGregorianToHebrew(gregorianDate) {
                // Try to use the jewish-date library if available
                if (jewishDateLib && typeof jewishDateLib.toJewishDate === 'function') {
                    try {
                        var jewishDate = jewishDateLib.toJewishDate(gregorianDate);
                        var monthKey = jewishDate.monthName;
                        var hebrewMonthLabel = jewishLibMonthToHebrew[monthKey] || monthKey;
                        var englishMonthLabel = jewishLibMonthToEnglish[monthKey] || monthKey;

                        return {
                            year: jewishDate.year,
                            month: jewishDate.month,
                            day: jewishDate.day,
                            monthName: hebrewMonthLabel,
                            englishMonthName: englishMonthLabel,
                            dayName: hebrewDays[gregorianDate.getDay()]
                        };
                    } catch (error) {
                        console.warn('Error using jewish-date library, falling back to approximation:', error);
                    }
                }
                
                // Fallback to simple approximation if library is not available
                return gregorianToHebrew(gregorianDate);
            }

            // Simple Hebrew date conversion (fallback approximation)
            function gregorianToHebrew(gregorianDate) {
                var year = gregorianDate.getFullYear();
                var month = gregorianDate.getMonth() + 1;
                var day = gregorianDate.getDate();
                
                // This is a simplified conversion - for production use, 
                // a proper Hebrew calendar library like jewish-date should be used
                var hebrewYear = year + 3760; // Approximate conversion
                
                // Calculate Hebrew month and day (simplified)
                var hebrewMonth = month;
                var hebrewDay = day;
                
                // Adjust for Hebrew calendar differences
                if (month >= 9) {
                    hebrewMonth = month - 8;
                } else {
                    hebrewMonth = month + 4;
                }
                
                return {
                    year: hebrewYear,
                    month: hebrewMonth,
                    day: hebrewDay,
                    monthName: hebrewMonths[hebrewMonth - 1],
                    englishMonthName: englishHebrewMonths[hebrewMonth - 1],
                    dayName: hebrewDays[gregorianDate.getDay()]
                };
            }

            // English day names
            var englishDays = [
                'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
            ];

            // Get English date string with Hebrew month name
            function getEnglishDateString(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);
                var englishDayName = englishDays[gregorianDate.getDay()];
                var gregorianDateStr = (gregorianDate.getDate() < 10 ? '0' : '') + gregorianDate.getDate() + 
                                    '/' + 
                                    ((gregorianDate.getMonth() + 1) < 10 ? '0' : '') + (gregorianDate.getMonth() + 1) + 
                                    '/' + 
                                    gregorianDate.getFullYear();
                
                var englishHebrewMonthName = hebrewDate.englishMonthName ||
                    englishHebrewMonths[hebrewDate.month - 1] ||
                    hebrewDate.monthName;
                
                // Format: English day name, Gregorian date / English Hebrew month name
                return englishDayName + ', ' + gregorianDateStr + ' / ' + englishHebrewMonthName;
            }

            // Get Hebrew date string in the requested format
            function getHebrewDateString(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);
                var hebrewDayName = hebrewDays[gregorianDate.getDay()];
                var gregorianDateStr = (gregorianDate.getDate() < 10 ? '0' : '') + gregorianDate.getDate() + 
                                    '/' + 
                                    ((gregorianDate.getMonth() + 1) < 10 ? '0' : '') + (gregorianDate.getMonth() + 1) + 
                                    '/' + 
                                    gregorianDate.getFullYear();
                
                // Get Hebrew numeral for the day
                var hebrewDayNumeral = hebrewNumerals[hebrewDate.day] || hebrewDate.day;
                // Format: Hebrew day name, Gregorian date / Hebrew day numeral + Hebrew month name
                return hebrewDayName + ', ' + gregorianDateStr + ' / ' + hebrewDayNumeral + ' ' + hebrewDate.monthName;
            }

            function getEnglishDateName(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);

                var englishHebrewMonthName = hebrewDate.englishMonthName ||
                    englishHebrewMonths[hebrewDate.month - 1];

                return englishHebrewMonthName;
            }

            function getHebrewDateName(gregorianDate) {
                var hebrewDate = accurateGregorianToHebrew(gregorianDate);
                var hebrewDayNumeral = hebrewNumerals[hebrewDate.day] || hebrewDate.day;
                
                return hebrewDayNumeral + ' ' + hebrewDate.monthName;
            }

            // Get Hebrew format date string - detects language and returns appropriate format
            function getHebrewFormatDateString(gregorianDate) {
                // Check if we're in Hebrew language
                if (window.langKey === 'hb_ISR') {
                    return getHebrewDateString(gregorianDate);
                } else {
                    return getEnglishDateString(gregorianDate);
                }
            }

            function getHebrewFormatDateName(gregorianDate) {
                if (window.langKey === 'hb_ISR') {
                    return getHebrewDateName(gregorianDate);
                } else {
                    return getEnglishDateName(gregorianDate);
                }
            }

            return {
                gregorianToHebrew: gregorianToHebrew,
                accurateGregorianToHebrew: accurateGregorianToHebrew,
                getEnglishDateString: getEnglishDateString,
                getHebrewDateString: getHebrewDateString,
                getHebrewFormatDateString: getHebrewFormatDateString,
                getHebrewFormatDateName: getHebrewFormatDateName,
                hebrewMonths: hebrewMonths,
                englishHebrewMonths: englishHebrewMonths,
                hebrewDays: hebrewDays,
                hebrewNumerals: hebrewNumerals
            };
        });

})();

(function () {
    'use strict';

    angular.module('app.services')
        .service('GoogleCalendarService', ['$q', '$window', '$http', '$api', '$rootScope', function ($q, $window, $http, $api, $rootScope) {
            var service = this;
            // Google Calendar API configuration - will be loaded from user config
            var CLIENT_ID = null;
            var DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';
            var SCOPES = null;
            var GOOGLE_API_SCRIPT = 'https://apis.google.com/js/api.js';
            var GOOGLE_GIS_SCRIPT = 'https://accounts.google.com/gsi/client';
            
            // Development configuration
            var isDevelopment = $window.location.hostname === 'localhost' || $window.location.hostname === '127.0.0.1';

            var gapi = null;
            var google = null;
            var isInitialized = false;
            var isGisLoaded = false;

            /**
             * Load configuration from user data
             */
            function loadConfiguration() {
                if ($rootScope.$user && $rootScope.$user.google_calendar_config) {
                    CLIENT_ID = $rootScope.$user.google_calendar_config.client_id;
                    SCOPES = $rootScope.$user.google_calendar_config.scopes.join(' ');
                    return true;
                }
                return false;
            }

            /**
             * Initialize Google API with new Google Identity Services
             */
            service.initialize = function () {
                var deferred = $q.defer();
                
                if (isInitialized) {
                    deferred.resolve();
                    return deferred.promise;
                }

                // Load configuration first
                if (!loadConfiguration()) {
                    return deferred.reject('Google Calendar configuration not found');
                }

                // Load Google Identity Services first
                loadGoogleIdentityServices().then(function() {
                    // Then load Google API client
                    return loadGoogleApiClient();
                }).then(function() {
                    isInitialized = true;
                    console.log('Google API initialized successfully with new Google Identity Services');
                    deferred.resolve();
                }).catch(function(error) {
                    console.error('Error initializing Google API:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Load Google Identity Services
             */
            function loadGoogleIdentityServices() {
                var deferred = $q.defer();
                
                if (isGisLoaded && $window.google) {
                    google = $window.google;
                    deferred.resolve();
                    return deferred.promise;
                }

                // Load Google Identity Services script
                var script = document.createElement('script');
                script.src = GOOGLE_GIS_SCRIPT;
                script.onload = function() {
                    google = $window.google;
                    isGisLoaded = true;
                    console.log('Google Identity Services loaded');
                    deferred.resolve();
                };
                script.onerror = function() {
                    deferred.reject('Failed to load Google Identity Services');
                };
                document.head.appendChild(script);

                return deferred.promise;
            }

            /**
             * Load Google API Client
             */
            function loadGoogleApiClient() {
                var deferred = $q.defer();
                
                if (typeof $window.gapi !== 'undefined') {
                    gapi = $window.gapi;
                    initializeGapiClient();
                } else {
                    // Load Google API script
                    var script = document.createElement('script');
                    script.src = GOOGLE_API_SCRIPT;
                    script.onload = function() {
                        gapi = $window.gapi;
                        initializeGapiClient();
                    };
                    script.onerror = function() {
                        deferred.reject('Failed to load Google API');
                    };
                    document.head.appendChild(script);
                }

                function initializeGapiClient() {
                    gapi.load('client', function () {
                        gapi.client.init({
                            discoveryDocs: [DISCOVERY_DOC]
                        }).then(function () {
                            console.log('Google API client initialized');
                            deferred.resolve();
                        }).catch(function (error) {
                            console.error('Error initializing Google API client:', error);
                            deferred.reject(error);
                        });
                    });
                }

                return deferred.promise;
            }

            /**
             * Check if user is signed in
             */
            service.isSignedIn = function () {
                // Check if we have a stored token response and it's not expired
                if (!window.googleTokenResponse || !window.googleTokenResponse.access_token) {
                    return false;
                }
                
                // Check if token is expired (Google tokens typically expire in 1 hour)
                var tokenResponse = window.googleTokenResponse;
                if (tokenResponse.expires_in) {
                    var now = new Date().getTime();
                    var tokenTime = tokenResponse.token_time || 0;
                    var expiresIn = tokenResponse.expires_in * 1000; // Convert to milliseconds
                    
                    // Add 5 minute buffer to prevent edge cases
                    var bufferTime = 5 * 60 * 1000; // 5 minutes in milliseconds
                    
                    if (now - tokenTime > (expiresIn - bufferTime)) {
                        // Token expired or about to expire, clear it
                        window.googleTokenResponse = null;
                        return false;
                    }
                }
                
                return true;
            };

            /**
             * Sign in user and request permissions using Google Identity Services
             */
            service.signIn = function () {
                var deferred = $q.defer();
                
                if (!google || !google.accounts) {
                    deferred.reject('Google Identity Services not initialized');
                    return deferred.promise;
                }

                // Initialize the OAuth2 token client first
                var codeClient = google.accounts.oauth2.initCodeClient({
                    client_id: CLIENT_ID,
                    scope: SCOPES,
                    ux_mode: 'popup',
                    access_type: 'offline',
                    prompt: 'consent',
                    callback: function (response) {
                      // response.code must be exchanged on backend for tokens
                      exchangeCodeForToken(response.code).then(function(tokenResponse) {
                        tokenResponse.token_time = Date.now();
                        window.googleTokenResponse = tokenResponse;
                        return fetchUserInfo(tokenResponse.access_token, tokenResponse.id_token);
                      }).then(function(userInfo) {
                        deferred.resolve({ user: userInfo, accessToken: window.googleTokenResponse.access_token });
                      }).catch(function(err) {
                        deferred.reject('Failed to complete authentication: ' + err);
                      });
                    },
                    error_callback: function(err) {
                      deferred.reject(err.message || 'Popup error');
                    }
                });
                
                codeClient.requestCode();

                return deferred.promise;
            };


            /**
             * Sign out user
             */
            service.signOut = function () {
                var deferred = $q.defer();
                
                if (!google || !google.accounts) {
                    deferred.reject('Google Identity Services not initialized');
                    return deferred.promise;
                }

                // Get token before clearing it
                var tokenToRevoke = window.googleTokenResponse;
                
                // Clear stored token
                window.googleTokenResponse = null;

                // Revoke the token if it exists
                if (tokenToRevoke && tokenToRevoke.access_token) {
                    google.accounts.oauth2.revoke(tokenToRevoke.access_token, function() {
                        console.log('User signed out successfully');
                        deferred.resolve();
                    });
                } else {
                    console.log('User signed out successfully');
                    deferred.resolve();
                }

                return deferred.promise;
            };

            /**
             * Get user's Google Calendar list
             */
            service.getCalendarList = function () {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                gapi.client.calendar.calendarList.list().then(function (response) {
                    deferred.resolve(response.result.items);
                }).catch(function (error) {
                    console.error('Error fetching calendar list:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Exchange authorization code for access token
             */
            function exchangeCodeForToken(code) {
                var deferred = $q.defer();
                // Make a request to your backend to exchange the code for tokens
                $api.googlecalendar.token.save({
                    code: code,
                }, function(response) {
                    if (response.success && response.data && response.data.access_token) {
                        // Ensure refresh_token is properly included in the response
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject('Invalid token response from server: ' + (response.message || 'Unknown error'));
                    }
                }, function(error) {
                    console.error('Error exchanging code for token:', error);
                    deferred.reject('Failed to exchange code for token: ' + (error.data ? error.data.message : error.message));
                });
                
                return deferred.promise;
            }

            /**
             * Refresh access token using refresh token
             */
            function refreshAccessToken(refreshToken) {
                var deferred = $q.defer();
                
                // Make a request to your backend to refresh the token
                $api.googlecalendar.token.save({
                    refresh_token: refreshToken,
                }, function(response) {
                    if (response.success && response.data && response.data.access_token) {
                        response.data.token_time = Date.now();
                        window.googleTokenResponse = response.data;
                        deferred.resolve(response.data);
                    } else {
                        console.error('Failed to refresh token:', response);
                        window.googleTokenResponse = null;
                        deferred.reject('Failed to refresh token: ' + (response.message || 'Unknown error'));
                    }
                }, function(error) {
                    console.error('Error refreshing token:', error);
                    window.googleTokenResponse = null;
                    deferred.reject('Failed to refresh token: ' + (error.data ? error.data.message : error.message));
                });
                
                return deferred.promise;
            }

            /**
             * Get user info from token response
             */
            function fetchUserInfo(accessToken, idToken) {
                // First try to decode the ID token if available
                if (idToken) {
                    try {
                        // Decode the JWT ID token to get user info
                        var payload = JSON.parse(atob(idToken.split('.')[1]));
                        if (payload.email) {
                            return $q.resolve({
                                getId: function() { return payload.sub || ''; },
                                getName: function() { return payload.name || ''; },
                                getEmail: function() { return payload.email || ''; },
                                getImageUrl: function() { return payload.picture || ''; },
                                getAccessToken: function() { return accessToken || ''; },
                                getRefreshToken: function() { return window.googleTokenResponse ? window.googleTokenResponse.refresh_token || '' : ''; },
                                getTokenExpiresAt: function() { return payload.exp || ''; },
                                raw: payload
                            });
                        }
                    } catch (e) {
                        console.warn('Could not decode ID token:', e);
                    }
                }
                
                // Fallback to API call if ID token is not available or invalid
                return $http.get('https://www.googleapis.com/oauth2/v2/userinfo', {
                    headers: { 
                        'Authorization': 'Bearer ' + accessToken,
                        'Content-Type': 'application/json'
                    }
                }).then(function(resp) {
                    var data = resp.data || {};
                    return {
                        getId: function() { return data.id || ''; },
                        getName: function() { return data.name || ''; },
                        getEmail: function() { return data.email || ''; },
                        getImageUrl: function() { return data.picture || ''; },
                        getAccessToken: function() { return accessToken || ''; },
                        getRefreshToken: function() { return window.googleTokenResponse ? window.googleTokenResponse.refresh_token || '' : ''; },
                        getTokenExpiresAt: function() { return window.googleTokenResponse ? window.googleTokenResponse.expires_in || '' : ''; },
                        raw: data
                    };
                }).catch(function(error) {
                    console.error('Error fetching user info:', error);
                    if (error.status === 401) {
                        // Try to refresh the token if we have a refresh token
                        if (window.googleTokenResponse && window.googleTokenResponse.refresh_token) {
                            return refreshAccessToken(window.googleTokenResponse.refresh_token).then(function(newTokenResponse) {
                                // Retry the user info request with the new token
                                return $http.get('https://www.googleapis.com/oauth2/v2/userinfo', {
                                    headers: { 
                                        'Authorization': 'Bearer ' + newTokenResponse.access_token,
                                        'Content-Type': 'application/json'
                                    }
                                }).then(function(resp) {
                                    var data = resp.data || {};
                                    return {
                                        getId: function() { return data.id || ''; },
                                        getName: function() { return data.name || ''; },
                                        getEmail: function() { return data.email || ''; },
                                        getImageUrl: function() { return data.picture || ''; },
                                        getAccessToken: function() { return newTokenResponse.access_token || ''; },
                                        getRefreshToken: function() { return newTokenResponse.refresh_token || ''; },
                                        raw: data
                                    };
                                });
                            }).catch(function(refreshError) {
                                console.error('Failed to refresh token:', refreshError);
                                window.googleTokenResponse = null;
                                throw new Error('Token expired and could not be refreshed. Please sign in again.');
                            });
                        } else {
                            window.googleTokenResponse = null;
                            throw new Error('Token expired or invalid. Please sign in again.');
                        }
                    }
                    throw error;
                });
            }

            /**
             * Set authorization header for API requests
             */
            function setAuthHeader() {
                if (window.googleTokenResponse && window.googleTokenResponse.access_token) {
                    // Check if token is expired
                    var tokenResponse = window.googleTokenResponse;
                    if (tokenResponse.expires_in) {
                        var now = new Date().getTime();
                        var tokenTime = tokenResponse.token_time || 0;
                        var expiresIn = tokenResponse.expires_in * 1000;
                        
                        if (now - tokenTime > expiresIn) {
                            // Token expired, clear it
                            window.googleTokenResponse = null;
                            return false;
                        }
                    }
                    
                    // Store the access token for use in API calls
                    gapi.client.setToken(window.googleTokenResponse);
                    return true;
                }
                return false;
            }

            /**
             * Force re-authentication when token is expired
             */
            service.forceReAuth = function() {
                window.googleTokenResponse = null;
                return service.signIn();
            };

            /**
             * Check and refresh token if needed
             */
            service.checkAndRefreshToken = function() {
                if (!service.isSignedIn()) {
                    return $q.reject('User not signed in or token expired');
                }
                
                // Check if token is about to expire (within 5 minutes)
                var tokenResponse = window.googleTokenResponse;
                if (tokenResponse.expires_in) {
                    var now = new Date().getTime();
                    var tokenTime = tokenResponse.token_time || 0;
                    var expiresIn = tokenResponse.expires_in * 1000;
                    var timeUntilExpiry = expiresIn - (now - tokenTime);
                    var fiveMinutes = 5 * 60 * 1000;
                    
                    if (timeUntilExpiry < fiveMinutes && tokenResponse.refresh_token) {
                        // Try to refresh the token
                        return refreshAccessToken(tokenResponse.refresh_token);
                    }
                }
                
                return $q.resolve(window.googleTokenResponse);
            };

            /**
             * Get user info using stored token
             */
            service.getUserInfo = function() {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                var tokenResponse = window.googleTokenResponse;
                fetchUserInfo(tokenResponse.access_token, tokenResponse.id_token).then(function(userInfo) {
                    deferred.resolve(userInfo);
                }).catch(function(error) {
                    console.error('Error getting user info:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Create a new event in Google Calendar
             */
            service.createEvent = function (calendarId, eventData) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var event = {
                    'summary': eventData.summary,
                    'description': eventData.description || '',
                    'start': {
                        'dateTime': eventData.startDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    },
                    'end': {
                        'dateTime': eventData.endDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    }
                };

                // Add attendees if provided
                if (eventData.attendees && eventData.attendees.length > 0) {
                    event.attendees = eventData.attendees;
                }

                gapi.client.calendar.events.insert({
                    'calendarId': calendarId,
                    'resource': event
                }).then(function (response) {
                    deferred.resolve(response.result);
                }).catch(function (error) {
                    console.error('Error creating event:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Update an existing event in Google Calendar
             */
            service.updateEvent = function (calendarId, eventId, eventData) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var event = {
                    'summary': eventData.summary,
                    'description': eventData.description || '',
                    'start': {
                        'dateTime': eventData.startDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    },
                    'end': {
                        'dateTime': eventData.endDateTime,
                        'timeZone': eventData.timeZone || 'UTC'
                    }
                };

                // Add attendees if provided
                if (eventData.attendees && eventData.attendees.length > 0) {
                    event.attendees = eventData.attendees;
                }

                gapi.client.calendar.events.update({
                    'calendarId': calendarId,
                    'eventId': eventId,
                    'resource': event
                }).then(function (response) {
                    deferred.resolve(response.result);
                }).catch(function (error) {
                    console.error('Error updating event:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Delete an event from Google Calendar
             */
            service.deleteEvent = function (calendarId, eventId) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                gapi.client.calendar.events.delete({
                    'calendarId': calendarId,
                    'eventId': eventId
                }).then(function () {
                    deferred.resolve();
                }).catch(function (error) {
                    console.error('Error deleting event:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Get events from Google Calendar
             */
            service.getEvents = function (calendarId, timeMin, timeMax) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var request = {
                    'calendarId': calendarId,
                    'timeMin': timeMin,
                    'timeMax': timeMax,
                    'showDeleted': false,
                    'singleEvents': true,
                    'orderBy': 'startTime'
                };

                gapi.client.calendar.events.list(request).then(function (response) {
                    deferred.resolve(response.result.items || []);
                }).catch(function (error) {
                    console.error('Error fetching events:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Create a new calendar
             */
            service.createCalendar = function (calendarData) {
                var deferred = $q.defer();
                
                if (!service.isSignedIn()) {
                    deferred.reject('User not signed in');
                    return deferred.promise;
                }

                if (!setAuthHeader()) {
                    deferred.reject('No valid access token');
                    return deferred.promise;
                }

                var calendar = {
                    'summary': calendarData.summary,
                    'description': calendarData.description || '',
                    'timeZone': calendarData.timeZone || 'UTC'
                };

                gapi.client.calendar.calendars.insert({
                    'resource': calendar
                }).then(function (response) {
                    deferred.resolve(response.result);
                }).catch(function (error) {
                    console.error('Error creating calendar:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            return service;
        }]);
})();

(function() {
    
    angular.module("app.services").factory("$date", function() {
            
        var $date = this;

        /**
         * Return the date of Sunday at the same week
         * @param {Date} date 
         */
        $date.getSunday = function(date) {
            
            var 
                day = date.getDay(),
                time = date.getTime();

            return new Date(time - (day * 3600 * 24 * 1000));
        };

        /**
         * Return the date of Saturday at the same week
         * @param {Date} date 
         */
        $date.getSaturday = function(date) {
            
            var
                day = date.getDay(),
                time = date.getTime(),
                difference = 6 - day;

            return new Date(time + (difference * 3600 * 24 * 1000));
        };

        return $date;
    });
    
})();
(function () {
  angular.module('app.services')
    .factory('$customFields', function ($rootScope, $translate) {
      return {
        getTypes: function () {
          return [
            { key: '', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_SELECT_TYPE') },
            { key: 'text', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_TEXT') },
            { key: 'date', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_DATE') },
            { key: 'datetime', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_DATETIME') },
            { key: 'list', title: $translate.instant('SETTINGS_CUSTOM_FIELDS_TYPE_LIST') },
          ];
        },

        getCurrentName: function (names) {
          var currentLocale = $rootScope.currentLanguage ? $rootScope.currentLanguage : 'en_US';
          var data;
          try {
            data = JSON.parse(names);
          } catch (e) {
            return names;
          }
  
          var result = data[currentLocale];
          if (!data[currentLocale]) {
            var values = Object.keys(data).map(function (key) {
              return data[key];
            });
  
            for (var i = 0; i < values.length; i++) {
              if (values[i] && values[i].trim()) {
                result = values[i];
                break;
              }
            }
          }
          return result;
        },
      };
    });
})();

(function () {
  angular.module('app.services')
    .factory('$color', function () {
      function pSBC(p,c0,c1,l) {
        var r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
        if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
        if(!this.pSBCr)this.pSBCr=function(d) {
            var n=d.length,x={};
            if(n>9){
                d=d.split(","),n=d.length;
                r = d[0] ? d[0] : '';
                g = d[1] ? d[1] : '';
                b = d[2] ? d[2] : '';
                a = d[3] ? d[3] : '';
                if(n<3||n>4)return null;
                x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
            }else{
                if(n==8||n==6||n<4)return null;
                if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
                d=i(d.slice(1),16);
                if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
                else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
            }return x};
        h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
        if(!f||!t)return null;
        if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
        else r=m(Math.pow((P*Math.pow(f.r,2)+p*Math.pow(t.r,2)),0.5)),g=m(Math.pow((P*Math.pow(f.g,2)+p*Math.pow(t.g,2)),0.5)),b=m(Math.pow((P*Math.pow(f.b,2)+p*Math.pow(t.b,2)),0.5));
        a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
        if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
        else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
      }
      
      var svc = {
        pSBC: pSBC,

        // lighten by pct (0..1). linear=true for linear blend; false uses gamma blend (default of pSBC).
        lighten: function (c, pct, linear) {
          return this.pSBC(Math.abs(pct || 0), c, null, !!linear);
        },

        // darken by pct (0..1)
        darken: function (c, pct, linear) {
          return this.pSBC(-Math.abs(pct || 0), c, null, !!linear);
        },

        // mix two colors by pct (0..1) toward c1
        mix: function (c0, c1, pct, linear) {
          return this.pSBC(Math.max(0, Math.min(1, pct || 0)), c0, c1, !!linear);
        },

        // quick gradient helpers
        gradientLR: function (base, lightPct, darkPct, linear) {
          // defaults: 25% lighter → 20% darker
          lightPct = (lightPct == null) ? 0.25 : lightPct;
          darkPct  = (darkPct  == null) ? -0.20 : darkPct;
          var from = this.pSBC(lightPct, base, null, !!linear);
          var to   = this.pSBC(darkPct,  base, null, !!linear);
          return 'linear-gradient(90deg,' + from + ' 0%,' + to + ' 100%)';
        },

        gradientTB: function (base, lightPct, darkPct, linear) {
          lightPct = (lightPct == null) ? 0.25 : lightPct;
          darkPct  = (darkPct  == null) ? -0.20 : darkPct;
          var from = this.pSBC(lightPct, base, null, !!linear);
          var to   = this.pSBC(darkPct,  base, null, !!linear);
          return 'linear-gradient(180deg,' + from + ' 0%,' + to + ' 100%)';
        }
      };

      return svc;
    });
})();

(function () {
    'use strict';

    angular.module('app.services')
        .service('CalendarSyncService', ['$q', '$http', '$api', 'GoogleCalendarService', function ($q, $http, $api, GoogleCalendarService) {
            var service = this;

            /**
             * Synchronize calendar events for a specific resource
             */
            service.syncResourceCalendar = function (resourceId, resourceEmail, calendarDate) {
                var deferred = $q.defer();

                // First, get the resource's Google Calendar ID
                GoogleCalendarService.getCalendarList().then(function (calendars) {
                    var targetCalendar = null;
                    
                    // Look for a calendar that matches the resource email
                    for (var i = 0; i < calendars.length; i++) {
                        if (calendars[i].id === resourceEmail || 
                            calendars[i].primary === true ||
                            calendars[i].summary.toLowerCase().includes(resourceEmail.toLowerCase())) {
                            targetCalendar = calendars[i];
                            break;
                        }
                    }

                    if (!targetCalendar) {
                        // Create a new calendar for this resource
                        return GoogleCalendarService.createCalendar({
                            summary: 'Tiffulit - ' + resourceEmail,
                            description: 'Calendar for Tiffulit resource: ' + resourceEmail,
                            timeZone: moment.tz.guess()
                        });
                    } else {
                        return $q.resolve(targetCalendar);
                    }
                }).then(function (calendar) {
                    // Get Tiffulit events for the resource on the specified date
                    return getTiffulitEvents(resourceId, calendarDate).then(function(tiffulitEvents) {
                        return {
                            calendar: calendar,
                            tiffulitEvents: tiffulitEvents
                        };
                    });
                }).then(function (data) {
                    // Get existing Google Calendar events for the same date
                    var startOfDay = moment(calendarDate).startOf('day').toISOString();
                    var endOfDay = moment(calendarDate).endOf('day').toISOString();
                    
                    return GoogleCalendarService.getEvents(data.calendar.id, startOfDay, endOfDay).then(function(googleEvents) {
                        return {
                            calendar: data.calendar,
                            tiffulitEvents: data.tiffulitEvents,
                            googleEvents: googleEvents
                        };
                    });
                }).then(function (data) {
                    // Process synchronization
                    return processSync(data.tiffulitEvents, data.googleEvents, data.calendar.id);
                }).then(function (result) {
                    deferred.resolve(result);
                }).catch(function (error) {
                    console.error('Error synchronizing calendar:', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            /**
             * Get Tiffulit events for a specific resource and date
             */
            function getTiffulitEvents(resourceId, date) {
                var deferred = $q.defer();

                $api.orders.calendar.get({
                    date: moment(date).format('YYYY-MM-DD'),
                    range: 'daily'
                }, function (response) {
                    if (response.status === 'success') {
                        // Filter events by resource ID
                        var filteredEvents = (response.data || []).filter(function(event) {
                            return event.resource_id == resourceId;
                        });
                        deferred.resolve(filteredEvents);
                    } else {
                        deferred.reject('Failed to fetch Tiffulit events');
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            /**
             * Process synchronization between Tiffulit and Google Calendar events
             */
            function processSync(tiffulitEvents, googleEvents, calendarId) {
                var deferred = $q.defer();
                var promises = [];
                var syncResult = {
                    created: 0,
                    updated: 0,
                    deleted: 0,
                    errors: []
                };

                // Create/Update events from Tiffulit
                for (var i = 0; i < tiffulitEvents.length; i++) {
                    var tiffulitEvent = tiffulitEvents[i];
                    var existingGoogleEvent = findExistingGoogleEvent(googleEvents, tiffulitEvent);

                    if (existingGoogleEvent) {
                        // Update existing event
                        var updatePromise = updateGoogleEvent(calendarId, existingGoogleEvent.id, tiffulitEvent);
                        updatePromise.then(function () {
                            syncResult.updated++;
                        }).catch(function (error) {
                            syncResult.errors.push('Failed to update event: ' + error);
                        });
                        promises.push(updatePromise);
                    } else {
                        // Create new event
                        var createPromise = createGoogleEvent(calendarId, tiffulitEvent);
                        createPromise.then(function () {
                            syncResult.created++;
                        }).catch(function (error) {
                            syncResult.errors.push('Failed to create event: ' + error);
                        });
                        promises.push(createPromise);
                    }
                }

                // Delete Google events that don't exist in Tiffulit
                for (var j = 0; j < googleEvents.length; j++) {
                    var googleEvent = googleEvents[j];
                    var existsInTiffulit = findExistingTiffulitEvent(tiffulitEvents, googleEvent);

                    if (!existsInTiffulit) {
                        var deletePromise = GoogleCalendarService.deleteEvent(calendarId, googleEvent.id);
                        deletePromise.then(function () {
                            syncResult.deleted++;
                        }).catch(function (error) {
                            syncResult.errors.push('Failed to delete event: ' + error);
                        });
                        promises.push(deletePromise);
                    }
                }

                $q.all(promises).then(function () {
                    deferred.resolve(syncResult);
                }).catch(function () {
                    deferred.resolve(syncResult); // Still resolve with partial results
                });

                return deferred.promise;
            }

            /**
             * Find existing Google event that matches Tiffulit event
             */
            function findExistingGoogleEvent(googleEvents, tiffulitEvent) {
                for (var i = 0; i < googleEvents.length; i++) {
                    var googleEvent = googleEvents[i];
                    // Match by start time and customer name
                    var googleStart = moment(googleEvent.start.dateTime || googleEvent.start.date);
                    var tiffulitStart = moment(tiffulitEvent.start_time);
                    
                    if (googleStart.isSame(tiffulitStart, 'minute') && 
                        googleEvent.summary.includes(getCustomerName(tiffulitEvent))) {
                        return googleEvent;
                    }
                }
                return null;
            }

            /**
             * Find existing Tiffulit event that matches Google event
             */
            function findExistingTiffulitEvent(tiffulitEvents, googleEvent) {
                for (var i = 0; i < tiffulitEvents.length; i++) {
                    var tiffulitEvent = tiffulitEvents[i];
                    var googleStart = moment(googleEvent.start.dateTime || googleEvent.start.date);
                    var tiffulitStart = moment(tiffulitEvent.start_time);
                    
                    if (googleStart.isSame(tiffulitStart, 'minute') && 
                        googleEvent.summary.includes(getCustomerName(tiffulitEvent))) {
                        return tiffulitEvent;
                    }
                }
                return null;
            }

            /**
             * Create a new Google Calendar event from Tiffulit event
             */
            function createGoogleEvent(calendarId, tiffulitEvent) {
                var eventData = formatTiffulitEventForGoogle(tiffulitEvent);
                return GoogleCalendarService.createEvent(calendarId, eventData);
            }

            /**
             * Update an existing Google Calendar event from Tiffulit event
             */
            function updateGoogleEvent(calendarId, eventId, tiffulitEvent) {
                var eventData = formatTiffulitEventForGoogle(tiffulitEvent);
                return GoogleCalendarService.updateEvent(calendarId, eventId, eventData);
            }

            /**
             * Format Tiffulit event data for Google Calendar
             */
            function formatTiffulitEventForGoogle(tiffulitEvent) {
                var customerName = getCustomerName(tiffulitEvent);
                var startDateTime = moment(tiffulitEvent.start_time).format();
                var endDateTime = moment(tiffulitEvent.end_time).format();
                
                // Calculate accumulated duration for multiple services
                var duration = calculateAccumulatedDuration(tiffulitEvent);
                var description = '';

                // Add service details to description
                if (tiffulitEvent.merged && tiffulitEvent.merged.length > 0) {
                    description = 'Services: ';
                    for (var i = 0; i < tiffulitEvent.merged.length; i++) {
                        if (i > 0) description += ', ';
                        description += tiffulitEvent.merged[i].item_data.name;
                    }
                } else {
                    description = 'Service: ' + tiffulitEvent.item_data.name;
                }

                if (tiffulitEvent.order_notes) {
                    description += '\nNotes: ' + tiffulitEvent.order_notes;
                }

                return {
                    summary: customerName,
                    description: description,
                    startDateTime: startDateTime,
                    endDateTime: endDateTime,
                    timeZone: moment.tz.guess()
                };
            }

            /**
             * Get customer name from Tiffulit event
             */
            function getCustomerName(tiffulitEvent) {
                if (tiffulitEvent.order_customer) {
                    var name = tiffulitEvent.order_customer_firstname;
                    if (tiffulitEvent.order_customer_lastname) {
                        name += ' ' + tiffulitEvent.order_customer_lastname;
                    }
                    return name;
                } else {
                    return tiffulitEvent.customer_name || 'Unknown Customer';
                }
            }

            /**
             * Calculate accumulated duration for multiple services
             */
            function calculateAccumulatedDuration(tiffulitEvent) {
                var totalDuration = moment(tiffulitEvent.end_time).diff(moment(tiffulitEvent.start_time), 'minutes');
                
                // If there are merged events, calculate total duration
                if (tiffulitEvent.merged && tiffulitEvent.merged.length > 0) {
                    totalDuration = 0;
                    for (var i = 0; i < tiffulitEvent.merged.length; i++) {
                        var mergedEvent = tiffulitEvent.merged[i];
                        totalDuration += moment(mergedEvent.end_time).diff(moment(mergedEvent.start_time), 'minutes');
                    }
                }
                
                return totalDuration;
            }

            /**
             * Initialize Google Calendar integration for a resource
             */
            service.initializeResourceSync = function (resourceId, resourceEmail) {
                var deferred = $q.defer();

                GoogleCalendarService.initialize().then(function () {
                    if (!GoogleCalendarService.isSignedIn()) {
                        // User needs to sign in
                        deferred.resolve({
                            needsAuth: true,
                            message: 'Please sign in to Google to enable calendar synchronization'
                        });
                    } else {
                        // User is already signed in, check if calendar exists
                        GoogleCalendarService.getCalendarList().then(function (calendars) {
                            var hasCalendar = false;
                            for (var i = 0; i < calendars.length; i++) {
                                if (calendars[i].id === resourceEmail || 
                                    calendars[i].summary.toLowerCase().includes(resourceEmail.toLowerCase())) {
                                    hasCalendar = true;
                                    break;
                                }
                            }
                            
                            deferred.resolve({
                                needsAuth: false,
                                hasCalendar: hasCalendar,
                                message: hasCalendar ? 'Calendar synchronization ready' : 'Calendar will be created on first sync'
                            });
                        }).catch(function (error) {
                            deferred.reject(error);
                        });
                    }
                }).catch(function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            return service;
        }]);
})();

(function() {

    angular.module("app.services").factory("$business", function($translate, $api) {

        var $business = this,

        // The order in array is important;
        businesses_statuses = ["ADMIN_BUSINESS_STATUS_ACTIVE", "ADMIN_BUSINESS__STATUS_TRIAL", "ADMIN_BUSINESS_STATUS_INACTIVE"],
        businesses_credit = ["TRANZILA", "YAAD_SARIG", "PELECARD", "ZCREDIT"];


        // The order in array is important;
        $business.businesses_msg_channels = [
            {name: "SETTINGS_MSG_CHANNEL_NO", index: 0},
            {name: "SETTINGS_MSG_CHANNEL_EMAIL", index: 1},
            {name: "SETTINGS_MSG_CHANNEL_SMS", index: 2},

            //WhatsApp is not an option till the official API release
            {name: "SETTINGS_MSG_CHANNEL_WHATSAPP", index: 3},

            {name: "SETTINGS_MSG_CHANNEL_PRINT", index: 4}
        ];

        //Customer notifications channels;
        $business.customers_notifications_channels = [
          {name: "SETTINGS_MSG_CHANNEL_NO", value: 0},
          {name: "SETTINGS_MSG_CHANNEL_EMAIL", value: 1},
          {name: "SETTINGS_MSG_CHANNEL_SMS", value: 2},
          {name: "SETTINGS_MSG_CHANNEL_WHATSAPP", value: 3}
        ];

        //Reminder sending time before scheduled order;
        $business.reminder_send_times = [
          {name: "SETTINGS_USER_REMINDER_NO", value: 0},
          {name: "SETTINGS_USER_REMINDER_2_HOURS", value: 2},
          {name: "SETTINGS_USER_REMINDER_4_HOURS", value: 4},
          {name: "SETTINGS_USER_REMINDER_24_HOURS", value: 24},
          {name: "SETTINGS_USER_REMINDER_48_HOURS", value: 48},
          {name: "SETTINGS_USER_REMINDER_72_HOURS", value: 72},
          {name: "SETTINGS_USER_REMINDER_168_HOURS", value: 168}
        ];

        $business.laser_categories = [
            {
                id: 1,
                translation_key: 'LF_SETTINGS_CATEGORY_1',
                default_name: 'LF_SETTINGS_CATEGORY_1',
                name: 'LF_SETTINGS_CATEGORY_1'
            },
            {
                id: 2,
                translation_key: 'LF_SETTINGS_CATEGORY_2',
                default_name: 'LF_SETTINGS_CATEGORY_2',
                name: 'LF_SETTINGS_CATEGORY_2'
            },
            {
                id: 3,
                translation_key: 'LF_SETTINGS_CATEGORY_3',
                default_name: 'LF_SETTINGS_CATEGORY_3',
                name: 'LF_SETTINGS_CATEGORY_3'
            }
        ];

        $business.loadLaserCategories = function() {
            $api.settings.laser_file_categories.get(function(response) {
                var customNames = (response && response.status === 'success' && response.data) ? response.data : {};

                angular.forEach($business.laser_categories, function(category) {
                    var categoryId = String(category.id);
                    $translate(category.translation_key).then(function(translatedName) {
                        category.default_name = translatedName || category.translation_key;

                        if (customNames[categoryId]) {
                            category.name = customNames[categoryId];
                        } else {
                            category.name = category.default_name;
                        }
                    }, function() {
                        category.default_name = category.translation_key;

                        if (customNames[categoryId]) {
                            category.name = customNames[categoryId];
                        } else {
                            category.name = category.default_name;
                        }
                    });
                });
            });
        };

        $business.getStatusByIndex = function($i) {
            return businesses_statuses[$i];
        };

        $business.getAllStatuses = function() {
            return businesses_statuses;
        }

        $business.getCreditCompByIndex = function($i) {
            return businesses_credit[$i];
        };

        $business.getAllCreditComp = function() {
            return businesses_credit;
        }

        /**
         * Return message channel type by it's index from the above list 'businesses_msg_channels'
         * @param $i
         * @returns {string}
         */
        $business.getMsgChannelByIndex = function($i) {
            return $business.businesses_msg_channels[$i];
        };

        /**
         * Return all types of message channels
         *
         * @returns {string[]}
         */
        $business.getMsgChannels = function() {
            return $business.businesses_msg_channels;
        }

        $business.ai = {
            enabled: null,
            booking_agent: null
        };

        $business.ai_fetch = function () {
            // if ($business.ai.enabled === null || $business.ai.booking_agent === null) {
            //     $api.settings.ai.get(function (response) {
            //         if (response && response.data) {
            //             $business.ai.enabled = !!response.data.enabled;
            //             $business.ai.booking_agent = !!response.data.booking_agent;
            //         }
            //     });
            // }
        };

        $business.ai_reset = function() {
            $business.ai.enabled = null;
            $business.ai.booking_agent = null;
        }

        return $business;
    });

})();

(function() {
    'use strict';

    /**
     * Audio Recorder Service
     * 
     * Provides audio recording functionality with speech-to-text conversion.
     * Uses a single state variable to prevent UI overlap issues.
     * 
     * States:
     * - 'idle': Ready to record (shows microphone icon)
     * - 'recording': Currently recording audio (shows stop icon)
     * - 'processing': Sending audio to AI for transcription (shows spinner with gradient)
     */
    angular.module('app.services').factory('AudioRecorderService', function($translate, $cookies, $timeout) {

        var service = {
            state: 'idle',  // 'idle' | 'recording' | 'processing'
            activeInstanceId: null,  // Track which directive instance is currently active
            mediaRecorder: null,
            audioChunks: [],
            callbacks: {}
        };

        /**
         * Start recording audio from microphone
         * @param {Object} callbacks - { onStart, onStop, onSuccess, onError, instanceId }
         */
        service.startRecording = function(callbacks) {
            service.callbacks = callbacks || {};
            service.activeInstanceId = callbacks.instanceId || null;

            // Check if browser supports getUserMedia
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                var errorMsg = $translate.instant('AUDIO_NOT_SUPPORTED');
                if (service.callbacks.onError) {
                    service.callbacks.onError(errorMsg);
                }
                swal({
                    title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                    text: errorMsg,
                    type: 'error',
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON')
                });
                return;
            }

            // Request microphone access
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(function(stream) {
                    service.audioChunks = [];
                    
                    // Create MediaRecorder instance
                    service.mediaRecorder = new MediaRecorder(stream);
                    
                    // Collect audio data chunks
                    service.mediaRecorder.ondataavailable = function(event) {
                        if (event.data.size > 0) {
                            service.audioChunks.push(event.data);
                        }
                    };
                    
                    // Handle recording stop
                    service.mediaRecorder.onstop = function() {
                        // Stop all tracks to release microphone
                        stream.getTracks().forEach(function(track) {
                            track.stop();
                        });
                        
                        if (service.callbacks.onStop) {
                            service.callbacks.onStop();
                        }
                    };
                    
                    // Start recording
                    service.mediaRecorder.start();
                    
                    $timeout(function() {
                        service.state = 'recording';
                        
                        if (service.callbacks.onStart) {
                            service.callbacks.onStart();
                        }
                    });
                })
                .catch(function(error) {
                    console.error('Error accessing microphone:', error);
                    var errorMsg = $translate.instant('MICROPHONE_ACCESS_DENIED');

                    $timeout(function() {
                        service.state = 'idle';
                        service.activeInstanceId = null;
                        
                        if (service.callbacks.onError) {
                            service.callbacks.onError(errorMsg);
                        }
                    });
                    
                    swal({
                        title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                        text: errorMsg,
                        type: 'error',
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                });
        };

        /**
         * Stop recording
         */
        service.stopRecording = function() {
            if (service.mediaRecorder && service.mediaRecorder.state !== 'inactive') {
                service.mediaRecorder.stop();
            }
        };

        /**
         * Send recorded audio to backend for speech-to-text conversion
         * @param {string} apiBaseURL - Base URL for API
         * @param {Function} onSuccess - Callback with transcribed text
         * @param {Function} onError - Error callback
         */
        service.sendAudioToBackend = function(apiBaseURL, onSuccess, onError) {
            if (service.audioChunks.length === 0) {
                console.error('No audio data recorded');
                if (onError) {
                    onError('No audio data recorded');
                }
                return;
            }

            // Create audio blob from chunks
            var audioBlob = new Blob(service.audioChunks, { type: 'audio/webm' });
            
            // Update state to processing
            $timeout(function() {
                service.state = 'processing';
            });
            
            // Create FormData to send file
            var formData = new FormData();
            formData.append('audio_file', audioBlob, 'recording.webm');

            // Send to backend using XMLHttpRequest
            var xhr = new XMLHttpRequest();
            xhr.open('POST', apiBaseURL + '/ai/action/speach_to_text', true);
            
            // Add authorization header
            var token = $cookies.get('token');
            if (token) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            }

            xhr.onload = function() {
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        
                        if (response.status === 'success') {
                            $timeout(function() {
                                service.state = 'idle';
                                service.activeInstanceId = null;
                                if (onSuccess) {
                                    onSuccess(response.data);
                                }
                            });
                        } else {
                            $timeout(function() {
                                service.state = 'idle';
                                service.activeInstanceId = null;
                            });
                            var errorMsg = response.message || 'Failed to convert audio to text';
                            if (onError) {
                                onError(errorMsg);
                            }
                            
                            swal({
                                title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                                text: errorMsg,
                                type: 'error',
                                confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                                timer: 2000
                            });
                        }
                    } catch (e) {
                        $timeout(function() {
                            service.state = 'idle';
                            service.activeInstanceId = null;
                        });
                        
                        console.error('Error parsing response:', e);
                        var errorMsg = $translate.instant('AUDIO_PROCESSING_ERROR');
                        
                        if (onError) {
                            onError(errorMsg);
                        }
                        
                        swal({
                            title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                            text: errorMsg,
                            type: 'error',
                            confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                            timer: 2000
                        });
                    }
                } else {
                    $timeout(function() {
                        service.state = 'idle';
                        service.activeInstanceId = null;
                    });
                    console.error('Request failed with status:', xhr);
                    var response = xhr && xhr.responseText ? JSON.parse(xhr.responseText) : {};
                    var errorMsg = response.message || $translate.instant('AUDIO_UPLOAD_ERROR');
                    
                    if (onError) {
                        onError(errorMsg);
                    }
                    
                    swal({
                        title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                        text: errorMsg,
                        type: 'error',
                        confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                        timer: 2000
                    });
                }
            };

            xhr.onerror = function() {
                $timeout(function() {
                    service.state = 'idle';
                    service.activeInstanceId = null;
                });
                
                console.error('Network error occurred');
                var errorMsg = $translate.instant('NETWORK_ERROR');
                
                if (onError) {
                    onError(errorMsg);
                }
                
                swal({
                    title: $translate.instant('AUDIO_TO_SPEACH_ERROR'),
                    text: errorMsg,
                    type: 'error',
                    confirmButtonText: $translate.instant('SWAL_CONFIRM_BUTTON'),
                    timer: 2000
                });
            };

            xhr.send(formData);
        };

        /**
         * Toggle recording on/off
         * @param {Object} options - { apiBaseURL, instanceId, onSuccess, onError, onStart, onStop }
         */
        service.toggleRecording = function(options) {
            if (service.state === 'processing') {
                return; // Prevent multiple clicks while processing
            }

            if (service.state !== 'recording') {
                // Start recording
                service.startRecording({
                    instanceId: options.instanceId,
                    onStart: options.onStart,
                    onStop: function() {
                        if (options.onStop) {
                            options.onStop();
                        }
                        // Process and send audio after stopping
                        service.sendAudioToBackend(
                            options.apiBaseURL,
                            options.onSuccess,
                            options.onError
                        );
                    },
                    onError: options.onError
                });
            } else {
                // Stop recording
                service.stopRecording();
            }
        };

        /**
         * Reset the service state
         */
        service.reset = function() {
            $timeout(function() {
                service.state = 'idle';
                service.activeInstanceId = null;
                service.mediaRecorder = null;
                service.audioChunks = [];
                service.callbacks = {};
            });
        };

        return service;
    });

})();


/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function () {

    angular.module("app.services").factory("$api", function ($header, $q, $log, $resource, $state) {
        var
            $api = this,
            baseURL = "https://dev.tiffulit.co.il/api";
            if (window.location.hostname == 'localhost' || window.location.hostname == '192.168.68.115') {
                baseURL = window.location.port == 3002 ? "https://api.tiffulit.da/api" : "http://tiffulit.my/api";
            }
            // baseURL = "http://192.168.68.112/index.php/api";
            // baseURL = "http://tiffulit-api.project-release.info/index.php/api";
            // baseURL = "http://tiffulit.api.loc/index.php/api";
            // baseURL = "http://tiffulit-env-dev.eu-west-1.elasticbeanstalk.com/api/index.php/api";
            // baseURL = "http://localhost/Tiffulit_Israel_API/index.php/api";
            // baseURL = "https://stage.tiffulit.co.il/api";


        /**
         * Contain all the api available routes
         */
        $api = {};
        $api.baseURL = baseURL;

        /**
         * Authentication
         */
        $api.auth = $resource(baseURL + "/auth");

        $api.auth.check_password = $resource(baseURL + "/auth/action/check_password");

        $api.auth.logout = $resource(baseURL + "/auth/action/logout");

        $api.auth.my_businesses = $resource(baseURL + "/auth/action/my_businesses");
        $api.auth.switch_business = $resource(baseURL + "/auth/action/switch_business");

        $api.forgot_password = $resource(baseURL + "/ForgotPassword");

        $api.passwordconfirm = $resource(baseURL + "/PasswordConfirm");

        $api.all_acls = $resource(baseURL + "/UserACL/all");

        /**
         * Customers
         */
        $api.customers = $resource(baseURL + "/customers");
        $api.customers.single = $resource(baseURL + "/customers/id/:id", {id: "@id"});
        $api.customers.list = $resource(baseURL + "/customers/action/list"); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.customers.download = $resource(baseURL + "/customers/action/download", {}, { download: { method: 'GET', responseType: 'arraybuffer', headers: { 'Accept': 'text/csv' }, transformResponse: [],       // don’t try to JSON.parse
            interceptor: {
              response: function(response) {
                return {
                  data:    response.data,
                  headers: response.headers
                };
              }
            }} }); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.customers.marketing = $resource(baseURL + "/customers/action/marketing");
        $api.customers.update = $resource(baseURL + "/customers/action/update");
        $api.customers.today_birthday = $resource(baseURL + "/customers/action/today_birthday");
        $api.customers.filter = $resource(baseURL + "/customers/action/filter_values");
        $api.customers.find = $resource(baseURL + "/customers/action/search/str/:str", {str: "@str"});
        $api.customers.request_review = $resource(baseURL + "/customers/action/request_review", { id: "@id", type: "@type"});
        $api.customers.social_link = $resource(baseURL + "/customers/action/social_link/id/:id", { id: "@id"});
        $api.customers.send_online_booking_link = $resource(baseURL + "/customers/action/send_online_booking_link/id/:id", { id: "@id"});
        $api.customers.remove = $resource(baseURL + "/customers/id/:id/confirm/:confirm", {id: "@id", confirm: "@confirm"});
        $api.customers.recover = $resource(baseURL + "/customers/action/recover/id/:id", {id: "@id"});
        $api.customers.movelead = $resource(baseURL + "/customers/action/movelead/id/:id", {id: "@id"});
        $api.customers.leads_count = $resource(baseURL + "/customers/action/leads_count");
        $api.customers.tab_info = $resource(baseURL + "/customers/action/tab_info/tab/:tab/id/:id", {tab: "@tab", id: "@id"});
        $api.customers.request_card = $resource(baseURL + "/customers/action/request_card/id/:id", {id: "@id"});
        $api.customers.credit_cards = $resource(baseURL + "/customers/action/credit_cards/id/:id", {id: "@id"});
        $api.customers.request_card_iframe = $resource(baseURL + "/customercards/action/request/id/:id", {id: "@id"});
        $api.customers.check_phone = $resource(baseURL + "/customers/action/check_phone");
        $api.customers.fillable_fields = $resource(baseURL + "/customers/action/fillable_fields");

        /**
         * Continuous deals (future invoices for customers)
         */
        $api.continuousDeals = {};
        $api.continuousDeals.futureInvoices = $resource(baseURL + "/continuousdeals/action/future_invoices", {}, {get: {method: 'GET'}});

        /**
         * Customers coloring
         */
        $api.coloring = $resource(baseURL + "/coloring");
        $api.coloring.single = $resource(baseURL + "/coloring/id/:id", {id: "@id"});
        $api.coloring.pdf = $resource(baseURL + "/coloring/action/pdf/id/:id", {id: "@id"});

        /**
         * Customers laser file
         */
        $api.laser_file = $resource(baseURL + "/laserFiles");

        /**
         * Customers bookings
         */
        $api.customers_bookings = $resource(baseURL + "/bookings");
        $api.customers_bookings.list = $resource(baseURL + "/bookings/action/list"); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.customers_bookings.waiting_list = $resource(baseURL + "/bookings/action/waiting_list");
        $api.customers_bookings.waiting_list.single = $resource(baseURL + "/bookings/action/waiting_list/list_id/:id", {id: "@id"});
        $api.customers_bookings.remove_waiting_list = $resource(baseURL + "/bookings/action/remove_waiting_list");
        $api.customers_bookings.find = $resource(baseURL + "/bookings/action/search/str/:str", {str: "@str"});


        /**
         * FB auth
         */
        $api.fb_auth = $resource(baseURL + "/FBAuth/authorize");

        /**
         * WA
         */
        $api.wa = $resource(baseURL + "/whatsapp");
        $api.wa.qr_code = $resource(baseURL + "/whatsapp/action/qr_code");
        $api.wa.status = $resource(baseURL + "/whatsapp/action/status");
        $api.wa.logout = $resource(baseURL + "/whatsapp/action/logout");

        /**
         * Business WhatsApp Agent
         */
        $api.whatsappagent = $resource(baseURL + "/whatsappagent");
        $api.whatsappagent.init = $resource(baseURL + "/whatsappagent/action/init");
        $api.whatsappagent.disconnect = $resource(baseURL + "/whatsappagent/action/disconnect");
        $api.whatsappagent.register_wa = $resource(baseURL + "/whatsappagent/action/register_wa", {}, {save: {method: 'POST'}});
        $api.whatsappagent.retry_credit_attach = $resource(baseURL + "/whatsappagent/action/retry_credit_attach", {}, {save: {method: 'POST'}});

        $api.whatsapptemplates = $resource(baseURL + "/whatsapptemplates");
        $api.whatsapptemplates.sync_all = $resource(baseURL + "/whatsapptemplates/action/sync_all", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.sync_one = $resource(baseURL + "/whatsapptemplates/action/sync_one", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.submit_all = $resource(baseURL + "/whatsapptemplates/action/submit_all", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.submit_one = $resource(baseURL + "/whatsapptemplates/action/submit_one", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.resubmit_one = $resource(baseURL + "/whatsapptemplates/action/resubmit_one", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.sync_statuses = $resource(baseURL + "/whatsapptemplates/action/sync_statuses", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.update_localization = $resource(baseURL + "/whatsapptemplates/action/update_localization", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.create_marketing = $resource(baseURL + "/whatsapptemplates/action/create_marketing", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.delete_marketing = $resource(baseURL + "/whatsapptemplates/action/delete_marketing", {}, {save: {method: 'POST'}});
        $api.whatsapptemplates.marketing = $resource(baseURL + "/whatsapptemplates/scope/marketing");

        /**
         * Resources
         */
        $api.resources = $resource(baseURL + "/resources");
        $api.resources.freeSlots = $resource(baseURL + "/resources/filter/free-slots/start_date/:start_date/end_date/:end_date/order_id/:order_id", {
            start_date: "@start_date",
            end_date: "@end_date",
            order_id: "@order_id"
        });
        $api.resources.single = $resource(baseURL + "/resources/id/:id", {id: "@id"});
        $api.resources.permissions = $resource(baseURL + "/resources/action/permissions/id/:id", {id: "@id"});
        $api.resources.capacity = $resource(baseURL + "/capacity/id/:id/date/:date/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.resources.capacity.single = $resource(baseURL + "/capacity/id/:id/date/:date/single/1/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.resources.capacity.all = $resource(baseURL + "/capacity/action/resources_with_capacity", {date: "@date"});

        /**
         * SecondResources
         */
        $api.second_resources = $resource(baseURL + "/secondresources");
        $api.second_resources.freeSlots = $resource(baseURL + "/secondresources/filter/free-slots/start_date/:start_date/end_date/:end_date/order_id/:order_id", {
            start_date: "@start_date",
            end_date: "@end_date",
            order_id: "@order_id"
        });
        $api.second_resources.single = $resource(baseURL + "/secondresources/id/:id", {id: "@id"});
        $api.second_resources.capacity = $resource(baseURL + "/capacity/second/1/id/:id/date/:date/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.second_resources.capacity.single = $resource(baseURL + "/capacity/second/1/id/:id/date/:date/single/1/capacity_type/:capacity_type", {id: "@id", date: "@date", capacity_type: "@capacity_type"});
        $api.second_resources.capacity.all = $resource(baseURL + "/capacity/second/true/action/resources_with_capacity", {date: "@date"});

        /**
         * Categories
         */
        $api.categories = $resource(baseURL + "/categories");
        $api.categories.single = $resource(baseURL + "/categories/id/:id", {id: "@id"});

        /**
         * Statuses
         */
        $api.statuses = $resource(baseURL + "/statuses");
        $api.statuses.single = $resource(baseURL + "/statuses/id/:id", {id: "@id"});

        /**
         * Quotation Statuses
         */
        $api.quotation_statuses = $resource(baseURL + "/quotationstatuses");
        $api.quotation_statuses.single = $resource(baseURL + "/quotationstatuses/id/:id", {id: "@id"});


        /**
         * Interested in
         */
        $api.interested = $resource(baseURL + "/interested");
        $api.interested.single = $resource(baseURL + "/interested/id/:id", {id: "@id"});

        /**
         * Items
         */
        $api.items = $resource(baseURL + "/items");
        $api.items_list = $resource(baseURL + "/items?list=1");
        $api.items.single = $resource(baseURL + "/items/id/:id", {id: "@id"});
        $api.items.items_with_duration = $resource(baseURL + "/items/type/duration");
        $api.items.transactions = $resource(baseURL + "/items/action/get_transactions/item_id/:item_id", {item_id: "@item_id"});
        $api.items.download = $resource(baseURL + "/items/action/download", {}, { download: { method: 'GET', responseType: 'arraybuffer', headers: { 'Accept': 'text/csv' }, transformResponse: [],
            interceptor: {
              response: function(response) {
                return {
                  data:    response.data,
                  headers: response.headers
                };
              }
            }} });


        /**
         * Automations
         */
        $api.automations = $resource(baseURL + "/automations");
        $api.automations.recommendations = $resource(baseURL + "/automations/action/recommendations");
        $api.automations.recommendations.send = $resource(baseURL + "/automations/action/send/id/:id", {id: "@id"});
        $api.automations.recommendations.single = $resource(baseURL + "/automations/action/recommendations/id/:id", {id: "@id"});
        $api.automations.activations = $resource(baseURL + "/automations/action/activations/id/:id", {id: "@id"});
        $api.automations.single = $resource(baseURL + "/automations/id/:id", {id: "@id"});


        /**
         * Notes
         */
        $api.notes = $resource(baseURL + "/notes");
        $api.notes.single = $resource(baseURL + "/notes/id/:id", {id: "@id"});


        /**
         * Medical Notes
         */
        $api.medical_notes = $resource(baseURL + "/medicalnotes");
        $api.medical_notes.single = $resource(baseURL + "/medicalnotes/id/:id", {id: "@id"});
        $api.medical_notes.log = $resource(baseURL + "/medicalnotes/id/:id/action/log", {id: "@id"});

        /**
         * Files
         */
        $api.files = $resource(baseURL + "/files");
        $api.files.single = $resource(baseURL + "/files/id/:id", {id: "@id"});

        /**
         * Digital Forms
         */
        $api.digital_forms = $resource(baseURL + "/digitalforms");
        $api.digital_forms.send = $resource(baseURL + "/digitalforms/action/send");
        $api.digital_forms.single = $resource(baseURL + "/digitalforms/id/:id", {id: "@id"});
        $api.digital_forms.preview = $resource(baseURL + "/digitalforms/action/preview/id/:id", {id: "@id"});
        $api.digital_forms.templates_list = $resource(baseURL + "/digitalforms/action/templates_list");
        $api.digital_forms.update_last_time = $resource(baseURL + "/digitalforms/action/update_last_time");
        $api.digital_forms.unchecked = $resource(baseURL + "/digitalforms/action/unchecked");
        $api.digital_forms.all = $resource(baseURL + "/digitalforms/action/all");

        /**
         * Call Logs
         */
        $api.call_logs = $resource(baseURL + "/callLogs");

        /**
         * Sms Logs
         */
        $api.sms_logs = $resource(baseURL + "/sms");

        /**
         * Cards
         */
        $api.cards = $resource(baseURL + "/cards");
        $api.cards.single = $resource(baseURL + "/cards/id/:id", {id: "@id"});
        $api.cards.customers = $resource(baseURL + "/cards/action/get_cards/customer_id/:id", {id: "@id"});
        $api.cards.for_order = $resource(baseURL + "/cards/action/get_cards/order_id/:id", {id: "@id"});
        $api.cards.transactions = $resource(baseURL + "/cards/action/get_transactions/card_id/:card_id", {card_id: "@card_id"});


        /**
         * Business Messages
         */
        $api.b_messages = $resource(baseURL + "/messages");
        $api.b_messages.list = $resource(baseURL + "/messages/action/list");
        $api.b_messages.read = $resource(baseURL + "/messages/action/read/id/:id", {id: "@id"});
        $api.b_messages.remove = $resource(baseURL + "/messages/action/remove/id/:id", {id: "@id"});


        /**
         * Notifications
         */
        $api.notifications = {};
        $api.notifications.list = $resource(baseURL + "/notifications/action/list");
        $api.notifications.dashboard = $resource(baseURL + "/notifications/action/dashboard");
        $api.notifications.remove = $resource(baseURL + "/notifications/action/remove/id/:id", {id: "@id"});
        $api.notifications.removeAll = $resource(baseURL + "/notifications/action/removeAll/type/:type", {type: "@type"});

        /**
         * Users
         */
        $api.users = $resource(baseURL + "/users");
        $api.users.single = $resource(baseURL + "/users/id/:id", {id: "@id"});

        /**
         * User Devices
         */
        $api.userDevices = $resource(baseURL + "/userdevices");
        $api.userDevices.revoke = $resource(baseURL + "/userdevices/action/revoke");

        /**
         * Custom Fields
         */
        $api.customFields = $resource(baseURL + "/customfields");
        $api.customFields.single = $resource(baseURL + "/customfields/id/:id", {id: "@id"});
        $api.customFields.lists = $resource(baseURL + "/customfields/action/lists");
        $api.customFields.list = $resource(baseURL + "/customfields/action/single/id/:id", {id: "@id"});
        $api.customFields.value = {
            add: $resource(baseURL + "/customfields/action/valueAdd/id/:id/", {id: "@id"}),
            update: $resource(baseURL + "/customfields/action/valueUpdate/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            get: $resource(baseURL + "/customfields/action/valueGet/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            remove: $resource(baseURL + "/customfields/action/valueRemove/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
        };
        $api.customFields.all = $resource(baseURL + "/customfields/action/all");


        /**
         * Courses Fields
         */
        $api.coursesFields = $resource(baseURL + "/coursesfields");
        $api.coursesFields.single = $resource(baseURL + "/coursesfields/id/:id", {id: "@id"});
        $api.coursesFields.lists = $resource(baseURL + "/coursesfields/action/lists");
        $api.coursesFields.list = $resource(baseURL + "/coursesfields/action/single/id/:id", {id: "@id"});
        $api.coursesFields.value = {
            add: $resource(baseURL + "/coursesfields/action/valueAdd/id/:id/", {id: "@id"}),
            update: $resource(baseURL + "/coursesfields/action/valueUpdate/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            get: $resource(baseURL + "/coursesfields/action/valueGet/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
            remove: $resource(baseURL + "/coursesfields/action/valueRemove/id/:id/vid/:vid", {id: "@id", vid: "@vid"}),
        };
        $api.coursesFields.all = $resource(baseURL + "/coursesfields/action/all");


        /**
         * Photos Stock
         */
        $api.photosStock = $resource(baseURL + "/photosstock", {}, {
            upload: {
                method: "POST",
                url: baseURL + "/photosstock/upload",
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
        });
        $api.photosStock.delete = $resource(baseURL + "/photosstock/id/:id", {id: "@id"});


        /**
         * Gift Card Templates
         */
        $api.giftCardTemplate = $resource(baseURL + "/giftcardtemplates");
        $api.giftCardTemplate.single = $resource(baseURL + "/giftcardtemplates/id/:id", {id: "@id"});


        /**
         * Gift Cards
         */
        $api.giftCard = $resource(baseURL + "/giftcards");
        $api.giftCard.single = $resource(baseURL + "/giftcards/id/:id", {id: "@id"});
        $api.giftCard.transactions = $resource(baseURL + "/giftcards/action/transactions");
        $api.giftCard.transactions.single = $resource(baseURL + "/giftcards/action/transactions/id/:id", {id: "@id"});
        $api.giftCard.balance = $resource(baseURL + "/giftcards/action/change_balance/id/:id", {id: "@id"});

        /**
         * Public Gift Cards
         */
        $api.publicGiftCard = $resource(baseURL + "/giftcardspublic");
        $api.publicGiftCard.single = $resource(baseURL + "/giftcardspublic/id/:id", {id: "@id"});

        /**
         * AI
         */
        $api.ai = $resource(baseURL + "/ai");
        $api.ai.agent = $resource(baseURL + "/ai/action/agent");
        $api.ai.feedback = $resource(baseURL + "/ai/action/feedback");
        $api.ai.history = $resource(baseURL + "/ai/action/history");
        $api.ai.speach_to_text = $resource(baseURL + "/ai/action/speach_to_text");

        /**
         * AI Prompts
         */
        $api.prompts = $resource(baseURL + "/prompts");
        $api.prompts.list = $resource(baseURL + "/prompts/action/list");
        $api.prompts.single = $resource(baseURL + "/prompts/action/single/id/:id", {id: "@id"});
        $api.prompts.resolve = $resource(baseURL + "/prompts/action/resolve/run_id/:run_id", {run_id: "@run_id"});

        /**
         * AI Support
         */
        $api.support = $resource(baseURL + "/support");
        $api.support.list = $resource(baseURL + "/support/action/list");
        $api.support.single = $resource(baseURL + "/support/action/single/id/:id", {id: "@id"});
        $api.support.filters = $resource(baseURL + "/support/action/filters");
        $api.support.save = $resource(baseURL + "/support/action/save");
        $api.support.update = $resource(baseURL + "/support/action/update/id/:id", {id: "@id"});
        $api.support.files = $resource(baseURL + "/support/action/files");
        $api.support.files.process = $resource(baseURL + "/support/action/process");
        $api.support.files.remove = $resource(baseURL + "/support/action/remove");
        $api.support.files.articles = $resource(baseURL + "/support/action/articles");
        $api.support.files.embeddings = $resource(baseURL + "/support/action/embeddings");

        /**
         * AI Booking Agent
         */
        $api.ai_booking_agent = $resource(baseURL + "/bookingagent");
        $api.ai_booking_agent.agent = $resource(baseURL + "/bookingagent/action/agent");
        $api.ai_booking_agent.remove = $resource(baseURL + "/bookingagent/action/remove");

        $api.ai_booking_agent.history = $resource(baseURL + "/bookingagent/action/history");
        $api.ai_booking_agent.history_list = $resource(baseURL + "/bookingagent/action/history_list");
        $api.ai_booking_agent.history_messages = $resource(baseURL + "/bookingagent/action/history_messages");
        $api.ai_booking_agent.prompt = $resource(baseURL + "/bookingagent/action/prompt");

        /**
         * Find
         */
        $api.findEvents = $resource(baseURL + "/findEvents");

        /**
         * Workers
         */
        $api.workers = $resource(baseURL + "/employees");
        $api.workers.single = $resource(baseURL + "/employees/id/:id", {id: "@id"});
        $api.workers.recover = $resource(baseURL + "/employees/action/recover/id/:id", {id: "@id"});
        $api.workers.list = $resource(baseURL + "/employees/action/list"); //   {limit: "@limit", offset: "@offset", order: '@order', order_dir: '@order_dir', search: '@search'});
        $api.workers.find = $resource(baseURL + "/employees/action/search/str/:str", {str: "@str"});
        $api.workers.employee_transactions = $resource(baseURL + "/employeeTransactions");
        $api.workers.employee_transactions.single = $resource(baseURL + "/employeeTransactions/password/:password/id/:id", {password: "@password",id: "@password"});
        /**
         * Workers Times
         */
        $api.employeeTransactions = $resource(baseURL + "/employeeTransactions");
        /**
         * SMS
         */
        $api.sms = $resource(baseURL + "/sms");

        /**
         * Dashboard
         */
        $api.dashboard = $resource(baseURL + "/dashboard");


        /**
         * Whatsapp
         */
        $api.whatsapp = $resource(baseURL + "/whatsapp");
        $api.whatsapp.avatar = $resource(baseURL + "/whatsapp/action/avatar");
        $api.whatsapp.wachat = $resource(baseURL + "/whatsapp/action/wachat/id/:id", {id: "@id"});

        /**
         * Transactions
         */
        $api.transactions = $resource(baseURL + "/transactions");
        $api.transactions.single = $resource(baseURL + "/transactions/id/:id", {id: "@id"});
        $api.transactions.pending = $resource(baseURL + "/transactions/action/pending");
        $api.transactions.retainers = $resource(baseURL + "/transactions/action/retainers");
        $api.transactions.retainer = $resource(baseURL + "/transactions/action/retainer/id/:id", {id: "@id"});
        $api.transactions.prepare = $resource(baseURL + "/transactions/action/prepare");
        $api.transactions.remove = $resource(baseURL + "/transactions/action/remove/id/:id", {id: "@id"});
        $api.transactions.remove_retainer = $resource(baseURL + "/transactions/action/remove_retainer/id/:id", {id: "@id"});
        $api.transactions.send_sms_invoice = $resource(baseURL + "/transactions/action/smsinvoice/id/:id", {id: "@id"});
        $api.transactions.resetzcredit = $resource(baseURL + "/transactions/action/resetzcredit");
        $api.transactions.quotation_status = $resource(baseURL + "/transactions/action/quotation_status/id/:id", {id: "@id"});

        /**
         * ZCredit
         */
        $api.zcredit = $resource(baseURL + "/zcredit/amount/:amount/b_id/:b_id", {amount: "@amount", b_id: "@b_id"});

        /**
         * Analytics
         */
        $api.analytics = $resource(baseURL + "/analytics");
        $api.analytics.customers = $resource(baseURL + "/analytics/action/customers");

        /**
         * Settings
         */
        $api.settings = {};
        $api.settings.info = $resource(baseURL + "/settings/section/info");
        $api.settings.mass_customers = $resource(baseURL + "/settings/section/mass_customers");
        $api.settings.colors = $resource(baseURL + "/settings/section/colors");
        $api.settings.online = $resource(baseURL + "/settings/section/online");
        $api.settings.online.isAliasTaken = $resource(baseURL + "/settings/section/is_alias_taken");
        $api.settings.landing = $resource(baseURL + "/settings/section/landing");
        $api.settings.landing.isAliasTaken = $resource(baseURL + "/settings/section/is_landing_alias_taken");
        $api.settings.landing.edit_page = $resource(baseURL + "/settings/section/edit_page");
        $api.settings.messages = $resource(baseURL + "/settings/section/messages");
        $api.settings.bu_types = $resource(baseURL + "/settings/section/bu_types");
        $api.settings.clubs = $resource(baseURL + "/settings/section/clubs");
        $api.settings.documents = $resource(baseURL + "/settings/section/documents/lang/:lang", {lang: "@lang"});
        $api.settings.digital_documents = $resource(baseURL + "/DigitalDocuments");
        $api.settings.digital_documents.single = $resource(baseURL + "/DigitalDocuments/remove/id/:id", {id: "@id"});
        $api.settings.menuorder = $resource(baseURL + "/settings/section/menuorder");
        $api.settings.ai = $resource(baseURL + "/settings/section/ai");
        $api.settings.ai_agents_options = $resource(baseURL + "/settings/section/ai_agents_options");
        $api.settings.ai_agent_test_message = $resource(baseURL + "/settings/section/ai_agent_test_message");
        $api.settings.table_columns = $resource(baseURL + "/settings/section/table_columns");
        $api.settings.digital_secretary = $resource(baseURL + "/settings/section/digital_secretary");
        $api.settings.notifications_messages = $resource(baseURL + "/settings/section/notifications_messages");

        // Allocation settings (issue allocation number + token)
        $api.settings.allocation_settings = $resource(baseURL + "/settings/section/allocation_settings");
        $api.settings.allocation_token_initiate = $resource(baseURL + "/settings/section/allocation_token_initiate");
        $api.settings.allocation_token_callback = $resource(baseURL + "/settings/section/allocation_token_callback");
        $api.settings.allocation_token_refresh = $resource(baseURL + "/settings/section/allocation_token_refresh");


        $api.settings.laser_file = $resource(baseURL + "/settings/section/laser_file");
        $api.settings.laser_file_categories = $resource(baseURL + "/settings/section/laser_file_categories");
        $api.settings.laser_file_field = $resource(baseURL + "/settings/section/laser_file_field");
        $api.settings.laser_file_field.single = $resource(baseURL + "/settings/section/laser_file_field/id/:id", {id: "@id"});


        /**
         * Social routes
         */
        $api.social = {};
        $api.social.customer = $resource(baseURL + "/social/action/customer/id/:id", {id: "@id"});
        $api.social.customer_post = $resource(baseURL + "/social/action/customer_post/id/:id", {id: "@id"});

        
        /**
         * Tax Files
         */
        $api.settings.tax_files = $resource(baseURL + "/settings/section/taxfiles");
        $api.settings.tax_files_check = $resource(baseURL + "/settings/section/taxfiles_check");
        $api.settings.lead_settings = $resource(baseURL + "/settings/section/lead_settings");
        $api.settings.telephony_users = $resource(baseURL + "/settings/section/telephony_users");
        


        $api.customer_documents = $resource(baseURL + "/CustomerDocuments/sign/id/:id", {id: "@id"});
        $api.customer_forms = $resource(baseURL + "/customerforms/id/:id", {id: "@id"});
        $api.customer_forms.new = $resource(baseURL + "/customerforms/action/new/id/:id", {id: "@id"});
        $api.customer_forms.pdf = $resource(baseURL + "/customerforms/action/pdf/id/:id", {id: "@id"});
        
        /**
         * Orders
         */
        $api.orders = $resource(baseURL + "/orders");
        $api.orders.calendar = $resource(baseURL + "/orders/date/:date/type/orders/range/:range", {date: "@date", range: "@range"});
        $api.orders.capcaity = $resource(baseURL + "/orders/date/:date/type/capacity", {date: "@date"});
        $api.orders.customer_history = $resource(baseURL + "/orders/type/history/filter-status/:filter_status/customer-id/:id", {id: '@id',filter_status: "@filter_status"});
        $api.orders.single = $resource(baseURL + "/orders/id/:id", {id: "@id"});
        $api.orders.copy = $resource(baseURL + "/orders/action/copy/id/:id", {id: "@id"});
        $api.orders.approval = $resource(baseURL + "/orders/action/approval/id/:id", {id: "@id"});
        $api.orders.link_medical_note = $resource(baseURL + "/orders/action/link_medical_note/id/:id", {id: "@id"});
        $api.orders.request_approval = $resource(baseURL + "/orders/action/request_approval/order_id/:id", {id: "@order_id"});
        $api.orders.today_orders = $resource(baseURL + "/orders/action/today_orders");
        $api.orders.add_waiting_list = $resource(baseURL + "/orders/action/add_waiting_list");
        // $api.orders.send = $resource(baseURL + "/orders/action/:action/id/:id", {action: "@action",id: "@id"});

        /**
         * Events
         */
        $api.events = $resource(baseURL + "/events");
        $api.events.single = $resource(baseURL + "/events/id/:id/all/:all", {id: "@id", all: "@all"});
        $api.events.copy = $resource(baseURL + "/events/action/copy/id/:id/all/:all", {id: "@id", all: "@all"});
        $api.events.group = $resource(baseURL + "/events/action/group/id/:id", {id: "@id"});
        $api.events.calendar = $resource(baseURL + "/events/date/:date/type/events/range/:range", {date: "@date", range: "@range"});


        /**
         * Courses
         */
        $api.courses = $resource(baseURL + "/courses");
        $api.courses.single = $resource(baseURL + "/courses/id/:id", {id: "@id"});
        $api.courses.calendar = $resource(baseURL + "/courses/date/:date/type/courses/range/:range", {date: "@date", range: "@range"});
        $api.courses.cashbox = $resource(baseURL + "/courses/action/cashbox/id/:id", {id: "@id"});


        /**
         * Filters
         */
        $api.filters = $resource(baseURL + "/filters");
        $api.filters.single = $resource(baseURL + "/filters/id/:id", {id: "@id"});
        $api.filters.filter_values = $resource(baseURL + "/filters/action/filter_values/module/:module", {module: "@module"});

        /**
         * Reports
         */
        $api.reports = $resource(baseURL + "/reports");

        /**
         * Holidays
         */
        $api.holidays = $resource(baseURL + "/holidays/year/:year", {year: "@year"});

        /**
         * Messages
         */

        $api.messages  = $resource(baseURL + "/settings/messages");

        /**
         * Mailer
         */
        $api.mails =  $resource(baseURL + "/mails");

        /**
         * Admin
         */
        $api.businesses = $resource(baseURL + "/businesses");
        $api.businesses.list_lite = $resource(baseURL + "/businesses/action/list_lite");
        $api.businesses.types = $resource(baseURL + "/btypes");
        $api.businesses.variants = $resource(baseURL + "/variants");
        $api.businesses.single = $resource(baseURL + "/businesses/id/:id", {id: "@id"});
        $api.businesses.message = $resource(baseURL + "/businesses/action/message");
        $api.businesses.check_import = $resource(baseURL + "/businesses/action/check_import/id/:id", {id: "@id"});
        $api.businesses.change_all_vat = $resource(baseURL + "/businesses/action/change_all_vat");
        $api.businesses.resources = $resource(baseURL + "/businesses/action/resources/id/:id", {id: "@id"});
        $api.businesses.create_whapi_instance = $resource(baseURL + "/businesses/action/create_whapi_instance");
        $api.businesses.create_texter_webhook = $resource(baseURL + "/businesses/action/create_texter_webhook");
        $api.businesses.set_whapi_settings = $resource(baseURL + "/businesses/action/set_whapi_settings");
        $api.businesses.push_whapi_settings = $resource(baseURL + "/businesses/action/push_whapi_settings");

        $api.admin = {};
        $api.admin.settings = $resource(baseURL + "/admin/action/settings");
        $api.admin.ai_sessions = {};
        $api.admin.ai_sessions.list = $resource(baseURL + "/admin/action/ai_sessions_list");
        $api.admin.ai_sessions.messages = $resource(baseURL + "/admin/action/ai_sessions_messages");

        /**
         * Logs
         */
        $api.logs = $resource(baseURL + "/admin/action/logs");


        // $api.orders.calendar = $resource(baseURL + "/orders/date/:date/type/orders/range/:range", {date: "@date", range: "@range"});
        // $api.orders.capcaity = $resource(baseURL + "/orders/date/:date/type/capacity", {date: "@date"});
        // $api.orders.single = $resource(baseURL + "/orders/id/:id", {id: "@id"});
        $api.showHideButton = false;
        $api.test = function (data) {
            $api.showHideButton = data;
        }

        /**
         * Approval
         */
        $api.approval = $resource(baseURL + "/approval/id/:id", {id: "@id"});

        /**
         * Calendar event
         */
        $api.calendar_event = $resource(baseURL + "/calendarev/id/:id", {id: "@id"});


        /**
         * Review
         */
        $api.review = $resource(baseURL + "/review/id/:id", {id: "@id"});

        /**
         * Prepaid
         */
        $api.prepaid = $resource(baseURL + "/prepaid/id/:id", {id: "@id"});

        /**
         * Pay
         */
        $api.pay = $resource(baseURL + "/prepaid/action/pay/id/:id", {id: "@id"});

        /**
         * Feedback sending
         */
        $api.feedback = $resource(baseURL + "/feedback");

        /**
         * Tutorials
         */
        $api.tutorials = {};
        $api.tutorials.playlist = $resource(baseURL + "/tutorials/action/playlist/playlist_id/:playlist_id", {playlist_id: "@playlist_id"});
        $api.tutorials.custom = $resource(baseURL + "/tutorials/action/custom");

        /**
         * Custom Tutorial Videos 
         */
        $api.customTutorialVideos = $resource(baseURL + "/customtutorialvideos", {}, {
            upload: {
                method: "POST",
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        });
        $api.customTutorialVideos.single = $resource(baseURL + "/customtutorialvideos/id/:id", {id: "@id"});

        /**
         * Business Helper
         */
        $api.business_helper = $resource(baseURL + "/businesshelper");
        $api.business_helper.dashboard = $resource(baseURL + "/businesshelper/action/dashboard");
        $api.business_helper.insights = $resource(baseURL + "/businesshelper/action/insights");
        $api.business_helper.mark_read = $resource(baseURL + "/businesshelper/action/mark_read");

        /**
         * Google Calendar
         */
        $api.googlecalendar = $resource(baseURL + "/googlecalendar");
        $api.googlecalendar.single = $resource(baseURL + "/googlecalendar/id/:id/remove_google_events/:remove_google_events/remove_tiffulit_events/:remove_tiffulit_events", {id: "@id", remove_google_events: "@remove_google_events", remove_tiffulit_events: "@remove_tiffulit_events"});
        $api.googlecalendar.active = $resource(baseURL + "/googlecalendar/action/active/id/:id", {id: "@id"});
        $api.googlecalendar.resources = $resource(baseURL + "/googlecalendar/action/resources/id/:id", {id: "@id"});
        $api.googlecalendar.token = $resource(baseURL + "/googlecalendar/action/token");

        /*
        *   Financial report
        */
        $api.financial = $resource(baseURL + "/financial/start/:start/end/:end");

        /**
         * apiResolver for async api calls
         * Used mostly for the states resolve parameters
         */
        var resolver = function(action, parameters) {

            var
                actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if (!resource || !method) {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if (!apiObject) {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else {
                apiObject[method](params,

                    // Success
                    function (response) {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response) {
                      if(response.status === 403) {
                        $state.go("login");
                      }
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        };

        /**
         * Determine the api resource object by the resource string
         * @param string Resource string
         * @returns api resource object
         */
        var getApiObject = function(resource) {

            // Split the resource in case if we have a dot notated object
            var
                resourceParts = resource.split('.'),
                apiObject = $api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for (var l = 0; l < resourceParts.length; l++) {
                if (angular.isUndefined(apiObject[resourceParts[l]])) {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if (!apiObject) {
                return false;
            }

            return apiObject;
        };

        $api.resolve = resolver;

        return $api;

    }).service("ResourceHeaders", function ($cookies) {

        this.request = function (config) {

            //var email = $cookies.get("email"), pass = $cookies.get("pass"), hash = $cookies.get("hash");
            // if(email !== ""){
            //     config.headers["API-Email"] = email;
            //     config.headers["API-Pass"] = pass;
            //     config.headers["API-Hash"] = hash;
            // }

            //new way with bearer token
            var token = $cookies.get("token");
            if (token !== "") {
                config.headers["Authorization"] = "Bearer " + token;
            }

            return config;
        };

    }).config(function ($httpProvider, $locationProvider) {
        $httpProvider.interceptors.push("ResourceHeaders");
        $locationProvider.html5Mode(true);
    });

})();

(function () {
  angular.module('app.services')
    .factory('AnalyticsStorage', function () {
      var NS = 'analytics.filters.v1';

      var DEFAULTS = {};

      function key(graphID) {
        return NS + '.' + graphID;
      }

      function safeParse(json) {
        try {
          return JSON.parse(json);
        } catch (e) {
          return null;
        }
      }

      function formatDateToYMD(date) {
        if (!date) {
          return null;
        }

        if (typeof date === 'object' && typeof date.format === 'function') {
          return date.format('YYYY-MM-DD');
        }

        var d = new Date(date);
        if (isNaN(d.getTime())) {
          return null;
        }

        var year = d.getFullYear();
        var month = ('0' + (d.getMonth() + 1)).slice(-2);
        var day = ('0' + d.getDate()).slice(-2);
        return year + '-' + month + '-' + day;
      }

      function defaultFilter() {
        return {
          item: [],
          category: [],
          resource: [],
          arrival_source: [],
          lastvisit_from: null,
          lastvisit_to: null,
          created_from: null,
          created_to: null,
          birthday: [],
          status: [],
          visited_from: null,
          visited_to: null,
          have_card: false,
          gender: '',
          campaign: '',
          ad: '',
          adset: '',
        };
      }

      function ids(arr) {
        if (!Array.isArray(arr)) {
          return [];
        }

        return arr.map(function (x) {
          if (x == null) {
            return null;
          }

          if (typeof x === 'object' && x.id != null) {
            return x.id;
          }

          if (typeof x === 'object' && x.value != null) {
            return x.value;
          }

          return x;
        }).filter(function (v) {
          return v !== null && v !== undefined;
        });
      }

      function birthdayMonths(arr) {
        if (!Array.isArray(arr)) {
          return [];
        }

        return arr.map(function (x) {
          if (x && typeof x === 'object' && x.month != null) {
            return {
              month: x.month,
              value: x.value
            };
          }

          return x;
        }).filter(function (v) {
          return v !== null && v !== undefined;
        });
      }

      function normalizeFilter(f) {
        f = f || {};
        return {
          item: ids(f.item),
          category: ids(f.category),
          resource: ids(f.resource),
          arrival_source: ids(f.arrival_source),
          birthday: birthdayMonths(f.birthday),
          status: ids(f.status),

          lastvisit_from: f.lastvisit_from ? formatDateToYMD(f.lastvisit_from) : null,
          lastvisit_to: f.lastvisit_to ? formatDateToYMD(f.lastvisit_to) : null,
          created_from: f.created_from ? formatDateToYMD(f.created_from) : null,
          created_to: f.created_to ? formatDateToYMD(f.created_to) : null,
          visited_from: f.visited_from ? formatDateToYMD(f.visited_from) : null,
          visited_to: f.visited_to ? formatDateToYMD(f.visited_to) : null,

          have_card: !!f.have_card,
          gender: f.gender || '',
          campaign: f.campaign || '',
          ad: f.ad || '',
          adset: f.adset || '',
        };
      }

      function nullIfEmpty(v) {
        return (v === '' || v === undefined) ? null : v;
      }

      function normalizeState(graph, filter) {
        graph = graph || {};
        return {
          filter_values: normalizeFilter(filter || {}),
          ui: {
            period: graph.filter || 'monthly',
            start: graph.start ? formatDateToYMD(graph.start) : null,
            end: graph.end ? formatDateToYMD(graph.end) : null,
            stats_type: nullIfEmpty(graph.stats_type),

            campaign_type: nullIfEmpty(graph.campaign_type),
            campaign_metric: nullIfEmpty(graph.campaign_metric),
            campaign_filter: nullIfEmpty(graph.campaign_filter),

            category: nullIfEmpty(graph.category),
            resource: nullIfEmpty(graph.resource),
            resource_treated: nullIfEmpty(graph.resource_treated),
            resource_booked: nullIfEmpty(graph.resource_booked),
            resource_responsible: nullIfEmpty(graph.resource_responsible),
            payment_method: nullIfEmpty(graph.payment_method),
          }
        };
      }

      function customersKey(graphID) {
        return NS + '.customers.' + graphID;
      }

      function getCustomersState(graphID) {
        var raw = localStorage.getItem(customersKey(graphID));
        if (!raw) {
          return null;
        }
        return safeParse(raw);
      }

      function setCustomersState(graphID, data) {
        try {
          localStorage.setItem(customersKey(graphID), JSON.stringify(data || {}));
          return true;
        } catch (e) {
          return false;
        }
      }

      function clearCustomersState(graphID) {
        localStorage.removeItem(customersKey(graphID));
      }

      function clearAllCustomersState() {
        Object.keys(localStorage).forEach(function (k) {
          if (k.indexOf(NS + '.customers.') === 0) localStorage.removeItem(k);
        });
      }

      function listCustomersGraphIds() {
        var prefix = NS + '.customers.';
        var out = [];

        Object.keys(localStorage).forEach(function (k) {
          if (k.indexOf(prefix) !== 0) {
            return;
          }

          var graphID = k.slice(prefix.length);
          if (graphID) {
            out.push(graphID);
          }
        });

        return out;
      }

      function get(graphID) {
        var raw = localStorage.getItem(key(graphID));
        if (!raw) {
          return null;
        }

        return safeParse(raw);
      }

      function set(graphID, data) {
        try {
          localStorage.setItem(key(graphID), JSON.stringify(data || {}));
          return true;
        } catch (e) {
          return false;
        }
      }

      function remove(graphID) {
        localStorage.removeItem(key(graphID));
      }

      function clearAll() {
        Object.keys(localStorage).forEach(function (k) {
          if (k.indexOf(NS + '.') === 0) localStorage.removeItem(k);
        });
      }

      function registerDefaults(graphsMap, filtersMap, graphIds) {
        (graphIds || Object.keys(graphsMap || {})).forEach(function (graphID) {
          DEFAULTS[graphID] = normalizeState(graphsMap[graphID], filtersMap[graphID]);
        });
      }

      function isDirty(graphID, graphsMap, filtersMap) {
        var cur = normalizeState(graphsMap[graphID], filtersMap[graphID]);
        var def = DEFAULTS[graphID] || normalizeState({}, defaultFilter());
        return !angular.equals(cur, def);
      }

      function applyStoredOrDefault(graphID, graphsMap, filtersMap) {
        var stored = get(graphID);
        var defFilter = defaultFilter();

        var storedFilters = stored && stored.filter_values ? stored.filter_values : null;
        filtersMap[graphID] = angular.extend(defFilter, storedFilters || {});

        var ui = stored && stored.ui ? stored.ui : null;
        if (ui && graphsMap && graphsMap[graphID]) {
          var g = graphsMap[graphID];

          if (ui.period) {
            g.filter = ui.period;
          }

          if (ui.stats_type) {
            g.stats_type = ui.stats_type;
          }

          if (ui.campaign_type) {
            g.campaign_type = ui.campaign_type;
          }

          if (ui.campaign_metric) {
            g.campaign_metric = ui.campaign_metric;
          }

          if (ui.campaign_filter) {
            g.campaign_filter = ui.campaign_filter;
          }

          if (ui.category !== undefined) {
            g.category = ui.category;
          }

          if (ui.resource !== undefined) {
            g.resource = ui.resource;
          }

          if (ui.resource_treated !== undefined) {
            g.resource_treated = ui.resource_treated;
          }

          if (ui.resource_booked !== undefined) {
            g.resource_booked = ui.resource_booked;
          }

          if (ui.resource_responsible !== undefined) {
            g.resource_responsible = ui.resource_responsible;
          }

          if (ui.payment_method !== undefined) {
            g.payment_method = ui.payment_method;
          }

          if (typeof moment === 'function') {
            if (ui.start) {
              g.start = moment(ui.start, 'YYYY-MM-DD');
            }

            if (ui.end) {
              g.end = moment(ui.end, 'YYYY-MM-DD');
            }
          } else {
            if (ui.start) {
              g.start = ui.start;
            }

            if (ui.end) {
              g.end = ui.end;
            }
          }
        }

        return {
          graph: graphsMap[graphID],
          filter: filtersMap[graphID]
        };
      }

      function reset(graphID, graphsMap, filtersMap) {
        var def = DEFAULTS[graphID];
        if (!def) {
          filtersMap[graphID] = defaultFilter();
          remove(graphID);
          return;
        }

        filtersMap[graphID] = angular.copy(def.filter_values || defaultFilter());

        var g = graphsMap[graphID];
        if (g && def.ui) {
          g.filter = def.ui.period || g.filter;

          g.stats_type = def.ui.stats_type || g.stats_type;

          g.campaign_type = def.ui.campaign_type || g.campaign_type;
          g.campaign_metric = def.ui.campaign_metric || g.campaign_metric;
          g.campaign_filter = def.ui.campaign_filter || g.campaign_filter;

          g.category = def.ui.category;
          g.resource = def.ui.resource;
          g.resource_treated = def.ui.resource_treated;
          g.resource_booked = def.ui.resource_booked;
          g.resource_responsible = def.ui.resource_responsible;
          g.payment_method = def.ui.payment_method;

          if (typeof moment === 'function') {
            g.start = def.ui.start ? moment(def.ui.start, 'YYYY-MM-DD') : g.start;
            g.end = def.ui.end ? moment(def.ui.end, 'YYYY-MM-DD') : g.end;
          } else {
            g.start = def.ui.start || g.start;
            g.end = def.ui.end || g.end;
          }
        }

        remove(graphID);
      }

      function watch($scope, graphsMap, filtersMap, graphIds) {
        (graphIds || Object.keys(graphsMap || {})).forEach(function (graphID) {
          $scope.$watch(function () {
            return normalizeState(graphsMap[graphID], filtersMap[graphID]);
          }, function (newVal, oldVal) {
            if (!newVal) {
              return;
            }

            if (angular.equals(newVal, oldVal)) {
              return;
            }

            set(graphID, newVal);
          }, true);
        });
      }

      return {
        get: get,
        set: set,
        remove: remove,
        clearAll: clearAll,
        defaultFilter: defaultFilter,
        normalizeFilter: normalizeFilter,
        normalizeState: normalizeState,
        registerDefaults: registerDefaults,
        applyStoredOrDefault: applyStoredOrDefault,
        watch: watch,
        isDirty: isDirty,
        reset: reset,
        getCustomersState: getCustomersState,
        setCustomersState: setCustomersState,
        clearCustomersState: clearCustomersState,
        clearAllCustomersState: clearAllCustomersState,
        listCustomersGraphIds: listCustomersGraphIds,
      };
    });
})();
(function () {

    angular.module("app.providers").provider('modalState', function ($stateProvider){

        var provider = this;

        var modalResult;

        this.$get = function () {
            return provider;
        };

        this.state = function (stateName, options) {

            var modalInstance;

            $stateProvider.state(stateName, {

                url: options.url,

                onEnter: function ($uibModal, $state, $stateParams, $rootScope) {

                    options.windowTopClass = "form-modal";

                    if(options.smallModal){
                        options.windowTopClass += " small-modal";
                    }

                    if(options.mediumModal){
                        options.windowTopClass += " medium-modal";
                    }

                    if(options.minimizable){
                        options.windowTopClass += " minimizable-modal";
                    }

                    options.backdrop = "static";
                    options.keyboard = false;

                    $rootScope.$stateParams = $stateParams;

                    modalInstance = $uibModal.open(options);

                    modalInstance.result.then(function (result) {
                        modalResult = result;
                    }).finally(function(){
                        if (modalResult){
                            $state.get('^').modalResult = modalResult;
                        }
                        modalInstance = modalResult = null;
                        if ($state.$current.name === stateName){
                            $state.go('^');
                        }
                    });
                },
                onExit: function(){
                    if(modalInstance){
                        modalInstance.close();
                    }
                }
            });
            return provider;
        };
    });

})();
(function (){
    angular.module("app.providers").provider("dates", function(){

        var provider = this, currentYear = new Date().getFullYear();

        this.$get = function () {
            return provider;
        };

        this.days = [];

        for(var i = 1; i <= 31; i++){
            this.days.push(i);
        }

        this.months = [
            "ינואר",
            "פברואר",
            "מרץ",
            "אפריל",
            "מאי",
            "יוני",
            "יולי",
            "אוגוסט",
            "ספטמבר",
            "אוקטובר",
            "נובמבר",
            "דצמבר"
        ];

        this.years = [];

        for(var i = currentYear; i >= 1900; i--){
            this.years.push(i);
        }

        this.daysNames = [
            "ראשון",
            "שני",
            "שלישי",
            "רביעי",
            "חמישי",
            "שישי",
            "שבת"
        ];

        this.hours = [];
        for(var h = 0, m = 0; h != 23 || m != 60; m += 5){
            if(m == 60) {
                m = 0;
                h++;
            }

            this.hours.push((h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m));
        }

        this.duration = [];

        var minutesLabel, hoursLabel;

        for(var h = 0, m = 5; h <= 10 && m < 60; m+= 5){
            minutesLabel = "";
            hoursLabel = "";
            if(m > 0){
                minutesLabel = m + " דקות";
            }

            if(h == 1){
                hoursLabel = "שעה";
            }else if(h == 2){
                hoursLabel = "שעתיים";
            }else if(h > 2){
                hoursLabel = h + " שעות";
            }

            if(minutesLabel != "" && hoursLabel != ""){
                hoursLabel = hoursLabel + " ו-";
            }

            this.duration.push({
                duration: (h * 60) + m,
                label: hoursLabel + minutesLabel 
            });

            if(m == 55){
                m = -5;
                h++;
            }
        }
    });
})();
(function () {

    angular.module("app.providers").value("dataTablesHebrewProvider", {
        "processing": "מעבד...",
        "loadingRecords": "טוען...",
        "lengthMenu": "הצג _MENU_ פריטים",
        "zeroRecords": "לא נמצאו רשומות מתאימות",
        "emptyTable": "לא נמצאו רשומות מתאימות",
        "info": "_START_ עד _END_ מתוך _TOTAL_ רשומות",
        "infoEmpty": "0 עד 0 מתוך 0 רשומות",
        "infoFiltered": "(מסונן מסך _MAX_  רשומות)",
        "infoPostFix": "",
        "search": "",
        "searchPlaceholder": "חפש...",
        "url": "",
        "paginate": {
            "first": "ראשון",
            "previous": "קודם",
            "next": "הבא",
            "last": "אחרון"
        }
    });

})();
/*
*  AngularJs Fullcalendar Wrapper for the JQuery FullCalendar
*  API @ http://arshaw.com/fullcalendar/
*
*  Angular Calendar Directive that takes in the [eventSources] nested array object as the ng-model and watches it deeply changes.
*       Can also take in multiple event urls as a source object(s) and feed the events per view.
*       The calendar will watch any eventSource array and update itself when a change is made.
*
*/
angular.module('ui.calendar', [])

    .constant('uiCalendarConfig', {
        calendars : {}
    })
    .controller('uiCalendarCtrl', ['$scope', '$locale',
        function ($scope, $locale) {

            var sources = $scope.eventSources;
            var extraEventSignature = $scope.calendarWatchEvent ? $scope.calendarWatchEvent : angular.noop;

            var wrapFunctionWithScopeApply = function (functionToWrap) {
                return function () {
                    // This may happen outside of angular context, so create one if outside.
                    if ($scope.$root.$$phase) {
                        return functionToWrap.apply(this, arguments);
                    }

                    var args = arguments;
                    var that = this;
                    return $scope.$root.$apply(
                        function () {
                            return functionToWrap.apply(that, args);
                        }
                    );
                };
            };

            var eventSerialId = 1;
            // @return {String} fingerprint of the event object and its properties
            this.eventFingerprint = function (e) {
                if (!e._id) {
                    e._id = eventSerialId++;
                }

                var extraSignature = extraEventSignature({
                    event : e
                }) || '';
                var start = moment.isMoment(e.start) ? e.start.unix() : (e.start ? moment(e.start).unix() : '');
                var end = moment.isMoment(e.end) ? e.end.unix() : (e.end ? moment(e.end).unix() : '');

                // This extracts all the information we need from the event. http://jsperf.com/angular-calendar-events-fingerprint/3
                return [e._id, e.id || '', e.title || '', e.url || '', start, end, e.allDay || '', e.className || '', extraSignature].join('');
            };

            var sourceSerialId = 1;
            var sourceEventsSerialId = 1;
            // @return {String} fingerprint of the source object and its events array
            this.sourceFingerprint = function (source) {
                var fp = '' + (source.__id || (source.__id = sourceSerialId++));
                var events = angular.isObject(source) && source.events;

                if (events) {
                    fp = fp + '-' + (events.__id || (events.__id = sourceEventsSerialId++));
                }
                return fp;
            };

            // @return {Array} all events from all sources
            this.allEvents = function () {
                return Array.prototype.concat.apply(
                    [],
                    (sources || []).reduce(
                        function (previous, source) {
                            if (angular.isArray(source)) {
                                previous.push(source);
                            } else if (angular.isObject(source) && angular.isArray(source.events)) {
                                var extEvent = Object.keys(source).filter(
                                    function (key) {
                                        return (key !== '_id' && key !== 'events');
                                    }
                                );

                                source.events.forEach(
                                    function (event) {
                                        angular.extend(event, extEvent);
                                    }
                                );

                                previous.push(source.events);
                            }
                            return previous;
                        },
                        []
                    )
                );
            };

            // Track changes in array of objects by assigning id tokens to each element and watching the scope for changes in the tokens
            // @param {Array|Function} arraySource array of objects to watch
            // @param tokenFn {Function} that returns the token for a given object
            // @return {Object}
            //  subscribe: function(scope, function(newTokens, oldTokens))
            //    called when source has changed. return false to prevent individual callbacks from firing
            //  onAdded/Removed/Changed:
            //    when set to a callback, called each item where a respective change is detected
            this.changeWatcher = function (arraySource, tokenFn) {
                var self;

                var getTokens = function () {
                    return ((angular.isFunction(arraySource) ? arraySource() : arraySource) || []).reduce(
                        function (rslt, el) {
                            var token = tokenFn(el);
                            map[token] = el;
                            rslt.push(token);
                            return rslt;
                        },
                        []
                    );
                };

                // @param {Array} a
                // @param {Array} b
                // @return {Array} elements in that are in a but not in b
                // @example
                //  subtractAsSets([6, 100, 4, 5], [4, 5, 7]) // [6, 100]
                var subtractAsSets = function (a, b) {
                    var obj = (b || []).reduce(
                        function (rslt, val) {
                            rslt[val] = true;
                            return rslt;
                        },
                        Object.create(null)
                    );
                    return (a || []).filter(
                        function (val) {
                            return !obj[val];
                        }
                    );
                };

                // Map objects to tokens and vice-versa
                var map = {};

                // Compare newTokens to oldTokens and call onAdded, onRemoved, and onChanged handlers for each affected event respectively.
                var applyChanges = function (newTokens, oldTokens) {
                    var i;
                    var token;
                    var replacedTokens = {};
                    var removedTokens = subtractAsSets(oldTokens, newTokens);
                    for (i = 0; i < removedTokens.length; i++) {
                        var removedToken = removedTokens[i];
                        var el = map[removedToken];
                        delete map[removedToken];
                        var newToken = tokenFn(el);
                        // if the element wasn't removed but simply got a new token, its old token will be different from the current one
                        if (newToken === removedToken) {
                            self.onRemoved(el);
                        } else {
                            replacedTokens[newToken] = removedToken;
                            self.onChanged(el);
                        }
                    }

                    var addedTokens = subtractAsSets(newTokens, oldTokens);
                    for (i = 0; i < addedTokens.length; i++) {
                        token = addedTokens[i];
                        if (!replacedTokens[token]) {
                            self.onAdded(map[token]);
                        }
                    }
                };

                self = {
                    subscribe : function (scope, onArrayChanged) {
                        scope.$watch(getTokens, function (newTokens, oldTokens) {
                            var notify = !(onArrayChanged && onArrayChanged(newTokens, oldTokens) === false);
                            if (notify) {
                                applyChanges(newTokens, oldTokens);
                            }
                        }, true);
                    },
                    onAdded : angular.noop,
                    onChanged : angular.noop,
                    onRemoved : angular.noop
                };
                return self;
            };

            this.getFullCalendarConfig = function (calendarSettings, uiCalendarConfig) {
                var config = {};

                angular.extend(config, uiCalendarConfig);
                angular.extend(config, calendarSettings);

                angular.forEach(config, function (value, key) {
                    if (typeof value === 'function') {
                        config[key] = wrapFunctionWithScopeApply(config[key]);
                    }
                });

                return config;
            };

            this.getLocaleConfig = function (fullCalendarConfig) {
                if (!fullCalendarConfig.lang && !fullCalendarConfig.locale || fullCalendarConfig.useNgLocale) {
                    // Configure to use locale names by default
                    var tValues = function (data) {
                        // convert {0: "Jan", 1: "Feb", ...} to ["Jan", "Feb", ...]
                        return (Object.keys(data) || []).reduce(
                            function (rslt, el) {
                                rslt.push(data[el]);
                                return rslt;
                            },
                            []
                        );
                    };

                    var dtf = $locale.DATETIME_FORMATS;
                    return {
                        monthNames : tValues(dtf.MONTH),
                        monthNamesShort : tValues(dtf.SHORTMONTH),
                        dayNames : tValues(dtf.DAY),
                        dayNamesShort : tValues(dtf.SHORTDAY)
                    };
                }

                return {};
            };
        }
    ])
    .directive('uiCalendar', ['uiCalendarConfig',
        function (uiCalendarConfig) {

            return {
                restrict : 'A',
                scope : {
                    eventSources : '=ngModel',
                    calendarWatchEvent : '&'
                },
                controller : 'uiCalendarCtrl',
                link : function (scope, elm, attrs, controller) {
                    var sources = scope.eventSources;
                    var sourcesChanged = false;
                    var calendar;
                    var eventSourcesWatcher = controller.changeWatcher(sources, controller.sourceFingerprint);
                    var eventsWatcher = controller.changeWatcher(controller.allEvents, controller.eventFingerprint);
                    var options = null;

                    function getOptions () {
                        var calendarSettings = attrs.uiCalendar ? scope.$parent.$eval(attrs.uiCalendar) : {};
                        var fullCalendarConfig = controller.getFullCalendarConfig(calendarSettings, uiCalendarConfig);
                        var localeFullCalendarConfig = controller.getLocaleConfig(fullCalendarConfig);
                        angular.extend(localeFullCalendarConfig, fullCalendarConfig);
                        options = {
                            eventSources : sources
                        };
                        angular.extend(options, localeFullCalendarConfig);
                        //remove calendars from options
                        options.calendars = null;

                        var options2 = {};
                        for (var o in options) {
                            if (o !== 'eventSources') {
                                options2[o] = options[o];
                            }
                        }
                        return JSON.stringify(options2);
                    }

                    scope.destroyCalendar = function () {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('destroy');
                        }
                        if (attrs.calendar) {
                            calendar = uiCalendarConfig.calendars[attrs.calendar] = angular.element(elm).html('');
                        } else {
                            calendar = angular.element(elm).html('');
                        }
                    };

                    scope.initCalendar = function () {
                        if (!calendar) {
                            calendar = $(elm).html('');
                        }
                        calendar.fullCalendar(options);
                        if (attrs.calendar) {
                            uiCalendarConfig.calendars[attrs.calendar] = calendar;
                        }
                    };

                    scope.$on('$destroy', function () {
                        scope.destroyCalendar();
                    });

                    eventSourcesWatcher.onAdded = function (source) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar(options);
                            if (attrs.calendar) {
                                uiCalendarConfig.calendars[attrs.calendar] = calendar;
                            }
                            calendar.fullCalendar('addEventSource', source);
                            sourcesChanged = true;
                        }
                    };

                    eventSourcesWatcher.onRemoved = function (source) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('removeEventSource', source);
                            sourcesChanged = true;
                        }
                    };

                    eventSourcesWatcher.onChanged = function () {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('refetchEvents');
                            sourcesChanged = true;
                        }
                    };

                    eventsWatcher.onAdded = function (event) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('renderEvent', event, !!event.stick);
                        }
                    };

                    eventsWatcher.onRemoved = function (event) {
                        if (calendar && calendar.fullCalendar) {
                            calendar.fullCalendar('removeEvents', event._id);
                        }
                    };

                    eventsWatcher.onChanged = function (event) {
                        if (calendar && calendar.fullCalendar) {
                            var clientEvents = calendar.fullCalendar('clientEvents', event._id);
                            for (var i = 0; i < clientEvents.length; i++) {
                                var clientEvent = clientEvents[i];
                                clientEvent = angular.extend(clientEvent, event);
                                calendar.fullCalendar('updateEvent', clientEvent);
                            }
                        }
                    };

                    eventSourcesWatcher.subscribe(scope);
                    eventsWatcher.subscribe(scope, function () {
                        if (sourcesChanged === true) {
                            sourcesChanged = false;
                            // return false to prevent onAdded/Removed/Changed handlers from firing in this case
                            return false;
                        }
                    });

                    scope.$watch(getOptions, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            
                            newValue = JSON.parse(newValue);
                            oldValue = JSON.parse(oldValue);

                            if(newValue.defaultView != oldValue.defaultView)
                                calendar.fullCalendar("changeView", newValue.defaultView);
                                
                        } else if ((newValue && angular.isUndefined(calendar))) {
                            scope.initCalendar();
                        }
                    });
                }
            };
        }
    ]
);
!function(e,a){"object"==typeof exports&&"object"==typeof module?module.exports=a(require("moment"),require("fullcalendar")):"function"==typeof define&&define.amd?define(["moment","fullcalendar"],a):"object"==typeof exports?a(require("moment"),require("fullcalendar")):a(e.moment,e.FullCalendar)}("undefined"!=typeof self?self:this,function(e,a){return function(e){function a(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,a),r.l=!0,r.exports}var t={};return a.m=e,a.c=t,a.d=function(e,t,n){a.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,a){return Object.prototype.hasOwnProperty.call(e,a)},a.p="",a(a.s=434)}([function(a,t){a.exports=e},function(e,t){e.exports=a},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(66);var n=t(1);n.datepickerLocale("af","af",{closeText:"Selekteer",prevText:"Vorige",nextText:"Volgende",currentText:"Vandag",monthNames:["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],monthNamesShort:["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],dayNames:["Sondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrydag","Saterdag"],dayNamesShort:["Son","Maa","Din","Woe","Don","Vry","Sat"],dayNamesMin:["So","Ma","Di","Wo","Do","Vr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("af",{buttonText:{year:"Jaar",month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayHtml:"Heeldag",eventLimitText:"Addisionele",noEventsMessage:"Daar is geen gebeurtenisse nie"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"vm":"VM":t?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[Môre om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(68);var n=t(1);n.datepickerLocale("ar-dz","ar-DZ",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["جانفي","فيفري","مارس","أفريل","ماي","جوان","جويلية","أوت","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-dz",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-dz",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"أح_إث_ثلا_أر_خم_جم_سب".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(70);var n=t(1);n.datepickerLocale("ar-kw","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-kw",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-kw",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(72);var n=t(1);n.datepickerLocale("ar-ly","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-ly",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},t=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},n={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},r=function(e){return function(a,r,s,d){var i=t(a),o=n[e][t(a)];return 2===i&&(o=o[r?0:1]),o.replace(/%d/i,a)}},s=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];return e.defineLocale("ar-ly",{months:s,monthsShort:s,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:r("s"),ss:r("s"),m:r("m"),mm:r("m"),h:r("h"),hh:r("h"),d:r("d"),dd:r("d"),M:r("M"),MM:r("M"),y:r("y"),yy:r("y")},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(74);var n=t(1);n.datepickerLocale("ar-ma","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-ma",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(76);var n=t(1);n.datepickerLocale("ar-sa","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-sa",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},t={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"};return e.defineLocale("ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:0,doy:6}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(78);var n=t(1);n.datepickerLocale("ar-tn","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar-tn",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(80);var n=t(1);n.datepickerLocale("ar","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ar",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},t={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},n=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},r={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},s=function(e){return function(a,t,s,d){var i=n(a),o=r[e][n(a)];return 2===i&&(o=o[t?0:1]),o.replace(/%d/i,a)}},d=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];return e.defineLocale("ar",{months:d,monthsShort:d,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:s("s"),ss:s("s"),m:s("m"),mm:s("m"),h:s("h"),hh:s("h"),d:s("d"),dd:s("d"),M:s("M"),MM:s("M"),y:s("y"),yy:s("y")},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(82);var n=t(1);n.datepickerLocale("bg","bg",{closeText:"затвори",prevText:"&#x3C;назад",nextText:"напред&#x3E;",nextBigText:"&#x3E;&#x3E;",currentText:"днес",monthNames:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Яну","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Нов","Дек"],dayNames:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"],dayNamesShort:["Нед","Пон","Вто","Сря","Чет","Пет","Съб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Съ"],weekHeader:"Wk",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("bg",{buttonText:{month:"Месец",week:"Седмица",day:"Ден",list:"График"},allDayText:"Цял ден",eventLimitText:function(e){return"+още "+e},noEventsMessage:"Няма събития за показване"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[В изминалата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[В изминалия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",ss:"%d секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дни",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-ев":0===t?e+"-ен":t>10&&t<20?e+"-ти":1===a?e+"-ви":2===a?e+"-ри":7===a||8===a?e+"-ми":e+"-ти"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(84);var n=t(1);n.datepickerLocale("bs","bs",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Januar","Februar","Mart","April","Maj","Juni","Juli","August","Septembar","Oktobar","Novmbar","Decembar"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNames:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Sed",dateFormat:"dd.mm.yy.",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("bs",{buttonText:{prev:"Prošli",next:"Sljedeći",month:"Mjesec",week:"Sedmica",day:"Dan",list:"Raspored"},allDayText:"Cijeli dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nema događaja za prikazivanje"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){var n=e+" ";switch(t){case"ss":return n+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return n+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return n+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return n+=1===e?"dan":"dana";case"MM":return n+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return n+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}return e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:a,m:a,mm:a,h:a,hh:a,d:"dan",dd:a,M:"mjesec",MM:a,y:"godinu",yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(86);var n=t(1);n.datepickerLocale("ca","ca",{closeText:"Tanca",prevText:"Anterior",nextText:"Següent",currentText:"Avui",monthNames:["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre"],monthNamesShort:["gen","feb","març","abr","maig","juny","jul","ag","set","oct","nov","des"],dayNames:["diumenge","dilluns","dimarts","dimecres","dijous","divendres","dissabte"],dayNamesShort:["dg","dl","dt","dc","dj","dv","ds"],dayNamesMin:["dg","dl","dt","dc","dj","dv","ds"],weekHeader:"Set",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ca",{buttonText:{month:"Mes",week:"Setmana",day:"Dia",list:"Agenda"},allDayText:"Tot el dia",eventLimitText:"més",noEventsMessage:"No hi ha esdeveniments per mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ca",{months:{standalone:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,a){var t=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return"w"!==a&&"W"!==a||(t="a"),e+t},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(88);var n=t(1);n.datepickerLocale("cs","cs",{closeText:"Zavřít",prevText:"&#x3C;Dříve",nextText:"Později&#x3E;",currentText:"Nyní",monthNames:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],monthNamesShort:["led","úno","bře","dub","kvě","čer","čvc","srp","zář","říj","lis","pro"],dayNames:["neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota"],dayNamesShort:["ne","po","út","st","čt","pá","so"],dayNamesMin:["ne","po","út","st","čt","pá","so"],weekHeader:"Týd",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("cs",{buttonText:{month:"Měsíc",week:"Týden",day:"Den",list:"Agenda"},allDayText:"Celý den",eventLimitText:function(e){return"+další: "+e},noEventsMessage:"Žádné akce k zobrazení"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e>1&&e<5&&1!=~~(e/10)}function t(e,t,n,r){var s=e+" ";switch(n){case"s":return t||r?"pár sekund":"pár sekundami";case"ss":return t||r?s+(a(e)?"sekundy":"sekund"):s+"sekundami";case"m":return t?"minuta":r?"minutu":"minutou";case"mm":return t||r?s+(a(e)?"minuty":"minut"):s+"minutami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?s+(a(e)?"hodiny":"hodin"):s+"hodinami";case"d":return t||r?"den":"dnem";case"dd":return t||r?s+(a(e)?"dny":"dní"):s+"dny";case"M":return t||r?"měsíc":"měsícem";case"MM":return t||r?s+(a(e)?"měsíce":"měsíců"):s+"měsíci";case"y":return t||r?"rok":"rokem";case"yy":return t||r?s+(a(e)?"roky":"let"):s+"lety"}}var n="leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),r="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_");return e.defineLocale("cs",{months:n,monthsShort:r,monthsParse:function(e,a){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp("^"+e[t]+"$|^"+a[t]+"$","i");return n}(n,r),shortMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(r),longMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(n),weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(90);var n=t(1);n.datepickerLocale("da","da",{closeText:"Luk",prevText:"&#x3C;Forrige",nextText:"Næste&#x3E;",currentText:"Idag",monthNames:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNames:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],dayNamesShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayNamesMin:["Sø","Ma","Ti","On","To","Fr","Lø"],weekHeader:"Uge",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("da",{buttonText:{month:"Måned",week:"Uge",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"flere",noEventsMessage:"Ingen arrangementer at vise"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"på dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(92);var n=t(1);n.datepickerLocale("de-at","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("de-at",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}return e.defineLocale("de-at",{
months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(94);var n=t(1);n.datepickerLocale("de-ch","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("de-ch",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}return e.defineLocale("de-ch",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(96);var n=t(1);n.datepickerLocale("de","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("de",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}return e.defineLocale("de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(98);var n=t(1);n.datepickerLocale("el","el",{closeText:"Κλείσιμο",prevText:"Προηγούμενος",nextText:"Επόμενος",currentText:"Σήμερα",monthNames:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],monthNamesShort:["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],dayNames:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"],dayNamesShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],dayNamesMin:["Κυ","Δε","Τρ","Τε","Πε","Πα","Σα"],weekHeader:"Εβδ",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("el",{buttonText:{month:"Μήνας",week:"Εβδομάδα",day:"Ημέρα",list:"Ατζέντα"},allDayText:"Ολοήμερο",eventLimitText:"περισσότερα",noEventsMessage:"Δεν υπάρχουν γεγονότα για να εμφανιστεί"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}return e.defineLocale("el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(e,a){return e?"string"==typeof a&&/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(e,a,t){return e>11?t?"μμ":"ΜΜ":t?"πμ":"ΠΜ"},isPM:function(e){return"μ"===(e+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[το προηγούμενο] dddd [{}] LT";default:return"[την προηγούμενη] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,t){var n=this._calendarEl[e],r=t&&t.hours();return a(n)&&(n=n.apply(t)),n.replace("{}",r%12==1?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",ss:"%d δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},dayOfMonthOrdinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(100);var n=t(1);n.datepickerLocale("en-au","en-AU",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("en-au")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(102),t(1).locale("en-ca")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(104);var n=t(1);n.datepickerLocale("en-gb","en-GB",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("en-gb")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(106),t(1).locale("en-ie")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(108);var n=t(1);n.datepickerLocale("en-nz","en-NZ",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("en-nz")},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(110);var n=t(1);n.datepickerLocale("es-do","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("es-do",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],r=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;return e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(112);var n=t(1);n.datepickerLocale("es-us","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("es-us",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_");return e.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsParseExact:!0,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"MMMM [de] D [de] YYYY",LLL:"MMMM [de] D [de] YYYY h:mm A",LLLL:"dddd, MMMM [de] D [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:0,doy:6}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(114);var n=t(1);n.datepickerLocale("es","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("es",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],r=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;return e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(116);var n=t(1);n.datepickerLocale("et","et",{closeText:"Sulge",prevText:"Eelnev",nextText:"Järgnev",currentText:"Täna",monthNames:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],monthNamesShort:["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],dayNames:["Pühapäev","Esmaspäev","Teisipäev","Kolmapäev","Neljapäev","Reede","Laupäev"],dayNamesShort:["Pühap","Esmasp","Teisip","Kolmap","Neljap","Reede","Laup"],dayNamesMin:["P","E","T","K","N","R","L"],weekHeader:"näd",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("et",{buttonText:{month:"Kuu",week:"Nädal",day:"Päev",list:"Päevakord"},allDayText:"Kogu päev",eventLimitText:function(e){return"+ veel "+e},noEventsMessage:"Kuvamiseks puuduvad sündmused"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={s:["mõne sekundi","mõni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["ühe minuti","üks minut"],mm:[e+" minuti",e+" minutit"],h:["ühe tunni","tund aega","üks tund"],hh:[e+" tunni",e+" tundi"],d:["ühe päeva","üks päev"],M:["kuu aja","kuu aega","üks kuu"],MM:[e+" kuu",e+" kuud"],y:["ühe aasta","aasta","üks aasta"],yy:[e+" aasta",e+" aastat"]};return a?r[t][2]?r[t][2]:r[t][1]:n?r[t][0]:r[t][1]}return e.defineLocale("et",{months:"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[Täna,] LT",nextDay:"[Homme,] LT",nextWeek:"[Järgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s pärast",past:"%s tagasi",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:"%d päeva",M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(118);var n=t(1);n.datepickerLocale("eu","eu",{closeText:"Egina",prevText:"&#x3C;Aur",nextText:"Hur&#x3E;",currentText:"Gaur",monthNames:["urtarrila","otsaila","martxoa","apirila","maiatza","ekaina","uztaila","abuztua","iraila","urria","azaroa","abendua"],monthNamesShort:["urt.","ots.","mar.","api.","mai.","eka.","uzt.","abu.","ira.","urr.","aza.","abe."],dayNames:["igandea","astelehena","asteartea","asteazkena","osteguna","ostirala","larunbata"],dayNamesShort:["ig.","al.","ar.","az.","og.","ol.","lr."],dayNamesMin:["ig","al","ar","az","og","ol","lr"],weekHeader:"As",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("eu",{buttonText:{month:"Hilabetea",week:"Astea",day:"Eguna",list:"Agenda"},allDayHtml:"Egun<br/>osoa",eventLimitText:"gehiago",noEventsMessage:"Ez dago ekitaldirik erakusteko"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(120);var n=t(1);n.datepickerLocale("fa","fa",{closeText:"بستن",prevText:"&#x3C;قبلی",nextText:"بعدی&#x3E;",currentText:"امروز",monthNames:["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["يکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"],dayNamesShort:["ی","د","س","چ","پ","ج","ش"],dayNamesMin:["ی","د","س","چ","پ","ج","ش"],weekHeader:"هف",dateFormat:"yy/mm/dd",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fa",{buttonText:{month:"ماه",week:"هفته",day:"روز",list:"برنامه"},allDayText:"تمام روز",eventLimitText:function(e){return"بیش از "+e},noEventsMessage:"هیچ رویدادی به نمایش"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},t={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"};return e.defineLocale("fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,a,t){return e<12?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چند ثانیه",ss:"ثانیه d%",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},dayOfMonthOrdinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(122);var n=t(1);n.datepickerLocale("fi","fi",{closeText:"Sulje",prevText:"&#xAB;Edellinen",nextText:"Seuraava&#xBB;",currentText:"Tänään",monthNames:["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kesäkuu","Heinäkuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"],monthNamesShort:["Tammi","Helmi","Maalis","Huhti","Touko","Kesä","Heinä","Elo","Syys","Loka","Marras","Joulu"],dayNamesShort:["Su","Ma","Ti","Ke","To","Pe","La"],dayNames:["Sunnuntai","Maanantai","Tiistai","Keskiviikko","Torstai","Perjantai","Lauantai"],dayNamesMin:["Su","Ma","Ti","Ke","To","Pe","La"],weekHeader:"Vk",dateFormat:"d.m.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fi",{buttonText:{month:"Kuukausi",week:"Viikko",day:"Päivä",list:"Tapahtumat"},allDayText:"Koko päivä",eventLimitText:"lisää",noEventsMessage:"Ei näytettäviä tapahtumia"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,n,r){var s="";switch(n){
case"s":return r?"muutaman sekunnin":"muutama sekunti";case"ss":return r?"sekunnin":"sekuntia";case"m":return r?"minuutin":"minuutti";case"mm":s=r?"minuutin":"minuuttia";break;case"h":return r?"tunnin":"tunti";case"hh":s=r?"tunnin":"tuntia";break;case"d":return r?"päivän":"päivä";case"dd":s=r?"päivän":"päivää";break;case"M":return r?"kuukauden":"kuukausi";case"MM":s=r?"kuukauden":"kuukautta";break;case"y":return r?"vuoden":"vuosi";case"yy":s=r?"vuoden":"vuotta"}return s=t(e,r)+" "+s}function t(e,a){return e<10?a?r[e]:n[e]:e}var n="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),r=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",n[7],n[8],n[9]];return e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(124);var n=t(1);n.datepickerLocale("fr-ca","fr-CA",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"yy-mm-dd",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fr-ca",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(126);var n=t(1);n.datepickerLocale("fr-ch","fr-CH",{closeText:"Fermer",prevText:"&#x3C;Préc",nextText:"Suiv&#x3E;",currentText:"Courant",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sm",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fr-ch",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("fr-ch",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(128);var n=t(1);n.datepickerLocale("fr","fr",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("fr",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(130);var n=t(1);n.datepickerLocale("gl","gl",{closeText:"Pechar",prevText:"&#x3C;Ant",nextText:"Seg&#x3E;",currentText:"Hoxe",monthNames:["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],monthNamesShort:["Xan","Feb","Mar","Abr","Mai","Xuñ","Xul","Ago","Set","Out","Nov","Dec"],dayNames:["Domingo","Luns","Martes","Mércores","Xoves","Venres","Sábado"],dayNamesShort:["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"],dayNamesMin:["Do","Lu","Ma","Mé","Xo","Ve","Sá"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("gl",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Axenda"},allDayHtml:"Todo<br/>o día",eventLimitText:"máis",noEventsMessage:"Non hai eventos para amosar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),weekdaysShort:"dom._lun._mar._mér._xov._ven._sáb.".split("_"),weekdaysMin:"do_lu_ma_mé_xo_ve_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"ás":"á")+"] LT"},nextDay:function(){return"[mañá "+(1!==this.hours()?"ás":"á")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"ás":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"á":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"ás":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(132);var n=t(1);n.datepickerLocale("he","he",{closeText:"סגור",prevText:"&#x3C;הקודם",nextText:"הבא&#x3E;",currentText:"היום",monthNames:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],monthNamesShort:["ינו","פבר","מרץ","אפר","מאי","יוני","יולי","אוג","ספט","אוק","נוב","דצמ"],dayNames:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת"],dayNamesShort:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],dayNamesMin:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),n.locale("he",{buttonText:{month:"חודש",week:"שבוע",day:"יום",list:"סדר יום"},allDayText:"כל היום",eventLimitText:"אחר",noEventsMessage:"אין אירועים להצגה",weekNumberTitle:"שבוע"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY HH:mm",LLLL:"dddd, D [ב]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",ss:"%d שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(e){return 2===e?"שעתיים":e+" שעות"},d:"יום",dd:function(e){return 2===e?"יומיים":e+" ימים"},M:"חודש",MM:function(e){return 2===e?"חודשיים":e+" חודשים"},y:"שנה",yy:function(e){return 2===e?"שנתיים":e%10==0&&10!==e?e+" שנה":e+" שנים"}},meridiemParse:/אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,a,t){return e<5?"לפנות בוקר":e<10?"בבוקר":e<12?t?'לפנה"צ':"לפני הצהריים":e<18?t?'אחה"צ':"אחרי הצהריים":"בערב"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(134);var n=t(1);n.datepickerLocale("hi","hi",{closeText:"बंद",prevText:"पिछला",nextText:"अगला",currentText:"आज",monthNames:["जनवरी ","फरवरी","मार्च","अप्रेल","मई","जून","जूलाई","अगस्त ","सितम्बर","अक्टूबर","नवम्बर","दिसम्बर"],monthNamesShort:["जन","फर","मार्च","अप्रेल","मई","जून","जूलाई","अग","सित","अक्ट","नव","दि"],dayNames:["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],dayNamesShort:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],dayNamesMin:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],weekHeader:"हफ्ता",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("hi",{buttonText:{month:"महीना",week:"सप्ताह",day:"दिन",list:"कार्यसूची"},allDayText:"सभी दिन",eventLimitText:function(e){return"+अधिक "+e},noEventsMessage:"कोई घटनाओं को प्रदर्शित करने के लिए"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},t={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};return e.defineLocale("hi",{months:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm बजे",LLLL:"dddd, D MMMM YYYY, A h:mm बजे"},calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",ss:"%d सेकंड",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return t[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,a){return 12===e&&(e=0),"रात"===a?e<4?e:e+12:"सुबह"===a?e:"दोपहर"===a?e>=10?e:e+12:"शाम"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"रात":e<10?"सुबह":e<17?"दोपहर":e<20?"शाम":"रात"},week:{dow:0,doy:6}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(136);var n=t(1);n.datepickerLocale("hr","hr",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],monthNamesShort:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],dayNames:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Tje",dateFormat:"dd.mm.yy.",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("hr",{buttonText:{prev:"Prijašnji",next:"Sljedeći",month:"Mjesec",week:"Tjedan",day:"Dan",list:"Raspored"},allDayText:"Cijeli dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nema događaja za prikaz"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){var n=e+" ";switch(t){case"ss":return n+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return n+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return n+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return n+=1===e?"dan":"dana";case"MM":return n+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return n+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}return e.defineLocale("hr",{months:{format:"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:a,m:a,mm:a,h:a,hh:a,d:"dan",dd:a,M:"mjesec",MM:a,y:"godinu",yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(138);var n=t(1);n.datepickerLocale("hu","hu",{closeText:"bezár",prevText:"vissza",nextText:"előre",currentText:"ma",monthNames:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],monthNamesShort:["Jan","Feb","Már","Ápr","Máj","Jún","Júl","Aug","Szep","Okt","Nov","Dec"],dayNames:["Vasárnap","Hétfő","Kedd","Szerda","Csütörtök","Péntek","Szombat"],dayNamesShort:["Vas","Hét","Ked","Sze","Csü","Pén","Szo"],dayNamesMin:["V","H","K","Sze","Cs","P","Szo"],weekHeader:"Hét",dateFormat:"yy.mm.dd.",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),n.locale("hu",{buttonText:{month:"Hónap",week:"Hét",day:"Nap",list:"Napló"},allDayText:"Egész nap",eventLimitText:"további",noEventsMessage:"Nincs megjeleníthető események"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r=e;switch(t){case"s":return n||a?"néhány másodperc":"néhány másodperce";case"ss":return r+(n||a)?" másodperc":" másodperce";case"m":return"egy"+(n||a?" perc":" perce");case"mm":return r+(n||a?" perc":" perce");case"h":return"egy"+(n||a?" óra":" órája");case"hh":return r+(n||a?" óra":" órája");case"d":return"egy"+(n||a?" nap":" napja");case"dd":return r+(n||a?" nap":" napja");case"M":return"egy"+(n||a?" hónap":" hónapja");case"MM":return r+(n||a?" hónap":" hónapja");case"y":return"egy"+(n||a?" év":" éve");case"yy":return r+(n||a?" év":" éve")}return""}function t(e){return(e?"":"[múlt] ")+"["+n[this.day()]+"] LT[-kor]"}var n="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");return e.defineLocale("hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,t){return e<12?!0===t?"de":"DE":!0===t?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return t.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return t.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(140);var n=t(1);n.datepickerLocale("id","id",{closeText:"Tutup",prevText:"&#x3C;mundur",nextText:"maju&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","Nopember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agus","Sep","Okt","Nop","Des"],dayNames:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"],dayNamesShort:["Min","Sen","Sel","Rab","kam","Jum","Sab"],dayNamesMin:["Mg","Sn","Sl","Rb","Km","jm","Sb"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("id",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayHtml:"Sehari<br/>penuh",eventLimitText:"lebih",noEventsMessage:"Tidak ada acara untuk ditampilkan"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?e>=11?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(142);var n=t(1);n.datepickerLocale("is","is",{closeText:"Loka",prevText:"&#x3C; Fyrri",nextText:"Næsti &#x3E;",currentText:"Í dag",monthNames:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],dayNames:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"],dayNamesShort:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"],dayNamesMin:["Su","Má","Þr","Mi","Fi","Fö","La"],weekHeader:"Vika",dateFormat:"dd.mm.yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("is",{buttonText:{month:"Mánuður",week:"Vika",day:"Dagur",list:"Dagskrá"},allDayHtml:"Allan<br/>daginn",eventLimitText:"meira",noEventsMessage:"Engir viðburðir til að sýna"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e%100==11||e%10!=1}function t(e,t,n,r){var s=e+" ";switch(n){case"s":return t||r?"nokkrar sekúndur":"nokkrum sekúndum";case"ss":return a(e)?s+(t||r?"sekúndur":"sekúndum"):s+"sekúnda";case"m":return t?"mínúta":"mínútu";case"mm":return a(e)?s+(t||r?"mínútur":"mínútum"):t?s+"mínúta":s+"mínútu";case"hh":return a(e)?s+(t||r?"klukkustundir":"klukkustundum"):s+"klukkustund";case"d":return t?"dagur":r?"dag":"degi";case"dd":return a(e)?t?s+"dagar":s+(r?"daga":"dögum"):t?s+"dagur":s+(r?"dag":"degi");case"M":return t?"mánuður":r?"mánuð":"mánuði";case"MM":return a(e)?t?s+"mánuðir":s+(r?"mánuði":"mánuðum"):t?s+"mánuður":s+(r?"mánuð":"mánuði");case"y":return t||r?"ár":"ári";case"yy":return a(e)?s+(t||r?"ár":"árum"):s+(t||r?"ár":"ári")}}return e.defineLocale("is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:t,ss:t,m:t,mm:t,h:"klukkustund",hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(144);var n=t(1);n.datepickerLocale("it","it",{closeText:"Chiudi",prevText:"&#x3C;Prec",nextText:"Succ&#x3E;",currentText:"Oggi",monthNames:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthNamesShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],dayNames:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],dayNamesShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayNamesMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("it",{buttonText:{month:"Mese",week:"Settimana",day:"Giorno",list:"Agenda"},allDayHtml:"Tutto il<br/>giorno",eventLimitText:function(e){return"+altri "+e},noEventsMessage:"Non ci sono eventi da visualizzare"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(146);var n=t(1);n.datepickerLocale("ja","ja",{closeText:"閉じる",prevText:"&#x3C;前",nextText:"次&#x3E;",currentText:"今日",monthNames:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthNamesShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayNames:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],dayNamesShort:["日","月","火","水","木","金","土"],dayNamesMin:["日","月","火","水","木","金","土"],weekHeader:"週",dateFormat:"yy/mm/dd",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),n.locale("ja",{buttonText:{month:"月",week:"週",day:"日",list:"予定リスト"},allDayText:"終日",eventLimitText:function(e){return"他 "+e+" 件"},noEventsMessage:"イベントが表示されないように"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ja",{months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日 HH:mm dddd",l:"YYYY/MM/DD",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日 HH:mm dddd"},meridiemParse:/午前|午後/i,isPM:function(e){return"午後"===e},meridiem:function(e,a,t){return e<12?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:"[来週]dddd LT",lastDay:"[昨日] LT",lastWeek:"[前週]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}日/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"数秒",ss:"%d秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(148);var n=t(1);n.datepickerLocale("ka","ka",{closeText:"დახურვა",prevText:"წინა",nextText:"შემდეგი",currentText:"დღეს",monthNames:["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],monthNamesShort:["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],dayNames:["კვირა","ორშაბათი","სამშაბათი","ოთხშაბათი","ხუთშაბათი","პარასკევი","შაბათი"],dayNamesShort:["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"],dayNamesMin:["კვ","ორ","სა","ოთ","ხუ","პა","შა"],weekHeader:"კვ",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ka",{buttonText:{month:"თვე",week:"კვირა",day:"დღე",list:"დღის წესრიგი"},allDayText:"მთელი დღე",eventLimitText:function(e){return"+ კიდევ "+e},noEventsMessage:"ღონისძიებები არ არის"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ka",{months:{standalone:"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),format:"იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს".split("_")},monthsShort:"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),weekdays:{standalone:"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),format:"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),weekdaysMin:"კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[დღეს] LT[-ზე]",nextDay:"[ხვალ] LT[-ზე]",lastDay:"[გუშინ] LT[-ზე]",nextWeek:"[შემდეგ] dddd LT[-ზე]",lastWeek:"[წინა] dddd LT-ზე",sameElse:"L"},relativeTime:{future:function(e){return/(წამი|წუთი|საათი|წელი)/.test(e)?e.replace(/ი$/,"ში"):e+"ში"},past:function(e){return/(წამი|წუთი|საათი|დღე|თვე)/.test(e)?e.replace(/(ი|ე)$/,"ის უკან"):/წელი/.test(e)?e.replace(/წელი$/,"წლის უკან"):void 0},s:"რამდენიმე წამი",ss:"%d წამი",m:"წუთი",mm:"%d წუთი",h:"საათი",hh:"%d საათი",d:"დღე",dd:"%d დღე",M:"თვე",MM:"%d თვე",y:"წელი",yy:"%d წელი"},dayOfMonthOrdinalParse:/0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,ordinal:function(e){return 0===e?e:1===e?e+"-ლი":e<20||e<=100&&e%20==0||e%100==0?"მე-"+e:e+"-ე"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(150);var n=t(1);n.datepickerLocale("kk","kk",{closeText:"Жабу",prevText:"&#x3C;Алдыңғы",nextText:"Келесі&#x3E;",currentText:"Бүгін",monthNames:["Қаңтар","Ақпан","Наурыз","Сәуір","Мамыр","Маусым","Шілде","Тамыз","Қыркүйек","Қазан","Қараша","Желтоқсан"],
monthNamesShort:["Қаң","Ақп","Нау","Сәу","Мам","Мау","Шіл","Там","Қыр","Қаз","Қар","Жел"],dayNames:["Жексенбі","Дүйсенбі","Сейсенбі","Сәрсенбі","Бейсенбі","Жұма","Сенбі"],dayNamesShort:["жкс","дсн","ссн","срс","бсн","жма","снб"],dayNamesMin:["Жк","Дс","Сс","Ср","Бс","Жм","Сн"],weekHeader:"Не",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("kk",{buttonText:{month:"Ай",week:"Апта",day:"Күн",list:"Күн тәртібі"},allDayText:"Күні бойы",eventLimitText:function(e){return"+ тағы "+e},noEventsMessage:"Көрсету үшін оқиғалар жоқ"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={0:"-ші",1:"-ші",2:"-ші",3:"-ші",4:"-ші",5:"-ші",6:"-шы",7:"-ші",8:"-ші",9:"-шы",10:"-шы",20:"-шы",30:"-шы",40:"-шы",50:"-ші",60:"-шы",70:"-ші",80:"-ші",90:"-шы",100:"-ші"};return e.defineLocale("kk",{months:"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),monthsShort:"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),weekdays:"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),weekdaysShort:"жек_дүй_сей_сәр_бей_жұм_сен".split("_"),weekdaysMin:"жк_дй_сй_ср_бй_жм_сн".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгін сағат] LT",nextDay:"[Ертең сағат] LT",nextWeek:"dddd [сағат] LT",lastDay:"[Кеше сағат] LT",lastWeek:"[Өткен аптаның] dddd [сағат] LT",sameElse:"L"},relativeTime:{future:"%s ішінде",past:"%s бұрын",s:"бірнеше секунд",ss:"%d секунд",m:"бір минут",mm:"%d минут",h:"бір сағат",hh:"%d сағат",d:"бір күн",dd:"%d күн",M:"бір ай",MM:"%d ай",y:"бір жыл",yy:"%d жыл"},dayOfMonthOrdinalParse:/\d{1,2}-(ші|шы)/,ordinal:function(e){var t=e%10,n=e>=100?100:null;return e+(a[e]||a[t]||a[n])},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(152);var n=t(1);n.datepickerLocale("ko","ko",{closeText:"닫기",prevText:"이전달",nextText:"다음달",currentText:"오늘",monthNames:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],monthNamesShort:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayNames:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],dayNamesShort:["일","월","화","수","목","금","토"],dayNamesMin:["일","월","화","수","목","금","토"],weekHeader:"주",dateFormat:"yy. m. d.",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"년"}),n.locale("ko",{buttonText:{month:"월",week:"주",day:"일",list:"일정목록"},allDayText:"종일",eventLimitText:"개",noEventsMessage:"일정이 없습니다"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h:mm",LLLL:"YYYY년 MMMM D일 dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY년 MMMM D일",lll:"YYYY년 MMMM D일 A h:mm",llll:"YYYY년 MMMM D일 dddd A h:mm"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",ss:"%d초",m:"1분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"},dayOfMonthOrdinalParse:/\d{1,2}(일|월|주)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"일";case"M":return e+"월";case"w":case"W":return e+"주";default:return e}},meridiemParse:/오전|오후/,isPM:function(e){return"오후"===e},meridiem:function(e,a,t){return e<12?"오전":"오후"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(154);var n=t(1);n.datepickerLocale("lb","lb",{closeText:"Fäerdeg",prevText:"Zréck",nextText:"Weider",currentText:"Haut",monthNames:["Januar","Februar","Mäerz","Abrëll","Mee","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mäe","Abr","Mee","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonndeg","Méindeg","Dënschdeg","Mëttwoch","Donneschdeg","Freideg","Samschdeg"],dayNamesShort:["Son","Méi","Dën","Mët","Don","Fre","Sam"],dayNamesMin:["So","Mé","Dë","Më","Do","Fr","Sa"],weekHeader:"W",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("lb",{buttonText:{month:"Mount",week:"Woch",day:"Dag",list:"Terminiwwersiicht"},allDayText:"Ganzen Dag",eventLimitText:"méi",noEventsMessage:"Nee Evenementer ze affichéieren"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?r[t][0]:r[t][1]}function t(e){return r(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e}function n(e){return r(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e}function r(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var a=e%10,t=e/10;return r(0===a?t:a)}if(e<1e4){for(;e>=10;)e/=10;return r(e)}return e/=1e3,r(e)}return e.defineLocale("lb",{months:"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mé_Dë_Më_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[Gëschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:t,past:n,s:"e puer Sekonnen",ss:"%d Sekonnen",m:a,mm:"%d Minutten",h:a,hh:"%d Stonnen",d:a,dd:"%d Deeg",M:a,MM:"%d Méint",y:a,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(156);var n=t(1);n.datepickerLocale("lt","lt",{closeText:"Uždaryti",prevText:"&#x3C;Atgal",nextText:"Pirmyn&#x3E;",currentText:"Šiandien",monthNames:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],monthNamesShort:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],dayNames:["sekmadienis","pirmadienis","antradienis","trečiadienis","ketvirtadienis","penktadienis","šeštadienis"],dayNamesShort:["sek","pir","ant","tre","ket","pen","šeš"],dayNamesMin:["Se","Pr","An","Tr","Ke","Pe","Še"],weekHeader:"SAV",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),n.locale("lt",{buttonText:{month:"Mėnuo",week:"Savaitė",day:"Diena",list:"Darbotvarkė"},allDayText:"Visą dieną",eventLimitText:"daugiau",noEventsMessage:"Nėra įvykių rodyti"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){return a?"kelios sekundės":n?"kelių sekundžių":"kelias sekundes"}function t(e,a,t,n){return a?r(t)[0]:n?r(t)[1]:r(t)[2]}function n(e){return e%10==0||e>10&&e<20}function r(e){return d[e].split("_")}function s(e,a,s,d){var i=e+" ";return 1===e?i+t(e,a,s[0],d):a?i+(n(e)?r(s)[1]:r(s)[0]):d?i+r(s)[1]:i+(n(e)?r(s)[1]:r(s)[2])}var d={ss:"sekundė_sekundžių_sekundes",m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"};return e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:a,ss:s,m:t,mm:s,h:t,hh:s,d:t,dd:s,M:t,MM:s,y:t,yy:s},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(158);var n=t(1);n.datepickerLocale("lv","lv",{closeText:"Aizvērt",prevText:"Iepr.",nextText:"Nāk.",currentText:"Šodien",monthNames:["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],monthNamesShort:["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],dayNames:["svētdiena","pirmdiena","otrdiena","trešdiena","ceturtdiena","piektdiena","sestdiena"],dayNamesShort:["svt","prm","otr","tre","ctr","pkt","sst"],dayNamesMin:["Sv","Pr","Ot","Tr","Ct","Pk","Ss"],weekHeader:"Ned.",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("lv",{buttonText:{month:"Mēnesis",week:"Nedēļa",day:"Diena",list:"Dienas kārtība"},allDayText:"Visu dienu",eventLimitText:function(e){return"+vēl "+e},noEventsMessage:"Nav notikumu"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){return t?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function t(e,t,n){return e+" "+a(s[n],e,t)}function n(e,t,n){return a(s[n],e,t)}function r(e,a){return a?"dažas sekundes":"dažām sekundēm"}var s={ss:"sekundes_sekundēm_sekunde_sekundes".split("_"),m:"minūtes_minūtēm_minūte_minūtes".split("_"),mm:"minūtes_minūtēm_minūte_minūtes".split("_"),h:"stundas_stundām_stunda_stundas".split("_"),hh:"stundas_stundām_stunda_stundas".split("_"),d:"dienas_dienām_diena_dienas".split("_"),dd:"dienas_dienām_diena_dienas".split("_"),M:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),MM:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};return e.defineLocale("lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"pēc %s",past:"pirms %s",s:r,ss:t,m:n,mm:t,h:n,hh:t,d:n,dd:t,M:n,MM:t,y:n,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(160);var n=t(1);n.datepickerLocale("mk","mk",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Денес",monthNames:["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],dayNames:["Недела","Понеделник","Вторник","Среда","Четврток","Петок","Сабота"],dayNamesShort:["Нед","Пон","Вто","Сре","Чет","Пет","Саб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Са"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("mk",{buttonText:{month:"Месец",week:"Недела",day:"Ден",list:"График"},allDayText:"Цел ден",eventLimitText:function(e){return"+повеќе "+e},noEventsMessage:"Нема настани за прикажување"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("mk",{months:"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),monthsShort:"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),weekdays:"недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),weekdaysShort:"нед_пон_вто_сре_чет_пет_саб".split("_"),weekdaysMin:"нe_пo_вт_ср_че_пе_сa".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Денес во] LT",nextDay:"[Утре во] LT",nextWeek:"[Во] dddd [во] LT",lastDay:"[Вчера во] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Изминатата] dddd [во] LT";case 1:case 2:case 4:case 5:return"[Изминатиот] dddd [во] LT"}},sameElse:"L"},relativeTime:{future:"после %s",past:"пред %s",s:"неколку секунди",ss:"%d секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дена",M:"месец",MM:"%d месеци",y:"година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-ев":0===t?e+"-ен":t>10&&t<20?e+"-ти":1===a?e+"-ви":2===a?e+"-ри":7===a||8===a?e+"-ми":e+"-ти"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(162);var n=t(1);n.datepickerLocale("ms-my","ms",{closeText:"Tutup",prevText:"&#x3C;Sebelum",nextText:"Selepas&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthNamesShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],dayNames:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],dayNamesShort:["Aha","Isn","Sel","Rab","kha","Jum","Sab"],dayNamesMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ms-my",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayText:"Sepanjang hari",eventLimitText:function(e){return"masih ada "+e+" acara"},noEventsMessage:"Tiada peristiwa untuk dipaparkan"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(164);var n=t(1);n.datepickerLocale("ms","ms",{closeText:"Tutup",prevText:"&#x3C;Sebelum",nextText:"Selepas&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthNamesShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],dayNames:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],dayNamesShort:["Aha","Isn","Sel","Rab","kha","Jum","Sab"],dayNamesMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ms",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayText:"Sepanjang hari",eventLimitText:function(e){return"masih ada "+e+" acara"},noEventsMessage:"Tiada peristiwa untuk dipaparkan"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(166);var n=t(1);n.datepickerLocale("nb","nb",{closeText:"Lukk",prevText:"&#xAB;Forrige",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["søn","man","tir","ons","tor","fre","lør"],dayNames:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],dayNamesMin:["sø","ma","ti","on","to","fr","lø"],weekHeader:"Uke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nb",{buttonText:{month:"Måned",week:"Uke",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"til",noEventsMessage:"Ingen hendelser å vise"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"sø._ma._ti._on._to._fr._lø.".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en måned",MM:"%d måneder",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(168);var n=t(1);n.datepickerLocale("nl-be","nl-BE",{closeText:"Sluiten",prevText:"←",nextText:"→",currentText:"Vandaag",monthNames:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNamesShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],dayNames:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayNamesShort:["zon","maa","din","woe","don","vri","zat"],dayNamesMin:["zo","ma","di","wo","do","vr","za"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nl-be",{buttonText:{month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayText:"Hele dag",eventLimitText:"extra",noEventsMessage:"Geen evenementen om te laten zien"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),t="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),n=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],r=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;return e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(170);var n=t(1);n.datepickerLocale("nl","nl",{closeText:"Sluiten",prevText:"←",nextText:"→",currentText:"Vandaag",monthNames:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNamesShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],dayNames:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayNamesShort:["zon","maa","din","woe","don","vri","zat"],dayNamesMin:["zo","ma","di","wo","do","vr","za"],weekHeader:"Wk",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nl",{buttonText:{year:"Jaar",month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayText:"Hele dag",eventLimitText:"extra",noEventsMessage:"Geen evenementen om te laten zien"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),t="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),n=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],r=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;return e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,n){return e?/-MMM-/.test(n)?t[e.month()]:a[e.month()]:a},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(172);var n=t(1);n.datepickerLocale("nn","nn",{closeText:"Lukk",prevText:"&#xAB;Førre",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["sun","mån","tys","ons","tor","fre","lau"],dayNames:["sundag","måndag","tysdag","onsdag","torsdag","fredag","laurdag"],dayNamesMin:["su","må","ty","on","to","fr","la"],weekHeader:"Veke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("nn",{buttonText:{month:"Månad",week:"Veke",day:"Dag",list:"Agenda"},allDayText:"Heile dagen",eventLimitText:"til",noEventsMessage:"Ingen hendelser å vise"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"sun_mån_tys_ons_tor_fre_lau".split("_"),weekdaysMin:"su_må_ty_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I går klokka] LT",lastWeek:"[Føregåande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",M:"ein månad",MM:"%d månader",y:"eit år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(174);var n=t(1);n.datepickerLocale("pl","pl",{closeText:"Zamknij",prevText:"&#x3C;Poprzedni",nextText:"Następny&#x3E;",currentText:"Dziś",monthNames:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthNamesShort:["Sty","Lu","Mar","Kw","Maj","Cze","Lip","Sie","Wrz","Pa","Lis","Gru"],dayNames:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],dayNamesShort:["Nie","Pn","Wt","Śr","Czw","Pt","So"],dayNamesMin:["N","Pn","Wt","Śr","Cz","Pt","So"],weekHeader:"Tydz",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("pl",{buttonText:{month:"Miesiąc",week:"Tydzień",day:"Dzień",list:"Plan dnia"},allDayText:"Cały dzień",eventLimitText:"więcej",noEventsMessage:"Brak wydarzeń do wyświetlenia"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function t(e,t,n){var r=e+" ";switch(n){case"ss":return r+(a(e)?"sekundy":"sekund");case"m":return t?"minuta":"minutę";case"mm":return r+(a(e)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return r+(a(e)?"godziny":"godzin");case"MM":return r+(a(e)?"miesiące":"miesięcy");case"yy":return r+(a(e)?"lata":"lat")}}var n="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),r="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_");return e.defineLocale("pl",{months:function(e,a){return e?""===a?"("+r[e.month()]+"|"+n[e.month()]+")":/D MMMM/.test(a)?r[e.month()]:n[e.month()]:n},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedzielę o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W środę o] LT";case 6:return"[W sobotę o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:t,m:t,mm:t,h:t,hh:t,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:t,y:"rok",yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(176);var n=t(1);n.datepickerLocale("pt-br","pt-BR",{closeText:"Fechar",prevText:"&#x3C;Anterior",nextText:"Próximo&#x3E;",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("pt-br",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Compromissos"},allDayText:"dia inteiro",eventLimitText:function(e){return"mais +"+e},noEventsMessage:"Não há eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("pt-br",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",
LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº"})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(178);var n=t(1);n.datepickerLocale("pt","pt",{closeText:"Fechar",prevText:"Anterior",nextText:"Seguinte",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sem",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("pt",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Agenda"},allDayText:"Todo o dia",eventLimitText:"mais",noEventsMessage:"Não há eventos para mostrar"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("pt",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(180);var n=t(1);n.datepickerLocale("ro","ro",{closeText:"Închide",prevText:"&#xAB; Luna precedentă",nextText:"Luna următoare &#xBB;",currentText:"Azi",monthNames:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],monthNamesShort:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"],dayNamesShort:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],dayNamesMin:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],weekHeader:"Săpt",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ro",{buttonText:{prev:"precedentă",next:"următoare",month:"Lună",week:"Săptămână",day:"Zi",list:"Agendă"},allDayText:"Toată ziua",eventLimitText:function(e){return"+alte "+e},noEventsMessage:"Nu există evenimente de afișat"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t){var n={ss:"secunde",mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"},r=" ";return(e%100>=20||e>=100&&e%100==0)&&(r=" de "),e+r+n[t]}return e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",ss:a,m:"un minut",mm:a,h:"o oră",hh:a,d:"o zi",dd:a,M:"o lună",MM:a,y:"un an",yy:a},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(182);var n=t(1);n.datepickerLocale("ru","ru",{closeText:"Закрыть",prevText:"&#x3C;Пред",nextText:"След&#x3E;",currentText:"Сегодня",monthNames:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthNamesShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],dayNames:["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"],dayNamesShort:["вск","пнд","втр","срд","чтв","птн","сбт"],dayNamesMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Нед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("ru",{buttonText:{month:"Месяц",week:"Неделя",day:"День",list:"Повестка дня"},allDayText:"Весь день",eventLimitText:function(e){return"+ ещё "+e},noEventsMessage:"Нет событий для отображения"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function t(e,t,n){var r={ss:t?"секунда_секунды_секунд":"секунду_секунды_секунд",mm:t?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",MM:"месяц_месяца_месяцев",yy:"год_года_лет"};return"m"===n?t?"минута":"минуту":e+" "+a(r[n],+e)}var n=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i];return e.defineLocale("ru",{months:{format:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),standalone:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")},monthsShort:{format:"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),standalone:"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")},weekdays:{standalone:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),format:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),isFormat:/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/},weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:n,longMonthsParse:n,shortMonthsParse:n,monthsRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsShortRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., H:mm",LLLL:"dddd, D MMMM YYYY г., H:mm"},calendar:{sameDay:"[Сегодня в] LT",nextDay:"[Завтра в] LT",lastDay:"[Вчера в] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В следующее] dddd [в] LT";case 1:case 2:case 4:return"[В следующий] dddd [в] LT";case 3:case 5:case 6:return"[В следующую] dddd [в] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",ss:t,m:t,mm:t,h:"час",hh:t,d:"день",dd:t,M:"месяц",MM:t,y:"год",yy:t},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,a,t){return e<4?"ночи":e<12?"утра":e<17?"дня":"вечера"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-й";case"D":return e+"-го";case"w":case"W":return e+"-я";default:return e}},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(184);var n=t(1);n.datepickerLocale("sk","sk",{closeText:"Zavrieť",prevText:"&#x3C;Predchádzajúci",nextText:"Nasledujúci&#x3E;",currentText:"Dnes",monthNames:["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],monthNamesShort:["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],dayNames:["nedeľa","pondelok","utorok","streda","štvrtok","piatok","sobota"],dayNamesShort:["Ned","Pon","Uto","Str","Štv","Pia","Sob"],dayNamesMin:["Ne","Po","Ut","St","Št","Pia","So"],weekHeader:"Ty",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sk",{buttonText:{month:"Mesiac",week:"Týždeň",day:"Deň",list:"Rozvrh"},allDayText:"Celý deň",eventLimitText:function(e){return"+ďalšie: "+e},noEventsMessage:"Žiadne akcie na zobrazenie"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e){return e>1&&e<5}function t(e,t,n,r){var s=e+" ";switch(n){case"s":return t||r?"pár sekúnd":"pár sekundami";case"ss":return t||r?s+(a(e)?"sekundy":"sekúnd"):s+"sekundami";case"m":return t?"minúta":r?"minútu":"minútou";case"mm":return t||r?s+(a(e)?"minúty":"minút"):s+"minútami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?s+(a(e)?"hodiny":"hodín"):s+"hodinami";case"d":return t||r?"deň":"dňom";case"dd":return t||r?s+(a(e)?"dni":"dní"):s+"dňami";case"M":return t||r?"mesiac":"mesiacom";case"MM":return t||r?s+(a(e)?"mesiace":"mesiacov"):s+"mesiacmi";case"y":return t||r?"rok":"rokom";case"yy":return t||r?s+(a(e)?"roky":"rokov"):s+"rokmi"}}var n="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),r="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");return e.defineLocale("sk",{months:n,monthsShort:r,weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 4:case 5:return"[minulý] dddd [o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(186);var n=t(1);n.datepickerLocale("sl","sl",{closeText:"Zapri",prevText:"&#x3C;Prejšnji",nextText:"Naslednji&#x3E;",currentText:"Trenutni",monthNames:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],dayNames:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"],dayNamesShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],dayNamesMin:["Ne","Po","To","Sr","Če","Pe","So"],weekHeader:"Teden",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sl",{buttonText:{month:"Mesec",week:"Teden",day:"Dan",list:"Dnevni red"},allDayText:"Ves dan",eventLimitText:"več",noEventsMessage:"Ni dogodkov za prikaz"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a,t,n){var r=e+" ";switch(t){case"s":return a||n?"nekaj sekund":"nekaj sekundami";case"ss":return r+=1===e?a?"sekundo":"sekundi":2===e?a||n?"sekundi":"sekundah":e<5?a||n?"sekunde":"sekundah":"sekund";case"m":return a?"ena minuta":"eno minuto";case"mm":return r+=1===e?a?"minuta":"minuto":2===e?a||n?"minuti":"minutama":e<5?a||n?"minute":"minutami":a||n?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return r+=1===e?a?"ura":"uro":2===e?a||n?"uri":"urama":e<5?a||n?"ure":"urami":a||n?"ur":"urami";case"d":return a||n?"en dan":"enim dnem";case"dd":return r+=1===e?a||n?"dan":"dnem":2===e?a||n?"dni":"dnevoma":a||n?"dni":"dnevi";case"M":return a||n?"en mesec":"enim mesecem";case"MM":return r+=1===e?a||n?"mesec":"mesecem":2===e?a||n?"meseca":"mesecema":e<5?a||n?"mesece":"meseci":a||n?"mesecev":"meseci";case"y":return a||n?"eno leto":"enim letom";case"yy":return r+=1===e?a||n?"leto":"letom":2===e?a||n?"leti":"letoma":e<5?a||n?"leta":"leti":a||n?"let":"leti"}}return e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prejšnjo] [nedeljo] [ob] LT";case 3:return"[prejšnjo] [sredo] [ob] LT";case 6:return"[prejšnjo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"pred %s",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(188);var n=t(1);n.datepickerLocale("sq","sq",{closeText:"mbylle",prevText:"&#x3C;mbrapa",nextText:"Përpara&#x3E;",currentText:"sot",monthNames:["Janar","Shkurt","Mars","Prill","Maj","Qershor","Korrik","Gusht","Shtator","Tetor","Nëntor","Dhjetor"],monthNamesShort:["Jan","Shk","Mar","Pri","Maj","Qer","Kor","Gus","Sht","Tet","Nën","Dhj"],dayNames:["E Diel","E Hënë","E Martë","E Mërkurë","E Enjte","E Premte","E Shtune"],dayNamesShort:["Di","Hë","Ma","Më","En","Pr","Sh"],dayNamesMin:["Di","Hë","Ma","Më","En","Pr","Sh"],weekHeader:"Ja",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sq",{buttonText:{month:"Muaj",week:"Javë",day:"Ditë",list:"Listë"},allDayHtml:"Gjithë<br/>ditën",eventLimitText:function(e){return"+më tepër "+e},noEventsMessage:"Nuk ka evente për të shfaqur"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),weekdays:"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),weekdaysShort:"Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_Më_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,a,t){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot në] LT",nextDay:"[Nesër në] LT",nextWeek:"dddd [në] LT",lastDay:"[Dje në] LT",lastWeek:"dddd [e kaluar në] LT",sameElse:"L"},relativeTime:{future:"në %s",past:"%s më parë",s:"disa sekonda",ss:"%d sekonda",m:"një minutë",mm:"%d minuta",h:"një orë",hh:"%d orë",d:"një ditë",dd:"%d ditë",M:"një muaj",MM:"%d muaj",y:"një vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(190);var n=t(1);n.datepickerLocale("sr-cyrl","sr",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Данас",monthNames:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthNamesShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],dayNames:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],dayNamesShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],dayNamesMin:["Не","По","Ут","Ср","Че","Пе","Су"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sr-cyrl",{buttonText:{prev:"Претходна",next:"следећи",month:"Месец",week:"Недеља",day:"Дан",list:"Планер"},allDayText:"Цео дан",eventLimitText:function(e){return"+ још "+e},noEventsMessage:"Нема догађаја за приказ"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={words:{ss:["секунда","секунде","секунди"],m:["један минут","једне минуте"],mm:["минут","минуте","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],dd:["дан","дана","дана"],MM:["месец","месеца","месеци"],yy:["година","године","година"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,t,n){var r=a.words[n];return 1===n.length?t?r[0]:r[1]:e+" "+a.correctGrammaticalCase(e,r)}};return e.defineLocale("sr-cyrl",{months:"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),monthsShort:"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),monthsParseExact:!0,weekdays:"недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),weekdaysShort:"нед._пон._уто._сре._чет._пет._суб.".split("_"),weekdaysMin:"не_по_ут_ср_че_пе_су".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){return["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",ss:a.translate,m:a.translate,mm:a.translate,h:a.translate,hh:a.translate,d:"дан",dd:a.translate,M:"месец",MM:a.translate,y:"годину",yy:a.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(192);var n=t(1);n.datepickerLocale("sr","sr-SR",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],dayNames:["Nedelja","Ponedeljak","Utorak","Sreda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sre","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Sed",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sr",{buttonText:{prev:"Prethodna",next:"Sledeći",month:"Mеsеc",week:"Nеdеlja",day:"Dan",list:"Planеr"},allDayText:"Cеo dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nеma događaja za prikaz"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,t,n){var r=a.words[n];return 1===n.length?t?r[0]:r[1]:e+" "+a.correctGrammaticalCase(e,r)}};return e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){return["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:a.translate,m:a.translate,mm:a.translate,h:a.translate,hh:a.translate,d:"dan",dd:a.translate,M:"mesec",MM:a.translate,y:"godinu",yy:a.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(194);var n=t(1);n.datepickerLocale("sv","sv",{closeText:"Stäng",prevText:"&#xAB;Förra",nextText:"Nästa&#xBB;",currentText:"Idag",monthNames:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNamesShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"],dayNames:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"],dayNamesMin:["Sö","Må","Ti","On","To","Fr","Lö"],weekHeader:"v. ",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("sv",{buttonText:{month:"Månad",week:"Vecka",day:"Dag",list:"Program"},allDayText:"Heldag",eventLimitText:"till",noEventsMessage:"Inga händelser att visa"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"[På] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"e":1===a?"a":2===a?"a":"e")},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(196);var n=t(1);n.datepickerLocale("th","th",{closeText:"ปิด",prevText:"&#xAB;&#xA0;ย้อน",nextText:"ถัดไป&#xA0;&#xBB;",currentText:"วันนี้",monthNames:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],monthNamesShort:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],dayNames:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์","เสาร์"],dayNamesShort:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],dayNamesMin:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("th",{buttonText:{month:"เดือน",week:"สัปดาห์",day:"วัน",list:"แผนงาน"},allDayText:"ตลอดวัน",eventLimitText:"เพิ่มเติม",noEventsMessage:"ไม่มีกิจกรรมที่จะแสดง"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),monthsParseExact:!0,weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H:mm",LLLL:"วันddddที่ D MMMM YYYY เวลา H:mm"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return"หลังเที่ยง"===e},meridiem:function(e,a,t){return e<12?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",ss:"%d วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(198);var n=t(1);n.datepickerLocale("tr","tr",{closeText:"kapat",prevText:"&#x3C;geri",nextText:"ileri&#x3e",currentText:"bugün",monthNames:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthNamesShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],dayNames:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],dayNamesShort:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],dayNamesMin:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],weekHeader:"Hf",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("tr",{buttonText:{next:"ileri",month:"Ay",week:"Hafta",day:"Gün",list:"Ajanda"},allDayText:"Tüm gün",eventLimitText:"daha fazla",noEventsMessage:"Herhangi bir etkinlik görüntülemek için"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){var a={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"};return e.defineLocale("tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinal:function(e,t){switch(t){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'ıncı";var n=e%10,r=e%100-n,s=e>=100?100:null;return e+(a[n]||a[r]||a[s])}},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(200);var n=t(1);n.datepickerLocale("uk","uk",{closeText:"Закрити",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Сьогодні",monthNames:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],monthNamesShort:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],dayNames:["неділя","понеділок","вівторок","середа","четвер","п’ятниця","субота"],dayNamesShort:["нед","пнд","вів","срд","чтв","птн","сбт"],dayNamesMin:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Тиж",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("uk",{buttonText:{month:"Місяць",week:"Тиждень",day:"День",list:"Порядок денний"},allDayText:"Увесь день",eventLimitText:function(e){return"+ще "+e+"..."},noEventsMessage:"Немає подій для відображення"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){function a(e,a){var t=e.split("_");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function t(e,t,n){var r={ss:t?"секунда_секунди_секунд":"секунду_секунди_секунд",mm:t?"хвилина_хвилини_хвилин":"хвилину_хвилини_хвилин",hh:t?"година_години_годин":"годину_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"};return"m"===n?t?"хвилина":"хвилину":"h"===n?t?"година":"годину":e+" "+a(r[n],+e)}function n(e,a){var t={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")};return e?t[/(\[[ВвУу]\]) ?dddd/.test(a)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(a)?"genitive":"nominative"][e.day()]:t.nominative}function r(e){return function(){return e+"о"+(11===this.hours()?"б":"")+"] LT"}}return e.defineLocale("uk",{months:{format:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),standalone:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")},monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:n,weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., HH:mm",LLLL:"dddd, D MMMM YYYY р., HH:mm"},calendar:{sameDay:r("[Сьогодні "),nextDay:r("[Завтра "),lastDay:r("[Вчора "),nextWeek:r("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return r("[Минулої] dddd [").call(this);case 1:case 2:case 4:return r("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",ss:t,m:t,mm:t,h:"годину",hh:t,d:"день",dd:t,M:"місяць",MM:t,y:"рік",yy:t},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,a,t){return e<4?"ночі":e<12?"ранку":e<17?"дня":"вечора"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-й"
;case"D":return e+"-го";default:return e}},week:{dow:1,doy:7}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(202);var n=t(1);n.datepickerLocale("vi","vi",{closeText:"Đóng",prevText:"&#x3C;Trước",nextText:"Tiếp&#x3E;",currentText:"Hôm nay",monthNames:["Tháng Một","Tháng Hai","Tháng Ba","Tháng Tư","Tháng Năm","Tháng Sáu","Tháng Bảy","Tháng Tám","Tháng Chín","Tháng Mười","Tháng Mười Một","Tháng Mười Hai"],monthNamesShort:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayNames:["Chủ Nhật","Thứ Hai","Thứ Ba","Thứ Tư","Thứ Năm","Thứ Sáu","Thứ Bảy"],dayNamesShort:["CN","T2","T3","T4","T5","T6","T7"],dayNamesMin:["CN","T2","T3","T4","T5","T6","T7"],weekHeader:"Tu",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),n.locale("vi",{buttonText:{month:"Tháng",week:"Tuần",day:"Ngày",list:"Lịch biểu"},allDayText:"Cả ngày",eventLimitText:function(e){return"+ thêm "+e},noEventsMessage:"Không có sự kiện để hiển thị"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),monthsParseExact:!0,weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"sa":"SA":t?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần rồi lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",ss:"%d giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(204);var n=t(1);n.datepickerLocale("zh-cn","zh-CN",{closeText:"关闭",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),n.locale("zh-cn",{buttonText:{month:"月",week:"周",day:"日",list:"日程"},allDayText:"全天",eventLimitText:function(e){return"另外 "+e+" 个"},noEventsMessage:"没有事件显示"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah点mm分",LLLL:"YYYY年M月D日ddddAh点mm分",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),"凌晨"===a||"早上"===a||"上午"===a?e:"下午"===a||"晚上"===a?e+12:e>=11?e:e+12},meridiem:function(e,a,t){var n=100*e+a;return n<600?"凌晨":n<900?"早上":n<1130?"上午":n<1230?"中午":n<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|周)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"周";default:return e}},relativeTime:{future:"%s内",past:"%s前",s:"几秒",ss:"%d 秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},week:{dow:1,doy:4}})})},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0}),t(206);var n=t(1);n.datepickerLocale("zh-tw","zh-TW",{closeText:"關閉",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy/mm/dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),n.locale("zh-tw",{buttonText:{month:"月",week:"週",day:"天",list:"活動列表"},allDayText:"整天",eventLimitText:"顯示更多",noEventsMessage:"没有任何活動"})},function(e,a,t){!function(e,a){a(t(0))}(0,function(e){return e.defineLocale("zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),"凌晨"===a||"早上"===a||"上午"===a?e:"中午"===a?e>=11?e:e+12:"下午"===a||"晚上"===a?e+12:void 0},meridiem:function(e,a,t){var n=100*e+a;return n<600?"凌晨":n<900?"早上":n<1130?"上午":n<1230?"中午":n<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})})},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(e,a,t){t(65),t(67),t(69),t(71),t(73),t(75),t(77),t(79),t(81),t(83),t(85),t(87),t(89),t(91),t(93),t(95),t(97),t(99),t(101),t(103),t(105),t(107),t(109),t(111),t(113),t(115),t(117),t(119),t(121),t(123),t(125),t(127),t(129),t(131),t(133),t(135),t(137),t(139),t(141),t(143),t(145),t(147),t(149),t(151),t(153),t(155),t(157),t(159),t(161),t(163),t(165),t(167),t(169),t(171),t(173),t(175),t(177),t(179),t(181),t(183),t(185),t(187),t(189),t(191),t(193),t(195),t(197),t(199),t(201),t(203),t(205),e.exports=t(435)},function(e,a,t){Object.defineProperty(a,"__esModule",{value:!0});var n=t(0),r=t(1);n.locale("en"),r.locale("en"),window.jQuery.datepicker&&window.jQuery.datepicker.setDefaults(window.jQuery.datepicker.regional[""])}])});
(function() {
    'use strict';

    /**
     * Audio Recorder Directive
     * 
     * Usage:
     * Add 'audio-recorder' attribute to any form-group with a textarea
     * Add 'audio-model' with the path to the model in the scope
     * Example:
     * <div class="form-group" audio-recorder audio-model="ctrl.form.text">
     *   <label>Notes</label>
     *   <textarea ng-model="ctrl.form.text" class="form-control"></textarea>
     * </div>
     */
    angular.module('app').directive('audioRecorder', audioRecorder);

    audioRecorder.$inject = ['AudioRecorderService', '$api', '$compile', '$parse'];
    function audioRecorder(AudioRecorderService, $api, $compile, $parse) {
        var instanceCounter = 0;
        
        return {
            restrict: 'A',
            scope: false,
            link: function(scope, element, attrs) {
                
                // Generate unique instance ID (using underscores to avoid Angular expression issues)
                var instanceId = 'audioRecorder_' + (++instanceCounter) + '_' + Date.now();
                
                // Add the 'with-audio' class to the parent element
                element.addClass('with-audio');

                // Get the model from attribute
                var audioModelPath = attrs.audioModel;

                // Simple state variable on scope - scoped to this instance
                var stateVarName = 'audioRecState_' + instanceId;
                
                // Initialize state to idle
                scope[stateVarName] = 'idle';
                
                // Ensure service is in idle state if no active instance
                if (!AudioRecorderService.activeInstanceId && AudioRecorderService.state !== 'idle') {
                    AudioRecorderService.state = 'idle';
                }

                // Watch service state and update scope when it changes - only for this instance
                scope.$watch(function() {
                    return {
                        state: AudioRecorderService.state,
                        activeInstanceId: AudioRecorderService.activeInstanceId
                    };
                }, function(newVal) {
                    // Ensure we have valid values
                    var currentState = newVal.state || 'idle';
                    var currentActiveId = newVal.activeInstanceId;
                    
                    // Only update state if this instance is active or if service is idle
                    if (currentActiveId === instanceId || currentState === 'idle') {
                        scope[stateVarName] = currentState;
                        
                        // Add/remove ai-processing class to form-group for border animation
                        if (currentState === 'processing' && currentActiveId === instanceId) {
                            element.addClass('ai-processing');
                        } else {
                            element.removeClass('ai-processing');
                        }
                    } else {
                        // Reset to idle if another instance is active
                        scope[stateVarName] = 'idle';
                        element.removeClass('ai-processing');
                    }
                }, true);

                // Create the audio container HTML - ONE icon and ONE label that change based on state
                var audioContainerHTML = 
                    '<div class="audio-container">' +
                        '<div class="audio-icon" ' +
                             'ng-click="recordAudioFn_' + instanceId + '()" ' +
                             'ng-class="{\'recording\': ' + stateVarName + ' === \'recording\', \'processing\': ' + stateVarName + ' === \'processing\'}" ' +
                             'ng-disabled="' + stateVarName + ' === \'processing\'">' +
                            '<i ng-class="{' +
                                '\'las la-stop\': ' + stateVarName + ' === \'recording\',' +
                                '\'las la-spinner la-spin\': ' + stateVarName + ' === \'processing\'' +
                            '}"></i>' +
                        '</div>' +
                        '<span class="audio-state-label" ' +
                              'ng-class="{\'recording-label\': ' + stateVarName + ' === \'recording\', \'processing-label\': ' + stateVarName + ' === \'processing\'}" ' +
                              'ng-show="' + stateVarName + ' !== \'idle\'">' +
                            '{{' + stateVarName + ' === \'recording\' ? ("RECORDING" | translate) : ("PROCESSING" | translate)}}' +
                        '</span>' +
                    '</div>';

                // Compile and append the audio container
                var compiled = $compile(audioContainerHTML)(scope);
                element.append(compiled);

                // Recording function - instance specific
                scope['recordAudioFn_' + instanceId] = function() {
                    var baseURL = attrs.apiBaseUrl || $api.baseURL;
                    
                    AudioRecorderService.toggleRecording({
                        apiBaseURL: baseURL,
                        instanceId: instanceId,
                        onSuccess: function(transcribedText) {
                            // Append or replace text using $parse to access the model
                            var model = $parse(audioModelPath);
                            var currentValue = model(scope);
                            
                            if (currentValue) {
                                model.assign(scope, currentValue + ' ' + transcribedText);
                            } else {
                                model.assign(scope, transcribedText);
                            }
                        }
                    });
                };

                // Cleanup on destroy - only stop if this instance is active
                scope.$on('$destroy', function() {
                    if (AudioRecorderService.state === 'recording' && AudioRecorderService.activeInstanceId === instanceId) {
                        AudioRecorderService.stopRecording();
                    }
                    // Clean up the instance-specific scope variables
                    delete scope[stateVarName];
                    delete scope['recordAudioFn_' + instanceId];
                });
            }
        };
    }

})();


/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
        angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeight = angular.element('nav.navbar-default').height();
        var wrapperHeight = angular.element('#page-wrapper').height();

        if (navbarHeight > wrapperHeight) {
            angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
        }

        if (navbarHeight < wrapperHeight) {
            angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
        }

        if (angular.element('body').hasClass('fixed-nav')) {
            if (navbarHeight > wrapperHeight) {
                angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
            } else {
                angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
            }
        }

    }

    angular.element(window).bind("load resize scroll", function () {
        if (!angular.element("body").hasClass('body-small')) {
            //fix_height();
        }
    });

    // Move right sidebar top after scroll
    angular.element(window).scroll(function () {
        if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
            angular.element('#right-sidebar').addClass('sidebar-top');
        } else {
            angular.element('#right-sidebar').removeClass('sidebar-top');
        }
    });

    $timeout(function () {
        //fix_height();
    });

    // Minimalize menu when screen is less than 768px
    angular.element(window).bind("load resize", function () {
        if (angular.element(document).width() < 769) {
          angular.element('body').addClass('body-small')
          angular.element('body').addClass('mini-navbar')
        } else {
         angular.element('body').removeClass('body-small')
        }
    })



});

(function() {
    'use strict';
    angular.module('inspinia', [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'ui.bootstrap',
        'ui.bootstrap.modal',
        'ui.calendar',
        'ui.sortable',
        'ui.select',
        'cgNotify',
        'NgSwitchery',
        'datePicker',
        'datatables',
        'datatables.buttons',
        'localytics.directives',
        'ovh-angular-input-number-spinner',
        'chart.js',
        'app'
    ]);
})();
(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log){
    $log.debug('runBlock end');
  }

})();
(function () {

    angular.module("app.filters", [])

        /**
         * Returns a parsed float number
         */
        .filter("hebrewHolidayName", function() {

            var holidayNames = {
                "Erev Purim" : "ערב פורים",
                "Purim (Tel Aviv)" : "פורים",
                "Shushan Purim (Jerusalem)" : "שושן פורים",
                "Erev Pesach" : "ערב פסח",
                "Pesach I" : "פסח",
                "Pesach II" : "פסח",
                "Pesach III" : "פסח",
                "Pesach IV" : "פסח",
                "Pesach V" : "פסח",
                "Pesach VI" : "פסח",
                "Pesach VII" : "פסח",
                "Yom Ha'atzmaut" : "יום העצמאות",
                "Yom Ha'shoah" : "יום השואה",
                "Yom Ha'zikaron" : "יום הזכרון",
                "Yom Yerushalayim" : "יום ירושלים",
                "Erev Shavuot" : "ערב שבועות",
                "Shavuot" : "שבועות",
                "Erev Tisha B'Av" : "ערב תשעה באב",
                "Tisha B'Av" : "תשעה באב",
                "Erev Rosh Hashanah" : "ערב ראש השנה",
                "Rosh Hashanah" : "ראש השנה",
                "Rosh Hashanah II" : "ראש השנה",
                "Yom Kippur" : "יום כיפור",
                "Erev Sukkot" : "ערב סוכות",
                "Sukkot I" : "סוכות",
                "Sukkot II" : "סוכות",
                "Sukkot III" : "סוכות",
                "Sukkot IV" : "סוכות",
                "Sukkot V" : "סוכות",
                "Sukkot VI" : "סוכות",
                "Sukkot VII" : "סוכות",
                "Simchat Torah" : "שמחת תורה",
                "Hanukkah I" : "חנוכה",
                "Hanukkah II" : "חנוכה",
                "Hanukkah III" : "חנוכה",
                "Hanukkah IV" : "חנוכה",
                "Hanukkah V" : "חנוכה",
                "Hanukkah VI" : "חנוכה",
                "Hanukkah VII" : "חנוכה",
                "Hanukkah VIII" : "חנוכה"
            };

            return function(input) {

                if(holidayNames[input])
                    return holidayNames[input];

                return input;
            }
        })

        /**
         * Returns a parsed float number
         */
        .filter("parseFloat", function(dates) {
            return function(input) {
                return parseFloat(parseFloat(input).toFixed(2));
            }
        })

        /**
         * Returns a label of duration in minutes and hours
         */
        .filter("duration", function(dates) {
            return function(input) {

                for(var i in dates.duration)
                    if(dates.duration[i].duration == input)
                        return dates.duration[i].label;

                return input;
            }
        })

        /**
         * Retreive a formated decimal number for displaying price
         */
        .filter("price", function() {
            return function(input, ltr, numeric) {
                input = parseFloat(input).toFixed(2);

                if(numeric === true)
                    return input;

                // var decimalPoint = String(input).split(".")[1];

                if(ltr) {
                    // return Number(parseInt(input)).toLocaleString('en-US') + "." + decimalPoint + "₪";
                    return Number(parseInt(input)).toLocaleString('en-US') + "₪";
                }

                return "₪" + Number(parseInt(input)).toLocaleString('en-US');
            }
        })

        .filter("priceFloat", function() {
            return function(input, ltr, numeric) {
                var parsedInput = parseFloat(input).toFixed(2);

                if(isNaN(parsedInput))
                    parsedInput = 0;

                if(numeric === true)
                    return parsedInput;

                if(ltr) {
                    return Number(parsedInput).toLocaleString('en-US') + "₪";
                }

                return "₪" + Number(parsedInput).toLocaleString('en-US');
            }
        })

        .filter('thousands', function () {
            return function (input) {
                if (input == null) return '';
                // turn into string
                var str = input.toString();
                // split off any decimal part
                var parts = str.split('.');
                // insert commas in the integer part
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                // reassemble (will drop the dot if no fractional part)
                return parts.join('.');
            };
        })

        /**
         * Retrieve the default avatar in case the given url is empty
         */
        .filter("hourAndMinute", function () {

            return function (input) {

                input = input.split(":");

                return input[0] + ":" + input[1];
            };

        })

        /**
         * Return time with leading zeros
         */
        .filter("hourAndMinuteWithZeros", function () {
          return function (input) {
            input = input.split(":");
            input.forEach(function (val, index) {
              if (val.length < 2) {
                input[index] = '0' + val;
              }
            })
            return input[0] + ":" + input[1];
          };
        })

        /**
         * Retrieve the default avatar in case the given url is empty
         */
        .filter("defaultProfilePicture", function () {

            var defaultPictureURL = "assets/images/avatar.jpg";

            return function (input) {
                if (input == null)
                    return defaultPictureURL;

                return input;
            };

        })

        /**
         * Turns empty values into (---) for more aesthetic look
         */
        .filter("emptyValue", function () {

            return function(input) {

                if(input == "" || input == null)
                    return "---";

                return input;
            };
        })

        /**
         * Converts numeric represenation of gender to its text definiton
         */
        .filter("gender", function() {

            var genders = {
                "-1": "לא מוגדר",
                "0" : "זכר",
                "1" : "נקבה"
            };

            return function(input) {

                if(typeof genders[input] !== typeof undefined)
                    return genders[input];

                return input;
            };
        })

        /**
         * Converts numeric represenation of notifications type to its text definiton
         */
        .filter("notificationTypes", function() {

            var types = {
                "0": "SETTINGS_USER_REMINDER_NO",
                "1": "CUSTOMER_SETTING_EMAIL",
                "2": "CUSTOMERS_SMS",
                "3": "CUSTOMERS_WHATSAPP"
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })

        /**
         * Converts numeric represenation of send notifications type to its text definiton
         */
        .filter("notificationSendTypes", function() {

            var types = {
                "0": "OPTION_NO",
                "1": "OPTION_YES"
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })

        /**
         * Converts numeric represenation of send notifications type to its text definiton
         */
        .filter("sendReminderTypes", function() {

            var types = {
                "0": "SETTINGS_USER_REMINDER_NO",
                "2": "SETTINGS_USER_REMINDER_2_HOURS",
                "4": "SETTINGS_USER_REMINDER_4_HOURS",
                "24": "SETTINGS_USER_REMINDER_24_HOURS",
                "48": "SETTINGS_USER_REMINDER_48_HOURS",
                "72": "SETTINGS_USER_REMINDER_72_HOURS",
                "168": "SETTINGS_USER_REMINDER_168_HOURS"
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })

        /**
         * Converts numeric representation of send documents type to its text definition
         */
        .filter("sendDocumentsTypes", function() {

            var types = {
                "0": "SETTINGS_USER_REMINDER_NO",
                "1": "CUSTOMER_SETTING_EMAIL",
                "2": "CUSTOMERS_SMS",
                "3": "CUSTOMERS_WHATSAPP",
                "4": "CUSTOMERS_PRINT",
            };

            return function(input) {

                if(typeof types[input] !== typeof undefined)
                    return types[input];

                return input;
            };
        })


        /**
         * Converts to Unix timestamp
         */
        .filter("toUnixTimestamp", function () {
            
            return function (timeString) {
                if (!timeString) {
                    return timeString;
                }
        
                // Define an array of possible date formats
                var dateFormats = [
                    'DD/MM/YYYY', // day/month/year
                    'MM/DD/YYYY', // month/day/year
                    'D/M/YYYY',   // day/month/year
                    'YYYY-MM-DD', // Year-month-day
                    'DD-MM-YYYY', // day-month-year
                    'DD/MM/YYYY', // day/month/year
                    'MM/DD/YYYY', // month/day/year
                    'D/M/YYYY',   // day/month/year
                    'YYYY/MM/DD', // Year/month/day
                    'HH:mm DD/MM/YYYY', // 24-hour time with day/month/year
                    'HH:mm MM/DD/YYYY', // 24-hour time with month/day/year
                    'HH:mm D/M/YYYY',   // 24-hour time with single-digit day/month/year
                    'YYYY-MM-DD HH:mm', // Year-month-day with 24-hour time
                    'YYYY-MM-DDTHH:mm', // Year-month-day with T separator
                    'YYYY/MM/DD HH:mm', // Year/month/day with 24-hour time
                    'YYYY/MM/DDTHH:mm', // Year/month/day with T separator
                    'HH:mm:ss DD/MM/YYYY', // 24-hour time with day/month/year
                    'HH:mm:ss MM/DD/YYYY', // 24-hour time with month/day/year
                    'HH:mm:ss D/M/YYYY',   // 24-hour time with single-digit day/month/year
                    'YYYY-MM-DD HH:mm:ss', // Year-month-day with 24-hour time
                    'YYYY-MM-DDTHH:mm:ss', // Year-month-day with T separator
                    'YYYY/MM/DD HH:mm:ss', // Year/month/day with 24-hour time
                    'YYYY/MM/DDTHH:mm:ss', // Year/month/day with T separator
                ];
        
                var inputTime = moment(timeString, dateFormats, 'he', true);
        
                if (!inputTime.isValid()) {
                    console.error('Invalid date format:', timeString);
                    return timeString; // Return the original string if parsing fails
                }
        
                return inputTime.format('x');
            };

            //old version
            return function (timeString) {
                if(!timeString) { return timeString; }

                if(timeString.indexOf('/') > -1) {
                    //timeString = timeString.split('/').join('-');
                    var dateParts = timeString.split('/');
                    // If the year is in the end the date parts should be reversed before joining
                    // to be parsed like a date.
                    if (dateParts[dateParts.length -1].length == 4) {
                        dateParts = dateParts.reverse()
                    }
                    timeString = dateParts.join('-');
                }
                moment.locale("he");
                var inputTime = moment(timeString);
                return inputTime.format('x');
            };
        })

        .filter('notEmptyCountFilter', function() {
            return function(filter, excludeKeys) {
              var count = 0;
              var excludeArray = [];
              
              // Handle excludeKeys parameter - can be a string, comma-separated string, array, or undefined
              if (excludeKeys) {
                if (typeof excludeKeys === 'string') {
                  // Support comma-separated strings like "period,otherKey"
                  if (excludeKeys.indexOf(',') !== -1) {
                    excludeArray = excludeKeys.split(',').map(function(key) {
                      return key.trim();
                    });
                  } else {
                    excludeArray = [excludeKeys];
                  }
                } else if (Array.isArray(excludeKeys)) {
                  excludeArray = excludeKeys;
                }
              }
              
              for (var key in filter) {
                // Skip excluded keys
                if (excludeArray.indexOf(key) !== -1) {
                  continue;
                }
                
                if (
                  filter[key] !== null &&
                  filter[key] !== false &&
                  filter[key] !== '' &&
                  !(Array.isArray(filter[key]) && filter[key].length === 0)
                ) {
                  count++;
                }
              }
              return count;
            };
        })


        /**
         * Convert boolean values to yes or no strings
         */
        .filter("booleanText", function() {

            return function(input, yes, no) {

                if(!yes)
                    yes = "כן";

                if(!no)
                    no = "לא";

                if(Boolean(input))
                    return yes;

                return no;
            }
        })

        .filter("nl2br", function($sce) {
            return function(input) {
                if (input) {
                    // Strip all HTML tags
                    var textOnly = input.replace(/<\/?[^>]+(>|$)/g, "");
                    // Replace newlines with <br />
                    var result = textOnly.replace(/\n/g, "<br />");
                    return $sce.trustAsHtml(result);
                }
                return input;
            };
        })

        /**
         * Convert URLs in text to clickable links
         * Returns plain HTML string for use in swal() or other HTML contexts
         * For template use with ng-bind-html, use the linkifyHtml filter
         */
        .filter("linkify", function() {
            return function(input) {
                if (!input) return input;
                var urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
                return input.replace(urlRegex, function(url) {
                    var href = url;
                    if (!url.match(/^https?:\/\//i)) {
                        href = 'http://' + url;
                    }
                    return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
                });
            };
        })

        /**
         * Convert URLs in text to clickable links for use in templates with ng-bind-html
         */
        .filter("linkifyHtml", function($sce) {
            return function(input) {
                if (!input) return input;
                var urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
                var result = input.replace(urlRegex, function(url) {
                    var href = url;
                    if (!url.match(/^https?:\/\//i)) {
                        href = 'http://' + url;
                    }
                    return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
                });
                return $sce.trustAsHtml(result);
            };
        })

        /**
         * Convert Gregorian date to Hebrew date format
         */
        .filter("hebrewDate", function(HebrewDate) {
            return function(input) {
                if (!input) return input;
                
                var date;
                if (input instanceof Date) {
                    date = input;
                } else if (typeof input === 'string') {
                    date = new Date(input);
                } else {
                    return input;
                }
                
                if (isNaN(date.getTime())) {
                    return input;
                }
                
                return HebrewDate.getHebrewDateString(date);
            };
        });

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')

  .directive("formControl", function () {

    var inputCount = 0;

    return {
      restrict: "C",

      link: function (scope, element, attrs) {

        if ((element.is('input') || element.is("textarea")) && element.closest(".form-group").find(">label").length) {

          inputCount++;

          if (!element.attr("id")) {
            element.attr("id", "input-id-" + inputCount);
            element.closest(".form-group").find("> label").attr("for", "input-id-" + inputCount);
          }

          //element.attr("placeholder", "");

          element.closest(".form-group").addClass("form-input");

          element.on("focus", function () {
            element.closest(".form-group").find(">label").addClass("is-focused");
          });

          element.on("blur", function () {
            element.closest(".form-group").find(">label").removeClass("is-focused");
          });

          var inputUpdate = function () {
            if ($.trim(element.val()).length)
              element.closest(".form-group").find(">label").addClass("has-value");
            else
              element.closest(".form-group").find(">label").removeClass("has-value");
          };

          element.on("input", inputUpdate);
          element.on("load", inputUpdate);
          scope.$watch(attrs.ngModel, inputUpdate);
        }
      }
    };
  })
  // .directive('sideNavigation', function ($timeout) {
  //     return {
  //         restrict: 'A',
  //         link: function (scope, element) {
  //             // Call metsi to build when user signup
  //             scope.$watch('authentication.user', function () {
  //                 $timeout(function () {
  //                     element.metisMenu();
  //                 });
  //             });

  //             // Colapse menu in mobile mode after click on element
  //             setTimeout(
  //                 function(){
  //                     var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
  //                     menuElement.click(function () {
  //                         if (angular.element(window).width() < 769) {
  //                             angular.element("body").toggleClass("mini-navbar");

  //                         }
  //                     });
  //                 },
  //                 1000
  //             );

  //             // Enable initial fixed sidebar
  //             if (angular.element("body").hasClass('fixed-sidebar')) {
  //                 var sidebar = element.parent();
  //                 sidebar.slimScroll({
  //                     height: '100%',
  //                     railOpacity: 0.9
  //                 });
  //             }
  //         }
  //     };
  // })
  // .directive('minimalizaSidebar', function ($timeout) {
  //     return {
  //         restrict: 'A',
  //         template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary2 " href="" ng-click="minimalize()"><img src="assets/images/backburger.svg" ></i></a>',
  //        // template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
  //         controller: function ($scope) {

  //             if (angular.element('body').hasClass('body-small')) {
  //                 // angular.element('body').toggleClass('mini-navbar'); navbar popup fix
  //             }

  //             $scope.minimalize = function () {
  //                 angular.element('body').toggleClass('mini-navbar');
  //                 if (!angular.element('body').hasClass('mini-navbar')) {
  //                     // Hide menu in order to smoothly turn on when maximize menu
  //                     angular.element('#side-menu').hide();
  //                     // For smoothly turn on menu
  //                     $timeout(function () {
  //                         angular.element('#side-menu').fadeIn(400);
  //                     }, 200);
  //                 } else {
  //                     // Remove all inline style from jquery fadeIn function to reset menu state
  //                     // angular.element('body').toggleClass('mini-navbar');
  //                     if (angular.element('body').hasClass('body-small')) {
  //                         angular.element('body').toggleClass('mini-navbar');
  //                         angular.element('.menuBackDrop').remove();
  //                     } else {
  //                         angular.element('#side-menu').removeAttr('style');
  //                     }
  //                 }
  //             };
  //         }
  //     };
  // })
  .directive("fileread", [function () {
    return {
      scope: {
        fileread: "="
      },
      link: function (scope, element, attributes) {
        element.bind("change", function (changeEvent) {
          var reader = new FileReader();
          reader.onload = function (loadEvent) {
            scope.$apply(function () {
              scope.fileread = loadEvent.target.result;
            });
          };
          reader.readAsDataURL(changeEvent.target.files[0]);
        });
      }
    }
  }])
angular.module('app').directive('autoExpand', function ($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var minHeight = element[0].offsetHeight;

      // Create a mirror textarea to measure the content
      var $shadow = angular.element('<div></div>').css({
        position: 'absolute',
        top: -10000,
        left: -10000,
        fontSize: element.css('fontSize'),
        fontFamily: element.css('fontFamily'),
        lineHeight: element.css('lineHeight'),
        resize: 'none',
        'word-wrap': 'break-word'
      });
      angular.element(document.body).append($shadow);

      var update = function () {
        if (element[0].offsetWidth === 0) return;

        // Read padding values dynamically each time to account for CSS changes
        var paddingLeft = parseInt(element.css('paddingLeft') || 0);
        var paddingRight = parseInt(element.css('paddingRight') || 0);

        var times = function (string, number) {
          return Array(number + 1).join(string);
        };

        var val = element.val().replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/&/g, '&amp;')
          .replace(/\n$/, '<br/>&nbsp;')
          .replace(/\n/g, '<br/>')
          .replace(/ {2,}/g, function (space) {
            return times('&nbsp;', space.length - 1) + ' ';
          });

        $shadow.css('width', element[0].offsetWidth - paddingLeft - paddingRight + 'px');
        $shadow.html(val);

        var newHeight = Math.max($shadow[0].offsetHeight + 20 /* the "threshold" */, minHeight);
        element.css('height', newHeight + 'px');
      };

      element.bind('input', update);

      // Trigger update on initialization
      scope.$watch(function () {
        return element.val();
      }, function () {
        $timeout(update, 350); // Wait for Bootstrap collapse animation (default: 350ms)
      });

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.target.offsetHeight > 0) {
            $timeout(update, 10); // Recalculate after becoming visible
          }
        });
      });

      var parent = element.closest('div');
      if (parent.length) {
        observer.observe(parent[0], { attributes: true, childList: true, subtree: true });
      }

      // Initialize the directive
      $timeout(update, 350);
    }
  };
})
  .directive('toggleSelect', function () {
    return {
      require: 'uiSelect',
      link: function (scope, element, attrs, $select) {
        var toggleSelectedItem = function (item) {
          var selectedItems = $select.selected;
          var idx = selectedItems.indexOf(item);
          //selectedItems like
          //0: {name: 'Women service', id: 7, $$hashKey: 'object:485'}
          //1: {name: 'גברים', id: 63, $$hashKey: 'object:486'}
          if (idx > -1) {
            // Item is already selected, remove it
            $select.selected.splice(idx, 1);
            $select.close();
            // To reflect changes in the view
            scope.$apply();
          }
        };

        element.on('click', '.ui-select-choices-row', function (e) {

          var itemScope = angular.element(e.target).scope();
          if (itemScope && itemScope.$id) {
            toggleSelectedItem(itemScope.$id);
          }
        });
      }
    };
  })
  .directive('toggleSelection', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var getModel = $parse(attrs.ngModel);
        var valueAttr = attrs.toggleSelection;

        // Listen for select event
        var clickedItem = false;
        scope.$on('uis:select', function (event, item) {
          clickedItem = item;
        });

        element.on('click', function (event) {
          event.stopPropagation(); // Still useful to prevent double handling
          var modelArray = getModel(scope) || [];
          var el = angular.element(event.target).scope();
          var item = el.$parent[valueAttr];

          if (clickedItem) {
            clickedItem = false;
            return;
          }
          if (!item) return;

          var idx = modelArray.indexOf(item);
          if (idx > -1) {
            modelArray.splice(idx, 1); // Remove item
          }

          getModel.assign(scope, modelArray);
          scope.$apply();
        });
      }
    };
  }])
  .directive('clickOutside', function ($document) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        var onClick = function (event) {
          var isOutside = (element[0] !== event.target) && !element[0].contains(event.target);
          if (isOutside) {
            scope.$apply(attr.clickOutside);
          }
        };

        $document.on('click', onClick);

        scope.$on('$destroy', function () {
          $document.off('click', onClick);
        });
      }
    };
  }).directive('chartJs', ['$rootScope', '$window', function ($rootScope, $window) {
    return {
      restrict: 'A',
      scope: {
        chartData: '=',
        chartOptions: '=',
        chartType: '=',
        chartInstance: '=?'
      },
      link: function (scope, element) {
        var ctx = element[0].getContext('2d');
        var chart;

        if (!Chart._gradientPluginRegistered) {
          Chart._gradientPluginRegistered = true;

          Chart.register({
            id: 'gradientPlugin',
            beforeRender: function (chart) {
              var datasets = chart.config.data.datasets;
              var ctx = chart.ctx;
              var chartArea = chart.chartArea;

              // Use a traditional for loop for better compatibility
              for (var i = 0; i < datasets.length; i++) {
                var dataset = datasets[i];
                var originalColor = dataset.backgroundColor;

                // Check if originalColor is a string
                if (typeof originalColor !== 'string') {
                  continue; // Skip if not a string
                }

                // Use the lightenColor method from $rootScope
                var lighterColor = $rootScope.lightenColor(originalColor, 10);

                // Create gradient
                var gradient = chart.config.options.indexAxis == 'y' ? ctx.createLinearGradient(0, chartArea.left, 0, chartArea.right) : ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                gradient.addColorStop(0, originalColor);
                gradient.addColorStop(1, lighterColor);

                dataset.backgroundColor = gradient;
              }
            }
          });
        }

        function createChart() {
          if (chart) {
            return;
          }

          var data = scope.chartData;
          if (!data) {
            return;
          }

          chart = new Chart(ctx, {
            type: scope.chartType || 'line',
            data: data,
            options: scope.chartOptions || {}
          });

          scope.chartInstance = chart;
        }

        function updateChart(mode) {
          if (!scope.chartData) {
            return;
          }

          if (!chart) {
            createChart();
            return;
          }

          var newType = scope.chartType || 'line';
          if (chart.config.type !== newType) {
            chart.destroy();
            chart = null;
            createChart();
            return;
          }

          chart.data = scope.chartData;
          chart.options = scope.chartOptions || {};

          chart.update(mode);
        }

        scope.$watch('chartData', function () {
          updateChart();
        }, false);

        scope.$watch('chartOptions', function () {
          updateChart();
        }, false);

        scope.$watch('chartType', function () {
          updateChart();
        }, false);

        var resizeHandler = function () {
          if (chart) {
            chart.resize();
            chart.update('none');
          } else {
            createChart();
          }
        };

        angular.element($window).on('resize', resizeHandler);

        scope.$on('$destroy', function () {
          angular.element($window).off('resize', resizeHandler);
          if (chart) {
            chart.destroy();
            chart = null;
            scope.chartInstance = null;
          }
        });

        scope.getChartInstance = function () {
          return chart;
        };
      }
    };
  }])
  .directive('tooltip2', [
    '$window', '$document', '$compile', '$timeout',
    function ($window, $document, $compile, $timeout) {
      return {
        restrict: 'A',
        scope: {
          tooltip2: '@',
          tooltip2Placement: '@', // expected values: top, bottom, left, right
          tooltip2Container: '@', // selector for container element
          tooltip2Size: '@'       // expected values: small, medium, large, content-fit, target-fit; you can pass "desktop,mobile"
        },
        link: function (scope, element, attrs) {
          var tooltipElement, container;
          var placement = scope.tooltip2Placement || 'top';

          container = $document.find('body');
          if (scope.tooltip2Container) {
            var found = $document[0].querySelector(scope.tooltip2Container);
            if (found) {
              container = angular.element(found);
            }
          }

          var sizeClassDesktop = '';
          var sizeClassMobile = '';
          if (scope.tooltip2Size) {
            var sizes = scope.tooltip2Size.split(',');
            sizeClassDesktop = sizes[0].trim();
            sizeClassMobile = sizes.length > 1 ? sizes[1].trim() : sizeClassDesktop;
          }

          var isMobile = 'ontouchstart' in $window;
          var appliedSizeClass = isMobile ? sizeClassMobile : sizeClassDesktop;

          var isHoveringTarget = false;
          var isHoveringTooltip = false;
          function hasTooltipText() {
            return !!(scope.tooltip2 && String(scope.tooltip2).trim());
          }

          function createTooltip() {
            if (!hasTooltipText()) return;
            tooltipElement = angular.element('<div class="tooltip2"></div>');
            tooltipElement.append(scope.tooltip2.replace(/\n/gi, '<br />'));
            if (appliedSizeClass && appliedSizeClass !== 'target-fit') {
              tooltipElement.addClass(appliedSizeClass);
            }
            container.append(tooltipElement);
            $compile(tooltipElement)(scope);
          }

          function positionTooltip() {
            if (!tooltipElement) return;

            var targetRect = element[0].getBoundingClientRect();
            tooltipElement.css('display', 'block');

            if (appliedSizeClass === 'target-fit') {
              tooltipElement.css('width', targetRect.width + 'px');
            } else {
              tooltipElement.css('width', '');
            }

            var tooltipRect = tooltipElement[0].getBoundingClientRect();

            var top, left;

            switch (placement) {
              case 'bottom':
                top = targetRect.bottom;
                left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
                break;
              case 'left':
                top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
                left = targetRect.left - tooltipRect.width;
                break;
              case 'right':
                top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
                left = targetRect.right;
                break;
              case 'top':
              default:
                top = targetRect.top - tooltipRect.height;
                left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
            }

            top += $window.pageYOffset;
            left += $window.pageXOffset;

            var windowWidth = $window.innerWidth,
                windowHeight = $window.innerHeight;

            if (top < $window.pageYOffset) {
              top = targetRect.bottom + $window.pageYOffset;
            }
            if (top + tooltipRect.height > $window.pageYOffset + windowHeight) {
              top = targetRect.top - tooltipRect.height + $window.pageYOffset;
            }
            if (left < $window.pageXOffset) {
              left = targetRect.left + $window.pageXOffset;
            }
            if (left + tooltipRect.width > $window.pageXOffset + windowWidth) {
              left = targetRect.right - tooltipRect.width + $window.pageXOffset;
            }

            tooltipElement.css({ top: top + 'px', left: left + 'px' });
          }

          function showTooltip() {
            if (!hasTooltipText()) return;
            if (!tooltipElement) {
              createTooltip();
            }
            if (!tooltipElement) return;

            tooltipElement.css('display', 'block');
            $timeout(positionTooltip);

            // Tooltip hover tracking
            tooltipElement.on('mouseenter', function () {
              isHoveringTooltip = true;
            });
            tooltipElement.on('mouseleave', function () {
              isHoveringTooltip = false;
              checkHideTooltip();
            });

            angular.element($window).on('scroll.tooltip resize.tooltip', function () {
              var targetRect = element[0].getBoundingClientRect();
              if (targetRect.bottom < 0 || targetRect.top > $window.innerHeight) {
                hideTooltip();
              } else {
                positionTooltip();
              }
            });
          }

          function hideTooltip() {
            if (tooltipElement) {
              tooltipElement.css('display', 'none');
              tooltipElement.off('mouseenter');
              tooltipElement.off('mouseleave');
            }
            angular.element($window).off('scroll.tooltip resize.tooltip');
          }

          function checkHideTooltip() {
            $timeout(function () {
              if (!isHoveringTarget && !isHoveringTooltip) {
                hideTooltip();
              }
            }, 100);
          }

          // Hover tracking for target element
          element.on('mouseenter', function () {
            isHoveringTarget = true;
            showTooltip();
          });
          element.on('mouseleave', function () {
            isHoveringTarget = false;
            checkHideTooltip();
          });

          // Mobile support
          if (isMobile) {
            element.on('click', function (event) {
              event.stopPropagation();
              event.preventDefault();
              if (tooltipElement && tooltipElement.css('display') === 'block') {
                hideTooltip();
              } else {
                showTooltip();
              }
            });

            $document.on('click', function () {
              hideTooltip();
            });
          }

          scope.$on('$destroy', function () {
            if (tooltipElement) {
              tooltipElement.remove();
            }
            element.off('mouseenter mouseleave click');
            angular.element($window).off('scroll.tooltip resize.tooltip');
            $document.off('click');
          });
        }
      };
    }
  ]).directive('fixDatepickerPosition', function($timeout, $window, $document) {
    return {
        link: function(scope, element) {
            var wrapper = null;
            var repositionHandler = null;

            function findWrapper() {
                wrapper = $document[0].querySelector('[date-picker-wrapper]');
                if (wrapper) {
                    // Move wrapper to BODY → KEY step!
                    $document[0].body.appendChild(wrapper);
                }
            }

            function adjustPosition() {
              if (!wrapper) return;

              wrapper.style.position = 'absolute';
              wrapper.style.zIndex = 999999;

              var inputRect = element[0].getBoundingClientRect();

              var offsetY = window.innerWidth < 768 ? -60 : -40;
              var wrapperWidth = 290;
              var wrapperHeight = wrapper.scrollHeight > 0 ? wrapper.scrollHeight : 280;

              // Detect RTL
              var isRTL = window.getComputedStyle(element[0]).direction === 'rtl';

              if (isRTL) {
                  wrapper.style.left = ''; // clear left

                  var right = window.innerWidth - inputRect.right - window.scrollX;

                  if (right + wrapperWidth > window.innerWidth) {
                      right = window.innerWidth - wrapperWidth - 20;
                  }

                  if (right < 10) {
                      right = 10;
                  }

                  wrapper.style.right = right + 'px';
              } else {
                  // LTR → use LEFT
                  wrapper.style.right = ''; // clear right
                  var left = inputRect.left + window.scrollX;
                  if (left + wrapperWidth > window.innerWidth + window.scrollX) {
                      left = inputRect.right + window.scrollX - wrapperWidth;
                      if (left < 10) left = 10;
                  }
                  wrapper.style.left = left + 'px';
              }

              // Vertical position (unchanged)
              var spaceBelow = window.innerHeight + window.scrollY - (inputRect.bottom + window.scrollY) - offsetY;
              var spaceAbove = inputRect.top + window.scrollY;

              var top;

              if (spaceBelow >= wrapperHeight + Math.abs(offsetY)) {
                  top = inputRect.bottom + window.scrollY + offsetY;
              } else if (spaceAbove >= wrapperHeight + Math.abs(offsetY)) {
                  top = inputRect.top + window.scrollY - wrapperHeight - offsetY;
              } else {
                  top = inputRect.bottom + window.scrollY + offsetY;
              }

              wrapper.style.top = top + 'px';
            }

            function moveAndAdjust() {
                findWrapper();

                // Wait for wrapper to become visible
                var tries = 0;
                function waitForVisible() {
                    wrapper = $document[0].querySelector('[date-picker-wrapper]');
                    if (wrapper && wrapper.offsetParent !== null && wrapper.offsetWidth > 0) {
                        adjustPosition();

                        // Add resize/scroll listeners once
                        if (!repositionHandler) {
                            repositionHandler = function() {
                                adjustPosition();
                            };
                            $window.addEventListener('resize', repositionHandler);
                            $window.addEventListener('scroll', repositionHandler, true); // capture phase for nested scrolls
                        }
                    } else {
                        if (tries < 10) {
                            tries++;
                            $timeout(waitForVisible, 50);
                        }
                    }
                }

                waitForVisible();
            }

            // On input click or focus
            element.on('click focus', function() {
                $timeout(moveAndAdjust, 50);
            });

            // Cleanup on destroy
            scope.$on('$destroy', function() {
                if (repositionHandler) {
                    $window.removeEventListener('resize', repositionHandler);
                    $window.removeEventListener('scroll', repositionHandler, true);
                    repositionHandler = null;
                }
            });
        }
    };
  }).directive('forceCloseUiSelectOnOutsideClick', function ($document, $timeout) {
    return {
      restrict: 'A',
      require: 'uiSelect',
      link: function (scope, element, attrs, uiSelect) {
        $timeout(function () {
          function isInAnyOpenDropdown(target) {
            var nodes = document.querySelectorAll('.ui-select-choices, .ui-select-dropdown');
            for (var i = 0; i < nodes.length; i++) {
              var n = nodes[i];
              if (n.offsetParent !== null && n.contains(target)) return true;
            }
            return false;
          }

          function handler(e) {
            if (!uiSelect.open) return;
            if (element[0].contains(e.target)) return;
            if (isInAnyOpenDropdown(e.target)) return;

            scope.$evalAsync(function () {
              uiSelect.close();
            });
          }

          document.addEventListener('mousedown', handler, true);
          document.addEventListener('touchstart', handler, true);

          scope.$on('$destroy', function () {
            document.removeEventListener('mousedown', handler, true);
            document.removeEventListener('touchstart', handler, true);
          });
        });
      }
    };
  })
  .directive('uiSelectCloseOthers', function ($rootScope, $timeout) {
    return {
      restrict: 'A',
      require: 'uiSelect',
      link: function (scope, element, attrs, uiSelect) {
        scope.$watch(function () { return uiSelect.open; }, function (isOpen) {
          if (isOpen) {
            $rootScope.$broadcast('uiSelect:closeOthers', element[0]);
          }
        });

        scope.$on('uiSelect:closeOthers', function (ev, sourceElement) {
          if (sourceElement !== element[0] && uiSelect.open) {
            $timeout(function () { uiSelect.close(); });
          }
        });
      }
    };
  })
  .directive('linkify', ['$filter', function($filter) {
    return {
      restrict: 'A',
      scope: {
        linkify: '='
      },
      link: function(scope, element, attrs) {
        var linkifyFilter = $filter('linkifyHtml');
        
        scope.$watch('linkify', function(newValue) {
          if (newValue) {
            element.html(linkifyFilter(newValue));
          }
        });
      }
    };
  }])
  .directive('linkifyText', ['$filter', function($filter) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var linkifyFilter = $filter('linkifyHtml');
        
        var updateContent = function() {
          var text = element.text();
          if (text) {
            element.html(linkifyFilter(text));
          }
        };
        
        scope.$watch(function() {
          return element.text();
        }, function() {
          updateContent();
        });
        
        updateContent();
      }
    };
  }])
  .directive('fixModalPosition', function($timeout, $window, $document) {
    return {
      restrict: 'A',
      link: function(scope, element) {
        var repositionHandler = null;
        var mutationObserver = null;
        var parent = element[0].parentElement;
        var button = parent ? parent.querySelector('button') : null;

        function adjustPosition() {
          // Check if element is visible
          var computedStyle = window.getComputedStyle(element[0]);
          if (computedStyle.visibility === 'hidden' || !element[0].offsetParent) {
            return;
          }

          // Get parent element (filter-button)
          if (!parent) return;

          var parentRect = parent.getBoundingClientRect();
          var modalWidth = element[0].offsetWidth || element[0].getBoundingClientRect().width;
          var windowWidth = $window.innerWidth;
          var margin = 10; // Minimum margin from window edge

          // Detect RTL - check both element and body
          var isRTL = window.getComputedStyle(element[0]).direction === 'rtl' || 
                      $document[0].body.classList.contains('rtls') ||
                      angular.element('body').hasClass('rtls');

          // Position at top of parent
          element[0].style.setProperty('top', '0px', 'important');

          if (isRTL) {
            // RTL mode - CSS sets left: 0 by default (modal's left aligns with parent's left)
            element[0].style.setProperty('right', 'auto', 'important');
            
            // Calculate where modal's right edge would be
            var modalRightEdge = parentRect.left + modalWidth;
            
            // Check if modal goes out of window on the right
            if (modalRightEdge > windowWidth - margin) {
              // Modal goes out on right, shift it left
              var overflow = modalRightEdge - (windowWidth - margin);
              var left = -overflow;
              
              // Ensure it doesn't go out on the left either
              var newModalLeft = parentRect.left - overflow;
              if (newModalLeft < margin) {
                var leftShift = margin - newModalLeft;
                left = -overflow + leftShift;
              }
              
              element[0].style.setProperty('left', left + 'px', 'important');
            } else {
              // Default: align to left edge of parent
              element[0].style.setProperty('left', '0px', 'important');
            }
          } else {
            // LTR mode - CSS sets right: 0 by default (modal's right aligns with parent's right)
            element[0].style.setProperty('left', 'auto', 'important');
            
            // Calculate where modal's left edge would be
            var modalLeftEdge = parentRect.right - modalWidth;
            
            // Check if modal goes out of window on the left
            if (modalLeftEdge < margin) {
              // Modal goes out on left, shift it right
              var shiftRight = margin - modalLeftEdge;
              element[0].style.setProperty('right', (-shiftRight) + 'px', 'important');
            } else {
              // Default: align to right edge of parent
              element[0].style.setProperty('right', '0px', 'important');
            }
          }
        }

        function waitAndAdjust() {
          // Wait for element to become visible
          var tries = 0;
          function waitForVisible() {
            var computedStyle = window.getComputedStyle(element[0]);
            if (computedStyle.visibility === 'visible' && element[0].offsetParent !== null && element[0].offsetWidth > 0) {
              adjustPosition();
              
              // Add resize/scroll listeners once
              if (!repositionHandler) {
                repositionHandler = function() {
                  if (element.hasClass('active')) {
                    adjustPosition();
                  }
                };
                $window.addEventListener('resize', repositionHandler);
                $window.addEventListener('scroll', repositionHandler, true);
              }
            } else {
              if (tries < 15) {
                tries++;
                $timeout(waitForVisible, 50);
              }
            }
          }
          waitForVisible();
        }

        // Use MutationObserver for more reliable class change detection
        if (window.MutationObserver) {
          mutationObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (element.hasClass('active')) {
                  $timeout(function() {
                    waitAndAdjust();
                  }, 50);
                }
              }
            });
          });

          mutationObserver.observe(element[0], {
            attributes: true,
            attributeFilter: ['class']
          });
        }

        // Listen to button click in parent (immediate trigger)
        if (button) {
          angular.element(button).on('click', function() {
            $timeout(function() {
              waitAndAdjust();
            }, 100);
          });
        }

        // Watch for active class changes (fallback)
        var activeWatcher = scope.$watch(function() {
          return element.hasClass('active');
        }, function(isActive) {
          if (isActive) {
            $timeout(function() {
              waitAndAdjust();
            }, 100);
          }
        });

        // Cleanup on destroy
        scope.$on('$destroy', function() {
          if (repositionHandler) {
            $window.removeEventListener('resize', repositionHandler);
            $window.removeEventListener('scroll', repositionHandler, true);
            repositionHandler = null;
          }
          if (activeWatcher) {
            activeWatcher();
          }
          if (mutationObserver) {
            mutationObserver.disconnect();
            mutationObserver = null;
          }
          if (button) {
            angular.element(button).off('click');
          }
        });
      }
    };
  });
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.users - Main users table state
             * app.settings.users.new - New users form state
             * app.settings.users.edit - Edit users form state
             */
            $stateProvider.state('app.admin.users', {
                url: "/users",
                views: {
                    "content@app": {
                        controller: "UsersListController as ctrl",
                        templateUrl: "app/modules/admin/modules/users/modules/users-list/users.list.html"
                    }
                },
                resolve: {
                    Users: function ($api) {
                        return $api.resolve("users@get");
                    }
                }
            });

            modalStateProvider.state("app.admin.users.new", {
                url: "/new",
                controller: "UsersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/admin/modules/users/modules/users-form/users.form.html",
                smallModal: true,
                resolve: {
                    Businesses: ['$api', function ($api) {
                      return $api.resolve("businesses.list_lite@get");
                    }],
                    User: null
                }
            });

            modalStateProvider.state('app.admin.users.edit', {
                url: "/:id",
                controller: "UsersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/admin/modules/users/modules/users-form/users.form.html",
                smallModal: true,
                resolve: {
                    Businesses: ['$api', function ($api) {
                      return $api.resolve("businesses.list_lite@get");
                    }],
                    User: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("users.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.admin.tutorial-videos', {
        url: '/tutorial-videos',
        views: {
          'content@app': {
            controller: 'TutorialVideosListController as ctrl',
            templateUrl: 'app/modules/admin/modules/tutorial-videos/modules/tutorial-videos-list/tutorial-videos.list.html'
          }
        },
        resolve: {
          TutorialVideos: function ($api) {
            return $api.resolve('customTutorialVideos@get');
          }
        }
      });

      modalStateProvider.state('app.admin.tutorial-videos.new', {
        url: '/new',
        controller: 'TutorialVideosFormController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/admin/modules/tutorial-videos/modules/tutorial-videos-form/tutorial-videos.form.html',
        mediumModal: true,
        resolve: {
          TutorialVideo: null
        }
      });

      modalStateProvider.state('app.admin.tutorial-videos.edit', {
        url: '/:id',
        controller: 'TutorialVideosFormController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/admin/modules/tutorial-videos/modules/tutorial-videos-form/tutorial-videos.form.html',
        mediumModal: true,
        resolve: {
          TutorialVideo: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customTutorialVideos.single@get', { id: $rootScope.$stateParams.id });
          }]
        }
      });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.admin.logs', {
                url: "/logs",
                views: {
                    "content@app": {
                        controller: "LogsListController as ctrl",
                        templateUrl: "app/modules/admin/modules/logs/modules/logs-list/logs.list.html"
                    }
                },
                resolve: {
                    Logs: function ($api) {
                        return [];
                    }
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      /**
       * Defining the following custom fields module routes:
       * app.admin.custom-fields - Main custom fields table state
       * app.admin.custom-fields.new - New custom field form state
       * app.admin.custom-fields.edit - Edit custom field form state
       */
      $stateProvider.state('app.admin.custom-fields', {
        url: '/custom-fields',
        views: {
          'content@app': {
            controller: 'CustomFieldsListController as ctrl',
            templateUrl: 'app/modules/admin/modules/custom-fields/modules/custom-fields-list/custom-fields.list.html'
          }
        },
        resolve: {
          CustomFields: function ($api) {
            return $api.resolve('customFields@get');
          }
        }
      });

      modalStateProvider.state('app.admin.custom-fields.new', {
        url: '/new',
        controller: 'CustomFieldsFormController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/admin/modules/custom-fields/modules/custom-fields-form/custom-fields.form.html',
        smallModal: true,
        resolve: {
          Businesses: ['$api', function ($api) {
            return $api.resolve('businesses@get');
          }],
          CustomField: null
        }
      });

      modalStateProvider.state('app.admin.custom-fields.edit', {
        url: '/:id',
        controller: 'CustomFieldsFormController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/admin/modules/custom-fields/modules/custom-fields-form/custom-fields.form.html',
        smallModal: true,
        resolve: {
          Businesses: ['$api', function ($api) {
            return $api.resolve("businesses@get");
          }],
          CustomField: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customFields.single@get', { 'id': $rootScope.$stateParams.id });
          }]
        }
      });
    });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      $stateProvider.state('app.admin.ai-support', {
        url: "/ai-support",
        views: {
          "content@app": {
            controller: "AiSupportListController as ctrl",
            templateUrl: "app/modules/admin/modules/ai-support/modules/ai-support-list/ai-support-list.view.html"
          }
        },
        resolve: {
          Filters: ['$api', function ($api) {
            return $api.resolve("support.filters@get");
          }],
        }
      });

      $stateProvider.state('app.admin.ai-support.files', {
        url: "/files",
        views: {
          "content@app": {
            controller: "AiSupportFilesController as ctrl",
            templateUrl: "app/modules/admin/modules/ai-support/modules/ai-support-files/ai-support-files.view.html"
          }
        },
        resolve: {
          Businesses: ['$api', function ($api) {
            return $api.resolve("businesses@get");
          }],
        }
      });

      modalStateProvider.state('app.admin.ai-support.new', {
        url: "/new",
        controller: "AiSupportSingleController",
        controllerAs: "ctrl",
        templateUrl: "app/modules/admin/modules/ai-support/modules/ai-support-single/ai-support-single.view.html",
        resolve: {
          Article: null,
          Filters: ['$api', function ($api) {
            return $api.resolve("support.filters@get");
          }],
        }
      });

      modalStateProvider.state('app.admin.ai-support.single', {
        url: "/:id",
        controller: "AiSupportSingleController",
        controllerAs: "ctrl",
        templateUrl: "app/modules/admin/modules/ai-support/modules/ai-support-single/ai-support-single.view.html",
        resolve: {
          Article: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve("support.single@get", {"id": $rootScope.$stateParams.id});
          }],
          Filters: ['$api', function ($api) {
            return $api.resolve("support.filters@get");
          }],
        }
      });
    });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider) {
      $stateProvider.state('app.admin.ai-sessions', {
        url: "/ai-sessions",
        views: {
          "content@app": {
            controller: "AiSessionsListController as ctrl",
            templateUrl: "app/modules/admin/modules/ai-sessions/modules/ai-sessions-list/ai-sessions-list.view.html"
          }
        }
      });
    });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      $stateProvider.state('app.admin.ai-prompts', {
        url: "/ai-prompts",
        views: {
          "content@app": {
            controller: "AiPromptsListController as ctrl",
            templateUrl: "app/modules/admin/modules/ai-prompts/modules/ai-prompts-list/ai-prompts-list.view.html"
          }
        },
        resolve: {
          Businesses: ['$api', function ($api) {
            return $api.resolve("businesses@get");
          }],
        }
      });

      modalStateProvider.state('app.admin.ai-prompts.single', {
        url: "/:id",
        controller: "AiPromptsSingleController",
        controllerAs: "ctrl",
        templateUrl: "app/modules/admin/modules/ai-prompts/modules/ai-prompts-single/ai-prompts-single.view.html",
        resolve: {
          Prompt: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve("prompts.single@get", {"id": $rootScope.$stateParams.id});
          }],
        }
    });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider) {

            $stateProvider.state('app.settings.whatsapp_templates', {
                url: "/whatsapp_templates",
                views: {
                    "content@app": {
                        controller: "WhatsappTemplatesSettingsController as ctrl",
                        templateUrl: "app/modules/settings/whatsapp_templates/settings.whatsapp_templates.html"
                    }
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.telephony_settings', {
                url: "/telephony_settings",
                views: {
                    "content@app": {
                        controller: "TelephonySettingsController as ctrl",
                        templateUrl: 'app/modules/settings/telephony_settings/telephony_settings.view.html'
                    }
                },
                resolve: {
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Resources: function ($api) {
                        return $api.resolve("resources@get");
                    },
                    Statuses: function ($api) {
                        return $api.resolve("statuses@get");
                    },
                    TelephonyUsers: function ($api) {
                        return $api.resolve("settings.telephony_users@get");
                    }
                }
            });

        });

})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.sms_logs', {
                url: "/sms_logs",
                views: {
                    "content@app": {
                        controller: "SmsLogsController as ctrl",
                        templateUrl: "app/modules/settings/sms_logs/modules/sms_logs/sms_logs.html"
                    }
                },
                resolve: {
                    Logs: ['$api', function ($api) {
                        return $api.resolve("sms_logs@get");
                    }],
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.second_resources', {
                url: "/second_resources",
                views: {
                    "content@app": {
                        controller: "SecondResourcesListController as ctrl",
                        templateUrl: "app/modules/settings/second_resources/modules/second-resources-list/second_resources.list.html"
                    }
                },
                resolve: {
                    SecondResources: function ($api) {
                        return $api.resolve("second_resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    }
                }
            });

            modalStateProvider.state('app.settings.second_resources.single', {
                url: "/single/:id",
                controller: "SecondResourcesSingleController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-single/second_resources.single.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    SecondResource: ['$api', '$stateParams', '$rootScope', function ($api, $stateParams, $rootScope) {
                        var id = $rootScope.$stateParams && $rootScope.$stateParams.id ? $rootScope.$stateParams.id : $stateParams.id;
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("second_resources.single@get", {"id": id});
                    }],
                    Info: ['$api', function ($api) {
                      return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.second_resources.edit', {
                url: "/edit/:id",
                controller: "SecondResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-form/second_resources.form.html",
                smallModal: true,
                resolve: {
                    SecondResource: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("second_resources.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state("app.settings.second_resources.new", {
                url: "/new",
                controller: "SecondResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-form/second_resources.form.html",
                smallModal: true,
                resolve: {
                    SecondResource: null,
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state('app.settings.second_resources.capacity', {
                url: "/capacity/:id",
                controller: "SecondResourcesCapacityController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/second_resources/modules/second-resources-capacity/second_resources.capacity.html",
                smallModal: true,
                resolve: {
                    CapacityData: ['$api', '$rootScope', '$state', function ($api, $rootScope, $state) {
                        if(typeof $rootScope.$stateParams.id === typeof undefined || $rootScope.$stateParams.id == null) {
                            return null;
                        }
                        return $api.resolve("second_resources.capacity.single@get", {
                            "id": $rootScope.$stateParams.id,
                            "date": $rootScope.capacityDate,
                            "capacity_type": $rootScope.capacityType
                        });
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.resources - Main resources table state
             * app.settings.resources.new - New resource form state
             * app.settings.resources.edit - Edit resource form state
             */
            $stateProvider.state('app.settings.resources', {
                url: "/resources",
                views: {
                    "content@app": {
                        controller: "ResourcesListController as ctrl",
                        templateUrl: "app/modules/settings/resources/modules/resources-list/resources.list.html"
                    }
                },
                resolve: {
                    Resources: function ($api) {
                        return $api.resolve("resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    }
                }
            });

            modalStateProvider.state('app.settings.resources.single', {
                url: "/single/:id",
                controller: "ResourcesSingleController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-single/resources.single.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Resource: ['$api', '$stateParams', '$rootScope', function ($api, $stateParams, $rootScope) {
                        var id = $rootScope.$stateParams && $rootScope.$stateParams.id ? $rootScope.$stateParams.id : $stateParams.id;
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("resources.single@get", {"id": id});
                    }],
                    Info: ['$api', function ($api) {
                      return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.resources.edit', {
                url: "/edit/:id",
                controller: "ResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-form/resources.form.html",
                smallModal: true,
                resolve: {
                    Resource: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state("app.settings.resources.new", {
                url: "/new",
                controller: "ResourcesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-form/resources.form.html",
                smallModal: true,
                resolve: {
                    Resource: null,
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state('app.settings.resources.edit_permissions', {
                url: "/edit_permissions/:id",
                controller: "ResourcesPermissionsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-permissions/resources.permissions.html",
                smallModal: true,
                resolve: {
                    Resource: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DeleteButton: function() {
                        return false;
                    }
                }
            });

            modalStateProvider.state('app.settings.resources.capacity', {
                url: "/capacity/:id",
                controller: "ResourcesCapacityController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/resources/modules/resources-capacity/resources.capacity.html",
                smallModal: true,
                resolve: {
                    CapacityData: ['$api', '$rootScope', '$state', function ($api, $rootScope, $state) {
                        if(typeof $rootScope.$stateParams.id === typeof undefined || $rootScope.$stateParams.id == null) {
                            return null;
                        }
                        return $api.resolve("resources.capacity.single@get", {
                            "id": $rootScope.$stateParams.id,
                            "date": $rootScope.capacityDate,
                            "capacity_type": $rootScope.capacityType
                        });
                    }]
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.settings.photos_stock', {
        url: '/photos_stock',
        views: {
          'content@app': {
            controller: 'PhotosStockSettingsController as ctrl',
            templateUrl: 'app/modules/settings/photos_stock/photos_stock.html'
          }
        },
        resolve: {
          PhotosStock: ['$api', function ($api) {
            return $api.resolve('photosStock@get');
          }]
        }
      });
    });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            // Business online state
            $stateProvider.state('app.settings.online', {
                url: "/online",
                views: {
                    "content@app": {
                        controller: "OnlineSettingsController as ctrl",
                        templateUrl: "app/modules/settings/online/settings.online.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    FillableFields: ['$api', function ($api) {
                        return $api.resolve("customers.fillable_fields@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

             // Messages settings
             $stateProvider.state('app.settings.messages', {
                url: "/messages",
                views: {
                    "content@app": {
                        controller: "MessagesSettingsController as ctrl",
                        templateUrl: "app/modules/settings/messages/settings.messages.html",
                    }
                },
                resolve: {
                    Messages: ['$api', function ($api) {
                        return $api.resolve("settings.messages@get");
                    }],
                    DigitalSecretary: ['$api', '$q', function ($api, $q) {
                        return $api.resolve("settings.digital_secretary@get").catch(function() {
                            // Return empty object if digital secretary endpoint doesn't exist or fails
                            return $q.resolve({data: {}});
                        });
                    }],
                    NotificationsMessages: ['$api', '$q', function ($api, $q) {
                        return $api.resolve("settings.notifications_messages@get").catch(function(error) {
                            // Return empty object if notifications messages endpoint doesn't exist or fails
                            // This handles migration scenarios where the endpoint may not be available yet
                            return $q.resolve({data: {}});
                        });
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following logs module routes:
             * app.settings.logs - Main logs table state
             * app.settings.logs.info - New logs form state
             */
            $stateProvider.state('app.settings.logs', {
                url: "/logs",
                views: {
                    "content@app": {
                        controller: "LogsController as ctrl",
                        templateUrl: "app/modules/settings/logs/modules/logs-list/logs.list.html"
                    }
                },
                resolve: {
                    QuotationStatuses: ['$api', function ($api) {
                        return $api.resolve("quotation_statuses@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.logs.info', {
                url: "/:id",
                controller: "LogsInfoController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/logs/modules/logs-info/logs.info.html",
                smallModal: true,
                resolve: {
                    Transaction: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("transactions.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.leads', {
                url: "/leads",
                views: {
                    "content@app": {
                        controller: "LeadsSettingsController as ctrl",
                        templateUrl: "app/modules/settings/leads/modules/leads-settings/leads.settings.html"
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            $stateProvider.state('app.settings.leads.statuses', {
                url: "/statuses",
                views: {
                    "content@app": {
                        controller: "LeadsStatusesController as ctrl",
                        templateUrl: "app/modules/settings/leads/modules/leads-statuses/leads.statuses.html"
                    }
                },
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                }
            });

            modalStateProvider.state("app.settings.leads.facebook", {
                url: "/facebook",
                controller: "LeadsFacebookController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-facebook/leads.facebook.html",
                smallModal: true,
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state("app.settings.leads.webhook", {
                url: "/webhook",
                controller: "LeadsWebhookController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-webhook/leads.webhook.html",
                smallModal: true,
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state("app.settings.leads.whatsapp", {
                url: "/whatsapp",
                controller: "LeadsWhatsappController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-whatsapp/leads.whatsapp.html",
                smallModal: true,
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state("app.settings.leads.statuses.new", {
                url: "/new",
                controller: "LeadsStatusesNewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-statuses-new/leads.statuses.new.html",
                smallModal: true,
                resolve: {
                    Status: null
                }
            });

            modalStateProvider.state("app.settings.leads.statuses.edit", {
                url: "/:id",
                controller: "LeadsStatusesNewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/leads/modules/leads-statuses-new/leads.statuses.new.html",
                smallModal: true,
                resolve: {
                    Status: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("statuses.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.laser_file', {
                url: "/laser_file",
                views: {
                    "content@app": {
                        controller: "LaserFileSettingsController as ctrl",
                        templateUrl: "app/modules/settings/laser_file/settings.laser_file.html",
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.laser_file@get");
                    }]
                }
            });

            
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            // Business landing state
            $stateProvider.state('app.settings.landing', {
                url: "/landing",
                views: {
                    "content@app": {
                        controller: "LandingSettingsController as ctrl",
                        templateUrl: "app/modules/settings/landing/settings.landing.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.items - Main items table state
             * app.settings.items.new - New items form state
             * app.settings.items.edit - Edit items form state
             */
            $stateProvider.state('app.settings.items', {
                url: "/items",
                views: {
                    "content@app": {
                        controller: "ItemsListController as ctrl",
                        templateUrl: "app/modules/settings/items/modules/items-list/items.list.html"
                    }
                }
            });

            $stateProvider.state('app.settings.items.stock_log', {
                url: "/stock_log/{item_id:int}",
                views: {
                    "content@app": {
                        controller: "ItemsStockLogController as ctrl",
                        templateUrl: "app/modules/settings/items/stock_log/items.stock_log.html"
                    }
                },
                resolve: {
                    Item: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("items.single@get", {"id": $stateParams.item_id});
                    },
                    StockTransactions: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("items.transactions@get", {"item_id": $stateParams.item_id});
                    }
                }
            });

            modalStateProvider.state("app.settings.items.new", {
                url: "/new",
                controller: "ItemsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/items/modules/items-form/items.form.html",
                smallModal: true,
                resolve: {
                    Item: null,
                    Items: ['$api', function ($api) {
                        return $api.resolve("items@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    Categories: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories@get");
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    Resources: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources@get");
                    }],
                }
            });

            modalStateProvider.state('app.settings.items.edit', {
                url: "/:id",
                controller: "ItemsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/items/modules/items-form/items.form.html",
                smallModal: true,
                resolve: {
                    Item: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("items.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    Items: ['$api', function($api) {
                        return $api.resolve("items@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    Categories: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories@get");
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    Resources: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("resources@get");
                    }],
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.info', {
                url: "/info",
                views: {
                    "content@app": {
                        controller: "InfoSettingsController as ctrl",
                        templateUrl: "app/modules/settings/info/info.view.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.google_calendar', {
                url: "/google_calendar",
                views: {
                    "content@app": {
                        controller: "GoogleCalendarController as ctrl",
                        templateUrl: 'app/modules/settings/google_calendar/google_calendar.view.html'
                    }
                },
                resolve: {
                    GoogleCalendarAccounts: function ($api) {
                        return $api.resolve("googlecalendar@get");
                    },
                }
            });

        });

})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      $stateProvider.state('app.settings.gift_cards', {
        url: "/gift_cards",
        views: {
          "content@app": {
            controller: "GiftCardsListSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/list/list.view.html",
          }
        },
        resolve: {
          GiftCards: ['$api', function ($api) {
            return $api.resolve("giftCard@get");
          }]
        }
      });

      $stateProvider.state('app.settings.gift_cards.templates', {
        url: "/templates",
        views: {
          "content@app": {
            controller: "GiftCardsTemplatesSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/templates/templates.view.html",
          }
        },
        resolve: {
          GiftCardsTemplates: ['$api', function ($api) {
            return $api.resolve("giftCardTemplate@get");
          }]
        }
      });

      $stateProvider.state('app.settings.gift_cards.single', {
        url: "/:id",
        views: {
          "content@app": {
            controller: "GiftCardsSingleSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/single/single.view.html",
          }
        },
        resolve: {
          GiftCard: ['$api', '$stateParams', function ($api, $stateParams) {
            return $api.resolve("giftCard.single@get", { id: $stateParams.id });
          }],
          Transactions: ['$api', '$stateParams', function ($api, $stateParams) {
            return $api.resolve("giftCard.transactions.single@get", { id: $stateParams.id });
          }],
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
        }
      });

      $stateProvider.state('app.settings.gift_cards.templates.new', {
        url: "/new",
        views: {
          "content@app": {
            controller: "GiftCardsTemplateSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/template/template.view.html",
          }
        },
        resolve: {
          GiftCardsTemplate: [function () { return null; }],
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
        }
      });

      $stateProvider.state('app.settings.gift_cards.templates.single', {
        url: "/:id",
        views: {
          "content@app": {
            controller: "GiftCardsTemplateSettingsController as ctrl",
            templateUrl: "app/modules/settings/gift_cards/modules/template/template.view.html",
          }
        },
        resolve: {
          GiftCardsTemplate: ['$api', '$stateParams', function ($api, $stateParams) {
            return $api.resolve("giftCardTemplate.single@get", { id: $stateParams.id });
          }],
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
        }
      });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            modalStateProvider.state('app.settings.documents_he', {
                url: "/documents/he",
                controller: "DocumentSettingsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/documents/documents.view.html",
                smallModal: true,
                resolve: {
                    Language: function() {
                        return "he";
                    },
                    Settings: ['$api', function($api) {
                        return $api.resolve("settings.documents@get", {
                            "lang" : "he"
                        })
                    }]
                }
            });

            modalStateProvider.state('app.settings.documents_en', {
                url: "/documents/en",
                controller: "DocumentSettingsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/documents/documents.view.html",
                smallModal: true,
                resolve: {
                    Language: function() {
                        return "en";
                    },
                    Settings: ['$api', function($api) {
                        return $api.resolve("settings.documents@get", {
                            "lang" : "en"
                        })
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.digital_forms', {
                url: "/digital_forms",
                views: {
                    "content@app": {
                        controller: "DigitalFormsListController as ctrl",
                        templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-list/digital_forms.list.html"
                    }
                },
                resolve: {
                    DigitalForms: ['$api', function ($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                }
            });
            

            modalStateProvider.state('app.settings.digital_forms.preview', {
                url: "/formpreview/:id",
                controller: "DigitalFormsPreviewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-preview/digital_forms.preview.html",
                resolve: {
                    DForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms.preview@get", {"id": $rootScope.$stateParams.id});
                    }],
                }
            });

            modalStateProvider.state('app.settings.digital_forms.templates', {
                url: "/formtemplates",
                controller: "DigitalFormsTemplatesController",
                controllerAs: "ctrl",
                smallModal: true,
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-templates/digital_forms.templates.html",
                resolve: {
                    TemplatesList: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms.templates_list@get");
                    }],
                }
            });

            modalStateProvider.state("app.settings.digital_forms.new", {
                url: "/new",
                controller: "DigitalFormsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html",
                smallModal: true,
                resolve: {
                    DigitalForm: null,
                    isDuplicate: function () { return false; },
                    DigitalForms: ['$api', function ($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    PhotosStock: ['$api', function ($api) {
                        return $api.resolve("photosStock@get");
                    }]
                }
            });

            modalStateProvider.state('app.settings.digital_forms.edit', {
                url: "/:id",
                controller: "DigitalFormsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html",
                smallModal: true,
                resolve: {
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms@get", {"id": $rootScope.$stateParams.id});
                    }],
                    isDuplicate: function () { return false; },
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    PhotosStock: ['$api', function ($api) {
                        return $api.resolve("photosStock@get");
                    }]

                }
            });

            modalStateProvider.state('app.settings.digital_forms.duplicate', {
                url: "/duplicate/:id",
                controller: "DigitalFormsFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html",
                smallModal: true,
                resolve: {
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("digital_forms@get", {"id": $rootScope.$stateParams.id});
                    }],
                    isDuplicate: function () { return true; },
                    DigitalForms: ['$api', function ($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    PhotosStock: ['$api', function ($api) {
                        return $api.resolve("photosStock@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

             // Digital documents settings
             $stateProvider.state('app.settings.digital_documents', {
                url: "/digital_documents",
                views: {
                    "content@app": {
                        controller: "DigitalDocumentsSettingsController as ctrl",
                        templateUrl: "app/modules/settings/digital_documents/settings.digital_documents.html",
                    }
                },
                resolve: {
                    DigitalDocuments: ['$api', function ($api) {
                        return $api.resolve("settings.digital_documents@get");
                    }]
                }
            });
        });
})();

(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.settings.custom_fields', {
        url: '/custom_fields',
        views: {
          'content@app': {
            controller: 'CustomFieldsSettingsController as ctrl',
            templateUrl: 'app/modules/settings/custom_fields/custom_fields.html'
          }
        },
        resolve: {
          CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customFields.lists@get');
          }]
        }
      });

      $stateProvider.state('app.settings.custom_fields.single', {
        url: '/:id',
        views: {
          'content@app': {
            controller: 'CustomFieldsSingleSettingsController as ctrl',
            templateUrl: 'app/modules/settings/custom_fields/modules/custom_fields_single/custom_fields.single.html'
          }
        },
        resolve: {
          CustomField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('customFields.list@get', { id: $stateParams.id });
          }],
        }
      });

      modalStateProvider.state('app.settings.custom_fields.single.new', {
        url: '/new',
        controller: 'CustomFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/custom_fields/modules/custom_fields_form/custom_fields.form.html',
        smallModal: true,
        resolve: {
          CustomFieldValue: null
        }
      });

      modalStateProvider.state('app.settings.custom_fields.single.edit', {
        url: '/:vid',
        controller: 'CustomFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/custom_fields/modules/custom_fields_form/custom_fields.form.html',
        smallModal: true,
        resolve: {
          CustomFieldValue: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('customFields.value.get@get', { id: $rootScope.$stateParams.id, vid: $rootScope.$stateParams.vid });
          }],
        }
      });
    });
})();
(function () {

  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {

      $stateProvider.state('app.settings.courses_fields', {
        url: '/courses_fields',
        views: {
          'content@app': {
            controller: 'CoursesFieldsSettingsController as ctrl',
            templateUrl: 'app/modules/settings/courses_fields/courses_fields.html'
          }
        },
        resolve: {
          CoursesFields: ['$api', function ($api) {
            return $api.resolve('coursesFields.lists@get');
          }]
        }
      });

      $stateProvider.state('app.settings.courses_fields.single', {
        url: '/:id',
        views: {
          'content@app': {
            controller: 'CoursesFieldsSingleSettingsController as ctrl',
            templateUrl: 'app/modules/settings/courses_fields/modules/courses_fields_single/courses_fields.single.html'
          }
        },
        resolve: {
          CoursesField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('coursesFields.list@get', { id: $stateParams.id });
          }],
        }
      });

      modalStateProvider.state('app.settings.courses_fields.single.new', {
        url: '/new',
        controller: 'CoursesFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/courses_fields/modules/courses_fields_form/courses_fields.form.html',
        smallModal: true,
        resolve: {
          CoursesFieldValue: null,
          CoursesField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('coursesFields.list@get', { id: $stateParams.id });
          }],
        }
      });

      modalStateProvider.state('app.settings.courses_fields.single.edit', {
        url: '/:vid',
        controller: 'CoursesFieldsFormSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/modules/settings/courses_fields/modules/courses_fields_form/courses_fields.form.html',
        smallModal: true,
        resolve: {
          CoursesFieldValue: ['$api', '$rootScope', function ($api, $rootScope) {
            return $api.resolve('coursesFields.value.get@get', { id: $rootScope.$stateParams.id, vid: $rootScope.$stateParams.vid });
          }],
          CoursesField: ['$api', '$rootScope', '$stateParams', function ($api, $rootScope, $stateParams) {
            return $api.resolve('coursesFields.list@get', { id: $stateParams.id });
          }],
        }
      });
    });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            // Business color state
            $stateProvider.state('app.settings.color', {
                url: "/color",
                views: {
                    "content@app": {
                        controller: "ColorSettingsController as ctrl",
                        templateUrl: "app/modules/settings/color/settings.color.html",
                    }
                },
                resolve: {
                    BU_Types: ['$api', function($api) {
                        return $api.resolve("settings.bu_types@get");
                    }],
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.settings.categories - Main resources table state
             * app.settings.categories.new - New resource form state
             * app.settings.categories.edit - Edit resource form state
             */
            $stateProvider.state('app.settings.categories', {
                url: "/categories",
                views: {
                    "content@app": {
                        controller: "CategoriesListController as ctrl",
                        templateUrl: "app/modules/settings/categories/modules/categories-list/categories.list.html"
                    }
                },
                resolve: {
                    Categories: function ($api) {
                        return $api.resolve("categories@get");
                    }
                }
            });

            modalStateProvider.state("app.settings.categories.new", {
                url: "/new",
                controller: "CategoriesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/categories/modules/categories-form/categories.form.html",
                smallModal: true,
                resolve: {
                    Category: null
                }
            });

            modalStateProvider.state('app.settings.categories.edit', {
                url: "/:id",
                controller: "CategoriesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/categories/modules/categories-form/categories.form.html",
                smallModal: true,
                resolve: {
                    Category: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("categories.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.call_logs', {
                url: "/call_logs",
                views: {
                    "content@app": {
                        controller: "CallLogsController as ctrl",
                        templateUrl: "app/modules/settings/call_logs/modules/call_logs/call_logs.html"
                    }
                },
                resolve: {
                    CallLogs: ['$api', function ($api) {
                        return $api.resolve("call_logs@get");
                    }],
                }
            });
        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.business_whatsapp', {
                url: "/business_whatsapp",
                views: {
                    "content@app": {
                        controller: "BusinessWhatsappSettingsController as ctrl",
                        templateUrl: "app/modules/settings/business_whatsapp/settings.business_whatsapp.html"
                    }
                }
            });
        });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider) {
      $stateProvider.state('app.settings.ai_booking_agent', {
        url: "/ai_booking_agent",
        views: {
          "content@app": {
            controller: "AiBookingAgentController as ctrl",
            templateUrl: 'app/modules/settings/ai_booking_agent/ai_booking_agent.view.html'
          }
        },
        resolve: {
          Info: function ($api) {
            return $api.resolve("settings.info@get");
          },

          Agent: function ($api) {
            return $api.resolve("ai_booking_agent.agent@get");
          }
        }
      });
    });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider) {
      $stateProvider.state('app.settings.ai_agents', {
        url: "/ai_agents",
        views: {
          "content@app": {
            controller: "AiAgentsListController as ctrl",
            templateUrl: 'app/modules/settings/ai_agents/ai_agents.view.html'
          }
        },
        resolve: {
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }]
        }
      });

      $stateProvider.state('app.settings.ai_agents.agent_booking', {
        url: "/agent_booking?tab",
        params: {
          tab: { value: 'settings', squash: true }
        },
        views: {
          "content@app": {
            controller: "AgentBookingController as ctrl",
            templateUrl: 'app/modules/settings/ai_agents/agent_booking/agent_booking.view.html'
          }
        },
        resolve: {
          Info: ['$api', function ($api) {
            return $api.resolve("settings.info@get");
          }],
          Statuses: ['$api', function ($api) {
            return $api.resolve("statuses@get");
          }]
        }
      });

    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.additional_fields', {
                url: "/additional_fields",
                views: {
                    "content@app": {
                        controller: "AdditionalFieldsSettingsController as ctrl",
                        templateUrl: "app/modules/settings/additional_fields/additional_fields.html"
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],

                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.lists@get");
                    }]
                }
            });

            $stateProvider.state('app.settings.additional_fields.interested', {
                url: "/interested",
                views: {
                    "content@app": {
                        controller: "InterestedController as ctrl",
                        templateUrl: "app/modules/settings/additional_fields/modules/interested/interested.html"
                    }
                },
                resolve: {
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                }
            });

            modalStateProvider.state("app.settings.additional_fields.interested.new", {
                url: "/new",
                controller: "InterestedFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/additional_fields/modules/interested-form/interested-form.html",
                smallModal: true,
                resolve: {
                    Interested: null
                }
            });

            modalStateProvider.state("app.settings.additional_fields.interested.edit", {
                url: "/:id",
                controller: "InterestedFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/additional_fields/modules/interested-form/interested-form.html",
                smallModal: true,
                resolve: {
                    Interested: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("interested.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.settings.accounting_settings', {
                url: "/accounting_settings",
                views: {
                    "content@app": {
                        controller: "AccountingSettingsController as ctrl",
                        templateUrl: "app/modules/settings/accounting_settings/accounting_settings.view.html"
                    }
                }
            });

            $stateProvider.state('app.settings.accounting_settings.quotation_statuses', {
                url: "/quotation_statuses",
                views: {
                    "content@app": {
                        controller: "QuotationStatusesController as ctrl",
                        templateUrl: "app/modules/settings/accounting_settings/modules/quotation-statuses/quotation.statuses.html"
                    }
                },
                resolve: {
                    QuotationStatuses: ['$api', function ($api) {
                        return $api.resolve("quotation_statuses@get");
                    }],
                }
            });

            $stateProvider.state('app.settings.accounting_settings.allocation_settings', {
                url: "/allocation_settings",
                views: {
                    "content@app": {
                        controller: "AllocationSettingsController as ctrl",
                        templateUrl: "app/modules/settings/accounting_settings/modules/allocation-settings/allocation.settings.html"
                    }
                }
            });

            modalStateProvider.state("app.settings.accounting_settings.quotation_statuses.new", {
                url: "/new",
                controller: "QuotationStatusesNewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/accounting_settings/modules/quotation-statuses-new/quotation.statuses.new.html",
                smallModal: true,
                resolve: {
                    QuotationStatus: null
                }
            });

            modalStateProvider.state("app.settings.accounting_settings.quotation_statuses.edit", {
                url: "/:id",
                controller: "QuotationStatusesNewController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/accounting_settings/modules/quotation-statuses-new/quotation.statuses.new.html",
                smallModal: true,
                resolve: {
                    QuotationStatus: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("quotation_statuses.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        $stateProvider.state('app.marketing.recommendations', {
            url: "/recommendations",
            views: {
                "content@app": {
                    controller: "RecommendationsController as ctrl",
                    templateUrl: "app/modules/marketing/recommendations/recommendations.view.html"
                }
            },
            resolve: {
                Recommendations: ['$api', function ($api) {
                    return $api.resolve("automations.recommendations@get");
                }],
            }
        });
    });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        $stateProvider.state('app.marketing.automations', {
            url: "/automations",
            views: {
                "content@app": {
                    controller: "AutomationsController as ctrl",
                    templateUrl: "app/modules/marketing/automations/automations.view.html"
                }
            },
            resolve: {
                Automations: ['$api', function ($api) {
                    return $api.resolve("automations@get");
                }],
            }
        });

        modalStateProvider.state("app.marketing.automations.new", {
            url: "/new",
            controller: "AutomationsFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/marketing/automations/form/automations.form.html",
            mediumModal: true,
            resolve: {
                Automation: null,
                DigitalForms: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("digital_forms@get");
                }],
                CustomerStatuses: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("statuses@get");
                }],
            }
        });

        modalStateProvider.state('app.marketing.automations.edit', {
            url: "/:id",
            controller: "AutomationsFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/marketing/automations/form/automations.form.html",
            mediumModal: true,
            resolve: {
                Automation: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("automations.single@get", {"id": $rootScope.$stateParams.id});
                }],
                DigitalForms: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("digital_forms@get");
                }],
                CustomerStatuses: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("statuses@get");
                }],
            }
        });
    });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.workers', {
                url: "/workers",
                views: {
                    "content@app": {
                        controller: "WorkersListController as ctrl",
                        templateUrl: "app/modules/workers/modules/workers-list/workers.list.html"
                    }
                }
            });

            $stateProvider.state('app.workers.single', {
                url: "/{id:int}",
                views: {
                    "content@app": {
                        controller: "WorkersSingleController as ctrl",
                        templateUrl: "app/modules/workers/modules/workers-single/workers.single.html"
                    }
                },
                resolve: {
                    Worker: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("workers.single@get", {"id": $stateParams.id});
                    }
                }
            });

            

            modalStateProvider.state("app.workers.new", {
                url: "/new",
                controller: "WorkersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/workers/modules/workers-form/workers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Worker: null,
                    isModal: false,
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            modalStateProvider.state('app.workers.single.edit', {
                url: "/edit",
                controller: "WorkersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/workers/modules/workers-form/workers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Worker: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("workers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    isModal: false,
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });

            
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.tutorials_center', {
                url: "/tutorials_center",
                views: {
                    "content@app": {
                        controller: "TutorialsCenterController as ctrl",
                        templateUrl: "app/modules/tutorials_center/tutorials_center.html"
                    }
                }
            });
    });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the main abstract settings state (app.settings)
             */
            $stateProvider.state('app.settings', {
                url: "/settings",
                views: {
                    "content@app": {
                        controller: "SettingsController as ctrl",
                        templateUrl: "app/modules/settings/settings.view.html"
                    }
                },
                resolve: {
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }]
                }
            });
        });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

            /**
             * app.reports - Main state of the reports module
             */
            $stateProvider.state('app.reports', {
                url: "/reports?tab",
                views: {
                    "content@app": {
                        controller: "ReportsController as ctrl",
                        templateUrl: "app/modules/reports/reports.view.html"
                    }
                },
                params: {
                    tab: { value: '4', squash: true }
                },
                resolve: {
                    //Customers: function ($api) {
                    //    return $api.resolve("customers@get");
                    //},
                    Resources: function ($api) {
                      return $api.resolve("resources@get");
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                }
            });

            // Tax files
            modalStateProvider.state('app.reports.tax_files', {
                url: "/tax_files",
                controller: "TaxFilesReportsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/reports/tax_files/reports.tax_files.html",
                smallModal: true,
                resolve: {
                }
            });
        });
})();

(function () {
  angular.module('app.modules')
    .config(function ($stateProvider, modalStateProvider) {
      modalStateProvider.state('app.pdf-preview', {
        controller: "PdfPreviewController",
        controllerAs: "ctrl",
        templateUrl: "app/modules/pdf-preview/pdf-preview.view.html",
        smallModal: true,
        resolve: {
          pdfUrl: function ($pdfUrl) {
            return $pdfUrl;
          },
          imageUrl: function ($imageUrl) {
            return $imageUrl;
          }

        }
      });
    });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        
        $stateProvider.state('pay', {
            url: "/pay/{id}",
            controller: "PayController as ctrl",
            templateUrl: "app/modules/pay/pay.view.html",
            resolve: {
                Order: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("pay@get", {"id": $rootScope.$stateParams.id});
                },
            }
        });
    });

        
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            $stateProvider.state('app.notifications', {
                url: "/notifications",
                views: {
                    "content@app": {
                        controller: "NotificationsListController as ctrl",
                        templateUrl: "app/modules/notifications/modules/notifications_list/notifications_list.html"
                    }
                },
                resolve: {
                    Notifications: ['$api', function ($api) {
                        return $api.resolve("notifications.list@get");
                    }],
                }
            });
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.notes', {
                url: "/notes",
                views: {
                    "content@app": {
                        controller: "NotesListController as ctrl",
                        templateUrl: "app/modules/notes/modules/notes-list/notes.list.html"
                    }
                },
                params: {
                    type: { value: 'notes', squash: true }
                },
            });            
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            
        });
})();

(function () {

    angular.module('app.modules').config(function ($stateProvider, modalStateProvider) {

        $stateProvider.state('app.marketing', {
            url: "/marketing",
            views: {
                "content@app": {
                    controller: "MarketingController as ctrl",
                    templateUrl: "app/modules/marketing/marketing.view.html"
                }
            },
            resolve: {
            }
        });
    });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){
        $stateProvider.state('login', {
            url: "/login",
            controller: "LoginController as ctrl",
            templateUrl: "app/modules/login/login.html",
            data: {
                specialClass: 'gray-bg login-page'
            }
        });
        modalStateProvider.state('login.forgot_password', {
            url: "/forgot_password",
            controller: "ForgotPasswordController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/forgot_password/forgot_password.html",
            smallModal: true
        });
        modalStateProvider.state('forgotpassword', {
            url: "/forgotpassword",
            controller: "ForgotPasswordConfirmController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/forgot_password_confirm/forgot_password_confirm.html",
            smallModal: true
        });
        modalStateProvider.state('login.termsofuse', {
            url: "/termsofuse",
            controller: "TermsOfUseController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/terms-of-use/terms-of-use.html",
            smallModal: true
        });
        modalStateProvider.state('approval', {
            url: "/approval/{id}",
            controller: "ApprovalController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/approval/approval.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("approval@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: null
            }
        });
        modalStateProvider.state('order', {
            url: "/order/{id}",
            controller: "ApprovalController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/approval/approval.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("approval@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: true
            }
        });
        modalStateProvider.state('review', {
            url: "/review/{id}",
            controller: "ReviewController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/review/review.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("review@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: null
            }
        });
        modalStateProvider.state('document', {
            url: "/document/{id}",
            controller: "DigitalDocumentsController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/digital_documents/digital_documents.view.html",
            resolve: {
                DigitalDocument: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("customer_documents@get", {"id": $rootScope.$stateParams.id});
                }],
            }
        });
        modalStateProvider.state('form', {
            url: "/form/{id}",
            controller: "DigitalFormsController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/digital_forms/digital_forms.view.html",
            resolve: {
                DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("customer_forms@get", {"id": $rootScope.$stateParams.id});
                }],
            }
        });
        modalStateProvider.state('view_approval', {
            url: "/approval/{id}/{view:int}",
            controller: "ApprovalController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/approval/approval.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("approval@get", {"id": $rootScope.$stateParams.id});
                }],
                IsPreview: ['$rootScope', function ($rootScope) {
                    return $rootScope.$stateParams.view;
                }]
            }
        });
        modalStateProvider.state('prepaid', {
            url: "/prepaid/{id}",
            controller: "PrepaidController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/prepaid/prepaid.view.html",
            resolve: {
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("prepaid@get", {"id": $rootScope.$stateParams.id});
                }],
            }
        });
        $stateProvider.state('gift_card', {
            url: "/gift_card/{id}",
            controller: "PublicGiftCardController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/gift_card/gift_card.view.html",
            resolve: {
                GiftCard: ['$api', '$stateParams', function ($api, $stateParams) {
                    return $api.resolve("publicGiftCard.single@get", { id: $stateParams.id });
                }],
            }
        });

        modalStateProvider.state('cardrequest', {
            url: "/cardrequest/{id}",
            controller: "PublicCardRequestController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/customers/modules/customers-card-request/customers.card_request.html",
            resolve: {
                Info: ['$api', '$rootScope', function ($api, $rootScope) {
                    return $api.resolve("customers.request_card_iframe@get", { id: $rootScope.$stateParams.id });
                }],
            }
        });
    });
})();
(function(){
  angular.module('app.modules').config(function ($stateProvider, modalStateProvider){
    $stateProvider.state('app.digital_forms', {
      url: "/digital_forms",
      views: {
        "content@app": {
          controller: "DigitalFormsAllListController as ctrl",
          templateUrl: "app/modules/digital_forms/modules/digital-forms-list/digital-forms.list.html"
        }
      }
    });
  });
})();
(function(){
    angular.module('app.modules').config(function( $stateProvider ){
        $stateProvider.state('app.dashboard', {
            url: "/",
            views: {
                "content@app": {
                    controller  : "DashboardController as ctrl",
                    templateUrl : "app/modules/dashboard/dashboard.html"
                }
            },
            resolve: {
                Info: function ($api) {
                    return $api.resolve("settings.info@get");
                },
            }
        });

        $stateProvider.state('app.dashboard.load', {
            url: "load",
            views: {
                "content@app": {
                    controller  : "DashboardController as ctrl",
                    templateUrl : "app/modules/dashboard/dashboard_load.html"
                }
            },
            resolve: {
                Info: function ($api) {
                    return null;
                },
            }
          });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * app.orders - Main state of the customers_bookings module
             */
            $stateProvider.state('app.customers_bookings', {
                url: "/customers_bookings",
                views: {
                    "content@app": {
                        controller: "CustomersBookingsController as ctrl",
                        templateUrl: "app/modules/customers_bookings/list/list.view.html"
                    }
                }
            });

        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider, modalStateProvider){

            $stateProvider.state('app.customers', {
                url: "/customers",
                views: {
                    "content@app": {
                        controller: "CustomersListController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-list/customers.list.html"
                    }
                },
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                }
            });

            $stateProvider.state('app.leads', {
                url: "/leads",
                views: {
                    "content@app": {
                        controller: "LeadsListController as ctrl",
                        templateUrl: "app/modules/customers/modules/leads-list/leads.list.html"
                    }
                },
                resolve: {
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Resources: ['$api', function ($api) {
                        return $api.resolve("resources@get");
                    }],
                }
            });

            $stateProvider.state('app.customers.single', {
                url: "/{id:int}",
                views: {
                    "content@app": {
                        controller: "CustomersSingleController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-single/customers.single.html"
                    }
                },
                resolve: {
                    Customer: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("customers.single@get", {"id": $stateParams.id});
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    LaserInfo: function ($api) {
                        return $api.resolve("settings.laser_file@get");
                    },
                    CustomFields: function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    },
                    QuotationStatuses: function ($api) {
                        return $api.resolve("quotation_statuses@get");
                    },
                }
            });

            $stateProvider.state('app.leads.single', {
                url: "/{id:int}",
                views: {
                    "content@app": {
                        controller: "CustomersSingleController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-single/customers.single.html"
                    }
                },
                resolve: {
                    Customer: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("customers.single@get", {"id": $stateParams.id});
                    },
                    Cards: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("cards.customers@get", {"id": $stateParams.id});
                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },

                    LaserFields: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("laser_file@get", {"customer_id": $stateParams.id});
                    },
                    LaserInfo: function ($api) {
                        return $api.resolve("settings.laser_file@get");
                    },
                    CustomFields: function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    },
                    QuotationStatuses: function ($api) {
                        return $api.resolve("quotation_statuses@get");
                    },
                }
            });
            
            modalStateProvider.state('customers_public_form', {
                url: "/cform/{id}",
                controller: "CustomersPublicFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-public-form/customers.public.form.html",
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("social.customer@get", {"id": $rootScope.$stateParams.id});
                    }],
                }
            });

            $stateProvider.state('app.customers.card_transactions', {
                url: "/{id:int}/card_transactions/{card_id:int}",
                views: {
                    "content@app": {
                        controller: "CustomersCardTransactionsController as ctrl",
                        templateUrl: "app/modules/customers/modules/customers-single/cards/transactions.list.html"
                    }
                },
                resolve: {
                    Customer: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("customers.single@get", {"id": $stateParams.id});
                    },
                    Card: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("cards.single@get", {"id": $stateParams.card_id});
                    },
                    CardsTransactions: function ($api, $stateParams, $rootScope) {
                        $rootScope.$stateParams = $stateParams;
                        return $api.resolve("cards.transactions@get", {"card_id": $stateParams.card_id});
                    }
                }
            });

            modalStateProvider.state("app.customers.new", {
                url: "/new",
                controller: "CustomersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Customer: null,
                    isModal: false,
                    Lead: false,
                    Info: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("settings.info@get");
                    }],
                    Resources: ['$api', function ($api) {
                      return $api.resolve("resources@get");
                    }],
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    }],
                    Phone: null,
                }
            });

            modalStateProvider.state("app.leads.new_lead", {
                url: "/new_lead",
                controller: "CustomersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Customer: null,
                    isModal: false,
                    Lead: true,
                    Info: ['$api', '$rootScope', function ($api, $rootScope) {
                        console.log($rootScope);
                        return $api.resolve("settings.info@get");
                    }],
                    Resources: ['$api', function ($api) {
                      return $api.resolve("resources@get");
                    }],
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    }],
                    Phone: null,
                }
            });

            modalStateProvider.state('app.customers.single.edit', {
                url: "/edit",
                controller: "CustomersFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-form/customers.form.html",
                windowClass: "form-modal medium-modal side-modal",
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    isModal: false,
                    Lead: false,
                    Info: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                    Resources: ['$api', function ($api) {
                      return $api.resolve("resources@get");
                    }],
                    Statuses: ['$api', function ($api) {
                        return $api.resolve("statuses@get");
                    }],
                    Interested: ['$api', function ($api) {
                        return $api.resolve("interested@get");
                    }],
                    CustomFields: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customFields.all@get");
                    }],
                    Phone: null,
                }
            });

            modalStateProvider.state('app.customers.single.sms', {
                url: "/sms",
                controller: "CustomersSMSController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-sms/customers.sms.html",
                smallModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });

            modalStateProvider.state('app.customers.single.dd', {
                url: "/dd",
                controller: "CustomersDDController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-dd/customers.dd.html",
                smallModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });

            modalStateProvider.state('app.customers.single.df', {
                url: "/df",
                controller: "CustomersDFController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers-df/customers.df.html",
                smallModal: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });

            modalStateProvider.state('app.customers.single.customers_digital_form', {
                url: "/customer-form/{form_id:int}",
                controller: "CustomersDigitalFormsController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html",
                windowTopClass: "form-modal medium-modal laser-file-modal",
                mediumModal: true,
                minimizable: true,
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customer_forms@get", {"id": $rootScope.$stateParams.form_id});
                    }],
                    DigitalForms: null,
                    Order: null,
                    Business: ['$api', function ($api) {
                        return $api.resolve("settings.info@get");
                    }],
                }
            });

            modalStateProvider.state('app.customers.single.customers_digital_form_print', {
                url: "/customer-form-print/{form_id:int}",
                controller: "CustomersDigitalFormsPrintController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html",
                mediumModal: true,
                windowTopClass: "form-modal medium-modal laser-file-modal print-form-modal",
                resolve: {
                    DigitalForm: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("customer_forms@get", {"id": $rootScope.$stateParams.form_id});
                    }],
                }
            });

            modalStateProvider.state('app.customers.single.customers_digital_form_add', {
                url: "/customer-form-add",
                controller: "CustomersDigitalFormsAddController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html",
                mediumModal: true,
                minimizable: true,
                windowTopClass: "form-modal medium-modal laser-file-modal",
                resolve: {
                    Customer: ['$api', '$rootScope', function ($api, $rootScope){
                        return $api.resolve("customers.single@get", {"id": $rootScope.$stateParams.id});
                    }],
                    DigitalForms: ['$api', function($api) {
                        return $api.resolve("digital_forms@get");
                    }],
                    OrderForm: false,
                    DigitalForm: null,
                    Order: null,
                }
            });
        });
})();

(function(){
    angular.module('app.modules').config(function ($stateProvider){
        $stateProvider.state('app.cashbox', {
            url: "/cashbox",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Resources: function($api) {
                    return $api.resolve("resources@get");
                },
                Customer: function() {
                    return null;
                },
                Transaction: function() {
                    return null
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.credit', {
            url: "/cashbox/credit/:transaction",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function() {
                    return null;
                },
                Transaction: function($api, $stateParams) {
                    return $api.resolve("transactions.single@get", {"id": $stateParams.transaction});
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.quotation', {
            url: "/cashbox/quotation/:transaction",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function() {
                    return null;
                },
                Transaction: function($api, $stateParams) {
                    return $api.resolve("transactions.single@get", {"id": $stateParams.transaction});
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.quotation_edit', {
            url: "/cashbox/quotation-edit/:transaction?quotation",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function() {
                    return null;
                },
                Transaction: function($api, $stateParams) {
                    return $api.resolve("transactions.single@get", {"id": $stateParams.transaction});
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.closedebt', {
            url: "/cashbox/closedebt/:customer",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function ($api) {
                    return $api.resolve("categories@get");
                },
                Items: function ($api) {
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function($api, $stateParams) {
                    return $api.resolve("customers.single@get",  {"id": $stateParams.customer});
                },
                Transaction: function() {
                    return null
                },
                Order: function() {
                    return null
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function() {
                  return null
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.order', {
            url: "/cashbox/order/:orderID",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function($api){
                    return $api.resolve("categories@get");
                },
                Items: function($api){
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function(){
                    return null;
                },
                Order: function($api, $stateParams) {
                    return $api.resolve("orders.single@get", {"id": $stateParams.orderID});
                },
                Transaction: function(){
                    return null;
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function($api, $stateParams){
                  return $api.resolve("cards.for_order@get", {"id": $stateParams.orderID});
                },
                Retainer: function() {
                  return null
                }
            }
        });

        $stateProvider.state('app.cashbox.retainer', {
            url: "/cashbox/retainer/:retainerID",
            views: {
                "content@app": {
                    controller: "CashBoxController as ctrl",
                    templateUrl: "app/modules/cashbox/cashbox.view.html"
                }
            },
            resolve: {
                Categories: function($api){
                    return $api.resolve("categories@get");
                },
                Items: function($api){
                    return $api.resolve("items@get");
                },
                Workers: function ($api) {
                    return $api.resolve("workers.list@get");
                },
                Customer: function(){
                    return null;
                },
                Order: function($api, $stateParams) {
                    return null;
                },
                Transaction: function(){
                    return null;
                },
                Info: function($api){
                    return $api.resolve("settings.info@get");
                },
                CustomerCards: function($api, $stateParams){
                  return null;
                },
                Retainer: function($api, $stateParams){
                  return $api.resolve("transactions.retainer@get", {"id": $stateParams.retainerID});
                },
            }
        });
    });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

          $stateProvider.state('e', {
            url: "/e/{id}",
            controller: "CalendarEventController as ctrl",
            templateUrl: "app/modules/calendar_event/calendar_event.view.html",
            resolve: {
                Order: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("calendar_event@get", {"id": $rootScope.$stateParams.id});
                },
            }
          });

        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * app.orders - Main state of the orders module
             */
            $stateProvider.state('app.calendar', {
                url: "/calendar",
                views: {
                    "content@app": {
                        controller: "CalendarController as ctrl",
                        templateUrl: "app/modules/calendar/calendar.view.html"
                    }
                },
                resolve: {
                    Resources: function($api) {
                        return $api.resolve("resources.capacity.all@get");

                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Lflag: function ($api) {
                        return 0;
                    },
                    Holidays: function($api) {
                        return $api.resolve("holidays@get", {
                            "year" : new Date().getFullYear()
                        });
                    },
                    Customer: function($api) {
                      return null;
                    }
                }
            });

            $stateProvider.state('app.calendar.date', {
              url: "/:date",
              views: {
                  "content@app": {
                      controller: "CalendarController as ctrl",
                      templateUrl: "app/modules/calendar/calendar.view.html"
                  }
              },
              resolve: {
                  Resources: function($api) {
                      return $api.resolve("resources.capacity.all@get");

                  },
                  Info: function ($api) {
                      return $api.resolve("settings.info@get");
                  },
                  Lflag: function ($api) {
                      return 0;
                  },
                  Holidays: function($api) {
                      return $api.resolve("holidays@get", {
                          "year" : new Date().getFullYear()
                      });
                  },
                  Customer: function($api) {
                    return null;
                  }
              }
          });


            $stateProvider.state('app.calendar.call', {
              url: "/call/:phone",
              views: {
                  "content@app": {
                      controller: "CalendarController as ctrl",
                      templateUrl: "app/modules/calendar/calendar.view.html"
                  }
              },
              resolve: {
                Resources: function($api) {
                    return $api.resolve("resources.capacity.all@get");

                },
                Info: function ($api) {
                    return $api.resolve("settings.info@get");
                },
                Lflag: function ($api) {
                    return 0;
                },
                Holidays: function($api) {
                    return $api.resolve("holidays@get", {
                        "year" : new Date().getFullYear()
                    });
                },
                Customer: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("customers.find@get", {"str": $stateParams.phone});
                }
              }
            });

            $stateProvider.state('app.calendar.customer', {
              url: "/customer/:id",
              views: {
                  "content@app": {
                      controller: "CalendarController as ctrl",
                      templateUrl: "app/modules/calendar/calendar.view.html"
                  }
              },
              resolve: {
                Resources: function($api) {
                    return $api.resolve("resources.capacity.all@get");

                },
                Info: function ($api) {
                    return $api.resolve("settings.info@get");
                },
                Lflag: function ($api) {
                    return 0;
                },
                Holidays: function($api) {
                    return $api.resolve("holidays@get", {
                        "year" : new Date().getFullYear()
                    });
                },
                Customer: function ($api, $stateParams, $rootScope) {
                    $rootScope.$stateParams = $stateParams;
                    return $api.resolve("customers.single@get", {"id": $stateParams.id});
                }
              }
            });

            $stateProvider.state('app.calendar.login', {
                url: "/type/:view",
                views: {
                    "content@app": {
                        controller: "CalendarController as ctrl",
                        templateUrl: "app/modules/calendar/calendar.view.html"
                    }
                },
                resolve: {
                    Resources: function($api) {
                        return $api.resolve("resources.capacity.all@get");

                    },
                    Info: function ($api) {
                        return $api.resolve("settings.info@get");
                    },
                    Lflag: function ($api) {
                        return 1;
                    },
                    Holidays: function($api) {
                        return $api.resolve("holidays@get", {
                            "year" : new Date().getFullYear()
                        });
                    },
                    Customer: function($api) {
                      return null;
                    },
                }
            });

            modalStateProvider.state('app.calendar.order-edit', {
              url: "/order/:id",
              controller: "OrderFormController",
              controllerAs: "ctrl",
              templateUrl: "app/modules/calendar/order/order.form.html",
              windowClass: "form-modal medium-modal order-edit-modal side-modal",
              resolve: {
                Items: ['$api', function ($api) {
                  return $api.resolve("items.items_with_duration@get");
                }],
                Resources: ['$api', function ($api) {
                  return $api.resolve("resources@get");
                }],
                SecondResources: ['$api', function ($api) {
                  return $api.resolve("second_resources@get");
                }],
                Info: ['$api', function ($api) {
                  return $api.resolve("settings.info@get");
                }],
                Clubs: ['$api', function ($api) {
                  return $api.resolve("settings.clubs@get");
                }],
                Messages: ['$api', function ($api) {
                  return $api.resolve("settings.messages@get");
                }],
                Customer: [function () {
                  return null;
                }],
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                  return $api.resolve("orders.single@get", {
                    "id": $rootScope.$stateParams.id
                  });
                }],
                CalendarEvent: [function () {
                  return null;
                }],
                CalendarCourse: [function () {
                  return null;
                }],
                EventCopy: [function () {
                  return false;
                }],
                CoursesFields: ['$api', function ($api) {
                  return $api.resolve('coursesFields.lists@get');
                }],
              },
              onExit: function() {
                console.log('client: onExit');
              }
            });

            modalStateProvider.state('app.calendar.order-copy', {
              url: "/copy/:id",
              controller: "OrderFormController",
              controllerAs: "ctrl",
              templateUrl: "app/modules/calendar/order/order.form.html",
              windowClass: "form-modal medium-modal order-edit-modal side-modal",
              resolve: {
                Items: ['$api', function ($api) {
                  return $api.resolve("items.items_with_duration@get");
                }],
                Resources: ['$api', function ($api) {
                  return $api.resolve("resources@get");
                }],
                SecondResources: ['$api', function ($api) {
                  return $api.resolve("second_resources@get");
                }],
                Info: ['$api', function ($api) {
                  return $api.resolve("settings.info@get");
                }],
                Clubs: ['$api', function ($api) {
                  return $api.resolve("settings.clubs@get");
                }],
                Messages: ['$api', function ($api) {
                  return $api.resolve("settings.messages@get");
                }],
                Customer: [function () {
                  return null;
                }],
                Order: ['$api', '$rootScope', function ($api, $rootScope) {
                  return $api.resolve("orders.single@get", {
                    "id": $rootScope.$stateParams.id
                  });
                }],
                CalendarEvent: [function () {
                  return null;
                }],
                CalendarCourse: [function () {
                  return null;
                }],
                EventCopy: [function () {
                  return true;
                }],
                CoursesFields: ['$api', function ($api) {
                  return $api.resolve('coursesFields.lists@get');
                }],
              },
              onExit: function() {
                console.log('client: onExit');
              }
            });

          modalStateProvider.state('app.calendar.event-edit', {
            url: "/event/:id",
            controller: "OrderFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/calendar/order/order.form.html",
            windowClass: "form-modal medium-modal order-edit-modal side-modal",
            resolve: {
              Items: ['$api', function ($api) {
                return $api.resolve("items.items_with_duration@get");
              }],
              Resources: ['$api', function ($api) {
                return $api.resolve("resources@get");
              }],
              SecondResources: ['$api', function ($api) {
                return $api.resolve("second_resources@get");
              }],
              Info: ['$api', function ($api) {
                return $api.resolve("settings.info@get");
              }],
              Clubs: ['$api', function ($api) {
                return $api.resolve("settings.clubs@get");
              }],
              Messages: ['$api', function ($api) {
                return $api.resolve("settings.messages@get");
              }],
              Customer: [function () {
                return null;
              }],
              Order: [function () {
                return null;
              }],
              CalendarEvent: ['$api', '$rootScope', function($api, $rootScope) {
                return $api.resolve("events.single@get", {
                  "id": $rootScope.$stateParams.id
                });
              }],
              CalendarCourse: [function () {
                return null;
              }],
              EventCopy: [function () {
                return false;
              }],
              CoursesFields: ['$api', function ($api) {
                return $api.resolve('coursesFields.lists@get');
              }],
            }
          });


          modalStateProvider.state('app.calendar.course-edit', {
            url: "/course/:id",
            controller: "OrderFormController",
            controllerAs: "ctrl",
            templateUrl: "app/modules/calendar/order/order.form.html",
            windowClass: "form-modal medium-modal order-edit-modal side-modal",
            resolve: {
              Items: ['$api', function ($api) {
                return $api.resolve("items.items_with_duration@get");
              }],
              Resources: ['$api', function ($api) {
                return $api.resolve("resources@get");
              }],
              SecondResources: ['$api', function ($api) {
                return $api.resolve("second_resources@get");
              }],
              Info: ['$api', function ($api) {
                return $api.resolve("settings.info@get");
              }],
              Clubs: ['$api', function ($api) {
                return $api.resolve("settings.clubs@get");
              }],
              Messages: ['$api', function ($api) {
                return $api.resolve("settings.messages@get");
              }],
              Customer: [function () {
                return null;
              }],
              Order: [function () {
                return null;
              }],
              CalendarEvent: [function () {
                return null;
              }],
              CalendarCourse: ['$api', '$rootScope', function($api, $rootScope) {
                return $api.resolve("courses.single@get", {
                  "id": $rootScope.$stateParams.id
                });
              }],
              EventCopy: [function () {
                return false;
              }],
              CoursesFields: ['$api', function ($api) {
                return $api.resolve('coursesFields.lists@get');
              }],
            }
          });

        });
})();

(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * Defining the following customers module routes:
             * app.businesses - Main resources table state
             * app.businesses.new - New resource form state
             * app.businesses.edit - Edit resource form state
             */
            $stateProvider.state('app.businesses', {
                url: "/businesses",
                views: {
                    "content@app": {
                        controller: "BusinessesListController as ctrl",
                        templateUrl: "app/modules/settings/businesses/modules/businesses-list/businesses.list.html"
                    }
                },
                resolve: {
                    Businesses: function ($api) {
                        return $api.resolve("businesses@get");
                    }
                }
            });

            modalStateProvider.state("app.businesses.new", {
                url: "/new",
                controller: "BusinessesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/businesses/modules/businesses-form/businesses.form.html",
                smallModal: true,
                resolve: {
                    Business: null
                }
            });

            modalStateProvider.state('app.businesses.edit', {
                url: "/:id",
                controller: "BusinessesFormController",
                controllerAs: "ctrl",
                templateUrl: "app/modules/settings/businesses/modules/businesses-form/businesses.form.html",
                smallModal: true,
                resolve: {
                    Business: ['$api', '$rootScope', function ($api, $rootScope) {
                        return $api.resolve("businesses.single@get", {"id": $rootScope.$stateParams.id});
                    }]
                }
            });
        });
})();
(function () {

    angular.module('app.modules')

        .config(function ($stateProvider, modalStateProvider) {

            /**
             * app.analytics - Main state of the cashbox module
             */
            $stateProvider.state('app.analytics', {
                url: "/analytics",
                views: {
                    "content@app": {
                        controller: "AnalyticsController as ctrl",
                        templateUrl: "app/modules/analytics/analytics.view.html"
                    }
                },
                resolve: {
                    Statuses: function($api) {
                        return $api.resolve("statuses@get");
                    }
                }
            });
        });
})();
(function(){
  angular.module('app.modules').config(function($stateProvider, modalStateProvider){
    $stateProvider.state('app.admin', {
      url: "/super",
      views: {
        "content@app": {
          controller  : "AdminController as ctrl",
          templateUrl : "app/modules/admin/admin.view.html"
        }
      },
      resolve: {
        Businesses: ['$api', function ($api) {
          return $api.resolve("businesses@get");
        }],
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
        Settings: ['$api', function ($api) {
          return $api.resolve("admin.settings@get");
        }],
      }
    });

    $stateProvider.state('app.admin.single-business', {
      url: "/business/:id",
      views: {
        "content@app": {
          controller  : "BusinessSingleController as ctrl",
          templateUrl : "app/modules/admin/modules/business-single/business.single.html"
        }
      },
      resolve: {
        Business: function ($api, $stateParams, $rootScope) {
          $rootScope.$stateParams = $stateParams;
          return $api.resolve("businesses.single@get", {"id": $rootScope.$stateParams.id});
        },
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
      }
    });

    modalStateProvider.state("app.admin.new", {
      url: "/new-business",
      controller: "BusinessFormController",
      controllerAs: "ctrl",
      templateUrl: "app/modules/admin/modules/business-form/business.form.html",
      resolve: {
        Types: ['$api', function ($api) {
          return $api.resolve("businesses.types@get");
        }],
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
        Business: null,
        Resources: null
      }
    });

    modalStateProvider.state("app.admin.copy", {
      url: "/new-business-copy",
      controller: "BusinessCopyController",
      controllerAs: "ctrl",
      smallModal: true,
      templateUrl: "app/modules/admin/modules/business-copy/business.copy.html",
      resolve: {
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
      }
    });

    modalStateProvider.state("app.admin.message", {
      url: "/message-business",
      controller: "BusinessMessageController",
      controllerAs: "ctrl",
      smallModal: true,
      templateUrl: "app/modules/admin/modules/business-message/business.message.html",
      resolve: {
        Types: ['$api', function ($api) {
          return $api.resolve("businesses.types@get");
        }],
        Business: null,
        Resources: null
      }
    });

    // modalStateProvider.state('app.admin.editbusiness', {
    modalStateProvider.state('app.admin.single-business.edit', {
      url: "/edit",
      controller: "BusinessFormController",
      controllerAs: "ctrl",
      templateUrl: "app/modules/admin/modules/business-form/business.form.html",
      resolve: {
        Business: ['$api', '$rootScope', function ($api, $rootScope) {
          return $api.resolve("businesses.single@get", {"id": $rootScope.$stateParams.id});
        }],
        Types: ['$api', function ($api) {
          return $api.resolve("businesses.types@get");
        }],
        Variants: ['$api', function ($api) {
          return $api.resolve("businesses.variants@get");
        }],
        Resources: ['$api', '$rootScope', function ($api, $rootScope) {
          return $api.resolve("resources@get", {"b_id": $rootScope.$stateParams.id});
        }]
      }
    });
  });
})();

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/ai-dialog/ai-dialog.view.html","<div class=\"ai-dialog\" ng-cloak=\"\" ai-dialog-drag-resize=\"\" ng-class=\"{\'is-mounted\': $ctrl.mounted, \'is-visible\': $ctrl.state.visible, \'ai-dialog--min\': $ctrl.state.minimized}\" ng-style=\"{insetInlineEnd: $ctrl.state.position.insetInlineEnd + \'px\', bottom: $ctrl.state.position.bottom + \'px\', width: $ctrl.state.size.width + \'px\', height: $ctrl.state.size.height + \'px\'}\"><div class=\"ai-dialog__header\" role=\"toolbar\"><div class=\"ai-dialog__title\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewbox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z\"></path></svg>AI Assistant</div><div ng-if=\"$ctrl.state.bookingAgentEnabled\" class=\"ai-dialog__switch\" title=\"Booking mode (WhatsApp emulator)\"><div class=\"form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-checked=\"$ctrl.state.bookingMode\" ng-change=\"$ctrl.toggleBookingMode()\" ng-model=\"$ctrl.state.bookingMode\"> Booking</label></div><div ng-if=\"$ctrl.state.bookingMode\" class=\"form-select\" style=\"width: 200px;\"><app-dropdown model=\"$ctrl.customerId\" options=\"$ctrl.customerOptions\" value-prop=\"id\" label-prop=\"name\" searchable=\"true\" placeholder=\"Select customer...\" fixed-panel=\"true\" on-change=\"$ctrl.onCustomerChange()\"></app-dropdown></div></div><div class=\"ai-dialog__actions\"><button type=\"button\" class=\"ai-dialog__btn\" ng-click=\"$ctrl.toggleMinimize()\" title=\"Minimize\"><i class=\"las la-minus\"></i></button> <button type=\"button\" class=\"ai-dialog__btn\" ng-click=\"$ctrl.close()\" title=\"Close\"><i class=\"las la-times\"></i></button></div></div><div class=\"ai-dialog__body\" ng-if=\"!$ctrl.state.minimized\"><div class=\"ai-dialog__buttons\" ng-if=\"$ctrl.messages.length > 1\"><button ng-if=\"$ctrl.state.bookingMode\" type=\"button\" class=\"ai-dialog__button-new\" ng-click=\"$ctrl.copyLastPairs()\" title=\"Copy last 10 pairs\" ng-disabled=\"$ctrl.loading\"><i class=\"las la-copy\"></i></button> <button type=\"button\" class=\"ai-dialog__button-new\" ng-click=\"$ctrl.resetSession()\" title=\"New chat\"><i class=\"las la-edit\"></i></button></div><div class=\"ai-dialog__messages\" scroll-bottom=\"$ctrl.messages\" scroll-bottom-trigger=\"$ctrl.state.visible + \'-\' + $ctrl.state.minimized\"><div ng-repeat=\"m in $ctrl.messages track by $index\" class=\"ai-dialog__msg\" ng-class=\"{\'ai-dialog__msg--user\': m.role === \'user\'}\"><ai-render ng-if=\"m.render\" data=\"m.render\" meta=\"m.meta\" booking-mode=\"$ctrl.state.bookingMode\" style=\"width: 100%\"></ai-render><div ng-if=\"!m.render\" class=\"ai-dialog__bubble\" ng-bind=\"m.text\"></div></div><div ng-if=\"$ctrl.loading\" class=\"ai-dialog__msg\"><div class=\"ai-dialog__bubble\"><i class=\"las la-spinner la-spin\"></i> Thinking...</div></div></div><form class=\"ai-dialog__input\" ng-submit=\"$ctrl.send()\"><textarea ng-model=\"$ctrl.input\" class=\"form-control\" auto-expand=\"\" placeholder=\"Write your request\" ng-keydown=\"$ctrl.onTextareaKeydown($event)\"></textarea> <button ng-if=\"!$ctrl.loading\" type=\"submit\" ng-disabled=\"$ctrl.loading\"><i class=\"las la-arrow-circle-up\"></i></button> <button ng-if=\"$ctrl.loading\" type=\"button\" ng-disabled=\"$ctrl.loading\"><i class=\"las la-spinner la-spin\"></i></button></form></div><div class=\"ai-dialog__minimized\" ng-if=\"$ctrl.state.minimized\" ng-click=\"$ctrl.toggleMinimize()\" tabindex=\"0\" role=\"button\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewbox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z\"></path></svg></div><div class=\"ai-dialog__resize\"></div></div>");
$templateCache.put("app/components/ai-dialog/ai-render.view.html","<div class=\"ai-render\"><div class=\"ai-render__summary\" ng-if=\"vm.data.summary\">{{ vm.data.summary }}</div><div class=\"ai-render__block\" ng-repeat=\"b in vm.data.blocks track by $index\" ng-switch=\"b.type\"><div ng-switch-when=\"table\" class=\"ai-render__table\"><table class=\"ai-render__tbl\" role=\"table\" aria-label=\"{{ b.title || \'table\' }}\"><thead><tr><th ng-repeat=\"c in b.columns track by $index\">{{ c.label || c.key }}</th></tr></thead><tbody><tr ng-repeat=\"row in b._rowsNorm = vm.visibleRows(b) track by $index\" ng-class=\"{clickable: !!b.row_link}\" ng-click=\"vm.onRowClick(b, row)\"><td ng-repeat=\"c in b.columns track by $index\">{{ vm.formatCell(vm.cell(row, $index), c) }}</td></tr></tbody></table></div><div ng-if=\"!vm.isDuplicateSummaryNote(b)\" ng-switch-when=\"note\" class=\"ai-render__note\" ng-class=\"\'ai-render__note--\' + (b.style || \'info\')\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__text\">{{ b.text }}</div></div><div ng-switch-when=\"text\" class=\"ai-render__text-block\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__text-body\" ng-if=\"b.body\" ng-bind-html=\"vm.richText(b.body)\"></div><ul ng-if=\"(b.items || []).length\"><li ng-repeat=\"it in (b.items || []) track by $index\"><a ng-if=\"vm.safeHref(it.href)\" ng-href=\"{{ vm.safeHref(it.href) }}\"><span ng-bind-html=\"vm.richText(it.text)\"></span></a> <span ng-if=\"!vm.safeHref(it.href)\" ng-bind-html=\"vm.richText(it.text)\"></span></li></ul></div><div ng-switch-when=\"message\" class=\"ai-render__summary\"><div class=\"ai-render__text-body\" ng-if=\"b.body\" ng-bind-html=\"vm.richText(b.body)\"></div></div><div ng-switch-when=\"list\" class=\"ai-render__list\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><ul><li ng-repeat=\"it in (b.items || []) track by $index\"><a ng-if=\"vm.safeHref(it.href)\" ng-href=\"{{ vm.safeHref(it.href) }}\">{{ it.text }}</a> <span ng-if=\"!vm.safeHref(it.href)\">{{ it.text }}</span></li></ul></div><div ng-switch-when=\"steps\" class=\"ai-render__steps\"><div class=\"ai-render__steps-title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__steps-text\" ng-if=\"b.body\" ng-bind-html=\"vm.richText(b.body)\"></div><ol class=\"ai-render__steps-list\"><li ng-repeat=\"step in (b.items || []) track by $index\"><a ng-if=\"vm.stepHref(step)\" ng-href=\"{{ vm.stepHref(step) }}\"><span ng-bind-html=\"vm.richText(vm.stepText(step))\"></span></a> <span ng-if=\"!vm.stepHref(step)\" ng-bind-html=\"vm.richText(vm.stepText(step))\"></span></li></ol></div><div ng-switch-when=\"stat\" class=\"ai-render__stats\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__stats-grid\"><div class=\"ai-render__stat\" ng-repeat=\"s in (b.stats || []) track by $index\"><div class=\"ai-render__stat-label\">{{ s.label }}</div><div class=\"ai-render__stat-value\">{{ (s.value === true ? \'Yes\' : (s.value === false ? \'No\' : s.value)) }} <span class=\"ai-render__stat-unit\" ng-if=\"s.unit\">{{ s.unit }}</span></div></div></div></div><div ng-switch-when=\"chart\" class=\"ai-render__chart\"><div class=\"ai-render__title\" ng-if=\"b.title\">{{ b.title }}</div><div class=\"ai-render__chart-canvas\" ng-if=\"vm.hasChart()\"><canvas width=\"400\" height=\"240\" ai-chart=\"\" block=\"b\"></canvas></div><div class=\"ai-render__chart-fallback\" ng-if=\"!vm.hasChart()\"><table class=\"ai-render__tbl\"><thead><tr><th>{{ b.xKey || \'Category\' }}</th><th ng-repeat=\"yk in (b.yKeys || []) track by $index\">{{ yk }}</th></tr></thead><tbody><tr ng-repeat=\"r in (b.data || []) track by $index\"><td>{{ r[(b.xKey || \'\')] }}</td><td ng-repeat=\"yk in (b.yKeys || []) track by $index\">{{ r[yk] }}</td></tr></tbody></table></div></div><div ng-switch-default=\"\" class=\"ai-render__unknown\">Unsupported block: {{ b.type }}</div></div><div ng-if=\"!vm.bookingMode\" class=\"ai-render__rate\"><div class=\"ai-render__rate-thumb ai-render__rate-good\" ng-class=\"{active: vm.meta.rating == true}\" ng-click=\"vm.onRate(true)\"><i class=\"las la-thumbs-up\"></i></div><div class=\"ai-render__rate-thumb ai-render__rate-bad\" ng-class=\"{active: vm.meta.rating == false}\" ng-click=\"vm.onRate(false)\"><i class=\"las la-thumbs-down\"></i></div></div></div>");
$templateCache.put("app/components/business-helper/business-helper.view.html","<div class=\"business-helper\" ng-cloak=\"\" ng-class=\"{\'is-open\': $ctrl.isOpen}\"><button type=\"button\" class=\"business-helper__fab\" ng-click=\"$ctrl.toggle()\" aria-label=\"{{\'BUSINESS_HELPER_OPEN\' | translate}}\"><span class=\"business-helper__fab-icon\" aria-hidden=\"true\"></span> <span class=\"business-helper__badge\" ng-if=\"$ctrl.notificationCount\" ng-class=\"{\'business-helper__badge--bounce\': $ctrl.badgeAnimate}\">{{$ctrl.notificationCount}}</span></button><div class=\"business-helper__backdrop\" ng-if=\"$ctrl.isOpen\" ng-click=\"$ctrl.close()\"></div><div class=\"business-helper__modal\" ng-if=\"$ctrl.isOpen\"><div class=\"business-helper__header\"><div class=\"business-helper__title-wrap\"><div class=\"business-helper__title\">{{\'BUSINESS_HELPER_TITLE\' | translate}}</div><div class=\"business-helper__subtitle\">{{\'BUSINESS_HELPER_SUBTITLE\' | translate}}</div></div><button type=\"button\" class=\"business-helper__close\" ng-click=\"$ctrl.close()\" aria-label=\"{{\'BUSINESS_HELPER_CLOSE\' | translate}}\"><i class=\"las la-times\"></i></button></div><div class=\"business-helper__tabs\"><button type=\"button\" ng-repeat=\"tab in $ctrl.tabs track by tab.key\" class=\"business-helper__tab\" ng-class=\"{\'active\': $ctrl.isActiveTab(tab.key)}\" ng-click=\"$ctrl.setTab(tab.key)\">{{(\'BUSINESS_HELPER_TAB_\' + (tab.key | uppercase)) | translate}}</button></div><div class=\"business-helper__content\"><div ng-if=\"$ctrl.isActiveTab(\'insights\')\" class=\"business-helper__insights\"><div class=\"business-helper__insights-filter\"><app-dropdown model=\"$ctrl.selectedInsightsPeriod\" options=\"$ctrl.insightsPeriods\" label-prop=\"label\" value-prop=\"key\" placeholder=\"{{\'BUSINESS_HELPER_PERIOD_PLACEHOLDER\' | translate}}\" on-change=\"$ctrl.onInsightsPeriodChange(model)\"></app-dropdown></div><div class=\"circle-loader\" ng-if=\"$ctrl.insightsLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'BUSINESS_HELPER_LOADING_INSIGHTS\' | translate}}</div></div><div class=\"business-helper__insight-card\" ng-if=\"!$ctrl.insightsLoading\" ng-repeat=\"insight in $ctrl.insights track by $index\"><div class=\"business-helper__insight-icon\"><i class=\"las {{insight.icon}}\"></i></div><div class=\"business-helper__insight-meta\"><div class=\"business-helper__insight-label\">{{insight.label}}</div><div class=\"business-helper__insight-value\">{{insight.value}}</div></div></div></div><div ng-if=\"$ctrl.isActiveTab(\'news\')\" class=\"business-helper__news\"><div class=\"business-helper__news-item\" ng-class=\"{\'business-helper__news-item--unread\': !item.is_read, \'business-helper__news-item--animate-in\': item._animateIn}\" ng-repeat=\"item in $ctrl.news track by item.id\"><div class=\"business-helper__avatar\" ng-if=\"item.customer.avatar\"><img ng-src=\"{{item.customer.avatar}}\" alt=\"{{$ctrl.getCustomerName(item.customer)}}\"></div><div class=\"business-helper__avatar business-helper__avatar--fallback\" ng-if=\"!item.customer.avatar\">{{$ctrl.getCustomerName(item.customer).charAt(0)}}</div><div class=\"business-helper__news-content\"><div class=\"business-helper__news-text\">{{$ctrl.getNewsText(item)}}</div><div class=\"business-helper__news-date\">{{item.created_at}}</div></div></div><div class=\"business-helper__news-loading\" ng-if=\"$ctrl.newsLoading\">{{\'BUSINESS_HELPER_LOADING_OLDER_NEWS\' | translate}}</div><div class=\"business-helper__news-empty\" ng-if=\"!$ctrl.newsLoading && !$ctrl.news.length\">{{\'BUSINESS_HELPER_NO_NEWS\' | translate}}</div></div><div ng-if=\"$ctrl.isActiveTab(\'support\')\" class=\"business-helper__support-empty\"><i class=\"las la-headset\"></i><div>{{\'BUSINESS_HELPER_SUPPORT_IN_DEVELOPMENT\' | translate}}</div></div></div></div></div>");
$templateCache.put("app/components/cfilter/button.html","<div ng-controller=\"CfilterController as cfilter\"><div class=\"filter-button\"><button type=\"button\" class=\"btn icon default\" ng-click=\"cfilter.openFilter()\"><span ng-show=\"(cfilter.filter | notEmptyCountFilter) > 0\" class=\"filter-count\">{{cfilter.filter | notEmptyCountFilter}}</span><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal filter-scrolled\': true, \'active\': cfilter.filterModal}\" ng-click=\"$event.stopPropagation();\"><div class=\"filter-modal-content\"><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.item\" options=\"cfilter.filter_values.items\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_ITEMS\' | translate}}\" placeholder=\"{{\'FILTER_ITEMS\' | translate}}\" search-placeholder=\"{{\'FILTER_ITEMS\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.not_use_item\" options=\"cfilter.filter_values.items\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_NO_USE_ITEMS\' | translate}}\" placeholder=\"{{\'FILTER_NO_USE_ITEMS\' | translate}}\" search-placeholder=\"{{\'FILTER_NO_USE_ITEMS\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.category\" options=\"cfilter.filter_values.categories\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_CATEGORY\' | translate}}\" placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\" search-placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.resource\" options=\"cfilter.filter_values.resources\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_RESOURCE\' | translate}}\" placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\" search-placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.arrival_source\" options=\"cfilter.filter_values.arrival_sources\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_ARRIVAL_SOURCE\' | translate}}\" placeholder=\"{{\'FILTER_ARRIVAL_SOURCE\' | translate}}\" search-placeholder=\"{{\'FILTER_ARRIVAL_SOURCE\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.interested\" options=\"cfilter.filter_values.interested\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_INTERESTED_IN\' | translate}}\" placeholder=\"{{\'FILTER_INTERESTED_IN\' | translate}}\" search-placeholder=\"{{\'FILTER_INTERESTED_IN\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_OPENED_ORDERS_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.opened_orders_from || cfilter.filter.opened_orders_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.opened_orders_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_OPENED_ORDERS_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.opened_orders_to || cfilter.filter.opened_orders_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.opened_orders_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.lastvisit_from || cfilter.filter.lastvisit_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.lastvisit_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.lastvisit_to || cfilter.filter.lastvisit_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.lastvisit_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.created_from || cfilter.filter.created_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.created_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.created_to || cfilter.filter.created_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.created_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.birthday\" options=\"cfilter.birthdayOptions\" label-prop=\"value\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_BIRTHDAY\' | translate}}\" placeholder=\"{{\'FILTER_BIRTHDAY\' | translate}}\" search-placeholder=\"{{\'FILTER_BIRTHDAY\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.visited_from || cfilter.filter.visited_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.visited_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.visited_to || cfilter.filter.visited_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.visited_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div><div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"cfilter.filter.have_card\">{{\"FILTER_HAVE_CARDS\" | translate}}</label></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.gender\" options=\"cfilter.genderOptions\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_GENDER\' | translate}}\" placeholder=\"{{\'FILTER_GENDER\' | translate}}\"></app-dropdown></div></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.status\" options=\"cfilter.filter_values.statuses\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_STATUS\' | translate}}\" placeholder=\"{{\'FILTER_STATUS\' | translate}}\" search-placeholder=\"{{\'FILTER_STATUS\' | translate}}\"></app-dropdown></div></div><div ng-if=\"cfilter.module == \'marketing\'\"><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.type\" options=\"cfilter.filter_values.types\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_TYPE\' | translate}}\" placeholder=\"{{\'FILTER_TYPE\' | translate}}\" search-placeholder=\"{{\'FILTER_TYPE\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\"><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.campaign\" options=\"cfilter.filter_values.campaigns\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_CAMPAIGN_NAME\' | translate}}\" placeholder=\"{{\'FILTER_CAMPAIGN_NAME\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.ad\" options=\"cfilter.filter_values.ads\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_AD_NAME\' | translate}}\" placeholder=\"{{\'FILTER_AD_NAME\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"cfilter.filter.adset\" options=\"cfilter.filter_values.adsets\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_ADSET_NAME\' | translate}}\" placeholder=\"{{\'FILTER_ADSET_NAME\' | translate}}\"></app-dropdown></div></div><div ng-if=\"cfilter.filter_values.custom_fields.length > 0\"><div ng-repeat=\"field in cfilter.filter_values.custom_fields\"><div ng-if=\"field.type == \'date\' || field.type == \'datetime\'\" class=\"form-group\"><label>{{field.name | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !cfilter.filter.custom_fields[field.id] || cfilter.filter.custom_fields[field.id] == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"cfilter.filter.custom_fields[field.id]\" view=\"date\" min-view=\"{{ field.type == \'date\' ? \'date\' : \'minutes\' }}\" format=\"{{ field.type == \'date\' ? \'DD/MM/YYYY\' : \'DD/MM/YYYY HH:mm\' }}\" readonly=\"readonly\"></div><div ng-if=\"field.type == \'list\'\" class=\"form-group\"><app-dropdown model=\"cfilter.filter.custom_fields[field.id]\" options=\"field.values\" label-prop=\"value\" multiple=\"true\" searchable=\"true\" label=\"{{field.name | translate}}\" placeholder=\"{{field.name | translate}}\" search-placeholder=\"{{field.name | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"flex nowrap gap-16 between filter-modal-footer\"><a ng-click=\"cfilter.clearFilter()\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a><div class=\"flex nowrap gap-16\"><a ng-if=\"cfilter.store\" ng-click=\"cfilter.storeFilter()\" class=\"btn text large\">{{\"STORE_FILTER\" | translate}}</a> <a ng-if=\"!cfilter.store\" ng-click=\"cfilter.closeFilter()\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"cfilter.applyFilter()\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/components/common/bottomnavbar.html","<nav class=\"bottom-nav\" role=\"navigation\"><ul class=\"nav\" id=\"bottom-menu\"><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'dashboard\')\"><a ui-sref=\"app.dashboard\"><i class=\"las la-home\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'calendar\')\"><a ui-sref=\"app.calendar\"><i class=\"las la-calendar\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\')\"><a ui-sref=\"app.customers\"><i class=\"las la-users\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><a ui-sref=\"app.cashbox\"><i class=\"las la-dollar-sign\"></i></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings\"><i class=\"las la-cog\"></i></a></li></ul></nav>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\" ng-if=\"isAuth\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"content\"></div></div><div ng-include=\"\'app/components/common/bottomnavbar.html\'\" ng-if=\"isAuth\"></div><div class=\"minimized-modal-bar\" ng-if=\"minimizedModal\" ng-click=\"restoreMinimizedModal()\"><i class=\"la la-window-restore\"></i> <span>{{minimizedModal.title}}</span></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">10GB of <strong>250GB</strong> Free.</div><div><strong>Copyright</strong> Example Company &copy; 2015-2016</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav ng-class=\"{\'navbar-default navbar-static-side sidebar-mainnav\': true, \'admin-page\': ($user && $user.role == \'1\')}\" role=\"navigation\"><div class=\"sidebar-collapse\"><div class=\"head-logo\"><a href=\"/\"><img ng-if=\"!color_form.switch_colors\" src=\"assets/images/logonew-white.svg\" class=\"main-logo img-responsive\"> <img ng-if=\"color_form.switch_colors\" src=\"assets/images/logonew.svg\" class=\"main-logo img-responsive\"></a><div class=\"side-menu-collapse\" ng-click=\"toggleSidebar()\"><i ng-if=\"isSidebarCollapsed\" class=\"las la-angle-right\"></i> <i ng-if=\"!isSidebarCollapsed\" class=\"las la-angle-left\"></i></div></div><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"row\"><div class=\"col-xs-12 header-sidebar\"><div><span minimaliza-sidebar=\"\"></span></div><div style=\"margin-right:-50px;\"><ol class=\"breadcrumb\"><li ng-repeat=\"(index, page) in header.breadcrumbs\"><a ui-sref=\"{{page.state}}\" ng-if=\"page.state\">{{page.title | translate}}</a> <span ng-if=\"!page.state && index === header.breadcrumbs.length-1\"><strong>{{page.title | translate}}</strong></span> <span ng-if=\"!page.state && index !== header.breadcrumbs.length-1\">{{page.title | translate}}</span></li></ol></div></div></div></li><li ui-sref-active-eq=\"active\" ng-if=\"isUserAllowedAccess(\'businesses\')\"><a ui-sref=\"app.admin\" class=\"WhiteBg\"><i class=\"las la-briefcase\"></i> <span class=\"nav-label\">{{\"NAV_BUSINESSES\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'users\')\"><a ui-sref=\"app.admin.users\" class=\"WhiteBg\"><i class=\"las la-user\"></i> <span class=\"nav-label\">{{\"NAV_USERS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'custom_fields\')\"><a ui-sref=\"app.admin.custom-fields\" class=\"WhiteBg\"><i class=\"las la-user-edit\"></i> <span class=\"nav-label\">{{\"NAV_CUSTOM_FIELDS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'tutorial_videos\')\"><a ui-sref=\"app.admin.tutorial-videos\" class=\"WhiteBg\"><i class=\"las la-video\"></i> <span class=\"nav-label\">{{\"NAV_TUTORIAL_VIDEOS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'logs\')\"><a ui-sref=\"app.admin.logs\" class=\"WhiteBg\"><i class=\"las la-file-code\"></i> <span class=\"nav-label\">{{\"NAV_LOGS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'ai_prompts\')\"><a ui-sref=\"app.admin.ai-prompts\" class=\"WhiteBg\"><i class=\"las la-comment-dots\"></i> <span class=\"nav-label\">{{\"NAV_AI_PROMPTS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'ai_sessions\')\"><a ui-sref=\"app.admin.ai-sessions\" class=\"WhiteBg\"><i class=\"las la-comment-dots\"></i> <span class=\"nav-label\">{{\"NAV_AI_SESSIONS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'ai_support_articles\')\"><a ui-sref=\"app.admin.ai-support\" class=\"WhiteBg\"><i class=\"las la-file-alt\"></i> <span class=\"nav-label\">{{\"NAV_AI_SUPPORT_ARTICLES\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'dashboard\')\"><a ui-sref=\"app.dashboard\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-home\"></i> <span class=\"nav-label\">{{\"DASHBOARD\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'calendar\')\"><a ui-sref=\"app.calendar\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-calendar\"></i> <span class=\"nav-label\">{{\"NAV_DAY\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><a ui-sref=\"app.cashbox\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-dollar-sign\"></i> <span class=\"nav-label\">{{\"NAV_CASH\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\')\"><a ui-sref=\"app.customers\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-users\"></i> <span class=\"nav-label\">{{\"NAV_CUSTOMERS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'business_settings\') && ai_agent_booking\"><a ui-sref=\"app.settings.ai_agents.agent_booking({ tab: \'history\' })\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-robot\"></i> <span class=\"nav-label\">{{\"NAV_AI_AGENTS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'leads\') && manage_leads\"><a ui-sref=\"app.leads\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-star\"></i> <span class=\"nav-label\">{{\"NAV_LEADS\" | translate}}</span> <span ng-class=\"{\'gelatine\': isBouncingLead}\" ng-if=\"leads_count\" class=\"nav-mark\">{{leads_count}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\') && show_notes_page\"><a ui-sref=\"app.notes\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-sticky-note\"></i> <span class=\"nav-label\">{{\"NAV_NOTES\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'customers\') && show_digital_forms_page\"><a ui-sref=\"app.digital_forms\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-file-alt\"></i> <span class=\"nav-label\">{{\"NAV_DIGITAL_FORMS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'workers\')\"><a ui-sref=\"app.workers\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-briefcase\"></i> <span class=\"nav-label\">{{\"WORKERS\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'marketing\')\"><a ui-sref=\"app.marketing\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-bullhorn\"></i> <span class=\"nav-label\">{{\"NAV_MARKETING\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'business_analysis\')\"><a ui-sref=\"app.analytics\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-chart-area\"></i> <span class=\"nav-label\">{{\"NAV_ANALYTIC\" | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"isUserAllowedAccess(\'reports\')\"><a ui-sref=\"app.reports\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-clipboard\"></i> <span class=\"nav-label\">{{\"NAV_REPORTS\" | translate}}</span></a></li><li ng-if=\"$state.includes(\'app.dashboard\') && !isSidebarCollapsed\" class=\"menu-color-settings\"><div class=\"flex form nowrap\"><div><div class=\"form-group form-color flex column\"><label class=\"thin\">{{\"ADMIN_BACK_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"color_form.back_color\" ng-change=\"submitColors()\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color flex column\"><label class=\"thin\">{{\"ADMIN_MENU_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"color_form.menu_color\" ng-change=\"submitColors()\" name=\"name\" class=\"form-control\"></div></div></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-model=\"color_form.switch_colors\" ng-change=\"submitColors()\">{{\"SWITCH_MENU_COLORS\" | translate}}</label></div></li><li ng-if=\"isUserAllowedAccess(\'tutorials_center\')\" ng-class=\"{active: $state.includes(\'app.tutorials_center\'), ondashboard: $state.includes(\'app.dashboard\') && !isSidebarCollapsed, tobottom: true}\"><a ui-sref=\"app.tutorials_center\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-video\"></i> <span class=\"nav-label\">{{\"NAV_TUTORIALS\" | translate}}</span></a></li><li ng-class=\"{active: $state.includes(\'app.settings\')}\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings\" class=\"WhiteBg\" ng-click=\"menuHide()\"><i class=\"las la-cog\"></i> <span class=\"nav-label\">{{\"NAV_SETTINGS\" | translate}}</span></a></li><li><a ng-click=\"menuHide(); logout()\" class=\"WhiteBg\"><i class=\"las la-sign-out-alt\"></i> <span class=\"nav-label\">{{\"HEADER_LOGOUT\" | translate}}</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/notify.html","<div class=\"cg-notify-message inspinia-notify cg-notify-message-center\" ng-class=\"$classes\"><div class=\"p-lg\"><div ng-show=\"!$messageTemplate\">{{$message}}</div><div ng-show=\"$messageTemplate\" class=\"cg-notify-message-template\"></div><button type=\"button\" class=\"cg-notify-close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span> <span class=\"cg-notify-sr-only\">Close</span></button></div></div>");
$templateCache.put("app/components/common/topnavbar.html","");
$templateCache.put("app/components/feedback/feedback.form.html","<div ng-controller=\"FeedbackController as ctrl\"><div class=\"modal-head\"><h3 class=\"modal-title\">{{\"FEEDBACK_SENDING_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\" ng-if=\"isModal\">&times;</a></div><form name=\"feedbackForm\" ng-submit=\"ctrl.submit()\"><div class=\"modal-body\" style=\"background: white;\"><div class=\"flex form fill\"><div class=\"form-group\"><textarea class=\"feedback-question form-control\" rows=\"5\" required=\"\" ng-model=\"ctrl.feedback.question\" placeholder=\'{{\"FEEDBACK_SENDING_MSG_PLACEHOLDER\" | translate}}\'></textarea></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\" ng-if=\"isModal\">{{\"FEEDBACK_SENDING_MSG_CLOSE\" | translate}}</button> <button type=\"submit\" ng-disabled=\"feedbackForm.$invalid || feedbackForm.$pristine\" class=\"btn text primary large\">{{\"FEEDBACK_SENDING_MSG_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/components/gift_card/gift_card.view.html","<div class=\"gift-card\" ng-class=\"ctrl.classes()\" ng-attr-style=\"--gc-page-bg-color: {{ctrl.settings.page_bg_color}}; --gc-card-bg-color: {{ctrl.settings.card_bg_color}}; --gc-primary-color: {{ctrl.settings.primary_color}}; --gc-text-color: {{ctrl.settings.text_color}}; --gc-card-bg-gradient: {{ctrl.card_bg_gradient}};\"><div class=\"gift-card__bow\"></div><div class=\"gift-card__image\" ng-style=\"{\'background-image\': \'url(\' + ctrl.settings.image + \')\'}\"></div><div class=\"gift-card__image-mobile\" ng-style=\"{\'background-image\': \'url(\' + ctrl.settings.image + \')\'}\"></div><div class=\"gift-card__content\"><div class=\"gift-card__content-title\">{{ \"GIFT_CARD\" | translate }}</div><div class=\"gift-card__content-number\">{{ \"GIFT_CARD_NUMBER\" | translate }} #{{ctrl.values.number}}</div><div class=\"gift-card__content-business\"><div class=\"gift-card__content-business__logo\"><img ng-if=\"ctrl.settings.logo != \'\'\" ng-src=\"{{ctrl.settings.logo}}\" alt=\"\"></div><div class=\"gift-card__content-business__info\"><p class=\"gift-card__content-business__info-name\">{{ctrl.values.business}}</p><p class=\"gift-card__content-business__info-address\"><svg width=\"17\" height=\"17\" viewbox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.91797 6.2002C8.08954 6.2002 7.41797 6.87177 7.41797 7.7002C7.41797 8.52862 8.08954 9.2002 8.91797 9.2002C9.7464 9.2002 10.418 8.52862 10.418 7.7002C10.418 6.87177 9.7464 6.2002 8.91797 6.2002ZM6.41797 7.7002C6.41797 6.31948 7.53726 5.2002 8.91797 5.2002C10.2987 5.2002 11.418 6.31948 11.418 7.7002C11.418 9.08091 10.2987 10.2002 8.91797 10.2002C7.53726 10.2002 6.41797 9.08091 6.41797 7.7002Z\" fill=\"#434343\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.91793 2.86707C7.962 2.86707 7.02753 3.15053 6.2327 3.68161C5.43787 4.21269 4.81837 4.96754 4.45254 5.8507C4.08671 6.73387 3.99098 7.70568 4.17745 8.64324C4.36392 9.58079 4.82421 10.442 5.50011 11.1179C5.50009 11.1179 5.50013 11.118 5.50011 11.1179L8.32931 13.9465C8.48556 14.1026 8.6974 14.1903 8.91826 14.1903C9.13913 14.1903 9.35097 14.1026 9.50722 13.9465L12.3357 11.118C13.0116 10.442 13.4719 9.58081 13.6584 8.64324C13.8449 7.70567 13.7492 6.73387 13.3833 5.8507C13.0175 4.96754 12.398 4.21269 11.6032 3.68161C10.8083 3.15053 9.87386 2.86707 8.91793 2.86707ZM13.0428 11.8251C13.8586 11.0093 14.4141 9.96986 14.6392 8.83831C14.8643 7.70677 14.7487 6.53389 14.3072 5.46801C13.8657 4.40212 13.118 3.4911 12.1587 2.85014C11.1994 2.20918 10.0716 1.86707 8.91793 1.86707C7.76422 1.86707 6.63642 2.20918 5.67714 2.85014C4.71786 3.4911 3.97018 4.40212 3.52866 5.46801C3.08714 6.53389 2.97161 7.70677 3.19666 8.83831C3.42172 9.96986 3.97726 11.0093 4.79303 11.8251L7.62242 14.6538C7.96618 14.9972 8.43235 15.1903 8.91826 15.1903C9.40417 15.1903 9.87021 14.9974 10.214 14.6539L13.0428 11.8251Z\" fill=\"#434343\"></path></svg>{{ctrl.values.address}}</p></div></div><div ng-if=\"ctrl.settings.service && ctrl.values.service\" class=\"gift-card__content-service\"><p class=\"gift-card__content-service__label\">{{ \"GIFT_CARD_SERVICE\" | translate }}:</p><p class=\"gift-card__content-service__value\">{{ ctrl.values.service }}</p></div><div ng-if=\"ctrl.settings.receiver && ctrl.values.receiver\" class=\"gift-card__content-receiver\"><p class=\"gift-card__content-receiver__label\">{{ \"GIFT_CARD_GIFTED_TO\" | translate }}</p><p class=\"gift-card__content-receiver__value\">{{ ctrl.values.receiver }}</p></div><div ng-if=\"ctrl.settings.value && ctrl.values.value\" class=\"gift-card__content-value\"><p class=\"gift-card__content-value__label\">{{ \"GIFT_CARD_VALUE\" | translate }}:</p><p class=\"gift-card__content-value__value\">₪{{ (ctrl.values.value * 1).toFixed(2) }}</p><b ng-if=\"ctrl.values.balance !== undefined && ctrl.values.balance !== null && ctrl.values.balance !== \'\' && ctrl.values.balance !== ctrl.values.value\" class=\"gift-card__content-value__label\">/</b><p ng-if=\"ctrl.values.balance !== undefined && ctrl.values.balance !== null && ctrl.values.balance !== \'\' && ctrl.values.balance !== ctrl.values.value\" class=\"gift-card__content-value__label\">{{ \"GIFT_CARD_BALANCE\" | translate }}:</p><p ng-if=\"ctrl.values.balance !== undefined && ctrl.values.balance !== null && ctrl.values.balance !== \'\' && ctrl.values.balance !== ctrl.values.value\" class=\"gift-card__content-value__value\">₪{{ (ctrl.values.balance * 1).toFixed(2) }}</p></div><div ng-if=\"ctrl.settings.message && ctrl.values.message\" class=\"gift-card__content-message\"><span class=\"start\"><svg width=\"14\" height=\"14\" viewbox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.276 0.480021L12.9692 2.71917C12.1717 2.65782 11.5889 2.82141 11.2209 3.20993C10.8528 3.59846 10.6279 4.11991 10.5461 4.77427C10.4643 5.42863 10.4438 6.13411 10.4847 6.89072H13.276V13.3628H8.03086V5.66379C8.03086 3.7825 8.50118 2.37153 9.44182 1.43089C10.4029 0.490246 11.681 0.173289 13.276 0.480021ZM5.48498 0.480021L5.17825 2.71917C4.38075 2.65782 3.79796 2.82141 3.42988 3.20993C3.0618 3.59846 2.83686 4.11991 2.75507 4.77427C2.67327 5.42863 2.65283 6.13411 2.69372 6.89072H5.48498V13.3628H0.239868V5.66379C0.239868 3.7825 0.71019 2.37153 1.65083 1.43089C2.61193 0.490246 3.88998 0.173289 5.48498 0.480021Z\" fill=\"currentColor\"></path></svg></span> {{ ctrl.values.message }} <span class=\"end\"><svg width=\"14\" height=\"14\" viewbox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.560089 13.0471L0.866821 10.808C1.66432 10.8693 2.24711 10.7058 2.61519 10.3172C2.98327 9.9287 3.20821 9.40726 3.29 8.7529C3.3718 8.09853 3.39225 7.39305 3.35135 6.63645L0.560089 6.63645L0.560088 0.164403L5.8052 0.164403L5.8052 7.86337C5.8052 9.74466 5.33488 11.1556 4.39424 12.0963C3.43314 13.0369 2.15509 13.3539 0.560089 13.0471ZM8.35108 13.0471L8.65781 10.808C9.45531 10.8693 10.0381 10.7058 10.4062 10.3172C10.7743 9.9287 10.9992 9.40725 11.081 8.75289C11.1628 8.09853 11.1832 7.39305 11.1423 6.63645L8.35108 6.63645L8.35108 0.164402L13.5962 0.164402L13.5962 7.86337C13.5962 9.74466 13.1259 11.1556 12.1852 12.0963C11.2241 13.0369 9.94608 13.3539 8.35108 13.0471Z\" fill=\"currentColor\"></path></svg></span></div><div ng-if=\"ctrl.settings.sender && ctrl.values.sender\" class=\"gift-card__content-sender\"><p class=\"gift-card__content-sender__label\">{{ \"GIFT_CARD_GIFTED_BY\" | translate }}</p><p class=\"gift-card__content-sender__value\">{{ ctrl.values.sender }}</p></div></div></div>");
$templateCache.put("app/components/header/header.html","<div ng-controller=\"HeaderController as header\" id=\"header-wrapper\"><div class=\"mobile-head-logo\"><button class=\"btn icon simple mobile-menu-toggle\" ng-click=\"header.menuToggle()\"><i class=\"las la-bars\"></i></button> <a href=\"/\"><img src=\"assets/images/logonew.svg\" class=\"main-logo img-responsive\"></a></div><div class=\"wrapper white-bg page-heading\" ng-class=\"isMobile ? \'application\' : \'\'\"><div class=\"header-sidebar\"><div><div ng-if=\"header.stop_messages\" class=\"header-red-alert\">{{\"MESSAGES_STOPED_ALERT\" | translate}}</div><ol class=\"breadcrumb\"><li ng-repeat=\"(index, page) in header.breadcrumbs\"><a ui-sref=\"{{page.state}}\" ng-if=\"page.state\" class=\"bread-menu\">{{page.title | translate}}</a> <span ng-if=\"!page.state && index === header.breadcrumbs.length-1\"><strong>{{page.title | translate}}</strong></span> <span ng-if=\"!page.state && index !== header.breadcrumbs.length-1\">{{page.title | translate}}</span> <span ng-if=\"header.dealer_name\">{{\' - \' + header.dealer_name}} <span ng-if=\"header.allowedBusinessIds.length > 1\" class=\"business-switcher business-switcher--breadcrumb\"><i class=\"las la-angle-down business-switcher__arrow\" ng-click=\"header.businessSwitcherOpen = !header.businessSwitcherOpen; $event.stopPropagation()\" ng-class=\"{\'active\': header.businessSwitcherOpen}\"></i><div ng-click=\"header.businessSwitcherOpen = false;\" ng-class=\"{\'business-switcher__backdrop\': true, \'active\': header.businessSwitcherOpen}\"></div><div ng-class=\"{\'business-switcher__dropdown\': true, \'active\': header.businessSwitcherOpen}\"><div class=\"business-switcher__header\">{{\"ADMIN_BUSINESS\" | translate}}</div><div class=\"business-switcher__list\"><button type=\"button\" class=\"business-switcher__item\" ng-repeat=\"business in header.businesses\" ng-class=\"{\'active\': business.id == header.currentBusinessId}\" ng-click=\"header.switchBusiness(business)\"><span>{{business.name}}</span> <i ng-if=\"business.id == header.currentBusinessId\" class=\"las la-check\"></i></button></div></div></span></span></li></ol></div></div><div class=\"header-buttons\"><div ng-if=\"header.wa_status\" ng-class=\"{\'wa-status-block\': true, \'open\': header.openedWaNotifications}\"><div ng-class=\"{\'btn icon wa-icon\': true, \'green-bg\': header.wa_status == \'authorized\', \'red-bg\': header.wa_status != \'authorized\'}\" ng-click=\"header.openedWaNotifications = !header.openedWaNotifications\"><i class=\"la la-whatsapp\"></i> <span ng-if=\"header.notifications.wa_unread > 0 && !header.hide_wa_notifications\" class=\"wa-status__counter\">{{header.notifications.wa_unread}}</span></div><div class=\"wa-status__dropdown\"><div ng-if=\"!header.hide_wa_notifications\" class=\"wa-status__results\"><div ng-if=\"header.notifications.wa_unread == 0\" class=\"wa-status__empty\">{{\"NOTIFICATIONS_EMPTY\" | translate}}</div><div ng-repeat=\"item in header.notifications.wa_list\" class=\"wa-status__result\"><div class=\"wa-status__cell\" ng-click=\"header.clickNotification(item)\"><div class=\"wa-status__preview color-green\"><i class=\"la la-whatsapp\"></i></div></div><div class=\"wa-status__cell\" ng-click=\"header.clickNotification(item)\"><div class=\"wa-status__title\">{{item.title ? item.title+\' - \' : \'\'}}<span>{{item.date}}</span></div><div class=\"wa-status__text\"><div ng-if=\"item.text\">{{item.text}}</div><span ng-if=\"!item.text\">{{\"NOTIFICATIONS_WA_MESSAGE\" | translate}}</span></div></div><div class=\"wa-status__cell\"><button ng-click=\"event.stopPropagation(); header.removeNotification(item)\" class=\"btn icon circle\"><i class=\"las la-trash-alt\"></i></button></div></div></div><div class=\"wa-status__all\"><button ng-if=\"header.wa_status == \'authorized\' && !header.hide_wa_notifications\" class=\"btn text primary\" ng-click=\"header.goAllNotifications(\'wa\')\">{{\"NOTIFICATIONS_SHOW_ALL\" | translate}}</button> <button ng-class=\"{\'btn text\': true, \'error\': header.wa_status == \'authorized\', \'success\': header.wa_status != \'authorized\'}\" ng-click=\"header.getQrCode()\">{{header.wa_status == \'authorized\' ? \"WA_DISCONNECT\" : \"WA_CONNECT\" | translate}}</button> <button ng-if=\"header.wa_status == \'authorized\' && !header.hide_wa_notifications\" class=\"btn text border-red\" ng-click=\"header.removeAllNotifications(\'wa\')\">{{\"NOTIFICATIONS_REMOVE_ALL\" | translate}}</button></div></div><div ng-click=\"header.openedWaNotifications = false;\" class=\"wa-status__backdrop\"></div><span class=\"wa-status-test\" ng-if=\"header.wa_status == \'authorized\'\">{{\"WA_CONNECTED\" | translate}}</span> <span class=\"wa-status-test\" ng-if=\"header.wa_status != \'authorized\'\">{{\"WA_DISCONNECTED\" | translate}}</span></div><div ng-if=\"header.filters && header.filters.length\"><div><div ng-click=\"header.activeFilterModal = true;\" ng-class=\"{\'btn icon m-6\': true, \'active\': header.activeFilterModal}\"><i class=\"las la-filter\"></i></div><div ng-click=\"header.activeFilterModal = false;\" ng-class=\"{\'filters-list-backdrop\': true, \'active\': header.activeFilterModal}\"></div><div ng-class=\"{\'filters-list\': true, \'active\': header.activeFilterModal}\"><div class=\"filters-list-header\"><span>{{\"FILTERS_POPUP_TITLE\" | translate}}</span><div class=\"btn icon simple\" ng-click=\"header.activeFilterModal = false;\"><i class=\"las la-times\"></i></div></div><div class=\"filters-list-inner\"><div class=\"filters-list-item\" ng-repeat=\"filter in header.filters\"><div class=\"filters-list-item-inner\"><div class=\"filters-list-item-content\"><div class=\"filters-list-item-content-inner\"><div class=\"filters-list-item-content-type\"><button ng-if=\"filter.module == \'customers\'\" ng-click=\"header.goFilter(filter)\" class=\"btn icon bordered primary\"><i class=\"las la-users\"></i></button> <button ng-if=\"filter.module == \'leads\'\" ng-click=\"header.goFilter(filter)\" class=\"btn icon bordered primary\"><i class=\"las la-star\"></i></button> <button ng-if=\"filter.module == \'notes\' || filter.module == \'medical_notes\'\" ng-click=\"header.goFilter(filter)\" class=\"btn icon bordered primary\"><i class=\"las la-sticky-note\"></i></button></div><div class=\"filters-list-item-content-text\"><div ng-click=\"header.goFilter(filter)\">{{filter.name}}</div><button class=\"btn icon filters-list-item-content-remove\" ng-click=\"header.removeFilter(filter.id);\"><i class=\"las la-trash-alt\"></i></button></div></div></div></div></div></div></div></div></div><div ng-if=\"header.messages && header.messages.length\"><div><div ng-click=\"header.activeMessageModal = true;\" ng-class=\"{\'btn icon m-6\': true, \'red\': header.messages.length, \'active\': header.activeMessageModal}\"><i class=\"las la-bell\"></i></div><div class=\"b-messages-icon\"><span class=\"b-messages-count\"></span></div><div ng-click=\"header.activeMessageModal = false;\" ng-class=\"{\'b-messages-list-backdrop\': true, \'active\': header.activeMessageModal}\"></div><div ng-class=\"{\'b-messages-list\': true, \'active\': header.activeMessageModal}\"><div class=\"b-messages-list-header\"><span>{{\"MESSAGES_TITLE\" | translate}}</span><div class=\"btn icon simple\" ng-click=\"header.activeMessageModal = false;\"><i class=\"las la-times\"></i></div></div><div class=\"b-messages-list-inner\"><div class=\"b-messages-list-item\" ng-repeat=\"message in header.messages\"><div class=\"b-messages-list-item-inner\"><div class=\"b-messages-list-item-content\"><a href=\"javascript:void(0);\" class=\"b-messages-list-item-content-inner\"><div class=\"b-messages-list-item-content-type {{message.type}}\"><i ng-if=\"message.type == \'info\'\" class=\"las la-info-circle\"></i> <i ng-if=\"message.type == \'success\'\" class=\"las la-check-circle\"></i> <i ng-if=\"message.type == \'error\'\" class=\"las la-exclamation-circle\"></i></div><div class=\"b-messages-list-item-content-text\"><div ng-if=\"message.customer_id\" ui-sref=\"app.customers.single({id: {{message.customer_id}}})\">{{message.title ? message.title : \'Tiffulit\'}}</div><div ng-if=\"!message.customer_id\">{{message.title ? message.title : \'Tiffulit\'}}<span ng-if=\"message.date != \'\'\">- {{message.date}}</span></div><div><span ng-bind-html=\"message.message\"></span></div><button class=\"btn text simple\" ng-click=\"header.removeMessage(message.id);\">{{\"MESSAGES_DELETE\" | translate}}</button></div></a></div></div></div></div></div></div></div><div class=\"btn icon m-6\" ng-controller=\"FeedbackController\" ng-click=\"header.openFeedbackModal()\" ng-if=\"$user.role != 1\"><i class=\"las la-comment\"></i></div><div class=\"profile-element\" uib-dropdown=\"\"><div class=\"user-detail-top\"><img alt=\"image\" class=\"user-profile-picture\" ng-src=\"{{$user.profile | defaultProfilePicture}}\"> <a uib-dropdown-toggle=\"\" href=\"\" class=\"user-options-dropdown\"><span class=\"username-box\"><strong>{{$user.name}}</strong> <i class=\"las la-angle-down\"></i></span></a></div><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a ng-click=\"logout()\" class=\"logout-button\">{{\"NAV_LOGOUT\" | translate}}</a></li></ul></div></div><button ng-if=\"header.show\" class=\"btn btn-nostyle report-back-btn\"><i class=\"fa fa-angle-right fa-2x\"></i></button></div></div>");
$templateCache.put("app/components/items-filter/items-filter.html","<div class=\"items-filter-container\"><div class=\"items-filter-button\"><button type=\"button\" class=\"btn icon default\" ng-click=\"ctrl.toggleDropdown()\"><span ng-show=\"(ctrl.filter | notEmptyCountFilter) > 0\" class=\"filter-count\">{{ctrl.filter | notEmptyCountFilter}}</span> <i class=\"las la-filter\"></i></button><div class=\"items-filter-modal\" ng-if=\"ctrl.showDropdown\" ng-click=\"$event.stopPropagation()\"><div class=\"items-filter-fields\"><div class=\"form-group\"><app-dropdown model=\"ctrl.filter.category\" options=\"ctrl.categoryOptions\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_CATEGORY\' | translate}}\" placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\" search-placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\" value-prop=\"id\"></app-dropdown></div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter.item_type\" options=\"ctrl.itemTypeOptions\" multiple=\"true\" searchable=\"true\" label=\"{{\'SETTINGS_ITEM_TYPE\' | translate}}\" placeholder=\"{{\'SETTINGS_ITEM_TYPE\' | translate}}\" search-placeholder=\"{{\'SETTINGS_ITEM_TYPE\' | translate}}\" value-prop=\"id\"></app-dropdown></div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter.customer_allowed_booking\" options=\"ctrl.customerBookingOptions\" label=\"{{\'SETTINGS_ITEM_CUSTOMER_BOOKING\' | translate}}\" placeholder=\"{{\'SETTINGS_ITEM_CUSTOMER_BOOKING\' | translate}}\" value-prop=\"id\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"flex nowrap gap-16 between items-filter-actions\"><a ng-click=\"ctrl.clearFilter()\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a><div class=\"flex nowrap gap-16\"><a ng-click=\"ctrl.toggleDropdown()\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"ctrl.applyFilter()\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/components/list-filter/list-filter.html","<div class=\"list-filter-container\"><div class=\"list-filter-button\"><button type=\"button\" class=\"btn icon default\" ng-click=\"ctrl.toggleDropdown()\"><span ng-show=\"(ctrl.list | notEmptyCountFilter:\'period\') > 0\" class=\"filter-count\">{{ctrl.list | notEmptyCountFilter:\'period\'}}</span><i class=\"las la-filter\"></i></button><div class=\"list-filter-modal\" ng-if=\"ctrl.showDropdown\"><div><div ng-if=\"ctrl.module == \'notes\' || ctrl.module == \'medical_notes\'\"><div class=\"form-group\"><app-dropdown model=\"ctrl.list.resource\" options=\"ctrl.filter_values.resources\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_RESOURCE\' | translate}}\" placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\" search-placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\"></app-dropdown></div></div><div ng-if=\"ctrl.module == \'notes\' || ctrl.module == \'medical_notes\'\"><div class=\"form-group\"><app-dropdown model=\"ctrl.list.status\" options=\"ctrl.filter_values.statuses\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_STATUS\' | translate}}\" placeholder=\"{{\'FILTER_STATUS\' | translate}}\" search-placeholder=\"{{\'FILTER_STATUS\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\" ng-if=\"ctrl.module == \'notes\' || ctrl.module == \'medical_notes\'\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_REMINDER_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.list.reminder_from || ctrl.list.reminder_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.list.reminder_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_REMINDER_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.list.reminder_to || ctrl.fillistter.reminder_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.list.reminder_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"filter-action-buttons\" ng-if=\"ctrl.module == \'notes\' || ctrl.module == \'medical_notes\'\"><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.changePeriod(\'today\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.list.period == \'today\'}\">{{\"FILTER_SELECT_TODAY\" | translate}}</button> <button ng-click=\"ctrl.changePeriod(\'tomorrow\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.list.period == \'tomorrow\'}\">{{\"FILTER_SELECT_TOMORROW\" | translate}}</button> <button ng-click=\"ctrl.changePeriod(\'this_week\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.list.period == \'this_week\'}\">{{\"FILTER_SELECT_THIS_WEEK\" | translate}}</button> <button ng-click=\"ctrl.changePeriod(\'next_7_days\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.list.period == \'next_7_days\'}\">{{\"FILTER_SELECT_NEXT_7_DAYS\" | translate}}</button></div></div></div><div class=\"flex nowrap gap-16 between\"><a ng-click=\"ctrl.clearFilter()\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a><div class=\"flex nowrap gap-16\"><a ng-if=\"ctrl.store\" ng-click=\"ctrl.storeFilter()\" class=\"btn text large\">{{\"STORE_FILTER\" | translate}}</a> <a ng-if=\"!ctrl.store\" ng-click=\"ctrl.toggleDropdown()\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"ctrl.applyFilter()\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/components/list-filter/store-filter.html","<div class=\"modal-form-inner\" id=\"store-filter\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"STORE_FILTER_MODAL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"STORE_FILTER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\"></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.default\">{{\"STORE_FILTER_DEFAULT\" | translate}}</label></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/components/table-column-settings/table-column-settings.html","<div class=\"table-settings-container\" ng-class=\"{\'table-settings-inline\': ctrl.inline}\"><div class=\"dropdown-container\" ng-class=\"{ open: ctrl.showDropdown }\" click-outside=\"ctrl.closeDropdown()\"><button ng-if=\"!ctrl.isMobile\" type=\"button\" class=\"btn icon default\" ng-click=\"ctrl.toggleDropdown($event)\" tooltip2=\"{{ctrl.title || (\'TABLE_SETTINGS\' | translate)}}\"><i class=\"{{ctrl.iconClass || \'las la-cog\'}}\"></i></button> <button ng-if=\"ctrl.isMobile\" type=\"button\" class=\"btn icon default\" ng-click=\"ctrl.toggleDropdown($event)\"><i class=\"{{ctrl.iconClass || \'las la-cog\'}}\"></i></button><div class=\"dropdown\" ng-if=\"ctrl.showDropdown\" ng-style=\"ctrl.dropdownStyle\"><div class=\"dropdown-header\"><h4 ng-style=\"{\'color\': ctrl.headerColor || null}\">{{ctrl.headerTitle || (\'TABLE_COLUMNS_SETTINGS\' | translate)}}</h4><a class=\"close-btn\" ng-click=\"ctrl.closeDropdown()\">&times;</a></div><div class=\"dropdown-items\"><ul ui-sortable=\"ctrl.sortableOptions\" ng-model=\"ctrl.fieldsList\" class=\"sortable-list\"><li ng-repeat=\"field in ctrl.fieldsList\" ng-if=\"ctrl.shouldShowField(field)\" class=\"dropdown-item\"><div><i class=\"drag-handle las la-braille\"></i> <label ng-click=\"ctrl.toggleFieldDisplay(field); $event.stopPropagation();\"><span class=\"multicheck\" ng-class=\"{checked: field.display}\"></span> <span>{{ctrl.getFieldDisplayName(field)}}</span></label></div></li></ul></div></div></div></div>");
$templateCache.put("app/modules/admin/admin.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\" style=\"display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 12px;\"><button class=\"btn text primary large\" ui-sref=\"app.admin.new\">{{\"NEW_BUSINESS\" | translate}}</button> <button class=\"btn text border-orange large\" ui-sref=\"app.admin.copy\">{{\"ADMIN_ADD_BUSINESS_FROM_TEMPLATE\" | translate}}</button> <button class=\"btn text border-green large\" ui-sref=\"app.admin.message\">{{\"BUSINESS_MESSAGE\" | translate}}</button><div class=\"admin-search\"><label><input type=\"search\" class=\"form-control input-sm\" ng-model=\"ctrl.search\"></label></div><div class=\"form-switch form-group first last pull-end\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_cron()\" ng-model=\"ctrl.enabled_cron\">{{\"ADMIN_CHANGE_CRON\" | translate}}</label></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example\" dt-options=\"dtOptions\"><thead><tr><th>{{\"ADMIN_BUSINESS_STATUS\" | translate}}</th><th>{{\"ADMIN_BUSINESS_NAME\" | translate}}</th><th>{{\"ADMIN_CONTACT_PERSON\" | translate}}</th><th>{{\"ADMIN_BUSINESS_TYPE\" | translate}}</th><th>{{\"DEALER_TYPE\" | translate}}</th><th>{{\"ADMIN_BUSINESS_VAT\" | translate}}</th><th>{{\"ADMIN_CASHBOX\" | translate}}</th><th>{{\"ADMIN_CITY\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"business in ctrl.filtered_businessess()\" ui-sref=\"app.admin.single-business({id: {{business.id}}})\"><td>{{getStatusByIndex(business.status) | translate}}</td><td>{{business.name | emptyValue}}</td><td>{{business.agent | emptyValue}}</td><td>{{ctrl.variants[business.variant] | translate | emptyValue}}</td><td>{{business.dealer_type | emptyValue}}</td><td>{{business.vat | emptyValue}}</td><td>{{business.cashbox ? \"Y\" : \"N\" }}</td><td>{{business.city | emptyValue}}</td></tr></tbody></table></div></div></div></div><div class=\"settings-block\"><ul style=\"list-style-type: none;font-size: 16px;text-align: center; padding: 5px; background: #fff;\"><li><a ui-sref=\"app.admin.users\" id=\"users-list-link\"><h6 style=\"font-weight: 400; font-size: 16px\">{{\"SETTINGS_USERS\" | translate}}</h6><p>{{\"SETTINGS_USERS_MANAGE\" | translate}}</p></a></li></ul></div></div></div></div>");
$templateCache.put("app/modules/analytics/analytics.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} page-wrapper-main\" id=\"analytics\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"cloud mb-24 analytics-repeat-block\" ng-repeat=\"(graphID, graph) in ctrl.graphs\"><div class=\"window-header analytic\"><div class=\"block-title\" ng-class=\"graphID == \'income\' ? \'blue\' : graphID == \'orders\' ? \'green\' : \'blue\'\"><div class=\"btn icon small\"><i class=\"las la-chart-line\"></i></div><span>{{graph.title}}</span></div><div ng-if=\"graph.widgets\" class=\"chart-widgets-block\"><div class=\"chart-widget-block\" ng-repeat=\"(widgetID, widget) in graph.widgets\"><div class=\"flex gap-16\"><div class=\"widget-title\">{{widget.title | translate}}</div><div class=\"widget-data\">{{widget.data}}</div></div></div></div><div class=\"flex gap-16 nowrap-d\"><a ng-if=\"ctrl.isFilterDirty(graphID)\" ng-click=\"ctrl.clearFilter(graphID)\" class=\"btn icon default\"><i class=\"las la-trash-alt text-danger\"></i></a><div class=\"filter-button\"><button class=\"btn icon default\" ng-click=\"ctrl.openFilter(graphID)\"><span ng-show=\"(ctrl.filter[graphID] | notEmptyCountFilter) > 0\" class=\"filter-count\">{{ctrl.filter[graphID] | notEmptyCountFilter}}</span><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal filter-scrolled\': true, \'active\': ctrl.filterModal[graphID]}\" ng-click=\"event.stopPropagation();\"><div class=\"filter-modal-content\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].item\" options=\"ctrl.filter_values.items\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_ITEMS\' | translate}}\" placeholder=\"{{\'FILTER_ITEMS\' | translate}}\" search-placeholder=\"{{\'FILTER_ITEMS\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].category\" options=\"ctrl.filter_values.categories\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_CATEGORY\' | translate}}\" placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\" search-placeholder=\"{{\'FILTER_CATEGORY\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].resource\" options=\"ctrl.filter_values.resources\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_RESOURCE\' | translate}}\" placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\" search-placeholder=\"{{\'FILTER_RESOURCE\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].arrival_source\" options=\"ctrl.filter_values.arrival_sources\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_ARRIVAL_SOURCE\' | translate}}\" placeholder=\"{{\'FILTER_ARRIVAL_SOURCE\' | translate}}\" search-placeholder=\"{{\'FILTER_ARRIVAL_SOURCE\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].lastvisit_from || ctrl.filter[graphID].lastvisit_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].lastvisit_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_LASTVISIT_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].lastvisit_to || ctrl.filter[graphID].lastvisit_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].lastvisit_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].created_from || ctrl.filter[graphID].created_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].created_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_CREATED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter[graphID].created_to || ctrl.filter[graphID].created_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].created_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].birthday\" options=\"ctrl.birthdayOptions\" label-prop=\"value\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_BIRTHDAY\' | translate}}\" placeholder=\"{{\'FILTER_BIRTHDAY\' | translate}}\" search-placeholder=\"{{\'FILTER_BIRTHDAY\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.visited_from || ctrl.filter.visited_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].visited_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_NOT_VISITED_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.visited_to || ctrl.filter.visited_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter[graphID].visited_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div><div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.filter[graphID].have_card\">{{\"FILTER_HAVE_CARDS\" | translate}}</label></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].gender\" options=\"ctrl.genderOptions\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_GENDER\' | translate}}\" placeholder=\"{{\'FILTER_GENDER\' | translate}}\"></app-dropdown></div></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].status\" options=\"ctrl.filter_values.statuses\" multiple=\"true\" searchable=\"true\" label=\"{{\'FILTER_STATUS\' | translate}}\" placeholder=\"{{\'FILTER_STATUS\' | translate}}\" search-placeholder=\"{{\'FILTER_STATUS\' | translate}}\"></app-dropdown></div></div><div ng-if=\"graphID != \'campaignBar\'\" class=\"not-select\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].campaign\" options=\"ctrl.filter_values.campaigns\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_CAMPAIGN_NAME\' | translate}}\" placeholder=\"{{\'FILTER_CAMPAIGN_NAME\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].ad\" options=\"ctrl.filter_values.ads\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_AD_NAME\' | translate}}\" placeholder=\"{{\'FILTER_AD_NAME\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter[graphID].adset\" options=\"ctrl.filter_values.adsets\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'FILTER_ADSET_NAME\' | translate}}\" placeholder=\"{{\'FILTER_ADSET_NAME\' | translate}}\"></app-dropdown></div></div></div></div><div class=\"flex nowrap gap-16 filter-modal-footer\"><a ng-click=\"ctrl.closeFilter(graphID)\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a><a ng-click=\"ctrl.applyFilter(graphID)\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div><div ng-if=\"graph.customer_filter\" class=\"form-group last\"><app-dropdown class=\"small\" ng-if=\"graph.categoryOptions\" model=\"graph.category\" options=\"graph.categoryOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div><div ng-if=\"graph.customer_filter && graphID == \'income\'\" class=\"filter-button flex-none\"><button class=\"btn text gray\" ng-click=\"ctrl.openResourceFilter(graphID)\">{{\"CALENDAR_RESOURCES_SELECT\" | translate}}</button><div ng-class=\"{\'filter-modal filter-scrolled\': true, \'filter-modal-simple\': true, \'active\': ctrl.resourceFilterModal[graphID]}\" ng-click=\"event.stopPropagation();\" fix-modal-position=\"\"><div class=\"filter-modal-content\"><div class=\"form-group\"><app-dropdown ng-if=\"graph.resources\" model=\"graph.resource\" options=\"graph.resources\" value-prop=\"id\" searchable=\"true\" show-clear=\"true\" label=\"{{\'CALENDAR_RESOURCES_SALESPERSON\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_SALESPERSON\' | translate}}\" search-placeholder=\"{{\'CALENDAR_RESOURCES_SALESPERSON\' | translate}}\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div><div class=\"form-group\"><app-dropdown ng-if=\"graph.resources\" model=\"ctrl.graphs[graphID].resource_treated\" options=\"graph.resources\" value-prop=\"id\" searchable=\"true\" show-clear=\"true\" label=\"{{\'CALENDAR_RESOURCES_TREATED\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_TREATED\' | translate}}\" search-placeholder=\"{{\'CALENDAR_RESOURCES_TREATED\' | translate}}\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div><div class=\"form-group\"><app-dropdown ng-if=\"graph.resources\" model=\"ctrl.graphs[graphID].resource_booked\" options=\"graph.resources\" value-prop=\"id\" searchable=\"true\" show-clear=\"true\" label=\"{{\'CALENDAR_RESOURCES_BOOKED\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_BOOKED\' | translate}}\" search-placeholder=\"{{\'CALENDAR_RESOURCES_BOOKED\' | translate}}\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div><div class=\"form-group\"><app-dropdown ng-if=\"graph.resources\" model=\"ctrl.graphs[graphID].resource_responsible\" options=\"graph.resources\" value-prop=\"id\" searchable=\"true\" show-clear=\"true\" label=\"{{\'CALENDAR_RESOURCES_RESPONSIBLE\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_RESPONSIBLE\' | translate}}\" search-placeholder=\"{{\'CALENDAR_RESOURCES_RESPONSIBLE\' | translate}}\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div></div><div class=\"flex nowrap gap-16 filter-modal-footer\"><a ng-click=\"ctrl.closeResourceFilter(graphID)\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a></div></div></div><div ng-if=\"graph.customer_filter && graphID != \'income\'\" class=\"form-group last\"><app-dropdown class=\"small\" ng-if=\"graph.resources\" model=\"graph.resource\" options=\"graph.resources\" value-prop=\"id\" label-prop=\"name\" placeholder=\"{{\'CALENDAR_RESOURCES_SALESPERSON\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div><div ng-if=\"graphID == \'statsBar\' || graphID == \'statsPie\'\" class=\"graph-btn-row btn-group flex-end\"><button tooltip2=\'{{\"ANALYTIC_BY_LEADS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.graphs[graphID].stats_type = \'leads\'; ctrl.loadAnalytics(graphID)\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].stats_type == \'leads\', \'btn-default\': ctrl.graphs[graphID].stats_type != \'leads\'}\">{{\"ANALYTIC_BY_LEADS\" | translate}}</button> <button tooltip2=\'{{\"ANALYTIC_BY_STATUS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.graphs[graphID].stats_type = \'statuses\'; ctrl.loadAnalytics(graphID)\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].stats_type == \'statuses\', \'btn-default\': ctrl.graphs[graphID].stats_type != \'statuses\'}\">{{\"ANALYTIC_BY_STATUS\" | translate}}</button></div><div ng-if=\"graphID == \'campaignBar\'\" class=\"graph-btn-row btn-group flex-end\"><button tooltip2=\'{{\"CAMPAIGN_BAR_CAMPAIGNS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.graphs[graphID].campaign_type = \'campaigns\'; ctrl.loadAnalytics(graphID)\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].campaign_type == \'campaigns\', \'btn-default\': ctrl.graphs[graphID].campaign_type != \'campaigns\'}\">{{\"CAMPAIGN_BAR_CAMPAIGNS\" | translate}}</button> <button tooltip2=\'{{\"CAMPAIGN_BAR_ADSETS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.graphs[graphID].campaign_type = \'adsets\'; ctrl.loadAnalytics(graphID)\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].campaign_type == \'adsets\', \'btn-default\': ctrl.graphs[graphID].campaign_type != \'adsets\'}\">{{\"CAMPAIGN_BAR_ADSETS\" | translate}}</button> <button tooltip2=\'{{\"CAMPAIGN_BAR_ADS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.graphs[graphID].campaign_type = \'ads\'; ctrl.loadAnalytics(graphID)\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].campaign_type == \'ads\', \'btn-default\': ctrl.graphs[graphID].campaign_type != \'ads\'}\">{{\"CAMPAIGN_BAR_ADS\" | translate}}</button></div><div ng-if=\"graphID == \'campaignBar\'\" class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><app-dropdown class=\"small\" model=\"ctrl.graphs[graphID].campaign_metric\" options=\"ctrl.campaignMetricOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(graphID)\"></app-dropdown></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><app-dropdown class=\"small\" model=\"ctrl.graphs[graphID].campaign_filter\" options=\"ctrl.campaignFilterOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.onCampaignBarFilterChange()\"></app-dropdown></div></div><div class=\"flex gap-8\" ng-if=\"ctrl.graphs[graphID].campaign_filter == \'custom\'\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"campaign-bar-start-date\" required=\"\" ng-model=\"ctrl.graphs[graphID].start\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"campaign-bar-end-date\" required=\"\" ng-model=\"ctrl.graphs[graphID].end\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div><div ng-if=\"(graph.customer_filter || graphID == \'statsBar\') && graphID != \'campaignBar\'\" class=\"form-group last\"><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.loadAnalytics(graphID, \'daily\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].filter == \'daily\'}\">{{\"ANALYTIC_SELECT_1\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(graphID, \'weekly\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].filter == \'weekly\'}\">{{\"ANALYTIC_SELECT_2\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(graphID, \'monthly\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.graphs[graphID].filter == \'monthly\'}\">{{\"ANALYTIC_SELECT_3\" | translate}}</button></div></div><div ng-if=\"!graph.customer_filter && graphID != \'campaignBar\'\" class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"pie-start-date\" required=\"\" ng-model=\"graph.start\" view=\"date\" fix-datepicker-position=\"\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" class=\"form-control background-white\" id=\"pie-end-date\" required=\"\" ng-model=\"graph.end\" view=\"date\" fix-datepicker-position=\"\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div></div><div class=\"circle-loader\" ng-if=\"ctrl.graphLoading[graphID]\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-wrapper\" ng-if=\"!ctrl.graphLoading[graphID]\"><div class=\"chart-body\"><div class=\"chart-canvas\" ng-style=\"{\'height\': ((graph.height || ctrl.graphHeight) + \'px\')}\"><canvas chart-js=\"\" chart-data=\"graph.data\" chart-options=\"graph.options\" chart-type=\"graph.type\" chart-instance=\"ctrl.chartInstances[graphID]\"></canvas></div></div></div><div class=\"customers-list\" ng-if=\"ctrl.customersByGraph[graphID] && ctrl.customersByGraph[graphID].request && ctrl.customersDt[graphID] && ctrl.customersDt[graphID].options\"><div class=\"customers-list-header\"><h4>{{\"NAV_CUSTOMERS\" | translate}}</h4><button class=\"btn text border-red\" ng-click=\"ctrl.clearChartSelection(graphID)\">{{\"CLEAR_FILTER\" | translate}}</button></div><div class=\"customer-ibox-content\" ng-show=\"!ctrl.customersByGraph[graphID].loading\"><div class=\"table-holder customer-table-holder\"><table-column-settings ng-if=\"ctrl.fieldSettings && ctrl.fieldSettings.length > 0\" fields-list=\"ctrl.fieldSettings\" on-update=\"ctrl.onFieldsUpdate(fieldsList)\"></table-column-settings><div class=\"table-responsive\" ng-if=\"!ctrl.customersDt[graphID].refreshing\"><table id=\"analytics_cust_dt_{{graphID}}\" datatable=\"\" dt-options=\"ctrl.customersDt[graphID].options\" dt-columns=\"ctrl.customersDt[graphID].columns\" dt-instance=\"ctrl.customersDt[graphID].instance\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"></table><div id=\"analytics-custom-pagination-container-{{graphID}}\" class=\"custom-pagination-container\"><div class=\"dataTables_per-page\"><span>{{\"ENTRIES_PER_PAGE\" | translate}}</span><div class=\"per-page-options\"><label><input type=\"radio\" ng-model=\"ctrl.customersDt[graphID].entriesPerPage\" ng-change=\"ctrl.reinitCustomersDt(graphID)\" value=\"20\"><span>20</span></label> <label><input type=\"radio\" ng-model=\"ctrl.customersDt[graphID].entriesPerPage\" ng-change=\"ctrl.reinitCustomersDt(graphID)\" value=\"50\"><span>50</span></label> <label><input type=\"radio\" ng-model=\"ctrl.customersDt[graphID].entriesPerPage\" ng-change=\"ctrl.reinitCustomersDt(graphID)\" value=\"100\"><span>100</span></label></div></div></div></div></div></div><div class=\"sk-loading\" ng-if=\"ctrl.customersByGraph[graphID].loading\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/approval/approval.view.html","<div class=\"modal-form-inner modal-approval\"><div class=\"modal-head modal-head-online\"><div class=\"background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: contain;\"><div class=\"logo-container\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><h1 class=\"business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"business-address\">{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}</h2></div></div><div class=\"modal-head\"><h3 ng-if=\"!isPreview\" class=\"form-title no-padding-x\">{{\"NAV_APPROVAL\" | translate}} # {{orderItem.number}}</h3><h3 ng-if=\"isPreview\" class=\"form-title no-padding-x\">{{\"NAV_APPROVAL_PREVIEW\" | translate}}</h3><h2 class=\"form-title no-padding-x\">{{orderItem.order_date}}</h2></div><div ng-if=\"business.type*1 == 1\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"add-to-caledar-buttons\"><div class=\"atcb\" style=\"display:none;\">{ \"name\":\"{{ctrl.first_item.item_data.name}}\", \"description\":\"\", \"startDate\":\"{{ctrl.date}}\", \"endDate\":\"{{ctrl.date}}\", \"startTime\":\"{{ctrl.start}}\", \"endTime\":\"{{ctrl.end}}\", \"location\":\"{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}\", \"label\":\"{{\"EXPORT_TO_CALENDAR\" | translate}}\", \"options\":[ \"Apple\", \"Google\", \"Microsoft365\", \"Outlook.com\", \"Yahoo\" ], \"timeZone\":\"{{ctrl.tz}}\", \"timeZoneOffset\":\"{{ctrl.utcOffset}}\", \"trigger\":\"click\", \"iCalFileName\":\"Reminder-Event\" }</div></div><div class=\"arrive-buttons\" ng-if=\"!isPreview\"><a ng-if=\"!isApproved\" class=\"btn text large border-green\" ng-click=\"ctrl.submit()\">{{\"ARRIVE_APPROVAL\" | translate}} 😊</a> <a ng-if=\"business.not_arrive_option && orderItem.approval_sent != 3\" class=\"btn text large border-red\" ng-click=\"ctrl.submit(true)\">{{\"NOT_ARRIVE_APPROVAL\" | translate}}</a></div><div ng-if=\"business.approval_text && !isPreview\" class=\"approval-text\" ng-bind-html=\"business.approval_text\"></div><div class=\"online-buttons\"><a class=\"btn icon circle large bordered blue\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{(business.online_booking_data.phone != \'\' ? \'tel:\'+business.online_booking_data.phone : \'tel:\'+business.phone)}}\"><i class=\"las la-phone\"></i></a> <a class=\"btn icon circle large bordered green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{(business.online_booking_data.phone != \'\' ? \'https://wa.me/\'+ctrl.waPhone(business.online_booking_data.phone) : \'https://wa.me/\'+ctrl.waPhone(business.phone))}}\"><i class=\"lab la-whatsapp\"></i></a> <a class=\"btn icon circle large bordered waze\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://waze.com/ul?q={{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}\"><i class=\"lab la-waze\"></i></a> <a class=\"btn icon circle large bordered facebook\" nf-if=\"business.online_booking_data.facebook\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.facebook}}\"><i class=\"lab la-facebook-f\"></i></a> <a class=\"btn icon circle large bordered instagram\" nf-if=\"business.online_booking_data.instagram\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.instagram}}\"><i class=\"lab la-instagram\"></i></a> <a class=\"btn icon circle large bordered linkedin\" nf-if=\"business.online_booking_data.linkedin\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.linkedin}}\"><i class=\"lab la-linkedin-in\"></i></a> <a class=\"btn icon circle large bordered twitter\" nf-if=\"business.online_booking_data.twitter\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"{{business.online_booking_data.twitter}}\"><i class=\"lab la-twitter\"></i></a></div></div></div></div><form class=\"modal-form_f\" name=\"forgotPasswordForm\" novalidate=\"\" ng-if=\"business.type*1==2\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"col-md-12 order-wrapper\"><div class=\"row\"><div class=\"col-md-4 col-xs-6\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\">{{orderItem.name}}</div></div></div><div class=\"col-md-4\" ng-if=\"!isMobile\"><div class=\"form-group\"><label>&nbsp;</label><br></div></div><div class=\"col-md-4 col-xs-6\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_DATE\" | translate}}</label><div>{{ctrl.date}}</div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PHONE\" | translate}}</label><div>{{orderItem.phone}}</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_EMAIL\" | translate}}</label><div>{{orderItem.email}}</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>&nbsp;</label><div>&nbsp;</div></div></div></div><div class=\"order-item\" ng-repeat=\"($orderItemIndex, orderItem) in orderItem.items\"><div class=\"row\"><div class=\"col-md-4 col-xs-8 item-wrapper\"><label>{{\"CALENDAR_ORDER_SERVICE\" | translate}}</label><br>{{orderItem.item_data.name}}</div><div class=\"col-md-4 col-xs-4 resource-wrapper\"><label>{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</label><br>{{orderItem.resource_data.name}}</div><div class=\"col-md-4 col-xs-12 guest-name-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_NAME_GUEST\" | translate}}</label><div>&nbsp;</div></div></div><div class=\"col-md-4 col-xs-6 start-time-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ENTRY_DATE\" | translate}}</label><div>{{orderItem.start_time}}</div></div></div><div class=\"col-md-4 col-xs-6 duration-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_RELEASE_DATE\" | translate}}</label><div>{{orderItem.end_time}}</div></div></div><div class=\"col-md-4 col-xs-6 price-wrapper\"><label>{{\"CALENDAR_NIGHTS_NUMBER\" | translate}}</label><div>{{orderItem.nights}} לילות</div></div><div class=\"col-md-4 col-xs-6 price-wrapper\"><label>{{\"CALENDAR_ORDER_PRICE\" | translate}}</label><div>{{orderItem.order_price}}</div></div><div class=\"col-md-12 col-xs-12 notes-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_REMARKS\" | translate}}</label><div>{{orderItem.notes}}</div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4 number-wrapper adults-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ADULTS\" | translate}}</label><div>{{orderItem.adults}}</div></div></div><div class=\"col-md-4 col-xs-4 number-wrapper kids-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_CHILDREN\" | translate}}</label><div>{{orderItem.kids}}</div></div></div><div class=\"col-md-4 col-xs-4 number-wrapper babies-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_BABIES\" | translate}}</label><div>{{orderItem.babies}}</div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"item-summary\" ng-if=\"orderItem.nights > 0\"><b>סה\"כ: {{orderItem.item_data.price * orderItem.nights | price}}</b></div></div></div></div><div class=\"form-group\" style=\"margin-top: 20px;\"><label>&nbsp; {{\"APPROVAL_NOTE\" | translate}}</label><div>{{orderItem.note_order_approval}}</div></div><div class=\"form-group\" style=\"margin-top: 20px;\"><label>&nbsp; {{\"CALENDAR_ORDER_SECURITY\" | translate}}</label><div></div></div></div><div class=\"order-summary\"><div class=\"inner\"><div class=\"price-line\" ng-if=\"orderItem.business_data.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_BEFORE\" | translate}}</span> <span class=\"price\">{{subtotal | price}}</span></div><div class=\"price-line\" ng-if=\"orderItem.business_data.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_VAT\" | translate}} (%{{ctrl.dealer_vat}})</span> <span class=\"price\">{{tax | price}}</span></div><div class=\"price-line\"><span class=\"title\">{{\"CALENDAR_ORDER_TOTAL\" | translate}}</span> <span class=\"price\">{{total | price}}</span></div></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-if=\"orderItem.approved_date == null && !isPreview\" ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn btn-w-m btn-primary\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button ng-if=\"isPreview\" class=\"btn btn-w-m btn-primary\" ng-click=\"ctrl.close()\">{{\"SETTINGS_LOG_CLOSED\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/approvalrequest/approvalrequest.view.html","<div id=\"customers-form\" class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!ctrl.is_edit\">{{\"APPROVAL_SEND_METHOD_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"orderForm\" ng-submit=\"ctrl.send_order_form()\" novalidate=\"\"><div ng-if=\"!ctrl.confirm_delete\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"settings_label\">{{\"APPROVAL_SEND_METHOD\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"1\"> <label>{{\"SETTINGS_USER_MAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"$close();\" class=\"btn btn-w-m btn-white\">{{\"CALENDAR_ORDER_RETURN\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.viewRequest();\" class=\"btn btn-w-m btn-white\">{{\"CALENDAR_ORDER_VIEW_APPROVE\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send();\" class=\"btn btn-w-m btn-primary\">{{\"CALENDAR_ORDER_SEND_APPROVE\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/calendar/calendar-sync.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GOOGLE_CALENDAR_SYNC\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.cancel()\">&times;</a></div><div class=\"modal-body\"><div class=\"form-group\" ng-if=\"!ctrl.googleInitialized\"><div class=\"alert alert-info\"><i class=\"fa fa-info-circle\"></i> {{\"GOOGLE_CALENDAR_INIT_REQUIRED\" | translate}}</div><button type=\"button\" ng-click=\"ctrl.initGoogleCalendar()\" class=\"btn text primary large\" ng-disabled=\"ctrl.syncLoading\"><span ng-if=\"ctrl.syncLoading\">{{\"INITIALIZING\" | translate}}...</span> <span ng-if=\"!ctrl.syncLoading\">{{\"INITIALIZE_GOOGLE_CALENDAR\" | translate}}</span></button></div><div ng-if=\"ctrl.googleInitialized\"><div class=\"form-group\"><label>{{\"SELECT_DATE\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.selectedDate\" class=\"form-control\"></div><div class=\"form-group\"><app-dropdown model=\"ctrl.selectedResource\" options=\"ctrl.syncResources\" label-prop=\"sync_label\" label=\"{{\'SELECT_RESOURCE\' | translate}}\" placeholder=\"{{\'SELECT_RESOURCE_PLACEHOLDER\' | translate}}\" searchable=\"true\" fixed-panel=\"true\"></app-dropdown></div><div class=\"form-group\"><button type=\"button\" ng-click=\"ctrl.syncCalendar()\" class=\"btn text primary large\" ng-disabled=\"ctrl.syncLoading || !ctrl.selectedResource\"><span ng-if=\"ctrl.syncLoading\">{{\"SYNCING\" | translate}}...</span> <span ng-if=\"!ctrl.syncLoading\">{{\"SYNC_SELECTED_RESOURCE\" | translate}}</span></button> <button type=\"button\" ng-click=\"ctrl.syncAllCalendars()\" class=\"btn text border-primary large\" ng-disabled=\"ctrl.syncLoading\"><span ng-if=\"ctrl.syncLoading\">{{\"SYNCING_ALL\" | translate}}...</span> <span ng-if=\"!ctrl.syncLoading\">{{\"SYNC_ALL_RESOURCES\" | translate}}</span></button></div><div class=\"form-group\" ng-if=\"ctrl.syncResults.length > 0\"><h4>{{\"SYNC_RESULTS\" | translate}}</h4><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>{{\"RESOURCE\" | translate}}</th><th>{{\"DATE\" | translate}}</th><th>{{\"CREATED\" | translate}}</th><th>{{\"UPDATED\" | translate}}</th><th>{{\"DELETED\" | translate}}</th><th>{{\"ERRORS\" | translate}}</th><th>{{\"TIMESTAMP\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"result in ctrl.syncResults\"><td>{{result.resource}}</td><td>{{result.date}}</td><td><span class=\"badge badge-success\" ng-if=\"result.result.created > 0\">{{result.result.created}}</span> <span ng-if=\"result.result.created == 0\">0</span></td><td><span class=\"badge badge-info\" ng-if=\"result.result.updated > 0\">{{result.result.updated}}</span> <span ng-if=\"result.result.updated == 0\">0</span></td><td><span class=\"badge badge-warning\" ng-if=\"result.result.deleted > 0\">{{result.result.deleted}}</span> <span ng-if=\"result.result.deleted == 0\">0</span></td><td><span class=\"badge badge-danger\" ng-if=\"result.result.errors && result.result.errors.length > 0\">{{result.result.errors.length}}</span> <span ng-if=\"!result.result.errors || result.result.errors.length == 0\">0</span></td><td>{{result.timestamp}}</td></tr></tbody></table></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.cancel()\" class=\"btn text border-primary large\">{{\"CLOSE\" | translate}}</button></div></div>");
$templateCache.put("app/modules/calendar/calendar.print-modal.html","<div class=\"modal-form-inner calendar-print-modal-inner\"><div id=\"print-form\"><div class=\"calendar-print-modal-body\"></div></div></div>");
$templateCache.put("app/modules/calendar/calendar.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"calendar\" ng-if=\"isUserAllowedAccess(\'calendar\')\" ng-class=\"{\'loading\': ctrl.settings.loading || ctrl.settings.loadingHolidays, \'motels-calendar\': ctrl.settings.bu_type == 2}\"><div class=\"calendar-options desktop\"><div class=\"calendar-options-column\"><div class=\"datepicker-column datepicker-column-wrap\"><div class=\"date-picker date-picker--width-auto\"><div class=\"input-group date-picker--input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerPrev();\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div style=\"width:100px;\"></div><div class=\"inputs-wrapper\"><input style=\"width: 100%\" type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"date\" min-view=\"date\" ng-if=\"ctrl.settings.datePickerView == \'date\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\" ng-click=\"ctrl.datePickerClicked()\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"month\" min-view=\"month\" ng-if=\"ctrl.settings.datePickerView == \'month\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\" ng-click=\"ctrl.datePickerClicked()\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerNext();\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div><button type=\"button\" ng-click=\"ctrl.gotoToday();\" class=\"btn text\">{{\"CALENDAR_TODAY\" | translate}}</button></div><div class=\"datepicker-column\"><div class=\"calendar-resources\" ng-if=\"ctrl.settings.bu_type == 1\"><app-dropdown model=\"ctrl.settings.resource\" options=\"resources\" multiple=\"true\" searchable=\"true\" visible-tags-count=\"1\" placeholder=\"{{\'CALENDAR_RESOURCES\' | translate}}\" search-placeholder=\"{{\'CALENDAR_RESOURCES\' | translate}}\"></app-dropdown></div><div class=\"btn-group\" ng-if=\"ctrl.showCapacityButton\"><button class=\"btn\" title=\"Header\" data-toggle=\"popover\" data-placement=\"right\" data-content=\"Content\" ng-click=\"ctrl.change_calendar_type(\'orders\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'orders\', \'btn-default\': ctrl.settings.type != \'orders\'}\">{{\"CALENDAR_INVITATIONS\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_type(\'capacity\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'capacity\', \'btn-default\': ctrl.settings.type != \'capacity\'}\">{{\"CALENDAR_TONNAGE\" | translate}}</button></div><div class=\"btn-group\"><button class=\"btn\" ng-if=\"ctrl.settings.bu_type == 1\" ng-click=\"ctrl.change_calendar_time(\'daily\');\" ng-disabled=\"ctrl.settings.type == \'capacity\'\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'daily\', \'btn-default\': ctrl.settings.time != \'daily\'}\">{{\"CALENDAR_DAILY\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_time(\'weekly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-disabled=\"ctrl.settings.type == \'capacity\' && ctrl.settings.type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'weekly\', \'btn-default\': ctrl.settings.time != \'weekly\'}\">{{\"CALENDAR_WEEKLY\" | translate}}</button> <button class=\"btn hidden-xs\" ng-click=\"ctrl.change_calendar_time(\'monthly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'monthly\', \'btn-default\': ctrl.settings.time != \'monthly\'}\">{{\"CALENDAR_MONTHLY\" | translate}}</button></div></div><div ng-if=\"ctrl.settings.type == \'orders\'\" class=\"calendar-search-actions\"><button type=\"button\" class=\"btn icon bordered\" ng-if=\"ctrl.canPrintCalendar()\" ng-click=\"ctrl.printCalendar()\" tooltip2=\"{{\'CUSTOMERS_PRINT\' | translate}}\"><i class=\"las la-print\"></i></button><div ng-switch=\"ctrl.isSearching\"><div ng-switch-when=\"true\" class=\"input-group date-picker--input-group find-event\"><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'prev\')\" ng-click=\"ctrl.findEvent(\'prev\');\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div class=\"find-event-input-container\"><input type=\"text\" ng-model=\"ctrl.findSettings.search\" class=\"form-control find-event-input\" placeholder=\"{{\'CALENDAR_FIND_EVENTS_PLACEHOLDER\' | translate}}\"><div class=\"find-event-input-icon\" ng-if=\"!ctrl.findSettings.loading && ctrl.findSettings.search != \'\'\" ng-click=\"ctrl.resetFindSettings()\"><i class=\"las la-times\"></i></div><div class=\"find-event-input-icon\" ng-if=\"ctrl.findSettings.loading\"><i class=\"las la-spinner la-spin\"></i></div></div><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'next\')\" ng-click=\"ctrl.findEvent(\'next\');\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div><div ng-switch-when=\"false\" class=\"search-button\" ng-click=\"ctrl.activateSearch()\"><i class=\"las la-search\"></i></div></div></div></div></div><div><a class=\"btn text\" ui-sref=\"app.customers_bookings\" ng-class=\"{\'exist-bookings\': ctrl.settings.exist_bookings}\"><span class=\"btn-number\" ng-if=\"ctrl.settings.exist_bookings\">{{ctrl.settings.exist_bookings}}</span> {{\"CALENDAR_ORDERS_PENDING\" | translate}} <i class=\"las la-angle-left rotatable\"></i></a></div></div><div class=\"calendar-options mobile\"><div class=\"datepicker-column\"><div class=\"date-picker\"><div class=\"input-group date-picker--input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerPrev();\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div style=\"width:100px;\"></div><div class=\"inputs-wrapper\"><input style=\"width: 100%\" type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"date\" min-view=\"date\" ng-if=\"ctrl.settings.datePickerView == \'date\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <input style=\"width: 100%\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.settings.date\" auto-close=\"true\" view=\"month\" min-view=\"month\" ng-if=\"ctrl.settings.datePickerView == \'month\'\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerNext();\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div></div><div ng-if=\"!ctrl.isExpanded\"><a class=\"btn text\" ui-sref=\"app.customers_bookings\" ng-class=\"{\'exist-bookings\': ctrl.settings.exist_bookings}\"><span class=\"btn-number\" ng-if=\"ctrl.settings.exist_bookings\">{{ctrl.settings.exist_bookings}}</span> {{\"CALENDAR_ORDERS_PENDING_MOBILE\" | translate}} <i class=\"las la-angle-left rotatable\"></i></a></div></div><div class=\"cal-types\"></div><div ng-if=\"!ctrl.isExpanded\" ng-class=\"{\'cal-types-wrapper\': true, \'wrapped\': ctrl.isSearching}\"><div class=\"cal-types\"><div class=\"calendar-resources\" ng-if=\"ctrl.settings.bu_type == 1\"><app-dropdown model=\"ctrl.settings.resource\" options=\"resources\" multiple=\"true\" searchable=\"true\" visible-tags-count=\"1\" placeholder=\"{{\'CALENDAR_RESOURCES\' | translate}}\" search-placeholder=\"{{\'CALENDAR_RESOURCES\' | translate}}\"></app-dropdown></div><button type=\"button\" ng-click=\"ctrl.gotoToday();\" class=\"btn text\">{{\"CALENDAR_TODAY\" | translate}}</button><div class=\"btn-group\" ng-if=\"ctrl.showCapacityButton\"><button class=\"btn\" title=\"Header\" data-toggle=\"popover\" data-placement=\"right\" data-content=\"Content\" ng-click=\"ctrl.change_calendar_type(\'orders\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'orders\', \'btn-default\': ctrl.settings.type != \'orders\'}\">{{\"CALENDAR_INVITATIONS\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_type(\'capacity\');\" ng-class=\"{\'btn-primary\': ctrl.settings.type == \'capacity\', \'btn-default\': ctrl.settings.type != \'capacity\'}\">{{\"CALENDAR_TONNAGE\" | translate}}</button></div><div class=\"btn-group\"><button class=\"btn\" ng-if=\"ctrl.settings.bu_type == 1\" ng-click=\"ctrl.change_calendar_time(\'daily\');\" ng-disabled=\"ctrl.settings.type == \'capacity\'\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'daily\', \'btn-default\': ctrl.settings.time != \'daily\'}\">{{\"CALENDAR_DAILY\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_time(\'weekly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-disabled=\"ctrl.settings.type == \'capacity\' && ctrl.settings.type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'weekly\', \'btn-default\': ctrl.settings.time != \'weekly\'}\">{{\"CALENDAR_WEEKLY\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_calendar_time(\'monthly\');\" ng-if=\"ctrl.settings.bu_type == 1\" ng-class=\"{\'btn-primary\': ctrl.settings.time == \'monthly\', \'btn-default\': ctrl.settings.time != \'monthly\'}\">{{\"CALENDAR_MONTHLY\" | translate}}</button></div></div><div ng-if=\"ctrl.settings.type == \'orders\'\" ng-switch=\"ctrl.isSearching\" class=\"cal-search\"><div ng-switch-when=\"true\" class=\"input-group date-picker--input-group find-event\"><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'prev\')\" ng-click=\"ctrl.findEvent(\'prev\');\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div class=\"find-event-input-container\"><input type=\"text\" ng-model=\"ctrl.findSettings.search\" class=\"form-control find-event-input\" placeholder=\"{{\'CALENDAR_FIND_EVENTS_PLACEHOLDER\' | translate}}\"><div class=\"find-event-input-icon\" ng-if=\"!ctrl.findSettings.loading && ctrl.findSettings.search != \'\'\" ng-click=\"ctrl.resetFindSettings()\"><i class=\"las la-times\"></i></div><div class=\"find-event-input-icon\" ng-if=\"ctrl.findSettings.loading\"><i class=\"las la-spinner la-spin\"></i></div></div><span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"ctrl.isButtonDisabled(\'next\')\" ng-click=\"ctrl.findEvent(\'next\');\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div><div ng-switch-when=\"false\" class=\"search-button\" ng-click=\"ctrl.activateSearch()\"><i class=\"las la-search\"></i></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"calendar-wrapper height-100\" ng-class=\"{\'calendar-capacity\': ctrl.settings.type == \'capacity\',\'calendar-non-capacity\': ctrl.settings.type != \'capacity\'}\"><div id=\"mainCalendar\" ng-if=\"calendarConfig\" ui-calendar=\"calendarConfig\" ng-model=\"events\" calendar=\"mainCalendar\" class=\"calendar height-100\"></div><div class=\"cursor-circle\"></div><div class=\"calendar-expand-button\" ng-click=\"ctrl.expandCalendar()\"><i ng-if=\"!ctrl.isExpanded\" class=\"las la-expand\"></i> <i ng-if=\"ctrl.isExpanded\" class=\"las la-compress\"></i></div></div></div></div></div>");
$templateCache.put("app/modules/calendar_event/calendar_event.view.html","<div class=\"create-event-container\" ng-if=\"ctrl.order\"><div class=\"business-head\"><img ng-if=\"ctrl.order.business.image\" src=\"{{ctrl.order.business.image}}\"><div><div class=\"business-head-name\">{{ctrl.order.business.name}}</div><div class=\"business-head-address\">{{ctrl.order.business.address}}</div></div></div><div class=\"calendar-event-title\">{{ctrl.first_item.item_data.name}}</div><div class=\"calendar-event-time\">{{ctrl.date}}</div><div class=\"calendar-event-time\">{{ctrl.start}} - {{ctrl.end}}</div><div class=\"atcb\" style=\"display:none;\">{ \"name\":\"{{ctrl.first_item.item_data.name}}\", \"description\":\"\", \"startDate\":\"{{ctrl.date}}\", \"endDate\":\"{{ctrl.date}}\", \"startTime\":\"{{ctrl.start}}\", \"endTime\":\"{{ctrl.end}}\", \"location\":\"{{ctrl.order.business.address}}\", \"label\":\"{{\"EXPORT_TO_CALENDAR\" | translate}}\", \"options\":[ \"Apple\", \"Google\", \"iCal\", \"Microsoft365\", \"Outlook.com\", \"Yahoo\" ], \"timeZone\":\"{{ctrl.tz}}\", \"timeZoneOffset\":\"{{ctrl.utcOffset}}\", \"trigger\":\"click\", \"iCalFileName\":\"Reminder-Event\" }</div></div>");
$templateCache.put("app/modules/cashbox/cashbox.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"cashbox\" ng-if=\"isUserAllowedAccess(\'cashbox\')\"><div class=\"main-title ng-binding\"><div class=\"flex fill gap-24 gap-24-m-8\" ng-if=\"!ctrl.isCreditTransaction && !ctrl.form.retainer_id\"><button class=\"btn text primary large hidden-sm visible-xs\" ng-click=\"ctrl.openSelectItem()\"><i class=\"las la-plus\"></i> {{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}</button> <button class=\"btn text primary large hidden-sm visible-xs\" ng-click=\"ctrl.openSelectCustomer()\"><i class=\"las la-plus\"></i> {{\"CALENDAR_CASH_SELECT_C\" | translate}}</button></div></div><div class=\"cashbox-row\"><div class=\"col-md-12 col-lg-7 cashbox-items-box\" ng-if=\"!isMobile\"><div id=\"cashbox-top-options\"><div class=\"flex between\"><div id=\"cashbox-top-options-title\"><strong class=\"main-title\">מוצרים</strong></div><div class=\"form-group last icon-prepend\"><i class=\"las la-search\"></i> <input id=\"calendarCashSearch\" type=\"text\" ng-model=\"ctrl.searchItem\" class=\"form-control\" placeholder=\'{{\"CALENDAR_CASH_SEARCH\" | translate}}\' ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction\"></div></div></div><div id=\"catalog\" ng-class=\"{\'disabled\': ctrl.isDebtTransaction || ctrl.isCreditTransaction}\"><ul id=\"categories\"><li ng-class=\"{\'active\': ctrl.categoryFilter == -1}\"><a ng-click=\"ctrl.filterCategory(-1)\">{{\"CALENDAR_CASH_ALL_PROD\" | translate}}</a></li><li ng-class=\"{\'active\': ctrl.categoryFilter == category.id}\" ng-repeat=\"(index, category) in ctrl.categories\"><a ng-click=\"ctrl.filterCategory(category.id)\">{{category.name}}</a></li></ul><div id=\"items\"><div class=\"row\"><div class=\"col-md-12 products\"><div class=\"row\" style=\"display: flex; flex-wrap: wrap;\"><div class=\"product col-lg-4 col-md-3 col-sm-4 col-xs-12\" ng-repeat=\"(index, product) in ctrl.products\"><a ng-click=\"ctrl.addItem(product)\"><div ng-if=\"product.item_image\" class=\"item-pic-wrapper cashbox\"><img src=\"{{product.item_image}}\" alt=\"Image\" class=\"item-pic\"></div>{{product.name}} <small class=\"price\" ng-if=\"!ctrl.hide_prices\">({{product.price | price}})</small></a></div><div class=\"not-found\" ng-if=\"!ctrl.products.length\"><h5 class=\"title\">{{\"CALENDAR_CASH_NO_ITEMS\" | translate}}</h5><p class=\"desc\">{{\"CALENDAR_CASH_NO_ITEMS_SENTENCE\" | translate}}</p></div></div></div></div></div></div></div><div class=\"col-md-12 col-lg-5 no-padding\"><div id=\"summary\" class=\"ibox-content\" ng-class=\"{\'sk-loading\': ctrl.cashboxLoading}\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"row\"><div class=\"form-group last col-md-12 customer-select-wrapper\"><div ng-if=\"!ctrl.isCreditTransaction\" class=\"flex gap-16 cashbox-options\"><div ng-if=\"!ctrl.isOrderTransaction\" class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-disabled=\"ctrl.form.retainer_id\" ng-model=\"ctrl.occ_customer\" value=\"1\" ng-change=\"ctrl.remove_customer();\">{{\"CALENDAR_ORDER_OCC\" | translate}}</label></div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.show_discount\" value=\"1\">{{\"SHOW_CASHBOX_DISCOUNT\" | translate}}</label></div><div ng-if=\"!ctrl.isOrderTransaction && !ctrl.isQuotationTransaction\" class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-disabled=\"ctrl.form.retainer_id\" ng-model=\"ctrl.form.quotation\" value=\"1\">{{\"CASHBOX_QUOTATION\" | translate}}</label></div></div><div ng-if=\"!ctrl.occ_customer && !ctrl.form.customer && !isMobile\" class=\"customer-select\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id\" ng-model=\"ctrl.customer_search_name\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div><div ng-if=\"ctrl.occ_customer\" class=\"occ_customer flex form v-start fill\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id\" ng-model=\"ctrl.form.customer_occ_name\" ng-class=\"{\'red\': !ctrl.form.customer_occ_name, \'form-control\': true}\"></div><div class=\"form-group\"><label>{{\"CUSTOMERS_PHONE\" | translate}}</label> <input type=\"text\" autocomplete=\"off\" ng-disabled=\"ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id\" ng-model=\"ctrl.form.customer_occ_phone\" ng-class=\"{\'red\': !ctrl.form.customer_occ_phone, \'form-control\': true}\"></div></div></div></div><div class=\"flex\" ng-if=\"(ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_name))\"><div class=\"cashbox-customer-container\"><table class=\"cashbox-customer-details\"><thead><tr><td>{{\"CUSTOMER_FULL_NAME\" | translate}}</td><td>{{\"CUSTOMERS_PHONE\" | translate}}</td></tr></thead><tbody><tr ng-if=\"!ctrl.occ_customer && (ctrl.form.customer || ctrl.form.name)\"><td><div class=\"customer-pic-wrapper\" ng-if=\"ctrl.customerData.avatar\"><img ng-src=\"{{ctrl.customerData.avatar}}\" alt=\"User Profile\" class=\"customer-pic\"></div><b class=\"cashbox-full-name\">{{ctrl.form.name}}</b> <i ng-if=\"ctrl.customerData.oncredit > 0\" class=\"las la-dollar-sign\" aria-hidden=\"true\"></i></td><td><b>{{ctrl.form.phone}}</b></td></tr><tr ng-if=\"ctrl.occ_customer\"><td><b class=\"cashbox-full-name\">{{ctrl.form.customer_occ_name}}</b></td><td><b>{{ctrl.form.customer_occ_phone}}</b></td></tr></tbody></table></div><div class=\"cashbox-customer-remove\"><button type=\"button\" class=\"btn icon simple red\" ng-click=\"ctrl.remove_customer();\" ng-if=\"ctrl.form.customer && !(ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id)\"><i class=\"las la-times\"></i></button> <button type=\"button\" class=\"btn icon simple red\" ng-click=\"ctrl.remove_customer();\" ng-if=\"ctrl.form.customer_occ_name && !(ctrl.isDebtTransaction || ctrl.isCreditTransaction || ctrl.isOrderTransaction || ctrl.form.retainer_id)\"><i class=\"las la-times\"></i></button></div></div><div class=\"cashbox-allocation-warning\" ng-if=\"ctrl.customerMissingVatForAllocation()\"><i class=\"las la-exclamation-circle\"></i> {{\"CASHBOX_ALLOCATION_CUSTOMER_VAT_REQUIRED\" | translate}}</div><div class=\"empty flex\" ng-if=\"ctrl.items.length == 0\"><div><i class=\"las la-shopping-bag\"></i></div><div><h4 class=\"title\">{{\"CALENDAR_CASH_EMPTY\" | translate}}</h4><p class=\"text\">{{\"CALENDAR_CASH_EMPTY_SENTENCE\" | translate}}</p></div></div><div class=\"items\" ng-if=\"ctrl.items.length > 0\"><div class=\"item\" ng-class=\"{\'have-discount\': ctrl.show_discount}\" ng-repeat=\"(index, item) in ctrl.items track by $index\"><div class=\"item-col-qty\"><div class=\"item-inputs form-group last\"><label><i ng-if=\"item.isGiftCard\" class=\"las la-gift\"></i> {{item.name || (item.item_type == \'gift_card\' ? (\"GIFT_CARD\" | translate) : \'&nbsp;\')}}</label><input-number-spinner ng-if=\"item.item_type != \'gift_card\'\" data-ng-disabled=\"ctrl.isDebtTransaction || item.quantityDisabled || ctrl.items[index].item_type == \'card\'\" data-ng-model=\"ctrl.items[index].quantity\" data-input-number-spinner-min=\"1\"></input-number-spinner><div ng-if=\"item.item_type == \'gift_card\'\" class=\"cachbox-gc-number\"><i class=\"las la-gift customers-has-chards\"></i> <span>{{item.number}}</span></div></div></div><div class=\"item-col-employee\" ng-if=\"ctrl.businessInfo.data.manage_employee && item.item_type != \'prepaid\' && item.item_type != \'gift_card\'\"><div class=\"form-group last\"><app-dropdown model=\"ctrl.items[index].resource\" options=\"ctrl.salesResources\" value-prop=\"id\" required=\"true\" label=\"{{\'CALENDAR_ORDER_RESOURCE\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_RESOURCE\' | translate}}\"></app-dropdown></div></div><div class=\"item-col-card card-item-match\" ng-if=\"ctrl.hasCustomerCardForItem(item.id) && !item.isCard && !ctrl.continuous_deal\"><span>{{ ctrl.items[index].card_balance_used || \'0\' }}/{{ ctrl.getCustomerCardForItem(item.id)[\'balance\'] }} <i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': ctrl.hasCustomerCardForItem(item.id) === \'expired\'}\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-click=\"ctrl.useCardPopup(item)\"></i></span></div><div class=\"item-col-price price-spinner-data relative\" ng-hide=\"ctrl.hide_prices\"><div class=\"flex nowrap gap-8\"><div class=\"form-group last\" ng-if=\"item.item_type == \'gift_card\'\"><label>{{\"GIFT_CARD_BALANCE\" | translate}}</label><div class=\"original-price\">{{item.balance | price}}</div></div><div class=\"form-group last\" ng-if=\"ctrl.show_discount\"><label>{{\"CASHBOX_ORIGINAL_PRICE_LABEL\" | translate}}</label><div class=\"original-price\">{{item.original_price | price}}</div></div><div class=\"form-group last\" ng-if=\"ctrl.show_discount\"><label>{{\"CASHBOX_DISCOUNT_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"discount-input-{{$index}}\" class=\"form-control discount-input\" ng-model=\"item.discount\" ng-change=\"ctrl.changePercentage({{$index}})\"></div><div class=\"form-group last\"><label>{{\"CASHBOX_NET_PRICE_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"price-input-{{$index}}\" class=\"form-control price-input\" ng-model=\"item.price\" ng-change=\"ctrl.changePrice({{$index}})\"></div><div tooltip=\'{{\"MAKE_CARD_TOOLTIP\" | translate}}\' ng-if=\"item.item_type == \'service\' && ctrl.form.customer && (!item.card_balance_used || item.card_balance_used == 0) && !ctrl.checkAlreadyExistCard(index)\" class=\"have-tooltip make-cards{{item.isCard ? \' active\' : \'\'}}\" ng-click=\"ctrl.makeCard(index)\"><i class=\"las la-plus\"></i><i class=\"las la-ticket-alt customers-has-chards\" aria-hidden=\"true\"></i></div><div tooltip=\'{{\"GIFT_CARD_TOOLTIP\" | translate}}\' ng-if=\"item.item_type == \'service\'\" class=\"have-tooltip make-cards\" ng-click=\"ctrl.openGiftCardDetails(index)\"><i ng-if=\"!item.isGiftCard\" class=\"las la-plus\"></i><i ng-if=\"item.isGiftCard\" class=\"las la-cog\"></i><i class=\"las la-gift customers-has-chards\" aria-hidden=\"true\"></i></div></div></div><div class=\"td-middle\"><button type=\"button\" class=\"btn icon simple red\" ng-click=\"ctrl.removeItem(index)\" ng-disabled=\"ctrl.isDebtTransaction\"><i class=\"las la-times\"></i></button></div><div class=\"course\" ng-if=\"item.courses\"><div class=\"form-group last\"><app-dropdown model=\"ctrl.items[index].course_id\" options=\"item.courseOptions\" value-prop=\"id\" required=\"true\" label=\"{{\'CALENDAR_ORDER_COURSES\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_COURSES\' | translate}}\"></app-dropdown></div></div></div></div><table class=\"table cashbox-summary-table\" ng-if=\"ctrl.items.length > 0\"><tfoot class=\"checkout\" ng-if=\"isMobile || (!isMobile && ctrl.items.length > 0)\"><tr class=\"total\" ng-hide=\"ctrl.hide_prices\"><td><h6 class=\"title\" ng-if=\"!ctrl.isCreditTransaction\">{{\"CALENDAR_CASH_TOTAL\" | translate}}</h6></td><td style=\"vertical-align: middle; text-align: center;\"><div ng-if=\"ctrl.prepaid\"><b>{{\"CASHBOX_PREPAID_TITLE\" | translate}} {{ctrl.prepaid}}</b></div><div ng-if=\"ctrl.giftCardTotal() > 0\"><i class=\"las la-gift\"></i> <b>{{\"GIFT_CARD\" | translate}} {{ctrl.giftCardTotal()}}₪</b></div></td><td></td><td width=\"100px\"><div ng-if=\"ctrl.show_discount\"><div class=\"form-group last\"><label>{{\"CASHBOX_DISCOUNT_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"discount-input\" class=\"form-control discount-input\" ng-model=\"ctrl.total_discount\" ng-change=\"ctrl.changeTotalPercentage()\"></div><span class=\"price\">&nbsp;</span></div></td><td width=\"100px\"><div ng-if=\"ctrl.show_discount\"><div class=\"form-group last\"><label>{{\"CASHBOX_NET_PRICE_LABEL\" | translate}}</label> <input type=\"number\" step=\"0.01\" id=\"discount-input\" class=\"form-control discount-input\" ng-model=\"ctrl.cashboxTotal\" ng-change=\"ctrl.changeTotalSum()\"></div></div><h6 class=\"title\" ng-if=\"ctrl.isCreditTransaction\">{{\"CALENDAR_CASH_TOTAL_CREDIT\" | translate}}</h6><span class=\"price\">{{ctrl.cashboxTotal | priceFloat:true}}</span></td></tr><tr class=\"methods\" ng-if=\"!ctrl.isAllPayedByCard() && !ctrl.isAllPayedByGiftCards() && !ctrl.form.quotation\"><td colspan=\"5\" ng-class=\"{\'debt-transaction\': !(!ctrl.isDebtTransaction && (!ctrl.isCreditTransaction || ctrl.customerData.oncredit))}\"><div class=\"flex cashbox-buttons\"><a ng-click=\"ctrl.choosePayMethod(\'cash\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.cash.active, \'disabled\': ctrl.methods.cash.disabled}\">{{\"CALENDAR_CASH_CASH\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'credit_card\')\" class=\"btn text border-primary large\" ng-if=\"ctrl.businessInfo && ctrl.businessInfo.data.credit_card && (!ctrl.isCreditTransaction || ctrl.isCreditCreditCard)\" ng-class=\"{\'active\': ctrl.methods.credit_card.active, \'disabled\': ctrl.methods.credit_card.disabled}\">{{\"ADMIN_CREDIT_CARD\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'oncredit\')\" class=\"btn text border-primary large\" ng-if=\"!ctrl.isDebtTransaction && (!ctrl.isCreditTransaction || ctrl.customerData.oncredit)\" ng-class=\"{\'active\': ctrl.methods.oncredit.active, \'disabled\': ctrl.methods.oncredit.disabled}\">{{\"CALENDAR_CASH_ON_CREDIT\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'cheque\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.cheque.active, \'disabled\': ctrl.methods.cheque.disabled}\">{{\"CALENDAR_CASH_CHEQUE\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'bank_transfer\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.bank_transfer.active, \'disabled\': ctrl.methods.bank_transfer.disabled}\">{{\"CALENDAR_CASH_BANK_TRANS\" | translate}}</a> <a ng-click=\"ctrl.choosePayMethod(\'credit_card_external\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.credit_card_external.active, \'disabled\': ctrl.methods.credit_card_external.disabled}\">{{\"CALENDAR_CASH_CREDIT_CARD_EXT\" | translate}}</a> <a ng-if=\"(ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_phone)) && ctrl.businessInfo.data && ctrl.businessInfo.data.paid_link && !ctrl.isCreditTransaction\" ng-click=\"ctrl.choosePayMethod(\'pay_link\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.pay_link.active, \'disabled\': ctrl.methods.pay_link.disabled}\">{{\"CALENDAR_PAY_LINK\" | translate}}</a> <a ng-click=\"ctrl.openGiftCardModal()\" class=\"btn text border-primary large\" ng-class=\"{\'disabled\': ctrl.methods.retainer.active}\">{{\"GIFT_CARD\" | translate}}</a> <a ng-if=\"ctrl.customerCreditCards && ctrl.customerCreditCards.length > 0 && !ctrl.isCreditTransaction\" ng-click=\"ctrl.choosePayMethod(\'retainer\')\" class=\"btn text border-primary large\" ng-class=\"{\'active\': ctrl.methods.retainer.active, \'disabled\': ctrl.methods.retainer.disabled || ctrl.form.retainer_id}\">{{\"RETAINER_PAYMENT_TYPE\" | translate}}</a></div></td></tr><tr><td class=\"payments-col\" colspan=\"5\"><div class=\"form-group last credit-card-select\" ng-if=\"ctrl.customerCreditCards && ctrl.customerCreditCards.length > 0 && !ctrl.isCreditTransaction && (ctrl.methods[\'credit_card\'].active || ctrl.methods[\'retainer\'].active)\"><app-dropdown model=\"ctrl.creditCardId\" options=\"ctrl.customerCreditCards\" label-prop=\"number\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'ZCREDIT_CARD_SELECT\' | translate}}\" placeholder=\"{{\'ZCREDIT_CARD_SELECT\' | translate}}\"></app-dropdown></div><div class=\"col-xs-12 btn-nostyle no-padding retainer-form\" ng-if=\"ctrl.methods[\'retainer\'].active\"><div class=\"flex gap-16\"><div class=\"form-group last\"><label>{{\'RETAINER_START_DATETIME\' | translate}}</label> <input type=\"datetime-local\" class=\"form-control\" ng-model=\"ctrl.form.retainer_start_date\"></div><div class=\"form-group last\"><app-dropdown model=\"ctrl.form.retainer_period\" options=\"ctrl.retainerPeriodOptions\" value-prop=\"id\" label=\"{{\'RETAINER_PERIOD\' | translate}}\" placeholder=\"{{\'RETAINER_PERIOD\' | translate}}\"></app-dropdown></div></div><div class=\"flex gap-16\"><div class=\"form-group last\"><label>{{\'RETAINER_COUNT\' | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.form.retainer_count\" ng-disabled=\"ctrl.form.retainer_infinity\"></div><div class=\"form-switch form-group last\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.retainer_infinity\">{{\"RETAINER_INFINITY\" | translate}}</label></div></div></div><div class=\"col-xs-12 btn-nostyle no-padding cashbox-send-invoice-container\" ng-if=\"((ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_phone)) && ctrl.msg_channel_inv_link*1 > 0) || ((ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_phone)) && ctrl.form.quotation)\"><div class=\"form-switch form-group last\" ng-if=\"(ctrl.form.customer || (ctrl.occ_customer && ctrl.form.customer_occ_phone)) && ctrl.msg_channel_inv_link*1 > 0\"><label><input type=\"checkbox\" ng-model=\"ctrl.sendInvoice\">{{\"CASHBOX_SEND_INVOICE\" | translate}}</label></div></div><div class=\"col-xs-12 btn-nostyle no-padding\"><div ng-if=\"ctrl.businessInfo.data.continuous_deal && !ctrl.isCreditTransaction && !ctrl.isAllPayedByCard() && !ctrl.isAllPayedByGiftCards() && ctrl.isAllPayByCreditCard() && !ctrl.creditDeal && !ctrl.hasUsedAnyCards() && !ctrl.hasUsedGiftCards()\" class=\"form-switch form-group last\"><label><input type=\"checkbox\" ng-checked=\"ctrl.continuous_deal\" ng-click=\"ctrl.onContinuousDealClick($event)\">{{\"ENABLED_CONTINUOUS_DEAL\" | translate}} <span ng-if=\"ctrl.continuous_deal\">({{ctrl.continuous_deal_count}})</span></label></div></div><div class=\"col-xs-12 btn-nostyle no-padding\"><div class=\"form-switch form-group last\" ng-if=\"ctrl.cerdit_company != 2 && ctrl.cerdit_company != 3 && ctrl.businessHasCardReader && ctrl.methods[\'credit_card\'].active\"><label><input type=\"checkbox\" ng-model=\"ctrl.useCardReader\">{{\"CASHBOX_CARD_READEAR_SWITCHER\" | translate}}</label></div></div><div class=\"col-xs-12 btn-nostyle no-padding\" ng-if=\"ctrl.cerdit_company == 3 && ctrl.methods[\'credit_card\'].active && !ctrl.isCreditTransaction\"><div class=\"form-switch form-group\" ng-if=\"!ctrl.creditCardId\"><label><input type=\"checkbox\" ng-model=\"ctrl.useIframe\" ng-change=\"ctrl.numberOfPaymentsEmv = 1; ctrl.creditDeal = false;\">{{\"ZCREDIT_IFRAME_CHECKBOX\" | translate}}</label></div><div class=\"form-switch form-group\" ng-if=\"ctrl.z_credit_credit_deal && !ctrl.useIframe && ctrl.cashboxTotal >= 75 && !ctrl.continuous_deal\"><label><input type=\"checkbox\" ng-model=\"ctrl.creditDeal\" ng-change=\"ctrl.continuous_deal = false;\">{{\"ZCREDIT_CHECKBOX_CREDIT_DEAL\" | translate}}</label></div><div class=\"form-group\" ng-if=\"!ctrl.useIframe && !ctrl.continuous_deal\"><label style=\"display:block\">{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}</label> <input type=\"text\" value=\"1\" placeholder=\"{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}\" class=\"form-control\" ng-model=\"ctrl.numberOfPaymentsEmv\"></div></div><div class=\"col-xs-12 btn-nostyle no-padding\" ng-if=\"(ctrl.cerdit_company == 3 || ctrl.cerdit_company == 2 || ctrl.cerdit_company == 1) && ctrl.methods[\'pay_link\'].active\"><div class=\"form-group\" ng-if=\"!ctrl.continuous_deal\"><label style=\"display:block\">{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}</label> <input type=\"text\" value=\"1\" placeholder=\"{{\'EMV_NUMBER_OF_PAYMENTS\' | translate}}\" class=\"form-control\" ng-model=\"ctrl.numberOfPaymentsEmv\"></div></div></td></tr><tr ng-if=\"ctrl.methods[\'retainer\'].active\"><td colspan=\"5\" style=\"border-top: none;\"><div class=\"retainer-amount\"><p ng-if=\"ctrl.form.retainer_period == \'monthly\'\">{{\'RETAINER_MONTHLY_AMOUNT\' | translate: {amount: (ctrl.cashboxTotal | priceFloat:true)} }}</p><p ng-if=\"ctrl.form.retainer_period == \'weekly\'\">{{\'RETAINER_WEEKLY_AMOUNT\' | translate: {amount: (ctrl.cashboxTotal | priceFloat:true)} }}</p></div></td></tr><tr><td colspan=\"5\"><div class=\"payment-buttons\"><button id=\"checkout\" class=\"btn text primary large\" ng-if=\"!ctrl.isAllPayedByCard() && !ctrl.isAllPayedByGiftCards()\" ng-click=\"ctrl.resetPayment(); ctrl.completePayment();\" ng-disabled=\"ctrl.isDisabledPaymentBtn() || ctrl.cashboxLoading\">{{\"CALENDAR_CASH_FOR_PAYMENT\" | translate}}</button> <button id=\"checkout\" class=\"btn text primary large\" ng-if=\"ctrl.isAllPayedByCard() || ctrl.isAllPayedByGiftCards()\" ng-disabled=\"ctrl.cashboxLoading\" ng-click=\"ctrl.resetPayment(); ctrl.completePayment();\">{{\"CASHBOX_CONFIRM_PAYMENT_BTN\" | translate}}</button></div><div class=\"mt-24\"><textarea placeholder=\'{{\"CASHBOX_COMMENT\" | translate}}\' auto-expand=\"\" class=\"form-control\" ng-model=\"ctrl.form.comment\"></textarea></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/modules/dashboard/dashboard.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} page-wrapper-main\" ng-if=\"isUserAllowedAccess(\'dashboard\')\" id=\"dashboard-main\"><div class=\"dashboard-buttons\"><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings.logs\"><i class=\"las la-file\"></i> <span>{{\"NAV_INVOICES\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'reports\')\"><a ui-sref=\"app.reports\"><i class=\"las la-paste\"></i> <span>{{\"NAV_REPORTS\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><a ui-sref=\"app.settings\"><i class=\"las la-cog\"></i> <span>{{\"NAV_SETTINGS\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'calendar\')\"><a ui-sref=\"app.calendar\"><i class=\"las la-calendar\"></i> <span>{{\"NAV_DAY\" | translate}}</span></a></div><div class=\"dashboard-button\"><a ui-sref=\"app.marketing\"><i class=\"las la-bullhorn\"></i> <span>{{\"NAV_MARKETING\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'business_analysis\')\"><a ui-sref=\"app.analytics\"><i class=\"las la-chart-area\"></i> <span>{{\"NAV_ANALYTIC\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'customers\')\"><a ui-sref=\"app.customers\"><i class=\"las la-users\"></i> <span>{{\"NAV_CUSTOMERS\" | translate}}</span></a></div><div class=\"dashboard-button\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><a ui-sref=\"app.cashbox\"><i class=\"las la-dollar-sign\"></i> <span>{{\"NAV_CASH\" | translate}}</span></a></div><div class=\"dashboard-button\"><a ui-sref=\"app.leads\" ng-if=\"isUserAllowedAccess(\'customers\') && manage_leads\"><i class=\"las la-star\"></i> <span>{{\"NAV_LEADS\" | translate}}</span></a> <a ui-sref=\"app.workers\" ng-if=\"!(isUserAllowedAccess(\'customers\') && manage_leads) && isUserAllowedAccess(\'workers\')\"><i class=\"las la-briefcase\"></i> <span>{{\"WORKERS\" | translate}}</span></a></div></div><div class=\"widgets-row\" style=\"margin-left:0;margin-right: 0;display: flex;justify-content: space-around\" ng-if=\"isMobile\"><div ng-hide=\"ctrl.hide_prices\" class=\"col-xs-5 align-center data-widget income mobile\"><div class=\"text title\">{{\"DASHBOARD_DAILY_INCOME\" | translate}}</div><div class=\"price\">{{ctrl.dailyIncome}}<span class=\"currency\">שח</span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome)}}%</span> &#x2022 {{ctrl.today()}}</div></div><div class=\"col-xs-5 align-center data-widget orders mobile\" style=\"width:50%\"><div class=\"text title\">{{\"DASHBOARD_DAILY_ORDERS\" | translate}}</div><div class=\"price\">{{ctrl.dailyOrders}}<span class=\"currency\"></span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders)}}%</span> &#x2022 {{ctrl.today()}}</div></div></div><div class=\"row dashboard-row\"><div class=\"col-xs-12 col-md-7 col-lg-6\"><div class=\"mobile-second bg-white data-table\"><div class=\"window-header\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-dollar-sign\"></i></div><span ng-if=\"b_type==2\">{{\"DASHBOARD_WEEKS_ORDERS\" | translate}}</span> <span ng-if=\"b_type==1\">{{\"DASHBOARD_TODAYS_ORDERS\" | translate}}</span></div><div><a ui-sref=\"app.calendar\" class=\"btn text special\"><span class=\"hidden-xs\">{{\"VIEW_ALL\" | translate}}</span> <i class=\"las la-angle-left rotatable\"></i></a></div></div><div><div class=\"dashboard-orders-widget\"><div class=\"table-holder\"><div class=\"table-responsive\" id=\"today_order_tb\"><table ng-if=\"ctrl.tableOrdersData\" datatable=\"\" dt-column-defs=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th class=\"hide\"></th><th class=\"hidden-xs\" ng-if=\"b_type==2\">{{\"REPORT_ORDER_DATE\" | translate}}</th><th class=\"hidden-xs\" ng-if=\"b_type==1\">{{\"DASHBOARD_TIME\" | translate}}</th><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th>{{\"SETTINGS_ITEM\" | translate}}</th><th ng-hide=\"ctrl.hide_prices\">{{\"REPORT_ITEM_PRICE\" | translate}}</th><th>{{\"CALENDAR_ORDER_RESOURCE\" | translate}}</th><th ng-if=\"b_type==2\">{{\"CALENDAR_NIGHTS_NUMBER\" | translate}}</th><th><span class=\"hidden-xs\">{{\"CALENDAR_ORDER_ACTION\" | translate}}</span></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableOrdersData\" ng-click=\"ctrl.edit_order_form(row.order_id)\"><td class=\"hide\"></td><td class=\"hidden-xs\" ng-if=\"b_type==2\"><span ng-hide=\"true\">{{row.start_time | toUnixTimestamp }}</span> <span class=\"time-txt\" ng-class=\"{\'expired_order_widget\' : currentDateTime > (row.start_time | toUnixTimestamp)}\">{{row.start_time | toUnixTimestamp | date:\"dd/MM/yyyy\"}} <i ng-if=\"currentDateTime > (row.start_time | toUnixTimestamp)\" class=\"las la-exclamation-triangle\"></i></span></td><td class=\"hidden-xs\" ng-if=\"b_type==1\"><span ng-hide=\"true\">{{row.start_time | toUnixTimestamp }}</span> <span class=\"time-txt\" ng-class=\"{\'expired_order_widget\' : currentDateTime > (row.start_time | toUnixTimestamp)}\">{{row.start_time | toUnixTimestamp | date:\"H:mm\"}} <i ng-if=\"currentDateTime > (row.start_time | toUnixTimestamp)\" class=\"las la-exclamation-triangle\"></i></span></td><td><b>{{row.customer}}</b><div class=\"visible-xs time-txt\" ng-class=\"{\'expired_order_widget\' : currentDateTime > (row.start_time | toUnixTimestamp)}\">{{row.start_time | toUnixTimestamp | date:\"H:mm\"}} <i ng-if=\"currentDateTime > (row.start_time | toUnixTimestamp)\" class=\"las la-exclamation-triangle\"></i></div></td><td><span class=\"btn btn-primary btn-xs category-item\" style=\"background-color: {{ctrl.hexToRgbA(row.item_data.bg_color)}};\">{{row.item_data.name}}</span></td><td ng-hide=\"ctrl.hide_prices\"><b>{{row.item_data.price}}</b></td><td><span>{{row.resource}}</span></td><td ng-if=\"b_type==2\"><span>{{row.nights}}</span></td><td><a ng-click=\"$event.stopPropagation();\" ui-sref=\"app.cashbox.order({orderID: {{row.id}}})\" class=\"btn icon\"><i class=\"las la-hand-holding-usd\"></i></a></td></tr></tbody></table></div></div></div></div></div><div ng-hide=\"ctrl.hide_prices\" class=\"block-title-green bg-white data-table mobile-four\" ng-if=\"!page_is_loading\"><div class=\"window-header wrap\"><div class=\"block-title blue\"><div class=\"btn icon small\"><i class=\"las la-chalkboard\"></i></div><span>{{\"CUSTOMERS_REV\" | translate}}</span></div><div class=\"d-flex flex-end\"><div class=\"d-flex gap-16\"><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.loadAnalytics(\'income\', \'daily\')\" ng-class=\"{\'btn-primary\': ctrl.incomeGraph.filter == \'daily\', \'btn-default\': ctrl.incomeGraph.filter != \'daily\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_1\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(\'income\', \'weekly\')\" ng-class=\"{\'btn-primary\': ctrl.incomeGraph.filter == \'weekly\', \'btn-default\': ctrl.incomeGraph.filter != \'weekly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_2\" | translate}}</button> <button ng-click=\"ctrl.loadAnalytics(\'income\', \'monthly\')\" ng-class=\"{\'btn-primary\': ctrl.incomeGraph.filter == \'monthly\', \'btn-default\': ctrl.incomeGraph.filter != \'monthly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_3\" | translate}}</button></div></div></div><div class=\"window-header-second\"><div class=\"m-4\"><app-dropdown class=\"small\" ng-if=\"ctrl.incomeGraph.categoryOptions\" model=\"ctrl.incomeGraph.category\" options=\"ctrl.incomeGraph.categoryOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(\'income\')\"></app-dropdown></div><div class=\"m-4\"><app-dropdown class=\"small\" ng-if=\"ctrl.incomeGraph.resourceOptions\" model=\"ctrl.incomeGraph.resource\" options=\"ctrl.incomeGraph.resourceOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(\'income\')\"></app-dropdown></div><div class=\"filter-button flex-none\"><button class=\"btn icon default\" ng-click=\"ctrl.openFilter(\'incomeGraph\')\"><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal\': true, \'filter-modal-simple\': true, \'active\': ctrl.filterModal.incomeGraph}\" ng-click=\"event.stopPropagation();\"><div><div><div class=\"form-group\"><app-dropdown ng-if=\"ctrl.incomeGraph.resources\" model=\"ctrl.incomeGraph.resource_treated\" options=\"ctrl.incomeGraph.resources\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_RESOURCES_TREATED\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_TREATED\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(\'income\')\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown ng-if=\"ctrl.incomeGraph.resources\" model=\"ctrl.incomeGraph.resource_booked\" options=\"ctrl.incomeGraph.resources\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_RESOURCES_BOOKED\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_BOOKED\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(\'income\')\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown ng-if=\"ctrl.incomeGraph.resources\" model=\"ctrl.incomeGraph.resource_responsible\" options=\"ctrl.incomeGraph.resources\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_RESOURCES_RESPONSIBLE\' | translate}}\" placeholder=\"{{\'CALENDAR_RESOURCES_RESPONSIBLE\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalytics(\'income\')\"></app-dropdown></div></div></div><div class=\"flex nowrap gap-16\"><a ng-click=\"ctrl.closeFilter(\'incomeGraph\')\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a></div></div></div></div></div><div class=\"visible-xs\"></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"circle-loader\" ng-if=\"ctrl.incomeLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-wrapper\" ng-if=\"!ctrl.incomeLoading\"><div class=\"chart-body\"><div class=\"income income-dashboard\"><canvas chart-js=\"\" chart-data=\"ctrl.incomeGraph.data\" chart-options=\"ctrl.incomeGraph.options\" chart-type=\"ctrl.incomeGraph.type\" height=\"{{ctrl.graphHeight}}\"></canvas></div></div></div></div></div></div><div class=\"block-title-green bg-white data-table mobile-seven\" ng-if=\"!page_is_loading\"><div class=\"window-header analytic\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-chart-pie\"></i></div><span>{{\"CUSTOMERS_STATSPIE\" | translate}}</span></div><div class=\"flex gap-8\"><div class=\"graph-btn-row btn-group flex-end\"><button tooltip2=\'{{\"ANALYTIC_BY_LEADS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.pie_type = \'leads\'; ctrl.loadStatsPie()\" ng-class=\"{\'btn-primary\': ctrl.pie_type == \'leads\', \'btn-default\': ctrl.pie_type != \'leads\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_BY_LEADS\" | translate}}</button> <button tooltip2=\'{{\"ANALYTIC_BY_STATUS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.pie_type = \'statuses\'; ctrl.loadStatsPie()\" ng-class=\"{\'btn-primary\': ctrl.pie_type == \'statuses\', \'btn-default\': ctrl.pie_type != \'statuses\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_BY_STATUS\" | translate}}</button></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"pie-start-date\" required=\"\" ng-model=\"ctrl.pie_start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"pie-end-date\" required=\"\" ng-model=\"ctrl.pie_end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div><div><div class=\"circle-loader\" ng-if=\"ctrl.statsPieLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-wrapper\" ng-if=\"!ctrl.statsPieLoading\"><div class=\"chart-body\"><div class=\"stats statspie-dashboard\"><canvas chart-js=\"\" chart-data=\"ctrl.statsPie.data\" chart-options=\"ctrl.statsPie.options\" chart-type=\"ctrl.statsPie.type\"></canvas></div></div></div></div></div></div><div class=\"col-xs-12 col-md-5 col-lg-6\"><div ng-hide=\"ctrl.hide_prices\" class=\"flex-container mobile-first\" ng-if=\"!isMobile\"><div class=\"\"><div class=\"data-widget income\"><div class=\"text title\">{{\"DASHBOARD_DAILY_INCOME\" | translate}}</div><div class=\"price\">{{ctrl.dailyIncome}}<span class=\"currency\">שח</span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayIncome, ctrl.dailyIncome)}}%</span> &#x2022 {{ctrl.today()}}</div></div></div><div class=\"\"><div class=\"data-widget orders\"><div class=\"text title\">{{\"DASHBOARD_DAILY_ORDERS\" | translate}}</div><div class=\"price\">{{ctrl.dailyOrders}}<span class=\"currency\"></span></div><div class=\"text\"><span ng-class=\"{\'red\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) < 0, \'green\': ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders) >= 0}\"><i></i>{{ctrl.checkPercent(ctrl.yesterdayOrders, ctrl.dailyOrders)}}%</span> &#x2022 {{ctrl.today()}}</div></div></div></div><div ng-if=\"!page_is_loading\" class=\"mobile-three\"><div class=\"block-title-red data-table bg-white\"><div class=\"window-header\"><div class=\"block-title pink\"><div class=\"btn icon small\"><i class=\"las la-gift\"></i></div><span>{{\"DASHBOARD_TODAY_BDAYS\" | translate}}</span></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"table-holder\"><div class=\"circle-loader\" ng-if=\"ctrl.customersLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"table-responsive\" ng-if=\"!ctrl.customersLoading\"><table ng-if=\"ctrl.tableCustomersData\" datatable=\"\" dt-options=\"dtOptionsBirth\" class=\"table table-striped table-bordered table-hover dataTables-example\" id=\"birthday_tb\"><thead><tr><th>{{\"CUSTOMERS_LAST_VISIT\" | translate}}</th><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th class=\"customer-shows\">{{\"CUSTOMERS_AGE\" | translate}}</th><th class=\"hidden-xs customer-income\">{{\"CUSTOMER_GIFT_CARD\" | translate}}</th><th class=\"customer-send\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableCustomersData\"><td><span class=\"expired_order_widget\">{{row.last_date}}</span></td><td><b>{{row.firstname}} {{row.lastname}}</b></td><td class=\"customer-shows\">{{row.age}}</td><td class=\"hidden-xs customer-income\">{{CUSTOMER_GIFT_CARD_SEND | translate}}</td><td class=\"customer-send\"><button ng-if=\"!row.flag\" class=\"btn text primary btn-birthday-{{row.id}}\" ng-click=\"ctrl.send_birthday_message(row.id)\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div></div><div ng-hide=\"ctrl.hide_prices\" ng-if=\"showIncomeByItem\" class=\"mobile-six\"><div class=\"bg-white block-title-green data-table\"><div class=\"window-header\"><div class=\"block-title orange\"><div class=\"btn icon small\"><i class=\"las la-chart-bar\"></i></div><span>{{\"DASHBOARD_DAILY_INCOME_BY_ITEM\" | translate}}</span></div><div><a ui-sref=\"app.analytics\" class=\"btn text special\"><span class=\"hidden-xs\">{{\"VIEW_ALL\" | translate}}</span> <i class=\"las la-angle-left rotatable\"></i></a></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"circle-loader\" ng-if=\"ctrl.incomeByItemLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-body\" ng-if=\"!ctrl.incomeByItemLoading\"><div class=\"chart-canvas\"><canvas chart-js=\"\" chart-data=\"ctrl.dailyIncomeByItemGraph.data\" chart-options=\"ctrl.dailyIncomeByItemGraph.options\" chart-type=\"ctrl.dailyIncomeByItemGraph.type\"></canvas></div></div></div></div></div></div><div ng-hide=\"ctrl.hide_prices\" ng-if=\"!page_is_loading\" class=\"mobile-five\"><div class=\"block-title-green bg-white data-table\"><div class=\"window-header analytic\"><div class=\"block-title purple\"><div class=\"btn icon small\"><i class=\"lab la-cc-mastercard\"></i></div><span>{{\"DASHBOARD_DAILY_INCOME_BY_PAYMENT_TYPE\" | translate}}</span></div><div class=\"flex gap-8\"><div class=\"form-inline flex-end\"><app-dropdown class=\"small\" model=\"ctrl.paymentGraph.filter\" options=\"ctrl.paymentFilterOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.loadAnalyticsPaymentType()\"></app-dropdown></div><div class=\"flex gap-8\" ng-if=\"ctrl.paymentGraph.filter == \'daterange\'\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"payment-start-date\" required=\"\" ng-model=\"ctrl.payment_start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"payment-end-date\" required=\"\" ng-model=\"ctrl.payment_end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"circle-loader\" ng-if=\"ctrl.paymentLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-body\" ng-if=\"!ctrl.paymentLoading\"><div class=\"payment-canvas\"><canvas chart-js=\"\" chart-data=\"ctrl.paymentGraph.data\" chart-options=\"ctrl.paymentGraph.options\" chart-type=\"ctrl.paymentGraph.type\"></canvas></div></div></div></div></div></div><div ng-if=\"showCalendar\"><div class=\"bg-white data-table\"><div class=\"row\"><div class=\"col-xs-8\"><div class=\"data-table-title\"><div class=\"data-table-icon occupation-icon\"></div><div class=\"title-text\">{{\"DASHBOARD_TONNAGE\" | translate}}</div></div></div><div class=\"col-xs-4 btn-holder\"><button class=\"btn btn-primary light-green btn-long\" ui-sref=\"app.calendar\">{{\"NAV_DAY\" | translate}}</button></div></div><div class=\"row\"><div ng-if=\"calendarConfig\" ui-calendar=\"calendarConfig\" ng-model=\"events\" calendar=\"mainCalendar\" class=\"calendar\"></div></div></div></div><div class=\"block-title-green bg-white data-table mobile-seven\" ng-if=\"!page_is_loading\"><div class=\"window-header analytic\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-chart-bar\"></i></div><span>{{\"CUSTOMERS_STATSBAR\" | translate}}</span></div><div class=\"flex gap-8\"><div class=\"graph-btn-row btn-group flex-end\"><button tooltip2=\'{{\"ANALYTIC_BY_LEADS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.bar_type = \'leads\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_type == \'leads\', \'btn-default\': ctrl.bar_type != \'leads\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_BY_LEADS\" | translate}}</button> <button tooltip2=\'{{\"ANALYTIC_BY_STATUS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.bar_type = \'statuses\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_type == \'statuses\', \'btn-default\': ctrl.bar_type != \'statuses\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_BY_STATUS\" | translate}}</button></div><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.bar_filter = \'daily\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_filter == \'daily\', \'btn-default\': ctrl.bar_filter != \'daily\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_1\" | translate}}</button> <button ng-click=\"ctrl.bar_filter = \'weekly\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_filter == \'weekly\', \'btn-default\': ctrl.bar_filter != \'weekly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_2\" | translate}}</button> <button ng-click=\"ctrl.bar_filter = \'monthly\'; ctrl.loadStatsBar()\" ng-class=\"{\'btn-primary\': ctrl.bar_filter == \'monthly\', \'btn-default\': ctrl.bar_filter != \'monthly\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"ANALYTIC_SELECT_3\" | translate}}</button></div><div class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"bar-start-date\" required=\"\" ng-model=\"ctrl.bar_start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"bar-end-date\" required=\"\" ng-model=\"ctrl.bar_end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div></div><div><div class=\"circle-loader\" ng-if=\"ctrl.statsBarLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-wrapper\" ng-if=\"!ctrl.statsBarLoading\"><div class=\"chart-body\"><div class=\"stats statspie-dashboard mobile-chart\"><canvas chart-js=\"\" chart-data=\"ctrl.statsBar.data\" chart-options=\"ctrl.statsBar.options\" chart-type=\"ctrl.statsBar.type\"></canvas></div></div></div></div></div><div class=\"block-title-green bg-white data-table mobile-seven\" ng-if=\"!page_is_loading\"><div class=\"window-header analytic\"><div class=\"block-title green\"><div class=\"btn icon small\"><i class=\"las la-chart-bar\"></i></div><span>{{\"CAMPAIGN_BAR\" | translate}}</span></div><div class=\"flex gap-8\"><div class=\"graph-btn-row btn-group flex-end\"><button tooltip2=\'{{\"CAMPAIGN_BAR_CAMPAIGNS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.campaign_bar_type = \'campaigns\'; ctrl.loadCampaignBar()\" ng-class=\"{\'btn-primary\': ctrl.campaign_bar_type == \'campaigns\', \'btn-default\': ctrl.campaign_bar_type != \'campaigns\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"CAMPAIGN_BAR_CAMPAIGNS\" | translate}}</button> <button tooltip2=\'{{\"CAMPAIGN_BAR_ADSETS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.campaign_bar_type = \'adsets\'; ctrl.loadCampaignBar()\" ng-class=\"{\'btn-primary\': ctrl.campaign_bar_type == \'adsets\', \'btn-default\': ctrl.campaign_bar_type != \'adsets\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"CAMPAIGN_BAR_ADSETS\" | translate}}</button> <button tooltip2=\'{{\"CAMPAIGN_BAR_ADS_TOOLTIP\" | translate}}\' ng-click=\"ctrl.campaign_bar_type = \'ads\'; ctrl.loadCampaignBar()\" ng-class=\"{\'btn-primary\': ctrl.campaign_bar_type == \'ads\', \'btn-default\': ctrl.campaign_bar_type != \'ads\', \'btn-xs\': ctrl.isMobile, \'btn\': ! ctrl.isMobile}\">{{\"CAMPAIGN_BAR_ADS\" | translate}}</button></div><div class=\"flex gap-8\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><app-dropdown class=\"small\" model=\"ctrl.campaign_bar_metric\" options=\"ctrl.campaignBarMetricOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.loadCampaignBar()\"></app-dropdown></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><app-dropdown class=\"small\" model=\"ctrl.campaign_bar_filter\" options=\"ctrl.campaignBarFilterOptions\" value-prop=\"id\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.onCampaignBarFilterChange()\"></app-dropdown></div></div><div class=\"flex gap-8\" ng-if=\"ctrl.campaign_bar_filter == \'custom\'\"><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_from\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" class=\"form-control background-white\" id=\"campaign-bar-start-date\" required=\"\" ng-model=\"ctrl.campaign_bar_start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div class=\"dashboard-f-t\"><div class=\"form-group icon-append form-input last\"><input type=\"datetime\" placeholder=\"{{\" stats_until\"=\"\" |=\"\" translate}}\"=\"\" date-time=\"\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"campaign-bar-end-date\" required=\"\" ng-model=\"ctrl.campaign_bar_end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div></div></div></div></div><div><div class=\"circle-loader\" ng-if=\"ctrl.campaignBarLoading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"chart-wrapper\" ng-if=\"!ctrl.campaignBarLoading\"><div class=\"chart-body\"><div class=\"stats statspie-dashboard mobile-chart\"><canvas chart-js=\"\" chart-data=\"ctrl.campaignBar.data\" chart-options=\"ctrl.campaignBar.options\" chart-type=\"ctrl.campaignBar.type\"></canvas></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/dashboard/dashboard_load.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div id=\"page-loading\" class=\"ibox-content sk-loading\"><style>\n        .sk-spinner-fading-circle.sk-spinner {\n          width: 80px;\n          height: 80px;\n          margin: 0 auto;\n          position: relative;\n        }\n        .sk-spinner-fading-circle .sk-circle {\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          left: 0;\n          top: 0;\n        }\n        .sk-spinner-fading-circle .sk-circle:before {\n          content: \'\';\n          display: block;\n          margin: 0 auto;\n          width: 18%;\n          height: 18%;\n          background-color: #337ab7;\n          border-radius: 100%;\n          -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out;\n          animation: sk-circleFadeDelay 1.2s infinite ease-in-out;\n          -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n        }\n        .sk-spinner-fading-circle .sk-circle2 {\n          -webkit-transform: rotate(30deg);\n          -ms-transform: rotate(30deg);\n          transform: rotate(30deg);\n        }\n        .sk-spinner-fading-circle .sk-circle3 {\n          -webkit-transform: rotate(60deg);\n          -ms-transform: rotate(60deg);\n          transform: rotate(60deg);\n        }\n        .sk-spinner-fading-circle .sk-circle4 {\n          -webkit-transform: rotate(90deg);\n          -ms-transform: rotate(90deg);\n          transform: rotate(90deg);\n        }\n        .sk-spinner-fading-circle .sk-circle5 {\n          -webkit-transform: rotate(120deg);\n          -ms-transform: rotate(120deg);\n          transform: rotate(120deg);\n        }\n        .sk-spinner-fading-circle .sk-circle6 {\n          -webkit-transform: rotate(150deg);\n          -ms-transform: rotate(150deg);\n          transform: rotate(150deg);\n        }\n        .sk-spinner-fading-circle .sk-circle7 {\n          -webkit-transform: rotate(180deg);\n          -ms-transform: rotate(180deg);\n          transform: rotate(180deg);\n        }\n        .sk-spinner-fading-circle .sk-circle8 {\n          -webkit-transform: rotate(210deg);\n          -ms-transform: rotate(210deg);\n          transform: rotate(210deg);\n        }\n        .sk-spinner-fading-circle .sk-circle9 {\n          -webkit-transform: rotate(240deg);\n          -ms-transform: rotate(240deg);\n          transform: rotate(240deg);\n        }\n        .sk-spinner-fading-circle .sk-circle10 {\n          -webkit-transform: rotate(270deg);\n          -ms-transform: rotate(270deg);\n          transform: rotate(270deg);\n        }\n        .sk-spinner-fading-circle .sk-circle11 {\n          -webkit-transform: rotate(300deg);\n          -ms-transform: rotate(300deg);\n          transform: rotate(300deg);\n        }\n        .sk-spinner-fading-circle .sk-circle12 {\n          -webkit-transform: rotate(330deg);\n          -ms-transform: rotate(330deg);\n          transform: rotate(330deg);\n        }\n        .sk-spinner-fading-circle .sk-circle2:before {\n          -webkit-animation-delay: -1.1s;\n          animation-delay: -1.1s;\n        }\n        .sk-spinner-fading-circle .sk-circle3:before {\n          -webkit-animation-delay: -1s;\n          animation-delay: -1s;\n        }\n        .sk-spinner-fading-circle .sk-circle4:before {\n          -webkit-animation-delay: -0.9s;\n          animation-delay: -0.9s;\n        }\n        .sk-spinner-fading-circle .sk-circle5:before {\n          -webkit-animation-delay: -0.8s;\n          animation-delay: -0.8s;\n        }\n        .sk-spinner-fading-circle .sk-circle6:before {\n          -webkit-animation-delay: -0.7s;\n          animation-delay: -0.7s;\n        }\n        .sk-spinner-fading-circle .sk-circle7:before {\n          -webkit-animation-delay: -0.6s;\n          animation-delay: -0.6s;\n        }\n        .sk-spinner-fading-circle .sk-circle8:before {\n          -webkit-animation-delay: -0.5s;\n          animation-delay: -0.5s;\n        }\n        .sk-spinner-fading-circle .sk-circle9:before {\n          -webkit-animation-delay: -0.4s;\n          animation-delay: -0.4s;\n        }\n        .sk-spinner-fading-circle .sk-circle10:before {\n          -webkit-animation-delay: -0.3s;\n          animation-delay: -0.3s;\n        }\n        .sk-spinner-fading-circle .sk-circle11:before {\n          -webkit-animation-delay: -0.2s;\n          animation-delay: -0.2s;\n        }\n        .sk-spinner-fading-circle .sk-circle12:before {\n          -webkit-animation-delay: -0.1s;\n          animation-delay: -0.1s;\n        }\n        @-webkit-keyframes sk-circleFadeDelay {\n          0%, 39%, 100% {\n            opacity: 0;\n          }\n          40% {\n            opacity: 1;\n          }\n        }\n        @keyframes sk-circleFadeDelay {\n          0%, 39%, 100% {\n            opacity: 0;\n          }\n          40% {\n            opacity: 1;\n          }\n        }\n        .ibox-content > .sk-spinner {\n          display: none;\n        }\n        .ibox-content.sk-loading {\n          position: relative;\n        }\n        .ibox-content.sk-loading:after {\n          content: \'\';\n          background-color: rgba(255, 255, 255, 0.7);\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n        }\n        .ibox-content.sk-loading > .sk-spinner {\n          display: block;\n          position: absolute;\n          top: 40%;\n          left: 0;\n          right: 0;\n          z-index: 2000;\n        }\n    </style><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div>");
$templateCache.put("app/modules/digital_documents/digital_documents.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h1 ng-if=\"!DigitalDocument.sign\" class=\"text-center\">{{\"PLEASE_SIGN_DOCUMENT\" | translate}}</h1><h1 ng-if=\"DigitalDocument.sign\" class=\"text-center\">{{\"DIGITAL_DOCUMENT_ALREADY_SIGNED\" | translate}}</h1></div><form class=\"modal-form_f\" name=\"signForm\" novalidate=\"\" ng-if=\"DigitalDocument.id\"><div class=\"modal-body\"><div class=\"panel-body\"><iframe ng-src=\"{{iframe()}}\" style=\"width:100%; height:100%; min-height: 500px;\" frameborder=\"0\" allow=\"payment; clipboard-write\"></iframe></div></div><div class=\"modal-footer modal-footer-align-center\" ng-if=\"!DigitalDocument.sign\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.sign\" ng-disabled=\"ctrl.is_edit\">{{\"ACCEPT_DIGITAL_DOCUMENT\" | translate}}</label></div><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/digital_forms/digital_forms.view.html","<div class=\"modal-form-inner digital_form_modal\" ng-if=\"!ctrl.finished\"><div ng-if=\"business.online_booking_data.background && business.online_booking_data.background != \'removed\'\" class=\"df-background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: cover;\"></div><div class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name ? DigitalForm.name : \"&nbsp;\"}}</h2></div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><app-dropdown model=\"field.value\" options=\"field.items\" value-prop=\"value\" label-prop=\"name\" label=\"{{field.name}}\" placeholder=\"{{field.name}}\" required=\"field.require || field.required\" disabled=\"DigitalForm.fill_date\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"date\" min=\"1900-01-01\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.require\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require || field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><span ng-click=\"ctrl.clearSign(index)\" ng-if=\"!DigitalForm.fill_date\"><i class=\"las la-trash\"></i></span><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div></div></div></div></div></div></div><div class=\"modal-footer modal-footer-align-center\" ng-if=\"!DigitalForm.fill_date && !DigitalForm.text_form\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/forgot_password/forgot_password.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"LOGIN_FORGOT_PASS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"forgotPasswordForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"LOGIN_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"forgotPasswordForm.email.$error\" class=\"ng-messages\" ng-show=\"forgotPasswordForm.email.$dirty\"><div ng-message=\"email\">{{\"SETTINGS_INFO_EMAIL_VALID\" | translate}}</div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/forgot_password_confirm/forgot_password_confirm.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">Create New password</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"forgotPasswordConfirmForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"LOGIN_PASS\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.password\" name=\"password\" placeholder=\"new password\" class=\"form-control\"><div ng-messages=\"forgotPasswordConfirmForm.password.$error\" class=\"ng-messages\" ng-show=\"forgotPasswordConfirmForm.password.$dirty\"><div ng-message=\"password\">{{\"SETTINGS_INFO_PASSWORD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"LOGIN_PASS_REPEAT\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.newPassword\" name=\"password\" placeholder=\"new password\" class=\"form-control\"><div ng-messages=\"forgotPasswordConfirmForm.password.$error\" class=\"ng-messages\" ng-show=\"forgotPasswordConfirmForm.newPassword.$dirty\"><div ng-message=\"newPassword\">{{\"SETTINGS_INFO_PASSWORD_VALID\" | translate}}</div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"forgotPasswordConfirmForm.$invalid || forgotPasswordConfirmForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/gift_card/gift_card.view.html","<div ng-if=\"ctrl.settings && ctrl.settings.page_bg_color\" class=\"public-gc-page\" ng-style=\"{ backgroundColor: ctrl.settings.page_bg_color }\"><div class=\"public-gc-waves\"></div><div class=\"public-gc-container\"><gift-card settings=\"ctrl.settings\" values=\"ctrl.values\" size=\"large\" view=\"mobile\"></gift-card><div ng-if=\"ctrl.used\" class=\"public-gc-used\"><div class=\"stamp\">{{ \'GIFT_CARD_USED\' | translate }}</div></div></div><div class=\"public-gc-socials\"><a ng-href=\"{{ ctrl.socials.phone }}\" target=\"_blank\" ng-if=\"ctrl.socials.phone\"><img src=\"/assets/images/phone-icon.png\" alt=\"Phone\"></a> <a ng-href=\"{{ ctrl.socials.facebook }}\" target=\"_blank\" ng-if=\"ctrl.socials.facebook\"><img src=\"/assets/images/facebook-icon.png\" alt=\"Facebook\"></a> <a ng-href=\"{{ ctrl.socials.wa }}\" target=\"_blank\" ng-if=\"ctrl.socials.wa\"><img src=\"/assets/images/whatsapp-icon.png\" alt=\"WhatsApp\"></a> <a ng-href=\"{{ ctrl.socials.waze }}\" target=\"_blank\" ng-if=\"ctrl.socials.waze\"><img src=\"/assets/images/waze-icon.png\" alt=\"Waze\"></a> <a ng-href=\"{{ ctrl.socials.instagram }}\" target=\"_blank\" ng-if=\"ctrl.socials.instagram\"><img src=\"/assets/images/instagram-icon.png\" alt=\"Instagram\"></a></div><div class=\"public-gc-powered\"><span>{{\"GIFT_CARD_POWERED_BY\" | translate}}</span> <a href=\"https://tiffulit.co.il\" target=\"_blank\" rel=\"noopener noreferrer\">{{\"GIFT_CARD_TIFFULIT_CRM\" | translate}}</a></div></div><div ng-if=\"!ctrl.settings.page_bg_color\" class=\"public-gc-page\"><h1>{{ \"GIFT_CARD_EMPTY\" | translate }}</h1></div>");
$templateCache.put("app/modules/login/login.html","<div class=\"loginscreen animated fadeInDown\" translate-cloak=\"loginscreen\"><div class=\"login-data-form\"><div class=\"login-form-logo-holder\"><div class=\"logo\"></div></div><div class=\"login-form-holder\"><form class=\"modal-form_f\" name=\"loginForm\" ng-submit=\"ctrl.login()\" novalidate=\"\"><div class=\"heading text-center mb-4\">{{\"LOGIN_FORM_TITLE\" | translate}}</div><div class=\"form-group\"><div class=\"login-input-row\"><input type=\"email\" name=\"email\" ng-model=\"ctrl.form.email\" class=\"form-control\" required=\"\" placeholder=\'{{\"LOGIN_EMAIL\" | translate}}\'></div><div ng-messages=\"loginForm.email.$error\" class=\"ng-messages\" ng-show=\"loginForm.email.$dirty\" style=\"margin-right: 28px;\"><div ng-message=\"email\">{{\"LOGIN_EMAIL_VALID\" | translate}}</div><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group icon-append\"><div class=\"login-input-row\"><input id=\"login-input\" type=\"{{ctrl.showPassword ? \'text\' : \'password\'}}\" name=\"password\" ng-model=\"ctrl.form.password\" class=\"form-control\" required=\"\" placeholder=\'{{\"LOGIN_PASS\" | translate}}\'></div><i class=\"top las {{ctrl.showPassword ? \'la-eye\' : \'la-low-vision\'}}\" ng-click=\"ctrl.togglePasswordVisibility()\" style=\"cursor: pointer;\"></i><div ng-messages=\"loginForm.password.$error\" class=\"ng-messages\" ng-show=\"loginForm.password.$dirty\" style=\"margin-right: 28px;\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div><div ng-message=\"creds\">{{\"LOGIN_INCORRECT\" | translate}}</div></div></div><div class=\"form-group mfa-login-card\" ng-if=\"ctrl.mfaRequired\"><div class=\"mfa-login-info\" ng-if=\"ctrl.mfaSetup\"><div class=\"mfa-login-icon\"><i class=\"las la-shield-alt\"></i></div><div class=\"mfa-login-content\"><div class=\"mfa-login-title\">{{\"LOGIN_MFA_TITLE\" | translate}}</div><div class=\"mfa-login-text\">{{\"LOGIN_MFA_SETUP\" | translate}}</div><div id=\"mfa-qrcode\" class=\"mfa-qrcode\" ng-if=\"ctrl.mfaOtpauthUrl\"></div><div class=\"mfa-secret\" ng-if=\"ctrl.mfaSecret\"><span>{{\"LOGIN_MFA_SECRET\" | translate}}</span> <strong>{{ctrl.mfaSecret}}</strong></div><a class=\"mfa-setup-link\" ng-if=\"ctrl.mfaOtpauthUrl && !ctrl.mfaQrAvailable\" ng-href=\"{{ctrl.mfaOtpauthUrl}}\">{{\"LOGIN_MFA_OPEN_APP\" | translate}}</a></div></div><div class=\"mfa-login-info\" ng-if=\"!ctrl.mfaSetup\"><div class=\"mfa-login-icon\"><i class=\"las la-lock\"></i></div><div class=\"mfa-login-content\"><div class=\"mfa-login-title\">{{\"LOGIN_MFA_VERIFY_TITLE\" | translate}}</div><div class=\"mfa-login-text\">{{\"LOGIN_MFA_ALREADY_SETUP\" | translate}}</div></div></div><div class=\"login-input-row\"><input type=\"text\" name=\"mfa_code\" ng-model=\"ctrl.form.mfa_code\" class=\"form-control\" ng-required=\"ctrl.mfaRequired\" ng-pattern=\"/^[0-9]{6}$/\" autocomplete=\"one-time-code\" placeholder=\'{{\"LOGIN_MFA_CODE\" | translate}}\'></div><div ng-messages=\"loginForm.mfa_code.$error\" class=\"ng-messages\" ng-show=\"loginForm.mfa_code.$dirty || loginForm.$submitted\" style=\"margin-right: 28px;\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div><div ng-message=\"pattern\">{{\"LOGIN_MFA_REQUIRED\" | translate}}</div><div ng-message=\"mfa\">{{\"LOGIN_MFA_INVALID\" | translate}}</div></div></div><div class=\"forgot-link\"><div class=\"form-check\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.remember\">{{\"LOGIN_REMEMBER\" | translate}}</label></div><a ui-sref=\"login.forgot_password\">{{\"LOGIN_FORGOT_PASS\" | translate}}</a></div><button type=\"submit\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" class=\"btn new full-width btn-login\">{{\"LOGIN_LOGIN\" | translate}}</button></form></div></div><div class=\"login-data-image\"></div></div>");
$templateCache.put("app/modules/marketing/marketing.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'marketing\')\"><div class=\"cloud mb-24\" ng-if=\"ctrl.tab != \'\'\"><div class=\"cloud-head\"><button class=\"btn icon default\" ng-click=\"ctrl.tab = \'\';\"><i class=\"las la-angle-right rotatable\"></i></button><h3 ng-if=\"ctrl.tab == \'sms\'\">{{ \"MARKETING_SMS\" | translate }}</h3><h3 ng-if=\"ctrl.tab == \'wa\'\">{{ \"MARKETING_WA\" | translate }}</h3><h3 ng-if=\"ctrl.tab == \'email\'\">{{ \"MARKETING_EMAIL\" | translate }}</h3></div><div><form action=\"\" method=\"\" name=\"reportsForm\" class=\"generate-report bg-white panel-rounded\" autocomplete=\"off\"><div class=\"\" ng-if=\"ctrl.tab == \'sms\' || ctrl.tab == \'wa\' || ctrl.tab == \'email\'\" id=\"reports-table\"><div class=\"tb-div\" ng-app=\"tabApp\"><div class=\"flex form fill fill-m\"><div class=\"flex form\"><div ng-include=\"\'app/components/cfilter/button.html\'\"></div><div ng-if=\"ctrl.tab == \'wa\' && ctrl.isTexterWa\" class=\"form-group last\"><app-dropdown model=\"ctrl.selectedTemplateKey\" options=\"ctrl.marketingTemplates\" label-prop=\"title\" value-prop=\"template_key\" placeholder=\"{{\'MARKETING_WA_TEMPLATE_SELECT\' | translate}}\"></app-dropdown></div><div><div class=\"actions\"><button type=\"button\" ng-click=\"ctrl.send_message();\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></div></div><div class=\"flex form fill fill-m\" ng-if=\"!(ctrl.tab == \'wa\' && ctrl.isTexterWa)\"><div class=\"mt-24\"><div class=\"form-group last with_upload\"><label>{{\"CUSTOMERS_CONTENT_MESSAGE\" | translate}}</label> <span ng-if=\"ctrl.tab == \'wa\'\" class=\"upload_file_paperclip\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"> <i class=\"la la-paperclip\"></i> <span ng-if=\"ctrl.files && ctrl.files.length\" class=\"remove\"><i class=\"las la-times\"></i></span></span> <button type=\"button\" style=\"margin: 0 10px; height: 24px;\" ng-click=\"ctrl.putVariable();\" class=\"btn text border-primary small\">{{\"MARKETING_PUT_CUSTOMER_NAME\" | translate}}</button> <textarea class=\"form-control\" maxlength=\"{{ctrl.smsMaxLength}}\" type=\"text\" name=\"message\" ng-model=\"ctrl.message\"></textarea></div></div></div></div></div></form></div></div><div class=\"cloud\" ng-if=\"ctrl.tab == \'sms\' || ctrl.tab == \'wa\' || ctrl.tab == \'email\'\"><div class=\"table-responsive\"><table id=\"cust_dt\" ng-table=\"ctrl.tableCustomers\" datatable=\"\" dt-instance=\"dtInstanceCustomers\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" class=\"table table-striped table-bordered table-hover dataTables-example reports-table customers-table\"></table></div></div><div class=\"cloud\" id=\"settings\" ng-if=\"ctrl.tab === \'\'\"><div class=\"all-reports--container\"><div class=\"all-reports--inner blue\"><div ng-click=\"ctrl.setTab(\'sms\')\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_SMS\" | translate }}</p></div></div><div class=\"all-reports--inner green\"><div ng-click=\"ctrl.setTab(\'wa\')\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-whatsapp\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_WA\" | translate }}</p></div></div><div class=\"all-reports--inner red\"><div ng-click=\"ctrl.setTab(\'email\')\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_EMAIL\" | translate }}</p></div></div><a ui-sref=\"app.marketing.automations\" class=\"all-reports--inner blue\"><div><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-magic\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_AUTOMATIONS\" | translate }}</p></div></a> <a ui-sref=\"app.marketing.recommendations\" class=\"all-reports--inner green\"><div><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-lightbulb\"></i></span><p class=\"all-reports--title\">{{ \"MARKETING_RECOMMENDATIONS\" | translate }}</p></div></a></div></div></div>");
$templateCache.put("app/modules/pay/pay.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h1 ng-if=\"!orderItem\" class=\"text-center\">{{\"ORDER_NOT_EXIST\" | translate}}</h1><h1 ng-if=\"orderItem && !orderItem.already_paid\" class=\"text-center\">{{\"ORDER_PAY_TITLE\" | translate}} {{orderItem.data.payments.pay_link.amount}}</h1><h1 ng-if=\"orderItem && orderItem.already_paid\" class=\"text-center\">{{\"ORDER_ALREADY_PAY\" | translate}}</h1></div><form class=\"modal-form_f\" name=\"signForm\" novalidate=\"\" ng-if=\"orderItem && !orderItem.already_paid\"><div class=\"modal-body\"><div class=\"panel-body pay-form\"><table class=\"table\" ng-if=\"items.length > 0\"><thead><tr><td>{{\"CUSTOMER_TRANSACTIONS_ITEM_DESC\" | translate}}</td><td>{{\"CUSTOMER_TRANSACTIONS_QUANTITY\" | translate}}</td><td></td><td>מחיר</td></tr></thead><tbody class=\"items\"><tr class=\"item\" ng-repeat=\"item in items\"><td><div class=\"item-inputs form-group last\"><label>{{item.name}}</label></div></td><td>{{item.quantity}}</td><td width=\"1%\" class=\"card-item-match\"><span ng-if=\"item.card_balance_used\"><i class=\"las la-ticket-alt\"></i></span></td><td class=\"price-spinner-data relative\"><div class=\"form-group last\">{{item.price}}</div></td></tr></tbody><tfoot class=\"checkout\"><tr><td><label>{{\"CALENDAR_CASH_TOTAL\" | translate}}</label></td><td></td><td></td><td><b>{{orderItem.data.payments.pay_link.amount | price:true}}</b></td></tr></tfoot></table><iframe ng-src=\"{{iframe()}}\" style=\"width:100%; height:100%; min-height: 700px;\" frameborder=\"0\" allow=\"payment; clipboard-write\"></iframe></div></div></form></div>");
$templateCache.put("app/modules/pdf-preview/pdf-preview.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\"></h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div ng-if=\"ctrl.pdfUrl\" class=\"modal-body\"><div class=\"pdf-preview\"><iframe ng-src=\"{{ctrl.pdfUrl}}\" style=\"width: 100%; height: calc(100vh - 68px); border: none;\"></iframe></div></div><div ng-if=\"ctrl.imageUrl\" class=\"modal-body\"><div class=\"image-preview\"><img ng-src=\"{{ctrl.imageUrl}}\" style=\"width: 100%; height: auto; border: none;\"></div></div></div>");
$templateCache.put("app/modules/prepaid/prepaid.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h1 ng-if=\"!orderItem\" class=\"text-center\">{{\"ORDER_NOT_EXIST\" | translate}}</h1><h1 ng-if=\"orderItem && !orderItem.already_paid\" class=\"text-center\">{{\"ORDER_PREPAID_TITLE\" | translate}} {{orderItem.business.prepaid}}</h1><h1 ng-if=\"orderItem && orderItem.already_paid\" class=\"text-center\">{{\"ORDER_ALREADY_PREPAID\" | translate}}</h1></div><form class=\"modal-form_f\" name=\"signForm\" novalidate=\"\" ng-if=\"orderItem && !orderItem.already_paid\"><div class=\"modal-body\"><div class=\"panel-body\"><iframe ng-src=\"{{iframe()}}\" style=\"width:100%; height:100%; min-height: 700px;\" frameborder=\"0\" allow=\"payment; clipboard-write\"></iframe></div></div></form></div>");
$templateCache.put("app/modules/reports/reports.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'reports\')\"><div class=\"cloud mb-24\" ng-if=\"ctrl.tab != 4\"><div class=\"cloud-head\"><button class=\"btn icon default\" ng-click=\"ctrl.tab = 4;ctrl.form.order_type = \'\';ctrl.report_is_finished=false;\"><i class=\"las la-angle-right rotatable\"></i></button><h3 ng-if=\"ctrl.tab == 2\">{{ \"REPORTS_CANCELED_ORDERS_HISTORY_LBL\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 3\">{{ \"REPORTS_INCOME_LBL\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 7\">{{\"CUSTOMERS_DEBTS_REPORT_TITLE\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 9\">{{\"REPORT_ORDERS_LBL\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 8\">{{\"WORKERS_TIME_REPORT\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 10\">{{ \"REPORTS_CUSTOMERS_TITLE\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 11\">{{ \"REPORTS_FEEDBACK_TITLE\" | translate }}</h3><h3 ng-if=\"ctrl.tab == 12\">{{\"REPORT_SALES\" | translate}}</h3><h3 ng-if=\"ctrl.tab == 13\">{{\"REPORT_CARDS\" | translate}}</h3></div><div><form action=\"\" method=\"\" name=\"reportsForm\" class=\"generate-report bg-white panel-rounded\" autocomplete=\"off\"><div class=\"fields\" ng-if=\"ctrl.tab !== 7\"><div class=\"test\" ng-app=\"tabApp\" ng-model=\"ctrl.form.order_type\"><div class=\"flex form fill-m\" ng-if=\"ctrl.tab == 10\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.gender\" options=\"ctrl.genderOptions\" value-prop=\"id\" disabled=\"ctrl.request_in_progress\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_GENDER\' | translate}}\" placeholder=\"{{\'CUSTOMERS_GENDER\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.card_exist\" options=\"ctrl.yesNoAllOptions\" value-prop=\"id\" disabled=\"ctrl.request_in_progress\" fixed-panel=\"true\" label=\"{{\'REPORT_CUSTOMERS_FIELDS_CARD_EXIST\' | translate}}\" placeholder=\"{{\'REPORT_CUSTOMERS_FIELDS_CARD_EXIST\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><label>{{\"REPORT_CUSTOMERS_FIELDS_LAST_VISIT\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-disabled=\"ctrl.request_in_progress\" ng-model=\"ctrl.form.last_visit\"></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.self_order\" options=\"ctrl.yesNoAllOptions\" value-prop=\"id\" disabled=\"ctrl.request_in_progress\" fixed-panel=\"true\" label=\"{{\'REPORT_CUSTOMERS_FIELDS_SELF_ORDER\' | translate}}\" placeholder=\"{{\'REPORT_CUSTOMERS_FIELDS_SELF_ORDER\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form fill-m\" ng-if=\"ctrl.tab !== 4 && ctrl.tab !== 10 && ctrl.tab !== 13\"><div ng-if=\"ctrl.tab == 9 || ctrl.tab === 3 || ctrl.tab === 12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.report_type\" options=\"ctrl.reportTypeOptions\" value-prop=\"id\" disabled=\"ctrl.request_in_progress\" required=\"true\" fixed-panel=\"true\" label=\"{{\'REPORT_TYPE\' | translate}}\" placeholder=\"{{\'REPORT_TYPE\' | translate}}\"></app-dropdown></div></div><div ng-if=\"ctrl.tab == 9 || ctrl.tab == 12\" ng-include=\"\'app/components/cfilter/button.html\'\"></div><div><div class=\"form-group icon-append\"><label for=\"report-start-date\">{{\"REPORT_FROM\" | translate}}</label> <input type=\"datetime\" date-time=\"\" auto-close=\"true\" fix-datepicker-position=\"\" ng-disabled=\"ctrl.request_in_progress\" class=\"form-control background-white\" id=\"report-start-date\" required=\"\" ng-model=\"ctrl.start_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div ng-if=\"ctrl.tab !== 4 && ctrl.tab !== 13\"><div class=\"form-group icon-append\"><label for=\"report-end-date\">{{\"REPORT_UNTIL\" | translate}}</label> <input type=\"datetime\" date-time=\"\" ng-disabled=\"ctrl.request_in_progress\" fix-datepicker-position=\"\" class=\"form-control background-white\" id=\"report-end-date\" required=\"\" ng-model=\"ctrl.end_date\" auto-close=\"true\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <i class=\"las la-calendar\"></i></div></div><div ng-if=\"ctrl.tab == 9 && ctrl.form.report_type == \'summary\'\"><div class=\"form-group\" style=\"width: 300px\"><app-dropdown model=\"ctrl.selectedStatuses\" options=\"ctrl.statusFilterOptions\" multiple=\"true\" searchable=\"true\" label-prop=\"label\" disabled=\"ctrl.request_in_progress\" fixed-panel=\"true\" label=\"{{\'FILTER_STATUSES\' | translate}}\" placeholder=\"{{\'FILTER_STATUSES_PLACEHOLDER\' | translate}}\" search-placeholder=\"{{\'FILTER_STATUSES_PLACEHOLDER\' | translate}}\"></app-dropdown></div></div><div ng-if=\"ctrl.tab == 12\"><div class=\"flex form fill-m\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.fields_customer\">{{\"SALES_REPORT_FIELD_CUSTOMER\" | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.fields_category\">{{\"SALES_REPORT_FIELD_CATEGORY\" | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.fields_resource\">{{\"SALES_REPORT_FIELD_RESOURCE\" | translate}}</label></div></div></div><div ng-if=\"ctrl.tab == 3 || ctrl.tab == 12 || ctrl.tab == 8\"><div class=\"flex form fill-m\"><div class=\"form-group\"><label>{{\"REPORT_EMAILS_LIST\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.emails_list\"></div></div></div><div ng-if=\"ctrl.tab == 3 && ctrl.dealer_type == \'licensed\'\"><div class=\"flex form fill-m\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.export_excel\">{{\"REPORT_EXPORT_EXCEL\" | translate}}</label></div></div></div></div></div><div class=\"flex gap-24\" ng-if=\"ctrl.tab !== 4\"><button type=\"button\" ng-click=\"ctrl.create_new_report(\'download\');\" ng-if=\"showDownloadBtn\" ng-disabled=\"reportsForm.$invalid || ctrl.request_in_progress || ctrl.tab === 1\" class=\"btn text border-green large\" ng-class=\"{\'loading\': ctrl.download_in_progress}\">{{\"REPORT_DOWNLOAD\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.create_new_report(\'preview\');\" ng-disabled=\"reportsForm.$invalid || ctrl.request_in_progress || ctrl.tab === 1\" ng-if=\"ctrl.tab !== 8\" class=\"btn text border-primary large\" ng-class=\"{\'loading\': ctrl.preview_in_progress}\">{{\"REPORT_PREVIEW\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.create_new_report(\'sendbymail\');\" ng-if=\"ctrl.tab != 11\" ng-disabled=\"reportsForm.$invalid || ctrl.request_in_progress || ctrl.tab === 1\" class=\"btn text primary large\" ng-class=\"{\'loading\': ctrl.send_in_progress}\">{{\"REPORT_SEND_MAIL\" | translate}}</button><table-column-settings ng-if=\"ctrl.tab == 9 && ctrl.form.report_type == \'detailed\'\" fields-list=\"ctrl.ordersReportFieldSettings\" icon-class=\"las la-eye\" inline=\"true\" title=\"{{\'TABLE_COLUMNS_SETTINGS\' | translate}}\" on-update=\"ctrl.onOrdersReportFieldsUpdate(fieldsList)\"></table-column-settings></div></div><div class=\"\" ng-if=\"ctrl.tab == 7\" id=\"reports-table\"><div class=\"tb-div\" ng-app=\"tabApp\"><div><div><div class=\"table-responsive\"><table ng-if=\"ctrl.tableData\" datatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover reports-table customers-debtors-table\"><thead><tr><th class=\"customer-name\">{{\"CUSTOMERS_NAME\" | translate}}</th><th class=\"customer-debt-header\">{{\"CUSTOMERS_DEBT_AMOUNT_TITLE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.showCustomersDetails(row.id)\"><td class=\"customer-name\"><div class=\"customer-pic-wrapper\"><img ng-src=\"{{row.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{row.firstname}} {{row.lastname}}</td><td class=\"customer-debt-cell\">{{row.oncredit | thousands}}</td><td><button type=\"button\" ng-click=\"ctrl.remind_customer_debt(row);$event.stopPropagation()\" class=\"btn text border-primary\">{{\"SEND_DEBTORS_MSG_BTN\" | translate}}</button> <a ui-sref=\"app.cashbox.closedebt({customer: {{row.id}}})\" class=\"close-debt btn text primary\">{{\"CUSTOMERS_OV_COV\" | translate}}</a></td></tr></tbody></table></div></div></div><div class=\"row\"></div></div></div></form></div></div><div class=\"cloud\" id=\"settings\" ng-if=\"ctrl.tab === 4\"><div class=\"all-reports--container\"><div class=\"all-reports--inner\"><div ng-click=\"ctrl.goToTransactions()\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-dollar-sign\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_TRANSACTIONS_HISTORY_LBL\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(2);ctrl.form.order_type=\'cancelled\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-times\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_CANCELED_ORDERS_HISTORY_LBL\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(3);ctrl.form.order_type=\'income\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-chart-bar\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_INCOME_LBL\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(7)\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-money-bill\"></i></span><p class=\"all-reports--title\">{{\"CUSTOMERS_DEBTS_REPORT_TITLE\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(9);ctrl.form.order_type=\'items\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-alt\"></i></span><p class=\"all-reports--title\">{{\"REPORT_ORDERS_LBL\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(8);ctrl.form.order_type=\'workers_time\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-alt\"></i></span><p class=\"all-reports--title\">{{\"WORKERS_TIME_REPORT\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(10);ctrl.form.order_type=\'customers\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-user-friends\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_CUSTOMERS_TITLE\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(11);ctrl.form.order_type=\'feedbacks\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-user-edit\"></i></span><p class=\"all-reports--title\">{{ \"REPORTS_FEEDBACK_TITLE\" | translate }}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(12);ctrl.form.order_type=\'sales\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-chart-line\"></i></span><p class=\"all-reports--title\">{{\"REPORT_SALES\" | translate}}</p></div></div><div class=\"all-reports--inner\"><div ng-click=\"ctrl.setTab(13);ctrl.form.order_type=\'cards\'\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-credit-card\"></i></span><p class=\"all-reports--title\">{{\"REPORT_CARDS\" | translate}}</p></div></div><div class=\"all-reports--inner\" ui-sref=\"app.reports.tax_files\"><div><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-invoice-dollar\"></i></span><p class=\"all-reports--title\">{{\"SETTINGS_TAX_FILES\" | translate}}</p></div></div></div></div><div class=\"cloud\" ng-if=\"ctrl.report_is_finished\"><div class=\"flex form\"><div><div class=\"form-group icon-prepend\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.searchTableData()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\" ng-if=\"showTable\"><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'cancelled\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_ORDER_DATE\" | translate}}</th><th>{{\"REPORT_CANCEL_DATE\" | translate}}</th><th>{{\"REPORT_CANCEL_REASON\" | translate}}</th><th>{{\"REPORT_CLIENT\" | translate}}</th><th>{{\"REPORT_CANCEL_USER\" | translate}}</th><th>{{\"REPORT_ITEM\" | translate}}</th><th>{{\"REPORT_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.order_date}}</td><td>{{row.cancel_date}}</td><td>{{row.cancel_reason}}</td><td>{{row.order_customer_firstname}} {{row.order_customer_lastname}}</td><td>{{row.cancel_user_name || \'\'}}</td><td>{{row.item_data.name}}</td><td>{{row.order_price | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'sales\' && ctrl.tableData\" dt-options=\"dtOptionsSales\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-show=\"ctrl.form.fields_customer\">{{\"SALES_REPORT_FIELD_CUSTOMER\" | translate}}</th><th ng-show=\"ctrl.form.report_type == \'detailed\'\">{{\"SALES_REPORT_FIELD_DATE\" | translate}}</th><th ng-show=\"ctrl.form.fields_category\">{{\"SALES_REPORT_FIELD_CATEGORY\" | translate}}</th><th ng-show=\"ctrl.form.fields_resource\">{{\"SALES_REPORT_FIELD_RESOURCE\" | translate}}</th><th>{{\"SALES_REPORT_FIELD_ITEM\" | translate}}</th><th>{{\"SALES_REPORT_FIELD_QTY\" | translate}}</th><th>{{\"SALES_REPORT_FIELD_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td ng-show=\"ctrl.form.fields_customer\">{{row.customer_name}}</td><td ng-show=\"ctrl.form.report_type == \'detailed\'\">{{row.date}}</td><td ng-show=\"ctrl.form.fields_category\">{{row.category}}</td><td ng-show=\"ctrl.form.fields_resource\">{{row.resource}}</td><td>{{row.item}}</td><td>{{row.qty}}</td><td>{{row.total | thousands}}</td></tr></tbody><tfoot><tr class=\"gradeX\"><td ng-show=\"ctrl.form.fields_customer\"></td><td ng-show=\"ctrl.form.report_type == \'detailed\'\"></td><td ng-show=\"ctrl.form.fields_category\"></td><td ng-show=\"ctrl.form.fields_resource\"></td><td></td><td><b>{{ctrl.calculateTotals().qty}}</b></td><td><b>{{ctrl.calculateTotals().total | thousands}}</b></td></tr></tfoot></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'income\' && ctrl.form.report_type == \'detailed\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_DOCUMENT_DATE\" | translate}}</th><th>{{\"REPORT_DOCUMENT_TYPE\" | translate}}</th><th>{{\"REPORT_DOCUMENT_NUMBER\" | translate}}</th><th>{{\"REPORT_TOTAL_BEFORE_VAT\" | translate}}</th><th>{{\"REPORT_VAT\" | translate}}</th><th>{{\"REPORT_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.document_date}}</td><td>{{row.document_type | translate}}</td><td>{{row.number}}</td><td>{{row.subtotal}}</td><td>{{row.vat}}</td><td>{{row.total | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'income\' && ctrl.form.report_type == \'summary\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_DOCUMENT_TYPE\" | translate}}</th><th>{{\"REPORT_QUANTITY\" | translate}}</th><th>{{\"REPORT_TOTAL_BEFORE_VAT\" | translate}}</th><th>{{\"REPORT_VAT\" | translate}}</th><th>{{\"REPORT_TOTAL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.document_type | translate}}</td><td>{{row.qty}}</td><td>{{row.subtotal | thousands}}</td><td>{{row.vat | thousands}}</td><td>{{row.total | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'customers\' && ctrl.tableData\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th>{{\"CUSTOMERS_LAST_VISIT\" | translate}}</th><th>{{\"CUSTOMERS_SHOWS\" | translate}}</th><th>{{\"CUSTOMERS_YEAR_INCOME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar ? row.avatar : \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{(row.firstname != null ? row.firstname : \'\')+\' \'+(row.lastname != null ? row.lastname : \'\')}}</td><td><span ng-hide=\"{{row.last_visit == \'01/01/1970\'}}\">{{row.last_visit}}</span></td><td>{{row.number_of_shows}}</td><td>{{row.current_year_income | thousands}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'items\' && ctrl.tableData && ctrl.form.report_type == \'detailed\'\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-repeat=\"field in ctrl.ordersReportVisibleFields track by field.name\">{{field.translationKey | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td ng-repeat=\"field in ctrl.ordersReportVisibleFields track by field.name\" ng-switch=\"field.name\"><span ng-switch-when=\"resource_name\">{{row.resource_name | translate}}</span> <span ng-switch-when=\"customer_name\">{{row.customer_name}}</span> <span ng-switch-when=\"customer_phone\">{{row.customer_phone}}</span> <span ng-switch-when=\"dealer_id\">{{row.dealer_id}}</span> <span ng-switch-when=\"order_status\">{{row.order_status_ttl}}</span> <span ng-switch-when=\"item_name\">{{row.item_name}}</span> <span ng-switch-when=\"order_date\">{{row.order_date}}</span> <span ng-switch-when=\"item_start_time\">{{row.item_start_time}}</span> <span ng-switch-when=\"item_end_time\">{{row.item_end_time}}</span> <span ng-switch-when=\"item_duration\">{{row.item_duration | hourAndMinuteWithZeros}}</span> <span ng-switch-when=\"item_price\">{{row.item_price | thousands}}</span> <span ng-switch-when=\"notes\">{{row.notes}}</span></td></tr></tbody><tfoot ng-if=\"ctrl.tableData[0].total_items_duration\"><tr class=\"gradeX\"><td ng-repeat=\"field in ctrl.ordersReportVisibleFields track by field.name\" ng-switch=\"field.name\"><span ng-switch-when=\"item_duration\">{{ctrl.tableData[0].total_items_duration}}</span> <span ng-switch-when=\"item_price\">{{ctrl.tableData[0].total_items_price}}</span></td></tr></tfoot></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'items\' && ctrl.tableData && ctrl.form.report_type != \'detailed\'\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_ORDERS_RES_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"SALES_REPORT_FIELD_CUSTOMER\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'detailed\'\">{{\"REPORT_ORDERS_ITEMS_AMOUNT_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_ORDER_STATUS_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_ITEM_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"REPORT_ORDERS_DATE_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"REPORT_ORDERS_START_COL\" | translate}}</th><th ng-if=\"ctrl.form.report_type != \'summary\'\">{{\"REPORT_ORDERS_END_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_HOURS_COL\" | translate}}</th><th>{{\"REPORT_ORDERS_PRICE_COL\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.resource_name | translate}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.customer_name}}</td><td ng-if=\"ctrl.form.report_type != \'detailed\'\">{{row.items_amount | translate}}</td><td>{{row.order_status_ttl}}</td><td>{{row.item_name}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.order_date}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.item_start_time}}</td><td ng-if=\"ctrl.form.report_type != \'summary\'\">{{row.item_end_time}}</td><td>{{row.item_duration | hourAndMinuteWithZeros}}</td><td>{{row.item_price | thousands}}</td></tr></tbody><tfoot ng-if=\"ctrl.tableData[0].total_items_duration\"><tr class=\"gradeX\"><td></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td ng-if=\"ctrl.form.report_type != \'detailed\'\">{{ctrl.tableData[0].total_items_amount}}</td><td></td><td></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td ng-if=\"ctrl.form.report_type != \'summary\'\"></td><td>{{ctrl.tableData[0].total_items_duration}}</td><td>{{ctrl.tableData[0].total_items_price}}</td></tr></tfoot></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'feedbacks\' && ctrl.tableData\" dt-options=\"dtOptionsFeedback\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_CUSTOMER\" | translate}}</th><th>{{\"REPORT_STARS\" | translate}}</th><th>{{\"REPORT_SERVICE\" | translate}}</th><th>{{\"REPORT_SERVICE_LEVEL\" | translate}}</th><th>{{\"REPORT_CLEAN_LEVEL\" | translate}}</th><th>{{\"REPORT_TEXT\" | translate}}</th><th>{{\"REPORT_DATE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.openOrderModal(row.order_id)\"><td>{{row.c_customer_name}}{{row.o_customer_name}}</td><td>{{row.stars}}</td><td>{{row.service}}</td><td>{{row.level_service}}</td><td>{{row.level_cleanliness}}</td><td>{{row.text}}</td><td>{{row.feedback_date}}</td></tr></tbody></table><table datatable=\"\" ng-if=\"ctrl.form.order_type == \'cards\' && ctrl.tableData\" dt-options=\"dtOptionsCards\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"REPORT_CARDS_CUSTOMER\" | translate}}</th><th>{{\"REPORT_CARDS_NAME\" | translate}}</th><th>{{\"REPORT_CARDS_BALANCE\" | translate}}</th><th>{{\"REPORT_CARDS_DATE_UPDATED\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.firstname}} {{row.lastname}}</td><td>{{row.name}}</td><td>{{row.balance | thousands}}</td><td>{{row.date_updated}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/review/review.view.html","<div class=\"modal-form-inner\" id=\"order\"><div class=\"modal-head\" ng-if=\"orderItem.id\"><div class=\"text-center\"><div class=\"business_logo\"><img height=\"100px\" src=\"{{orderItem.business_data.logo}}\"></div><div class=\"business_name\">{{orderItem.business_data.name}}</div><div class=\"business_address\">{{orderItem.business_data.address}}, {{orderItem.business_data.city}}</div></div></div><form class=\"modal-form_f\" name=\"feedbackForm\" novalidate=\"\" ng-if=\"orderItem.id && !ctrl.is_review\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"col-md-24 order-wrapper text-center\"><div class=\"feedback_title\">היי {{orderItem.customer_data.fullname}} נשמח לקבל דירוג ומשוב לשירות {{orderItem.services}} שקיבלת ב {{orderItem.order_date}} תודה {{orderItem.business_data.name}}</div><p>{{\"REQUEST_FEEDBACK_SERVICE\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.service >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 1\"></span> <span class=\"fa fa-star {{ctrl.service >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 2\"></span> <span class=\"fa fa-star {{ctrl.service >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 3\"></span> <span class=\"fa fa-star {{ctrl.service >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 4\"></span> <span class=\"fa fa-star {{ctrl.service >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.service = 5\"></span></div><p>{{\"REQUEST_FEEDBACK_LEVEL_SERVICE\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.level_service >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 1\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 2\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 3\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 4\"></span> <span class=\"fa fa-star {{ctrl.level_service >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_service = 5\"></span></div><p>{{\"REQUEST_FEEDBACK_LEVEL_CLEANLINESS\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.level_cleanliness >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 1\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 2\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 3\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 4\"></span> <span class=\"fa fa-star {{ctrl.level_cleanliness >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.level_cleanliness = 5\"></span></div><p>{{\"REQUEST_FEEDBACK_SUMMARY\" | translate}}</p><div class=\"stars\"><span class=\"fa fa-star {{ctrl.stars >= 1 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 1\"></span> <span class=\"fa fa-star {{ctrl.stars >= 2 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 2\"></span> <span class=\"fa fa-star {{ctrl.stars >= 3 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 3\"></span> <span class=\"fa fa-star {{ctrl.stars >= 4 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 4\"></span> <span class=\"fa fa-star {{ctrl.stars >= 5 ? \'checked\' : \'\'}}\" ng-click=\"ctrl.stars = 5\"></span></div><div class=\"feedback_text\"><textarea class=\"feedback_input\" rows=\"5\" required=\"\" ng-model=\"ctrl.feedback\" placeholder=\'{{\"REQUEST_FEEDBACK_PLACEHOLDER\" | translate}}\'></textarea></div></div></div></div><div class=\"modal-footer modal-footer-align-center feedback-footer\"><button ng-if=\"ctrl.stars > 0 && ctrl.service > 0 && ctrl.level_service > 0 && ctrl.level_cleanliness > 0\" ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn btn-w-m btn-primary\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form><div ng-if=\"ctrl.is_review\"><div class=\"modal-body\"><div class=\"panel-body\"><h1 class=\"text-center\">{{\"REQUEST_FEEDBACK_THANKS\" | translate}}</h1></div></div><div class=\"modal-footer modal-footer-align-center\"></div></div><div ng-if=\"!orderItem.id\"><div class=\"modal-body\"><div class=\"panel-body\"><h1 class=\"text-center\">{{\"REQUEST_FEEDBACK_EXIST\" | translate}}</h1></div></div><div class=\"modal-footer modal-footer-align-center\"></div></div></div>");
$templateCache.put("app/modules/settings/settings.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"><div class=\"cloud\"><div class=\"settings-block\"><h3 class=\"title\">{{\"SETTINGS_GENERAL\" | translate}}</h3><ul><li ng-if=\"isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.info\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-cog\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_DET\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_EDIT\" | translate}}</p></div></a></li><li ng-if=\"isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.color\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-tv\"></i></span><div><h6>{{\"SETTINGS_COLOR_DET\" | translate}}</h6><p>{{\"SETTINGS_COLOR_EDIT\" | translate}}</p></div></a></li><li ng-if=\"isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.online\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-calendar\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_ONLINE_DET\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_ONLINE_EDIT\" | translate}}</p></div></a></li><li ng-if=\"false && isUserAllowedAccess(\'business_settings_edit\')\"><a ui-sref=\"app.settings.landing\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-desktop\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_LANDING_DET\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_LANDING_EDIT\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.resources\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-user-tie\"></i></span><div><h6 ng-if=\"bu_type == 2\">{{\"SETTINGS_RESOURCE\" | translate}}</h6><p ng-if=\"bu_type == 2\">{{\"SETTINGS_RESOURCE_EDIT\" | translate}}</p><h6 ng-if=\"bu_type == 1\">{{\"SETTINGS_STAFF\" | translate}}</h6><p ng-if=\"bu_type == 1\">{{\"SETTINGS_STAFF_EDIT\" | translate}}</p></div></a></li><li ng-if=\"second_resource\"><a ui-sref=\"app.settings.second_resources\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-user-tie\"></i></span><div><h6>{{second_resource_name}} {{\"SETTINGS_SECOND_STAFF\" | translate}}</h6><p>{{second_resource_name}} {{\"SETTINGS_SECOND_STAFF_EDIT\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.items\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-cube\"></i></span><div><h6>{{\"SETTINGS_ITEMS\" | translate}}</h6><p>{{\"SETTINGS_ITEMS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.categories\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-th-large\"></i></span><div><h6>{{\"SETTINGS_CAT\" | translate}}</h6><p>{{\"SETTINGS_CAT_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.digital_documents\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-book\"></i></span><div><h6>{{\"SETTINGS_DIGITAL_DOCUMENTS\" | translate}}</h6><p>{{\"SETTINGS_DIGITAL_DOCUMENTS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.digital_forms\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-alt\"></i></span><div><h6>{{\"SETTINGS_DIGITAL_FORMS\" | translate}}</h6><p>{{\"SETTINGS_DIGITAL_FORMS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.laser_file\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-wrench\"></i></span><div><h6>{{\"SETTINGS_LASER_FILE\" | translate}}</h6><p>{{\"SETTINGS_LASER_FILE_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.call_logs\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-phone\"></i></span><div><h6>{{\"SETTINGS_CALL_LOGS\" | translate}}</h6><p>{{\"SETTINGS_CALL_LOGS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.sms_logs\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><div><h6>{{\"SETTINGS_SMS_LOGS\" | translate}}</h6><p>{{\"SETTINGS_SMS_LOGS_MANAGE\" | translate}}</p></div></a></li><li ng-if=\"manage_leads\"><a ui-sref=\"app.settings.leads\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-star\"></i></span><div><h6>{{\"SETTINGS_LEADS\" | translate}}</h6><p>{{\"SETTINGS_LEADS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.additional_fields\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{\"SETTINGS_ADDITIONAL_FIELDS\" | translate}}</h6><p>{{\"SETTINGS_ADDITIONAL_FIELDS_MANAGE\" | translate}}</p></div></a></li><li ng-if=\"ctrl.settings.courses\"><a ui-sref=\"app.settings.courses_fields\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{\"SETTINGS_COURSES_FIELDS\" | translate}}</h6><p>{{\"SETTINGS_COURSES_FIELDS_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.photos_stock\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-images\"></i></span><div><h6>{{\"SETTINGS_PHOTOS_STOCK\" | translate}}</h6><p>{{\"SETTINGS_PHOTOS_STOCK_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.gift_cards\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-gift\"></i></span><div><h6>{{\"SETTINGS_GIFT_CARDS\" | translate}}</h6><p>{{\"SETTINGS_GIFT_CARDS_DESCRIPTION\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.google_calendar\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"fa fa-google\"></i></span><div><h6>{{\"GOOGLE_CALENDAR_SETTINGS\" | translate}}</h6><p>{{\"GOOGLE_CALENDAR_SETTINGS_DESCRIPTION\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.telephony_settings\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-phone\"></i></span><div><h6>{{\"TELEPHONY_SETTINGS\" | translate}}</h6><p>{{\"TELEPHONY_SETTINGS_DESCRIPTION\" | translate}}</p></div></a></li><li ng-if=\"ctrl.settings.ai_agent_booking\"><a ui-sref=\"app.settings.ai_agents.agent_booking({ tab: \'settings\' })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-robot\"></i></span><div><h6>{{\"SETTINGS_AI_AGENTS\" | translate}}</h6><p>{{\"SETTINGS_AI_AGENTS_DESCRIPTION\" | translate}}</p></div></a></li><li ng-if=\"ctrl.settings.wa_api == \'official\'\"><a ui-sref=\"app.settings.business_whatsapp\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-whatsapp\"></i></span><div><h6>{{\"SETTINGS_BUSINESS_WHATSAPP\" | translate}}</h6><p>{{\"SETTINGS_BUSINESS_WHATSAPP_DESCRIPTION\" | translate}}</p></div></a></li><li ng-if=\"ctrl.settings.wa_api == \'texter\'\"><a ui-sref=\"app.settings.whatsapp_templates\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-whatsapp\"></i></span><div><h6>{{\"SETTINGS_WHATSAPP_TEMPLATES\" | translate}}</h6><p>{{\"SETTINGS_WHATSAPP_TEMPLATES_DESCRIPTION\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.accounting_settings\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-invoice\"></i></span><div><h6>{{\"ACCOUNTING_SETTINGS\" | translate}}</h6><p>{{\"ACCOUNTING_SETTINGS_DESCRIPTION\" | translate}}</p></div></a></li></ul></div><div class=\"settings-block\"><h3 class=\"title\">{{\"SETTINGS_DOC_MESS\" | translate}}</h3><ul><li><a ui-sref=\"app.settings.logs\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{\"SETTINGS_TRANSACTIONS\" | translate}}</h6><p>{{\"SETTINGS_TRANSACTION_VIEW\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.messages\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-comment\"></i></span><div><h6>{{\"SETTINGS_NOT_SET\" | translate}}</h6><p>{{\"SETTINGS_MES_SET\" | translate}}</p></div></a></li><li ng-if=\"false\"><a ui-sref=\"app.settings.digital_secretary\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-headset\"></i></span><div><h6>{{\"SETTINGS_DIGITAL_SECRETARY\" | translate}}</h6><p>{{\"SETTINGS_DIGITAL_SECRETARY_MANAGE\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/terms-of-use/terms-of-use.html","<h1>TERMS OF USE (MOBILE APP)</h1><h2>1. TERMS OF USE</h2><p>By downloading, browsing, accessing or using this Sample Store mobile application (“Mobile Application”), you agree to be bound by these Terms and Conditions of Use. We reserve the right to amend these terms and conditions at any time. If you disagree with any of these Terms and Conditions of Use, you must immediately discontinue your access to the Mobile Application and your use of the services offered on the Mobile Application. Continued use of the Mobile Application will constitute acceptance of these Terms and Conditions of Use, as may be amended from time to time.</p><h2>2. DEFINITIONS</h2><p>In these Terms and Conditions of Use, the following capitalised terms shall have the following meanings, except where the context otherwise requires: \"Account\" means an account created by a User on the Mobile Application as part of Registration. \"Merchant\" refers to any entity whose products or Samples can be purchased and/or redeemed (as the case may be) via the Mobile Application. \"Privacy Policy\" means the privacy policy set out in Clause 14 of these Terms and Conditions of Use. \"Redeem\" means to redeem a Merchant’s products or Samples on these Terms and Conditions of Use and \"Redemption\" means the act of redeeming such products or Samples. \"Register\" means to create an Account on the Mobile Application and \"Registration\" means the act of creating such an Account. \"Samples\" means samples of Merchant’s products and/or Merchant’s services, including without limitation, any vouchers for the redemption of such services, and \"Sample\" means any one of them. \"Services\" means all the services provided by Tiffulit smart management systems via the Mobile Application to Users, and \"Service\" means any one of them, \"Users\" means users of the Mobile Application, including you and \"User\" means any one of them.</p><h2>3. GENERAL ISSUES ABOUT THE MOBILE APPLICATION AND THE SERVICES</h2><p>3.1 Applicability of terms and conditions: The use of any Services and/or the Mobile Application and the making of any Redemptions are subject to these Terms and Conditions of Use.3.2 Location: The Mobile Application, the Services and any Redemptions are intended solely for use by Users who access the Mobile Application worldwide. 3.3 Scope: The Mobile Application, the Services and any Redemptions are for your non- commercial, personal use only and must not be used for business purposes. 3.4 Prevention on use: We reserve the right to prevent you using the Mobile Application and the Service (or any part of them) and to prevent you from making any Redemptions. 3.5 Equipment and Networks: The provision of the Services and the Mobile Application does not include the provision of a mobile telephone or handheld device or other necessary equipment to access the Mobile Application or the Services or make any Redemptions. To use the Mobile Application or Services or to make Redemptions, you will require Internet connectivity and appropriate telecommunication links. You acknowledge that the terms of agreement with your respective mobile network provider (\"Mobile Provider\") will continue to apply when using the Mobile Application. As a result, you may be charged by the Mobile Provider for access to network connection services for the duration of the connection while accessing the Mobile Application or any such third party charges as may arise. You accept responsibility for any such charges that arise. 3.6 Permission to use Mobile Application: If you are not the bill payer for the mobile telephone or handheld device being used to access the Mobile Application, you will be assumed to have received permission from the bill payer for using the Mobile Application. 3.7 License to Use Material: By submitting any text or images (including photographs) (“Material”) via the Application, you represent that you are the owner of the Material, or have proper authorization from the owner of the Material to use, reproduce and distribute it. You hereby grant us a worldwide, royalty-free, non-exclusive license to use the Material to promote any products or services.</p><h2>4. REDEMPTIONS</h2><p>4.1 Need for registration: You must Register to make a Redemption from the Mobile Application. 4.2 Application of these Terms and Conditions of Use: By making any Redemption, you acknowledge that the Redemption is subject to these Terms and Conditions of Use. 4.3 Redemption: Any attempted Redemption not consistent with these Terms and Conditions of Use may be disallowed or rendered void at our or the relevant Merchant’s discretion. 4.4 Responsibility for Redemptions of perishable products of Samples: Each Merchant shall be responsible to ensure that any of its products or Samples for Redemption that are perishable has not expired. 4.5 Restrictions: (a) Reproduction, sale, resale or trading of any products or Samples or Redeemed products is prohibited. (b) If any product or Sample is Redeemed for less than its face value, there is no entitlement to a credit, cash or Sample equal to the difference between the face value and the amount Redeemed. (c) Redemption of products or Samples is subject toavailability of the relevant Merchants’ stocks. 4.6 SingPost Not Liable: For the avoidance of doubt, shall not be liable for any losses or damages suffered by you resulting from a failure by the relevant Merchant to fulfil any Redemptions in accordance with Clause 4.4 or for a failure by us to deliver any products or Samples to you due to the unavailability of such products or Samples pursuant to Clause 4.5(c). 4.7 Lost/stolen Samples: Neither we nor any Merchant shall be responsible for lost or stolen Samples or products that have been Redeemed.</p><h2>5. LOCATION ALERTS AND NOTIFICATIONS</h2><p>5.1 You agree to receive pre-programmed notifications (“Location Alerts”) on the Mobile Application from Merchants if you have turned on locational services on your mobile telephone or other handheld devices (as the case may be).</p>6. YOUR OBLIGATIONS<p>6.1 Merchant terms: You agree to (and shall) abide by the terms and conditions of the relevant Merchant for which your Redemption relates to, as may be amended from time to time. 6.2 Accurate information: You warrant that all information provided on Registration and contained as part of your Account is true, complete and accurate and that you will promptly inform us of any changes to such information by updating the information in your Account. 6.3 Content on the Mobile Application and Service: It is your responsibility to ensure that any products, Samples or information available through the Mobile Application or the Services meet your specific requirements before making any Redemption. 6.4 Prohibitions in relation to usage of Services or Mobile Application: Without limitation, you undertake not to use or permit anyone else to use the Services or Mobile Application:- 6.4.1 to send or receive any material which is not civil or tasteful 6.4.2 to send or receive any material which is threatening, grossly offensive, of an indecent, obscene or menacing character, blasphemous or defamatory of any person, in contempt of court or in breach of confidence, copyright, rights of personality, publicity or privacy or any other third party rights; 6.4.3 to send or receive any material for which you have not obtained all necessary licences and/ or approvals (from us or third parties); or which constitutes or encourages conduct that would be considered a criminal offence, give rise to civil liability, or otherwise be contrary to the law of or infringe the rights of any third party in any country in the world; 6.4.4 to send or receive any material which is technically harmful (including computer viruses, logic bombs, Trojan horses, worms, harmful components, corrupted data or other malicious software or harmful data); 6.4.5 to cause annoyance, inconvenience or needless anxiety;6.4.6 to intercept or attempt to intercept any communications transmitted by way of a telecommunications system; 6.4.7 for a purpose other than which we have designed them or intended them to be used; 6.4.8 for any fraudulent purpose; 6.4.9 other than in conformance with accepted Internet practices and practices of any connected networks; 6.4.10 in any way which is calculated to incite hatred against any ethnic, religious or any other minority or is otherwise calculated to adversely affect any individual, group or entity; or 6.4.11 in such a way as to, or commit any act that would or does, impose an unreasonable or disproportionately large load on our infrastructure. 6.5 Prohibitions in relation to usage of Services, Mobile Application: Without limitation, you further undertake not to or permit anyone else to:- 6.5.1 resell any products or Samples ; 6.5.2 furnish false data including false names, addresses and contact details and fraudulently use credit/debit card numbers; 6.5.3 attempt to circumvent our security or network including to access data not intended for you, log into a server or account you are not expressly authorised to access, or probe the security of other networks (such as running a port scan); 6.5.4 execute any form of network monitoring which will intercept data not intended for you; 6.5.5 enter into fraudulent interactions or transactions with us or a Merchant (including interacting or transacting purportedly on behalf of a third party where you have no authority to bind that third party or you are pretending to be a third party); 6.5.6 extract data from or hack into the Mobile Application; 6.5.7 use the Services or Mobile Application in breach of these Terms and Conditions of Use; 6.5.8 engage in any unlawful activity in connection with the use of the Mobile Application or the Services; or 6.5.9 engage in any conduct which, in our exclusive reasonable opinion, restricts or inhibits any other customer from properly using or enjoying the Mobile Application or Services.</p><h2>7. RULES ABOUT USE OF THE SERVICE AND THE MOBILE APPLICATION</h2><p>7.1 We will use reasonable endeavours to correct any errors or omissions as soon as practicableafter being notified of them. However, we do not guarantee that the Services or the Mobile Application will be free of faults, and we do not accept liability for any such faults, errors or omissions. In the event of any such error, fault or omission, you should report it by contacting us at +972-48803377. 7.2 We do not warrant that your use of the Services or the Mobile Application will be uninterrupted and we do not warrant that any information (or messages) transmitted via the Services or the Mobile Application will be transmitted accurately, reliably, in a timely manner or at all. Notwithstanding that we will try to allow uninterrupted access to the Services and the Mobile Application, access to the Services and the Mobile Application may be suspended, restricted or terminated at any time. 7.3 We do not give any warranty that the Services and the Mobile Application are free from viruses or anything else which may have a harmful effect on any technology. 7.4 We reserve the right to change, modify, substitute, suspend or remove without notice any information or Services on the Mobile Application from time to time. Your access to the Mobile Application and/or the Services may also be occasionally restricted to allow for repairs, maintenance or the introduction of new facilities or services. We will attempt to restore such access as soon as we reasonably can. For the avoidance of doubt, we reserve the right to withdraw any information or Services from the Mobile Application at any time. 7.5 We reserve the right to block access to and/or to edit or remove any material which in our reasonable opinion may give rise to a breach of these Terms and Conditions of Use.</p><h2>8. SUSPENSION AND TERMINATION</h2><p>8.1 If you use (or anyone other than you, with your permission uses) the Mobile Application, any Services in contravention of these Terms and Conditions of Use, we may suspend your use of the Services and/or Mobile Application. 8.2 If we suspend the Services or Mobile Application, we may refuse to restore the Services or Mobile Application for your use until we receive an assurance from you, in a form we deem acceptable, that there will be no further breach of the provisions of these Terms and Conditions of Use. 8.3 Tiffulit smart management systems Ltd shall fully co-operate with any law enforcement authorities or court order requesting or directing Tiffulit smart management systems Ltd to disclose the identity or locate anyone in breach of these Terms and Conditions of Use. 8.4 Without limitation to anything else in this Clause 8, we shall be entitled immediately or at any time (in whole or in part) to: (a) suspend the Services and/or Mobile Application; (b) suspend your use of the Services and/or Mobile Application; and/or (c) suspend the use of the Services and/or Mobile Application for persons we believe to be connected (in whatever manner) to you, if: 8.4.1 you commit any breach of these Terms and Conditions of Use;8.4.2 we suspect, on reasonable grounds, that you have, might or will commit a breach of these Terms and Conditions of Use; or 8.4.3 we suspect, on reasonable grounds, that you may have committed or be committing any fraud against us or any person. 8.5 Our rights under this Clause 8 shall not prejudice any other right or remedy we may have in respect of any breach or any rights, obligations or liabilities accrued prior to termination.</p><h2>9. DISCLAIMER AND EXCLUSION OF LIABILITY</h2><p>9.1 The Mobile Application, the Services, the information on the Mobile Application and use of all related facilities are provided on an \"as is, as available\" basis without any warranties whether express or implied. 9.2 To the fullest extent permitted by applicable law, we disclaim all representations and warranties relating to the Mobile Application and its contents, including in relation to any inaccuracies or omissions in the Mobile Application, warranties of merchantability, quality, fitness for a particular purpose, accuracy, availability, non-infringement or implied warranties from course of dealing or usage of trade. 9.3 We do not warrant that the Mobile Application will always be accessible, uninterrupted, timely, secure, error free or free from computer virus or other invasive or damaging code or that the Mobile Application will not be affected by any acts of God or other force majeure events, including inability to obtain or shortage of necessary materials, equipment facilities, power or telecommunications, lack of telecommunications equipment or facilities and failure of information technology or telecommunications equipment or facilities. 9.4 While we may use reasonable efforts to include accurate and up-to-date information on the Mobile Application, we make no warranties or representations as to its accuracy, timeliness or completeness. 9.5 We shall not be liable for any acts or omissions of any third parties howsoever caused, and for any direct, indirect, incidental, special, consequential or punitive damages, howsoever caused, resulting from or in connection with the mobile application and the services offered in the mobile application, your access to, use of or inability to use the mobile application or the services offered in the mobile application, reliance on or downloading from the mobile application and/or services, or any delays, inaccuracies in the information or in its transmission including but not limited to damages for loss of business or profits, use, data or other intangible, even if we have been advised of the possibility of such damages. 9.6 We shall not be liable in contract, tort (including negligence or breach of statutory duty) or otherwise howsoever and whatever the cause thereof, for any indirect, consequential, collateral, special or incidental loss or damage suffered or incurred by you in connection with the Mobile Application and these Terms and Conditions of Use. For the purposes of these Terms and Conditions of Use, indirect or consequential loss or damage includes, without limitation, loss of revenue, profits, anticipated savings or business, loss of data or goodwill, loss of use or value of any equipment including software, claims of third parties, and all associated and incidental costsand expenses. 9.7 The above exclusions and limitations apply only to the extent permitted by law. None of your statutory rights as a consumer that cannot be excluded or limited are affected. 9.8 Notwithstanding our efforts to ensure that our system is secure, you acknowledge that all electronic data transfers are potentially susceptible to interception by others. We cannot, and do not, warrant that data transfers pursuant to the Mobile Application, or electronic mail transmitted to and from us, will not be monitored or read by others.</p><h2>10. INDEMNITY</h2><p>You agree to indemnify and keep us indemnified against any claim, action, suit or proceeding brought or threatened to be brought against us which is caused by or arising out of (a) your use of the Services, (b) any other party’s use of the Services using your user ID, verification PIN and/ or any identifier number allocated by Tiffulit smart management systems Ltd, and/or (c) your breach of any of these Terms and Conditions of Use, and to pay us damages, costs and interest in connection with such claim, action, suit or proceeding.</p><h2>11. INTELLECTUAL PROPERTY RIGHTS</h2><p>11.1 All editorial content, information, photographs, illustrations, artwork and other graphic materials, and names, logos and trade marks on the Mobile Application are protected by copyright laws and/or other laws and/or international treaties, and belong to us and/or our suppliers, as the case may be. These works, logos, graphics, sounds or images may not be copied, reproduced, retransmitted, distributed, disseminated, sold, published, broadcasted or circulated whether in whole or in part, unless expressly permitted by us and/or our suppliers, as the case may be. 11.2 Nothing contained on the Mobile Application should be construed as granting by implication, estoppel, or otherwise, any license or right to use any trademark displayed on the Mobile Application without our written permission. Misuse of any trademarks or any other content displayed on the Mobile Application is prohibited. 11.3 We will not hesitate to take legal action against any unauthorised usage of our trade marks, name or symbols to preserve and protect its rights in the matter. All rights not expressly granted herein are reserved. Other product and company names mentioned herein may also be the trade marks of their respective owners.</p><h2>12. AMENDMENTS</h2><p>12.1 We may periodically make changes to the contents of the Mobile Application, including to the descriptions and prices of goods and services advertised, at any time and without notice. We assume no liability or responsibility for any errors or omissions in the content of the Mobile Application. 12.2 We reserve the right to amend these Terms and Conditions of Use from time to time without notice. The revised Terms and Conditions of Use will be posted on the Mobile Application and shall take effect from the date of such posting. You are advised to review these terms and conditions periodically as they are binding upon you.</p><h2>13. APPLICABLE LAW AND JURISDICTION</h2><p>13.1 The Mobile Application can be accessed from all countries around the world where the local technology permits. As each of these places have differing laws, by accessing the Mobile Application both you and we agree that the laws of the Republic of Singapore, without regard to the conflicts of laws principles thereof, will apply to all matters relating to the use of the Mobile Application. 13.2 You accept and agree that both you and we shall submit to the exclusive jurisdiction of the courts of the state of Israel in respect of any dispute arising out of and/or in connection with these Terms and Conditions of Use.</p><h2>14. PRIVACY POLICY</h2><p>14.1 Access to the Mobile Application and use of the Services offered on the Mobile Application Tiffulit smart management systems Ltd and/or its group of companies is subject to this Privacy Policy. By accessing the Mobile Application and by continuing to use the Services offered, you are deemed to have accepted this Privacy Policy, and in particular, you are deemed to have consented to our use and disclosure of your personal information in the manner prescribed in this Privacy Policy and for the purposes set out in Clauses 3.7 and/or 4.1. We reserve the right to amend this Privacy Policy from time to time. If you disagree with any part of this Privacy Policy, you must immediately discontinue your access to the Mobile Application and your use of the Services. 14.2 As part of the normal operation of our Services, we collect, use and, in some cases, disclose information about you to third parties. Accordingly, we have developed this Privacy Policy in order for you to understand how we collect, use, communicate and disclose and make use of your personal information when you use the Services on the Mobile Application:- (a) Before or at the time of collecting personal information, we will identify the purposes for which information is being collected. (b) We will collect and use of personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned or as required by law. (c) We will only retain personal information as long as necessary for the fulfillment of those purposes. (d) We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned. (e) Personal information should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date. (f) We will protect personal information by reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.</p>");
$templateCache.put("app/modules/tutorials_center/tutorials_center.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"tutorials_center\"><div class=\"cloud\"><div class=\"settings-block\"><div class=\"tutorials-container\"><div ng-if=\"ctrl.loading\" class=\"loading-container\"><div class=\"spinner\"></div></div><div ng-if=\"ctrl.error\" class=\"error-container\"><i class=\"las la-exclamation-triangle\"></i><p>{{ctrl.error}}</p><button class=\"btn text large border-red\" ng-click=\"ctrl.loadVideos()\">{{\"TUTORIALS_CENTER_RETRY\" | translate}}</button></div><div ng-if=\"!ctrl.loading && !ctrl.error\" class=\"videos-grid\"><div ng-repeat=\"video in ctrl.videos\" class=\"video-card\" ng-click=\"ctrl.openVideo(video)\"><div class=\"video-thumbnail\"><img ng-src=\"{{video.thumbnail || \'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\'}}\" alt=\"{{video.title}}\" class=\"thumbnail-image\" ng-class=\"{\'no-thumbnail\': !video.thumbnail}\"><div class=\"play-overlay\"><i class=\"las la-play\"></i></div></div><div class=\"video-info\"><h3 class=\"video-title\">{{video.title}}</h3></div></div></div><div ng-if=\"!ctrl.loading && !ctrl.error && ctrl.videos.length === 0\" class=\"empty-state\"><i class=\"las la-video\"></i><h3>{{\"TUTORIALS_CENTER_NO_VIDEOS\" | translate}}</h3><p>{{\"TUTORIALS_CENTER_NO_VIDEOS_TEXT\" | translate}}</p></div></div></div></div></div>");
$templateCache.put("app/modules/tutorials_center/video.modal.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\"><i class=\"las la-play-circle\"></i> {{vm.video.title}}</h3><a class=\"close\" ng-click=\"vm.close();\">&times;</a></div><div class=\"modal-body\"><div class=\"video-embed-wrapper\"><iframe ng-if=\"!vm.isCustom\" width=\"100%\" height=\"400\" ng-src=\"{{vm.getEmbedUrl()}}\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe><video ng-if=\"vm.isCustom\" width=\"100%\" height=\"400\" controls=\"\" autoplay=\"\" ng-src=\"{{vm.getEmbedUrl()}}\">{{\"TUTORIALS_VIDEO_NOT_SUPPORTED\" | translate}}</video></div><p class=\"video-description\" ng-if=\"vm.video.description\">{{vm.video.description}}</p></div><div class=\"modal-footer\"><button class=\"btn text large\" ng-click=\"vm.close()\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <a ng-if=\"!vm.isCustom\" class=\"btn text large primary\" ng-click=\"vm.stopVideo();\" target=\"_blank\" ng-href=\"https://www.youtube.com/watch?v={{vm.video.videoId}}\">{{\"OPEN_ON_YOUTUBE\" | translate}}</a></div></div>");
$templateCache.put("app/components/app/app-button/app-button.view.html","<button type=\"{{$ctrl.type || \'button\'}}\" class=\"{{$ctrl.classes}}\" ng-disabled=\"$ctrl.disabled || $ctrl.loading\" ng-click=\"$ctrl.handleClick($event)\"><i ng-if=\"$ctrl.icon\" class=\"{{$ctrl.icon}}\"></i><ng-transclude></ng-transclude></button>");
$templateCache.put("app/components/app/app-dropdown/app-dropdown.view.html","<div class=\"app-dropdown\" ng-class=\"{ \'is-open\': $ctrl.isOpen, \'is-dropup\': $ctrl.dropup, \'is-disabled\': $ctrl.disabled, \'is-multiple\': $ctrl.multiple, \'is-fixed-panel\': $ctrl.fixedPanel, \'is-required-invalid\': $ctrl.isRequiredInvalid() }\" ng-click=\"$event.stopPropagation()\"><label class=\"app-dropdown__label\" ng-if=\"$ctrl.label\"><span class=\"required\" ng-if=\"$ctrl.isRequired()\">*</span> {{$ctrl.label}}</label> <input type=\"text\" class=\"app-dropdown__validator\" tabindex=\"-1\" aria-hidden=\"true\" ng-model=\"$ctrl.model\" ng-required=\"$ctrl.isRequiredInvalid()\"><div class=\"app-dropdown__control\"><div class=\"app-dropdown__trigger\" ng-class=\"{\'app-dropdown__trigger--expanded\': $ctrl.multiple && $ctrl.expandTriggerForAllTags && $ctrl.getSelectedItems().length}\" ng-style=\"{\'background-color\': $ctrl.getTriggerBackground()}\" ng-click=\"$ctrl.toggle($event)\"><div class=\"app-dropdown__chips\" ng-class=\"{\'app-dropdown__chips--wrap\': $ctrl.expandTriggerForAllTags}\" ng-if=\"$ctrl.multiple && $ctrl.getSelectedItems().length\"><span class=\"app-dropdown__chip\" ng-repeat=\"item in $ctrl.getSelectedItems() | limitTo: $ctrl.getVisibleChipsLimit()\" ng-attr-title=\"$ctrl.getLabel(item)\"><span class=\"app-dropdown__chip-label\">{{$ctrl.getLabel(item)}}</span> <button type=\"button\" class=\"app-dropdown__chip-remove\" ng-click=\"$ctrl.removeChip($event, item)\"><i class=\"las la-times\"></i></button></span> <span class=\"app-dropdown__chip app-dropdown__chip--more\" ng-if=\"$ctrl.getHiddenChipsCount() > 0\">{{$ctrl.getMoreLabel()}}</span></div><span class=\"app-dropdown__value\" ng-if=\"!$ctrl.multiple && $ctrl.getDisplayLabel() !== null\"><img ng-if=\"$ctrl.getOptionImage($ctrl.getSelectedOption())\" ng-src=\"{{$ctrl.getOptionImage($ctrl.getSelectedOption())}}\" class=\"app-dropdown__option-image\" alt=\"\"> <i ng-if=\"$ctrl.getCardBadgeState($ctrl.getSelectedOption())\" ng-class=\"{ \'las la-ticket-alt\': true, \'expired\': $ctrl.getCardBadgeState($ctrl.getSelectedOption()) === \'expired\' }\"></i> {{$ctrl.getDisplayLabel()}}</span><span class=\"app-dropdown__placeholder\" ng-if=\"$ctrl.multiple ? !$ctrl.getSelectedItems().length : $ctrl.getDisplayLabel() === null\">{{$ctrl.placeholder}}</span><button type=\"button\" class=\"app-dropdown__clear\" ng-if=\"$ctrl.showClear && (($ctrl.multiple && $ctrl.getSelectedItems().length) || (!$ctrl.multiple && $ctrl.getDisplayLabel() !== null))\" ng-click=\"$ctrl.clearAll($event)\"><i class=\"las la-times\"></i></button><i class=\"las la-angle-down app-dropdown__arrow\"></i></div><div class=\"app-dropdown__panel\" ng-class=\"{ \'app-dropdown__panel--fixed\': $ctrl.fixedPanel, \'app-dropdown__panel--dropup\': $ctrl.dropup }\" ng-if=\"$ctrl.isOpen\" ng-style=\"$ctrl.panelStyle\"><div class=\"app-dropdown__search\" ng-if=\"$ctrl.searchable\"><i class=\"las la-search\"></i> <input type=\"text\" class=\"app-dropdown__search-input\" ng-model=\"$ctrl.searchQuery\" placeholder=\"{{$ctrl.searchPlaceholder || \'...\'}}\"></div><div class=\"app-dropdown__options\"><div class=\"app-dropdown__option\" ng-class=\"{\'is-selected\': $ctrl.isSelected(opt)}\" ng-style=\"{\'background-color\': $ctrl.getOptionBackground(opt)}\" ng-repeat=\"opt in $ctrl._options | filter:$ctrl.searchFilter track by $index\" ng-click=\"$ctrl.select(opt)\"><span ng-if=\"$ctrl.multiple\" class=\"app-dropdown__checkbox\" ng-class=\"{\'is-checked\': $ctrl.isSelected(opt)}\"></span> <img ng-if=\"$ctrl.getOptionImage(opt)\" ng-src=\"{{$ctrl.getOptionImage(opt)}}\" class=\"app-dropdown__option-image\" alt=\"\"><span class=\"app-dropdown__option-label\"><i ng-if=\"$ctrl.getCardBadgeState(opt)\" ng-class=\"{ \'las la-ticket-alt\': true, \'expired\': $ctrl.getCardBadgeState(opt) === \'expired\' }\"></i> {{$ctrl.getLabel(opt)}}</span><i ng-if=\"!$ctrl.multiple && $ctrl.isSelected(opt)\" class=\"las la-check app-dropdown__option-check\"></i></div><div class=\"app-dropdown__option app-dropdown__option--create\" ng-if=\"$ctrl.canCreateOption()\" ng-click=\"$ctrl.createOption($event)\"><span class=\"app-dropdown__option-label\">{{$ctrl.searchQuery}} (new)</span></div><div class=\"app-dropdown__empty\" ng-if=\"!($ctrl._options | filter:$ctrl.searchFilter).length && !$ctrl.canCreateOption()\"><i class=\"las la-search\"></i> <span>{{$ctrl.searchQuery ? \'No results\' : \'No options\'}}</span></div></div></div></div></div>");
$templateCache.put("app/components/app/app-input/app-input.view.html","<div class=\"app-input\" ng-class=\"{ \'is-disabled\': $ctrl.disabled, \'is-simple\': $ctrl.simple, \'has-error\': !!$ctrl.error, \'has-value\': $ctrl.hasValue() }\"><label class=\"app-input__label\" ng-if=\"$ctrl.label\"><span class=\"required\" ng-if=\"$ctrl.required\">*</span> {{$ctrl.label}}</label><div class=\"app-input__control\"><input ng-if=\"!$ctrl.multiline && $ctrl.value === undefined\" class=\"form-control app-input__field\" type=\"{{$ctrl.type}}\" name=\"{{$ctrl.name}}\" ng-model=\"$ctrl.model\" ng-change=\"$ctrl.handleChange()\" ng-blur=\"$ctrl.handleBlur($event)\" ng-focus=\"$ctrl.handleFocus($event)\" ng-disabled=\"$ctrl.disabled\" ng-readonly=\"$ctrl.readonly\" ng-required=\"$ctrl.required\" ng-attr-maxlength=\"{{$ctrl.maxlength}}\" placeholder=\"{{$ctrl.placeholder}}\"> <input ng-if=\"!$ctrl.multiline && $ctrl.value !== undefined\" class=\"form-control app-input__field\" type=\"{{$ctrl.type}}\" name=\"{{$ctrl.name}}\" ng-value=\"$ctrl.value\" ng-blur=\"$ctrl.handleBlur($event)\" ng-focus=\"$ctrl.handleFocus($event)\" ng-disabled=\"$ctrl.disabled\" readonly=\"\" ng-required=\"$ctrl.required\" placeholder=\"{{$ctrl.placeholder}}\"><textarea ng-if=\"$ctrl.multiline\" class=\"form-control app-input__field app-input__field--textarea\" name=\"{{$ctrl.name}}\" rows=\"{{$ctrl.rows}}\" ng-model=\"$ctrl.model\" ng-change=\"$ctrl.handleChange()\" ng-blur=\"$ctrl.handleBlur($event)\" ng-focus=\"$ctrl.handleFocus($event)\" ng-disabled=\"$ctrl.disabled\" ng-readonly=\"$ctrl.readonly\" ng-required=\"$ctrl.required\" ng-attr-maxlength=\"{{$ctrl.maxlength}}\" placeholder=\"{{$ctrl.placeholder}}\">\n    </textarea><button type=\"button\" class=\"app-input__clear\" ng-if=\"$ctrl.clearable && $ctrl.hasValue() && !$ctrl.readonly && !$ctrl.disabled\" ng-click=\"$ctrl.clear()\"><i class=\"las la-times\"></i></button><div class=\"input-loader\" ng-if=\"$ctrl.loading\"><i class=\"las la-spinner\"></i></div></div><div class=\"app-input__messages\"><div class=\"input-hint error visible\" ng-if=\"$ctrl.error\">{{$ctrl.error}}</div><div class=\"input-hint visible\" ng-if=\"!$ctrl.error && $ctrl.hint\">{{$ctrl.hint}}</div></div></div>");
$templateCache.put("app/components/app/app-textarea-mask/app-textarea-mask.view.html","<div class=\"app-textarea-mask\" ng-class=\"{ \'is-open\': $ctrl.isOpen, \'is-disabled\': $ctrl.disabled }\" ng-click=\"$event.stopPropagation()\"><label class=\"app-textarea-mask__label\" ng-if=\"$ctrl.label\">{{$ctrl.label}}</label><div class=\"app-textarea-mask__control\"><textarea class=\"form-control app-textarea-mask__field\" rows=\"{{$ctrl.rows}}\" ng-model=\"$ctrl.model\" ng-trim=\"$ctrl.trim\" ng-change=\"$ctrl.handleChange()\" ng-disabled=\"$ctrl.disabled\" ng-readonly=\"$ctrl.readonly\" placeholder=\"{{$ctrl.placeholder}}\">\n    </textarea> <button type=\"button\" class=\"app-textarea-mask__toggle\" ng-if=\"$ctrl.hasMasks()\" ng-disabled=\"$ctrl.disabled || $ctrl.readonly\" ng-click=\"$ctrl.toggleMasks($event)\" title=\"{{\'SETTINGS_DIGITAL_SECRETARY_INSERT_MASK\' | translate}}\"><i class=\"las la-tags\"></i></button><div class=\"app-textarea-mask__popup\" ng-if=\"$ctrl.isOpen\"><div class=\"app-textarea-mask__popup-title\">{{\"SETTINGS_DIGITAL_SECRETARY_INSERT_MASK\" | translate}}</div><div class=\"app-textarea-mask__grid\"><button type=\"button\" class=\"btn text small border-primary\" ng-repeat=\"mask in $ctrl.masks track by (mask.key || $index)\" ng-click=\"$ctrl.insertMask($event, mask)\" ng-attr-title=\"{{$ctrl.getMaskTitle(mask) | translate}}\">{{$ctrl.getMaskLabel(mask) | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/cfilter/store-filter/store-filter.html","<div class=\"modal-form-inner\" id=\"store-filter\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"STORE_FILTER_MODAL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"STORE_FILTER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\"></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.default\" \"=\"\">{{\"STORE_FILTER_DEFAULT\" | translate}}</label></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/modules/calendar/order/order.form.html","<div id=\"order\" class=\"modal-form-inner\"><div class=\"modal-head\"><a class=\"btn icon default\" ng-click=\"$close();\"><i class=\"las la-angle-right rotatable\"></i></a><div class=\"flex\"><h3 class=\"form-title\" ng-if=\"!ctrl.is_edit && !ctrl.event\">{{\"CALENDAR_NEW_ORDER\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"ctrl.is_edit && !ctrl.event\">{{(ctrl.order ? ctrl.order.number : \'\')}} # {{\"CALENDAR_ORDER_NUM\" | translate}} {{ctrl.course ? ctrl.course.id : \'\'}}<a ng-if=\"ctrl.course && ctrl.course.id\" href=\"javascript:;\" ng-click=\"ctrl.copyId(ctrl.course.id)\" class=\"btn icon\"><i class=\"las la-copy\"></i></a></h3><h3 class=\"form-title\" ng-if=\"ctrl.is_edit && ctrl.event\">{{ctrl.order.number}} # {{\"CALENDAR_EVENT_FORM_LABEL\" | translate}}</h3><div class=\"form-sub-title\" ng-if=\"ctrl.order && ctrl.bu_type == 2 && ctrl.is_edit && ctrl.approved_date != null\">{{\"CALENDAR_APPROVED_ORDER\" | translate}} <span class=\"form-approved-date\">{{ctrl.approved_date}}</span></div><div class=\"form-sub-title\" ng-if=\"ctrl.order && ctrl.order.prepaid && !ctrl.business.stop_messages\">{{\"ORDER_MODAL_PREPAID_TITLE\" | translate}} {{ctrl.order.prepaid}}</div><button type=\"button\" class=\"btn icon\" ng-if=\"ctrl.is_edit && ctrl.order && ctrl.order.session_id_book\" ng-click=\"ctrl.openAiSession()\"><i class=\"ai-icon\"></i></button></div></div><form name=\"orderForm\" ng-submit=\"ctrl.send_order_form()\"><div ng-if=\"!ctrl.confirm_delete\"><div class=\"modal-body\" id=\"order-modal-body\" ng-class=\"{\'two-btns-only\': !ctrl.is_edit}\"><div class=\"panel-body\"><div ng-if=\"ctrl.bu_type == 1 && !ctrl.form.isCourse\" ng-include=\"\'app/modules/calendar/order/order.stores.form.html\'\"></div><div ng-if=\"ctrl.bu_type == 2\" ng-include=\"\'app/modules/calendar/order/order.motels.form.html\'\"></div><div ng-if=\"ctrl.bu_type == 1 && ctrl.form.isCourse\" ng-include=\"\'app/modules/calendar/order/order.stores_course.form.html\'\"></div><div class=\"order-summary\" ng-if=\"!ctrl.hide_prices && !ctrl.form.isEvent && !ctrl.form.isCourse\"><div class=\"inner\"><div class=\"price-line\" ng-if=\"ctrl.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_BEFORE\" | translate}}</span> <span class=\"price\">{{ctrl.form.subtotal | price}}</span></div><div class=\"price-line\" ng-if=\"ctrl.dealer_type == \'licensed\'\"><span class=\"title\">{{\"CALENDAR_ORDER_VAT\" | translate}} (%{{ctrl.dealer_vat}})</span> <span class=\"price\">{{ctrl.form.tax | price}}</span></div><div class=\"price-line\"><span class=\"title\">{{\"CALENDAR_ORDER_TOTAL\" | translate}}</span> <span class=\"price\">{{ctrl.form.total | price}}</span></div></div></div></div></div><div class=\"modal-footer order-modal-buttons\"><div class=\"flex gap-8 nowrap\"><span ng-repeat=\"document in ctrl.order.documents\" ng-if=\"ctrl.order && ctrl.order.status == 3 && ctrl.order.documents\"><a ng-href=\"{{document[\'document_invoice_receipt\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_invoice_receipt\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV_TAX\" | translate}}</a> <a ng-href=\"{{document[\'document_invoice\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_invoice\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV\" | translate}}</a> <a ng-href=\"{{document[\'document_receipt\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_receipt\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_ACC\" | translate}}</a> <a ng-href=\"{{document[\'document_proforma_invoice\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_proforma_invoice\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV_TR\" | translate}}</a> <a ng-href=\"{{document[\'document_credit\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_credit\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_INV_CR\" | translate}}</a> <a ng-href=\"{{document[\'document_cards-document\'].file}}\" target=\"_blank\" ng-if=\"document[\'document_cards-document\'].file\" class=\"btn text large success\">{{\"SETTINGS_LOG_CARD_TR\" | translate}}</a></span></div><div ng-if=\"([1, 6].indexOf(ctrl.order.status) === -1)\" class=\"flex gap-8 nowrap\"><button type=\"button\" ng-click=\"ctrl.decline_order();$close();\" ng-if=\"ctrl.order.status == 4\" class=\"btn text large border-red\">{{\"CALENDAR_ORDER_DECLINE_BOOKING\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.delete_event();\" ng-if=\"ctrl.is_edit && ctrl.event\" class=\"btn text large border-red\">{{\"CALENDAR_EVENT_DELETE_BTN\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send_order_prepaid();\" ng-if=\"ctrl.is_prepaid && ctrl.order && ctrl.form.phone && ([3, 4, 7].indexOf(ctrl.order.status) === -1) && ! ctrl.order.prepaid\" class=\"btn text large border-pink\">{{\"CALENDAR_ORDER_PREPAID\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send_order_sms();\" ng-if=\"ctrl.order && ctrl.form.phone && ctrl.order.status == 0\" class=\"btn text large border-blue\">{{\"CALENDAR_ORDER_SMS\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.send_approval_request();\" ng-if=\"ctrl.bu_type == 2 && ctrl.is_edit\" class=\"btn text large border-primary\">{{\"CALENDAR_ORDER_APPROVE\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.goToCashbox();\" ng-if=\"ctrl.order && cashbox_available && ctrl.is_edit && ([3, 4, 7].indexOf(ctrl.order.status) === -1) && !ctrl.is_full_prepaid\" class=\"btn text large border-orange\">{{\"CALENDAR_ORDER_CHECKOUT\" | translate}}</button> <a ng-click=\"ctrl.completeOrder(ctrl.order.id, (ctrl.order.status == 7 || ctrl.is_full_prepaid))\" ng-if=\"ctrl.is_edit && ([3, 4].indexOf(ctrl.order.status) === -1) && !ctrl.event && !ctrl.course\" class=\"btn text large border-green\">{{ctrl.order.status == 7 || ctrl.is_full_prepaid ? \"CALENDAR_ORDER_CLOSE_PAID\" : \"CALENDAR_ORDER_COMPLETED\" | translate}}</a></div><div ng-if=\"ctrl.is_edit && ctrl.form.isCourse && ctrl.form.meetings.length <= 1\" class=\"flex gap-8 nowrap\"><button type=\"button\" ng-click=\"ctrl.deleteCourse()\" class=\"btn text large border-red\">{{\"CALENDAR_COURSE_DELETE\" | translate}}</button></div><div class=\"flex gap-8 nowrap\"><button type=\"button\" ng-click=\"ctrl.confirm_delete = true\" ng-if=\"showCancelBtn\" class=\"btn text large border-red\">{{\"CALENDAR_ORDER_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.goBack();$close();\" class=\"btn text large border-primary\">{{\"CALENDAR_ORDER_RETURN\" | translate}}</button> <button type=\"submit\" ng-click=\"\" ng-if=\"!(ctrl.order && [1, 6, 3, 4].indexOf(ctrl.order.status) !== -1) || ctrl.allow_edit\" class=\"btn text large primary\" ng-disabled=\"orderForm.$invalid || (ctrl.isNoCustomerSelected() && !ctrl.form.isEvent && !ctrl.form.isCourse)\">{{\"CALENDAR_ORDER_SAVE\" | translate}}</button> <button type=\"submit\" ng-click=\"\" ng-if=\"ctrl.order && ctrl.order.status == 4\" class=\"btn text large border-primary\" ng-disabled=\"orderForm.$invalid\">{{\"CALENDAR_ORDER_APPROVE_BOOKING\" | translate}}</button></div></div></div><div class=\"message-wrapper order-cancel-wrapper\" ng-if=\"ctrl.confirm_delete\"><div class=\"modal-body\"><div class=\"panel-body\"><p>{{\"CALENDAR_ORDER_CANCEL_SENTENCE_START\" | translate}} <b>{{ctrl.order.id}}</b>?<br><b>{{\"CALENDAR_ORDER_CANCEL_SENTENCE_CENTER\" | translate}}</b>{{\"CALENDAR_ORDER_CANCEL_SENTENCE_END\" | translate}}. <i class=\"fa fa-info\"></i></p><div class=\"row cancel-reason\"><div class=\"col-md-5\"><div class=\"form-group last\"><app-dropdown model=\"ctrl.form.cancelReason\" options=\"ctrl.cancelReasonOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_CANCEL_REASON\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_CANCEL_REASON_SELECT\' | translate}}\"></app-dropdown></div><div ng-if=\"ctrl.form.repeat_id\" class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.all_repeatable\">{{\'CALENDAR_ORDER_CANCEL_ALL_REPEATABLE\' | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.discardSms\">{{\'CALENDAR_ORDER_CANCEL_SMS\' | translate}}</label></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"ctrl.confirm_delete = false\" class=\"btn text large primary\">{{\"CALENDAR_ORDER_CANCEL_PREV\" | translate}}</button> <button type=\"button\" ng-disabled=\"orderForm.$invalid\" ng-click=\"ctrl.cancel_order();\" class=\"btn text large border-red\">{{\"CALENDAR_ORDER_CANCEL_OK\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/calendar/order/order.motels.form.html","<div class=\"row\" ng-click=\"containerClicked()\"><div class=\"col-md-12 order-wrapper\" ng-class=\"{\'disabled\': ([1, 6, 3].indexOf(ctrl.order.status) !== -1)}\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-8 no-padding\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select\"><div class=\"customer-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectCustomer()\"></div><div class=\"customer-pic-wrapper\" ng-if=\"ctrl.form.customer.id\" ui-sref=\"app.customers.single({id: {{ctrl.form.customer.id}}})\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-required=\"!ctrl.form.randomCustomer\" class=\"form-control customer-input\"><ul id=\"searchResult\"><li ng-click=\"chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul><button type=\"button\" ng-click=\"ctrl.addNewCustomer();\" class=\"btn btn-primary add-new-customer\" ng-if=\"!ctrl.form.randomCustomer && !ctrl.is_edit\"><i class=\"las la-user-plus\"></i></button></div></div></div><div class=\"col-md-4 col-xs-4 no-padding\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.randomCustomer\" ng-change=\"ctrl.random_customer_changed();\" value=\"1\">{{\'CALENDAR_ORDER_OCC\' | translate}}</label></div></div><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.order_date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-xs-6 no-padding\" ng-if=\"ctrl.isMobile && ctrl.form.phone && ctrl.business.id == 1\"><div class=\"form-group\"><a href=\"{{ \'tel:\' + ctrl.form.phone }}\" class=\"btn btn-w-m btn-success\">{{\"CALENDAR_ORDER_CALL_BTN\" | translate}} <span class=\"glyphicon glyphicon-earphone\"></span></a></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label>{{\"CUSTOMER_FULL_NAME\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.customer_name\" ng-required=\"ctrl.form.randomCustomer\"></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-4 no-padding\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PHONE\" | translate}}</label> <input type=\"tel\" class=\"form-control\" ng-model=\"ctrl.form.phone\" ng-required=\"ctrl.form.randomCustomer\"> <span ng-if=\"ctrl.form.randomCustomer\"><input type=\"checkbox\" ng-model=\"ctrl.allow_sending\"> {{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</span></div></div><div class=\"col-md-4 col-xs-4 no-padding\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_EMAIL\" | translate}}</label> <input type=\"email\" class=\"form-control\" placeholder=\"example@gmail.com\" ng-model=\"ctrl.form.email\"></div></div><div class=\"col-md-4 col-xs-4 no-padding\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.club\" options=\"ctrl.clubs\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_ORDER_CLUB\' | translate}}\" placeholder=\"בחר\" fixed-panel=\"true\"></app-dropdown></div></div></div><div class=\"order-item\" ng-repeat=\"($orderItemIndex, orderItem) in ctrl.form.items\"><h3 ng-if=\"orderItem.item_type == \'service\'\" class=\"item-type-h3\">{{\"SERVICE\" | translate}}</h3><h3 ng-if=\"orderItem.item_type == \'sale\'\" class=\"item-type-h3\">{{\"SALE\" | translate}}</h3><input type=\"number\" style=\"display: none;\" ng-model=\"orderItem.nights\" ng-required=\"orderItem.item==\'service\'\" min=\"1\"> <a ng-click=\"ctrl.remove_item_from_order($orderItemIndex)\" ng-hide=\"ctrl.form.items.length == 1\" class=\"remove-item\"><i class=\"fa fa-remove\"></i></a><div class=\"flex form\"><div class=\"col-md-4 col-xs-8 no-padding item-wrapper\"><div class=\"items-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectItem($orderItemIndex, orderItem)\"></div><label>{{\"CALENDAR_ORDER_SERVICE\" | translate}} <i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': ctrl.hasCustomerCardForItem(orderItem.item_id) === \'expired\'}\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-if=\"ctrl.hasCustomerCardForItem(orderItem.item_id) && ctrl.isMobile\"></i></label><app-dropdown ng-if=\"ctrl.items\" model=\"orderItem.item_id\" options=\"ctrl.getOrderItemOptions(orderItem)\" value-prop=\"id\" label-prop=\"order_dropdown_label\" placeholder=\"בחר פריט לשיוך\" fixed-panel=\"true\" with-tooltip=\"true\" required=\"true\" on-change=\"ctrl.order_item_resource_change($orderItemIndex)\"></app-dropdown></div><div class=\"col-md-4 col-xs-4 no-padding resource-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><app-dropdown model=\"orderItem.resource\" options=\"ctrl.resources\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_ORDER_RESOURCE\' | translate}}\" placeholder=\"בחר משאב\" required=\"true\" fixed-panel=\"true\"></app-dropdown></div><div class=\"col-md-4 col-xs-12 no-padding guest-name-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_NAME_GUEST\" | translate}}</label> <input type=\"text\" ng-model=\"orderItem.name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12 no-padding start-time-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ENTRY_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control hide-input\" ng-click=\"ctrl.setNightsType(0)\" ng-change=\"ctrl.motels_update_item_nights($orderItemIndex)\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"orderItem.start_time\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-xs-12 no-padding duration-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_RELEASE_DATE\" | translate}}</label> <input type=\"datetime\" id=\"order_check_out\" ng-change=\"ctrl.motels_update_item_nights($orderItemIndex)\" auto-close=\"true\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"orderItem.end_time\" view=\"date\" min-view=\"date\" ng-click=\"ctrl.setNightsType(0)\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-xs-6 no-padding price-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-12 col-xs-12 no-padding number-wrapper\"><div class=\"form-group\" ng-class=\"orderItem.nights === 0 ? \'notvalid\' : \'\'\"><label>{{\"CALENDAR_NIGHTS_NUMBER\" | translate}}</label><input-number-spinner ng-mouseenter=\"ctrl.setNightsType(1)\" data-ng-model=\"orderItem.nights\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div></div><div class=\"col-md-4 col-xs-6 no-padding price-wrapper\"><label>{{\"CALENDAR_ORDER_PRICE\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"orderItem.item.price\" ng-required=\"orderItem.item_type == \'sale\'\"></div><div class=\"col-md-4 col-xs-6 no-padding number-wrapper\" ng-if=\"orderItem.item_type == \'sale\'\"><label>{{\"CALENDAR_ORDER_QUANTITY\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.item.quantity\" ng-required=\"orderItem.item_type == \'sale\'\" data-input-number-spinner-min=\"0\"></input-number-spinner></div><div class=\"col-md-12 col-xs-12 no-padding notes-wrapper\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_REMARKS\" | translate}}</label> <textarea class=\"form-control\" ng-model=\"orderItem.notes\" placeholder=\"כאן תוכל להכניס מידע הרלוונטי לפריט זה\"></textarea></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-4 col-xs-4 no-padding number-wrapper adults-wrapper\"><div class=\"form-group\" ng-class=\"orderItem.adults === 0 ? \'notvalid\' : \'\'\"><label>{{\"CALENDAR_ORDER_ADULTS\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.adults\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div><div class=\"col-md-4 col-xs-4 no-padding number-wrapper kids-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_CHILDREN\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.kids\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div><div class=\"col-md-4 col-xs-4 no-padding number-wrapper babies-wrapper\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_BABIES\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.babies\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-12 no-padding\"><div class=\"item-summary\" ng-if=\"orderItem.item && orderItem.nights > 0\"><b>סה\"כ: {{orderItem.item.price * orderItem.nights | price}}</b></div></div></div></div><button type=\"button\" ng-click=\"ctrl.add_service_item();\" class=\"btn btn-nostyle\" ng-if=\"!ctrl.form.randomCustomer\"><span class=\"btn-plus inline-icon-btn\"></span> {{\"CALENDAR_ORDER_SERVICE_ADD\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.add_sales_item();\" class=\"btn btn-nostyle\" ng-if=\"!ctrl.form.randomCustomer\"><span class=\"btn-plus inline-icon-btn\"></span> {{\"CALENDAR_ORDER_SALES_ADD\" | translate}}</button><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.credit_card\">{{\'CALENDAR_ORDER_SECURITY\' | translate}}</label></div></div></div>");
$templateCache.put("app/modules/calendar/order/order.stores.form.html","<div class=\"row\" ng-click=\"containerClicked()\"><div class=\"order-wrapper\" ng-class=\"{\'disabled\': ([1, 6, 3].indexOf(ctrl.order.status) !== -1)}\"><div class=\"event-order-switch flex form\"><div ng-if=\"!ctrl.is_edit\"><div class=\"form-group last\" style=\"margin-bottom: 10px;\"><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"0\"> <label>{{\"ORDER_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"1\"> <label>{{\"EVENT_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div ng-if=\"ctrl.business.courses\" class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"2\"> <label>{{\"COURSE_ORDER_SWITCHER_LABEL\" | translate}}</label></div></div></div><div ng-if=\"ctrl.form.isEvent\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.all_day\" ng-disabled=\"ctrl.is_edit\">{{\"EVENT_ORDER_ALL_DAY_LABEL\" | translate}}</label></div></div><div ng-if=\"((ctrl.form.isEvent) || (!ctrl.form.isEvent && !ctrl.is_edit))\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.repeat\" ng-disabled=\"ctrl.is_edit\">{{ctrl.form.isEvent ? \"EVENT_ORDER_REPEAT_LABEL\" : \"ORDER_REPEAT_LABEL\" | translate}}</label></div></div><div ng-if=\"!ctrl.form.isEvent && ctrl.form.repeat\" class=\"form-group\"><app-dropdown model=\"ctrl.form.period\" options=\"ctrl.orderRepeatPeriodOptions\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_ORDER_REPEAT_PERIOD\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_REPEAT_PERIOD\' | translate}}\" disabled=\"ctrl.is_edit\" required=\"ctrl.form.repeat\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"!ctrl.form.isEvent && ctrl.form.repeat\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_REPEAT_COUNT\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.form.repeat_count\" max=\"50\" min=\"1\" ng-disabled=\"ctrl.is_edit\"></div></div><div ng-if=\"ctrl.form.isEvent && ctrl.form.repeat\" class=\"form-group\"><app-dropdown model=\"ctrl.form.period\" options=\"ctrl.eventRepeatPeriodOptions\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_ORDER_REPEAT\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_REPEAT\' | translate}}\" disabled=\"ctrl.is_edit\" required=\"ctrl.form.repeat\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"ctrl.form.isEvent && ctrl.form.repeat\"><div class=\"form-group\"><label>{{\"CALENDAR_END_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.endDate\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\" ng-disabled=\"ctrl.is_edit\"></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-group clearfix customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select\"><div class=\"customer-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectCustomer()\"></div><div class=\"customer-pic-wrapper no-margin\" ng-if=\"ctrl.form.customer.id\" ui-sref=\"app.customers.single({id: {{ctrl.form.customer.id}}})\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-required=\"!ctrl.form.randomCustomer\" ng-model=\"ctrl.customer_search_name\" class=\"form-control customer-input\"><ul id=\"searchResult\"><li ng-click=\"chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul><button type=\"button\" ng-click=\"ctrl.addNewCustomer();\" class=\"btn icon default large\" ng-if=\"!ctrl.form.randomCustomer && !ctrl.is_edit\"><i class=\"las la-user-plus\"></i></button></div></div></div><div class=\"col-md-4 col-xs-12 no-padding flex nowrap top gap-16\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-change=\"ctrl.random_customer_changed();\" ng-model=\"ctrl.form.randomCustomer\">{{\"CALENDAR_ORDER_OCC\" | translate}}</label></div><div class=\"col-md-5 col-xs-12 no-padding visible-xs\" ng-if=\"ctrl.is_edit && !ctrl.form.isEvent && ((ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone) || (ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3))\"><div class=\"flex gap-8\"><a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}\"><i class=\"lab la-whatsapp\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered blue\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"tel:{{(ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone)}}\"><i class=\"las la-phone\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn text small border-green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}?text={{ctrl.reminderText()}}\"><i class=\"lab la-whatsapp\"></i>{{\"CALENDAR_WA_REMINDER\" | translate}}</a> <button type=\"button\" ng-if=\"ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3\" class=\"btn icon small bordered red\" ng-click=\"ctrl.approveArrival();\"><i class=\"las la-thumbs-up\" style=\"color: red;\"></i></button></div></div></div><div class=\"col-md-3 col-xs-12 no-padding\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.request_feedback\">{{\"SETTINGS_REQUEST_FEEDBACK\" | translate}}</label></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.randomCustomer\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label>{{\"CUSTOMER_FULL_NAME\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.customer_name\" ng-required=\"ctrl.form.randomCustomer\"></div></div><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PHONE\" | translate}}</label> <input type=\"tel\" class=\"form-control\" ng-model=\"ctrl.form.phone\" ng-required=\"ctrl.form.randomCustomer\"></div></div><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-check\" ng-if=\"ctrl.form.randomCustomer\"><label><input type=\"checkbox\" ng-model=\"ctrl.allow_sending\"> {{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</label></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><label class=\"text-nowrap\">{{\"CALENDAR_ORDER_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <span class=\"select-holiday-name\">{{ctrl.holidayName}}</span></div></div><div class=\"col-md-8 col-xs-12 no-padding\" ng-if=\"!ctrl.form.isEvent && !ctrl.form.isCourse && !ctrl.form.randomCustomer && ctrl.form.customer && !ctrl.form.isEdit\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.not_send_message\"> {{\"SETTINGS_USER_NOT_SEND_MESSAGE\" | translate}}</label></div></div><div class=\"col-md-8 col-xs-12 no-padding hidden-xs\" ng-if=\"ctrl.is_edit && !ctrl.form.isEvent && ((ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone) || (ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3))\"><div class=\"flex gap-16\"><a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}\"><i class=\"lab la-whatsapp\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn icon circle small bordered blue\" ng-click=\"d(); $event.stopPropagation();\" tooltip2=\"{{ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone}}\" target=\"_blank\" href=\"tel:{{(ctrl.form.randomCustomer ? ctrl.form.phone : ctrl.form.customer.phone)}}\"><i class=\"las la-phone\"></i></a> <a ng-if=\"(ctrl.form.phone && ctrl.form.randomCustomer) || (!ctrl.form.randomCustomer && ctrl.form.customer && ctrl.form.customer.phone)\" class=\"btn text small border-green\" ng-click=\"d(); $event.stopPropagation();\" target=\"_blank\" href=\"https://wa.me/{{ctrl.waPhone()}}?text={{ctrl.reminderText()}}\"><i class=\"lab la-whatsapp\"></i>{{\"CALENDAR_WA_REMINDER\" | translate}}</a> <button type=\"button\" ng-if=\"ctrl.form.approval_sent*1 == 1 || ctrl.form.approval_sent*1 == 3\" class=\"btn icon small bordered red\" ng-click=\"ctrl.approveArrival();\"><i class=\"las la-thumbs-up\" style=\"color: red;\"></i></button></div></div><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"ctrl.form.isEvent\"><div class=\"form-group\"><label for=\"event-description\">{{\"EVENT_DESCRIPTION_LABEL\" | translate}}</label> <input type=\"text\" id=\"event-description\" class=\"form-control\" ng-model=\"ctrl.form.event_description\"></div></div></div><div class=\"order-item\" ng-repeat=\"($orderItemIndex, orderItem) in ctrl.form.items\"><h3 ng-if=\"orderItem.item_type == \'service\' && !ctrl.form.isEvent\" class=\"item-type-h3\">{{\"SERVICE\" | translate}}</h3><h3 ng-if=\"orderItem.item_type == \'sale\' && !ctrl.form.isEvent\" class=\"item-type-h3\">{{\"SALE\" | translate}}</h3><a ng-click=\"ctrl.remove_item_from_order($orderItemIndex)\" ng-hide=\"ctrl.form.items.length == 1\" class=\"remove-item\"><i class=\"fa fa-remove\"></i></a><div class=\"flex form\" ng-if=\"!ctrl.form.isEvent\"><div class=\"col-md-4 col-xs-12 no-padding item-wrapper\"><div class=\"items-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectItem($orderItemIndex, orderItem)\"></div><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_ITEM_ASSOCIATE\" | translate}} <i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': ctrl.hasCustomerCardForItem(orderItem.item_id) === \'expired\'}\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-if=\"ctrl.hasCustomerCardForItem(orderItem.item_id) && ctrl.isMobile\"></i></label><app-dropdown ng-if=\"ctrl.items\" model=\"orderItem.item_id\" options=\"ctrl.getOrderItemOptions(orderItem)\" label-prop=\"order_dropdown_label\" value-prop=\"id\" searchable=\"true\" required=\"true\" fixed-panel=\"true\" with-tooltip=\"true\" on-change=\"ctrl.order_item_resource_change($orderItemIndex)\" placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-4 col-xs-6 no-padding\" ng-hide=\"ctrl.hide_prices\" ng-if=\"!ctrl.form.isEvent\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_PRICE\" | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"orderItem.item.price\" ng-required=\"orderItem.item_type == \'sale\'\"></div></div><div class=\"col-md-4 col-xs-6 no-padding number-wrapper\" ng-if=\"orderItem.item_type == \'sale\' && !ctrl.form.isEvent\"><div class=\"mb-24\"><label>{{\"CALENDAR_ORDER_QUANTITY\" | translate}}</label><input-number-spinner data-ng-model=\"orderItem.item.quantity\" ng-required=\"orderItem.item_type == \'sale\'\" data-input-number-spinner-min=\"0\"></input-number-spinner></div></div><div ng-class=\"orderItem.item_type == \'sale\' ? \'col-xs-12\' : \'col-xs-6\'\" class=\"col-md-4 no-padding\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"form-group\"><app-dropdown require=\"true\" model=\"orderItem.resource\" options=\"ctrl.activeResources\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\'\"><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"ctrl.form.isEvent\"><div class=\"form-group\"><app-dropdown require=\"true\" model=\"ctrl.form.event_resource_ids\" options=\"ctrl.activeResources\" value-prop=\"id\" multiple=\"true\" searchable=\"true\" fixed-panel=\"true\" on-change=\"ctrl.syncEventPrimaryResource()\" label=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\"></app-dropdown></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown model=\"orderItem.start_time\" options=\"ctrl.dates.hours\" required=\"true\" fixed-panel=\"true\" on-change=\"ctrl.changeStartTime($orderItemIndex)\" label=\"{{\'CALENDAR_ORDER_START_TIME\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_START_TIME\' | translate}}\"></app-dropdown></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown model=\"orderItem.duration\" options=\"ctrl.dates.duration\" label-prop=\"label\" value-prop=\"duration\" disabled=\"!orderItem.item_id && !ctrl.form.isEvent\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_LENGTH\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_LENGTH\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\" ng-if=\"orderItem.item_type == \'service\' && orderItem.item && orderItem.item.break && !ctrl.form.isEvent\"><div class=\"col-xs-12 no-padding\"><h3>{{orderItem.item.name_second}}</h3><div class=\"form-check second-part-check\"><label><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"orderItem.enabled_second\" ng-change=\"ctrl.enable_second_change($orderItemIndex)\">{{\"CALENDAR_ORDER_ENABLED_SECOND\" | translate}}</label></div></div></div><div class=\"flex form\" ng-if=\"orderItem.enabled_second && !ctrl.form.isEvent\"><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown require=\"true\" model=\"orderItem.resource_second\" options=\"ctrl.activeResources\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_WORKER2\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_WORKER2\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_WORKER2\' | translate}}\"></app-dropdown></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown model=\"orderItem.start_time_second\" options=\"ctrl.dates.hours\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_START_TIME2\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_START_TIME2\' | translate}}\"></app-dropdown></div></div><div ng-if=\"!ctrl.form.all_day\" class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown model=\"orderItem.duration_second\" options=\"ctrl.dates.duration\" label-prop=\"label\" value-prop=\"duration\" disabled=\"!orderItem.item_id && !ctrl.form.isEvent\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_LENGTH2\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_LENGTH2\' | translate}}\"></app-dropdown></div></div></div></div><div class=\"flex form top\" ng-if=\"!ctrl.form.isEvent\"><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"!ctrl.form.randomCustomer && !ctrl.form.isEvent\"><div ng-if=\"ctrl.order.status != 7\" class=\"flex between mb-8 relative\">{{\"CALENDAR_ORDER_SERVICE_ITEM\" | translate}}<div class=\"flex between gap-8\"><div class=\"dropdown-container\" ng-class=\"{ open: ctrl.showMultiServiceDropdown }\" click-outside=\"ctrl.closeDropdown()\"><button type=\"button\" class=\"btn icon default\" tooltip2=\"{{\'CALENDAR_ORDER_SERVICE_ITEM_MULTIPLE_TOOLTIP\' | translate}}\" ng-click=\"ctrl.toggleDropdown($event)\"><i class=\"las la-list-alt\"></i></button><div class=\"dropdown\" ng-if=\"ctrl.showMultiServiceDropdown\" ng-animate=\"\'dropdown\'\"><input type=\"text\" class=\"form-control dropdown-filter\" ng-model=\"ctrl.multiServiceFilterText\" placeholder=\"{{\'SERVICE_ITEM_MULTIPLE_FILTER_ITEMS\' | translate}}\"><div class=\"dropdown-items\"><label class=\"dropdown-item\" ng-repeat=\"item in ctrl.items | filter:filterItems({item_type: \'service\', \'item_id\': null}) | filter:ctrl.multiServiceFilterText | orderBy:getItemPriority\" ng-click=\"ctrl.toggleItem(item.id)\"><span class=\"multicheck\" ng-class=\"{checked: ctrl.isSelected(item.id)}\"></span> {{ item.name }}</label></div></div></div><button type=\"button\" ng-click=\"ctrl.add_service_item();\" class=\"btn text primary short\">{{\"CALENDAR_ORDER_SERVICE_ADD_BUTTON\" | translate}}</button></div></div><div ng-if=\"ctrl.order.status != 7\" class=\"flex between mb-8\">{{\"CALENDAR_ORDER_SALES\" | translate}} <button type=\"button\" ng-click=\"ctrl.add_sales_item();\" class=\"btn text short primary\">{{\"CALENDAR_ORDER_SALES_ADD_BUTTON\" | translate}}</button></div></div><div class=\"col-md-8 col-xs-12 no-padding\"><div class=\"flex form top\"><div class=\"col-md-6 col-xs-6 no-padding order-images-col\"><p>{{\"CALENDAR_ORDER_IMAGES_BEFORE\" | translate}}</p><div class=\"flex column\"><label ng-repeat=\"(i, k) in ctrl.images_count\" ng-class=\"{\'import-image\': true, \'w-image\': !ctrl.form[\'image_before\'+k] || ctrl.form[\'image_before\'+k] == \'\', \'first\': ctrl.checkFirstWImage(\'image_before\', k)}\"><input ng-if=\"!ctrl.form[\'image_before\'+k] || ctrl.form[\'image_before\'+k] == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image_before{{k}}\" type=\"file\" accept=\"image/*\" ng-click=\"ctrl.allow_edit = true;\" ng-disabled=\"[1, 6].indexOf(ctrl.order.status) !== -1\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form[\'image_before\'+k] && ctrl.form[\'image_before\'+k] != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, ctrl.form[\'image_before\'+k]);\"><img ng-src=\"{{ctrl.form[\'image_before\'+k]}}\"></div><span class=\"filename\">{{ctrl.form[\'image_before\'+k].substring(ctrl.form[\'image_before\'+k].lastIndexOf(\'/\') + 1)}}<br><a class=\"download-link\" href=\"{{ctrl.form[\'image_before\'+k]}}\" download=\"\" target=\"_blank\" ng-click=\"$event.stopPropagation()\">{{\"CALENDAR_ORDER_IMAGES_DOWNLOAD_LINK\" | translate}}</a></span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event, \'image_before\'+k)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!ctrl.form[\'image_before\'+k] || ctrl.form[\'image_before\'+k] == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div><div class=\"col-md-6 col-xs-6 no-padding order-images-col\"><p>{{\"CALENDAR_ORDER_IMAGES_AFTER\" | translate}}</p><div class=\"flex column\"><label ng-repeat=\"(i, k) in ctrl.images_count\" ng-class=\"{\'import-image\': true, \'w-image\': !ctrl.form[\'image_after\'+k] || ctrl.form[\'image_after\'+k] == \'\', \'first\': ctrl.checkFirstWImage(\'image_after\', k)}\"><input ng-if=\"!ctrl.form[\'image_after\'+k] || ctrl.form[\'image_after\'+k] == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image_after{{k}}\" type=\"file\" accept=\"image/*\" ng-click=\"ctrl.allow_edit = true;\" ng-disabled=\"[1, 6].indexOf(ctrl.order.status) !== -1\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form[\'image_after\'+k] && ctrl.form[\'image_after\'+k] != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, ctrl.form[\'image_after\'+k]);\"><img ng-src=\"{{ctrl.form[\'image_after\'+k]}}\"></div><span class=\"filename\">{{ctrl.form[\'image_after\'+k].substring(ctrl.form[\'image_after\'+k].lastIndexOf(\'/\') + 1)}}<br><a class=\"download-link\" href=\"{{ctrl.form[\'image_after\'+k]}}\" download=\"\" target=\"_blank\" ng-click=\"$event.stopPropagation()\">{{\"CALENDAR_ORDER_IMAGES_DOWNLOAD_LINK\" | translate}}</a></span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event, \'image_after\'+k)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!ctrl.form[\'image_after\'+k] || ctrl.form[\'image_after\'+k] == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div></div><div ng-if=\"ctrl.form.customer\" class=\"flex gap-16 order-l-df-buttons mt-8\"><button type=\"button\" ng-click=\"ctrl.show_laser_file();\" class=\"btn text border-primary\">{{\"CALENDAR_ORDER_LASER_FILE\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.add_form();\" class=\"btn text border-primary\">{{\"CALENDAR_ORDER_DIGITAL_FORM\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.open_medical_note();\" class=\"btn text\" ng-class=\"{\'border-primary\': !ctrl.pending_medical_note_id && !ctrl.order.medical_note_id, \'primary\': ctrl.pending_medical_note_id || ctrl.order.medical_note_id}\">{{\"CALENDAR_ORDER_MEDICAL_NOTE\" | translate}}</button></div></div></div><div class=\"flex form\" style=\"margin-top: 15px;\" ng-if=\"!ctrl.form.isEvent\"><div class=\"col-xs-12 no-padding\"><div class=\"form-group last\" audio-recorder=\"\" audio-model=\"ctrl.form.notes\"><label>{{\"CALENDAR_ORDER_REMARKS\" | translate}}</label> <textarea auto-expand=\"\" class=\"form-control\" ng-model=\"ctrl.form.notes\" placeholder=\"כאן תוכל להכניס מידע הרלוונטי להזמנה זו\" ng-change=\"ctrl.allow_edit = true\"></textarea></div></div></div></div></div>");
$templateCache.put("app/modules/calendar/order/order.stores_course.form.html","<div class=\"row\" ng-click=\"containerClicked()\"><div class=\"order-wrapper\" ng-class=\"{\'disabled\': ([1, 6, 3].indexOf(ctrl.order.status) !== -1)}\"><div class=\"event-order-switch flex form\"><div ng-if=\"!ctrl.is_edit\"><div class=\"form-group last\" style=\"margin-bottom: 10px; margin-top: 16px;\"><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"0\"> <label>{{\"ORDER_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"1\"> <label>{{\"EVENT_ORDER_SWITCHER_LABEL\" | translate}}</label></div><div ng-if=\"ctrl.business.courses\" class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-change=\"ctrl.changeOrderType()\" ng-model=\"ctrl.form.typeOfOrder\" value=\"2\"> <label>{{\"COURSE_ORDER_SWITCHER_LABEL\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><label class=\"text-nowrap\">{{\"CALENDAR_ORDER_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <span class=\"select-holiday-name\">{{ctrl.getHolidayName(ctrl.form.date)}}</span></div></div><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"items-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectItem($orderItemIndex, orderItem, true)\"></div><div class=\"form-group\"><app-dropdown ng-if=\"ctrl.items\" require=\"true\" model=\"ctrl.form.item_id\" options=\"ctrl.courseItems\" label-prop=\"course_dropdown_label\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\" ng-if=\"ctrl.courses_fields && ctrl.courses_fields.length > 0\"><div class=\"col-md-4 col-xs-6 no-padding\" ng-repeat=\"field in ctrl.courses_fields\"><div class=\"form-group\" ng-if=\"field.type == \'list\'\"><app-dropdown model=\"ctrl.form.courses_fields[field.id]\" options=\"field.values\" label-prop=\"value\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{field.name}}\" placeholder=\"{{field.name}}\" search-placeholder=\"{{field.name}}\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group clearfix customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select\"><div class=\"customer-select-mobile-click\" ng-if=\"ctrl.isMobile\" ng-click=\"ctrl.openSelectCustomer()\"></div><div class=\"customer-pic-wrapper no-margin\" ng-if=\"ctrl.form.customer.id\" ui-sref=\"app.customers.single({id: {{ctrl.form.customer.id}}})\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" class=\"form-control customer-input\"><ul id=\"searchResult\"><li ng-click=\"chooseCustomer($index,$event)\" ng-if=\"ctrl.check_existed_customer(customer.id) == false\" ng-repeat=\"customer in ctrl.searchResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul><button type=\"button\" ng-click=\"ctrl.addNewCustomer();\" class=\"btn icon default large\" ng-if=\"!ctrl.is_edit\"><i class=\"las la-user-plus\"></i></button></div></div></div></div><div class=\"flex form top\"><div class=\"col-md-12 col-xs-12 no-padding flex-customers\"><div class=\"customer-item ng-scope\" ng-repeat=\"($customerItemIndex, customerItem) in ctrl.form.customers_list\"><div class=\"customer-pic-wrapper no-margin\"><img ng-src=\"{{customerItem.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{customerItem.firstname}} {{customerItem.lastname}} <span class=\"customer-item-remove\" ng-click=\"ctrl.remove_customer_item($customerItemIndex)\"><i class=\"las la-times\"></i></span></div></div></div><div class=\"sline-sep\"></div><div class=\"flex form top\"><div class=\"col-md-12 col-xs-12 no-padding\"><div class=\"flex between mb-24\"><button type=\"button\" ng-click=\"ctrl.add_meeting_item();\" class=\"btn text primary\">{{\"CALENDAR_ORDER_MEETING_ADD_BUTTON\" | translate}}</button></div></div><div class=\"order-item meeting ng-scope\" ng-repeat=\"($orderItemIndex, orderItem) in ctrl.form.meetings\"><div class=\"flex form\"><div ng-class=\"{\'col-md-7\': ctrl.business.second_resource, \'col-md-11\': !ctrl.business.second_resource, \'col-xs-10 no-padding\': true}\"><div class=\"form-group\"><label>{{\"CALENDAR_ORDER_MEETING_NAME\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"orderItem.name\" required=\"\"></div></div><div ng-if=\"isMobile\" class=\"col-md-1 col-xs-2 no-padding\"><button ng-click=\"ctrl.remove_meeting_item($orderItemIndex);\" class=\"btn icon circle large single-model-delete\" ng-if=\"ctrl.form.meetings.length > 1\"><i class=\"las la-trash-alt\"></i></button></div><div class=\"col-md-4 col-xs-12 no-padding\" ng-if=\"ctrl.business.second_resource\"><div class=\"form-group\"><app-dropdown model=\"orderItem.second_resource\" options=\"ctrl.activeSecondResources\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{ctrl.business.second_resource_name}}\" placeholder=\"{{ctrl.business.second_resource_name}}\" search-placeholder=\"{{ctrl.business.second_resource_name}}\"></app-dropdown></div></div><div ng-if=\"!isMobile\" class=\"col-md-1 col-xs-2 no-padding\"><button ng-click=\"ctrl.remove_meeting_item($orderItemIndex);\" class=\"btn icon circle large single-model-delete\" ng-if=\"ctrl.form.meetings.length > 1\"><i class=\"las la-trash-alt\"></i></button></div></div><div class=\"flex form\"><div class=\"col-md-3 col-xs-6 no-padding\"><div class=\"form-group top-datepicker\"><label class=\"text-nowrap\">{{\"CALENDAR_ORDER_MEETING_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"orderItem.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <span class=\"select-holiday-name\">{{ctrl.getHolidayName(orderItem.date)}}</span></div></div><div class=\"col-md-2 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown model=\"orderItem.start_time\" options=\"ctrl.dates.hours\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_MEETING_START_TIME\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_MEETING_START_TIME\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-3 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown model=\"orderItem.duration\" options=\"ctrl.dates.duration\" label-prop=\"label\" value-prop=\"duration\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_LENGTH\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_LENGTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-4 col-xs-6 no-padding\"><div class=\"form-group\"><app-dropdown require=\"true\" model=\"orderItem.resource\" options=\"ctrl.activeResources\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"sline-sep\"></div></div></div>");
$templateCache.put("app/modules/cashbox/methods/card.popup.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"MAKE_CARD\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"form flex\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-qty\">{{\"MAKE_CARD_QTY\" | translate}}</label> <input type=\"number\" id=\"card-qty\" required=\"\" ng-model=\"ctrl.cardQtyModel\" class=\"form-control\" ng-change=\"ctrl.changeCardQty()\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-price\">{{\"MAKE_CARD_PRICE\" | translate}}</label> <input type=\"number\" id=\"card-price\" required=\"\" ng-model=\"ctrl.cardPrice\" class=\"form-control\" ng-change=\"ctrl.changeCardPrice()\"></div></div></div><div class=\"form flex\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-price\">{{\"MAKE_CARD_PRICE_PER_ITEM\" | translate}}</label> <input type=\"number\" id=\"card-price\" required=\"\" ng-model=\"ctrl.cardPerItemModel\" class=\"form-control\" ng-change=\"ctrl.changeCardPerItem()\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"card-expired\">{{\"MAKE_CARD_EXPIRED_DATE\" | translate}}</label> <input type=\"date\" id=\"card-expired\" class=\"form-control\" ng-model=\"ctrl.expired_at\"></div></div></div></div><div class=\"modal-footer end\"><button ng-click=\"ctrl.makeCardAccept();\" type=\"button\" class=\"btn large text primary\">{{\"MAKE_CARD_CONFIRM\" | translate}}</button></div></div>");
$templateCache.put("app/modules/cashbox/methods/credit.view.html","<div class=\"modal-form-inner payment-method\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_PAY_BY_CREDIT\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.resetPayment(); $close()\">&times;</a></div><form class=\"modal-form_f\" name=\"paymentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><iframe class=\"iframe-tranzila\" ng-src=\"{{iframe}}\" width=\"100%\" height=\"400px\" frameborder=\"0\" allow=\"payment; clipboard-write\"></iframe></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"flex between full\"><div class=\"flex gap-24\"><button type=\"button\" ng-click=\"ctrl.resetPayment(); $close();\" class=\"btn text large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-show=\"showContinue\" ng-disabled=\"paymentForm.$invalid\" ng-click=\"ctrl.completePayment();\" class=\"btn text large primary\">{{\"CALENDAR_CASH_CONTINUE\" | translate}}</button></div><span class=\"cash-left\"><p>{{\"CALENDAR_CASH_LEFT_PAY\" | translate}}</p><b>{{ctrl.cashboxTotal - (ctrl.totalPaid ? ctrl.totalPaid : 0) | price}}</b></span></div></div></form></div>");
$templateCache.put("app/modules/cashbox/methods/credit_zcard.view.html","<div class=\"modal-form-inner payment-method\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_PAY_BY_CREDIT\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.resetPayment(); ctrl.resetZCredit(); $close()\">&times;</a></div><form class=\"\" name=\"paymentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><div class=\"waiting-pay\"><img src=\"assets/images/emv_icon.png\" class=\"swal2-image\" style=\"display: flex;\"> {{\"CASHBOX_WAITING_FOR_PAY\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"flex between full\"><div class=\"flex gap-24\"><button type=\"button\" ng-click=\"ctrl.resetPayment(); ctrl.resetZCredit(); $close();\" class=\"btn text large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-show=\"showContinue\" ng-disabled=\"paymentForm.$invalid\" ng-click=\"ctrl.completePayment();\" class=\"btn text large primary\">{{\"CALENDAR_CASH_CONTINUE\" | translate}}</button></div><span class=\"cash-left\"><p>{{\"CALENDAR_CASH_LEFT_PAY\" | translate}}</p><b>{{ctrl.cashboxTotal - (ctrl.totalPaid ? ctrl.totalPaid : 0) | price}}</b></span></div></div></form></div>");
$templateCache.put("app/modules/cashbox/methods/emv.popup.html","<div id=\"bank-select-mob\" aria-labelledby=\"swal2-title\" aria-describedby=\"swal2-content\" class=\"swal2-popup swal2-modal swal2-show\" tabindex=\"-1\" role=\"dialog\" aria-live=\"assertive\" aria-modal=\"true\" style=\"display: flex; width: 100%;\"><div class=\"swal2-header\"><img src=\"assets/images/emv_icon.png\" class=\"swal2-image\" style=\"display: flex;\"><h2 class=\"swal2-title\" id=\"swal2-title\" style=\"display: flex;\">{{statusShow}}</h2><button type=\"button\" class=\"swal2-close\" ng-click=\"$close();\">×</button></div><div class=\"swal2-content\"></div></div>");
$templateCache.put("app/modules/cashbox/methods/payment.view.html","<div class=\"modal-form-inner payment-method\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"method == \'cash\'\">{{\"CALENDAR_CASH_PAY_CASH\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'oncredit\'\">{{\"CALENDAR_CASH_PAY_CREDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'cheque\'\">{{\"CASHBOX_PAY_CHEQUE\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'bank_transfer\'\">{{\"CASHBOX_PAY_BANK_TRANSFER\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'credit_card_external\'\">{{\"CASHBOX_PAY_CREDIT_CARD_EXT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"method == \'pay_link\'\">{{\"CALENDAR_PAY_LINK\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.resetPayment(); $close();\">&times;</a></div><form class=\"modal-form_f\" name=\"paymentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"form-group\"><label ng-if=\"method == \'cash\'\">{{\"CALENDAR_CASH_HOW_MUCH\" | translate}}<br><small><b>{{\"CALENDAR_CASH_NOTE\" | translate}}</b> {{\"CALENDAR_CASH_ABOUT\" | translate}}</small></label> <label ng-if=\"method == \'oncredit\'\">{{\"CALENDAR_CASH_HOW_MUCH2\" | translate}}</label> <label ng-if=\"method == \'cheque\'\">{{\"CASHBOX_HOW_MUCH_CHEQUE\" | translate}}</label> <label ng-if=\"method == \'bank_transfer\'\">{{\"CASHBOX_HOW_MUCH_BANK_TRANSFER\" | translate}}</label> <label ng-if=\"method == \'credit_card_external\'\">{{\"CASHBOX_HOW_MUCH_EXT_CREDIT_CARD\" | translate}}</label> <label ng-if=\"method == \'pay_link\'\">{{\"CALENDAR_PAY_LINK\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.methods[method].amount\" ng-disabled=\"method == ctrl.lastMethod\" min=\"0\" required=\"\" max=\"{{ctrl.cashboxTotal - ctrl.totalPaid}}\" class=\"form-control\"></div><div class=\"flex form\" ng-if=\"method == \'cheque\'\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-cheque-number\">{{\"CASHBOX_CHEQUE_NUM_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-cheque-number\" required=\"\" pattern=\"[0-9 ]{1,20}\" ng-model=\"ctrl.methods[method].payment_details.cheque_number\" class=\"form-control\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-due-date\">{{\"CASHBOX_DUE_DATE_LABEL\" | translate}}</label> <input type=\"date-time\" id=\"input-due-date\" class=\"form-control\" auto-close=\"true\" date-time=\"\" ng-model=\"ctrl.methods[method].payment_details.cheque_due_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div><div class=\"flex form\" ng-if=\"method == \'cheque\' || method == \'bank_transfer\'\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-bank-number-mobile\">{{\"CASHBOX_BANK_NUM_LABEL\" | translate}}</label> <input type=\"text\" readonly=\"true\" id=\"input-bank-number-mobile\" required=\"\" ng-if=\"isMobile\" ng-model=\"ctrl.methods[method].payment_details.bank_name\" class=\"form-control\" ng-click=\"ctrl.showBankList()\"><app-dropdown ng-if=\"!isMobile\" model=\"ctrl.methods[method].payment_details.bank_number\" options=\"ctrl.BanksList\" value-prop=\"bank_number\" label-prop=\"name\" image-prop=\"img_url\" searchable=\"true\" placeholder=\"{{\'CASHBOX_BANK_NUM_LABEL\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-branch\">{{\"CASHBOX_BRANCH_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-branch\" pattern=\"[0-9 ]{1,20}\" ng-required=\"method == \'cheque\'\" ng-model=\"ctrl.methods[method].payment_details.branch_number\" class=\"form-control\"></div></div></div><div class=\"flex form\" ng-if=\"method == \'cheque\' || method == \'bank_transfer\'\"><div class=\"col-xs-6\"><div class=\"form-group\"><label for=\"input-account-number\">{{\"CASHBOX_ACCOUNT_NUM_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-account-number\" pattern=\"[0-9 ]{1,20}\" ng-model=\"ctrl.methods[method].payment_details.bank_account_number\" class=\"form-control\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"></div></div></div><div class=\"flex form\" ng-if=\"method == \'credit_card_external\'\"><div class=\"form-group\"><label for=\"input-credit-card-ext\">{{\"CASHBOX_CREDIT_CARD_EXT_4_LABEL\" | translate}}</label> <input type=\"number\" id=\"input-credit-card-ext\" ng-maxlength=\"4\" required=\"\" pattern=\"[0-9]{4,4}\" ng-model=\"ctrl.methods[method].payment_details.credit_card_ext_number\" class=\"form-control\"></div></div><p ng-if=\"method == \'credit_card_external\'\" class=\"text-center color-red\">{{\"CASHBOX_PAY_CREDIT_CARD_EXT_NOTE\" | translate}}</p></div></div><div class=\"modal-footer\"><div class=\"flex between full\"><div class=\"flex gap-24\"><button type=\"button\" ng-click=\"ctrl.resetPayment(); $close();\" class=\"btn text large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"paymentForm.$invalid || ctrl.paymentDetailsInvalid() || ctrl.cashboxLoading\" ng-click=\"ctrl.completePayment();\" class=\"btn text large primary\">{{\"CALENDAR_CASH_CONTINUE\" | translate}}</button></div><span class=\"cash-left\"><p>{{\"CALENDAR_CASH_LEFT_PAY\" | translate}}</p><b>{{ctrl.cashboxTotal - (ctrl.totalPaid ? ctrl.totalPaid : 0) | price}}</b></span></div></div></form></div>");
$templateCache.put("app/modules/cashbox/popup/bank.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"bank-select-mob\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CASHBOX_BANK_NUM_SELECT_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'ITEM_ENTER_NAME\' | translate}}\" ng-change=\"find_item()\" ng-model=\"ctrl.item_name\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.banks\"><table datatable=\"\" dt-options=\"dtOptions\" id=\"res_dt\" class=\"table table-striped table-bordered table-hover dataTables-example banks-select-table\"><thead><tr><th>{{\"BANK_NAME_HEADER\" | translate}}</th><th>{{\"BANK_NUMBER_HEADER\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectBank($index)\" ng-repeat=\"row in ctrl.banks\"><td><img ng-if=\"row.img_url\" ng-src=\"{{row.img_url}}\" width=\"20\" height=\"20\"> {{row.name}}</td><td><span ng-hide=\"row.bank_number.indexOf(\'service\') === 0\">{{row.bank_number}}</span></td></tr></tbody></table></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/cashbox/popup/continuous-deal.modal.html","<div class=\"modal-header\"><h4 class=\"modal-title\">{{ \'CONTINUOUS_DEAL_MODAL_TITLE\' | translate }}</h4></div><div class=\"modal-body\"><p class=\"mb-16\">{{ \'CONTINUOUS_DEAL_MODAL_HELP\' | translate }}</p><label class=\"display-block mb-8\">{{ \'CONTINUOUS_DEAL_COUNT\' | translate }}</label> <input type=\"number\" min=\"2\" max=\"18\" class=\"form-control\" ng-model=\"modalCount\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn text\" ng-click=\"cancel()\">{{ \'SWAL_CANCEL_BUTTON\' | translate }}</button> <button type=\"button\" class=\"btn text primary\" ng-click=\"confirm()\">{{ \'SWAL_CONFIRM_BUTTON\' | translate }}</button></div>");
$templateCache.put("app/modules/cashbox/popup/use-card.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CASHBOX_USE_CARD_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"editForm\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><div class=\"form-group\"><label>{{\"CASHBOX_CARD_USE_AMOUNT\" | translate}}</label><div class=\"item-inputs\"><input-number-spinner data-ng-model=\"ctrl.form.card_balance_used\" data-input-number-spinner-min=\"0\" data-input-number-spinner-max=\"ctrl.card.balance > ctrl.item.quantity ? ctrl.item.quantity : ctrl.card.balance\" data-input-number-spinner-required=\"true\"></input-number-spinner></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><br><label>{{\"CARD_CURRENT_BALANCE\" | translate}}: {{ ctrl.card.balance }}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid\" ng-click=\"ctrl.saveForm()\" class=\"btn text primary large\">{{\"CARD_CHANGE_BALANCE_SAVE_BTN\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/customers/popup/customers.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_SELECT_C\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'CUSTOMER_ENTER_NAME\' | translate}}\" ng-change=\"find_customer()\" ng-model=\"ctrl.customer_name\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.customers && ctrl.customers.length>0\"><table class=\"sorted-table\"><thead><tr><th>{{\"CUSTOMERS_NAME\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in ctrl.customers\" ng-click=\"ctrl.selectCustomer(row)\"><td class=\"customer-name with-pic\"><div class=\"customer-pic-wrapper\"><img ng-src=\"{{row.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic mobile\"></div>{{row.firstname}} {{row.lastname}} <span class=\"customer-search-notes\" ng-if=\"row.notes\" title=\"{{row.notes}}\">{{row.notes}}</span></td></tr></tbody></table></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/customers_bookings/list/list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'customers\')\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.calendar\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"NAV_CUSTOMERS_BOOKINGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div><button class=\"btn text large\" ng-class=\"{\'primary\': activeTab === \'pending\'}\" ng-click=\"ctrl.changeTab(\'pending\')\">{{\"NAV_CUSTOMERS_PENDING\" | translate}}</button> <button class=\"btn text large\" ng-class=\"{\'primary\': activeTab === \'waiting\'}\" ng-click=\"ctrl.changeTab(\'waiting\')\">{{\"NAV_CUSTOMERS_WAITING\" | translate}}</button> <button class=\"btn icon default large\" ng-click=\"ctrl.openAddWaitingListModal()\" title=\"{{\'NAV_CUSTOMERS_WAITING\' | translate}}\"><i class=\"las la-plus\"></i></button></div><div class=\"table-holder customer-table-holder\" ng-if=\"activeTab === \'pending\'\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div><div class=\"table-holder customer-table-holder\" ng-if=\"activeTab === \'waiting\'\"><div class=\"table-responsive\"><table id=\"cust_dt_waitings\" datatable=\"\" dt-options=\"dtOptionsWaitings\" dt-columns=\"ctrl.dtColumnsWaitingList\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div>");
$templateCache.put("app/modules/customers_bookings/list/waiting-list-add.modal.html","<div class=\"modal-form-inner\" id=\"waiting-list-add-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADD_TO_WAITING_LIST\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"waitingListForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group clearfix customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div ng-class=\"ctrl.form.customer.id ? \'customer-has-avatar\' : \'\'\" class=\"customer-select customer-select-waiting-list\"><div class=\"customer-pic-wrapper no-margin\" ng-if=\"ctrl.form.customer.id\"><img ng-src=\"{{ctrl.form.customer.avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" class=\"form-control customer-input\" required=\"\"><ul id=\"searchResult\"><li ng-mousedown=\"ctrl.startChooseCustomer()\" ng-click=\"ctrl.chooseCustomer($index, $event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown ng-if=\"ctrl.items\" model=\"ctrl.form.item_id\" options=\"ctrl.serviceItems\" value-prop=\"id\" searchable=\"true\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.resource_id\" options=\"ctrl.resources\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CALENDAR_ORDER_WORKER\' | translate}}\" placeholder=\"{{\'BOOKING_RESOURCE_ANY\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"BOOKING_WAITING_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\" required=\"\"></div></div><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.start_time\" options=\"ctrl.dates.hours\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_START_TIME\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_START_TIME\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-4 col-xs-12 no-padding\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.end_time\" options=\"ctrl.dates.hours\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CALENDAR_ORDER_END_TIME\' | translate}}\" placeholder=\"{{\'CALENDAR_ORDER_END_TIME\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"waitingListForm.$invalid || ctrl.isLoading\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/marketing/automations/automations.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.marketing\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"MARKETING_AUTOMATIONS\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.marketing.automations.new\"><i class=\"las la-plus\"></i> {{\"AUTOMATIONS_ADD\" | translate}}</button></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.tableData\" id=\"automations_dt\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"AUTOMATION_NAME\" | translate}}</th><th>{{\"AUTOMATION_TRIGGER\" | translate}}</th><th>{{\"AUTOMATION_CUSTOMER_REMIND_TYPE\" | translate}}</th><th>{{\"AUTOMATION_ACTIVE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.marketing.automations.edit({id: {{row.id}}})\"><td>{{row.name}}</td><td><span ng-if=\"row.remind_type == \'before\'\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_BEFORE\" | translate}}</span> <span ng-if=\"row.remind_type == \'after\'\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_AFTER\" | translate}}</span> <span ng-if=\"row.remind_type == \'now\' || !row.remind_time\">{{\"AUTOMATION_CUSTOMER_REMIND_TYPE_NOW\" | translate}}</span> <span ng-if=\"row.remind_type != \'now\' && row.remind_time\">{{row.remind_time}}</span> <span ng-if=\"row.remind_type != \'now\' && row.remind_time\"><span ng-if=\"row.timetype == \'minutes\'\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_MINUTES\" | translate}}</span> <span ng-if=\"row.timetype == \'hours\'\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_HOURS\" | translate}}</span> <span ng-if=\"row.timetype == \'days\'\">{{\"AUTOMATION_CUSTOMER_TIMETYPE_DAYS\" | translate}}</span></span></td><td>{{\"AUTOMATION_TRIGGER_\"+row.trigger.toString().toUpperCase() | translate}}</td><td ng-click=\"$event.stopPropagation()\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"row.active\" ng-change=\"ctrl.updateActive(row)\"> {{\"AUTOMATION_ACTIVE\" | translate}}</label></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/marketing/recommendations/recommendations.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.marketing\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"MARKETING_RECOMMENDATIONS\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyOrdersSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th>{{\"RECOMMENDATIONS_NAME\" | translate}}</th><th>{{\"RECOMMENDATIONS_CUSTOMER\" | translate}}</th><th>{{\"RECOMMENDATIONS_TEXT\" | translate}}</th><th>{{\"RECOMMENDATIONS_CREATED_AT\" | translate}}</th><th></th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td>{{row.name}}</td><td>{{row.customer}}</td><td>{{row.text}}</td><td>{{row.created_at}}</td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.send(row.id)\">{{\"RECOMMENDATIONS_SEND\" | translate}}</button></td><td width=\"1%\"><button ng-click=\"ctrl.delete(row.id)\" class=\"btn icon red\"><i class=\"las la-trash-alt\"></i></button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/reports/popups/debt-remind.view.html","<div class=\"modal-form-inner remind-debt-popup\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"REMIND_DEBT_POPUP_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"\" ng-submit=\"\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"form-group\"><textarea class=\"form-control\" rows=\"5\" maxlength=\"70\" required=\"\" ng-model=\"ctrl.form.message\"></textarea></div><div class=\"flex form fill fill-m\"><div class=\"form-group\"><label class=\"settings_label\">{{\"REMIND_DEBT_SEND_METHOD\" | translate}}</label><br><div class=\"radio-btn\"><input id=\"send-reminde-debt-email\" type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"1\" data-ng-disabled=\"!ctrl.customer.email\"> <label for=\"send-reminde-debt-email\">{{\"SETTINGS_USER_MAIL\" | translate}}</label></div><div class=\"radio-btn\"><input id=\"send-reminde-debt-sms\" type=\"radio\" name=\"send_method\" ng-model=\"ctrl.form.send_method\" value=\"2\" data-ng-disabled=\"!ctrl.customer.phone\"> <label for=\"send-reminde-debt-sms\">{{\"CUSTOMERS_SMS\" | translate}}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"REMIND_POPUP_CLOSE_BTN\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.sendReminder()\" class=\"btn text primary large\">{{\"REMIND_POPUP_SEND_BTN\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/reports/tax_files/reports.tax_files.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_TAX_FILES\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"infoForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_TAX_FILES_FROM\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.form.from\" name=\"from\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.from.$error\" class=\"ng-messages\" ng-show=\"infoForm.from.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_TAX_FILES_TO\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.form.to\" name=\"to\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.to.$error\" class=\"ng-messages\" ng-show=\"infoForm.to.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_TAX_FILES_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid || infoForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_TAX_FILES_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/accounting_settings/accounting_settings.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"ACCOUNTING_SETTINGS\" | translate }}</h3></div><div class=\"settings-block leads\"><ul><li><a ui-sref=\"app.settings.accounting_settings.quotation_statuses\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-invoice\"></i></span><div><h6>{{\"SETTINGS_QUOTATION_STATUSES\" | translate}}</h6><p>{{\"SETTINGS_QUOTATION_STATUSES_MANAGE\" | translate}}</p></div></a></li><li><a ui-sref=\"app.settings.accounting_settings.allocation_settings\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-file-invoice\"></i></span><div><h6>{{\"SETTINGS_ALLOCATION_SETTINGS\" | translate}}</h6><p>{{\"SETTINGS_ALLOCATION_SETTINGS_MANAGE\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/additional_fields/additional_fields.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_ADDITIONAL_FIELDS\" | translate }}</h3></div><div class=\"settings-block additional_fields\"><ul><li><a ui-sref=\"app.settings.additional_fields.interested\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-gratipay\"></i></span><div><h6>{{\"SETTINGS_INTERESTED\" | translate}}</h6><p>{{\"SETTINGS_INTERESTED_MANAGE\" | translate}}</p></div></a></li><li class=\"li custom_field\" ng-repeat=\"field in ctrl.customFields\"><a ui-sref=\"app.settings.custom_fields.single({ id: field.id })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{field.name}}</h6><p>{{\"SETTINGS_CUSTOM_FIELDS_VALUES\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/ai_agents/ai_agents.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_AI_AGENTS\" | translate }}</h3></div><div class=\"settings-block\"><ul><li class=\"li ai_agent\" ng-repeat=\"agent in ctrl.enabledAgents\"><a ui-sref=\"{{agent.state}}\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"{{agent.icon}}\"></i></span><div><h6>{{agent.name | translate}}</h6><p>{{agent.description | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/ai_booking_agent/ai_booking_agent.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"AI_BOOKING_AGENT_SETTINGS\" | translate }}</h3></div><form name=\"agentForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\" ng-if=\"ctrl.form\"><div class=\"aba-tabs\"><button ng-repeat=\"tab in ctrl.tabs\" type=\"button\" class=\"aba-tab btn text\" ng-class=\"{\'primary\': ctrl.activeTab === tab.id, \'border-primary\': ctrl.activeTab !== tab.id}\" ng-click=\"ctrl.setTab(tab.id)\">{{tab.label | translate}}</button></div><div ng-show=\"ctrl.activeTab === \'general\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_GENERAL_TITLE\" | translate}}</h3><div class=\"aba-row aba-gap-6\"><div class=\"aba-column aba-width-small\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_NAME\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_NAME_HINT\' | translate}}\"></i></div><input type=\"text\" class=\"form-control\" ng-model=\"ctrl.agent.name\"></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_STATUS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_STATUS_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.agent.status\" options=\"ctrl.agentStatusOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_STATUS\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_DEFAULT_LANGUAGE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_DEFAULT_LANGUAGE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.default_language\" options=\"ctrl.languageOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_DEFAULT_LANGUAGE\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_TONE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_TONE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.tone\" options=\"ctrl.toneOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_TONE\' | translate}}\"></app-dropdown></div></div><div class=\"aba-column aba-width-medium\"><div class=\"aba-row aba-gap-2\"><div class=\"form-group aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_SESSION_IDLE_MINUTES\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_SESSION_IDLE_MINUTES_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"5\" step=\"1\" class=\"form-control\" ng-model=\"ctrl.form.general.session_idle_minutes\"></div><div class=\"form-group aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_SESSION_POLICY\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_SESSION_POLICY_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.session_policy\" options=\"ctrl.sessionPolicyOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_SESSION_POLICY\' | translate}}\"></app-dropdown></div></div><div class=\"aba-row aba-gap-2\"><div class=\"form-group aba-flex-2\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_CURRENCY\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_CURRENCY_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.currency\" options=\"ctrl.currencyOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_CURRENCY\' | translate}}\"></app-dropdown></div><div class=\"form-group aba-flex-4\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_PRICE_DISPLAY\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_PRICE_DISPLAY_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.price_display\" options=\"ctrl.priceDisplayOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_PRICE_DISPLAY\' | translate}}\"></app-dropdown></div><div class=\"form-group aba-flex-2\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_PRICE_PRECISION\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_PRICE_PRECISION_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.price_precision\" options=\"ctrl.pricePrecisionOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_PRICE_PRECISION\' | translate}}\"></app-dropdown></div></div><div class=\"aba-row aba-gap-2\"><div class=\"aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_SUPPORTED_MODALITIES\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MODALITIES_HINT\' | translate}}\"></i></div><div class=\"aba-row aba-gap-4\"><div class=\"form-group form-check aba-checkbox-container\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" disabled=\"\" ng-checked=\"ctrl.hasModality(\'text\')\" ng-click=\"ctrl.toggleModality(\'text\')\"> {{\"AI_AGENT_MODALITY_TEXT\" | translate}}</label></div><div class=\"form-group form-check aba-checkbox-container aba-hidden\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-checked=\"ctrl.hasModality(\'voice\')\" ng-click=\"ctrl.toggleModality(\'voice\')\"> {{\"AI_AGENT_MODALITY_VOICE\" | translate}}</label></div></div></div><div class=\"form-group aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_DEFAULT_MODALITY\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_DEFAULT_MODALITY_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.general.default_modality\" options=\"ctrl.form.general.supported_modalities\" disabled=\"!ctrl.form.general.supported_modalities || ctrl.form.general.supported_modalities.length === 1\" placeholder=\"{{\'AI_AGENT_DEFAULT_MODALITY\' | translate}}\"></app-dropdown></div><div ng-if=\"false\"><input type=\"text\" ng-model=\"ctrl.agent.type\"> <input type=\"text\" ng-model=\"ctrl.form.general.default_channel\"></div></div></div></div></div><div ng-show=\"ctrl.activeTab === \'routing\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_ROUTING_TITLE\" | translate}}</h3><div class=\"aba-row aba-gap-6\"><div class=\"aba-column aba-width-medium\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_ACTIVATION_MODE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_ACTIVATION_MODE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.routing.activation.mode\" options=\"ctrl.activationModeOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_ACTIVATION_MODE\' | translate}}\"></app-dropdown></div><div class=\"form-group\" ng-if=\"ctrl.needsActivationKeywords()\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_ACTIVATION_KEYWORDS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_ACTIVATION_KEYWORDS_HINT\' | translate}}\"></i></div><input type=\"text\" class=\"form-control\" ng-model=\"ctrl.activationKeywordsText\" placeholder=\"{{\'AI_AGENT_ACTIVATION_KEYWORDS_PLACEHOLDER\' | translate}}\"></div><div ng-if=\"ctrl.form.routing.activation.mode === \'after_admin_silence\'\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_ADMIN_SILENCE_SECONDS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_ADMIN_SILENCE_SECONDS_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"10\" step=\"10\" class=\"form-control\" ng-model=\"ctrl.form.routing.activation.admin_silence_seconds\"></div><div class=\"form-group form-check mt-24\" ng-if=\"ctrl.form.routing.activation.mode === \'after_admin_silence\'\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.routing.activation.only_if_last_message_from_customer\"> {{\"AI_AGENT_ONLY_IF_LAST_MSG_FROM_CUSTOMER\" | translate}}</label></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_BOOKING_TRIGGER_MODE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_BOOKING_TRIGGER_MODE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.booking.trigger.mode\" options=\"ctrl.bookingTriggerModeOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_BOOKING_TRIGGER_MODE\' | translate}}\"></app-dropdown></div><div class=\"form-group\" ng-if=\"ctrl.needsBookingTriggerKeywords()\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_BOOKING_TRIGGER_KEYWORDS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_BOOKING_TRIGGER_KEYWORDS_HINT\' | translate}}\"></i></div><input type=\"text\" class=\"form-control\" ng-model=\"ctrl.bookingTriggerKeywordsText\" placeholder=\"{{\'AI_AGENT_BOOKING_TRIGGER_KEYWORDS_PLACEHOLDER\' | translate}}\"></div></div><div class=\"aba-column aba-width-medium\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_HANDOFF_KEYWORDS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_HANDOFF_KEYWORDS_HINT\' | translate}}\"></i></div><input type=\"text\" class=\"form-control\" ng-model=\"ctrl.handoffKeywordsText\" placeholder=\"{{\'AI_AGENT_HANDOFF_KEYWORDS_PLACEHOLDER\' | translate}}\"></div><div><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_HANDOFF_POLICY_TITLE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_HANDOFF_POLICY_TITLE_HINT\' | translate}}\"></i></div><div class=\"form-group form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.routing.handoff_policy.on_customer_request\"> {{\"AI_AGENT_HANDOFF_ON_CUSTOMER_REQUEST\" | translate}}</label></div><div class=\"form-group form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.routing.handoff_policy.on_low_confidence\"> {{\"AI_AGENT_HANDOFF_ON_LOW_CONFIDENCE\" | translate}}</label></div><div class=\"form-group form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.routing.handoff_policy.on_repeated_no_progress\"> {{\"AI_AGENT_HANDOFF_ON_REPEATED_NO_PROGRESS\" | translate}}</label></div><div class=\"form-group\" ng-show=\"ctrl.form.routing.handoff_policy.on_repeated_no_progress\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MAX_NO_PROGRESS_TURNS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MAX_NO_PROGRESS_TURNS_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"1\" max=\"10\" step=\"1\" class=\"form-control\" ng-model=\"ctrl.form.routing.handoff_policy.max_no_progress_turns\"></div></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_FALLBACK_MODE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_FALLBACK_MODE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.routing.fallback_behavior.mode\" options=\"ctrl.fallbackModeOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_FALLBACK_MODE\' | translate}}\"></app-dropdown></div><div class=\"aba-row aba-gap-2\"><div class=\"form-group aba-flex-2\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MAX_CLARIFY_TURNS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MAX_CLARIFY_TURNS_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"1\" max=\"10\" step=\"1\" class=\"form-control\" ng-model=\"ctrl.form.routing.fallback_behavior.max_clarify_turns\"></div><div class=\"form-group aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_FALLBACK_THEN\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_FALLBACK_THEN_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.routing.fallback_behavior.then\" options=\"ctrl.fallbackThenOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_FALLBACK_THEN\' | translate}}\"></app-dropdown></div></div></div></div></div><div ng-show=\"ctrl.activeTab === \'booking\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_BOOKING_TITLE\" | translate}}</h3><div class=\"aba-row aba-gap-6\"><div class=\"aba-column aba-width-small\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_SUGGESTED_SLOTS_COUNT\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_SUGGESTED_SLOTS_COUNT_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"1\" max=\"10\" class=\"form-control\" ng-model=\"ctrl.form.booking.suggested_slots_count\"></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_SLOT_SEARCH_WINDOW_HOURS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_SLOT_SEARCH_WINDOW_HOURS_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"1\" max=\"720\" class=\"form-control\" ng-model=\"ctrl.form.booking.slot_search_window_hours\"></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.booking.employee_auto_pick_strategy\" options=\"ctrl.employeeAutoPickStrategyOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_EMPLOYEE_AUTO_PICK_STRATEGY\' | translate}}\"></app-dropdown></div></div><div class=\"aba-column aba-width-medium\"><div><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_ONLINE_BOOKING_OVERRIDES\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_INHERIT_ONLINE_BOOKING_HINT\' | translate}}\"></i></div><div class=\"form-group form-check aba-checkbox-container\"><label class=\"form-check-label\" for=\"inherit_online\"><input type=\"checkbox\" class=\"form-check-input\" id=\"inherit_online\" ng-model=\"ctrl.inheritOnlineBooking\"> {{\"AI_AGENT_INHERIT_ONLINE_BOOKING\" | translate}}</label></div></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_BOOKING_ACCESS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_BOOKING_ACCESS_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.bookingUi.allow_online_booking\" options=\"ctrl.allowOnlineBookingOptions\" value-prop=\"value\" disabled=\"ctrl.inheritOnlineBooking\" placeholder=\"{{\'AI_AGENT_BOOKING_ACCESS\' | translate}}\"></app-dropdown></div><div class=\"aba-row aba-gap-2\"><div class=\"form-group aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"MIN_TIME_BEFORE_BOOKING_HOURS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'MIN_TIME_BEFORE_BOOKING_HOURS_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.bookingUi.closest_time\" options=\"ctrl.closestTimeOptions\" value-prop=\"value\" disabled=\"ctrl.inheritOnlineBooking\" placeholder=\"{{\'MIN_TIME_BEFORE_BOOKING_HOURS\' | translate}}\"></app-dropdown></div><div class=\"form-group aba-flex-1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"MAX_DAYS_FOR_BOOKING\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'MAX_DAYS_FOR_BOOKING_HINT\' | translate}}\"></i></div><input type=\"number\" min=\"1\" class=\"form-control\" ng-model=\"ctrl.bookingUi.latest_time\" ng-disabled=\"ctrl.inheritOnlineBooking\"></div></div><div class=\"aba-row aba-gap-2\"><div class=\"aba-flex-2\"><label>&nbsp;</label><div class=\"form-group form-check aba-checkbox-container\"><label class=\"form-check-label\" for=\"ob_allow_update\"><input type=\"checkbox\" class=\"form-check-input\" id=\"ob_allow_update\" ng-model=\"ctrl.bookingUi.allow_update\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"ctrl.inheritOnlineBooking\"> {{\"SETTINGS_ONLINE_ALLOW_UPDATE\" | translate}}</label></div></div><div class=\"form-group aba-flex-1\" ng-show=\"ctrl.bookingUi.allow_update == 1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"SETTINGS_ONLINE_UPDATE_HOURS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'SETTINGS_ONLINE_UPDATE_HOURS_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.bookingUi.update_hours\" options=\"ctrl.deadlineOptions\" value-prop=\"value\" disabled=\"ctrl.inheritOnlineBooking\" placeholder=\"{{\'SETTINGS_ONLINE_UPDATE_HOURS\' | translate}}\"></app-dropdown></div></div><div class=\"aba-row aba-gap-2\"><div class=\"aba-flex-2\"><label>&nbsp;</label><div class=\"form-group form-check aba-checkbox-container\"><label class=\"form-check-label\" for=\"ob_allow_cancel\"><input type=\"checkbox\" class=\"form-check-input\" id=\"ob_allow_cancel\" ng-model=\"ctrl.bookingUi.allow_cancel\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"ctrl.inheritOnlineBooking\"> {{\"SETTINGS_ONLINE_ALLOW_CANCEL\" | translate}}</label></div></div><div class=\"form-group aba-flex-1\" ng-show=\"ctrl.bookingUi.allow_cancel == 1\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"SETTINGS_ONLINE_CANCEL_HOURS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'SETTINGS_ONLINE_CANCEL_HOURS_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.bookingUi.cancel_hours\" options=\"ctrl.deadlineOptions\" value-prop=\"value\" disabled=\"ctrl.inheritOnlineBooking\" placeholder=\"{{\'SETTINGS_ONLINE_CANCEL_HOURS\' | translate}}\"></app-dropdown></div></div><div class=\"aba-row aba-gap-2\"><div class=\"form-group form-check aba-flex-1\"><label class=\"form-check-label\" for=\"ob_show_price\"><input type=\"checkbox\" class=\"form-check-input\" id=\"ob_show_price\" ng-model=\"ctrl.bookingUi.display_price\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"ctrl.inheritOnlineBooking\"> {{\"DISPLAY_PRICE\" | translate}}</label></div><div class=\"form-group form-check aba-flex-1\"><label class=\"form-check-label\" for=\"ob_show_duration\"><input type=\"checkbox\" class=\"form-check-input\" id=\"ob_show_duration\" ng-model=\"ctrl.bookingUi.display_duration\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"ctrl.inheritOnlineBooking\"> {{\"DISPLAY_DURATION\" | translate}}</label></div></div></div></div></div><div ng-show=\"ctrl.activeTab === \'time\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_TIME_DATE_TITLE\" | translate}}</h3><div class=\"aba-row aba-gap-6\"><div class=\"aba-column aba-width-medium\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_TIMEZONE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_TIMEZONE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.time.timezone\" options=\"ctrl.timezoneOptions\" value-prop=\"value\" searchable=\"true\" placeholder=\"{{\'AI_AGENT_TIMEZONE\' | translate}}\" search-placeholder=\"{{\'AI_AGENT_TIMEZONE\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_DATE_FORMAT\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_DATE_FORMAT_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.time.date_format\" options=\"ctrl.dateFormatOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_DATE_FORMAT\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_TIME_FORMAT\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_TIME_FORMAT_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.time.time_format\" options=\"ctrl.timeFormatOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_TIME_FORMAT\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_WEEK_START\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_WEEK_START_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.time.week_start\" options=\"ctrl.weekStartOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_WEEK_START\' | translate}}\"></app-dropdown></div><div><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_DAY_PARTS_TITLE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_DAY_PARTS_HINT\' | translate}}\"></i></div><div class=\"aba-column aba-gap-2\"><div class=\"aba-row aba-gap-4 aba-align-center\"><div class=\"aba-row aba-flex-1 aba-align-center\"><span>{{\"MORNING\" | translate}}</span></div><div class=\"aba-flex-1\"><app-dropdown model=\"ctrl.form.time.day_parts.morning.from\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onDayPartsChange()\" placeholder=\"{{\'MORNING\' | translate}}\"></app-dropdown></div><div class=\"aba-flex-1\"><app-dropdown model=\"ctrl.form.time.day_parts.morning.to\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onDayPartsChange()\" placeholder=\"{{\'MORNING\' | translate}}\"></app-dropdown></div></div><div class=\"aba-row aba-gap-4\"><div class=\"aba-row aba-flex-1 aba-align-center\"><span>{{\"DAY\" | translate}}</span></div><div class=\"aba-flex-1\"><app-dropdown model=\"ctrl.form.time.day_parts.day.from\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onDayPartsChange()\" placeholder=\"{{\'DAY\' | translate}}\"></app-dropdown></div><div class=\"aba-flex-1\"><app-dropdown model=\"ctrl.form.time.day_parts.day.to\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onDayPartsChange()\" placeholder=\"{{\'DAY\' | translate}}\"></app-dropdown></div></div><div class=\"aba-row aba-gap-4\"><div class=\"aba-row aba-flex-1 aba-align-center\"><span>{{\"EVENING\" | translate}}</span></div><div class=\"aba-flex-1\"><app-dropdown model=\"ctrl.form.time.day_parts.evening.from\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onDayPartsChange()\" placeholder=\"{{\'EVENING\' | translate}}\"></app-dropdown></div><div class=\"aba-flex-1\"><app-dropdown model=\"ctrl.form.time.day_parts.evening.to\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onDayPartsChange()\" placeholder=\"{{\'EVENING\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"aba-column aba-width-medium\"><div><label>&nbsp;</label><div class=\"form-group form-check aba-checkbox-container\"><label class=\"form-check-label\" for=\"wh_enabled\"><input type=\"checkbox\" class=\"form-check-input\" id=\"wh_enabled\" ng-model=\"ctrl.form.time.working_hours.enabled\"> {{\"AI_AGENT_WORKING_HOURS_ENABLED\" | translate}}</label></div></div><div class=\"form-group\" ng-if=\"ctrl.form.time.working_hours.enabled\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_WORKING_HOURS_TITLE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_WORKING_HOURS_HINT\' | translate}}\"></i></div><div class=\"aba-column aba-gap-2\"><div class=\"aba-row aba-gap-4\" ng-repeat=\"d in ctrl.weekDays\"><div class=\"form-check aba-checkbox-container aba-flex-1\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.workingDaysEnabled[d.key]\"> {{ d.label | translate }}</label></div><div class=\"aba-flex-1\" ng-if=\"ctrl.workingDaysEnabled[d.key]\"><app-dropdown model=\"ctrl.form.time.working_hours.days[d.key][0].from\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onWorkingHoursChange(d.key)\" placeholder=\"{{d.label | translate}}\"></app-dropdown></div><div class=\"aba-flex-1\" ng-if=\"ctrl.workingDaysEnabled[d.key]\"><app-dropdown model=\"ctrl.form.time.working_hours.days[d.key][0].to\" options=\"ctrl.timeOptions\" searchable=\"true\" on-change=\"ctrl.onWorkingHoursChange(d.key)\" placeholder=\"{{d.label | translate}}\"></app-dropdown></div></div></div></div><div class=\"form-group\" ng-if=\"ctrl.form.time.working_hours.enabled\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_OUTSIDE_WORKING_HOURS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_OUTSIDE_WORKING_HOURS_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.time.outside_working_hours.mode\" options=\"ctrl.outsideWorkingHoursOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_OUTSIDE_WORKING_HOURS\' | translate}}\"></app-dropdown></div><div ng-if=\"ctrl.form.time.working_hours.enabled\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_WORKING_HOURS_EXCEPTIONS_TITLE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_WORKING_HOURS_EXCEPTIONS_HINT\' | translate}}\"></i></div><div class=\"aba-row aba-gap-4 aba-align-center\"><div class=\"form-group aba-flex-1\"><input type=\"datetime\" class=\"form-control form-date\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.exceptionDate\" view=\"date\" min-view=\"date\" format=\"DD-MM-YYYY\" readonly=\"readonly\"></div><div class=\"form-group\"><button type=\"button\" class=\"btn text border-primary\" ng-click=\"ctrl.addExceptionDate()\" ng-disabled=\"!ctrl.exceptionDate\"><i class=\"las la-plus\"></i> {{\"ADD\" | translate}}</button></div></div><div ng-if=\"(ctrl.form.time.working_hours.exceptions || []).length\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_EXCLUDED_DATES\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_ADD_EXCEPTION_DATE_HINT\' | translate}}\"></i></div><div class=\"flex gap-8 wrap\"><span class=\"badge badge-light\" ng-repeat=\"dt in ctrl.form.time.working_hours.exceptions track by $index\">{{ ctrl.formatIsoToUiDate(dt) }} <a href=\"\" ng-click=\"ctrl.removeExceptionDate($index)\" class=\"ml-6\"><i class=\"las la-times\"></i></a></span></div></div></div></div></div></div></div><div ng-show=\"ctrl.activeTab === \'kb\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_KB_TITLE\" | translate}}</h3><div class=\"aba-row aba-gap-6\"><div class=\"aba-column aba-width-medium\"><div><label>&nbsp;</label><div class=\"form-group form-check aba-checkbox-container\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.kb.enabled\"> {{\"AI_AGENT_KB_ENABLED\" | translate}}</label></div></div><div class=\"form-group\" ng-if=\"ctrl.form.kb.enabled\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_KB_STRICT_MODE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_KB_STRICT_MODE_HINT\' | translate}}\"></i></div><app-dropdown model=\"ctrl.form.kb.strict_mode\" options=\"ctrl.kbStrictModeOptions\" value-prop=\"value\" placeholder=\"{{\'AI_AGENT_KB_STRICT_MODE\' | translate}}\"></app-dropdown></div><div class=\"form-group\" ng-if=\"ctrl.form.kb.enabled\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_KB_DOCS_TITLE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_KB_UPLOAD_PDF_HINT\' | translate}}\"></i></div><div class=\"form-group\"><label class=\"btn text primary large\"><i class=\"las\" ng-class=\"ctrl.kbUploading ? \'la-spinner la-spin\' : \'la-plus\'\"></i> {{\"AI_AGENT_KB_UPLOAD_PDF\" | translate}} <input style=\"visibility: hidden; display: none;\" type=\"file\" ng-disabled=\"ctrl.kbLoading || ctrl.kbUploading\" name=\"document\" accept=\".pdf\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div><div ng-if=\"ctrl.kbFiles && ctrl.kbFiles.length\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_KB_UPLOADED_FILES\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_KB_UPLOADED_FILES_HINT\' | translate}}\"></i></div><div class=\"aba-column aba-gap-2\"><div class=\"aba-row aba-gap-4 aba-align-center\" ng-repeat=\"f in ctrl.kbFiles track by (f.id || $index)\"><div class=\"aba-row aba-gap-2 aba-flex-1\" style=\"min-width: 0;\"><div class=\"aba-kb-circle\" tooltip2=\"{{ctrl.getTooltip(f)}}\" ng-class=\"{\'error\': f.pipeline_status == \'error\', \'done\': f.pipeline_status == \'done\'}\"></div><div class=\"aba-text-ellipsis\"><strong>{{f.original_name || f.name || (\'PDF #\' + ($index + 1))}}</strong></div></div><button type=\"button\" class=\"btn text border-danger small\" ng-disabled=\"ctrl.kbLoading\" ng-click=\"ctrl.confirmDeleteFile(f)\">{{\"DELETE\" | translate}}</button></div></div></div></div></div><div class=\"aba-column aba-width-medium\" ng-if=\"ctrl.form.kb.enabled\"><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{ ctrl.faqEditing ? (\"AI_AGENT_KB_FAQ_EDIT\" | translate) : (\"AI_AGENT_KB_FAQ_ADD\" | translate) }}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_KB_FAQ_HINT\' | translate}}\"></i></div><input type=\"text\" class=\"form-control\" ng-model=\"ctrl.faqDraft.question\" placeholder=\"{{\'AI_AGENT_KB_FAQ_QUESTION_PLACEHOLDER\' | translate}}\" ng-disabled=\"ctrl.kbLoading\"> <textarea class=\"form-control mt-8\" rows=\"3\" ng-model=\"ctrl.faqDraft.answer\" placeholder=\"{{\'AI_AGENT_KB_FAQ_ANSWER_PLACEHOLDER\' | translate}}\" ng-disabled=\"ctrl.kbLoading\"></textarea><div class=\"aba-row aba-gap-2 mt-8\"><button type=\"button\" class=\"btn text primary\" ng-disabled=\"ctrl.kbLoading || !ctrl.faqDraft.question || !ctrl.faqDraft.answer\" ng-click=\"ctrl.saveFaq()\">{{ ctrl.faqEditing ? (\"SAVE\" | translate) : (\"ADD\" | translate) }}</button> <button type=\"button\" class=\"btn text border-primary\" ng-if=\"ctrl.faqEditing\" ng-disabled=\"ctrl.kbLoading\" ng-click=\"ctrl.cancelFaqEdit()\">{{\"CANCEL\" | translate}}</button></div></div><div class=\"form-group\" ng-if=\"ctrl.faqItems && ctrl.faqItems.length\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_KB_FAQ_LIST\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_KB_FAQ_LIST_HINT\' | translate}}\"></i></div><div class=\"aba-column aba-gap-2\"><div class=\"aba-row aba-gap-4 aba-align-center\" ng-repeat=\"q in ctrl.faqItems track by (q.id || $index)\"><div class=\"aba-flex-1 aba-lines-2\">{{q.question}}</div><button type=\"button\" class=\"btn text border-primary small\" ng-disabled=\"ctrl.kbLoading\" ng-click=\"ctrl.editFaq(q)\">{{\"EDIT\" | translate}}</button> <button type=\"button\" class=\"btn text border-danger small\" ng-disabled=\"ctrl.kbLoading\" ng-click=\"ctrl.deleteFaq(q)\">{{\"DELETE\" | translate}}</button></div></div></div></div></div></div><div ng-show=\"ctrl.activeTab === \'customer_info\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_CUSTOMER_INFO_TITLE\" | translate}}</h3><div class=\"aba-column aba-width-medium\"><div class=\"form-group form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.customer_info.enabled\"> {{\"AI_AGENT_CUSTOMER_INFO_ENABLED\" | translate}}</label></div><div><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_CUSTOMER_INFO_ALLOWED_QUERIES_TITLE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_CUSTOMER_INFO_HINT\' | translate}}\"></i></div><div class=\"form-group aba-row aba-gap-2\"><button type=\"button\" class=\"btn text border-primary\" ng-click=\"ctrl.customerInfoAllowAll && ctrl.customerInfoAllowAll()\">{{\"AI_AGENT_CI_ALLOW_ALL\" | translate}}</button> <button type=\"button\" class=\"btn text border-primary\" ng-click=\"ctrl.customerInfoDenyAll && ctrl.customerInfoDenyAll()\">{{\"AI_AGENT_CI_DENY_ALL\" | translate}}</button></div><div class=\"aba-column aba-gap-2 form-check\"><label class=\"form-check-label\" ng-repeat=\"q in ctrl.customerInfoQueries track by q.key\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.form.customer_info.allowed[q.key]\" ng-disabled=\"!ctrl.form.customer_info.enabled\"> {{ q.titleKey | translate }} <i class=\"las la-info-circle\" tooltip2=\"{{ q.hintKey | translate}}\"></i></label></div></div></div></div><div ng-show=\"ctrl.activeTab === \'messages\'\"><h3 class=\"aba-title\">{{\"AI_AGENT_MESSAGES_TITLE\" | translate}}</h3><div class=\"alert alert-info\" style=\"margin-bottom: 16px;\"><strong>{{\"AI_AGENT_MESSAGES_PLACEHOLDERS_TITLE\" | translate}}:</strong> <span class=\"ml-8\"><code>{{\"[customerName]\"}}</code>, <code>{{\"[businessName]\"}}</code>, <code>{{\"[serviceName]\"}}</code>, <code>{{\"[employeeName]\"}}</code>, <code>{{\"[date]\"}}</code>, <code>{{\"[time]\"}}</code>, <code>{{\"[timezone]\"}}</code>, <code>{{\"[suggestedSlots]\"}}</code></span></div><div class=\"aba-row aba-gap-6\"><div class=\"aba-column aba-width-medium\"><h4 class=\"aba-title\">{{\"AI_AGENT_MESSAGES_SECTION_ROUTING_KB\" | translate}}</h4><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_OUT_OF_SCOPE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_OUT_OF_SCOPE_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.out_of_scope\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_OUT_OF_SCOPE_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_KB_NO_ANSWER\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_KB_NO_ANSWER_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.kb_no_answer\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_KB_NO_ANSWER_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_KB_HANDOFF_OFFER\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_KB_HANDOFF_OFFER_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.kb_handoff_offer\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_KB_HANDOFF_OFFER_PLACEHOLDER\' | translate}}\"></textarea></div><h4 class=\"aba-title\">{{\"AI_AGENT_MESSAGES_SECTION_BOOKING_FLOW\" | translate}}</h4><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_WELCOME\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_WELCOME_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.welcome\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_WELCOME_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_NEED_MORE_INFO\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_NEED_MORE_INFO_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.need_more_info\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_NEED_MORE_INFO_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_ASK_SERVICE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_ASK_SERVICE_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.ask_service\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_ASK_SERVICE_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_ASK_DATE_TIME\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_ASK_DATE_TIME_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.ask_date_time\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_ASK_DATE_TIME_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_ASK_EMPLOYEE\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_ASK_EMPLOYEE_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.ask_employee\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_ASK_EMPLOYEE_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_CONFIRM_BOOKING\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_CONFIRM_BOOKING_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.confirm_booking\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_CONFIRM_BOOKING_PLACEHOLDER\' | translate}}\"></textarea></div></div><div class=\"aba-clumn aba-width-medium\"><h4 class=\"aba-title\">{{\"AI_AGENT_MESSAGES_SECTION_AFTER_ACTION\" | translate}}</h4><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_BOOKING_CREATED\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_BOOKING_CREATED_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.booking_created\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_BOOKING_CREATED_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_BOOKING_UPDATED\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_BOOKING_UPDATED_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.booking_updated\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_BOOKING_UPDATED_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_BOOKING_CANCELLED\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_BOOKING_CANCELLED_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.booking_cancelled\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_BOOKING_CANCELLED_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_BOOKING_ACTION_FAILED\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_BOOKING_ACTION_FAILED_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.booking_action_failed\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_BOOKING_ACTION_FAILED_PLACEHOLDER\' | translate}}\"></textarea></div><h4 class=\"aba-title\">{{\"AI_AGENT_MESSAGES_SECTION_SCHEDULE\" | translate}}</h4><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_NO_SLOTS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_NO_SLOTS_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.no_slots_found\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_NO_SLOTS_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_OUTSIDE_WORKING_HOURS\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_OUTSIDE_WORKING_HOURS_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.outside_working_hours\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_OUTSIDE_WORKING_HOURS_PLACEHOLDER\' | translate}}\"></textarea></div><div class=\"form-group\"><div class=\"aba-row aba-align-center aba-gap-1\"><label>{{\"AI_AGENT_MSG_HANDOFF\" | translate}}</label> <i class=\"las la-info-circle\" tooltip2=\"{{\'AI_AGENT_MSG_HANDOFF_HINT\' | translate}}\"></i></div><textarea class=\"form-control\" ng-model=\"ctrl.form.messages.handoff\" rows=\"3\" placeholder=\"{{\'AI_AGENT_MSG_HANDOFF_PLACEHOLDER\' | translate}}\"></textarea></div></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"agentForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/business_whatsapp/settings.business_whatsapp.html","<div ng-include=\"\'app/components/header/header.html\'\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{\"SETTINGS_BUSINESS_WHATSAPP\" | translate}}</h3></div><div class=\"wa-settings-card\"><div class=\"wa-settings-row\"><span class=\"wa-settings-label\">{{\"BUSINESS_WHATSAPP_STATUS\" | translate}}</span> <span class=\"wa-status-badge\" ng-class=\"{ \'wa-status--none\': !ctrl.channel, \'wa-status--active\': ctrl.channel && ctrl.channel.status == \'active\', \'wa-status--pending\': ctrl.channel && ctrl.channel.status == \'pending\', \'wa-status--error\': ctrl.channel && ctrl.channel.status == \'error\', \'wa-status--disabled\': ctrl.channel && ctrl.channel.status == \'disabled\' }\"><i ng-if=\"ctrl.channel && ctrl.channel.status == \'active\'\" class=\"lab la-whatsapp\"></i> {{!ctrl.channel ? (\"BUSINESS_WHATSAPP_STATUS_NONE\" | translate) : (ctrl.statusLabels[ctrl.channel.status] || ctrl.channel.status)}}</span></div><div class=\"wa-settings-row\" ng-if=\"ctrl.channel && (ctrl.channel.display_phone_number || ctrl.channel.phone_number)\"><span class=\"wa-settings-label\">{{\"BUSINESS_WHATSAPP_PHONE_NUMBER\" | translate}}</span> <span class=\"wa-settings-value\"><i class=\"lab la-whatsapp wa-value-icon\"></i> {{ctrl.channel.display_phone_number || ctrl.channel.phone_number}}</span></div><div class=\"wa-settings-row\" ng-if=\"ctrl.channel && ctrl.channel.verified_name\"><span class=\"wa-settings-label\">{{\"BUSINESS_WHATSAPP_VERIFIED_NAME\" | translate}}</span> <span class=\"wa-settings-value\">{{ctrl.channel.verified_name}}</span></div><div class=\"wa-error-alert\" ng-if=\"ctrl.channel && ctrl.channel.last_error\"><strong>{{\"BUSINESS_WHATSAPP_LAST_ERROR\" | translate}}:</strong> {{ctrl.channel.last_error}} <span ng-if=\"ctrl.channel.last_error_at\" class=\"wa-error-time\">({{ctrl.channel.last_error_at}})</span></div><div class=\"wa-success-alert mt-24\" ng-if=\"ctrl.isFullyConnected()\"><i class=\"lab la-whatsapp wa-success-icon\"></i> <span>{{\"BUSINESS_WHATSAPP_CONNECTED_READY\" | translate}}</span></div><div class=\"wa-register-section mt-24\" ng-if=\"ctrl.canShowRegisterOption() && !ctrl.showRegisterForm && (ctrl.needsRegistration() || (ctrl.channel.status === \'active\' && !ctrl.channel.registration_completed_at))\"><p class=\"wa-register-hint\">{{\"BUSINESS_WHATSAPP_REGISTER_HINT\" | translate}}</p><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.toggleRegisterForm()\">{{\"BUSINESS_WHATSAPP_COMPLETE_REGISTRATION\" | translate}}</button></div><div class=\"wa-register-form mt-24\" ng-if=\"ctrl.canShowRegisterOption() && ctrl.showRegisterForm\"><p class=\"wa-register-hint mb-12\">{{\"BUSINESS_WHATSAPP_PIN_HINT\" | translate}}</p><div class=\"flex gap-12 align-center\" style=\"flex-wrap: wrap;\"><input type=\"text\" class=\"form-control\" ng-model=\"ctrl.pin\" placeholder=\"{{\'BUSINESS_WHATSAPP_PIN_PLACEHOLDER\' | translate}}\" maxlength=\"6\" pattern=\"[0-9]*\" inputmode=\"numeric\" style=\"width: 140px;\"> <button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.registerWa()\" ng-disabled=\"ctrl.saving\">{{ctrl.saving ? (\"BUSINESS_WHATSAPP_REGISTERING\" | translate) : (\"BUSINESS_WHATSAPP_SUBMIT_PIN\" | translate)}}</button> <button type=\"button\" class=\"btn text default\" ng-click=\"ctrl.toggleRegisterForm()\" ng-disabled=\"ctrl.saving\">{{\"CANCEL\" | translate}}</button></div><div class=\"wa-error-alert mt-12\" ng-if=\"ctrl.registerError\">{{ctrl.registerError}}</div></div></div><div class=\"flex end gap-24 mt-24\"><button ng-if=\"!ctrl.channel\" type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.init()\" ng-disabled=\"ctrl.saving\">{{\"BUSINESS_WHATSAPP_SETUP\" | translate}}</button> <button ng-if=\"ctrl.channel && ctrl.channel.status != \'active\' && !ctrl.channel.phone_number_id\" type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.init()\" ng-disabled=\"ctrl.saving\">{{\"BUSINESS_WHATSAPP_SETUP\" | translate}}</button> <button ng-if=\"ctrl.channel && ctrl.channel.status == \'error\' && !ctrl.channel.phone_number_id\" type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.init()\" ng-disabled=\"ctrl.saving\">{{\"BUSINESS_WHATSAPP_RETRY\" | translate}}</button> <button ng-if=\"ctrl.channel && ctrl.channel.status == \'active\'\" type=\"button\" class=\"btn text error large\" ng-click=\"ctrl.disconnect()\" ng-disabled=\"ctrl.saving\">{{\"BUSINESS_WHATSAPP_DISABLE\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/color/settings.color.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.interval\" options=\"ctrl.intervalOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_INFO_INT_LENGTH\' | translate}}\" required=\"true\" placeholder=\"{{\'SETTINGS_INFO_INT_LENGTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.min_time\" options=\"datesProvider.hours\" label=\"{{\'SETTINGS_WORKING_HOURS_START\' | translate}}\" placeholder=\"{{\'SETTINGS_WORKING_HOURS_START\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.max_time\" options=\"datesProvider.hours\" label=\"{{\'SETTINGS_WORKING_HOURS_END\' | translate}}\" placeholder=\"{{\'SETTINGS_WORKING_HOURS_END\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.calendar_default\" options=\"ctrl.calendarDefaultOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_CALENDAR_DEFAULT\' | translate}}\" placeholder=\"{{\'SETTINGS_CALENDAR_DEFAULT\' | translate}}\"></app-dropdown></div></div></div><div class=\"line-sep b\"></div><h3 class=\"title\">{{\"ADMIN_COLOR_TITLE\" | translate}}</h3><div class=\"flex form fill-m\"><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_BACK_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.back_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_MENU_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.menu_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_CALENDAR_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.calendar_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_HOLIDAY_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.holiday_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_CALENDAR_STRIPE_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.calendar_stripe_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-group form-color inl\"><label>{{\"ADMIN_CALENDAR_EVENT_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.calendar_event_color\" name=\"name\" class=\"form-control\"></div></div><div><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.switch_colors\">{{\"SWITCH_MENU_COLORS\" | translate}}</label></div></div></div><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.resetColors()\">{{\"SETTINGS_INFO_RESET_COLORS\" | translate}}</button><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/courses_fields/courses_fields.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_COURSES_FIELDS\" | translate }}</h3></div><div class=\"settings-block\"><ul><li class=\"li custom_field\" ng-repeat=\"field in ctrl.coursesFields\" ng-if=\"field.type == \'list\'\"><a ui-sref=\"app.settings.courses_fields.single({ id: field.id })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{field.name}}</h6><p>{{\"SETTINGS_COURSES_FIELDS_VALUES\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/custom_fields/custom_fields.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_CUSTOM_FIELDS\" | translate }}</h3></div><div class=\"settings-block\"><ul><li class=\"li custom_field\" ng-repeat=\"field in ctrl.customFields\"><a ui-sref=\"app.settings.custom_fields.single({ id: field.id })\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"las la-clipboard-list\"></i></span><div><h6>{{field.name}}</h6><p>{{\"SETTINGS_CUSTOM_FIELDS_VALUES\" | translate}}</p></div></a></li></ul></div></div></div>");
$templateCache.put("app/modules/settings/digital_documents/settings.digital_documents.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_DIGITAL_DOCUMENTS_INFO_TITLE\" | translate }}</h3></div><div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex gap-24 mb-24\"><label class=\"btn text primary large\"><i class=\"las la-plus\"></i>{{\"SETTINGS_DIGITAL_DOCUMENT\" | translate}} <input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"document\" accept=\".pdf\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div><div><div ng-if=\"ctrl.list\" class=\"dd-files\"><div ng-repeat=\"row in ctrl.list\" class=\"laser-field gap-24\">{{row.name}} <a type=\"button\" class=\"btn icon red\" ng-click=\"ctrl.removeFile(row.id);\"><i class=\"las la-trash-alt\"></i></a></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/modules/settings/documents/documents.view.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"lang == \'he\'\">{{\"SETTINGS_DEC_SET_HEB\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"lang == \'en\'\">{{\"SETTINGS_DEC_SET_ENG\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"m-t\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DOC_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.agent\" class=\"form-control\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DOC_NOTE\" | translate}}</label> <textarea ng-model=\"ctrl.form.notes\" class=\"form-control\" style=\"height: 130px; resize: none;\"></textarea></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_DOC_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid || infoForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_DOC_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/google_calendar/google_calendar.view.html","<div ng-include=\"\'app/components/header/header.html\'\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"GOOGLE_CALENDAR_SETTINGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ng-click=\"ctrl.connectNewAccount()\">{{\"CONNECT_NEW_ACCOUNT\" | translate}}</button></div><div class=\"cloud-list\"><table ng-if=\"ctrl.accounts.length\" class=\"sorted-table\"><thead><tr><th>{{\"GOOGLE_CALENDAR_ACCOUNT_NAME\" | translate}}</th><th>{{\"GOOGLE_CALENDAR_ACCOUNT_RESOURCES\" | translate}}</th><th>{{\"GOOGLE_CALENDAR_ACCOUNT_INCOME_RESOURCES\" | translate}}</th><th></th><th style=\"text-align: end;\">{{\"GOOGLE_CALENDAR_ACCOUNT_ACTIVE\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in ctrl.accounts\" ng-click=\"ctrl.editAccountResources(row)\" ng-class=\"{\'error\': row.error_message}\"><td><div class=\"flex nowrap\"><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar_url || \'assets/images/default-avatar.png\'}}\" alt=\"\" class=\"customer-pic\"></div><div><p>{{row.name}}</p><p>{{row.email}}</p></div></div></td><td>{{row.resource_names.join(\', \')}}</td><td>{{row.income_resource_names.join(\', \')}}</td><td>{{row.error_message || \'\'}}</td><td style=\"text-align: end;\"><div class=\"form-switch form-group first last pull-end\" ng-click=\"$event.stopPropagation()\"><label style=\"padding-left: 42px;\"><input type=\"checkbox\" ng-change=\"ctrl.toggleAccountStatus(row)\" ng-model=\"row.is_active\">&nbsp;</label></div></td></tr></tbody></table></div><div ng-if=\"!ctrl.loading && ctrl.accounts.length === 0\" class=\"no-accounts\"><div class=\"no-accounts-content\"><i class=\"fa fa-google fa-3x\"></i><h4>{{\"NO_GOOGLE_ACCOUNTS\" | translate}}</h4><p>{{\"NO_GOOGLE_ACCOUNTS_DESCRIPTION\" | translate}}</p></div></div></div></div></div>");
$templateCache.put("app/modules/settings/info/info.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form\"><div class=\"col-md-2 col-xs-6\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.avatar + \')\'}\"></div></label></div><div class=\"col-md-2 col-xs-6\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"logo\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.logo + \')\'}\"></div></label></div></div><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_BUSS_NAME\" | translate}}</label> <input disabled=\"\" type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"infoForm.name.$error\" class=\"ng-messages\" ng-show=\"infoForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_COMP_ID\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.company_id\" name=\"company_id\" class=\"form-control\" disabled=\"\" required=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.default_screen\" options=\"ctrl.defaultScreenOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_DEFAULT_SCREEN\' | translate}}\" placeholder=\"{{\'SETTINGS_DEFAULT_SCREEN\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_ACCOUNTANT_EMAIL\" | translate}}</label> <input type=\"accountant_email\" ng-model=\"ctrl.form.accountant_email\" name=\"accountant_email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"infoForm.accountant_email.$error\" class=\"ng-messages\" ng-show=\"infoForm.accountant_email.$dirty\"><div ng-message=\"accountant_email\">{{\"SETTINGS_INFO_ACCOUNTANT_EMAIL_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INFO_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"infoForm.email.$error\" class=\"ng-messages\" ng-show=\"infoForm.email.$dirty\"><div ng-message=\"email\">{{\"SETTINGS_INFO_EMAIL_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PHONE\" | translate}}</label> <input type=\"tel\" name=\"phone\" required=\"\" ng-model=\"ctrl.form.phone\" placeholder=\"0534231367\" class=\"form-control\"><div ng-messages=\"businessForm.phone.$error\" class=\"ng-messages\" ng-show=\"businessForm.phone.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.city\" name=\"address\" class=\"form-control\"><div ng-messages=\"infoForm.city.$error\" class=\"ng-messages\" ng-show=\"infoForm.city.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_ADDRESS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"><div ng-messages=\"infoForm.address.$error\" class=\"ng-messages\" ng-show=\"infoForm.address.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_HOME_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.home_number\" name=\"name\" class=\"form-control\"><div ng-messages=\"infoForm.home_number.$error\" class=\"ng-messages\" ng-show=\"infoForm.home_number.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_POST_CODE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.zip\" name=\"name\" class=\"form-control\"><div ng-messages=\"infoForm.zip.$error\" class=\"ng-messages\" ng-show=\"infoForm.zip.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.dealer_type\" options=\"ctrl.dealerTypeOptions\" value-prop=\"id\" disabled=\"true\" label=\"{{\'DEALER_TYPE\' | translate}}\" required=\"true\" placeholder=\"{{\'DEALER_TYPE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.language_code\" options=\"ctrl.languageOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_INFO_LANG\' | translate}}\" required=\"true\" placeholder=\"{{\'SETTINGS_INFO_LANG\' | translate}}\"></app-dropdown></div></div></div><div class=\"line-sep\"></div><div class=\"flex form\"><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_notes\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_notes\" ng-model=\"ctrl.form.show_notes\">{{\"SETTINGS_INFO_SHOW_NOTES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"stop_messages\"><input type=\"checkbox\" class=\"form-check-input\" id=\"stop_messages\" ng-model=\"ctrl.form.stop_messages\">{{\"SETTINGS_INFO_STOP_MESSAGES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"manage_leads\"><input type=\"checkbox\" class=\"form-check-input\" id=\"manage_leads\" ng-model=\"ctrl.form.manage_leads\">{{\"SETTINGS_INFO_MANAGE_LEADS\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"manage_employee\"><input type=\"checkbox\" class=\"form-check-input\" id=\"manage_employee\" ng-model=\"ctrl.form.manage_employee\">{{\"SETTINGS_MANAGE_EMPLOYEE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"print_invoices\"><input type=\"checkbox\" class=\"form-check-input\" id=\"print_invoices\" ng-model=\"ctrl.form.print_invoices\">{{\"SETTINGS_PRINT_AUTOMATICALLY\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_stock\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_stock\" ng-model=\"ctrl.form.show_stock\">{{\"SETTINGS_SHOW_STOCK\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"stop_saturday_messages\"><input type=\"checkbox\" class=\"form-check-input\" id=\"stop_saturday_messages\" ng-model=\"ctrl.form.stop_saturday_messages\">{{\"SETTINGS_STOP_SATURDAY_MESSAGES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_notes_page\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_notes_page\" ng-model=\"ctrl.form.show_notes_page\">{{\"SETTINGS_INFO_SHOW_NOTES_PAGE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"show_digital_forms_page\"><input type=\"checkbox\" class=\"form-check-input\" id=\"show_digital_forms_page\" ng-model=\"ctrl.form.show_digital_forms_page\">{{\"SETTINGS_INFO_SHOW_DIGITAL_FORMS_PAGE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"customer_wa_chat\"><input type=\"checkbox\" class=\"form-check-input\" id=\"customer_wa_chat\" ng-model=\"ctrl.form.customer_wa_chat\" ng-change=\"ctrl.changeCustomerWaChat()\">{{\"SETTINGS_INFO_CUSTOMER_WA_CHAT\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_wa_messages\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_wa_messages\" ng-model=\"ctrl.form.display_wa_messages\">{{\"SETTINGS_INFO_DISPLAY_WA_MESSAGES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"print_customer_dealer_id\"><input type=\"checkbox\" class=\"form-check-input\" id=\"print_customer_dealer_id\" ng-model=\"ctrl.form.print_customer_dealer_id\">{{\"SETTINGS_INFO_PRINT_CUSTOMER_DEALER_ID\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_order_user\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_order_user\" ng-model=\"ctrl.form.display_order_user\">{{\"SETTINGS_INFO_DISPLAY_ORDER_USER\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_one_block_services\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_one_block_services\" ng-model=\"ctrl.form.display_one_block_services\">{{\"SETTINGS_INFO_DISPLAY_ONE_BLOCK_SERVICES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"display_hebrew_dates\"><input type=\"checkbox\" class=\"form-check-input\" id=\"display_hebrew_dates\" ng-model=\"ctrl.form.display_hebrew_dates\">{{\"SETTINGS_INFO_DISPLAY_HEBREW_DATES\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"allow_duplicate_phone\"><input type=\"checkbox\" class=\"form-check-input\" id=\"allow_duplicate_phone\" ng-model=\"ctrl.form.allow_duplicate_phone\">{{\"SETTINGS_INFO_ALLOW_DUPLICATE_PHONE\" | translate}}</label></div></div><div><div class=\"form-group form-check\"><label class=\"form-check-label\" for=\"sent_accountant_report\"><input type=\"checkbox\" class=\"form-check-input\" id=\"sent_accountant_report\" ng-model=\"ctrl.form.sent_accountant_report\">{{\"SETTINGS_INFO_SENT_ACCOUNTANT_REPORT\" | translate}}</label></div></div></div><div class=\"line-sep\"></div><h3 class=\"title\">{{\"ADMIN_OPTIONAL_TITLE\" | translate}}</h3><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\" ng-show=\"ctrl.form.sent_accountant_report\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.accountant_report_day\" options=\"ctrl.accountantReportDayOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_INFO_ACCOUNTANT_REPORT_DAY\' | translate}}\" placeholder=\"{{\'SETTINGS_INFO_ACCOUNTANT_REPORT_DAY\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\" ng-show=\"ctrl.form.sent_accountant_report\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.accountant_report_time\" options=\"ctrl.accountantReportTimeOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_INFO_ACCOUNTANT_REPORT_TIME\' | translate}}\" placeholder=\"{{\'SETTINGS_INFO_ACCOUNTANT_REPORT_TIME\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_INFO_PREPAID\" | translate}}</label> <input type=\"number\" step=\"0.01\" ng-model=\"ctrl.form.prepaid\" name=\"prepaid\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.ave_calculation\" options=\"ctrl.aveCalculationOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_INFO_AVE_CALCULATION\' | translate}}\" placeholder=\"{{\'SETTINGS_INFO_AVE_CALCULATION\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.msg_channel_scheduling\" options=\"ctrl.msgChannelOptionsNoFour\" value-prop=\"id\" label=\"{{\'SETTINGS_DEFAULT_SCHEDULE_MESSAGE_CHANNEL\' | translate}}\" placeholder=\"{{\'SETTINGS_DEFAULT_SCHEDULE_MESSAGE_CHANNEL\' | translate}}\" on-change=\"ctrl.checkCustomerDefault(\'msg_channel_scheduling\')\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.update_order_notification\" options=\"ctrl.orderUpdateNotificationOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ORDER_UPDATE_NOTIFICATION\' | translate}}\" placeholder=\"{{\'SETTINGS_ORDER_UPDATE_NOTIFICATION\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.send_reminder\" options=\"ctrl.sendReminderOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_USER_SEND_REMINDER\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_SEND_REMINDER\' | translate}}\" on-change=\"ctrl.checkCustomerDefault(\'send_reminder\')\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\" ng-show=\"ctrl.form.send_reminder != 0\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.reminder_send_type\" options=\"ctrl.msgChannelOptionsNoFour\" value-prop=\"id\" label=\"{{\'CUSTOMERS_SEND_REMINDER\' | translate}}\" placeholder=\"{{\'CUSTOMERS_SEND_REMINDER\' | translate}}\" on-change=\"ctrl.checkCustomerDefault(\'reminder_send_type\')\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\" ng-show=\"ctrl.form.send_reminder != 0\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.request_order_confirmation\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ORDER_CONFIRMATION_DEFAULT\' | translate}}\" placeholder=\"{{\'SETTINGS_ORDER_CONFIRMATION_DEFAULT\' | translate}}\" on-change=\"ctrl.checkCustomerDefault(\'request_order_confirmation\')\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.msg_channel_inv_link\" options=\"ctrl.msgChannelOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_DEFAULT_INV_LINK_MESSAGE_CHANNEL\' | translate}}\" placeholder=\"{{\'SETTINGS_DEFAULT_INV_LINK_MESSAGE_CHANNEL\' | translate}}\" on-change=\"ctrl.checkCustomerDefault(\'msg_channel_inv_link\')\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.dd_df_channel\" options=\"ctrl.msgChannelOptionsNoFourNoOne\" value-prop=\"id\" label=\"{{\'SETTINGS_DF_DD_CHANNEL\' | translate}}\" placeholder=\"{{\'SETTINGS_DF_DD_CHANNEL\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.online_channel\" options=\"ctrl.msgChannelOptionsNoFourNoOne\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_CHANNEL\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_CHANNEL\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.not_arrive_option\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_NOT_ARRIVE\' | translate}}\" placeholder=\"{{\'SETTINGS_NOT_ARRIVE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\" ng-if=\"false\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.update_order_notification\" options=\"ctrl.orderUpdateNotificationOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_UPDATE_ORDER_NOTIFICATION\' | translate}}\" placeholder=\"{{\'SETTINGS_UPDATE_ORDER_NOTIFICATION\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_APPROVAL_TEXT\" | translate}}</label> <textarea ng-model=\"ctrl.form.approval_text\" class=\"form-control\"></textarea></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.lead_appearence\" options=\"ctrl.leadAppearanceOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_LEAD_APPEARENCE\' | translate}}\" placeholder=\"{{\'SETTINGS_LEAD_APPEARENCE\' | translate}}\"></app-dropdown></div></div><div ng-if=\"ctrl.form.stop_saturday_messages\" class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.stop_saturday_messages_condition\" options=\"ctrl.stopSaturdayConditionOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION\' | translate}}\" placeholder=\"{{\'SETTINGS_STOP_SATURDAY_MESSAGES_CONDITION\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group last\"><app-dropdown model=\"ctrl.selectedNotifications\" options=\"ctrl.user_device_notifications_options\" multiple=\"true\" searchable=\"true\" label=\"{{\'SETTINGS_MOBILE_NOTIFICATION_SETTINGS\' | translate}}\" placeholder=\"{{\'SETTINGS_MOBILE_NOTIFICATION_SETTINGS\' | translate}}\" search-placeholder=\"{{\'SETTINGS_MOBILE_NOTIFICATION_SETTINGS\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\" ng-if=\"ctrl.isUpcomingQueueSelected()\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.self_queue_notification\" options=\"ctrl.queueNotificationIntervalOptions\" value-prop=\"id\" show-clear=\"true\" label=\"{{\'SETTINGS_SELF_QUEUE_NOTIFICATION\' | translate}}\" placeholder=\"{{\'SETTINGS_SELECT_INTERVAL\' | translate}}\"></app-dropdown></div></div></div><div class=\"line-sep\"></div><h3 class=\"title\">{{\"ADMIN_LINK_TITLE\" | translate}}</h3><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_FACEBOOK_REVIEW\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.facebook_review\" name=\"name\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_GOOGLE_REVIEW\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.google_review\" name=\"name\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_TELEPHONY_LINK\" | translate}}</label> <input type=\"text\" value=\"{{ctrl.telephonyLink}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"ADMIN_TELEPHONY_TOKEN\" | translate}}</label> <input type=\"text\" value=\"{{ctrl.form.telephony_token}}\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/landing/settings.landing.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_LANDING_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form form_templates\"><div><div class=\"form_radio_img\"><img src=\"assets/images/template1.png\" alt=\"template1\"></div><div class=\"radio-btn\"><input ng-change=\"ctrl.submit()\" id=\"radio_template1\" type=\"radio\" value=\"1\" ng-model=\"ctrl.form.template\" name=\"name\"> <label for=\"radio_template1\">{{\"LANDING_TEMPLATE_1\" | translate}}</label></div></div><div><div class=\"form_radio_img\"><img src=\"assets/images/template2.png\" alt=\"template2\"></div><div class=\"radio-btn\"><input ng-change=\"ctrl.submit()\" id=\"radio_template2\" type=\"radio\" value=\"2\" ng-model=\"ctrl.form.template\" name=\"name\"> <label for=\"radio_template2\">{{\"LANDING_TEMPLATE_2\" | translate}}</label></div></div><div><div class=\"form_radio_img\"><img src=\"assets/images/template3.png\" alt=\"template3\"></div><div class=\"radio-btn\"><input ng-change=\"ctrl.submit()\" id=\"radio_template3\" type=\"radio\" value=\"3\" ng-model=\"ctrl.form.template\" name=\"name\"> <label for=\"radio_template3\">{{\"LANDING_TEMPLATE_3\" | translate}}</label></div></div></div><div class=\"line-sep\"></div><div class=\"flex form v-start\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"SETTINGS_ONLINE_ALIAS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.landing_alias\" ng-change=\"ctrl.onAliasChange()\" name=\"alias\" class=\"form-control\" ng-class=\"{\'form-control-error\': ctrl.aliasStatus == \'symbols\' || ctrl.aliasStatus == \'taken\' || ctrl.aliasStatus == \'length\'}\"><div ng-show=\"ctrl.aliasStatus == \'loading\'\" class=\"input-loader\"><i class=\"las la-spinner\"></i></div></div><i class=\"input-hint\" ng-class=\"{\'visible error\': ctrl.aliasStatus == \'symbols\' || ctrl.aliasStatus == \'taken\' || ctrl.aliasStatus == \'length\'}\"><span ng-if=\"ctrl.aliasStatus == \'pending\' || ctrl.aliasStatus == \'loading\' || ctrl.aliasStatus == \'success\'\">&nbsp;</span> <span ng-if=\"ctrl.aliasStatus == \'symbols\'\">{{\"SETTINGS_ONLINE_ALIAS_SYMBOLS\" | translate}}</span> <span ng-if=\"ctrl.aliasStatus == \'taken\'\">{{\"SETTINGS_ONLINE_ALIAS_TAKEN\" | translate}}</span> <span ng-if=\"ctrl.aliasStatus == \'length\'\">{{\"SETTINGS_ONLINE_ALIAS_LENGTH\" | translate}}</span></i></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"SETTINGS_LANDING_BOOKING_LINK\" | translate}}</label> <a href=\"javascript:;\" ng-click=\"ctrl.copyLink()\" class=\"copy-icon\"><i class=\"las la-copy\"></i></a> <input type=\"text\" value=\"{{ ctrl.uniqueBusinessBookingURL() }}\" class=\"form-control\" readonly=\"\"></div><i class=\"input-hint success\" ng-class=\"{\'visible\': ctrl.copied}\">{{\"SETTINGS_ONLINE_URL_COPIED\" | translate}}</i></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <a href=\"javascript:;\" ng-click=\"ctrl.editPage()\" class=\"btn text white large\"><i class=\"las la-pen\"></i>{{\"LANDING_EDIT\" | translate}}</a> <a href=\"{{ ctrl.uniqueBusinessBookingURL() }}\" target=\"_blank\" class=\"btn text primary large\"><i class=\"las la-eye\"></i>{{\"LANDING_PREVIEW\" | translate}}</a> <button type=\"button\" ng-click=\"ctrl.submit(true)\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/laser_file/settings.laser_file.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_LASER_INFO_TITLE\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><div class=\"btn-group large\"><button ng-repeat=\"category in ctrl.laser_categories\" class=\"btn\" ng-click=\"ctrl.change_category(category.id);\" ng-class=\"{\'btn-primary\': ctrl.category == category.id, \'btn-default\': ctrl.category != category.id}\"><span ng-if=\"!ctrl.category_edit[category.id]\">{{category.name}}</span><div ng-if=\"ctrl.category_edit[category.id]\" style=\"width: 180px;\"><app-input model=\"ctrl.category_edit_values[category.id]\" type=\"text\" simple=\"true\" placeholder=\"{{\'SETTINGS_INFO_BUSS_NAME\' | translate}}\"></app-input></div><a class=\"btn small icon primary circle simple\" ng-if=\"!ctrl.category_edit[category.id]\" ng-click=\"ctrl.start_edit_category($event, category);\"><i class=\"las la-edit\"></i></a> <a class=\"btn small icon green circle simple\" ng-if=\"ctrl.category_edit[category.id]\" ng-click=\"ctrl.save_category_name($event, category);\"><i class=\"las la-check\"></i></a></button></div><button class=\"btn text primary large\" ng-click=\"ctrl.new_field();\"><i class=\"las la-plus\"></i> {{\"SETTINGS_LASER_NEW_FIELD\" | translate}}</button></div></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" novalidate=\"\"><div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\" ui-sortable=\"sortableOptions\" ng-model=\"ctrl.form\"><div ng-repeat=\"field in ctrl.form\" class=\"laser-field\" ng-show=\"field.category_id == ctrl.category\"><i class=\"drag-handle las la-braille\"></i><div class=\"form-check form-group last\"><label for=\"{{field.id}}\"><input type=\"checkbox\" id=\"{{field.id}}\" ng-model=\"field.active\"> <b>{{field.name}}</b></label></div><div class=\"flex gap-8 laser-list-setup\"><a ng-if=\"field.type==\'list\'\" class=\"btn text primary\" ng-click=\"ctrl.setup_list(field);\">{{\"SETTINGS_LASER_SETUP_LIST\" | translate}}</a> <a class=\"btn icon bordered primary\" ng-click=\"ctrl.new_field(field);\"><span class=\"las la-edit\"></span></a></div></div></div></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/modules/settings/messages/settings.messages.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_NOT_SET\" | translate }}</h3><div class=\"btn-group large\"><button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.mainTabIndex === 0, \'btn-default\': ctrl.mainTabIndex !== 0}\" ng-click=\"ctrl.mainTabIndex = 0\">{{ \"SETTINGS_MESS_REGULAR\" | translate }}</button> <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.mainTabIndex === 1, \'btn-default\': ctrl.mainTabIndex !== 1}\" ng-click=\"ctrl.mainTabIndex = 1\">{{ \"SETTINGS_MESS_NOTIFICATIONS\" | translate }}</button> <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.mainTabIndex === 2, \'btn-default\': ctrl.mainTabIndex !== 2}\" ng-click=\"ctrl.mainTabIndex = 2\">{{ \"SETTINGS_DIGITAL_SECRETARY\" | translate }}</button></div></div><div class=\"mesages-settings\"><form class=\"modal-form_f\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"ctrl.mainTabIndex === 0\"><uib-tabset><uib-tab heading=\'{{\"SETTINGS_MESS_NEW_OR\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.order_created\" masks=\"ctrl.regularMessageMasks.order_created\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.order_created\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_UP_INV\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_2\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.order_updated\" masks=\"ctrl.regularMessageMasks.order_updated\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.order_updated\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_CANS_RES\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_3\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.order_cancelled\" masks=\"ctrl.regularMessageMasks.order_cancelled\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.order_cancelled\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_UPD_BAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_4\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.customer_debt\" masks=\"ctrl.regularMessageMasks.customer_debt\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.customer_debt\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_SEND_INV\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.invoice\" masks=\"ctrl.regularMessageMasks.invoice\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.invoice\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_REMINDER\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_8\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.reminder\" masks=\"ctrl.regularMessageMasks.reminder\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.reminder\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_APPROVAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_8\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.order_approval\" masks=\"ctrl.regularMessageMasks.order_approval\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.order_approval\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_BIRTHDAY\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.birthday\" masks=\"ctrl.regularMessageMasks.birthday\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.birthday\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_ONLINE_APPROVAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.online_approval\" masks=\"ctrl.regularMessageMasks.online_approval\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.online_approval\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_ONLINE_DECLINE\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.online_decline\" masks=\"ctrl.regularMessageMasks.online_decline\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.online_decline\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_CUSTOMER_UPDATE_ONLINE\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.customer_update_online\" masks=\"ctrl.regularMessageMasks.customer_update_online\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.customer_update_online\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_CUSTOMER_ONLINE_CANCELED\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.customer_online_canceled\" masks=\"ctrl.regularMessageMasks.customer_online_canceled\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.customer_online_canceled\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_DIGITAL_FORM\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.digital_form\" masks=\"ctrl.regularMessageMasks.digital_form\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.digital_form\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_DIGITAL_DOCUMENTS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.digital_documents\" masks=\"ctrl.regularMessageMasks.digital_documents\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.digital_documents\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_PAY_BY_LINK\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.pay_by_link\" masks=\"ctrl.regularMessageMasks.pay_by_link\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.pay_by_link\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_PREPAID\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.prepaid\" masks=\"ctrl.regularMessageMasks.prepaid\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.prepaid\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_PUBLIC_LINK\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.public_link\" masks=\"ctrl.regularMessageMasks.public_link\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.public_link\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_WAITING_SMS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.waiting_sms\" masks=\"ctrl.regularMessageMasks.waiting_sms\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.waiting_sms\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_GIFT_CARD_SMS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.gift_card_sms\" masks=\"ctrl.regularMessageMasks.gift_card_sms\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.gift_card_sms\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_REQUEST_CARD\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.request_card\" masks=\"ctrl.regularMessageMasks.request_card\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.request_card\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_LINK_ONLINE\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.link_online\" masks=\"ctrl.regularMessageMasks.link_online\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.link_online\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_DEBT_REMINDER\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_ENTER_9\" | translate}}</label><app-textarea-mask model=\"ctrl.form.regular.debt_reminder\" masks=\"ctrl.regularMessageMasks.debt_reminder\" rows=\"6\"></app-textarea-mask><br><label>{{\"SETTINGS_MESS_TXT1\" | translate}}</label><p ng-repeat=\"item in ctrl.regularMessageMasks.debt_reminder\" style=\"margin-bottom: 0;\">{{item.value}}</p></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"ctrl.mainTabIndex === 1\"><uib-tabset><uib-tab heading=\'{{\"SETTINGS_MESS_NOTIF_DIGITAL_FORMS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_NOTIF_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.notifications.digital_forms\"></textarea></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_NOTIF_NEW_LEADS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_NOTIF_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.notifications.new_leads\"></textarea></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_NOTIF_BIRTHDAYS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_NOTIF_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.notifications.birthdays\"></textarea></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_NOTIF_UPCOMING_QUEUE\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_NOTIF_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.notifications.upcoming_queue\"></textarea></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_NOTIF_CANCELLATIONS\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_NOTIF_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.notifications.cancellations\"></textarea></div></div></div></uib-tab><uib-tab heading=\'{{\"SETTINGS_MESS_NOTIF_QUEUE_AWAITING_APPROVAL\" | translate}}\'><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_MESS_NOTIF_ENTER\" | translate}}</label> <textarea class=\"form-control tall\" ng-model=\"ctrl.form.notifications.queue_awaiting_approval\"></textarea></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"ctrl.mainTabIndex === 2\"><uib-tabset active=\"ctrl.digitalSecretaryActiveTabIndex\"><uib-tab heading=\'{{\"SETTINGS_DIGITAL_SECRETARY_ORDER_APPROVAL_TAB\" | translate}}\' select=\"ctrl.onDigitalSecretaryTabSelect(\'order_approval\')\"><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><div class=\"form-switch\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.digital_secretary[ctrl.digitalSecretaryActiveTab].active\"> {{ \"SETTINGS_DIGITAL_SECRETARY_ACTIVATE\" | translate }}</label></div><p class=\"help-text\">{{ \"SETTINGS_DIGITAL_SECRETARY_ACTIVATE_DESC\" | translate }}</p></div></div></div><div ng-if=\"ctrl.form.digital_secretary[ctrl.digitalSecretaryActiveTab] && ctrl.form.digital_secretary[ctrl.digitalSecretaryActiveTab].active\" class=\"digital-secretary-config\"><div class=\"config-section\"><div class=\"flex form\"><div class=\"col-xs-12\"><div class=\"form-group\"><app-textarea-mask label=\"{{ \'SETTINGS_DIGITAL_SECRETARY_MESSAGE_LABEL\' | translate }}\" model=\"ctrl.form.digital_secretary[ctrl.digitalSecretaryActiveTab].message\" placeholder=\"{{ \'SETTINGS_DIGITAL_SECRETARY_MESSAGE_PLACEHOLDER\' | translate }}\" masks=\"ctrl.digitalSecretaryMasks\" rows=\"6\"></app-textarea-mask></div></div></div></div><div class=\"config-section speech-after-section\"><div class=\"action-wrapper\"><div class=\"action-item speech-after-item\" ng-repeat=\"n in ctrl.getDigitalSecretarySpeechRange()\"><label class=\"speech-after-label\">{{ n }} {{ \"SETTINGS_DIGITAL_SECRETARY_SPEECH_LABEL\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.form.digital_secretary[ctrl.digitalSecretaryActiveTab][\'speech_\' + n]\" placeholder=\"{{ ctrl.getDigitalSecretarySpeechPlaceholder(n) }}\"></div></div></div></div></uib-tab></uib-tabset></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_DOC_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"infoForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_DOC_SEND\" | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/modules/settings/online/booking-fields-modal.html","<div class=\"modal-form-inner tabs-form\" id=\"booking-fields\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\'SETTINGS_ONLINE_BOOKING_FIELDS\' | translate}}</h3><a type=\"button\" class=\"close\" ng-click=\"ctrl.cancel()\"><span>&times;</span></a></div><div class=\"modal-body\"><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\'SETTINGS_ONLINE_BOOKING_FIELDS_FIELD\' | translate}}</th><th style=\"text-align: center;\">{{\'SETTINGS_ONLINE_BOOKING_FIELDS_DISPLAY\' | translate}}</th><th style=\"text-align: center;\">{{\'SETTINGS_ONLINE_BOOKING_FIELDS_REQUIRED\' | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.onSortStop }\" ng-model=\"ctrl.fields\"><tr ng-repeat=\"field in ctrl.fields\" ng-class=\"{\'inactive\': !field.display}\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><span class=\"field-name\">{{ctrl.getFieldDisplayName(field)}}</span></td><td style=\"text-align: center;\"><div class=\"form-switch form-group first last\" ng-click=\"$event.stopPropagation()\"><label style=\"padding-left: 42px;\"><input type=\"checkbox\" ng-model=\"field.display\" ng-change=\"ctrl.toggleFieldDisplay(field)\"></label></div></td><td style=\"text-align: center;\"><div class=\"form-switch form-group first last\" ng-click=\"$event.stopPropagation()\" ng-class=\"{\'disabled\': !ctrl.canRequire(field)}\"><label ng-class=\"{\'disabled\': !ctrl.canRequire(field)}\" style=\"padding-left: 42px;\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"ctrl.toggleFieldRequired(field)\" ng-disabled=\"!ctrl.canRequire(field)\"></label></div></td></tr></tbody></table><div class=\"empty-list text-center mt-24\" ng-if=\"!ctrl.fields || ctrl.fields.length === 0\"><i class=\"las la-info-circle\"></i><p>{{\'NO_FIELDS_AVAILABLE\' | translate}}</p></div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.cancel()\">{{\"CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.save()\">{{\"SAVE\" | translate}}</button></div></div>");
$templateCache.put("app/modules/settings/online/settings.online.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_BUSINESS_ONLINE_DET\" | translate }}</h3></div><form class=\"\" name=\"infoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"flex form v-start\"><div class=\"col-md-2 col-xs-12\"><div class=\"import-multifile\">{{\"SETTINGS_PICTURE_BACKGROUND\" | translate}}<div class=\"import-multifile-inner\"><label><input style=\"visibility: hidden\" type=\"file\" name=\"background\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background + \')\'}\"></div><img ng-if=\"!ctrl.form.background\" src=\"/assets/images/empty_image.png\"> <span class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background\')\"><i class=\"las la-trash-alt\"></i></span></label> <label><input style=\"visibility: hidden\" type=\"file\" name=\"background1\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background1\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background1 + \')\'}\"></div><img ng-if=\"!ctrl.form.background1\" src=\"/assets/images/empty_image.png\"> <span ng-if=\"ctrl.form.background1\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background1\')\"><i class=\"las la-trash-alt\"></i></span></label> <label><input style=\"visibility: hidden\" type=\"file\" name=\"background2\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background2\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background2 + \')\'}\"></div><img ng-if=\"!ctrl.form.background2\" src=\"/assets/images/empty_image.png\"> <span ng-if=\"ctrl.form.background2\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background2\')\"><i class=\"las la-trash-alt\"></i></span></label> <label><input style=\"visibility: hidden\" type=\"file\" name=\"background3\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.background3\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.background3 + \')\'}\"></div><img ng-if=\"!ctrl.form.background3\" src=\"/assets/images/empty_image.png\"> <span ng-if=\"ctrl.form.background3\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'background3\')\"><i class=\"las la-trash-alt\"></i></span></label></div></div></div><div class=\"col-md-2 col-xs-12\"><label class=\"import-file\">{{\"SETTINGS_PICTURE_LOGO\" | translate}} <input style=\"visibility: hidden\" type=\"file\" name=\"online_logo\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.online_logo + \')\'}\"></div><span class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'online_logo\')\"><i class=\"las la-trash-alt\"></i></span></label></div><div class=\"col-md-2 col-xs-12\"><label class=\"import-file\">{{\"SETTINGS_PICTURE_ICON\" | translate}} <input style=\"visibility: hidden\" type=\"file\" name=\"icon\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image logo\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.icon + \')\'}\"></div><span class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'icon\')\"><i class=\"las la-trash-alt\"></i></span></label></div><div class=\"col-md-6 col-xs-12\"><label>{{\"SETTINGS_ONLINE_BOOKING_FIELDS\" | translate}}</label><div class=\"form-group\"><span ng-if=\"ctrl.hasVisibleFields()\">{{ctrl.getVisibleFieldsDisplay()}}</span> <span ng-if=\"!ctrl.hasVisibleFields()\" style=\"color: #999; font-style: italic;\">{{\"SETTINGS_ONLINE_BOOKING_FIELDS_EMPTY\" | translate}}</span></div><button type=\"button\" ng-click=\"ctrl.openBookingFieldsModal()\" class=\"btn text border-primary\">{{\"SETTINGS_ONLINE_BOOKING_FIELDS_EDIT\" | translate}}</button></div></div><div class=\"line-sep\"></div><div class=\"flex form v-start\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.name\" type=\"text\" name=\"name\" label=\"{{\'SETTINGS_INFO_BUSS_NAME\' | translate}}\" required=\"true\"></app-input><div ng-messages=\"infoForm.name.$error\" class=\"ng-messages\" ng-show=\"infoForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.address\" type=\"text\" name=\"address\" label=\"{{\'SETTINGS_WAZE_ADDRESS\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.status\" options=\"ctrl.statusOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_STATUS\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_STATUS\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_online_booking\" options=\"ctrl.allowOnlineBookingOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ALLOW_ONLINE_BOOKING\' | translate}}\" placeholder=\"{{\'SETTINGS_ALLOW_ONLINE_BOOKING\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_new\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_ALLOW_NEW\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_ALLOW_NEW\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.waiting_list\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_WAITING_LIST\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_WAITING_LIST\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.display_price\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_DISPLAY_PRICE\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_DISPLAY_PRICE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.display_duration\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_DISPLAY_DURATION\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_DISPLAY_DURATION\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.disable_confirmation_code\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" on-change=\"ctrl.handleDisableCode()\" label=\"{{\'SETTINGS_ONLINE_DISABLE_CONFIRMATION_CODE\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_DISABLE_CONFIRMATION_CODE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.confirmation_code\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_CONFIRMATION_CODE\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_CONFIRMATION_CODE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.resource\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_SELECT_RESOURCE\' | translate}}\" placeholder=\"{{\'SETTINGS_SELECT_RESOURCE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.display_category\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_DISPLAY_CATEGORY\' | translate}}\" placeholder=\"{{\'SETTINGS_DISPLAY_CATEGORY\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.display_earliest\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_DISPLAY_EARLIEST\' | translate}}\" placeholder=\"{{\'SETTINGS_DISPLAY_EARLIEST\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_multi\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ALLOW_MULTI\' | translate}}\" placeholder=\"{{\'SETTINGS_ALLOW_MULTI\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_first_available\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ALLOW_FIRST_AVAILABLE\' | translate}}\" placeholder=\"{{\'SETTINGS_ALLOW_FIRST_AVAILABLE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group last\"><app-dropdown model=\"ctrl.form.available_hours\" options=\"ctrl.availableHoursOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_AVAILABLE_HOURS\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_AVAILABLE_HOURS\' | translate}}\"></app-dropdown></div><i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'calendar\'\">{{\"SETTINGS_ONLINE_CALENDAR_INTERVAL_TOOLTIP\" | translate}}</i> <i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'item\'\">{{\"SETTINGS_ONLINE_ITEM_DURATION_TOOLTIP\" | translate}}</i> <i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'calendar_order\'\">{{\"SETTINGS_ONLINE_CALENDAR_ORDER_INTERVAL_TOOLTIP\" | translate}}</i> <i class=\"select-tooltip\" ng-if=\"ctrl.form.available_hours == \'item_order\'\">{{\"SETTINGS_ONLINE_ITEM_ORDER_DURATION_TOOLTIP\" | translate}}</i><div class=\"mt-24\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.interval\" options=\"ctrl.intervalOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_INTERVAL\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_INTERVAL\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.phone\" type=\"text\" name=\"phone\" label=\"{{\'SETTINGS_PHONE_CALL\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><app-input model=\"ctrl.form.alias\" type=\"text\" name=\"alias\" label=\"{{\'SETTINGS_ONLINE_ALIAS\' | translate}}\" on-change=\"ctrl.onAliasChange()\" loading=\"ctrl.aliasStatus == \'loading\'\" error=\"{{ctrl.getAliasError()}}\"></app-input></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><a href=\"javascript:;\" ng-click=\"ctrl.copyLink()\" class=\"copy-icon\"><i class=\"las la-copy\"></i></a><app-input type=\"text\" label=\"{{\'SETTINGS_ONLINE_BOOKING_LINK\' | translate}}\" value=\"{{ctrl.uniqueBusinessBookingURL()}}\"></app-input></div><i class=\"input-hint success\" ng-class=\"{\'visible\': ctrl.copied}\">{{\"SETTINGS_ONLINE_URL_COPIED\" | translate}}</i></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_POPUP_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.popup_text\" name=\"popup_text\" class=\"form-control\" style=\"min-height: 110px;\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.facebook\" type=\"text\" name=\"facebook\" label=\"{{\'SETTINGS_ONLINE_FACEBOOK\' | translate}}\"></app-input><div class=\"form-group\"><app-input model=\"ctrl.form.instagram\" type=\"text\" name=\"instagram\" label=\"{{\'SETTINGS_ONLINE_INSTAGRAM\' | translate}}\"></app-input></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ONLINE_ABOUT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.about\" name=\"about\" class=\"form-control\" style=\"min-height: 110px;\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.linkedin\" type=\"text\" name=\"linkedin\" label=\"{{\'SETTINGS_ONLINE_LINKEDIN\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.twitter\" type=\"text\" name=\"twitter\" label=\"{{\'SETTINGS_ONLINE_TWITTER\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.background_picture\" options=\"ctrl.backgroundPictureOptions\" value-prop=\"id\" on-change=\"ctrl.checkDefaultBack()\" label=\"{{\'SETTINGS_BACKGROUND_PICTURE\' | translate}}\" placeholder=\"{{\'SETTINGS_BACKGROUND_PICTURE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-color\"><app-input model=\"ctrl.form.online_color\" type=\"color\" name=\"online_color\" label=\"{{\'SETTINGS_ONLINE_COLOR\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group form-color\"><app-input model=\"ctrl.form.online_text_color\" type=\"color\" name=\"online_text_color\" label=\"{{\'SETTINGS_ONLINE_TEXT_COLOR\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_update\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_ALLOW_UPDATE\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_ALLOW_UPDATE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.update_hours\" options=\"ctrl.hoursOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_UPDATE_HOURS\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_UPDATE_HOURS\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_cancel\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_ALLOW_CANCEL\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_ALLOW_CANCEL\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.cancel_hours\" options=\"ctrl.hoursOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_CANCEL_HOURS\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_CANCEL_HOURS\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.closest_time\" options=\"ctrl.closestTimeOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_CLOSEST_TIME\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_CLOSEST_TIME\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.latest_time\" type=\"number\" name=\"latest_time\" label=\"{{\'SETTINGS_ONLINE_LATEST_TIME\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.facebook_pixel\" type=\"text\" name=\"facebook_pixel\" label=\"{{\'SETTINGS_ONLINE_FACEBOOK_PIXEL\' | translate}}\"></app-input></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.allow_number_of_payment\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_ALLOW_NUMBER_OF_PAYMENT\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_ALLOW_NUMBER_OF_PAYMENT\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.send_code_by\" options=\"ctrl.sendCodeByOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_SEND_CODE_BY\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_SEND_CODE_BY\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.ai_agent_popup\" options=\"ctrl.yesNoOptions\" value-prop=\"id\" label=\"{{\'SETTINGS_ONLINE_AI_AGENT_POPUP\' | translate}}\" placeholder=\"{{\'SETTINGS_ONLINE_AI_AGENT_POPUP\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><app-input model=\"ctrl.form.ai_button_text\" type=\"text\" name=\"ai_button_text\" label=\"{{\'SETTINGS_ONLINE_AI_BUTTON_TEXT\' | translate}}\"></app-input></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div></div>");
$templateCache.put("app/modules/settings/photos_stock/photos_stock.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_PHOTOS_STOCK\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><label class=\"btn text primary\"><i class=\"las la-upload\"></i> {{\"SETTINGS_PHOTOS_STOCK_ADD_FILE\" | translate}} <input style=\"display: none\" type=\"file\" accept=\"image/*\" multiple=\"\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"photosstock_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_PHOTOS_STOCK_IMG\" | translate}}</th><th>{{\"SETTINGS_PHOTOS_STOCK_NAME\" | translate}}</th><th>{{\"SETTINGS_PHOTOS_STOCK_CREATED_AT\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><div class=\"stock-pic-wrapper no-margin\"><img ng-src=\"{{row.url}}\" alt=\"{{row.name}}\"></div></td><td><span>{{row.name}}</span></td><td><span>{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td><span class=\"btn icon small bordered red\" ng-click=\"ctrl.deletePhoto(row.id)\"><i class=\"las la-trash\"></i></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/telephony_settings/telephony_settings.view.html","<div ng-include=\"\'app/components/header/header.html\'\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"TELEPHONY_SETTINGS\" | translate }}</h3></div><form class=\"\" name=\"telephonyForm\" ng-submit=\"ctrl.save()\" novalidate=\"\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"TELEPHONY_CALLS_API_LINK\" | translate}}</label> <input type=\"text\" value=\"{{ctrl.callsApiLink}}\" class=\"form-control\" readonly=\"\"> <a href=\"javascript:;\" ng-click=\"ctrl.copyApiLink()\" class=\"copy-icon\"><i class=\"las la-copy\"></i></a></div><i class=\"input-hint visible\">{{\"TELEPHONY_CALLS_API_LINK_HINT\" | translate}}</i></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div class=\"relative\"><label>{{\"TELEPHONY_CALLS_API_TOKEN\" | translate}}</label> <input type=\"text\" value=\"{{ctrl.callsApiToken}}\" class=\"form-control\" readonly=\"\"> <a href=\"javascript:;\" ng-click=\"ctrl.copyApiToken()\" class=\"copy-icon\"><i class=\"las la-copy\"></i></a></div><i class=\"input-hint visible\">{{\"TELEPHONY_CALLS_API_TOKEN_HINT\" | translate}}</i></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><div ng-if=\"ctrl.resources.length === 0\" class=\"no-resources mt-16\"><p>{{\"TELEPHONY_NO_RESOURCES\" | translate}}</p></div><div ng-if=\"ctrl.resources.length > 0\"><app-dropdown model=\"ctrl.selectedUsers\" options=\"ctrl.resources\" multiple=\"true\" searchable=\"true\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'TELEPHONY_CALLER_POPUP_USERS\' | translate}}\" placeholder=\"{{\'TELEPHONY_CALLER_POPUP_USERS\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.updateSelectedUsers(model)\"></app-dropdown></div><i class=\"input-hint visible\">{{\"TELEPHONY_CALLER_POPUP_USERS_DESCRIPTION\" | translate}}</i></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.create_lead_on_call\"> {{\"TELEPHONY_CREATE_LEAD_ON_CALL\" | translate}}</label></div><i class=\"input-hint visible\">{{\"TELEPHONY_CREATE_LEAD_ON_CALL_DESCRIPTION\" | translate}}</i></div></div></div><div ng-if=\"ctrl.form.create_lead_on_call\" class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.lead_status\" options=\"ctrl.statuses\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'SETTINGS_LEADS_STATUSES\' | translate}}\" placeholder=\"{{\'SETTINGS_LEADS_STATUSES\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.lead_arrival_source\" name=\"lead_arrival_source\" class=\"form-control\" placeholder=\"{{\'TELEPHONY_ARRIVAL_SOURCE_PLACEHOLDER\' | translate}}\"></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\" ng-init=\"telephonyUsersSectionExpanded = false\"><div class=\"form-group\"><label class=\"expand-toggle\" ng-click=\"telephonyUsersSectionExpanded = !telephonyUsersSectionExpanded\" style=\"cursor: pointer;\">{{ \"TELEPHONY_USERS_AGENT_TOKEN\" | translate }} <span class=\"availability-toggle__arrow\" ng-if=\"!telephonyUsersSectionExpanded\"><i class=\"las la-angle-down\"></i></span> <span class=\"availability-toggle__arrow\" ng-if=\"telephonyUsersSectionExpanded\"><i class=\"las la-angle-up\"></i></span></label> <i class=\"input-hint visible\">{{ \"TELEPHONY_USERS_AGENT_TOKEN_DESCRIPTION\" | translate }}</i><div ng-show=\"telephonyUsersSectionExpanded\"><div ng-if=\"ctrl.telephonyUsers.length === 0\" class=\"no-resources mt-16\"><p>{{ \"TELEPHONY_NO_USERS\" | translate }}</p></div><div ng-if=\"ctrl.telephonyUsers.length > 0\" class=\"telephony-users-list mt-16\"><div class=\"telephony-user-row flex align-center gap-16 mb-12\" ng-repeat=\"user in ctrl.telephonyUsers track by user.id\"><span class=\"telephony-user-name col-md-3 col-xs-12\">{{ user.name || (\'TELEPHONY_USER\' | translate) }}</span><div class=\"col-md-4 col-xs-12\"><input type=\"text\" ng-model=\"user.telephony_agent_id\" class=\"form-control\" placeholder=\"{{ \'TELEPHONY_AGENT_ID_PLACEHOLDER\' | translate }}\"></div><div class=\"col-md-4 col-xs-12\"><input type=\"text\" ng-model=\"user.telephony_token\" class=\"form-control\" placeholder=\"{{ \'TELEPHONY_TOKEN_PLACEHOLDER\' | translate }}\"></div></div></div></div></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" ui-sref=\"app.settings\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\" ng-disabled=\"ctrl.saveLoading\"><span ng-if=\"ctrl.saveLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"SAVING\" | translate}}</span> <span ng-if=\"!ctrl.saveLoading\">{{\"SETTINGS_INFO_SEND\" | translate}}</span></button></div></form></div></div>");
$templateCache.put("app/modules/settings/whatsapp_templates/marketing_template.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"WA_TEMPLATE_CREATE_MARKETING\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"marketingTemplateForm\" ng-submit=\"ctrl.saveMarketingTemplate()\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"form-group\"><label>{{\"WA_TEMPLATE_MARKETING_MESSAGE\" | translate}}</label><app-textarea-mask model=\"ctrl.marketingForm.message\" masks=\"ctrl.marketingMasks\" rows=\"6\"></app-textarea-mask></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"ctrl.actionLoading || !ctrl.marketingForm.message\" class=\"btn text primary large\">{{ctrl.actionLoading ? (\"WA_TEMPLATE_SYNCING\" | translate) : (\"SAVE\" | translate)}}</button></div></form></div>");
$templateCache.put("app/modules/settings/whatsapp_templates/settings.whatsapp_templates.html","<div ng-include=\"\'app/components/header/header.html\'\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{\"SETTINGS_WHATSAPP_TEMPLATES\" | translate}}</h3></div><div class=\"wa-settings-card\"><div class=\"flex gap-8 mb-24\"><app-button type=\"button\" color=\"primary\" ng-if=\"ctrl.hasNotCreated()\" ng-click=\"ctrl.syncAll()\" ng-disabled=\"ctrl.loading || ctrl.actionLoading\">{{ctrl.actionLoading ? (\"WA_TEMPLATE_SYNCING\" | translate) : (\"WA_TEMPLATE_SYNC_ALL\" | translate)}}</app-button><app-button type=\"button\" color=\"border-primary\" ng-if=\"!ctrl.syncAllRunning\" ng-click=\"ctrl.refreshStatuses()\" ng-disabled=\"ctrl.loading || ctrl.actionLoading\">{{\"WA_TEMPLATE_REFRESH_STATUSES\" | translate}}</app-button><app-button type=\"button\" color=\"primary\" ng-if=\"!ctrl.syncAllRunning\" ng-click=\"ctrl.openMarketingModal()\" ng-disabled=\"ctrl.loading || ctrl.actionLoading\">{{\"WA_TEMPLATE_CREATE_MARKETING\" | translate}}</app-button></div><div class=\"circle-loader\" ng-if=\"ctrl.loading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"table-holder\" ng-if=\"!ctrl.loading\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>{{\"WA_TEMPLATE_COL_NAME\" | translate}}</th><th>{{\"WA_TEMPLATE_COL_STATUS\" | translate}}</th><th>{{\"WA_TEMPLATE_COL_ACTIONS\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in ctrl.templates\"><td><strong>{{item.label_key ? (item.label_key | translate) : item.title}}</strong> <span class=\"wa-template-outdated\" ng-if=\"item.message_outdated\">— {{\"WA_TEMPLATE_MESSAGE_OUTDATED\" | translate}}</span></td><td><span class=\"wa-status-badge\" ng-class=\"{ \'wa-status--active\': item.status == \'approved\', \'wa-status--pending\': item.status == \'pending_approval\' || item.status == \'localization_ready\', \'wa-status--error\': item.status == \'error\' || item.status == \'rejected\', \'wa-status--none\': item.status == \'not_created\' || item.status == \'draft\' }\">{{ctrl.getStatusLabel(item)}}</span><div ng-if=\"item.last_error\" class=\"wa-error-alert mt-8\">{{item.last_error}}</div></td><td><div class=\"flex gap-8\" style=\"flex-wrap: wrap;\" ng-if=\"!ctrl.syncAllRunning\"><app-button type=\"button\" color=\"border-primary\" size=\"small\" ng-if=\"ctrl.canSync(item)\" ng-click=\"ctrl.syncOne(item)\" ng-disabled=\"ctrl.actionLoading\">{{\"WA_TEMPLATE_SYNC_ONE\" | translate}}</app-button><app-button type=\"button\" color=\"border-primary\" size=\"small\" ng-if=\"ctrl.canUpdateLocalization(item)\" ng-click=\"ctrl.updateLocalization(item)\" ng-disabled=\"ctrl.actionLoading\">{{\"WA_TEMPLATE_UPDATE_LOCALIZATION\" | translate}}</app-button><app-button type=\"button\" color=\"primary\" size=\"small\" ng-if=\"ctrl.canSubmit(item)\" ng-click=\"ctrl.submitOne(item)\" ng-disabled=\"ctrl.actionLoading\">{{\"WA_TEMPLATE_SUBMIT_ONE\" | translate}}</app-button><app-button type=\"button\" color=\"error\" size=\"small\" ng-if=\"ctrl.canResubmit(item)\" ng-click=\"ctrl.resubmitOne(item)\" ng-disabled=\"ctrl.actionLoading\">{{\"WA_TEMPLATE_RESUBMIT_ONE\" | translate}}</app-button><app-button type=\"button\" color=\"error\" size=\"small\" ng-if=\"item.is_marketing\" ng-click=\"ctrl.deleteMarketing(item)\" ng-disabled=\"ctrl.actionLoading\">{{\"WA_TEMPLATE_DELETE_ONE\" | translate}}</app-button></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/workers/popup/workers.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\" ng-if=\"isUserAllowedAccess(\'workers\')\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_CASH_SELECT_W\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><table ng-if=\"ctrl.workers && ctrl.workers.length>0\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example workers-table\"><thead><tr><th class=\"customer-name\">{{\"CUSTOMERS_NAME\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectCustomer($index)\" ng-repeat=\"row in ctrl.workers\"><td class=\"customer-name with-pic\">{{row.emp_firstname}} {{row.emp_lastname}}</td><td></td></tr></tbody></table></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/admin/modules/business-copy/business.copy.html","<div class=\"modal-form-inner\" id=\"settings-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADMIN_ADD_BUSINESS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"businessForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.variant\" options=\"ctrl.variantOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'ADMIN_BUSINESS_TYPE\' | translate}}\" placeholder=\"{{\'ADMIN_BUSINESS_TYPE\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_BUSINESS_NAME\" | translate}}</label> <input type=\"text\" name=\"name\" required=\"\" ng-minlength=\"5\" ng-model=\"ctrl.form.name\" placeholder=\"Business Name\" class=\"form-control\"><div ng-messages=\"businessForm.name.$error\" class=\"ng-messages\" ng-show=\"businessForm.name.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_EMAIL\" | translate}}</label> <input type=\"email\" name=\"email\" required=\"\" ng-model=\"ctrl.form.email\" placeholder=\"email@example.com\" class=\"form-control\"><div ng-messages=\"businessForm.email.$error\" class=\"ng-messages\" ng-show=\"businessForm.email.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div><div ng-message=\"email\">{{\"SETTINGS_USER_VALID_MAIL\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_USER_PERSON_NAME\" | translate}}</label> <input type=\"text\" ng-minlength=\"3\" required=\"\" name=\"personname\" ng-model=\"ctrl.form.user_name\" placeholder=\"User Name\" class=\"form-control\"><div ng-messages=\"businessForm.personname.$error\" class=\"ng-messages\" ng-show=\"businessForm.personname.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_3_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PASSWORD\" | translate}}</label> <input type=\"text\" ng-minlength=\"5\" required=\"\" name=\"password\" ng-model=\"ctrl.form.password\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.password.$error\" class=\"ng-messages\" ng-show=\"businessForm.password.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/business-form/business.form.html","<div class=\"modal-form-inner tabs-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!ctrl.hideUser\">{{\"ADMIN_ADD_BUSINESS\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"ctrl.hideUser\">{{\"ADMIN_EDIT_BUSINESS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"businessForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex top fill gap-16\"><div><div class=\"flex fill gap-16\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.variant\" options=\"ctrl.variantOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'ADMIN_BUSINESS_TYPE\' | translate}}\" placeholder=\"{{\'ADMIN_BUSINESS_TYPE\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_BUSINESS_NAME\" | translate}}</label> <input type=\"text\" name=\"name\" required=\"\" ng-minlength=\"5\" ng-model=\"ctrl.form.name\" class=\"form-control\"><div ng-messages=\"businessForm.name.$error\" class=\"ng-messages\" ng-show=\"businessForm.name.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_CONTACT_PERSON\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.agent\" ng-minlength=\"5\" required=\"\" name=\"agent\" placeholder=\"John Smith\" class=\"form-control\"><div ng-messages=\"businessForm.agent.$error\" class=\"ng-messages\" ng-show=\"businessForm.agent.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PHONE\" | translate}}</label> <input type=\"tel\" name=\"phone\" required=\"\" ng-model=\"ctrl.form.phone\" placeholder=\"0534231367\" class=\"form-control\"><div ng-messages=\"businessForm.phone.$error\" class=\"ng-messages\" ng-show=\"businessForm.phone.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_ADDRESS\" | translate}}</label> <input type=\"text\" name=\"address\" required=\"\" ng-model=\"ctrl.form.address\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.address.$error\" class=\"ng-messages\" ng-show=\"businessForm.address.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_CITY\" | translate}}</label> <input type=\"text\" name=\"city\" required=\"\" ng-model=\"ctrl.form.city\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.city.$error\" class=\"ng-messages\" ng-show=\"businessForm.city.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_HOME_NUMBER\" | translate}}</label> <input type=\"text\" name=\"home_number\" required=\"\" ng-model=\"ctrl.form.home_number\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.home_number.$error\" class=\"ng-messages\" ng-show=\"businessForm.home_number.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_POST_CODE\" | translate}}</label> <input type=\"text\" name=\"zip\" required=\"\" ng-model=\"ctrl.form.zip\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.zip.$error\" class=\"ng-messages\" ng-show=\"businessForm.zip.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_COMPANY_ID\" | translate}}</label> <input type=\"text\" name=\"company_id\" required=\"\" ng-minlength=\"3\" ng-model=\"ctrl.form.company_id\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.company_id.$error\" class=\"ng-messages\" ng-show=\"businessForm.company_id.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div><div ng-message=\"minlength\">{{\"ADMIN_3_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label>{{\"ADMIN_COURSES\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.courses\" type=\"radio\" name=\"courses\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.courses\" type=\"radio\" name=\"courses\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.dealer_type\" options=\"ctrl.dealerTypeOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'DEALER_TYPE\' | translate}}\" placeholder=\"{{\'DEALER_TYPE\' | translate}}\"></app-dropdown><div ng-messages=\"businessForm.dealer_type.$error\" class=\"ng-messages\" ng-show=\"businessForm.dealer_type.$dirty\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_ZERO_VAT\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.zero_vat\" type=\"radio\" name=\"zero_vat\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.zero_vat\" type=\"radio\" name=\"zero_vat\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.wa_api\" options=\"ctrl.waApiOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'ADMIN_WA_API\' | translate}}\" placeholder=\"{{\'ADMIN_WA_API\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><label>{{\"ADMIN_WA_ACCOUNT_ID\" | translate}}</label> <input type=\"text\" name=\"wa_account_id\" ng-model=\"ctrl.form.wa_account_id\" class=\"form-control\"></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_WA_INSTANCE\" | translate}}</label> <input type=\"text\" name=\"wa_instance\" ng-model=\"ctrl.form.wa_instance\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"ADMIN_WA_TOKEN\" | translate}}</label> <input type=\"text\" name=\"wa_token\" ng-model=\"ctrl.form.wa_token\" class=\"form-control\"></div></div><div ng-if=\"ctrl.form.wa_api == \'texter\' && ctrl.form.wa_instance && ctrl.form.wa_token\" class=\"flex fill gap-16\"><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.createTexterWebhook()\">{{\"ADMIN_CREATE_TEXTER_WEBHOOK\" | translate}}</button></div><div ng-if=\"ctrl.form.wa_api == \'whapi\' && !ctrl.form.wa_instance && !ctrl.form.wa_token && ctrl.hideUser\" class=\"flex fill gap-16\"><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.createWhapiInstance()\">{{\"ADMIN_CREATE_WHAPI_INSTANCE\" | translate}}</button></div><div ng-if=\"ctrl.form.wa_api == \'whapi\'\" class=\"form-group last\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.offline_presence\">{{\"ADMIN_OFFLINE_PRESENCE\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_DEDUCTIONS_FILE\" | translate}}</label> <input type=\"text\" name=\"deductions_file\" ng-minlength=\"3\" ng-model=\"ctrl.form.deductions_file\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.deductions_file.$error\" class=\"ng-messages\" ng-show=\"businessForm.deductions_file.$dirty\"><div ng-message=\"required\">{{\"LOGIN_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.cerdit_company\" options=\"ctrl.creditCompanyOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'ADMIN_CREDIT_COMPANY\' | translate}}\" placeholder=\"{{\'ADMIN_CREDIT_COMPANY\' | translate}}\"></app-dropdown></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_TRANZILA\" | translate}}</label> <input type=\"text\" name=\"credit_suplier\" ng-minlength=\"3\" ng-model=\"ctrl.form.credit_suplier\" placeholder=\"...\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"ADMIN_KEY\" | translate}}</label> <input type=\"text\" name=\"credit_yaad_key\" ng-minlength=\"3\" ng-model=\"ctrl.form.credit_yaad_key\" placeholder=\"...\" class=\"form-control\"></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_CASHBOX\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.cashbox\" type=\"radio\" name=\"cashbox\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.cashbox\" type=\"radio\" name=\"cashbox\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.status\" options=\"ctrl.statusOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'ADMIN_BUSINESS_STATUS\' | translate}}\" placeholder=\"{{\'ADMIN_BUSINESS_STATUS\' | translate}}\"></app-dropdown></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_CREDIT_CARD\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.credit_card\" type=\"radio\" name=\"credit_card\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.credit_card\" type=\"radio\" name=\"credit_card\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_PAID_LINK\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.paid_link\" type=\"radio\" name=\"paid_link\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.paid_link\" type=\"radio\" name=\"paid_link\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_SECOND_RESOURCE\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.second_resource\" type=\"radio\" name=\"second_resource\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.second_resource\" type=\"radio\" name=\"second_resource\" value=\"0\"> <label>N</label></div></div><div class=\"form-group last\"><label>{{\"ADMIN_SECOND_RESOURCE_NAME\" | translate}}</label> <input type=\"text\" name=\"second_resource_name\" ng-required=\"second_resource*1==1\" ng-model=\"ctrl.form.second_resource_name\" placeholder=\'{{\"ADMIN_SECOND_RESOURCE_NAME\" | translate}}\' class=\"form-control\"></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_ENABLED_RETAINERS\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.enabled_retainers\" type=\"radio\" name=\"enabled_retainers\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.enabled_retainers\" type=\"radio\" name=\"enabled_retainers\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_ENABLED_CONTINUOUS_DEAL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.continuous_deal\" type=\"radio\" name=\"continuous_deal\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.continuous_deal\" type=\"radio\" name=\"continuous_deal\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_ENABLED_BUSINESS_HELPER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.business_helper\" type=\"radio\" name=\"business_helper\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.business_helper\" type=\"radio\" name=\"business_helper\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_AI_AGENTS\" | translate}}</label><br><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.ai_agent_booking\" ng-true-value=\"1\" ng-false-value=\"0\">{{\"ADMIN_AI_AGENT_BOOKING\" | translate}}</label></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.ai_agent_testing\" ng-true-value=\"1\" ng-false-value=\"0\">{{\"ADMIN_AI_AGENT_TESTING\" | translate}}</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"EMV_TERMINAL_ID\" | translate}}</label> <input type=\"text\" name=\"emv_terminal_id\" ng-model=\"ctrl.form.emv_terminal_id\" placeholder=\"emv_terminal_id\" class=\"form-control\"></div><div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ZCREDIT_KEY\" | translate}}</label> <input type=\"text\" name=\"zcredit_key\" ng-model=\"ctrl.form.zcredit_key\" placeholder=\"zcredit_key\" class=\"form-control\"></div><div class=\"form-group\"><label>{{\"ZCREDIT_CREDIT_DEAL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.z_credit_credit_deal\" type=\"radio\" name=\"z_credit_credit_deal\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.z_credit_credit_deal\" type=\"radio\" name=\"z_credit_credit_deal\" value=\"0\"> <label>N</label></div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"CALL_TOKEN\" | translate}}</label> <input type=\"text\" name=\"call_token\" ng-model=\"ctrl.form.call_token\" placeholder=\"call_token\" class=\"form-control\"></div><div></div></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.language_code\" options=\"ctrl.languageOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'ADMIN_LANGUAGE\' | translate}}\" placeholder=\"{{\'ADMIN_LANGUAGE\' | translate}}\"></app-dropdown></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_EMAIL\" | translate}}</label> <input type=\"email\" name=\"email\" required=\"\" ng-model=\"ctrl.form.email\" placeholder=\"email@example.com\" class=\"form-control\"><div ng-messages=\"businessForm.email.$error\" class=\"ng-messages\" ng-show=\"businessForm.email.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div><div ng-message=\"email\">{{\"SETTINGS_USER_VALID_MAIL\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\" ng-if=\"!ctrl.hideUser\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_USER_PERSON_NAME\" | translate}}</label> <input type=\"text\" ng-minlength=\"5\" name=\"personname\" ng-model=\"ctrl.form.user_name\" placeholder=\"NikolaTesla\" class=\"form-control\"><div ng-messages=\"businessForm.personname.$error\" class=\"ng-messages\" ng-show=\"businessForm.personname.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_PASSWORD\" | translate}}</label> <input type=\"text\" ng-minlength=\"5\" name=\"password\" ng-model=\"ctrl.form.password\" placeholder=\"...\" class=\"form-control\"><div ng-messages=\"businessForm.password.$error\" class=\"ng-messages\" ng-show=\"businessForm.password.$dirty\"><div ng-message=\"minlength\">{{\"ADMIN_5_CHARACTERS\" | translate}}</div></div></div></div><div class=\"flex fill gap-16\"><div><div class=\"form-group\"><label>{{\"ADMIN_CUSTOMERS\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event)\" ng-model=\"ctrl.form.customers\" name=\"customer_file\"></div><div class=\"flex fill gap-16\"><div class=\"form-group\"><label>{{\"ADMIN_ORDERS\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event, \'orders\')\" ng-model=\"ctrl.form.orders\" name=\"orders_file\"></div><div class=\"form-group last\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.create_resources_services\">{{\"ADMIN_CREATE_RESOURCES_SERVICES\" | translate}}</label></div></div></div><div class=\"form-group\"><label>{{\"ADMIN_CUSTOMER_NOTES\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event, \'customer_notes\')\" ng-model=\"ctrl.form.customer_notes\" name=\"notes_file\"></div><div class=\"form-group\"><label>{{\"ADMIN_IMPORT_CRM\" | translate}}</label> <input type=\"file\" accept=\".csv, .xls, .xlsx\" onchange=\"angular.element(this).scope().uploadExcel(event, \'crm\')\" ng-model=\"ctrl.form.crm\" name=\"crm\"></div></div></div></div><div><div class=\"form-group\"><label>{{\"ADMIN_ONLINE_PAYMENTS_TTL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.online_payments\" type=\"radio\" name=\"online_payments\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.online_payments\" type=\"radio\" name=\"online_payments\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_CARD_READER_TTL\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.card_reader\" type=\"radio\" name=\"card_reader\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.card_reader\" type=\"radio\" name=\"card_reader\" value=\"0\"> <label>N</label></div></div><div class=\"form-group\"><label>{{\"ADMIN_BUSINESS_SMS_SENDER_TITLE\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.sms_own_sign\" type=\"radio\" name=\"sms_own_sign\" value=\"1\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.sms_own_sign\" type=\"radio\" name=\"sms_own_sign\" value=\"0\"> <label>N</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><app-dropdown model=\"ctrl.form.customers_settings.self_order.value\" options=\"ctrl.selfOrderOptions\" value-prop=\"id\" required=\"ctrl.form.customers_settings.self_order.update_all\" disabled=\"!ctrl.form.customers_settings.self_order.update_all\" fixed-panel=\"true\" label=\"{{\'SETTINGS_USER_SELF_ORDER\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_SELF_ORDER\' | translate}}\"></app-dropdown></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.self_order.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><app-dropdown model=\"ctrl.form.customers_settings.resource.value\" options=\"ctrl.resourceOptions\" value-prop=\"id\" searchable=\"true\" required=\"ctrl.form.customers_settings.resource.update_all\" disabled=\"!ctrl.form.customers_settings.resource.update_all\" fixed-panel=\"true\" label=\"{{\'SETTINGS_USER_RESOURCE\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_RESOURCE\' | translate}}\" search-placeholder=\"{{\'SETTINGS_USER_RESOURCE\' | translate}}\"></app-dropdown></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.resource.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><app-dropdown model=\"ctrl.form.customers_settings.send_notifications.value\" options=\"ctrl.customerNotificationOptions\" value-prop=\"id\" required=\"ctrl.form.customers_settings.send_notifications.update_all\" disabled=\"!ctrl.form.customers_settings.send_notifications.update_all\" fixed-panel=\"true\" label=\"{{\'SETTINGS_USER_SEND_MESSAGES\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_SEND_MESSAGES\' | translate}}\"></app-dropdown></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.send_notifications.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><app-dropdown model=\"ctrl.form.customers_settings.send_reminder.value\" options=\"ctrl.reminderSendOptions\" value-prop=\"id\" required=\"ctrl.form.customers_settings.send_reminder.update_all\" disabled=\"!ctrl.form.customers_settings.send_reminder.update_all\" fixed-panel=\"true\" label=\"{{\'SETTINGS_USER_SEND_REMINDER\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_SEND_REMINDER\' | translate}}\"></app-dropdown></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.send_reminder.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><app-dropdown model=\"ctrl.form.customers_settings.reminder_send_type.value\" options=\"ctrl.customerNotificationOptions\" value-prop=\"id\" required=\"ctrl.form.customers_settings.reminder_send_type.update_all\" disabled=\"!ctrl.form.customers_settings.reminder_send_type.update_all\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_SEND_REMINDER\' | translate}}\" placeholder=\"{{\'CUSTOMERS_SEND_REMINDER\' | translate}}\"></app-dropdown></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.reminder_send_type.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><app-dropdown model=\"ctrl.form.customers_settings.send_documents.value\" options=\"ctrl.documentMessageChannelOptions\" value-prop=\"id\" required=\"ctrl.form.customers_settings.send_documents.update_all\" disabled=\"!ctrl.form.customers_settings.send_documents.update_all\" fixed-panel=\"true\" label=\"{{\'SETTINGS_DEFAULT_INV_LINK_MESSAGE_CHANNEL\' | translate}}\" placeholder=\"{{\'SETTINGS_DEFAULT_INV_LINK_MESSAGE_CHANNEL\' | translate}}\"></app-dropdown></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.send_documents.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div><div class=\"flex fill gap-16\"><div class=\"form-group clearfix\"><label>{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"1\" ng-model=\"ctrl.form.customers_settings.request_order_confirmation.value\" ng-required=\"ctrl.form.customers_settings.request_order_confirmation.update_all\" ng-disabled=\"!ctrl.form.customers_settings.request_order_confirmation.update_all\"> <label>Y</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"0\" ng-model=\"ctrl.form.customers_settings.request_order_confirmation.value\" ng-required=\"ctrl.form.customers_settings.request_order_confirmation.update_all\" ng-disabled=\"!ctrl.form.customers_settings.request_order_confirmation.update_all\"> <label>N</label></div></div><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.customers_settings.request_order_confirmation.update_all\">{{\"SETTINGS_DO_UPDATE_ALL\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button><button type=\"submit\" class=\"btn text primary large\" ng-click=\"businessForm.$valid?$close():\'\'\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/business-message/business.message.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADMIN_ADD_BUSINESS_MESSAGE\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"m-t\" name=\"businessMForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.type\" options=\"ctrl.messageTypeOptions\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'ADMIN_BUSINESS_MESSAGE_TYPE\' | translate}}\" required=\"true\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label><span class=\"required\">*</span>{{\"ADMIN_BUSINESS_MESSAGE_TEXT\" | translate}}</label> <textarea name=\"text\" ng-model=\"ctrl.form.text\" class=\"form-control\"></textarea></div></div></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn btn-w-m btn-white\">{{\"CUSTOMERS_CANCEL\" | translate}}</button><button type=\"submit\" class=\"btn btn-w-m btn-primary\" ng-click=\"ctrl.submit()\">{{\"CUSTOMERS_SEND\" | translate}}</button></div>");
$templateCache.put("app/modules/admin/modules/business-single/business.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div id=\"loading_count\"><div>Imported: <span id=\"l_imported\"></span></div><div>Total: <span id=\"l_total\"></span></div></div><div class=\"{{wrapperClasses}} single-model-page\" id=\"business\" ng-if=\"userRole && ctrl.business != null\"><div class=\"row-fluid clearfix\"><div class=\"cloud col-xs-12 single-model-details border-top border-bottom border-right border-left\"><div class=\"single-model-head\"><div class=\"flex gap-24 gap-24-m-8\"><h3 class=\"main-title single-model-name\">{{ctrl.business.name}}</h3><button class=\"btn text primary large\" ui-sref=\"app.admin.single-business.edit({id: {{ctrl.businessId}}})\"><i class=\"fa fa-pencil\"></i> {{\"CUSTOMERS_EDIT\" | translate}}</button> <button class=\"btn text primary large\" ng-click=\"ctrl.createNewUser()\"><i class=\"fa fa-plus\"></i> {{\"SETTINGS_USER_NEW\" | translate}}</button></div></div><div class=\"single-model-info\"><div class=\"col-md-6 collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_GENERAL\" | translate}}</h4><dl><dt>{{\"ADMIN_BUSINESS_TYPE\" | translate}}</dt><dd>{{ctrl.variants[ctrl.business.variant] | translate | emptyValue}}</dd><dt>{{\"ADMIN_COMPANY_ID\" | translate}}</dt><dd>{{ctrl.business.company_id | emptyValue}}</dd><dt>{{\"ADMIN_DEDUCTIONS_FILE\" | translate}}</dt><dd>{{ctrl.business.deductions_file | emptyValue}}</dd><dt>{{\"DEALER_TYPE\" | translate}}</dt><dd>{{ctrl.business.dealer_type | emptyValue}}</dd><dt>{{\"ADMIN_ADDRESS\" | translate}}</dt><dd>{{ctrl.business.address | emptyValue}}</dd><dt>{{\"ADMIN_HOME_NUMBER\" | translate}}</dt><dd>{{ctrl.business.home_number | emptyValue}}</dd><dt>{{\"ADMIN_CITY\" | translate}}</dt><dd>{{ctrl.business.city | emptyValue}}</dd><dt>{{\"ADMIN_POST_CODE\" | translate}}</dt><dd>{{ctrl.business.zip | emptyValue}}</dd><dt>{{\"EMV_TERMINAL_ID\" | translate}}</dt><dd>{{ctrl.business.emv_terminal_id | translate}}</dd><dt>{{\"ZCREDIT_KEY\" | translate}}</dt><dd>{{ctrl.business.zcredit_key | translate}}</dd><dt>{{\"CALL_TOKEN\" | translate}}</dt><dd>{{ctrl.business.call_token | translate}}</dd><dt>{{\"ADMIN_LANGUAGE\" | translate}}</dt><dd>{{ctrl.business.language | translate}}</dd><dt>{{\"ADMIN_CASHBOX\" | translate}}</dt><dd>{{ctrl.business.cashbox ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_PAID_LINK\" | translate}}</dt><dd>{{ctrl.business.paid_link ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_CREDIT_CARD\" | translate}}</dt><dd>{{ctrl.business.credit_card ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_AI_AGENT_BOOKING\" | translate}}</dt><dd>{{ctrl.business.ai_agent_booking ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_ONLINE_PAYMENTS_TTL\" | translate}}</dt><dd>{{ctrl.business.online_payments ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_CARD_READER_TTL\" | translate}}</dt><dd>{{ctrl.business.card_reader ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_ENABLED_RETAINERS\" | translate}}</dt><dd>{{ctrl.business.enabled_retainers ? \'Yes\': \'No\'}}</dd><dt>{{\"ADMIN_OFFLINE_PRESENCE\" | translate}}</dt><dd>{{ctrl.business.offline_presence ? \'Yes\': \'No\'}}</dd></dl></div><div class=\"col-md-6 collapsed-mobile\"><h4 class=\"info-title\">{{\"ADMIN_CONTACTS\" | translate}}</h4><dl><dt>{{\"ADMIN_CONTACT_PERSON\" | translate}}</dt><dd>{{ctrl.business.agent | emptyValue}}</dd><dt>{{\"ADMIN_PHONE\" | translate}}</dt><dd>{{ctrl.business.phone | emptyValue}}</dd><dt>{{\"ADMIN_EMAIL\" | translate}}</dt><dd>{{ctrl.business.email | emptyValue}}</dd></dl></div></div></div></div></div>");
$templateCache.put("app/modules/businesses/modules/businesses-form/businesses.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">הוספת קטגוריה</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"categoriesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> שם הקטגוריה</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"categoriesForm.name.$error\" class=\"ng-messages\" ng-show=\"categoriesForm.name.$dirty\"><div ng-message=\"required\">2שדה זה הוא שדה חובה</div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">הסר קטגוריה</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">ביטול</button> <button type=\"submit\" ng-disabled=\"categoriesForm.$invalid || categoriesForm.$pristine\" class=\"btn text primary large\">שליחה</button></div></form></div>");
$templateCache.put("app/modules/businesses/modules/businesses-list/businesses.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn btn-primary\" ui-sref=\"app.settings.categories.new\">קטגוריה חדשה</button></div><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>שם הקטגוריה</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.categories.edit({id: {{row.id}}})\"><td>{{row.name}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/cashbox/modules/digital_forms/digital_forms.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CASHBOX_ATTACH_DIGITAL_FORM\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.cancel()\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"form-group\" ng-if=\"DigitalFormList.length\"><app-dropdown model=\"ctrl.selectedForm\" options=\"DigitalFormList\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CASHBOX_DIGITAL_FORM\' | translate}}\" placeholder=\"{{\'CASHBOX_DIGITAL_FORM\' | translate}}\"></app-dropdown></div><div class=\"text-center\" ng-if=\"!DigitalFormList.length\">{{\"CASHBOX_DIGITAL_FORM_EMPTY\" | translate}}</div></div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.cancel()\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.attach()\" ng-disabled=\"!DigitalFormList.length || !ctrl.selectedForm\">{{\"CASHBOX_ATTACH_DIGITAL_FORM_BUTTON\" | translate}}</button></div></div>");
$templateCache.put("app/modules/customers/modules/customers-card-request/customers.card_request.html","<div class=\"modal-form-inner modal-approval\"><div class=\"modal-head modal-head-online\"><div class=\"background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: contain;\"><div class=\"logo-container\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><h1 class=\"business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"business-address\">{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}</h2></div></div><div class=\"modal-head\"><h3 class=\"form-title no-padding-x\">{{\"CUSTOMERS_CARD_REQUEST_TITLE\" | translate}}</h3></div><div class=\"modal-body\"><div class=\"panel-body\"><iframe ng-src=\"{{ctrl.iframe}}\" style=\"width:100%; height:100%; min-height: 700px;\" frameborder=\"0\" allow=\"payment; clipboard-write\"></iframe></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers-dd/customers.dd.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">\"{{Customer.firstname}} {{Customer.lastname}}\" {{\"CUSTOMERS_DD_TO\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"documentForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.document\" options=\"documents\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_DOCUMENT\' | translate}}\" placeholder=\"{{\'CUSTOMERS_DOCUMENT\' | translate}}\"></app-dropdown><div ng-messages=\"documentForm.message.$error\" class=\"ng-messages\" ng-show=\"documentForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"documentForm.$invalid\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-df/customers.df.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_DF_TO\" | translate}} \"{{Customer.firstname}} {{Customer.lastname}}\"</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"formForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.form\" options=\"forms\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_DIGITAL_FORM\' | translate}}\" placeholder=\"{{\'CUSTOMERS_FORM\' | translate}}\"></app-dropdown><div ng-messages=\"formForm.message.$error\" class=\"ng-messages\" ng-show=\"formForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"formForm.$invalid\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-form/customers.form.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ng-click=\"$close();\" ng-if=\"isModal\"><i class=\"las la-angle-right rotatable\"></i></a> <a class=\"btn icon default\" ui-sref=\"^.\" ng-if=\"!isModal\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"CUSTOMERS_ADD_NEW\" | translate}}</h3></div></div><form class=\"modal-form\" name=\"customersForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body-m\"><uib-tabset><uib-tab heading=\'{{\"CUSTOMERS_GEN_INFO\" | translate}}\'><div class=\"modal-body\"><div class=\"mb-24\"><div class=\"flex form\"><div class=\"col-md-3 col-xs-12\"><label class=\"import-file\"><input style=\"visibility: hidden; height:0\" type=\"file\" name=\"customer_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\" accept=\"image/*\"><div class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.avatar + \')\'}\"></div></label></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_ADD_CLIENT\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.firstname\" name=\"firstname\" class=\"form-control\" required=\"\"><div ng-messages=\"customersForm.firstname.$error\" class=\"ng-messages\" ng-show=\"customersForm.firstname.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LAST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.lastname\" class=\"form-control\"></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_PHONE\" | translate}}</label><span ng-if=\"ctrl.phone_exists\" class=\"field-warning\">{{\"CUSTOMERS_PHONE_EXISTS\" | translate}}</span> <input type=\"tel\" ng-model=\"ctrl.form.phone\" placeholder=\"053-423-1367\" class=\"form-control\" ng-change=\"ctrl.checkPhoneExists()\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LANDLINE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.telephone\" placeholder=\"08-689-0823\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"DEALER_ID\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.dealer_id\" name=\"dealer_id\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-5 col-xs-12\"><div class=\"form-group last\"><label>{{\"CUSTOMERS_BIRTHDAY\" | translate}}</label><div class=\"form flex min-gap\"><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_year\" options=\"ctrl.yearOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_YEAR\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_month\" options=\"ctrl.monthOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_MONTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_day\" options=\"ctrl.dayOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_DAY\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"customersForm.email.$error\" class=\"ng-messages\" ng-show=\"customersForm.email.$dirty\"><div ng-message=\"email\">עליך להכניס כתובת דוא\"ל תקינה</div></div></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><div><label>{{\"CUSTOMER_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"></div></div></div></div><div class=\"flex form\"><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.status_id\" options=\"ctrl.statusOptions\" value-prop=\"id\" fixed-panel=\"true\" color-prop=\"color\" label=\"{{\'CUSTOMERS_STATUS\' | translate}}\" placeholder=\"{{\'CUSTOMERS_STATUS\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.interested_id\" options=\"ctrl.interestedOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_INTERESTED\' | translate}}\" placeholder=\"{{\'CUSTOMERS_INTERESTED\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.resource_lead\" options=\"ctrl.resourceLeadOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_RESOURSE\' | translate}}\" placeholder=\"{{\'CUSTOMERS_RESOURSE\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><label>{{\"CUSTOMERS_GENDER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"0\"> <label>{{\"CUSTOMERS_GENDER_MALE\" | translate}}</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"1\"> <label>{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</label></div></div></div><div class=\"col-md-4 col-xs-6\" ng-if=\"ctrl.form.lead == false && ctrl.form.lead_platform\"><button class=\"btn text primary\" ng-click=\"d(); $event.stopPropagation(); ctrl.moveToLeads()\">{{\"CUSTOMERS_MAKE_LEAD\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group last\"><div><label>{{\"CUSTOMERS_NOTES\" | translate}}</label> <textarea ng-model=\"ctrl.form.notes\" placeholder=\'{{\"CUSTOMERS_INFO_ABOUT\" | translate}}\' class=\"customer-notes form-control\"></textarea></div></div></div></div></div></uib-tab><uib-tab heading=\'{{\"CUSTOMERS_ADDR\" | translate}}\'><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_ADDR\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_HOME_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.home_number\" name=\"address\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_MAILBOX\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.mailbox\" name=\"mailbox\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_POST_CODE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.zipcode\" name=\"zipcode\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.city\" name=\"city\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.country\" options=\"ctrl.countryOptions\" label-prop=\"name\" value-prop=\"code\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_COUNTRY\' | translate}}\" placeholder=\"{{\'CUSTOMERS_COUNTRY\' | translate}}\" search-placeholder=\"{{\'CUSTOMERS_COUNTRY\' | translate}}\"></app-dropdown></div></div></div></div></uib-tab><uib-tab ng-if=\"ctrl.customFields.length > 0\" heading=\'{{\"CUSTOMERS_CUSTOM_FIELDS\" | translate}}\'><div class=\"modal-body\"><div class=\"flex form\"><div ng-repeat=\"field in ctrl.customFields\" class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{field.name}}</label> <input ng-if=\"field.type === \'text\'\" type=\"text\" ng-model=\"ctrl.form.custom_values[field.id]\" class=\"form-control\"><app-dropdown ng-if=\"field.type === \'list\'\" model=\"ctrl.form.custom_values[field.id]\" options=\"field.values\" label-prop=\"value\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_CUSTOM_FIELDS_LIST_PLACEHOLDER\' | translate}}\" search-placeholder=\"{{\'CUSTOMERS_CUSTOM_FIELDS_LIST_PLACEHOLDER\' | translate}}\"></app-dropdown><input ng-if=\"field.type === \'date\'\" type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.custom_values[field.id]\" view=\"date\" min-view=\"date\" position=\"absolute\" format=\"DD/MM/YYYY\" readonly=\"readonly\"> <input ng-if=\"field.type === \'datetime\'\" type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.custom_values[field.id]\" view=\"date\" min-view=\"minutes\" position=\"absolute\" format=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\"></div></div></div></div></uib-tab><uib-tab heading=\'{{\"CUSTOMERS_SETTINGS\" | translate}}\'><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"0\"> <label>{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"1\"> <label>{{\"CUSTOMER_SETTING_EMAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"type\" ng-model=\"ctrl.form.send_notifications\" value=\"3\"> <label><span class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{\"CUSTOMERS_WHATSAPP\" | translate}}</label></div></div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_USER_SEND_REMINDER\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"0\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"2\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_2_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"4\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_4_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"24\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_24_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"48\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_48_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"72\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_72_HOURS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_reminder\" value=\"168\" ng-model=\"ctrl.form.send_reminder\"> <label>{{\"SETTINGS_USER_REMINDER_168_HOURS\" | translate}}</label></div></div><div class=\"form-group animate-show-hide\" ng-show=\"ctrl.form.send_reminder != 0\"><label class=\"settings_label\">{{\"CUSTOMERS_SEND_REMINDER\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"reminder_send_type\" ng-model=\"ctrl.form.reminder_send_type\" value=\"1\"> <label>{{\"SETTINGS_USER_MAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"reminder_send_type\" ng-model=\"ctrl.form.reminder_send_type\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"reminder_send_type\" ng-model=\"ctrl.form.reminder_send_type\" value=\"3\"> <label><span class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{\"CUSTOMERS_WHATSAPP\" | translate}}</label></div></div><div class=\"form-group\" ng-if=\"ctrl.bu_type == 1 && ctrl.form.send_reminder != 0\"><label class=\"settings_label\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"0\" ng-model=\"ctrl.form.request_order_confirmation\"> <label>{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"request_order_confirmation\" value=\"1\" ng-model=\"ctrl.form.request_order_confirmation\"> <label>{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</label></div></div><div class=\"form-group\"><label class=\"settings_label\">{{\"CUSTOMERS_SEND_DOCUMENTS\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" value=\"0\" ng-model=\"ctrl.form.send_documents\"> <label>{{\"SETTINGS_USER_REMINDER_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"1\"> <label>{{\"CUSTOMER_SETTING_EMAIL\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"2\"> <label>{{\"CUSTOMERS_SMS\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"3\"> <label><span class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{\"CUSTOMERS_WHATSAPP\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"send_documents\" ng-model=\"ctrl.form.send_documents\" value=\"4\"> <label>{{\"CUSTOMERS_PRINT\" | translate}}</label></div></div></div><div><div class=\"form-group\"><label class=\"settings_label\">{{\"CUSTOMERS_IND_ORD\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"orders\" ng-model=\"ctrl.form.self_order\" value=\"0\"> <label>{{\"CUSTOMERS_UNAUTHORIZED\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"orders\" ng-model=\"ctrl.form.self_order\" value=\"1\"> <label>{{\"CUSTOMERS_ALLOWED\" | translate}}</label></div></div></div><div><div class=\"form-group\"><label class=\"settings_label\">{{\"CUSTOMERS_GROUP_MESS\" | translate}}</label><div class=\"radio-btn\"><input type=\"radio\" name=\"messages\" ng-model=\"ctrl.form.group_notifications\" value=\"0\"> <label>{{\"CUSTOMERS_OFF\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"messages\" ng-model=\"ctrl.form.group_notifications\" value=\"1\"> <label>{{\"CUSTOMERS_ACTIVE\" | translate}}</label></div></div></div><div class=\"col-md-3 no-padding\"><div class=\"form-group last\"><app-dropdown model=\"ctrl.form.resource\" options=\"ctrl.resourceOptions\" value-prop=\"id\" disabled=\"!ctrl.resources || ctrl.resources.length == 0\" fixed-panel=\"true\" label=\"{{\'CUSTOMERS_PREF_RES\' | translate}}\" placeholder=\"{{\'CUSTOMERS_PREF_RES\' | translate}}\"></app-dropdown></div></div></div></div></div></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\" ng-if=\"!isModal\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\" ng-if=\"isModal\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"customersForm.$invalid || customersForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-list/customers.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'customers\')\"><div class=\"cloud\"><div class=\"flex full mb-24 gap-24 gap-24-m-8 customer-list-header\"><button class=\"btn text large primary\" ui-sref=\"app.customers.new\"><i class=\"las la-plus\"></i> {{\"NEW_CLIENT\" | translate}}</button><div class=\"form-group icon-prepend last search-input\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_customer()\" ng-model=\"ctrl.customer_name\" class=\"form-control\"></div><div ng-include=\"\'app/components/cfilter/button.html\'\"></div><button class=\"btn icon default green\" ng-class=\"{\'loading\': ctrl.download_in_progress}\" ng-click=\"ctrl.downloadCustomerData()\"><i class=\"las la-file-excel\"></i></button><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_deleted()\" ng-model=\"ctrl.show_deleted\">{{\"SHOW_DELETED\" | translate}}</label></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><table-column-settings ng-if=\"ctrl.fieldSettings && ctrl.fieldSettings.length > 0\" fields-list=\"ctrl.fieldSettings\" on-update=\"ctrl.onFieldsUpdate(fieldsList)\"></table-column-settings><div class=\"table-responsive\"><div id=\"module-loading\" class=\"ibox-content sk-loading\" ng-if=\"module_is_loading\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div><table id=\"cust_dt\" ng-table=\"ctrl.tableCustomers\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCustomers\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"></table><div id=\"custom-pagination-container\"><div class=\"dataTables_per-page\"><span>{{\"ENTRIES_PER_PAGE\" | translate}}</span><div class=\"per-page-options\"><label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"20\"><span>20</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"50\"><span>50</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"100\"><span>100</span></label></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers-public-form/customers.public.form.html","<div class=\"modal-form-inner digital_form_modal\" ng-if=\"business\"><div class=\"modal-head modal-head-online\"><div class=\"background-container\" style=\"background: url(\'{{business.online_booking_data.background}}\') center no-repeat; background-size: contain;\"><div class=\"logo-container\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><h1 class=\"business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"business-address\">{{business.online_booking_data.address ? business.online_booking_data.address : business.city + \' \' + business.address + \' \' +business.home_number}}</h2></div></div><h1 class=\"digital_form_title\">{{\"CUSTOMER_FORM_TITLE\" | translate}}</h1><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"mb-24\"><div class=\"flex form\"><div class=\"col-md-3 col-xs-12\"><label class=\"import-file\"><input style=\"visibility: hidden; height:0\" type=\"file\" name=\"customer_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\" accept=\"image/*\"><div ng-if=\"ctrl.form.avatar\" class=\"image\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.avatar + \')\'}\"></div><div ng-if=\"!ctrl.form.avatar\" class=\"image\" ng-style=\"{\'background-image\':\'url(/assets/images/avatar.jpg)\'}\"></div></label></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_ADD_CLIENT\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.firstname\" name=\"firstname\" class=\"form-control\" required=\"\"><div ng-messages=\"customersForm.firstname.$error\" class=\"ng-messages\" ng-show=\"customersForm.firstname.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LAST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.lastname\" class=\"form-control\"></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_PHONE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.phone\" placeholder=\"053-423-1367\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_LANDLINE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.telephone\" placeholder=\"08-689-0823\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"DEALER_ID\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.dealer_id\" name=\"dealer_id\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-5 col-xs-12\"><div class=\"form-group last\"><label>{{\"CUSTOMERS_BIRTHDAY\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_year\" options=\"ctrl.birthdateYearOptions\" value-prop=\"value\" label-prop=\"label\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_YEAR\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_month\" options=\"ctrl.birthdateMonthOptions\" value-prop=\"value\" label-prop=\"label\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_MONTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_day\" options=\"ctrl.birthdateDayOptions\" value-prop=\"value\" label-prop=\"label\" fixed-panel=\"true\" placeholder=\"{{\'CUSTOMERS_DAY\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_EMAIL\" | translate}}</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" placeholder=\"email@example.co.il\" class=\"form-control\"><div ng-messages=\"customersForm.email.$error\" class=\"ng-messages\" ng-show=\"customersForm.email.$dirty\"><div ng-message=\"email\">עליך להכניס כתובת דוא\"ל תקינה</div></div></div></div></div><div class=\"flex form\"><div class=\"col-md-4 col-xs-6\"><div class=\"form-group\"><label>{{\"CUSTOMERS_GENDER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"0\"> <label>{{\"CUSTOMERS_GENDER_MALE\" | translate}}</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.gender\" type=\"radio\" name=\"gender\" value=\"1\"> <label>{{\"CUSTOMERS_GENDER_FEMALE\" | translate}}</label></div></div></div><div class=\"col-md-4 col-xs-6\" ng-if=\"ctrl.form.lead == false && ctrl.form.lead_platform\"><button class=\"btn text primary\" ng-click=\"d(); $event.stopPropagation(); ctrl.moveToLeads()\">{{\"CUSTOMERS_MAKE_LEAD\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_ADDR\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.address\" name=\"address\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_HOME_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.home_number\" name=\"address\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_MAILBOX\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.mailbox\" name=\"mailbox\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_POST_CODE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.zipcode\" name=\"zipcode\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.city\" name=\"city\" class=\"form-control\"></div></div></div></div></div><div class=\"modal-footer modal-footer-align-center\"><button ng-click=\"ctrl.submit()\" type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/customers.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} customer-details-single single-model-page\" id=\"customer\" ng-if=\"isUserAllowedAccess(\'customers\') && customer != null\"><div class=\"row-fluid clearfix\"><div class=\"cloud col-xs-12 col-lg-9 single-model-details border-top border-bottom border-right border-left\"><div class=\"single-model-head\"><div class=\"flex gap-24 gap-24-m-8 nowrap\"><button class=\"btn icon default\" ng-click=\"ctrl.goBackOrNavigate(customer.lead, $event)\"><i class=\"las la-angle-right rotatable\"></i></button><h3 class=\"main-title single-model-name\"><div class=\"customer-pic-wrapper\" ng-if=\"customer.avatar\"><img ng-src=\"{{customer.avatar}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{customer.firstname}} {{customer.lastname}} <span ng-if=\"customer.credit_cards && customer.credit_cards.length > 0\" class=\"btn icon circle green customer-have-credit-card\"><i class=\"las la-credit-card\"></i></span></h3></div><div class=\"btn-socials gap-16\"><a href=\"/cashbox?customer={{customer.id}}\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\" class=\"btn text success large\"><i class=\"las la-hand-holding-usd\"></i> {{\"CUSTOMER_GO_CASHBOX\" | translate}}</a> <a href=\"/calendar/customer/{{customer.id}}\" class=\"btn text purple large\"><i class=\"las la-calendar\"></i> {{\"CUSTOMER_GO_CALENDAR\" | translate}}</a> <button type=\"button\" ng-click=\"ctrl.request_review(customer.id, \'facebook\');\" ng-if=\"ctrl.business.facebook_review && !customer.facebook_review_request\" class=\"btn text transparent large\"><i class=\"lab la-facebook\"></i> {{\"REQUEST_FACEBOOK_REVIEW\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.request_review(customer.id, \'google\');\" ng-if=\"ctrl.business.google_review && !customer.google_review_request\" class=\"btn text transparent large\"><i class=\"lab la-google\"></i> {{\"REQUEST_GOOGLE_REVIEW\" | translate}}</button></div><div class=\"btn-actions wrap\"><button tooltip=\'{{\"CUSTOMER_SEND_ONLINE_BOOKING_LINK\" | translate}}\' ng-click=\"ctrl.send_online_booking_link()\" class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"(customer.phone != \'\' || customer.telephone != \'\')\"><i class=\"las la-link\"></i></button> <button tooltip=\'{{\"CUSTOMER_GO_QUOTATION\" | translate}}\' ng-click=\"ctrl.go_quotation()\" class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"isUserAllowedAccess(\'cashbox\') && cashbox_available\"><i class=\"las la-file-invoice-dollar\"></i></button> <button tooltip=\'{{\"SEND_PUBLIC_LINK\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"(customer.phone != \'\' || customer.telephone != \'\')\" ng-click=\"ctrl.social_link(customer.id)\"><i class=\"las la-external-link-alt\"></i></button> <button tooltip=\'{{\"SEND_DIGITAL_DOCUMENT\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"documents && documents.length > 0 && (customer.phone != \'\' || customer.telephone != \'\')\" ui-sref=\"app.customers.single.dd({id: {{customer.id}}})\"><i class=\"las la-book\"></i></button> <button tooltip=\'{{\"SEND_DIGITAL_FORM\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"forms && forms.length > 0 && (customer.phone != \'\' || customer.telephone != \'\')\" ui-sref=\"app.customers.single.df({id: {{customer.id}}})\"><i class=\"las la-file-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_SEND_SMS\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"customer.phone != \'\' || customer.telephone != \'\'\" ui-sref=\"app.customers.single.sms({id: {{customer.id}}})\"><i class=\"las la-comment\"></i></button> <button tooltip=\'{{\"CUSTOMERS_REQUEST_CARD\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-message\" ng-if=\"(customer.phone != \'\' || customer.telephone != \'\') && ctrl.business.cerdit_company == 3 && ctrl.business.enabled_retainers\" ng-click=\"ctrl.request_card()\"><i class=\"las la-credit-card\"></i></button> <button tooltip=\'{{\"CUSTOMERS_EDIT\" | translate}}\' class=\"have-tooltip btn icon circle large single-model-edit\" ng-click=\"ctrl.edit_customer()\"><i class=\"las la-edit\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DELETE\" | translate}}\' ng-click=\"ctrl.delete();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"customer.status != 2\" ng-disabled=\"customer.hasOrders\"><i class=\"las la-trash-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_RECOVER\" | translate}}\' ng-click=\"ctrl.recover();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"customer.status == 2\"><i class=\"las la-trash-restore-alt\"></i></button></div></div><div class=\"single-model-info\"><div class=\"col-md-4 collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_GENERAL\" | translate}} <span ng-if=\"customer.status_item\" class=\"btn btn-primary btn-xs category-item\" ng-style=\"{\'background-color\': ctrl.hexToRgbA(customer.status_item.color || \'#a9cfe8\')}\">{{customer.status_item.name}}</span> <button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_1 = !ctrl.info_1\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_1, \'la-angle-up\': ctrl.info_1}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_1}\"><div><div class=\"info-label\">{{\"CUSTOMERS_GENDER\" | translate}}</div><div class=\"info-value\">{{customer.gender | gender | emptyValue }}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_EMAIL\" | translate}}</div><div class=\"info-value\">{{customer.email | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_PHONE\" | translate}}</div><div class=\"info-value\">{{customer.phone | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_LANDLINE\" | translate}}</div><div class=\"info-value\">{{customer.telephone | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_BIRTHDAY\" | translate}}</div><div class=\"info-value\">{{customer.birthdate | date: \'dd/MM/yyyy\' | emptyValue}} <span ng-if=\"customer.birthdate\">({{ ctrl.calculateAge(customer.birthdate) }})</span></div></div><div><div class=\"info-label\">{{\"CUSTOMER_ARRIVAL_SOURCE\" | translate}}</div><div class=\"info-value\">{{customer.arrival_source | emptyValue}}</div></div><div><div class=\"info-label\">{{\"DEALER_ID\" | translate}}</div><div class=\"info-value\">{{customer.dealer_id | emptyValue}}</div></div><div class=\"notes-bubble\"><div class=\"info-label\">{{\"CUSTOMERS_REMARKS\" | translate}}</div><div class=\"info-value\">{{customer.notes | emptyValue}}</div></div></div></div><div class=\"col-md-4\"><div class=\"collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_ADDR\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_2 = !ctrl.info_2\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_2, \'la-angle-up\': ctrl.info_2}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_2}\"><div><div class=\"info-label\">{{\"CUSTOMERS_ADDR\" | translate}}</div><div class=\"info-value\">{{customer.address | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_HOME_NUMBER\" | translate}}</div><div class=\"info-value\">{{customer.home_number | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_CITY\" | translate}}</div><div class=\"info-value\">{{customer.city | emptyValue}}</div></div></div></div><div class=\"collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_LEAD_DETAILS\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_4 = !ctrl.info_4\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_4, \'la-angle-up\': ctrl.info_4}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_4}\"><div><div class=\"info-label\">{{\"CUSTOMERS_INTERESTED\" | translate}}</div><div class=\"info-value\">{{customer.interested_in ? customer.interested_in.name : \'\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_RESOURSE\" | translate}}</div><div class=\"info-value\">{{customer.resource_lead_name | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_CAMPAING_NAME\" | translate}}</div><div class=\"info-value\">{{customer.campaign_name | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_AD_NAME\" | translate}}</div><div class=\"info-value\">{{customer.ad_name | emptyValue}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_ADSET_NAME\" | translate}}</div><div class=\"info-value\">{{customer.adset_name | emptyValue}}</div></div><div ng-if=\"customer.custom_fields\" style=\"display: block;\"><h4 class=\"info-title\" style=\"width: 100%;\">{{\"CUSTOMERS_LEAD_QUESTIONS\" | translate}}<button class=\"btn icon simple\" ng-click=\"ctrl.info_5 = !ctrl.info_5\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_5, \'la-angle-up\': ctrl.info_5}\"></i></button></h4><div class=\"dl collapsed-all\" ng-class=\"{\'active\': ctrl.info_5}\"><div ng-repeat=\"(name, value) in customer.custom_fields\"><div class=\"info-label\">{{name | translate}}</div><div class=\"info-value\">{{value | emptyValue}}</div></div></div></div><div ng-if=\"customer.custom_values_list.length > 0\" style=\"display: block;\"><h4 class=\"info-title\" style=\"width: 100%;\">{{\"CUSTOMERS_CUSTOM_FIELDS\" | translate}}<button class=\"btn icon simple\" ng-click=\"ctrl.info_6 = !ctrl.info_6\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_6, \'la-angle-up\': ctrl.info_6}\"></i></button></h4><div class=\"dl collapsed-all\" ng-class=\"{\'active\': ctrl.info_6}\"><div ng-repeat=\"item in customer.custom_values_list\"><div class=\"info-label\">{{item.name}}</div><div class=\"info-value\">{{item.value }}</div></div></div></div></div></div></div><div class=\"col-md-4 collapsed-mobile\"><h4 class=\"info-title\">{{\"CUSTOMERS_CL_SETT\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_3 = !ctrl.info_3\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_3, \'la-angle-up\': ctrl.info_3}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_3}\"><div><div class=\"info-label\">{{\"SETTINGS_USER_SEND_MESSAGES\" | translate}}</div><div class=\"info-value\"><span ng-if=\"customer.send_notifications==3\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{customer.send_notifications | notificationTypes | translate}}</div></div><div><div class=\"info-label\">{{\"SETTINGS_USER_SEND_REMINDER\" | translate}}</div><div class=\"info-value\">{{customer.send_reminder | sendReminderTypes | translate}}</div></div><div ng-if=\"customer.send_reminder>0\"><div class=\"info-label\">{{\"CUSTOMERS_SEND_REMINDER\" | translate}}</div><div class=\"info-value\"><span ng-if=\"customer.reminder_send_type==3\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{customer.reminder_send_type | notificationTypes | translate}}</div></div><div ng-if=\"customer.send_reminder>0\"><div class=\"info-label\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION\" | translate}}</div><div class=\"info-value\" ng-if=\"customer.request_order_confirmation == 0\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_NO\" | translate}}</div><div class=\"info-value\" ng-if=\"customer.request_order_confirmation == 1\">{{\"SETTINGS_USER_SEND_ORDER_CONFIRMATION_YES\" | translate}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_SEND_DOCUMENTS\" | translate}}</div><div class=\"info-value\"><span ng-if=\"customer.send_documents==3\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{customer.send_documents | sendDocumentsTypes | translate}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_IND_ORD\" | translate}}</div><div class=\"info-value\">{{customer.self_order | booleanText:(\'CUSTOMERS_ALLOWED\' | translate):(\'CUSTOMERS_UNAUTHORIZED\' | translate)}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_GROUP_MESS\" | translate}}</div><div class=\"info-value\">{{customer.group_notifications | booleanText:(\'CUSTOMERS_ACTIVE\' | translate):(\'CUSTOMERS_OFF\' | translate)}}</div></div><div><div class=\"info-label\">{{\"CUSTOMERS_PREF_RES\" | translate}}</div><div class=\"info-value\">{{customer.resource_name | emptyValue}}</div></div></div></div></div></div><div class=\"col-xs-12 col col-lg-3 single-model-highlights\" ng-if=\"ctrl.isSummaryDetailEnabled(\'reg_date\') || ctrl.isSummaryDetailEnabled(\'inv\') || ctrl.isSummaryDetailEnabled(\'cons\') || ctrl.isSummaryDetailEnabled(\'last_12_month\') || ctrl.isSummaryDetailEnabled(\'ave\') || ctrl.isSummaryDetailEnabled(\'bal\')\"><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\" ng-if=\"ctrl.isSummaryDetailEnabled(\'reg_date\')\"><div class=\"btn icon fill-black\"><i class=\"las la-calendar\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_REG_DATE\" | translate}}</div><div ng-if=\"customer.created_at\" class=\"info-value mb0\">{{customer.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div><div ng-if=\"!customer.created_at\" class=\"info-value mb0\">{{customer.date | toUnixTimestamp | date: \'dd/MM/yyyy\'}}</div><div ng-if=\"customer.repeat_at\" class=\"mt-8\"><div class=\"info-label\">{{\"CUSTOMERS_REPEAT_DATE\" | translate}}</div><div class=\"info-value mb0\">{{customer.repeat_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div></div><div ng-if=\"customer.repeat_second_at\" class=\"mt-8\"><div class=\"info-label\">{{\"CUSTOMERS_REPEAT_SECOND_DATE\" | translate}}</div><div class=\"info-value mb0\">{{customer.repeat_second_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div></div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\" ng-if=\"ctrl.isSummaryDetailEnabled(\'inv\')\"><div class=\"btn icon fill-orange\"><i class=\"las la-box\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_INV\" | translate}}</div><div class=\"info-value mb0\">{{customer.number_of_shows}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\" ng-if=\"ctrl.isSummaryDetailEnabled(\'cons\')\"><div class=\"btn icon fill-red\"><i class=\"las la-times\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_CONS\" | translate}}</div><div class=\"info-value mb0\">{{customer.cancelations}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\" ng-if=\"ctrl.isSummaryDetailEnabled(\'last_12_month\')\"><div class=\"btn icon fill-green\"><i class=\"las la-dollar-sign\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_LAST_12_MONTH\" | translate}}</div><div class=\"info-value mb0\">{{customer.current_year_income | price}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\" ng-if=\"ctrl.isSummaryDetailEnabled(\'ave\')\"><div class=\"btn icon fill-blue\"><i class=\"las la-chart-line\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_AVE\" | translate}}</div><div class=\"info-value mb0\">{{customer.ave | price}}</div></div></div><div class=\"cloud mb-16 p-16 flex gap-24 nowrap\" ng-if=\"ctrl.isSummaryDetailEnabled(\'bal\')\"><div class=\"btn icon fill-purple\"><i class=\"las la-wallet\"></i></div><div><div class=\"info-label\">{{\"CUSTOMERS_BAL\" | translate}}</div><div class=\"info-value mb0\">{{customer.oncredit | price}}</div></div><a ui-sref=\"app.cashbox.closedebt({customer: {{customer.id}}})\" class=\"close-debt btn text primary\" ng-if=\"customer.oncredit > 0\">{{\"CUSTOMERS_OV_COV\" | translate}}</a></div></div></div><div class=\"row-fluid\"><div class=\"col-md-12 border-top border-bottom single-model-tabs customer-single-model cloud\"><div class=\"tab-row\"><ul ng-if=\"!isMobile\" ui-sortable=\"{ stop: ctrl.dropMenu }\" class=\"nav nav-tabs\" ng-model=\"ctrl.menuOrderedList\"><li ng-repeat=\"row in ctrl.menuOrderedList\" ng-if=\"row.display && (row.name != \'wachat\' || (row.name == \'wachat\' && customer_wa_chat))\" ng-class=\"[{active: ctrl.active_tab == row.name}, [\'uib-tab\', \'nav-item\']]\"><a href=\"\" ng-click=\"ctrl.setActiveTab(row.name)\" class=\"nav-link nowrap\"><span ng-if=\"row.name == \'wachat\'\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{ctrl.menuTitles[row.name]}}</a></li></ul><ul ng-if=\"isMobile\" class=\"nav nav-tabs\" ng-model=\"ctrl.menuOrderedList\"><li ng-repeat=\"row in ctrl.menuOrderedList\" ng-if=\"row.display && (row.name != \'wachat\' || (row.name == \'wachat\' && customer_wa_chat))\" ng-class=\"[{active: ctrl.active_tab == row.name}, [\'uib-tab\', \'nav-item\']]\"><a href=\"\" ng-click=\"ctrl.setActiveTab(row.name)\" class=\"nav-link nowrap\"><span ng-if=\"row.name == \'wachat\'\" class=\"green\"><i class=\"lab la-whatsapp\"></i></span>{{ctrl.menuTitles[row.name]}}</a></li></ul><div class=\"tab-settings\"><div class=\"tab-settings-inner\"><table-column-settings ng-if=\"ctrl.menuOrderedList && ctrl.menuOrderedList.length > 0\" :title=\"{{\'CUSTOMER_MENU_SETTINGS\' | translate}}\" :header-title=\"{{\'CUSTOMER_MENU_SETTINGS_HEADER\' | translate}}\" header-color=\"red\" fields-list=\"ctrl.menuOrderedList\" on-update=\"ctrl.dropMenu()\"></table-column-settings></div></div></div><div class=\"tab-content\"><div ng-if=\"ctrl.isTabEnabled(\'history\')\" ng-class=\"[{active: ctrl.active_tab === \'history\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0 && !ctrl.tableData.length\"><div class=\"flex form top nowrap mb-16\"><div><div class=\"form-group last\"><app-dropdown model=\"ctrl.historyOrdersStatusFilter\" options=\"ctrl.orderStatusOptions\" value-prop=\"value\" label-prop=\"name\" placeholder=\"{{\'CUSTOMERS_HISTORY_FILTER_BY_STATUS\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.loadOrderHistory()\"></app-dropdown></div></div></div><i class=\"las la-history\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_ORDERS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_ORDERS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'history\' && (ctrl.initedTableData.length>0 || ctrl.tableData.length>0)\"><div class=\"flex form top nowrap mb-16\"><div><div class=\"form-group last\"><app-dropdown model=\"ctrl.historyOrdersStatusFilter\" options=\"ctrl.orderStatusOptions\" value-prop=\"value\" label-prop=\"name\" placeholder=\"{{\'CUSTOMERS_HISTORY_FILTER_BY_STATUS\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.loadOrderHistory()\"></app-dropdown></div></div><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.searchTableData(\'historyOrdersSearchFilter\')\" ng-model=\"ctrl.historyOrdersSearchFilter\" class=\"form-control\"></div></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyOrdersSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_DATE\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_ITEM\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_RESOURCE\" | translate}}</th><th class=\"customer-cell\" ng-if=\"b_type==1\">{{\"CUSTOMER_ORDER_HISTORY_QTY\" | translate}}</th><th class=\"customer-cell\" ng-if=\"b_type==2\">{{\"CUSTOMER_ORDER_HISTORY_NIGHTS\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_PRICE\" | translate}}</th><th class=\"customer-cell\">{{\"CUSTOMER_ORDER_HISTORY_TOTAL\" | translate}}</th><th class=\"customer-cell\"></th><th class=\"images-cell\">{{\"CALENDAR_ORDER_IMAGES_BEFORE\" | translate}}</th><th class=\"images-cell\">{{\"CALENDAR_ORDER_IMAGES_AFTER\" | translate}}</th><th class=\"notes-cell\">{{\"CALENDAR_ORDER_REMARKS\" | translate}}</th><th class=\"notes-cell\">{{\"CUSTOMER_ORDER_HISTORY_MEDICAL_NOTE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.edit_order_form(row)\"><td class=\"customer-cell\"><span ng-hide=\"true\">{{row.order_date | toUnixTimestamp }}</span> {{row.order_date}} <i ng-click=\"ctrl.goToOrder($event, row)\" class=\"las la-eye show-order\"></i></td><td class=\"customer-cell\"><b>{{row.item_data.name}}</b></td><td class=\"customer-cell\">{{row.resource_name}}</td><td class=\"customer-cell\" ng-if=\"b_type==1\">{{row.item_data.quantity ? row.item_data.quantity : 1}}</td><td class=\"customer-cell\" ng-if=\"b_type==2\">{{row.nights}}</td><td class=\"customer-cell\">{{row.item_data.price}}</td><td class=\"customer-cell\">{{row.order_price}}</td><td class=\"customer-cell\"><div class=\"flex gap-8\"><div class=\"single-model-floating\" ng-if=\"row.customer_form_ids\" ng-repeat=\"form_id in row.customer_form_ids\"><div class=\"single-model-floating-inner\"><button class=\"btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation();\" ui-sref=\"app.customers.single.customers_digital_form({id: customer.id, form_id: form_id})\"><i class=\"las la-file-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DF_PDF_TOOLTIP\" | translate}}\' class=\"have-tooltip green btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.send_form(form_id)\"><i class=\"las la-file-pdf\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DF_PRINT_TOOLTIP\" | translate}}\' class=\"have-tooltip blue btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.print_form(form_id)\"><i class=\"las la-print\"></i></button></div></div></div></td><td class=\"images-cell\"><div ng-if=\"row.images_before && row.images_before.length > 0\" class=\"image-for-orders\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, row.images_before);\"><img ng-src=\"{{row.images_before[0]}}\" alt=\"\"></div><span ng-if=\"row.images_before.length > 1\" class=\"nav-mark\">{{row.images_before.length}}</span></div></td><td class=\"images-cell\"><div ng-if=\"row.images_after && row.images_after.length > 0\" class=\"image-for-orders\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, row.images_after);\"><img ng-src=\"{{row.images_after[0]}}\" alt=\"\"></div><span ng-if=\"row.images_after.length > 1\" class=\"nav-mark\">{{row.images_after.length}}</span></div></td><td class=\"notes-cell\"><div class=\"remark-cell\" tooltip2-size=\"target-fit,object-fit\" tooltip2=\"{{row.order_notes}}\"><div ng-bind-html=\"ctrl.renderNoteText(row.order_notes)\"></div></div></td><td class=\"notes-cell\"><div ng-if=\"row.medical_note_text\" class=\"remark-cell\" tooltip2-size=\"target-fit,object-fit\"><div ng-bind-html=\"ctrl.renderNoteText(row.medical_note_text)\"></div></div></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'wachat\')\" ng-class=\"[{active: ctrl.active_tab === \'wachat\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'wachat\'\"><div class=\"empty-section\" ng-if=\"!customer.phone\"><i class=\"lab la-whatsapp\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_WA\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_WA_SENTENCE\" | translate}}</p></div><div ng-if=\"customer.phone && !ctrl.isTexterWa\" ng-include=\"\'app/modules/customers/modules/customers-wa-chat/customers.wa.chat.html\'\"></div><iframe ng-if=\"customer.phone && ctrl.isTexterWa && ctrl.texterIframeUrl\" ng-src=\"{{ctrl.texterIframeUrl}}\" style=\"width:100%; height: 620px; border:none; margin:0; padding:0; overflow:hidden; max-width: 1020px;\">Your browser doesn\'t support iframes</iframe></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'notes\')\" ng-class=\"[{active: ctrl.active_tab === \'notes\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-clipboard\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_NOTES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_NOTES_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.add_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_NOTE\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'notes\' && ctrl.tableData.length\"><div class=\"flex form top nowrap mb-16\"><div><a ng-click=\"ctrl.add_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_NOTE\" | translate}}</a></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-notes\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-note-cell\">{{\"NOTES_CREATED_AT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_TEXT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_REMIND_AT\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.add_note(row)\"><td class=\"customer-note-cell\">{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-note-cell\">{{row.resource_name}}</td><td class=\"customer-note-cell\" ng-bind-html=\"ctrl.renderNoteText(row.text)\"></td><td class=\"customer-note-cell\">{{row.remind_at_display}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'medical_notes\')\" ng-class=\"[{active: ctrl.active_tab === \'medical_notes\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-clipboard\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_NOTES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_NOTES_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.add_medical_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_MEDICAL_NOTE\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'medical_notes\' && ctrl.tableData.length\"><div class=\"flex form top nowrap mb-16\"><div><a ng-click=\"ctrl.add_medical_note()\" class=\"btn text primary\">{{\"CUSTOMERS_ADD_MEDICAL_NOTE\" | translate}}</a></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-medical_notes\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-note-cell\">{{\"NOTES_CREATED_AT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_TEXT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_REMIND_AT\" | translate}}</th><th class=\"customer-note-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-class=\"{\'deleted-row\': row.removed_at}\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.add_medical_note(row)\"><td class=\"customer-note-cell\">{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-note-cell\">{{row.resource_name}}</td><td class=\"customer-note-cell\" ng-bind-html=\"ctrl.renderNoteText(row.text)\"></td><td class=\"customer-note-cell\">{{row.remind_at_display}}</td><td class=\"customer-note-cell\"><i ng-click=\"ctrl.open_medical_note_log($event, row)\" class=\"las la-eye show-order\"></i></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'cards\')\" ng-class=\"[{active: ctrl.active_tab === \'cards\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-ticket-alt\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_CARDS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_CARDS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'cards\' && ctrl.initedTableData.length\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-cards\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-card-cell\">{{\"CUSTOMER_CARD_NAME\" | translate}}</th><th class=\"customer-card-cell\">{{\"CUSTOMER_CARD_BALANCE\" | translate}}</th><th class=\"customer-card-cell\">{{\"MAKE_CARD_EXPIRED_DATE\" | translate}}</th><th class=\"customer-card-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_customer_card_transactions(row.id)\"><td class=\"customer-card-cell\"><i ng-class=\"{\'las la-ticket-alt\':true, \'expired\': row.expired}\"></i> {{row.card_name}}</td><td class=\"customer-card-cell\">{{row.balance}}</td><td class=\"customer-card-cell\">{{row.expired_at | toUnixTimestamp | date:\"dd/MM/yyyy\"}}</td><td class=\"customer-card-cell customer-card-change-cell\"><button class=\"btn text primary\" ng-click=\"ctrl.showChangeCard(row.id);$event.stopPropagation()\">{{\"CARD_BALANCE_CHANGE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'color\')\" ng-class=\"[{active: ctrl.active_tab === \'color\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-tint\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_COLOR\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_COLOR_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.edit_color_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_COLOR\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'color\' && ctrl.initedTableData.length > 0\"><div class=\"mb-24\"><a ng-click=\"ctrl.edit_color_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_COLOR\" | translate}}</a></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-color\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_DATE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_OXYGEN\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_OXYGEN_DOSAGE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_BRAND\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_COLOR_COMMENTS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.edit_color_form(row.id)\"><td class=\"customer-color-cell\"><span>{{row.date}}</span> <button type=\"button\" class=\"btn icon bordered\" ng-click=\"ctrl.print_coloring(row, $event)\" title=\"{{\'CUSTOMERS_PRINT\' | translate}}\"><i class=\"las la-print\"></i></button></td><td class=\"customer-color-cell\">{{row.color_number}}<br ng-if=\"row.color_number_2\">{{row.color_number_2}}<br ng-if=\"row.color_number_3\">{{row.color_number_3}}<br ng-if=\"row.color_number_4\">{{row.color_number_4}}</td><td class=\"customer-color-cell\">{{row.color_dosage}}<br ng-if=\"row.color_dosage_2\">{{row.color_dosage_2}}<br ng-if=\"row.color_dosage_3\">{{row.color_dosage_3}}<br ng-if=\"row.color_dosage_4\">{{row.color_dosage_4}}</td><td class=\"customer-color-cell\">{{row.oxygen_percent}}</td><td class=\"customer-color-cell\">{{row.oxygen_dosage}}</td><td class=\"customer-color-cell\">{{row.brand}}</td><td class=\"customer-color-cell\">{{row.comments}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'transaction\')\" ng-class=\"[{active: ctrl.active_tab === \'transaction\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-file-invoice-dollar\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_TRANSACTIONS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_TRANSACTIONS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'transaction\' && ctrl.futureInvoices && ctrl.futureInvoices.length > 0\" class=\"mb-24\"><h3 class=\"mb-16\">{{\"FUTURE_INVOICES\" | translate}}</h3><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table class=\"customer-single-table table table-striped table-bordered table-hover ng-scope ng-isolate-scope dataTable no-footer\"><thead><tr><th>{{\"FUTURE_INVOICES_TOTAL\" | translate}}</th><th>{{\"FUTURE_INVOICES_ISSUED\" | translate}}</th><th>{{\"FUTURE_INVOICES_LEFT\" | translate}}</th><th>{{\"FUTURE_INVOICES_AMOUNT_LEFT\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"deal in ctrl.futureInvoices\"><td>{{deal.total_amount | price}}</td><td>{{deal.num_type2_issued}} / {{deal.number_of_payments}}</td><td>{{deal.payments_left}}</td><td>{{deal.amount_left | price}}</td></tr></tbody></table></div></div></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'transaction\' && ctrl.initedTableData.length > 0\"><div class=\"flex form gap-16 mb-16\"><div><div class=\"btn-group\" role=\"group\"><button ng-click=\"ctrl.change_item_type(\'service\')\" type=\"button\" class=\"btn {{ctrl.active_item_type == \'service\' ? \'btn-primary\' : \'\'}}\">{{\"SERVICE\" | translate}}</button> <button ng-click=\"ctrl.change_item_type(\'sale\')\" type=\"button\" class=\"btn {{ctrl.active_item_type == \'sale\' ? \'btn-primary\' : \'\'}}\">{{\"SALE\" | translate}}</button> <button ng-click=\"ctrl.change_item_type(\'card\')\" type=\"button\" class=\"btn {{ctrl.active_item_type == \'card\' ? \'btn-primary\' : \'\'}}\">{{\"CARD_ITEM_TYPE\" | translate}}</button></div></div><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.searchTableData(\'historyTransSearchFilter\')\" ng-model=\"ctrl.historyTransSearchFilter\" class=\"form-control\"></div></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyTransSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_DATE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_NAME\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_QUANTITY\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_PRICE\" | translate}}</th><th class=\"customer-color-cell\">{{\"CUSTOMER_TRANSACTIONS_TOTAL_PRICE\" | translate}}</th><th class=\"customer-color-cell\" ng-if=\"ctrl.hasQuotationStatuses\">{{\"CUSTOMER_QUOTATION_STATUS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_log_card(row)\"><td class=\"customer-color-cell\">{{row.date}}<div ng-if=\"row.quotation\" class=\"prepaid-label\">{{\"SETTINGS_LOG_QUOTATION_LABEL\" | translate}}</div><span ng-if=\"row.continuous_deal_id\" class=\"continuous-deal-icon\" tooltip2=\"{{\'CONTINUOUS_DEAL_ICON_TITLE\' | translate}}\"><i class=\"las la-calendar-check\"></i></span></td><td><b ng-bind-html=\"row.name | nl2br\"></b></td><td class=\"customer-color-cell\">{{row.quantity}}</td><td class=\"customer-color-cell\">{{row.price}}</td><td class=\"customer-color-cell\">{{row.total}}</td><td class=\"customer-color-cell\" ng-if=\"ctrl.hasQuotationStatuses\"><div ng-if=\"row.quotation\" class=\"form-group form-list prevent-click\"><app-dropdown model=\"transactionQuotationStatuses[row.id]\" options=\"ctrl.quotation_statuses_options\" value-prop=\"id\" label-prop=\"name\" color-prop=\"color\" fixed-panel=\"true\" on-change=\"ctrl.updateQuotationStatus(row.id, model)\"></app-dropdown></div></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'documents\')\" ng-class=\"[{active: ctrl.active_tab === \'documents\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-book\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_DOCUMENTS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_DOCUMENTS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab == \'documents\' && ctrl.initedTableData.length > 0\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyDocumentsSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_NAME\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_DATE\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_DATE_SIGN\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_SIGN\" | translate}}</th><th class=\"customer-document-cell\">{{\"CUSTOMER_DOCUMENTS_LINK\" | translate}}</th><th class=\"customer-document-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-document-cell\"><b>{{ctrl.documentName(row)}}</b></td><td class=\"customer-document-cell\">{{row.date}}</td><td class=\"customer-document-cell\">{{row.sign_date}}</td><td class=\"customer-document-cell\"><span ng-if=\"row.sign\" class=\"btn text success label\">{{\"CUSTOMER_DOCUMENTS_SIGNED\" | translate}}</span> <span ng-if=\"!row.sign\" class=\"btn text warning label\">{{\"CUSTOMER_DOCUMENTS_SIGN_WAIT\" | translate}}</span></td><td class=\"customer-document-cell\"><a ng-if=\"ctrl.isWebView()\" ng-click=\"ctrl.openPdf(row.url)\" class=\"btn icon bordered\"><i class=\"las la-file-alt\"></i></a> <a ng-if=\"!ctrl.isWebView()\" href=\"{{row.url}}\" class=\"btn icon bordered\" target=\"_blank\"><i class=\"las la-file-alt\"></i></a></td><td class=\"customer-document-cell\"><button class=\"btn text border-red\" ng-click=\"ctrl.removeDocument(row.id); $event.stopPropagation()\">{{\"CUSTOMER_DOCUMENTS_REMOVE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'forms\')\" ng-class=\"[{active: ctrl.active_tab === \'forms\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length==0\"><i class=\"las la-file-alt\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_FORMS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_FORMS_SENTENCE\" | translate}}</p><a ng-click=\"ctrl.add_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_FORM\" | translate}}</a></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab == \'forms\' && ctrl.initedTableData.length > 0\"><div class=\"mb-24\"><a ng-click=\"ctrl.add_form()\" class=\"btn text primary\">{{\"CUSTOMER_ADD_FORM\" | translate}}</a></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyFormsSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-forms-cell\">{{\"CUSTOMER_FORMS_NAME\" | translate}}</th><th class=\"customer-forms-cell\">{{\"CUSTOMER_FORMS_DATE\" | translate}}</th><th class=\"customer-forms-cell\">{{\"CUSTOMER_FORMS_FILL_DATE\" | translate}}</th><th></th><th></th></tr></thead><tbody><tr ui-sref=\"app.customers.single.customers_digital_form({id: customer.id, form_id: row.id})\" class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-forms-cell\"><b>{{row.name}}</b></td><td class=\"customer-forms-cell\">{{row.date}}</td><td class=\"customer-forms-cell\">{{row.fill_date}}</td><td class=\"customer-forms-cell\"><button tooltip=\'{{\"CUSTOMERS_DF_PDF_TOOLTIP\" | translate}}\' class=\"have-tooltip green btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.send_form(row.id)\"><i class=\"las la-file-pdf\"></i></button> <button tooltip=\'{{\"CUSTOMERS_DF_PRINT_TOOLTIP\" | translate}}\' class=\"have-tooltip blue btn icon circle large single-model-message\" ng-click=\"$event.stopPropagation(); ctrl.print_form(row.id)\"><i class=\"las la-print\"></i></button></td><td class=\"customer-forms-cell\"><button class=\"btn text border-red\" ng-click=\"ctrl.removeForm(row.id); $event.stopPropagation()\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'laser\')\" ng-class=\"[{active: ctrl.active_tab === \'laser\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" id=\"drop-area\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0 && !ctrl.laser_form.length\"><i class=\"las la-file\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_LASER_FILES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_LASER_FILES_SENTENCE\" | translate}}</p><button type=\"submit\" ng-click=\"ctrl.add_line();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_ADD\" | translate}}</button></div><div ng-if=\"!ctrl.tabLoading && (ctrl.initedTableData.length || ctrl.laser_form.length)\"><div class=\"flex form gap-16 mb-16\"><div><div class=\"btn-group\"><button ng-repeat=\"category in ctrl.laser_categories\" class=\"btn\" ng-click=\"ctrl.laser_category = category.id\" ng-class=\"{\'btn-primary\': ctrl.laser_category == category.id, \'btn-default\': ctrl.laser_category != category.id}\">{{category.name | translate}}</button></div></div></div><div class=\"laser-values\"><table class=\"dataTable\"><thead><tr><th class=\"min\"></th><th ng-repeat=\"field in ctrl.laser_fields\" ng-if=\"field.category_id == ctrl.laser_category\" class=\"laser-value-column\"><p>{{field.name}}</p></th><th class=\"min\"></th></tr></thead><tbody><tr ng-repeat=\"(index, form) in ctrl.laser_form\" ng-if=\"!form.remove && form.category_id == ctrl.laser_category && (form.show || form.first)\"><td class=\"min\" width=\"1%\"><button ng-if=\"form.order_id && form.first && ctrl.laser_orders[form.order_id] == \'closed\' && ctrl.laser_orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form);\" class=\"btn icon bordered\"><i class=\"las la-angle-down\"></i></button> <button ng-if=\"form.order_id && form.first && ctrl.laser_orders[form.order_id] == \'opened\' && ctrl.laser_orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form, true);\" class=\"btn icon bordered\"><i class=\"las la-angle-up\"></i></button></td><td ng-repeat=\"field in ctrl.laser_fields\" ng-if=\"field.category_id == ctrl.laser_category\" ng-class=\"{\'min\': field.type == \'map\', \'laser-value-column\': true}\"><div ng-if=\"field.type == \'text\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"text\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'date\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"date\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'datetime\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"datetime-local\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'textarea\'\" class=\"form-group\"><textarea placeholder=\"{{field.name}}\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" auto-expand=\"\" class=\"form-control small\"></textarea></div><div ng-if=\"field.type == \'list\'\" class=\"form-group\"><app-dropdown model=\"form[field.id]\" options=\"field.list\" value-prop=\"id\" label-prop=\"name\" placeholder=\"{{field.name}}\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"field.type == \'map\'\" class=\"form-group\"><button ng-click=\"ctrl.laser_map(index, field);\" class=\"btn text border-primary\">{{\"LASER_FILE_MAP_BUTTON\" | translate}}</button></div></td><td class=\"min\" width=\"1%\"><button ng-click=\"ctrl.remove_line(index);\" class=\"btn icon circle error\"><i class=\"las la-trash-alt\"></i></button></td></tr></tbody></table></div><div class=\"laser-footer\"><button type=\"submit\" ng-click=\"ctrl.add_line();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_ADD\" | translate}}</button> <button type=\"submit\" ng-click=\"ctrl.submit_fields();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'files\')\" ng-class=\"[{active: ctrl.active_tab === \'files\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" id=\"drop-area\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-file\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_FILES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_FILES_SENTENCE\" | translate}}</p><label class=\"btn text primary\">{{\"CUSTOMERS_ADD_FILE\" | translate}} <input style=\"display: none\" type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'files\' && ctrl.initedTableData.length\"><div class=\"flex form top nowrap mb-16\"><div><label class=\"btn text primary\">{{\"CUSTOMERS_ADD_FILE\" | translate}} <input style=\"display: none\" type=\"file\" multiple=\"\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div></div><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-files\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-file-cell\">{{\"FILES_NAME\" | translate}}</th><th class=\"customer-file-cell\">{{\"FILES_CREATED_AT\" | translate}}</th><th class=\"customer-file-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-file-cell\"><a ng-if=\"ctrl.isWebView() && (ctrl.isPdfUrl(row.url) || ctrl.isImageUrl(row.url))\" ng-click=\"ctrl.openPdf(row.url)\" class=\"btn icon bordered\"><i class=\"las la-download\"></i></a> <a ng-if=\"!(ctrl.isWebView() && (ctrl.isPdfUrl(row.url) || ctrl.isImageUrl(row.url)))\" class=\"btn icon bordered\" download=\"\" target=\"_blank\" href=\"{{row.url}}\"><i class=\"las la-download\"></i></a> <a ng-if=\"(!ctrl.isWebView() && (ctrl.isPdfUrl(row.url) || ctrl.isImageUrl(row.url)))\" ng-click=\"ctrl.openPdf(row.url)\" class=\"btn icon bordered\"><i class=\"las la-eye\"></i></a> {{row.name}}</td><td class=\"customer-file-cell\">{{row.created_at_display}}</td><td class=\"customer-file-cell\"><button class=\"btn text border-red\" ng-click=\"ctrl.deleteFile(row.id); $event.stopPropagation()\">{{\"CUSTOMER_FILES_REMOVE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'smses\')\" ng-class=\"[{active: ctrl.active_tab === \'smses\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-comment\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_SMSES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_SMSES_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'smses\' && ctrl.initedTableData.length\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-historyTransSearchFilter\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th style=\"width: auto !important;\" class=\"customer-color-cell\">{{\"CUSTOMER_SMSES_DATE\" | translate}}</th><th style=\"min-width: 40%; width: auto !important;\" class=\"customer-color-cell\">{{\"CUSTOMER_SMSES_TEXT\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\" class=\"customer-color-cell\">{{\"CUSTOMER_SMSES_STATUS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-color-cell\"><span ng-hide=\"true\">{{row.created_at | toUnixTimestamp }}</span> {{row.sent}}</td><td class=\"customer-color-cell\"><b>{{row.message}}</b></td><td class=\"customer-color-cell\">{{row.updated}} - <span ng-if=\"!row.error\">{{\"SETTINGS_SMS_LOGS_STATUS_SENT\" | translate}}</span> <span ng-if=\"row.error\"><span ng-if=\"row.error == \'Delivered\'\">{{\"SETTINGS_SMS_LOGS_STATUS_DELIVERED\" | translate}}</span> <span ng-if=\"row.error != \'Delivered\'\">{{row.error}}</span></span></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"ctrl.isTabEnabled(\'calls\')\" ng-class=\"[{active: ctrl.active_tab === \'calls\'}, [\'tab-pane\']]\"><div class=\"panel-body p-24\"><div class=\"tab-loading\" ng-if=\"ctrl.tabLoading\"><div class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div><div class=\"empty-section\" ng-if=\"!ctrl.tabLoading && ctrl.initedTableData.length == 0\"><i class=\"las la-phone\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_CALLS\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_CALLS_SENTENCE\" | translate}}</p></div><div ng-if=\"!ctrl.tabLoading && ctrl.active_tab === \'calls\' && ctrl.initedTableData.length\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-calls\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th style=\"width: auto !important;\" class=\"customer-color-cell\">{{\"SETTINGS_CALL_LOGS_DATE\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\" class=\"customer-color-cell\">{{\"SETTINGS_CALL_LOGS_PHONE\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\" class=\"customer-color-cell\">{{\"SETTINGS_CALL_LOGS_STATUS\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\" class=\"customer-color-cell\">{{\"SETTINGS_CALL_LOGS_DURATION\" | translate}}</th><th style=\"min-width: 1%; width: 1% !important;\" class=\"customer-color-cell\">{{\"SETTINGS_CALL_LOGS_RECORD\" | translate}}</th><th style=\"min-width: 1%; width: 1% !important;\" class=\"customer-color-cell\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td class=\"customer-color-cell\"><span ng-hide=\"true\">{{row.created_at | toUnixTimestamp }}</span> {{row.created_at_formatted || row.created_at}}</td><td class=\"customer-color-cell\"><b>{{row.caller}}</b></td><td class=\"customer-color-cell\"><span ng-if=\"row.status\">{{\"SETTINGS_CALL_LOGS_STATUS_\"+(row.status.toUpperCase()) | translate}}</span> <span ng-if=\"!row.status\">-</span></td><td class=\"customer-color-cell\">{{row.duration ? row.duration + \'s\' : \'-\'}}</td><td class=\"customer-color-cell\"><button ng-if=\"ctrl.currentAudioRow && ctrl.getRowId(ctrl.currentAudioRow) == ctrl.getRowId(row) && ctrl.audio && row.record\" class=\"btn icon small circle bordered red\" ng-click=\"ctrl.playRecord(row); $event.stopPropagation()\"><i class=\"las la-stop\"></i></button> <button ng-if=\"(!ctrl.currentAudioRow || ctrl.getRowId(ctrl.currentAudioRow) != ctrl.getRowId(row) || !ctrl.audio) && row.record\" class=\"btn icon small circle bordered green\" ng-click=\"ctrl.playRecord(row); $event.stopPropagation()\"><i class=\"las la-play\"></i></button> <span ng-if=\"!row.record\">-</span></td><td class=\"customer-color-cell\"><a class=\"btn icon circle small bordered blue\" ng-click=\"$event.stopPropagation()\" href=\"tel:{{row.caller}}\"><i class=\"las la-phone\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers-sms/customers.sms.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">\"{{Customer.firstname}} {{Customer.lastname}}\" {{\"CUSTOMERS_SMS_TO\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"smsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group with_upload\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_CONTENT_MESSAGE\" | translate}}</label> <span class=\"upload_file_paperclip\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"> <i class=\"la la-paperclip\"></i> <span ng-if=\"ctrl.form.files && ctrl.form.files.length\" class=\"remove\"><i class=\"las la-times\"></i></span></span> <textarea class=\"form-control\" name=\"message\" ng-model=\"ctrl.form.message\" required=\"\" style=\"height: 120px; resize: none;\"></textarea><div ng-messages=\"smsForm.message.$error\" class=\"ng-messages\" ng-show=\"smsForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"smsForm.$invalid || smsForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-wa-chat/customers.wa.chat.html","<div class=\"wachat\" ng-controller=\"CustomersWaChatController as wachat\"><div class=\"wachat_scroll\"><div class=\"wachat_messages\"><div class=\"wachat_body\"><div id=\"wa-chat-container\" ng-if=\"wa_history && wa_history && !wa_history.invokeStatus\"><div ng-repeat=\"item in wa_history\" ng-key=\"$index\"><div ng-class=\"{\'wachat__msg\': true, \'wachat__msg_reply\': item.type == \'outgoing\'}\"><div class=\"wachat__user\" ng-if=\"item.type == \'incoming\' && wa_avatar\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar }}\" alt=\"User\"></div><div class=\"wachat__user\" ng-if=\"item.type == \'outgoing\' && wa_avatar_my\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar_my }}\" alt=\"User\"></div><div class=\"wachat__wrap\"><div class=\"wachat__comment wachat__comment_deleted\" ng-if=\"item.typeMessage == \'deletedMessage\'\">{{ \'WACHAT_MESSAGE_DELETED\' | translate }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'textMessage\'\" ng-bind-html=\"formattedText(item.textMessage)\"></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'extendedTextMessage\'\"><a ng-if=\"item.extendedTextMessage && item.extendedTextMessage.text && ((item.extendedTextMessage.jpegThumbnail && item.extendedTextMessage.jpegThumbnail != \'\') || item.extendedTextMessage.title || item.extendedTextMessage.description || extractDomain(item.extendedTextMessage.text))\" ng-href=\"{{ item.extendedTextMessage.url ? item.extendedTextMessage.url : item.extendedTextMessage.text }}\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"wachat__extended\"><div ng-if=\"item.extendedTextMessage.jpegThumbnail && item.extendedTextMessage.jpegThumbnail != \'\'\" class=\"wachat__extended-image\"><img ng-src=\"data:image/png;base64,{{ item.extendedTextMessage.jpegThumbnail }}\" alt=\"\"></div><div class=\"wachat__extended-content\"><div ng-if=\"item.extendedTextMessage.title\" class=\"wachat__extended-title\">{{ item.extendedTextMessage.title }}</div><div ng-if=\"item.extendedTextMessage.description\" class=\"wachat__extended-description\">{{ item.extendedTextMessage.description }}</div><div ng-if=\"extractDomain(item.extendedTextMessage.text)\" class=\"wachat__extended-domain\">{{ extractDomain(item.extendedTextMessage.text) }}</div></div></a><div ng-bind-html=\"checkForUrl(item.textMessage || (item.extendedTextMessage && item.extendedTextMessage.text))\"></div></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'audioMessage\'\"><i ng-if=\"currentAudioId == item.idMessage\" class=\"las la-stop play-wa\" ng-click=\"playWaRecord(item)\"></i> <i ng-if=\"currentAudioId != item.idMessage\" class=\"las la-play play-wa\" ng-click=\"playWaRecord(item)\"></i></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'imageMessage\' || item.typeMessage == \'videoMessage\'\"><a ng-href=\"{{ item.downloadUrl }}\" target=\"_blank\" rel=\"noopener noreferrer\"><img ng-if=\"item.jpegThumbnail\" ng-src=\"data:image/png;base64,{{item.jpegThumbnail}}\"></a></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'stickerMessage\'\"><a ng-if=\"item.downloadUrl\" ng-href=\"{{ item.downloadUrl }}\" target=\"_blank\" rel=\"noopener noreferrer\"><img ng-if=\"item.jpegThumbnail\" ng-src=\"data:image/png;base64,{{item.jpegThumbnail}}\"> <img ng-if=\"!item.jpegThumbnail\" ng-src=\"{{ item.downloadUrl }}\"></a> <img ng-if=\"!item.downloadUrl && item.jpegThumbnail\" ng-src=\"data:image/png;base64,{{item.jpegThumbnail}}\"> <span ng-if=\"!item.downloadUrl && !item.jpegThumbnail\">{{ \'WACHAT_STICKER\' | translate }}</span></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'documentMessage\'\"><a ng-href=\"{{ item.downloadUrl }}\" download=\"{{ item.fileName }}\"><i class=\"las la-file play-wa\"></i> {{ item.fileName }}</a><br ng-if=\"item.caption\">{{ item.caption }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'quotedMessage\' && item.extendedTextMessage && item.extendedTextMessage.text\"><div class=\"wachat__quoted\" ng-if=\"item.quotedMessage\"><div ng-class=\"{\'wachat__msg\': true, \'wachat__msg_reply\': item.type == \'outgoing\'}\"><div class=\"wachat__user\" ng-if=\"item.type == \'incoming\' && wa_avatar\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar }}\" alt=\"User\"></div><div class=\"wachat__user\" ng-if=\"item.type == \'outgoing\' && wa_avatar_my\"><img class=\"wachat__pic\" ng-src=\"{{ wa_avatar_my }}\" alt=\"User\"></div><div class=\"wachat__wrap\"><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'textMessage\'\" ng-bind-html=\"formattedText(item.textMessage)\"></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'extendedTextMessage\'\"><a ng-if=\"item.extendedTextMessage && item.extendedTextMessage.text && ((item.extendedTextMessage.jpegThumbnail && item.extendedTextMessage.jpegThumbnail != \'\') || item.extendedTextMessage.title || item.extendedTextMessage.description || extractDomain(item.extendedTextMessage.text))\" ng-href=\"{{ item.extendedTextMessage.url ? item.extendedTextMessage.url : item.extendedTextMessage.text }}\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"wachat__extended\"><div ng-if=\"item.extendedTextMessage.jpegThumbnail && item.extendedTextMessage.jpegThumbnail != \'\'\" class=\"wachat__extended-image\"><img ng-src=\"data:image/png;base64,{{ item.extendedTextMessage.jpegThumbnail }}\" alt=\"\"></div><div class=\"wachat__extended-content\"><div ng-if=\"item.extendedTextMessage.title\" class=\"wachat__extended-title\">{{ item.extendedTextMessage.title }}</div><div ng-if=\"item.extendedTextMessage.description\" class=\"wachat__extended-description\">{{ item.extendedTextMessage.description }}</div><div ng-if=\"extractDomain(item.extendedTextMessage.text)\" class=\"wachat__extended-domain\">{{ extractDomain(item.extendedTextMessage.text) }}</div></div></a><div ng-bind-html=\"checkForUrl(item.textMessage || (item.extendedTextMessage && item.extendedTextMessage.text))\"></div></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'audioMessage\'\"><i ng-if=\"currentAudioId == item.idMessage\" class=\"las la-stop play-wa\" ng-click=\"playWaRecord(item)\"></i> <i ng-if=\"currentAudioId != item.idMessage\" class=\"las la-play play-wa\" ng-click=\"playWaRecord(item)\"></i></div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'imageMessage\' || item.typeMessage == \'videoMessage\'\"><img ng-if=\"item.jpegThumbnail\" ng-src=\"data:image/png;base64,{{item.jpegThumbnail}}\"> {{ item.caption }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'documentMessage\'\"><a ng-href=\"{{ item.downloadUrl }}\" download=\"{{ item.fileName }}\"><i class=\"las la-file play-wa\"></i> {{ item.fileName }}</a><br ng-if=\"item.caption\">{{ item.caption }}</div><div class=\"wachat__comment\" ng-if=\"item.typeMessage == \'quotedMessage\' && item.extendedTextMessage && item.extendedTextMessage.text\"><div class=\"wachat__quoted\" ng-if=\"item.quotedMessage\"></div>{{ item.extendedTextMessage.text }}</div></div></div></div>{{ item.extendedTextMessage.text }}</div><div class=\"wachat__time\">{{ getReadableTime(item.timestamp) }}</div></div></div></div></div><div ng-if=\"wa_history && wa_history.invokeStatus && wa_history.invokeStatus.descr\" class=\"wachat__error\">{{ wa_history.invokeStatus.descr }}</div><div ng-if=\"!wa_history\" class=\"wachat__loader\" ng-class=\"{\'wachat__loader_hidden\': !wa_history}\"><span></span></div></div></div></div><div class=\"reply wachat__reply\" ng-hide=\"!(wa_history && wa_history && !wa_history.invokeStatus)\"><div class=\"reply__field\"><textarea ng-model=\"wa_message\" ng-keydown=\"handleKeyDown($event)\" class=\"reply__textarea\" placeholder=\"{{ \'WACHAT_MESSAGE\' | translate }}\"></textarea></div><div class=\"reply__actions\"><div class=\"wa-papperclip\"><span class=\"upload-input-wrapper\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\" class=\"upload-input\"></span> <i class=\"la la-paperclip\"></i> <span ng-if=\"files && files.length\" class=\"remove\" ng-click=\"clearFiles()\"><i class=\"las la-times\"></i></span></div><button class=\"wa-submit\" ng-click=\"sendWaMessage()\"></button></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers_digital_forms/customers.digital_forms.html","<div class=\"modal-form-inner\"><div class=\"modal-head modal-head-minimizable\"><h3 class=\"form-title\">&nbsp;</h3><a class=\"modal-minimize\" ng-click=\"ctrl.minimize($event)\" title=\"{{\'MODAL_MINIMIZE\' | translate}}\"><i class=\"la la-minus\"></i></a> <a class=\"modal-restore\" ng-click=\"ctrl.restore($event)\" title=\"{{\'MODAL_RESTORE\' | translate}}\"><i class=\"la la-window-restore\"></i></a> <a class=\"close\" ng-click=\"$close(DigitalFormList)\">&times;</a></div><div ng-if=\"DigitalForm.id\" class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{ctrl.business_name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name ? DigitalForm.name : \"&nbsp;\"}}</h2></div><div ng-if=\"DigitalForm.cf_locked\" class=\"df-locked\"><i class=\"las la-lock\"></i>{{\"DIGITAL_FORM_LOCKED_TITLE\" | translate}}</div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\" audio-recorder=\"\" audio-model=\"field.value\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea ng-disabled=\"DigitalForm.cf_locked\" auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\">{{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\"> {{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><app-dropdown model=\"field.value\" options=\"field.items\" value-prop=\"value\" label-prop=\"name\" label=\"{{field.name}}\" placeholder=\"{{field.name}}\" required=\"field.required\" disabled=\"DigitalForm.cf_locked\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"field.other\" class=\"form-group\"><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"date\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"drawing-toolbar\"><div class=\"tool-buttons\"><button type=\"button\" ng-class=\"{ active: field.tool === \'pen\', default: field.tool !== \'pen\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'pen\'\"><i class=\"la la-pencil\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'spray\', default: field.tool !== \'spray\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'spray\'\"><i class=\"la la-spray-can\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'text\', default: field.tool !== \'text\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'text\'\"><i class=\"la la-font\"></i></button></div><div class=\"color-picker\"><div class=\"color-circle\" ng-style=\"{\'background\': field.color}\" ng-click=\"openColorPicker($event, field)\"></div><input type=\"color\" class=\"color-input\" ng-model=\"field.color\"></div><div class=\"size-slider\"><input type=\"range\" min=\"1\" max=\"30\" ng-model=\"field.size\"></div><button class=\"btn icon red\" ng-click=\"clearCanvas(field)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div><div class=\"drawing-canvas-container\"><img ng-src=\"{{field.map}}\"><canvas id=\"mapCanvas{{$index}}\"></canvas></div></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close()\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button ng-if=\"!DigitalForm.cf_locked\" type=\"button\" ng-click=\"ctrl.save()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form><div ng-if=\"!DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"digital_form_list\"><div class=\"digital_form_form\" ng-click=\"ctrl.openForm(form)\" ng-repeat=\"(index, form) in DigitalFormList\">{{form.name}}</div><div class=\"digital_form_form\" ng-click=\"ctrl.newForm()\">{{\"ADD_NEW_CUSTOMER_ORDER_FORM\" | translate}}</div></div></div></div></div></div>");
$templateCache.put("app/modules/customers/modules/customers_digital_forms_add/customers.digital_forms_add.html","<div class=\"modal-form-inner\"><div class=\"modal-head modal-head-minimizable\"><h3 class=\"form-title\">{{DigitalForm ? DigitalForm.name : \"CUSTOMERS_DIGITAL_FORM\" | translate}}</h3><a class=\"modal-minimize\" ng-click=\"ctrl.minimize($event)\" title=\"{{\'MODAL_MINIMIZE\' | translate}}\"><i class=\"la la-minus\"></i></a> <a class=\"modal-restore\" ng-click=\"ctrl.restore($event)\" title=\"{{\'MODAL_RESTORE\' | translate}}\"><i class=\"la la-window-restore\"></i></a> <a class=\"close\" ng-click=\"ctrl.close()\">&times;</a></div><form class=\"modal-form_f\" name=\"formForm\" ng-submit=\"ctrl.chooseForm()\" ng-if=\"!DigitalForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex fill gap-24\"><div ng-if=\"!ctrl.customer_page\" class=\"form-group customer-select-wrapper\"><label><span class=\"required\">*</span> {{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\"><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-disabled=\"ctrl.customer_modal\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.form_id\" options=\"forms\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'CUSTOMERS_DIGITAL_FORM\' | translate}}\" placeholder=\"{{\'CUSTOMERS_FORM\' | translate}}\" fixed-panel=\"true\"></app-dropdown><div ng-messages=\"formForm.message.$error\" class=\"ng-messages\" ng-show=\"documentForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"button\" ng-disabled=\"!ctrl.form.customer_id || !ctrl.form.form_id\" ng-click=\"ctrl.send_to_customer()\" class=\"btn text border-primary large\">{{\"SEND_DIGITAL_FORM\" | translate}}</button> <button type=\"submit\" ng-disabled=\"!ctrl.form.customer_id || !ctrl.form.form_id\" class=\"btn text primary large\">{{\"PLEASE_FILL_FORM\" | translate}}</button></div></form><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data track by $index\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea ng-disabled=\"DigitalForm.cf_locked\" auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\">{{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input ng-disabled=\"DigitalForm.cf_locked\" type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\"> {{item.name}}</label></div></div><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" ng-if=\"field.other\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><app-dropdown model=\"field.value\" options=\"field.items\" value-prop=\"value\" label-prop=\"name\" label=\"{{field.name}}\" placeholder=\"{{field.name}}\" required=\"field.required\" disabled=\"DigitalForm.cf_locked\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"field.other\" class=\"form-group\"><label ng-if=\"field.other && field.other_name\">{{field.other_name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" style=\"margin-top: 15px;\" type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input ng-disabled=\"DigitalForm.cf_locked\" type=\"date\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"drawing-toolbar\"><div class=\"tool-buttons\"><button type=\"button\" ng-class=\"{ active: field.tool === \'pen\', default: field.tool !== \'pen\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'pen\'\"><i class=\"la la-pencil\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'spray\', default: field.tool !== \'spray\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'spray\'\"><i class=\"la la-spray-can\"></i></button> <button type=\"button\" ng-class=\"{ active: field.tool === \'text\', default: field.tool !== \'text\' }\" class=\"btn icon small bordered\" ng-click=\"field.tool = \'text\'\"><i class=\"la la-font\"></i></button></div><div class=\"color-picker\"><div class=\"color-circle\" ng-style=\"{\'background\': field.color}\" ng-click=\"openColorPicker($event, field)\"></div><input type=\"color\" class=\"color-input\" ng-model=\"field.color\"></div><div class=\"size-slider\"><input type=\"range\" min=\"1\" max=\"30\" ng-model=\"field.size\"></div><button class=\"btn icon red\" ng-click=\"clearCanvas(field)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div><div class=\"drawing-canvas-container\"><img ng-src=\"{{field.map}}\"><canvas id=\"mapCanvas{{$index}}\"></canvas></div></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.backForm()\" class=\"btn text border-primary large\">{{\"CUSTOMERS_BACK\" | translate}}</button> <button ng-if=\"!DigitalForm.cf_locked\" type=\"button\" ng-click=\"ctrl.save()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers_digital_forms_print/customers.digital_forms_print.html","<div id=\"print-form\" class=\"modal-form-inner print_one\"><div class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{ctrl.business_name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name ? DigitalForm.name : \"&nbsp;\"}}</h2></div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\' || field.type == \'textarea\'\"><div class=\"form-group\"><label>{{field.name}}</label><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'date\' && field.value\"><div class=\"form-group\"><label>{{field.name}}</label><p>{{field.value | toUnixTimestamp | date: \'dd/MM/yyyy\'}}</p></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\" ng-if=\"item.value == field.value\"><p>{{item.name}}</p><p></p></div></div><p ng-bind-html=\"ctrl.textValueWithBR(field.other_value)\"></p></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\" ng-if=\"item.checked\"><p>{{item.name}}</p><p></p></div></div><p ng-bind-html=\"ctrl.textValueWithBR(field.other_value)\"></p></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label>{{field.name}}</label><p ng-if=\"item.value == field.value\" ng-repeat=\"(i, item) in field.items\">{{item.name}}</p></div><p ng-bind-html=\"ctrl.textValueWithBR(field.other_value)\"></p></div></div><div ng-if=\"field.type == \'comment\'\"><p class=\"text-danger\">{{field.name}}</p></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"drawing-canvas-container\"><img style=\"position: relative\" ng-src=\"{{field.map}}\"> <img class=\"drawed_image\" ng-if=\"field.value\" ng-src=\"{{field.value}}\"></div></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/modules/customers/modules/leads-list/leads.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'customers\')\"><div class=\"cloud\"><div class=\"flex full mb-24 gap-24 gap-24-m-8 leads-list-header\"><button class=\"btn text large primary\" ui-sref=\"app.leads.new_lead\"><i class=\"las la-plus\"></i> {{\"NEW_LEAD\" | translate}}</button><div class=\"form-group icon-prepend last search-input\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_customer()\" ng-model=\"ctrl.customer_name\" class=\"form-control\"></div><div ng-include=\"\'app/components/cfilter/button.html\'\"></div><button class=\"btn icon default green\" ng-class=\"{\'loading\': ctrl.download_in_progress}\" ng-click=\"ctrl.downloadCustomerData()\"><i class=\"las la-file-excel\"></i></button></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><table-column-settings ng-if=\"ctrl.fieldSettings && ctrl.fieldSettings.length > 0\" fields-list=\"ctrl.fieldSettings\" on-update=\"ctrl.onFieldsUpdate(fieldsList)\"></table-column-settings><div class=\"table-responsive\"><div id=\"module-loading\" class=\"ibox-content sk-loading\" ng-if=\"module_is_loading\"><div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></div><table id=\"cust_dt\" ng-table=\"ctrl.tableCustomers\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCustomers\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"></table><div id=\"custom-pagination-container\"><div class=\"dataTables_per-page\"><span>{{\"ENTRIES_PER_PAGE\" | translate}}</span><div class=\"per-page-options\"><label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"20\"><span>20</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"50\"><span>50</span></label> <label><input type=\"radio\" ng-model=\"ctrl.entriesPerPage\" ng-change=\"ctrl.initDtOptions()\" value=\"100\"><span>100</span></label></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/digital_forms/modules/digital-forms-list/digital-forms.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text large primary\" ng-click=\"ctrl.newForm()\"><i class=\"las la-plus\"></i> {{\"CUSTOMER_ADD_FORM\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_items()\" ng-model=\"ctrl.search\" class=\"form-control\"></div></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div>");
$templateCache.put("app/modules/marketing/automations/form/automations.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_AUTOMATION_NEW\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_AUTOMATION_EDIT\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"automationsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"AUTOMATION_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-4 col-xs-12\" ng-class=\"{\'col-xs-10\': ctrl.form.trigger != \'order_status\'}\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.trigger\" options=\"ctrl.triggers\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'AUTOMATION_TRIGGER\' | translate}}\" required=\"true\" fixed-panel=\"true\"></app-dropdown><div ng-messages=\"itemsForm.trigger.$error\" class=\"ng-messages\" ng-show=\"itemsForm.trigger.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"ctrl.form.trigger != \'order_status\' && ctrl.form.trigger != \'birthday\'\" class=\"col-xs-2\"><div ng-include=\"\'app/components/cfilter/button.html\'\"></div></div><div ng-if=\"ctrl.form.trigger == \'order_status\' || ctrl.form.trigger == \'birthday\'\" class=\"col-md-4 col-xs-12\"><div class=\"flex form\"><div ng-if=\"ctrl.form.trigger == \'order_status\'\" class=\"col-sm-9 col-xs-10\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.order_status\" options=\"ctrl.orderStatuses\" value-prop=\"value\" label-prop=\"name\" label=\"{{\'AUTOMATION_TRIGGER_ORDER_STATUS\' | translate}}\" required=\"ctrl.form.trigger == \'order_status\'\" fixed-panel=\"true\"></app-dropdown><div ng-messages=\"itemsForm.order_status.$error\" class=\"ng-messages\" ng-show=\"itemsForm.order_status.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"ctrl.form.trigger == \'birthday\'\" class=\"col-sm-9 col-xs-10\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"AUTOMATION_TRIGGER_BIRTHDAY_TIME\" | translate}}</label> <input type=\"time\" ng-model=\"ctrl.form.birthday_time\" name=\"birthday_time\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.birthday_time.$error\" class=\"ng-messages\" ng-show=\"itemsForm.birthday_time.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-sm-3 col-xs-2\"><div ng-include=\"\'app/components/cfilter/button.html\'\"></div></div></div></div></div><div class=\"form-group\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-6\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.send_message\"> {{\"AUTOMATION_SEND_MESSAGE\" | translate}}</label></div></div><div class=\"col-md-6 col-xs-6\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.active\"> {{\"AUTOMATION_ACTIVE\" | translate}}</label></div></div></div><div class=\"collapse\" ng-class=\"{\'in\': ctrl.form.send_message}\"><div class=\"panel panel-custom\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-check form-group\"><label class=\"form-check-label\" for=\"recommendation\"><input type=\"checkbox\" class=\"form-control\" id=\"recommendation\" ng-model=\"ctrl.form.recommendation\"> {{\"AUTOMATION_RECOMMENDATION\" | translate}}</label></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.digital_form_id\" options=\"ctrl.digitalForms\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'AUTOMATION_DIGITAL_FORM\' | translate}}\" placeholder=\"{{\'AUTOMATION_DIGITAL_FORM\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.notify_type\" options=\"ctrl.notifyTypeOptions\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'AUTOMATION_CUSTOMER_NOTIFY_TYPE\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"with-button with_upload\">{{\"AUTOMATION_CUSTOMER_TEXT\" | translate}}<div class=\"variables-block\"><button type=\"button\" class=\"btn text primary\" ng-click=\"event.stopPropagation(); ctrl.showVariables = !ctrl.showVariables\">{{\"AUTOMATION_VARIABLES\" | translate}}</button><div class=\"variables-list\" ng-if=\"ctrl.showVariables\"><button type=\"button\" class=\"btn text\" ng-click=\"event.stopPropagation(); ctrl.showVariables = !ctrl.showVariables; ctrl.insertVariable(\'customer_name\')\">{{\"AUTOMATION_VARIABLES_CUSTOMER_NAME\" | translate}}</button> <button type=\"button\" class=\"btn text\" ng-click=\"event.stopPropagation(); ctrl.showVariables = !ctrl.showVariables; ctrl.insertVariable(\'businesses_name\')\">{{\"AUTOMATION_VARIABLES_BUSINESS_NAME\" | translate}}</button></div></div></label> <span class=\"upload_file_paperclip\" style=\"margin-top: 15px;\"><input type=\"file\" onchange=\"angular.element(this).scope().uploadFile(this)\"> <i class=\"la la-paperclip\"></i> <span ng-if=\"ctrl.form.files && ctrl.form.files.length\" ng-click=\"event.stopPropagation(); ctrl.form.files = []\" class=\"remove\"><i class=\"las la-times\"></i></span></span> <textarea auto-expand=\"\" class=\"form-control\" style=\"min-height: 70px;\" name=\"notify_text\" ng-model=\"ctrl.form.notify_text\" ng-trim=\"false\"></textarea></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><app-dropdown ng-if=\"ctrl.displayRemindType\" model=\"ctrl.form.remind_type\" options=\"ctrl.remindTypeOptions\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'AUTOMATION_CUSTOMER_REMIND_TYPE\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div ng-if=\"ctrl.form.remind_type != \'now\'\" class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"AUTOMATION_CUSTOMER_REMIND_TIME\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.remind_time\" name=\"remind_time\" class=\"form-control\"></div></div><div ng-if=\"ctrl.form.remind_type != \'now\'\" class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.timetype\" options=\"ctrl.timeTypeOptions\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'AUTOMATION_CUSTOMER_TIMETYPE\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div></div><div class=\"flex gap-24\"><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"once\"><input type=\"checkbox\" class=\"form-control\" id=\"once\" ng-model=\"ctrl.form.once\"> {{\"AUTOMATION_ONCE\" | translate}}</label></div><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"last\"><input type=\"checkbox\" class=\"form-control\" id=\"last\" ng-model=\"ctrl.form.last\"> {{\"AUTOMATION_LAST\" | translate}}</label></div></div></div></div></div></div><div class=\"form-group\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-switch form-group-sm first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.change_customer_status\"> {{\"AUTOMATION_CHANGE_CUSTOMER_STATUS\" | translate}}</label></div></div></div><div class=\"collapse\" ng-class=\"{\'in\': ctrl.form.change_customer_status}\"><div class=\"panel panel-custom\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><app-dropdown model=\"ctrl.form.status_id\" options=\"ctrl.customerStatuses\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'AUTOMATION_CHANGE_CUSTOMER_STATUS_TO\' | translate}}\" placeholder=\"{{\'AUTOMATION_CUSTOMER_STATUS\' | translate}}\" required=\"ctrl.form.change_customer_status\" fixed-panel=\"true\"></app-dropdown></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/medical_notes/modules/medical_notes-form/medical_notes.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_ADD_MEDICAL_NOTE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\"><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-disabled=\"ctrl.customer_modal\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.resource_id\" options=\"ctrl.resourceOptions\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'NOTES_RESOURCE\' | translate}}\" placeholder=\"{{\'NOTES_RESOURCE\' | translate}}\" search-placeholder=\"{{\'NOTES_RESOURCE\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" audio-recorder=\"\" audio-model=\"ctrl.form.text\"><label>{{\"NOTES_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.text\" name=\"text\" class=\"form-control\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"NOTES_REMIND_AT\" | translate}}</label><div class=\"col-xs-12\"><div class=\"flex form nowrap gap-8\"><input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.remind_at_date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\"><app-dropdown model=\"ctrl.form.remind_at_time\" options=\"ctrl.timeOptions\" value-prop=\"value\" label-prop=\"label\" placeholder=\"--:--\" fixed-panel=\"true\"></app-dropdown></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/medical_notes/modules/medical_notes-log/medical_notes.log.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_MEDICAL_NOTE_LOG\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"ctrl.list\" class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"res_dt-medical_notes\" dt-options=\"dtOptions\" datatable=\"ng\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-note-cell\">{{\"NOTES_LOG_DATE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_ACTION\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_USER\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_OLD_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_NEW_RESOURCE\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_OLD_TEXT\" | translate}}</th><th class=\"customer-note-cell\">{{\"NOTES_LOG_NEW_TEXT\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.list\"><td class=\"customer-note-cell\">{{row.created_at | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-note-cell\">{{\"NOTES_LOG_ACTION_\"+row.action.toUpperCase() | translate}}</td><td class=\"customer-note-cell\">{{row.user_name}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_resource_name != row.new_resource_name) ? row.old_resource_name : \'\'}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_resource_name != row.new_resource_name) || row.action == \'create\' || row.action == \'delete\' ? row.new_resource_name : \'\'}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_text != row.new_text) ? row.old_text : \'\'}}</td><td class=\"customer-note-cell\">{{(row.action == \'update\' && row.old_text != row.new_text) || row.action == \'create\' || row.action == \'delete\' ? row.new_text : \'\'}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/notes/modules/notes-form/notes.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMERS_ADD_NOTE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group customer-select-wrapper\"><label>{{\"CALENDAR_ORDER_ASSOCIATE\" | translate}}</label><div class=\"customer-select\"><input type=\"text\" autocomplete=\"off\" ng-change=\"ctrl.find_customer()\" data-placeholder=\"בחר לקוח\" ng-blur=\"ctrl.cleanCustomerSearch()\" ng-model=\"ctrl.customer_search_name\" ng-disabled=\"ctrl.customer_modal\" ng-class=\"{\'red\': !ctrl.form.customer_search_name, \'form-control customer-input\': true}\"><ul id=\"searchResult\" ng-class=\"{\'active\': ctrl.searchCustomerResult && ctrl.searchCustomerResult.length}\"><li ng-click=\"ctrl.chooseCustomer($index,$event)\" ng-repeat=\"customer in ctrl.searchCustomerResult\">{{ customer.firstname }} {{ customer.lastname }} <span class=\"customer-search-notes\" ng-if=\"customer.notes\" title=\"{{customer.notes}}\">{{customer.notes}}</span></li></ul></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.resource_id\" options=\"ctrl.resourceOptions\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" label=\"{{\'NOTES_RESOURCE\' | translate}}\" placeholder=\"{{\'NOTES_RESOURCE\' | translate}}\" search-placeholder=\"{{\'NOTES_RESOURCE\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" audio-recorder=\"\" audio-model=\"ctrl.form.text\"><label>{{\"NOTES_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.text\" name=\"text\" class=\"form-control\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"NOTES_REMIND_AT\" | translate}}</label><div class=\"col-xs-12\"><div class=\"flex form nowrap gap-8\"><input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.remind_at_date\" view=\"date\" min-view=\"date\" auto-close=\"true\" format=\"DD/MM/YYYY\"><app-dropdown model=\"ctrl.form.remind_at_time\" options=\"ctrl.timeOptions\" value-prop=\"value\" label-prop=\"label\" placeholder=\"--:--\" fixed-panel=\"true\"></app-dropdown></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/notes/modules/notes-list/notes.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text large primary\" ng-click=\"ctrl.type == \'notes\' ? ctrl.add_note() : ctrl.add_medical_note()\"><i class=\"las la-plus\"></i> {{ctrl.type == \'notes\' ? \"NEW_NOTE\" : \"NEW_MEDICAL_NOTE\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_items()\" ng-model=\"ctrl.search\" class=\"form-control\"></div><list-filter ng-if=\"ctrl.type == \'notes\'\" module=\"notes\" on-update=\"ctrl.onFilterUpdate(list)\" store=\"true\"></list-filter><list-filter ng-if=\"ctrl.type == \'medical_notes\'\" module=\"medical_notes\" on-update=\"ctrl.onFilterMedicalUpdate(list)\" store=\"true\"></list-filter><div class=\"graph-btn-row btn-group flex-end\"><button ng-click=\"ctrl.change_type(\'notes\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.type == \'notes\'}\">{{\"NOTE_TYPE\" | translate}}</button> <button ng-click=\"ctrl.change_type(\'medical_notes\')\" class=\"btn\" ng-class=\"{\'btn-primary\': ctrl.type == \'medical_notes\'}\">{{\"MEDICAL_NOTE_TYPE\" | translate}}</button></div></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div>");
$templateCache.put("app/modules/notifications/modules/notifications_list/notifications_list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.dashboard\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"NOTIFICATIONS_LIST\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"NOTIFICATIONS_CUSTOMER\" | translate}}</th><th>{{\"NOTIFICATIONS_MESSAGE\" | translate}}</th><th>{{\"NOTIFICATIONS_DATE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><span>{{row.title}}</span></td><td><span>{{row.text}}</span></td><td data-order=\"{{row.created_at}}\"><span>{{row.date}}</span></td><td><button class=\"btn icon circle\" ng-click=\"ctrl.delete(row.id)\"><i class=\"las la-trash-alt\"></i></button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/ai_agents/agent_booking/agent_booking.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} agent-booking-page\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"AI_AGENT_ONLINE_BOOKING\" | translate }}</h3></div><div class=\"ab-card ab-disabled-state\" ng-if=\"!ctrl.isEnabled && ctrl.animationPhase === \'idle\'\"><div class=\"ab-glow-orb ab-orb-1\"></div><div class=\"ab-glow-orb ab-orb-2\"></div><div class=\"ab-glow-orb ab-orb-3\"></div><div class=\"ab-content\"><div class=\"ab-icon-wrap\"><i class=\"las la-robot ab-icon ab-icon-inactive\"></i></div><h2 class=\"ab-title\">{{ \"AI_AGENT_BOOKING_DISABLED_TITLE\" | translate }}</h2><p class=\"ab-description\">{{ \"AI_AGENT_BOOKING_DISABLED_DESCRIPTION\" | translate }}</p><button class=\"ab-enable-btn\" ng-click=\"ctrl.enableAgent()\" ng-disabled=\"ctrl.isActivating\"><span class=\"ab-btn-inner\"><i class=\"las la-sparkles\"></i> {{ \"AI_AGENT_BOOKING_ENABLE_BUTTON\" | translate }}</span></button></div></div><div class=\"ab-card ab-activating\" ng-if=\"ctrl.animationPhase === \'activating\'\"><div class=\"ab-ai-aurora\"><div class=\"ab-aurora-layer ab-aurora-1\"></div><div class=\"ab-aurora-layer ab-aurora-2\"></div><div class=\"ab-aurora-layer ab-aurora-3\"></div></div><div class=\"ab-neural-grid\"></div><div class=\"ab-particles\"><span class=\"ab-particle\" ng-repeat=\"i in [1,2,3,4,5,6,7,8,9,10] track by $index\"></span></div><div class=\"ab-activating-content\"><div class=\"ab-pulse-ring\"><div class=\"ab-pulse-ring-inner\"></div><div class=\"ab-pulse-ring-outer\"></div><i class=\"las la-brain ab-brain-icon\"></i></div><h2 class=\"ab-activating-title\">{{ \"AI_AGENT_ACTIVATING\" | translate }}</h2><p class=\"ab-activating-sub\">{{ \"AI_AGENT_ACTIVATING_SUB\" | translate }}</p><div class=\"ab-progress-bar\"><div class=\"ab-progress-fill\"></div></div></div></div><div class=\"ab-card ab-complete\" ng-if=\"ctrl.animationPhase === \'complete\'\"><div class=\"ab-success-rings\"><div class=\"ab-success-ring r1\"></div><div class=\"ab-success-ring r2\"></div><div class=\"ab-success-ring r3\"></div></div><div class=\"ab-complete-content\"><i class=\"las la-check-circle ab-check-icon\"></i><h2 class=\"ab-complete-title\">{{ \"AI_AGENT_ENABLED_SUCCESS\" | translate }}</h2></div></div><div ng-if=\"ctrl.isEnabled && ctrl.animationPhase === \'idle\'\"><div class=\"ab-tabs\"><app-button variant=\"text\" color=\"{{ ctrl.activeTab === \'settings\' ? \'primary\' : \'default\' }}\" ng-class=\"{ \'active\': ctrl.activeTab === \'settings\' }\" ng-click=\"ctrl.setTab(\'settings\')\">{{ \"AI_AGENT_BOOKING_TAB_SETTINGS\" | translate }}</app-button><app-button variant=\"text\" color=\"{{ ctrl.activeTab === \'history\' ? \'primary\' : \'default\' }}\" ng-class=\"{ \'active\': ctrl.activeTab === \'history\' }\" ng-click=\"ctrl.setTab(\'history\')\">{{ \"AI_AGENT_BOOKING_TAB_HISTORY\" | translate }}</app-button><app-button ng-if=\"ctrl.isTestingEnabled\" variant=\"text\" color=\"{{ ctrl.activeTab === \'testing\' ? \'primary\' : \'default\' }}\" ng-class=\"{ \'active\': ctrl.activeTab === \'testing\' }\" ng-click=\"ctrl.setTab(\'testing\')\">{{ \"AI_AGENT_BOOKING_TAB_TESTING\" | translate }}</app-button></div><div class=\"ab-card ab-enabled-state\" ng-if=\"ctrl.activeTab === \'settings\'\"><div class=\"ab-enabled-header\"><div class=\"ab-status-badge ab-status-active\"><span class=\"ab-status-dot\"></span> {{ \"ACTIVE\" | translate }}</div><button class=\"ab-disable-btn\" ng-click=\"ctrl.disableAgent()\" ng-disabled=\"ctrl.isDeactivating\"><i class=\"las la-power-off\"></i> {{ \"AI_AGENT_BOOKING_DISABLE_BUTTON\" | translate }}</button></div><div class=\"ab-settings-preview\"><div class=\"ab-settings-header\"><div><h3 class=\"ab-settings-title\">{{ \"AI_AGENT_BOOKING_SETTINGS_TITLE\" | translate }}</h3><p class=\"ab-settings-desc\">{{ \"AI_AGENT_BOOKING_SETTINGS_DESC\" | translate }}</p></div><span class=\"ab-settings-saving\" ng-if=\"ctrl.isSavingSettings\">{{ \"SAVING\" | translate }}...</span></div><div class=\"ab-settings-grid\"><div class=\"ab-setting-group\" ng-repeat=\"item in ctrl.visibleSettingsConfig track by item.key\"><div class=\"ab-setting-label-row\" ng-if=\"item.key !== \'general_info\' && item.type !== \'customer_restrictions_block\'\"><label class=\"ab-setting-label\">{{ item.labelKey | translate }}</label> <i class=\"las la-info-circle ab-setting-hint\" tooltip2=\"{{ item.hintKey | translate }}\"></i></div><div class=\"ab-radio-group\" ng-if=\"item.type !== \'checkboxes\' && item.type !== \'textarea\' && item.type !== \'text\' && item.type !== \'customer_restrictions_block\'\"><label class=\"ab-radio-option\" ng-repeat=\"opt in item.options\"><input type=\"radio\" name=\"ab_radio_{{ item.key }}\" ng-model=\"ctrl.settings[item.key]\" ng-value=\"opt.value\" ng-change=\"ctrl.onSettingChange(item.key)\"> <span class=\"ab-radio-label\">{{ opt.labelKey | translate }}</span> <i class=\"las la-info-circle ab-radio-hint\" tooltip2=\"{{ opt.descKey | translate }}\" tooltip2-size=\"medium\"></i></label></div><div class=\"ab-customer-restrictions-statuses\" ng-if=\"item.key === \'non_online_service_request_behavior\' && ctrl.settings[item.key] === \'offer_allowed_services_dropdown\'\"><div class=\"ab-setting-label-row ab-setting-label-row--inner\"><label class=\"ab-setting-label\">{{ \'AI_AGENT_AB_NON_ONLINE_SERVICE_ALLOWED_DROPDOWN_LABEL\' | translate }}</label> <i class=\"las la-info-circle ab-setting-hint\" tooltip2=\"{{ \'AI_AGENT_AB_NON_ONLINE_SERVICE_ALLOWED_DROPDOWN_HINT\' | translate }}\"></i></div><app-dropdown model=\"ctrl.settings.non_online_service_offer_service_id\" options=\"ctrl.allowedOnlineServiceOptions\" searchable=\"true\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{ \'AI_AGENT_AB_NON_ONLINE_SERVICE_ALLOWED_DROPDOWN_LABEL\' | translate }}\" search-placeholder=\"{{ \'SEARCH\' | translate }}\" on-change=\"ctrl.onSettingChange(\'non_online_service_offer_service_id\')\"></app-dropdown></div><app-input ng-if=\"item.type === \'text\'\" model=\"ctrl.settings[item.key]\" type=\"text\" name=\"{{ item.key }}\" on-change=\"ctrl.onSettingChange(item.key)\"></app-input><div class=\"ab-customer-restrictions-block\" ng-if=\"item.type === \'customer_restrictions_block\'\"><div class=\"ab-setting-label-row\"><label class=\"ab-setting-label\">{{ item.labelKey | translate }}</label> <i class=\"las la-info-circle ab-setting-hint\" tooltip2=\"{{ item.hintKey | translate }}\"></i></div><div class=\"ab-checkbox-group\"><label class=\"ab-schedule-day-label\"><input type=\"checkbox\" class=\"ab-schedule-checkbox\" ng-model=\"ctrl.settings.dont_allow_new_customers\" ng-change=\"ctrl.onSettingChange()\"> <span class=\"ab-schedule-day-name\">{{ \'AI_AGENT_AB_DONT_ALLOW_NEW_CUSTOMERS\' | translate }}</span> <i class=\"las la-info-circle ab-radio-hint\" tooltip2=\"{{ \'AI_AGENT_AB_DONT_ALLOW_NEW_CUSTOMERS_HINT\' | translate }}\" tooltip2-size=\"medium\"></i></label></div><div class=\"ab-customer-restrictions-statuses\"><div class=\"ab-setting-label-row ab-setting-label-row--inner\"><label class=\"ab-setting-label\">{{ \'AI_AGENT_AB_DONT_ALLOW_STATUSES\' | translate }}</label> <i class=\"las la-info-circle ab-setting-hint\" tooltip2=\"{{ \'AI_AGENT_AB_DONT_ALLOW_STATUSES_HINT\' | translate }}\"></i></div><app-dropdown model=\"ctrl.settings.dont_allow_status_ids\" options=\"ctrl.customerStatusOptions\" multiple=\"true\" searchable=\"true\" value-prop=\"id\" fixed-panel=\"true\" color-prop=\"color\" visible-tags-count=\"1\" placeholder=\"{{ \'AI_AGENT_AB_DONT_ALLOW_STATUSES\' | translate }}\" search-placeholder=\"{{ \'SEARCH\' | translate }}\" on-change=\"ctrl.onSettingChange()\"></app-dropdown></div></div><div class=\"ab-checkbox-group\" ng-if=\"item.type === \'checkboxes\'\"><label class=\"ab-schedule-day-label\" ng-repeat=\"opt in item.options\"><input type=\"checkbox\" class=\"ab-schedule-checkbox\" ng-model=\"ctrl.settings[item.key][opt.value]\" ng-change=\"ctrl.onSettingChange(item.key)\"> <span class=\"ab-schedule-day-name\">{{ opt.labelKey | translate }}</span> <i class=\"las la-info-circle ab-radio-hint\" tooltip2=\"{{ opt.descKey | translate }}\" tooltip2-size=\"medium\"></i></label></div><div class=\"ab-textarea-group\" ng-if=\"item.type === \'textarea\'\"><div class=\"ab-combined-field\" ng-if=\"item.key === \'general_info\'\"><div class=\"ab-setting-label-row ab-setting-label-row--inner\"><label class=\"ab-setting-label\">{{ \'AI_AGENT_AB_AGENT_NAME\' | translate }}</label> <i class=\"las la-info-circle ab-setting-hint\" tooltip2=\"{{ \'AI_AGENT_AB_AGENT_NAME_HINT\' | translate }}\"></i></div><app-input model=\"ctrl.settings.agent_name\" type=\"text\" name=\"agent_name\" maxlength=\"60\" on-change=\"ctrl.onSettingChange(\'agent_name\')\"></app-input></div><div class=\"ab-setting-label-row ab-setting-label-row--inner\" ng-if=\"item.key === \'general_info\'\"><label class=\"ab-setting-label\">{{ item.labelKey | translate }}</label> <i class=\"las la-info-circle ab-setting-hint\" tooltip2=\"{{ item.hintKey | translate }}\"></i></div><textarea ng-model=\"ctrl.settings[item.key]\" name=\"{{ item.key }}\" class=\"form-control\" ng-attr-maxlength=\"{{ item.maxLength }}\" style=\"min-height: 92px; resize: vertical;\" auto-expand=\"\" ng-change=\"ctrl.onSettingChange(item.key)\"></textarea></div><div class=\"ab-schedule-panel\" ng-if=\"item.hasSchedule && ctrl.settings[item.key] === \'custom\'\"><div class=\"ab-schedule-row ab-schedule-row--wrap\" ng-repeat=\"day in item.weekdays track by day.key\" ng-class=\"{ \'ab-schedule-row--off\': !ctrl.settings.availability_schedule[day.key].enabled }\"><label class=\"ab-schedule-day-label\"><input type=\"checkbox\" class=\"ab-schedule-checkbox\" ng-model=\"ctrl.settings.availability_schedule[day.key].enabled\" ng-change=\"ctrl.onScheduleChange()\"> <span class=\"ab-schedule-day-name\">{{ day.labelKey | translate }}</span></label><div class=\"ab-schedule-times\"><input type=\"time\" class=\"ab-schedule-time-input\" ng-model=\"ctrl.settings.availability_schedule[day.key].from\" ng-change=\"ctrl.onScheduleChange()\" ng-disabled=\"!ctrl.settings.availability_schedule[day.key].enabled\"> <span class=\"ab-schedule-sep\">—</span> <input type=\"time\" class=\"ab-schedule-time-input\" ng-model=\"ctrl.settings.availability_schedule[day.key].to\" ng-change=\"ctrl.onScheduleChange()\" ng-disabled=\"!ctrl.settings.availability_schedule[day.key].enabled\"></div></div></div></div></div><div class=\"ab-settings-actions\"><button type=\"button\" class=\"ab-save-btn\" ng-click=\"ctrl.saveSettings()\" ng-disabled=\"ctrl.isSavingSettings || !ctrl.hasUnsavedChanges\"><i class=\"las la-save\"></i> {{ \"SAVE\" | translate }}</button></div></div></div><div ng-if=\"ctrl.activeTab === \'history\'\" class=\"ab-history-wrap\"><div class=\"ab-settings-header\"><div class=\"dark\"><h3 class=\"ab-settings-title dark\">{{ \"AI_AGENT_BOOKING_TAB_HISTORY\" | translate }}</h3><p class=\"ab-settings-desc\">{{ \"AI_AGENT_BOOKING_HISTORY_DESC\" | translate }}</p></div><div class=\"form-group icon-prepend last ab-history-search\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.reloadHistory()\" ng-model=\"ctrl.historySearch\" class=\"form-control\"></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"ab_history_dt\" datatable=\"\" dt-options=\"historyDtOptions\" dt-columns=\"ctrl.historyDtColumns\" dt-instance=\"ctrl.historyDtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div><div ng-if=\"ctrl.activeTab === \'testing\'\" class=\"ab-history-wrap\"><div class=\"ab-history-chat-body ab-testing-chat-body\"><div ng-if=\"!ctrl.testingMessages.length\" class=\"ab-history-empty\">{{ \"AI_AGENT_BOOKING_HISTORY_EMPTY\" | translate }}</div><div class=\"ab-history-message\" ng-repeat=\"msg in ctrl.testingMessages track by $index\" ng-class=\"{ \'ab-history-message--assistant\': (msg.role || \'assistant\') === \'assistant\', \'ab-history-message--user\': msg.role === \'user\' }\"><div class=\"ab-history-message-role\">{{ (\"AI_AGENT_BOOKING_HISTORY_ROLE_\" + (msg.role || \'assistant\')) | uppercase | translate }}</div><div class=\"ab-history-message-text\">{{ msg.content || \'\' }}</div></div><div class=\"wachat__loader\" ng-class=\"{\'wachat__loader_hidden\': !ctrl.testingLoading}\"><span></span></div></div><div class=\"ab-testing-controls-wrap\"><div class=\"ab-testing-controls\"><div class=\"form-group icon-prepend last\"><i class=\"las la-phone\"></i> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.testingPhone\" placeholder=\"0501234567\" ng-disabled=\"ctrl.testingLoading\"></div><app-button variant=\"text\" color=\"primary\" ng-click=\"ctrl.startNewTestingSession()\" ng-disabled=\"ctrl.testingLoading\">{{ \"AI_AGENT_BOOKING_NEW_SESSION\" | translate }}</app-button></div><div class=\"reply wachat__reply ab-testing-reply\"><div class=\"reply__field\"><textarea ng-model=\"ctrl.testingMessage\" ng-keydown=\"ctrl.handleTestingKeyDown($event)\" class=\"reply__textarea\" placeholder=\"{{ \'WACHAT_MESSAGE\' | translate }}\" ng-disabled=\"(ctrl.testingLoading && !ctrl.testingSessionId)\"></textarea></div><div class=\"reply__actions\"><button type=\"button\" class=\"wa-submit\" ng-click=\"ctrl.sendTestingMessage()\" ng-disabled=\"(ctrl.testingLoading && !ctrl.testingSessionId) || !ctrl.testingPhone || !ctrl.testingMessage\"></button></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/ai_agents/agent_booking/agent_booking_history.view.html","<div class=\"modal-form-inner tabs-form\" id=\"agent-booking-history-modal\"><div class=\"modal-head\"><h3 class=\"form-title\">{{ \"AI_AGENT_BOOKING_HISTORY_MESSAGES_TITLE\" | translate }}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body ab-history-chat-body\"><div ng-if=\"ctrl.loading\" class=\"ab-history-loading\">{{ \"LOADING\" | translate }}...</div><div ng-if=\"!ctrl.loading && !ctrl.messages.length\" class=\"ab-history-empty\">{{ \"AI_AGENT_BOOKING_HISTORY_EMPTY\" | translate }}</div><div class=\"ab-history-message\" ng-repeat=\"msg in ctrl.messages track by $index\" ng-class=\"{ \'ab-history-message--assistant\': (msg.role || \'assistant\') === \'assistant\', \'ab-history-message--user\': msg.role === \'user\' }\"><div class=\"ab-history-message-role\">{{ (\"AI_AGENT_BOOKING_HISTORY_ROLE_\" + (msg.role || \'assistant\')) | uppercase | translate }}</div><div class=\"ab-history-message-text\">{{ msg.content || msg.text || msg.message || \'\' }}</div></div></div><div class=\"modal-footer end top-padding\"><app-button type=\"button\" color=\"border-primary\" ng-click=\"$close();\" ng-disabled=\"ctrl.loading\"><span ng-if=\"ctrl.loading\"><i class=\"las la-spinner la-spin\"></i> {{ \"LOADING\" | translate }}...</span> <span ng-if=\"!ctrl.loading\">{{ \"CLOSE\" | translate }}</span></app-button></div></div>");
$templateCache.put("app/modules/settings/gift_cards/popup/balance.view.html","<div class=\"modal-form-inner tabs-form\" id=\"gift-card-balance\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GIFT_CARD_CHANGE_BALANCE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"details-gc-column\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_BALANCE\" | translate }}</p><input type=\"number\" min=\"0\" step=\"0.01\" autocomplete=\"off\" ng-model=\"ctrl.giftCard.balance\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer end\"><div class=\"modal-footer-buttons\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"GIFT_CARD_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.save()\">{{\"GIFT_CARD_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/popup/details.view.html","<div class=\"modal-form-inner tabs-form\" id=\"gift-card-details\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GIFT_CARD_DETAILS\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"details-gc-column\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_NAME\" | translate }}</p><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.values.name\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div><div class=\"details-gc-row\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_GIFTED_TO\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.receiver}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.receiver\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.values.receiver\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_SENDER\" | translate }} ({{ \"GIFT_CARD_GIFTED_BY\" | translate }})</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.sender}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.sender\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.values.sender\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div></div><div class=\"details-gc-row\"><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_SERVICE\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.service}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.service\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" readonly=\"\" ng-model=\"ctrl.values.service\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_VALUE\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.value}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.value\" ng-change=\"ctrl.bumpSettings()\"></label></div><input type=\"text\" autocomplete=\"off\" readonly=\"\" ng-model=\"ctrl.values.value\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></div></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_MESSAGE\" | translate }}</p><div class=\"details-gc-input\" ng-class=\"{\'inactive\': !ctrl.localSettings.message}\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-model=\"ctrl.localSettings.message\" ng-change=\"ctrl.bumpSettings()\"></label></div><textarea ng-model=\"ctrl.values.message\" class=\"form-control\" ng-change=\"ctrl.bumpValues()\"></textarea></div></div><div class=\"details-gc-cell\"><p>{{ \"GIFT_CARD_TEMPLATES\" | translate }}</p><div class=\"details-gc-templates\"><div ng-repeat=\"(index, template) in ctrl.templates\" class=\"details-gc-templates-item\" ng-click=\"ctrl.selectTemplate(index)\"><div class=\"details-gc-preview\" ng-style=\"{\'background-color\': template.page_bg_color}\"><gift-card settings=\"ctrl.selectedTemplate == index ? ctrl.localSettings : template\" values=\"ctrl.values\" size=\"small\" view=\"mobile\" zoom-on-hover=\"::true\"></gift-card></div><div class=\"details-gc-name\"><p>&nbsp;{{ template.name }}&nbsp;</p></div><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"radio\" name=\"template\" class=\"form-check-input\" ng-value=\"index\" ng-model=\"ctrl.selectedTemplate\"></label></div></div></div></div></div></div></div><div class=\"modal-footer between\"><div class=\"details-gc-info\"><p>{{ \"GIFT_CARD_PRICE\" | translate }}</p><span>₪{{ctrl.values.value}}</span></div><div class=\"modal-footer-buttons\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"GIFT_CARD_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.save()\">{{\"GIFT_CARD_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/popup/select.view.html","<div class=\"modal-form-inner tabs-form\" id=\"gift-card-details\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"GIFT_CARD_SELECT\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div ng-if=\"ctrl.giftCards.length\" class=\"panel-body\"><div class=\"flex gap-24 gap-24-m-8 mb-24\"><div class=\"form-group last icon-prepend\"><i class=\"las la-search\"></i> <input id=\"giftCardSearch\" type=\"text\" ng-model=\"ctrl.search\" class=\"form-control\" placeholder=\'{{\"GIFT_CARD_SEARCH\" | translate}}\'></div></div><table ng-if=\"ctrl.tableData.length\" class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"GIFT_CARD_NUMBER\" | translate}}</th><th>{{\"GIFT_CARD_NAME\" | translate}}</th><th>{{\"GIFT_CARD_PRICE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE\" | translate}}</th></tr></thead><tbody ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.giftCardToggle(row)\"><td width=\"1%\"><div class=\"form-check details-gc-radio\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" ng-checked=\"ctrl.isSelected(row)\"></label></div></td><td>{{row.number}}</td><td>{{row.name}}</td><td>₪{{row.price}}</td><td>₪{{row.balance}}</td></tr></tbody></table><div ng-if=\"!ctrl.tableData.length\"><h3>{{\"GIFT_CARD_SEARCH_EMPTY\" | translate}}</h3></div></div><div ng-if=\"!ctrl.giftCards.length\" class=\"panel-body\"><div class=\"flex gap-24 gap-24-m-8 mb-24\"><h3>{{\"GIFT_CARD_LIST_EMPTY\" | translate}}</h3></div></div></div><div class=\"modal-footer end\"><div class=\"modal-footer-buttons\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"GIFT_CARD_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.confirm()\">{{\"GIFT_CARD_CONFIRM\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/items/popup/items.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_ORDER_ITEM_ASSOCIATE2\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'ITEM_ENTER_NAME\' | translate}}\" ng-change=\"find_item()\" ng-model=\"ctrl.item_name\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.items\"><table datatable=\"\" dt-options=\"dtOptions\" id=\"items_dt\" class=\"table table-striped table-bordered table-hover dataTables-example customers-table\"><thead><tr><th>{{\"CUSTOMERS_NAME\" | translate}}</th><th class=\"item-price\">{{\"CUSTOMER_ORDER_HISTORY_PRICE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectCustomer($index)\" ng-repeat=\"row in ctrl.items\"><td><div class=\"bg-div\" style=\"background-color: {{row.bg_color}};\"></div><div ng-if=\"row.item_image\" class=\"item-pic-wrapper\"><img src=\"{{row.item_image}}\" alt=\"Image\" class=\"item-pic\"></div>{{row.name}} <i class=\"las la-ticket-alt\" aria-hidden=\"true\" title=\'{{\"CARD_ITEM_MATCH_DESCRIPTION\" | translate}}\' ng-if=\"row.customer_has_card\"></i></td><td class=\"item-price\">{{row.price}}<i class=\"fa fa-ils\" aria-hidden=\"true\"></i></td><td></td></tr></tbody></table></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/settings/items/stock/items.stock.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ITEM_STOCK_CHANGE_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"editForm\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_STOCK_AMOUNT\" | translate}}</label><div class=\"item-inputs\"><input-number-spinner data-ng-model=\"ctrl.form.amount_changed\" data-input-number-spinner-required=\"true\"></input-number-spinner></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_STOCK_COST\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.cost\" name=\"cost\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-12\"><div class=\"form-group\"><label>{{\"ITEM_STOCK_COMMENT\" | translate}}</label> <textarea class=\"form-control\" ng-model=\"ctrl.form.comment\" placeholder=\"\"></textarea></div></div></div><div class=\"flex form\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_CURRENT_STOCK\" | translate}}: {{ ctrl.item.stock }}</label></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"ITEM_RESULT_STOCK\" | translate}}: {{ ((ctrl.item.stock*1) + ctrl.form.amount_changed)}}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid\" ng-click=\"ctrl.saveForm()\" class=\"btn text primary large\">{{\"ITEM_CHANGE_STOCK_SAVE_BTN\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/items/stock_log/items.stock_log.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.items.edit({id: {{ctrl.item.id}}})\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{\"ITEMS_TRANSACTIONS_LABEL\" | translate}}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.transactions\" id=\"logs_dt\" datatable=\"ng\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover customers-table\"><thead><tr><th class=\"\">{{\"ITEM_TRANSACTION_DATE\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_CHANGE_AMOUNT\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_AMOUNT_AFTER\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_ORDER_ID\" | translate}}</th><th class=\"\">{{\"ITEM_STOCK_COST\" | translate}}</th><th class=\"\">{{\"ITEM_TRANSACTION_COMMENTS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.transactions\"><td class=\"\"><span ng-hide=\"true\">{{row.date_created | toUnixTimestamp }}</span> {{row.date_created | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"\"><span ng-if=\"row.amount_changed > 0\">+</span>{{row.amount_changed}}</td><td class=\"\">{{row.amount_result}}</td><td><button ng-if=\"row.transaction_id\" ng-click=\"ctrl.open_log_card(row.transaction_id)\" class=\"btn text primary large\">{{\"ITEM_TRANSACTION_SHOW_INVOICE\" | translate}}</button></td><td class=\"\">{{row.cost}}</td><td class=\"\">{{row.comment | emptyValue}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/laser_file/list/laser_file.list.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LASER_INFO_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div ng-repeat=\"(index, field) in ctrl.list\" class=\"laser-value-list-field\"><div class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"text\" ng-model=\"field.name\" name=\"{{field.id}}\" class=\"form-control\"> <button ng-click=\"ctrl.remove_value(index);\" class=\"btn icon red\"><i class=\"las la-trash-alt\"></i></button></div></div><button type=\"button\" ng-click=\"ctrl.add_value();\" ng-disabled=\"false\" class=\"btn text border-primary\">{{\"LASER_FILE_ADD_VALUE\" | translate}}</button></div><div class=\"modal-footer end\"><button type=\"submit\" ng-click=\"$close(ctrl.list);\" ng-disabled=\"false\" class=\"btn text primary large\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/modules/settings/laser_file/map/laser_file.map.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LASER_MAP\" | translate}}</h3><a class=\"close\" ng-click=\"ctrl.save(); $close(ctrl);\">&times;</a></div><div class=\"modal-body\"><div class=\"laser-map\"><canvas id=\"can\"></canvas></div></div><div class=\"modal-footer between\"><div class=\"form-switch form-group\" ng-if=\"!ctrl.field.image\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_image()\" ng-model=\"ctrl.men\">{{\"LASER_FILE_MAP_MEN\" | translate}}</label></div><div class=\"flex gap-16\"><button type=\"button\" ng-click=\"ctrl.erase()\" class=\"btn text border-red large\">{{\"LASER_FILE_MAP_CLEAR\" | translate}}</button> <button type=\"submit\" ng-click=\"ctrl.save(); $close(ctrl);\" ng-disabled=\"false\" class=\"btn text primary large\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/laser_file/popup/laser_file.popup.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CALENDAR_ORDER_LASER_FILE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><div class=\"empty-section\" id=\"drop-area\" ng-if=\"ctrl.form.length == 0\"><i class=\"las la-file\"></i><h5 class=\"empty-section-title\">{{\"CUSTOMERS_NO_LASER_FILES\" | translate}}</h5><p class=\"empty-section-desc\">{{\"CUSTOMERS_NO_LASER_FILES_SENTENCE\" | translate}}</p><button type=\"submit\" ng-click=\"ctrl.add_line();\" ng-disabled=\"false\" class=\"btn text primary\">{{\"LASER_FILE_ADD\" | translate}}</button></div><div ng-if=\"ctrl.form.length\"><div class=\"flex form gap-16 mb-16\"><div><div class=\"btn-group\"><button ng-repeat=\"category in ctrl.laser_categories\" class=\"btn\" ng-click=\"ctrl.laser_category = category.id\" ng-class=\"{\'btn-primary\': ctrl.laser_category == category.id, \'btn-default\': ctrl.laser_category != category.id}\">{{category.name | translate}}</button></div></div></div><div class=\"laser-values\"><table><tr><th class=\"min\"></th><th ng-repeat=\"field in ctrl.fields\" ng-if=\"field.category_id == ctrl.laser_category\" class=\"laser-value-column\"><p>{{field.name}}</p></th><th class=\"min\"></th></tr><tr ng-repeat=\"(index, form) in ctrl.form\" ng-if=\"!form.remove && form.category_id == ctrl.laser_category && (form.show || form.first)\"><td class=\"min\" width=\"1%\"><button ng-if=\"form.order_id && form.first && ctrl.orders[form.order_id] == \'closed\' && ctrl.orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form);\" class=\"btn icon bordered\"><i class=\"las la-angle-down\"></i></button> <button ng-if=\"form.order_id && form.first && ctrl.orders[form.order_id] == \'opened\' && ctrl.orders_count[form.order_id] > 1\" ng-click=\"ctrl.display_laser_orders(form, true);\" class=\"btn icon bordered\"><i class=\"las la-angle-up\"></i></button></td><td ng-repeat=\"field in ctrl.fields\" ng-if=\"field.category_id == ctrl.laser_category\" ng-class=\"{\'min\': field.type == \'map\', \'laser-value-column\': true}\"><div ng-if=\"field.type == \'text\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"text\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control\"></div><div ng-if=\"field.type == \'date\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"date\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control\"></div><div ng-if=\"field.type == \'datetime\'\" class=\"form-group\"><input placeholder=\"{{field.name}}\" type=\"datetime-local\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" class=\"form-control small\"></div><div ng-if=\"field.type == \'textarea\'\" class=\"form-group\"><textarea placeholder=\"{{field.name}}\" ng-model=\"form[field.id]\" name=\"{{field.id}}\" auto-expand=\"\" class=\"form-control small\"></textarea></div><div ng-if=\"field.type == \'list\'\" class=\"form-group\"><app-dropdown model=\"form[field.id]\" options=\"field.list\" value-prop=\"id\" label-prop=\"name\" placeholder=\"{{field.name}}\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"field.type == \'map\'\" class=\"form-group\"><button ng-click=\"ctrl.laser_map(index, field);\" class=\"btn text border-primary laser-map-setup\">{{\"LASER_FILE_MAP_BUTTON\" | translate}}</button></div></td><td class=\"min\" width=\"1%\"><button ng-click=\"ctrl.remove_line(index);\" class=\"btn btn-nostyle\"><span class=\"btn-minus inline-icon-btn medium\"><i class=\"las la-trash-alt\"></i></span></button></td></tr></table></div></div></div><div class=\"modal-footer end\"><button type=\"submit\" ng-click=\"ctrl.add_line();\" class=\"btn text primary large\">{{\"LASER_FILE_ADD\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"LASER_FILE_CANCEL\" | translate}}</button> <button type=\"submit\" ng-click=\"ctrl.submit();\" ng-disabled=\"false\" class=\"btn text primary large\">{{\"LASER_FILE_SEND\" | translate}}</button></div></div>");
$templateCache.put("app/modules/settings/laser_file/popup_field/laser_file.popup_field.html","<div class=\"modal-form-inner tabs-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LASER_FIELD_ADD_TITLE\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"fieldForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_LASER_FIELD_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"fieldForm.name.$error\" class=\"ng-messages\" ng-show=\"fieldForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.type\" options=\"ctrl.fieldTypeOptions\" value-prop=\"value\" label-prop=\"name\" label=\"{{\'SETTINGS_LASER_FIELD_TYPE\' | translate}}\" placeholder=\"{{\'SETTINGS_LASER_FIELD_TYPE\' | translate}}\" required=\"true\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-12 col-xs-12\" ng-if=\"ctrl.form.type == \'map\'\"><div class=\"order-images-col\"><p>{{\"SETTINGS_LASER_FIELD_TYPE_PICTURE\" | translate}}</p><div class=\"flex column\"><label ng-class=\"{\'import-image\': true, \'w-image\': !ctrl.form.image || ctrl.form.image == \'\', \'first\': true}\"><input ng-if=\"!ctrl.form.image || ctrl.form.image == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image\" type=\"file\" accept=\"image/*\" ng-disabled=\"false\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.image && ctrl.form.image != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, ctrl.form.image);\"><img ng-src=\"{{ctrl.form.image}}\"></div><span class=\"filename\">{{ctrl.form.image.substring(ctrl.form.image.lastIndexOf(\'/\') + 1)}}</span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!ctrl.form.image || ctrl.form.image == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"fieldForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/workers/modules/workers-form/workers.form.html","<div class=\"modal-form-inner tabs-form\" id=\"workers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ng-click=\"$close();\" ng-if=\"isModal\"><i class=\"las la-angle-right rotatable\"></i></a> <a class=\"btn icon default\" ui-sref=\"^.\" ng-if=\"!isModal\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"WORKERS_ADD_NEW\" | translate}}</h3></div></div><form class=\"modal-form\" name=\"workersForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"flex form\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_FIRST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_firstname\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_LAST_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_lastname\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_PASSWORD\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.emp_password\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group date-control last\"><label>{{\"WORKERS_BIRTHDAY\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_year\" options=\"ctrl.yearOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_YEAR\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_month\" options=\"ctrl.monthOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_MONTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.birthdate_day\" options=\"ctrl.dayOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_DAY\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_GENDER\" | translate}}</label><br><div class=\"radio-btn\"><input ng-model=\"ctrl.form.emp_gender\" type=\"radio\" name=\"emp_gender\" value=\"0\"> <label>{{\"WORKERS_GENDER_MALE\" | translate}}</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.form.emp_gender\" type=\"radio\" name=\"emp_gender\" value=\"1\"> <label>{{\"WORKERS_GENDER_FEMALE\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group date-control last\"><label>{{\"WORKERS_START_JOB\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.startjob_year\" options=\"ctrl.yearOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_YEAR\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.startjob_month\" options=\"ctrl.monthOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_MONTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.startjob_day\" options=\"ctrl.dayOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_DAY\' | translate}}\"></app-dropdown></div></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group date-control last\"><label>{{\"WORKERS_END_JOB\" | translate}}</label><div class=\"form flex\"><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.endjob_year\" options=\"ctrl.yearOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_YEAR\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.endjob_month\" options=\"ctrl.monthOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_MONTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.endjob_day\" options=\"ctrl.dayOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'WORKERS_DAY\' | translate}}\"></app-dropdown></div></div></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_PHONE\" | translate}}</label> <input type=\"tel\" ng-model=\"ctrl.form.emp_mobilephone\" placeholder=\"053-423-1367\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_ADRESS\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_adress\" name=\"emp_adress\" class=\"form-control\"></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"CUSTOMERS_CITY\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_city\" name=\"emp_city\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"WORKERS_ROLE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.emp_role\" name=\"emp_role\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\" ng-if=\"!isModal\">{{\"WORKERS_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\" ng-if=\"isModal\">{{\"WORKERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"workersForm.$invalid || workersForm.$pristine\" class=\"btn text primary large\">{{\"WORKERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/workers/modules/workers-list/workers.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"isUserAllowedAccess(\'workers\')\"><div class=\"cloud\"><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text large primary\" ui-sref=\"app.workers.new\"><i class=\"las la-plus\"></i> {{\"NEW_WORKER\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"find_worker()\" ng-model=\"ctrl.worker_name\" class=\"form-control\"></div></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_deleted()\" ng-model=\"ctrl.show_deleted\">{{\"SHOW_DELETED\" | translate}}</label></div></div><div class=\"ibox\"><div class=\"customer-ibox-content\"><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"cust_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div>");
$templateCache.put("app/modules/workers/modules/workers-single/workers.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}} single-model-page\" id=\"worker\" ng-if=\"worker != null\"><div class=\"row-fluid clearfix\"><div class=\"cloud mb-24 col-xs-12 single-model-details border-top border-bottom border-right border-left\"><div class=\"single-model-head\"><div class=\"flex gap-24 gap-24-m-8 nowrap\"><button class=\"btn icon default\" ui-sref=\"^.\"><i class=\"las la-angle-right rotatable\"></i></button><h3 class=\"main-title single-model-name\">{{worker.emp_firstname}} {{worker.emp_lastname}}</h3></div><div class=\"btn-actions\"><button class=\"btn icon circle large single-model-edit\" ui-sref=\"app.workers.single.edit({id: {{worker.id}}})\"><i class=\"las la-edit\"></i></button> <button tooltip=\'{{\"WORKERS_DELETE\" | translate}}\' ng-click=\"ctrl.delete();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"worker.emp_status != 0\"><i class=\"las la-trash-alt\"></i></button> <button tooltip=\'{{\"CUSTOMERS_RECOVER\" | translate}}\' ng-click=\"ctrl.recover();\" class=\"have-tooltip btn icon circle large single-model-delete\" ng-if=\"worker.emp_status == 0\"><i class=\"las la-trash-restore-alt\"></i></button></div></div><div class=\"single-model-info\"><div class=\"col-md-12 collapsed-mobile\"><h4 class=\"info-title\">{{\"WORKERS_GENERAL\" | translate}}<button class=\"btn icon simple visible-xs\" ng-click=\"ctrl.info_1 = !ctrl.info_1\"><i class=\"las\" ng-class=\"{\'la-angle-down\': !ctrl.info_1, \'la-angle-up\': ctrl.info_1}\"></i></button></h4><div class=\"dl\" ng-class=\"{\'active\': ctrl.info_1}\"><div><div class=\"info-label\">{{\"WORKERS_GENDER\" | translate}}</div><div class=\"info-value\">{{worker.emp_gender | gender | emptyValue }}</div></div><div><div class=\"info-label\">{{\"WORKERS_PHONE\" | translate}}</div><div class=\"info-value\">{{worker.emp_mobilephone | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_BIRTHDAY\" | translate}}</div><div class=\"info-value\">{{worker.emp_birthdate | date: \'dd/MM/yyyy\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_JOB_START\" | translate}}</div><div class=\"info-value\">{{worker.emp_jobstartdate| date: \'dd/MM/yyyy\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_JOB_END\" | translate}}</div><div class=\"info-value\">{{worker.emp_jobenddate | date: \'dd/MM/yyyy\' | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_ROLE\" | translate}}</div><div class=\"info-value\">{{worker.emp_role | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_ADRESS\" | translate}}</div><div class=\"info-value\">{{worker.emp_adress | emptyValue}}</div></div><div><div class=\"info-label\">{{\"WORKERS_CITY\" | translate}}</div><div class=\"info-value\">{{worker.emp_city | emptyValue}}</div></div></div></div></div></div></div><div class=\"cloud\"><h3 class=\"info-title\">{{\"WORKER_HOURS\" | translate}}</h3><div class=\"table-holder customer-table-holder\"><div class=\"table-responsive\"><table id=\"customer-hitsory-orders\" dt-options=\"dtOptions\" datatable=\"ng\" ng-if=\"ctrl.tableData\" class=\"customer-single-table table table-striped table-bordered table-hover\"><thead><tr><th class=\"customer-log-cell\">{{\"WORKER_ENTRY_TIME\" | translate}}</th><th class=\"customer-log-cell\">{{\"WORKER_EXIT_TIME\" | translate}}</th><th class=\"customer-log-cell\">{{\"WORKER_SUM_HOURS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"turntoinput(row.id,row.entry_date_time,row.exit_date_time)\"><td class=\"customer-log-cell\"><span ng-hide=\"true\">{{row.entry_date_time | toUnixTimestamp }}</span> {{row.entry_date_time | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-log-cell\">{{row.exit_date_time | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"customer-log-cell\">{{row.trn_sum_of_hours}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/workers/modules/workers-sms/workers.sms.html","<div class=\"modal-form-inner\" id=\"settings-form\"><div class=\"modal-head\"><h3 class=\"form-title\">\"{{Customer.firstname}} {{Customer.lastname}}\" {{\"CUSTOMERS_SMS_TO\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"smsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CUSTOMERS_CONTENT_MESSAGE\" | translate}}</label> <textarea class=\"form-control\" name=\"message\" ng-model=\"ctrl.form.message\" required=\"\" style=\"height: 120px; resize: none;\"></textarea><div ng-messages=\"smsForm.message.$error\" class=\"ng-messages\" ng-show=\"smsForm.message.$dirty\"><div ng-message=\"required\">{{\"CUSTOMERS_REQUIRED\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"smsForm.$invalid || smsForm.$pristine\" class=\"btn text primary large\">{{\"CUSTOMERS_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/cards/change-balance.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CARD_BALANCE_CHANGE_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><form class=\"modal-form_f\" name=\"editForm\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"CARD_CHANGE_BALANCE_AMOUNT\" | translate}}</label><div class=\"item-inputs\"><input-number-spinner data-ng-model=\"ctrl.form.amount_changed\" data-input-number-spinner-min=\"-(ctrl.card.balance)\" data-input-number-spinner-required=\"true\"></input-number-spinner></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"card-expired\">{{\"MAKE_CARD_EXPIRED_DATE\" | translate}}</label> <input type=\"date\" id=\"card-expired\" class=\"form-control\" ng-model=\"ctrl.form.expired_at\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 notes-wrapper\"><div class=\"form-group\"><label>{{\"CARD_CHANGE_BALANCE_COMMENT\" | translate}}</label> <textarea class=\"form-control\" ng-model=\"ctrl.form.comment\" placeholder=\"\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"CARD_CURRENT_BALANCE\" | translate}}: {{ ctrl.card.balance }}</label></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>{{\"CARD_RESULT_BALANCE\" | translate}}: {{ (ctrl.card.balance + ctrl.form.amount_changed)}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\">{{\"CALENDAR_CASH_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid\" ng-click=\"ctrl.saveForm()\" class=\"btn text primary large\">{{\"CARD_CHANGE_BALANCE_SAVE_BTN\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/cards/coloring.form.html","<div class=\"modal-form-inner tabs-form\" id=\"coloring-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CUSTOMER_ADD_COLOR\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\" ng-if=\"!isModal\">&times;</a> <a class=\"close\" ng-click=\"$close();\" ng-if=\"isModal\">&times;</a></div><form class=\"modal-form\" name=\"customersColoring\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.form.date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_BRAND\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.brand\" class=\"form-control\"></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage\" class=\"form-control\"></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_OXYGEN\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.oxygen_percent\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_OXYGEN_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.oxygen_dosage\" class=\"form-control\"></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_COMMENTS\" | translate}}</label> <textarea ng-model=\"ctrl.form.comments\" class=\"form-control\"></textarea></div></div></div><div ng-if=\"ctrl.color_inputs[2]\" class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number_2\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage_2\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.color_inputs[3]\" class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number_3\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage_3\" class=\"form-control\"></div></div></div><div ng-if=\"ctrl.color_inputs[4]\" class=\"flex form fill\"><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_NUMBER\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_number_4\" class=\"form-control\"></div></div><div><div class=\"form-group\"><label>{{\"CUSTOMER_COLOR_DOSAGE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.color_dosage_4\" class=\"form-control\"></div></div></div><div ng-if=\"!ctrl.color_inputs[2] || !ctrl.color_inputs[3] || !ctrl.color_inputs[4]\" class=\"flex form fill\"><div><button type=\"button\" ng-click=\"ctrl.add_color();\" class=\"btn text border-primary large\"><i class=\"las la-plus\"></i> {{\"CUSTOMER_COLOR_ADD\" | translate}}</button></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.remove();\" ng-if=\"ctrl.form.id\" class=\"btn text border-red large\">{{\"CUSTOMERS_COLOR_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close();\" class=\"btn text border-red large\">{{\"CUSTOMERS_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"CUSTOMER_COLOR_SAVE\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/customers/modules/customers-single/cards/transactions.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.customers.single({id: {{ctrl.customer.id}}})\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{\"CUSTOMERS_CARDS_TRANSACTIONS_LABEL\" | translate}}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.transactions\" id=\"logs_dt\" datatable=\"ng\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover customers-table\"><thead><tr><th class=\"\">{{\"CARD_TRANSACTION_DATE\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_CHANGE_AMOUNT\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_AMOUNT_AFTER\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_ORDER_ID\" | translate}}</th><th class=\"\">{{\"CARD_TRANSACTION_COMMENTS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.transactions\"><td class=\"\"><span ng-hide=\"true\">{{row.date_created | toUnixTimestamp }}</span> {{row.date_created | toUnixTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"\"><span ng-if=\"row.amount_changed > 0\">+</span>{{row.amount_changed}}</td><td class=\"\">{{row.amount_result}}</td><td class=\"\">{{row.order_id | emptyValue}}</td><td class=\"\">{{row.comment | emptyValue}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/accounting_settings/modules/allocation-settings/allocation.settings.html","<div ng-include=\"\'app/components/header/header.html\'\" ng-if=\"isUserAllowedAccess(\'business_settings\')\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.accounting_settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_ALLOCATION_SETTINGS\" | translate }}</h3></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.issueAllocationNumber\" options=\"ctrl.issueAllocationDropdownOptions\" value-prop=\"value\" label-prop=\"name\" label=\"{{\'SETTINGS_ALLOCATION_ISSUE_NUMBER\' | translate}}\" fixed-panel=\"true\" on-change=\"ctrl.onIssueAllocationNumberChange(model)\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{ \"SETTINGS_ALLOCATION_TOKEN_STATUS\" | translate }}</label><div class=\"allocation-status-container\"><div class=\"allocation-status-indicator\" ng-class=\"\'allocation-indicator-\' + (ctrl.tokenStatusIndicator || \'red\')\"></div><span class=\"input-hint visible allocation-status-message\" ng-class=\"\'allocation-status-\' + (ctrl.tokenStatusIndicator || \'red\')\"><span ng-if=\"ctrl.tokenStatusMessage\">{{ ctrl.tokenStatusMessage }}</span> <span ng-if=\"!ctrl.tokenStatusMessage\">{{ \"SETTINGS_ALLOCATION_TOKEN_STATUS_NO_TOKEN\" | translate }}</span></span></div></div></div></div><div class=\"flex end gap-24 mt-24\"><button type=\"button\" class=\"btn text primary large\" ng-if=\"!ctrl.hasToken\" ng-click=\"ctrl.generate()\" ng-disabled=\"ctrl.loadingGenerate\"><span ng-if=\"ctrl.loadingGenerate\"><i class=\"las la-spinner la-spin\"></i> {{ \"SAVING\" | translate }}</span> <span ng-if=\"!ctrl.loadingGenerate\">{{ \"SETTINGS_ALLOCATION_GENERATE_TOKEN\" | translate }}</span></button> <button type=\"button\" class=\"btn text primary large\" ng-if=\"ctrl.hasToken\" ng-click=\"ctrl.refresh()\" ng-disabled=\"ctrl.loadingRefresh\"><span ng-if=\"ctrl.loadingRefresh\"><i class=\"las la-spinner la-spin\"></i> {{ \"SAVING\" | translate }}</span> <span ng-if=\"!ctrl.loadingRefresh\">{{ \"SETTINGS_ALLOCATION_REFRESH_TOKEN\" | translate }}</span></button></div></div></div><style>\n.allocation-status-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.allocation-status-indicator {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n.allocation-indicator-green {\n    background-color: #4CAF50;\n    box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);\n}\n.allocation-indicator-orange {\n    background-color: #FF9800;\n    box-shadow: 0 0 5px rgba(255, 152, 0, 0.5);\n}\n.allocation-indicator-red,\n.allocation-indicator-no_token {\n    background-color: #F44336;\n    box-shadow: 0 0 5px rgba(244, 67, 54, 0.5);\n}\n.allocation-status-message.allocation-status-valid { color: #4CAF50; }\n.allocation-status-message.allocation-status-expired { color: #F44336; }\n.allocation-status-message.allocation-status-error { color: #F44336; }\n.allocation-status-message.allocation-status-no_token { color: #757575; }\n</style>");
$templateCache.put("app/modules/settings/accounting_settings/modules/quotation-statuses/quotation.statuses.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.accounting_settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_QUOTATION_STATUSES\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.accounting_settings.quotation_statuses.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_QUOTATION_STATUSES_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_QUOTATION_STATUSES_NAME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.accounting_settings.quotation_statuses.edit({id: {{row.id}}})\"><td><div class=\"bg-div\" ng-style=\"{\'background-color\': row.color ? row.color : \'#a9cfe8\'}\"></div><span>{{row.name}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/accounting_settings/modules/quotation-statuses-new/quotation.statuses.new.html","<div class=\"modal-form-inner\" id=\"quotation-statuses-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_QUOTATION_STATUSES_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"statusesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_QUOTATION_STATUSES_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"statusesForm.name.$error\" class=\"ng-messages\" ng-show=\"statusesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6\"><div class=\"form-group form-color\"><label>{{\"SETTINGS_QUOTATION_STATUSES_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.color\" name=\"color\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/additional_fields/modules/interested/interested.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.additional_fields\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_INTERESTED\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.additional_fields.interested.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_INTERESTED_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_INTERESTED_NAME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.additional_fields.interested.edit({id: {{row.id}}})\"><td><span>{{row.name}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/additional_fields/modules/interested-form/interested-form.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_INTERESTED_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_INTERESTED_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemForm.name.$error\" class=\"ng-messages\" ng-show=\"itemForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemForm.$invalid || itemForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/call_logs/modules/call_logs/call_logs.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_CALL_LOGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_CALL_LOGS_PHONE\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_CUSTOMER\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_DATE\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_STATUS\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_DURATION\" | translate}}</th><th>{{\"SETTINGS_CALL_LOGS_RECORD\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><span>{{row.caller}}</span></td><td><div class=\"flex nowrap\"><div class=\"customer-pic-wrapper\"><img ng-src=\"{{row.customer_avatar || \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div><span>{{row.customer}}</span></div></td><td><span>{{row.created_at}}</span></td><td><span ng-if=\"row.status\">{{\"SETTINGS_CALL_LOGS_STATUS_\" + row.status.toUpperCase() | translate}}</span> <span ng-if=\"!row.status\">-</span></td><td><span>{{row.duration ? row.duration + \'s\' : \'-\'}}</span></td><td><button ng-if=\"ctrl.currentAudioRow && ctrl.getRowId(ctrl.currentAudioRow) == ctrl.getRowId(row) && ctrl.audio && row.record\" class=\"btn icon small circle bordered red\" ng-click=\"ctrl.playRecord(row); $event.stopPropagation()\"><i class=\"las la-stop\"></i></button> <button ng-if=\"(!ctrl.currentAudioRow || ctrl.getRowId(ctrl.currentAudioRow) != ctrl.getRowId(row) || !ctrl.audio) && row.record\" class=\"btn icon small circle bordered green\" ng-click=\"ctrl.playRecord(row); $event.stopPropagation()\"><i class=\"las la-play\"></i></button> <span ng-if=\"!row.record\">-</span></td><td><a class=\"btn icon circle small bordered blue\" ng-click=\"$event.stopPropagation()\" href=\"tel:{{row.caller}}\"><i class=\"las la-phone\"></i></a></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/categories/modules/categories-form/categories.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_CAT_ADD\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"categoriesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CAT_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"categoriesForm.name.$error\" class=\"ng-messages\" ng-show=\"categoriesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-switch form-group first last pull-end\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.active\" ng-change=\"ctrl.change_active()\">{{\"SETTINGS_CAT_ACTIVE\" | translate}}</label></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"categoriesForm.$invalid || categoriesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/categories/modules/categories-list/categories.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_CAT\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.categories.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_CAT_NEW\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_CAT_NAME\" | translate}}</th><th style=\"text-align: end;\">{{\"SETTINGS_CAT_ACTIVE\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.categories.edit({id: {{row.id}}})\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><span>{{row.name}}</span></td><td style=\"text-align: end;\"><div class=\"form-switch form-group first last pull-end\" ng-click=\"$event.stopPropagation()\"><label style=\"padding-left: 42px;\"><input type=\"checkbox\" ng-change=\"ctrl.change_active(row)\" ng-model=\"row.active\">&nbsp;</label></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/settings/courses_fields/modules/courses_fields_form/courses_fields.form.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_COURSES_FIELDS_VALUE_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_COURSES_FIELDS_VALUE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.value\" name=\"value\" class=\"form-control\" required=\"\"><div ng-messages=\"itemForm.value.$error\" class=\"ng-messages\" ng-show=\"itemForm.value.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div><div class=\"form-group form-switch\" ng-if=\"ctrl.coursesField.cashbox_condition\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.cashbox_condition\"> {{\"SETTINGS_COURSES_FIELDS_CASHBOX_CONDITION\" | translate}}</label></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"ctrl.isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemForm.$invalid || itemForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/courses_fields/modules/courses_fields_single/courses_fields.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.courses_fields\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ ctrl.title }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.courses_fields.single.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_COURSES_FIELDS_VALUE_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_COURSES_FIELDS_VALUE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.courses_fields.single.edit({vid: {{row.id}}})\"><td><span>{{row.value}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/custom_fields/modules/custom_fields_form/custom_fields.form.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_CUSTOM_FIELDS_VALUE_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_VALUE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.value\" name=\"value\" class=\"form-control\" required=\"\"><div ng-messages=\"itemForm.value.$error\" class=\"ng-messages\" ng-show=\"itemForm.value.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"ctrl.isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemForm.$invalid || itemForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/custom_fields/modules/custom_fields_single/custom_fields.single.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.additional_fields\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ ctrl.title }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.custom_fields.single.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_CUSTOM_FIELDS_VALUE_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_CUSTOM_FIELDS_VALUE\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.custom_fields.single.edit({vid: {{row.id}}})\"><td><span>{{row.value}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-form/digital_forms.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head modal-head-minimizable\"><h3 class=\"form-title\" ng-if=\"!isEdit && !isDuplicate\">{{\"SETTINGS_DIGITAL_FORM_NEW\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_DIGITAL_FORM_EDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isDuplicate\">{{\"SETTINGS_DIGITAL_FORM_DUPLICATE\" | translate}}</h3><a class=\"modal-minimize\" ng-click=\"ctrl.minimize($event)\" title=\"{{\'MODAL_MINIMIZE\' | translate}}\"><i class=\"la la-minus\"></i></a> <a class=\"modal-restore\" ng-click=\"ctrl.restore($event)\" title=\"{{\'MODAL_RESTORE\' | translate}}\"><i class=\"la la-window-restore\"></i></a> <a class=\"close\" ng-click=\"$close()\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body digital_form\"><div class=\"flex form\"><div ng-class=\"{\'col-xs-12\': true, \'col-md-8\': ctrl.master_business || ctrl.form.logo, \'col-md-12\': !ctrl.master_business || !ctrl.form.logo}\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_DIGITAL_FORM_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"ctrl.master_business || ctrl.form.logo\" ng-class=\"{\'col-xs-12\': true, \'col-md-4\': ctrl.master_business || ctrl.form.logo, \'col-md-12\': !ctrl.master_business || !ctrl.form.logo}\"><label class=\"import-file\">{{\"SETTINGS_DIGITAL_FORM_LOGO\" | translate}} <input style=\"visibility: hidden; height: 0;\" type=\"file\" name=\"logo\" onchange=\"angular.element(this).scope().uploadImage(this, index)\"><div ng-if=\"ctrl.form.logo\" class=\"image logo small\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.logo + \')\'}\"></div><div ng-if=\"!ctrl.form.logo\" class=\"image logo small\" ng-style=\"{\'background-image\':\'url(/assets/images/empty_image.png)\'}\"></div><span ng-if=\"ctrl.master_business && ctrl.form.logo\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'logo\')\"><i class=\"las la-trash-alt\"></i></span></label><div ng-if=\"!ctrl.master_business && ctrl.form.logo\" class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.hide_logo\">{{\"SETTINGS_DIGITAL_FORM_HIDE_LOGO\" | translate}}</label></div></div></div><div class=\"flex form\"><div class=\"col-md-6 cols-xs-12\"><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.text_form\">{{\"SETTINGS_DIGITAL_FORM_TEXT_FORM\" | translate}}</label></div></div><div ng-if=\"!ctrl.form.text_form\" class=\"col-md-6 cols-xs-12\"><div class=\"form-switch form-group first\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.locked\">{{\"SETTINGS_DIGITAL_FORM_LOCKED\" | translate}}</label></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.text_form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"ctrl.form.text\" class=\"form-control\" style=\"height: 200px;\"></textarea></div></div></div><div ng-if=\"!ctrl.form.text_form\" class=\"digital_form_fields\"><h3>{{\"SETTINGS_DIGITAL_FORM_FIELDS\" | translate}}</h3><div ui-sortable=\"sortableOptions\" ng-model=\"ctrl.form.fields\"><div class=\"digital_form_item move\" ng-repeat=\"(index, field) in ctrl.form.fields\"><span tooltip=\'{{\"SETTINGS_DIGITAL_FORM_MOVE\" | translate}}\' class=\"drag-handle have-tooltip move-triger\"><i class=\"las la-braille\"></i></span><div class=\"flex form\"><div class=\"col-md-8 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.name\" name=\"field_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"field.type\" options=\"ctrl.fieldTypeOptions\" value-prop=\"value\" label-prop=\"name\" label=\"{{\'SETTINGS_DIGITAL_FORM_FIELD_TYPE\' | translate}}\" required=\"true\" fixed-panel=\"true\" on-change=\"ctrl.onChangeType(index, model)\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_TYPE_TEXT\" | translate}}</label> <textarea auto-expand=\"\" ng-model=\"field.value\" class=\"form-control\" style=\"height:200px;border:1px solid red;\"></textarea></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"flex form\" ng-repeat=\"(i, item) in field.items\"><div class=\"col-md-8 col-xs-10\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OPTION\" | translate}}</label> <input type=\"text\" ng-model=\"item.name\" name=\"item_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-2 text-right\"><button class=\"digital_form_remove_option btn icon red\" ng-click=\"ctrl.onRemoveItem(index, i)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.other_name\" name=\"other_name\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><button class=\"digital_form_add_option btn text border-primary\" ng-click=\"ctrl.onAddItem(index)\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_OPTION\" | translate}}</button></div><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\"><label><input type=\"checkbox\" ng-model=\"field.other\">{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER\" | translate}}</label></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"flex form\" ng-repeat=\"(i, item) in field.items\"><div class=\"col-md-8 col-xs-10\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OPTION\" | translate}}</label> <input type=\"text\" ng-model=\"item.name\" name=\"item_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-2 text-right\"><button class=\"digital_form_remove_option btn icon red\" ng-click=\"ctrl.onRemoveItem(index, i)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.other_name\" name=\"other_name\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><button class=\"digital_form_add_option btn text border-primary\" ng-click=\"ctrl.onAddItem(index)\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_OPTION\" | translate}}</button></div><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\"><label><input type=\"checkbox\" ng-model=\"field.other\">{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER\" | translate}}</label></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"flex form\" ng-repeat=\"(i, item) in field.items\"><div class=\"col-md-8 col-xs-10\"><div class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OPTION\" | translate}}</label> <input type=\"text\" ng-model=\"item.name\" name=\"item_name\" class=\"form-control\"></div></div><div class=\"col-md-4 col-xs-2 text-right\"><button class=\"digital_form_remove_option btn icon red\" ng-click=\"ctrl.onRemoveItem(index, i)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"field.other_name\" name=\"other_name\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><button class=\"digital_form_add_option btn text border-primary\" ng-click=\"ctrl.onAddItem(index)\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_OPTION\" | translate}}</button></div><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\"><label><input type=\"checkbox\" ng-model=\"field.other\">{{\"SETTINGS_DIGITAL_FORM_FIELD_OTHER\" | translate}}</label></div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"form-group\"><div class=\"text-danger\">{{field.name}}</div></div></div><div ng-if=\"field.type == \'business_signature\'\"><div class=\"order-images-col\"><div class=\"flex column\"><label ng-class=\"{\'import-image\': true, \'w-image\': !field.image || field.image == \'\', \'first\': true}\"><input ng-if=\"!field.image || field.image == \'\'\" style=\"visibility: hidden; display: none;\" name=\"image\" data-index=\"{{index}}\" type=\"file\" accept=\"image/*\" ng-disabled=\"false\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"field.image && field.image != \'\'\" class=\"image\"><div class=\"customer-pic-wrapper no-margin\" ng-click=\"ctrl.showImage($event, field.image);\"><img ng-src=\"{{field.image}}\"></div><span class=\"filename\">{{field.image.substring(field.image.lastIndexOf(\'/\') + 1)}}</span><span class=\"remove-img\" ng-click=\"ctrl.removeImage($event, index)\"><i class=\"las la-trash-alt\"></i></span></div><div ng-if=\"!field.image || field.image == \'\'\"><span class=\"btn icon circle default\"><i class=\"las la-download\"></i></span> {{\"CALENDAR_ORDER_IMAGES_DOWNLOAD\" | translate}}</div></label></div></div></div><div ng-if=\"field.type == \'map\'\"><div class=\"form-group\"><app-dropdown model=\"field.map\" options=\"ctrl.mapOptions\" value-prop=\"url\" label-prop=\"name\" label=\"{{\'SETTINGS_DIGITAL_FORM_MAP\' | translate}}\" required=\"true\" fixed-panel=\"true\"></app-dropdown></div></div></div></div><div class=\"flex form\"><div class=\"col-xs-6\"><div class=\"form-switch form-group other-check\" ng-if=\"field.type != \'comment\' && field.type != \'text\' && field.type != \'business_signature\' && field.type != \'map\'\"><label><input type=\"checkbox\" ng-model=\"field.require\">{{\"SETTINGS_DIGITAL_FORM_FIELD_REQUIRE\" | translate}}</label></div></div><div class=\"col-xs-6 text-right\"><button ng-if=\"ctrl.form.fields.length > 1\" class=\"digital_form_remove_field btn icon red\" ng-click=\"ctrl.onRemoveField(index)\" type=\"button\"><i class=\"fa fa-trash\"></i></button></div></div></div></div><button class=\"digital_form_add_field btn text border-green\" ng-click=\"ctrl.onAddField()\" type=\"button\">{{\"SETTINGS_DIGITAL_FORM_FIELD_ADD_FIELD\" | translate}}</button></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit && !isDuplicate\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$close()\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid || !ctrl.checkRequiredFields()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-list/digital_forms.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_DIGITAL_FORMS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.digital_forms.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_DIGITAL_FORM_NEW\" | translate}}</button> <button class=\"btn text primary large\" ui-sref=\"app.settings.digital_forms.templates\"><i class=\"las la-plus\"></i>{{\"SETTINGS_DIGITAL_FORM_NEW_TEMPLATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_DIGITAL_FORM\" | translate}}</th><th></th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td ui-sref=\"app.settings.digital_forms.edit({id: row.id})\"><span>{{row.name}}</span></td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ui-sref=\"app.settings.digital_forms.preview({id: row.id})\">{{\"SETTINGS_DIGITAL_FORM_PREVIEW\" | translate}}</button></td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ui-sref=\"app.settings.digital_forms.duplicate({id: row.id})\">{{\"SETTINGS_DIGITAL_FORM_DUPLICATE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-preview/digital_forms.preview.html","<div class=\"modal-form-inner digital_form_modal\"><div class=\"modal-head modal-head-online\"><div ng-if=\"business.online_booking_data.background\" class=\"df-background\"><img ng-src=\"{{business.online_booking_data.background}}\"></div><a class=\"close\" ng-click=\"ctrl.back()\" style=\"top: 20px;\">&times;</a></div><div class=\"df-header\" ng-class=\"{\'df-header-both-logos\': (business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) && (DigitalForm.logo && !DigitalForm.hide_logo)}\"><div class=\"df-logos\" ng-if=\"(business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)) || (DigitalForm.logo && !DigitalForm.hide_logo)\"><div ng-if=\"business.online_booking_data.online_logo && business.online_booking_data.online_logo != \'removed\' && !(business.online_booking_data.online_logo.indexOf(\'logo-icon@2x.png\') >= 0)\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{business.online_booking_data.online_logo}}\"></div></div><div ng-if=\"DigitalForm.logo && !DigitalForm.hide_logo\" class=\"df-logo\"><div class=\"digital_form_logo\"><img ng-src=\"{{DigitalForm.logo}}\"></div></div></div><div class=\"df-titles\"><h1 class=\"df-business-name\">{{business.online_booking_data.name ? business.online_booking_data.name : business.name}}</h1><h2 class=\"df-form-name\">{{DigitalForm.name}}</h2></div></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\" ng-if=\"DigitalForm.id\"><div class=\"modal-body\"><div class=\"panel-body\"><div ng-if=\"DigitalForm.text_form\" ng-bind-html=\"DigitalForm.text\"></div><div ng-if=\"!DigitalForm.text_form\" class=\"digital_form_fields\"><div class=\"digital_form_item\" ng-repeat=\"(index, field) in DigitalForm.data\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div ng-if=\"field.type == \'input\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"text\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'textarea\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <textarea auto-expand=\"\" class=\"form-control\" name=\"field{{index}}\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"></textarea><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'radio\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"radio\" name=\"field{{index}}\" ng-model=\"field.value\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'checkbox\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label><div class=\"digital_form_options-line\"><div class=\"form-check form-group\" ng-repeat=\"(i, item) in field.items\"><label><input type=\"checkbox\" name=\"field{{index}}\" ng-model=\"item.checked\" value=\"{{item.value}}\" ng-disabled=\"DigitalForm.fill_date\"> {{item.name}}</label></div></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div ng-if=\"field.type == \'select\'\"><div class=\"digital_form_options\"><div class=\"form-group\"><app-dropdown model=\"field.value\" options=\"field.items\" value-prop=\"value\" label-prop=\"name\" label=\"{{field.name}}\" placeholder=\"{{field.name}}\" required=\"field.required\" disabled=\"DigitalForm.fill_date\" fixed-panel=\"true\"></app-dropdown></div><div ng-if=\"field.other\" class=\"form-group\"><label>{{field.other_name}}</label> <input type=\"text\" name=\"field{{index}}other\" class=\"form-control\" ng-model=\"field.other_value\" ng-disabled=\"DigitalForm.fill_date\"></div><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'date\'\"><div class=\"form-group\"><label><span ng-if=\"field.required\" class=\"required\">*</span> {{field.name}}</label> <input type=\"date\" min=\"1900-01-01\" name=\"field{{index}}\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"field.required\" ng-disabled=\"DigitalForm.fill_date\"><div ng-messages=\"fillForm[field+index].$error\" class=\"ng-messages\" ng-show=\"fillForm[field+index].$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div ng-if=\"field.type == \'comment\'\"><div class=\"text-danger\">{{field.name}}</div></div><div ng-if=\"field.type == \'signature\'\"><div class=\"form-group\"><label><span ng-if=\"field.require\" class=\"required\">*</span> {{field.name}}</label><div class=\"sign-block\"><canvas id=\"can{{index}}\"></canvas></div></div></div><div ng-if=\"field.type == \'text\'\"><div class=\"form-group\"><h3>{{field.name}}</h3><p ng-bind-html=\"ctrl.textValueWithBR(field.value)\"></p></div></div><div ng-if=\"field.type == \'business_signature\' && field.image && field.image != \'\'\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"business-signature-image\"><img ng-src=\"{{field.image}}\" alt=\"{{field.name}}\"></div></div></div><div ng-if=\"field.type == \'map\' && field.map\"><div class=\"form-group\"><label>{{field.name}}</label><div class=\"map-image\"><img ng-src=\"{{field.map}}\" alt=\"{{field.name}}\"></div></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/modules/settings/digital_forms/modules/digital_forms-templates/digital_forms.templates.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_DIGITAL_FORM_NEW_TEMPLATE\" | translate}}</h3><a class=\"close\" ng-click=\"$close()\" style=\"top: 20px;\">&times;</a></div><form class=\"modal-form_f\" name=\"fillForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.list\" class=\"table table-striped table-hover\"><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.list\"><td><span>{{row.name}}</span></td><td width=\"1%\"><button type=\"button\" class=\"btn text border-green\" ui-sref=\"app.settings.digital_forms.preview({id: {{row.id}}})\">{{\"SETTINGS_DIGITAL_FORM_PREVIEW\" | translate}}</button></td><td width=\"1%\"><button type=\"button\" class=\"btn text primary\" ng-click=\"ctrl.createForm(row)\">{{\"SETTINGS_DIGITAL_FORM_CREATE\" | translate}}</button></td></tr></tbody></table></div></div></div></div></form></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/list/list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_GIFT_CARDS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.gift_cards.templates\">{{\"SETTINGS_GIFT_CARDS_TEMPLATES\" | translate}}</button><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.changeUsed()\" ng-model=\"ctrl.showUsed\">{{\"SHOW_USED\" | translate}}</label></div></div><div class=\"cloud-list\"><table class=\"sorted-table\"><thead><tr><th>{{\"GIFT_CARD_NUMBER\" | translate}}</th><th>{{\"GIFT_CARD_NAME\" | translate}}</th><th>{{\"GIFT_CARD_PRICE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE\" | translate}}</th><th>{{\"GIFT_CARD_STATUS\" | translate}}</th><th>{{\"GIFT_CARD_CUSTOMER\" | translate}}</th><th width=\"1%\">{{\"GIFT_CARD_LINK\" | translate}}</th></tr></thead><tbody ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.gift_cards.single({id: {{row.id}}})\"><td>{{row.number}}</td><td>{{row.name}}</td><td>₪{{row.price}}</td><td>₪{{row.balance}}</td><td>{{row.used ? (\"GIFT_CARD_USED\" | translate) : (\"GIFT_CARD_NOT_USED\" | translate)}}</td><td>{{row.customer_name}}</td><td width=\"1%\"><a target=\"_blank\" class=\"btn text primary\" ui-sref=\"gift_card({id: row.b_id + \'b\' + row.number})\" ng-click=\"$event.stopPropagation()\">{{\"GIFT_CARD_PREVIEW\" | translate}}</a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/single/single.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.gift_cards\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ ctrl.settings.name ? ctrl.settings.name : (\"GIFT_CARD_NUMBER\" | translate) }} - #{{ ctrl.values.number }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><h3>{{\"GIFT_CARD_BALANCE\" | translate}}: ₪{{ctrl.balance}}</h3><button class=\"btn text primary large\" ng-click=\"ctrl.changeBalanceModal()\">{{\"GIFT_CARD_CHANGE\" | translate}}</button></div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><table ng-if=\"ctrl.tableData.length\" class=\"sorted-table\"><thead><tr><th>{{\"GIFT_CARD_DATE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE_BEFORE\" | translate}}</th><th>{{\"GIFT_CARD_BALANCE_AFTER\" | translate}}</th><th>{{\"GIFT_CARD_AMOUNT\" | translate}}</th><th width=\"1%\"></th></tr></thead><tbody ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.giftCardToggle(row)\"><td>{{row.created_at}}</td><td>{{row.balance_before}}₪</td><td>{{row.balance_after}}₪</td><td>{{(row.balance_before - row.balance_after) * -1}}₪</td><td width=\"1%\"><a ng-if=\"row.invoice\" tooltip=\'{{\"SETTINGS_LOG_INV\" | translate}}\' href=\"{{row.invoice}}\" target=\"_blank\" class=\"have-tooltip btn icon small default\"><i class=\"las la-file-invoice\"></i></a></td></tr></tbody></table><div class=\"gc-preview-row\"><div class=\"gc-preview\" ng-style=\"{ backgroundColor: ctrl.settings.page_bg_color }\"><gift-card settings=\"ctrl.settings\" values=\"ctrl.values\" size=\"normal\" view=\"mobile\"></gift-card></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/template/template.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.gift_cards.templates\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_GIFT_CARDS_TEMPLATE\" | translate }}</h3></div><div class=\"gc-page\"><div class=\"gc-container\"><div class=\"gc-page gc-start\"><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_NAME\" | translate }}</div><div class=\"gc-section__body gc-section__body-input\"><input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.settings.name\" class=\"form-control\" ng-change=\"ctrl.bumpSettings()\"></div></div><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_COLORS\" | translate }}</div><div class=\"gc-section__body\"><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.page_bg_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_PAGE_BACKGROUND_COLOR\" | translate }}</p></div><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.card_bg_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_CERTIFICATE_BACKGROUND_COLOR\" | translate }}</p></div><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.primary_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_ACCENT_COLOR\" | translate }}</p></div><div class=\"gc-color\"><input type=\"color\" ng-model=\"ctrl.settings.text_color\" ng-change=\"ctrl.bumpSettings()\"><p>{{ \"GIFT_CARD_TEXT_COLOR\" | translate }}</p></div></div><div class=\"gc-section__footer\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.resetColors()\">{{\"SETTINGS_INFO_RESET_COLORS\" | translate}}</button></div></div><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_VISUALS\" | translate }}</div><div class=\"gc-section__body\"><div class=\"gc-upload\"><p>{{ \"GIFT_CARD_COMPANY_LOGO\" | translate }}</p><label class=\"gc-upload__area\"><div class=\"gc-upload__area-start\"><input type=\"file\" name=\"logo\" onchange=\"angular.element(this).scope().uploadImage(this)\" style=\"visibility: hidden; display: none;\"><div class=\"gc-upload__area-preview\" ng-style=\"{\'background-image\':\'url(\' + ctrl.settings.logo + \')\'}\"></div><div class=\"gc-upload__area-filename\">{{ ctrl.getFilename(ctrl.settings.logo) }}</div></div><div ng-if=\"ctrl.settings.logo != \'\'\" class=\"gc-upload__area-end\" ng-click=\"ctrl.removeImage(\'logo\', $event)\"><i class=\"las la-trash-alt\"></i></div></label></div><div class=\"gc-upload\"><p>{{ \"GIFT_CARD_BANNER\" | translate }}</p><label class=\"gc-upload__area\"><div class=\"gc-upload__area-start\"><input type=\"file\" name=\"image\" onchange=\"angular.element(this).scope().uploadImage(this)\" style=\"visibility: hidden; display: none;\"><div class=\"gc-upload__area-preview cover\" ng-style=\"{\'background-image\':\'url(\' + ctrl.settings.image + \')\'}\"></div><div class=\"gc-upload__area-filename\">{{ ctrl.getFilename(ctrl.settings.image) }}</div></div><div ng-if=\"ctrl.settings.image != \'\'\" class=\"gc-upload__area-end\" ng-click=\"ctrl.removeImage(\'image\', $event)\"><i class=\"las la-trash-alt\"></i></div></label></div></div></div><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_TEXT_FIELDS\" | translate }}</div><div class=\"gc-section__body\"><div class=\"form-check\"><label class=\"form-check-label\" for=\"receiver\"><input type=\"checkbox\" class=\"form-check-input\" id=\"receiver\" ng-model=\"ctrl.settings.receiver\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_GIFTED_TO\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"value\"><input type=\"checkbox\" class=\"form-check-input\" id=\"value\" ng-model=\"ctrl.settings.value\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_VALUE\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"service\"><input type=\"checkbox\" class=\"form-check-input\" id=\"service\" ng-model=\"ctrl.settings.service\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_SERVICE\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"message\"><input type=\"checkbox\" class=\"form-check-input\" id=\"message\" ng-model=\"ctrl.settings.message\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_MESSAGE\" | translate}}</label></div><div class=\"form-check\"><label class=\"form-check-label\" for=\"sender\"><input type=\"checkbox\" class=\"form-check-input\" id=\"sender\" ng-model=\"ctrl.settings.sender\" ng-change=\"ctrl.bumpSettings()\"> {{\"GIFT_CARD_SENDER\" | translate}}</label></div></div></div></div><div class=\"gc-end\"><div class=\"gc-section\"><div class=\"gc-section__title\">{{ \"GIFT_CARD_TEMPLATE_PREVIEW\" | translate }}</div><div class=\"gc-preview-row\"><div class=\"gc-preview\" ng-style=\"{ backgroundColor: ctrl.settings.page_bg_color }\"><gift-card settings=\"ctrl.settings\" values=\"ctrl.values\" size=\"normal\" view=\"mobile\"></gift-card></div></div></div></div></div><div class=\"flex end gap-24\"><button type=\"button\" ng-if=\"ctrl.isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_GIFT_CARDS_TEMPLATES_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.saveTemplate()\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></div></div>");
$templateCache.put("app/modules/settings/gift_cards/modules/templates/templates.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.gift_cards\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_GIFT_CARDS_TEMPLATES\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.gift_cards.templates.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_GIFT_CARDS_TEMPLATE_NEW\" | translate}}</button></div><div class=\"details-gc-templates details-gc-templates--start\"><div ng-repeat=\"(index, template) in ctrl.templates\" class=\"details-gc-templates-item\" ui-sref=\"app.settings.gift_cards.templates.single({id: template.id})\"><div class=\"details-gc-preview\" ng-style=\"{\'background-color\': template.page_bg_color}\"><gift-card settings=\"template\" size=\"small\" view=\"mobile\" zoom-on-hover=\"::true\"></gift-card></div><div class=\"details-gc-name\"><p>{{ template.name }}</p></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/google_calendar/modules/connect-account/connect-account.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"CONNECT_GOOGLE_ACCOUNT\" | translate}}</h3><a class=\"close\" ng-click=\"$dismiss()\">&times;</a></div><div class=\"modal-body\"><div class=\"connect-account-content\"><div class=\"google-auth-section\" ng-if=\"!ctrl.authSuccess\"><div class=\"auth-icon\"><i class=\"fa fa-google fa-3x\"></i></div><h4>{{\"GOOGLE_AUTH_TITLE\" | translate}}</h4><p>{{\"GOOGLE_AUTH_DESCRIPTION\" | translate}}</p><button type=\"button\" ng-click=\"ctrl.authenticateWithGoogle()\" class=\"btn text primary large\" ng-disabled=\"ctrl.authLoading\"><span ng-if=\"ctrl.authLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"AUTHENTICATING\" | translate}}...</span> <span ng-if=\"!ctrl.authLoading\"><i class=\"fa fa-google\"></i> {{\"SIGN_IN_WITH_GOOGLE\" | translate}}</span></button></div><div ng-if=\"ctrl.authSuccess && ctrl.availableResources.length > 0\" class=\"resources-selection\"><div class=\"sync-type\"><h4>{{\"SYNC_DIRECTION\" | translate}}</h4><div class=\"flex gap-16\"><div class=\"form-check form-group\"><label><input type=\"radio\" name=\"syncDirection\" ng-model=\"ctrl.syncType\" value=\"google_to_tiffulit\"> {{\"GOOGLE_TO_TIFULIT\" | translate}}</label></div><div class=\"form-check form-group\"><label><input type=\"radio\" name=\"syncDirection\" ng-model=\"ctrl.syncType\" value=\"tiffulit_to_google\"> {{\"TIFULIT_TO_GOOGLE\" | translate}}</label></div><div class=\"form-check form-group\"><label><input type=\"radio\" name=\"syncDirection\" ng-model=\"ctrl.syncType\" value=\"both\"> {{\"BOTH_DIRECTIONS\" | translate}}</label></div></div></div><div ng-if=\"ctrl.syncType === \'tiffulit_to_google\' || ctrl.syncType === \'both\'\"><h4>{{\"SELECT_RESOURCES_TO_SYNC_FROM_TIFFULIT\" | translate}}</h4><p>{{\"SELECT_RESOURCES_DESCRIPTION_FROM_TIFFULIT\" | translate}}</p><div class=\"resources-list\"><div ng-repeat=\"resource in ctrl.availableResources\" class=\"resource-item\"><div class=\"form-check form-group\"><label><input type=\"checkbox\" ng-model=\"resource.selected\" ng-change=\"ctrl.updateSelectedResources()\">{{resource.name}}</label></div></div></div><div class=\"selected-resources-summary\"><p><strong>{{\"SELECTED_RESOURCES\" | translate}}: {{ctrl.selectedResources.length}}</strong></p></div></div><div ng-if=\"ctrl.syncType === \'google_to_tiffulit\' || ctrl.syncType === \'both\'\"><h4>{{\"SELECT_RESOURCES_TO_SYNC_FROM_GOOGLE\" | translate}}</h4><p>{{\"SELECT_RESOURCES_DESCRIPTION_FROM_GOOGLE\" | translate}}</p><div class=\"resources-list\"><div ng-repeat=\"resource in ctrl.availableIncomeResources\" class=\"resource-item\"><div class=\"form-check form-group\"><label><input type=\"checkbox\" ng-model=\"resource.selected\" ng-change=\"ctrl.updateSelectedIncomeResources()\">{{resource.name}}</label></div></div></div><div class=\"selected-resources-summary\"><p><strong>{{\"SELECTED_RESOURCES\" | translate}}: {{ctrl.selectedIncomeResources.length}}</strong></p></div></div></div></div></div><div class=\"modal-footer end\" ng-if=\"ctrl.authSuccess\"><button type=\"button\" ng-click=\"$dismiss()\" class=\"btn text border-primary large\">{{\"CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.saveAccount()\" class=\"btn text primary large\" ng-disabled=\"ctrl.saveLoading || (((ctrl.syncType === \'tiffulit_to_google\' || ctrl.syncType === \'both\') && ctrl.selectedResources.length === 0) || ((ctrl.syncType === \'google_to_tiffulit\' || ctrl.syncType === \'both\') && ctrl.selectedIncomeResources.length === 0))\"><span ng-if=\"ctrl.saveLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"SAVING\" | translate}}...</span> <span ng-if=\"!ctrl.saveLoading\">{{\"SAVE_ACCOUNT\" | translate}}</span></button></div></div>");
$templateCache.put("app/modules/settings/google_calendar/modules/manage-resources/manage-resources.modal.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"MANAGE_ACCOUNT_RESOURCES\" | translate}}</h3><a class=\"close\" ng-click=\"$dismiss()\">&times;</a></div><div class=\"modal-body\"><div class=\"account-info\"><div class=\"account-avatar\"><img ng-src=\"{{ctrl.account.avatar_url || \'assets/images/default-avatar.png\'}}\" alt=\"{{ctrl.account.email}}\"></div><div class=\"account-details\"><h4>{{ctrl.account.email}}</h4><p>{{ctrl.account.name || ctrl.account.email}}</p></div></div><div class=\"sync-type\"><h4>{{\"SYNC_DIRECTION\" | translate}}</h4><div class=\"flex gap-16\"><div class=\"form-check form-group\"><label><input type=\"radio\" name=\"syncDirection\" ng-model=\"ctrl.syncType\" value=\"google_to_tiffulit\"> {{\"GOOGLE_TO_TIFULIT\" | translate}}</label></div><div class=\"form-check form-group\"><label><input type=\"radio\" name=\"syncDirection\" ng-model=\"ctrl.syncType\" value=\"tiffulit_to_google\"> {{\"TIFULIT_TO_GOOGLE\" | translate}}</label></div><div class=\"form-check form-group\"><label><input type=\"radio\" name=\"syncDirection\" ng-model=\"ctrl.syncType\" value=\"both\"> {{\"BOTH_DIRECTIONS\" | translate}}</label></div></div></div><div ng-if=\"ctrl.syncType === \'tiffulit_to_google\' || ctrl.syncType === \'both\'\"><div class=\"resources-management\"><h4>{{\"SELECT_RESOURCES_TO_SYNC_FROM_TIFFULIT\" | translate}}</h4><p>{{\"SELECT_RESOURCES_DESCRIPTION_FROM_TIFFULIT\" | translate}}</p><div class=\"resources-list\"><div ng-repeat=\"resource in ctrl.availableResources\" class=\"resource-item\"><div class=\"form-check form-group\"><label><input type=\"checkbox\" ng-model=\"resource.selected\" ng-change=\"ctrl.updateSelectedResources()\">{{resource.name}}</label></div></div></div><div class=\"selected-resources-summary\"><p><strong>{{\"SELECTED_RESOURCES\" | translate}}: {{ctrl.selectedResources.length}}</strong></p></div></div></div><div ng-if=\"ctrl.syncType === \'google_to_tiffulit\' || ctrl.syncType === \'both\'\"><div class=\"resources-management\"><h4>{{\"SELECT_RESOURCES_TO_SYNC_FROM_GOOGLE\" | translate}}</h4><p>{{\"SELECT_RESOURCES_DESCRIPTION_FROM_GOOGLE\" | translate}}</p></div><div class=\"resources-list\"><div ng-repeat=\"resource in ctrl.availableIncomeResources\" class=\"resource-item\"><div class=\"form-check form-group\"><label><input type=\"checkbox\" ng-model=\"resource.selected\" ng-change=\"ctrl.updateSelectedIncomeResources()\">{{resource.name}}</label></div></div></div><div class=\"selected-resources-summary\"><p><strong>{{\"SELECTED_RESOURCES\" | translate}}: {{ctrl.selectedIncomeResources.length}}</strong></p></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-click=\"ctrl.disconnectAccount()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ng-click=\"$dismiss()\" class=\"btn text border-primary large\">{{\"CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.saveResources()\" class=\"btn text primary large\" ng-disabled=\"ctrl.saveLoading || (((ctrl.syncType === \'tiffulit_to_google\' || ctrl.syncType === \'both\') && ctrl.selectedResources.length === 0) || ((ctrl.syncType === \'google_to_tiffulit\' || ctrl.syncType === \'both\') && ctrl.selectedIncomeResources.length === 0))\"><span ng-if=\"ctrl.saveLoading\"><i class=\"las la-spinner la-spin\"></i> {{\"SAVING\" | translate}}...</span> <span ng-if=\"!ctrl.saveLoading\">{{\"SAVE_RESOURCES\" | translate}}</span></button></div></div>");
$templateCache.put("app/modules/settings/items/modules/items-form/items.form.html","<div class=\"modal-form-inner\" id=\"categories-form\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_ITEM_NEW\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_ITEM_EDIT\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"itemsForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><label class=\"import-file\">{{\"SETTINGS_ITEM_IMAGE\" | translate}} <input style=\"visibility: hidden; height: 0;\" type=\"file\" name=\"item_image\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div ng-if=\"ctrl.form.item_image\" class=\"image small\" ng-style=\"{\'background-image\':\'url(\' + ctrl.form.item_image + \')\'}\"></div><div ng-if=\"!ctrl.form.item_image\" class=\"image small\" ng-style=\"{\'background-image\':\'url(/assets/images/empty_image.png)\'}\"></div><span ng-if=\"ctrl.form.item_image\" class=\"remove btn icon red simple\" ng-click=\"ctrl.removeImage(\'item_image\')\"><i class=\"las la-trash-alt\"></i></span></label></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_TYPE\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"service\" ng-disabled=\"isEdit\"> <label>{{\'SERVICE\' | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"sale\" ng-disabled=\"isEdit\"> <label>{{\'SALE\' | translate}}</label></div><div ng-if=\"ctrl.business.courses\" class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"course\" ng-disabled=\"isEdit\"> <label>{{\'COURSE\' | translate}}</label></div><div ng-if=\"isEdit\" class=\"radio-btn\"><input type=\"radio\" name=\"item_type\" ng-model=\"ctrl.form.item_type\" value=\"card\" ng-disabled=\"isEdit\" ng-change=\"ctrl.cardTypeSelected()\"> <label>{{\'CARD_ITEM_TYPE\' | translate}}</label></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label ng-if=\"ctrl.form.item_type != \'card\'\"><span class=\"required\">*</span> {{\"SETTINGS_ITEM_NAME\" | translate}}</label> <label ng-if=\"ctrl.form.item_type == \'card\'\"><span class=\"required\">*</span> {{\"SETTINGS_ITEM_CARD_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_ITEM_PRICE\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.price\" name=\"price\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.price.$error\" class=\"ng-messages\" ng-show=\"itemsForm.price.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div class=\"col-xs-12 form-group\"><label>{{\"SETTINGS_ITEM_DESCRIPTION\" | translate}}</label> <textarea ng-model=\"ctrl.form.description\" name=\"description\" class=\"form-control\" style=\"min-height: 42px;\" auto-expand=\"\"></textarea></div></div><div class=\"flex form\" ng-if=\"ctrl.show_stock && ctrl.form.item_type == \'sale\'\"><div class=\"col-xs-12 form-group\"><label>{{\"SETTINGS_ITEM_MINIMUM_BALANCE\" | translate}}</label> <input type=\"number\" min=\"0\" ng-model=\"ctrl.form.minimum_balance\" name=\"minimum_balance\" class=\"form-control\"></div></div><div class=\"flex form\"><div class=\"col-xs-12 form-group\"><label>{{\"SETTINGS_ITEM_GENERAL_INFO\" | translate}}</label> <textarea ng-model=\"ctrl.form.general_info\" name=\"general_info\" class=\"form-control\" style=\"min-height: 42px;\" auto-expand=\"\"></textarea></div></div><div class=\"flex form\"><div class=\"col-xs-12 form-group\"><label>{{\"SETTINGS_ITEM_SPECIFIC_INFO\" | translate}}</label> <textarea ng-model=\"ctrl.form.specific_info\" name=\"specific_info\" class=\"form-control\" style=\"min-height: 42px;\" auto-expand=\"\"></textarea></div></div><div class=\"flex form\"><div class=\"col-xs-12 form-group\"><label>{{\"SETTINGS_ITEM_RESTRICTION\" | translate}}</label> <textarea ng-model=\"ctrl.form.restriction\" name=\"restriction\" class=\"form-control\" style=\"min-height: 42px;\" auto-expand=\"\"></textarea></div></div><div class=\"flex form\" ng-if=\"ctrl.form.item_type==\'service\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_LENGTH\" | translate}}</label><app-dropdown model=\"ctrl.form.duration\" options=\"ctrl.durationOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_LENGTH\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_BREAK\" | translate}}</label><app-dropdown model=\"ctrl.form.break\" options=\"ctrl.breakOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_NO_BREAK\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.item_type==\'service\' && ctrl.form.break\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_ITEM_NAME2\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name_second\" name=\"name_second\" class=\"form-control\"><div ng-messages=\"itemsForm.name.$error\" class=\"ng-messages\" ng-show=\"itemsForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_LENGTH2\" | translate}}</label><app-dropdown model=\"ctrl.form.duration_second\" options=\"ctrl.durationWithEmptyOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_NOT_SET\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\" ng-if=\"ctrl.form.item_type == \'card\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"CALENDAR_ORDER_ITEM_ASSOCIATE\" | translate}}</label><app-dropdown model=\"ctrl.form.item_id\" options=\"ctrl.serviceItemOptions\" value-prop=\"id\" searchable=\"true\" required=\"true\" disabled=\"isEdit\" fixed-panel=\"true\" on-change=\"ctrl.itemSelected(ctrl.form.item_id)\" placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\" search-placeholder=\"{{\'CALENDAR_ORDER_ITEM_ASSOCIATE2\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_ITEM_AMOUNT\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.amount\" name=\"amount\" class=\"form-control\" required=\"\"><div ng-messages=\"itemsForm.amount.$error\" class=\"ng-messages\" ng-show=\"itemsForm.amount.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_CAT_ASSOC\" | translate}}</label><app-dropdown model=\"ctrl.form.categories\" options=\"ctrl.categoryOptions\" value-prop=\"id\" searchable=\"true\" disabled=\"ctrl.form.item_type==\'card\'\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_CAT_SEL\' | translate}}\" search-placeholder=\"{{\'SETTINGS_ITEM_CAT_SEL\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_CUSTOMER_BOOKING\" | translate}}</label><app-dropdown model=\"ctrl.form.customer_allowed_booking\" options=\"ctrl.customerAllowedBookingOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_CUSTOMER_BOOKING\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\" ng-if=\"[\'service\', \'card\', \'course\'].indexOf(ctrl.form.item_type) !== -1\"><div class=\"form-group form-color inl\"><label>{{\"SETTINGS_ITEM_COLOR_SEL\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.bg_color\" name=\"name\" class=\"form-control\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-check form-group\"><label class=\"form-check-label\" for=\"inactive\"><input type=\"checkbox\" class=\"form-control\" id=\"inactive\" ng-model=\"ctrl.form.inactive\"> {{\"SETTINGS_ITEM_INACTIVE\" | translate}}</label></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12 mb-24\" ng-init=\"resourcesSectionExpanded = false\"><label class=\"expand-toggle\" ng-click=\"resourcesSectionExpanded = !resourcesSectionExpanded\" style=\"cursor: pointer;\">{{\"SETTINGS_ITEM_RESOURCES\" | translate}} <span class=\"resources-toggle__arrow\" ng-if=\"!resourcesSectionExpanded\"><i class=\"las la-angle-down\"></i></span> <span class=\"resources-toggle__arrow\" ng-if=\"resourcesSectionExpanded\"><i class=\"las la-angle-up\"></i></span></label><div class=\"item-resources\" ng-show=\"resourcesSectionExpanded\"><div ng-if=\"item.status == 1 && !item.hide_online\" class=\"item\" ng-repeat=\"(index, item) in ctrl.resources track by $index\"><div class=\"form-check\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-control\" ng-model=\"ctrl.form.resources[item.id]\"> {{item.name}}</label><div ng-if=\"ctrl.form.resources[item.id]\" class=\"form-group last\"><label>{{\"SETTINGS_ITEM_LENGTH\" | translate}}</label><app-dropdown model=\"ctrl.form.resources_options[item.id].duration\" options=\"ctrl.durationWithEmptyOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_NOT_SET\' | translate}}\"></app-dropdown></div><div ng-if=\"ctrl.form.resources[item.id]\" class=\"form-group last\"><label>{{\"SETTINGS_ITEM_PRICE\" | translate}}</label> <input type=\"number\" ng-model=\"ctrl.form.resources_options[item.id].price\" name=\"price\" class=\"form-control\"><div ng-messages=\"itemsForm.price.$error\" class=\"ng-messages\" ng-show=\"itemsForm.price.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12 mb-24\" ng-init=\"availabilitySectionExpanded = false\"><label class=\"expand-toggle\" ng-click=\"availabilitySectionExpanded = !availabilitySectionExpanded\" style=\"cursor: pointer;\">{{\"SETTINGS_ITEM_AVAILABILITY\" | translate}} <span class=\"availability-toggle__arrow\" ng-if=\"!availabilitySectionExpanded\"><i class=\"las la-angle-down\"></i></span> <span class=\"availability-toggle__arrow\" ng-if=\"availabilitySectionExpanded\"><i class=\"las la-angle-up\"></i></span></label><div class=\"item-availability\" ng-show=\"availabilitySectionExpanded\"><div class=\"availability-day-row\" ng-repeat=\"day in ctrl.availabilityDays track by day.key\"><div class=\"availability-weekday\"><div class=\"availability-day-header flex form\"><div class=\"col-md-3 col-xs-3\"><div class=\"form-check form-group\"><label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-control\" ng-model=\"ctrl.form.availability[day.key].enabled\"> {{day.label}}</label></div></div></div></div><div class=\"availability-ranges\" ng-if=\"ctrl.form.availability[day.key].enabled\"><div class=\"availability-row flex form\" ng-repeat=\"range in ctrl.form.availability[day.key].ranges track by $index\"><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_AVAILABILITY_FROM\" | translate}}</label><app-dropdown model=\"range.from\" options=\"ctrl.dates.hours\" searchable=\"true\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_AVAILABILITY_FROM\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label>{{\"SETTINGS_ITEM_AVAILABILITY_TO\" | translate}}</label><app-dropdown model=\"range.to\" options=\"ctrl.dates.hours\" searchable=\"true\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_ITEM_AVAILABILITY_TO\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\" style=\"padding-top: 25px;\"><button type=\"button\" class=\"btn icon circle small bordered red\" ng-click=\"ctrl.removeAvailabilityRange(day.key, $index)\" ng-if=\"ctrl.form.availability[day.key].ranges.length > 1\"><i class=\"las la-minus\"></i></button> <button type=\"button\" class=\"btn icon circle small bordered green\" ng-click=\"ctrl.addAvailabilityRange(day.key)\" ng-if=\"$last\"><i class=\"las la-plus\"></i></button></div></div></div></div></div></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12 item-df flex-form\"><label>{{\"DIGITAL_FORM_SEND_DIGITAL_FORM\" | translate}}</label><div class=\"form-group first last\"><app-dropdown model=\"ctrl.form.digital_form\" options=\"ctrl.digitalFormOptions\" value-prop=\"id\" searchable=\"true\" fixed-panel=\"true\" placeholder=\"{{\'DIGITAL_FORM_SEND_DIGITAL_FORM\' | translate}}\" search-placeholder=\"{{\'DIGITAL_FORM_SEND_DIGITAL_FORM\' | translate}}\"></app-dropdown></div><label>{{\"DIGITAL_FORM_SEND_TEXT_2\" | translate}}</label><div class=\"form-group first last\"><input type=\"number\" style=\"width:60px;\" ng-model=\"ctrl.form.digital_form_hour\" name=\"digital_form_hour\" class=\"form-control\"></div><label>{{\"DIGITAL_FORM_SEND_TEXT_3\" | translate}}</label><div class=\"form-group first last\"><app-dropdown model=\"ctrl.form.digital_form_option\" options=\"ctrl.digitalFormOptionOptions\" value-prop=\"id\" fixed-panel=\"true\" placeholder=\"{{\'DIGITAL_FORM_SEND_TEXT_3\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form fill\"><div class=\"col-md-12 mt-24\"><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"digital_form_once\"><input type=\"checkbox\" class=\"form-control\" id=\"digital_form_once\" ng-model=\"ctrl.form.digital_form_once\"> {{\"DIGITAL_FORM_ONCE\" | translate}}</label></div></div></div><div ng-if=\"ctrl.business.online_payments\"><div class=\"flex form fill last\"><div class=\"col-md-12 mt-24\"><div class=\"form-check form-group last\"><label class=\"form-check-label\" for=\"require_online_payment\"><input type=\"checkbox\" class=\"form-control\" id=\"require_online_payment\" ng-model=\"ctrl.form.require_online_payment\"> {{\"ITEM_REQUIRE_ONLINE_PAYMENT\" | translate}}</label></div></div></div><div ng-if=\"ctrl.form.require_online_payment\" class=\"flex form\"><div><div class=\"form-group\"><div class=\"radio-btn\"><input id=\"online_payment_type1\" type=\"radio\" name=\"online_payment_type\" ng-model=\"ctrl.form.online_payment_type\" value=\"1\"> <label for=\"online_payment_type1\">{{\'ITEM_FULL_ONLINE_PAYMENT\' | translate}}</label></div><div class=\"radio-btn\"><input id=\"online_payment_type2\" type=\"radio\" name=\"online_payment_type\" ng-model=\"ctrl.form.online_payment_type\" value=\"2\"> <label for=\"online_payment_type2\">{{\'ITEM_PREPAID_ONLINE_PAYMENT\' | translate}}</label></div></div></div><div ng-if=\"ctrl.form.online_payment_type == 2\"><div class=\"form-group\"><input type=\"number\" placeholder=\"{{\'ITEM_SUM_ONLINE_PAYMENT\' | translate}}\" ng-model=\"ctrl.form.online_payment_amount\" name=\"online_payment_amount\" class=\"form-control\"></div></div></div></div></div></div><div class=\"modal-footer end\"><a ng-if=\"ctrl.show_stock && isEdit && itemId && ctrl.form.item_type == \'sale\'\" ui-sref=\"app.settings.items.stock_log({item_id: {{itemId}}})\" class=\"start-position btn text border-green large\">{{\"SETTINGS_INFO_STOCK_LOG\" | translate}}</a> <button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"itemsForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/items/modules/items-list/items.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_ITEMS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24\"><button class=\"btn text primary large\" ui-sref=\"app.settings.items.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_ITEM_NEW\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_inactive()\" ng-model=\"ctrl.show_inactive\">{{\"SHOW_INACTIVE\" | translate}}</label></div><items-filter category-options=\"ctrl.categoryFilterOptions\" on-update=\"ctrl.onFilterUpdate()\"></items-filter><button class=\"btn icon default green\" ng-class=\"{\'loading\': ctrl.download_in_progress}\" ng-click=\"ctrl.downloadItemsData()\"><i class=\"las la-file-excel\"></i></button></div><div class=\"cloud-list\"><div class=\"circle-loader\" ng-if=\"ctrl.loading\"><span class=\"circle-loader__ring\"></span><div class=\"circle-loader__text\">{{\'LOADING\' | translate}}</div></div><div class=\"items-list-table\" ng-if=\"!ctrl.loading\"><table-column-settings ng-if=\"ctrl.fieldSettings && ctrl.fieldSettings.length > 0\" fields-list=\"ctrl.fieldSettings\" skip-fields=\"ctrl.stockSkipFields\" on-update=\"ctrl.onFieldsUpdate(fieldsList)\"></table-column-settings><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th ng-repeat=\"field in ctrl.visibleFields track by field.name\">{{field.translationKey | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop, disabled: ctrl.isSortingDisabled() }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.items.edit({id: {{row.id}}})\"><td width=\"1%\"><i class=\"drag-handle las la-braille\" ng-style=\"{\'pointer-events\': ctrl.isSortingDisabled() ? \'none\' : \'auto\'}\"></i></td><td ng-repeat=\"field in ctrl.visibleFields track by field.name\" ng-switch=\"field.name\"><div ng-switch-when=\"name\"><div class=\"bg-div\" ng-style=\"{\'background-color\': row.bg_color}\"></div><div ng-if=\"row.item_image\" class=\"item-pic-wrapper\"><img src=\"{{row.item_image}}\" alt=\"Image\" class=\"item-pic\"></div><span>{{row.name}}</span></div><span ng-switch-when=\"price\">{{row.price | price}}</span> <span ng-switch-when=\"categories\"><span ng-repeat=\"(index, categoryID) in row.categories track by $index\"><span ng-if=\"index > 0\">,</span>{{categories[categoryID].name}}</span></span> <span ng-switch-when=\"stock\"><span ng-if=\"row.item_type == \'sale\'\">{{row.stock}}</span></span> <span ng-switch-when=\"stock_action\"><button ng-if=\"row.item_type == \'sale\'\" class=\"btn icon bordered green have-tooltip\" tooltip=\"{{\'ITEM_STOCK\' | translate}}\" ng-click=\"d(); $event.stopPropagation(); ctrl.stockModal(row.id);\"><i class=\"las la-caret-square-up\"></i></button></span> <span ng-switch-when=\"item_type\"><span ng-if=\"row.item_type == \'service\'\">{{\"SERVICE\" | translate}}</span> <span ng-if=\"row.item_type == \'sale\'\">{{\"SALE\" | translate}}</span> <span ng-if=\"row.item_type == \'course\'\">{{\"COURSE\" | translate}}</span> <span ng-if=\"row.item_type == \'card\'\">{{\"CARD_ITEM_TYPE\" | translate}}</span></span> <span ng-switch-when=\"duration\">{{ctrl.formatDuration(row.duration)}}</span> <span ng-switch-when=\"customer_allowed_booking\">{{ctrl.formatYesNo(row.customer_allowed_booking)}}</span> <span ng-switch-when=\"inactive\">{{ctrl.formatYesNo(row.inactive)}}</span> <span ng-switch-when=\"digital_form\" class=\"items-list-cell-text\">{{ctrl.formatDigitalForm(row)}}</span> <span ng-switch-when=\"name_second\">{{ctrl.formatText(row.name_second)}}</span> <span ng-switch-when=\"break\">{{ctrl.formatBreak(row.break)}}</span> <span ng-switch-when=\"duration_second\">{{ctrl.formatDuration(row.duration_second)}}</span> <span ng-switch-when=\"require_online_payment\" class=\"items-list-cell-text\">{{ctrl.formatOnlinePayment(row)}}</span> <span ng-switch-when=\"description\" class=\"items-list-cell-text\">{{ctrl.formatText(row.description)}}</span> <span ng-switch-when=\"general_info\" class=\"items-list-cell-text\">{{ctrl.formatText(row.general_info)}}</span> <span ng-switch-when=\"specific_info\" class=\"items-list-cell-text\">{{ctrl.formatText(row.specific_info)}}</span> <span ng-switch-when=\"restriction\" class=\"items-list-cell-text\">{{ctrl.formatText(row.restriction)}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-facebook/leads.facebook.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_FACEBOOK\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"facebookForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div ng-repeat=\"item in ctrl.pages\">{{item.name}} - <span ng-if=\"item.subscribed*1 == 1\">{{\"SETTINGS_LEADS_FACEBOOK_SUBSCRIBED\" | translate}}</span> <span ng-if=\"item.subscribed*1 != 1\">{{\"SETTINGS_LEADS_FACEBOOK_NOT_SUBSCRIBED\" | translate}}</span></div><button type=\"button\" class=\"btn text border-primary\" ng-click=\"ctrl.loginFacebook()\"><i class=\"la la-facebook\"></i>{{ctrl.pages.length > 0 ? \"SETTINGS_LEADS_FACEBOOK_RECONNECT\" : \"SETTINGS_LEADS_FACEBOOK_CONNECT\" | translate}}</button></div></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.status\" options=\"ctrl.statuses\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'SETTINGS_LEADS_STATUSES\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"><div ng-messages=\"facebookForm.arrival_source.$error\" class=\"ng-messages\" ng-show=\"facebookForm.arrival_source.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-settings/leads.settings.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" id=\"settings\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_LEADS\" | translate }}</h3></div><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.notify\" options=\"ctrl.msgChannelOptions\" multiple=\"true\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'SETTINGS_LEADS_NOTIFY\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div></div></div><div class=\"settings-block leads\"><ul><li><a ui-sref=\"app.settings.leads.facebook\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"lab la-facebook\"></i></span><div><h6>{{\"SETTINGS_LEADS_FACEBOOK\" | translate}}</h6></div></a></li><li><a ui-sref=\"app.settings.leads.webhook\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-user-cog\"></i></span><div><h6>{{\"SETTINGS_LEADS_WEBHOOK\" | translate}}</h6></div></a></li><li class=\"green\"><a ui-sref=\"app.settings.leads.whatsapp\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-whatsapp\"></i></span><div><h6>{{\"SETTINGS_LEADS_WHATSAPP\" | translate}}</h6></div></a></li><li><a ui-sref=\"app.settings.leads.statuses\"><span class=\"settings-icon settings btn icon circle large\"><i class=\"la la-star\"></i></span><div><h6>{{\"SETTINGS_LEADS_STATUSES\" | translate}}</h6><p>{{\"SETTINGS_LEADS_STATUSES_MANAGE\" | translate}}</p></div></a></li></ul></div><div class=\"flex end gap-24 mt-24\"><button ng-click=\"ctrl.submitSettings()\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-statuses/leads.statuses.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings.leads\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_LEADS_STATUSES\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><button class=\"btn text primary large\" ui-sref=\"app.settings.leads.statuses.new\"><i class=\"las la-plus\"></i>{{\"SETTINGS_LEADS_STATUSES_CREATE\" | translate}}</button><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_LEADS_STATUSES_NAME\" | translate}}</th><th>{{\"SETTINGS_LEADS_STATUSES_DISPLAY\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.settings.leads.statuses.edit({id: {{row.id}}})\"><td><div class=\"bg-div\" ng-style=\"{\'background-color\': row.color ? row.color : \'#a9cfe8\'}\"></div><span>{{row.name}}</span></td><td style=\"width: 200px;\"><div style=\"width: 200px;\" class=\"form-group\"><app-dropdown model=\"row.type\" options=\"ctrl.displayTypeOptions\" value-prop=\"id\" fixed-panel=\"true\" on-change=\"ctrl.update(row)\" placeholder=\"{{\'SETTINGS_LEADS_STATUSES_DISPLAY\' | translate}}\"></app-dropdown></div><span style=\"display: none;\">{{row.type}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-statuses-new/leads.statuses.new.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_STATUSES_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"statusesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_LEADS_STATUSES_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"statusesForm.name.$error\" class=\"ng-messages\" ng-show=\"statusesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.type\" options=\"ctrl.displayTypeOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'SETTINGS_LEADS_STATUSES_DISPLAY\' | translate}}\" placeholder=\"{{\'SETTINGS_LEADS_STATUSES_DISPLAY\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-12\"><div class=\"form-group form-color inl\"><label>{{\"SETTINGS_LEADS_STATUSES_COLOR\" | translate}}</label> <input type=\"color\" ng-model=\"ctrl.form.color\" name=\"color\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"isEdit\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-webhook/leads.webhook.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_WEBHOOK\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"webhookForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><p>{{ctrl.url}}</p></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><p><b>{{\"SETTINGS_LEADS_WEBHOOK_TOKEN\" | translate}}:</b> {{ctrl.token}}</p></div></div><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.status\" options=\"ctrl.statuses\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'SETTINGS_LEADS_STATUSES\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"><div ng-messages=\"webhookForm.arrival_source.$error\" class=\"ng-messages\" ng-show=\"webhookForm.arrival_source.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/leads/modules/leads-whatsapp/leads.whatsapp.html","<div class=\"modal-form-inner\" id=\"leads-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_LEADS_WHATSAPP\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"whatsappForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.enabled\">{{\"SETTINGS_LEADS_WHATSAPP_ENABLED\" | translate}}</label></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.status\" options=\"ctrl.statuses\" value-prop=\"id\" label-prop=\"name\" label=\"{{\'SETTINGS_LEADS_STATUSES\' | translate}}\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label>{{\"SETTINGS_LEADS_ARRIVAL_SOURCE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.arrival_source\" name=\"arrival_source\" class=\"form-control\"><div ng-messages=\"whatsappForm.arrival_source.$error\" class=\"ng-messages\" ng-show=\"whatsappForm.arrival_source.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"statusesForm.$invalid || statusesForm.$pristine\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/logs/modules/logs-info/logs.info.html","<div class=\"modal-form-inner\" id=\"logs-info\"><div class=\"modal-head\"><h3 class=\"form-title\">{{transaction.document_number}} # {{\"SETTINGS_LOG_TR_TTL\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body document-buttons\"><div><a ng-href=\"{{transaction[\'document_invoice_receipt\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_invoice_receipt\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV_TAX\" | translate}}</a> <a ng-href=\"{{transaction[\'document_invoice\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_invoice\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV\" | translate}}</a> <a ng-href=\"{{transaction[\'document_receipt\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_receipt\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_ACC\" | translate}}</a> <a ng-href=\"{{transaction[\'document_proforma_invoice\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_proforma_invoice\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV_TR\" | translate}}</a> <a ng-href=\"{{transaction[\'document_credit\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_credit\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_INV_CR\" | translate}}</a> <a ng-href=\"{{transaction[\'document_cards-document\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_cards-document\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_CARD_TR\" | translate}}</a> <a ng-href=\"{{transaction[\'document_quotation\'].file}}\" target=\"_blank\" ng-if=\"transaction[\'document_quotation\'].file\" class=\"btn text purple large\"><i class=\"las la-clipboard-list\"></i>{{\"SETTINGS_LOG_QUOTATION\" | translate}}</a></div><div ng-if=\"!ctrl.isMobile\"><a ng-click=\"ctrl.printInvoice(transaction[\'document_invoice_receipt\'].file)\" ng-if=\"transaction[\'document_invoice_receipt\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_invoice\'].file)\" ng-if=\"transaction[\'document_invoice\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_receipt\'].file)\" ng-if=\"transaction[\'document_receipt\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_proforma_invoice\'].file)\" ng-if=\"transaction[\'document_proforma_invoice\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_credit\'].file)\" ng-if=\"transaction[\'document_credit\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_cards-document\'].file)\" ng-if=\"transaction[\'document_cards-document\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a> <a ng-click=\"ctrl.printInvoice(transaction[\'document_quotation\'].file)\" ng-if=\"transaction[\'document_quotation\'].file\" class=\"btn text blue large\"><i class=\"las la-print\"></i>{{\"CUSTOMERS_PRINT\" | translate}}</a></div><div ng-if=\"transaction[\'customer_phone\']\"><a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_invoice_receipt\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_invoice\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_receipt\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_proforma_invoice\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_credit\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_cards-document\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a> <a ng-click=\"ctrl.smsInvoice(transaction.id)\" ng-if=\"transaction[\'document_quotation\'].file\" class=\"btn text orange large\"><i class=\"las la-comment\"></i>{{\"SMS_INVOICE\" | translate}}</a></div><div ng-if=\"transaction.total > 0\"><button type=\"button\" ui-sref=\"app.cashbox.credit({transaction: {{transaction.id}}})\" ng-if=\"transaction.total > 0 && !transaction.quotation && !transaction.continuous_deal_id && !transaction.continuous_deal_type\" class=\"btn text success large\"><i class=\"las la-file-alt\"></i>{{\"SETTINGS_LOG_TR_CR\" | translate}}</button> <button type=\"button\" ui-sref=\"app.cashbox.quotation({transaction: transaction.id})\" ng-if=\"transaction.total > 0 && transaction.quotation\" class=\"btn text success large\"><i class=\"las la-file-alt\"></i>{{\"SETTINGS_LOG_TR_QUOTATION\" | translate}}</button></div><div><button type=\"button\" ui-sref=\"app.cashbox.quotation_edit({transaction: transaction.id, quotation: 1})\" ng-if=\"transaction.quotation\" class=\"btn text warning large\"><i class=\"las la-edit\"></i>{{\"EDIT_QUOTATION\" | translate}}</button></div></div></div>");
$templateCache.put("app/modules/settings/logs/modules/logs-list/logs.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.reports\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"REPORTS_TRANSACTIONS_HISTORY_LBL\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.cashbox\"><i class=\"las la-plus\"></i> {{\"SETTINGS_LOG_NEW_DEAL\" | translate}}</button><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div><div class=\"filter-button\" style=\"flex: none\" ng-if=\"!ctrl.show_continuous_deals\"><button type=\"button\" class=\"btn icon default\" ng-click=\"ctrl.openFilter()\"><span ng-show=\"(ctrl.filter | notEmptyCountFilter) > 0\" class=\"filter-count\">{{ctrl.filter | notEmptyCountFilter}}</span><i class=\"las la-filter\"></i></button><div ng-class=\"{\'filter-modal\': true, \'active\': ctrl.filterModal}\" ng-click=\"event.stopPropagation();\"><div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.filter.payment_type\" options=\"ctrl.paymentTypeOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'FILTER_PAYMENT_TYPE\' | translate}}\" placeholder=\"{{\'FILTER_PAYMENT_TYPE\' | translate}}\"></app-dropdown></div></div><div ng-if=\"ctrl.hasQuotationStatuses\"><div class=\"form-group\"><app-dropdown model=\"ctrl.filter.quotation_status_id\" options=\"ctrl.quotationStatusFilterOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'CUSTOMER_QUOTATION_STATUS\' | translate}}\" placeholder=\"{{\'CUSTOMER_QUOTATION_STATUS\' | translate}}\"></app-dropdown></div></div><div class=\"not-select\"><div class=\"flex nowrap gap-16\"><div><div class=\"form-group\"><label>{{\"FILTER_DATE_FROM\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.date_from || ctrl.filter.date_from == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter.date_from\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div><div><div class=\"form-group\"><label>{{\"FILTER_DATE_TO\" | translate}}</label> <input type=\"datetime\" class=\"form-control form-date\" ng-class=\"{\'empty-value\': !ctrl.filter.date_to || ctrl.filter.date_to == \'\'}\" auto-close=\"true\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.filter.date_to\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div><div class=\"not-select\"></div></div><div class=\"flex nowrap gap-16\"><a ng-click=\"ctrl.closeFilter()\" class=\"btn text border-primary large\">{{\"CLOSE_FILTER\" | translate}}</a> <a ng-click=\"ctrl.clearFilter()\" class=\"btn text border-red large\">{{\"CLEAR_FILTER\" | translate}}</a> <a ng-click=\"ctrl.applyFilter()\" class=\"btn text primary large\">{{\"APPLY_FILTER\" | translate}}</a></div></div></div></div></div><div class=\"flex gap-16\"><button ng-if=\"ctrl.enabled_retainers\" class=\"btn text large\" ng-class=\"ctrl.show_retainers ? \'primary\' : \'\'\" ng-click=\"ctrl.toggle_retainers()\">{{\"SHOW_RETAINERS\" | translate}}</button> <button class=\"btn text large\" ng-class=\"ctrl.show_pending_payments ? \'primary\' : \'\'\" ng-click=\"ctrl.toggle_pending_payments()\">{{\"SHOW_PENDING_PAYMENTS\" | translate}}</button> <button ng-if=\"ctrl.enabled_continuous_deal\" class=\"btn text large\" ng-class=\"ctrl.show_continuous_deals ? \'primary\' : \'\'\" ng-click=\"ctrl.toggle_continuous_deals()\">{{\"SHOW_CONTINUOUS_DEALS\" | translate}}</button></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"logs_dt\" class=\"customer-table-holder\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\"></table></div></div></div></div></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-capacity/resources.capacity.html","<div class=\"modal-form-inner\" id=\"capacity-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{capacityDate | date:\"dd/MM/yyyy\"}} - {{\"SETTINGS_RES_H_CAP\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"capacityForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"ctrl.formScreen == 0\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.start_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" label=\"{{\'SETTINGS_RES_START_S\' | translate}}\" placeholder=\"{{\'SETTINGS_RES_START_S\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.end_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" label=\"{{\'SETTINGS_RES_END_S\' | translate}}\" placeholder=\"{{\'SETTINGS_RES_END_S\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form fill\" ng-if=\"ctrl.form.has_second_shift\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.shift2_start_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_RES_START_S\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.shift2_end_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_RES_END_S\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"form-group\"><button type=\"button\" ng-if=\"!ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = true\" class=\"btn text border-primary\">{{\"SETTINGS_RES_ADD_S\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = false\" class=\"btn text border-red\">{{\"SETTINGS_RES_DEL_S\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.has_end_date\" options=\"ctrl.endDateOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'SETTINGS_RES_FORCE_S\' | translate}}\" placeholder=\"{{\'SETTINGS_RES_FORCE_S\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"ctrl.form.has_end_date == 1\"><div class=\"form-group\"><label>{{\"SETTINGS_RES_END_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.form.end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false)\" ng-if=\"capacityID\">{{\"SETTINGS_INFO_DEL\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-disabled=\"capacityForm.$invalid\" ng-click=\"ctrl.submit(false)\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 1\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_1\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.submit(false, false)\">{{\"SETTINGS_RES_EDIT\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.submit(false, true)\">{{\"SETTINGS_RES_EDIT_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 2\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_2\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.delete(false, false)\">{{\"SETTINGS_RES_DEL\" | translate}}</button> <button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false, true)\">{{\"SETTINGS_RES_DEL_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-form/resources.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_RES_ADD_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"resourcesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"worker_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image\" ng-style=\"{\'background-image\':\'url(\' + (ctrl.form.worker_avatar || \'assets/images/avatar.jpg\') + \')\', \'background-size\': \'cover\', \'background-position\': \'center\', \'background-repeat\': \'no-repeat\'}\"></div></label></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_RES_NAME_OF\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"resourcesForm.name.$error\" class=\"ng-messages\" ng-show=\"resourcesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_STATUS\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"1\"> <label>{{\"SETTINGS_RES_STATUS_ACTIVE\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"0\"> <label>{{\"SETTINGS_RES_STATUS_INACTIVE\" | translate}}</label></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_SALES_ACTIVE\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_DEFAULT\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"false\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"true\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_HIDE_ONLINE\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"resourcesForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.DeleteButton\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></div></div></div></form></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-list/resources.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3 ng-if=\"ctrl.bu_type == 2\">{{ \"SETTINGS_RESOURCE\" | translate }}</h3><h3 ng-if=\"ctrl.bu_type == 1\">{{ \"SETTINGS_STAFF\" | translate }}</h3></div><div><div class=\"flex full between mb-24 gap-16\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.settings.resources.new\" ng-if=\"ctrl.bu_type == 2\"><i class=\"las la-plus\"></i> {{\"SETTINGS_RES_NEW\" | translate}}</button> <button class=\"btn text primary large\" ui-sref=\"app.settings.resources.new\" ng-if=\"ctrl.bu_type == 1\"><i class=\"las la-plus\"></i> {{\"SETTINGS_EMP_NEW\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div><div class=\"flex gap-24 gap-24-m-8\"><div class=\"form-switch form-group first last\"><label><input type=\"checkbox\" ng-change=\"ctrl.change_inactive()\" ng-model=\"ctrl.show_inactive\">{{\"SHOW_INACTIVE\" | translate}}</label></div></div></div><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_RES_NAME\" | translate}}</th><th>{{\"SETTINGS_RES_STATUS\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_resource_card(row.id)\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar ? row.avatar : \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{row.name}}</td><td>{{row.status == 1 ? \"SETTINGS_RES_STATUS_ACTIVE\" : \"SETTINGS_RES_STATUS_INACTIVE\" | translate }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-permissions/resources.permissions.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_RES_PERMISSIONS\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"resourcesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><div ng-repeat=\"(key, permission) in ctrl.form.permissions\"><div class=\"form-switch form-group\"><label><input type=\"checkbox\" ng-model=\"permission.enabled\">{{\"SETTINGS_PERMISSIONS_\"+key.toUpperCase() | translate}}</label></div><div class=\"form-switch form-group margin-start-50\" ng-if=\"permission.enabled && permission.personal != undefined\"><label><input type=\"checkbox\" ng-model=\"permission.personal\">{{\"SETTINGS_PERMISSIONS_PERSONAL_\"+key.toUpperCase() | translate}}</label></div><div class=\"form-switch form-group margin-start-50\" ng-if=\"permission.enabled && permission.assigned != undefined\"><label><input type=\"checkbox\" ng-model=\"permission.assigned\">{{\"SETTINGS_PERMISSIONS_ASSIGNED_\"+key.toUpperCase() | translate}}</label></div></div><div ng-init=\"customerSummaryExpanded = false\" class=\"margin-top-16\"><label class=\"expand-toggle\" ng-click=\"customerSummaryExpanded = !customerSummaryExpanded\" style=\"cursor: pointer;\">{{\"SETTINGS_PERMISSIONS_CUSTOMER_SUMMARY_DETAILS\" | translate}} <span ng-if=\"!customerSummaryExpanded\"><i class=\"las la-angle-down\"></i></span> <span ng-if=\"customerSummaryExpanded\"><i class=\"las la-angle-up\"></i></span></label><div ng-show=\"customerSummaryExpanded\" class=\"margin-start-50 margin-top-8\"><div class=\"form-switch form-group\" ng-repeat=\"optKey in ctrl.summaryDetailKeys\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.permissions.customer_summary_details[optKey]\">{{\"SETTINGS_PERM_SUMMARY_\"+optKey.toUpperCase() | translate}}</label></div></div></div><div ng-init=\"customerTabsExpanded = false\" class=\"margin-top-16\"><label class=\"expand-toggle\" ng-click=\"customerTabsExpanded = !customerTabsExpanded\" style=\"cursor: pointer;\">{{\"SETTINGS_PERMISSIONS_CUSTOMER_TABS\" | translate}} <span ng-if=\"!customerTabsExpanded\"><i class=\"las la-angle-down\"></i></span> <span ng-if=\"customerTabsExpanded\"><i class=\"las la-angle-up\"></i></span></label><div ng-show=\"customerTabsExpanded\" class=\"margin-start-50 margin-top-8\"><div class=\"form-switch form-group\" ng-repeat=\"optKey in ctrl.tabKeys\"><label><input type=\"checkbox\" ng-model=\"ctrl.form.permissions.customer_tabs[optKey]\">{{\"SETTINGS_PERM_TAB_\"+optKey.toUpperCase() | translate}}</label></div></div></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"resourcesForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/settings/resources/modules/resources-single/resources.single.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ui-sref=\"^.\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"SETTINGS_RES_CAP_SET\" | translate}} - {{resource.name}}</h3></div></div><div id=\"resource\" ng-if=\"resource != null\"><div class=\"modal-body\"><div class=\"flex form\"><div><div class=\"form-group last\"><app-dropdown model=\"ctrl.resource_view_type\" options=\"ctrl.resourceViewOptions\" value-prop=\"value\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.changeShiftsView(model)\"></app-dropdown></div></div><div><div class=\"resource-date-picker\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.prevWeek();\" class=\"btn icon\"><i class=\"las la-angle-right rotatable\"></i></button></span><div class=\"inputs-wrapper\"><input type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.capacityDate\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.nextWeek();\" class=\"btn icon\"><i class=\"las la-angle-left rotatable\"></i></button></span></div></div></div><div class=\"flex form\"><button class=\"btn icon circle large default\" ui-sref=\"app.settings.resources.edit(ctrl.edit_params)\"><i class=\"las la-edit\"></i></button> <button ng-if=\"resource.user_id && (userRole == 0 || userRole == 4)\" class=\"btn icon circle large default\" ui-sref=\"app.settings.resources.edit_permissions(ctrl.edit_params)\"><i class=\"las la-check-circle\"></i></button></div></div><div class=\"capacity-block\"><div class=\"capacity-days\" ng-class=\"{\'loading\': ctrl.loading}\"><div class=\"capacity-day\" ng-repeat=\"(index, capacityRow) in capacityData track by $index\"><h4 class=\"info-title\">{{datesProvider.daysNames[index]}} {{\"SETTINGS_RES_A_DAY\" | translate}} <span class=\"date\">{{capacityRow.date*1000 | date: \"dd/MM/yyyy\"}}</span></h4><div class=\"capacity-hours\"><button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time == null\">{{\"SETTINGS_RES_SET_H\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time != null\">{{capacityRow.start_time | hourAndMinute}} - {{capacityRow.end_time | hourAndMinute}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.shift2_end_time\">{{capacityRow.shift2_start_time | hourAndMinute}} - {{capacityRow.shift2_end_time | hourAndMinute}}</button></div><div ng-if=\"false && ctrl.resource_view_type == 2\"><div class=\"form-group last\"><app-dropdown model=\"capacityRow.multiple_book\" options=\"[ {value: \'1\', name: (\'SETTINGS_RES_MULTIPLE_BOOK\' | translate) + \': 1\'}, {value: \'2\', name: (\'SETTINGS_RES_MULTIPLE_BOOK\' | translate) + \': 2\'}, {value: \'3\', name: (\'SETTINGS_RES_MULTIPLE_BOOK\' | translate) + \': 3\'} ]\" value-prop=\"value\" label-prop=\"name\" fixed-panel=\"true\"></app-dropdown></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-capacity/second_resources.capacity.html","<div class=\"modal-form-inner\" id=\"capacity-form\"><div class=\"modal-head\"><h3 class=\"form-title\">{{capacityDate | date:\"dd/MM/yyyy\"}} - {{\"SETTINGS_RES_H_CAP\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"capacityForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"ctrl.formScreen == 0\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.start_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" label=\"{{\'SETTINGS_RES_START_S\' | translate}}\" placeholder=\"{{\'SETTINGS_RES_START_S\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.end_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" label=\"{{\'SETTINGS_RES_END_S\' | translate}}\" placeholder=\"{{\'SETTINGS_RES_END_S\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form fill\" ng-if=\"ctrl.form.has_second_shift\"><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.shift2_start_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_RES_START_S\' | translate}}\"></app-dropdown></div></div><div><div class=\"form-group\"><app-dropdown model=\"ctrl.form.shift2_end_time\" options=\"datesProvider.hours\" fixed-panel=\"true\" placeholder=\"{{\'SETTINGS_RES_END_S\' | translate}}\"></app-dropdown></div></div></div><div class=\"flex form\"><div class=\"form-group\"><button type=\"button\" ng-if=\"!ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = true\" class=\"btn text border-primary\">{{\"SETTINGS_RES_ADD_S\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.form.has_second_shift\" ng-click=\"ctrl.form.has_second_shift = false\" class=\"btn text border-red\">{{\"SETTINGS_RES_DEL_S\" | translate}}</button></div></div><div class=\"flex form\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.has_end_date\" options=\"ctrl.endDateOptions\" value-prop=\"id\" fixed-panel=\"true\" label=\"{{\'SETTINGS_RES_FORCE_S\' | translate}}\" placeholder=\"{{\'SETTINGS_RES_FORCE_S\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"ctrl.form.has_end_date == 1\"><div class=\"form-group\"><label>{{\"SETTINGS_RES_END_DATE\" | translate}}</label> <input type=\"datetime\" class=\"form-control\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.form.end_date\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false)\" ng-if=\"capacityID\">{{\"SETTINGS_INFO_DEL\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-disabled=\"capacityForm.$invalid\" ng-click=\"ctrl.submit(false)\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 1\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_1\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.submit(false, false)\">{{\"SETTINGS_RES_EDIT\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.submit(false, true)\">{{\"SETTINGS_RES_EDIT_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div><div ng-if=\"ctrl.formScreen == 2\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\">{{\"SETTINGS_RES_QUEST_2\" | translate}}</div></div><div class=\"modal-footer end\"><button type=\"button\" class=\"btn text border-primary large\" ng-click=\"ctrl.delete(false, false)\">{{\"SETTINGS_RES_DEL\" | translate}}</button> <button type=\"button\" class=\"btn text border-red large\" ng-click=\"ctrl.delete(false, true)\">{{\"SETTINGS_RES_DEL_THIS\" | translate}}</button> <button type=\"button\" class=\"btn text primary large\" ng-click=\"ctrl.formScreen = 0\">{{\"SETTINGS_RES_PREV\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-form/second_resources.form.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"SETTINGS_RES_ADD_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form class=\"modal-form_f\" name=\"resourcesForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"flex form fill\"><div><div class=\"form-group\"><label class=\"import-file\"><input style=\"visibility: hidden; display: none;\" type=\"file\" name=\"worker_avatar\" onchange=\"angular.element(this).scope().uploadImage(this)\"><div class=\"image\" ng-style=\"{\'background-image\':\'url(\' + (ctrl.form.worker_avatar || \'assets/images/avatar.jpg\') + \')\', \'background-size\': \'cover\', \'background-position\': \'center\', \'background-repeat\': \'no-repeat\'}\"></div></label></div></div></div><div class=\"flex form fill\"><div><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_RES_NAME_OF\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\"><div ng-messages=\"resourcesForm.name.$error\" class=\"ng-messages\" ng-show=\"resourcesForm.name.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_INFO_FIELD_VALID\" | translate}}</div></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_STATUS\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"1\"> <label>{{\"SETTINGS_RES_STATUS_ACTIVE\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"status\" ng-model=\"ctrl.form.status\" value=\"0\"> <label>{{\"SETTINGS_RES_STATUS_INACTIVE\" | translate}}</label></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_SALES_ACTIVE\" | translate}}:</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"sales_active\" ng-model=\"ctrl.form.sales_active\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_DEFAULT\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"false\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"is_default\" ng-model=\"ctrl.form.is_default\" value=\"true\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div><div class=\"flex form\"><div><div class=\"form-group\"><label class=\"settings_label\">{{\"SETTINGS_RES_HIDE_ONLINE\" | translate}}</label><br><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"0\"> <label>{{\"OPTION_NO\" | translate}}</label></div><div class=\"radio-btn\"><input type=\"radio\" name=\"hide_online\" ng-model=\"ctrl.form.hide_online\" value=\"1\"> <label>{{\"OPTION_YES\" | translate}}</label></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"resourcesForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button type=\"button\" ng-if=\"ctrl.DeleteButton\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></div></div></div></form></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-list/second_resources.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ctrl.second_resource_name}} {{ \"SETTINGS_SECOND_STAFF\" | translate }}</h3></div><div><div class=\"flex full between mb-24\"><div class=\"flex gap-24 gap-24-m-8\"><button class=\"btn text primary large\" ui-sref=\"app.settings.second_resources.new\"><i class=\"las la-plus\"></i> {{\"SETTINGS_EMP_NEW\" | translate}}</button><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><table class=\"sorted-table\"><thead><tr><th width=\"1%\"></th><th>{{\"SETTINGS_RES_NAME\" | translate}}</th><th>{{\"SETTINGS_RES_STATUS\" | translate}}</th></tr></thead><tbody ui-sortable=\"{ handle: \'.drag-handle\', stop: ctrl.drop }\" ng-model=\"ctrl.tableData\"><tr ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.open_resource_card(row.id)\"><td width=\"1%\"><i class=\"drag-handle las la-braille\"></i></td><td><div class=\"customer-pic-wrapper\"><img src=\"{{row.avatar ? row.avatar : \'assets/images/avatar.jpg\'}}\" alt=\"User Profile\" class=\"customer-pic\"></div>{{row.name}}</td><td>{{row.status == 1 ? \"SETTINGS_RES_STATUS_ACTIVE\" : \"SETTINGS_RES_STATUS_INACTIVE\" | translate }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/settings/second_resources/modules/second-resources-single/second_resources.single.html","<div class=\"modal-form-inner tabs-form\" id=\"customers-form\"><div class=\"modal-head\"><a class=\"btn icon default\" ui-sref=\"^.\"><i class=\"las la-angle-right rotatable\"></i></a><div><h3 class=\"form-title\">{{\"SETTINGS_RES_CAP_SET\" | translate}} - {{second_resource.name}}</h3></div></div><div id=\"resource\" ng-if=\"second_resource != null\"><div class=\"modal-body\"><div class=\"flex form\"><div><div class=\"form-group last\"><app-dropdown model=\"ctrl.resource_view_type\" options=\"ctrl.resourceViewOptions\" value-prop=\"value\" label-prop=\"name\" fixed-panel=\"true\" on-change=\"ctrl.changeShiftsView(model)\"></app-dropdown></div></div><div><div class=\"resource-date-picker\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.prevWeek();\" class=\"btn icon\"><i class=\"las la-angle-right rotatable\"></i></button></span><div class=\"inputs-wrapper\"><input type=\"text\" name=\"\" ng-model=\"ctrl.displayDate\" class=\"form-control show-input\"> <input type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" auto-close=\"true\" ng-model=\"ctrl.capacityDate\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.nextWeek();\" class=\"btn icon\"><i class=\"las la-angle-left rotatable\"></i></button></span></div></div></div><div><button class=\"btn icon circle large default\" ui-sref=\"app.settings.second_resources.edit(ctrl.edit_params)\"><i class=\"las la-edit\"></i></button></div></div><div class=\"capacity-block\"><div class=\"capacity-days\" ng-class=\"{\'loading\': ctrl.loading}\"><div class=\"capacity-day\" ng-repeat=\"(index, capacityRow) in capacityData track by $index\"><h4 class=\"info-title\">{{datesProvider.daysNames[index]}} {{\"SETTINGS_RES_A_DAY\" | translate}} <span class=\"date\">{{capacityRow.date*1000 | date: \"dd/MM/yyyy\"}}</span></h4><div class=\"capacity-hours\"><button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time == null\">{{\"SETTINGS_RES_SET_H\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.start_time != null\">{{capacityRow.start_time | hourAndMinute}} - {{capacityRow.end_time | hourAndMinute}}</button> <button type=\"button\" ng-click=\"ctrl.capacityForm(capacityRow.date);\" class=\"btn text border-primary\" ng-if=\"capacityRow.shift2_end_time\">{{capacityRow.shift2_start_time | hourAndMinute}} - {{capacityRow.shift2_end_time | hourAndMinute}}</button></div><div ng-if=\"false && ctrl.resource_view_type == 2\"><div class=\"form-group last\"><app-dropdown model=\"capacityRow.multiple_book\" options=\"[ {value: \'1\', name: (\'SETTINGS_RES_MULTIPLE_BOOK\' | translate) + \': 1\'}, {value: \'2\', name: (\'SETTINGS_RES_MULTIPLE_BOOK\' | translate) + \': 2\'}, {value: \'3\', name: (\'SETTINGS_RES_MULTIPLE_BOOK\' | translate) + \': 3\'} ]\" value-prop=\"value\" label-prop=\"name\" fixed-panel=\"true\"></app-dropdown></div></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/settings/sms_logs/modules/sms_logs/sms_logs.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\"><div class=\"cloud\"><div class=\"cloud-head\"><button class=\"btn icon default\" ui-sref=\"app.settings\"><i class=\"las la-angle-right rotatable\"></i></button><h3>{{ \"SETTINGS_SMS_LOGS\" | translate }}</h3></div><div><div class=\"flex gap-24 gap-24-m-8 mb-24 nowrap\"><div><div class=\"form-group icon-prepend last\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.find_table()\" ng-model=\"ctrl.search_value\" class=\"form-control\"></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"smslog_dt\" ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th style=\"width: auto !important;\">{{\"SETTINGS_SMS_LOGS_DATE\" | translate}}</th><th style=\"width: auto !important;\">{{\"SETTINGS_SMS_LOGS_CUSTOMER\" | translate}}</th><th style=\"min-width: 40%; width: auto !important;\">{{\"SETTINGS_SMS_LOGS_TEXT\" | translate}}</th><th style=\"min-width: 30%; width: auto !important;\">{{\"SETTINGS_SMS_LOGS_STATUS\" | translate}}</th><th style=\"min-width: 5%; width: auto !important;\"></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td><span ng-hide=\"true\">{{row.created_at | toUnixTimestamp }}</span> <span>{{row.sent}}</span></td><td><span>{{row.customer ? row.customer : row.mobile}}</span></td><td><span>{{row.message}}</span></td><td>{{row.updated}} - <span ng-if=\"!row.error\">{{\"SETTINGS_SMS_LOGS_STATUS_SENT\" | translate}}</span> <span ng-if=\"row.error\"><span ng-if=\"row.error == \'Delivered\'\">{{\"SETTINGS_SMS_LOGS_STATUS_DELIVERED\" | translate}}</span> <span ng-if=\"row.error != \'Delivered\'\">{{row.error}}</span></span></td><td><span ng-if=\"row.wa\" class=\"btn icon circle small bordered green\"><i class=\"lab la-whatsapp\"></i></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/ai-prompts/modules/ai-prompts-list/ai-prompts-list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\" style=\"display: flex; gap: 16px; flex-wrap: wrap;\"><div class=\"form-group\" style=\"width: 250px;\"><app-dropdown model=\"ctrl.filter.businessId\" options=\"ctrl.businessOptions\" value-prop=\"id\" searchable=\"true\" label=\"{{\'ADMIN_AI_BUSINESS\' | translate}}\" placeholder=\"{{\'ADMIN_AI_BUSINESS\' | translate}}\" search-placeholder=\"{{\'ADMIN_AI_BUSINESS\' | translate}}\"></app-dropdown></div><div class=\"form-group\" style=\"width: 220px;\"><app-dropdown model=\"ctrl.filter.rating\" options=\"ctrl.ratingOptions\" value-prop=\"value\" label=\"{{\'ADMIN_AI_RATING\' | translate}}\" placeholder=\"{{\'ADMIN_AI_RATING\' | translate}}\"></app-dropdown></div><div class=\"form-group\" style=\"flex: 1; min-width: 260px;\"><label>{{\"ADMIN_AI_SEARCH\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.filter.search\" placeholder=\'{{\"ADMIN_AI_SEARCH_PLACEHOLDER\" | translate}}\'></div></div><div class=\"table-holder\" ng-if=\"!ctrl.isLoading\"><div class=\"table-responsive\"><table datatable=\"ng\" dt-options=\"ctrl.dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"ADMIN_AI_COL_PROMPT\" | translate}}</th><th>{{\"ADMIN_AI_COL_BUSINESS\" | translate}}</th><th>{{\"ADMIN_AI_COL_USER\" | translate}}</th><th>{{\"ADMIN_AI_COL_STATUS\" | translate}}</th><th>{{\"ADMIN_AI_COL_RATING\" | translate}}</th><th>{{\"ADMIN_AI_COL_DATE\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"prompt in ctrl.prompts\" ui-sref=\"app.admin.ai-prompts.single({id: prompt.query_id})\"><td style=\"max-width: 500px; white-space: normal;\">{{prompt.prompt}}</td><td>{{prompt.business_name}}</td><td>{{prompt.user_name}} ({{prompt.user_email}})</td><td>{{prompt.status}}</td><td><div class=\"ai-single-pair\"><span ng-if=\"prompt.rating === true\" class=\"label label-success\">{{\'ADMIN_AI_RATING_POSITIVE\' | translate}}</span> <span ng-if=\"prompt.rating === false\" class=\"label label-danger\">{{\'ADMIN_AI_RATING_NEGATIVE\' | translate}}</span> <span ng-if=\"prompt.rating === null\" class=\"label label-default\">{{\'ADMIN_AI_RATING_NOT_MARKED\' | translate}}</span> <span ng-if=\"prompt.feedback_resolved_at\"><i class=\"lar la-check-circle green\"></i></span></div></td><td data-order=\"{{prompt.created_ts}}\">{{(prompt.created_ts * 1000) | date:\'dd/MM/yyyy HH:mm\'}}</td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/ai-prompts/modules/ai-prompts-single/ai-prompts-single.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{ctrl.prompt.prompt}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"ai-single-col\"><div class=\"ai-single-row\"><div class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_STATUS\" | translate}}:</p><p><b>{{ctrl.prompt.status}}</b></p></div><div class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_RATING\" | translate}}:</p><span ng-if=\"ctrl.prompt.rating === true\" class=\"label label-success\">{{\'ADMIN_AI_RATING_POSITIVE\' | translate}}</span> <span ng-if=\"ctrl.prompt.rating === false\" class=\"label label-danger\">{{\'ADMIN_AI_RATING_NEGATIVE\' | translate}}</span> <span ng-if=\"ctrl.prompt.rating === null\" class=\"label label-default\">{{\'ADMIN_AI_RATING_NOT_MARKED\' | translate}}</span><p ng-if=\"ctrl.prompt.feedback_resolved_at\"><i class=\"lar la-check-circle green\"></i></p></div><div ng-if=\"ctrl.prompt.model\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_MODEL\" | translate}}:</p><p><b>{{ctrl.prompt.model}}</b></p></div><div ng-if=\"ctrl.prompt.compile_ms\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_COMPILE\" | translate}}:</p><p><b>{{ctrl.prompt.compile_ms / 1000}}s</b></p></div><div ng-if=\"ctrl.prompt.exec_ms\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_EXEC\" | translate}}:</p><p><b>{{ctrl.prompt.exec_ms / 1000}}s</b></p></div><div ng-if=\"ctrl.prompt.render_ms\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_RENDER\" | translate}}:</p><p><b>{{ctrl.prompt.render_ms / 1000}}s</b></p></div><div ng-if=\"ctrl.prompt.total_ms\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_TOTAL\" | translate}}:</p><p><b>{{ctrl.prompt.total_ms / 1000}}s</b></p></div></div><p ng-if=\"ctrl.prompt.error_message\" class=\"ai-single-error\">{{ctrl.prompt.error_message}}</p><div ng-if=\"ctrl.prompt.router_input_json\" class=\"ai-single-section\"><p class=\"ai-single-header\">{{\"ADMIN_AI_ZERO_LAYER\" | translate}}</p><div class=\"ai-single-row\"><div ng-if=\"ctrl.prompt.route_normalized_request\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_NORMALIZED\" | translate}}:</p><p><b>{{ctrl.prompt.route_normalized_request}}</b></p></div><div ng-if=\"ctrl.prompt.route_model\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_DOMAIN\" | translate}}:</p><p><b>{{ctrl.prompt.route_model}}</b></p></div><div ng-if=\"ctrl.prompt.router_action\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_ACTION\" | translate}}:</p><p><b>{{ctrl.prompt.router_action}}</b></p></div><div ng-if=\"ctrl.prompt.router_session_scope\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_SESSION_SCOPE\" | translate}}:</p><p><b>{{ctrl.prompt.router_session_scope}}</b></p></div></div></div><div ng-if=\"ctrl.prompt.dsl_json || ctrl.kbDocIds.length\" class=\"ai-single-section\"><p class=\"ai-single-header\">{{\"ADMIN_AI_PROCESSING_LAYER\" | translate}}</p><div class=\"ai-single-row\"><div ng-if=\"ctrl.prompt.dsl_json\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_DSL\" | translate}}:</p><div class=\"ai-single-icons\"><div class=\"ai-single-icon blue\" ng-click=\"ctrl.openJsonModal(\'dsl_json\')\"><i class=\"las la-eye\"></i></div><div class=\"ai-single-icon orange\" ng-click=\"ctrl.copyJson(\'dsl_json\')\"><i class=\"las\" ng-class=\"ctrl.copied.dsl_json ? \'la-check\' : \'la-copy\'\"></i></div></div></div><div ng-if=\"ctrl.prompt.dsl_after_pipeline_json\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_DSL_PIPELINE\" | translate}}:</p><div class=\"ai-single-icons\"><div class=\"ai-single-icon blue\" ng-click=\"ctrl.openJsonModal(\'dsl_after_pipeline_json\')\"><i class=\"las la-eye\"></i></div><div class=\"ai-single-icon orange\" ng-click=\"ctrl.copyJson(\'dsl_after_pipeline_json\')\"><i class=\"las\" ng-class=\"ctrl.copied.dsl_after_pipeline_json ? \'la-check\' : \'la-copy\'\"></i></div></div></div><div ng-if=\"ctrl.prompt.sql_text\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_SQL\" | translate}}:</p><div class=\"ai-single-icons\"><div class=\"ai-single-icon blue\" ng-click=\"ctrl.openJsonModal(\'sql_text\')\"><i class=\"las la-eye\"></i></div><div class=\"ai-single-icon orange\" ng-click=\"ctrl.copyJson(\'sql_text\')\"><i class=\"las\" ng-class=\"ctrl.copied.sql_text ? \'la-check\' : \'la-copy\'\"></i></div></div></div><div ng-if=\"ctrl.kbDocIds.length\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_ARTICLES\" | translate}}:</p><a ng-href=\"{{ctrl.kbArticlesUrl}}\" target=\"_blank\">{{ctrl.kbDocIds.length}} {{ ctrl.kbDocIds.length === 1 ? (\'ADMIN_AI_ARTICLE\' | translate) : (\'ADMIN_AI_ARTICLES\' | translate) }}</a></div></div></div><div ng-if=\"ctrl.prompt.render_json\" class=\"ai-single-section\"><p class=\"ai-single-header\">{{\"ADMIN_AI_RENDER_LAYER\" | translate}}</p><div class=\"ai-single-row\"><div ng-if=\"ctrl.prompt.render_json\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_RENDER_DSL\" | translate}}:</p><div class=\"ai-single-icons\"><div class=\"ai-single-icon blue\" ng-click=\"ctrl.openJsonModal(\'render_json\')\"><i class=\"las la-eye\"></i></div><div class=\"ai-single-icon orange\" ng-click=\"ctrl.copyJson(\'render_json\')\"><i class=\"las\" ng-class=\"ctrl.copied.render_json ? \'la-check\' : \'la-copy\'\"></i></div></div></div></div></div><div ng-if=\"ctrl.session_dialog\" class=\"ai-single-section\"><p class=\"ai-single-header\">{{\"ADMIN_AI_SESSION\" | translate}}</p><div ng-if=\"ctrl.prompt.session_id\" class=\"ai-single-pair\"><p>{{\"ADMIN_AI_COL_SESSION_ID\" | translate}}:</p><p><b>{{ctrl.prompt.session_id}}</b></p></div><div class=\"ai-session-thread\"><div ng-repeat=\"item in ctrl.session_dialog\"><a ng-if=\"item.query_id != ctrl.prompt.query_id\" href=\"\" ng-click=\"ctrl.loadPrompt(item.query_id); $event.preventDefault();\"><b>#{{item.query_id}}</b> — {{item.prompt}}</a><p ng-if=\"item.query_id == ctrl.prompt.query_id\"><b>#{{item.query_id}}</b> — {{item.prompt}}</p></div></div></div></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ng-if=\"ctrl.prompt.rating === false && !ctrl.prompt.feedback_resolved_at\" ng-click=\"ctrl.resolve()\" class=\"btn text primary large\">{{\"ADMIN_AI_RESOLVE\" | translate}}</button> <button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button></div></div>");
$templateCache.put("app/modules/admin/modules/ai-sessions/modules/ai-sessions-history/ai-sessions-history.view.html","<div class=\"modal-form-inner tabs-form\" id=\"agent-booking-history-modal\"><div class=\"modal-head\"><h3 class=\"form-title\">AI Sessions Messages</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body ab-history-chat-body\"><div ng-if=\"ctrl.loading\" class=\"ab-history-loading\">{{ \"LOADING\" | translate }}...</div><div ng-if=\"!ctrl.loading && !ctrl.messages.length\" class=\"ab-history-empty\">No messages found</div><div class=\"ab-history-message\" ng-repeat=\"msg in ctrl.messages track by $index\" ng-class=\"{ \'ab-history-message--assistant\': (msg.role || \'assistant\') === \'assistant\', \'ab-history-message--user\': msg.role === \'user\' }\"><div class=\"ab-history-message-role\">{{ (msg.role || \'assistant\') | uppercase }}</div><div class=\"ab-history-message-text\">{{ msg.content || msg.text || msg.message || \'\' }}</div></div></div><div class=\"modal-footer end top-padding\"><app-button type=\"button\" color=\"border-primary\" ng-click=\"$close();\" ng-disabled=\"ctrl.loading\"><span ng-if=\"ctrl.loading\"><i class=\"las la-spinner la-spin\"></i> {{ \"LOADING\" | translate }}...</span> <span ng-if=\"!ctrl.loading\">{{ \"CLOSE\" | translate }}</span></app-button></div></div>");
$templateCache.put("app/modules/admin/modules/ai-sessions/modules/ai-sessions-list/ai-sessions-list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\"><div class=\"form-group icon-prepend last\" style=\"max-width: 320px;\"><i class=\"las la-search\"></i> <input type=\"text\" autocomplete=\"off\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-change=\"ctrl.reload()\" ng-model=\"ctrl.search\" class=\"form-control\"></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"admin_ai_sessions_dt\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstanceCallback\" class=\"table table-striped table-bordered table-hover dataTables-example\"></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/ai-support/modules/ai-support-files/ai-support-files.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\" style=\"display: flex; gap: 16px; flex-wrap: wrap;\"><div class=\"form-group\" style=\"padding-top: 28px;\"><button class=\"btn icon default\" ui-sref=\"app.admin.ai-support\"><i class=\"las la-angle-right rotatable\"></i></button></div><div class=\"form-group\" style=\"width: 250px;\"><app-dropdown model=\"ctrl.filter.businessId\" options=\"ctrl.businessOptions\" value-prop=\"id\" searchable=\"true\" label=\"{{\'ADMIN_AI_BUSINESS\' | translate}}\" placeholder=\"{{\'ADMIN_AI_BUSINESS\' | translate}}\" search-placeholder=\"{{\'ADMIN_AI_BUSINESS\' | translate}}\"></app-dropdown></div><div class=\"form-group\" style=\"flex: 1; min-width: 260px;\"><label>{{\"ADMIN_AI_SEARCH\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.filter.search\" placeholder=\'{{\"ADMIN_AI_SUPPORT_SEARCH_PLACEHOLDER\" | translate}}\'></div><div class=\"form-group\" style=\"padding-top: 26px;\"><label class=\"btn text primary large\"><i class=\"las\" ng-class=\"ctrl.isLoading ? \'la-spinner la-spin\' : \'la-plus\'\"></i> {{\"ADMIN_AI_UPLOAD_FILE\" | translate}} <input style=\"visibility: hidden; display: none;\" type=\"file\" ng-disabled=\"ctrl.isLoading || ctrl.globalBusy\" name=\"document\" accept=\".pdf\" onchange=\"angular.element(this).scope().uploadFile(this)\"></label></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table datatable=\"\" dt-options=\"ctrl.dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstance\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"ADMIN_AI_COL_FILENAME\" | translate}}</th><th>{{\"ADMIN_AI_COL_BUSINESS\" | translate}}</th><th>{{\"ADMIN_AI_COL_STATUS\" | translate}}</th><th>{{\"ADMIN_AI_COL_SECTIONS\" | translate}}</th><th>{{\"ADMIN_AI_COL_ARTICLES\" | translate}}</th><th>{{\"ADMIN_AI_COL_ACTIONS\" | translate}}</th></tr></thead><tbody></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/ai-support/modules/ai-support-list/ai-support-list.view.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\" style=\"display: flex; gap: 16px; flex-wrap: wrap;\"><div class=\"form-group\" style=\"width: 250px;\"><app-dropdown model=\"ctrl.filter.category\" options=\"ctrl.categoryOptions\" value-prop=\"id\" searchable=\"true\" label=\"{{\'ADMIN_AI_CATEGORIES\' | translate}}\" placeholder=\"{{\'ADMIN_AI_CATEGORIES\' | translate}}\" search-placeholder=\"{{\'ADMIN_AI_CATEGORIES\' | translate}}\"></app-dropdown></div><div class=\"form-group\" style=\"width: 220px;\"><app-dropdown model=\"ctrl.filter.tags\" options=\"ctrl.tags\" multiple=\"true\" searchable=\"true\" label=\"{{\'ADMIN_AI_TAGS\' | translate}}\" placeholder=\"{{\'ADMIN_AI_ALL_TAGS\' | translate}}\" search-placeholder=\"{{\'ADMIN_AI_TAGS\' | translate}}\"></app-dropdown></div><div class=\"form-group\" style=\"flex: 1; min-width: 260px;\"><label>{{\"ADMIN_AI_IDS\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.filter.ids\" placeholder=\"1,2,4,5\"></div><div class=\"form-group\" style=\"flex: 1; min-width: 260px;\"><label>{{\"ADMIN_AI_SEARCH\" | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.filter.search\" placeholder=\'{{\"ADMIN_AI_SUPPORT_SEARCH_PLACEHOLDER\" | translate}}\'></div><div class=\"form-group\" style=\"padding-top: 26px;\"><button type=\"button\" ui-sref=\"app.admin.ai-support.new\" class=\"btn text primary large\">{{\"ADMIN_AI_CREATE_ARTICLE\" | translate}}</button></div><div class=\"form-group\" style=\"padding-top: 26px;\"><button type=\"button\" ui-sref=\"app.admin.ai-support.files\" class=\"btn text primary large\">{{\"ADMIN_AI_UPLOAD_FILES\" | translate}}</button></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table datatable=\"\" dt-options=\"ctrl.dtOptions\" dt-columns=\"ctrl.dtColumns\" dt-instance=\"ctrl.dtInstance\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"ADMIN_AI_COL_ID\" | translate}}</th><th>{{\"ADMIN_AI_COL_TITLE\" | translate}}</th><th>{{\"ADMIN_AI_COL_CATEGORY\" | translate}}</th><th>{{\"ADMIN_AI_COL_TAGS\" | translate}}</th><th>{{\"ADMIN_AI_COL_ORDER\" | translate}}</th><th>{{\"ADMIN_AI_COL_ACTIVE\" | translate}}</th><th>{{\"ADMIN_AI_COL_FILE\" | translate}}</th></tr></thead><tbody></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/ai-support/modules/ai-support-single/ai-support-single.view.html","<div class=\"modal-form-inner\"><div class=\"modal-head\"><h3 class=\"form-title\">{{ctrl.isEdit ? ctrl.article.title : (\'ADMIN_AI_ARTICLE_NEW\' | translate)}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"ai-support-row\"><div class=\"ai-support-6\"><div class=\"form-group\"><label>{{\'ADMIN_AI_COL_TITLE\' | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.article.title\" ng-change=\"ctrl.onTitleChange()\" required=\"\"></div></div><div class=\"ai-support-5\"><div class=\"form-group\"><label>{{\'ADMIN_AI_COL_SLUG\' | translate}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ctrl.article.slug\" ng-change=\"ctrl.onSlugChange()\" required=\"\"></div></div><div class=\"ai-support-1\"><div class=\"form-group\"><label>{{\'ADMIN_AI_COL_ORDER\' | translate}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"ctrl.article.sort_order\"></div></div></div><div class=\"ai-support-row\"><div class=\"ai-support-3\"><div class=\"form-group\"><app-dropdown model=\"ctrl.article.categoryObjs\" options=\"ctrl.categories\" multiple=\"true\" searchable=\"true\" allow-create=\"true\" label-prop=\"value\" fixed-panel=\"true\" on-change=\"ctrl.onCategoryChange(model)\" label=\"{{\'ADMIN_AI_COL_CATEGORY\' | translate}}\" placeholder=\"{{\'ADMIN_AI_CATEGORY_PLACEHOLDER\' | translate}}\" search-placeholder=\"{{\'ADMIN_AI_CATEGORY_PLACEHOLDER\' | translate}}\"></app-dropdown></div></div><div class=\"ai-support-7\"><div class=\"form-group\"><app-dropdown model=\"ctrl.article.tagsObjs\" options=\"ctrl.allTags\" multiple=\"true\" searchable=\"true\" allow-create=\"true\" label-prop=\"value\" fixed-panel=\"true\" label=\"{{\'ADMIN_AI_COL_TAGS\' | translate}}\" placeholder=\"{{\'ADMIN_AI_TAGS_PLACEHOLDER\' | translate}}\" search-placeholder=\"{{\'ADMIN_AI_TAGS_PLACEHOLDER\' | translate}}\"></app-dropdown></div></div><div class=\"ai-support-2\"><div class=\"form-group\"><label>{{\'ADMIN_AI_COL_ACTIVE\' | translate}}</label><div><div class=\"radio-btn\"><input ng-model=\"ctrl.article.is_active\" type=\"radio\" name=\"active\" ng-value=\"true\"> <label>Y</label></div><div class=\"radio-btn\"><input ng-model=\"ctrl.article.is_active\" type=\"radio\" name=\"active\" ng-value=\"false\"> <label>N</label></div></div></div></div></div><div ng-if=\"ctrl.article.source_file_id\" class=\"form-group\"><label>{{\'ADMIN_AI_COL_GENERATE_FROM_FILE\' | translate}}</label><br><a ng-href=\"{{ctrl.article.source_file_path}}\" target=\"_blank\" rel=\"noreferrer\">{{ ctrl.article.source_file_name }}</a></div><div class=\"form-group\"><label>{{\'ADMIN_AI_COL_BODY\' | translate}}</label> <textarea class=\"form-control\" rows=\"18\" ng-model=\"ctrl.article.body\"></textarea></div></div></div><div class=\"modal-footer end\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border-primary large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.save()\" ng-disabled=\"articleForm.$invalid\" class=\"btn text primary large\">{{\"ADMIN_AI_SAVE\" | translate}}</button></div></div>");
$templateCache.put("app/modules/admin/modules/custom-fields/modules/custom-fields-form/custom-fields.form.html","<div class=\"modal-form-inner\" id=\"categories-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"ctrl.isEdit\">{{\"SETTINGS_CUSTOM_FIELDS_EDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"!ctrl.isEdit\">{{\"SETTINGS_CUSTOM_FIELDS_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"customFieldForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"row\"><div><div class=\"col-md-6 form-group\" ng-repeat=\"locale in ctrl.availableLocales\"><label><span class=\"required\" ng-if=\"ctrl.isLocalRequired(locale)\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_NAME_\" + locale.split(\'_\')[0].toUpperCase() | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name[locale]\" name=\"name_{{locale}}\" class=\"form-control\" ng-required=\"ctrl.isLocalRequired(locale)\" autocomplete=\"off\"></div></div></div><div class=\"row\"><div><div class=\"col-md-6 form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_BUSINESSES\" | translate}}</label><div><app-dropdown model=\"ctrl.selectedBusinessIds\" options=\"ctrl.businesses\" multiple=\"true\" searchable=\"true\" value-prop=\"id\" label-prop=\"name\" placeholder=\"{{\'SETTINGS_CUSTOM_FIELDS_SELECT_BUSINESSES\' | translate}}\" required=\"true\" fixed-panel=\"true\"></app-dropdown></div></div><div class=\"col-md-6 form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_CUSTOM_FIELDS_TYPE\" | translate}}</label><div><app-dropdown model=\"ctrl.form.type\" options=\"ctrl.types\" value-prop=\"key\" label-prop=\"title\" placeholder=\"{{\'SETTINGS_CUSTOM_FIELDS_TYPE\' | translate}}\" required=\"true\" fixed-panel=\"true\"></app-dropdown></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"customFieldForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button></div></form></div>");
$templateCache.put("app/modules/admin/modules/custom-fields/modules/custom-fields-list/custom-fields.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn text primary large\" ui-sref=\"app.admin.custom-fields.new\">{{\"SETTINGS_CUSTOM_FIELDS_NEW\" | translate}}</button></div><div class=\"table-main-options table-holder\"><div class=\"table-responsive table-with-search\"><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_CUSTOM_FIELDS_NAME\" | translate}}</th><th>{{\"SETTINGS_CUSTOM_FIELDS_BUSINESSES\" | translate}}</th><th>{{\"SETTINGS_CUSTOM_FIELDS_TYPE\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.editItem(row.id)\"><td>{{ctrl.getCurrentName(row.name)}}</td><td>{{ctrl.getBusinesses(row.businesses)}}</td><td>{{ctrl.getType(row.type)}}</td><td style=\"width: 80px; text-align: right;\"><a class=\"btn icon circle small bordered blue\" ng-click=\"ctrl.editItem(row.id); $event.stopPropagation();\"><i class=\"las la-edit\"></i></a> <a class=\"btn icon circle small bordered red\" ng-click=\"ctrl.removeItem(row.id); $event.stopPropagation();\"><i class=\"las la-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/logs/modules/logs-list/logs.list.html","<div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row admin-logs\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-main-options\"><div class=\"flex full mb-24 gap-24 gap-24-m-8\"><div class=\"date-picker\"><div class=\"input-group date-picker--input-group\"><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerPrev();\" class=\"btn right btn-default datePickerPrev--btn\"><i class=\"fa fa-angle-left\"></i></button></span><div style=\"width:100px;\"></div><div class=\"inputs-wrapper\"><input style=\"width: 100%; height: 33px; text-align: center;\" type=\"datetime\" class=\"form-control hide-input\" date-time=\"\" fix-datepicker-position=\"\" ng-model=\"ctrl.date\" auto-close=\"true\" view=\"date\" min-view=\"date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></div><span class=\"input-group-btn\"><button type=\"button\" ng-click=\"ctrl.datePickerNext();\" class=\"btn left btn-default datePickerNext--btn\"><i class=\"fa fa-angle-right\"></i></button></span></div></div><div class=\"btn-group\"><button class=\"btn\" ng-click=\"ctrl.change_type(\'all\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'all\', \'btn-default\': ctrl.type != \'all\'}\">{{\"All\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_type(\'error\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'error\', \'btn-default\': ctrl.type != \'error\'}\">{{\"Error\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_type(\'info\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'info\', \'btn-default\': ctrl.type != \'info\'}\">{{\"Info\" | translate}}</button> <button class=\"btn\" ng-click=\"ctrl.change_type(\'debug\');\" ng-class=\"{\'btn-primary\': ctrl.type == \'debug\', \'btn-default\': ctrl.type != \'debug\'}\">{{\"Debug\" | translate}}</button></div></div></div><div class=\"table-holder\"><div class=\"table-responsive\"><table id=\"res_dt\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th style=\"width: 140px;\">{{\"Date\" | translate}}</th><th style=\"width: 1%;\">{{\"Type\" | translate}}</th><th>{{\"Text\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\"><td style=\"width: 140px;\">{{row.date}}</td><td style=\"width: 1%;\">{{row.type}}</td><td ng-bind-html=\"row.text | nl2br\"></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/tutorial-videos/modules/tutorial-videos-form/tutorial-videos.form.html","<div class=\"modal-form-inner\" id=\"tutorial-video-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"ctrl.isEdit\">{{\"TUTORIAL_VIDEOS_EDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"!ctrl.isEdit\">{{\"TUTORIAL_VIDEOS_NEW\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"tutorialVideoForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12 form-group\"><label><span class=\"required\">*</span> {{\"TUTORIAL_VIDEOS_TITLE\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.title\" name=\"title\" class=\"form-control\" required=\"\" autocomplete=\"off\"></div></div><div class=\"row\"><div class=\"col-md-12 form-group\"><label><span ng-if=\"!ctrl.isEdit\" class=\"required\">*</span> {{\"TUTORIAL_VIDEOS_VIDEO\" | translate}}</label><div class=\"file-upload-area\"><label class=\"btn text border large\"><i class=\"las la-upload\"></i> {{\"TUTORIAL_VIDEOS_SELECT_VIDEO\" | translate}} <input type=\"file\" accept=\"video/mp4,video/webm,video/ogg\" style=\"display: none\" onchange=\"angular.element(this).scope().uploadVideo(this)\"></label> <span class=\"upload-filename\" ng-if=\"ctrl.videoFilename\">{{ctrl.videoFilename}}</span> <span class=\"upload-filename\" ng-if=\"ctrl.isEdit && ctrl.form.video_url && !ctrl.videoFilename\">{{\"TUTORIAL_VIDEOS_CURRENT_FILE\" | translate}}</span></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group\"><label>{{\"TUTORIAL_VIDEOS_THUMBNAIL\" | translate}}</label><div class=\"file-upload-area with-preview\"><label class=\"btn text border large\"><i class=\"las la-image\"></i> {{\"TUTORIAL_VIDEOS_SELECT_THUMBNAIL\" | translate}} <input type=\"file\" accept=\"image/*\" style=\"display: none\" onchange=\"angular.element(this).scope().uploadThumbnail(this)\"></label><div ng-if=\"ctrl.form.thumbnail_url || ctrl.thumbnailPreview\" class=\"image small thumb-preview\" ng-style=\"{\'background-image\':\'url(\' + (ctrl.thumbnailPreview || ctrl.form.thumbnail_url) + \')\'}\"></div><span class=\"upload-filename\" ng-if=\"ctrl.thumbnailFilename\">{{ctrl.thumbnailFilename}}</span></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group\"><label><span class=\"required\">*</span> {{\"TUTORIAL_VIDEOS_PUBLISHED_AT\" | translate}}</label> <input type=\"date\" ng-model=\"ctrl.form.published_date\" name=\"published_date\" class=\"form-control\" required=\"\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"tutorialVideoForm.$invalid || ctrl.saving\" class=\"btn text primary large\"><span ng-if=\"!ctrl.saving\">{{\"SETTINGS_INFO_SEND\" | translate}}</span> <span ng-if=\"ctrl.saving\">{{\"LOADING\" | translate}}</span></button></div></form></div>");
$templateCache.put("app/modules/admin/modules/tutorial-videos/modules/tutorial-videos-list/tutorial-videos.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn text primary large\" ui-sref=\"app.admin.tutorial-videos.new\">{{\"TUTORIAL_VIDEOS_NEW\" | translate}}</button></div><div class=\"table-main-options table-holder\"><div class=\"table-responsive table-with-search\"><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"TUTORIAL_VIDEOS_TITLE\" | translate}}</th><th>{{\"TUTORIAL_VIDEOS_PUBLISHED_AT\" | translate}}</th><th></th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ng-click=\"ctrl.editItem(row.id)\"><td>{{row.title}}</td><td>{{row.published_at | date:\'mediumDate\'}}</td><td style=\"width: 80px; text-align: right;\"><a class=\"btn icon circle small bordered blue\" ng-click=\"ctrl.editItem(row.id); $event.stopPropagation();\"><i class=\"las la-edit\"></i></a> <a class=\"btn icon circle small bordered red\" ng-click=\"ctrl.removeItem(row.id); $event.stopPropagation();\"><i class=\"las la-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/admin/modules/users/modules/popup/business.popup.html","<div class=\"modal-form-inner tabs-form\" id=\"bank-select-mob\"><div class=\"modal-head\"><h3 class=\"form-title\">{{\"ADMIN_BUSINESS\" | translate}}</h3><a class=\"close\" ng-click=\"$close();\">&times;</a></div><div class=\"modal-body\"><table ng-if=\"ctrl.businesses\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover businesses-select-table\"><thead><tr><th>{{\"ADMIN_BUSINESS\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"ctrl.selectBusiness($index)\" ng-repeat=\"row in ctrl.businesses\"><td>{{row.name}}</td></tr></tbody></table></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/modules/admin/modules/users/modules/users-form/users.form.html","<div class=\"modal-form-inner\" id=\"categories-form\" ng-if=\"userRole\"><div class=\"modal-head\"><h3 class=\"form-title\" ng-if=\"isEdit\">{{\"SETTINGS_USER_EDIT\" | translate}}</h3><h3 class=\"form-title\" ng-if=\"!isEdit\">{{\"SETTINGS_USER_N\" | translate}}</h3><a class=\"close\" ui-sref=\"^.\">&times;</a></div><form name=\"usersForm\" ng-submit=\"ctrl.submit()\" ng-if=\"ctrl.form\" novalidate=\"\"><div ng-if=\"formScreen == 0\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> {{\"SETTINGS_USER_NAME\" | translate}}</label> <input type=\"text\" ng-model=\"ctrl.form.name\" name=\"name\" class=\"form-control\" required=\"\" autocomplete=\"off\"><div ng-messages=\"usersForm.name.$error\" class=\"ng-messages\" ng-show=\"usersForm.name.$dirty\"><div ng-message=\"required\">1שדה זה הוא שדה חובה</div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label><span class=\"required\">*</span> Use for login</label> <input type=\"email\" ng-model=\"ctrl.form.email\" name=\"email\" required=\"\" placeholder=\"email@example.co.il\" class=\"form-control\" autocomplete=\"off\"><div ng-messages=\"usersForm.email.$error\" class=\"ng-messages\" ng-show=\"usersForm.email.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div><div ng-message=\"email\">{{\"SETTINGS_USER_VALID_MAIL\" | translate}}</div></div></div></div></div><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\" ng-if=\"ctrl.form.role != 4\"><label ng-if=\"isMobile\"><span class=\"required\">*</span> {{\"ADMIN_BUSINESS\" | translate}}</label> <input type=\"text\" readonly=\"true\" ng-if=\"isMobile\" ng-model=\"ctrl.name_business\" class=\"form-control\" ng-click=\"ctrl.showBusinessList()\"><app-dropdown ng-if=\"!isMobile\" model=\"ctrl.form.b_id\" options=\"ctrl.businesses\" value-prop=\"id\" searchable=\"true\" required=\"true\" fixed-panel=\"true\" on-change=\"ctrl.roleChange()\" label=\"{{\'ADMIN_BUSINESS\' | translate}}\" placeholder=\"{{\'ADMIN_BUSINESS\' | translate}}\" search-placeholder=\"{{\'ADMIN_BUSINESS\' | translate}}\"></app-dropdown></div><div class=\"form-group\" ng-if=\"ctrl.form.role == 4\"><app-dropdown model=\"ctrl.form.business_ids\" options=\"ctrl.businesses\" multiple=\"true\" searchable=\"true\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" label=\"{{\'ADMIN_BUSINESS\' | translate}}\" placeholder=\"{{\'ADMIN_BUSINESS\' | translate}}\" search-placeholder=\"{{\'ADMIN_BUSINESS\' | translate}}\"></app-dropdown></div></div><div class=\"col-md-6\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.role\" options=\"ctrl.roleOptions\" value-prop=\"id\" required=\"true\" fixed-panel=\"true\" on-change=\"ctrl.roleChange()\" label=\"{{\'SETTINGS_USER_ROLE\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_ROLE\' | translate}}\"></app-dropdown></div></div></div><div ng-if=\"ctrl.form.role == 3\" class=\"col-md-12 no-padding-col\"><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-6\"><div class=\"form-group\"><app-dropdown model=\"ctrl.form.resource_id\" options=\"ctrl.resources\" value-prop=\"id\" searchable=\"true\" required=\"true\" fixed-panel=\"true\" label=\"{{\'SETTINGS_USER_RESOURCE\' | translate}}\" placeholder=\"{{\'SETTINGS_USER_RESOURCE\' | translate}}\" search-placeholder=\"{{\'SETTINGS_USER_RESOURCE\' | translate}}\"></app-dropdown></div></div></div></div><div class=\"col-md-12 no-padding-col\"><div class=\"col-md-12\"><div class=\"form-group\"><div><label><span class=\"required\" ng-if=\"!isEdit\">*</span> {{\"SETTINGS_USER_PASS\" | translate}}</label> <input type=\"password\" ng-model=\"ctrl.form.password\" name=\"password\" class=\"form-control\" required=\"\" ng-if=\"!isEdit\" autocomplete=\"off\"> <input type=\"password\" ng-model=\"ctrl.form.password\" placeholder=\'{{\"SETTINGS_USER_NOT_CH\" | translate}}\' name=\"password\" class=\"form-control\" ng-if=\"isEdit\" autocomplete=\"off\"><div ng-messages=\"usersForm.password.$error\" class=\"ng-messages\" ng-show=\"usersForm.password.$dirty\"><div ng-message=\"required\">{{\"SETTINGS_USER_VALID\" | translate}}</div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ui-sref=\"^.\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" ng-disabled=\"usersForm.$invalid\" class=\"btn text primary large\">{{\"SETTINGS_INFO_SEND\" | translate}}</button> <button type=\"button\" ng-if=\"isEdit && $user.id != ctrl.form.id\" ng-click=\"ctrl.delete();\" class=\"btn text border-red large\">{{\"SETTINGS_INFO_REMOVE\" | translate}}</button></div></div><div ng-if=\"formScreen == 1\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\">{{\"SETTINGS_USER_SENTENCE_1\" | translate}}</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"formScreen = 0\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"submit\" class=\"btn text primary large\">{{\"SETTINGS_OK\" | translate}}</button></div></div><div ng-if=\"formScreen == 2\" class=\"message-wrapper\"><div class=\"modal-body\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\">{{\"SETTINGS_USER_QUEST\" | translate}}</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"formScreen = 0\" class=\"btn text border large\">{{\"SETTINGS_INFO_CANCEL\" | translate}}</button> <button type=\"button\" ng-click=\"ctrl.delete()\" class=\"btn text border-red large\">{{\"CUSTOMERS_DELETE\" | translate}}</button></div></div></form></div>");
$templateCache.put("app/modules/admin/modules/users/modules/users-list/users.list.html","<div ng-include=\"\'app/components/header/header.html\'\"></div><div class=\"{{wrapperClasses}}\" ng-if=\"userRole\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-main-options\"><button class=\"btn text primary large\" ui-sref=\"app.admin.users.new\">{{\"SETTINGS_USER_NEW\" | translate}}</button></div><div class=\"table-holder\"><div class=\"table-responsive\"><table ng-if=\"ctrl.tableData\" datatable=\"\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>{{\"SETTINGS_USER_NAME\" | translate}}</th><th>{{\"SETTINGS_USER_MAIL\" | translate}}</th><th>{{\"ADMIN_BUSINESS_NAME\" | translate}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-repeat=\"row in ctrl.tableData\" ui-sref=\"app.admin.users.edit({id: {{row.id}}})\"><td>{{row.name}}</td><td>{{row.email}}</td><td>{{row.business}}</td></tr></tbody></table></div></div></div></div></div></div></div>");}]);